
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea2a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea2a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8TgEi", function(module, exports) {
module.exports = function navigation(app) {
    app.ports.refresh && app.ports.refresh.subscribe(function() {
        window.location.reload(true);
    });
    app.ports.redirectAndRefresh && app.ports.redirectAndRefresh.subscribe(function(url) {
        setTimeout(function() {
            window.location.replace(url);
        }, 0);
    });
};

});

parcelRegister("bvPu1", function(module, exports) {
module.exports = function(app) {
    if (window.nomalab.intercom) {
        // Load intercom snippet
        (function() {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
                ic('reattach_activator');
                ic('update', w.intercomSettings);
            } else {
                var d = document;
                var i = function() {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function(args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                var l = function() {
                    var s = d.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = 'https://widget.intercom.io/widget/' + window.nomalab.intercom.id;
                    var x = d.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                };
                if (document.readyState === 'complete') l();
                else if (w.attachEvent) w.attachEvent('onload', l);
                else w.addEventListener('load', l, false);
            }
        })();
        window.Intercom("boot", {
            api_base: "https://api-iam.intercom.io",
            app_id: window.nomalab.intercom.id,
            name: window.nomalab.user?.name || "",
            email: window.nomalab.user?.email,
            alignment: "left"
        });
    }
    if (window.nomalab.sentry) {
        var sentryTag = document.createElement('script');
        sentryTag.crossOrigin = "anonymous";
        sentryTag.src = "https://browser.sentry-cdn.com/5.27.6/bundle.tracing.min.js";
        sentryTag.integrity = "sha384-9Z8PxByVWP+gIm/rTMPn9BWwknuJR5oJcLj+Nr9mvzk8nJVkVXgQvlLGZ9SIFEJF";
        sentryTag.addEventListener('load', function() {
            Sentry.init({
                dsn: window.nomalab.sentry.url,
                release: 'dev',
                environment: window.nomalab.environment || 'prod',
                integrations: [
                    new Sentry.Integrations.BrowserTracing()
                ],
                tracesSampleRate: 0.2
            });
            if (window.nomalab.user && window.nomalab.user.email) Sentry.setUser({
                email: window.nomalab.user.email
            });
        });
        document.body.appendChild(sentryTag);
    }
    app.ports.openIntercom && app.ports.openIntercom.subscribe(function(toggle) {
        if (toggle) Intercom && Intercom('show');
        else Intercom && Intercom('hide');
    });
};

});

parcelRegister("hjsOJ", function(module, exports) {
module.exports = function(app) {
    app.ports.gotoSSO && app.ports.gotoSSO.subscribe(async function(ssoUrl) {
        window.location = ssoUrl;
    });
};

});

parcelRegister("iHeIR", function(module, exports) {
module.exports = function routing(app, portName) {
    // Manually handle the push history state
    // mostly to allow ctrl/cmd + click to open in new tab
    document.body.addEventListener('click', function(e) {
        // ignore click + meta or ctrl for new tabs
        if (e.ctrlKey || e.metaKey) return true;
        // lookup for an <a[href]>
        var element = e.target;
        while(!element.href){
            if (!element.parentNode) return true;
            element = element.parentNode;
        }
        var href = element.getAttribute('href');
        // ignore links for <a[data-prevent-history]>
        if (element.getAttribute('data-prevent-history')) return true;
        // ignore external links and anchors
        if (/^https?:\/\//.test(href) || href.slice(0, 1) === '#') return true;
        // ignore mailto links or tel
        if (href.slice(0, 7) === 'mailto:' || href.slice(0, 4) === 'tel:') return true;
        // let's do the magic
        e.preventDefault();
        try {
            app.ports.newurl.send(href);
        } catch (e) {
            console.error(e);
        }
        history.pushState(null, null, href);
        return false;
    }, true);
    window.addEventListener('popstate', function() {
        app.ports.newurl.send(window.location.pathname + window.location.search);
    });
    app.ports[portName].subscribe(function(href) {
        try {
            app.ports.newurl.send(href);
        } catch (e) {
            console.error(e);
        }
        history.pushState(null, null, href);
    });
};

});

parcelRegister("8oUNT", function(module, exports) {
function $61dca0a9cfd068cc$var$hoursToOffset(hours) {
    const sign = hours >= 0 ? "+" : "-";
    const absHours = Math.abs(hours);
    const pad = (num)=>num.toString().padStart(2, "0");
    return `${sign}${pad(absHours)}:00`;
}
Object.defineProperty(Event.prototype, "timezone", {
    get () {
        const offset = -(new Date().getTimezoneOffset() / 60);
        return this.target.value + $61dca0a9cfd068cc$var$hoursToOffset(offset);
    }
});
/*
 * <time-zone />
 * Gives a string representation of the navigator's timezone like "europe/paris".
 */ class $61dca0a9cfd068cc$var$TimeZone extends HTMLElement {
    constructor(){
        super();
        const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.attachShadow({
            mode: "open"
        });
        this.shadowRoot.innerHTML = timeZone;
    }
}
customElements.define("time-zone", $61dca0a9cfd068cc$var$TimeZone);

});

parcelRegister("3mVol", function(module, exports) {

var $bQTtn = parcelRequire("bQTtn");
var $01yxO = parcelRequire("01yxO");

var $9Mags = parcelRequire("9Mags");
var $273ff1f51366ad7c$var$localeFns = {
    locale: $9Mags.fr
};
/*
 * <format-time datetime="2020-06-04T12:27:06.222Z">
 */ class $273ff1f51366ad7c$var$FormatTime extends HTMLElement {
    constructor(){
        super();
        this.useRelativeDate = false;
    }
    connectedCallback() {
        this.render();
        this.onclick = function() {
            this.useRelativeDate = !this.useRelativeDate;
            this.render();
        };
    }
    render() {
        var x = new Date(this.getAttribute('datetime'));
        this.innerHTML = this.useRelativeDate ? $01yxO.formatRelative(x, new Date(), $273ff1f51366ad7c$var$localeFns) : $bQTtn.format(x, 'PP, p', $273ff1f51366ad7c$var$localeFns);
    }
}
customElements.define('format-time', $273ff1f51366ad7c$var$FormatTime);

});
parcelRegister("bQTtn", function(module, exports) {

$parcel$export(module.exports, "format", () => $8a0f94cf009a4946$export$d9468344d3651243);

var $lDwz3 = parcelRequire("lDwz3");

var $clqZR = parcelRequire("clqZR");

var $eU5LL = parcelRequire("eU5LL");

var $4lli5 = parcelRequire("4lli5");

var $9zwaQ = parcelRequire("9zwaQ");

var $gla4m = parcelRequire("gla4m");

var $9piCv = parcelRequire("9piCv");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8a0f94cf009a4946$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8a0f94cf009a4946$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8a0f94cf009a4946$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8a0f94cf009a4946$var$doubleQuoteRegExp = /''/g;
const $8a0f94cf009a4946$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8a0f94cf009a4946$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $lDwz3.enUS);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $9piCv.toDate)(date, options?.in);
    if (!(0, $gla4m.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($8a0f94cf009a4946$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $4lli5.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8a0f94cf009a4946$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $8a0f94cf009a4946$var$cleanEscapedString(substring)
        };
        if ((0, $eU5LL.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($8a0f94cf009a4946$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $9zwaQ.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, $9zwaQ.isProtectedDayOfYearToken)(token)) (0, $9zwaQ.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, $eU5LL.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $8a0f94cf009a4946$var$cleanEscapedString(input) {
    const matched = input.match($8a0f94cf009a4946$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($8a0f94cf009a4946$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$8a0f94cf009a4946$export$2e2bcd8739ae039 = $8a0f94cf009a4946$export$d9468344d3651243;

});
parcelRegister("lDwz3", function(module, exports) {

$parcel$export(module.exports, "enUS", () => $fc06801cb681cd51$export$137380d9ce54f7f);

var $186kz = parcelRequire("186kz");

var $kcojA = parcelRequire("kcojA");

var $5alD8 = parcelRequire("5alD8");

var $2qWXh = parcelRequire("2qWXh");

var $9mp8A = parcelRequire("9mp8A");
const $fc06801cb681cd51$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $186kz.formatDistance),
    formatLong: (0, $kcojA.formatLong),
    formatRelative: (0, $5alD8.formatRelative),
    localize: (0, $2qWXh.localize),
    match: (0, $9mp8A.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$fc06801cb681cd51$export$2e2bcd8739ae039 = $fc06801cb681cd51$export$137380d9ce54f7f;

});
parcelRegister("186kz", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $0d2b72f7daad25ab$export$2c14ff85d6318973);
const $0d2b72f7daad25ab$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0d2b72f7daad25ab$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0d2b72f7daad25ab$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

});

parcelRegister("kcojA", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $eb47ca12c1d82ea6$export$cbf60ecb96cbb82f);

var $27kCy = parcelRequire("27kCy");
const $eb47ca12c1d82ea6$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $eb47ca12c1d82ea6$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $eb47ca12c1d82ea6$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $eb47ca12c1d82ea6$export$cbf60ecb96cbb82f = {
    date: (0, $27kCy.buildFormatLongFn)({
        formats: $eb47ca12c1d82ea6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $27kCy.buildFormatLongFn)({
        formats: $eb47ca12c1d82ea6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $27kCy.buildFormatLongFn)({
        formats: $eb47ca12c1d82ea6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});
parcelRegister("27kCy", function(module, exports) {

$parcel$export(module.exports, "buildFormatLongFn", () => $18ac3b18a414568b$export$38e44e97ce4dbb7d);
function $18ac3b18a414568b$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("5alD8", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $3c2eaa3c76711534$export$8fbbfd65594f46a0);
const $3c2eaa3c76711534$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $3c2eaa3c76711534$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$3c2eaa3c76711534$var$formatRelativeLocale[token];

});

parcelRegister("2qWXh", function(module, exports) {

$parcel$export(module.exports, "localize", () => $1c5bbdbea2674188$export$b3bd0bc58e36cd63);

var $h8wHD = parcelRequire("h8wHD");
const $1c5bbdbea2674188$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $1c5bbdbea2674188$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $1c5bbdbea2674188$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $1c5bbdbea2674188$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $1c5bbdbea2674188$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $1c5bbdbea2674188$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $1c5bbdbea2674188$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $1c5bbdbea2674188$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $1c5bbdbea2674188$var$ordinalNumber,
    era: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $h8wHD.buildLocalizeFn)({
        values: $1c5bbdbea2674188$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1c5bbdbea2674188$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

});
parcelRegister("h8wHD", function(module, exports) {

$parcel$export(module.exports, "buildLocalizeFn", () => $c79c8d23bc4e58f1$export$63596d6ee8878b25);
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $c79c8d23bc4e58f1$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("9mp8A", function(module, exports) {

$parcel$export(module.exports, "match", () => $6d09aaea8050d7cb$export$4659b591c19bdf3d);

var $21azF = parcelRequire("21azF");

var $ggD50 = parcelRequire("ggD50");
const $6d09aaea8050d7cb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $6d09aaea8050d7cb$var$parseOrdinalNumberPattern = /\d+/i;
const $6d09aaea8050d7cb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $6d09aaea8050d7cb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $6d09aaea8050d7cb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $6d09aaea8050d7cb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6d09aaea8050d7cb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $6d09aaea8050d7cb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $6d09aaea8050d7cb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $6d09aaea8050d7cb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $6d09aaea8050d7cb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $6d09aaea8050d7cb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $6d09aaea8050d7cb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ggD50.buildMatchPatternFn)({
        matchPattern: $6d09aaea8050d7cb$var$matchOrdinalNumberPattern,
        parsePattern: $6d09aaea8050d7cb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d09aaea8050d7cb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $21azF.buildMatchFn)({
        matchPatterns: $6d09aaea8050d7cb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6d09aaea8050d7cb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});
parcelRegister("21azF", function(module, exports) {

$parcel$export(module.exports, "buildMatchFn", () => $1783e097adacaea4$export$1430a0f35710914d);
function $1783e097adacaea4$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $1783e097adacaea4$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $1783e097adacaea4$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $1783e097adacaea4$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $1783e097adacaea4$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("ggD50", function(module, exports) {

$parcel$export(module.exports, "buildMatchPatternFn", () => $bd7c7461c2ecc479$export$fdaf2fd6d7edde95);
function $bd7c7461c2ecc479$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("clqZR", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $8fcc633751370d5a$export$430a3269e24b912e);
let $8fcc633751370d5a$var$defaultOptions = {};
function $8fcc633751370d5a$export$430a3269e24b912e() {
    return $8fcc633751370d5a$var$defaultOptions;
}
function $8fcc633751370d5a$export$95365be1b0704abc(newOptions) {
    $8fcc633751370d5a$var$defaultOptions = newOptions;
}

});

parcelRegister("eU5LL", function(module, exports) {

$parcel$export(module.exports, "formatters", () => $ad9ac550a502d0dd$export$fe98a034cfb96d55);

var $2kNan = parcelRequire("2kNan");

var $7RD6s = parcelRequire("7RD6s");

var $gKHxq = parcelRequire("gKHxq");

var $3JkLZ = parcelRequire("3JkLZ");

var $2yLHC = parcelRequire("2yLHC");

var $1SrIf = parcelRequire("1SrIf");

var $1OfHQ = parcelRequire("1OfHQ");
const $ad9ac550a502d0dd$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $ad9ac550a502d0dd$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $1OfHQ.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $2yLHC.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $1SrIf.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $1SrIf.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $gKHxq.getISOWeekYear)(date);
        // Padding
        return (0, $1SrIf.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $1SrIf.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $1SrIf.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $1SrIf.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $1OfHQ.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $1SrIf.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $3JkLZ.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $1SrIf.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $7RD6s.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $1SrIf.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $1OfHQ.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $2kNan.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $1SrIf.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $1SrIf.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $1SrIf.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $1SrIf.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $ad9ac550a502d0dd$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $1OfHQ.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $1OfHQ.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1SrIf.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1SrIf.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $1OfHQ.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $1OfHQ.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $1OfHQ.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $ad9ac550a502d0dd$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $ad9ac550a502d0dd$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $ad9ac550a502d0dd$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $1SrIf.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $1SrIf.addLeadingZeros)(+date, token.length);
    }
};
function $ad9ac550a502d0dd$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $1SrIf.addLeadingZeros)(minutes, 2);
}
function $ad9ac550a502d0dd$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $1SrIf.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return $ad9ac550a502d0dd$var$formatTimezone(offset, delimiter);
}
function $ad9ac550a502d0dd$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $1SrIf.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $1SrIf.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

});
parcelRegister("2kNan", function(module, exports) {

$parcel$export(module.exports, "getDayOfYear", () => $1b33966f5fd76c6b$export$d3b42cd8452deec);

var $exQSP = parcelRequire("exQSP");

var $69LDz = parcelRequire("69LDz");

var $9piCv = parcelRequire("9piCv");
function $1b33966f5fd76c6b$export$d3b42cd8452deec(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const diff = (0, $exQSP.differenceInCalendarDays)(_date, (0, $69LDz.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$1b33966f5fd76c6b$export$2e2bcd8739ae039 = $1b33966f5fd76c6b$export$d3b42cd8452deec;

});
parcelRegister("exQSP", function(module, exports) {

$parcel$export(module.exports, "differenceInCalendarDays", () => $a96d2b471ccbd713$export$4a02e9c37dab4871);

var $dL2Ic = parcelRequire("dL2Ic");

var $8k4Ky = parcelRequire("8k4Ky");

var $lXVqG = parcelRequire("lXVqG");

var $8Y3Vi = parcelRequire("8Y3Vi");
function $a96d2b471ccbd713$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $8k4Ky.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $8Y3Vi.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, $8Y3Vi.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $lXVqG.millisecondsInDay));
}
var // Fallback for modularized imports:
$a96d2b471ccbd713$export$2e2bcd8739ae039 = $a96d2b471ccbd713$export$4a02e9c37dab4871;

});
parcelRegister("dL2Ic", function(module, exports) {

$parcel$export(module.exports, "getTimezoneOffsetInMilliseconds", () => $a041c4b022a0abcb$export$113002b5eff6e430);

var $9piCv = parcelRequire("9piCv");
function $a041c4b022a0abcb$export$113002b5eff6e430(date) {
    const _date = (0, $9piCv.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

});
parcelRegister("9piCv", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $6d94e4666b795786$export$e67a095c620b86fe);

var $4JKjc = parcelRequire("4JKjc");
function $6d94e4666b795786$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $4JKjc.constructFrom)(context || argument, argument);
}
var // Fallback for modularized imports:
$6d94e4666b795786$export$2e2bcd8739ae039 = $6d94e4666b795786$export$e67a095c620b86fe;

});
parcelRegister("4JKjc", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $372f49515f3dbe8b$export$ead8a1812b171991);

var $lXVqG = parcelRequire("lXVqG");
function $372f49515f3dbe8b$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $lXVqG.constructFromSymbol) in date) return date[0, $lXVqG.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$372f49515f3dbe8b$export$2e2bcd8739ae039 = $372f49515f3dbe8b$export$ead8a1812b171991;

});
parcelRegister("lXVqG", function(module, exports) {

$parcel$export(module.exports, "millisecondsInWeek", () => $ffdba7ec0b20562f$export$4fad13613e88edc8);
$parcel$export(module.exports, "millisecondsInDay", () => $ffdba7ec0b20562f$export$b76b1809a2898f9a);
$parcel$export(module.exports, "millisecondsInMinute", () => $ffdba7ec0b20562f$export$91246f0b9bd9beff);
$parcel$export(module.exports, "minutesInYear", () => $ffdba7ec0b20562f$export$3633035e63cee86a);
$parcel$export(module.exports, "minutesInMonth", () => $ffdba7ec0b20562f$export$ab7da2ccd1075c38);
$parcel$export(module.exports, "minutesInDay", () => $ffdba7ec0b20562f$export$2423174df8cd3cd2);
$parcel$export(module.exports, "constructFromSymbol", () => $ffdba7ec0b20562f$export$2a7b97929c48d47d);
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $ffdba7ec0b20562f$export$dfd9b671c89acc8e = 7;
const $ffdba7ec0b20562f$export$3913210603d8e9ae = 365.2425;
const $ffdba7ec0b20562f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $ffdba7ec0b20562f$export$4dec998e48f9c246 = -$ffdba7ec0b20562f$export$81caae6e1cc7a622;
const $ffdba7ec0b20562f$export$4fad13613e88edc8 = 604800000;
const $ffdba7ec0b20562f$export$b76b1809a2898f9a = 86400000;
const $ffdba7ec0b20562f$export$91246f0b9bd9beff = 60000;
const $ffdba7ec0b20562f$export$7f72910d6dfd237a = 3600000;
const $ffdba7ec0b20562f$export$397c2d5776aa9055 = 1000;
const $ffdba7ec0b20562f$export$3633035e63cee86a = 525600;
const $ffdba7ec0b20562f$export$ab7da2ccd1075c38 = 43200;
const $ffdba7ec0b20562f$export$2423174df8cd3cd2 = 1440;
const $ffdba7ec0b20562f$export$f2f5ae5a8e2d8f9f = 60;
const $ffdba7ec0b20562f$export$3c58128db900d44e = 3;
const $ffdba7ec0b20562f$export$80d7e435f744f319 = 12;
const $ffdba7ec0b20562f$export$4db7641526e3241f = 4;
const $ffdba7ec0b20562f$export$698aec755e92c695 = 3600;
const $ffdba7ec0b20562f$export$a77c1a7ebebe2a5a = 60;
const $ffdba7ec0b20562f$export$815a9362476d2fe3 = $ffdba7ec0b20562f$export$698aec755e92c695 * 24;
const $ffdba7ec0b20562f$export$34804a017b31e2fe = $ffdba7ec0b20562f$export$815a9362476d2fe3 * 7;
const $ffdba7ec0b20562f$export$7271e9e3478110d1 = $ffdba7ec0b20562f$export$815a9362476d2fe3 * $ffdba7ec0b20562f$export$3913210603d8e9ae;
const $ffdba7ec0b20562f$export$8e6600bbdee7dabb = $ffdba7ec0b20562f$export$7271e9e3478110d1 / 12;
const $ffdba7ec0b20562f$export$be1dccf2de902d31 = $ffdba7ec0b20562f$export$8e6600bbdee7dabb * 3;
const $ffdba7ec0b20562f$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");

});




parcelRegister("8k4Ky", function(module, exports) {

$parcel$export(module.exports, "normalizeDates", () => $60f3e039e35760d5$export$9f53b88e82f64d8d);

var $4JKjc = parcelRequire("4JKjc");
function $60f3e039e35760d5$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $4JKjc.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

});

parcelRegister("8Y3Vi", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $6876f85f60833acc$export$63fa379ae8a9ba2);

var $9piCv = parcelRequire("9piCv");
function $6876f85f60833acc$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$6876f85f60833acc$export$2e2bcd8739ae039 = $6876f85f60833acc$export$63fa379ae8a9ba2;

});


parcelRegister("69LDz", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $47b8891ac047b76a$export$f91e89d3d0406102);

var $9piCv = parcelRequire("9piCv");
function $47b8891ac047b76a$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $9piCv.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$47b8891ac047b76a$export$2e2bcd8739ae039 = $47b8891ac047b76a$export$f91e89d3d0406102;

});


parcelRegister("7RD6s", function(module, exports) {

$parcel$export(module.exports, "getISOWeek", () => $5b9bd0b6d332dc16$export$7cabdc5698b63e2f);

var $lXVqG = parcelRequire("lXVqG");

var $ceCiY = parcelRequire("ceCiY");

var $e8Lwm = parcelRequire("e8Lwm");

var $9piCv = parcelRequire("9piCv");
function $5b9bd0b6d332dc16$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const diff = +(0, $ceCiY.startOfISOWeek)(_date) - +(0, $e8Lwm.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $lXVqG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$5b9bd0b6d332dc16$export$2e2bcd8739ae039 = $5b9bd0b6d332dc16$export$7cabdc5698b63e2f;

});
parcelRegister("ceCiY", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeek", () => $8e84816b02742985$export$6173213f95a4431e);

var $7fUGY = parcelRequire("7fUGY");
function $8e84816b02742985$export$6173213f95a4431e(date, options) {
    return (0, $7fUGY.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$8e84816b02742985$export$2e2bcd8739ae039 = $8e84816b02742985$export$6173213f95a4431e;

});
parcelRegister("7fUGY", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $5485e8fa6e6fea88$export$42c81a444fbfb5d4);

var $clqZR = parcelRequire("clqZR");

var $9piCv = parcelRequire("9piCv");
function $5485e8fa6e6fea88$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$5485e8fa6e6fea88$export$2e2bcd8739ae039 = $5485e8fa6e6fea88$export$42c81a444fbfb5d4;

});


parcelRegister("e8Lwm", function(module, exports) {

$parcel$export(module.exports, "startOfISOWeekYear", () => $a4b6acbd542cebd6$export$236bdfa374eb69a9);

var $4JKjc = parcelRequire("4JKjc");

var $gKHxq = parcelRequire("gKHxq");

var $ceCiY = parcelRequire("ceCiY");
function $a4b6acbd542cebd6$export$236bdfa374eb69a9(date, options) {
    const year = (0, $gKHxq.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $ceCiY.startOfISOWeek)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$a4b6acbd542cebd6$export$2e2bcd8739ae039 = $a4b6acbd542cebd6$export$236bdfa374eb69a9;

});
parcelRegister("gKHxq", function(module, exports) {

$parcel$export(module.exports, "getISOWeekYear", () => $c322b6f7d3bab504$export$3dbc52535f6f8fcc);

var $4JKjc = parcelRequire("4JKjc");

var $ceCiY = parcelRequire("ceCiY");

var $9piCv = parcelRequire("9piCv");
function $c322b6f7d3bab504$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $4JKjc.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $ceCiY.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $4JKjc.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $ceCiY.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c322b6f7d3bab504$export$2e2bcd8739ae039 = $c322b6f7d3bab504$export$3dbc52535f6f8fcc;

});



parcelRegister("3JkLZ", function(module, exports) {

$parcel$export(module.exports, "getWeek", () => $2b75b02ab160a67b$export$efe19b760242b2fc);

var $lXVqG = parcelRequire("lXVqG");

var $7fUGY = parcelRequire("7fUGY");

var $3uwsX = parcelRequire("3uwsX");

var $9piCv = parcelRequire("9piCv");
function $2b75b02ab160a67b$export$efe19b760242b2fc(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const diff = +(0, $7fUGY.startOfWeek)(_date, options) - +(0, $3uwsX.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $lXVqG.millisecondsInWeek)) + 1;
}
var // Fallback for modularized imports:
$2b75b02ab160a67b$export$2e2bcd8739ae039 = $2b75b02ab160a67b$export$efe19b760242b2fc;

});
parcelRegister("3uwsX", function(module, exports) {

$parcel$export(module.exports, "startOfWeekYear", () => $28ad5b80ef4531e0$export$bb7b45bb8e74da0f);

var $clqZR = parcelRequire("clqZR");

var $4JKjc = parcelRequire("4JKjc");

var $2yLHC = parcelRequire("2yLHC");

var $7fUGY = parcelRequire("7fUGY");
function $28ad5b80ef4531e0$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $2yLHC.getWeekYear)(date, options);
    const firstWeek = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $7fUGY.startOfWeek)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$28ad5b80ef4531e0$export$2e2bcd8739ae039 = $28ad5b80ef4531e0$export$bb7b45bb8e74da0f;

});
parcelRegister("2yLHC", function(module, exports) {

$parcel$export(module.exports, "getWeekYear", () => $1dd3c2775aeead00$export$12d572480ceb6e58);

var $clqZR = parcelRequire("clqZR");

var $4JKjc = parcelRequire("4JKjc");

var $7fUGY = parcelRequire("7fUGY");

var $9piCv = parcelRequire("9piCv");
function $1dd3c2775aeead00$export$12d572480ceb6e58(date, options) {
    const _date = (0, $9piCv.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $7fUGY.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $4JKjc.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $7fUGY.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$1dd3c2775aeead00$export$2e2bcd8739ae039 = $1dd3c2775aeead00$export$12d572480ceb6e58;

});



parcelRegister("1SrIf", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $15e054c450fa906c$export$c8306e720e213c0f);
function $15e054c450fa906c$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});

parcelRegister("1OfHQ", function(module, exports) {

$parcel$export(module.exports, "lightFormatters", () => $1516a4dede9b3dcb$export$b0d4b338e1516f13);

var $1SrIf = parcelRequire("1SrIf");
const $1516a4dede9b3dcb$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $1SrIf.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $1SrIf.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $1SrIf.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $1SrIf.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

});


parcelRegister("4lli5", function(module, exports) {

$parcel$export(module.exports, "longFormatters", () => $3299a3782897d2c4$export$70cc8fd02856fd58);
const $3299a3782897d2c4$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $3299a3782897d2c4$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $3299a3782897d2c4$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $3299a3782897d2c4$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3299a3782897d2c4$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3299a3782897d2c4$var$timeLongFormatter(timePattern, formatLong));
};
const $3299a3782897d2c4$export$70cc8fd02856fd58 = {
    p: $3299a3782897d2c4$var$timeLongFormatter,
    P: $3299a3782897d2c4$var$dateTimeLongFormatter
};

});

parcelRegister("9zwaQ", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $6f8057073b26e801$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $6f8057073b26e801$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "warnOrThrowProtectedError", () => $6f8057073b26e801$export$f5f38f90ecaaf879);
const $6f8057073b26e801$var$dayOfYearTokenRE = /^D+$/;
const $6f8057073b26e801$var$weekYearTokenRE = /^Y+$/;
const $6f8057073b26e801$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $6f8057073b26e801$export$c6cc36aa33304772(token) {
    return $6f8057073b26e801$var$dayOfYearTokenRE.test(token);
}
function $6f8057073b26e801$export$c6b49d6dceb604a1(token) {
    return $6f8057073b26e801$var$weekYearTokenRE.test(token);
}
function $6f8057073b26e801$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $6f8057073b26e801$var$message(token, format, input);
    console.warn(_message);
    if ($6f8057073b26e801$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $6f8057073b26e801$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

});

parcelRegister("gla4m", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $be566b14e93ea1f9$export$1ea939691cdc45b8);

var $bicdS = parcelRequire("bicdS");

var $9piCv = parcelRequire("9piCv");
function $be566b14e93ea1f9$export$1ea939691cdc45b8(date) {
    return !(!(0, $bicdS.isDate)(date) && typeof date !== "number" || isNaN(+(0, $9piCv.toDate)(date)));
}
var // Fallback for modularized imports:
$be566b14e93ea1f9$export$2e2bcd8739ae039 = $be566b14e93ea1f9$export$1ea939691cdc45b8;

});
parcelRegister("bicdS", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $838adb5272615574$export$871608497c498473);
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $838adb5272615574$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$838adb5272615574$export$2e2bcd8739ae039 = $838adb5272615574$export$871608497c498473;

});



parcelRegister("01yxO", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $004ae3e38e95f2b8$export$8fbbfd65594f46a0);

var $lDwz3 = parcelRequire("lDwz3");

var $clqZR = parcelRequire("clqZR");

var $8k4Ky = parcelRequire("8k4Ky");

var $exQSP = parcelRequire("exQSP");

var $bQTtn = parcelRequire("bQTtn");
function $004ae3e38e95f2b8$export$8fbbfd65594f46a0(date, baseDate, options) {
    const [date_, baseDate_] = (0, $8k4Ky.normalizeDates)(options?.in, date, baseDate);
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $lDwz3.enUS);
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const diff = (0, $exQSP.differenceInCalendarDays)(date_, baseDate_);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    let token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    const formatStr = locale.formatRelative(token, date_, baseDate_, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $bQTtn.format)(date_, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}
var // Fallback for modularized imports:
$004ae3e38e95f2b8$export$2e2bcd8739ae039 = $004ae3e38e95f2b8$export$8fbbfd65594f46a0;

});

parcelRegister("9Mags", function(module, exports) {

$parcel$export(module.exports, "fr", () => $71e08f0cb96e66bd$export$acb2a88f7d552ebf);

var $ajAml = parcelRequire("ajAml");

var $bu71Y = parcelRequire("bu71Y");

var $6eCfD = parcelRequire("6eCfD");

var $eKJ2Y = parcelRequire("eKJ2Y");

var $eLBeG = parcelRequire("eLBeG");
const $71e08f0cb96e66bd$export$acb2a88f7d552ebf = {
    code: "fr",
    formatDistance: (0, $ajAml.formatDistance),
    formatLong: (0, $bu71Y.formatLong),
    formatRelative: (0, $6eCfD.formatRelative),
    localize: (0, $eKJ2Y.localize),
    match: (0, $eLBeG.match),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$71e08f0cb96e66bd$export$2e2bcd8739ae039 = $71e08f0cb96e66bd$export$acb2a88f7d552ebf;

});
parcelRegister("ajAml", function(module, exports) {

$parcel$export(module.exports, "formatDistance", () => $7827e1ee3e178330$export$2c14ff85d6318973);
const $7827e1ee3e178330$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
const $7827e1ee3e178330$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const form = $7827e1ee3e178330$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};

});

parcelRegister("bu71Y", function(module, exports) {

$parcel$export(module.exports, "formatLong", () => $85c7f333f81b7d01$export$cbf60ecb96cbb82f);

var $27kCy = parcelRequire("27kCy");
const $85c7f333f81b7d01$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
const $85c7f333f81b7d01$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
const $85c7f333f81b7d01$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $85c7f333f81b7d01$export$cbf60ecb96cbb82f = {
    date: (0, $27kCy.buildFormatLongFn)({
        formats: $85c7f333f81b7d01$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $27kCy.buildFormatLongFn)({
        formats: $85c7f333f81b7d01$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $27kCy.buildFormatLongFn)({
        formats: $85c7f333f81b7d01$var$dateTimeFormats,
        defaultWidth: "full"
    })
};

});

parcelRegister("6eCfD", function(module, exports) {

$parcel$export(module.exports, "formatRelative", () => $48a1b8c5b94b87ba$export$8fbbfd65594f46a0);
const $48a1b8c5b94b87ba$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
const $48a1b8c5b94b87ba$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$48a1b8c5b94b87ba$var$formatRelativeLocale[token];

});

parcelRegister("eKJ2Y", function(module, exports) {

$parcel$export(module.exports, "localize", () => $abd84df413b635c4$export$b3bd0bc58e36cd63);

var $h8wHD = parcelRequire("h8wHD");
const $abd84df413b635c4$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
const $abd84df413b635c4$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
const $abd84df413b635c4$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
const $abd84df413b635c4$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
const $abd84df413b635c4$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
const $abd84df413b635c4$var$ordinalNumber = (dirtyNumber, options)=>{
    const number = Number(dirtyNumber);
    const unit = options?.unit;
    if (number === 0) return "0";
    const feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    let suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
const $abd84df413b635c4$var$LONG_MONTHS_TOKENS = [
    "MMM",
    "MMMM"
];
const $abd84df413b635c4$export$b3bd0bc58e36cd63 = {
    preprocessor: (date, parts)=>{
        // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
        // Use case "do MMMM" => 1er août, 29 août
        // see https://github.com/date-fns/date-fns/issues/1391
        if (date.getDate() === 1) return parts;
        const hasLongMonthToken = parts.some((part)=>part.isToken && $abd84df413b635c4$var$LONG_MONTHS_TOKENS.includes(part.value));
        if (!hasLongMonthToken) return parts;
        return parts.map((part)=>part.isToken && part.value === "do" ? {
                isToken: true,
                value: "d"
            } : part);
    },
    ordinalNumber: $abd84df413b635c4$var$ordinalNumber,
    era: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $h8wHD.buildLocalizeFn)({
        values: $abd84df413b635c4$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};

});

parcelRegister("eLBeG", function(module, exports) {

$parcel$export(module.exports, "match", () => $ac0256b859bbb5bc$export$4659b591c19bdf3d);

var $21azF = parcelRequire("21azF");

var $ggD50 = parcelRequire("ggD50");
const $ac0256b859bbb5bc$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
const $ac0256b859bbb5bc$var$parseOrdinalNumberPattern = /\d+/i;
const $ac0256b859bbb5bc$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
const $ac0256b859bbb5bc$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
const $ac0256b859bbb5bc$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
const $ac0256b859bbb5bc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $ac0256b859bbb5bc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
const $ac0256b859bbb5bc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $ac0256b859bbb5bc$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
const $ac0256b859bbb5bc$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
const $ac0256b859bbb5bc$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
const $ac0256b859bbb5bc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
const $ac0256b859bbb5bc$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $ggD50.buildMatchPatternFn)({
        matchPattern: $ac0256b859bbb5bc$var$matchOrdinalNumberPattern,
        parsePattern: $ac0256b859bbb5bc$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value)
    }),
    era: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ac0256b859bbb5bc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $21azF.buildMatchFn)({
        matchPatterns: $ac0256b859bbb5bc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ac0256b859bbb5bc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

});



parcelRegister("4ARPW", function(module, exports) {

var $bQTtn = parcelRequire("bQTtn");

var $9Mags = parcelRequire("9Mags");
var $358449145bcc6074$var$localeFns = {
    locale: $9Mags.fr
};
/*
 * <format-date datetime="2020-06-04T12:27:06.222Z">
 */ class $358449145bcc6074$var$FormatDate extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.render();
        this.onclick = function() {
            this.render();
        };
    }
    render() {
        var x = new Date(this.getAttribute('datetime'));
        this.innerHTML = $bQTtn.format(x, 'PP', $358449145bcc6074$var$localeFns);
    }
}
customElements.define('format-date', $358449145bcc6074$var$FormatDate);

});

parcelRegister("5JGum", function(module, exports) {

var $hZ3s7 = parcelRequire("hZ3s7");

var $9Mags = parcelRequire("9Mags");
var $42d21d1d2554d6c6$var$localeFns = {
    locale: $9Mags.fr
};
/*
 * <format-distance startdate="2020-06-04T12:27:06.222Z" enddate="2021-06-04T12:27:06.222Z">
 */ class $42d21d1d2554d6c6$var$DistanceTime extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.render();
    }
    render() {
        var start = new Date(this.getAttribute('startdate'));
        var end = new Date(this.getAttribute('enddate'));
        this.innerHTML = $hZ3s7.formatDistanceStrict(end, start, $42d21d1d2554d6c6$var$localeFns);
    }
}
customElements.define('format-distance', $42d21d1d2554d6c6$var$DistanceTime);

});
parcelRegister("hZ3s7", function(module, exports) {

$parcel$export(module.exports, "formatDistanceStrict", () => $d17acfca019529ad$export$e4be225b8ee0a759);

var $lDwz3 = parcelRequire("lDwz3");

var $clqZR = parcelRequire("clqZR");

var $6XJQC = parcelRequire("6XJQC");

var $dL2Ic = parcelRequire("dL2Ic");

var $8k4Ky = parcelRequire("8k4Ky");

var $5u67A = parcelRequire("5u67A");

var $lXVqG = parcelRequire("lXVqG");
function $d17acfca019529ad$export$e4be225b8ee0a759(laterDate, earlierDate, options) {
    const defaultOptions = (0, $clqZR.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $lDwz3.enUS);
    const comparison = (0, $5u67A.compareAsc)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $8k4Ky.normalizeDates)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const roundingMethod = (0, $6XJQC.getRoundingMethod)(options?.roundingMethod ?? "round");
    const milliseconds = earlierDate_.getTime() - laterDate_.getTime();
    const minutes = milliseconds / (0, $lXVqG.millisecondsInMinute);
    const timezoneOffset = (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(earlierDate_) - (0, $dL2Ic.getTimezoneOffsetInMilliseconds)(laterDate_);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    const dstNormalizedMinutes = (milliseconds - timezoneOffset) / (0, $lXVqG.millisecondsInMinute);
    const defaultUnit = options?.unit;
    let unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < (0, $lXVqG.minutesInDay)) unit = "hour";
        else if (dstNormalizedMinutes < (0, $lXVqG.minutesInMonth)) unit = "day";
        else if (dstNormalizedMinutes < (0, $lXVqG.minutesInYear)) unit = "month";
        else unit = "year";
    } else unit = defaultUnit;
    // 0 up to 60 seconds
    if (unit === "second") {
        const seconds = roundingMethod(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        const roundedMinutes = roundingMethod(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        const hours = roundingMethod(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        const days = roundingMethod(dstNormalizedMinutes / (0, $lXVqG.minutesInDay));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        const months = roundingMethod(dstNormalizedMinutes / (0, $lXVqG.minutesInMonth));
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else {
        const years = roundingMethod(dstNormalizedMinutes / (0, $lXVqG.minutesInYear));
        return locale.formatDistance("xYears", years, localizeOptions);
    }
}
var // Fallback for modularized imports:
$d17acfca019529ad$export$2e2bcd8739ae039 = $d17acfca019529ad$export$e4be225b8ee0a759;

});
parcelRegister("6XJQC", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $511bd12385432cec$export$b6474a47258c1211);
function $511bd12385432cec$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}

});

parcelRegister("5u67A", function(module, exports) {

$parcel$export(module.exports, "compareAsc", () => $3fe480aea1043697$export$fe114145ae75d197);

var $9piCv = parcelRequire("9piCv");
function $3fe480aea1043697$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $9piCv.toDate)(dateLeft) - +(0, $9piCv.toDate)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$3fe480aea1043697$export$2e2bcd8739ae039 = $3fe480aea1043697$export$fe114145ae75d197;

});



parcelRegister("3Ii3I", function(module, exports) {
module.exports = function raf(app) {
    var lastTime = 0;
    var vendors = [
        'ms',
        'moz',
        'webkit',
        'o'
    ];
    var usingSetTimeout = false;
    if (!window.requestAnimationFrame) vendors.forEach(function(prefix) {
        window.requestAnimationFrame = window[prefix + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[prefix + 'CancelAnimationFrame'] || window[prefix + 'CancelRequestAnimationFrame'];
    });
    if (!window.requestAnimationFrame) {
        usingSetTimeout = true;
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
    if (!window.cancelAnimationFrame) {
        if (usingSetTimeout) window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
        else window.cancelAnimationFrame = function() {};
    }
    return app;
};

});

parcelRegister("4lCIN", function(module, exports) {
module.exports = function keyboard(app) {
    window.addEventListener('keypress', function(e) {
        if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") ;
        else app.ports.onKeypressNoInput.send(e.keyCode);
    });
// window.addEventListener('keydown', function (e) {
//   if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") {
//     // filling a form...
//   } else {
//     // do not scroll
//     if (e.keyCode == 32) e.preventDefault();
//     app.ports.onKeydownNoInput.send(e.keyCode);
//   }
// });
// window.addEventListener('keyup', function (e) {
//   if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT" || e.target.tagName === "TEXTAREA") {
//     // filling a form...
//   } else {
//     app.ports.onKeyupNoInput.send(e.keyCode);
//   }
// });
};

});

parcelRegister("56a0I", function(module, exports) {
module.exports = function viewport(app) {
    window.onresize = function() {
        app.ports.viewport.send({
            width: window.innerWidth,
            height: window.innerHeight,
            isFullscreen: !!(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement)
        });
    };
};

});

parcelRegister("j63Xd", function(module, exports) {
window.document.body.addEventListener("click", function(e) {
    var target = e.target;
    var current = document.getElementById("CatchClickAll");
    if (!current) return true;
    do {
        if (target === current) return true;
    }while (target = target.parentNode);
    current.click();
}, true);

});

parcelRegister("fFcjN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3704c843920dcfc2$export$2e2bcd8739ae039);

var $ffDwH = parcelRequire("ffDwH");

var $kjMit = parcelRequire("kjMit");

var $eqZ8F = parcelRequire("eqZ8F");

var $8dcRR = parcelRequire("8dcRR");

var $gguoi = parcelRequire("gguoi");

var $6jqaU = parcelRequire("6jqaU");
const $3704c843920dcfc2$var$$ = $gguoi.$;
var $3704c843920dcfc2$var$shakaVideoContainer;
// shaka buffer config (in second)
const $3704c843920dcfc2$var$BUFFERBEHIND = 300;
const $3704c843920dcfc2$var$BUFFERINGGOAL = 300;
const $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY = 0.00001;
const $3704c843920dcfc2$var$IS_IOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
function $3704c843920dcfc2$export$2e2bcd8739ae039(app) {
    function sendEventToElm(event) {
        app.ports.jsToElm?.send(Object.assign({
            action: '',
            buffer: [
                {
                    start: 0,
                    end: 0
                }
            ],
            frame: 0
        }, event));
    }
    function preventDefaultWindowOnSpace(event) {
        if (event.key == ' ' && ![
            'INPUT',
            'TEXTAREA'
        ].includes(event.target.nodeName)) event.preventDefault();
    }
    function computeCurrentFrame(video, frameRate, supportFrameAccuracy) {
        if (supportFrameAccuracy) return $8dcRR(video);
        else return Math.floor(video.currentTime * frameRate);
    }
    class Nomaplayer extends HTMLElement {
        constructor(){
            super(), this.state = {
                selectedTracks: [],
                audiotracks: [],
                manifest: '',
                player: {},
                currentSubtitle: '',
                frameRate: 0,
                startTimecode: '00:00:00:00'
            }, this.frameAccuracySupport = true, // Timecode input
            this.maskInput = {}, this.timecodeMaskElt = {}, // Timecode overlay
            this.timeMaskElt = {}, this.timeCursorElt = {}, this.timeTCElt = {}, // Proxy `this` inside listener
            this.videoProgressListener = (event)=>this.onVideoProgress(event), this.inputFocusListener = ()=>this.getVideo().pause(), this.inputBlurListener = ()=>setTimeout(()=>this.getVideo().focus(), 10), this.moveTimecodeListener = (event)=>this.moveTimecode(event), this.requestFrameTimecodeOverlayListener = ()=>this.requestFrameTimecodeOverlay(), this.portsFromElm = (event)=>this.eventFromElm(event), this.onTimeMaskClickListener = (event)=>this.onTimeMaskClick(event), this.keyUpVideo = (event)=>{
                if (!(event.target.tagName === 'INPUT' || event.target.tagName === 'SELECT' || event.target.tagName === 'TEXTAREA')) switch(event.keyCode){
                    // space
                    case 32:
                        if (this.getVideo().paused) this.play();
                        else this.pause();
                        break;
                    // Left arrow
                    case 37:
                        this.prevFrame();
                        break;
                    // Right arrow
                    case 39:
                        this.nextFrame();
                }
            };
            $6jqaU.polyfill.installAll();
            this.attachShadow({
                mode: 'open'
            });
            this.frameAccuracySupport = !(!$6jqaU.Player.isBrowserSupported() || $3704c843920dcfc2$var$IS_IOS);
            const videoCtrl = document.createElement('div');
            $3704c843920dcfc2$var$shakaVideoContainer = videoCtrl;
            const videoStyles = document.createElement('style');
            videoStyles.innerHTML = `
.shaka-hidden{display:none!important}
.shaka-video-container{pointer-events:none;position:absolute;left:1vw;right:1vw;top:1vw;bottom:1vw;display:flex}

.shaka-text-container{position:absolute;left:0;right:0;top:0;bottom:0;font-size:1vw;line-height:1.4;color:#fff}
.shaka-text-container span.shaka-text-wrapper{display:inline;background:0 0}
@media (min-width: 1000px) and (max-width: 1400px) { .shaka-text-container { font-size: 1.55vw; } }
@media (max-width: 1000px) { .shaka-text-container { font-size: 2.2vw; } }
.PlayerFullScreen .shaka-text-container { font-size: 2.2vw !important; }
.shaka-text-container * { background-color: rgba(0,0,0,0) !important; }
.shaka-text-container {
  text-shadow: 0 0 0.11vw #000, 0 0 2px #000, 0 0 2px #000;
}
.PlayerControlsShown.shaka-video-container { bottom: calc(90px + 1vw); }

.shaka-spinner-container{display:none;}
      `;
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%;display: block;margin-top: -3.68%;');
            video.setAttribute('id', 'video-player');
            video.setAttribute('playsinline', '');
            video.setAttribute('crossOrigin', 'anonymous');
            this.shadowRoot?.appendChild(video);
            this.shadowRoot?.appendChild(videoCtrl);
            this.shadowRoot?.appendChild(videoStyles);
        }
        connectedCallback() {
            this.initVariables();
            fetch(new Request(`/v4/proxy/${this.getAttribute('data-manifest')}/play`, {
                method: 'POST'
            }));
            this.render();
            app.ports.elmToJs?.subscribe(this.portsFromElm);
        }
        disconnectedCallback() {
            app.ports.elmToJs?.unsubscribe(this.portsFromElm);
            this.maskInput.destroy();
            this.ui.destroy();
            return this.state.player.destroy().then(()=>{
                this.state = {
                    selectedTracks: [],
                    audiotracks: [],
                    manifest: '',
                    player: {},
                    currentSubtitle: '',
                    frameRate: 0,
                    startTimecode: '00:00:00:00'
                };
                this.timecodeMaskElt.removeEventListener('focus', this.inputFocusListener);
                this.timecodeMaskElt.removeEventListener('blur', this.inputBlurListener);
                this.timeMaskElt.removeEventListener('mousemove', this.moveTimecodeListener);
                this.timeMaskElt.removeEventListener('mouseleave', this.requestFrameTimecodeOverlayListener);
                this.timeMaskElt.removeEventListener('click', this.onTimeMaskClickListener);
                this.getVideo().removeEventListener('ended', this.ended);
                this.getVideo().removeEventListener('progress', this.onVideoLoading);
                this.getVideo().removeEventListener('timeupdate', this.videoProgressListener);
                this.getVideo().removeEventListener('click', this.playOrPause);
                this.getVideo().removeEventListener('dblclick', this.handleFullScreen);
                window.removeEventListener('keydown', preventDefaultWindowOnSpace);
                window.removeEventListener('keyup', this.keyUpVideo);
            });
        }
        initVariables() {
            const manifest = this.getAttribute('data-manifest');
            if (manifest) this.state.manifest = manifest;
            const audiostracks = this.getAttribute('data-audiostracks');
            if (audiostracks) {
                this.state.audiotracks = JSON.parse(audiostracks);
                if (!this.state.audiotracks.length) this.state.audiotracks.push('1');
            }
            const playbackSpeed = this.getAttribute('data-playbackspeed');
            if (playbackSpeed) this.getVideo().playbackRate = parseFloat(playbackSpeed);
            const subtitles = this.getAttribute('data-subtitles');
            if (subtitles) this.state.currentSubtitle = subtitles;
            const framerate = this.getAttribute('data-framerate');
            if (framerate) this.state.frameRate = parseFloat(framerate);
            const startTimecode = this.getAttribute('data-starttimecode');
            if (startTimecode) this.state.startTimecode = startTimecode;
        }
        static get observedAttributes() {
            return [
                'data-manifest',
                'data-audiostracks',
                'data-playbackspeed',
                'data-subtitles',
                'data-framerate',
                'data-starttimecode'
            ];
        }
        attributeChangedCallback(name, _, newValue) {
            switch(name){
                case 'data-audiostracks':
                    this.state.audiotracks = JSON.parse(newValue);
                    if (Object.entries(this.state.player).length !== 0) this.loadVideo();
                    break;
                case 'data-manifest':
                    const isInitialized = this.state.manifest !== '';
                    this.state.manifest = newValue;
                    // Clear the current player if the manifest change and it was already initialized
                    if (isInitialized) {
                        if (this.state.player.destroy) return this.state.player.destroy().then(()=>this.initPlayer());
                        this.initPlayer();
                    }
                    break;
                case 'data-starttimecode':
                    this.state.startTimecode = newValue;
                    break;
                case 'data-playbackspeed':
                    if (newValue) this.getVideo().playbackRate = parseFloat(newValue);
                    break;
                case 'data-framerate':
                    if (newValue) this.state.frameRate = parseFloat(newValue);
                    break;
                case 'data-subtitles':
                    if (newValue != null) {
                        this.state.currentSubtitle = newValue;
                        if (this.state.player.destroy) return this.state.player.destroy().then(()=>this.initPlayer());
                        this.initPlayer();
                    }
                    break;
                default:
            }
        }
        eventFromElm(event) {
            switch(event.action){
                case 'Play':
                    this.play();
                    break;
                case 'Pause':
                    this.pause();
                    break;
                case 'GoTo':
                    if (event.frame !== undefined) this.goToFrame(event.frame);
                    break;
                case 'GoToStart':
                    this.goToStart();
                    break;
                case 'GoToEnd':
                    this.goToEnd();
                    break;
                case 'SubstractTime':
                    if (event.seconds !== undefined) this.substractTime(event.seconds);
                    break;
                case 'AddTime':
                    if (event.seconds !== undefined) this.addTime(event.seconds);
                    break;
                case 'NextFrame':
                    this.nextFrame();
                    break;
                case 'PrevFrame':
                    this.prevFrame();
                    break;
                case 'Fullscreen':
                    this.handleFullScreen();
                    break;
                case 'Aspectratio':
                    if (event.trackSelection !== undefined) this.state.selectedTracks = event.trackSelection;
                    break;
                case 'GetPicture':
                    if (event.rawFrame !== undefined) this.rawFrame(event.rawFrame);
                    break;
            }
        }
        play() {
            this.getVideo().play();
        }
        pause() {
            this.getVideo().pause();
        }
        playOrPause(event) {
            const videoElt = event.currentTarget;
            if (videoElt.paused) videoElt.play();
            else videoElt.pause();
        }
        substractTime(seconds) {
            if (this.getVideo().currentTime - seconds > 0) this.getVideo().currentTime -= seconds;
            else this.getVideo().currentTime = 0;
        }
        addTime(seconds) {
            if (this.getVideo().currentTime + seconds < this.getVideo().duration) this.getVideo().currentTime += seconds;
            else // Since setting the duration of the video make it bug, just remove the little constant to make it works
            this.getVideo().currentTime = this.getVideo().duration - $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
        }
        goToFrame(frame) {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const lastFrameNumber = Math.floor(this.state.frameRate * this.getVideo().duration) - 1;
                if (frame < 0) frame = 0;
                if (frame > lastFrameNumber) frame = lastFrameNumber;
                this.getVideo().currentTime = frame / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        nextFrame() {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const lastFrameNumber = Math.floor(this.state.frameRate * this.getVideo().duration) - 1;
                if (currentFrame < lastFrameNumber) this.getVideo().currentTime = (currentFrame + 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        prevFrame() {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            if (!isNaN(currentFrame)) {
                const frameNumber = isNaN(currentFrame) ? null : currentFrame;
                if (frameNumber != null && frameNumber > 0) this.getVideo().currentTime = (currentFrame - 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
            }
        }
        goToStart() {
            this.getVideo().currentTime = 0;
        }
        goToEnd() {
            const totalFrames = Math.round(this.state.frameRate * this.getVideo().duration);
            this.getVideo().currentTime = (totalFrames - 1) / this.state.frameRate + $3704c843920dcfc2$var$CONSTANT_VIDEO_INTERACTIVITY;
        }
        rawFrame(params) {
            const currentFrame = computeCurrentFrame(this.getVideo(), this.state.frameRate, this.frameAccuracySupport);
            const frameNumber = isNaN(currentFrame) ? null : currentFrame;
            if (frameNumber != null) {
                const seconds = Math.floor(frameNumber / params.frameRate * 100) / 100;
                const imageUrl = `${window.nomalab.raw_frame_url}?bucket=${params.bucket}&key=${params.key}&seconds=${seconds}&user=${window.nomalab.user.id}`;
                const newWin = open('', '', 'height=1920,width=1080,toolbar=no,location=no,directories=no,status=no');
                if (newWin) newWin.document.write((0, $ffDwH.render)(imageUrl));
            }
        }
        getVideo() {
            return this.shadowRoot?.childNodes[0];
        }
        getMpdUrl() {
            const subtitle = this.state.currentSubtitle ? `?subtitle=${this.state.currentSubtitle}` : '';
            return `/v3/files/${this.state.manifest}/manifest${subtitle}`;
        }
        getMp4Url() {
            return fetch(this.getMpdUrl()).then((resp)=>{
                if (resp.ok) return resp.text().then((xml)=>{
                    let url = xml.match(/>([^>]+video_[^<]+\.mp4[^<]+)</g)[0].slice(1, -1);
                    let txt = document.createElement("textarea");
                    txt.innerHTML = url;
                    return txt.value;
                });
            });
        }
        // TODO Move this back in the elm
        displaySelectedVideo() {
            const videoStream = $3704c843920dcfc2$var$$('[name=selected-video-track]');
            if (videoStream) videoStream.checked = true;
        }
        onTimeMaskClick(event) {
            const b = this.timeMaskElt.getBoundingClientRect();
            const frame = Math.round((event.x - b.x) / b.width * this.state.frameRate * (this.getVideo().duration - 1 / this.state.frameRate));
            this.goToFrame(frame);
        }
        loadVideoOnly() {
            this.getMp4Url().then((url)=>{
                this.getVideo().src = url;
                this.getVideo().play();
            });
        }
        loadVideo() {
            this.state.player.setTextTrackVisibility(this.state.currentSubtitle != '' && this.state.currentSubtitle != null);
            const tracks = this.state.player.getVariantTracks();
            const trackIndex = parseInt(this.state.audiotracks[0]);
            const selectedTrack = tracks.find((el)=>{
                if (el.label?.includes('audio_stream')) {
                    const searchId = new RegExp("audio_stream_([^//]+)$");
                    const trackId = parseInt(el.label.replace(searchId, '$1'));
                    return trackId === (trackIndex || 0);
                }
                return false;
            });
            if (selectedTrack) {
                this.displaySelectedVideo();
                app.ports.updateAudioStreams.send([
                    [
                        trackIndex,
                        null
                    ]
                ]);
                this.state.player.selectVariantTrack(selectedTrack, true);
            }
            // Timecode input
            const timecodeMaskElt = $3704c843920dcfc2$var$$('.TimecodeEditable');
            if (timecodeMaskElt) {
                this.timecodeMaskElt = timecodeMaskElt;
                const lastTC = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate,
                    timecode: this.state.startTimecode
                });
                lastTC.add([
                    Math.floor(this.state.frameRate * this.getVideo().duration) - 1
                ]);
                const tc = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate,
                    timecode: this.state.startTimecode
                });
                this.maskInput = (0, $kjMit.inputMaskTimecode)(this.timecodeMaskElt, tc.frameCount, lastTC.frameCount, this.state.frameRate, (tc)=>{
                    tc.subtract([
                        this.state.startTimecode
                    ]);
                    this.goToFrame(tc.frameCount);
                });
                this.maskInput.setTc(tc);
                this.timecodeMaskElt.addEventListener('focus', this.inputFocusListener);
                this.timecodeMaskElt.addEventListener('blur', this.inputBlurListener);
            }
            // Timecode overlay on mousemove
            // TODO: do something better
            const timeMaskElt = $3704c843920dcfc2$var$$('.PlayerControlsTimeMask');
            if (timeMaskElt && !this.timeMaskElt.addEventListener) {
                this.timeMaskElt = timeMaskElt;
                this.timeMaskElt.addEventListener('mouseleave', this.requestFrameTimecodeOverlayListener);
                this.timeMaskElt.addEventListener('click', this.onTimeMaskClickListener);
                this.timeCursorElt = document.createElement('div');
                this.timeCursorElt.className = 'PlayerControlsTimeCursor';
                this.timeCursorElt.style.pointerEvents = 'none';
                this.timeTCElt = document.createElement('span');
                this.timeTCElt.className = 'PlayerControlsTimeTimecode';
                this.timeCursorElt.appendChild(this.timeTCElt);
                if (this.timeMaskElt) {
                    this.timeMaskElt.appendChild(this.timeCursorElt);
                    this.timeMaskElt.addEventListener('mousemove', this.moveTimecodeListener);
                }
            }
            this.state.player.addEventListener('buffering', this.buffer);
            this.getVideo().addEventListener('ended', this.ended);
            this.getVideo().addEventListener('progress', this.onVideoLoading);
            this.getVideo().addEventListener('timeupdate', this.videoProgressListener);
            this.getVideo().addEventListener('click', this.playOrPause);
            this.getVideo().addEventListener('dblclick', this.handleFullScreen);
            window.addEventListener('keydown', preventDefaultWindowOnSpace);
            window.addEventListener('keyup', this.keyUpVideo);
        }
        buffer(event) {
            const action = event.buffering ? 'Buffering' : 'StopBuffering';
            sendEventToElm({
                action: action
            });
        }
        ended() {
            sendEventToElm({
                action: 'Finished'
            });
        }
        onVideoLoading(event) {
            const videoElt = event.currentTarget;
            if (videoElt.buffered.length) {
                const eventForElm = {
                    action: 'Loaded',
                    buffer: [
                        {
                            start: videoElt.buffered.start(0),
                            end: videoElt.buffered.end(0)
                        }
                    ]
                };
                sendEventToElm(eventForElm);
            }
        }
        onVideoProgress(event) {
            const videoElt = event.currentTarget;
            const frameNumber = computeCurrentFrame(videoElt, this.state.frameRate, this.frameAccuracySupport);
            sendEventToElm({
                action: videoElt.paused ? 'isPaused' : 'Playing',
                frame: frameNumber
            });
            this.setTcFromFrame(frameNumber);
        }
        setTcFromFrame(frame) {
            const tc = (0, $eqZ8F.Timecode).init({
                framerate: this.state.frameRate
            });
            tc.setFrameNumberToTimecode(frame);
            tc.add([
                this.state.startTimecode
            ]);
            this.maskInput.setTc(tc);
        }
        moveTimecode(evt) {
            const b = this.timeMaskElt.getBoundingClientRect();
            if (evt.x < b.x + b.width && evt.x >= b.x && evt.y >= b.y && evt.y <= b.y + b.height) {
                const frame = Math.round((evt.x - b.x) / b.width * this.state.frameRate * (this.getVideo().duration - 1 / this.state.frameRate));
                const tc = (0, $eqZ8F.Timecode).init({
                    framerate: this.state.frameRate
                });
                tc.set(frame);
                tc.add([
                    this.state.startTimecode
                ]);
                requestAnimationFrame(()=>{
                    this.timeTCElt.innerHTML = tc.toString();
                    this.timeTCElt.style.transform = evt.offsetX < 80 ? `translateX(100%)` : '';
                    this.timeCursorElt.style.left = `${evt.x - b.x}px`;
                    this.timeMaskElt.style.opacity = '1';
                });
            } else requestAnimationFrame(()=>this.timeMaskElt.style.opacity = '0');
        }
        requestFrameTimecodeOverlay() {
            requestAnimationFrame(()=>this.timeMaskElt.style.opacity = '0');
        }
        warns(message) {
            const banner = $3704c843920dcfc2$var$$('.PlayerBanner');
            $3704c843920dcfc2$var$$('.PlayerBanner .BannerContent').innerHTML = message;
            banner.style.display = '';
            banner.addEventListener('click', function h() {
                banner.style.display = 'none';
                banner.removeEventListener('click', h);
            });
        }
        handleFullScreen() {
            const videoWrapper = $3704c843920dcfc2$var$$('#player-wrapper');
            const controlsWrapper = $3704c843920dcfc2$var$$('.PlayerControlsBox');
            let hoveringControls = false;
            let controlsFullscreenDelay = 0;
            function playerMouseMove() {
                if (controlsFullscreenDelay) clearTimeout(controlsFullscreenDelay);
                if (!hoveringControls) controlsFullscreenDelay = setTimeout(hideControls, 1000);
                toggleCtrl(true);
            }
            function controlsMouseEnter() {
                hoveringControls = true;
            }
            function controlsMouseLeave() {
                hoveringControls = false;
            }
            function hideControls() {
                toggleCtrl(false);
            }
            if (videoWrapper.webkitRequestFullscreen) null == document.webkitFullscreenElement ? videoWrapper.webkitRequestFullscreen() : document.webkitExitFullscreen();
            else if (videoWrapper.mozRequestFullScreen) null == document.mozFullScreenElement ? videoWrapper.mozRequestFullScreen() : document.mozCancelFullScreen();
            else if (videoWrapper.msRequestFullscreen) null == document.msFullscreenElement ? videoWrapper.msRequestFullscreen() : document.msExitFullscreen();
            else if (videoWrapper.requestFullscreen) null == document.fullscreenElement ? videoWrapper.requestFullscreen() : document.exitFullscreen();
            else if ($3704c843920dcfc2$var$IS_IOS) this.getVideo().webkitEnterFullscreen();
            function toggleCtrl(shown) {
                if (shown === undefined) {
                    videoWrapper.classList.remove('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerControlsShown');
                } else if (shown) {
                    videoWrapper.classList.remove('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.add('PlayerControlsShown');
                } else {
                    videoWrapper.classList.add('PlayerControlsHidden');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerControlsShown');
                }
            }
            function toggleFullscreen(full) {
                if (full) {
                    videoWrapper.classList.add('PlayerFullScreen');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.add('PlayerFullScreen');
                } else {
                    videoWrapper.classList.remove('PlayerFullScreen');
                    $3704c843920dcfc2$var$shakaVideoContainer.classList.remove('PlayerFullScreen');
                }
            }
            function toggle() {
                if (!document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement && !document.fullscreenElement) {
                    toggleCtrl();
                    toggleFullscreen(false);
                    if (controlsFullscreenDelay) clearTimeout(controlsFullscreenDelay);
                    videoWrapper.removeEventListener('mousemove', playerMouseMove);
                    controlsWrapper.removeEventListener('mouseenter', controlsMouseEnter);
                    controlsWrapper.removeEventListener('mouseleave', controlsMouseLeave);
                } else {
                    toggleFullscreen(true);
                    videoWrapper.addEventListener('mousemove', playerMouseMove);
                    controlsWrapper.addEventListener('mouseenter', controlsMouseEnter);
                    controlsWrapper.addEventListener('mouseleave', controlsMouseLeave);
                }
            }
            videoWrapper.addEventListener('fullscreenchange', toggle);
            videoWrapper.addEventListener('mozfullscreenchange', toggle);
            videoWrapper.addEventListener('MSFullscreenChange', toggle);
            videoWrapper.addEventListener('webkitfullscreenchange', toggle);
        }
        initPlayer() {
            // Init the shaka player
            this.state.player = new $6jqaU.Player(this.getVideo());
            const ui = new $6jqaU.ui.Overlay(this.state.player, $3704c843920dcfc2$var$shakaVideoContainer, this.getVideo());
            this.ui = ui;
            // disable shaka native controls https://shaka-player-demo.appspot.com/docs/api/shaka.extern.html#.UIConfiguration
            ui.configure({
                controlPanelElements: [],
                overflowMenuButtons: [],
                contextMenuElements: [],
                addSeekBar: false
            });
            this.state.player.configure({
                abr: {
                    enabled: false
                },
                streaming: {
                    bufferBehind: $3704c843920dcfc2$var$BUFFERBEHIND,
                    bufferingGoal: $3704c843920dcfc2$var$BUFFERINGGOAL
                }
            });
            this.state.player.load(this.getMpdUrl()).catch(()=>{
                this.loadVideoOnly();
                if (!$3704c843920dcfc2$var$IS_IOS) {
                    const message = navigator.language.startsWith('fr') ? "Essayez de mettre \xe0 jour votre navigateur (Chrome, Edge, Firefox...) pour lire la vid\xe9o avec le son, sinon contactez-nous." : 'Please try updating your brwoser (Chrome, Edge, Firefox...) to play the video with Sound, otherwise contact us.';
                    this.warns(message);
                }
            }).then(()=>{
                this.loadVideo();
                sendEventToElm({
                    action: 'Added'
                });
            });
        }
        render() {
            this.initPlayer();
        }
    }
    customElements.define('noma-player', Nomaplayer);
}

});
parcelRegister("ffDwH", function(module, exports) {

$parcel$export(module.exports, "render", () => $8463e20461391507$export$b3890eb0ae9dca99);
function $8463e20461391507$export$b3890eb0ae9dca99(imageUrl) {
    return `<html>
<head>
  <title>Nomalab</title>                                                  
</head>
<body style="background:#555D68; text-align:center">
  <style>
    @keyframes anim_spin {
      from { transform: rotate(0deg); } 
      to { transform: rotate(359deg); }
    }
    span {
      font-family: Open Sans, Roboto,sans-serif;
      font-size:13px;
      font-weight: 500;
      color: #CFD1D5;
      display: block;
    }
    svg {
      animation: anim_spin 1s linear infinite;
      fill: #3BAAFF;
    }
    div {
      margin: 250px 0 0 0;
    }
  </style>
  <div id="nomalabSpinner">
    <svg height="40px" viewBox="0 0 40 40" width="40px">
      <g transform="translate(5, 9)">
        <path d="M15,0 C21.0751322,0 26,4.92486775 26,11 C26,17.0751322 21.0751322,22 15,22 C9.26195744,22 4.55007179,17.6065 4.04484302,12 L6.05492878,12 C6.55237307,16.4999505 10.3674463,20 15,20 C19.9705627,20 24,15.9705627 24,11 C24,6.02943725 19.9705627,2 15,2 L15,0 Z"/>
        <polygon points="5 6 10 12 0 12"/>
      </g>
    </svg>
    <span>Extraction en cours...</span>
  </div>
  <script>
    var i = document.createElement('img');
    var loadedCb = function () {
      window.nomalabSpinner.style.display = 'none';
      window.document.body.appendChild(i);
    };

    var errorCb = function (err) {
      document.querySelector('#nomalabSpinner svg').style.display = 'none';
      document.querySelector('#nomalabSpinner span').innerHTML = 'Une erreur est survenue. Merci de contacter notre service op\xe9rations via le chat ou par mail \xe0 ops@nomalab.com';
    };
    
    i.onload = loadedCb;
    i.onerror = errorCb;
    i.style = "width: 100%";
    
    // get url and then create IMAGE

    let myRequest = new Request('${imageUrl}');

    fetch(myRequest)
    .then(function(response) {
      if (!response.ok) {
        throw new Error(\`HTTP error! status: \${response.status}\`);
      }
      return response.text();
    })
    .then(function(imgUrl) {
      i.src = imgUrl;
    });

  </script>
  </body>
</html>`;
}

});

parcelRegister("kjMit", function(module, exports) {

$parcel$export(module.exports, "inputMaskTimecode", () => $aaf81a275793b52d$export$4bccd78e60fd0875);

var $eqZ8F = parcelRequire("eqZ8F");
function $aaf81a275793b52d$export$4bccd78e60fd0875(el, minFrame, maxFrame, frameRate, cb) {
    let savedTC = (0, $eqZ8F.Timecode).init({
        framerate: frameRate
    });
    let isEditing = false;
    function doNothing(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    }
    function formatTC(value) {
        let segments = value.split(':').map((i)=>i.padStart(2, '0'));
        while(segments.length < 4)segments.unshift('00');
        return segments.join(':');
    }
    const numbers = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ];
    const autorizedKeyCodes = [
        37,
        39,
        38,
        40,
        8,
        46
    ];
    function onFocus() {
        isEditing = true;
        savedTC = (0, $eqZ8F.Timecode).init({
            framerate: frameRate
        });
        savedTC.set(el.value);
    }
    function updateValue() {
        try {
            let nextTC = (0, $eqZ8F.Timecode).init({
                framerate: frameRate
            });
            nextTC.set(formatTC(el.value));
            if (minFrame > nextTC.frame_count) nextTC.set(minFrame);
            else if (maxFrame < nextTC.frame_count) nextTC.set(maxFrame);
            savedTC = nextTC;
            savedTC.timecodeToFrameNumber();
            cb(savedTC);
            el.value = savedTC.toString();
        } catch (e) {
            el.value = savedTC.toString();
        }
        isEditing = false;
    }
    function onKeyDown(e) {
        if (autorizedKeyCodes.includes(e.keyCode) || e.ctrlKey || e.metaKey) {
            e.stopImmediatePropagation();
            return true;
        } else if (e.keyCode == 13 || e.keyCode == 27) el.blur();
        else if (numbers.includes(e.key)) {
            let value = el.value;
            let position = el.selectionStart;
            let newChar = e.key;
            if (position) {
                let prevChar = parseInt(value.charAt(position - 1));
                let prev2Char = parseInt(value.charAt(position - 2));
                let nextChar = value.charAt(position);
                let notSelecting = position == el.selectionEnd;
                // Can't have more than 2 consecutive digits
                if (!isNaN(prev2Char) && !isNaN(prevChar)) doNothing(e);
                else if (!isNaN(prevChar) && nextChar != ':' && canHaveMoreSegments() && notSelecting) {
                    el.value = value.slice(0, position) + newChar + ':' + value.slice(position);
                    el.setSelectionRange(position + 2, position + 2);
                    doNothing(e);
                }
            }
        } else if (e.key == ':') {
            // limit to 3 colons ':'
            if (!canHaveMoreSegments()) return doNothing(e);
        } else return doNothing(e);
    }
    function canHaveMoreSegments() {
        return el.value.split(':').length < 4;
    }
    function setTc(tc) {
        if (isEditing) return;
        savedTC = tc;
        el.value = savedTC.toString();
    }
    function setTcFromFrame(frame) {
        if (isEditing) return;
        savedTC.setFrameNumberToTimecode(frame);
        el.value = savedTC.toString();
    }
    function init() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', updateValue);
        el.addEventListener('keydown', onKeyDown);
    }
    function destroy() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', updateValue);
        el.removeEventListener('keydown', onKeyDown);
    }
    init();
    return {
        destroy: destroy,
        setTc: setTc,
        setTcFromFrame: setTcFromFrame
    };
}

});
parcelRegister("eqZ8F", function(module, exports) {

$parcel$export(module.exports, "Timecode", () => $41342b85841ebc6f$export$c7bb7bfc56e79955);
if (typeof Object.create !== 'function') Object.create = function(o) {
    let F = function() {};
    F.prototype = o;
    return new F();
};
function $41342b85841ebc6f$var$getValueFromDict(dict, name, default_value) {
    if (dict.hasOwnProperty(name)) return dict[name];
    else return default_value;
}
const $41342b85841ebc6f$export$c7bb7bfc56e79955 = {
    framerate: '',
    intFramerate: 0,
    dropFrame: false,
    hours: 0,
    minutes: 0,
    seconds: 0,
    frames: 0,
    frameCount: 0,
    init: function(args) {
        let obj = Object.create(this);
        obj.framerate = $41342b85841ebc6f$var$getValueFromDict(args, 'framerate', '29.97');
        obj.intFramerate = obj.getIntFramerate();
        obj.dropFrame = $41342b85841ebc6f$var$getValueFromDict(args, 'drop_frame', false);
        obj.hours = false;
        obj.minutes = false;
        obj.seconds = false;
        obj.frames = false;
        obj.frameCount = false;
        obj.set($41342b85841ebc6f$var$getValueFromDict(args, 'timecode', 0));
        return obj;
    },
    getIntFramerate: function() {
        if (this.framerate === 'ms') return 1000;
        else return Math.round(parseFloat(this.framerate));
    },
    set: function(timecode) {
        if (typeof timecode === 'string') {
            this.partsFromString(timecode);
            this.timecodeToFrameNumber();
            this.frameNumberToTimecode();
        } else if (typeof timecode === 'number') {
            this.frameCount = timecode;
            this.frameNumberToTimecode();
        } else if (timecode instanceof Date) {
            this.frameCount = this.dateToFrameNumber(timecode);
            this.frameNumberToTimecode();
        }
    },
    partsFromString: function(timecode) {
        // Parses timecode strings non-drop 'hh:mm:ss:ff', drop 'hh:mm:ss;ff', or milliseconds 'hh:mm:ss:fff'
        if (timecode.length === 11) this.frames = parseInt(timecode.slice(9, 11));
        else if (timecode.length === 12 && this.framerate === 'ms') this.frames = parseInt(timecode.slice(9, 12));
        else throw new Error(`Timecode string parsing error. ${timecode}`);
        this.hours = parseInt(timecode.slice(0, 2));
        this.minutes = parseInt(timecode.slice(3, 5));
        this.seconds = parseInt(timecode.slice(6, 8));
    },
    frameNumberToTimecode: function() {
        // Converts frame_count to timecode
        let frame_count = this.frameCount;
        if (this.dropFrame) {
            let parts = this.frameNumberToDropFrameTimecode(frame_count);
            this.hours = parts[0];
            this.minutes = parts[1];
            this.seconds = parts[2];
            this.frames = parts[3];
        } else {
            this.hours = frame_count / (3600 * this.intFramerate);
            if (this.hours > 23) {
                this.hours = this.hours % 24;
                frame_count = frame_count - 82800 * this.intFramerate;
            }
            this.minutes = frame_count % (3600 * this.intFramerate) / (60 * this.intFramerate);
            this.seconds = frame_count % (3600 * this.intFramerate) % (60 * this.intFramerate) / this.intFramerate;
            this.frames = frame_count % (3600 * this.intFramerate) % (60 * this.intFramerate) % this.intFramerate;
            this.hours = Math.floor(this.hours);
            this.minutes = Math.floor(this.minutes);
            this.seconds = Math.floor(this.seconds);
            this.frames = Math.floor(this.frames);
        }
    },
    timecodeToFrameNumber: function() {
        // converts the current timecode to frame_count.
        if (this.dropFrame) this.frameCount = this.dropFrameTimecodeToFrameNumber([
            this.hours,
            this.minutes,
            this.seconds,
            this.frames
        ]);
        else this.frameCount = (this.hours * 3600 + this.minutes * 60 + this.seconds) * this.intFramerate + this.frames;
    },
    _calculate: function(sign, timecodes) {
        // all timecodes are calculated in place
        let frameCount;
        let timecode;
        for(let i = 0; i < timecodes.length; i += 1){
            // if a string, number or Date is given, convert it to a timecode
            if (typeof timecodes[i] === 'string' || typeof timecodes[i] === 'number' || timecodes[i] instanceof Date) timecode = $41342b85841ebc6f$export$c7bb7bfc56e79955.init({
                framerate: this.framerate,
                timecode: timecodes[i],
                drop_frame: this.dropFrame
            });
            else timecode = timecodes[i];
            // make sure this is a valid timecode
            if (timecode.frameCount) {
                if (timecode.framerate != this.framerate) throw new Error('Timecode framerates must match to do calculations.');
                if (sign === '-') frameCount = timecode.frameCount * -1;
                else if (sign === '+') frameCount = timecode.frameCount;
                else throw new Error('Expected sign to be + or -.');
                this.frameCount = this.frameCount + frameCount;
                this.frameNumberToTimecode();
            }
        }
    },
    add: function(args) {
        /*
        // This takes one or more Timecode objects as arguments
        // If this has been initialized, add to this, otherwise just add timecodes given.
        var timecodes = [];
        if (this.frameCount) {
            timecodes.push(this);
        }
        */ this._calculate('+', args);
    },
    subtract: function(args) {
        this._calculate('-', args);
    },
    toString: function() {
        const zeroPad = function(number) {
            const pad = number < 10 ? '0' : '';
            return pad + Math.floor(number);
        };
        const delim = this.dropFrame ? ';' : ':';
        return `${zeroPad(this.hours)}:${zeroPad(this.minutes)}:${zeroPad(this.seconds)}${delim}${zeroPad(this.frames)}`;
    },
    frameNumberToDropFrameTimecode: function(frameNumber) {
        const framerate = parseFloat(this.framerate);
        const drop_frames = Math.round(framerate * 0.066666);
        const frames_per_hour = Math.round(framerate * 3600);
        const frames_per_24_hours = frames_per_hour * 24;
        const frames_per_10_minutes = Math.round(framerate * 600);
        const frames_per_minute = Math.round(framerate * 60);
        // Roll over clock if greater than 24 hours
        frameNumber = frameNumber % frames_per_24_hours;
        // If time is negative, count back from 24 hours
        if (frameNumber < 0) frameNumber = frames_per_24_hours + frameNumber;
        const d = Math.floor(frameNumber / frames_per_10_minutes);
        const m = frameNumber % frames_per_10_minutes;
        if (m > drop_frames) frameNumber = frameNumber + drop_frames * 9 * d + drop_frames * Math.floor((m - drop_frames) / frames_per_minute);
        else frameNumber = frameNumber + drop_frames * 9 * d;
        return [
            Math.floor(Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) / 60),
            Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) % 60,
            Math.floor(frameNumber / this.intFramerate) % 60,
            frameNumber % this.intFramerate
        ];
    },
    setFrameNumberToTimecode: function(frameNumber) {
        const framerate = parseFloat(this.framerate);
        const frames_per_hour = Math.round(framerate * 3600);
        const frames_per_24_hours = frames_per_hour * 24;
        // Roll over clock if greater than 24 hours
        frameNumber = frameNumber % frames_per_24_hours;
        // If time is negative, count back from 24 hours
        if (frameNumber < 0) frameNumber = frames_per_24_hours + frameNumber;
        this.hours = Math.floor(Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) / 60);
        this.minutes = Math.floor(Math.floor(frameNumber / this.intFramerate) / 60) % 60;
        this.seconds = Math.floor(frameNumber / this.intFramerate) % 60;
        this.frames = frameNumber % this.intFramerate;
        this.timecodeToFrameNumber();
    },
    dropFrameTimecodeToFrameNumber: function(timecodeAsList) {
        const [hours, minutes, seconds, frames] = timecodeAsList;
        const drop_frames = Math.round(parseFloat(this.framerate) * 0.066666);
        const hour_frames = this.intFramerate * 3600;
        const minute_frames = this.intFramerate * 60;
        const total_minutes = hours * 60 + minutes;
        const frame_number = hour_frames * hours + minute_frames * minutes + this.intFramerate * seconds + frames - drop_frames * (total_minutes - Math.floor(total_minutes / 10));
        return frame_number;
    },
    /**
     * Converts the hour, minute, second, millisecond part of Date() object to the number of
     * frames using the current framerate
     * @param dt {Date}
     * @returns {number}
     */ dateToFrameNumber: function(dt) {
        const midnight = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0);
        return Math.floor((dt.getTime() - midnight.getTime()) / 1000 * parseFloat(this.framerate));
    }
};

});


parcelRegister("8dcRR", function(module, exports) {
/* braille.js
 *
 * Read the frame number coded in braille code
 * from the given video element.
 * returns NaN if failures while decoding
 *
 * braille : VideoHtmlElement -> Integer
 */ module.exports = function() {
    const numberOfSymbols = 7;
    const width = 392;
    const height = 60;
    const symbolWidth = width / numberOfSymbols;
    const symbolHeight = height;
    const colorMedian = 125;
    var brailleCoordinates = [
        [
            1 / 4,
            1 / 6
        ],
        [
            3 / 4,
            1 / 6
        ],
        [
            1 / 4,
            0.5
        ],
        [
            3 / 4,
            0.5
        ],
        [
            1 / 4,
            5 / 6
        ],
        [
            3 / 4,
            5 / 6
        ]
    ];
    var braille1 = JSON.stringify([
        1,
        0,
        0,
        0,
        0,
        0
    ]);
    var braille2 = JSON.stringify([
        1,
        0,
        1,
        0,
        0,
        0
    ]);
    var braille3 = JSON.stringify([
        1,
        1,
        0,
        0,
        0,
        0
    ]);
    var braille4 = JSON.stringify([
        1,
        1,
        0,
        1,
        0,
        0
    ]);
    var braille5 = JSON.stringify([
        1,
        0,
        0,
        1,
        0,
        0
    ]);
    var braille6 = JSON.stringify([
        1,
        1,
        1,
        0,
        0,
        0
    ]);
    var braille7 = JSON.stringify([
        1,
        1,
        1,
        1,
        0,
        0
    ]);
    var braille8 = JSON.stringify([
        1,
        0,
        1,
        1,
        0,
        0
    ]);
    var braille9 = JSON.stringify([
        0,
        1,
        1,
        0,
        0,
        0
    ]);
    var braille0 = JSON.stringify([
        0,
        1,
        1,
        1,
        0,
        0
    ]);
    // Would be better to test for all rgb to be exactly 0
    // but it appears sometime the value will be 2 or 3 or 4
    // so we just check it is in the lower half of the color range
    // (aka below 255/2, nearly)
    function isBlack(rgba) {
        return rgba[0] < colorMedian && rgba[1] < colorMedian && rgba[2] < colorMedian;
    }
    function parse(video) {
        let decodeCanvas = document.createElement('canvas');
        decodeCanvas.width = width;
        decodeCanvas.height = height;
        decodeCanvas.crossorigin = "anonymous";
        let decodeContext = decodeCanvas.getContext('2d');
        let frameNumber = '';
        if (!video) return 0;
        // void ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight)
        // braille font width is 56, height is 60 and drawn in the upper-left corner of
        // the video. we render 7 characters on each frame, making the total width 392.
        // however the 56px width includes letter-spacing, the interesting part of
        // a braille character is only 50px, so we take that into a account when decoding
        // the character.
        decodeContext.drawImage(video, 0, 0, width, height, 0, 0, width, height);
        // iterate over braille characters
        for(var i = 0; i < numberOfSymbols; i++){
            let candidate = JSON.stringify(// map over braille dots
            brailleCoordinates.map(function(rationalDotCoords) {
                // those are the coordinates of the center-most pixel of
                // the braille dot we are currently decoding
                var x = 50 * rationalDotCoords[0] + symbolWidth * i;
                var y = rationalDotCoords[1] * symbolHeight;
                var pixelData = decodeContext.getImageData(x, y, 1, 1).data;
                return isBlack(pixelData) ? 0 : 1;
            }));
            let decoded;
            switch(candidate){
                case braille0:
                    decoded = '0';
                    break;
                case braille1:
                    decoded = '1';
                    break;
                case braille2:
                    decoded = '2';
                    break;
                case braille3:
                    decoded = '3';
                    break;
                case braille4:
                    decoded = '4';
                    break;
                case braille5:
                    decoded = '5';
                    break;
                case braille6:
                    decoded = '6';
                    break;
                case braille7:
                    decoded = '7';
                    break;
                case braille8:
                    decoded = '8';
                    break;
                case braille9:
                    decoded = '9';
                    break;
                // returning NaN if decode failed
                default:
                    decoded = 'oops';
            }
            frameNumber += decoded;
        }
        return parseInt(frameNumber, 10);
    }
    return parse;
}();

});

parcelRegister("gguoi", function(module, exports) {

$parcel$export(module.exports, "$", () => $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9, (v) => $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9 = v);
/*
 * common.js
 */ var $bd75b6fa0b73898b$export$3c32761ab67e1b40;
var $bd75b6fa0b73898b$export$1a44d2b340da8eb5;
var $bd75b6fa0b73898b$export$3d8c2f653ac9d0b9;
var $bd75b6fa0b73898b$export$fe324b23443c13e2;
var $bd75b6fa0b73898b$export$185802fd694ee1f5;
var $bd75b6fa0b73898b$export$af88d00dbe7f521;
var $bd75b6fa0b73898b$export$627d822bae211d52;
$bd75b6fa0b73898b$export$3c32761ab67e1b40 = '<svg height="18px" width="18px" viewBox="0 0 18 18" class="IconIcon18"><rect class="Bg" height="18" width="18" x="0" y="0"></rect><rect class="Fg" height="8" width="3" x="5" y="5"></rect><rect class="Fg" height="8" width="3" x="10" y="5"></rect></svg>';
$bd75b6fa0b73898b$export$1a44d2b340da8eb5 = '<svg height="18px" width="18px" viewBox="0 0 18 18" class="IconIcon18"><rect class="Bg" height="18" width="18" x="0" y="0"></rect><polygon class="Fg" points="6 5 12 9 6 13"></polygon></svg>';
$bd75b6fa0b73898b$export$3d8c2f653ac9d0b9 = function $(s, el) {
    return (el || window.document).querySelector(s);
};
$bd75b6fa0b73898b$export$fe324b23443c13e2 = function $$(s, el) {
    return (el || window.document).querySelectorAll(s);
};
$bd75b6fa0b73898b$export$185802fd694ee1f5 = function create(t) {
    return window.document.createElement(t);
};
$bd75b6fa0b73898b$export$af88d00dbe7f521 = function logger(msg) {
    if (window.NOMALAB_DEBUG_MODE) {
        let m = typeof msg == 'object' ? JSON.stringify(msg, null, 2) : msg;
        console.log('%c[NOMALAB DEBUG] ' + m);
    }
};
$bd75b6fa0b73898b$export$627d822bae211d52 = function fixSubtitlePosition(video) {
    if (!video.textTracks[0] || !video.textTracks[0].cues) {
        console.log(video.textTracks);
        return;
    }
    let l = video.textTracks[0].cues.length;
    for(let i = 0; i < l; i++){
        let cue = video.textTracks[0].cues[i];
        if (cue.line == 0) cue.line = 1;
        video.textTracks[0].cues[i] = cue;
    }
};

});

parcelRegister("6jqaU", function(module, exports) {
/*
 @license
 Shaka Player
 Copyright 2016 Google LLC
 SPDX-License-Identifier: Apache-2.0
*/ (function() {
    var innerGlobal = typeof window != "undefined" ? window : $parcel$global;
    var exportTo = {};
    (function(window1, global1, module) {
        var p, aa = typeof Object.create == "function" ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ca(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window1 && window1,
                "object" == typeof self && self,
                "object" == typeof global1 && global1
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var da = ca(this), ea = "Int8 Uint8 Uint8Clamped Int16 Uint16 Int32 Uint32 Float32 Float64".split(" ");
        da.BigInt64Array && (ea.push("BigInt64"), ea.push("BigUint64"));
        function fa(a, b) {
            if (b) for(var c = 0; c < ea.length; c++)ha(ea[c] + "Array.prototype." + a, b);
        }
        function ia(a, b) {
            b && ha(a, b);
        }
        function ha(a, b) {
            var c = da;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) return;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && ba(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
        var ja;
        if (typeof Object.setPrototypeOf == "function") ja = Object.setPrototypeOf;
        else {
            var ka;
            a: {
                var la = {
                    a: !0
                }, ma = {};
                try {
                    ma.__proto__ = la;
                    ka = ma.a;
                    break a;
                } catch (a) {}
                ka = !1;
            }
            ja = ka ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var na = ja;
        function oa(a, b) {
            a.prototype = aa(b.prototype);
            a.prototype.constructor = a;
            if (na) na(a, b);
            else for(var c in b)if (c != "prototype") {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.Xn = b.prototype;
        }
        function qa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        function u(a) {
            var b = typeof Symbol != "undefined" && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if (typeof a.length == "number") return {
                next: qa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        function G(a) {
            if (!(a instanceof Array)) {
                a = u(a);
                for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        function ra(a) {
            if (!(a instanceof Object)) throw new TypeError("Iterator result " + a + " is not an object");
        }
        function sa() {
            this.J = !1;
            this.H = null;
            this.i = void 0;
            this.h = 1;
            this.G = this.I = 0;
            this.L = this.D = null;
        }
        function ta(a) {
            if (a.J) throw new TypeError("Generator is already running");
            a.J = !0;
        }
        sa.prototype.K = function(a) {
            this.i = a;
        };
        function ya(a, b) {
            a.D = {
                Xi: b,
                kj: !0
            };
            a.h = a.I || a.G;
        }
        sa.prototype.getNextAddressJsc = function() {
            return this.h;
        };
        sa.prototype.getYieldResultJsc = function() {
            return this.i;
        };
        sa.prototype.return = function(a) {
            this.D = {
                return: a
            };
            this.h = this.G;
        };
        sa.prototype["return"] = sa.prototype.return;
        sa.prototype.O = function(a) {
            this.D = {
                B: a
            };
            this.h = this.G;
        };
        sa.prototype.jumpThroughFinallyBlocks = sa.prototype.O;
        sa.prototype.g = function(a, b) {
            this.h = b;
            return {
                value: a
            };
        };
        sa.prototype.yield = sa.prototype.g;
        sa.prototype.P = function(a, b) {
            a = u(a);
            var c = a.next();
            ra(c);
            if (c.done) this.i = c.value, this.h = b;
            else return this.H = a, this.g(c.value, b);
        };
        sa.prototype.yieldAll = sa.prototype.P;
        sa.prototype.B = function(a) {
            this.h = a;
        };
        sa.prototype.jumpTo = sa.prototype.B;
        sa.prototype.j = function() {
            this.h = 0;
        };
        sa.prototype.jumpToEnd = sa.prototype.j;
        sa.prototype.m = function(a, b) {
            this.I = a;
            b != void 0 && (this.G = b);
        };
        sa.prototype.setCatchFinallyBlocks = sa.prototype.m;
        sa.prototype.F = function(a) {
            this.I = 0;
            this.G = a || 0;
        };
        sa.prototype.setFinallyBlock = sa.prototype.F;
        sa.prototype.o = function(a, b) {
            this.h = a;
            this.I = b || 0;
        };
        sa.prototype.leaveTryBlock = sa.prototype.o;
        sa.prototype.l = function(a) {
            this.I = a || 0;
            a = this.D.Xi;
            this.D = null;
            return a;
        };
        sa.prototype.enterCatchBlock = sa.prototype.l;
        sa.prototype.A = function(a, b, c) {
            c ? this.L[c] = this.D : this.L = [
                this.D
            ];
            this.I = a || 0;
            this.G = b || 0;
        };
        sa.prototype.enterFinallyBlock = sa.prototype.A;
        sa.prototype.C = function(a, b) {
            b = this.L.splice(b || 0)[0];
            (b = this.D = this.D || b) ? b.kj ? this.h = this.I || this.G : b.B != void 0 && this.G < b.B ? (this.h = b.B, this.D = null) : this.h = this.G : this.h = a;
        };
        sa.prototype.leaveFinallyBlock = sa.prototype.C;
        sa.prototype.M = function(a) {
            return new za(a);
        };
        sa.prototype.forIn = sa.prototype.M;
        function za(a) {
            this.i = a;
            this.g = [];
            for(var b in a)this.g.push(b);
            this.g.reverse();
        }
        za.prototype.h = function() {
            for(; this.g.length > 0;){
                var a = this.g.pop();
                if (a in this.i) return a;
            }
            return null;
        };
        za.prototype.getNext = za.prototype.h;
        function Ba(a) {
            this.g = new sa;
            this.h = a;
        }
        function Ea(a, b) {
            ta(a.g);
            var c = a.g.H;
            if (c) return Fa(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return Ha(a);
        }
        function Fa(a, b, c, d) {
            try {
                var e = b.call(a.g.H, c);
                ra(e);
                if (!e.done) return a.g.J = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.H = null, ya(a.g, g), Ha(a);
            }
            a.g.H = null;
            d.call(a.g, f);
            return Ha(a);
        }
        function Ha(a) {
            for(; a.g.h;)try {
                var b = a.h(a.g);
                if (b) return a.g.J = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.i = void 0, ya(a.g, c);
            }
            a.g.J = !1;
            if (a.g.D) {
                b = a.g.D;
                a.g.D = null;
                if (b.kj) throw b.Xi;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function Ia(a) {
            this.next = function(b) {
                ta(a.g);
                a.g.H ? b = Fa(a, a.g.H.next, b, a.g.K) : (a.g.K(b), b = Ha(a));
                return b;
            };
            this.throw = function(b) {
                ta(a.g);
                a.g.H ? b = Fa(a, a.g.H["throw"], b, a.g.K) : (ya(a.g, b), b = Ha(a));
                return b;
            };
            this.return = function(b) {
                return Ea(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function La(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        }
        function H(a) {
            return La(new Ia(new Ba(a)));
        }
        function Ma() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        }
        ia("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (Math.random() * 1E9 >>> 0) + "_", e = 0;
            return b;
        });
        ia("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            ba(Array.prototype, a, {
                configurable: !0,
                writable: !0,
                value: function() {
                    return Na(qa(this));
                }
            });
            return a;
        });
        function Na(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        ia("Promise", function(a) {
            function b(g) {
                this.h = 0;
                this.i = void 0;
                this.g = [];
                this.o = !1;
                var h = this.j();
                try {
                    g(h.resolve, h.reject);
                } catch (k) {
                    h.reject(k);
                }
            }
            function c() {
                this.g = null;
            }
            function d(g) {
                return g instanceof b ? g : new b(function(h) {
                    h(g);
                });
            }
            if (a) return a;
            c.prototype.h = function(g) {
                if (this.g == null) {
                    this.g = [];
                    var h = this;
                    this.i(function() {
                        h.l();
                    });
                }
                this.g.push(g);
            };
            var e = da.setTimeout;
            c.prototype.i = function(g) {
                e(g, 0);
            };
            c.prototype.l = function() {
                for(; this.g && this.g.length;){
                    var g = this.g;
                    this.g = [];
                    for(var h = 0; h < g.length; ++h){
                        var k = g[h];
                        g[h] = null;
                        try {
                            k();
                        } catch (l) {
                            this.j(l);
                        }
                    }
                }
                this.g = null;
            };
            c.prototype.j = function(g) {
                this.i(function() {
                    throw g;
                });
            };
            b.prototype.j = function() {
                function g(l) {
                    return function(m) {
                        k || (k = !0, l.call(h, m));
                    };
                }
                var h = this, k = !1;
                return {
                    resolve: g(this.G),
                    reject: g(this.l)
                };
            };
            b.prototype.G = function(g) {
                if (g === this) this.l(new TypeError("A Promise cannot resolve to itself"));
                else if (g instanceof b) this.I(g);
                else {
                    a: switch(typeof g){
                        case "object":
                            var h = g != null;
                            break a;
                        case "function":
                            h = !0;
                            break a;
                        default:
                            h = !1;
                    }
                    h ? this.F(g) : this.m(g);
                }
            };
            b.prototype.F = function(g) {
                var h = void 0;
                try {
                    h = g.then;
                } catch (k) {
                    this.l(k);
                    return;
                }
                typeof h == "function" ? this.J(h, g) : this.m(g);
            };
            b.prototype.l = function(g) {
                this.A(2, g);
            };
            b.prototype.m = function(g) {
                this.A(1, g);
            };
            b.prototype.A = function(g, h) {
                if (this.h != 0) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.h);
                this.h = g;
                this.i = h;
                this.h === 2 && this.H();
                this.C();
            };
            b.prototype.H = function() {
                var g = this;
                e(function() {
                    if (g.D()) {
                        var h = da.console;
                        typeof h !== "undefined" && h.error(g.i);
                    }
                }, 1);
            };
            b.prototype.D = function() {
                if (this.o) return !1;
                var g = da.CustomEvent, h = da.Event, k = da.dispatchEvent;
                if (typeof k === "undefined") return !0;
                typeof g === "function" ? g = new g("unhandledrejection", {
                    cancelable: !0
                }) : typeof h === "function" ? g = new h("unhandledrejection", {
                    cancelable: !0
                }) : (g = da.document.createEvent("CustomEvent"), g.initCustomEvent("unhandledrejection", !1, !0, g));
                g.promise = this;
                g.reason = this.i;
                return k(g);
            };
            b.prototype.C = function() {
                if (this.g != null) {
                    for(var g = 0; g < this.g.length; ++g)f.h(this.g[g]);
                    this.g = null;
                }
            };
            var f = new c;
            b.prototype.I = function(g) {
                var h = this.j();
                g.hf(h.resolve, h.reject);
            };
            b.prototype.J = function(g, h) {
                var k = this.j();
                try {
                    g.call(h, k.resolve, k.reject);
                } catch (l) {
                    k.reject(l);
                }
            };
            b.prototype.then = function(g, h) {
                function k(q, r) {
                    return typeof q == "function" ? function(t) {
                        try {
                            l(q(t));
                        } catch (v) {
                            m(v);
                        }
                    } : r;
                }
                var l, m, n = new b(function(q, r) {
                    l = q;
                    m = r;
                });
                this.hf(k(g, l), k(h, m));
                return n;
            };
            b.prototype.catch = function(g) {
                return this.then(void 0, g);
            };
            b.prototype.hf = function(g, h) {
                function k() {
                    switch(l.h){
                        case 1:
                            g(l.i);
                            break;
                        case 2:
                            h(l.i);
                            break;
                        default:
                            throw Error("Unexpected state: " + l.h);
                    }
                }
                var l = this;
                this.g == null ? f.h(k) : this.g.push(k);
                this.o = !0;
            };
            b.resolve = d;
            b.reject = function(g) {
                return new b(function(h, k) {
                    k(g);
                });
            };
            b.race = function(g) {
                return new b(function(h, k) {
                    for(var l = u(g), m = l.next(); !m.done; m = l.next())d(m.value).hf(h, k);
                });
            };
            b.all = function(g) {
                var h = u(g), k = h.next();
                return k.done ? d([]) : new b(function(l, m) {
                    function n(t) {
                        return function(v) {
                            q[t] = v;
                            r--;
                            r == 0 && l(q);
                        };
                    }
                    var q = [], r = 0;
                    do q.push(void 0), r++, d(k.value).hf(n(q.length - 1), m), k = h.next();
                    while (!k.done);
                });
            };
            return b;
        });
        function Oa(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        ia("WeakMap", function(a) {
            function b(k) {
                this.g = (h += Math.random() + 1).toString();
                if (k) {
                    k = u(k);
                    for(var l; !(l = k.next()).done;)l = l.value, this.set(l[0], l[1]);
                }
            }
            function c() {}
            function d(k) {
                var l = typeof k;
                return l === "object" && k !== null || l === "function";
            }
            function e(k) {
                if (!Oa(k, g)) {
                    var l = new c;
                    ba(k, g, {
                        value: l
                    });
                }
            }
            function f(k) {
                var l = Object[k];
                l && (Object[k] = function(m) {
                    if (m instanceof c) return m;
                    Object.isExtensible(m) && e(m);
                    return l(m);
                });
            }
            if (function() {
                if (!a || !Object.seal) return !1;
                try {
                    var k = Object.seal({}), l = Object.seal({}), m = new a([
                        [
                            k,
                            2
                        ],
                        [
                            l,
                            3
                        ]
                    ]);
                    if (m.get(k) != 2 || m.get(l) != 3) return !1;
                    m.delete(k);
                    m.set(l, 4);
                    return !m.has(k) && m.get(l) == 4;
                } catch (n) {
                    return !1;
                }
            }()) return a;
            var g = "$jscomp_hidden_" + Math.random();
            f("freeze");
            f("preventExtensions");
            f("seal");
            var h = 0;
            b.prototype.set = function(k, l) {
                if (!d(k)) throw Error("Invalid WeakMap key");
                e(k);
                if (!Oa(k, g)) throw Error("WeakMap key fail: " + k);
                k[g][this.g] = l;
                return this;
            };
            b.prototype.get = function(k) {
                return d(k) && Oa(k, g) ? k[g][this.g] : void 0;
            };
            b.prototype.has = function(k) {
                return d(k) && Oa(k, g) && Oa(k[g], this.g);
            };
            b.prototype.delete = function(k) {
                return d(k) && Oa(k, g) && Oa(k[g], this.g) ? delete k[g][this.g] : !1;
            };
            return b;
        });
        ia("Map", function(a) {
            function b() {
                var h = {};
                return h.Ec = h.next = h.head = h;
            }
            function c(h, k) {
                var l = h[1];
                return Na(function() {
                    if (l) {
                        for(; l.head != h[1];)l = l.Ec;
                        for(; l.next != l.head;)return l = l.next, {
                            done: !1,
                            value: k(l)
                        };
                        l = null;
                    }
                    return {
                        done: !0,
                        value: void 0
                    };
                });
            }
            function d(h, k) {
                var l = k && typeof k;
                l == "object" || l == "function" ? f.has(k) ? l = f.get(k) : (l = "" + ++g, f.set(k, l)) : l = "p_" + k;
                var m = h[0][l];
                if (m && Oa(h[0], l)) for(h = 0; h < m.length; h++){
                    var n = m[h];
                    if (k !== k && n.key !== n.key || k === n.key) return {
                        id: l,
                        list: m,
                        index: h,
                        entry: n
                    };
                }
                return {
                    id: l,
                    list: m,
                    index: -1,
                    entry: void 0
                };
            }
            function e(h) {
                this[0] = {};
                this[1] = b();
                this.size = 0;
                if (h) {
                    h = u(h);
                    for(var k; !(k = h.next()).done;)k = k.value, this.set(k[0], k[1]);
                }
            }
            if (function() {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var h = Object.seal({
                        x: 4
                    }), k = new a(u([
                        [
                            h,
                            "s"
                        ]
                    ]));
                    if (k.get(h) != "s" || k.size != 1 || k.get({
                        x: 4
                    }) || k.set({
                        x: 4
                    }, "t") != k || k.size != 2) return !1;
                    var l = k.entries(), m = l.next();
                    if (m.done || m.value[0] != h || m.value[1] != "s") return !1;
                    m = l.next();
                    return m.done || m.value[0].x != 4 || m.value[1] != "t" || !l.next().done ? !1 : !0;
                } catch (n) {
                    return !1;
                }
            }()) return a;
            var f = new WeakMap;
            e.prototype.set = function(h, k) {
                h = h === 0 ? 0 : h;
                var l = d(this, h);
                l.list || (l.list = this[0][l.id] = []);
                l.entry ? l.entry.value = k : (l.entry = {
                    next: this[1],
                    Ec: this[1].Ec,
                    head: this[1],
                    key: h,
                    value: k
                }, l.list.push(l.entry), this[1].Ec.next = l.entry, this[1].Ec = l.entry, this.size++);
                return this;
            };
            e.prototype.delete = function(h) {
                h = d(this, h);
                return h.entry && h.list ? (h.list.splice(h.index, 1), h.list.length || delete this[0][h.id], h.entry.Ec.next = h.entry.next, h.entry.next.Ec = h.entry.Ec, h.entry.head = null, this.size--, !0) : !1;
            };
            e.prototype.clear = function() {
                this[0] = {};
                this[1] = this[1].Ec = b();
                this.size = 0;
            };
            e.prototype.has = function(h) {
                return !!d(this, h).entry;
            };
            e.prototype.get = function(h) {
                return (h = d(this, h).entry) && h.value;
            };
            e.prototype.entries = function() {
                return c(this, function(h) {
                    return [
                        h.key,
                        h.value
                    ];
                });
            };
            e.prototype.keys = function() {
                return c(this, function(h) {
                    return h.key;
                });
            };
            e.prototype.values = function() {
                return c(this, function(h) {
                    return h.value;
                });
            };
            e.prototype.forEach = function(h, k) {
                for(var l = this.entries(), m; !(m = l.next()).done;)m = m.value, h.call(k, m[1], m[0], this);
            };
            e.prototype[Symbol.iterator] = e.prototype.entries;
            var g = 0;
            return e;
        });
        function Pa(a, b) {
            a instanceof String && (a += "");
            var c = 0, d = !1, e = {
                next: function() {
                    if (!d && c < a.length) {
                        var f = c++;
                        return {
                            value: b(f, a[f]),
                            done: !1
                        };
                    }
                    d = !0;
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
            e[Symbol.iterator] = function() {
                return e;
            };
            return e;
        }
        ia("Array.prototype.keys", function(a) {
            return a ? a : function() {
                return Pa(this, function(b) {
                    return b;
                });
            };
        });
        ia("Set", function(a) {
            function b(c) {
                this.g = new Map;
                if (c) {
                    c = u(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
                this.size = this.g.size;
            }
            if (function() {
                if (!a || typeof a != "function" || !a.prototype.entries || typeof Object.seal != "function") return !1;
                try {
                    var c = Object.seal({
                        x: 4
                    }), d = new a(u([
                        c
                    ]));
                    if (!d.has(c) || d.size != 1 || d.add(c) != d || d.size != 1 || d.add({
                        x: 4
                    }) != d || d.size != 2) return !1;
                    var e = d.entries(), f = e.next();
                    if (f.done || f.value[0] != c || f.value[1] != c) return !1;
                    f = e.next();
                    return f.done || f.value[0] == c || f.value[0].x != 4 || f.value[1] != f.value[0] ? !1 : e.next().done;
                } catch (g) {
                    return !1;
                }
            }()) return a;
            b.prototype.add = function(c) {
                c = c === 0 ? 0 : c;
                this.g.set(c, c);
                this.size = this.g.size;
                return this;
            };
            b.prototype.delete = function(c) {
                c = this.g.delete(c);
                this.size = this.g.size;
                return c;
            };
            b.prototype.clear = function() {
                this.g.clear();
                this.size = 0;
            };
            b.prototype.has = function(c) {
                return this.g.has(c);
            };
            b.prototype.entries = function() {
                return this.g.entries();
            };
            b.prototype.values = function() {
                return this.g.values();
            };
            b.prototype.keys = b.prototype.values;
            b.prototype[Symbol.iterator] = b.prototype.values;
            b.prototype.forEach = function(c, d) {
                var e = this;
                this.g.forEach(function(f) {
                    return c.call(d, f, f, e);
                });
            };
            return b;
        });
        ia("Array.prototype.values", function(a) {
            return a ? a : function() {
                return Pa(this, function(b, c) {
                    return c;
                });
            };
        });
        ia("Array.from", function(a) {
            return a ? a : function(b, c, d) {
                c = c != null ? c : function(h) {
                    return h;
                };
                var e = [], f = typeof Symbol != "undefined" && Symbol.iterator && b[Symbol.iterator];
                if (typeof f == "function") {
                    b = f.call(b);
                    for(var g = 0; !(f = b.next()).done;)e.push(c.call(d, f.value, g++));
                } else for(f = b.length, g = 0; g < f; g++)e.push(c.call(d, b[g], g));
                return e;
            };
        });
        function Qa(a, b, c) {
            if (a == null) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
            if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
            return a + "";
        }
        ia("String.prototype.startsWith", function(a) {
            return a ? a : function(b, c) {
                var d = Qa(this, b, "startsWith"), e = d.length, f = b.length;
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var g = 0; g < f && c < e;)if (d[c++] != b[g++]) return !1;
                return g >= f;
            };
        });
        ia("Object.is", function(a) {
            return a ? a : function(b, c) {
                return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
            };
        });
        ia("Array.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                var d = this;
                d instanceof String && (d = String(d));
                var e = d.length;
                c = c || 0;
                for(c < 0 && (c = Math.max(c + e, 0)); c < e; c++){
                    var f = d[c];
                    if (f === b || Object.is(f, b)) return !0;
                }
                return !1;
            };
        });
        ia("String.prototype.includes", function(a) {
            return a ? a : function(b, c) {
                return Qa(this, b, "includes").indexOf(b, c || 0) !== -1;
            };
        });
        ia("String.fromCodePoint", function(a) {
            return a ? a : function(b) {
                for(var c = "", d = 0; d < arguments.length; d++){
                    var e = Number(arguments[d]);
                    if (e < 0 || e > 1114111 || e !== Math.floor(e)) throw new RangeError("invalid_code_point " + e);
                    e <= 65535 ? c += String.fromCharCode(e) : (e -= 65536, c += String.fromCharCode(e >>> 10 & 1023 | 55296), c += String.fromCharCode(e & 1023 | 56320));
                }
                return c;
            };
        });
        function Ra(a, b, c) {
            a instanceof String && (a = String(a));
            for(var d = a.length, e = 0; e < d; e++){
                var f = a[e];
                if (b.call(c, f, e, a)) return {
                    gj: e,
                    v: f
                };
            }
            return {
                gj: -1,
                v: void 0
            };
        }
        ia("Array.prototype.findIndex", function(a) {
            return a ? a : function(b, c) {
                return Ra(this, b, c).gj;
            };
        });
        ia("WeakSet", function(a) {
            function b(c) {
                this.g = new WeakMap;
                if (c) {
                    c = u(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
            }
            if (function() {
                if (!a || !Object.seal) return !1;
                try {
                    var c = Object.seal({}), d = Object.seal({}), e = new a([
                        c
                    ]);
                    if (!e.has(c) || e.has(d)) return !1;
                    e.delete(c);
                    e.add(d);
                    return !e.has(c) && e.has(d);
                } catch (f) {
                    return !1;
                }
            }()) return a;
            b.prototype.add = function(c) {
                this.g.set(c, !0);
                return this;
            };
            b.prototype.has = function(c) {
                return this.g.has(c);
            };
            b.prototype.delete = function(c) {
                return this.g.delete(c);
            };
            return b;
        });
        ia("Array.prototype.find", function(a) {
            return a ? a : function(b, c) {
                return Ra(this, b, c).v;
            };
        });
        ia("Object.entries", function(a) {
            return a ? a : function(b) {
                var c = [], d;
                for(d in b)Oa(b, d) && c.push([
                    d,
                    b[d]
                ]);
                return c;
            };
        });
        var Sa = typeof Object.assign == "function" ? Object.assign : function(a, b) {
            if (a == null) throw new TypeError("No nullish arg");
            a = Object(a);
            for(var c = 1; c < arguments.length; c++){
                var d = arguments[c];
                if (d) for(var e in d)Oa(d, e) && (a[e] = d[e]);
            }
            return a;
        };
        ia("Object.assign", function(a) {
            return a || Sa;
        });
        ia("Promise.prototype.finally", function(a) {
            return a ? a : function(b) {
                return this.then(function(c) {
                    return Promise.resolve(b()).then(function() {
                        return c;
                    });
                }, function(c) {
                    return Promise.resolve(b()).then(function() {
                        throw c;
                    });
                });
            };
        });
        ia("Array.prototype.entries", function(a) {
            return a ? a : function() {
                return Pa(this, function(b, c) {
                    return [
                        b,
                        c
                    ];
                });
            };
        });
        ia("Number.EPSILON", function() {
            return 2.220446049250313E-16;
        });
        ia("Number.MAX_SAFE_INTEGER", function() {
            return 9007199254740991;
        });
        ia("Math.clz32", function(a) {
            return a ? a : function(b) {
                b = Number(b) >>> 0;
                if (b === 0) return 32;
                var c = 0;
                (b & 4294901760) === 0 && (b <<= 16, c += 16);
                (b & 4278190080) === 0 && (b <<= 8, c += 8);
                (b & 4026531840) === 0 && (b <<= 4, c += 4);
                (b & 3221225472) === 0 && (b <<= 2, c += 2);
                (b & 2147483648) === 0 && c++;
                return c;
            };
        });
        ia("Number.isNaN", function(a) {
            return a ? a : function(b) {
                return typeof b === "number" && isNaN(b);
            };
        });
        ia("String.prototype.repeat", function(a) {
            return a ? a : function(b) {
                var c = Qa(this, null, "repeat");
                if (b < 0 || b > 1342177279) throw new RangeError("Invalid count value");
                b |= 0;
                for(var d = ""; b;)if (b & 1 && (d += c), b >>>= 1) c += c;
                return d;
            };
        });
        ia("Number.isFinite", function(a) {
            return a ? a : function(b) {
                return typeof b !== "number" ? !1 : !isNaN(b) && b !== Infinity && b !== -Infinity;
            };
        });
        ia("Object.values", function(a) {
            return a ? a : function(b) {
                var c = [], d;
                for(d in b)Oa(b, d) && c.push(b[d]);
                return c;
            };
        });
        ia("Math.log2", function(a) {
            return a ? a : function(b) {
                return Math.log(b) / Math.LN2;
            };
        });
        ia("String.prototype.endsWith", function(a) {
            return a ? a : function(b, c) {
                var d = Qa(this, b, "endsWith");
                c === void 0 && (c = d.length);
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var e = b.length; e > 0 && c > 0;)if (d[--c] != b[--e]) return !1;
                return e <= 0;
            };
        });
        ia("Math.trunc", function(a) {
            return a ? a : function(b) {
                b = Number(b);
                if (isNaN(b) || b === Infinity || b === -Infinity || b === 0) return b;
                var c = Math.floor(Math.abs(b));
                return b < 0 ? -c : c;
            };
        });
        function Ta(a) {
            a = Math.trunc(a) || 0;
            a < 0 && (a += this.length);
            if (!(a < 0 || a >= this.length)) return this[a];
        }
        ia("Array.prototype.at", function(a) {
            return a ? a : Ta;
        });
        fa("at", function(a) {
            return a ? a : Ta;
        });
        ia("String.prototype.at", function(a) {
            return a ? a : Ta;
        });
        var Ua = this || self;
        function O(a, b) {
            a = a.split(".");
            var c = Ua;
            a[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a[0]);
            for(var d; a.length && (d = a.shift());)a.length || b === void 0 ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
        }
        function R(a, b) {
            if (b) {
                if (b instanceof Map) for(var c = u(b.keys()), d = c.next(); !d.done; d = c.next())d = d.value, Object.defineProperty(this, d, {
                    value: b.get(d),
                    writable: !0,
                    enumerable: !0
                });
                else for(c in b)Object.defineProperty(this, c, {
                    value: b[c],
                    writable: !0,
                    enumerable: !0
                });
            }
            this.defaultPrevented = this.cancelable = this.bubbles = !1;
            this.timeStamp = window1.performance && window1.performance.now ? window1.performance.now() : Date.now();
            this.type = a;
            this.isTrusted = !1;
            this.target = this.currentTarget = null;
            this.g = !1;
        }
        function Va(a) {
            var b = new R(a.type), c;
            for(c in a)Object.defineProperty(b, c, {
                value: a[c],
                writable: !0,
                enumerable: !0
            });
            return b;
        }
        R.prototype.preventDefault = function() {
            this.cancelable && (this.defaultPrevented = !0);
        };
        R.prototype.stopImmediatePropagation = function() {
            this.g = !0;
        };
        R.prototype.stopPropagation = function() {};
        O("shaka.util.FakeEvent", R);
        var Wa = {
            Km: "abrstatuschanged",
            Lm: "adaptation",
            Mm: "audiotrackchanged",
            Nm: "audiotrackschanged",
            Om: "boundarycrossed",
            Pm: "buffering",
            Qm: "canupdatestarttime",
            Rm: "complete",
            Sm: "currentitemchanged",
            Tm: "downloadcompleted",
            Um: "downloadfailed",
            Vm: "downloadheadersreceived",
            Wm: "drmsessionupdate",
            Xm: "emsg",
            dn: "itemsinserted",
            fn: "itemsremoved",
            xn: "prft",
            Error: "error",
            Ym: "expirationupdated",
            Zm: "firstquartile",
            $m: "gapjumped",
            gn: "keystatuschanged",
            ln: "loaded",
            mn: "loading",
            on: "manifestparsed",
            pn: "manifestupdated",
            qn: "mediaqualitychanged",
            rn: "mediasourcerecovered",
            tn: "metadataadded",
            Metadata: "metadata",
            un: "midpoint",
            vn: "nospatialvideoinfo",
            wn: "onstatechange",
            yn: "ratechange",
            Bn: "segmentappended",
            Cn: "sessiondata",
            Dn: "spatialvideoinfo",
            En: "stalldetected",
            Fn: "started",
            Gn: "statechanged",
            Hn: "streaming",
            In: "textchanged",
            Jn: "texttrackvisibility",
            Kn: "thirdquartile",
            Ln: "timelineregionadded",
            Mn: "timelineregionenter",
            Nn: "timelineregionexit",
            On: "trackschanged",
            Qn: "unloading",
            Sn: "variantchanged"
        };
        function Xa() {}
        function Ya() {}
        function Za() {}
        function $a(a) {
            var b = Ma.apply(1, arguments);
            ab.has(a) || (ab.add(a), Za.apply(Xa, G(b)));
        }
        function bb() {}
        function cb() {}
        function db() {}
        var ab = new Set;
        window1.console && ((new Map).set(1, function() {
            return console.error.apply(console, G(Ma.apply(0, arguments)));
        }).set(2, function() {
            return console.warn.apply(console, G(Ma.apply(0, arguments)));
        }).set(3, function() {
            return console.info.apply(console, G(Ma.apply(0, arguments)));
        }).set(4, function() {
            return console.log.apply(console, G(Ma.apply(0, arguments)));
        }).set(5, function() {
            return console.debug.apply(console, G(Ma.apply(0, arguments)));
        }).set(6, function() {
            return console.debug.apply(console, G(Ma.apply(0, arguments)));
        }), Za = function() {
            return console.warn.apply(console, G(Ma.apply(0, arguments)));
        }, Ya = function() {
            console.error.apply(console, G(Ma.apply(0, arguments)));
        });
        function eb() {
            this.g = new Map;
        }
        p = eb.prototype;
        p.push = function(a, b) {
            this.g.has(a) ? this.g.get(a).push(b) : this.g.set(a, [
                b
            ]);
        };
        p.get = function(a) {
            return this.g.has(a) ? this.g.get(a).slice() : null;
        };
        p.remove = function(a, b) {
            if (this.g.has(a)) {
                var c = this.g.get(a).filter(function(d) {
                    return d != b;
                });
                this.g.set(a, c);
                c.length || this.g.delete(a);
            }
        };
        p.forEach = function(a) {
            this.g.forEach(function(b, c) {
                a(c, b);
            });
        };
        p.size = function() {
            return this.g.size;
        };
        p.keys = function() {
            return Array.from(this.g.keys());
        };
        function fb() {
            this.hb = new eb;
            this.We = this;
        }
        fb.prototype.addEventListener = function(a, b) {
            this.hb && this.hb.push(a, b);
        };
        fb.prototype.removeEventListener = function(a, b) {
            this.hb && this.hb.remove(a, b);
        };
        fb.prototype.dispatchEvent = function(a) {
            if (!this.hb) return !0;
            var b = this.hb.get(a.type) || [], c = this.hb.get("All");
            c && (b = b.concat(c));
            b = u(b);
            for(c = b.next(); !c.done; c = b.next()){
                c = c.value;
                a.target = this.We;
                a.currentTarget = this.We;
                try {
                    c.handleEvent ? c.handleEvent(a) : c.call(this, a);
                } catch (d) {}
                if (a.g) break;
            }
            return a.defaultPrevented;
        };
        fb.prototype.release = function() {
            this.hb = null;
        };
        function gb(a, b) {
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())c.push(b(d.value));
            return c;
        }
        function hb(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (!b(c.value)) return !1;
            return !0;
        }
        function ib(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (b(c.value)) return !0;
            return !1;
        }
        function jb(a, b) {
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, b(d) && c.push(d);
            return c;
        }
        var kb = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#(.*))?$");
        function lb(a) {
            var b;
            a instanceof lb ? (mb(this, a.lc), this.rd = a.rd, nb(this, a.Eb), ob(this, a.Pd), this.Zb = a.Zb, pb(this, a.g.clone()), this.bd = a.bd) : a && (b = String(a).match(kb)) ? (mb(this, b[1] || "", !0), this.rd = qb(b[2] || ""), nb(this, b[3] || "", !0), ob(this, b[4]), this.Zb = qb(b[5] || "", !0), pb(this, b[6] || "", !0), this.bd = qb(b[7] || "")) : this.g = new rb(null);
        }
        p = lb.prototype;
        p.lc = "";
        p.rd = "";
        p.Eb = "";
        p.Pd = null;
        p.Zb = "";
        p.bd = "";
        p.toString = function() {
            var a = [], b = this.lc;
            b && a.push(tb(b, ub, !0), ":");
            if (b = this.Eb) {
                a.push("//");
                var c = this.rd;
                c && a.push(tb(c, ub, !0), "@");
                a.push(encodeURIComponent(b).replace(/%25([0-9a-fA-F]{2})/g, "%$1"));
                b = this.Pd;
                b != null && a.push(":", String(b));
            }
            if (b = this.Zb) this.Eb && b.charAt(0) != "/" && a.push("/"), a.push(tb(b, b.charAt(0) == "/" ? vb : xb, !0));
            (b = this.g.toString()) && a.push("?", b);
            (b = this.bd) && a.push("#", tb(b, yb));
            return a.join("");
        };
        p.resolve = function(a) {
            var b = this.clone();
            b.lc === "data" && (b = new lb);
            var c = !!a.lc;
            c ? mb(b, a.lc) : c = !!a.rd;
            c ? b.rd = a.rd : c = !!a.Eb;
            c ? nb(b, a.Eb) : c = a.Pd != null;
            var d = a.Zb;
            if (c) ob(b, a.Pd);
            else if (c = !!a.Zb) {
                if (d.charAt(0) != "/") {
                    if (this.Eb && !this.Zb) d = "/" + d;
                    else {
                        var e = b.Zb.lastIndexOf("/");
                        e != -1 && (d = b.Zb.substr(0, e + 1) + d);
                    }
                }
                e = d;
                if (e == ".." || e == ".") d = "";
                else if (e.indexOf("./") == -1 && e.indexOf("/.") == -1) d = e;
                else {
                    d = e.lastIndexOf("/", 0) == 0;
                    e = e.split("/");
                    for(var f = [], g = 0; g < e.length;){
                        var h = e[g++];
                        h == "." ? d && g == e.length && f.push("") : h == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
                    }
                    d = f.join("/");
                }
            }
            c ? b.Zb = d : c = a.g.toString() !== "";
            c ? pb(b, a.g.clone()) : c = !!a.bd;
            c && (b.bd = a.bd);
            return b;
        };
        p.clone = function() {
            return new lb(this);
        };
        function mb(a, b, c) {
            a.lc = c ? qb(b, !0) : b;
            a.lc && (a.lc = a.lc.replace(/:$/, ""));
        }
        function nb(a, b, c) {
            a.Eb = c ? qb(b, !0) : b;
        }
        function ob(a, b) {
            if (b) {
                b = Number(b);
                if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
                a.Pd = b;
            } else a.Pd = null;
        }
        function pb(a, b, c) {
            b instanceof rb ? a.g = b : (c || (b = tb(b, zb)), a.g = new rb(b));
        }
        function qb(a, b) {
            return a ? b ? decodeURI(a) : decodeURIComponent(a) : "";
        }
        function tb(a, b, c) {
            return a != null ? (a = encodeURI(a).replace(b, Ab), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
        }
        function Ab(a) {
            a = a.charCodeAt(0);
            return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
        }
        var ub = /[#\/\?@]/g, xb = /[#\?:]/g, vb = /[#\?]/g, zb = /[#\?@]/g, yb = /#/g;
        function rb(a) {
            this.g = a || null;
        }
        function Bb(a) {
            if (!a.ob && (a.ob = new Map, a.je = 0, a.g)) for(var b = a.g.split("&"), c = 0; c < b.length; c++){
                var d = b[c].indexOf("="), e = null;
                if (d >= 0) {
                    var f = b[c].substring(0, d);
                    e = b[c].substring(d + 1);
                } else f = b[c];
                f = decodeURIComponent(f);
                e = e || "";
                a.add(f, decodeURIComponent(e));
            }
        }
        p = rb.prototype;
        p.ob = null;
        p.je = null;
        p.add = function(a, b) {
            Bb(this);
            this.g = null;
            var c = this.ob.has(a) ? this.ob.get(a) : null;
            c || this.ob.set(a, c = []);
            c.push(b);
            this.je++;
            return this;
        };
        p.set = function(a, b) {
            Bb(this);
            this.g = null;
            this.ob.has(a) ? this.ob.set(a, [
                b
            ]) : this.add(a, b);
            return this;
        };
        p.get = function(a) {
            Bb(this);
            return this.ob.get(a) || [];
        };
        p.toString = function() {
            if (this.g) return this.g;
            if (!this.ob || !this.ob.size) return "";
            for(var a = [], b = u(this.ob.keys()), c = b.next(); !c.done; c = b.next()){
                var d = c.value;
                c = encodeURIComponent(d);
                d = this.ob.get(d);
                for(var e = 0; e < d.length; e++){
                    var f = c;
                    d[e] !== "" && (f += "=" + encodeURIComponent(d[e]));
                    a.push(f);
                }
            }
            return this.g = a.join("&");
        };
        p.clone = function() {
            var a = new rb;
            a.g = this.g;
            if (this.ob) {
                for(var b = new Map, c = u(this.ob), d = c.next(); !d.done; d = c.next()){
                    var e = u(d.value);
                    d = e.next().value;
                    e = e.next().value;
                    b.set(d, e.concat());
                }
                a.ob = b;
                a.je = this.je;
            }
            return a;
        };
        function Cb() {}
        function Eb(a, b) {
            if (!a && !b) return !0;
            if (!a || !b || a.byteLength != b.byteLength) return !1;
            if ((ArrayBuffer.isView(a) ? a.buffer : a) == (ArrayBuffer.isView(b) ? b.buffer : b) && (a.byteOffset || 0) == (b.byteOffset || 0)) return !0;
            var c = Fb(a);
            b = Fb(b);
            for(var d = 0; d < a.byteLength; d++)if (c[d] != b[d]) return !1;
            return !0;
        }
        function Gb(a) {
            return ArrayBuffer.isView(a) ? a.byteOffset == 0 && a.byteLength == a.buffer.byteLength ? a.buffer : new Uint8Array(a).buffer : a;
        }
        function Fb(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Hb(a, b === void 0 ? 0 : b, c, Uint8Array);
        }
        function Ib(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Hb(a, b === void 0 ? 0 : b, c, Uint16Array);
        }
        function Jb(a, b, c) {
            c = c === void 0 ? Infinity : c;
            return Hb(a, b === void 0 ? 0 : b, c, DataView);
        }
        function Hb(a, b, c, d) {
            var e = ArrayBuffer.isView(a) ? a.buffer : a, f = 1;
            "BYTES_PER_ELEMENT" in d && (f = d.BYTES_PER_ELEMENT);
            var g = ((a.byteOffset || 0) + a.byteLength) / f;
            a = Math.floor(Math.max(0, Math.min(((a.byteOffset || 0) + b) / f, g)));
            return new d(e, a, Math.floor(Math.min(a + Math.max(c, 0), g)) - a);
        }
        O("shaka.util.BufferUtils", Cb);
        Cb.toDataView = Jb;
        Cb.toUint16 = Ib;
        Cb.toUint8 = Fb;
        Cb.toArrayBuffer = Gb;
        Cb.equal = Eb;
        function Kb(a) {
            this.h = a;
            this.g = void 0;
        }
        Kb.prototype.value = function() {
            this.g === void 0 && (this.g = this.h());
            return this.g;
        };
        function Lb(a, b) {
            if (a === b || !a.length || !b.length) return !0;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (Mb(c)) return !0;
                for(var d = u(b), e = d.next(); !e.done; e = d.next())if (e = e.value, c.keySystem === e.keySystem || Mb(e)) return !0;
            }
            return !1;
        }
        function Nb(a, b) {
            if (!a.length) return b;
            if (!b.length) return a;
            var c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())if (f = f.value, d.keySystem == f.keySystem) {
                    e = new Map;
                    for(var g = u((d.initData || []).concat(f.initData || [])), h = g.next(); !h.done; h = g.next())h = h.value, e.set(h.keyId, h);
                    e = Array.from(e.values());
                    g = d.keyIds && f.keyIds ? new Set([].concat(G(d.keyIds), G(f.keyIds))) : d.keyIds || f.keyIds;
                    c.push({
                        keySystem: d.keySystem,
                        licenseServerUri: d.licenseServerUri || f.licenseServerUri,
                        distinctiveIdentifierRequired: d.distinctiveIdentifierRequired || f.distinctiveIdentifierRequired,
                        persistentStateRequired: d.persistentStateRequired || f.persistentStateRequired,
                        videoRobustness: d.videoRobustness || f.videoRobustness,
                        audioRobustness: d.audioRobustness || f.audioRobustness,
                        serverCertificate: d.serverCertificate || f.serverCertificate,
                        serverCertificateUri: d.serverCertificateUri || f.serverCertificateUri,
                        initData: e,
                        keyIds: g
                    });
                    break;
                } else Mb(d) ? c.push(d) : Mb(f) && c.push(f);
            }
            return c;
        }
        function Ob(a) {
            return a === "org.w3.clearkey";
        }
        function Pb(a) {
            return a ? !!a.match(/^com\.widevine\.alpha/) : !1;
        }
        function Qb(a) {
            return a ? !!a.match(/^com\.(microsoft|chromecast)\.playready/) : !1;
        }
        function Rb(a) {
            return a ? !!a.match(/^com\.apple\.fps/) : !1;
        }
        function Mb(a) {
            return (a = a.licenseServerUri) ? a.startsWith("data:application/json;base64,") : !1;
        }
        function Sb(a, b, c, d) {
            d = [].concat(G(new Set(d))).sort().join("#");
            return a + "#" + b + "#" + c + "#" + d;
        }
        var Tb = new Kb(function() {
            return Gb(new Uint8Array([
                0
            ]));
        }), Ub = new Map;
        function T(a, b, c) {
            var d = Ma.apply(3, arguments);
            this.severity = a;
            this.category = b;
            this.code = c;
            this.data = d;
            this.handled = !1;
            this.message = "Shaka Error " + this.code;
            if (Vb) try {
                throw Error(this.message || "Shaka Error");
            } catch (e) {
                this.stack = e.stack;
            }
        }
        T.prototype.toString = function() {
            return "shaka.util.Error " + JSON.stringify(this, null, "  ");
        };
        O("shaka.util.Error", T);
        var Vb = !0;
        T.Severity = {
            RECOVERABLE: 1,
            CRITICAL: 2
        };
        T.Category = {
            NETWORK: 1,
            TEXT: 2,
            MEDIA: 3,
            MANIFEST: 4,
            STREAMING: 5,
            DRM: 6,
            PLAYER: 7,
            CAST: 8,
            STORAGE: 9,
            ADS: 10
        };
        T.Code = {
            UNSUPPORTED_SCHEME: 1E3,
            BAD_HTTP_STATUS: 1001,
            HTTP_ERROR: 1002,
            TIMEOUT: 1003,
            MALFORMED_DATA_URI: 1004,
            REQUEST_FILTER_ERROR: 1006,
            RESPONSE_FILTER_ERROR: 1007,
            MALFORMED_TEST_URI: 1008,
            UNEXPECTED_TEST_REQUEST: 1009,
            ATTEMPTS_EXHAUSTED: 1010,
            SEGMENT_MISSING: 1011,
            INVALID_TEXT_HEADER: 2E3,
            INVALID_TEXT_CUE: 2001,
            UNABLE_TO_DETECT_ENCODING: 2003,
            BAD_ENCODING: 2004,
            INVALID_XML: 2005,
            INVALID_MP4_TTML: 2007,
            INVALID_MP4_VTT: 2008,
            UNABLE_TO_EXTRACT_CUE_START_TIME: 2009,
            INVALID_MP4_CEA: 2010,
            TEXT_COULD_NOT_GUESS_MIME_TYPE: 2011,
            CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS: 2012,
            TEXT_ONLY_WEBVTT_SRC_EQUALS: 2013,
            MISSING_TEXT_PLUGIN: 2014,
            UNSUPPORTED_EXTERNAL_THUMBNAILS_URI: 2017,
            BUFFER_READ_OUT_OF_BOUNDS: 3E3,
            JS_INTEGER_OVERFLOW: 3001,
            EBML_OVERFLOW: 3002,
            EBML_BAD_FLOATING_POINT_SIZE: 3003,
            MP4_SIDX_WRONG_BOX_TYPE: 3004,
            MP4_SIDX_INVALID_TIMESCALE: 3005,
            MP4_SIDX_TYPE_NOT_SUPPORTED: 3006,
            WEBM_CUES_ELEMENT_MISSING: 3007,
            WEBM_EBML_HEADER_ELEMENT_MISSING: 3008,
            WEBM_SEGMENT_ELEMENT_MISSING: 3009,
            WEBM_INFO_ELEMENT_MISSING: 3010,
            WEBM_DURATION_ELEMENT_MISSING: 3011,
            WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING: 3012,
            WEBM_CUE_TIME_ELEMENT_MISSING: 3013,
            MEDIA_SOURCE_OPERATION_FAILED: 3014,
            MEDIA_SOURCE_OPERATION_THREW: 3015,
            VIDEO_ERROR: 3016,
            QUOTA_EXCEEDED_ERROR: 3017,
            TRANSMUXING_FAILED: 3018,
            CONTENT_TRANSFORMATION_FAILED: 3019,
            MSS_MISSING_DATA_FOR_TRANSMUXING: 3020,
            MSS_TRANSMUXING_FAILED: 3022,
            TRANSMUXING_NO_VIDEO_DATA: 3023,
            STREAMING_NOT_ALLOWED: 3024,
            UNABLE_TO_GUESS_MANIFEST_TYPE: 4E3,
            DASH_INVALID_XML: 4001,
            DASH_NO_SEGMENT_INFO: 4002,
            DASH_EMPTY_ADAPTATION_SET: 4003,
            DASH_EMPTY_PERIOD: 4004,
            DASH_WEBM_MISSING_INIT: 4005,
            DASH_UNSUPPORTED_CONTAINER: 4006,
            DASH_PSSH_BAD_ENCODING: 4007,
            DASH_NO_COMMON_KEY_SYSTEM: 4008,
            DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED: 4009,
            DASH_CONFLICTING_KEY_IDS: 4010,
            RESTRICTIONS_CANNOT_BE_MET: 4012,
            HLS_PLAYLIST_HEADER_MISSING: 4015,
            INVALID_HLS_TAG: 4016,
            HLS_INVALID_PLAYLIST_HIERARCHY: 4017,
            DASH_DUPLICATE_REPRESENTATION_ID: 4018,
            HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND: 4020,
            HLS_REQUIRED_ATTRIBUTE_MISSING: 4023,
            HLS_REQUIRED_TAG_MISSING: 4024,
            HLS_COULD_NOT_GUESS_CODECS: 4025,
            HLS_KEYFORMATS_NOT_SUPPORTED: 4026,
            DASH_UNSUPPORTED_XLINK_ACTUATE: 4027,
            DASH_XLINK_DEPTH_LIMIT: 4028,
            CONTENT_UNSUPPORTED_BY_BROWSER: 4032,
            CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM: 4033,
            NO_VARIANTS: 4036,
            PERIOD_FLATTENING_FAILED: 4037,
            INCONSISTENT_DRM_ACROSS_PERIODS: 4038,
            HLS_VARIABLE_NOT_FOUND: 4039,
            HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED: 4040,
            HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4041,
            NO_WEB_CRYPTO_API: 4042,
            CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM: 4045,
            MSS_INVALID_XML: 4046,
            MSS_LIVE_CONTENT_NOT_SUPPORTED: 4047,
            AES_128_INVALID_IV_LENGTH: 4048,
            AES_128_INVALID_KEY_LENGTH: 4049,
            DASH_CONFLICTING_AES_128: 4050,
            DASH_UNSUPPORTED_AES_128: 4051,
            DASH_INVALID_PATCH: 4052,
            HLS_EMPTY_MEDIA_PLAYLIST: 4053,
            DASH_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED: 4054,
            CANNOT_ADD_EXTERNAL_CHAPTERS_TO_LIVE_STREAM: 4055,
            STREAMING_ENGINE_STARTUP_INVALID_STATE: 5006,
            NO_RECOGNIZED_KEY_SYSTEMS: 6E3,
            REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE: 6001,
            FAILED_TO_CREATE_CDM: 6002,
            FAILED_TO_ATTACH_TO_VIDEO: 6003,
            INVALID_SERVER_CERTIFICATE: 6004,
            FAILED_TO_CREATE_SESSION: 6005,
            FAILED_TO_GENERATE_LICENSE_REQUEST: 6006,
            LICENSE_REQUEST_FAILED: 6007,
            LICENSE_RESPONSE_REJECTED: 6008,
            ENCRYPTED_CONTENT_WITHOUT_DRM_INFO: 6010,
            NO_LICENSE_SERVER_GIVEN: 6012,
            OFFLINE_SESSION_REMOVED: 6013,
            EXPIRED: 6014,
            SERVER_CERTIFICATE_REQUIRED: 6015,
            INIT_DATA_TRANSFORM_ERROR: 6016,
            SERVER_CERTIFICATE_REQUEST_FAILED: 6017,
            MIN_HDCP_VERSION_NOT_MATCH: 6018,
            ERROR_CHECKING_HDCP_VERSION: 6019,
            MISSING_EME_SUPPORT: 6020,
            LOAD_INTERRUPTED: 7E3,
            OPERATION_ABORTED: 7001,
            NO_VIDEO_ELEMENT: 7002,
            OBJECT_DESTROYED: 7003,
            CONTENT_NOT_LOADED: 7004,
            SRC_EQUALS_PRELOAD_NOT_SUPPORTED: 7005,
            PRELOAD_DESTROYED: 7006,
            QUEUE_INDEX_OUT_OF_BOUNDS: 7007,
            CAST_API_UNAVAILABLE: 8E3,
            NO_CAST_RECEIVERS: 8001,
            ALREADY_CASTING: 8002,
            UNEXPECTED_CAST_ERROR: 8003,
            CAST_CANCELED_BY_USER: 8004,
            CAST_CONNECTION_TIMED_OUT: 8005,
            CAST_RECEIVER_APP_UNAVAILABLE: 8006,
            STORAGE_NOT_SUPPORTED: 9E3,
            INDEXED_DB_ERROR: 9001,
            DEPRECATED_OPERATION_ABORTED: 9002,
            REQUESTED_ITEM_NOT_FOUND: 9003,
            MALFORMED_OFFLINE_URI: 9004,
            CANNOT_STORE_LIVE_OFFLINE: 9005,
            NO_INIT_DATA_FOR_OFFLINE: 9007,
            LOCAL_PLAYER_INSTANCE_REQUIRED: 9008,
            NEW_KEY_OPERATION_NOT_SUPPORTED: 9011,
            KEY_NOT_FOUND: 9012,
            MISSING_STORAGE_CELL: 9013,
            STORAGE_LIMIT_REACHED: 9014,
            DOWNLOAD_SIZE_CALLBACK_ERROR: 9015,
            MODIFY_OPERATION_NOT_SUPPORTED: 9016,
            INDEXED_DB_INIT_TIMED_OUT: 9017,
            CS_IMA_SDK_MISSING: 1E4,
            CS_AD_MANAGER_NOT_INITIALIZED: 10001,
            SS_IMA_SDK_MISSING: 10002,
            SS_AD_MANAGER_NOT_INITIALIZED: 10003,
            CURRENT_DAI_REQUEST_NOT_FINISHED: 10004,
            MT_AD_MANAGER_NOT_INITIALIZED: 10005,
            INTERSTITIAL_AD_MANAGER_NOT_INITIALIZED: 10006,
            VAST_INVALID_XML: 10007
        };
        function Xb() {
            return Yb.value();
        }
        var Zb = null, $b = null, Yb = new Kb(function() {
            var a = void 0;
            Zb && (a = Zb());
            !a && $b && (a = $b());
            return a;
        });
        function ac() {}
        function bc(a) {
            if (!a) return "";
            a = Fb(a);
            a[0] == 239 && a[1] == 187 && a[2] == 191 && (a = a.subarray(3));
            if (window1.TextDecoder && !Xb().ni()) return a = (new TextDecoder).decode(a), a.includes("\ufffd") && Ya('Decoded string contains an "unknown character" codepoint.  That probably means the UTF8 encoding was incorrect!'), a;
            for(var b = "", c = 0; c < a.length; ++c){
                var d = 65533;
                (a[c] & 128) == 0 ? d = a[c] : a.length >= c + 2 && (a[c] & 224) == 192 && (a[c + 1] & 192) == 128 ? (d = (a[c] & 31) << 6 | a[c + 1] & 63, c += 1) : a.length >= c + 3 && (a[c] & 240) == 224 && (a[c + 1] & 192) == 128 && (a[c + 2] & 192) == 128 ? (d = (a[c] & 15) << 12 | (a[c + 1] & 63) << 6 | a[c + 2] & 63, c += 2) : a.length >= c + 4 && (a[c] & 241) == 240 && (a[c + 1] & 192) == 128 && (a[c + 2] & 192) == 128 && (a[c + 3] & 192) == 128 && (d = (a[c] & 7) << 18 | (a[c + 1] & 63) << 12 | (a[c + 2] & 63) << 6 | a[c + 3] & 63, c += 3);
                if (d <= 65535) b += String.fromCharCode(d);
                else {
                    d -= 65536;
                    var e = d & 1023;
                    b += String.fromCharCode(55296 + (d >> 10));
                    b += String.fromCharCode(56320 + e);
                }
            }
            return b;
        }
        function cc(a, b, c) {
            if (!a) return "";
            if (!c && a.byteLength % 2 != 0) throw new T(2, 2, 2004);
            c = Math.floor(a.byteLength / 2);
            var d = new Uint16Array(c);
            a = Jb(a);
            for(var e = 0; e < c; e++)d[e] = a.getUint16(e * 2, b);
            return dc.value()(d);
        }
        function ec(a) {
            function b(d) {
                return c.byteLength <= d || c[d] >= 9 && c[d] <= 126;
            }
            if (!a) return "";
            var c = Fb(a);
            if (c[0] == 239 && c[1] == 187 && c[2] == 191) return bc(c);
            if (c[0] == 254 && c[1] == 255) return cc(c.subarray(2), !1);
            if (c[0] == 255 && c[1] == 254) return cc(c.subarray(2), !0);
            if (c[0] == 0 && c[2] == 0) return cc(a, !1);
            if (c[1] == 0 && c[3] == 0) return cc(a, !0);
            if (b(0) && b(1) && b(2) && b(3)) return bc(a);
            throw new T(2, 2, 2003);
        }
        function hc(a) {
            if (window1.TextEncoder && !Xb().ni()) {
                var b = new TextEncoder;
                return Gb(b.encode(a));
            }
            a = encodeURIComponent(a);
            a = unescape(a);
            b = new Uint8Array(a.length);
            for(var c = 0; c < a.length; c++)b[c] = a[c].charCodeAt(0);
            return Gb(b);
        }
        function ic(a, b) {
            for(var c = new ArrayBuffer(a.length * 2), d = new DataView(c), e = 0; e < a.length; ++e)d.setUint16(e * 2, a.charCodeAt(e), b);
            return c;
        }
        function jc(a) {
            var b = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&apos;": "'",
                "&nbsp;": "\u00a0",
                "&lrm;": "\u200e",
                "&rlm;": "\u200f"
            }, c = /&(?:amp|lt|gt|quot|apos|nbsp|lrm|rlm|#[xX]?[0-9a-fA-F]+);/g, d = RegExp(c.source);
            return a && d.test(a) ? a.replace(c, function(e) {
                return e[1] == "#" ? (e = e[2] == "x" || e[2] == "X" ? parseInt(e.substring(3), 16) : parseInt(e.substring(2), 10), e >= 0 && e <= 1114111 ? String.fromCodePoint(e) : "") : b[e] || "'";
            }) : a || "";
        }
        O("shaka.util.StringUtils", ac);
        ac.resetFromCharCode = function() {
            dc.g = void 0;
        };
        ac.toUTF16 = ic;
        ac.toUTF8 = hc;
        ac.fromBytesAutoDetect = ec;
        ac.fromUTF16 = cc;
        ac.fromUTF8 = bc;
        var dc = new Kb(function() {
            function a(c) {
                try {
                    var d = new Uint8Array(c);
                    return String.fromCharCode.apply(null, d).length > 0;
                } catch (e) {
                    return !1;
                }
            }
            for(var b = {
                Xc: 65536
            }; b.Xc > 0; b = {
                Xc: b.Xc
            }, b.Xc /= 2)if (a(b.Xc)) return function(c) {
                return function(d) {
                    for(var e = "", f = 0; f < d.length; f += c.Xc)e += String.fromCharCode.apply(null, d.subarray(f, f + c.Xc));
                    return e;
                };
            }(b);
            return null;
        });
        function kc() {}
        function lc(a) {
            a = Fb(a);
            return Uint8Array.prototype.toBase64 ? a.toBase64({
                alphabet: "base64",
                omitPadding: !1
            }) : (a = dc.value()(a), btoa(a));
        }
        function mc(a, b) {
            b = b == void 0 ? !0 : b;
            return Uint8Array.prototype.toBase64 ? Fb(a).toBase64({
                alphabet: "base64url",
                omitPadding: !b
            }) : (a = lc(a).replace(/\+/g, "-").replace(/\//g, "_"), b ? a : a.replace(/[=]*$/, ""));
        }
        function qc(a) {
            if (!("fromBase64" in Uint8Array)) {
                a = window1.atob(a.replace(/-/g, "+").replace(/_/g, "/"));
                for(var b = new Uint8Array(a.length), c = 0; c < a.length; ++c)b[c] = a.charCodeAt(c);
                return b;
            }
            a = a.replace(/\s+/g, "");
            return Uint8Array.fromBase64(a, {
                alphabet: /[-_]/.test(a) ? "base64url" : "base64"
            });
        }
        function rc(a) {
            if (!("fromHex" in Uint8Array)) {
                for(var b = a.length / 2, c = new Uint8Array(b), d = 0; d < b; d++)c[d] = window1.parseInt(a.substr(d * 2, 2), 16);
                return c;
            }
            return Uint8Array.fromHex(a);
        }
        function sc(a) {
            var b = Fb(a);
            if (!Uint8Array.prototype.toHex) {
                a = "";
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c = c.toString(16), c.length == 1 && (c = "0" + c), a += c;
                return a;
            }
            return b.toHex();
        }
        function tc() {
            var a = Ma.apply(0, arguments);
            return uc(a, 0, a.length);
        }
        function uc(a, b, c) {
            b = b === void 0 ? 0 : b;
            c = c === void 0 ? a.length : c;
            for(var d = 0, e = b; e < c; ++e)d += a[e].byteLength;
            d = new Uint8Array(d);
            for(e = 0; b < c; ++b){
                var f = a[b];
                ArrayBuffer.isView(f) && f.BYTES_PER_ELEMENT === 1 ? d.set(f, e) : d.set(Fb(f), e);
                e += f.byteLength;
            }
            return d;
        }
        O("shaka.util.Uint8ArrayUtils", kc);
        kc.concat = tc;
        kc.toHex = sc;
        kc.fromHex = rc;
        kc.fromBase64 = qc;
        kc.toBase64 = mc;
        kc.toStandardBase64 = lc;
        function vc(a, b, c) {
            c = c === void 0 ? "" : c;
            if (b.length == 0) return a;
            if (a.length == 1 && b.length == 1) {
                var d = new lb(a[0]);
                b = new lb(b[0]);
                b = d.resolve(b);
                c && pb(b, c);
                return [
                    b.toString()
                ];
            }
            b = b.map(function(h) {
                return new lb(h);
            });
            d = [];
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next()){
                e = new lb(e.value);
                for(var f = u(b), g = f.next(); !g.done; g = f.next())g = e.resolve(g.value), c && pb(g, c), d.push(g.toString());
            }
            return d;
        }
        function yc(a, b, c, d, e) {
            b = {
                keySystem: a,
                encryptionScheme: b,
                licenseServerUri: "",
                distinctiveIdentifierRequired: !1,
                persistentStateRequired: !1,
                audioRobustness: "",
                videoRobustness: "",
                serverCertificate: null,
                serverCertificateUri: "",
                sessionType: "",
                initData: c || [],
                keyIds: new Set,
                mediaTypes: e
            };
            d && (b.keySystemUris = new Set([
                d
            ]));
            !c && Rb(a) && b.initData.push({
                initDataType: "sinf",
                initData: new Uint8Array(0),
                keyId: null
            });
            return b;
        }
        function zc(a, b) {
            b = b === void 0 ? "cenc" : b;
            var c = [], d = [], e = [];
            a.forEach(function(g, h) {
                var k = h;
                k.length != 22 && (k = mc(rc(h), !1));
                var l = g;
                l.length != 22 && (l = mc(rc(g), !1));
                g = {
                    kty: "oct",
                    kid: k,
                    k: l
                };
                c.push(g);
                d.push(g.kid);
                e.push(h);
            });
            a = JSON.stringify({
                keys: c
            });
            var f = JSON.stringify({
                kids: d
            });
            f = [
                {
                    initData: Fb(hc(f)),
                    initDataType: "keyids"
                }
            ];
            return {
                keySystem: "org.w3.clearkey",
                encryptionScheme: b,
                licenseServerUri: "data:application/json;base64," + window1.btoa(a),
                distinctiveIdentifierRequired: !1,
                persistentStateRequired: !1,
                audioRobustness: "",
                videoRobustness: "",
                serverCertificate: null,
                serverCertificateUri: "",
                sessionType: "",
                initData: f,
                keyIds: new Set(e)
            };
        }
        function Bc(a, b) {
            if (b.length == 1) return b[0];
            a = Cc(a, b);
            if (a != null) return a;
            throw new T(2, 4, 4025, b);
        }
        function Cc(a, b) {
            var c = Dc.get(a);
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())if (f = f.value, d.test(f.trim())) return f.trim();
            }
            return a == Ec ? "" : null;
        }
        function Fc(a, b) {
            var c = [];
            a = Dc.get(a);
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                for(var e = u(b), f = e.next(); !f.done; f = e.next())f = f.value, d.test(f.trim()) && c.push(f.trim());
            }
            return c;
        }
        var Ec = "text", Gc = {
            Ba: "video",
            ha: "audio",
            Va: Ec,
            zg: "image",
            Im: "application"
        }, Hc = 1 / 15, Dc = (new Map).set("audio", [
            /^vorbis$/,
            /^Opus$/,
            /^opus$/,
            /^fLaC$/,
            /^flac$/,
            /^mp4a/,
            /^[ae]c-3$/,
            /^ac-4/,
            /^dts[cehx]?$/,
            /^iamf/,
            /^mhm[12]/,
            /^ac3$/,
            /^eac3$/,
            /^apac$/
        ]).set("video", [
            /^avc/,
            /^hev/,
            /^hvc/,
            /^vvc/,
            /^vvi/,
            /^vp0?[89]/,
            /^av01/,
            /^mp2v/,
            /^dvh/,
            /^dva/,
            /^dav/
        ]).set("text", [
            /^vtt$/,
            /^wvtt/,
            /^stpp/
        ]);
        function Ic() {}
        function Jc(a, b) {
            a = Kc(a);
            b = Kc(b);
            return a.split("-")[0] == b.split("-")[0];
        }
        function Lc(a, b) {
            a = Kc(a);
            b = Kc(b);
            a = a.split("-");
            b = b.split("-");
            return a[0] == b[0] && a.length == 1 && b.length == 2;
        }
        function Mc(a, b) {
            a = Kc(a);
            b = Kc(b);
            a = a.split("-");
            b = b.split("-");
            return a.length == 2 && b.length == 2 && a[0] == b[0];
        }
        function Kc(a) {
            a = u(a.split("-x-"));
            var b = a.next().value;
            b = b === void 0 ? "" : b;
            a = a.next().value;
            a = a === void 0 ? "" : a;
            var c = u(b.split("-"));
            b = c.next().value;
            b = b === void 0 ? "" : b;
            c = c.next().value;
            c = c === void 0 ? "" : c;
            a = a ? "x-" + a : "";
            b = b.toLowerCase();
            b = Nc.get(b) || b;
            c = c.toUpperCase();
            return (c ? b + "-" + c : b) + (a ? "-" + a : "");
        }
        function Oc(a, b) {
            var c = Pc(a), d = Pc(b);
            return a != c && b != d && c == d;
        }
        function Qc(a, b) {
            a = Kc(a);
            b = Kc(b);
            return b == a ? 4 : Lc(b, a) ? 3 : Mc(b, a) ? 2 : Lc(a, b) ? 1 : 0;
        }
        function Pc(a) {
            var b = a.indexOf("-");
            a = b >= 0 ? a.substring(0, b) : a;
            a = a.toLowerCase();
            return a = Nc.get(a) || a;
        }
        function Rc(a) {
            return a.language ? Kc(a.language) : a.audio && a.audio.language ? Kc(a.audio.language) : a.video && a.video.language ? Kc(a.video.language) : "und";
        }
        function Sc(a, b) {
            a = Kc(a);
            var c = new Set;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())c.add(Kc(d.value));
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, d == a) return d;
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, Lc(d, a)) return d;
            b = u(c);
            for(d = b.next(); !d.done; d = b.next())if (d = d.value, Mc(d, a)) return d;
            c = u(c);
            for(b = c.next(); !b.done; b = c.next())if (b = b.value, Lc(a, b)) return b;
            return null;
        }
        O("shaka.util.LanguageUtils", Ic);
        Ic.findClosestLocale = Sc;
        Ic.getLocaleForVariant = Rc;
        Ic.getLocaleForText = function(a) {
            return Kc(a.language || "und");
        };
        Ic.getBase = Pc;
        Ic.relatedness = Qc;
        Ic.areSiblings = Oc;
        Ic.normalize = Kc;
        Ic.isSiblingOf = Mc;
        Ic.isParentOf = Lc;
        Ic.areLanguageCompatible = Jc;
        Ic.areLocaleCompatible = function(a, b) {
            a = Kc(a);
            b = Kc(b);
            return a == b;
        };
        var Nc = new Map([
            [
                "aar",
                "aa"
            ],
            [
                "abk",
                "ab"
            ],
            [
                "afr",
                "af"
            ],
            [
                "aka",
                "ak"
            ],
            [
                "alb",
                "sq"
            ],
            [
                "amh",
                "am"
            ],
            [
                "ara",
                "ar"
            ],
            [
                "arg",
                "an"
            ],
            [
                "arm",
                "hy"
            ],
            [
                "asm",
                "as"
            ],
            [
                "ava",
                "av"
            ],
            [
                "ave",
                "ae"
            ],
            [
                "aym",
                "ay"
            ],
            [
                "aze",
                "az"
            ],
            [
                "bak",
                "ba"
            ],
            [
                "bam",
                "bm"
            ],
            [
                "baq",
                "eu"
            ],
            [
                "bel",
                "be"
            ],
            [
                "ben",
                "bn"
            ],
            [
                "bih",
                "bh"
            ],
            [
                "bis",
                "bi"
            ],
            [
                "bod",
                "bo"
            ],
            [
                "bos",
                "bs"
            ],
            [
                "bre",
                "br"
            ],
            [
                "bul",
                "bg"
            ],
            [
                "bur",
                "my"
            ],
            [
                "cat",
                "ca"
            ],
            [
                "ces",
                "cs"
            ],
            [
                "cha",
                "ch"
            ],
            [
                "che",
                "ce"
            ],
            [
                "chi",
                "zh"
            ],
            [
                "chu",
                "cu"
            ],
            [
                "chv",
                "cv"
            ],
            [
                "cor",
                "kw"
            ],
            [
                "cos",
                "co"
            ],
            [
                "cre",
                "cr"
            ],
            [
                "cym",
                "cy"
            ],
            [
                "cze",
                "cs"
            ],
            [
                "dan",
                "da"
            ],
            [
                "deu",
                "de"
            ],
            [
                "div",
                "dv"
            ],
            [
                "dut",
                "nl"
            ],
            [
                "dzo",
                "dz"
            ],
            [
                "ell",
                "el"
            ],
            [
                "eng",
                "en"
            ],
            [
                "epo",
                "eo"
            ],
            [
                "est",
                "et"
            ],
            [
                "eus",
                "eu"
            ],
            [
                "ewe",
                "ee"
            ],
            [
                "fao",
                "fo"
            ],
            [
                "fas",
                "fa"
            ],
            [
                "fij",
                "fj"
            ],
            [
                "fin",
                "fi"
            ],
            [
                "fra",
                "fr"
            ],
            [
                "fre",
                "fr"
            ],
            [
                "fry",
                "fy"
            ],
            [
                "ful",
                "ff"
            ],
            [
                "geo",
                "ka"
            ],
            [
                "ger",
                "de"
            ],
            [
                "gla",
                "gd"
            ],
            [
                "gle",
                "ga"
            ],
            [
                "glg",
                "gl"
            ],
            [
                "glv",
                "gv"
            ],
            [
                "gre",
                "el"
            ],
            [
                "grn",
                "gn"
            ],
            [
                "guj",
                "gu"
            ],
            [
                "hat",
                "ht"
            ],
            [
                "hau",
                "ha"
            ],
            [
                "heb",
                "he"
            ],
            [
                "her",
                "hz"
            ],
            [
                "hin",
                "hi"
            ],
            [
                "hmo",
                "ho"
            ],
            [
                "hrv",
                "hr"
            ],
            [
                "hun",
                "hu"
            ],
            [
                "hye",
                "hy"
            ],
            [
                "ibo",
                "ig"
            ],
            [
                "ice",
                "is"
            ],
            [
                "ido",
                "io"
            ],
            [
                "iii",
                "ii"
            ],
            [
                "iku",
                "iu"
            ],
            [
                "ile",
                "ie"
            ],
            [
                "ina",
                "ia"
            ],
            [
                "ind",
                "id"
            ],
            [
                "ipk",
                "ik"
            ],
            [
                "isl",
                "is"
            ],
            [
                "ita",
                "it"
            ],
            [
                "jav",
                "jv"
            ],
            [
                "jpn",
                "ja"
            ],
            [
                "kal",
                "kl"
            ],
            [
                "kan",
                "kn"
            ],
            [
                "kas",
                "ks"
            ],
            [
                "kat",
                "ka"
            ],
            [
                "kau",
                "kr"
            ],
            [
                "kaz",
                "kk"
            ],
            [
                "khm",
                "km"
            ],
            [
                "kik",
                "ki"
            ],
            [
                "kin",
                "rw"
            ],
            [
                "kir",
                "ky"
            ],
            [
                "kom",
                "kv"
            ],
            [
                "kon",
                "kg"
            ],
            [
                "kor",
                "ko"
            ],
            [
                "kua",
                "kj"
            ],
            [
                "kur",
                "ku"
            ],
            [
                "lao",
                "lo"
            ],
            [
                "lat",
                "la"
            ],
            [
                "lav",
                "lv"
            ],
            [
                "lim",
                "li"
            ],
            [
                "lin",
                "ln"
            ],
            [
                "lit",
                "lt"
            ],
            [
                "ltz",
                "lb"
            ],
            [
                "lub",
                "lu"
            ],
            [
                "lug",
                "lg"
            ],
            [
                "mac",
                "mk"
            ],
            [
                "mah",
                "mh"
            ],
            [
                "mal",
                "ml"
            ],
            [
                "mao",
                "mi"
            ],
            [
                "mar",
                "mr"
            ],
            [
                "may",
                "ms"
            ],
            [
                "mkd",
                "mk"
            ],
            [
                "mlg",
                "mg"
            ],
            [
                "mlt",
                "mt"
            ],
            [
                "mon",
                "mn"
            ],
            [
                "mri",
                "mi"
            ],
            [
                "msa",
                "ms"
            ],
            [
                "mya",
                "my"
            ],
            [
                "nau",
                "na"
            ],
            [
                "nav",
                "nv"
            ],
            [
                "nbl",
                "nr"
            ],
            [
                "nde",
                "nd"
            ],
            [
                "ndo",
                "ng"
            ],
            [
                "nep",
                "ne"
            ],
            [
                "nld",
                "nl"
            ],
            [
                "nno",
                "nn"
            ],
            [
                "nob",
                "nb"
            ],
            [
                "nor",
                "no"
            ],
            [
                "nya",
                "ny"
            ],
            [
                "oci",
                "oc"
            ],
            [
                "oji",
                "oj"
            ],
            [
                "ori",
                "or"
            ],
            [
                "orm",
                "om"
            ],
            [
                "oss",
                "os"
            ],
            [
                "pan",
                "pa"
            ],
            [
                "per",
                "fa"
            ],
            [
                "pli",
                "pi"
            ],
            [
                "pol",
                "pl"
            ],
            [
                "por",
                "pt"
            ],
            [
                "pus",
                "ps"
            ],
            [
                "que",
                "qu"
            ],
            [
                "roh",
                "rm"
            ],
            [
                "ron",
                "ro"
            ],
            [
                "rum",
                "ro"
            ],
            [
                "run",
                "rn"
            ],
            [
                "rus",
                "ru"
            ],
            [
                "sag",
                "sg"
            ],
            [
                "san",
                "sa"
            ],
            [
                "sin",
                "si"
            ],
            [
                "slk",
                "sk"
            ],
            [
                "slo",
                "sk"
            ],
            [
                "slv",
                "sl"
            ],
            [
                "sme",
                "se"
            ],
            [
                "smo",
                "sm"
            ],
            [
                "sna",
                "sn"
            ],
            [
                "snd",
                "sd"
            ],
            [
                "som",
                "so"
            ],
            [
                "sot",
                "st"
            ],
            [
                "spa",
                "es"
            ],
            [
                "sqi",
                "sq"
            ],
            [
                "srd",
                "sc"
            ],
            [
                "srp",
                "sr"
            ],
            [
                "ssw",
                "ss"
            ],
            [
                "sun",
                "su"
            ],
            [
                "swa",
                "sw"
            ],
            [
                "swe",
                "sv"
            ],
            [
                "tah",
                "ty"
            ],
            [
                "tam",
                "ta"
            ],
            [
                "tat",
                "tt"
            ],
            [
                "tel",
                "te"
            ],
            [
                "tgk",
                "tg"
            ],
            [
                "tgl",
                "tl"
            ],
            [
                "tha",
                "th"
            ],
            [
                "tib",
                "bo"
            ],
            [
                "tir",
                "ti"
            ],
            [
                "ton",
                "to"
            ],
            [
                "tsn",
                "tn"
            ],
            [
                "tso",
                "ts"
            ],
            [
                "tuk",
                "tk"
            ],
            [
                "tur",
                "tr"
            ],
            [
                "twi",
                "tw"
            ],
            [
                "uig",
                "ug"
            ],
            [
                "ukr",
                "uk"
            ],
            [
                "urd",
                "ur"
            ],
            [
                "uzb",
                "uz"
            ],
            [
                "ven",
                "ve"
            ],
            [
                "vie",
                "vi"
            ],
            [
                "vol",
                "vo"
            ],
            [
                "wel",
                "cy"
            ],
            [
                "wln",
                "wa"
            ],
            [
                "wol",
                "wo"
            ],
            [
                "xho",
                "xh"
            ],
            [
                "yid",
                "yi"
            ],
            [
                "yor",
                "yo"
            ],
            [
                "zha",
                "za"
            ],
            [
                "zho",
                "zh"
            ],
            [
                "zul",
                "zu"
            ]
        ]);
        function Tc(a) {
            fb.call(this);
            this.j = Kc(a);
            this.i = new Map;
            this.g = new Set;
            this.h = new Map;
        }
        oa(Tc, fb);
        p = Tc.prototype;
        p.release = function() {
            fb.prototype.release.call(this);
        };
        p.Pi = function(a) {
            var b = this;
            this.g.clear();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())this.g.add(Kc(c.value));
            Uc(this);
            a = jb(this.g, function(d) {
                return !b.h.has(d);
            });
            a.length && this.dispatchEvent(new R("unknown-locales", (new Map).set("locales", a)));
            a = jb(this.g, function(d) {
                return b.h.has(d);
            });
            a = (new Map).set("locales", a.length ? a : [
                this.j
            ]);
            this.dispatchEvent(new R("locale-changed", a));
        };
        p.Ya = function(a, b, c) {
            a = Kc(a);
            c === void 0 && (c = Vc);
            var d = this.h.get(a) || new Map;
            b.forEach(function(e, f) {
                d.has(f) && c != Vc || d.set(f, e);
            });
            this.h.set(a, d);
            Uc(this);
            this.dispatchEvent(new R("locale-updated"));
            return this;
        };
        p.nm = function(a) {
            for(var b = u(a.keys()), c = b.next(); !c.done; c = b.next())c = c.value, a.set(c, this.resolve(c));
        };
        p.resolve = function(a) {
            var b = this.i.get(a);
            if (b) return b;
            a = (new Map).set("locales", Array.from(this.g)).set("missing", a);
            this.dispatchEvent(new R("unknown-localization", a));
            return "";
        };
        p.Ok = function() {
            return this.g;
        };
        function Uc(a) {
            for(var b = a.h, c = a.j, d = a.g, e = new Set, f = u(d), g = f.next(), h = {}; !g.done; h = {
                xe: void 0
            }, g = f.next()){
                h.xe = g.value;
                e.add(h.xe);
                e.add(Pc(h.xe));
                g = jb(b.keys(), function(l) {
                    return function(m) {
                        return Oc(m, l.xe);
                    };
                }(h));
                g.sort();
                g = u(g);
                for(var k = g.next(); !k.done; k = g.next())e.add(k.value);
                h = jb(b.keys(), function(l) {
                    return function(m) {
                        return Pc(m) == l.xe;
                    };
                }(h));
                h.sort();
                h = u(h);
                for(g = h.next(); !g.done; g = h.next())e.add(g.value);
            }
            e.add(c);
            c = [];
            e = u(e);
            for(f = e.next(); !f.done; f = e.next())(f = b.get(f.value)) && c.push(f);
            c.reverse();
            a.i.clear();
            b = u(c);
            for(e = b.next(); !e.done; e = b.next())e.value.forEach(function(l, m) {
                a.i.set(m, l);
            });
            b = a.i.keys();
            e = new Set;
            c = u(a.g);
            for(f = c.next(); !f.done; f = c.next())f = a.h.get(f.value) || new Map, Wc(f, b, e);
            e.size > 0 && (d = (new Map).set("locales", Array.from(d)).set("missing", Array.from(e)), a.dispatchEvent(new R("missing-localizations", d)));
        }
        function Wc(a, b, c) {
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())d = d.value, a.get(d) || c.add(d);
        }
        O("shaka.ui.Localization", Tc);
        Tc.prototype.getCurrentLocales = Tc.prototype.Ok;
        Tc.prototype.resolve = Tc.prototype.resolve;
        Tc.prototype.resolveDictionary = Tc.prototype.nm;
        Tc.prototype.insert = Tc.prototype.Ya;
        Tc.prototype.changeLocale = Tc.prototype.Pi;
        Tc.prototype.release = Tc.prototype.release;
        var Vc = 1;
        Tc.ConflictResolution = {
            USE_OLD: 0,
            USE_NEW: Vc
        };
        Tc.UNKNOWN_LOCALES = "unknown-locales";
        Tc.UNKNOWN_LOCALIZATION = "unknown-localization";
        Tc.MISSING_LOCALIZATIONS = "missing-localizations";
        Tc.LOCALE_CHANGED = "locale-changed";
        Tc.LOCALE_UPDATED = "locale-updated";
        function Xc(a) {
            this.i = Math.log(.5);
            this.g = Math.exp(this.i / a);
            this.j = this.h = 0;
        }
        Xc.prototype.sample = function(a, b) {
            var c = Math.pow(this.g, a);
            b = b * (1 - c) + c * this.h;
            isNaN(b) || (this.h = b, this.j += a);
        };
        function Yc(a) {
            return a.h / (1 - Math.pow(a.g, a.j));
        }
        function Zc() {
            this.h = new Xc(2);
            this.j = new Xc(5);
            this.g = 0;
            this.i = 128E3;
            this.l = 16E3;
        }
        Zc.prototype.configure = function(a) {
            this.i = a.minTotalBytes;
            this.l = a.minBytes;
            var b = this.h;
            b.g = Math.exp(b.i / a.fastHalfLife);
            b = this.j;
            b.g = Math.exp(b.i / a.slowHalfLife);
        };
        Zc.prototype.sample = function(a, b) {
            if (!(b < this.l)) {
                var c = 8E3 * b / a;
                a /= 1E3;
                this.g += b;
                this.h.sample(a, c);
                this.j.sample(a, c);
            }
        };
        Zc.prototype.getBandwidthEstimate = function(a) {
            return this.g < this.i ? a : Math.min(Yc(this.h), Yc(this.j));
        };
        function $c(a, b) {
            return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b) ? !0 : a === b;
        }
        function ad(a, b) {
            b = a.indexOf(b);
            b > -1 && a.splice(b, 1);
        }
        function bd(a, b, c) {
            c || (c = $c);
            if (a.length != b.length) return !1;
            b = b.slice();
            a = u(a);
            for(var d = a.next(), e = {}; !d.done; e = {
                lj: void 0
            }, d = a.next()){
                e.lj = d.value;
                d = b.findIndex(function(f) {
                    return function(g) {
                        return c(f.lj, g);
                    };
                }(e));
                if (d == -1) return !1;
                b[d] = b[b.length - 1];
                b.pop();
            }
            return b.length == 0;
        }
        function cd(a, b) {
            var c = [], d = [];
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())e = e.value, b(e) ? c.push(e) : d.push(e);
            return [
                c,
                d
            ];
        }
        function dd(a, b) {
            for(var c = 0, d = a.length; c < d;){
                var e = c + d >>> 1;
                b(a[e]) ? c = e + 1 : d = e;
            }
            return c;
        }
        function ed(a, b, c) {
            if (a === b) return !0;
            if (!a || !b) return a == b;
            c || (c = $c);
            if (a.length != b.length) return !1;
            for(var d = 0; d < a.length; d++)if (!c(a[d], b[d])) return !1;
            return !0;
        }
        function fd() {
            this.g = new eb;
        }
        p = fd.prototype;
        p.release = function() {
            this.Ta();
            this.g = null;
        };
        p.u = function(a, b, c, d) {
            this.g && (a = new gd(a, b, c, d), this.g.push(b, a));
        };
        p.ra = function(a, b, c, d) {
            function e(g) {
                f.Fa(a, b, e);
                c(g);
            }
            var f = this;
            this.u(a, b, e, d);
        };
        p.Fa = function(a, b, c) {
            if (this.g) {
                var d = this.g.get(b) || [];
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next())e = e.value, e.target != a || c != e.listener && c || (e.Fa(), this.g.remove(b, e));
            }
        };
        p.Ta = function() {
            if (this.g) {
                for(var a = [], b = u(this.g.g.values()), c = b.next(); !c.done; c = b.next())a.push.apply(a, G(c.value));
                a = u(a);
                for(b = a.next(); !b.done; b = a.next())b.value.Fa();
                this.g.g.clear();
            }
        };
        O("shaka.util.EventManager", fd);
        fd.prototype.removeAll = fd.prototype.Ta;
        fd.prototype.unlisten = fd.prototype.Fa;
        fd.prototype.listenOnce = fd.prototype.ra;
        fd.prototype.listen = fd.prototype.u;
        fd.prototype.release = fd.prototype.release;
        function gd(a, b, c, d) {
            this.target = a;
            this.type = b;
            this.listener = c;
            this.g = id(a, d);
            this.target.addEventListener(b, c, this.g);
        }
        gd.prototype.Fa = function() {
            this.target.removeEventListener(this.type, this.listener, this.g);
            this.listener = this.target = null;
            this.g = !1;
        };
        function id(a, b) {
            if (b == void 0) return !1;
            if (typeof b == "boolean") return b;
            var c = new Set([
                "passive",
                "capture"
            ]);
            Object.keys(b).filter(function(d) {
                return !c.has(d);
            });
            return jd(a) ? b : b.capture || !1;
        }
        function jd(a) {
            var b = kd;
            if (b == void 0) {
                b = !1;
                try {
                    var c = {}, d = {
                        get: function() {
                            b = !0;
                            return !1;
                        }
                    };
                    Object.defineProperty(c, "passive", d);
                    Object.defineProperty(c, "capture", d);
                    d = function() {};
                    a.addEventListener("test", d, c);
                    a.removeEventListener("test", d, c);
                } catch (e) {
                    b = !1;
                }
                kd = b;
            }
            return b || !1;
        }
        var kd = void 0;
        O("shaka.config.AutoShowText", {
            NEVER: 0,
            ALWAYS: 1,
            IF_PREFERRED_TEXT_LANGUAGE: 2,
            IF_SUBTITLES_MAY_BE_NEEDED: 3
        });
        function ld(a, b) {
            this.g = a;
            this.h = b;
        }
        ld.prototype.toString = function() {
            return "v" + this.g + "." + this.h;
        };
        function md(a, b) {
            var c = new ld(5, 0), d = nd, e = d.g, f = c.h - e.h;
            ((c.g - e.g || f) > 0 ? d.i : d.h)(d.g, c, a, b);
        }
        function od(a, b, c, d) {
            Za([
                c,
                "has been deprecated and will be removed in",
                b,
                ". We are currently at version",
                a,
                ". Additional information:",
                d
            ].join(" "));
        }
        function pd(a, b, c, d) {
            Ya([
                c,
                "has been deprecated and has been removed in",
                b,
                ". We are now at version",
                a,
                ". Additional information:",
                d
            ].join(" "));
        }
        var nd = null;
        function sd(a, b, c, d) {
            this.g = null;
            this.l = a;
            this.i = b;
            this.m = c;
            this.o = d;
            this.j = !1;
            a: {
                typeof libDPIModule === "undefined" && Za("Could not find LCEVC Library dependencies on this page");
                if (typeof LCEVCdec !== "undefined") this.h = LCEVCdec;
                else if (typeof LcevcDil !== "undefined") this.h = LcevcDil, this.j = !0, md("LcevcDil", "lcevc_dil.js is deprecated, please use lcevc_dec.js instead");
                else {
                    Za("Could not find LCEVC Library on this page");
                    a = !1;
                    break a;
                }
                typeof this.h.SupportObject === "undefined" ? (Za("Could not find LCEVC Library on this page"), a = !1) : (this.h.SupportObject.SupportStatus || Za(this.h.SupportObject.SupportError), a = typeof this.h !== "undefined" && typeof libDPIModule !== "undefined" && this.i instanceof HTMLCanvasElement && this.h.SupportObject.SupportStatus);
            }
            a && !this.g && this.h.SupportObject.webGLSupport(this.i) && (this.i.classList.remove("shaka-hidden"), this.g = this.j ? new this.h.LcevcDil(this.l, this.i, this.m) : new this.h.LCEVCdec(this.l, this.i, this.m));
        }
        function td(a, b, c, d) {
            d.type !== "video" || a.o && !d.baseOriginalId || a.g && a.g.appendBuffer(b, "video", d.id, -c, !a.o);
        }
        function ud(a) {
            a.g && a.i.classList.add("shaka-hidden");
        }
        sd.prototype.release = function() {
            this.g && (this.g.close(), this.g = null);
        };
        function vd(a) {
            return a && typeof LCEVCdec !== "undefined" ? a.codecs == "lvc1" : !1;
        }
        O("shaka.lcevc.Dec", sd);
        sd.prototype.release = sd.prototype.release;
        function wd() {}
        function xd(a, b) {
            yd.set(a, b);
        }
        function zd() {
            var a = {};
            Xb();
            if (Ad()) for(var b = u(yd.keys()), c = b.next(); !c.done; c = b.next())a[c.value] = !0;
            b = u([
                "application/dash+xml",
                "application/x-mpegurl",
                "application/vnd.apple.mpegurl",
                "audio/x-mpegurl",
                "application/vnd.ms-sstr+xml"
            ]);
            for(c = b.next(); !c.done; c = b.next())c = c.value, a[c] = Ad() ? yd.has(c) : Bd().canPlayType(c) != "";
            return a;
        }
        function Cd(a, b) {
            if (b) {
                var c = yd.get(b);
                if (c) return c;
            }
            throw new T(2, 4, 4E3, a, b);
        }
        O("shaka.media.ManifestParser", wd);
        wd.unregisterParserByMime = function(a) {
            yd.delete(a);
        };
        wd.registerParserByMime = xd;
        wd.registerParserByExtension = function() {
            md("ManifestParser.registerParserByExtension", "Please use an ManifestParser with registerParserByMime function.");
        };
        wd.AccessibilityPurpose = {
            Rn: "visually impaired",
            an: "hard of hearing",
            An: "spoken subtitles"
        };
        var yd = new Map;
        function Dd() {}
        Dd.prototype.extract = function() {};
        Dd.prototype.decode = function() {
            return [];
        };
        Dd.prototype.clear = function() {};
        Dd.prototype.getStreams = function() {
            return [];
        };
        function Ed() {}
        Ed.prototype.init = function() {};
        Ed.prototype.parse = function() {
            return [];
        };
        function Fd(a) {
            this.h = new Map;
            this.i = 0;
            this.j = new Ed;
            if (a = Hd(a.toLowerCase())) this.j = a();
            this.g = new Dd;
            if (a = Id) this.g = a(), this.h.set(this.i, this.g);
        }
        Fd.prototype.init = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? -1 : c;
            if (c != -1 && this.i != c) {
                b = c;
                var d = this.h.get(b);
                this.h.set(this.i, this.g);
                if (d) this.g = d;
                else {
                    if (d = Id) this.g = d();
                    this.h.set(b, this.g);
                }
            } else b || this.g.clear();
            this.j.init(a);
            c != -1 && (this.i = c);
        };
        function Jd(a, b) {
            b = a.j.parse(b);
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = Fb(c.packet);
                d.length > 0 && a.g.extract(d, c.pts);
            }
            return a.g.decode();
        }
        Fd.prototype.remove = function(a) {
            a = a === void 0 ? [] : a;
            a = new Set(a);
            for(var b = u(this.h.keys()), c = b.next(); !c.done; c = b.next())if (c = c.value, !a.has(c)) {
                var d = this.h.get(c);
                d && d.clear();
                this.h.delete(c);
            }
        };
        function Kd(a, b) {
            Ld.set(a, b);
        }
        function Hd(a) {
            return Ld.get(a);
        }
        O("shaka.media.ClosedCaptionParser", Fd);
        Fd.findDecoder = function() {
            return Id;
        };
        Fd.unregisterDecoder = function() {
            Id = null;
        };
        Fd.registerDecoder = function(a) {
            Id = a;
        };
        Fd.findParser = Hd;
        Fd.unregisterParser = function(a) {
            Ld.delete(a);
        };
        Fd.registerParser = Kd;
        var Ld = new Map, Id = null;
        function Md() {
            this.id = "";
            this.regionAnchorY = this.regionAnchorX = this.viewportAnchorY = this.viewportAnchorX = 0;
            this.height = this.width = 100;
            this.viewportAnchorUnits = this.widthUnits = this.heightUnits = Nd;
            this.scroll = Od;
        }
        O("shaka.text.CueRegion", Md);
        var Nd = 1;
        Md.units = {
            PX: 0,
            PERCENTAGE: Nd,
            LINES: 2
        };
        var Od = "";
        Md.scrollMode = {
            NONE: Od,
            UP: "up"
        };
        function Pd(a) {
            this.h = a || "";
            this.g = 0;
        }
        function Qd(a) {
            Rd(a, /[ \t]+/gm);
        }
        function Rd(a, b) {
            b.lastIndex = a.g;
            b = b.exec(a.h);
            b = b == null ? null : {
                position: b.index,
                length: b[0].length,
                results: b
            };
            if (a.g == a.h.length || b == null || b.position != a.g) return null;
            a.g += b.length;
            return b.results;
        }
        function Sd(a) {
            return a.g == a.h.length ? null : (a = Rd(a, /[^ \t\n]*/gm)) ? a[0] : null;
        }
        function Td(a) {
            a = Rd(a, Ud);
            if (a == null) return null;
            var b = Number(a[2]), c = Number(a[3]);
            return b > 59 || c > 59 ? null : (Number(a[6]) || 0) / 1E3 + c + b * 60 + (Number(a[1]) || 0) * 3600;
        }
        function Vd(a) {
            return a ? Td(new Pd(a)) : null;
        }
        var Ud = /(?:(\d{1,}):)?(\d{2}):(\d{2})((\.(\d{1,3})))?/g;
        function Wd() {}
        function Xd(a) {
            function b(d) {
                switch(typeof d){
                    case "undefined":
                    case "boolean":
                    case "number":
                    case "string":
                    case "symbol":
                    case "function":
                        return d;
                    default:
                        if (!d || ArrayBuffer.isView(d)) return d;
                        if (c.has(d)) return null;
                        var e = Array.isArray(d);
                        if (d.constructor != Object && !e) return null;
                        c.add(d);
                        var f = e ? [] : {}, g;
                        for(g in d)f[g] = b(d[g]);
                        e && (f.length = d.length);
                        return f;
                }
            }
            var c = new WeakSet;
            return b(a);
        }
        function Yd(a) {
            var b = {}, c;
            for(c in a)b[c] = a[c];
            return b;
        }
        function Zd(a) {
            if (Array.isArray(a)) {
                for(var b = [], c = 0; c < a.length; c++){
                    var d = c.toString(), e = a[c];
                    e !== void 0 && (e = Zd(e)) && b.push(d + ":" + e);
                }
                a = "[" + b.join(",") + "]";
            } else if (typeof a == "function") a = "";
            else if (a instanceof Object) {
                c = Object.keys(a);
                c.sort();
                b = [];
                c = u(c);
                for(d = c.next(); !d.done; d = c.next())e = d.value, d = JSON.stringify(e), e = a[e], e !== void 0 && (e = Zd(e)) && b.push(d + ":" + e);
                a = "{" + b.join(",") + "}";
            } else a = JSON.stringify(a);
            return a;
        }
        O("shaka.util.ObjectUtils", Wd);
        Wd.alphabeticalKeyOrderStringify = Zd;
        Wd.shallowCloneObject = Yd;
        Wd.cloneObject = Xd; /*
 @license
 tXml
 Copyright 2015 Tobias Nickel
 SPDX-License-Identifier: MIT
*/ 
        function $d(a, b) {
            var c = c === void 0 ? !1 : c;
            a = ec(a);
            return ae(a, b, c);
        }
        function ae(a, b, c) {
            a = be(a, c === void 0 ? !1 : c);
            if (!b && a.length) return a[0];
            var d = b.split(",");
            return (b = a.find(function(e) {
                return d.includes(e.tagName);
            })) ? b : null;
        }
        function ce(a) {
            return de.has(a) ? de.get(a) : "";
        }
        function be(a, b) {
            function c(g, h) {
                h = h === void 0 ? !1 : h;
                for(var k = []; a[e];)if (a.charCodeAt(e) == 60) {
                    if (a.charCodeAt(e + 1) === 47) {
                        h = e + 2;
                        e = a.indexOf(">", e);
                        h = a.substring(h, e);
                        var l = h.indexOf(g);
                        if (l == -1) {
                            var m = g.indexOf(".");
                            m > 0 && (l = h.indexOf(g.substring(0, m)));
                        }
                        if (l == -1) throw g = a.substring(0, e).split("\n"), Error("Unexpected close tag\nLine: " + (g.length - 1) + "\nColumn: " + (g[g.length - 1].length + 1) + "\nChar: " + a[e]);
                        e + 1 && (e += 1);
                        break;
                    } else if (a.charCodeAt(e + 1) === 33) {
                        if (a.charCodeAt(e + 2) == 45) {
                            for(; e !== -1 && (a.charCodeAt(e) !== 62 || a.charCodeAt(e - 1) != 45 || a.charCodeAt(e - 2) != 45 || e == -1);)e = a.indexOf(">", e + 1);
                            e === -1 && (e = a.length);
                        } else if (a.charCodeAt(e + 2) === 91 && a.charCodeAt(e + 8) === 91 && a.substr(e + 3, 5).toLowerCase() === "cdata") {
                            l = a.indexOf("]]\x3e", e);
                            l == -1 ? (k.push(a.substr(e + 9)), e = a.length) : (k.push(a.substring(e + 9, l)), e = l + 3);
                            continue;
                        }
                        e++;
                        continue;
                    }
                    if (f > 512) throw Error("XML is too deeply nested");
                    f++;
                    a: {
                        m = h;
                        e++;
                        var n = d(), q = {};
                        for(l = []; a.charCodeAt(e) !== 62 && a[e];){
                            var r = a.charCodeAt(e);
                            if (r > 64 && r < 91 || r > 96 && r < 123) {
                                r = d();
                                for(var t = a.charCodeAt(e); t && t !== 39 && t !== 34 && !(t > 64 && t < 91 || t > 96 && t < 123) && t !== 62;)e++, t = a.charCodeAt(e);
                                var v = e + 1;
                                e = a.indexOf(a[e], v);
                                v = (" " + a.slice(v, e)).slice(1);
                                if (t === 39 || t === 34) {
                                    if (e === -1) {
                                        m = {
                                            tagName: n,
                                            attributes: q,
                                            children: l,
                                            parent: null
                                        };
                                        if (b) for(n = 0; n < l.length; n++)typeof l[n] !== "string" && (l[n].parent = m);
                                        l = m;
                                        break a;
                                    }
                                } else v = null, e--;
                                if (r.startsWith("xmlns:")) {
                                    t = v;
                                    var w = r.split(":")[1];
                                    de.set(t, w);
                                    ee.set(w, t);
                                }
                                n === "tt" && r === "xml:space" && v === "preserve" && (m = !0);
                                q[r] = v;
                            }
                            e++;
                        }
                        a.charCodeAt(e - 1) !== 47 ? (e++, l = c(n, m)) : e++;
                        m = {
                            tagName: n,
                            attributes: q,
                            children: l,
                            parent: null
                        };
                        n = l.length;
                        for(q = 0; q < n; q++)r = l[q], typeof r !== "string" ? b && (r.parent = m) : q == n - 1 && r == "\n" && l.pop();
                        l = m;
                    }
                    f--;
                    k.push(l);
                    if (typeof l === "string") break;
                    l.tagName[0] === "?" && l.children && (k.push.apply(k, G(l.children)), l.children = []);
                } else l = e, e = a.indexOf("<", e) - 1, e === -2 && (e = a.length), l = (" " + a.slice(l, e + 1)).slice(1), h ? l.length > 0 && k.push(l) : k.length && l.length == 1 && l[0] == "\n" ? k.push(l) : l.trim().length > 0 && k.push(l), e++;
                return k;
            }
            function d() {
                for(var g = e; "\r\n\t>/= ".indexOf(a[e]) === -1 && a[e];)e++;
                return (" " + a.slice(g, e)).slice(1);
            }
            var e = 0, f = 0;
            return c("");
        }
        function fe(a) {
            return typeof a === "string";
        }
        function ge(a) {
            var b = [];
            if (!a.children) return [];
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c !== "string" && b.push(c);
            return b;
        }
        function ie(a, b) {
            var c = [];
            if (!a.children) return [];
            a = u(a.children);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.tagName === b && c.push(d);
            return c;
        }
        function ke(a) {
            if (typeof a === "string") return jc(a);
            var b = [];
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c === "string" && b.push(c);
            b = b.join("");
            return b === "" ? null : jc(b);
        }
        function le(a) {
            for(var b = u(a.children), c = b.next(); !c.done; c = b.next())if (typeof c.value !== "string") return null;
            (a = ke(a)) && (a = a.trim());
            return a;
        }
        function me(a, b, c) {
            c = c === void 0 ? [] : c;
            a.tagName === b && c.push(a);
            if (a.children) {
                a = u(a.children);
                for(var d = a.next(); !d.done; d = a.next())me(d.value, b, c);
            }
            return c;
        }
        function ne(a, b) {
            a = ie(a, b);
            return a.length != 1 ? null : a[0];
        }
        function oe(a, b, c) {
            a = pe(a, b, c);
            return a.length != 1 ? null : a[0];
        }
        function qe(a, b, c, d) {
            d = d === void 0 ? null : d;
            var e = null;
            a = a.attributes[b];
            a == null || a === "" && d !== null || (e = c(a));
            return e == null ? d : e;
        }
        function re(a, b, c) {
            b = ce(b);
            return a.attributes[b + ":" + c] || null;
        }
        function pe(a, b, c) {
            var d = ce(b);
            b = [];
            if (a.children) for(c = d ? d + ":" + c : c, a = u(a.children), d = a.next(); !d.done; d = a.next())(d = d.value) && d.tagName === c && b.push(d);
            return b;
        }
        function se(a, b, c) {
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())if (d = re(a, d.value, c)) return d;
            return null;
        }
        function te(a) {
            if (!a) return null;
            /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(a) && (a += "Z");
            a = Date.parse(a);
            return isNaN(a) ? null : a / 1E3;
        }
        function ue(a) {
            if (!a) return null;
            a = RegExp("^P(?:([0-9]*)Y)?(?:([0-9]*)M)?(?:([0-9]*)D)?(?:T(?:([0-9]*)H)?(?:([0-9]*)M)?(?:([0-9.]*)S)?)?$", "i").exec(a);
            if (!a) return null;
            a = 31536E3 * Number(a[1] || null) + 2592E3 * Number(a[2] || null) + 86400 * Number(a[3] || null) + 3600 * Number(a[4] || null) + 60 * Number(a[5] || null) + Number(a[6] || null);
            return isFinite(a) ? a : null;
        }
        function ve(a) {
            var b = /([0-9]+)-([0-9]+)/.exec(a);
            if (!b) return null;
            a = Number(b[1]);
            if (!isFinite(a)) return null;
            b = Number(b[2]);
            return isFinite(b) ? {
                start: a,
                end: b
            } : null;
        }
        function we(a) {
            a = Number(a);
            return a % 1 === 0 ? a : null;
        }
        function xe(a) {
            a = Number(a);
            return a % 1 === 0 && a > 0 ? a : null;
        }
        function ye(a) {
            a = Number(a);
            return a % 1 === 0 && a >= 0 ? a : null;
        }
        function ze(a) {
            a = Number(a);
            return isNaN(a) ? null : a;
        }
        function Ae(a) {
            return a ? a.toLowerCase() === "true" : !1;
        }
        function Be(a) {
            var b;
            var c = (b = a.match(/^(\d+)\/(\d+)$/)) ? Number(b[1]) / Number(b[2]) : Number(a);
            return isNaN(c) ? null : c;
        }
        function Ce(a) {
            var b = [];
            a = jc(a).split(/\/+(?=(?:[^'"]*['"][^'"]*['"])*[^'"]*$)/);
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = c.match(/^([\w]+)/);
                if (d) {
                    var e = c.match(/(@id='(.*?)')/), f = c.match(/(@t='(\d+)')/), g = c.match(/(@n='(\d+)')/), h = c.match(/\[(\d+)\]/);
                    b.push({
                        name: d[0],
                        id: e ? e[0].match(/'(.*?)'/)[0].replace(/'/gm, "") : null,
                        t: f ? Number(f[0].match(/'(.*?)'/)[0].replace(/'/gm, "")) : null,
                        n: g ? Number(g[0].match(/'(.*?)'/)[0].replace(/'/gm, "")) : null,
                        position: h ? Number(h[1]) - 1 : null,
                        Kc: c.split("/@")[1] || null
                    });
                } else c.startsWith("@") && b.length && (b[b.length - 1].Kc = c.slice(1));
            }
            return b;
        }
        function De(a, b) {
            var c = Ce(b.attributes.sel || "");
            if (c.length) {
                var d = c[c.length - 1], e = b.attributes.pos || null;
                c = d.position;
                c == null && (d.t !== null && (c = Ee(a, "t", d.t)), d.n !== null && (c = Ee(a, "n", d.n)));
                c === null ? c = e === "prepend" ? 0 : a.length : e === "prepend" ? --c : e === "after" && ++c;
                e = b.tagName;
                (d = d.Kc) && a[c] ? Fe(a[c], e, d, le(b) || "") : (e !== "remove" && e !== "replace" || a.splice(c, 1), e !== "add" && e !== "replace" || a.splice.apply(a, [
                    c,
                    0
                ].concat(G(b.children))));
            }
        }
        function Ee(a, b, c) {
            var d = 0;
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next()){
                if (Number(e.value.attributes[b]) === c) return d;
                d++;
            }
            return null;
        }
        function Fe(a, b, c, d) {
            if (b === "remove") delete a.attributes[c];
            else if (b === "add" || b === "replace") a.attributes[c] = d;
        }
        function Ge(a) {
            var b = "", c = a.tagName.split(":");
            c.length > 0 && (b = c[0], b = ee.has(b) ? ee.get(b) : "");
            b = document.createElementNS(b, a.tagName);
            for(var d in a.attributes)b.setAttribute(d, a.attributes[d]);
            a = u(a.children);
            for(d = a.next(); !d.done; d = a.next())d = d.value, c = void 0, typeof d == "string" ? c = new Text(d) : c = Ge(d), b.appendChild(c);
            return b;
        }
        function He(a) {
            if (!a) return null;
            var b = {
                tagName: a.tagName,
                attributes: Yd(a.attributes),
                children: [],
                parent: null
            };
            a = u(a.children);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, typeof c === "string" ? b.children.push(c) : (c = He(c), c.parent = b, b.children.push(c));
            return b;
        }
        var de = new Map, ee = new Map;
        function Ie(a, b, c) {
            this.startTime = a;
            this.endTime = b;
            this.payload = c;
            this.region = new Md;
            this.position = null;
            this.positionAlign = Je;
            this.size = 0;
            this.textAlign = Ke;
            this.direction = Le;
            this.writingMode = Me;
            this.lineInterpretation = Ne;
            this.line = null;
            this.lineHeight = "";
            this.lineAlign = Oe;
            this.displayAlign = Re;
            this.fontSize = this.border = this.backgroundImage = this.backgroundColor = this.color = "";
            this.fontWeight = Se;
            this.fontStyle = Te;
            this.linePadding = this.letterSpacing = this.fontFamily = "";
            this.opacity = 1;
            this.textCombineUpright = "";
            this.textDecoration = [];
            this.textStrokeWidth = this.textStrokeColor = this.textShadow = "";
            this.wrapLine = !0;
            this.id = "";
            this.nestedCues = [];
            this.lineBreak = this.isContainer = !1;
            this.rubyTag = null;
            this.cellResolution = {
                columns: 32,
                rows: 15
            };
        }
        function Ue(a, b) {
            a = new Ie(a, b, "");
            a.lineBreak = !0;
            return a;
        }
        Ie.prototype.clone = function() {
            var a = new Ie(0, 0, ""), b;
            for(b in this)a[b] = this[b], Array.isArray(a[b]) && (a[b] = a[b].slice());
            return a;
        };
        function Ve(a, b) {
            if (a.payload != b.payload || !(Math.abs(a.startTime - b.startTime) < .001 && Math.abs(a.endTime - b.endTime) < .001)) return !1;
            for(var c in a)if (c != "startTime" && c != "endTime" && c != "payload") {
                if (c == "nestedCues") {
                    if (!ed(a.nestedCues, b.nestedCues, Ve)) return !1;
                } else if (c == "region" || c == "cellResolution") for(var d in a[c]){
                    if (a[c][d] != b[c][d]) return !1;
                }
                else if (Array.isArray(a[c])) {
                    if (!ed(a[c], b[c])) return !1;
                } else if (a[c] != b[c]) return !1;
            }
            return !0;
        }
        function We(a, b) {
            b = b === void 0 ? new Map : b;
            var c = a.payload;
            if (c.includes("<")) {
                b.size === 0 && Xe(b);
                var d = c;
                c = [];
                for(var e = -1, f = 0; f < d.length; f++)d[f] === "<" ? e = f + 1 : d[f] === ">" && e > 0 && (e = d.substr(e, f - e), e.match(Ye) && c.push(e), e = -1);
                c = u(c);
                for(f = c.next(); !f.done; f = c.next())f = f.value, d = d.replace("<" + f + ">", '<div time="' + f + '">'), d += "</div>";
                a: {
                    f = d;
                    e = [];
                    var g = -1;
                    c = "";
                    d = !1;
                    for(var h = 0; h < f.length; h++)if (f[h] === "/") {
                        var k = f.indexOf(">", h);
                        if (k === -1) {
                            c = f;
                            break a;
                        }
                        if ((k = f.substring(h + 1, k)) && k == "v") {
                            d = !0;
                            var l = null;
                            e.length && (l = e[e.length - 1]);
                            if (l) {
                                if (l === k) c += "/" + k + ">";
                                else {
                                    if (!l.startsWith("v")) {
                                        c += f[h];
                                        continue;
                                    }
                                    c += "/" + l + ">";
                                }
                                h += k.length + 1;
                            } else c += f[h];
                        } else c += f[h];
                    } else f[h] === "<" ? (g = h + 1, f[g] != "v" && (g = -1)) : f[h] === ">" && g > 0 && (e.push(f.substr(g, h - g)), g = -1), c += f[h];
                    f = u(e);
                    for(e = f.next(); !e.done; e = f.next())e = e.value, g = e.replace(" ", ".voice-"), c = c.replace("<" + e + ">", "<" + g + ">"), c = c.replace("</" + e + ">", "</" + g + ">"), d || (c += "</" + g + ">");
                }
                c = Ze(c);
                a.payload = "";
                d = "<span>" + c.replace(/\n/g, "<br />") + "</span>";
                try {
                    var m = ae(d, "span");
                } catch (n) {}
                if (m) {
                    if (m = m.children, m.length != 1 || m[0].tagName) for(m = u(m), c = m.next(); !c.done; c = m.next())$e(c.value, a, b);
                    else a.payload = jc(c);
                } else a.payload = jc(c);
            } else a.payload = jc(c);
        }
        function Xe(a) {
            for(var b = u(Object.entries(af)), c = b.next(); !c.done; c = b.next()){
                var d = u(c.value);
                c = d.next().value;
                d = d.next().value;
                var e = new Ie(0, 0, "");
                e.color = d;
                a.set("." + c, e);
            }
            b = u(Object.entries(bf));
            for(c = b.next(); !c.done; c = b.next())d = u(c.value), c = d.next().value, d = d.next().value, e = new Ie(0, 0, ""), e.backgroundColor = d, a.set("." + c, e);
        }
        function Ze(a) {
            var b = {
                "< ": "",
                " >": " &gt;"
            }, c = /(< +>|<\s|\s>)/g, d = RegExp(c.source);
            return a && d.test(a) ? a.replace(c, function(e) {
                return b[e] || "";
            }) : a || "";
        }
        function $e(a, b, c) {
            var d = b.clone();
            d.nestedCues = [];
            d.payload = "";
            d.rubyTag = "";
            d.line = null;
            d.region = new Md;
            d.position = null;
            d.size = 0;
            d.textAlign = Ke;
            if (a.tagName) for(var e = u(a.tagName.split(/(?=[ .])+/g)), f = e.next(); !f.done; f = e.next()){
                var g = f = f.value;
                if (g.startsWith(".voice-")) {
                    var h = g.split("-").pop();
                    g = 'v[voice="' + h + '"]';
                    c.has(g) || (g = "v[voice=" + h + "]");
                }
                c.has(g) && (h = d, g = c.get(g)) && (h.backgroundColor = cf(g.backgroundColor, h.backgroundColor), h.color = cf(g.color, h.color), h.fontFamily = cf(g.fontFamily, h.fontFamily), h.fontSize = cf(g.fontSize, h.fontSize), h.textShadow = cf(g.textShadow, h.textShadow), h.fontWeight = g.fontWeight, h.fontStyle = g.fontStyle, h.opacity = g.opacity, h.rubyTag = g.rubyTag, h.textCombineUpright = g.textCombineUpright, h.wrapLine = g.wrapLine);
                switch(f){
                    case "br":
                        d = Ue(d.startTime, d.endTime);
                        b.nestedCues.push(d);
                        return;
                    case "b":
                        d.fontWeight = df;
                        break;
                    case "i":
                        d.fontStyle = ef;
                        break;
                    case "u":
                        d.textDecoration.push(ff);
                        break;
                    case "font":
                        if (f = a.attributes.color) d.color = f;
                        break;
                    case "div":
                        f = a.attributes.time;
                        if (!f) break;
                        if (f = Vd(f)) d.startTime = f;
                        break;
                    case "ruby":
                    case "rp":
                    case "rt":
                        d.rubyTag = f;
                }
            }
            e = a.children;
            if (fe(a) || e.length == 1 && fe(e[0])) for(c = ke(a).split("\n"), a = !0, c = u(c), e = c.next(); !e.done; e = c.next())e = e.value, a || (a = Ue(d.startTime, d.endTime), b.nestedCues.push(a)), e.length > 0 && (a = d.clone(), a.payload = jc(e), b.nestedCues.push(a)), a = !1;
            else for(b.nestedCues.push(d), b = u(e), a = b.next(); !a.done; a = b.next())$e(a.value, d, c);
        }
        function cf(a, b) {
            return a && a.length > 0 ? a : b;
        }
        O("shaka.text.Cue", Ie);
        Ie.parseCuePayload = We;
        Ie.equal = Ve;
        Ie.prototype.clone = Ie.prototype.clone;
        var Je = "auto";
        Ie.positionAlign = {
            LEFT: "line-left",
            RIGHT: "line-right",
            CENTER: "center",
            AUTO: Je
        };
        var Ke = "center", gf = {
            LEFT: "left",
            RIGHT: "right",
            CENTER: Ke,
            START: "start",
            END: "end"
        };
        Ie.textAlign = gf;
        var Re = "after", hf = {
            BEFORE: "before",
            CENTER: "center",
            AFTER: Re
        };
        Ie.displayAlign = hf;
        var Le = "ltr";
        Ie.direction = {
            HORIZONTAL_LEFT_TO_RIGHT: Le,
            HORIZONTAL_RIGHT_TO_LEFT: "rtl"
        };
        var Me = "horizontal-tb";
        Ie.writingMode = {
            HORIZONTAL_TOP_TO_BOTTOM: Me,
            VERTICAL_LEFT_TO_RIGHT: "vertical-lr",
            VERTICAL_RIGHT_TO_LEFT: "vertical-rl"
        };
        var Ne = 0;
        Ie.lineInterpretation = {
            LINE_NUMBER: Ne,
            PERCENTAGE: 1
        };
        var Oe = "start", jf = {
            CENTER: "center",
            START: Oe,
            END: "end"
        };
        Ie.lineAlign = jf;
        var af = {
            white: "white",
            lime: "lime",
            cyan: "cyan",
            red: "red",
            yellow: "yellow",
            magenta: "magenta",
            blue: "blue",
            black: "black"
        };
        Ie.defaultTextColor = af;
        var bf = {
            bg_white: "white",
            bg_lime: "lime",
            bg_cyan: "cyan",
            bg_red: "red",
            bg_yellow: "yellow",
            bg_magenta: "magenta",
            bg_blue: "blue",
            bg_black: "black"
        };
        Ie.defaultTextBackgroundColor = bf;
        var Se = 400, df = 700;
        Ie.fontWeight = {
            NORMAL: Se,
            BOLD: df
        };
        var Te = "normal", ef = "italic", kf = {
            NORMAL: Te,
            ITALIC: ef,
            OBLIQUE: "oblique"
        };
        Ie.fontStyle = kf;
        var ff = "underline";
        Ie.textDecoration = {
            UNDERLINE: ff,
            LINE_THROUGH: "line-through",
            OVERLINE: "overline"
        };
        var Ye = /(?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{2,3})/g;
        function lf() {}
        lf.prototype.destroy = function() {};
        function mf(a, b, c) {
            nf.set(a.toLowerCase().split(";")[0] + "-" + c, {
                priority: c,
                Vf: b
            });
        }
        function of(a, b) {
            for(var c = a.toLowerCase().split(";")[0], d = u([
                pf,
                qf,
                rf,
                uf
            ]), e = d.next(); !e.done; e = d.next())if (e = nf.get(c + "-" + e.value)) {
                var f = e.Vf(), g = f.isSupported(a, b);
                f.destroy();
                if (g) return e.Vf;
            }
            return null;
        }
        O("shaka.transmuxer.TransmuxerEngine", lf);
        lf.findTransmuxer = of;
        lf.unregisterTransmuxer = function(a, b) {
            nf.delete(a.toLowerCase().split(";")[0] + "-" + b);
        };
        lf.registerTransmuxer = mf;
        lf.prototype.destroy = lf.prototype.destroy;
        var nf = new Map, uf = 1, rf = 2, qf = 3, pf = 4;
        lf.PluginPriority = {
            FALLBACK: uf,
            PREFERRED_SECONDARY: rf,
            PREFERRED: qf,
            APPLICATION: pf
        };
        function vf() {}
        function wf(a, b) {
            var c = a;
            b && !yf.includes(a) && (c += '; codecs="' + b + '"');
            return c;
        }
        function zf(a, b) {
            b && (a += '; codecs="' + b + '"');
            return a;
        }
        function Af(a, b, c) {
            var d = wf(a, b);
            b = zf(a, b);
            of(b) ? (a = of(b)) ? (a = a(), c = a.convertCodecs(c, b), a.destroy()) : c = b : c = a != "video/mp2t" && c == "audio" ? d.replace("video", "audio") : d;
            return c;
        }
        function Bf(a) {
            return a.split(";")[0].split("/")[1];
        }
        function Cf(a) {
            var b = Df(a);
            a = b[0].toLowerCase();
            b = b[1].toLowerCase();
            switch(!0){
                case a === "mp4a" && b === "69":
                case a === "mp4a" && b === "6b":
                case a === "mp4a" && b === "40.34":
                    return "mp3";
                case a === "mp4a" && b === "66":
                case a === "mp4a" && b === "67":
                case a === "mp4a" && b === "68":
                case a === "mp4a" && b === "40.2":
                case a === "mp4a" && b === "40.02":
                case a === "mp4a" && b === "40.5":
                case a === "mp4a" && b === "40.05":
                case a === "mp4a" && b === "40.29":
                case a === "mp4a" && b === "40.42":
                    return "aac";
                case a === "mp4a" && b === "a5":
                case a === "ac3":
                case a === "ac-3":
                    return "ac-3";
                case a === "mp4a" && b === "a6":
                case a === "eac3":
                case a === "ec-3":
                    return "ec-3";
                case a === "ac-4":
                    return "ac-4";
                case a === "mp4a" && b === "b2":
                    return "dtsx";
                case a === "mp4a" && b === "a9":
                    return "dtsc";
                case a === "vp09":
                case a === "vp9":
                    return "vp9";
                case a === "avc1":
                case a === "avc3":
                    return "avc";
                case a === "hvc1":
                case a === "hev1":
                    return "hevc";
                case a === "vvc1":
                case a === "vvi1":
                    return "vvc";
                case a === "dvh1":
                case a === "dvhe":
                    return b && b.startsWith("05") ? "dovi-p5" : "dovi-hevc";
                case a === "dvav":
                case a === "dva1":
                    return "dovi-avc";
                case a === "dav1":
                    return "dovi-av1";
                case a === "dvc1":
                case a === "dvi1":
                    return "dovi-vvc";
                case a === "lvc1":
                    return "lcevc";
            }
            return a;
        }
        function Ef(a) {
            var b = [];
            a = u(a.split(","));
            for(var c = a.next(); !c.done; c = a.next())c = Df(c.value), b.push(c[0]);
            return b.sort().join(",");
        }
        function Ff(a) {
            return a.split(";")[0];
        }
        function Gf(a) {
            a = a.split(/ *; */);
            a.shift();
            return (a = a.find(function(b) {
                return b.startsWith("codecs=");
            })) ? a.split("=")[1].replace(/^"|"$/g, "") : "";
        }
        function Hf(a) {
            return a === "application/x-mpegurl" || a === "application/vnd.apple.mpegurl" || a === "audio/x-mpegurl";
        }
        function Df(a) {
            a = a.split(".");
            var b = a[0];
            a.shift();
            return [
                b,
                a.join(".")
            ];
        }
        O("shaka.util.MimeUtils", vf);
        vf.getFullTypeWithAllCodecs = zf;
        vf.getFullType = wf;
        (new Map).set("codecs", "codecs").set("frameRate", "framerate").set("bandwidth", "bitrate").set("width", "width").set("height", "height").set("channelsCount", "channels");
        var yf = [
            "audio/aac",
            "audio/ac3",
            "audio/ec3",
            "audio/mpeg"
        ];
        function If(a) {
            this.i = null;
            this.l = a;
            this.C = this.G = !1;
            this.m = this.A = 0;
            this.o = Infinity;
            this.h = this.g = null;
            this.F = "";
            this.D = function() {};
            this.j = new Map;
        }
        function Jf(a, b) {
            Kf.set(a, b);
        }
        function Lf(a) {
            return Kf.get(a);
        }
        function Mf(a) {
            return Kf.has(a) ? !0 : a == "application/cea-608" || a == "application/cea-708" ? !!Id : !1;
        }
        If.prototype.destroy = function() {
            this.l = this.i = null;
            this.j.clear();
            return Promise.resolve();
        };
        function Nf(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q;
            return H(function(r) {
                if (r.h == 1) return r.g(Promise.resolve(), 2);
                if (!a.i || !a.l) return r.return();
                if (c == null || d == null) return a.i.parseInit(Fb(b)), r.return();
                f = a.C ? 0 : a.A;
                g = a.G || a.C ? c : a.A;
                h = {
                    periodStart: f,
                    segmentStart: c,
                    segmentEnd: d,
                    vttOffset: g
                };
                k = a.i.parseMedia(Fb(b), h, e, []);
                l = u(k);
                for(m = l.next(); !m.done; m = l.next())n = m.value, a.D(n, e || null, h);
                q = k.filter(function(t) {
                    return t.startTime >= a.m && t.startTime < a.o;
                });
                a.l.append(q);
                a.g == null && (a.g = Math.max(c, a.m));
                a.h = Math.min(d, a.o);
                r.j();
            });
        }
        If.prototype.remove = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            var d = this;
            return H(function(e) {
                if (e.h == 1) return e.g(Promise.resolve(), 2);
                if (a >= b || c && (Of(d, a, b), d.F === "")) return e.return();
                d.l && d.l.remove(a, b) && d.g != null && (b <= d.g || a >= d.h || (a <= d.g && b >= d.h ? d.g = d.h = null : a <= d.g && b < d.h ? d.g = b : a > d.g && b >= d.h && (d.h = a)), Pf(d));
                e.j();
            });
        };
        function Qf(a, b, c) {
            a.m = b;
            a.o = c;
        }
        function Rf(a, b, c) {
            a.F = b;
            if (b = a.j.get(b)) b = b.filter(function(d) {
                return d.endTime <= c;
            }), b.length && a.l.append(b);
        }
        function Sf(a, b, c) {
            b.startTime += c;
            b.endTime += c;
            b = u(b.nestedCues);
            for(var d = b.next(); !d.done; d = b.next())Sf(a, d.value, c);
        }
        function Tf(a, b, c) {
            var d = new Map;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                var f = e.value;
                e = f.stream;
                f = f.cue;
                d.has(e) || d.set(e, []);
                Sf(a, f, c);
                f.startTime >= a.m && f.startTime < a.o && (d.get(e).push(f), e == a.F && a.l.append([
                    f
                ]));
            }
            c = u(d.keys());
            for(b = c.next(); !b.done; b = c.next())for(b = b.value, a.j.has(b) || a.j.set(b, []), e = u(d.get(b)), f = e.next(); !f.done; f = e.next())f = f.value, a.j.get(b).push(f);
            Pf(a);
        }
        function Of(a, b, c) {
            for(var d = u(a.j.keys()), e = d.next(); !e.done; e = d.next()){
                e = e.value;
                var f = a.j.get(e);
                f = f.filter(function(g) {
                    return g.startTime < b || g.endTime >= c;
                });
                a.j.set(e, f);
            }
        }
        function Pf(a) {
            for(var b = Infinity, c = -Infinity, d = u(a.j.values()), e = d.next(); !e.done; e = d.next()){
                e = u(e.value);
                for(var f = e.next(); !f.done; f = e.next())f = f.value, b = Math.min(b, f.startTime), c = Math.max(c, f.endTime);
            }
            b !== Infinity && c !== -Infinity && (a.g = a.g == null ? Math.max(b, a.m) : Math.min(a.g, Math.max(b, a.m)), a.h = Math.max(a.h, Math.min(c, a.o)));
        }
        O("shaka.text.TextEngine", If);
        If.prototype.destroy = If.prototype.destroy;
        If.findParser = Lf;
        If.unregisterParser = function(a) {
            Kf.delete(a);
        };
        If.registerParser = Jf;
        var Kf = new Map;
        function Uf(a) {
            this.g = a;
            this.h = null;
        }
        Uf.prototype.La = function() {
            this.stop();
            this.g();
            return this;
        };
        Uf.prototype.Z = function(a) {
            var b = this;
            this.stop();
            Vf(this, function() {
                b.g();
            }, a);
            return this;
        };
        Uf.prototype.xa = function(a) {
            this.stop();
            Wf(this, a);
            return this;
        };
        Uf.prototype.stop = function() {
            var a;
            (a = this.h) == null || a.call(this);
            this.h = null;
        };
        function Vf(a, b, c) {
            var d = !0, e = null;
            a.h = function() {
                clearTimeout(e);
                d = !1;
            };
            e = setTimeout(function() {
                d && b();
            }, c * 1E3);
        }
        function Wf(a, b) {
            Vf(a, function() {
                Wf(a, b);
                a.g();
            }, b);
        }
        O("shaka.util.Timer", Uf);
        Uf.prototype.stop = Uf.prototype.stop;
        Uf.prototype.tickEvery = Uf.prototype.xa;
        Uf.prototype.tickAfter = Uf.prototype.Z;
        Uf.prototype.tickNow = Uf.prototype.La;
        function Xf(a, b) {
            return a.concat(b);
        }
        function Yf() {}
        function Zf(a) {
            return a != null;
        }
        function $f(a, b) {
            return Promise.race([
                b,
                new Promise(function(c, d) {
                    new Uf(d).Z(a);
                })
            ]);
        }
        function ag() {}
        function bg(a, b, c, d, e) {
            if (e.length) {
                var f = a.textStreams;
                e = u(e);
                for(var g = e.next(), h = {}; !g.done; h = {
                    xi: void 0
                }, g = e.next())if (h.xi = g.value, g = f.filter(function(t) {
                    return function(v) {
                        return v.codecs.startsWith(t.xi) || v.mimeType.startsWith(t.xi) ? !0 : !1;
                    };
                }(h)), g.length) {
                    f = g;
                    break;
                }
                a.textStreams = f;
            }
            f = a.variants;
            if (b.length || c.length) f = cg(f, b, c);
            if (d.length) {
                b = new eb;
                f = u(f);
                for(c = f.next(); !c.done; c = f.next())c = c.value, b.push(String(c.video.width || 0), c);
                var k = [];
                b.forEach(function(t, v) {
                    t = 0;
                    var w = [];
                    v = u(v);
                    for(var x = v.next(), y = {}; !x.done; y = {
                        yg: void 0
                    }, x = v.next())y.yg = x.value, x = d.filter(function(z) {
                        return function(A) {
                            return z.yg.decodingInfos[0][A];
                        };
                    }(y)).length, x > t ? (t = x, w = [
                        y.yg
                    ]) : x == t && w.push(y.yg);
                    k.push.apply(k, G(w));
                });
                f = k;
            }
            b = new Set;
            c = u(f);
            for(e = c.next(); !e.done; e = c.next())e = e.value, e.video && b.add(e.video);
            if (b.size) {
                var l = {
                    vp8: 1,
                    avc: 1,
                    "dovi-avc": .95,
                    vp9: .9,
                    vp09: .9,
                    hevc: .85,
                    "dovi-hevc": .8,
                    "dovi-p5": .75,
                    av01: .7,
                    "dovi-av1": .65,
                    vvc: .6
                };
                e = Array.from(b).sort(function(t, v) {
                    return t.bandwidth && v.bandwidth && t.bandwidth != v.bandwidth ? t.bandwidth - v.bandwidth : t.width != v.width ? t.width - v.width : t.codecs && v.codecs ? (t = Cf(t.codecs), v = Cf(v.codecs), (l[t] || 1) - (l[v] || 1)) : 0;
                });
                var m = [];
                b = new Map;
                c = function(t) {
                    var v = [
                        String(t.width || ""),
                        String(t.height || ""),
                        String(Math.round(t.frameRate || 0)),
                        t.hdr || "",
                        t.fastSwitching
                    ];
                    t.dependencyStream && v.push(t.dependencyStream.baseOriginalId || "");
                    t.roles && v.push(t.roles.sort().join("_"));
                    return v.join(";");
                };
                e = u(e);
                for(g = e.next(); !g.done; g = e.next()){
                    g = g.value;
                    h = c(g);
                    var n = b.get(h) || [];
                    if (n.length) {
                        var q = Cf(n[n.length - 1].codecs), r = Cf(g.codecs);
                        q == r && (n.push(g), m.push(g.id));
                    } else n.push(g), m.push(g.id);
                    b.set(h, n);
                }
                a.variants = f.filter(function(t) {
                    return (t = t.video) && !m.includes(t.id) ? !1 : !0;
                });
            } else a.variants = f;
        }
        function cg(a, b, c) {
            b = u(b);
            for(var d = b.next(), e = {}; !d.done; e = {
                jk: void 0
            }, d = b.next())if (e.jk = d.value, d = a.filter(function(f) {
                return function(g) {
                    return g.video && g.video.codecs.startsWith(f.jk);
                };
            }(e)), d.length) {
                a = d;
                break;
            }
            c = u(c);
            b = c.next();
            for(d = {}; !b.done; d = {
                Ki: void 0
            }, b = c.next())if (d.Ki = b.value, b = a.filter(function(f) {
                return function(g) {
                    return g.audio && g.audio.codecs.startsWith(f.Ki);
                };
            }(d)), b.length) {
                a = b;
                break;
            }
            return a;
        }
        function dg(a, b, c) {
            a.variants = a.variants.filter(function(d) {
                return eg(d, b, c);
            });
        }
        function eg(a, b, c) {
            function d(g, h, k) {
                return g >= h && g <= k;
            }
            if (a && a.video && a.video.width && a.video.height) {
                var e = a.video.width, f = a.video.height;
                f > e && (f = u([
                    f,
                    e
                ]), e = f.next().value, f = f.next().value);
                if (!d(e, b.minWidth, Math.min(b.maxWidth, c.width)) || !d(f, b.minHeight, Math.min(b.maxHeight, c.height)) || !d(e * f, b.minPixels, b.maxPixels)) return !1;
            }
            return a && a.video && a.video.frameRate && !d(a.video.frameRate, b.minFrameRate, b.maxFrameRate) || a && a.audio && a.audio.channelsCount && !d(a.audio.channelsCount, b.minChannelsCount, b.maxChannelsCount) || !d(a.bandwidth, b.minBandwidth, b.maxBandwidth) ? !1 : !0;
        }
        function fg(a, b, c, d) {
            c = c === void 0 ? [] : c;
            d = d === void 0 ? {} : d;
            return H(function(e) {
                if (e.h == 1) return e.g(gg(a, b, b.offlineSessionIds.length > 0, c, d), 2);
                hg(b);
                return e.g(ig(b), 0);
            });
        }
        function gg(a, b, c, d, e) {
            var f, g;
            return H(function(h) {
                if (h.h == 1) return Xb().Tj() && jg(b.variants), h.g(kg(b.variants, c, !1, d), 2);
                f = null;
                a && (g = a.g) && (f = g.keySystem);
                b.variants = b.variants.filter(function(k) {
                    var l = lg(k, f, e);
                    if (!l) {
                        var m = [];
                        k.audio && m.push(mg(k.audio));
                        k.video && m.push(mg(k.video));
                    }
                    return l;
                });
                h.j();
            });
        }
        function jg(a) {
            var b = (new Map).set("dvav", "avc3").set("dva1", "avc1").set("dvhe", "hev1").set("dvh1", "hvc1").set("dvc1", "vvc1").set("dvi1", "vvi1"), c = new Set;
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.video && c.add(d.video);
            c = u(c);
            for(a = c.next(); !a.done; a = c.next()){
                a = a.value;
                d = u(b);
                for(var e = d.next(); !e.done; e = d.next()){
                    var f = u(e.value);
                    e = f.next().value;
                    f = f.next().value;
                    if (a.codecs.includes(e)) {
                        a.codecs = a.codecs.replace(e, f);
                        break;
                    }
                }
            }
        }
        function lg(a, b, c) {
            if (!a.decodingInfos.some(function(k) {
                return !k.supported || b && (k = k.keySystemAccess) && (c[k.keySystem] || k.keySystem) != b ? !1 : !0;
            })) return !1;
            var d = Xb(), e = d.Pb() === "Xbox";
            d = d.Pa() === "MOBILE" && d.Ma() === "GECKO";
            var f = a.video, g = f && f.width || 0, h = f && f.height || 0;
            if (e && f && (g > 1920 || h > 1080) && (f.codecs.includes("avc1.") || f.codecs.includes("avc3.")) || (e = f && f.dependencyStream) && !vd(e)) return !1;
            a = a.audio;
            return d && a && a.encrypted && a.codecs.toLowerCase().includes("opus") || a && a.dependencyStream ? !1 : !0;
        }
        function ng(a, b) {
            var c, d, e, f, g, h, k;
            return H(function(l) {
                if (l.h == 1) {
                    c = function(m, n) {
                        if (m) {
                            var q = Yd(m);
                            q.supported = m.supported && n.supported;
                            q.powerEfficient = m.powerEfficient && n.powerEfficient;
                            q.smooth = m.smooth && n.smooth;
                            n.keySystemAccess && !q.keySystemAccess && (q.keySystemAccess = n.keySystemAccess);
                            return q;
                        }
                        return n;
                    };
                    d = null;
                    e = [];
                    f = u(b);
                    g = f.next();
                    for(h = {}; !g.done; h = {
                        cache: void 0,
                        gf: void 0
                    }, g = f.next())k = g.value, h.gf = Zd(k), h.cache = og, h.cache.has(h.gf) ? d = c(d, h.cache.get(h.gf)) : e.push(pg(k).then(function(m) {
                        return function(n) {
                            var q = null;
                            n = u(n || []);
                            for(var r = n.next(); !r.done; r = n.next())q = c(q, r.value);
                            q && (m.cache.set(m.gf, q), d = c(d, q));
                        };
                    }(h)));
                    return l.g(Promise.all(e), 2);
                }
                d && a.decodingInfos.push(d);
                l.j();
            });
        }
        function pg(a) {
            var b = [
                ""
            ];
            a.video && (b = Gf(a.video.contentType).split(","));
            var c = [
                ""
            ];
            a.audio && (c = Gf(a.audio.contentType).split(","));
            var d = [];
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                for(var f = u(c), g = f.next(), h = {}; !g.done; h = {
                    $c: void 0
                }, g = f.next())g = g.value, h.$c = Xd(a), a.video && (h.$c.video.contentType = wf(Ff(h.$c.video.contentType), e)), a.audio && (h.$c.audio.contentType = wf(Ff(h.$c.audio.contentType), g)), d.push(new Promise(function(k) {
                    return function(l, m) {
                        (Xb().Pa() == "MOBILE" ? $f(5, navigator.mediaCapabilities.decodingInfo(k.$c)) : navigator.mediaCapabilities.decodingInfo(k.$c)).then(function(n) {
                            l(n);
                        }).catch(m);
                    };
                }(h)));
            }
            return Promise.all(d).catch(function() {
                JSON.stringify(a);
                return null;
            });
        }
        function kg(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C;
            return H(function(D) {
                switch(D.h){
                    case 1:
                        if (e = a.some(function(B) {
                            return B.decodingInfos.length;
                        })) return D.return();
                        f = u(d);
                        g = f.next();
                        h = {};
                    case 2:
                        if (g.done) {
                            D.B(4);
                            break;
                        }
                        h.yj = g.value;
                        k = !1;
                        l = u(a);
                        m = l.next();
                    case 5:
                        if (m.done) {
                            D.B(7);
                            break;
                        }
                        n = m.value;
                        q = qg(n, b, c).filter(function(B) {
                            return function(J) {
                                J = J[0];
                                J = J.keySystemConfiguration && J.keySystemConfiguration.keySystem;
                                return !J || J === B.yj;
                            };
                        }(h));
                        r = u(q);
                        t = r.next();
                    case 8:
                        if (t.done) {
                            D.B(10);
                            break;
                        }
                        v = t.value;
                        return D.g(ng(n, v), 9);
                    case 9:
                        t = r.next();
                        D.B(8);
                        break;
                    case 10:
                        n.decodingInfos.some(function(B) {
                            return B.supported;
                        }) && (k = !0);
                        m = l.next();
                        D.B(5);
                        break;
                    case 7:
                        if (k) return D.return();
                        h = {
                            yj: void 0
                        };
                        g = f.next();
                        D.B(2);
                        break;
                    case 4:
                        w = u(a), x = w.next();
                    case 12:
                        if (x.done) {
                            D.B(0);
                            break;
                        }
                        y = x.value;
                        z = qg(y, b, c).filter(function(B) {
                            B = B[0];
                            B = B.keySystemConfiguration && B.keySystemConfiguration.keySystem;
                            return !B || !d.includes(B);
                        });
                        A = u(z);
                        E = A.next();
                    case 15:
                        if (E.done) {
                            x = w.next();
                            D.B(12);
                            break;
                        }
                        C = E.value;
                        return D.g(ng(y, C), 16);
                    case 16:
                        E = A.next(), D.B(15);
                }
            });
        }
        function qg(a, b, c) {
            var d = a.audio, e = a.video, f = [], g = [];
            if (e) for(var h = u(e.fullMimeTypes), k = h.next(); !k.done; k = h.next()){
                k = k.value;
                var l = Gf(k);
                if (l.includes(",") && !d) {
                    var m = l.split(","), n = Ff(k);
                    l = Bc("video", m);
                    m = Bc("audio", m);
                    m = rg(m, n);
                    n = Af(n, m, "audio");
                    g.push({
                        contentType: n,
                        channels: 2,
                        bitrate: a.bandwidth || 1,
                        samplerate: 1,
                        spatialRendering: !1
                    });
                }
                l = sg(l);
                k = {
                    contentType: Af(Ff(k), l, "video"),
                    width: e.width || 64,
                    height: e.height || 64,
                    bitrate: e.bandwidth || a.bandwidth || 1,
                    framerate: e.frameRate || 30
                };
                if (e.hdr) switch(e.hdr){
                    case "PQ":
                        k.transferFunction = "pq";
                        break;
                    case "HLG":
                        k.transferFunction = "hlg";
                }
                e.colorGamut && (k.colorGamut = e.colorGamut);
                f.push(k);
            }
            if (d) for(h = u(d.fullMimeTypes), k = h.next(); !k.done; k = h.next())l = k.value, k = Ff(l), l = rg(Gf(l), k), k = Af(k, l, "audio"), g.push({
                contentType: k,
                channels: d.channelsCount || 2,
                bitrate: d.bandwidth || a.bandwidth || 1,
                samplerate: d.audioSamplingRate || 1,
                spatialRendering: d.spatialAudio
            });
            h = [];
            f.length == 0 && f.push(null);
            g.length == 0 && g.push(null);
            f = u(f);
            for(k = f.next(); !k.done; k = f.next())for(k = k.value, l = u(g), n = l.next(); !n.done; n = l.next())n = n.value, m = {
                type: c ? "file" : "media-source"
            }, k && (m.video = k), n && (m.audio = n), h.push(m);
            g = (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
            if (!g.length) return [
                h
            ];
            a = [];
            c = new Map;
            g = u(g);
            for(f = g.next(); !f.done; f = g.next())f = f.value, c.get(f.keySystem) || c.set(f.keySystem, []), c.get(f.keySystem).push(f);
            g = b ? "required" : "optional";
            b = b ? [
                "persistent-license"
            ] : [
                "temporary"
            ];
            f = u(c.keys());
            for(k = f.next(); !k.done; k = f.next()){
                k = k.value;
                n = c.get(k);
                l = new Map;
                n = u(n);
                for(m = n.next(); !m.done; m = n.next()){
                    m = m.value;
                    var q = m.videoRobustness + "," + m.audioRobustness;
                    l.get(q) || l.set(q, []);
                    l.get(q).push(m);
                }
                l = u(l.values());
                for(n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    m = [];
                    q = u(h);
                    for(var r = q.next(); !r.done; r = q.next()){
                        r = Object.assign({}, r.value);
                        for(var t = {
                            keySystem: k,
                            initDataType: "cenc",
                            persistentState: g,
                            distinctiveIdentifier: "optional",
                            sessionTypes: b
                        }, v = u(n), w = v.next(); !w.done; w = v.next()){
                            w = w.value;
                            if (w.initData && w.initData.length) {
                                for(var x = new Set, y = u(w.initData), z = y.next(); !z.done; z = y.next())x.add(z.value.initDataType);
                                t.initDataType = w.initData[0].initDataType;
                            }
                            w.distinctiveIdentifierRequired && (t.distinctiveIdentifier = "required");
                            w.persistentStateRequired && (t.persistentState = "required");
                            w.sessionType && (t.sessionTypes = [
                                w.sessionType
                            ]);
                            d && (t.audio ? (w.encryptionScheme && (t.audio.encryptionScheme = t.audio.encryptionScheme || w.encryptionScheme), t.audio.robustness = t.audio.robustness || w.audioRobustness) : (t.audio = {
                                robustness: w.audioRobustness
                            }, w.encryptionScheme && (t.audio.encryptionScheme = w.encryptionScheme)), t.audio.robustness == "" && delete t.audio.robustness);
                            e && (t.video ? (w.encryptionScheme && (t.video.encryptionScheme = t.video.encryptionScheme || w.encryptionScheme), t.video.robustness = t.video.robustness || w.videoRobustness) : (t.video = {
                                robustness: w.videoRobustness
                            }, w.encryptionScheme && (t.video.encryptionScheme = w.encryptionScheme)), t.video.robustness == "" && delete t.video.robustness);
                        }
                        r.keySystemConfiguration = t;
                        m.push(r);
                    }
                    a.push(m);
                }
            }
            return a;
        }
        function rg(a, b) {
            var c = Xb();
            return a.toLowerCase() == "flac" ? c.Ma() != "WEBKIT" ? "flac" : "fLaC" : a.toLowerCase() === "opus" ? c.Ma() != "WEBKIT" ? "opus" : Bf(b) == "mp4" ? "Opus" : "opus" : a.toLowerCase() == "ac-3" && c.Fe() ? "ec-3" : a;
        }
        function sg(a) {
            if (a.includes("avc1")) {
                var b = a.split(".");
                if (b.length == 3) return a = b.shift() + ".", a += parseInt(b.shift(), 10).toString(16), a += ("000" + parseInt(b.shift(), 10).toString(16)).slice(-4);
            } else if (a == "vp9") return "vp09.00.41.08";
            return a;
        }
        function hg(a) {
            a.textStreams = a.textStreams.filter(function(b) {
                b = wf(b.mimeType, b.codecs);
                return Mf(b);
            });
        }
        function ig(a) {
            var b, c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        b = [], c = u(a.imageStreams), d = c.next();
                    case 2:
                        if (d.done) {
                            l.B(4);
                            break;
                        }
                        e = d.value;
                        f = e.mimeType;
                        f == "application/mp4" && e.codecs == "mjpg" && (f = "image/jpg");
                        if (tg.has(f)) {
                            l.B(5);
                            break;
                        }
                        g = ug.get(f);
                        if (!g) {
                            tg.set(f, !1);
                            l.B(5);
                            break;
                        }
                        return l.g(vg(g), 7);
                    case 7:
                        h = l.i, tg.set(f, h);
                    case 5:
                        (k = tg.get(f)) && b.push(e);
                        d = c.next();
                        l.B(2);
                        break;
                    case 4:
                        a.imageStreams = b, l.j();
                }
            });
        }
        function vg(a) {
            return new Promise(function(b) {
                var c = new Image;
                c.src = a;
                "decode" in c ? c.decode().then(function() {
                    b(!0);
                }).catch(function() {
                    b(!1);
                }) : c.onload = c.onerror = function() {
                    b(c.height === 2);
                };
            });
        }
        function wg(a) {
            var b = a.audio, c = a.video, d = b ? b.mimeType : null, e = c ? c.mimeType : null, f = b ? b.codecs : null, g = c ? c.codecs : null, h = b ? b.groupId : null, k = [];
            c && k.push(c.mimeType);
            b && k.push(b.mimeType);
            k = k[0] || null;
            var l = [];
            b && l.push(b.kind);
            c && l.push(c.kind);
            l = l[0] || null;
            var m = new Set;
            if (b) for(var n = u(b.roles), q = n.next(); !q.done; q = n.next())m.add(q.value);
            if (c) for(n = u(c.roles), q = n.next(); !q.done; q = n.next())m.add(q.value);
            a = {
                id: a.id,
                active: !1,
                type: "variant",
                bandwidth: a.bandwidth,
                language: a.language,
                label: null,
                videoLabel: null,
                kind: l,
                width: null,
                height: null,
                frameRate: null,
                pixelAspectRatio: null,
                hdr: null,
                colorGamut: null,
                videoLayout: null,
                mimeType: k,
                audioMimeType: d,
                videoMimeType: e,
                codecs: "",
                audioCodec: f,
                videoCodec: g,
                primary: a.primary,
                roles: Array.from(m),
                audioRoles: null,
                videoRoles: null,
                forced: !1,
                videoId: null,
                audioId: null,
                audioGroupId: h,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                tilesLayout: null,
                audioBandwidth: null,
                videoBandwidth: null,
                originalVideoId: null,
                originalAudioId: null,
                originalTextId: null,
                originalImageId: null,
                accessibilityPurpose: null,
                originalLanguage: null
            };
            if (c) {
                a.videoId = c.id;
                a.originalVideoId = c.originalId;
                a.width = c.width || null;
                a.height = c.height || null;
                a.frameRate = c.frameRate || null;
                a.pixelAspectRatio = c.pixelAspectRatio || null;
                a.videoBandwidth = c.bandwidth || null;
                a.hdr = c.hdr || null;
                a.colorGamut = c.colorGamut || null;
                a.videoLayout = c.videoLayout || null;
                a.videoRoles = c.roles;
                a.videoLabel = c.label;
                if (d = c.dependencyStream) a.width = d.width || a.width, a.height = d.height || a.height, a.videoCodec = d.codecs || a.videoCodec, a.pixelAspectRatio = d.pixelAspectRatio || a.pixelAspectRatio, a.videoBandwidth && d.bandwidth && (a.videoBandwidth += d.bandwidth);
                if (g.includes(",")) {
                    a.channelsCount = c.channelsCount;
                    a.audioSamplingRate = c.audioSamplingRate;
                    a.spatialAudio = c.spatialAudio;
                    a.originalLanguage = c.originalLanguage;
                    a.audioMimeType = e;
                    e = g.split(",");
                    try {
                        a.videoCodec = Bc("video", e), a.audioCodec = Bc("audio", e);
                    } catch (r) {}
                }
            }
            b && (a.audioId = b.id, a.originalAudioId = b.originalId, a.channelsCount = b.channelsCount, a.audioSamplingRate = b.audioSamplingRate, a.audioBandwidth = b.bandwidth || null, a.spatialAudio = b.spatialAudio, a.label = b.label, a.audioRoles = b.roles, a.accessibilityPurpose = b.accessibilityPurpose, a.originalLanguage = b.originalLanguage, e = b.dependencyStream) && (a.audioCodec = e.codecs || a.audioCodec, a.audioBandwidth && e.bandwidth && (a.audioBandwidth += e.bandwidth));
            c && !a.videoBandwidth && (b ? a.audioBandwidth && (a.videoBandwidth = a.bandwidth - a.audioBandwidth) : a.videoBandwidth = a.bandwidth);
            b && !a.audioBandwidth && (c ? a.videoBandwidth && (a.audioBandwidth = a.bandwidth - a.videoBandwidth) : a.audioBandwidth = a.bandwidth);
            b = [];
            a.videoCodec && b.push(a.videoCodec);
            a.audioCodec && b.push(a.audioCodec);
            a.codecs = b.join(", ");
            return a;
        }
        function xg(a) {
            return {
                id: a.id,
                active: !1,
                type: Ec,
                bandwidth: a.bandwidth || 0,
                language: a.language,
                label: a.label,
                kind: a.kind || null,
                mimeType: a.mimeType,
                codecs: a.codecs || null,
                primary: a.primary,
                roles: a.roles,
                accessibilityPurpose: a.accessibilityPurpose,
                forced: a.forced,
                originalTextId: a.originalId,
                originalLanguage: a.originalLanguage
            };
        }
        function yg(a) {
            var b = a.width || null, c = a.height || null, d = null;
            a.segmentIndex && (d = a.segmentIndex.Fb());
            var e = a.tilesLayout;
            d && (e = d.tilesLayout || e);
            e && b != null && (b /= Number(e.split("x")[0]));
            e && c != null && (c /= Number(e.split("x")[1]));
            return {
                id: a.id,
                type: "image",
                bandwidth: a.bandwidth || 0,
                width: b,
                height: c,
                mimeType: a.mimeType,
                codecs: a.codecs || null,
                tilesLayout: e || null,
                originalImageId: a.originalId
            };
        }
        function zg(a) {
            a.__shaka_id || (a.__shaka_id = Ag++);
            return a.__shaka_id;
        }
        function Cg(a) {
            var b = {
                id: zg(a),
                active: a.mode != "disabled",
                type: Ec,
                bandwidth: 0,
                language: Kc(a.language || "und"),
                label: a.label,
                kind: a.kind,
                mimeType: null,
                codecs: null,
                primary: !1,
                roles: [],
                accessibilityPurpose: null,
                forced: a.kind == "forced",
                originalTextId: a.id,
                originalLanguage: a.language
            };
            a.kind == "captions" && (b.mimeType = "unknown");
            a.kind == "subtitles" && (b.mimeType = "text/vtt");
            a.kind && (b.roles = [
                a.kind
            ]);
            return b;
        }
        function Dg(a, b) {
            var c = a ? a.language : null;
            c = {
                id: zg(a || b),
                active: a ? a.enabled : b.selected,
                type: "variant",
                bandwidth: 0,
                language: Kc(c || "und"),
                label: a ? a.label : null,
                videoLabel: null,
                kind: a ? a.kind : null,
                width: null,
                height: null,
                frameRate: null,
                pixelAspectRatio: null,
                hdr: null,
                colorGamut: null,
                videoLayout: null,
                mimeType: null,
                audioMimeType: null,
                videoMimeType: null,
                codecs: null,
                audioCodec: null,
                videoCodec: null,
                primary: a ? a.kind == "main" : !1,
                roles: [],
                forced: !1,
                audioRoles: null,
                videoRoles: null,
                videoId: null,
                audioId: null,
                audioGroupId: null,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                tilesLayout: null,
                audioBandwidth: null,
                videoBandwidth: null,
                originalVideoId: b ? b.id : null,
                originalAudioId: a ? a.id : null,
                originalTextId: null,
                originalImageId: null,
                accessibilityPurpose: null,
                originalLanguage: c
            };
            a && a.kind && (c.roles = [
                a.kind
            ], c.audioRoles = [
                a.kind
            ]);
            a && a.configuration && (a.configuration.codec && (c.audioCodec = a.configuration.codec, c.codecs = c.audioCodec), a.configuration.bitrate && (c.audioBandwidth = a.configuration.bitrate, c.bandwidth += c.audioBandwidth), a.configuration.sampleRate && (c.audioSamplingRate = a.configuration.sampleRate), a.configuration.numberOfChannels && (c.channelsCount = a.configuration.numberOfChannels));
            if (b && b.configuration && (b.configuration.codec && (c.videoCodec = b.configuration.codec, c.codecs = c.codecs ? c.codecs + ("," + c.videoCodec) : c.videoCodec), b.configuration.bitrate && (c.videoBandwidth = b.configuration.bitrate, c.bandwidth += c.videoBandwidth), b.configuration.framerate && (c.frameRate = b.configuration.framerate), b.configuration.width && (c.width = b.configuration.width), b.configuration.height && (c.height = b.configuration.height), b.configuration.colorSpace && b.configuration.colorSpace.transfer)) switch(b.configuration.colorSpace.transfer){
                case "pq":
                    c.hdr = "PQ";
                    break;
                case "hlg":
                    c.hdr = "HLG";
                    break;
                case "bt709":
                    c.hdr = "SDR";
            }
            return c;
        }
        function Eg(a) {
            return a.allowedByApplication && a.allowedByKeySystem && a.disabledUntilTime == 0;
        }
        function Fg(a) {
            return a.filter(function(b) {
                return Eg(b);
            });
        }
        function Gg(a, b, c, d) {
            var e = a, f = a.filter(function(k) {
                return k.primary;
            });
            f.length && (e = f);
            var g = e.length ? e[0].language : "";
            e = e.filter(function(k) {
                return k.language == g;
            });
            if (b) {
                var h = Sc(Kc(b), a.map(function(k) {
                    return k.language;
                }));
                h && (e = a.filter(function(k) {
                    return Kc(k.language) == h;
                }));
            }
            e = e.filter(function(k) {
                return k.forced == d;
            });
            if (c) {
                if (a = Lg(e, c), a.length) return a;
            } else if (a = e.filter(function(k) {
                return k.roles.length == 0;
            }), a.length) return a;
            a = e.map(function(k) {
                return k.roles;
            }).reduce(Xf, []);
            return a.length ? Lg(e, a[0]) : e;
        }
        function Lg(a, b) {
            return a.filter(function(c) {
                return c.roles.includes(b);
            });
        }
        function Mg(a) {
            var b = [];
            a.audio && b.push(a.audio);
            a.video && b.push(a.video);
            return b;
        }
        function Ng(a, b) {
            b.length && (b = b.filter(function(c) {
                return Cf(a.codecs) == Cf(c.codecs);
            }).sort(function(c, d) {
                return c.bandwidth && d.bandwidth && c.bandwidth != d.bandwidth ? c.bandwidth - d.bandwidth : (c.width || 0) - (d.width || 0);
            }), a.trickModeVideo = b[0], b.length > 1 && (b = b.find(function(c) {
                return a.width == c.width && a.height == c.height;
            }))) && (a.trickModeVideo = b);
        }
        function mg(a) {
            return a.type == "audio" ? "type=audio codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " channelsCount=" + a.channelsCount + " audioSamplingRate=" + a.audioSamplingRate : a.type == "video" ? "type=video codecs=" + a.codecs + " bandwidth=" + a.bandwidth + " frameRate=" + a.frameRate + " width=" + a.width + " height=" + a.height : "unexpected stream type";
        }
        function Og(a, b, c) {
            if (c.autoShowText == 0) return !1;
            if (c.autoShowText == 1) return !0;
            var d = Kc(c.preferredTextLanguage);
            b = Kc(b.language);
            if (c.autoShowText == 2) return Jc(b, d);
            if (c.autoShowText == 3) {
                if (!a) return !1;
                a = Kc(a.language);
                return Jc(b, d) && !Jc(a, b);
            }
            Za("Invalid autoShowText setting!");
            return !1;
        }
        function Pg(a) {
            var b = {
                id: 0,
                language: "und",
                disabledUntilTime: 0,
                primary: !1,
                audio: null,
                video: null,
                bandwidth: 100,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
                decodingInfos: []
            };
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = {
                    id: 0,
                    originalId: null,
                    groupId: null,
                    createSegmentIndex: function() {
                        return Promise.resolve();
                    },
                    segmentIndex: null,
                    mimeType: c ? Ff(c) : "",
                    codecs: c ? Gf(c) : "",
                    encrypted: !0,
                    drmInfos: [],
                    keyIds: new Set,
                    language: "und",
                    originalLanguage: null,
                    label: null,
                    type: "video",
                    primary: !1,
                    trickModeVideo: null,
                    dependencyStream: null,
                    emsgSchemeIdUris: null,
                    roles: [],
                    forced: !1,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    closedCaptions: null,
                    accessibilityPurpose: null,
                    external: !1,
                    fastSwitching: !1,
                    fullMimeTypes: new Set,
                    isAudioMuxedInVideo: !1,
                    baseOriginalId: null
                };
                d.fullMimeTypes.add(wf(d.mimeType, d.codecs));
                c.startsWith("audio/") ? (d.type = "audio", b.audio = d) : b.video = d;
            }
            return b;
        }
        O("shaka.util.StreamUtils", ag);
        ag.meetsRestrictions = eg;
        var og = new Map, Ag = 0, tg = (new Map).set("image/svg+xml", !0).set("image/png", !0).set("image/jpeg", !0).set("image/jpg", !0), ug = (new Map).set("image/webp", "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA").set("image/avif", "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=");
        function Qg() {
            var a = this;
            this.H = null;
            this.G = !1;
            this.A = new Zc;
            this.j = new fd;
            navigator.connection && navigator.connection.addEventListener && this.j.u(navigator.connection, "change", function() {
                a.g.useNetworkInformation && navigator.onLine && (a.A = new Zc, a.g && a.A.configure(a.g.advanced), a.trySuggestStreams());
            });
            this.l = [];
            this.I = 1;
            this.J = !1;
            this.h = this.o = this.g = this.C = null;
            this.m = new Uf(function() {
                if (a.G && (a.g.restrictToElementSize || a.g.restrictToScreenSize)) {
                    var b = a.chooseVariant();
                    b && a.H && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
                }
            });
            this.D = window1;
            "documentPictureInPicture" in window1 && this.j.u(window1.documentPictureInPicture, "enter", function() {
                a.D = window1.documentPictureInPicture.window;
                a.m && a.m.La();
                a.j.ra(a.D, "pagehide", function() {
                    a.D = window1;
                    a.m && a.m.La();
                });
            });
            this.F = this.i = null;
        }
        p = Qg.prototype;
        p.stop = function() {
            this.H = null;
            this.G = !1;
            this.l = [];
            this.I = 1;
            this.o = this.C = null;
            this.h && (this.h.disconnect(), this.h = null);
            this.m && this.m.stop();
            this.F = this.i = null;
        };
        p.release = function() {
            this.stop();
            this.j.release();
            this.m = null;
        };
        p.init = function(a) {
            this.H = a;
        };
        p.chooseVariant = function(a) {
            a = a === void 0 ? !1 : a;
            var b = Infinity, c = Infinity;
            this.g.restrictToScreenSize && (c = this.g.ignoreDevicePixelRatio ? 1 : this.D.devicePixelRatio, b = this.D.screen.height * c, c *= this.D.screen.width);
            if (this.h && this.g.restrictToElementSize) {
                var d = this.g.ignoreDevicePixelRatio ? 1 : this.D.devicePixelRatio, e = this.o.clientHeight, f = this.o.clientWidth;
                this.i && document.pictureInPictureElement && document.pictureInPictureElement == this.o && (e = this.i.height, f = this.i.width);
                b = Math.min(b, e * d);
                c = Math.min(c, f * d);
            }
            e = this.l.filter(function(l) {
                return l && !(l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching);
            });
            e.length || (e = this.l);
            d = e;
            a && e.length != this.l.length && (d = this.l.filter(function(l) {
                return l && (l.audio && l.audio.fastSwitching || l.video && l.video.fastSwitching ? !0 : !1);
            }));
            a = Rg(this, this.g.restrictions, d, Infinity, Infinity);
            if (b != Infinity || c != Infinity) {
                a = Sg(a);
                a = u(a);
                for(e = a.next(); !e.done; e = a.next())if (e = e.value, e.height >= b && e.width >= c) {
                    b = e.height;
                    c = e.width;
                    break;
                }
                a = Rg(this, this.g.restrictions, d, b, c);
            }
            b = this.getBandwidthEstimate();
            d.length && !a.length && (a = Rg(this, null, d, Infinity, Infinity), a = [
                a[0]
            ]);
            c = a[0] || null;
            for(d = 0; d < a.length; d++){
                e = a[d];
                var g = isNaN(this.I) ? 1 : Math.abs(this.I);
                f = g * e.bandwidth / this.g.bandwidthDowngradeTarget;
                for(var h = {
                    bandwidth: Infinity
                }, k = d + 1; k < a.length; k++)if (e.bandwidth != a[k].bandwidth) {
                    h = a[k];
                    break;
                }
                g = g * h.bandwidth / this.g.bandwidthUpgradeTarget;
                c && e && b >= f && b <= g && (c.bandwidth != e.bandwidth || c.bandwidth == e.bandwidth && c.video && e.video && (c.video.width < e.video.width || c.video.height < e.video.height)) && (c = e);
            }
            this.C = Date.now();
            return c;
        };
        p.enable = function() {
            this.G = !0;
            this.l.length && this.trySuggestStreams();
        };
        p.disable = function() {
            this.G = !1;
        };
        p.segmentDownloaded = function(a, b, c, d) {
            var e = a;
            this.g.removeLatencyFromFirstPacketTime && d && d.packetNumber === 1 && d.timeToFirstByte && (e = a - d.timeToFirstByte);
            e >= this.g.cacheLoadThreshold && this.A.sample(e, b);
            c && this.C != null && this.G && Tg(this);
        };
        p.trySuggestStreams = function() {
            this.G && (this.C = Date.now(), Tg(this, !0));
        };
        p.getBandwidthEstimate = function() {
            var a = this.g.defaultBandwidthEstimate;
            navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && (a = navigator.connection.downlink * 1E6);
            if (navigator.connection && navigator.connection.downlink && this.g.useNetworkInformation && this.g.preferNetworkInformationBandwidth) return a;
            a = this.A.getBandwidthEstimate(a);
            return this.F ? this.F.getBandwidthEstimate(a) : a;
        };
        p.setVariants = function(a) {
            if (bd(a, this.l)) return !1;
            this.l = a;
            return !0;
        };
        p.playbackRateChanged = function(a) {
            this.I = a;
        };
        p.setMediaElement = function(a) {
            function b() {
                c.m.Z(Ug);
            }
            var c = this;
            this.o = a;
            this.h && (this.h.disconnect(), this.h = null);
            this.o && "ResizeObserver" in window1 && (this.h = new ResizeObserver(b), this.h.observe(this.o));
            this.j.u(a, "enterpictureinpicture", function(d) {
                d.pictureInPictureWindow && (c.i = d.pictureInPictureWindow, c.j.u(c.i, "resize", b));
            });
            this.j.u(a, "leavepictureinpicture", function() {
                c.i && c.j.Fa(c.i, "resize", b);
                c.i = null;
            });
        };
        p.setCmsdManager = function(a) {
            this.F = a;
        };
        p.configure = function(a) {
            this.g = a;
            this.A && this.g && this.A.configure(this.g.advanced);
        };
        function Tg(a, b) {
            if (b === void 0 || !b) {
                if (!a.J) {
                    b = a.A;
                    if (!(b.g >= b.i)) return;
                    a.J = !0;
                    a.C -= (a.g.switchInterval - a.g.minTimeToSwitch) * 1E3;
                }
                if (Date.now() - a.C < a.g.switchInterval * 1E3) return;
            }
            b = a.chooseVariant();
            a.getBandwidthEstimate();
            b && a.H && a.H(b, a.g.clearBufferSwitch, a.g.safeMarginSwitch);
        }
        function Rg(a, b, c, d, e) {
            if (a.F) {
                var f = a.F.aj();
                f && (c = c.filter(function(g) {
                    return g.bandwidth && f ? g.bandwidth <= f : !0;
                }));
            }
            b && (c = c.filter(function(g) {
                return eg(g, b, {
                    width: e,
                    height: d
                });
            }));
            return c.sort(function(g, h) {
                return g.bandwidth - h.bandwidth;
            });
        }
        function Sg(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())(c = c.value) && (c = c.video) && c.height && c.width && b.push({
                height: c.height,
                width: c.width
            });
            return b.sort(function(d, e) {
                return d.width - e.width;
            });
        }
        O("shaka.abr.SimpleAbrManager", Qg);
        Qg.prototype.configure = Qg.prototype.configure;
        Qg.prototype.setCmsdManager = Qg.prototype.setCmsdManager;
        Qg.prototype.setMediaElement = Qg.prototype.setMediaElement;
        Qg.prototype.playbackRateChanged = Qg.prototype.playbackRateChanged;
        Qg.prototype.setVariants = Qg.prototype.setVariants;
        Qg.prototype.getBandwidthEstimate = Qg.prototype.getBandwidthEstimate;
        Qg.prototype.trySuggestStreams = Qg.prototype.trySuggestStreams;
        Qg.prototype.segmentDownloaded = Qg.prototype.segmentDownloaded;
        Qg.prototype.disable = Qg.prototype.disable;
        Qg.prototype.enable = Qg.prototype.enable;
        Qg.prototype.chooseVariant = Qg.prototype.chooseVariant;
        Qg.prototype.init = Qg.prototype.init;
        Qg.prototype.release = Qg.prototype.release;
        Qg.prototype.stop = Qg.prototype.stop;
        var Ug = 1;
        function Vg(a, b) {
            var c = Wg();
            this.l = a.maxAttempts == null ? c.maxAttempts : a.maxAttempts;
            this.j = a.baseDelay == null ? c.baseDelay : a.baseDelay;
            this.o = a.fuzzFactor == null ? c.fuzzFactor : a.fuzzFactor;
            this.m = a.backoffFactor == null ? c.backoffFactor : a.backoffFactor;
            this.g = 0;
            this.h = this.j;
            if (this.i = b === void 0 ? !1 : b) this.g = 1;
        }
        function Xg(a) {
            var b, c;
            return H(function(d) {
                if (d.h == 1) {
                    if (a.g >= a.l) {
                        if (a.i) a.g = 1, a.h = a.j;
                        else throw new T(2, 7, 1010);
                    }
                    b = a.g;
                    a.g++;
                    if (b == 0) return d.return();
                    c = a.h * (1 + (Math.random() * 2 - 1) * a.o);
                    return d.g(new Promise(function(e) {
                        new Uf(e).Z(c / 1E3);
                    }), 2);
                }
                a.h *= a.m;
                d.j();
            });
        }
        function Wg() {
            return {
                maxAttempts: 2,
                baseDelay: 1E3,
                backoffFactor: 2,
                fuzzFactor: .5,
                timeout: 3E4,
                stallTimeout: 5E3,
                connectionTimeout: 1E4
            };
        }
        function Yg() {
            var a, b, c = new Promise(function(d, e) {
                a = d;
                b = e;
            });
            c.resolve = a;
            c.reject = b;
            return c;
        }
        Yg.prototype.resolve = function() {};
        Yg.prototype.reject = function() {};
        function Zg(a, b) {
            this.promise = a;
            this.i = b;
            this.g = null;
        }
        function $g(a) {
            return new Zg(Promise.reject(a), function() {
                return Promise.resolve();
            });
        }
        function ah() {
            var a = Promise.reject(new T(2, 7, 7001));
            a.catch(function() {});
            return new Zg(a, function() {
                return Promise.resolve();
            });
        }
        function bh(a) {
            return new Zg(Promise.resolve(a), function() {
                return Promise.resolve();
            });
        }
        function ch(a) {
            return new Zg(a, function() {
                return a.catch(function() {});
            });
        }
        Zg.prototype.abort = function() {
            this.g || (this.g = this.i());
            return this.g;
        };
        function dh(a) {
            return new Zg(Promise.all(a.map(function(b) {
                return b.promise;
            })), function() {
                return Promise.all(a.map(function(b) {
                    return b.abort();
                }));
            });
        }
        Zg.prototype.finally = function(a) {
            this.promise.then(function() {
                return a(!0);
            }, function() {
                return a(!1);
            });
            return this;
        };
        Zg.prototype.eb = function(a, b) {
            function c(h) {
                return function(k) {
                    if (e.g && h) f.reject(g);
                    else {
                        var l = h ? a : b;
                        l ? d = eh(l, k, f) : (h ? f.resolve : f.reject)(k);
                    }
                };
            }
            function d() {
                f.reject(g);
                return e.abort();
            }
            var e = this, f = new Yg;
            f.catch(function() {});
            var g = new T(2, 7, 7001);
            this.promise.then(c(!0), c(!1));
            return new Zg(f, function() {
                return d();
            });
        };
        function eh(a, b, c) {
            try {
                var d = a(b);
                if (d && d.promise && d.abort) return c.resolve(d.promise), function() {
                    return d.abort();
                };
                c.resolve(d);
                return function() {
                    return Promise.resolve(d).then(function() {}, function() {});
                };
            } catch (e) {
                return c.reject(e), function() {
                    return Promise.resolve();
                };
            }
        }
        da.Object.defineProperties(Zg.prototype, {
            aborted: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g !== null;
                }
            }
        });
        O("shaka.util.AbortableOperation", Zg);
        Zg.prototype.chain = Zg.prototype.eb;
        Zg.prototype["finally"] = Zg.prototype.finally;
        Zg.all = dh;
        Zg.prototype.abort = Zg.prototype.abort;
        Zg.notAbortable = ch;
        Zg.completed = bh;
        Zg.aborted = ah;
        Zg.failed = $g;
        function fh() {
            this.g = [];
        }
        function gh(a, b) {
            a.g.push(b.finally(function() {
                ad(a.g, b);
            }));
        }
        fh.prototype.destroy = function() {
            for(var a = [], b = u(this.g), c = b.next(); !c.done; c = b.next())c = c.value, c.promise.catch(function() {}), a.push(c.abort());
            this.g = [];
            return Promise.all(a);
        };
        function hh(a, b, c, d, e, f, g) {
            fb.call(this);
            this.i = null;
            this.j = !1;
            this.A = new fh;
            this.g = new Set;
            this.h = new Set;
            this.o = a || null;
            this.m = b || null;
            this.C = c || null;
            this.D = d || null;
            this.F = e || null;
            this.H = f || null;
            this.G = g || null;
            this.l = new Map;
        }
        oa(hh, fb);
        p = hh.prototype;
        p.configure = function(a) {
            this.i = a;
        };
        function ih(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            c = c || jh;
            var e = kh.get(a);
            (!e || c >= e.priority) && kh.set(a, {
                priority: c,
                Vf: b,
                $l: d
            });
        }
        function lh(a, b) {
            for(var c = u(a.g), d = c.next(); !d.done; d = c.next())b.g.add(d.value);
            a = u(a.h);
            for(c = a.next(); !c.done; c = a.next())b.h.add(c.value);
        }
        p.dm = function(a) {
            this.g.add(a);
        };
        p.Dm = function(a) {
            this.g.delete(a);
        };
        p.wk = function() {
            this.g.clear();
        };
        p.fm = function(a) {
            this.h.add(a);
        };
        p.Em = function(a) {
            this.h.delete(a);
        };
        p.xk = function() {
            this.h.clear();
        };
        p.Ri = function() {
            this.l.clear();
        };
        function mh(a, b, c) {
            return {
                uris: a,
                method: "GET",
                body: null,
                headers: {},
                allowCrossSiteCredentials: !1,
                retryParameters: b,
                licenseRequestType: null,
                sessionId: null,
                drmInfo: null,
                initData: null,
                initDataType: null,
                streamDataCallback: c === void 0 ? null : c
            };
        }
        p.destroy = function() {
            this.j = !0;
            this.g.clear();
            this.h.clear();
            this.l.clear();
            fb.prototype.release.call(this);
            return this.A.destroy();
        };
        p.request = function(a, b, c) {
            var d = this, e = new nh;
            if (this.j) {
                var f = Promise.reject(new T(2, 7, 7001));
                f.catch(function() {});
                return new oh(f, function() {
                    return Promise.resolve();
                }, e);
            }
            b.method = b.method || "GET";
            b.headers = b.headers || {};
            b.retryParameters = b.retryParameters ? Xd(b.retryParameters) : Wg();
            b.uris = Xd(b.uris);
            f = ph(this, a, b, c);
            var g = f.eb(function() {
                return qh(d, a, b, c, new Vg(b.retryParameters, !1), 0, null, e);
            }), h = g.eb(function(q) {
                return rh(d, a, q, c);
            }), k = Date.now(), l = 0;
            f.promise.then(function() {
                l = Date.now() - k;
            }, function() {});
            var m = 0;
            g.promise.then(function() {
                m = Date.now();
            }, function() {});
            var n = h.eb(function(q) {
                var r = Date.now() - m, t = q.response;
                t.timeMs += l;
                t.timeMs += r;
                q.Cl || !d.o || t.fromCache || b.method == "HEAD" || a != sh || d.o(t.timeMs, t.data.byteLength, th(c), b, c);
                d.G && d.G(a, t, c);
                return t;
            }, function(q) {
                q && (q.severity = 2);
                throw q;
            });
            f = new oh(n.promise, function() {
                return n.abort();
            }, e);
            gh(this.A, f);
            return f;
        };
        function ph(a, b, c, d) {
            function e(h) {
                f = f.eb(function() {
                    c.body && (c.body = Gb(c.body));
                    return h(b, c, d);
                });
            }
            var f = bh(void 0);
            a.F && e(a.F);
            a = u(a.g);
            for(var g = a.next(); !g.done; g = a.next())e(g.value);
            return f.eb(void 0, function(h) {
                if (h instanceof T && h.code == 7001) throw h;
                throw new T(2, 1, 1006, h);
            });
        }
        function qh(a, b, c, d, e, f, g, h) {
            a.i.forceHTTP && (c.uris[f] = c.uris[f].replace("https://", "http://"));
            a.i.forceHTTPS && (c.uris[f] = c.uris[f].replace("http://", "https://"));
            f > 0 && a.H && a.H(b, d, c.uris[f], c.uris[f - 1]);
            var k = new lb(c.uris[f]), l = k.lc, m = !1;
            l || (l = location.protocol, l = l.slice(0, -1), mb(k, l), c.uris[f] = k.toString());
            l = l.toLowerCase();
            var n = (l = kh.get(l)) ? l.Vf : null;
            if (!n) return $g(new T(2, 1, 1E3, k));
            var q = l.$l;
            (k = a.l.get(k.Eb)) && (c.headers["common-access-token"] = k);
            var r = null, t = null, v = !1, w = !1, x;
            return ch(Xg(e)).eb(function() {
                if (a.j) return ah();
                x = Date.now();
                var y = 0;
                c.requestStartTime = Date.now();
                var z = n(c.uris[f], c, b, function(C, D, B) {
                    r && r.stop();
                    t && t.Z(E / 1E3);
                    a.o && b == sh && (y++, c.packetNumber = y, a.o(C, D, th(d), c, d), m = !0, h.g = B);
                }, function(C) {
                    w = !0;
                    c.timeToFirstByte = Date.now() - c.requestStartTime;
                    a.m && a.m(C, c, b);
                }, {
                    minBytesForProgressEvents: a.i.minBytesForProgressEvents
                });
                if (!q) return z;
                var A = c.retryParameters.connectionTimeout;
                A && (r = new Uf(function() {
                    v = !0;
                    z.abort();
                }), r.Z(A / 1E3));
                var E = c.retryParameters.stallTimeout;
                E && (t = new Uf(function() {
                    v = !0;
                    z.abort();
                }));
                return z;
            }).eb(function(y) {
                r && r.stop();
                t && t.stop();
                y.timeMs == void 0 && (y.timeMs = Date.now() - x);
                var z = y.headers["common-access-token"];
                if (z) {
                    var A = new lb(y.uri);
                    a.l.set(A.Eb, z);
                }
                z = {
                    response: y,
                    Cl: m
                };
                !w && a.m && a.m(y.headers, c, b);
                a.C && a.C(c, y);
                return z;
            }, function(y) {
                r && r.stop();
                t && t.stop();
                if (a.D) {
                    var z = null, A = 0;
                    y instanceof T && (z = y, y.code == 1001 && (A = y.data[1]));
                    a.D(c, z, A, v);
                }
                if (a.j) return ah();
                v && (y = new T(1, 1, 1003, c.uris[f], b));
                if (y instanceof T) {
                    if (y.code == 7001) throw y;
                    if (y.code == 1010) throw g;
                    if (y.severity == 1) {
                        z = (new Map).set("error", y);
                        z = new R("retry", z);
                        z.cancelable = !0;
                        a.dispatchEvent(z);
                        if (z.defaultPrevented) throw y;
                        f = (f + 1) % c.uris.length;
                        return qh(a, b, c, d, e, f, y, h);
                    }
                }
                throw y;
            });
        }
        function rh(a, b, c, d) {
            var e = bh(void 0);
            a = u(a.h);
            for(var f = a.next(), g = {}; !f.done; g = {
                Ej: void 0
            }, f = a.next())g.Ej = f.value, e = e.eb(function(h) {
                return function() {
                    var k = c.response;
                    k.data && (k.data = Gb(k.data));
                    return (0, h.Ej)(b, k, d);
                };
            }(g));
            return e.eb(function() {
                return c;
            }, function(h) {
                var k = 2;
                if (h instanceof T) {
                    if (h.code == 7001) throw h;
                    k = h.severity;
                }
                throw new T(k, 1, 1007, h);
            });
        }
        function th(a) {
            if (a) {
                var b = a.segment;
                a = a.stream;
                if (b && a && a.fastSwitching && b.hd) return !1;
            }
            return !0;
        }
        O("shaka.net.NetworkingEngine", hh);
        hh.prototype.request = hh.prototype.request;
        hh.prototype.destroy = hh.prototype.destroy;
        hh.makeRequest = mh;
        hh.defaultRetryParameters = function() {
            return Wg();
        };
        hh.prototype.clearCommonAccessTokenMap = hh.prototype.Ri;
        hh.prototype.clearAllResponseFilters = hh.prototype.xk;
        hh.prototype.unregisterResponseFilter = hh.prototype.Em;
        hh.prototype.registerResponseFilter = hh.prototype.fm;
        hh.prototype.clearAllRequestFilters = hh.prototype.wk;
        hh.prototype.unregisterRequestFilter = hh.prototype.Dm;
        hh.prototype.registerRequestFilter = hh.prototype.dm;
        hh.unregisterScheme = function(a) {
            kh.delete(a);
        };
        hh.registerScheme = ih;
        hh.prototype.configure = hh.prototype.configure;
        function nh() {
            this.g = 0;
        }
        hh.NumBytesRemainingClass = nh;
        function oh(a, b, c) {
            Zg.call(this, a, b);
            this.h = c;
        }
        oa(oh, Zg);
        hh.PendingRequest = oh;
        var sh = 1;
        hh.RequestType = {
            MANIFEST: 0,
            SEGMENT: sh,
            LICENSE: 2,
            APP: 3,
            TIMING: 4,
            SERVER_CERTIFICATE: 5,
            KEY: 6,
            ADS: 7,
            CONTENT_STEERING: 8,
            CMCD: 9
        };
        hh.AdvancedRequestType = {
            INIT_SEGMENT: 0,
            MEDIA_SEGMENT: 1,
            MEDIA_PLAYLIST: 2,
            MASTER_PLAYLIST: 3,
            MPD: 4,
            MSS: 5,
            MPD_PATCH: 6,
            MEDIATAILOR_SESSION_INFO: 7,
            MEDIATAILOR_TRACKING_INFO: 8,
            MEDIATAILOR_STATIC_RESOURCE: 9,
            MEDIATAILOR_TRACKING_EVENT: 10,
            INTERSTITIAL_ASSET_LIST: 11,
            INTERSTITIAL_AD_URL: 12
        };
        var jh = 3;
        hh.PluginPriority = {
            FALLBACK: 1,
            PREFERRED: 2,
            APPLICATION: jh
        };
        var kh = new Map;
        function uh(a) {
            this.g = !1;
            this.h = new Yg;
            this.i = a;
        }
        uh.prototype.destroy = function() {
            var a = this;
            if (this.g) return this.h;
            this.g = !0;
            return this.i().then(function() {
                a.h.resolve();
            }, function() {
                a.h.resolve();
            });
        };
        function vh(a, b) {
            if (a.g) {
                if (b instanceof T && b.code == 7003) throw b;
                throw new T(2, 7, 7003, b);
            }
        }
        function wh(a) {
            for(var b = new Map, c = u(Object.keys(a)), d = c.next(); !d.done; d = c.next())d = d.value, b.set(d, a[d]);
            return b;
        }
        function xh(a) {
            var b = {};
            a.forEach(function(c, d) {
                b[d] = c;
            });
            return b;
        }
        function yh(a, b) {
            this.h = Jb(a);
            this.i = b == zh;
            this.g = 0;
        }
        p = yh.prototype;
        p.Sa = function() {
            return this.g < this.h.byteLength;
        };
        p.Xa = function() {
            return this.g;
        };
        p.getLength = function() {
            return this.h.byteLength;
        };
        p.ea = function() {
            try {
                var a = this.h.getUint8(this.g);
                this.g += 1;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Ka = function() {
            try {
                var a = this.h.getUint16(this.g, this.i);
                this.g += 2;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Y = function() {
            try {
                var a = this.h.getUint32(this.g, this.i);
                this.g += 4;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Vh = function() {
            try {
                var a = this.h.getInt32(this.g, this.i);
                this.g += 4;
                return a;
            } catch (b) {
                throw Ah();
            }
        };
        p.Rd = function() {
            try {
                if (this.i) {
                    var a = this.h.getUint32(this.g, !0);
                    var b = this.h.getUint32(this.g + 4, !0);
                } else b = this.h.getUint32(this.g, !1), a = this.h.getUint32(this.g + 4, !1);
            } catch (c) {
                throw Ah();
            }
            if (b > 2097151) throw new T(2, 3, 3001);
            this.g += 8;
            return b * 4294967296 + a;
        };
        p.Wb = function(a, b) {
            if (this.g + a > this.h.byteLength) throw Ah();
            var c = Fb(this.h, this.g, a);
            this.g += a;
            return b ? new Uint8Array(c) : c;
        };
        p.skip = function(a) {
            if (this.g + a > this.h.byteLength) throw Ah();
            this.g += a;
        };
        p.Fj = function(a) {
            if (this.g < a) throw Ah();
            this.g -= a;
        };
        p.seek = function(a) {
            if (a < 0 || a > this.h.byteLength) throw Ah();
            this.g = a;
        };
        p.Qd = function() {
            for(var a = this.g; this.Sa() && this.h.getUint8(this.g) != 0;)this.g += 1;
            a = Fb(this.h, a, this.g - a);
            this.g += 1;
            return bc(a);
        };
        function Ah() {
            return new T(2, 3, 3E3);
        }
        O("shaka.util.DataViewReader", yh);
        yh.prototype.readTerminatedString = yh.prototype.Qd;
        yh.prototype.seek = yh.prototype.seek;
        yh.prototype.rewind = yh.prototype.Fj;
        yh.prototype.skip = yh.prototype.skip;
        yh.prototype.readBytes = yh.prototype.Wb;
        yh.prototype.readUint64 = yh.prototype.Rd;
        yh.prototype.readInt32 = yh.prototype.Vh;
        yh.prototype.readUint32 = yh.prototype.Y;
        yh.prototype.readUint16 = yh.prototype.Ka;
        yh.prototype.readUint8 = yh.prototype.ea;
        yh.prototype.getLength = yh.prototype.getLength;
        yh.prototype.getPosition = yh.prototype.Xa;
        yh.prototype.hasMoreData = yh.prototype.Sa;
        var zh = 1;
        yh.Endianness = {
            BIG_ENDIAN: 0,
            LITTLE_ENDIAN: zh
        };
        function Bh() {
            this.i = new Map;
            this.h = new Map;
            this.g = !1;
        }
        p = Bh.prototype;
        p.box = function(a, b) {
            a = Ch(a);
            this.i.set(a, Dh);
            this.h.set(a, b);
            return this;
        };
        p.boxes = function(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())this.box(c.value, b);
            return this;
        };
        p.qa = function(a, b) {
            a = Ch(a);
            this.i.set(a, Eh);
            this.h.set(a, b);
            return this;
        };
        p.stop = function() {
            this.g = !0;
        };
        p.parse = function(a, b, c) {
            a = new yh(a, 0);
            for(this.g = !1; a.Sa() && !this.g;)this.Nd(0, a, b, c);
        };
        p.Nd = function(a, b, c, d) {
            var e = b.Xa();
            if (d && e + 8 > b.getLength()) this.g = !0;
            else {
                var f = b.Y(), g = b.Y(), h = Fh(g), k = !1;
                switch(f){
                    case 0:
                        f = b.getLength() - e;
                        break;
                    case 1:
                        if (d && b.Xa() + 8 > b.getLength()) {
                            this.g = !0;
                            return;
                        }
                        f = b.Rd();
                        k = !0;
                }
                var l = this.h.get(g);
                if (l) {
                    var m = null, n = null;
                    if (this.i.get(g) == Eh) {
                        if (d && b.Xa() + 4 > b.getLength()) {
                            this.g = !0;
                            return;
                        }
                        n = b.Y();
                        m = n >>> 24;
                        n &= 16777215;
                    }
                    g = e + f;
                    c && g > b.getLength() && (g = b.getLength());
                    d && g > b.getLength() ? this.g = !0 : (g -= b.Xa(), b = g > 0 ? b.Wb(g, !1) : new Uint8Array(0), b = new yh(b, 0), l({
                        name: h,
                        parser: this,
                        partialOkay: c || !1,
                        stopOnPartial: d || !1,
                        version: m,
                        flags: n,
                        reader: b,
                        size: f,
                        start: e + a,
                        has64BitSize: k
                    }));
                } else b.skip(Math.min(e + f - b.Xa(), b.getLength() - b.Xa()));
            }
        };
        function Gh(a) {
            for(var b = Hh(a); a.reader.Sa() && !a.parser.g;)a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function Ih(a) {
            for(var b = Hh(a), c = a.reader.Y(), d = 0; d < c && (a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial), !a.parser.g); d++);
        }
        function Jh(a) {
            var b = Hh(a);
            for(a.reader.skip(78); a.reader.Sa() && !a.parser.g;)a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function Kh(a) {
            var b = Hh(a);
            a.reader.skip(8);
            var c = a.reader.Ka();
            a.reader.skip(6);
            c == 2 ? a.reader.skip(48) : a.reader.skip(12);
            for(c == 1 && a.reader.skip(16); a.reader.Sa() && !a.parser.g;)a.parser.Nd(a.start + b, a.reader, a.partialOkay, a.stopOnPartial);
        }
        function Lh(a, b) {
            return function(c) {
                a(c.reader.Wb(c.reader.getLength() - c.reader.Xa(), b));
            };
        }
        function Ch(a) {
            var b = 0;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())b = b << 8 | c.value.charCodeAt(0);
            return b;
        }
        function Fh(a) {
            return String.fromCharCode(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255);
        }
        function Hh(a) {
            return 8 + (a.has64BitSize ? 8 : 0) + (a.flags != null ? 4 : 0);
        }
        O("shaka.util.Mp4Parser", Bh);
        Bh.headerSize = Hh;
        Bh.typeToString = Fh;
        Bh.allData = Lh;
        Bh.audioSampleEntry = Kh;
        Bh.visualSampleEntry = Jh;
        Bh.sampleDescription = Ih;
        Bh.children = Gh;
        Bh.prototype.parseNext = Bh.prototype.Nd;
        Bh.prototype.parse = Bh.prototype.parse;
        Bh.prototype.stop = Bh.prototype.stop;
        Bh.prototype.fullBox = Bh.prototype.qa;
        Bh.prototype.boxes = Bh.prototype.boxes;
        Bh.prototype.box = Bh.prototype.box;
        var Dh = 0, Eh = 1;
        function Mh(a) {
            var b = this;
            this.g = [];
            this.data = [];
            (new Bh).boxes([
                "moov",
                "moof"
            ], Gh).qa("pssh", function(c) {
                if (!(c.version > 1)) {
                    var d = Fb(c.reader.h, -12, c.size);
                    b.data.push(d);
                    c = c.reader.Wb(16, !1);
                    b.g.push(sc(c));
                }
            }).parse(a);
        }
        function Nh(a, b, c, d) {
            var e = a.length, f = 12 + b.length + 4 + e;
            d > 0 && (f += 4 + 16 * c.size);
            var g = new Uint8Array(f), h = Jb(g), k = 0;
            h.setUint32(k, f);
            k += 4;
            h.setUint32(k, 1886614376);
            k += 4;
            d < 1 ? h.setUint32(k, 0) : h.setUint32(k, 16777216);
            k += 4;
            g.set(b, k);
            k += b.length;
            if (d > 0) for(h.setUint32(k, c.size), k += 4, b = u(c), c = b.next(); !c.done; c = b.next())c = rc(c.value), g.set(c, k), k += c.length;
            h.setUint32(k, e);
            g.set(a, k + 4);
            return g;
        }
        function Oh(a) {
            var b = this;
            this.F = a;
            this.l = this.C = null;
            this.W = this.R = !1;
            this.J = 0;
            this.g = null;
            this.o = new fd;
            this.i = new Map;
            this.V = [];
            this.D = new Map;
            this.K = !1;
            this.m = new Yg;
            this.h = null;
            this.A = function(c) {
                c.severity == 2 && b.m.reject(c);
                a.onError(c);
            };
            this.X = new Map;
            this.$ = new Map;
            this.L = new Uf(function() {
                return Ph(b);
            });
            this.P = !1;
            this.M = [];
            this.ba = !1;
            this.G = new Uf(function() {
                Qh(b);
            });
            this.m.catch(function() {});
            this.j = new uh(function() {
                return Rh(b);
            });
            this.O = !1;
            this.H = this.I = null;
            this.S = function() {
                return !1;
            };
        }
        p = Oh.prototype;
        p.destroy = function() {
            return this.j.destroy();
        };
        function Rh(a) {
            var b;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        return a.o.release(), a.o = null, a.m.reject(), a.G.stop(), a.G = null, a.L.stop(), a.L = null, c.g(Sh(a), 2);
                    case 2:
                        if (!a.l) {
                            c.B(3);
                            break;
                        }
                        c.m(4);
                        return c.g(a.l.setMediaKeys(null), 6);
                    case 6:
                        c.o(5);
                        break;
                    case 4:
                        b = c.l(), Za("DrmEngine.destroyNow_ exception", b);
                    case 5:
                        a.l = null;
                    case 3:
                        a.g = null, a.C = null, a.D = new Map, a.h = null, a.A = function() {}, a.F = null, a.O = !1, a.I = null, c.j();
                }
            });
        }
        p.configure = function(a, b) {
            this.h = a;
            b && (this.S = b);
            this.G && this.R && this.g && this.G.xa(this.h.updateExpirationTime);
        };
        function Th(a, b, c) {
            a.W = !0;
            a.D = new Map;
            a.P = c;
            return Uh(a, b, !1);
        }
        function Vh(a, b, c, d) {
            d = d === void 0 ? !0 : d;
            a.D = new Map;
            c = u(c);
            for(var e = c.next(); !e.done; e = c.next())a.D.set(e.value, {
                initData: null,
                initDataType: null
            });
            c = u(a.h.persistentSessionsMetadata);
            for(e = c.next(); !e.done; e = c.next())e = e.value, a.D.set(e.sessionId, {
                initData: e.initData,
                initDataType: e.initDataType
            });
            a.P = a.D.size > 0;
            return Uh(a, b, d);
        }
        function Wh(a, b, c, d, e, f) {
            var g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return g = [], f.length && g.push(f[0].contentType), e.length && g.push(e[0].contentType), h = function(q) {
                    q = yc(b, q, null);
                    q.licenseServerUri = c;
                    q.serverCertificate = d;
                    q.persistentStateRequired = !0;
                    q.sessionType = "persistent-license";
                    return q;
                }, k = Pg(g), k.video && (l = h(f[0].encryptionScheme || ""), k.video.drmInfos.push(l)), k.audio && (m = h(e[0].encryptionScheme || ""), k.audio.drmInfos.push(m)), n.g(kg([
                    k
                ], !0, a.O, []), 2);
                vh(a.j);
                return n.return(Xh(a, [
                    k
                ]));
            });
        }
        function Uh(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A;
            return H(function(E) {
                if (E.h == 1) {
                    Yh(a.h.clearKeys, b);
                    d = b.some(function(C) {
                        return C.video && C.video.drmInfos.length || C.audio && C.audio.drmInfos.length ? !0 : !1;
                    });
                    e = wh(a.h.servers);
                    f = wh(a.h.advanced || {});
                    !d && c && Zh(b, e);
                    g = new WeakSet;
                    h = u(b);
                    for(k = h.next(); !k.done; k = h.next())for(l = k.value, m = $h(l), n = u(m), q = n.next(); !q.done; q = n.next())r = q.value, g.has(r) || (g.add(r), ai(r, e, f, a.h.keySystemsMapping));
                    t = function(C, D) {
                        var B = [];
                        C = u(C);
                        for(var J = C.next(); !J.done; J = C.next()){
                            J = J.value;
                            var F = J[D] || f.has(J.keySystem) && f.get(J.keySystem)[D] || "";
                            F == "" && Pb(J.keySystem) && (D == "audioRobustness" ? F = [
                                a.h.defaultAudioRobustnessForWidevine
                            ] : D == "videoRobustness" && (F = [
                                a.h.defaultVideoRobustnessForWidevine
                            ]));
                            if (typeof F === "string") B.push(J);
                            else if (Array.isArray(F)) {
                                F.length === 0 && (F = [
                                    ""
                                ]);
                                F = u(F);
                                for(var I = F.next(); !I.done; I = F.next()){
                                    var K = {};
                                    B.push(Object.assign({}, J, (K[D] = I.value, K)));
                                }
                            }
                        }
                        return B;
                    };
                    v = new WeakSet;
                    w = u(b);
                    for(x = w.next(); !x.done; x = w.next())y = x.value, y.video && !v.has(y.video) && (y.video.drmInfos = t(y.video.drmInfos, "videoRobustness"), y.video.drmInfos = t(y.video.drmInfos, "audioRobustness"), v.add(y.video)), y.audio && !v.has(y.audio) && (y.audio.drmInfos = t(y.audio.drmInfos, "videoRobustness"), y.audio.drmInfos = t(y.audio.drmInfos, "audioRobustness"), v.add(y.audio));
                    return E.g(kg(b, a.P, a.O, a.h.preferredKeySystems), 2);
                }
                vh(a.j);
                z = d || e.size > 0;
                if (!z) return a.R = !0, E.return(Promise.resolve());
                A = Xh(a, b);
                return E.return(d ? A : A.catch(function() {}));
            });
        }
        function bi(a) {
            var b;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        if (a.l.mediaKeys) return c.return();
                        if (!a.I) {
                            c.B(2);
                            break;
                        }
                        return c.g(a.I, 3);
                    case 3:
                        return vh(a.j), c.return();
                    case 2:
                        return c.m(4), a.I = a.l.setMediaKeys(a.C), c.g(a.I, 6);
                    case 6:
                        c.o(5);
                        break;
                    case 4:
                        b = c.l(), a.A(new T(2, 6, 6003, b.message));
                    case 5:
                        vh(a.j), c.j();
                }
            });
        }
        function ci(a, b) {
            return H(function(c) {
                if (c.h == 1) return c.g(bi(a), 2);
                di(a, b.initDataType, Fb(b.initData));
                c.j();
            });
        }
        p.Ob = function(a) {
            var b = this, c, d;
            return H(function(e) {
                if (e.h == 1) {
                    if (b.l === a) return e.return();
                    if (!b.C) return b.o.ra(a, "encrypted", function() {
                        b.A(new T(2, 6, 6010));
                    }), e.return();
                    b.l = a;
                    b.h.delayLicenseRequestUntilPlayed && b.o.ra(b.l, "play", function() {
                        for(var f = u(b.M), g = f.next(); !g.done; g = f.next())ei(b, g.value);
                        b.ba = !0;
                        b.M = [];
                    });
                    b.l.remote ? (b.o.u(b.l.remote, "connect", function() {
                        return Sh(b);
                    }), b.o.u(b.l.remote, "connecting", function() {
                        return Sh(b);
                    }), b.o.u(b.l.remote, "disconnect", function() {
                        return Sh(b);
                    })) : "webkitCurrentPlaybackTargetIsWireless" in b.l && b.o.u(b.l, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                        return Sh(b);
                    });
                    b.H = b.g ? b.g.initData.find(function(f) {
                        return f.initData.length > 0;
                    }) || null : null;
                    c = b.g.keySystem;
                    return (d = Xb().Nh(c)) || !b.H && b.g.keySystem === "com.apple.fps" && !b.D.size ? e.B(2) : e.g(bi(b), 2);
                }
                fi(b).catch(function() {});
                !d && (b.H || b.D.size || b.h.parseInbandPsshEnabled) || b.o.u(b.l, "encrypted", function(f) {
                    return ci(b, f);
                });
                e.j();
            });
        };
        function gi(a) {
            var b, c, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        if (!a.C || !a.g) return g.return();
                        if (!a.g.serverCertificateUri || a.g.serverCertificate && a.g.serverCertificate.length) {
                            g.B(2);
                            break;
                        }
                        b = mh([
                            a.g.serverCertificateUri
                        ], a.h.retryParameters);
                        g.m(3);
                        c = a.F.Cc.request(5, b, {
                            isPreload: a.S()
                        });
                        return g.g(c.promise, 5);
                    case 5:
                        d = g.i;
                        a.g.serverCertificate = Fb(d.data);
                        g.o(4);
                        break;
                    case 3:
                        throw e = g.l(), new T(2, 6, 6017, e);
                    case 4:
                        if (a.j.g) return g.return();
                    case 2:
                        if (!a.g.serverCertificate || !a.g.serverCertificate.length) return g.return();
                        g.m(6);
                        return g.g(a.C.setServerCertificate(a.g.serverCertificate), 8);
                    case 8:
                        g.o(0);
                        break;
                    case 6:
                        throw f = g.l(), new T(2, 6, 6004, f.message);
                }
            });
        }
        function hi(a, b) {
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) return f.g(ii(a, b, {
                    initData: null,
                    initDataType: null
                }), 2);
                if (f.h != 3) {
                    c = f.i;
                    if (!c) return f.return();
                    d = [];
                    if (e = a.i.get(c)) e.Lb = new Yg, d.push(e.Lb);
                    d.push(c.remove());
                    return f.g(Promise.all(d), 3);
                }
                a.i.delete(c);
                f.j();
            });
        }
        function fi(a) {
            var b, c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    if (!a.D.size) return g.B(2);
                    a.D.forEach(function(h, k) {
                        ii(a, k, h);
                    });
                    return g.g(a.m, 3);
                }
                if (g.h != 2) {
                    b = a.g && a.g.keyIds || new Set([]);
                    if (b.size > 0 && ji(a)) return g.return(a.m);
                    a.K = !1;
                    a.m = new Yg;
                    a.m.catch(function() {});
                }
                c = (a.g ? a.g.initData : []) || [];
                d = u(c);
                for(e = d.next(); !e.done; e = d.next())f = e.value, di(a, f.initDataType, f.initData);
                ki(a) && a.m.resolve();
                return g.return(a.m);
            });
        }
        function di(a, b, c) {
            if (c.length) {
                try {
                    c = a.h.initDataTransform(c, b, a.g);
                } catch (g) {
                    b = g;
                    g instanceof T || (b = new T(2, 6, 6016, g));
                    a.A(b);
                    return;
                }
                if (a.h.ignoreDuplicateInitData) {
                    var d = a.i.values();
                    d = u(d);
                    for(var e = d.next(); !e.done; e = d.next())if (Eb(c, e.value.initData)) return;
                    var f = !1;
                    a.D.forEach(function(g) {
                        !f && Eb(c, g.initData) && (f = !0);
                    });
                    if (f) return;
                }
                a.K = !0;
                a.i.size > 0 && ki(a) && (a.m.resolve(), a.K = !1, a.m = new Yg, a.m.catch(function() {}));
                li(a, b, c, a.g.sessionType);
            }
        }
        function pi(a) {
            a = a.i.keys();
            a = gb(a, function(b) {
                return b.sessionId;
            });
            return Array.from(a);
        }
        p.oh = function() {
            var a = this, b = this.i.keys();
            b = gb(b, function(c) {
                var d = a.i.get(c);
                return {
                    sessionId: c.sessionId,
                    sessionType: d.type,
                    initData: d.initData,
                    initDataType: d.initDataType
                };
            });
            return Array.from(b);
        };
        p.oe = function() {
            var a = Infinity, b = this.i.keys();
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())c = c.value, isNaN(c.expiration) || (a = Math.min(a, c.expiration));
            return a;
        };
        function qi(a) {
            return a.J ? a.J : NaN;
        }
        p.uf = function() {
            return xh(this.$);
        };
        function Xh(a, b) {
            var c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        c = new Map;
                        d = ri(a, b, c);
                        if (!d) {
                            if (!navigator.requestMediaKeySystemAccess) throw new T(2, 6, 6020);
                            throw new T(2, 6, 6001);
                        }
                        vh(a.j);
                        l.m(2);
                        d.getConfiguration();
                        e = a.h.keySystemsMapping[d.keySystem] || d.keySystem;
                        a.g = si(a, e, c.get(e));
                        if (!a.g.licenseServerUri) throw new T(2, 6, 6012, a.g.keySystem);
                        return l.g(d.createMediaKeys(), 4);
                    case 4:
                        f = l.i;
                        vh(a.j);
                        a.C = f;
                        if (!(a.h.minHdcpVersion != "" && "getStatusForPolicy" in a.C)) {
                            l.B(5);
                            break;
                        }
                        l.m(6);
                        return l.g(a.C.getStatusForPolicy({
                            minHdcpVersion: a.h.minHdcpVersion
                        }), 8);
                    case 8:
                        g = l.i;
                        if (g != "usable") throw new T(2, 6, 6018);
                        vh(a.j);
                        l.o(5, 2);
                        break;
                    case 6:
                        h = l.l(2);
                        if (h instanceof T) throw h;
                        throw new T(2, 6, 6019, h.message);
                    case 5:
                        return a.R = !0, a.G.xa(a.h.updateExpirationTime), l.g(gi(a), 9);
                    case 9:
                        vh(a.j);
                        l.o(0);
                        break;
                    case 2:
                        k = l.l();
                        vh(a.j, k);
                        a.g = null;
                        if (k instanceof T) throw k;
                        throw new T(2, 6, 6002, k.message);
                }
            });
        }
        function ri(a, b, c) {
            for(var d = u(b), e = d.next(); !e.done; e = d.next()){
                e = u($h(e.value));
                for(var f = e.next(); !f.done; f = e.next())f = f.value, c.has(f.keySystem) || c.set(f.keySystem, []), c.get(f.keySystem).push(f);
            }
            if (c.size == 1 && c.has("")) throw new T(2, 6, 6E3);
            d = a.h.preferredKeySystems;
            d.length || (e = wh(a.h.servers), e.size == 1 && (d = Array.from(e.keys())));
            e = u(d);
            var g = e.next();
            for(f = {}; !g.done; f = {
                zj: void 0
            }, g = e.next()){
                f.zj = g.value;
                g = u(b);
                for(var h = g.next(); !h.done; h = g.next())if (h = h.value.decodingInfos.find(function(n) {
                    return function(q) {
                        return q.supported && q.keySystemAccess != null && q.keySystemAccess.keySystem == n.zj;
                    };
                }(f))) return h.keySystemAccess;
            }
            e = u([
                !0,
                !1
            ]);
            for(f = e.next(); !f.done; f = e.next())for(f = f.value, g = u(b), h = g.next(); !h.done; h = g.next()){
                h = u(h.value.decodingInfos);
                for(var k = h.next(); !k.done; k = h.next())if (k = k.value, k.supported && k.keySystemAccess) {
                    var l = k.keySystemAccess.keySystem;
                    if (!d.includes(l)) {
                        var m = c.get(l);
                        !m && a.h.keySystemsMapping[l] && (m = c.get(a.h.keySystemsMapping[l]));
                        l = u(m);
                        for(m = l.next(); !m.done; m = l.next())if (!!m.value.licenseServerUri == f) return k.keySystemAccess;
                    }
                }
            }
            return null;
        }
        function ti(a) {
            ki(a) && a.m.resolve();
        }
        function ui(a, b) {
            new Uf(function() {
                b.loaded = !0;
                ti(a);
            }).Z(vi);
        }
        function ii(a, b, c) {
            var d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        try {
                            d = a.C.createSession("persistent-license");
                        } catch (n) {
                            return e = new T(2, 6, 6005, n.message), a.A(e), m.return(Promise.reject(e));
                        }
                        a.o.u(d, "message", function(n) {
                            wi(a) ? a.M.push(n) : ei(a, n);
                        });
                        a.o.u(d, "keystatuseschange", function(n) {
                            return xi(a, n);
                        });
                        f = {
                            initData: c.initData,
                            initDataType: c.initDataType,
                            loaded: !1,
                            Qh: Infinity,
                            Lb: null,
                            type: "persistent-license"
                        };
                        a.i.set(d, f);
                        m.m(2);
                        return m.g(d.load(b), 4);
                    case 4:
                        return g = m.i, vh(a.j), g || (a.i.delete(d), h = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.A(new T(h, 6, 6013)), f.loaded = !0), ui(a, f), ti(a), m.return(d);
                    case 2:
                        k = m.l(), vh(a.j, k), a.i.delete(d), l = a.h.persistentSessionOnlinePlayback ? 1 : 2, a.A(new T(l, 6, 6005, k.message)), f.loaded = !0, ti(a);
                    case 3:
                        return m.return(Promise.resolve());
                }
            });
        }
        function li(a, b, c, d) {
            try {
                var e = a.C.createSession(d);
            } catch (f) {
                a.A(new T(2, 6, 6005, f.message));
                return;
            }
            a.o.u(e, "message", function(f) {
                wi(a) ? a.M.push(f) : ei(a, f);
            });
            a.o.u(e, "keystatuseschange", function(f) {
                return xi(a, f);
            });
            a.i.set(e, {
                initData: c,
                initDataType: b,
                loaded: !1,
                Qh: Infinity,
                Lb: null,
                type: d
            });
            a.h.logLicenseExchange && mc(c);
            e.generateRequest(b, c).catch(function(f) {
                if (!a.j.g) {
                    a.i.delete(e);
                    var g = f.errorCode;
                    if (g && g.systemCode) {
                        var h = g.systemCode;
                        h < 0 && (h += 4294967296);
                        h = "0x" + h.toString(16);
                    }
                    a.A(new T(2, 6, 6006, f.message, f, h));
                }
            });
        }
        function wi(a) {
            return a.l ? a.h.delayLicenseRequestUntilPlayed && a.l.paused && !a.ba : !a.W && a.h.delayLicenseRequestUntilPlayed;
        }
        function yi(a) {
            return H(function(b) {
                return b.h == 1 ? !a.K || wi(a) ? b.B(0) : b.g(a.m, 3) : b.g(Promise.all(a.V.map(function(c) {
                    return c.promise;
                })), 0);
            });
        }
        function ei(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x;
            H(function(y) {
                switch(y.h){
                    case 1:
                        c = b.target;
                        a.h.logLicenseExchange && mc(b.message);
                        d = a.i.get(c);
                        e = a.g.licenseServerUri;
                        f = a.h.advanced[a.g.keySystem];
                        b.messageType == "individualization-request" && f && f.individualizationServer && (e = f.individualizationServer);
                        g = mh([
                            e
                        ], a.h.retryParameters);
                        g.body = b.message;
                        g.method = "POST";
                        g.licenseRequestType = b.messageType;
                        g.sessionId = c.sessionId;
                        g.drmInfo = a.g;
                        d && (g.initData = d.initData, g.initDataType = d.initDataType);
                        if (f && f.headers) for(h in f.headers)g.headers[h] = f.headers[h];
                        if (Ob(a.g.keySystem)) {
                            var z = g, A = a.g;
                            try {
                                var E = ec(z.body);
                                if (E) {
                                    var C = JSON.parse(E);
                                    C.type || (C.type = A.sessionType, z.body = hc(JSON.stringify(C)));
                                }
                            } catch (D) {}
                        }
                        if (Qb(a.g.keySystem)) {
                            if (z = cc(g.body, !0, !0), z.includes("PlayReadyKeyMessage")) {
                                z = ae(z, "PlayReadyKeyMessage");
                                A = me(z, "HttpHeader");
                                A = u(A);
                                for(E = A.next(); !E.done; E = A.next())C = E.value, E = me(C, "name")[0], C = me(C, "value")[0], g.headers[ke(E)] = ke(C);
                                z = me(z, "Challenge")[0];
                                g.body = qc(ke(z));
                            } else g.headers["Content-Type"] = "text/xml; charset=utf-8";
                        }
                        k = Date.now();
                        y.m(2);
                        m = a.F.Cc.request(2, g, {
                            isPreload: a.S()
                        });
                        a.V.push(m);
                        return y.g(m.promise, 4);
                    case 4:
                        l = y.i;
                        ad(a.V, m);
                        y.o(3);
                        break;
                    case 2:
                        n = y.l();
                        if (a.j.g) return y.return();
                        q = {
                            sessionId: c.sessionId,
                            sessionType: d.type,
                            initData: d.initData,
                            initDataType: d.initDataType
                        };
                        r = new T(2, 6, 6007, n, q);
                        a.i.size == 1 ? (a.A(r), d && d.Lb && d.Lb.reject(r)) : (d && d.Lb && d.Lb.reject(r), a.i.delete(c), ki(a) && (a.m.resolve(), a.L.Z(.1)));
                        return y.return();
                    case 3:
                        if (a.j.g) return y.return();
                        a.J += (Date.now() - k) / 1E3;
                        a.h.logLicenseExchange && mc(l.data);
                        y.m(5);
                        return y.g(c.update(l.data), 7);
                    case 7:
                        y.o(6);
                        break;
                    case 5:
                        return v = (t = y.l()) && t.message || String(t), w = new T(2, 6, 6008, v), a.A(w), d && d.Lb && d.Lb.reject(w), y.return();
                    case 6:
                        if (a.j.g) return y.return();
                        x = new R("drmsessionupdate");
                        a.F.onEvent(x);
                        d && (d.Lb && d.Lb.resolve(), ui(a, d));
                        y.j();
                }
            });
        }
        function xi(a, b) {
            b = b.target;
            var c = a.i.get(b), d = !1;
            b.keyStatuses.forEach(function(f, g) {
                if (typeof g == "string") {
                    var h = g;
                    g = f;
                    f = h;
                }
                h = Xb();
                if (Qb(a.g.keySystem) && g.byteLength == 16 && h.cg()) {
                    h = Jb(g);
                    var k = h.getUint32(0, !0), l = h.getUint16(4, !0), m = h.getUint16(6, !0);
                    h.setUint32(0, k, !1);
                    h.setUint16(4, l, !1);
                    h.setUint16(6, m, !1);
                }
                f != "status-pending" && (c.loaded = !0);
                f == "expired" && (d = !0);
                g = sc(g).slice(0, 32);
                a.X.set(g, f);
            });
            var e = b.expiration - Date.now();
            (e < 0 || d && e < 1E3) && c && !c.Lb && (a.i.delete(b), zi(b));
            ki(a) && (a.m.resolve(), a.L.Z(Ai));
        }
        function Ph(a) {
            var b = a.X, c = a.$;
            c.clear();
            b.forEach(function(d, e) {
                return c.set(e, d);
            });
            b = Array.from(c.values());
            b.length && b.every(function(d) {
                return d == "expired";
            }) && a.A(new T(2, 6, 6014));
            a.F.Uf(xh(c));
        }
        function Ei() {
            var a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K;
            return H(function(N) {
                if (N.h == 1) {
                    a = "org.w3.clearkey com.widevine.alpha com.widevine.alpha.experiment com.microsoft.playready com.microsoft.playready.hardware com.microsoft.playready.recommendation com.microsoft.playready.recommendation.3000 com.microsoft.playready.recommendation.3000.clearlead com.chromecast.playready com.apple.fps.1_0 com.apple.fps com.huawei.wiseplay".split(" ");
                    if (!(window1.MediaKeys && window1.navigator && window1.navigator.requestMediaKeySystemAccess && window1.MediaKeySystemAccess && window1.MediaKeySystemAccess.prototype.getConfiguration)) {
                        b = {};
                        c = u(a);
                        for(d = c.next(); !d.done; d = c.next())e = d.value, b[e] = null;
                        return N.return(b);
                    }
                    f = "1.0 1.1 1.2 1.3 1.4 2.0 2.1 2.2 2.3".split(" ");
                    g = [
                        "SW_SECURE_CRYPTO",
                        "SW_SECURE_DECODE",
                        "HW_SECURE_CRYPTO",
                        "HW_SECURE_DECODE",
                        "HW_SECURE_ALL"
                    ];
                    h = [
                        "150",
                        "2000",
                        "3000"
                    ];
                    k = {
                        "com.widevine.alpha": g,
                        "com.widevine.alpha.experiment": g,
                        "com.microsoft.playready.recommendation": h
                    };
                    l = [
                        {
                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                        },
                        {
                            contentType: 'video/webm; codecs="vp8"'
                        }
                    ];
                    m = [
                        {
                            contentType: 'audio/mp4; codecs="mp4a.40.2"'
                        },
                        {
                            contentType: 'audio/webm; codecs="opus"'
                        }
                    ];
                    n = {
                        videoCapabilities: l,
                        audioCapabilities: m,
                        initDataTypes: [
                            "cenc",
                            "sinf",
                            "skd",
                            "keyids"
                        ]
                    };
                    q = [
                        null,
                        "cenc",
                        "cbcs"
                    ];
                    r = new Map;
                    t = Xb();
                    v = function(P, M, L) {
                        var Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa;
                        return H(function(Ga) {
                            switch(Ga.h){
                                case 1:
                                    return Ga.m(2), Ga.g(M.createMediaKeys(), 5);
                                case 5:
                                    Q = Ga.i;
                                case 4:
                                    Ga.o(3);
                                    break;
                                case 2:
                                    return Ga.l(), Ga.return();
                                case 3:
                                    Z = (S = M.getConfiguration().sessionTypes) ? S.includes("persistent-license") : !1;
                                    t.sj() && (Z = !1);
                                    pa = M.getConfiguration().videoCapabilities;
                                    va = M.getConfiguration().audioCapabilities;
                                    Ca = {
                                        persistentState: Z,
                                        encryptionSchemes: [],
                                        videoRobustnessLevels: [],
                                        audioRobustnessLevels: [],
                                        minHdcpVersions: []
                                    };
                                    r.get(P) ? Ca = r.get(P) : r.set(P, Ca);
                                    (ua = pa[0].encryptionScheme) && !Ca.encryptionSchemes.includes(ua) && Ca.encryptionSchemes.push(ua);
                                    (xa = pa[0].robustness) && !Ca.videoRobustnessLevels.includes(xa) && Ca.videoRobustnessLevels.push(xa);
                                    (Da = va[0].robustness) && !Ca.audioRobustnessLevels.includes(Da) && Ca.audioRobustnessLevels.push(Da);
                                    if (!(L && "getStatusForPolicy" in Q)) {
                                        Ga.B(0);
                                        break;
                                    }
                                    Ka = u(f);
                                    wa = Ka.next();
                                case 7:
                                    if (wa.done) {
                                        Ga.B(0);
                                        break;
                                    }
                                    Ja = wa.value;
                                    if (Ca.minHdcpVersions.includes(Ja)) {
                                        Ga.B(8);
                                        break;
                                    }
                                    return Ga.g(Q.getStatusForPolicy({
                                        minHdcpVersion: Ja
                                    }), 10);
                                case 10:
                                    if (Aa = Ga.i, Aa == "usable") Ca.minHdcpVersions.includes(Ja) || Ca.minHdcpVersions.push(Ja);
                                    else {
                                        Ga.B(0);
                                        break;
                                    }
                                case 8:
                                    wa = Ka.next(), Ga.B(7);
                            }
                        });
                    };
                    w = function(P, M, L, Q, S) {
                        S = S === void 0 ? !1 : S;
                        var Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa;
                        return H(function(Ga) {
                            switch(Ga.h){
                                case 1:
                                    Ga.m(2);
                                    Z = Xd(n);
                                    pa = u(Z.videoCapabilities);
                                    for(va = pa.next(); !va.done; va = pa.next())Ca = va.value, Ca.encryptionScheme = M, Ca.robustness = L;
                                    ua = u(Z.audioCapabilities);
                                    for(xa = ua.next(); !xa.done; xa = ua.next())Da = xa.value, Da.encryptionScheme = M, Da.robustness = Q;
                                    Ka = Xd(Z);
                                    Ka.persistentState = "required";
                                    Ka.sessionTypes = [
                                        "persistent-license"
                                    ];
                                    wa = [
                                        Ka,
                                        Z
                                    ];
                                    Aa = Xb();
                                    return Aa.Pa() == "MOBILE" ? Ga.g($f(5, navigator.requestMediaKeySystemAccess(P, wa)), 7) : Ga.g(navigator.requestMediaKeySystemAccess(P, wa), 6);
                                case 6:
                                    Ja = Ga.i;
                                    Ga.B(5);
                                    break;
                                case 7:
                                    Ja = Ga.i;
                                case 5:
                                    return Ga.g(v(P, Ja, S), 8);
                                case 8:
                                    Ga.o(0);
                                    break;
                                case 2:
                                    Ga.l(), Ga.j();
                            }
                        });
                    };
                    x = function(P) {
                        return Xb().Ma() === "WEBKIT" && Ob(P) ? !1 : !0;
                    };
                    y = [];
                    z = u(a);
                    for(A = z.next(); !A.done; A = z.next())if (E = A.value, r.set(E, null), x(E)) {
                        C = !0;
                        D = u(q);
                        for(B = D.next(); !B.done; B = D.next())J = B.value, y.push(w(E, J, "", "", C)), C = !1;
                        F = u(k[E] || []);
                        for(I = F.next(); !I.done; I = F.next())K = I.value, y.push(w(E, null, K, "")), y.push(w(E, null, "", K));
                    }
                    return N.g(Promise.all(y), 2);
                }
                return N.return(xh(r));
            });
        }
        function zi(a) {
            return H(function(b) {
                if (b.h == 1) return b.m(2), b.g($f(Fi, Promise.all([
                    a.close().catch(function() {}),
                    a.closed
                ])), 4);
                if (b.h != 2) return b.o(0);
                b.l();
                b.j();
            });
        }
        function Sh(a) {
            var b;
            return H(function(c) {
                b = Array.from(a.i.entries());
                a.i.clear();
                return c.g(Promise.all(b.map(function(d) {
                    d = u(d);
                    var e = d.next().value;
                    var f = d.next().value;
                    return H(function(g) {
                        if (g.h == 1) return g.m(2), a.W || a.D.has(e.sessionId) || f.type !== "persistent-license" || a.h.persistentSessionOnlinePlayback ? g.g(zi(e), 5) : g.g(e.remove(), 5);
                        if (g.h != 2) return g.o(0);
                        g.l();
                        g.j();
                    });
                })), 0);
            });
        }
        function $h(a) {
            return (a.video ? a.video.drmInfos : []).concat(a.audio ? a.audio.drmInfos : []);
        }
        function Qh(a) {
            a.i.forEach(function(b, c) {
                var d = b.Qh, e = c.expiration;
                isNaN(e) && (e = Infinity);
                e != d && (a.F.onExpirationUpdated(c.sessionId, e), b.Qh = e);
            });
        }
        function ki(a) {
            a = a.i.values();
            return hb(a, function(b) {
                return b.loaded;
            });
        }
        function ji(a) {
            for(var b = u(a.g && a.g.keyIds || new Set([])), c = b.next(); !c.done; c = b.next())if (a.X.get(c.value) !== "usable") return !1;
            return !0;
        }
        function Zh(a, b) {
            var c = [];
            b.forEach(function(d, e) {
                c.push({
                    keySystem: e,
                    licenseServerUri: d,
                    distinctiveIdentifierRequired: !1,
                    persistentStateRequired: !1,
                    audioRobustness: "",
                    videoRobustness: "",
                    serverCertificate: null,
                    serverCertificateUri: "",
                    initData: [],
                    keyIds: new Set
                });
            });
            a = u(a);
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.video && (b.video.drmInfos = c), b.audio && (b.audio.drmInfos = c);
        }
        function si(a, b, c) {
            var d = [], e = [], f = [], g = [], h = [], k = new Set, l = new Set;
            Gi(c, d, e, g, f, h, k, l);
            a = a.P ? "persistent-license" : "temporary";
            b = {
                keySystem: b,
                encryptionScheme: d[0],
                licenseServerUri: e[0],
                distinctiveIdentifierRequired: c[0].distinctiveIdentifierRequired,
                persistentStateRequired: c[0].persistentStateRequired,
                sessionType: c[0].sessionType || a,
                audioRobustness: c[0].audioRobustness || "",
                videoRobustness: c[0].videoRobustness || "",
                serverCertificate: g[0],
                serverCertificateUri: f[0],
                initData: h,
                keyIds: k,
                mediaTypes: c[0].mediaTypes
            };
            l.size > 0 && (b.keySystemUris = l);
            c = u(c);
            for(l = c.next(); !l.done; l = c.next())l = l.value, l.distinctiveIdentifierRequired && (b.distinctiveIdentifierRequired = l.distinctiveIdentifierRequired), l.persistentStateRequired && (b.persistentStateRequired = l.persistentStateRequired);
            return b;
        }
        function Gi(a, b, c, d, e, f, g, h) {
            var k = [];
            a = u(a);
            for(var l = a.next(), m = {}; !l.done; m = {
                Ua: void 0
            }, l = a.next()){
                m.Ua = l.value;
                b.includes(m.Ua.encryptionScheme) || b.push(m.Ua.encryptionScheme);
                Ob(m.Ua.keySystem) && m.Ua.licenseServerUri.startsWith("data:application/json;base64,") ? k.includes(m.Ua.licenseServerUri) || k.push(m.Ua.licenseServerUri) : c.includes(m.Ua.licenseServerUri) || c.push(m.Ua.licenseServerUri);
                e.includes(m.Ua.serverCertificateUri) || e.push(m.Ua.serverCertificateUri);
                m.Ua.serverCertificate && (d.some(function(r) {
                    return function(t) {
                        return Eb(t, r.Ua.serverCertificate);
                    };
                }(m)) || d.push(m.Ua.serverCertificate));
                if (m.Ua.initData) {
                    l = u(m.Ua.initData);
                    for(var n = l.next(), q = {}; !n.done; q = {
                        Eh: void 0
                    }, n = l.next())q.Eh = n.value, f.some(function(r) {
                        return function(t) {
                            var v = r.Eh;
                            return t.keyId && t.keyId == v.keyId ? !0 : t.initDataType == v.initDataType && Eb(t.initData, v.initData);
                        };
                    }(q)) || f.push(q.Eh);
                }
                if (m.Ua.keyIds) for(l = u(m.Ua.keyIds), n = l.next(); !n.done; n = l.next())g.add(n.value);
                if (m.Ua.keySystemUris && h) for(m = u(m.Ua.keySystemUris), l = m.next(); !l.done; l = m.next())h.add(l.value);
            }
            if (k.length == 1) c.push(k[0]);
            else if (k.length > 0) {
                b = [];
                k = u(k);
                for(d = k.next(); !d.done; d = k.next())d = window1.atob(d.value.split("data:application/json;base64,").pop()), d = JSON.parse(d), b.push.apply(b, G(d.keys));
                k = JSON.stringify({
                    keys: b
                });
                c.push("data:application/json;base64," + window1.btoa(k));
            }
        }
        function ai(a, b, c, d) {
            var e = a.keySystem;
            if (e && (!Ob(e) || !a.licenseServerUri)) {
                b.size && b.get(e) && (b = b.get(e), a.licenseServerUri = b);
                a.keyIds || (a.keyIds = new Set);
                if (c = c.get(e)) a.distinctiveIdentifierRequired || (a.distinctiveIdentifierRequired = c.distinctiveIdentifierRequired), a.persistentStateRequired || (a.persistentStateRequired = c.persistentStateRequired), a.serverCertificate || (a.serverCertificate = c.serverCertificate), c.sessionType && (a.sessionType = c.sessionType), a.serverCertificateUri || (a.serverCertificateUri = c.serverCertificateUri);
                d[e] && (a.keySystem = d[e]);
                window1.cast && window1.cast.__platform__ && e == "com.microsoft.playready" && (a.keySystem = "com.chromecast.playready");
            }
        }
        function Yh(a, b) {
            a = wh(a);
            if (a.size != 0) {
                a = zc(a);
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c.video && (c.video.drmInfos = [
                    a
                ]), c.audio && (c.audio.drmInfos = [
                    a
                ]);
            }
        }
        var Fi = 1, vi = 5, Ai = .5;
        function Hi() {
            this.g = Ii;
            this.j = (new Map).set(Ii, 2).set(Ji, 1);
            this.i = 0;
            this.h = -1;
        }
        function Ki(a, b) {
            var c = a.g !== b;
            a.g = b;
            c && b === Ii && (a.i = Date.now());
            return c;
        }
        var Ji = 0, Ii = 1;
        function Li(a, b, c) {
            this.h = a;
            this.i = b;
            this.g = c;
        }
        function Mi(a, b) {
            return H(function(c) {
                if (c.h == 1) return c.g(fg(a.g, b, a.h.drm.preferredKeySystems, a.h.drm.keySystemsMapping), 2);
                a.h.streaming.dontChooseCodecs || bg(b, a.h.preferredVideoCodecs, a.h.preferredAudioCodecs, a.h.preferredDecodingAttributes, a.h.preferredTextFormats);
                if (!b.variants.some(Eg)) throw new T(2, 4, 4032);
                return c.return(Ni(a, b));
            });
        }
        function Oi(a, b) {
            var c = a.h.restrictions;
            a = a.i;
            var d = !1;
            b = u(b.variants);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = e.allowedByApplication;
                e.allowedByApplication = eg(e, c, a);
                f != e.allowedByApplication && (d = !0);
            }
            return d;
        }
        function Ni(a, b) {
            var c = Oi(a, b);
            if (b) {
                var d = a.g ? a.g.g : null;
                if (d && a.g.C) {
                    for(var e = new Set, f = u(b.variants), g = f.next(); !g.done; g = f.next())g = g.value, g.audio && e.add(g.audio), g.video && e.add(g.video);
                    e = u(e);
                    for(f = e.next(); !f.done; f = e.next())Pi(a, d.keySystem, f.value);
                }
                Qi(a, b);
            }
            return c;
        }
        function Pi(a, b, c) {
            c = u(c.drmInfos);
            for(var d = c.next(); !d.done; d = c.next())if (d = d.value, d.keySystem == b) {
                for(var e = u(d.initData || []), f = e.next(); !f.done; f = e.next())f = f.value, di(a.g, f.initDataType, f.initData);
                e = a.g;
                e.g && (e.g.mediaTypes !== d.mediaTypes && (e.g.mediaTypes = d.mediaTypes), Mb(d) && (e.g = si(e, e.g.keySystem, [
                    e.g,
                    d
                ])));
            }
        }
        function Qi(a, b) {
            function c(l) {
                if (l && !h.has(l) && (h.add(l), l.keyIds.size)) {
                    l = u(l.keyIds);
                    for(var m = l.next(); !m.done; m = l.next()){
                        m = m.value;
                        var n = d[e ? "00" : m];
                        n ? Ri.includes(n) && g.add(n) : f.add(m);
                    }
                }
            }
            var d = a.g ? a.g.uf() : {};
            a = Object.keys(d);
            var e = a.length && a[0] == "00";
            a = !1;
            var f = new Set, g = new Set, h = new WeakSet;
            b = u(b.variants);
            for(var k = b.next(); !k.done; k = b.next()){
                k = k.value;
                if (!k.allowedByApplication) a = !0;
                else if (k.allowedByKeySystem) return;
                c(k.audio);
                c(k.video);
            }
            a = {
                hasAppRestrictions: a,
                missingKeys: Array.from(f),
                restrictedKeyStatuses: Array.from(g)
            };
            throw new T(2, 4, 4012, a);
        }
        var Ri = [
            "output-restricted",
            "internal-error"
        ];
        O("shaka.config.CodecSwitchingStrategy", {
            RELOAD: "reload",
            SMOOTH: "smooth"
        });
        function Si(a) {
            if (Ti.has(a)) return Ti.get(a);
            var b = window1.ManagedMediaSource || window1.MediaSource;
            return b ? (b = b.isTypeSupported(a), Ti.set(a, b), b) : !1;
        }
        function Ui() {
            var a = window1.ManagedMediaSource || window1.MediaSource;
            return a && a.prototype ? !!a.prototype.setLiveSeekableRange && !!a.prototype.clearLiveSeekableRange : !1;
        }
        var Ti = new Map;
        function Vi(a, b) {
            var c = null, d = null, e = null, f = null, g = a.Y();
            b & 1 && (e = a.Rd());
            b & 2 && (f = a.Y());
            b & 8 && (c = a.Y());
            b & 16 && (d = a.Y());
            return {
                trackId: g,
                ke: c,
                le: d,
                tk: e,
                Gj: f
            };
        }
        function Wi(a, b) {
            return b == 1 ? (b = a.Y(), a = a.Y(), {
                baseMediaDecodeTime: b * 4294967296 + a
            }) : {
                baseMediaDecodeTime: a.Y()
            };
        }
        function Xi(a, b) {
            b == 1 ? (a.skip(8), a.skip(8)) : (a.skip(4), a.skip(4));
            b = a.Y();
            a.skip(4);
            a = a.Ka();
            return {
                timescale: b,
                language: String.fromCharCode((a >> 10) + 96) + String.fromCharCode(((a & 960) >> 5) + 96) + String.fromCharCode((a & 31) + 96)
            };
        }
        function Yi(a, b, c) {
            var d = a.Y(), e = [], f = null;
            c & 1 && (f = a.Vh());
            c & 4 && a.skip(4);
            for(var g = 0; g < d; g++){
                var h = {
                    di: null,
                    sampleSize: null,
                    dg: null
                };
                c & 256 && (h.di = a.Y());
                c & 512 && (h.sampleSize = a.Y());
                c & 1024 && a.skip(4);
                c & 2048 && (h.dg = b == 0 ? a.Y() : a.Vh());
                e.push(h);
            }
            return {
                Wn: d,
                ci: e,
                Ug: f
            };
        }
        function Zi(a) {
            a.skip(6);
            a.skip(2);
            a.skip(8);
            var b = a.Ka();
            a.skip(2);
            a.skip(2);
            a.skip(2);
            a = a.Ka() + a.Ka() / 65536;
            return {
                channelCount: b,
                sampleRate: a
            };
        }
        function $i(a) {
            a = a.Y();
            return {
                codec: Fh(a)
            };
        }
        function aj(a) {
            var b = null, c = null, d = a.Wb(4, !1);
            var e = String.fromCharCode(d[0]);
            e += String.fromCharCode(d[1]);
            e += String.fromCharCode(d[2]);
            e += String.fromCharCode(d[3]);
            if (e === "nclx") {
                switch(a.Ka()){
                    case 1:
                    case 5:
                    case 6:
                    case 7:
                        b = "srgb";
                        break;
                    case 9:
                        b = "rec2020";
                        break;
                    case 11:
                    case 12:
                        b = "p3";
                }
                d = a.Ka();
                a.Ka();
                switch(d){
                    case 1:
                    case 6:
                    case 13:
                    case 14:
                    case 15:
                        c = "SDR";
                        break;
                    case 16:
                        c = "PQ";
                        break;
                    case 18:
                        c = "HLG";
                }
            }
            return {
                colorGamut: b,
                Me: c
            };
        }
        function bj(a, b) {
            b = b === void 0 ? !1 : b;
            a = a.toString(16).toUpperCase();
            return b ? a : ("0" + a).slice(-2);
        }
        function cj(a) {
            return (a < 10 ? "0" : "") + a;
        }
        function dj(a) {
            this.g = a = a === void 0 ? [] : a;
        }
        function ej(a) {
            if (a.g.length === 0) throw Error("StreamInfos must have elements");
            for(var b = [], c = u(a.g), d = c.next(); !d.done; d = c.next()){
                var e = b, f = e.push;
                var g = d.value;
                d = fj;
                var h = g.id + 1;
                var k = g.stream.width || 0, l = g.stream.height || 0;
                g.type == "audio" && (l = k = 0);
                var m = g.duration * g.timescale, n = Math.floor(m / (gj + 1));
                m = Math.floor(m % (gj + 1));
                h = new Uint8Array([
                    1,
                    0,
                    0,
                    7,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ].concat(G(hj(h, 4)), [
                    0,
                    0,
                    0,
                    0
                ], G(hj(n, 4)), G(hj(m, 4)), [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0
                ], G(hj(k, 2)), [
                    0,
                    0
                ], G(hj(l, 2)), [
                    0,
                    0
                ]));
                h = fj("tkhd", h);
                k = fj;
                n = g.duration * g.timescale;
                l = Math.floor(n / (gj + 1));
                n = Math.floor(n % (gj + 1));
                m = g.stream.language;
                m = m.charCodeAt(0) - 96 << 10 | m.charCodeAt(1) - 96 << 5 | m.charCodeAt(2) - 96;
                l = new Uint8Array([
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3
                ].concat(G(hj(g.timescale, 4)), G(hj(l, 4)), G(hj(n, 4)), G(hj(m, 2)), [
                    0,
                    0
                ]));
                l = fj("mdhd", l);
                n = g;
                m = new Uint8Array([]);
                switch(n.type){
                    case "video":
                        m = ij.value();
                        break;
                    case "audio":
                        m = jj.value();
                }
                n = fj("hdlr", m);
                a: {
                    switch(g.type){
                        case "video":
                            g = fj("minf", fj("vmhd", kj.value()), lj.value(), mj(g));
                            break a;
                        case "audio":
                            g = fj("minf", fj("smhd", nj.value()), lj.value(), mj(g));
                            break a;
                    }
                    g = new Uint8Array([]);
                }
                g = k("mdia", l, n, g);
                d = d("trak", h, g);
                f.call(e, d);
            }
            c = a.g[0];
            e = fj;
            f = e.apply;
            g = c.duration * c.timescale;
            d = Math.floor(g / (gj + 1));
            g = Math.floor(g % (gj + 1));
            d = new Uint8Array([
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                3
            ].concat(G(hj(c.timescale, 4)), G(hj(d, 4)), G(hj(g, 4)), [
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                64,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                255,
                255,
                255,
                255
            ]));
            d = [
                "moov",
                fj("mvhd", d)
            ];
            g = d.concat;
            b = G(b);
            h = [];
            a = u(a.g);
            for(n = a.next(); !n.done; n = a.next())k = h, l = k.push, n = new Uint8Array([
                0,
                0,
                0,
                0
            ].concat(G(hj(n.value.id + 1, 4)), [
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ])), n = fj("trex", n), l.call(k, n);
            a = fj.apply(dj, [
                "mvex"
            ].concat(G(h)));
            a = f.call(e, dj, g.call(d, b, [
                a,
                oj(c.stream)
            ]));
            b = pj.value();
            c = new Uint8Array(b.byteLength + a.byteLength);
            c.set(b);
            c.set(a, b.byteLength);
            return c;
        }
        function mj(a) {
            var b = fj, c = "aac";
            a.codecs.includes("mp3") ? c = "mp3" : a.codecs.includes("ac-3") ? c = Xb().Fe() ? "ec-3" : "ac-3" : a.codecs.includes("ec-3") ? c = "ec-3" : a.codecs.includes("opus") && (c = "opus");
            var d = new Uint8Array([]);
            switch(a.type){
                case "video":
                    if (a.codecs.includes("avc1")) {
                        c = a.stream.width || 0;
                        d = a.stream.height || 0;
                        if (a.Za.byteLength > 0) var e = fj("avcC", a.Za);
                        else {
                            e = fj;
                            for(var f = 7, g = [], h = [], k = 0, l = 0, m = 0, n = 0; n < a.Cb.length; n++){
                                var q = qj(a.Cb[n]);
                                switch(q[0] & 31){
                                    case 7:
                                        g.push(q);
                                        f += q.length + 2;
                                        break;
                                    case 8:
                                        h.push(q), f += q.length + 2;
                                }
                            }
                            g.length > 0 && (k = g[0][1], m = g[0][2], l = g[0][3]);
                            f = new Uint8Array(f);
                            n = 0;
                            f[n++] = 1;
                            f[n++] = k;
                            f[n++] = m;
                            f[n++] = l;
                            f[n++] = 255;
                            f[n++] = 224 | g.length;
                            for(k = 0; k < g.length; k++)f[n++] = (g[k].length & 65280) >> 8, f[n++] = g[k].length & 255, f.set(g[k], n), n += g[k].length;
                            f[n++] = h.length;
                            for(g = 0; g < h.length; g++)f[n++] = (h[g].length & 65280) >> 8, f[n++] = h[g].length & 255, f.set(h[g], n), n += h[g].length;
                            e = e("avcC", f);
                        }
                        c = new Uint8Array([
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ].concat(G(hj(c, 2)), G(hj(d, 2)), [
                            0,
                            72,
                            0,
                            0,
                            0,
                            72,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            1,
                            19,
                            118,
                            105,
                            100,
                            101,
                            111,
                            106,
                            115,
                            45,
                            99,
                            111,
                            110,
                            116,
                            114,
                            105,
                            98,
                            45,
                            104,
                            108,
                            115,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            24,
                            17,
                            17
                        ]));
                        d = "avc1";
                        h = rj(a);
                        g = new Uint8Array([]);
                        sj(a.stream) && (g = tj(a.stream, a.codecs), d = "encv");
                        d = fj(d, c, e, h, g);
                    } else a.codecs.includes("hvc1") && (d = a.stream.width || 0, e = a.stream.height || 0, c = new Uint8Array([]), a.Za.byteLength > 0 && (c = fj("hvcC", a.Za)), d = new Uint8Array([
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ].concat(G(hj(d, 2)), G(hj(e, 2)), [
                        0,
                        72,
                        0,
                        0,
                        0,
                        72,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        19,
                        118,
                        105,
                        100,
                        101,
                        111,
                        106,
                        115,
                        45,
                        99,
                        111,
                        110,
                        116,
                        114,
                        105,
                        98,
                        45,
                        104,
                        108,
                        115,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        17,
                        17
                    ])), e = "hvc1", h = rj(a), g = new Uint8Array([]), sj(a.stream) && (g = tj(a.stream, a.codecs), e = "encv"), d = fj(e, d, c, h, g));
                    break;
                case "audio":
                    if (c == "mp3") a = fj(".mp3", uj(a));
                    else if (c == "ac-3") c = fj("dac3", a.Ha), d = "ac-3", e = new Uint8Array([]), sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca"), a = fj(d, uj(a), c, e);
                    else if (c == "ec-3") c = fj("dec3", a.Ha), d = "ec-3", e = new Uint8Array([]), sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca"), a = fj(d, uj(a), c, e);
                    else if (c == "opus") c = fj("dOps", a.Ha), d = "Opus", e = new Uint8Array([]), sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca"), a = fj(d, uj(a), c, e);
                    else {
                        if (a.Ha.byteLength > 0) c = fj("esds", a.Ha);
                        else {
                            c = fj;
                            d = a.id + 1;
                            e = a.stream.channelsCount || 2;
                            g = a.stream.audioSamplingRate || 44100;
                            k = Bc("audio", a.codecs.split(","));
                            l = {
                                96E3: 0,
                                88200: 1,
                                64E3: 2,
                                48E3: 3,
                                44100: 4,
                                32E3: 5,
                                24E3: 6,
                                22050: 7,
                                16E3: 8,
                                12E3: 9,
                                11025: 10,
                                8E3: 11,
                                7350: 12
                            };
                            h = l[g];
                            if (k === "mp4a.40.5" || k === "mp4a.40.29") h = l[g * 2];
                            g = parseInt(k.split(".").pop(), 10);
                            d = new Uint8Array([
                                0,
                                0,
                                0,
                                0,
                                3,
                                25
                            ].concat(G(hj(d, 2)), [
                                0,
                                4,
                                17,
                                64,
                                21,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                5,
                                2,
                                g << 3 | h >>> 1,
                                h << 7 | e << 3,
                                6,
                                1,
                                2
                            ]));
                            c = c("esds", d);
                        }
                        d = "mp4a";
                        e = new Uint8Array([]);
                        sj(a.stream) && (e = tj(a.stream, a.codecs), d = "enca");
                        a = fj(d, uj(a), c, e);
                    }
                    d = a;
            }
            a = fj("stsd", vj.value(), d);
            return b("stbl", a, fj("stts", wj.value()), fj("stsc", xj.value()), fj("stsz", yj.value()), fj("stco", zj.value()));
        }
        function rj(a) {
            if (!a.fb && !a.gb) return new Uint8Array([]);
            var b = a.gb;
            a = new Uint8Array([].concat(G(hj(a.fb, 4)), G(hj(b, 4))));
            return fj("pasp", a);
        }
        function uj(a) {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                a.stream.channelsCount || 2,
                0,
                16,
                0,
                0,
                0,
                0
            ].concat(G(hj(a.stream.audioSamplingRate || 44100, 2)), [
                0,
                0
            ]));
        }
        function oj(a) {
            var b = [];
            if (!sj(a)) return new Uint8Array([]);
            a = u(a.drmInfos);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.initData) {
                c = u(c.initData);
                for(var d = c.next(); !d.done; d = c.next())b.push(d.value.initData);
            }
            return tc.apply(kc, G(b));
        }
        function tj(a, b) {
            var c = fj;
            b = new Uint8Array([].concat(G(hj(Aj(b.split(".")[0]), 4))));
            b = fj("frma", b);
            var d = "cenc";
            var e = a.drmInfos[0];
            e && e.encryptionScheme && (d = e.encryptionScheme);
            d = new Uint8Array([
                0,
                0,
                0,
                0
            ].concat(G(hj(Aj(d), 4)), [
                0,
                1,
                0,
                0
            ]));
            d = fj("schm", d);
            e = fj;
            var f = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
            a = u(a.drmInfos);
            for(var g = a.next(); !g.done; g = a.next())if ((g = g.value) && g.keyIds && g.keyIds.size) {
                g = u(g.keyIds);
                for(var h = g.next(); !h.done; h = g.next())f = qj(h.value);
            }
            a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                8
            ]);
            f = fj("tenc", a, f);
            return c("sinf", b, d, e("schi", f));
        }
        function Bj(a) {
            var b = [];
            a = u(a.g);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = b, e = d.push;
                var f = fj;
                var g = new Uint8Array([
                    0,
                    0,
                    0,
                    0
                ].concat(G(hj(c.data ? c.data.sequenceNumber : 0, 4))));
                g = fj("mfhd", g);
                var h;
                var k = c.data ? c.data.zb : [];
                var l = new Uint8Array(4 + k.length);
                for(h = 0; h < k.length; h++){
                    var m = k[h].flags;
                    l[h + 4] = m.pf << 4 | m.Ef << 2 | m.zf;
                }
                k = fj("sdtp", l);
                var n = k.length + 32 + 20 + 8 + 16 + 8 + 8;
                l = fj;
                h = new Uint8Array([
                    0,
                    0,
                    0,
                    58
                ].concat(G(hj(c.id + 1, 4)), [
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]));
                h = fj("tfhd", h);
                m = c.data ? c.data.baseMediaDecodeTime : 0;
                var q = Math.floor(m % (gj + 1));
                m = new Uint8Array([
                    1,
                    0,
                    0,
                    0
                ].concat(G(hj(Math.floor(m / (gj + 1)), 4)), G(hj(q, 4))));
                m = fj("tfdt", m);
                var r = n;
                n = c.data ? c.data.zb : [];
                q = n.length;
                var t = 12 + 16 * q, v = new Uint8Array(t);
                r += 8 + t;
                v.set([
                    c.type === "video" ? 1 : 0,
                    0,
                    15,
                    1
                ].concat(G(hj(q, 4)), G(hj(r, 4))), 0);
                for(r = 0; r < q; r++){
                    var w = n[r];
                    t = hj(w.duration, 4);
                    var x = hj(w.size, 4), y = w.flags;
                    w = hj(w.ub, 4);
                    v.set([].concat(G(t), G(x), [
                        y.Hh << 2 | y.pf,
                        y.Ef << 6 | y.zf << 4 | y.Jh,
                        y.nf & 61440,
                        y.nf & 15
                    ], G(w)), 12 + 16 * r);
                }
                n = fj("trun", v);
                k = l("traf", h, m, n, k);
                f = f("moof", g, k);
                e.call(d, f, Cj(c));
            }
            return tc.apply(kc, G(b));
        }
        function Cj(a) {
            a = (a.data ? a.data.zb : []).map(function(b) {
                return b.data;
            });
            return fj.apply(dj, [
                "mdat"
            ].concat(G(a)));
        }
        function hj(a, b) {
            var c = [];
            for(--b; b >= 0; b--)c.push(a >> 8 * b & 255);
            return c;
        }
        function qj(a) {
            for(var b = new Uint8Array(a.length / 2), c = 0; c < a.length / 2; c += 1)b[c] = parseInt(String(a[c * 2] + a[c * 2 + 1]), 16);
            return b;
        }
        function Aj(a) {
            for(var b = 0, c = 0; c < a.length; c += 1)b |= a.charCodeAt(c) << (a.length - c - 1) * 8;
            return b;
        }
        function fj(a) {
            var b = Ma.apply(1, arguments), c = Dj.get(a);
            c || (c = [
                a.charCodeAt(0),
                a.charCodeAt(1),
                a.charCodeAt(2),
                a.charCodeAt(3)
            ], Dj.set(a, c));
            for(var d = 8, e = b.length - 1; e >= 0; e--)d += b[e].byteLength;
            e = new Uint8Array(d);
            e[0] = d >> 24 & 255;
            e[1] = d >> 16 & 255;
            e[2] = d >> 8 & 255;
            e[3] = d & 255;
            e.set(c, 4);
            c = 0;
            for(d = 8; c < b.length; c++)e.set(b[c], d), d += b[c].byteLength;
            return e;
        }
        function sj(a) {
            return a.encrypted && a.drmInfos.length > 0;
        }
        var gj = 4294967295, Dj = new Map, ij = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                118,
                105,
                100,
                101,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                86,
                105,
                100,
                101,
                111,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]);
        }), jj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                115,
                111,
                117,
                110,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                83,
                111,
                117,
                110,
                100,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]);
        }), wj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), xj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), zj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), yj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), kj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), nj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }), vj = new Kb(function() {
            return new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }), pj = new Kb(function() {
            var a = new Uint8Array([
                105,
                115,
                111,
                109
            ]), b = new Uint8Array([
                97,
                118,
                99,
                49
            ]), c = new Uint8Array([
                0,
                0,
                0,
                1
            ]);
            return fj("ftyp", a, c, a, b);
        }), lj = new Kb(function() {
            var a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                12,
                117,
                114,
                108,
                32,
                0,
                0,
                0,
                1
            ]);
            a = fj("dref", a);
            return fj("dinf", a);
        });
        function Ej(a) {
            a = Fb(a);
            var b = null;
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], Gh).qa("stsd", Ih).box("enca", function(c) {
                b = c.reader.h;
                return Kh(c);
            }).box("sinf", Gh).box("frma", function(c) {
                c.parser.stop();
                $i(c.reader).codec === "ec-3" && b && b.getUint16(16) !== 2 && b.setUint16(16, 2);
            }).parse(a);
            return a;
        }
        function Fj(a, b, c) {
            var d = b = Fb(b), e = !1, f, g = [], h = [];
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], function(l) {
                g.push(l);
                Gh(l);
            }).qa("stsd", function(l) {
                f = l;
                g.push(l);
                Ih(l);
            }).boxes([
                "encv",
                "enca"
            ], function(l) {
                e = !0;
                l.parser.stop();
            }).boxes("dvav dva1 dvh1 dvhe dvc1 dvi1 hev1 hvc1 avc1 avc3".split(" "), function(l) {
                h.push({
                    box: l,
                    tj: 1701733238
                });
            }).boxes("ac-3 ec-3 ac-4 Opus fLaC mp4a".split(" "), function(l) {
                h.push({
                    box: l,
                    tj: 1701733217
                });
            }).parse(b);
            if (e) return b;
            if (h.length == 0 || !f) throw db(sc(b)), new T(2, 3, 3019, c);
            h.reverse();
            c = u(h);
            for(var k = c.next(); !k.done; k = c.next())k = k.value, d = Gj(a, d, f, k.box, g, k.tj);
            d = Hj(a, d);
            return Xb().$h() ? (a = new Uint8Array(b.byteLength + d.byteLength), a.set(d), a.set(b, d.byteLength), a) : d;
        }
        function Ij(a) {
            a = Fb(a);
            var b = [];
            (new Bh).box("mdat", function(g) {
                b.push(g);
            }).parse(a);
            for(var c = [], d = 0; d < b.length; d++){
                var e = b[d - 1], f = b[d];
                c.push(Jj(a.subarray(e ? e.start + e.size : 0, f.start + f.size)));
            }
            return tc.apply(kc, G(c));
        }
        function Jj(a) {
            var b, c, d, e, f = [];
            (new Bh).boxes([
                "moof",
                "traf"
            ], function(m) {
                f.push(m);
                Gh(m);
            }).qa("tfhd", function(m) {
                b = m;
                d = Vi(m.reader, m.flags);
            }).qa("trun", function(m) {
                c = m;
                e = Yi(m.reader, m.version, m.flags);
            }).parse(a);
            if (d && d.Gj !== 2) {
                var g = b.start + Hh(b) + 4 + (d.tk !== null ? 8 : 0), h = Jb(a);
                if (d.Gj !== null) h.setUint32(g, 2);
                else {
                    Kj(a, b.start, b.size + 4);
                    var k = h.getUint32(b.start + 8);
                    h.setUint32(b.start + 8, k | 2);
                    e && e.Ug !== null && h.setInt32(c.start + Hh(c) + 4, e.Ug + 4);
                    k = a.subarray(0, g);
                    h = a.subarray(g);
                    a = new Uint8Array(a.byteLength + 4);
                    a.set(k);
                    k = [];
                    for(var l = 3; l >= 0; l--)k.push(2 >> 8 * l & 255);
                    a.set(new Uint8Array(k), g);
                    a.set(h, g + 4);
                    g = u(f);
                    for(h = g.next(); !h.done; h = g.next())h = h.value, Kj(a, h.start, h.size + 4);
                }
            }
            return a;
        }
        function Gj(a, b, c, d, e, f) {
            var g = tj(a, d.name), h = b.subarray(d.start, d.start + d.size);
            a = new Uint8Array(d.size + g.byteLength);
            a.set(h, 0);
            Jb(a).setUint32(4, f);
            a.set(g, d.size);
            Kj(a, 0, a.byteLength);
            f = new Uint8Array(b.byteLength + a.byteLength);
            d = Xb().Cf() ? d.start : d.start + d.size;
            g = b.subarray(d);
            f.set(b.subarray(0, d));
            f.set(a, d);
            f.set(g, d + a.byteLength);
            b = u(e);
            for(e = b.next(); !e.done; e = b.next())e = e.value, Kj(f, e.start, e.size + a.byteLength);
            a = Jb(f, c.start);
            c = Hh(c);
            b = a.getUint32(c);
            a.setUint32(c, b + 1);
            return f;
        }
        function Hj(a, b) {
            a = oj(a);
            if (a.byteLength === 0) return b;
            var c = 0, d = 0;
            (new Bh).box("moov", function(h) {
                c = h.start;
                d = h.size;
                h.parser.stop();
            }).parse(b);
            var e = c + d;
            Kj(b, c, d + a.byteLength);
            var f = new Uint8Array(b.byteLength + a.byteLength), g = b.subarray(e);
            f.set(b.subarray(0, e));
            f.set(a, e);
            f.set(g, e + a.byteLength);
            return f;
        }
        function Kj(a, b, c) {
            a = Jb(a, b);
            b = a.getUint32(0);
            b != 0 && (b == 1 ? (a.setUint32(8, c >> 32), a.setUint32(12, c & 4294967295)) : a.setUint32(0, c));
        }
        function Lj(a) {
            var b = Fb(a), c = [];
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], function(d) {
                c.push({
                    start: d.start,
                    size: d.size
                });
                Gh(d);
            }).box("stsd", function(d) {
                c.push({
                    start: d.start,
                    size: d.size
                });
                for(var e = Jb(b, d.start), f = 0; f < d.size - 3; f++){
                    var g = e.getUint32(f);
                    g == 1633889587 ? e.setUint32(f, 1700998451) : g == 1684103987 && e.setUint32(f, 1684366131);
                }
            }).parse(b);
            return b;
        }
        function Mj(a, b, c, d, e, f, g, h) {
            this.T = a;
            this.startByte = b;
            this.endByte = c;
            this.Kd = d === void 0 ? null : d;
            this.timescale = e === void 0 ? null : e;
            this.h = f === void 0 ? null : f;
            this.aesKey = g === void 0 ? null : g;
            this.g = this.mimeType = this.codecs = null;
            this.encrypted = h === void 0 ? !1 : h;
        }
        Mj.prototype.Qc = function() {
            return this.startByte;
        };
        Mj.prototype.Oc = function() {
            return this.endByte;
        };
        Mj.prototype.He = function(a) {
            this.h = a;
        };
        Mj.prototype.dc = function() {
            return this.h;
        };
        function Nj(a, b) {
            return a === b ? !0 : a && b ? a.Qc() == b.Qc() && a.Oc() == b.Oc() && ed(a.T().sort(), b.T().sort()) && Eb(a.dc(), b.dc()) : a == b;
        }
        O("shaka.media.InitSegmentReference", Mj);
        Mj.prototype.getEndByte = Mj.prototype.Oc;
        Mj.prototype.getStartByte = Mj.prototype.Qc;
        function Oj(a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v) {
            l = l === void 0 ? [] : l;
            r = r === void 0 ? Pj : r;
            this.startTime = a;
            this.j = this.endTime = b;
            this.D = c;
            this.startByte = d;
            this.endByte = e;
            this.ia = f;
            this.timestampOffset = g;
            this.appendWindowStart = h;
            this.appendWindowEnd = k;
            this.g = l;
            this.tilesLayout = m === void 0 ? "" : m;
            this.C = n === void 0 ? null : n;
            this.h = q === void 0 ? null : q;
            this.status = r;
            this.preload = !1;
            this.l = !0;
            this.o = !1;
            this.aesKey = t === void 0 ? null : t;
            this.thumbnailSprite = null;
            this.i = -1;
            this.m = v === void 0 ? !1 : v;
            this.we = this.hd = !1;
            a = u(this.g);
            for(b = a.next(); !b.done; b = a.next())b.value.qj();
            this.m && this.g.length && this.g[this.g.length - 1].pj();
            this.A = this.bandwidth = this.mimeType = this.codecs = null;
            this.F = !1;
        }
        p = Oj.prototype;
        p.T = function() {
            return this.D();
        };
        p.getStartTime = function() {
            return this.startTime;
        };
        p.Qk = function() {
            return this.endTime;
        };
        p.Qc = function() {
            return this.startByte;
        };
        p.Oc = function() {
            return this.endByte;
        };
        function Qj(a) {
            if (a.endByte) return a.endByte + 1 - a.startByte;
            if (a.bandwidth) {
                var b = a.bandwidth * (a.endTime - a.startTime);
                if (!isNaN(b) && b > 0) return b;
            }
            if (a.g.length > 0 && a.m) for(a = u(a.g), a = a.next(); !a.done; a = a.next()){
                Qj(a.value);
                break;
            }
            return null;
        }
        p.vl = function() {
            return this.tilesLayout;
        };
        p.ul = function() {
            return this.C;
        };
        p.ec = function() {
            return this.status;
        };
        p.Ql = function() {
            this.status = Rj;
        };
        p.Mh = function() {
            this.preload = !0;
        };
        p.isPreload = function() {
            return this.preload;
        };
        p.Jd = function() {
            this.l = !1;
        };
        p.Gl = function() {
            return this.l;
        };
        p.qj = function() {
            this.hd = !0;
        };
        p.Il = function() {
            return this.hd;
        };
        p.pj = function() {
            this.we = !0;
        };
        p.Hl = function() {
            return this.we;
        };
        p.oj = function() {
            this.o = !0;
        };
        p.Dl = function() {
            return this.o;
        };
        p.kg = function(a) {
            this.thumbnailSprite = a;
        };
        p.rl = function() {
            return this.thumbnailSprite;
        };
        p.offset = function(a) {
            this.startTime += a;
            this.endTime += a;
            this.j += a;
            for(var b = u(this.g), c = b.next(); !c.done; c = b.next())c = c.value, c.startTime += a, c.endTime += a, c.j += a;
        };
        p.ti = function(a) {
            this.h == null ? Ya("Sync attempted without sync time!") : (a = this.h - a - this.startTime, Math.abs(a) >= .001 && this.offset(a));
        };
        p.He = function(a, b) {
            this.A = a;
            this.F = b === void 0 ? !1 : b;
        };
        p.dc = function(a) {
            var b = this.A;
            (a === void 0 || a) && this.F && (this.A = null);
            return b;
        };
        function Sj(a, b) {
            a.ia = b;
            a = u(a.g);
            for(var c = a.next(); !c.done; c = a.next())Sj(c.value, b);
        }
        O("shaka.media.SegmentReference", Oj);
        Oj.prototype.getSegmentData = Oj.prototype.dc;
        Oj.prototype.setSegmentData = Oj.prototype.He;
        Oj.prototype.syncAgainst = Oj.prototype.ti;
        Oj.prototype.offset = Oj.prototype.offset;
        Oj.prototype.getThumbnailSprite = Oj.prototype.rl;
        Oj.prototype.setThumbnailSprite = Oj.prototype.kg;
        Oj.prototype.hasByterangeOptimization = Oj.prototype.Dl;
        Oj.prototype.markAsByterangeOptimization = Oj.prototype.oj;
        Oj.prototype.isLastPartial = Oj.prototype.Hl;
        Oj.prototype.markAsLastPartial = Oj.prototype.pj;
        Oj.prototype.isPartial = Oj.prototype.Il;
        Oj.prototype.markAsPartial = Oj.prototype.qj;
        Oj.prototype.isIndependent = Oj.prototype.Gl;
        Oj.prototype.markAsNonIndependent = Oj.prototype.Jd;
        Oj.prototype.isPreload = Oj.prototype.isPreload;
        Oj.prototype.markAsPreload = Oj.prototype.Mh;
        Oj.prototype.markAsUnavailable = Oj.prototype.Ql;
        Oj.prototype.getStatus = Oj.prototype.ec;
        Oj.prototype.getTileDuration = Oj.prototype.ul;
        Oj.prototype.getTilesLayout = Oj.prototype.vl;
        Oj.prototype.getEndByte = Oj.prototype.Oc;
        Oj.prototype.getStartByte = Oj.prototype.Qc;
        Oj.prototype.getEndTime = Oj.prototype.Qk;
        Oj.prototype.getStartTime = Oj.prototype.getStartTime;
        Oj.prototype.getUris = Oj.prototype.T;
        var Pj = 0, Rj = 1;
        Oj.Status = {
            Jm: Pj,
            Pn: Rj,
            nn: 2
        };
        function Tj(a) {
            return a.length == 1 && a.end(0) - a.start(0) < 1E-4;
        }
        function Uj(a) {
            return !a || Tj(a) ? null : a.length == 1 && a.start(0) < 0 ? 0 : a.length ? a.start(0) : null;
        }
        function Vj(a) {
            return !a || Tj(a) ? null : a.length ? a.end(a.length - 1) : null;
        }
        function Wj(a, b) {
            return !a || !a.length || Tj(a) || b > a.end(a.length - 1) ? !1 : b >= a.start(0);
        }
        function Xj(a, b) {
            if (!a || !a.length || Tj(a)) return 0;
            var c = 0;
            a = u(Yj(a));
            for(var d = a.next(); !d.done; d = a.next()){
                var e = d.value;
                d = e.start;
                e = e.end;
                e > b && (c += e - Math.max(d, b));
            }
            return c;
        }
        function Zj(a, b, c) {
            if (!a || !a.length || Tj(a)) return null;
            a = Yj(a).findIndex(function(d, e, f) {
                return d.start > b && (e == 0 || f[e - 1].end - b <= c);
            });
            return a >= 0 ? a : null;
        }
        function Yj(a) {
            if (!a) return [];
            for(var b = [], c = 0; c < a.length; c++)b.push({
                start: a.start(c),
                end: a.end(c)
            });
            return b;
        }
        function ak() {}
        function U(a) {
            return document.createElement(a);
        }
        function bk(a) {
            return document.createElementNS("http://www.w3.org/2000/svg", a);
        }
        function ck() {
            var a = document.createElement("button");
            a.setAttribute("type", "button");
            return a;
        }
        function dk(a, b) {
            var c = document.createElement("source");
            c.src = a;
            c.type = b === void 0 ? "" : b;
            return c;
        }
        function ek(a) {
            for(var b = !1, c = a.getElementsByTagName("source"), d = c.length - 1; d >= 0; --d)a.removeChild(c[d]), b = !0;
            a.src && (a.removeAttribute("src"), b = !0);
            return b;
        }
        function fk(a) {
            a = a.getElementsByClassName("shaka-overflow-quality-mark");
            return a.length ? a[0] : null;
        }
        function gk(a) {
            for(; a.firstChild;)a.removeChild(a.firstChild);
        }
        function Bd() {
            if (hk) return hk;
            ik || (ik = new Uf(function() {
                hk = null;
            }));
            (hk = document.getElementsByTagName("video")[0] || document.getElementsByTagName("audio")[0]) || (hk = document.createElement("video"));
            ik.Z(1);
            return hk;
        }
        function jk(a, b) {
            var c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) return "fonts" in document && "FontFace" in window1 ? h.g(document.fonts.ready, 2) : h.return();
                if (!("entries" in document.fonts)) return h.return();
                c = function(k) {
                    k = k.entries();
                    for(var l = [], m = k.next(); m.done === !1;)l.push(m.value), m = k.next();
                    return l;
                };
                d = u(c(document.fonts));
                for(e = d.next(); !e.done; e = d.next())if (f = e.value, f.family === a && f.display === "swap") return h.return();
                g = new FontFace(a, "url(" + b + ")", {
                    display: "swap"
                });
                document.fonts.add(g);
                h.j();
            });
        }
        O("shaka.util.Dom", ak);
        ak.removeAllChildren = gk;
        ak.clearSourceFromVideo = ek;
        var ik = null, hk = null;
        function kk() {}
        function lk(a, b) {
            return b + 10 <= a.length && a[b] === 73 && a[b + 1] === 68 && a[b + 2] === 51 && a[b + 3] < 255 && a[b + 4] < 255 && a[b + 6] < 128 && a[b + 7] < 128 && a[b + 8] < 128 && a[b + 9] < 128 ? !0 : !1;
        }
        function mk(a, b) {
            return b + 10 <= a.length && a[b] === 51 && a[b + 1] === 68 && a[b + 2] === 73 && a[b + 3] < 255 && a[b + 4] < 255 && a[b + 6] < 128 && a[b + 7] < 128 && a[b + 8] < 128 && a[b + 9] < 128 ? !0 : !1;
        }
        function nk(a, b) {
            var c = (a[b] & 127) << 21;
            c |= (a[b + 1] & 127) << 14;
            c |= (a[b + 2] & 127) << 7;
            return c |= a[b + 3] & 127;
        }
        function ok(a) {
            var b = {
                key: a.type,
                description: "",
                data: "",
                mimeType: null,
                pictureType: null
            };
            if (a.type === "APIC") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                var c = a.data.subarray(1).indexOf(0);
                if (c === -1) return null;
                var d = bc(Fb(a.data, 1, c)), e = a.data[2 + c], f = a.data.subarray(3 + c).indexOf(0);
                if (f === -1) return null;
                var g = bc(Fb(a.data, 3 + c, f)), h;
                d === "--\x3e" ? h = bc(Fb(a.data, 4 + c + f)) : h = Gb(a.data.subarray(4 + c + f));
                b.mimeType = d;
                b.pictureType = e;
                b.description = g;
                b.data = h;
                return b;
            }
            if (a.type === "TXXX") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                d = a.data.subarray(1).indexOf(0);
                if (d === -1) return null;
                c = bc(Fb(a.data, 1, d));
                a = bc(Fb(a.data, 2 + d)).replace(/\0*$/, "");
                b.description = c;
                b.data = a;
                return b;
            }
            if (a.type === "WXXX") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                d = a.data.subarray(1).indexOf(0);
                if (d === -1) return null;
                c = bc(Fb(a.data, 1, d));
                a = bc(Fb(a.data, 2 + d)).replace(/\0*$/, "");
                b.description = c;
                b.data = a;
                return b;
            }
            if (a.type === "PRIV") {
                if (a.size < 2) return null;
                c = a.data.indexOf(0);
                if (c === -1) return null;
                c = bc(Fb(a.data, 0, c));
                b.description = c;
                c == "com.apple.streaming.transportStreamTimestamp" ? (c = a.data.subarray(c.length + 1), a = c[3] & 1, c = (c[4] << 23) + (c[5] << 15) + (c[6] << 7) + c[7], c /= 45, a && (c += 4.772185884E7), b.data = c) : (a = Gb(a.data.subarray(c.length + 1)), b.data = a);
                return b;
            }
            if (a.type[0] === "T") {
                if (a.size < 2 || a.data[0] !== 3) return null;
                a = bc(a.data.subarray(1)).replace(/\0*$/, "");
                b.data = a;
                return b;
            }
            return a.type[0] === "W" ? (a = bc(a.data).replace(/\0*$/, ""), b.data = a, b) : a.data ? (b.data = Gb(a.data), b) : null;
        }
        function pk(a) {
            for(var b = 0, c = []; lk(a, b);){
                var d = nk(a, b + 6);
                a[b + 5] >> 6 & 1 && (b += 10);
                b += 10;
                for(d = b + d; b + 10 < d;){
                    var e = a.subarray(b), f = nk(e, 4);
                    e = {
                        type: String.fromCharCode(e[0], e[1], e[2], e[3]),
                        size: f,
                        data: e.subarray(10, 10 + f)
                    };
                    (f = ok(e)) && c.push(f);
                    b += e.size + 10;
                }
                mk(a, b) && (b += 10);
            }
            return c;
        }
        function qk(a, b) {
            for(var c = b = b === void 0 ? 0 : b, d = 0; lk(a, b);)a[b + 5] >> 6 & 1 && (d += 10), d += 10, d += nk(a, b + 6), mk(a, b + 10) && (d += 10), b += d;
            return d > 0 ? a.subarray(c, c + d) : new Uint8Array([]);
        }
        O("shaka.util.Id3Utils", kk);
        kk.getID3Data = qk;
        kk.getID3Frames = pk;
        function rk(a, b, c) {
            c = c === void 0 ? Number.EPSILON : c;
            if (a === b) return !0;
            a = Math.abs(a - b);
            return a <= c ? !0 : c !== Number.EPSILON ? Math.abs(a - c) <= Number.EPSILON : !1;
        }
        function sk(a) {
            return new Date(Date.UTC(1900, 0, 1, 0, 0, 0, 0) + a).getTime();
        }
        function tk(a, b) {
            this.j = a;
            if (b === void 0 ? 0 : b) {
                b = new Uint8Array(a.byteLength);
                for(var c = 0, d = 0; d < a.byteLength; d++)d >= 2 && a[d] == 3 && a[d - 1] == 0 && a[d - 2] == 0 || (b[c] = a[d], c++);
                this.j = Fb(b, 0, c);
            }
            this.i = this.j.byteLength;
            this.g = this.h = 0;
        }
        function uk(a) {
            var b = a.j.byteLength - a.i, c = Math.min(4, a.i);
            if (c !== 0) {
                for(var d = 0, e = 0; e < c; e++)d = d << 8 | a.j[b + e];
                a.h = d << (4 - c) * 8;
                a.g = c * 8;
                a.i -= c;
            }
        }
        function vk(a, b) {
            if (a.g <= b) {
                b -= a.g;
                var c = Math.floor(b / 8);
                b -= c * 8;
                a.g -= c;
                uk(a);
            }
            a.h <<= b;
            a.g -= b;
        }
        function wk(a, b) {
            var c = Math.min(a.g, b), d = a.h >>> 32 - c;
            a.g -= c;
            a.g > 0 ? a.h <<= c : a.i > 0 && uk(a);
            c = b - c;
            return c > 0 ? d << c | wk(a, c) : d;
        }
        function xk(a) {
            for(var b = 0; a.g === 0;){
                if (a.i === 0) return b;
                uk(a);
            }
            for(;;){
                var c = Math.clz32(a.h);
                c > a.g && (c = a.g);
                b += c;
                a.h <<= c;
                a.g -= c;
                if (a.g > 0 || a.i === 0) break;
                uk(a);
            }
            return b;
        }
        function yk(a) {
            vk(a, 1 + xk(a));
        }
        function V(a) {
            var b = xk(a);
            return wk(a, b + 1) - 1;
        }
        function zk(a) {
            a = V(a);
            return 1 & a ? 1 + a >>> 1 : -1 * (a >>> 1);
        }
        function Ak(a) {
            return wk(a, 1) === 1;
        }
        function Bk(a) {
            return wk(a, 8);
        }
        function Ck(a, b) {
            for(var c = 8, d = 8, e = 0; e < b; e++)d !== 0 && (d = zk(a), d = (c + d + 256) % 256), c = d === 0 ? c : d;
        }
        function Dk(a) {
            Bk(a);
            V(a);
            return V(a);
        }
        O("shaka.util.ExpGolomb", tk);
        function Ek() {
            this.K = null;
            this.L = !1;
            this.D = this.M = null;
            this.m = [];
            this.j = [];
            this.g = [];
            this.G = this.H = null;
            this.l = [];
            this.i = [];
            this.h = [];
            this.I = null;
            this.A = [];
            this.o = [];
            this.F = this.J = this.C = null;
        }
        p = Ek.prototype;
        p.clearData = function() {
            this.m = [];
            this.j = [];
            this.g = [];
            this.l = [];
            this.i = [];
            this.h = [];
            this.A = [];
            this.o = [];
        };
        p.hg = function(a) {
            this.F != null && this.F != a && (this.C = null);
            this.F = a;
        };
        p.parse = function(a) {
            if (a.length < 564) return this;
            for(var b = Math.max(0, Fk(a)), c = a.length - (a.length + b) % 188, d = !1, e = b; e < c; e += 188)if (a[e] == 71) {
                var f = !!(a[e + 1] & 64), g = ((a[e + 1] & 31) << 8) + a[e + 2];
                if ((a[e + 3] & 48) >> 4 > 1) {
                    var h = e + 5 + a[e + 4];
                    if (h == e + 188) continue;
                } else h = e + 4;
                switch(g){
                    case 0:
                        f && (h += a[h] + 1);
                        this.K = (a[h + 10] & 31) << 8 | a[h + 11];
                        break;
                    case 17:
                    case 8191:
                        break;
                    case this.K:
                        f && (h += a[h] + 1);
                        f = a;
                        g = {
                            audio: -1,
                            video: -1,
                            Af: -1,
                            audioCodec: "",
                            videoCodec: ""
                        };
                        var k = h + 3 + ((f[h + 1] & 15) << 8 | f[h + 2]) - 4;
                        for(h += 12 + ((f[h + 10] & 15) << 8 | f[h + 11]); h < k;){
                            var l = (f[h + 1] & 31) << 8 | f[h + 2], m = (f[h + 3] & 15) << 8 | f[h + 4];
                            switch(f[h]){
                                case 6:
                                    if (m > 0) for(var n = h + 5, q = m; q > 2;){
                                        var r = f[n + 1] + 2;
                                        switch(f[n]){
                                            case 5:
                                                var t = n + 2;
                                                t = f[t] << 24 | f[t + 1] << 16 | f[t + 2] << 8 | f[t + 3];
                                                g.audio == -1 && t === 1332770163 ? (g.audio = l, g.audioCodec = "opus") : g.video == -1 && t === 1096167473 && (g.video = l, g.videoCodec = "av1");
                                                break;
                                            case 106:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "ac3");
                                                break;
                                            case 122:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "ec3");
                                                break;
                                            case 124:
                                                g.audio == -1 && (g.audio = l, g.audioCodec = "aac");
                                                break;
                                            case 127:
                                                g.audioCodec == "opus" && (t = null, f[n + 2] === 128 && (t = f[n + 3]), t != null && (this.J = {
                                                    channelCount: (t & 15) === 0 ? 2 : t & 15,
                                                    vk: t,
                                                    sampleRate: 48E3
                                                }));
                                        }
                                        n += r;
                                        q -= r;
                                    }
                                    break;
                                case 15:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "aac");
                                    break;
                                case 17:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "aac-loas");
                                    break;
                                case 21:
                                    g.Af == -1 && (g.Af = l);
                                    break;
                                case 27:
                                    g.video == -1 && (g.video = l, g.videoCodec = "avc");
                                    break;
                                case 3:
                                case 4:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "mp3");
                                    break;
                                case 36:
                                    g.video == -1 && (g.video = l, g.videoCodec = "hvc");
                                    break;
                                case 129:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "ac3");
                                    break;
                                case 132:
                                case 135:
                                    g.audio == -1 && (g.audio = l, g.audioCodec = "ec3");
                            }
                            h += m + 5;
                        }
                        f = g;
                        f.video != -1 && (this.M = f.video, this.D = f.videoCodec);
                        f.audio != -1 && (this.H = f.audio, this.G = f.audioCodec);
                        f.Af != -1 && (this.I = f.Af);
                        d && !this.L && (d = !1, e = b - 188);
                        this.L = !0;
                        break;
                    case this.M:
                        h = a.subarray(h, e + 188);
                        f ? (this.j.push(this.m.length), this.m.push(h)) : this.j.length && this.m.push(h);
                        break;
                    case this.H:
                        h = a.subarray(h, e + 188);
                        f ? (this.i.push(this.l.length), this.l.push(h)) : this.i.length && this.l.push(h);
                        break;
                    case this.I:
                        h = a.subarray(h, e + 188);
                        f ? (this.o.push(this.A.length), this.A.push(h)) : this.o.length && this.A.push(h);
                        break;
                    default:
                        d = !0;
                }
            }
            return this;
        };
        function Gk(a, b, c) {
            return uc(a, b[c], c + 1 < b.length ? b[c + 1] : a.length);
        }
        function Hk(a, b, c) {
            if (b.byteLength < 9 || (b[0] << 16 | b[1] << 8 | b[2]) !== 1) return null;
            var d = b[4] << 8 | b[5];
            if (d && d > c - 6) return null;
            var e = null, f = null, g = b[7];
            if (b.byteLength < Ik(b)) return null;
            if (g & 192) {
                e = (b[9] & 14) * 536870912 + (b[10] & 255) * 4194304 + (b[11] & 254) * 16384 + (b[12] & 255) * 128 + (b[13] & 254) / 2;
                var h = null;
                g & 64 && (h = (b[14] & 14) * 536870912 + (b[15] & 255) * 4194304 + (b[16] & 254) * 16384 + (b[17] & 255) * 128 + (b[18] & 254) / 2, e = Jk(e, h));
                a.C == null && (a.C = e);
                e = Jk(e, a.C);
                f = a.C = e;
                h != null && (f = Jk(h, e));
            }
            a = b[8] + 9;
            return c <= a ? null : {
                packetLength: d,
                Zl: a,
                pts: e,
                dts: f
            };
        }
        function Kk(a, b) {
            return (a = Hk(a, b, b.byteLength)) ? {
                data: b.subarray(a.Zl),
                packetLength: a.packetLength,
                pts: a.pts,
                dts: a.dts,
                nalus: []
            } : null;
        }
        p.Yl = function(a) {
            md("TsParser.parseAvcNalus", "Please use parseNalus function instead.");
            return this.Sh(a, {
                ze: null,
                state: null
            });
        };
        p.Sh = function(a, b) {
            var c = a.pts ? a.pts / 9E4 : null;
            a = a.data;
            var d = a.byteLength, e = 1;
            this.D == "hvc" && (e = 2);
            var f = b.state || 0, g = f, h = 0, k = [], l = -1, m = 0, n = this.D === "hvc";
            f == -1 && (l = 0, m = n ? a[0] >> 1 & 63 : a[0] & 31, f = 0, h = 1);
            for(; h < d;){
                var q = a[h++];
                if (f) {
                    if (f === 1) f = q ? 0 : 2;
                    else if (q) {
                        if (q == 1) {
                            q = h - f - 1;
                            if (l >= 0) k.push({
                                data: a.subarray(l + e, q),
                                fullData: a.subarray(l, q),
                                type: m,
                                time: c,
                                state: null
                            });
                            else if (f = k.length ? k[k.length - 1] : b.ze) g && h <= 4 - g && f.state && (f.data = f.data.subarray(0, f.data.byteLength - g), f.fullData = f.fullData.subarray(0, f.fullData.byteLength - g)), q > 0 && (q = a.subarray(0, q), f.data = tc(f.data, q), f.fullData = tc(f.fullData, q), f.state = 0);
                            h < d ? (m = n ? a[h] >> 1 & 63 : a[h] & 31, l = h, f = 0) : f = -1;
                        } else f = 0;
                    } else f = 3;
                } else f = q ? 0 : 1;
            }
            l >= 0 && f >= 0 && k.push({
                data: a.subarray(l + e, d),
                fullData: a.subarray(l, d),
                type: m,
                time: c,
                state: f
            });
            !k.length && b.ze && (c = k.length ? k[k.length - 1] : b.ze) && (c.data = tc(c.data, a), c.fullData = tc(c.fullData, a));
            b.state = f;
            return k;
        };
        p.getMetadata = function() {
            for(var a = [], b = 0; b < this.o.length; b++){
                var c = Gk(this.A, this.o, b);
                (c = Kk(this, c)) && a.push({
                    cueTime: c.pts ? c.pts / 9E4 : null,
                    data: c.data,
                    frames: pk(c.data),
                    dts: c.dts,
                    pts: c.pts
                });
            }
            return a;
        };
        p.yb = function() {
            if (this.i.length && !this.h.length) for(var a = 0; a < this.i.length; a++){
                var b = Gk(this.l, this.i, a), c = Kk(this, b), d = this.h.length ? this.h[this.h.length - 1] : null;
                c && c.pts != null && c.dts != null && (!d || d.pts != c.pts && d.dts != c.dts) ? this.h.push(c) : this.h.length && (b = c ? c.data : b) && (d = this.h[this.h.length - 1], d.data = tc(d.data, b));
            }
            return this.h;
        };
        p.Ed = function(a) {
            a = a === void 0 ? !0 : a;
            if (this.j.length && !this.g.length) {
                for(var b = 0; b < this.j.length; b++){
                    var c = Gk(this.m, this.j, b), d = Kk(this, c), e = this.g.length ? this.g[this.g.length - 1] : null;
                    d && d.pts != null && d.dts != null && (!e || e.pts != d.pts && e.dts != d.dts) ? this.g.push(d) : this.g.length && (c = d ? d.data : c) && (e = this.g[this.g.length - 1], e.data = tc(e.data, c));
                }
                if (a) {
                    b = {
                        ze: null,
                        state: null
                    };
                    e = [];
                    c = u(this.g);
                    for(d = c.next(); !d.done; d = c.next())d = d.value, d.nalus = this.Sh(d, b), d.nalus.length && (e.push(d), b.ze = d.nalus[d.nalus.length - 1]);
                    this.g = e;
                }
            }
            return a ? this.g : (a = this.g, this.g = [], a);
        };
        function Lk(a, b) {
            if (b == "audio") {
                b = a.l;
                var c = a.i;
            } else if (b == "video") b = a.m, c = a.j;
            else return null;
            for(var d = 0; d < c.length; d++){
                var e = c[d], f = d + 1 < c.length ? c[d + 1] : b.length, g = b[e];
                if (g) {
                    for(var h = 0, k = e; k < f; k++)h += b[k].byteLength;
                    e = g.byteLength >= 9 && g.byteLength >= Ik(g) ? g : uc(b, e, f);
                    if (h = Hk(a, e, h)) {
                        if (h = Mk(h), h != null) return h;
                    }
                }
            }
            return null;
        }
        function Ik(a) {
            a = a[7];
            return a & 64 ? 19 : a & 192 ? 14 : 9;
        }
        function Mk(a) {
            return a.pts == null || a.dts == null ? null : Math.min(a.dts, a.pts) / 9E4;
        }
        p.getStartTime = function(a) {
            if (a == "audio") a = this.yb();
            else if (a == "video") a = this.Ed(!1);
            else return null;
            return a.length ? Mk(a[0]) : null;
        };
        p.me = function() {
            return {
                audio: this.G,
                video: this.D
            };
        };
        p.yf = function() {
            for(var a = [], b = u(this.Ed()), c = b.next(); !c.done; c = b.next())a.push.apply(a, G(c.value.nalus));
            return a;
        };
        p.Al = function() {
            md("TsParser.getVideoResolution", "Please use getVideoInfo function instead.");
            var a = this.yh();
            return {
                height: a.height,
                width: a.width
            };
        };
        p.yh = function() {
            return this.D == "hvc" ? Nk(this) : Ok(this);
        };
        function Pk(a) {
            var b = a.Ed();
            return b.length > 1 && (a = b[0].pts, b = b[1].pts, !isNaN(b - a)) ? String(Math.abs(1 / (b - a) * 9E4)) : null;
        }
        function Ok(a) {
            var b = {
                height: null,
                width: null,
                codec: null,
                frameRate: null
            }, c = a.yf();
            if (!c.length) return b;
            c = c.find(function(r) {
                return r.type == 7;
            });
            if (!c) return b;
            c = new tk(c.data);
            var d = Bk(c), e = Bk(c), f = Bk(c);
            yk(c);
            if (Qk.includes(d)) {
                var g = V(c);
                g === 3 && vk(c, 1);
                yk(c);
                yk(c);
                vk(c, 1);
                if (Ak(c)) {
                    g = g !== 3 ? 8 : 12;
                    for(var h = 0; h < g; h++)Ak(c) && (h < 6 ? Ck(c, 16) : Ck(c, 64));
                }
            }
            yk(c);
            g = V(c);
            if (g === 0) V(c);
            else if (g === 1) for(vk(c, 1), yk(c), yk(c), g = V(c), h = 0; h < g; h++)yk(c);
            yk(c);
            vk(c, 1);
            g = V(c);
            h = V(c);
            var k = wk(c, 1);
            k === 0 && vk(c, 1);
            vk(c, 1);
            var l = 0, m = 0, n = 0, q = 0;
            Ak(c) && (l = V(c), m = V(c), n = V(c), q = V(c));
            b.height = String((2 - k) * (h + 1) * 16 - n * 2 - q * 2);
            b.width = String((g + 1) * 16 - l * 2 - m * 2);
            b.codec = "avc1." + ("0" + d.toString(16).toUpperCase()).slice(-2) + ("0" + e.toString(16).toUpperCase()).slice(-2) + ("0" + f.toString(16).toUpperCase()).slice(-2);
            b.frameRate = Pk(a);
            return b;
        }
        function Nk(a) {
            var b = {
                height: null,
                width: null,
                codec: null,
                frameRate: null
            }, c = a.yf();
            if (!c.length) return b;
            c = c.find(function(E) {
                return E.type == 33;
            });
            if (!c) return b;
            var d = new tk(c.fullData, !0);
            Bk(d);
            Bk(d);
            wk(d, 4);
            var e = wk(d, 3);
            Ak(d);
            var f = wk(d, 2), g = wk(d, 1), h = wk(d, 5), k = wk(d, 32);
            c = Bk(d);
            for(var l = Bk(d), m = Bk(d), n = Bk(d), q = Bk(d), r = Bk(d), t = Bk(d), v = [], w = [], x = 0; x < e; x++)v.push(Ak(d)), w.push(Ak(d));
            if (e > 0) for(x = e; x < 8; x++)wk(d, 2);
            for(x = 0; x < e; x++)v[x] && wk(d, 88), w[x] && Bk(d);
            V(d);
            e = V(d);
            e == 3 && wk(d, 1);
            v = V(d);
            w = V(d);
            var y = x = 0, z = 0, A = 0;
            Ak(d) && (x += V(d), y += V(d), z += V(d), A += V(d));
            b.width = String(v - (x + y) * (e === 1 || e === 2 ? 2 : 1));
            b.height = String(w - (z + A) * (e === 1 ? 2 : 1));
            d = function(E) {
                for(var C = 0, D = 0; D < 32; D++)C |= (E >> D & 1) << 31 - D;
                return C >>> 0;
            }(k);
            g = g == 1 ? "H" : "L";
            f = "hvc1" + ("." + [
                "",
                "A",
                "B",
                "C"
            ][f] + h);
            f += "." + d.toString(16).toUpperCase();
            f += "." + g + t;
            r && (f += "." + r.toString(16).toUpperCase());
            q && (f += "." + q.toString(16).toUpperCase());
            n && (f += "." + n.toString(16).toUpperCase());
            m && (f += "." + m.toString(16).toUpperCase());
            l && (f += "." + l.toString(16).toUpperCase());
            c && (f += "." + c.toString(16).toUpperCase());
            b.codec = f;
            b.frameRate = Pk(a);
            return b;
        }
        function Jk(a, b) {
            var c = 1;
            for(a > b && (c = -1); Math.abs(b - a) > 4294967296;)a += c * 8589934592;
            return a;
        }
        function Rk(a) {
            return Fk(a) < 0 ? !1 : !0;
        }
        function Fk(a) {
            for(var b = Math.min(1E3, a.length - 564), c = 0; c < b;){
                if (a[c] == 71 && a[c + 188] == 71 && a[c + 376] == 71) return c;
                var d = a.indexOf(71, c + 1);
                c = d >= 0 && d < b ? d : c + 1;
            }
            return -1;
        }
        O("shaka.util.TsParser", Ek);
        Ek.syncOffset = Fk;
        Ek.probe = Rk;
        Ek.prototype.getVideoInfo = Ek.prototype.yh;
        Ek.prototype.getVideoResolution = Ek.prototype.Al;
        Ek.prototype.getVideoNalus = Ek.prototype.yf;
        Ek.prototype.getCodecs = Ek.prototype.me;
        Ek.prototype.getStartTime = Ek.prototype.getStartTime;
        Ek.prototype.getVideoData = Ek.prototype.Ed;
        Ek.prototype.getAudioData = Ek.prototype.yb;
        Ek.prototype.getMetadata = Ek.prototype.getMetadata;
        Ek.prototype.parseNalus = Ek.prototype.Sh;
        Ek.prototype.parseAvcNalus = Ek.prototype.Yl;
        Ek.prototype.parse = Ek.prototype.parse;
        Ek.prototype.setDiscontinuitySequence = Ek.prototype.hg;
        Ek.prototype.clearData = Ek.prototype.clearData;
        Ek.Timescale = 9E4;
        var Qk = [
            100,
            110,
            122,
            244,
            44,
            83,
            86,
            118,
            128,
            138,
            139,
            134
        ];
        function Sk(a, b, c, d, e) {
            var f = this;
            this.g = a;
            this.O = c;
            this.C = d;
            this.X = b;
            this.l = new Map;
            this.F = new Map;
            this.Ia = new Map;
            this.h = null;
            this.Ga = !1;
            this.D = e || null;
            this.m = new Map;
            this.A = new fd;
            this.j = new Map;
            this.J = null;
            this.L = new Yg;
            this.ya = "";
            this.kb = !1;
            this.va = !0;
            this.M = !1;
            this.K = this.V = null;
            this.i = Tk(this, this.L);
            this.Oa = this.H = !1;
            this.G = new uh(function() {
                return Uk(f);
            });
            this.I = !1;
            this.P = "UNKNOWN";
            this.ab = this.jb = !1;
            this.hb = new Yg;
            this.o = !1;
            this.ua = null;
            this.W = new Map;
            this.ba = this.R = this.na = this.S = null;
            this.$ = new Yg;
            this.g.remote && (this.M = this.g.remote.state != "disconnected", this.A.u(this.g.remote, "connect", function() {
                f.M = f.g.remote.state != "disconnected";
            }), this.A.u(this.g.remote, "connecting", function() {
                f.M = f.g.remote.state != "disconnected";
            }), this.A.u(this.g.remote, "disconnect", function() {
                f.M = f.g.remote.state != "disconnected";
            }));
        }
        function Tk(a, b) {
            a.va = !0;
            if (window1.ManagedMediaSource) {
                a.K || (a.g.disableRemotePlayback = !0);
                var c = new ManagedMediaSource;
                a.A.u(c, "startstreaming", function() {
                    a.va = !0;
                });
                a.A.u(c, "endstreaming", function() {
                    a.va = !1;
                });
            } else c = new MediaSource;
            a.A.ra(c, "sourceopen", function() {
                URL.revokeObjectURL(a.ya);
                b.resolve();
            });
            a.A.ra(a.g, "playing", function() {
                a.kb = !0;
            });
            a.ya = Vk(c);
            Wk(a);
            a.C.useSourceElements ? (a.V = dk(a.ya), a.g.appendChild(a.V), a.K && a.g.appendChild(a.K), a.g.load()) : a.g.src = a.ya;
            return c;
        }
        function Xk(a, b, c) {
            if (a.g && window1.ManagedMediaSource && a.i && a.C.useSourceElements) {
                var d;
                ((d = a.K) == null ? void 0 : d.parentElement) === a.g && a.g.removeChild(a.K);
                a.K = dk(b, c);
                a.g.appendChild(a.K);
                a.g.disableRemotePlayback = !1;
            }
        }
        function Zk() {
            var a = 'video/mp4; codecs="avc1.42E01E",video/mp4; codecs="avc3.42E01E",video/mp4; codecs="hev1.1.6.L93.90",video/mp4; codecs="hvc1.1.6.L93.90",video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084",video/mp4; codecs="hvc1.2.20000000.L153.B0",video/mp4; codecs="hvc1.2.4.L120.b0",video/mp4; codecs="hvc1.2.4.L123.b0",video/mp4; codecs="vp9",video/mp4; codecs="vp09.00.10.08",video/mp4; codecs="av01.0.01M.08",video/mp4; codecs="av01.0.31M.10.0.111.09.16.09.0",video/mp4; codecs="av01.0.31M.10.0.112.09.18.09.0",video/mp4; codecs="dvh1.05.01",video/mp4; codecs="dvh1.08.01",video/mp4; codecs="dav1.10.01",video/mp4; codecs="dvh1.20.01",audio/mp4; codecs="mp4a.40.2",audio/mp4; codecs="ac-3",audio/mp4; codecs="ec-3",audio/mp4; codecs="ac-4.02.01.03",audio/mp4; codecs="opus",audio/mp4; codecs="flac",audio/mp4; codecs="dtsc",audio/mp4; codecs="dtse",audio/mp4; codecs="dtsx",audio/mp4; codecs="apac.31.00",video/webm; codecs="vp8",video/webm; codecs="vp9",video/webm; codecs="vp09.00.10.08",audio/webm; codecs="vorbis",audio/webm; codecs="opus",video/mp2t; codecs="avc1.42E01E",video/mp2t; codecs="avc3.42E01E",video/mp2t; codecs="hvc1.1.6.L93.90",video/mp2t; codecs="mp4a.40.2",video/mp2t; codecs="ac-3",video/mp2t; codecs="ec-3",text/vtt,application/mp4; codecs="wvtt",application/ttml+xml,application/mp4; codecs="stpp"'.split(",").concat(G(yf)), b = {};
            Xb();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (Mf(c)) b[c] = !0;
                else if (Ad()) {
                    var d = Ff(c), e = rg(Gf(c), d);
                    d = wf(d, e);
                    b[c] = Si(d) || (of(d) ? !0 : !1);
                } else b[c] = Bd().canPlayType(c) != "";
                d = c.split(";")[0];
                b[d] = b[d] || b[c];
            }
            return b;
        }
        p = Sk.prototype;
        p.destroy = function() {
            return this.G.destroy();
        };
        function Uk(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t, v;
            return H(function(w) {
                if (w.h == 1) {
                    b = [];
                    c = u(a.m);
                    for(d = c.next(); !d.done; d = c.next())for(e = d.value, f = u(e), g = f.next().value, h = f.next().value, k = h[0], l = g, a.m.set(l, h.slice(0, 1)), k && b.push(k.p.catch(Yf)), m = u(h.slice(1)), n = m.next(); !n.done; n = m.next())q = n.value, q.p.reject(new T(2, 7, 7003, void 0));
                    a.h && b.push(a.h.destroy());
                    return w.g(Promise.all(b), 2);
                }
                r = u(a.j.values());
                for(t = r.next(); !t.done; t = r.next())v = t.value, v.destroy();
                a.A && (a.A.release(), a.A = null);
                a.g && (Wk(a), a.g.load(), a.g.disableRemotePlayback = !1);
                a.g = null;
                a.V = null;
                a.K = null;
                a.C = null;
                a.i = null;
                a.h = null;
                a.X = null;
                a.l.clear();
                a.Ia.clear();
                a.j.clear();
                a.J = null;
                a.m.clear();
                a.D = null;
                a.W.clear();
                a.O = null;
                w.j();
            });
        }
        function Wk(a) {
            if (a.g) {
                a.g.removeAttribute("src");
                var b;
                ((b = a.V) == null ? void 0 : b.parentElement) === a.g && a.g.removeChild(a.V);
                var c;
                ((c = a.K) == null ? void 0 : c.parentElement) === a.g && a.g.removeChild(a.K);
            }
        }
        p.init = function(a, b, c, d) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? "UNKNOWN" : c;
            d = d === void 0 ? !1 : d;
            var e = this, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return f = Gc, n.g(e.L, 2);
                if (n.h != 3) {
                    if (!$k(e) && !al(e)) return n.B(3);
                    Ya("Expected MediaSource to be open during init(); reopening the media source.");
                    e.L = new Yg;
                    e.i = Tk(e, e.L);
                    return n.g(e.L, 3);
                }
                e.I = b;
                e.P = c;
                e.jb = d;
                e.ab = !e.I && e.P == "HLS" && !e.jb;
                e.W.clear();
                e.S = null;
                e.na = null;
                e.R = null;
                e.ba = null;
                e.$ = new Yg;
                g = u(a.keys());
                for(h = g.next(); !h.done; h = g.next())k = h.value, l = a.get(k), bl(e, k, l, l.codecs), e.o ? (e.m.set(f.ha, []), e.m.set(f.Ba, [])) : e.m.set(k, []);
                (m = a.get(f.ha)) && m.isAudioMuxedInVideo && (e.o = !0);
                n.j();
            });
        };
        function bl(a, b, c, d) {
            b == "audio" && d && (d = rg(d, c.mimeType));
            b == "video" && d && c.mimeType == "video/mp4" && (d = sg(d));
            var e = wf(c.mimeType, d);
            if (b == Ec) cl(a, e, a.I, c.external);
            else {
                var f = a.C.forceTransmux;
                if (!Si(e) || !a.I && yf.includes(e)) f = !0;
                var g = zf(c.mimeType, d);
                if (f) {
                    f = Cc("audio", (d || "").split(","));
                    d = Cc("video", (d || "").split(","));
                    if (f && d) {
                        a.o = !0;
                        bl(a, "audio", c, f);
                        bl(a, "video", c, d);
                        return;
                    }
                    if (d = of(g)) e = d(), a.j.set(b, e), e = e.convertCodecs(b, g);
                }
                g = e + a.C.addExtraFeaturesToSourceBuffer(e);
                vh(a.G);
                try {
                    var h = a.i.addSourceBuffer(g);
                } catch (k) {
                    throw new T(2, 3, 3015, k, "The mediaSource_ status was " + a.i.readyState + " expected 'open'", null);
                }
                a.I && (h.mode = dl);
                a.A.u(h, "error", function() {
                    var k = a.m.get(b)[0];
                    k.p.reject(new T(2, 3, 3014, a.g.error ? a.g.error.code : 0, k.uri));
                });
                a.A.u(h, "updateend", function() {
                    return el(a, b);
                });
                a.l.set(b, h);
                a.F.set(b, e);
                a.Ia.set(b, !!c.drmInfos.length);
            }
        }
        p.configure = function(a) {
            this.C = a;
            this.h && (this.h.D = a.modifyCueCallback);
        };
        function fl(a) {
            return a.va && !a.M && !a.H;
        }
        function cl(a, b, c, d) {
            a.h || (a.h = new If(a.X), a.h && (a.h.D = a.C.modifyCueCallback));
            var e = a.h, f = a.Ga;
            a = a.P;
            b == "application/cea-608" || b == "application/cea-708" ? e.i = null : (e.i = Kf.get(b)(), e.i.setSequenceMode ? e.i.setSequenceMode(c) : md("Text parsers w/ setSequenceMode", 'Text parsers should have a "setSequenceMode" method!'), e.i.setManifestType ? e.i.setManifestType(a) : md("Text parsers w/ setManifestType", 'Text parsers should have a "setManifestType" method!'), e.G = f, e.C = d);
        }
        function $k(a) {
            return a.H ? !1 : a.i ? a.i.readyState == "ended" : !0;
        }
        function al(a) {
            return a.H ? !1 : a.i ? a.i.readyState == "closed" : !0;
        }
        function gl(a, b) {
            return a.l.size ? b == Ec ? a.h.g : Uj(hl(a, b)) : null;
        }
        function il(a, b) {
            return a.l.size ? b == Ec ? a.h.h : Vj(hl(a, b)) : null;
        }
        function jl(a, b, c) {
            if (b == Ec) return a = a.h, a.h == null || a.h < c ? 0 : a.h - Math.max(c, a.g);
            a = hl(a, b);
            return Xj(a, c);
        }
        p.Nc = function() {
            var a = {
                total: this.H ? [] : Yj(this.g.buffered),
                audio: Yj(hl(this, "audio")),
                video: Yj(hl(this, "video")),
                text: []
            };
            if (this.h) {
                var b = this.h.g, c = this.h.h;
                b != null && c != null && a.text.push({
                    start: b,
                    end: c
                });
            }
            return a;
        };
        function hl(a, b) {
            if (a.H || a.M || al(a)) return null;
            try {
                return a.l.get(b).buffered;
            } catch (c) {
                return a.l.has(b), null;
            }
        }
        function kl(a, b, c, d, e, f, g) {
            g = g === void 0 ? !1 : g;
            var h = null, k = [], l = Fb(c);
            if (yf.includes(f)) c = pk(l), c.length && d && ((g = c.find(function(v) {
                return v.description === "com.apple.streaming.transportStreamTimestamp";
            })) && typeof g.data == "number" && (h = Math.round(g.data) / 1E3), a.O.onMetadata([
                {
                    cueTime: d.startTime,
                    data: l,
                    frames: c,
                    dts: d.startTime,
                    pts: d.startTime
                }
            ], 0, d.endTime));
            else if (f.includes("/mp4") && d && d.ia) {
                l = new Bh;
                var m = e.emsgSchemeIdUris != null && e.emsgSchemeIdUris.length > 0 || a.C.dispatchAllEmsgBoxes, n = [];
                m && l.qa("emsg", function(v) {
                    a: {
                        var w = e.emsgSchemeIdUris;
                        if (v.version === 0) {
                            var x = v.reader.Qd();
                            var y = v.reader.Qd();
                            var z = v.reader.Y();
                            var A = v.reader.Y();
                            var E = v.reader.Y();
                            var C = v.reader.Y();
                            var D = d.startTime + A / z;
                        } else z = v.reader.Y(), D = v.reader.Rd() / z + d.timestampOffset, A = D - d.startTime, E = v.reader.Y(), C = v.reader.Y(), x = v.reader.Qd(), y = v.reader.Qd();
                        v = v.reader.Wb(v.reader.getLength() - v.reader.Xa(), !0);
                        if (w && w.includes(x) || a.C.dispatchAllEmsgBoxes) {
                            if (x == "urn:mpeg:dash:event:2012") a.O.Xl();
                            else {
                                w = D;
                                if (x !== "https://aomedia.org/emsg/ID3" || E !== 4294967295) w += E / z;
                                z = {
                                    startTime: D,
                                    endTime: w,
                                    schemeIdUri: x,
                                    value: y,
                                    timescale: z,
                                    presentationTimeDelta: A,
                                    eventDuration: E,
                                    id: C,
                                    messageData: v
                                };
                                break a;
                            }
                        }
                        z = null;
                    }
                    z && n.push(z);
                });
                var q = d.ia.timescale;
                b = q && !isNaN(q);
                var r = 0, t = !1;
                b && l.qa("prft", function(v) {
                    var w = v.reader, x = v.version;
                    w.Y();
                    v = w.Y();
                    var y = w.Y();
                    v = v * 1E3 + y / 4294967296 * 1E3;
                    x === 0 ? w = w.Y() : (x = w.Y(), w = w.Y(), w = x * 4294967296 + w);
                    v = sk(v);
                    w = (new Map).set("detail", {
                        wallClockTime: v,
                        programStartDate: new Date(v - w / q * 1E3)
                    });
                    w = new R("prft", w);
                    a.O.onEvent(w);
                }).boxes([
                    "moof",
                    "traf"
                ], Gh).qa("tfdt", function(v) {
                    t || (r = Wi(v.reader, v.version).baseMediaDecodeTime / q, t = !0, m || v.parser.stop());
                });
                (m || b) && l.parse(c, !1, g);
                t && d.timestampOffset == 0 && (h = r);
                l = u(n);
                for(c = l.next(); !c.done; c = l.next())ll(a, c.value, d, h);
            } else f.includes("/mp4") || f.includes("/webm") || !Rk(l) || (a.W.has(b) || a.W.set(b, new Ek), k = a.W.get(b), k.clearData(), k.hg(d.i), k.parse(l), l = Lk(k, b), l != null && (h = l), k = k.getMetadata());
            return {
                timestamp: h,
                metadata: k
            };
        }
        function ll(a, b, c, d) {
            var e = rk(b.startTime, c.startTime + b.presentationTimeDelta / b.timescale);
            d && a.P == "HLS" && !e && (c = -d + c.startTime, b.startTime += c, b.endTime += c);
            a.O.Vl(b);
            !b.messageData || b.schemeIdUri != "https://aomedia.org/emsg/ID3" && b.schemeIdUri != "https://developer.apple.com/streaming/emsg-id3" || (c = pk(b.messageData), c.length && (d = b.startTime, a.O.onMetadata([
                {
                    cueTime: d,
                    data: b.messageData,
                    frames: c,
                    dts: d,
                    pts: d
                }
            ], 0, b.endTime)));
        }
        function ml(a, b, c, d, e, f, g, h, k, l, m) {
            g = g === void 0 ? !1 : g;
            h = h === void 0 ? !1 : h;
            k = k === void 0 ? !1 : k;
            l = l === void 0 ? !1 : l;
            var n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M;
            return H(function(L) {
                switch(L.h){
                    case 1:
                        n = Gc;
                        if (b != n.Va) {
                            L.B(2);
                            break;
                        }
                        if (a.P != "HLS") {
                            L.B(3);
                            break;
                        }
                        return L.g(a.hb, 4);
                    case 4:
                        q = L.i, a.h.A = q;
                    case 3:
                        return L.g(Nf(a.h, c, d ? d.startTime : null, d ? d.endTime : null, d ? d.T()[0] : null), 5);
                    case 5:
                        return L.return();
                    case 2:
                        if (l || !a.o) {
                            L.B(6);
                            break;
                        }
                        return L.g(ml(a, n.ha, c, d, e, f, g, h, k, !0), 7);
                    case 7:
                        return L.g(ml(a, n.Ba, c, d, e, f, g, h, k, !0), 8);
                    case 8:
                        return L.return();
                    case 6:
                        if (!a.l.has(b)) return L.return();
                        r = a.l.get(b).timestampOffset;
                        t = a.F.get(b);
                        a.j.has(b) && (t = a.j.get(b).getOriginalMimeType());
                        if (d && (v = kl(a, b, c, d, e, t, k), w = v.timestamp, x = v.metadata, w != null && (a.S == null && b == n.Ba && (a.S = w, a.na = d.startTime, a.R != null && (y = 0, a.na == a.ba && (y = a.S - a.R), a.$.resolve(y))), a.R == null && b == n.ha && (a.R = w, a.ba = d.startTime, a.S != null && (z = 0, a.na == a.ba && (z = a.S - a.R), a.$.resolve(z))), A = w, E = yf, !a.I && E.includes(a.F.get(b)) && (A = 0), C = d.startTime - A, D = Math.abs(r - C), (D >= .001 || g || h) && (!k || C > 0 || !r) && (r = C, a.ab && (nl(a, b, function() {
                            return ol(a, b);
                        }, null), nl(a, b, function() {
                            return pl(a, b, r);
                        }, null))), (B = b == n.Ba || !a.l.has(n.Ba)) && a.hb.resolve(r)), x.length)) a.O.onMetadata(x, r, d ? d.endTime : null);
                        f && b == n.Ba && (a.h || cl(a, "application/cea-608", a.I, !1), a.J || (J = t.split(";", 1)[0], a.J = new Fd(J)), d ? (F = Jd(a.J, c), F.length && Tf(a.h, F, r)) : a.J.init(c, h, m));
                        if (!a.j.has(b)) {
                            L.B(9);
                            break;
                        }
                        return L.g(a.j.get(b).transmux(c, e, d, a.i.duration, b), 10);
                    case 10:
                        I = L.i, ArrayBuffer.isView(I) ? c = I : (K = I, K.init != null && (N = K.init, nl(a, b, function() {
                            a.D && td(a.D, N, r, e);
                            a.l.get(b).appendBuffer(N);
                        }, d ? d.T()[0] : null)), c = K.data);
                    case 9:
                        c = ql(a, e, c, d, b);
                        if (!d || !a.I || b == n.Va) {
                            L.B(11);
                            break;
                        }
                        if (!g && !h) {
                            L.B(11);
                            break;
                        }
                        P = d.startTime;
                        if (a.P != "HLS" || a.o || b != n.ha || !a.l.has(n.Ba)) {
                            L.B(13);
                            break;
                        }
                        return L.g(a.$, 14);
                    case 14:
                        M = L.i, Math.abs(M) > .15 && (P -= M);
                    case 13:
                        nl(a, b, function() {
                            return ol(a, b);
                        }, null), nl(a, b, function() {
                            return pl(a, b, P);
                        }, null);
                    case 11:
                        return L.g(nl(a, b, function() {
                            var Q = c;
                            a.D && td(a.D, Q, r, e);
                            a.l.get(b).appendBuffer(Q);
                        }, d ? d.T()[0] : null), 15);
                    case 15:
                        L.j();
                }
            });
        }
        function rl(a, b) {
            var c = il(a, "video") || 0;
            Rf(a.h, b, c);
        }
        function sl(a) {
            a.h && Rf(a.h, "", 0);
        }
        p.remove = function(a, b, c, d) {
            var e = this, f, g;
            return H(function(h) {
                return h.h == 1 ? (f = Gc, a == f.Ba && e.J && (e.J.remove(d), g = e.h.g || 0, e.h.remove(g, c, !0)), a == f.Va ? h.g(e.h.remove(b, c), 0) : c > b ? h.g(nl(e, a, function() {
                    return tl(e, a, b, c);
                }, null), 5) : h.B(0)) : e.o ? h.g(nl(e, f.ha, function() {
                    return tl(e, f.ha, b, c);
                }, null), 0) : h.B(0);
            });
        };
        function ul(a, b) {
            var c;
            return H(function(d) {
                return d.h == 1 ? (c = Gc, b == c.Va ? a.h ? d.g(a.h.remove(0, Infinity), 0) : d.return() : b === c.Ba && a.J && a.h ? d.g(a.h.remove(0, Infinity, !0), 4) : d.B(4)) : d.h != 6 ? d.g(nl(a, b, function() {
                    return tl(a, b, 0, a.i.duration);
                }, null), 6) : a.o ? d.g(nl(a, c.ha, function() {
                    return tl(a, c.ha, 0, a.i.duration);
                }, null), 0) : d.B(0);
            });
        }
        p.flush = function(a) {
            var b = this, c;
            return H(function(d) {
                return d.h == 1 ? (c = Gc, a == c.Va ? d.return() : d.g(nl(b, a, function() {
                    b.g.currentTime -= .001;
                    el(b, a);
                }, null), 2)) : b.o ? d.g(nl(b, c.ha, function() {
                    var e = c.ha;
                    b.g.currentTime -= .001;
                    el(b, e);
                }, null), 0) : d.B(0);
            });
        };
        function vl(a, b, c, d, e, f, g, h, k) {
            var l, m, n;
            return H(function(q) {
                if (q.h == 1) {
                    l = Gc;
                    if (b == l.Va) return f || (a.h.A = c), Qf(a.h, d, e), q.return();
                    m = [];
                    return q.g(wl(a, b, g, h, k), 2);
                }
                n = q.i;
                n || (m.push(nl(a, b, function() {
                    return ol(a, b);
                }, null)), a.o && m.push(nl(a, l.ha, function() {
                    return ol(a, l.ha);
                }, null)));
                f || (m.push(nl(a, b, function() {
                    return pl(a, b, c);
                }, null)), a.o && m.push(nl(a, l.ha, function() {
                    return pl(a, l.ha, c);
                }, null)));
                if (d != 0 || e != Infinity) m.push(nl(a, b, function() {
                    return xl(a, b, d, e);
                }, null)), a.o && m.push(nl(a, l.ha, function() {
                    return xl(a, l.ha, d, e);
                }, null));
                return m.length ? q.g(Promise.all(m), 0) : q.B(0);
            });
        }
        function yl(a, b, c) {
            var d, e;
            return H(function(f) {
                if (f.h == 1) {
                    d = Gc;
                    if (b == d.Va) return f.return();
                    b == d.Ba && (a.hb = new Yg);
                    if (!a.I || (e = il(a, b)) && Math.abs(e - c) < .15) return f.return();
                    nl(a, b, function() {
                        return ol(a, b);
                    }, null);
                    a.o && nl(a, d.ha, function() {
                        return ol(a, d.ha);
                    }, null);
                    return f.g(nl(a, b, function() {
                        return pl(a, b, c);
                    }, null), 2);
                }
                return a.o ? f.g(nl(a, d.ha, function() {
                    return pl(a, d.ha, c);
                }, null), 0) : f.B(0);
            });
        }
        p.endOfStream = function(a) {
            var b = this;
            return H(function(c) {
                return c.g(zl(b, function() {
                    $k(b) || al(b) || (a ? b.i.endOfStream(a) : b.i.endOfStream());
                }), 0);
            });
        };
        p.Ab = function(a) {
            var b = this;
            return H(function(c) {
                return c.g(zl(b, function() {
                    if (b.C.durationReductionEmitsUpdateEnd && a < b.i.duration) for(var d = u(b.l.keys()), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        var f = {
                            start: function() {},
                            p: new Yg,
                            uri: null
                        };
                        b.m.get(e).unshift(f);
                    }
                    b.i.duration = a;
                    b.ua = a;
                }), 0);
            });
        };
        p.getDuration = function() {
            return this.i.duration;
        };
        function Al(a, b, c) {
            H(function(d) {
                return a.G.g || a.g.error || a.M || a.H || $k(a) || al(a) ? d.return() : d.g(zl(a, function() {
                    $k(a) || al(a) || a.i.setLiveSeekableRange(b, c);
                }), 0);
            });
        }
        function Bl(a) {
            H(function(b) {
                return a.G.g || a.g.error || a.M || a.H || $k(a) || al(a) ? b.return() : b.g(zl(a, function() {
                    $k(a) || al(a) || a.i.clearLiveSeekableRange();
                }), 0);
            });
        }
        function tl(a, b, c, d) {
            if (d <= c) el(a, b);
            else {
                if (a.D) {
                    var e = a.D;
                    b === "video" && e.g && e.g.flushBuffer(c, d);
                }
                a.l.get(b).remove(c, d);
            }
        }
        function ol(a, b) {
            var c = a.l.get(b), d = c.appendWindowStart, e = c.appendWindowEnd;
            c.abort();
            c.appendWindowStart = d;
            c.appendWindowEnd = e;
            el(a, b);
        }
        function pl(a, b, c) {
            c < 0 && (c += .001);
            a.l.get(b).timestampOffset = c;
            el(a, b);
        }
        function xl(a, b, c, d) {
            var e = a.l.get(b);
            if (e.appendWindowEnd !== d || e.appendWindowStart !== c) e.appendWindowStart = 0, e.appendWindowEnd = d, e.appendWindowStart = c;
            el(a, b);
        }
        function el(a, b) {
            if (a.H || a.G.g) {
                var c = a.m.get(b);
                c && c.length && ((c = c[0]) && c.p && c.p.resolve(), a.m.set(b, []));
            } else if (c = a.m.get(b)[0]) c.p.resolve(), Cl(a, b);
        }
        function nl(a, b, c, d) {
            vh(a.G);
            c = {
                start: c,
                p: new Yg,
                uri: d
            };
            a.m.get(b).push(c);
            a.m.get(b).length == 1 && Dl(a, b);
            return c.p;
        }
        function zl(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z;
            return H(function(A) {
                switch(A.h){
                    case 1:
                        vh(a.G);
                        c = [];
                        d = Array.from(a.l.keys());
                        e = new Map;
                        f = u(d);
                        g = f.next();
                        for(h = {}; !g.done; h = {
                            ready: void 0
                        }, g = f.next())k = g.value, h.ready = new Yg, l = {
                            start: function(E) {
                                return function() {
                                    return E.ready.resolve();
                                };
                            }(h),
                            p: h.ready,
                            uri: null
                        }, m = a.m.get(k), m.push(l), c.push(h.ready), e.set(k, l), m.length == 1 && l.start();
                        A.m(2);
                        return A.g(Promise.all(c), 4);
                    case 4:
                        A.o(3);
                        break;
                    case 2:
                        n = A.l();
                        if (a.G.g) {
                            q = u(d);
                            for(r = q.next(); !r.done; r = q.next())t = r.value, v = a.m.get(t), e.has(t) && ad(v, e.get(t));
                            return A.return();
                        }
                        throw n;
                    case 3:
                        return A.m(5, 6), A.g(b(), 6);
                    case 6:
                        A.A();
                        w = u(d);
                        for(x = w.next(); !x.done; x = w.next())y = x.value, Cl(a, y);
                        A.C(0);
                        break;
                    case 5:
                        throw z = A.l(), new T(2, 3, 3015, z, a.g.error || "No error in the media element", null);
                }
            });
        }
        function Cl(a, b) {
            a.m.get(b).shift();
            Dl(a, b);
        }
        function Dl(a, b) {
            var c = a.m.get(b)[0];
            if (c) try {
                c.start();
            } catch (d) {
                d.name == "QuotaExceededError" ? c.p.reject(new T(2, 3, 3017, b)) : fl(a) ? c.p.reject(new T(2, 3, 3015, d, a.g.error || "No error in the media element", c.uri)) : c.p.reject(new T(2, 3, 3024, b)), Cl(a, b);
            }
        }
        function El(a, b) {
            a.X = b;
            a.h && (a.h.l = b);
        }
        function ql(a, b, c, d, e) {
            if (Bf(a.F.get(e)) != "mp4") return c;
            var f = d === null, g = a.Ia.get(e), h = a.O.Uk(), k = !1;
            d && d.ia && (k = d.ia.encrypted);
            d = d ? d.T()[0] : null;
            var l = Xb();
            a.C.correctEc3Enca && f && e === "audio" && (c = Ej(c));
            a.C.insertFakeEncryptionInInit && g && l.Sd(h, e) && (f ? c = Fj(b, c, d) : !k && l.Cj(e) && (c = Ij(c)));
            f && l.Fe() && (c = Lj(c));
            return c;
        }
        function Fl(a, b, c, d) {
            return nl(a, b, function() {
                if (b !== Ec) {
                    a.F.get(b);
                    if (Xb().Bb()) {
                        a.j.has(b) && (a.j.get(b).destroy(), a.j.delete(b));
                        d && a.j.set(b, d);
                        var e = c + a.C.addExtraFeaturesToSourceBuffer(c);
                        a.l.get(b).changeType(e);
                        a.F.set(b, c);
                    }
                    el(a, b);
                }
            }, null);
        }
        function Ol(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            return H(function(C) {
                if (C.h == 1) {
                    if (a.H || a.M) return C.return();
                    c = Gc;
                    a.H = !0;
                    a.o = !1;
                    d = a.g.currentTime;
                    e = a.g.autoplay;
                    a.g.paused || (a.Oa = !0);
                    a.kb && (a.g.autoplay = !1);
                    C.F(2);
                    a.A.Ta();
                    f = u(a.j.values());
                    for(g = f.next(); !g.done; g = f.next())h = g.value, h.destroy();
                    k = u(a.l.values());
                    for(l = k.next(); !l.done; l = k.next()){
                        m = l.value;
                        try {
                            a.i.removeSourceBuffer(m);
                        } catch (D) {}
                    }
                    a.j.clear();
                    a.l.clear();
                    n = a.i.duration;
                    a.L = new Yg;
                    a.i = Tk(a, a.L);
                    return C.g(a.L, 4);
                }
                if (C.h != 2) {
                    !isNaN(n) && n ? a.i.duration = n : !isNaN(a.ua) && a.ua && (a.i.duration = a.ua);
                    q = new Yg;
                    r = a.i.sourceBuffers;
                    t = b.size;
                    v = 0;
                    w = function() {
                        v++;
                        v === t && (q.resolve(), a.A.Fa(r, "addsourcebuffer", w));
                    };
                    a.A.u(r, "addsourcebuffer", w);
                    x = u(b.keys());
                    for(y = x.next(); !y.done; y = x.next())z = y.value, A = b.get(z), bl(a, z, A, A.codecs);
                    (E = b.get(c.ha)) && E.isAudioMuxedInVideo && (a.o = !0);
                    a.o && !a.m.has(c.ha) && a.m.set(c.ha, []);
                    return C.g(q, 2);
                }
                C.A();
                a.H = !1;
                vh(a.G);
                a.A.ra(a.g, "loadedmetadata", function() {
                    a.G.g || (a.g.currentTime = d);
                });
                a.A.ra(a.g, "canplaythrough", function() {
                    a.G.g || (a.g.autoplay = e, a.Oa && (a.Oa = !1, a.g.play()));
                });
                return C.C(0);
            });
        }
        function Pl(a, b) {
            return zl(a, function() {
                return Ol(a, b);
            });
        }
        function Ql(a, b, c, d) {
            var e = !1, f = Cc("audio", (d || "").split(",")), g = Cc("video", (d || "").split(",")), h = g;
            b == "audio" && (h = f);
            h || (h = d);
            var k = wf(c, h), l = Ff(a.F.get(b)), m = a.C.forceTransmux;
            !Si(k) || !a.I && yf.includes(k) ? m = !0 : m || c == l || (m = !Xb().mg() && yf.includes(c));
            if (m && (a = zf(c, h), h = of(a))) {
                var n = h();
                f && g && (e = !0);
                k = n.convertCodecs(b, a);
            }
            !n && b === "video" && f && (k = wf(c, d));
            b = Cf(Gf(k));
            return {
                qc: n,
                Cm: e,
                Mi: Ff(k),
                codec: b,
                mimeType: k
            };
        }
        function Rl(a, b, c, d, e) {
            if (b == Ec) return {
                type: Sl,
                Rf: c,
                qc: null
            };
            var f = Cf(Gf(a.F.get(b))), g = Ff(a.F.get(b)), h = Ql(a, b, c, d), k = h.qc, l = h.Cm, m = h.Mi, n = h.codec;
            h = h.mimeType;
            var q = !0;
            l && a.F.has("audio") && (c = Ql(a, "audio", c, d), d = Cf(Gf(a.F.get("audio"))), q = Ff(a.F.get("audio")), q = d == c.codec && q == c.Mi, c.qc && c.qc.destroy());
            if (f === n && g === m && q) return {
                type: Sl,
                Rf: h,
                qc: k
            };
            f = !0;
            if (a.o && !e.has("audio") || l && k && !a.j.has(b)) f = !1;
            b = Xb();
            if (f && a.C.codecSwitchingStrategy === "smooth" && b.Bb()) return {
                type: Tl,
                Rf: h,
                qc: k
            };
            k && k.destroy();
            return {
                type: Ul,
                Rf: h,
                qc: null
            };
        }
        function wl(a, b, c, d, e) {
            var f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) {
                    f = Gc;
                    g = Rl(a, b, c, d, e);
                    h = g.type;
                    k = g.qc;
                    l = g.Rf;
                    if (m = e.get(f.ha)) a.o = m.isAudioMuxedInVideo;
                    if (h == Sl) return a.j.has(b) && !k ? (a.j.get(b).destroy(), a.j.delete(b)) : !a.j.has(b) && k ? a.j.set(b, k) : k && (a.j.has(b) && a.j.get(b).transmux !== k.transmux ? (a.j.get(b).destroy(), a.j.set(b, k)) : k.destroy()), n.return(!1);
                    if (h == Tl) return n.g(Fl(a, b, l, k), 3);
                    if (h != Ul) return n.B(3);
                    k && k.destroy();
                    return n.g(Pl(a, e), 3);
                }
                return n.return(!0);
            });
        }
        function Vl(a, b, c, d, e) {
            a = Rl(a, b, c, d, e);
            a.qc && a.qc.destroy();
            return a.type == Ul;
        }
        var Vk = window1.URL.createObjectURL, dl = "sequence", Sl = "none", Ul = "reset", Tl = "changeType";
        function Wl(a, b, c) {
            this.i = a;
            this.F = b;
            this.A = this.l = Infinity;
            this.h = 1;
            this.g = this.j = null;
            this.C = 0;
            this.D = !0;
            this.J = !1;
            this.I = 0;
            this.G = c === void 0 ? !0 : c;
            this.H = 0;
            this.o = !1;
            this.m = a;
        }
        p = Wl.prototype;
        p.getDuration = function() {
            return this.l;
        };
        p.Zk = function() {
            return this.h;
        };
        p.Pj = function(a) {
            this.i = a;
        };
        p.Ab = function(a) {
            this.l = a;
        };
        p.hl = function() {
            return this.i;
        };
        p.Mj = function(a) {
            this.C = a;
        };
        p.md = function(a) {
            a && !this.D && (this.J = !0);
            this.D = a;
        };
        p.ig = function(a) {
            this.A = a;
        };
        p.xf = function() {
            return this.A;
        };
        p.ii = function(a) {
            this.F = a;
        };
        p.Pk = function() {
            return this.F;
        };
        p.wj = function(a, b) {
            if (a.length != 0) {
                var c = (Date.now() + this.C) / 1E3;
                a = a.filter(function(e) {
                    return e.start + b < c;
                });
                if (a.length != 0) {
                    var d = a[a.length - 1].end + b;
                    this.Sf(a[0].start + b);
                    this.h = a.reduce(function(e, f) {
                        return Math.max(e, f.end - f.start);
                    }, this.h);
                    this.g = Math.max(this.g, d);
                    this.i != null && this.G && !this.o && (this.i = c - this.g - this.h);
                }
            }
        };
        p.Ae = function(a) {
            if (a.length != 0) {
                var b = a[0].startTime, c = a[0].endTime, d = (Date.now() + this.C) / 1E3;
                a = u(a);
                for(var e = a.next(); !e.done; e = a.next())e = e.value, d < e.startTime || (b = Math.min(b, e.startTime), c = Math.max(c, e.endTime), this.h = Math.max(this.h, e.endTime - e.startTime));
                this.Sf(b);
                this.g = Math.max(this.g, c);
                this.i != null && this.G && !this.o && (this.i = d - this.g - this.h);
            }
        };
        p.vj = function(a, b) {
            this.Sf(a);
            b == Infinity || this.U() || (this.g = Math.max(this.g, b));
        };
        p.$k = function() {
            return this.g;
        };
        p.Mf = function() {
            this.o = !0;
        };
        p.Kl = function() {
            return this.o;
        };
        p.ki = function(a) {
            this.m = a;
        };
        p.Tk = function() {
            return this.m;
        };
        p.Sf = function(a) {
            this.j == null ? this.j = a : this.J || (this.j = Math.min(this.j, a));
        };
        p.Oh = function(a) {
            this.h = Math.max(this.h, a);
        };
        p.offset = function(a) {
            this.j != null && (this.j += a);
            this.g != null && (this.g += a);
        };
        p.U = function() {
            return this.l == Infinity && !this.D;
        };
        p.fd = function() {
            return this.l != Infinity && !this.D;
        };
        p.Hb = function() {
            return Math.max(this.I, this.Pc() - this.A);
        };
        p.Sj = function(a) {
            this.I = a;
        };
        p.Pc = function() {
            return this.U() || this.fd() ? Math.min(Math.max(0, (Date.now() + this.C) / 1E3 - this.h - this.i) + this.H, this.l) : this.g ? Math.min(this.g, this.l) : this.l;
        };
        p.pe = function(a) {
            var b = Math.max(this.j, this.I);
            return this.A == Infinity ? Math.ceil(b * 1E3) / 1E3 : Math.max(b, Math.min(this.Pc() - this.A + a, this.Gb()));
        };
        p.cc = function() {
            return this.pe(0);
        };
        p.Gb = function() {
            return Math.max(0, this.Pc() - (this.U() || this.fd() ? this.F : 0));
        };
        p.hk = function() {
            return this.i == null || this.g != null && this.G ? !1 : !0;
        };
        p.Lj = function(a) {
            this.H = a;
        };
        p.Fk = function() {
            return this.H;
        };
        O("shaka.media.PresentationTimeline", Wl);
        Wl.prototype.getAvailabilityTimeOffset = Wl.prototype.Fk;
        Wl.prototype.setAvailabilityTimeOffset = Wl.prototype.Lj;
        Wl.prototype.usingPresentationStartTime = Wl.prototype.hk;
        Wl.prototype.getSeekRangeEnd = Wl.prototype.Gb;
        Wl.prototype.getSeekRangeStart = Wl.prototype.cc;
        Wl.prototype.getSafeSeekRangeStart = Wl.prototype.pe;
        Wl.prototype.getSegmentAvailabilityEnd = Wl.prototype.Pc;
        Wl.prototype.setUserSeekStart = Wl.prototype.Sj;
        Wl.prototype.getSegmentAvailabilityStart = Wl.prototype.Hb;
        Wl.prototype.isInProgress = Wl.prototype.fd;
        Wl.prototype.isLive = Wl.prototype.U;
        Wl.prototype.offset = Wl.prototype.offset;
        Wl.prototype.notifyMaxSegmentDuration = Wl.prototype.Oh;
        Wl.prototype.notifyMinSegmentStartTime = Wl.prototype.Sf;
        Wl.prototype.getInitialProgramDateTime = Wl.prototype.Tk;
        Wl.prototype.setInitialProgramDateTime = Wl.prototype.ki;
        Wl.prototype.isStartTimeLocked = Wl.prototype.Kl;
        Wl.prototype.lockStartTime = Wl.prototype.Mf;
        Wl.prototype.getMaxSegmentEndTime = Wl.prototype.$k;
        Wl.prototype.notifyPeriodDuration = Wl.prototype.vj;
        Wl.prototype.notifySegments = Wl.prototype.Ae;
        Wl.prototype.notifyTimeRange = Wl.prototype.wj;
        Wl.prototype.getDelay = Wl.prototype.Pk;
        Wl.prototype.setDelay = Wl.prototype.ii;
        Wl.prototype.getSegmentAvailabilityDuration = Wl.prototype.xf;
        Wl.prototype.setSegmentAvailabilityDuration = Wl.prototype.ig;
        Wl.prototype.setStatic = Wl.prototype.md;
        Wl.prototype.setClockOffset = Wl.prototype.Mj;
        Wl.prototype.getPresentationStartTime = Wl.prototype.hl;
        Wl.prototype.setDuration = Wl.prototype.Ab;
        Wl.prototype.setPresentationStartTime = Wl.prototype.Pj;
        Wl.prototype.getMaxSegmentDuration = Wl.prototype.Zk;
        Wl.prototype.getDuration = Wl.prototype.getDuration;
        function Xl(a, b, c, d) {
            var e = this;
            this.A = d;
            this.g = a;
            this.F = b;
            this.h = c;
            this.l = new fd;
            this.o = !1;
            this.m = 0;
            this.D = !1;
            this.H = this.G = 0;
            this.j = Yl(this);
            this.C = !1;
            this.l.u(a, "waiting", function() {
                return Zl(e);
            });
            this.i = new Uf(function() {
                Zl(e);
            }).xa(this.h.gapJumpTimerTime);
        }
        Xl.prototype.release = function() {
            this.l && (this.l.release(), this.l = null);
            this.i != null && (this.i.stop(), this.i = null);
            this.j && (this.j.release(), this.j = null);
            this.g = this.F = this.A = null;
        };
        Xl.prototype.Md = function() {
            this.C = !0;
            this.i && this.i.xa(this.h.gapJumpTimerTime);
            Zl(this);
        };
        function Zl(a) {
            if (a.g.readyState != 0) {
                if (a.g.seeking) {
                    if (!a.o) return;
                } else a.o = !1;
                if (!a.g.paused || a.g.currentTime == a.m && (a.g.autoplay || a.g.currentTime != a.m)) {
                    if (!a.j || !$l(a.j)) {
                        var b = a.g.currentTime, c = a.g.buffered, d = Zj(c, b, a.h.gapDetectionThreshold);
                        if (d == null && a.j && !$l(a.j)) {
                            for(var e = Yj(c), f = 0; f < e.length - 1; f++)if (Math.abs(b - e[f].end) < .1 && e[f + 1].start > e[f].end) {
                                d = f + 1;
                                break;
                            }
                        }
                        d == null || d == 0 && !a.C || (e = c.start(d), (f = a.h.gapPadding) && (e = Math.ceil((e + f) * 100) / 100), e >= a.F.Gb() || e - b < .001 || (d != 0 && c.end(d - 1), am(a, e), b == a.m && (a.m = e), a.G++, a.A(new R("gapjumped"))));
                    }
                }
            }
        }
        function am(a, b) {
            a.D = !0;
            a.l.ra(a.g, "seeked", function() {
                a.D = !1;
            });
            a.g.currentTime = b;
        }
        function Yl(a) {
            if (!a.h.stallEnabled) return null;
            var b = a.h.stallThreshold, c = a.h.stallSkip;
            return new bm(new cm(a.g), b, function(d, e, f) {
                var g;
                return H(function(h) {
                    if (h.h == 1) return g = Yj(a.g.buffered), g.length ? c ? (a.g.currentTime += c, h.B(2)) : h.g(a.g.play(), 3) : h.return();
                    if (h.h != 2) {
                        if (!a.g) return h.return();
                        a.g.pause();
                        a.g.play();
                    }
                    f == 0 && (a.H++, a.A(new R("stalldetected")));
                    h.j();
                });
            });
        }
        function bm(a, b, c) {
            this.i = a;
            this.A = dm(a);
            this.h = a.g.currentTime;
            this.m = Date.now() / 1E3;
            this.l = this.g = 0;
            this.o = b;
            this.j = c;
        }
        bm.prototype.release = function() {
            this.i && this.i.release();
            this.j = this.i = null;
        };
        function $l(a) {
            var b = a.i, c = dm(b), d = b.g.currentTime, e = Date.now() / 1E3;
            if (a.h != d || a.A != c) a.m = e, a.h = d, a.A = c, a.g = 0;
            d = e - a.m;
            if (c = d >= a.o && c && a.g < 3 && (a.g == 0 || e - a.l >= a.o)) a.j && a.j(a.h, d, a.g), a.g++, a.l = e, a.h = b.g.currentTime;
            return c;
        }
        function cm(a) {
            var b = this;
            this.g = a;
            this.h = new fd;
            this.i = !1;
            this.h.u(this.g, "audiofocuspaused", function() {
                b.i = !0;
            });
            this.h.u(this.g, "audiofocusgranted", function() {
                b.i = !1;
            });
            this.h.u(this.g, "audiofocuslost", function() {
                b.i = !0;
            });
        }
        function dm(a) {
            if (a.g.paused || a.g.playbackRate == 0 || a.i || a.g.buffered.length == 0) var b = !1;
            else a: {
                b = a.g.currentTime;
                a = u(Yj(a.g.buffered));
                for(var c = a.next(); !c.done; c = a.next())if (c = c.value, !(b < c.start - .1 || b > c.end - .5)) {
                    b = !0;
                    break a;
                }
                b = !1;
            }
            return b;
        }
        cm.prototype.release = function() {
            this.h && this.h.release();
            this.h = null;
        };
        function em(a, b, c, d) {
            b == HTMLMediaElement.HAVE_NOTHING || a.readyState >= b ? d() : (b = fm.value().get(b), c.ra(a, b, d));
        }
        var fm = new Kb(function() {
            return new Map([
                [
                    HTMLMediaElement.HAVE_METADATA,
                    "loadedmetadata"
                ],
                [
                    HTMLMediaElement.HAVE_CURRENT_DATA,
                    "loadeddata"
                ],
                [
                    HTMLMediaElement.HAVE_FUTURE_DATA,
                    "canplay"
                ],
                [
                    HTMLMediaElement.HAVE_ENOUGH_DATA,
                    "canplaythrough"
                ]
            ]);
        });
        function gm(a, b, c, d) {
            var e = this;
            this.g = a;
            this.m = b;
            this.A = c;
            this.l = null;
            this.j = function() {
                e.l == null && (e.l = d());
                return e.l;
            };
            this.o = !1;
            this.h = new fd;
            this.i = new hm(a);
            em(this.g, HTMLMediaElement.HAVE_METADATA, this.h, function() {
                im(e, e.j());
            });
        }
        gm.prototype.release = function() {
            this.h && (this.h.release(), this.h = null);
            this.i != null && (this.i.release(), this.i = null);
            this.m = function() {};
            this.g = null;
        };
        function jm(a) {
            return a.o ? a.g.currentTime : a.j();
        }
        function km(a, b) {
            a.g.readyState > 0 ? lm(a.i, b) : em(a.g, HTMLMediaElement.HAVE_METADATA, a.h, function() {
                im(a, a.j());
            });
        }
        function im(a, b) {
            Math.abs(a.g.currentTime - b) < .001 ? mm(a) : (a.h.ra(a.g, "seeking", function() {
                mm(a);
            }), lm(a.i, a.g.currentTime && a.g.currentTime != 0 ? a.g.currentTime : b));
        }
        function mm(a) {
            a.o = !0;
            a.h.u(a.g, "seeking", function() {
                return a.m();
            });
            a.A(a.g.currentTime);
        }
        function hm(a) {
            var b = this;
            this.g = a;
            this.m = 10;
            this.j = this.l = this.i = 0;
            this.h = new Uf(function() {
                b.i <= 0 ? b.h.stop() : b.g.currentTime != b.l || b.g.currentTime === b.j ? b.h.stop() : (b.g.currentTime = b.j, b.i--);
            });
        }
        hm.prototype.release = function() {
            this.h && (this.h.stop(), this.h = null);
            this.g = null;
        };
        function lm(a, b) {
            a.l = a.g.currentTime;
            a.j = b;
            a.i = a.m;
            a.g.currentTime = b;
            a.h.xa(.1);
        }
        function nm(a) {
            this.g = a;
            this.i = !1;
            this.h = null;
            this.j = new fd;
        }
        p = nm.prototype;
        p.ready = function() {
            function a() {
                if (b.h == null || b.h == 0 && b.g.duration != Infinity) b.i = !0;
                else {
                    var c = b.g.currentTime, d = null;
                    if (typeof b.h === "number") d = b.h;
                    else if (b.h instanceof Date) {
                        var e = om(b);
                        e !== null && (d = b.h.getTime() / 1E3 - e, d = pm(b, d));
                    }
                    d == null ? b.i = !0 : (d < 0 && (d = Math.max(0, c + d)), c != d ? (b.j.ra(b.g, "seeking", function() {
                        b.i = !0;
                    }), b.g.currentTime = d) : b.i = !0);
                }
            }
            var b = this;
            em(this.g, HTMLMediaElement.HAVE_FUTURE_DATA, this.j, function() {
                a();
            });
        };
        p.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.g = null;
        };
        p.Ag = function(a) {
            this.h = this.i ? this.h : a;
        };
        p.ee = function() {
            var a = this.i ? this.g.currentTime : this.h;
            a instanceof Date && (a = a.getTime() / 1E3 - (om(this) || 0), a = pm(this, a));
            return a || 0;
        };
        p.Fi = function() {
            return 0;
        };
        p.Di = function() {
            return 0;
        };
        p.Ei = function() {
            return !1;
        };
        p.uj = function() {};
        p.jj = function() {
            var a = Vj(this.g.buffered);
            return a != null && a >= this.g.duration - 1;
        };
        function om(a) {
            return a.g.getStartDate && (a = a.g.getStartDate().getTime(), !isNaN(a)) ? a / 1E3 : null;
        }
        function pm(a, b) {
            a = a.g.seekable;
            a.length > 0 && (b = Math.max(a.start(0), b), b = Math.min(a.end(a.length - 1), b));
            return b;
        }
        function qm(a, b, c, d, e, f) {
            var g = this;
            this.h = a;
            this.g = b.presentationTimeline;
            this.l = c;
            this.A = e;
            this.o = null;
            this.i = new Xl(a, b.presentationTimeline, c, f);
            this.j = new gm(a, function() {
                a: {
                    var h = g.i;
                    h.o = !0;
                    h.C = !1;
                    h.i && h.i.xa(h.h.gapJumpTimerTime);
                    Zl(h);
                    var k = jm(g.j);
                    h = rm(g, k);
                    if (!Ui() && Math.abs(h - k) > .001) {
                        k = !1;
                        var l = Xb().Hj();
                        if (l) {
                            var m = Date.now() / 1E3;
                            if (!g.o || g.o < m - l) g.o = m, k = !0;
                        } else k = !0;
                        if (k) {
                            km(g.j, h);
                            h = void 0;
                            break a;
                        }
                    }
                    g.A();
                    h = void 0;
                }
                return h;
            }, function(h) {
                var k = g.i;
                k.g.seeking && !k.o && (k.o = !0, k.m = h);
                k.i && k.i.xa(k.h.gapJumpTimerTime);
                Zl(k);
            }, function() {
                return sm(g, d);
            });
            this.m = new Uf(function() {
                if (g.h.readyState != 0 && !g.h.paused) {
                    var h = jm(g.j), k = g.g.cc(), l = g.g.Gb();
                    l - k < 3 && (k = l - 3);
                    h < k && (h = rm(g, h), g.h.currentTime = h);
                }
            });
        }
        p = qm.prototype;
        p.ready = function() {
            this.m.xa(.25);
        };
        p.release = function() {
            this.j && (this.j.release(), this.j = null);
            this.i && (this.i.release(), this.i = null);
            this.m && (this.m.stop(), this.m = null);
            this.h = this.j = this.g = this.l = null;
            this.A = function() {};
        };
        p.Ag = function(a) {
            km(this.j, sm(this, a));
        };
        p.ee = function() {
            var a = jm(this.j);
            return this.h.readyState > 0 && !this.h.paused ? tm(this, a) : a;
        };
        p.Fi = function() {
            return this.i.H;
        };
        p.Di = function() {
            return this.i.G;
        };
        p.Ei = function() {
            return this.i.D;
        };
        function sm(a, b) {
            b == null ? b = a.g.getDuration() < Infinity ? a.g.cc() : a.g.Gb() : b instanceof Date ? b = b.getTime() / 1E3 - (a.g.m || a.g.i) : b < 0 && (b = a.g.Gb() + b);
            return um(a, tm(a, b));
        }
        p.uj = function() {
            this.i.Md();
        };
        p.jj = function() {
            if (this.g.U()) {
                var a = this.g.Pc(), b = Vj(this.h.buffered);
                if (b != null && b >= a) return !0;
            }
            return !1;
        };
        function um(a, b) {
            var c = a.g.getDuration();
            return b >= c ? c - a.l.durationBackoff : b;
        }
        function rm(a, b) {
            var c = a.l.rebufferingGoal, d = a.l.safeSeekOffset, e = a.g.cc(), f = a.g.Gb(), g = a.g.getDuration();
            f - e < 3 && (e = f - 3);
            var h = a.g.pe(c), k = a.g.pe(d);
            c = a.g.pe(c + d);
            return b >= g ? um(a, b) : b > f ? f - a.l.safeSeekEndOffset : b < e ? a.g.U() && a.l.returnToEndOfLiveWindowWhenOutside ? f - a.l.safeSeekEndOffset : Wj(a.h.buffered, k) ? k : c : b >= h || Wj(a.h.buffered, b) ? b : c;
        }
        function tm(a, b) {
            var c = a.g.cc();
            if (b < c) return c;
            a = a.g.Gb();
            return b > a ? a : b;
        }
        function vm(a) {
            this.g = a;
            this.m = null;
            this.i = 0;
            this.o = !1;
        }
        p = vm.prototype;
        p.getNumReferences = function() {
            return this.g.length;
        };
        p.getNumEvicted = function() {
            return this.i;
        };
        p.release = function() {
            this.o || (this.g = [], this.m && this.m.stop(), this.m = null);
        };
        p.Rl = function() {
            this.o = !0;
        };
        p.xb = function(a) {
            for(var b = u(this.g), c = b.next(); !c.done; c = b.next())a(c.value);
        };
        p.Fb = function() {
            return this.g[0] || null;
        };
        p.find = function(a) {
            var b = this.g.length - 1;
            if (b < 0) return null;
            if (a < this.g[0].startTime) return this.i;
            var c = dd(this.g, function(e) {
                return e.startTime <= a;
            }) - 1;
            if (c < 0) return null;
            var d = this.g[c];
            b = c < b ? this.g[c + 1].startTime : d.endTime;
            return a >= d.startTime && a < b ? c + this.i : null;
        };
        p.get = function(a) {
            if (this.g.length == 0) return null;
            a -= this.i;
            return a < 0 || a >= this.g.length ? null : this.g[a];
        };
        p.offset = function(a) {
            if (!this.o) for(var b = u(this.g), c = b.next(); !c.done; c = b.next())c.value.offset(a);
        };
        p.Of = function(a) {
            if (!this.o && a.length) {
                var b = Math.round(a[0].startTime * 1E3) / 1E3, c = dd(this.g, function(d) {
                    return Math.round(d.startTime * 1E3) / 1E3 < b;
                });
                this.g.length = c;
                this.g.push.apply(this.g, G(a));
            }
        };
        p.ye = function(a, b) {
            for(var c = Math.max(b, this.g.length > 0 ? this.g[0].startTime : -Infinity), d = 0; d < a.length && a[d].endTime <= c;)d++;
            d > 0 && (a = a.slice(d));
            this.Of(a);
            this.$a(b);
        };
        p.$a = function(a) {
            if (!this.o) {
                var b = dd(this.g, function(c) {
                    return c.endTime <= a;
                });
                b > 0 && (this.i += b, this.g = this.g.slice(b));
            }
        };
        p.zd = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            if (!this.o) {
                for(; this.g.length;)if (this.g[this.g.length - 1].startTime >= b) this.g.pop();
                else break;
                var d = dd(this.g, function(e) {
                    return e.endTime <= a;
                });
                d > 0 && (c || (this.i += d), this.g = this.g.slice(d));
                this.g.length != 0 && (c = this.g[this.g.length - 1], b = new Oj(c.startTime, b, c.D, c.startByte, c.endByte, c.ia, c.timestampOffset, c.appendWindowStart, c.appendWindowEnd, c.g, c.tilesLayout, c.C, c.h, c.status, c.aesKey), b.mimeType = c.mimeType, b.codecs = c.codecs, b.i = c.i, this.g[this.g.length - 1] = b);
            }
        };
        p.rg = function(a, b) {
            var c = this;
            this.o || (this.m && this.m.stop(), this.m = new Uf(function() {
                var d = b();
                d ? c.g.push.apply(c.g, G(d)) : (c.m.stop(), c.m = null);
            }), this.m.xa(a));
        };
        vm.prototype[Symbol.iterator] = function() {
            return this.ac(0);
        };
        vm.prototype.ac = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? !1 : c;
            var d = this.find(a);
            if (d == null) return null;
            var e = this.get(d);
            c ? d++ : d--;
            var f = -1;
            if (e && e.g.length > 0) for(var g = e.g.length - 1; g >= 0; --g){
                var h = e.g[g];
                if (a >= h.startTime && a < h.endTime) {
                    if (!b) {
                        for(; g && !h.l;)g--, h = e.g[g];
                        if (!h.l) return Ya("No independent partial segment found!"), null;
                    }
                    c ? d-- : d++;
                    f = g - 1;
                    break;
                }
            }
            return new wm(this, d, f, c);
        };
        vm.prototype.lf = function() {
            return -1;
        };
        function xm(a, b, c) {
            a = new Oj(a, a + b, function() {
                return c;
            }, 0, null, null, a, a, a + b);
            return new vm([
                a
            ]);
        }
        O("shaka.media.SegmentIndex", vm);
        vm.forSingleSegment = xm;
        vm.prototype.getIteratorForTime = vm.prototype.ac;
        vm.prototype.updateEvery = vm.prototype.rg;
        vm.prototype.fit = vm.prototype.zd;
        vm.prototype.evict = vm.prototype.$a;
        vm.prototype.mergeAndEvict = vm.prototype.ye;
        vm.prototype.offset = vm.prototype.offset;
        vm.prototype.get = vm.prototype.get;
        vm.prototype.find = vm.prototype.find;
        vm.prototype.markImmutable = vm.prototype.Rl;
        vm.prototype.release = vm.prototype.release;
        vm.prototype.getNumEvicted = vm.prototype.getNumEvicted;
        vm.prototype.getNumReferences = vm.prototype.getNumReferences;
        function wm(a, b, c, d) {
            this.i = a;
            this.h = b;
            this.g = c;
            this.reverse = d;
        }
        p = wm.prototype;
        p.Wd = function(a) {
            this.reverse = a;
        };
        p.Ak = function() {
            return this.h;
        };
        p.current = function() {
            var a = this.i.get(this.h);
            a && a.g.length > 0 && a.m && this.g >= a.g.length && (this.h++, this.g = 0, a = this.i.get(this.h));
            return a && a.g.length > 0 ? a.g[this.g] : a;
        };
        p.next = function() {
            var a = this.i.get(this.h);
            this.reverse ? a && a.g.length > 0 ? (this.g--, this.g < 0 && (this.h--, this.g = (a = this.i.get(this.h)) && a.g.length > 0 ? a.g.length - 1 : 0)) : (this.h--, this.g = 0) : a && a.g.length > 0 ? (this.g++, a.m && this.g == a.g.length && (this.h++, this.g = 0)) : (this.h++, this.g = 0);
            a = this.current();
            return {
                value: a,
                done: !a
            };
        };
        p.ai = function() {
            var a = this.current();
            if (a && a.hd && !a.l && (a = this.i.get(this.h)) && a.g.length > 0) for(var b = a.g[this.g]; b.l && !(this.g <= 0);)this.g--, b = a.g[this.g];
        };
        O("shaka.media.SegmentIterator", wm);
        wm.prototype.resetToLastIndependent = wm.prototype.ai;
        wm.prototype.next = wm.prototype.next;
        wm.prototype.current = wm.prototype.current;
        wm.prototype.currentPosition = wm.prototype.Ak;
        wm.prototype.setReverse = wm.prototype.Wd;
        function ym() {
            vm.call(this, []);
            this.h = [];
        }
        oa(ym, vm);
        p = ym.prototype;
        p.clone = function() {
            var a = new ym;
            a.h = this.h.slice();
            a.i = this.i;
            return a;
        };
        p.release = function() {
            this.h = [];
        };
        p.xb = function(a) {
            for(var b = u(this.h), c = b.next(); !c.done; c = b.next())c.value.xb(a);
        };
        function zm(a, b) {
            a = u(a.h);
            for(var c = a.next(); !c.done; c = a.next())b(c.value);
        }
        p.find = function(a) {
            for(var b = this.i, c = u(this.h), d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.find(a);
                if (e != null) return e + b;
                b += d.getNumEvicted() + d.getNumReferences();
            }
            return null;
        };
        function Am(a, b) {
            a = u(a.h);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.find(b) != null) return c.lf();
            return -1;
        }
        p.get = function(a) {
            for(var b = this.i, c = u(this.h), d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.get(a - b);
                if (e) return e;
                e = d.getNumReferences();
                b += d.getNumEvicted() + e;
            }
            return null;
        };
        p.offset = function() {};
        p.Of = function() {};
        p.$a = function(a) {
            if (this.h.length) {
                var b = this.h[0];
                b.$a(a);
                b.getNumReferences() == 0 && (this.h.shift(), this.i += b.getNumEvicted(), b.release(), this.$a(a));
            }
        };
        p.ye = function() {};
        p.zd = function() {};
        p.rg = function() {};
        O("shaka.media.MetaSegmentIndex", ym);
        ym.prototype.updateEvery = ym.prototype.rg;
        ym.prototype.fit = ym.prototype.zd;
        ym.prototype.mergeAndEvict = ym.prototype.ye;
        ym.prototype.evict = ym.prototype.$a;
        ym.prototype.merge = ym.prototype.Of;
        ym.prototype.offset = ym.prototype.offset;
        ym.prototype.get = ym.prototype.get;
        ym.prototype.find = ym.prototype.find;
        ym.prototype.forEachTopLevelReference = ym.prototype.xb;
        ym.prototype.release = ym.prototype.release;
        function Bm(a) {
            var b = this;
            this.g = a;
            this.j = !1;
            this.h = this.g.wh();
            this.i = new Uf(function() {
                b.g.isPaused() || b.g.Tl(b.h * .25);
            });
        }
        Bm.prototype.release = function() {
            this.set(this.Cd());
            this.i && (this.i.stop(), this.i = null);
            this.g = null;
        };
        Bm.prototype.set = function(a) {
            this.h = a;
            Cm(this);
        };
        Bm.prototype.Cd = function() {
            return this.g.Cd();
        };
        function Cm(a) {
            a.i.stop();
            var b = a.j ? 0 : a.h;
            if (b >= 0 && b <= 16) try {
                a.g.wh() != b && a.g.Qj(b);
                return;
            } catch (c) {}
            a.i.xa(.25);
            a.g.wh() != 0 && a.g.Qj(0);
        }
        function Dm(a) {
            var b = this;
            this.j = a;
            this.h = new fd;
            this.g = new Set;
            this.i = new Uf(function() {
                Em(b, !1);
            }).La();
            a.paused || this.i.xa(.25);
            this.h.u(a, "playing", function() {
                b.i.La().xa(.25);
            });
            this.h.u(a, "pause", function() {
                b.i.stop();
            });
            this.h.u(a, "seeked", function() {
                b.i.La();
                a.paused || b.i.xa(.25);
            });
        }
        Dm.prototype.release = function() {
            this.h && (this.h.release(), this.h = null);
            this.i.stop();
            for(var a = u(this.g), b = a.next(); !b.done; b = a.next())b.value.release();
            this.g.clear();
        };
        function Em(a, b) {
            var c = a.j.currentTime;
            a = u(a.g);
            for(var d = a.next(); !d.done; d = a.next())d.value.j(c, b);
        }
        function Fm(a) {
            fb.call(this);
            this.g = new Map;
            this.h = a;
        }
        oa(Fm, fb);
        Fm.prototype.release = function() {
            this.g.clear();
            fb.prototype.release.call(this);
        };
        function Gm(a, b) {
            var c = a.g.get(b);
            c || (c = {
                Ee: [],
                Tg: null,
                contentType: b
            }, a.g.set(b, c));
            return c;
        }
        function Hm(a, b, c) {
            var d = Gm(a, b.contentType);
            Im(a, d);
            a = {
                Kd: b,
                position: c
            };
            d = d.Ee;
            b = d.findIndex(function(e) {
                return e.position >= c;
            });
            b >= 0 ? d.splice(b, d[b].position == c ? 1 : 0, a) : d.push(a);
        }
        Fm.prototype.j = function(a) {
            for(var b = u(this.g.values()), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = c.Tg;
                a: {
                    var e = c.Ee;
                    for(var f = e.length - 1; f >= 0; f--){
                        var g = e[f];
                        if (g.position <= a) {
                            e = g.Kd;
                            break a;
                        }
                    }
                    e = null;
                }
                f = e && !(d === e || d && e && d.bandwidth == e.bandwidth && d.audioSamplingRate == e.audioSamplingRate && d.codecs == e.codecs && d.contentType == e.contentType && d.frameRate == e.frameRate && d.height == e.height && d.mimeType == e.mimeType && d.channelsCount == e.channelsCount && d.pixelAspectRatio == e.pixelAspectRatio && d.width == e.width);
                g = e && d && e.label && d.label && d.label !== e.label;
                var h = e && d && e.language && d.language && d.language !== e.language;
                d = e && d && e.roles && d.roles && !ed(d.roles, e.roles);
                (g || h || d) && Jm(this, a, e.contentType) && (c.Tg = e, d = new R("audiotrackchange", new Map([
                    [
                        "quality",
                        e
                    ],
                    [
                        "position",
                        a
                    ]
                ])), this.dispatchEvent(d));
                f && Jm(this, a, e.contentType) && (c.Tg = e, JSON.stringify(e), c = new R("qualitychange", new Map([
                    [
                        "quality",
                        e
                    ],
                    [
                        "position",
                        a
                    ]
                ])), this.dispatchEvent(c));
            }
        };
        function Jm(a, b, c) {
            return (a = a.h()[c]) && a.length > 0 && (c = a[a.length - 1].end, b >= a[0].start && b < c) ? !0 : !1;
        }
        function Im(a, b) {
            if ((a = a.h()[b.contentType]) && a.length > 0) {
                var c = a[0].start, d = a[a.length - 1].end, e = b.Ee;
                b.Ee = e.filter(function(f, g) {
                    return f.position <= c && g + 1 < e.length && e[g + 1].position <= c || f.position >= d ? !1 : !0;
                });
            } else b.Ee = [];
        }
        function Km(a) {
            var b = {
                bandwidth: a.bandwidth || 0,
                audioSamplingRate: null,
                codecs: a.codecs,
                contentType: a.type,
                frameRate: null,
                height: null,
                mimeType: a.mimeType,
                channelsCount: null,
                pixelAspectRatio: null,
                width: null,
                label: null,
                roles: a.roles,
                language: null
            };
            a.type == "video" && (b.frameRate = a.frameRate || null, b.height = a.height || null, b.pixelAspectRatio = a.pixelAspectRatio || null, b.width = a.width || null);
            a.type == "audio" && (b.audioSamplingRate = a.audioSamplingRate, b.channelsCount = a.channelsCount, b.label = a.label || null, b.language = a.language);
            return b;
        }
        function Lm(a) {
            fb.call(this);
            this.h = new Map;
            this.i = a;
            this.g = null;
        }
        oa(Lm, fb);
        Lm.prototype.release = function() {
            this.h.clear();
            this.g && (this.g.stop(), this.g = null);
            fb.prototype.release.call(this);
        };
        function Mm(a, b) {
            var c = b.schemeIdUri + "_" + b.id + "_" + (b.startTime.toFixed(1) + "_" + b.endTime.toFixed(1));
            a.h.has(c) || (a.h.set(c, b), b = new R("regionadd", new Map([
                [
                    "region",
                    b
                ]
            ])), a.dispatchEvent(b), Nm(a));
        }
        function Nm(a) {
            a.g || (a.g = new Uf(function() {
                for(var b = a.i(), c = u(a.h), d = c.next(); !d.done; d = c.next()){
                    var e = u(d.value);
                    d = e.next().value;
                    e = e.next().value;
                    e.endTime < b.start && (a.h.delete(d), d = new R("regionremove", new Map([
                        [
                            "region",
                            e
                        ]
                    ])), a.dispatchEvent(d));
                }
                !a.h.size && a.g && (a.g.stop(), a.g = null);
            }).xa(2));
        }
        function Om(a, b, c, d, e) {
            function f(g, h) {
                return h.fastSwitching && g.hd && g.we ? !1 : !0;
            }
            this.m = a;
            this.i = b;
            this.l = c;
            this.g = new Map;
            this.j = new Map;
            this.h = null;
            this.o = d;
            this.A = e || f;
        }
        function Pm(a, b) {
            a.l = b;
            a = u(a.g.values());
            for(var c = a.next(); !c.done; c = a.next())c.value.g = b;
        }
        function Qm(a, b, c) {
            c = c === void 0 ? !1 : c;
            if (!a.i.segmentIndex) return Promise.resolve();
            a.h || (a.h = a.i.segmentIndex.ac(b, !0, a.o));
            if (!a.h) return Promise.resolve();
            c && a.h.next();
            for(b = []; a.g.size < a.m;){
                c = a.h.next().value;
                if (!c) break;
                var d = !0;
                c.isPreload() && c.endByte != null && (d = !1);
                c.ec() == 2 && (d = !1);
                c.dc(!1) && (d = !1);
                d && c.ia && b.push(Rm(a, c.ia));
                d && !a.g.has(c) && (d = new Sm(a.l), b.push(Tm(d, c, a.i)), a.g.set(c, d));
                if (!a.A(c, a.i)) break;
            }
            Um(a);
            return Promise.all(b);
        }
        function Rm(a, b) {
            if (!a.i.segmentIndex || b.dc() || Array.from(a.j.keys()).some(function(e) {
                return Nj(e, b);
            })) return Promise.resolve();
            var c = new Sm(a.l), d = Tm(c, b, a.i);
            a.j.set(b, c);
            return d;
        }
        function Vm(a, b) {
            b = u(b.keys());
            for(var c = b.next(); !c.done; c = b.next())(c = c.value) && Wm(a, c);
        }
        function Xm(a) {
            Vm(a, a.g);
            Vm(a, a.j);
            a.h = null;
        }
        Om.prototype.$a = function(a, b) {
            b = b === void 0 ? !1 : b;
            for(var c = u(this.g.keys()), d = c.next(); !d.done; d = c.next())d = d.value, a > d.endTime && Wm(this, d);
            b && Um(this);
        };
        Om.prototype.Wd = function(a) {
            this.o = a;
            this.h && this.h.Wd(a);
        };
        function Um(a) {
            if (a.g.size) for(var b = Array.from(a.g.keys()), c = u(a.j.keys()), d = c.next(), e = {}; !d.done; e = {
                Fh: void 0
            }, d = c.next())e.Fh = d.value, b.some(function(f) {
                return function(g) {
                    return Nj(g.ia, f.Fh);
                };
            }(e)) || Wm(a, e.Fh);
        }
        function Ym(a, b) {
            a.m = b;
            for(var c = Array.from(a.g.keys()); c.length > b;){
                var d = c.pop();
                d && Wm(a, d);
            }
            Um(a);
        }
        function Zm(a, b) {
            b && b !== a.i && (Xm(a), a.i = b);
        }
        function Wm(a, b) {
            var c = a.g;
            b instanceof Mj && (c = a.j);
            a = c.get(b);
            c.delete(b);
            a && a.abort();
        }
        function Sm(a) {
            this.g = a;
            this.Be = this.ri = null;
        }
        function Tm(a, b, c) {
            var d = new Uint8Array(0);
            a.Be = a.g(b, c, function(e) {
                return H(function(f) {
                    if (f.h == 1) return d.byteLength > 0 ? d = tc(d, e) : d = e, a.ri ? f.g(a.ri(d), 3) : f.B(0);
                    d = new Uint8Array(0);
                    f.j();
                });
            });
            return a.Be.promise.catch(function(e) {
                return e instanceof T && e.code == 7001 ? Promise.resolve() : Promise.reject(e);
            });
        }
        Sm.prototype.abort = function() {
            this.Be && this.Be.abort();
        };
        O("shaka.config.CrossBoundaryStrategy", {
            KEEP: "keep",
            RESET: "reset",
            RESET_TO_ENCRYPTED: "reset_to_encrypted",
            RESET_ON_ENCRYPTION_CHANGE: "RESET_ON_ENCRYPTION_CHANGE"
        });
        function $m(a) {
            var b = Ff(a), c = b.split("/")[0];
            a = Gf(a);
            return {
                type: c,
                mimeType: b,
                codecs: a,
                language: null,
                height: null,
                width: null,
                channelCount: null,
                sampleRate: null,
                closedCaptions: new Map,
                Me: null,
                colorGamut: null,
                frameRate: null,
                timescale: null
            };
        }
        function an(a, b, c) {
            function d(B) {
                y = B.name;
                var J = B.reader;
                J.skip(24);
                var F = J.Ka(), I = J.Ka();
                J.skip(50);
                q = String(F);
                n = String(I);
                B.reader.Sa() && Gh(B);
            }
            function e(B) {
                var J = Zi(B.reader);
                r = J.channelCount;
                t = J.sampleRate;
                f(B.name);
            }
            function f(B) {
                B = B.toLowerCase();
                switch(B){
                    case "avc1":
                    case "avc3":
                        h.push(B + ".42E01E");
                        l = !0;
                        break;
                    case "hev1":
                    case "hvc1":
                        h.push(B + ".1.6.L93.90");
                        l = !0;
                        break;
                    case "dvh1":
                    case "dvhe":
                        h.push(B + ".05.04");
                        l = !0;
                        break;
                    case "vp09":
                        h.push(B + ".00.10.08");
                        l = !0;
                        break;
                    case "av01":
                        h.push(B + ".0.01M.08");
                        l = !0;
                        break;
                    case "mp4a":
                        g.push("mp4a.40.2");
                        k = !0;
                        break;
                    case "ac-3":
                    case "ec-3":
                    case "ac-4":
                    case "opus":
                    case "flac":
                        g.push(B);
                        k = !0;
                        break;
                    case "apac":
                        g.push("apac.31.00"), k = !0;
                }
            }
            var g = [], h = [], k = !1, l = !1, m = null, n = null, q = null, r = null, t = null, v = null, w = null, x = null, y;
            (new Bh).box("moov", Gh).box("trak", Gh).box("mdia", Gh).qa("mdhd", function(B) {
                B = Xi(B.reader, B.version);
                m = B.language;
                x = B.timescale;
            }).box("minf", Gh).box("stbl", Gh).qa("stsd", Ih).box("mp4a", function(B) {
                var J = Zi(B.reader);
                r = J.channelCount;
                t = J.sampleRate;
                B.reader.Sa() ? Gh(B) : f(B.name);
            }).box("esds", function(B) {
                B = B.reader;
                for(var J = "mp4a", F, I; B.Sa();){
                    F = B.ea();
                    for(var K = B.ea(); K & 128;)K = B.ea();
                    if (F == 3) B.Ka(), K = B.ea(), K & 128 && B.Ka(), K & 64 && B.skip(B.ea()), K & 32 && B.Ka();
                    else if (F == 4) I = B.ea(), B.skip(12);
                    else if (F == 5) break;
                }
                I && (J += "." + bj(I), F == 5 && B.Sa() && (F = B.ea(), I = (F & 248) >> 3, I === 31 && B.Sa() && (I = 32 + ((F & 7) << 3) + ((B.ea() & 224) >> 5)), J += "." + I));
                g.push(J);
                k = !0;
            }).box("ac-3", e).box("ec-3", e).box("ac-4", e).box("Opus", e).box("fLaC", e).box("apac", e).box("avc1", d).box("avc3", d).box("hev1", d).box("hvc1", d).box("dva1", d).box("dvav", d).box("dvh1", d).box("dvhe", d).box("vp09", d).box("av01", d).box("avcC", function(B) {
                var J = y || "";
                switch(y){
                    case "dvav":
                        J = "avc3";
                        break;
                    case "dva1":
                        J = "avc1";
                }
                B = B.reader;
                B.skip(1);
                B = J + "." + bj(B.ea()) + bj(B.ea()) + bj(B.ea());
                h.push(B);
                l = !0;
            }).box("hvcC", function(B) {
                var J = y || "";
                switch(y){
                    case "dvh1":
                        J = "hvc1";
                        break;
                    case "dvhe":
                        J = "hev1";
                }
                var F = B.reader;
                F.skip(1);
                B = F.ea();
                var I = [
                    "",
                    "A",
                    "B",
                    "C"
                ][B >> 6], K = B & 31, N = F.Y(), P = (B & 32) >> 5 ? "H" : "L";
                B = [
                    F.ea(),
                    F.ea(),
                    F.ea(),
                    F.ea(),
                    F.ea(),
                    F.ea()
                ];
                F = F.ea();
                for(var M = 0, L = 0; L < 32; L++){
                    M |= N & 1;
                    if (L == 31) break;
                    M <<= 1;
                    N >>= 1;
                }
                J = J + ("." + I + K) + ("." + bj(M, !0));
                J += "." + P + F;
                I = "";
                for(K = B.length; K--;)if ((P = B[K]) || I) I = "." + P.toString(16).toUpperCase() + I;
                J += I;
                h.push(J);
                l = !0;
            }).box("dvcC", function(B) {
                var J = y || "";
                switch(y){
                    case "hvc1":
                        J = "dvh1";
                        break;
                    case "hev1":
                        J = "dvhe";
                        break;
                    case "avc1":
                        J = "dva1";
                        break;
                    case "avc3":
                        J = "dvav";
                        break;
                    case "av01":
                        J = "dav1";
                }
                var F = B.reader;
                F.skip(2);
                B = F.ea();
                F = F.ea();
                h.push(J + "." + cj(B >> 1 & 127) + "." + cj(B << 5 & 32 | F >> 3 & 31));
                l = !0;
            }).box("dvvC", function(B) {
                var J = y || "";
                switch(y){
                    case "hvc1":
                        J = "dvh1";
                        break;
                    case "hev1":
                        J = "dvhe";
                        break;
                    case "avc1":
                        J = "dva1";
                        break;
                    case "avc3":
                        J = "dvav";
                        break;
                    case "av01":
                        J = "dav1";
                }
                var F = B.reader;
                F.skip(2);
                B = F.ea();
                F = F.ea();
                h.push(J + "." + cj(B >> 1 & 127) + "." + cj(B << 5 & 32 | F >> 3 & 31));
                l = !0;
            }).qa("vpcC", function(B) {
                var J = y || "", F = B.reader;
                B = F.ea();
                var I = F.ea();
                F = F.ea() >> 4 & 15;
                h.push(J + "." + cj(B) + "." + cj(I) + "." + cj(F));
                l = !0;
            }).box("av1C", function(B) {
                var J = y || "";
                switch(y){
                    case "dav1":
                        J = "av01";
                }
                var F = B.reader;
                F.skip(1);
                B = F.ea();
                F = F.ea();
                var I = B >>> 5, K = (F & 64) >> 6;
                h.push(J + "." + I + "." + cj(B & 31) + (F >>> 7 ? "H" : "M") + "." + cj(I === 2 && K ? (F & 32) >> 5 ? 12 : 10 : K ? 10 : 8) + "." + ((F & 16) >> 4) + "." + ((F & 8) >> 3) + ((F & 4) >> 2) + (F & 3) + "." + cj(1) + "." + cj(1) + "." + cj(1) + ".0");
                l = !0;
            }).box("enca", Kh).box("encv", Jh).box("sinf", Gh).box("frma", function(B) {
                B = $i(B.reader).codec;
                f(B);
            }).box("colr", function(B) {
                h = h.map(function(I) {
                    if (I.startsWith("av01.")) {
                        var K = B.reader, N = K.Xa(), P = K.Wb(4, !1);
                        var M = String.fromCharCode(P[0]);
                        M += String.fromCharCode(P[1]);
                        M += String.fromCharCode(P[2]);
                        M += String.fromCharCode(P[3]);
                        if (M === "nclx") {
                            P = K.Ka();
                            M = K.Ka();
                            var L = K.Ka(), Q = K.ea() >> 7, S = I.split(".");
                            S.length == 10 && (S[6] = cj(P), S[7] = cj(M), S[8] = cj(L), S[9] = String(Q), I = S.join("."));
                        }
                        K.seek(N);
                    }
                    return I;
                });
                var J = aj(B.reader), F = J.colorGamut;
                v = J.Me;
                w = F;
            }).parse(a || b, !0, !0);
            if (!g.length && !h.length) return null;
            var z = k && !l, A = new Map;
            if (l && !c) {
                c = new Fd("video/mp4");
                a && c.init(a);
                try {
                    Jd(c, b);
                    for(var E = u(c.g.getStreams()), C = E.next(); !C.done; C = E.next()){
                        var D = C.value;
                        A.set(D, D);
                    }
                } catch (B) {}
                c.g.clear();
            }
            return {
                type: z ? "audio" : "video",
                mimeType: z ? "audio/mp4" : "video/mp4",
                codecs: bn(g.concat(h)).join(", "),
                language: m,
                height: n,
                width: q,
                channelCount: r,
                sampleRate: t,
                closedCaptions: A,
                Me: v,
                colorGamut: w,
                frameRate: null,
                timescale: x
            };
        }
        function bn(a) {
            var b = new Set, c = [];
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next()){
                d = d.value;
                var e = Ef(d);
                b.has(e) || (c.push(d), b.add(e));
            }
            b = Fc("audio", c);
            d = Fc("video", c);
            a = Fc(Ec, c);
            d = cn(d);
            b = b.concat(d).concat(a);
            return c.length && !b.length ? c : b;
        }
        function cn(a) {
            if (a.length <= 1) return a;
            var b = a.find(function(c) {
                return c.startsWith("dvav.") || c.startsWith("dva1.") || c.startsWith("dvh1.") || c.startsWith("dvhe.") || c.startsWith("dav1.") || c.startsWith("dvc1.") || c.startsWith("dvi1.");
            });
            return b ? Si('video/mp4; codecs="' + b + '"') ? [
                b
            ] : a.filter(function(c) {
                return c != b;
            }) : a;
        }
        function dn(a) {
            var b = null;
            (new Bh).box("moov", Gh).box("trak", Gh).box("mdia", Gh).box("minf", Gh).box("stbl", Gh).qa("stsd", Ih).box("encv", Jh).box("enca", Kh).box("sinf", Gh).box("schi", Gh).qa("tenc", function(c) {
                c = c.reader;
                c.ea();
                c.ea();
                c.ea();
                c.ea();
                c = c.Wb(16, !1);
                b = sc(c);
            }).parse(a, !0);
            return b;
        }
        function en(a, b, c) {
            var d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) return d = b, d.cryptoKey ? k.B(2) : k.g(d.fetchKey(), 3);
                e = d.iv;
                if (!e) for(e = Fb(new ArrayBuffer(16)), f = d.firstMediaSequenceNumber + c, g = e.byteLength - 1; g >= 0; g--)e[g] = f & 255, f >>= 8;
                b.blockCipherMode == "CBC" ? h = {
                    name: "AES-CBC",
                    iv: e
                } : h = {
                    name: "AES-CTR",
                    counter: e,
                    length: 64
                };
                return k.return(window1.crypto.subtle.decrypt(h, d.cryptoKey, a));
            });
        }
        function fn(a, b, c) {
            var d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        d = gn(a);
                        if (e = hn.get(d)) return m.return(e);
                        f = 0;
                        g = mh([
                            a
                        ], c);
                        m.m(2);
                        g.method = "HEAD";
                        return m.g(b.request(f, g).promise, 4);
                    case 4:
                        h = m.i;
                        e = h.headers["content-type"];
                        m.o(3);
                        break;
                    case 2:
                        k = m.l();
                        if (!k || k.code != 1002 && k.code != 1001) {
                            m.B(3);
                            break;
                        }
                        g.method = "GET";
                        return m.g(b.request(f, g).promise, 6);
                    case 6:
                        l = m.i, e = l.headers["content-type"];
                    case 3:
                        return m.return(e ? e.toLowerCase().split(";").shift() : "");
                }
            });
        }
        function gn(a) {
            for(var b = a.length, c = 0; c < a.length; c++){
                var d = a.charCodeAt(c);
                if (d === 63 || d === 35) {
                    b = c;
                    break;
                }
            }
            for(c = b - 1; c >= 0; c--){
                d = a.charCodeAt(c);
                if (d === 46) {
                    if (c + 1 < b) return a.slice(c + 1, b).toLowerCase();
                    break;
                }
                if (d === 47) break;
            }
            return "";
        }
        function jn(a, b, c, d, e) {
            a = mh(a, d, e);
            if (b != 0 || c != null) a.headers.Range = c ? "bytes=" + b + "-" + c : "bytes=" + b + "-";
            return a;
        }
        var hn = (new Map).set("mp4", "video/mp4").set("m4v", "video/mp4").set("m4a", "audio/mp4").set("webm", "video/webm").set("weba", "audio/webm").set("mkv", "video/webm").set("ts", "video/mp2t").set("ogv", "video/ogg").set("ogg", "audio/ogg").set("mpg", "video/mpeg").set("mpeg", "video/mpeg").set("mov", "video/quicktime").set("m3u8", "application/x-mpegurl").set("mpd", "application/dash+xml").set("ism", "application/vnd.ms-sstr+xml").set("mp3", "audio/mpeg").set("aac", "audio/aac").set("flac", "audio/flac").set("wav", "audio/wav").set("sbv", "text/x-subviewer").set("srt", "text/srt").set("vtt", "text/vtt").set("webvtt", "text/vtt").set("ttml", "application/ttml+xml").set("lrc", "application/x-subtitle-lrc").set("ssa", "text/x-ssa").set("ass", "text/x-ssa").set("jpeg", "image/jpeg").set("jpg", "image/jpeg").set("png", "image/png").set("svg", "image/svg+xml").set("webp", "image/webp").set("avif", "image/avif").set("html", "text/html").set("htm", "text/html");
        function kn(a, b) {
            var c = this;
            this.g = b;
            this.j = a;
            this.i = null;
            this.L = new Map;
            this.D = 1;
            this.C = this.o = null;
            this.S = 0;
            this.h = new Map;
            this.M = !1;
            this.V = null;
            this.F = !1;
            this.l = new uh(function() {
                return ln(c);
            });
            this.P = Date.now() / 1E3;
            this.m = new Map;
            this.R = {
                projection: null,
                hfov: null
            };
            this.X = 0;
            this.W = Infinity;
            this.H = null;
            this.O = [];
            this.A = new Uf(function() {
                if (c.j && c.g) {
                    if (c.j.presentationTimeline.U()) {
                        var d = c.j.presentationTimeline.cc(), e = c.j.presentationTimeline.Gb();
                        e - d > 1 ? Al(c.g.aa, d, e) : Bl(c.g.aa);
                    } else Bl(c.g.aa), c.A && c.A.stop();
                } else c.A && c.A.stop();
            });
            this.I = null;
            this.J = !1;
            this.K = new Uf(function() {
                var d = c.g.video;
                !d.ended && c.I && (c.J = !0, d.currentTime = c.I, c.I = null);
            });
            this.G = new fd;
        }
        p = kn.prototype;
        p.destroy = function() {
            return this.l.destroy();
        };
        function ln(a) {
            var b, c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) {
                    a.A && a.A.stop();
                    a.A = null;
                    a.K && a.K.stop();
                    a.K = null;
                    a.G && (a.G.release(), a.G = null);
                    b = [];
                    c = u(a.h.values());
                    for(d = c.next(); !d.done; d = c.next())e = d.value, mn(e), b.push(nn(e)), e.ma && (Xm(e.ma), e.ma = null);
                    f = u(a.m.values());
                    for(g = f.next(); !g.done; g = f.next())h = g.value, Xm(h);
                    return k.g(Promise.all(b), 2);
                }
                a.h.clear();
                a.m.clear();
                a.g = null;
                a.j = null;
                a.i = null;
                a.I = null;
                k.j();
            });
        }
        p.configure = function(a) {
            this.i = a;
            this.V = new Vg({
                maxAttempts: Math.max(a.retryParameters.maxAttempts, 2),
                baseDelay: a.retryParameters.baseDelay,
                backoffFactor: a.retryParameters.backoffFactor,
                fuzzFactor: a.retryParameters.fuzzFactor,
                timeout: 0,
                stallTimeout: 0,
                connectionTimeout: 0
            }, !0);
            if (a.disableAudioPrefetch) {
                var b = this.h.get("audio");
                b && b.ma && (Xm(b.ma), b.ma = null);
                b = u(this.m.keys());
                for(var c = b.next(); !c.done; c = b.next())c = c.value, Xm(this.m.get(c)), this.m.delete(c);
            }
            a.disableTextPrefetch && (b = this.h.get(Ec)) && b.ma && (Xm(b.ma), b.ma = null);
            a.disableVideoPrefetch && (b = this.h.get("video")) && b.ma && (Xm(b.ma), b.ma = null);
            b = u(this.h.keys());
            for(c = b.next(); !c.done; c = b.next())c = this.h.get(c.value), c.ma ? (Ym(c.ma, a.segmentPrefetchLimit), a.segmentPrefetchLimit > 0 || (Xm(c.ma), c.ma = null)) : a.segmentPrefetchLimit > 0 && (c.ma = on(this, c.stream));
            a.disableAudioPrefetch || pn(this);
        };
        function qn(a, b, c) {
            a.j.presentationTimeline.U() || (a.X = b, a.W = c);
        }
        p.start = function(a) {
            var b = this;
            return H(function(c) {
                if (c.h == 1) return c.g(rn(b, a || new Map), 2);
                vh(b.l);
                b.M = !0;
                c.j();
            });
        };
        function sn(a, b) {
            var c, d, e, f, g, h, k;
            H(function(l) {
                switch(l.h){
                    case 1:
                        return c = Gc, a.S++, d = a.S, l.m(2), l.g(ul(a.g.aa, c.Va), 4);
                    case 4:
                        l.o(3);
                        break;
                    case 2:
                        if (e = l.l(), a.g) a.g.onError(e);
                    case 3:
                        f = wf(b.mimeType, b.codecs), cl(a.g.aa, f, a.j.sequenceMode, b.external), g = a.g.aa.X, (h = g.isTextVisible() || a.i.alwaysStreamText) && a.S == d && (k = tn(a, b), a.h.set(c.Va, k), un(a, k, 0)), l.j();
                }
            });
        }
        function vn(a) {
            var b = a.h.get(Ec);
            b && (mn(b), nn(b).catch(function() {}), a.H = a.h.get(Ec), a.h.delete(Ec), b.stream && b.stream.closeSegmentIndex && b.stream.closeSegmentIndex());
            a.C = null;
        }
        function wn(a, b) {
            for(var c = a.g.Wa() < 0, d = u(a.h.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.Aa && e.Aa.Wd(c), e.ma && e.ma.Wd(c);
            d = u(a.m.values());
            for(e = d.next(); !e.done; e = d.next())e.value.Wd(c);
            if (c = a.h.get("video")) {
                if (d = c.stream) {
                    if (b) (b = d.trickModeVideo) && !c.Vc && (xn(a, b, !1, 0, !1), c.Vc = d);
                    else if (b = c.Vc) c.Vc = null, xn(a, b, !0, 0, !1);
                }
            }
        }
        function yn(a, b, c, d, e, f) {
            c = c === void 0 ? !1 : c;
            d = d === void 0 ? 0 : d;
            e = e === void 0 ? !1 : e;
            f = f === void 0 ? !1 : f;
            a.o = b;
            a.M && (b.video && xn(a, b.video, c, d, e, f), b.audio && xn(a, b.audio, c, d, e, f));
        }
        function zn(a, b) {
            H(function(c) {
                if (c.h == 1) return a.H = null, a.C = b, a.M ? b.segmentIndex ? c.B(2) : c.g(b.createSegmentIndex(), 2) : c.return();
                xn(a, b, !0, 0, !1);
                c.j();
            });
        }
        function An(a) {
            var b = a.h.get(Ec);
            b && xn(a, b.stream, !0, 0, !0);
        }
        function Bn(a, b) {
            for(var c = u(a.L.entries()), d = c.next(); !d.done; d = c.next()){
                var e = u(d.value);
                d = e.next().value;
                e = e.next().value;
                d.includes(b.type) && (e(), a.L.delete(d));
            }
        }
        function xn(a, b, c, d, e, f) {
            var g = a.h.get(b.type);
            g || b.type != Ec ? g && (g.Vc && (b.trickModeVideo ? (g.Vc = b, b = b.trickModeVideo) : g.Vc = null), g.stream != b || e) && (a.m.has(b) ? g.ma = a.m.get(b) : g.ma && Zm(g.ma, b), b.type == Ec && g.stream != b && (e = wf(b.mimeType, b.codecs), cl(a.g.aa, e, a.j.sequenceMode, b.external)), !a.m.has(g.stream) && g.stream.closeSegmentIndex && (g.Ra ? (e = "(" + g.type + ":" + g.stream.id + ")", a.L.has(e) || a.L.set(e, g.stream.closeSegmentIndex)) : g.stream.closeSegmentIndex()), e = g.stream.isAudioMuxedInVideo != b.isAudioMuxedInVideo, g.stream = b, g.Aa = null, g.Gg = !!f, b.dependencyStream ? g.Mc = tn(a, b.dependencyStream) : g.Mc = null, Cn(a), e && (g.qb = null, g.Ac = null, g.zc = null, b.isAudioMuxedInVideo && (b = null, g.type === "video" ? b = a.h.get("audio") : g.type === "audio" && (b = a.h.get("video")), b && (nn(b).catch(function() {}), b.qb = null, b.Ac = null, b.zc = null, Dn(a, b), En(a, b).catch(function(h) {
                if (a.g) a.g.onError(h);
            })))), c ? g.$b ? g.ae = !0 : g.Ra ? (g.Yb = !0, g.vd = d, g.ae = !0) : (mn(g), Fn(a, g, !0, d).catch(function(h) {
                if (a.g) a.g.onError(h);
            })) : g.Ra || g.rb || un(a, g, 0), En(a, g).catch(function(h) {
                if (a.g) a.g.onError(h);
            })) : sn(a, b);
        }
        function En(a, b) {
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) {
                    if (!b.bb) return f.return();
                    c = b.stream;
                    d = b.bb;
                    return c.segmentIndex ? f.B(2) : f.g(c.createSegmentIndex(), 2);
                }
                if (f.h != 4) return e = c.dependencyStream, !e || e.segmentIndex ? f.B(4) : f.g(e.createSegmentIndex(), 4);
                if (b.bb != d || b.stream != c) return f.return();
                var g = a.g.bc();
                var h = il(a.g.aa, b.type), k = b.stream.segmentIndex.find(b.Na ? b.Na.endTime : g), l = k == null ? null : b.stream.segmentIndex.get(k);
                k = l ? Qj(l) : null;
                l && !k && (k = (l.endTime - l.getStartTime()) * (b.stream.bandwidth || a.o.bandwidth) / 8);
                k ? ((l = l.ia) && (k += (l.endByte ? l.endByte + 1 - l.startByte : null) || 0), l = a.g.getBandwidthEstimate(), g = k * 8 / l < (h || 0) - g - a.i.rebufferingGoal || b.bb.h.g > k ? !0 : !1) : g = !0;
                g && b.bb.abort();
                f.j();
            });
        }
        p.ld = function() {
            if (this.g) {
                for(var a = this.g.bc(), b = u(this.h.keys()), c = b.next(); !c.done; c = b.next()){
                    var d = c.value;
                    c = this.h.get(d);
                    var e;
                    if (e = !this.J) e = this.g.aa, d == Ec ? (e = e.h, e = e.g == null || e.h == null ? !1 : a >= e.g && a < e.h) : (e = hl(e, d), e = Wj(e, a)), e = !e;
                    if (e) {
                        this.P = 0;
                        c.ma && (c.ma.h = null);
                        if (c.type === "audio") {
                            e = u(this.m.values());
                            for(var f = e.next(); !f.done; f = e.next())f.value.h = null;
                        }
                        c.Aa = null;
                        (il(this.g.aa, d) != null || c.Ra) && Dn(this, c);
                        c.bb && (c.bb.abort(), c.bb = null);
                        d === Ec && (d = this.g.aa, d.J && d.J.g.clear());
                        c.ld = !0;
                    }
                    !this.J || c.$b || c.Ra || c.rb || un(this, c, 0);
                }
                Gn(this) && Hn(this);
            }
        };
        function Dn(a, b) {
            b.$b || b.Yb || (b.Ra ? (b.Yb = !0, b.vd = 0) : gl(a.g.aa, b.type) == null ? b.rb == null && un(a, b, 0) : (mn(b), Fn(a, b, !1, 0).catch(function(c) {
                if (a.g) a.g.onError(c);
            })));
        }
        function rn(a, b) {
            var c, d, e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    if (!a.o) throw new T(2, 5, 5006);
                    c = In(a, !0);
                    d = a.g.aa;
                    return m.g(d.init(c, a.j.sequenceMode, a.j.type, a.j.ignoreManifestTimestampsInSegmentsMode), 2);
                }
                vh(a.l);
                a.updateDuration();
                e = u(c.keys());
                for(f = e.next(); !f.done; f = e.next())g = f.value, h = c.get(g), a.h.has(g) || (k = tn(a, h), b.has(h.id) && (l = b.get(h.id), Pm(l, function(n, q, r) {
                    return Jn(n, q, r || null, a.i.retryParameters, a.g.Cc);
                }), k.ma = l), a.h.set(g, k), un(a, k, 0));
                Cn(a);
                m.j();
            });
        }
        function tn(a, b) {
            var c = {
                stream: b,
                type: b.type,
                Aa: null,
                ma: on(a, b),
                Na: null,
                qb: null,
                Lf: null,
                Ac: null,
                zc: null,
                Jf: null,
                Kf: null,
                Vc: null,
                endOfStream: !1,
                Ra: !1,
                rb: null,
                Yb: !1,
                vd: 0,
                ae: !1,
                $b: !1,
                ld: !0,
                Gg: !1,
                Wh: !1,
                Fd: !1,
                bb: null,
                Mc: null
            };
            b.dependencyStream && (c.Mc = tn(a, b.dependencyStream));
            return c;
        }
        function on(a, b) {
            if (b.type === "video" && a.i.disableVideoPrefetch || b.type === "audio" && a.i.disableAudioPrefetch || b.type === Ec && (b.mimeType == "application/cea-608" || b.mimeType == "application/cea-708") || b.type === Ec && a.i.disableTextPrefetch) return null;
            if (a.m.has(b)) return a.m.get(b);
            var c = a.h.get(b.type);
            return (c = c && c.ma) && b === c.i ? c : a.i.segmentPrefetchLimit > 0 ? new Om(a.i.segmentPrefetchLimit, b, function(d, e, f) {
                return Jn(d, e, f || null, a.i.retryParameters, a.g.Cc);
            }, a.g.Wa() < 0, a.g.Am) : null;
        }
        function pn(a) {
            for(var b = a.i.segmentPrefetchLimit, c = a.i.prefetchAudioLanguages, d = u(a.j.variants), e = d.next(), f = {}; !e.done; f = {
                Nb: void 0
            }, e = d.next())if (f.Nb = e.value, f.Nb.audio) {
                if (a.m.has(f.Nb.audio)) {
                    if (e = a.m.get(f.Nb.audio), Ym(e, b), !(b > 0 && c.some(function(h) {
                        return function(k) {
                            return Jc(h.Nb.audio.language, k);
                        };
                    }(f)))) {
                        var g = a.h.get(f.Nb.audio.type);
                        e !== (g && g.ma) && Xm(e);
                        a.m.delete(f.Nb.audio);
                    }
                } else b <= 0 || !c.some(function(h) {
                    return function(k) {
                        return Jc(h.Nb.audio.language, k);
                    };
                }(f)) || !(e = on(a, f.Nb.audio)) || (f.Nb.audio.segmentIndex || f.Nb.audio.createSegmentIndex(), a.m.set(f.Nb.audio, e));
            }
        }
        p.updateDuration = function() {
            var a = Ui(), b = this.j.presentationTimeline.getDuration();
            b < Infinity ? (a && (this.A && this.A.stop(), Bl(this.g.aa)), this.g.aa.Ab(b)) : a ? (this.A && this.A.xa(.5), this.g.aa.Ab(Infinity)) : this.g.aa.Ab(4294967296);
        };
        function Kn(a, b) {
            var c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                switch(n.h){
                    case 1:
                        vh(a.l);
                        c = Gc;
                        if (b.Ra || b.rb == null || b.$b) return n.return();
                        b.rb = null;
                        if (!b.Yb) {
                            n.B(2);
                            break;
                        }
                        return n.g(Fn(a, b, b.ae, b.vd), 3);
                    case 3:
                        return n.return();
                    case 2:
                        Bn(a, b);
                        if (b.stream.segmentIndex) {
                            n.B(4);
                            break;
                        }
                        d = b.stream;
                        n.m(5);
                        return n.g(b.stream.createSegmentIndex(), 7);
                    case 7:
                        n.o(6);
                        break;
                    case 5:
                        return e = n.l(), n.g(Ln(a, b, e), 8);
                    case 8:
                        return n.return();
                    case 6:
                        if (d != b.stream) return d.closeSegmentIndex && d.closeSegmentIndex(), b.Ra || b.rb || un(a, b, 0), n.return();
                    case 4:
                        if (!b.Mc) {
                            n.B(9);
                            break;
                        }
                        if (b.Mc.stream.segmentIndex) {
                            n.B(9);
                            break;
                        }
                        n.m(11);
                        return n.g(b.Mc.stream.createSegmentIndex(), 13);
                    case 13:
                        n.o(9);
                        break;
                    case 11:
                        n.l();
                    case 9:
                        n.m(14);
                        f = Mn(a, b);
                        f != null && (un(a, b, f), b.Fd = !1);
                        n.o(15);
                        break;
                    case 14:
                        return g = n.l(), n.g(Ln(a, b, g), 16);
                    case 16:
                        return n.return();
                    case 15:
                        if (b.type === c.Va) return n.return();
                        h = [];
                        b.stream && !b.stream.isAudioMuxedInVideo && h.push(b);
                        k = b.type === c.ha ? c.Ba : c.ha;
                        (l = a.h.get(k)) && l.stream && !l.stream.isAudioMuxedInVideo && h.push(l);
                        if (!a.M || !h.every(function(q) {
                            return q.endOfStream;
                        })) {
                            n.B(0);
                            break;
                        }
                        return n.g(a.g.aa.endOfStream(), 18);
                    case 18:
                        vh(a.l), m = a.g.aa.getDuration(), m != 0 && m < a.j.presentationTimeline.getDuration() && a.j.presentationTimeline.Ab(m), n.j();
                }
            });
        }
        function Mn(a, b) {
            if (Nn(b)) return rl(a.g.aa, b.stream.originalId || ""), null;
            b.type == Ec && sl(a.g.aa);
            if (b.stream.isAudioMuxedInVideo && b.type == "audio") return null;
            if (b.type != Ec && al(a.g.aa)) return On(a, !0), null;
            var c = a.i.updateIntervalSeconds / Math.max(1, Math.abs(a.g.Wa()));
            if (!fl(a.g.aa) && b.type != Ec) return c / 2;
            var d = a.g.bc();
            if (b.type === "audio") for(var e = u(a.m.keys()), f = e.next(); !f.done; f = e.next())f = a.m.get(f.value), f.$a(d, !0), Qm(f, d);
            e = b.Na ? b.Na.endTime : d;
            var g = jl(a.g.aa, b.type, d);
            f = Math.max(1, Math.max(a.i.rebufferingGoal, a.i.bufferingGoal) * a.D);
            var h = a.j.presentationTimeline.getDuration() - e, k = il(a.g.aa, b.type);
            if (h < 1E-6 && k) return b.endOfStream = !0, b.type == "video" && ((c = a.h.get(Ec)) && Nn(c) && (c.endOfStream = !0), (c = a.h.get("audio")) && c.stream.isAudioMuxedInVideo && (c.endOfStream = !0)), null;
            b.endOfStream = !1;
            if (g >= f) return c / 2;
            h = !b.Aa;
            k = Pn(a, b, d, k);
            if (!k) return a = Infinity, (b = b.Na) && (a = b.endTime - b.startTime), Math.min(a / 2, c);
            g = b.qb;
            var l = k.ia;
            g && l && Nj(l, g) && (g.g = l.g);
            g = !1;
            h && b.Gg && (g = !0, b.Gg = !1);
            h = Infinity;
            l = u(a.h.values());
            for(var m = l.next(); !m.done; m = l.next())m = m.value, Nn(m) || m.stream.isAudioMuxedInVideo || m.Aa && !m.Aa.current() || (h = Math.min(h, m.Na ? m.Na.endTime : d));
            if (e >= h + a.j.presentationTimeline.h) return c;
            b.ma && b.Aa && !a.m.has(b.stream) && (b.ma.$a(k.startTime + .001), Qm(b.ma, k.startTime).catch(function() {}));
            if (Gn(a) && Qn(a, b, k)) return null;
            Rn(a, b, d, k, g).catch(function() {});
            b.Mc && Sn(a, b.Mc, d, f);
            return null;
        }
        function Pn(a, b, c, d) {
            if (b.Aa) {
                var e = b.Aa.current();
                e && b.Na && (c = b.Na.endTime, rk(b.Na.startTime, e.startTime, .002) && rk(c, e.endTime, .002) && (e = b.Aa.next().value));
                return e;
            }
            if (b.Na || d) return e = b.Na ? b.Na.endTime : d, c = a.g.Wa() < 0, b.stream.segmentIndex && (b.Aa = b.stream.segmentIndex.ac(e, !1, c)), b.Aa && b.Aa.next().value;
            d = a.j.sequenceMode || Gn(a) ? 0 : a.i.inaccurateManifestTolerance;
            var f = Math.max(c - d, 0), g = a.g.aa.getDuration();
            Math.abs(f - g) < 1 && (d = 1, f = Math.max(c - d, 0));
            g = a.g.Wa() < 0;
            a = null;
            d && (b.stream.segmentIndex && (b.Aa = b.stream.segmentIndex.ac(f, !1, g)), a = b.Aa && b.Aa.next().value);
            a || (b.stream.segmentIndex && (b.Aa = b.stream.segmentIndex.ac(c, !1, g)), a = b.Aa && b.Aa.next().value);
            for(; ((e = a) == null ? void 0 : e.ec()) === 2;)d = c = void 0, a = (d = (c = b.Aa) == null ? void 0 : c.next().value) != null ? d : null;
            return a;
        }
        function Rn(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C;
            return H(function(D) {
                switch(D.h){
                    case 1:
                        f = Gc;
                        g = b.stream;
                        h = b.Aa;
                        b.Ra = !0;
                        D.m(2);
                        if (d.ec() == 2) throw new T(1, 1, 1011);
                        return D.g(Tn(a, b, d, e), 4);
                    case 4:
                        vh(a.l);
                        if (a.F) return D.return();
                        k = g.mimeType == "video/mp4" || g.mimeType == "audio/mp4";
                        l = window1.ReadableStream;
                        if ((m = a.i.lowLatencyMode && a.j.isLowLatency) && l && k && (a.j.type != "HLS" || d.o)) return r = new Uint8Array(0), v = t = !1, x = function(B) {
                            var J, F, I, K;
                            return H(function(N) {
                                switch(N.h){
                                    case 1:
                                        if (t) return N.return();
                                        v = !0;
                                        vh(a.l);
                                        if (a.F) return N.return();
                                        N.m(2);
                                        r = tc(r, B);
                                        J = !1;
                                        F = 0;
                                        (new Bh).box("mdat", function(P) {
                                            F = P.size + P.start;
                                            J = !0;
                                        }).parse(r, !1, !0);
                                        if (!J) {
                                            N.B(4);
                                            break;
                                        }
                                        I = r.subarray(0, F);
                                        r = r.subarray(F);
                                        return N.g(Un(a, b, c, g, d, I, !0, e), 5);
                                    case 5:
                                        b.ma && b.Aa && Qm(b.ma, d.startTime, !0);
                                    case 4:
                                        N.o(0);
                                        break;
                                    case 2:
                                        w = K = N.l(), N.j();
                                }
                            });
                        }, D.g(Vn(a, b, d, x), 9);
                        n = Vn(a, b, d);
                        return D.g(n, 7);
                    case 7:
                        q = D.i;
                        vh(a.l);
                        if (a.F) return D.return();
                        vh(a.l);
                        return b.Yb ? (b.Ra = !1, un(a, b, 0), D.return()) : D.g(Un(a, b, c, g, d, q, !1, e), 6);
                    case 9:
                        y = D.i;
                        if (w) throw w;
                        if (v) {
                            D.B(10);
                            break;
                        }
                        t = !0;
                        vh(a.l);
                        return a.F ? D.return() : b.Yb ? (b.Ra = !1, un(a, b, 0), D.return()) : D.g(Un(a, b, c, g, d, y, !1, e), 10);
                    case 10:
                        b.ma && b.Aa && Qm(b.ma, d.startTime, !0);
                    case 6:
                        vh(a.l);
                        if (a.F) return D.return();
                        b.Na = d;
                        h.next();
                        b.Ra = !1;
                        b.Wh = !1;
                        z = a.g.aa.Nc();
                        A = z[b.type];
                        cb(JSON.stringify(A));
                        b.Yb || (E = null, b.type === f.Ba ? E = a.h.get(f.ha) : b.type === f.ha && (E = a.h.get(f.Ba)), E && E.type == f.ha ? a.g.Md(d, b.stream, E.stream.isAudioMuxedInVideo, !1) : a.g.Md(d, b.stream, b.stream.codecs.includes(","), !1));
                        mn(b);
                        un(a, b, 0);
                        D.o(0);
                        break;
                    case 2:
                        C = D.l();
                        vh(a.l, C);
                        if (a.F) return D.return();
                        b.Ra = !1;
                        if (C.code == 7001) b.Ra = !1, mn(b), un(a, b, 0), D.B(0);
                        else if (b.type == f.Va && a.i.ignoreTextStreamFailures) a.h.delete(f.Va), D.B(0);
                        else {
                            if (C.code == 3017) return D.g(Wn(a, b, C), 0);
                            b.Fd = !0;
                            C.category == 1 && b.ma && Wm(b.ma, d);
                            C.severity = 2;
                            return D.g(Ln(a, b, C), 0);
                        }
                }
            });
        }
        function Sn(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w;
            return H(function(x) {
                switch(x.h){
                    case 1:
                        e = Gc;
                        f = b.stream;
                        for(k = (h = (g = f.segmentIndex) && g.ac(c)) && h.next().value; k && a.O.includes(k.startTime);)k = h && h.next().value;
                        if (!k) {
                            x.B(0);
                            break;
                        }
                        l = k.ia;
                        if (!l || Nj(l, b.qb)) {
                            x.B(3);
                            break;
                        }
                        b.qb = l;
                        x.m(4);
                        return x.g(Vn(a, b, l), 6);
                    case 6:
                        m = x.i;
                        if (!a.g) return x.return();
                        var y = a.g.aa;
                        y.D && td(y.D, m, 0, f);
                        a.O = [];
                        x.o(3);
                        break;
                    case 4:
                        throw n = x.l(), b.qb = null, n;
                    case 3:
                        if (b.Na && b.Na == k) {
                            x.B(0);
                            break;
                        }
                        b.Na = k;
                        x.m(8);
                        return x.g(Vn(a, b, k), 10);
                    case 10:
                        q = x.i;
                        if (!a.g) return x.return();
                        y = a.g.aa;
                        y.D && td(y.D, q, 0, f);
                        a.O.push(k.startTime);
                        x.o(9);
                        break;
                    case 8:
                        throw r = x.l(), b.Na = null, r;
                    case 9:
                        if (!a.g) return x.return();
                        b.Yb || (t = null, b.type === e.Ba ? t = a.h.get(e.ha) : b.type === e.ha && (t = a.h.get(e.Ba)), t && t.type == e.ha ? a.g.Md(k, b.stream, t.stream.isAudioMuxedInVideo, !0) : a.g.Md(k, b.stream, b.stream.codecs.includes(","), !0));
                        v = Math.max.apply(Math, [
                            0
                        ].concat(G(a.O)));
                        w = a.g.bc();
                        if (w + d > v) return x.g(Sn(a, b, k.startTime, d), 0);
                        x.B(0);
                }
            });
        }
        function Wn(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r;
            return H(function(t) {
                switch(t.h){
                    case 1:
                        d = !1;
                        e = u(a.h.values());
                        for(f = e.next(); !f.done; f = e.next())if (g = f.value, g != b && g.Wh) {
                            d = !0;
                            break;
                        }
                        if (d) {
                            t.B(2);
                            break;
                        }
                        if (a.i.avoidEvictionOnQuotaExceededError) {
                            h = Xn(a, c);
                            if (k = a.g.disableStream(b.stream, h)) return t.return();
                            un(a, b, 4);
                            return t.return();
                        }
                        l = Math.round(100 * a.D);
                        if (l > 20) {
                            a.D -= .2;
                            t.B(3);
                            break;
                        }
                        if (l > 4) {
                            a.D -= .04;
                            t.B(3);
                            break;
                        }
                        m = Xn(a, c);
                        n = a.g.disableStream(b.stream, m);
                        if (!n) {
                            b.Fd = !0;
                            a.F = !0;
                            a.g.onError(c);
                            t.B(5);
                            break;
                        }
                        a.D = 1;
                        q = a.g.bc();
                        return t.g(Yn(a, b, q), 5);
                    case 5:
                        return t.return();
                    case 3:
                        return b.Wh = !0, r = a.g.bc(), t.g(Yn(a, b, r), 2);
                    case 2:
                        un(a, b, 4), t.j();
                }
            });
        }
        function Tn(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z;
            return H(function(A) {
                switch(A.h){
                    case 1:
                        e = Gc;
                        f = b.Na == null;
                        g = [];
                        h = Math.max(0, Math.max(c.appendWindowStart, a.X) - .1);
                        k = Math.min(c.appendWindowEnd, a.W) + .1;
                        l = c.codecs || b.stream.codecs;
                        m = Ef(l);
                        n = Ff(c.mimeType || b.stream.mimeType);
                        q = c.timestampOffset;
                        if (q == b.Lf && h == b.Ac && k == b.zc && m == b.Jf && n == b.Kf) {
                            A.B(2);
                            break;
                        }
                        r = b.Jf && b.Kf && Vl(a.g.aa, b.type, n, l, In(a));
                        if (!r) {
                            A.B(3);
                            break;
                        }
                        t = null;
                        b.type === e.Ba ? t = a.h.get(e.ha) : b.type === e.ha && (t = a.h.get(e.Ba));
                        if (!t) {
                            A.B(3);
                            break;
                        }
                        return A.g(nn(t).catch(function() {}), 5);
                    case 5:
                        t.qb = null, t.Ac = null, t.zc = null, Dn(a, t);
                    case 3:
                        return A.g(Zn(a, b, q, h, k, c, m, n), 2);
                    case 2:
                        return Nj(c.ia, b.qb) || (b.qb = c.ia, c.l && c.ia && (v = Vn(a, b, c.ia), w = function() {
                            var E, C, D, B, J, F, I, K, N, P, M;
                            return H(function(L) {
                                switch(L.h){
                                    case 1:
                                        return L.m(2), L.g(v, 4);
                                    case 4:
                                        return E = L.i, vh(a.l), C = null, D = new Map, B = {
                                            projection: null,
                                            hfov: null
                                        }, b.stream && (J = b.stream.videoLayout) && (F = J.split("/"), F.includes("PROJ-RECT") ? B.projection = "rect" : F.includes("PROJ-EQUI") ? B.projection = "equi" : F.includes("PROJ-HEQU") ? B.projection = "hequ" : F.includes("PROJ-PRIM") ? B.projection = "prim" : F.includes("PROJ-AIV") && (B.projection = "hequ")), I = new Bh, I.box("moov", Gh).box("trak", Gh).box("mdia", Gh).qa("mdhd", function(Q) {
                                            C = Xi(Q.reader, Q.version).timescale;
                                        }).qa("hdlr", function(Q) {
                                            Q = Q.reader;
                                            Q.skip(4);
                                            Q = Q.Wb(4, !1);
                                            switch(String.fromCharCode(Q[0], Q[1], Q[2], Q[3])){
                                                case "soun":
                                                    D.set(e.ha, C);
                                                    break;
                                                case "vide":
                                                    D.set(e.Ba, C);
                                            }
                                            C = null;
                                        }), b.type !== e.Ba || B.projection || I.box("minf", Gh).box("stbl", Gh).qa("stsd", Ih).boxes("encv avc1 avc3 hev1 hvc1 dvav dva1 dvh1 dvhe dvc1 dvi1".split(" "), Jh).box("vexu", Gh).box("proj", Gh).qa("prji", function(Q) {
                                            Q = Q.reader.Qd();
                                            B.projection = Q;
                                        }).box("hfov", function(Q) {
                                            Q = Q.reader.Y() / 1E3;
                                            B.hfov = Q;
                                        }), I.parse(E, !0, !0), b.type === e.Ba && $n(a, B), D.has(b.type) ? c.ia.timescale = D.get(b.type) : C != null && (c.ia.timescale = C), K = b.stream.segmentIndex, K instanceof ym && (N = Am(K, c.startTime)), P = b.stream.closedCaptions && b.stream.closedCaptions.size > 0, L.g(a.g.Ni(b.type, E), 5);
                                    case 5:
                                        return L.g(ml(a.g.aa, b.type, E, null, b.stream, P, b.ld, d, !1, !1, N), 6);
                                    case 6:
                                        L.o(0);
                                        break;
                                    case 2:
                                        throw M = L.l(), b.qb = null, M;
                                }
                            });
                        }, x = c.startTime, f && (y = il(a.g.aa, b.type), y != null && (x = y)), a.g.Wl(x, c.ia), g.push(w()))), z = b.Na ? b.Na.i : -1, c.i != z && g.push(yl(a.g.aa, b.type, c.startTime)), A.g(Promise.all(g), 0);
                }
            });
        }
        function Zn(a, b, c, d, e, f, g, h) {
            var k, l, m, n, q;
            return H(function(r) {
                switch(r.h){
                    case 1:
                        k = Gc;
                        l = In(a);
                        r.m(2);
                        b.Ac = d;
                        b.zc = e;
                        g && (b.Jf = g);
                        h && (b.Kf = h);
                        b.Lf = c;
                        m = a.j.sequenceMode || a.j.type == "HLS";
                        n = null;
                        b.type === k.Ba ? n = a.h.get(k.ha) : b.type === k.ha && (n = a.h.get(k.Ba));
                        if (!(n && n.stream && n.stream.isAudioMuxedInVideo)) {
                            r.B(4);
                            break;
                        }
                        return r.g(vl(a.g.aa, n.type, c, d, e, m, n.stream.mimeType, n.stream.codecs, l), 4);
                    case 4:
                        return r.g(vl(a.g.aa, b.type, c, d, e, m, f.mimeType || b.stream.mimeType, f.codecs || b.stream.codecs, l), 6);
                    case 6:
                        r.o(0);
                        break;
                    case 2:
                        throw q = r.l(), b.Ac = null, b.zc = null, b.Jf = null, b.Kf = null, b.Lf = null, q;
                }
            });
        }
        function Un(a, b, c, d, e, f, g, h) {
            g = g === void 0 ? !1 : g;
            h = h === void 0 ? !1 : h;
            var k, l, m, n, q;
            return H(function(r) {
                switch(r.h){
                    case 1:
                        return k = d.closedCaptions && d.closedCaptions.size > 0, a.i.shouldFixTimestampOffset && (l = d.mimeType == "video/mp4" || d.mimeType == "audio/mp4", m = null, e.ia && (m = e.ia.timescale), (n = l && m && d.type === "video" && a.j.type == "DASH") && (new Bh).box("moof", Gh).box("traf", Gh).qa("tfdt", function(t) {
                            var v, w, x, y, z, A;
                            return H(function(E) {
                                v = Wi(t.reader, t.version);
                                w = v.baseMediaDecodeTime;
                                if (!w) return E.return();
                                x = -w / m;
                                y = Number(b.Lf) || 0;
                                if (!(y < x)) return E.B(0);
                                z = b.Ac;
                                A = b.zc;
                                return E.g(Zn(a, b, x, z, A, e), 0);
                            });
                        }).parse(f, !1, g)), r.g(Yn(a, b, c), 2);
                    case 2:
                        return vh(a.l), q = b.ld, b.ld = !1, r.g(a.g.Ni(b.type, f), 3);
                    case 3:
                        return r.g(ml(a.g.aa, b.type, f, e, d, k, q, h, g), 4);
                    case 4:
                        vh(a.l), r.j();
                }
            });
        }
        function Yn(a, b, c) {
            var d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                if (q.h == 1) {
                    a.H == b && (a.H = null);
                    d = b.stream.segmentIndex;
                    d instanceof ym && (d.$a(a.j.presentationTimeline.Hb()), e = [], zm(d, function(r) {
                        e.push(r.lf());
                    }));
                    f = Math.max(a.i.bufferBehind * a.D, a.j.presentationTimeline.h);
                    g = gl(a.g.aa, b.type);
                    if (g == null) return q.return();
                    h = c - g;
                    k = a.i.evictionGoal;
                    l = a.j.presentationTimeline.cc();
                    m = a.j.presentationTimeline.Gb();
                    n = h - f;
                    m - l > k && (n = Math.max(h - f, l - k - g));
                    return n <= k ? q.return() : q.g(a.g.aa.remove(b.type, g, g + n, e), 2);
                }
                if (q.h != 4) return vh(a.l), a.H ? q.g(Yn(a, a.H, c), 4) : q.B(0);
                vh(a.l);
                q.j();
            });
        }
        function Nn(a) {
            return a && a.type == Ec && (a.stream.mimeType == "application/cea-608" || a.stream.mimeType == "application/cea-708");
        }
        function Vn(a, b, c, d) {
            var e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        if (e = c.dc()) return l.return(e);
                        f = null;
                        if (b.ma) {
                            var m = b.ma, n = m.g;
                            c instanceof Mj && (n = m.j);
                            n.has(c) ? (m = n.get(c), d && (m.ri = d), f = m.Be) : f = null;
                        }
                        f || (f = Jn(c, b.stream, d || null, a.i.retryParameters, a.g.Cc));
                        g = 0;
                        b.Aa && (g = b.Aa.h);
                        b.bb = f;
                        return l.g(f.promise, 2);
                    case 2:
                        h = l.i;
                        b.bb = null;
                        k = h.data;
                        if (!c.aesKey) {
                            l.B(3);
                            break;
                        }
                        return l.g(en(k, c.aesKey, g), 4);
                    case 4:
                        k = l.i;
                    case 3:
                        return l.return(k);
                }
            });
        }
        function Jn(a, b, c, d, e, f) {
            f = f === void 0 ? !1 : f;
            var g = a instanceof Oj ? a : void 0, h = g ? 1 : 0;
            a = jn(a.T(), a.startByte, a.endByte, d, c);
            a.contentType = b.type;
            return e.request(sh, a, {
                type: h,
                stream: b,
                segment: g,
                isPreload: f
            });
        }
        function Fn(a, b, c, d) {
            var e, f;
            return H(function(g) {
                if (g.h == 1) return b.Yb = !1, b.ae = !1, b.vd = 0, b.$b = !0, b.Na = null, b.Aa = null, b.ma && !a.m.has(b.stream) && Xm(b.ma), d ? (e = a.g.bc(), f = a.g.aa.getDuration(), g.g(a.g.aa.remove(b.type, e + d, f), 3)) : g.g(ul(a.g.aa, b.type), 4);
                if (g.h != 3) return vh(a.l), c ? g.g(a.g.aa.flush(b.type), 3) : g.B(3);
                vh(a.l);
                b.$b = !1;
                b.endOfStream = !1;
                b.Ra || b.rb || un(a, b, 0);
                g.j();
            });
        }
        function un(a, b, c) {
            var d = b.type;
            if (d != Ec || a.h.has(d)) b.rb = new Uf(function() {
                var e;
                return H(function(f) {
                    if (f.h == 1) return f.m(2), f.g(Kn(a, b), 4);
                    if (f.h != 2) return f.o(0);
                    e = f.l();
                    if (a.g) a.g.onError(e);
                    f.j();
                });
            }).Z(c);
        }
        function mn(a) {
            a.rb != null && (a.rb.stop(), a.rb = null);
        }
        function nn(a) {
            return H(function(b) {
                return a.bb ? b.g(a.bb.abort(), 0) : b.B(0);
            });
        }
        function Ln(a, b, c) {
            var d, e, f, g, h;
            return H(function(k) {
                switch(k.h){
                    case 1:
                        return c.code == 3024 ? (b.Ra = !1, mn(b), un(a, b, 0), k.return()) : k.g(Xg(a.V), 2);
                    case 2:
                        vh(a.l);
                        if (c.category === 1 && c.code != 1003) {
                            if (b.Vc) return wn(a, !1), k.return();
                            d = Xn(a, c);
                            c.handled = a.g.disableStream(b.stream, d);
                            c.handled && (c.severity = 1);
                        }
                        if (c.handled || c.code != 1011) {
                            k.B(3);
                            break;
                        }
                        e = a.g.bc();
                        f = il(a.g.aa, b.type);
                        for(g = Pn(a, b, e, f); ((h = g) == null ? void 0 : h.ec()) === 2;)b.Na = g, g = Pn(a, b, e, f);
                        if (!g) {
                            k.B(3);
                            break;
                        }
                        return k.g(yl(a.g.aa, b.type, g.startTime), 5);
                    case 5:
                        return b.Ra = !1, b.Fd = !1, mn(b), un(a, b, 0), k.return();
                    case 3:
                        if (!c.handled || c.code != 1011) a.g.onError(c);
                        c.handled || a.i.failureCallback(c);
                        k.j();
                }
            });
        }
        function Xn(a, b) {
            return a.i.maxDisabledTime === 0 && b.code == 1011 ? 1 : a.i.maxDisabledTime;
        }
        function On(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) {
                    c = Date.now() / 1E3;
                    d = a.i.minTimeBetweenRecoveries;
                    if (!b && (!a.i.allowMediaSourceRecoveries || c - a.P < d)) return k.return(!1);
                    a.P = c;
                    e = Gc;
                    if (f = a.h.get(e.ha)) mn(f), f.bb && (f.bb.abort(), f.bb = null), f.qb = null, f.Ac = null, f.zc = null, f.Ra = !1, f.Yb = !1, f.vd = 0, f.ae = !1, f.$b = !1, f.Aa && f.Aa.ai();
                    if (g = a.h.get(e.Ba)) mn(g), g.bb && (g.bb.abort(), g.bb = null), g.qb = null, g.Ac = null, g.zc = null, g.Ra = !1, g.Yb = !1, g.vd = 0, g.ae = !1, g.$b = !1, g.Aa && g.Aa.ai();
                    h = a.g.video.paused;
                    return k.g(Pl(a.g.aa, In(a)), 2);
                }
                !g || g.$b || g.Ra || g.rb || un(a, g, 0);
                !f || f.$b || f.Ra || f.rb || un(a, f, 0);
                h || a.g.video.play();
                return k.return(!0);
            });
        }
        function $n(a, b) {
            if (a.R.projection != b.projection || a.R.hfov != b.hfov) {
                if (b.projection != null || b.hfov != null) {
                    var c = (new Map).set("detail", b);
                    c = new R("spatialvideoinfo", c);
                } else c = new R("nospatialvideoinfo");
                c.cancelable = !0;
                a.g.onEvent(c);
                a.R = b;
            }
        }
        function Gn(a) {
            if (a.i.crossBoundaryStrategy !== "keep") return !0;
            var b = Xb();
            if (!b.Bb()) {
                b = u(a.h.keys());
                for(var c = b.next(); !c.done; c = b.next())if (c = a.h.get(c.value), c.type !== Gc.Va && (c = c.stream) && c.fullMimeTypes && c.fullMimeTypes.size > 1) return !0;
            } else if (!b.mg()) {
                for(b = u(a.h.keys()), c = b.next(); !c.done; c = b.next())if (c = a.h.get(c.value), c.type !== Gc.Va && (c = c.stream) && c.fullMimeTypes && c.fullMimeTypes.size > 1) {
                    a = new Set;
                    b = u(c.fullMimeTypes);
                    for(c = b.next(); !c.done; c = b.next())a.add(Bf(c.value));
                    return a.size > 1;
                }
            }
            return !1;
        }
        function Cn(a) {
            a.G.Ta();
            Gn(a) && (a.G.u(a.g.video, "waiting", function() {
                return Hn(a);
            }), a.G.u(a.g.video, "timeupdate", function() {
                return Hn(a);
            }));
        }
        function Hn(a) {
            if (Gn(a)) {
                a.K.stop();
                var b = a.g.bc(), c = a.h.get("video") || a.h.get("audio");
                c && (c = c.qb) && c.g !== null && (b = c.g - b, b < 0 || b > 1 || (a.I = c.g + .1, a.K.Z(b)));
            }
        }
        function Qn(a, b, c) {
            if (b.type === Ec) return !1;
            var d = b.qb;
            if (!d) return !1;
            var e = c.ia;
            c = d.g !== e.g;
            a.i.crossBoundaryStrategy === "reset_to_encrypted" && (d.encrypted || e.encrypted || (c = !1), d.encrypted && (a.i.crossBoundaryStrategy = "keep"));
            a.i.crossBoundaryStrategy === "RESET_ON_ENCRYPTION_CHANGE" && d.encrypted == e.encrypted && (c = !1);
            if (a.i.crossBoundaryStrategy === "keep" && d.mimeType && e.mimeType) {
                var f = Cf(Gf(d.mimeType)), g = Cf(Gf(e.mimeType));
                d.mimeType == e.mimeType && f == g && (c = !1);
            }
            (a.h.get("video") || a.h.get("audio")) === b && c && (a.J || b.ld) && (a.J = !1, On(a, !0).then(function() {
                var h = (new Map).set("oldEncrypted", d.encrypted).set("newEncrypted", e.encrypted);
                a.g.onEvent(new R("boundarycrossed", h));
            }));
            return c;
        }
        function In(a, b) {
            function c(f) {
                if (f.fullMimeTypes && f.fullMimeTypes.size > 1 && a.h.has(f.type)) {
                    var g = a.h.get(f.type), h = il(a.g.aa, g.type), k = a.g.bc();
                    (g = Pn(a, g, k, h)) && g.codecs && g.mimeType && (f.codecs = g.codecs, f.mimeType = g.mimeType);
                }
            }
            b = b === void 0 ? !1 : b;
            var d = new Map, e = a.o.audio;
            e && (c(e), d.set("audio", e));
            if (e = a.o.video) c(e), d.set("video", e);
            b && a.C && d.set(Ec, a.C);
            return d;
        }
        function ao() {}
        function bo(a, b, c, d, e) {
            var f = e in d, g = new Set([
                "__proto__",
                "constructor",
                "prototype"
            ]);
            var h = f ? c.constructor == Object && Object.keys(d).length == 0 : c.constructor == Object && Object.keys(c).length == 0;
            for(var k = f || h, l = !0, m = u(Object.keys(b)), n = m.next(); !n.done; n = m.next()){
                n = n.value;
                var q = e + "." + n, r = f ? d[e] : c[n];
                g.has(n) ? (Ya("Invalid config, dangerous key " + q), l = !1) : k || n in c ? b[n] === void 0 ? r === void 0 || k ? delete a[n] : a[n] = Xd(r) : h ? a[n] = b[n] : r.constructor == Object && b[n] && b[n].constructor == Object ? (a[n] || (a[n] = Xd(r)), n = bo(a[n], b[n], r, d, q), l = l && n) : typeof b[n] != typeof r || b[n] == null || typeof b[n] != "function" && b[n].constructor != r.constructor ? (Ya("Invalid config, wrong type for " + q), l = !1) : typeof c[n] == "function" && c[n].length != b[n].length ? (Za("Unexpected number of arguments for " + q), a[n] = b[n]) : a[n] = Array.isArray(a[n]) ? b[n].slice() : b[n] : (Ya("Invalid config, unrecognized key " + q), l = !1);
            }
            return l;
        }
        function co(a, b) {
            for(var c = {}, d = c, e = 0, f = 0;;){
                e = a.indexOf(".", e);
                if (e < 0) break;
                if (e == 0 || a[e - 1] != "\\") f = a.substring(f, e).replace(/\\\./g, "."), d[f] = {}, d = d[f], f = e + 1;
                e += 1;
            }
            d[a.substring(f).replace(/\\\./g, ".")] = b;
            return c;
        }
        function eo(a, b) {
            return a && b;
        }
        function fo(a, b) {
            function c(f) {
                for(var g = u(Object.keys(f)), h = g.next(); !h.done; h = g.next())if (h = h.value, !(f[h] instanceof HTMLElement)) {
                    if (e(f[h]) && Object.keys(f[h]).length === 0) delete f[h];
                    else {
                        var k = f[h];
                        Array.isArray(k) && k.length === 0 ? delete f[h] : typeof f[h] == "function" ? delete f[h] : e(f[h]) && (c(f[h]), Object.keys(f[h]).length === 0 && delete f[h]);
                    }
                }
            }
            function d(f, g) {
                return Object.keys(f).reduce(function(h, k) {
                    var l = f[k];
                    if (g.hasOwnProperty(k)) {
                        if (l instanceof HTMLElement && g[k] instanceof HTMLElement) l.isEqualNode(g[k]) || (h[k] = l);
                        else if (e(l) && e(g[k])) {
                            if (l = d(l, g[k]), Object.keys(l).length > 0 || !e(l)) h[k] = l;
                        } else Array.isArray(l) && Array.isArray(g[k]) ? bd(l, g[k]) || (h[k] = l) : Number.isNaN(l) && Number.isNaN(g[k]) || l !== g[k] && (h[k] = l);
                    } else h[k] = l;
                    return h;
                }, {});
            }
            function e(f) {
                return f && typeof f === "object" && !Array.isArray(f);
            }
            a = d(a, b);
            c(a);
            return a;
        }
        O("shaka.util.ConfigUtils", ao);
        ao.getDifferenceFromConfigObjects = fo;
        ao.convertToConfigObject = co;
        ao.mergeConfigObjects = bo;
        O("shaka.config.RepeatMode", {
            OFF: 0,
            ALL: 1,
            SINGLE: 2
        });
        function go() {}
        function ho(a) {
            a = ec(a);
            return new lb(a).Eb;
        }
        function io(a, b, c) {
            function d(h) {
                Jb(f).setUint32(g, h.byteLength, !0);
                g += 4;
                f.set(Fb(h), g);
                g += h.byteLength;
            }
            if (!c || !c.byteLength) throw new T(2, 6, 6015);
            var e;
            typeof b == "string" ? e = ic(b, !0) : e = b;
            a = ec(a);
            a = ic(a, !0);
            var f = new Uint8Array(12 + a.byteLength + e.byteLength + c.byteLength), g = 0;
            d(a);
            d(e);
            d(c);
            return f;
        }
        function jo(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = ec(a).split("skd://").pop();
            return io(a, c, b);
        }
        function ko(a, b) {
            a === 2 && (a = b.drmInfo) && Rb(a.keySystem) && (b.headers["Content-Type"] = "application/octet-stream");
        }
        O("shaka.drm.FairPlay", go);
        go.commonFairPlayResponse = function(a, b) {
            if (a === 2 && (a = b.originalRequest.drmInfo) && Rb(a.keySystem)) {
                try {
                    var c = bc(b.data);
                } catch (e) {
                    return;
                }
                a = !1;
                c = c.trim();
                c.substr(0, 5) === "<ckc>" && c.substr(-6) === "</ckc>" && (c = c.slice(5, -6), a = !0);
                if (!a) try {
                    var d = JSON.parse(c);
                    d.ckc && (c = d.ckc, a = !0);
                    d.CkcMessage && (c = d.CkcMessage, a = !0);
                    d.License && (c = d.License, a = !0);
                } catch (e) {}
                a && (b.data = Gb(qc(c)));
            }
        };
        go.muxFairPlayRequest = function(a, b) {
            ko(a, b);
        };
        go.expressplayFairPlayRequest = function(a, b) {
            if (a === 2) {
                var c = b.drmInfo;
                c && Rb(c.keySystem) && ko(a, b);
            }
        };
        go.conaxFairPlayRequest = function(a, b) {
            ko(a, b);
        };
        go.ezdrmFairPlayRequest = function(a, b) {
            ko(a, b);
        };
        go.verimatrixFairPlayRequest = function(a, b) {
            a === 2 && (a = b.drmInfo) && Rb(a.keySystem) && (a = Fb(b.body), a = mc(a), b.headers["Content-Type"] = "application/x-www-form-urlencoded", b.body = hc("spc=" + a));
        };
        go.muxInitDataTransform = function(a, b, c) {
            return jo(a, b, c);
        };
        go.expressplayInitDataTransform = function(a, b, c) {
            return jo(a, b, c);
        };
        go.conaxInitDataTransform = function(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = ec(a).split("skd://").pop().split("?").shift();
            c = window1.atob(c);
            var d = new ArrayBuffer(c.length * 2);
            d = Ib(d);
            for(var e = 0, f = c.length; e < f; e++)d[e] = c.charCodeAt(e);
            return io(a, d, b);
        };
        go.ezdrmInitDataTransform = function(a, b, c) {
            if (b !== "skd") return a;
            b = c.serverCertificate;
            c = ec(a).split(";").pop();
            return io(a, c, b);
        };
        go.verimatrixInitDataTransform = function(a, b, c) {
            return jo(a, b, c);
        };
        go.initDataTransform = io;
        go.defaultGetContentId = ho;
        go.isFairPlaySupported = function() {
            var a;
            return H(function(b) {
                if (b.h == 1) return a = {
                    initDataTypes: [
                        "cenc",
                        "sinf",
                        "skd"
                    ],
                    videoCapabilities: [
                        {
                            contentType: 'video/mp4; codecs="avc1.42E01E"'
                        }
                    ]
                }, b.m(2), b.g(navigator.requestMediaKeySystemAccess("com.apple.fps", [
                    a
                ]), 4);
                if (b.h != 2) return b.return(!0);
                b.l();
                return b.return(!1);
            });
        };
        function lo(a, b, c) {
            c = c === void 0 ? !0 : c;
            this.h = a;
            this.g = new Set([
                a
            ]);
            b = b || [];
            a = u(b);
            for(b = a.next(); !b.done; b = a.next())this.add(b.value, c);
        }
        lo.prototype.add = function(a, b) {
            var c = this.h;
            b = b === void 0 ? !0 : b;
            var d;
            if (!(d = !!c.audio != !!a.audio || !!c.video != !!a.video || c.language != a.language) && (d = c.audio && a.audio)) {
                d = c.audio;
                var e = a.audio;
                d = !(!((!d.channelsCount || !e.channelsCount || d.channelsCount > 2 || e.channelsCount > 2) && d.channelsCount != e.channelsCount || d.spatialAudio !== e.spatialAudio || b && !mo(d, e)) && bd(d.roles, e.roles) && d.groupId === e.groupId);
            }
            !d && (d = c.video && a.video) && (c = c.video, d = a.video, d = !((!b || mo(c, d)) && bd(c.roles, d.roles)));
            return d ? !1 : (this.g.add(a), !0);
        };
        lo.prototype.values = function() {
            return this.g.values();
        };
        function mo(a, b) {
            if (a.mimeType != b.mimeType) return !1;
            a = a.codecs.split(",").map(function(c) {
                return Ef(c);
            });
            b = b.codecs.split(",").map(function(c) {
                return Ef(c);
            });
            return bd(a, b);
        }
        O("shaka.media.AdaptationSet", lo);
        function no() {
            this.h = this.g = null;
        }
        no.prototype.configure = function(a) {
            this.g = a;
        };
        no.prototype.getConfiguration = function() {
            return this.g;
        };
        no.prototype.create = function(a) {
            var b;
            if (this.g.language) {
                var c = oo(a, this.g.language);
                c.length && (b = c);
            }
            b || (b = a.filter(function(f) {
                return f.primary;
            }), b = b.length ? b : a);
            a = po(b, this.g.role);
            a.length && (b = a);
            a = qo(b, this.g.videoRole);
            a.length && (b = a);
            this.g.videoLayout && (a = ro(b, this.g.videoLayout), a.length && (b = a));
            this.g.hdrLevel && (a = so(b, this.g.hdrLevel), a.length && (b = a));
            var d = [
                this.g.channelCount,
                this.g.preferredAudioChannelCount
            ];
            a = d.filter(function(f, g) {
                return f && d.indexOf(f) === g;
            });
            if (a.length) {
                for(a = u(a), c = a.next(); !c.done; c = a.next())if (c = to(b, c.value), c.length) {
                    b = c;
                    break;
                }
            }
            this.g.audioLabel && (a = uo(b, this.g.audioLabel), a.length && (b = a));
            this.g.videoLabel && (a = vo(b, this.g.videoLabel), a.length && (b = a));
            a = wo(b, this.g.spatialAudio);
            a.length && (b = a);
            var e = [
                this.g.audioCodec,
                this.g.activeAudioCodec
            ].concat(G(this.g.preferredAudioCodecs));
            a = e.filter(function(f, g) {
                return f && e.indexOf(f) === g;
            });
            if (a.length) {
                for(a = u(a), c = a.next(); !c.done; c = a.next())if (c = xo(b, c.value), c.length) {
                    b = c;
                    break;
                }
            }
            a = Xb();
            a = this.g.codecSwitchingStrategy == "smooth" && a.Bb();
            return this.h = new lo(b[0], b, !a);
        };
        no.prototype.getLastAdaptationSet = function() {
            return this.h;
        };
        function oo(a, b) {
            b = Kc(b);
            var c = Sc(b, a.map(function(d) {
                return Rc(d);
            }));
            return c ? a.filter(function(d) {
                return c == Rc(d);
            }) : [];
        }
        function po(a, b) {
            return a.filter(function(c) {
                return c.audio ? b ? c.audio.roles.includes(b) : c.audio.roles.length == 0 : !1;
            });
        }
        function qo(a, b) {
            return a.filter(function(c) {
                return c.video ? b ? c.video.roles.includes(b) : c.video.roles.length == 0 : !1;
            });
        }
        function uo(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.label ? c.audio.label.toLowerCase() == b.toLowerCase() : !1;
            });
        }
        function vo(a, b) {
            return a.filter(function(c) {
                return c.video && c.video.label ? c.video.label.toLowerCase() == b.toLowerCase() : !1;
            });
        }
        function to(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.channelsCount && c.audio.channelsCount > b ? !1 : !0;
            }).sort(function(c, d) {
                return c.audio || d.audio ? c.audio ? d.audio ? (d.audio.channelsCount || 0) - (c.audio.channelsCount || 0) : 1 : -1 : 0;
            });
        }
        function so(a, b) {
            if (b == "AUTO") {
                var c = a.some(function(d) {
                    return d.video && d.video.hdr && d.video.hdr == "HLG" ? !0 : !1;
                });
                b = Xb().Dd(c);
            }
            return a.filter(function(d) {
                return d.video && d.video.hdr && d.video.hdr != b ? !1 : !0;
            });
        }
        function ro(a, b) {
            return a.filter(function(c) {
                return c.video && c.video.videoLayout && c.video.videoLayout != b ? !1 : !0;
            });
        }
        function wo(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.spatialAudio != b ? !1 : !0;
            });
        }
        function xo(a, b) {
            return a.filter(function(c) {
                return c.audio && c.audio.codecs != b ? !1 : !0;
            });
        }
        function yo() {}
        function zo() {
            var a = Infinity, b = Xb();
            navigator.connection && navigator.connection.saveData && (a = 360);
            var c = {
                retryParameters: Wg(),
                servers: {},
                clearKeys: {},
                advanced: {},
                delayLicenseRequestUntilPlayed: !1,
                persistentSessionOnlinePlayback: !1,
                persistentSessionsMetadata: [],
                initDataTransform: function(h, k, l) {
                    "apple" === window1.shakaMediaKeysPolyfill && k == "skd" && (k = l.serverCertificate, l = ho(h), h = io(h, l, k));
                    return h;
                },
                logLicenseExchange: !1,
                updateExpirationTime: 1,
                preferredKeySystems: [],
                keySystemsMapping: {},
                parseInbandPsshEnabled: !1,
                minHdcpVersion: "",
                ignoreDuplicateInitData: !0,
                defaultAudioRobustnessForWidevine: "SW_SECURE_CRYPTO",
                defaultVideoRobustnessForWidevine: "SW_SECURE_DECODE"
            }, d = "reload";
            b.Bb() && (d = "smooth");
            var e = {
                retryParameters: Wg(),
                availabilityWindowOverride: NaN,
                disableAudio: !1,
                disableVideo: !1,
                disableText: !1,
                disableThumbnails: !1,
                disableIFrames: !1,
                defaultPresentationDelay: 0,
                segmentRelativeVttTiming: !1,
                raiseFatalErrorOnManifestUpdateRequestFailure: !1,
                continueLoadingWhenPaused: !0,
                ignoreSupplementalCodecs: !1,
                updatePeriod: -1,
                ignoreDrmInfo: !1,
                enableAudioGroups: !0,
                dash: {
                    clockSyncUri: "",
                    disableXlinkProcessing: !0,
                    xlinkFailGracefully: !1,
                    ignoreMinBufferTime: !1,
                    autoCorrectDrift: !0,
                    initialSegmentLimit: 1E3,
                    ignoreSuggestedPresentationDelay: !1,
                    ignoreEmptyAdaptationSet: !1,
                    ignoreMaxSegmentDuration: !1,
                    keySystemsByURI: {
                        "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
                        "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e": "org.w3.clearkey",
                        "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
                        "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                        "urn:uuid:79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready",
                        "urn:uuid:94ce86fb-07ff-4f43-adb8-93d2fa968ca2": "com.apple.fps",
                        "urn:uuid:3d5e6d35-9b9a-41e8-b843-dd3c6e72c42c": "com.huawei.wiseplay"
                    },
                    manifestPreprocessor: Ao,
                    manifestPreprocessorTXml: Bo,
                    sequenceMode: !1,
                    useStreamOnceInPeriodFlattening: !1,
                    enableFastSwitching: !0
                },
                hls: {
                    ignoreTextStreamFailures: !1,
                    ignoreImageStreamFailures: !1,
                    defaultAudioCodec: "mp4a.40.2",
                    defaultVideoCodec: "avc1.42E01E",
                    ignoreManifestProgramDateTime: !1,
                    ignoreManifestProgramDateTimeForTypes: [],
                    mediaPlaylistFullMimeType: 'video/mp2t; codecs="avc1.42E01E, mp4a.40.2"',
                    liveSegmentsDelay: 3,
                    sequenceMode: b.pd(),
                    ignoreManifestTimestampsInSegmentsMode: !1,
                    disableCodecGuessing: !1,
                    disableClosedCaptionsDetection: !1,
                    allowLowLatencyByteRangeOptimization: !0,
                    allowRangeRequestsToGuessMimeType: !1
                },
                mss: {
                    manifestPreprocessor: Ao,
                    manifestPreprocessorTXml: Bo,
                    sequenceMode: !1,
                    keySystemsBySystemId: {
                        "9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                        "79f0049a-4098-8642-ab92-e65be0885f95": "com.microsoft.playready"
                    }
                }
            }, f = {
                trackSelectionCallback: function(h) {
                    return H(function(k) {
                        return k.return(h);
                    });
                },
                downloadSizeCallback: function(h) {
                    var k;
                    return H(function(l) {
                        if (l.h == 1) return navigator.storage && navigator.storage.estimate ? l.g(navigator.storage.estimate(), 3) : l.return(!0);
                        k = l.i;
                        return l.return(k.usage + h < k.quota * .95);
                    });
                },
                progressCallback: function(h, k) {
                    return eo([
                        h,
                        k
                    ]);
                },
                usePersistentLicense: !0,
                numberOfParallelDownloads: 5
            }, g = {
                drm: c,
                manifest: e,
                streaming: {
                    retryParameters: Wg(),
                    failureCallback: function(h) {
                        return eo([
                            h
                        ]);
                    },
                    rebufferingGoal: 0,
                    bufferingGoal: 10,
                    bufferBehind: 30,
                    evictionGoal: 1,
                    ignoreTextStreamFailures: !1,
                    alwaysStreamText: !1,
                    startAtSegmentBoundary: !1,
                    gapDetectionThreshold: .5,
                    gapPadding: 0,
                    gapJumpTimerTime: .25,
                    durationBackoff: 1,
                    safeSeekOffset: 5,
                    safeSeekEndOffset: 0,
                    stallEnabled: !0,
                    stallThreshold: 1,
                    stallSkip: .1,
                    useNativeHlsForFairPlay: !0,
                    inaccurateManifestTolerance: 2,
                    lowLatencyMode: !0,
                    preferNativeDash: !1,
                    preferNativeHls: !1,
                    updateIntervalSeconds: 1,
                    observeQualityChanges: !1,
                    maxDisabledTime: 30,
                    segmentPrefetchLimit: 1,
                    prefetchAudioLanguages: [],
                    disableAudioPrefetch: !1,
                    disableTextPrefetch: !1,
                    disableVideoPrefetch: !1,
                    liveSync: {
                        enabled: !1,
                        targetLatency: .5,
                        targetLatencyTolerance: .5,
                        maxPlaybackRate: 1.1,
                        minPlaybackRate: .95,
                        panicMode: !1,
                        panicThreshold: 60,
                        dynamicTargetLatency: {
                            enabled: !1,
                            stabilityThreshold: 60,
                            rebufferIncrement: .5,
                            maxAttempts: 10,
                            maxLatency: 4,
                            minLatency: 1
                        }
                    },
                    allowMediaSourceRecoveries: !0,
                    minTimeBetweenRecoveries: 5,
                    vodDynamicPlaybackRate: !1,
                    vodDynamicPlaybackRateLowBufferRate: .95,
                    vodDynamicPlaybackRateBufferRatio: .5,
                    preloadNextUrlWindow: 30,
                    loadTimeout: 30,
                    clearDecodingCache: !1,
                    dontChooseCodecs: !1,
                    shouldFixTimestampOffset: !1,
                    avoidEvictionOnQuotaExceededError: !1,
                    crossBoundaryStrategy: "keep",
                    returnToEndOfLiveWindowWhenOutside: !1
                },
                networking: {
                    forceHTTP: !1,
                    forceHTTPS: !1,
                    minBytesForProgressEvents: 16E3
                },
                mediaSource: {
                    codecSwitchingStrategy: d,
                    addExtraFeaturesToSourceBuffer: function(h) {
                        return eo([
                            h
                        ], "");
                    },
                    forceTransmux: !1,
                    insertFakeEncryptionInInit: !0,
                    correctEc3Enca: !1,
                    modifyCueCallback: function(h, k, l) {
                        return eo([
                            h,
                            k,
                            l
                        ]);
                    },
                    dispatchAllEmsgBoxes: !1,
                    useSourceElements: !0,
                    durationReductionEmitsUpdateEnd: !0
                },
                offline: f,
                abrFactory: function() {
                    return new Qg;
                },
                adaptationSetCriteriaFactory: function() {
                    return new (Function.prototype.bind.apply(no, [
                        null
                    ].concat(G(Ma.apply(0, arguments)))));
                },
                abr: {
                    enabled: !0,
                    useNetworkInformation: !0,
                    defaultBandwidthEstimate: 1E6,
                    switchInterval: 8,
                    bandwidthUpgradeTarget: .85,
                    bandwidthDowngradeTarget: .95,
                    restrictions: {
                        minWidth: 0,
                        maxWidth: Infinity,
                        minHeight: 0,
                        maxHeight: a,
                        minPixels: 0,
                        maxPixels: Infinity,
                        minFrameRate: 0,
                        maxFrameRate: Infinity,
                        minBandwidth: 0,
                        maxBandwidth: Infinity,
                        minChannelsCount: 0,
                        maxChannelsCount: Infinity
                    },
                    advanced: {
                        minTotalBytes: 128E3,
                        minBytes: 16E3,
                        fastHalfLife: 2,
                        slowHalfLife: 5
                    },
                    restrictToElementSize: !1,
                    restrictToScreenSize: !1,
                    ignoreDevicePixelRatio: !1,
                    clearBufferSwitch: !1,
                    safeMarginSwitch: 0,
                    cacheLoadThreshold: 5,
                    minTimeToSwitch: 0,
                    preferNetworkInformationBandwidth: !1,
                    removeLatencyFromFirstPacketTime: !1
                },
                autoShowText: 3,
                preferredAudioLanguage: "",
                preferredAudioLabel: "",
                preferredTextLanguage: "",
                preferredAudioRole: "",
                preferredVideoRole: "",
                preferredTextRole: "",
                preferredAudioChannelCount: 2,
                preferredVideoHdrLevel: "AUTO",
                preferredVideoLayout: "",
                preferredVideoLabel: "",
                preferredVideoCodecs: [],
                preferredAudioCodecs: [],
                preferredTextFormats: [],
                preferForcedSubs: !1,
                preferSpatialAudio: !1,
                preferredDecodingAttributes: [],
                restrictions: {
                    minWidth: 0,
                    maxWidth: Infinity,
                    minHeight: 0,
                    maxHeight: Infinity,
                    minPixels: 0,
                    maxPixels: Infinity,
                    minFrameRate: 0,
                    maxFrameRate: Infinity,
                    minBandwidth: 0,
                    maxBandwidth: Infinity,
                    minChannelsCount: 0,
                    maxChannelsCount: Infinity
                },
                playRangeStart: 0,
                playRangeEnd: Infinity,
                textDisplayer: {
                    captionsUpdatePeriod: .25,
                    fontScaleFactor: 1
                },
                textDisplayFactory: function() {
                    return null;
                },
                cmcd: {
                    enabled: !1,
                    sessionId: "",
                    contentId: "",
                    rtpSafetyFactor: 5,
                    useHeaders: !1,
                    includeKeys: [],
                    version: 1,
                    targets: []
                },
                cmsd: {
                    enabled: !0,
                    applyMaximumSuggestedBitrate: !0,
                    estimatedThroughputWeightRatio: .5
                },
                lcevc: {
                    enabled: !1,
                    dynamicPerformanceScaling: !0,
                    logLevel: 0,
                    drawLogo: !1,
                    poster: !0
                },
                ads: {
                    customPlayheadTracker: !1,
                    skipPlayDetection: !1,
                    supportsMultipleMediaElements: !0,
                    disableHLSInterstitial: !1,
                    disableDASHInterstitial: !1,
                    allowPreloadOnDomElements: !0,
                    allowStartInMiddleOfInterstitial: !0
                },
                ignoreHardwareResolution: !1,
                queue: {
                    preloadNextUrlWindow: Infinity,
                    preloadPrevItem: !0,
                    repeatMode: 0
                }
            };
            f.trackSelectionCallback = function(h) {
                return H(function(k) {
                    return k.return(Co(h, g.preferredAudioLanguage, g.preferredVideoHdrLevel));
                });
            };
            return b.cb(g);
        }
        function Do() {
            return {
                streaming: {
                    inaccurateManifestTolerance: 0,
                    segmentPrefetchLimit: 2,
                    updateIntervalSeconds: .1,
                    maxDisabledTime: 1,
                    retryParameters: {
                        baseDelay: 100
                    }
                },
                manifest: {
                    dash: {
                        autoCorrectDrift: !1
                    },
                    retryParameters: {
                        baseDelay: 100
                    }
                },
                drm: {
                    retryParameters: {
                        baseDelay: 100
                    }
                }
            };
        }
        function Eo(a, b, c) {
            var d = {
                ".drm.keySystemsMapping": "",
                ".drm.servers": "",
                ".drm.clearKeys": "",
                ".drm.advanced": {
                    distinctiveIdentifierRequired: !1,
                    persistentStateRequired: !1,
                    videoRobustness: [],
                    audioRobustness: [],
                    sessionType: "",
                    serverCertificate: new Uint8Array(0),
                    serverCertificateUri: "",
                    individualizationServer: "",
                    headers: {}
                }
            };
            return bo(a, b, c || zo(), d, "");
        }
        function Co(a, b, c) {
            var d = c;
            d == "AUTO" && (c = a.some(function(h) {
                return h.hdr && h.hdr == "HLG" ? !0 : !1;
            }), d = Xb().Dd(c));
            var e = a.filter(function(h) {
                return h.type != "variant" || h.hdr && h.hdr != d ? !1 : !0;
            });
            c = [];
            var f = Sc(b, e.map(function(h) {
                return h.language;
            }));
            f && (c = e.filter(function(h) {
                return Kc(h.language) == f;
            }));
            c.length == 0 && (c = e.filter(function(h) {
                return h.primary;
            }));
            c.length == 0 && (e.map(function(h) {
                return h.language;
            }), c = e);
            var g = c.filter(function(h) {
                return h.height && h.height <= 480;
            });
            g.length && (g.sort(function(h, k) {
                return k.height - h.height;
            }), c = g.filter(function(h) {
                return h.height == g[0].height;
            }));
            b = [];
            c.length && (e = Math.floor(c.length / 2), c.sort(function(h, k) {
                return h.bandwidth - k.bandwidth;
            }), b.push(c[e]));
            a = u(a);
            for(c = a.next(); !c.done; c = a.next())c = c.value, c.type != Ec && c.type != "image" || b.push(c);
            return b;
        }
        function Ao(a) {
            return eo([
                a
            ], a);
        }
        function Bo(a) {
            return eo([
                a
            ], a);
        }
        O("shaka.util.PlayerConfiguration", yo);
        yo.mergeConfigObjects = Eo;
        yo.createDefaultForLL = Do;
        yo.createDefault = zo;
        function Fo() {
            this.g = null;
            this.h = [];
        }
        function Go(a, b) {
            var c = 0;
            a.g && a.g.state == b && (c += a.g.duration);
            a = u(a.h);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, c += d.state == b ? d.duration : 0;
            return c;
        }
        function Ho(a) {
            function b(f) {
                return {
                    timestamp: f.timestamp,
                    state: f.state,
                    duration: f.duration
                };
            }
            for(var c = [], d = u(a.h), e = d.next(); !e.done; e = d.next())c.push(b(e.value));
            a.g && c.push(b(a.g));
            return c;
        }
        function Io() {
            this.i = this.h = null;
            this.g = [];
        }
        function Jo(a, b, c) {
            a.i != b && (a.i = b, a.g.push({
                timestamp: Date.now() / 1E3,
                id: b.id,
                type: "text",
                fromAdaptation: c,
                bandwidth: null
            }));
        }
        function Ko() {
            this.D = this.V = NaN;
            this.l = "";
            this.j = this.nj = this.A = this.C = this.K = this.F = this.o = this.m = this.J = this.G = this.i = this.R = this.S = this.M = this.O = this.P = NaN;
            this.L = 0;
            this.H = this.I = NaN;
            this.g = new Fo;
            this.h = new Io;
        }
        function Lo(a, b, c) {
            a.P = b;
            a.O = c;
        }
        function Mo(a, b, c) {
            a.V = b;
            a.D = c;
        }
        function No(a, b) {
            a.i = isNaN(a.i) ? b : Math.max(a.i, b);
        }
        function Oo(a, b) {
            b >= 0 && (a.o = b);
        }
        function Po(a, b) {
            b >= 0 && (a.F = b);
        }
        function Qo(a, b) {
            b >= 0 && (a.K = b);
        }
        function Ro(a, b) {
            a.j = isNaN(a.j) ? b : a.j + b;
        }
        function So(a) {
            var b = a.V, c = a.D, d = a.l, e = a.C, f = a.O, g = a.P, h = a.M, k = a.S, l = a.R, m = a.A, n = a.i, q = a.G, r = a.J, t = a.m, v = Go(a.g, "playing"), w = Go(a.g, "paused"), x = Go(a.g, "buffering"), y = a.o, z = a.F, A = a.K, E = a.nj, C = a.j, D = a.L, B = a.I, J = a.H, F = Ho(a.g), I = [];
            a = u(a.h.g);
            for(var K = a.next(); !K.done; K = a.next())K = K.value, I.push({
                timestamp: K.timestamp,
                id: K.id,
                type: K.type,
                fromAdaptation: K.fromAdaptation,
                bandwidth: K.bandwidth
            });
            return {
                width: b,
                height: c,
                currentCodecs: d,
                streamBandwidth: e,
                decodedFrames: f,
                droppedFrames: g,
                corruptedFrames: h,
                stallsDetected: k,
                gapsJumped: l,
                estimatedBandwidth: m,
                completionPercent: n,
                loadLatency: q,
                manifestTimeSeconds: r,
                drmTimeSeconds: t,
                playTime: v,
                pauseTime: w,
                bufferingTime: x,
                licenseTime: y,
                liveLatency: z,
                maxSegmentDuration: A,
                manifestSizeBytes: E,
                bytesDownloaded: C,
                nonFatalErrorCount: D,
                manifestPeriodCount: B,
                manifestGapCount: J,
                stateHistory: F,
                switchHistory: I
            };
        }
        function To(a, b, c, d) {
            fb.call(this);
            this.M = a;
            this.S = b;
            this.ya = d.networkingEngine;
            this.o = c;
            this.D = null;
            this.va = 0;
            this.Ia = d.wd;
            this.G = d.Ol;
            this.Oa = d.Pl;
            this.g = d.config;
            this.m = this.H = this.h = null;
            this.ba = !1;
            this.I = d.bm;
            this.na = !1;
            this.j = null;
            this.X = !1;
            this.A = null;
            this.L = new Map;
            this.ua = !1;
            this.Ga = d.am;
            this.V = new Ko;
            this.$ = new Yg;
            this.C = new Yg;
            this.O = null;
            this.l = !1;
            this.W = d.rk;
            this.R = this.i = null;
            this.P = !1;
            this.K = [];
            this.J = [];
            this.F = !0;
        }
        oa(To, fb);
        function Uo(a, b, c) {
            (a = b ? a.J : a.K) ? a.push(c) : c();
        }
        function Vo(a) {
            if (a.J) for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c = c.value, c();
            a.J = null;
        }
        function Wo(a, b) {
            a.O = b;
            a.P = !0;
            if (a.K) {
                b = u(a.K);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, c();
            }
            a.K = null;
        }
        p = To.prototype;
        p.getStartTime = function() {
            return this.o;
        };
        p.dd = function() {
            return this.M;
        };
        p.sh = function() {
            return this.h;
        };
        function Xo(a) {
            a.na = !0;
            return a.I;
        }
        p.getStats = function() {
            return this.V;
        };
        function Yo(a) {
            a.X = !0;
            return a.j;
        }
        p.fl = function() {
            return this.i ? wg(this.i) : null;
        };
        p.cl = function() {
            return this.R ? xg(this.R) : null;
        };
        function Zo(a) {
            a.ua = !0;
            return a.L;
        }
        p.start = function() {
            var a = this;
            (function() {
                var b;
                return H(function(c) {
                    switch(c.h){
                        case 1:
                            return c.g(Promise.resolve(), 2);
                        case 2:
                            return c.m(3), c.g($o(a), 5);
                        case 5:
                            ap(a);
                            if ("webkit" === window1.shakaMediaKeysPolyfill) {
                                c.B(6);
                                break;
                            }
                            return c.g(bp(a), 7);
                        case 7:
                            ap(a);
                        case 6:
                            return c.g(cp(a), 8);
                        case 8:
                            ap(a);
                            if (!a.W) {
                                c.B(9);
                                break;
                            }
                            return c.g(dp(a), 10);
                        case 10:
                            ap(a);
                        case 9:
                            if (!a.W || !a.j) {
                                c.B(11);
                                break;
                            }
                            return c.g(yi(a.j), 12);
                        case 12:
                            ap(a);
                        case 11:
                            a.C.resolve();
                            c.o(0);
                            break;
                        case 3:
                            b = c.l(), b instanceof T && (b.code == 7001 || b.code == 7003) || a.C.reject(b), c.j();
                    }
                });
            })();
        };
        p.dispatchEvent = function(a) {
            return this.O ? this.O.dispatchEvent(a) : fb.prototype.dispatchEvent.call(this, a);
        };
        p.onError = function(a) {
            a.severity === 2 && (this.C.reject(a), this.destroy());
            var b = (new Map).set("detail", a);
            b = new R("error", b);
            this.dispatchEvent(b);
            b.defaultPrevented && (a.handled = !0);
        };
        function ap(a) {
            if (a.l) throw new T(2, 7, 7003);
        }
        function ep(a, b) {
            a.dispatchEvent(new R("onstatechange", (new Map).set("state", b)));
        }
        function $o(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                switch(h.h){
                    case 1:
                        ep(a, "manifest-parser");
                        a.m || (a.H = Cd(a.M, a.S), a.m = a.H(), a.m.configure(a.g.manifest, function() {
                            return a.F;
                        }));
                        b = Date.now() / 1E3;
                        ep(a, "manifest");
                        if (a.h) {
                            h.B(2);
                            break;
                        }
                        return h.g(a.m.start(a.M, a.Oa), 3);
                    case 3:
                        return a.h = h.i, fp(a.h), h.g(gp(a), 2);
                    case 2:
                        return a.$.resolve(), c = new R("manifestparsed", void 0), h.g(Promise.resolve(), 5);
                    case 5:
                        a.dispatchEvent(c);
                        if (a.h.variants.length == 0) throw new T(2, 4, 4036);
                        fp(a.h);
                        d = Oi(a.G, a.h);
                        if (!d) {
                            h.B(6);
                            break;
                        }
                        e = new R("trackschanged", void 0);
                        return h.g(Promise.resolve(), 7);
                    case 7:
                        ap(a), a.dispatchEvent(e);
                    case 6:
                        f = Date.now() / 1E3, g = f - b, g >= 0 && (a.V.J = g), h.j();
                }
            });
        }
        function bp(a, b) {
            var c, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        if (!a.h || a.j) return g.return();
                        ep(a, "drm-engine");
                        a.va = Date.now() / 1E3;
                        a.j = a.Ia();
                        a.G.g = a.j;
                        a.j.configure(a.g.drm, function() {
                            return a.F;
                        });
                        c = Fg(a.h.variants);
                        d = !0;
                        a.h && a.h.presentationTimeline && (d = a.h.presentationTimeline.U());
                        return g.g(Vh(a.j, c, a.h.offlineSessionIds, d), 2);
                    case 2:
                        ap(a);
                        if (!b) {
                            g.B(3);
                            break;
                        }
                        return g.g(a.j.Ob(b), 4);
                    case 4:
                        ap(a);
                    case 3:
                        return g.g(Mi(a.G, a.h), 5);
                    case 5:
                        e = g.i;
                        if (!e) {
                            g.B(0);
                            break;
                        }
                        f = new R("trackschanged", void 0);
                        return g.g(Promise.resolve(), 7);
                    case 7:
                        a.dispatchEvent(f), g.j();
                }
            });
        }
        p.configure = function(a, b) {
            a = co(a, b);
            Eo(this.g, a);
        };
        p.getConfiguration = function() {
            return Xd(this.g);
        };
        function gp(a) {
            return H(function(b) {
                a.D || (a.D = a.g.adaptationSetCriteriaFactory(), a.D.configure({
                    language: a.g.preferredAudioLanguage,
                    role: a.g.preferredAudioRole,
                    videoRole: a.g.preferredVideoRole,
                    channelCount: 0,
                    hdrLevel: a.g.preferredVideoHdrLevel,
                    spatialAudio: a.g.preferSpatialAudio,
                    videoLayout: a.g.preferredVideoLayout,
                    audioLabel: a.g.preferredAudioLabel,
                    videoLabel: a.g.preferredVideoLabel,
                    codecSwitchingStrategy: a.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: "",
                    activeAudioCodec: "",
                    activeAudioChannelCount: 0,
                    preferredAudioCodecs: a.g.preferredAudioCodecs,
                    preferredAudioChannelCount: a.g.preferredAudioChannelCount
                }));
                if (a.i || !a.h.variants.length || a.h.variants.length != 1 && a.h.type != "HLS") return b.B(0);
                a.i = hp(a);
                return a.i ? b.g(ip(a.i), 0) : b.B(0);
            });
        }
        function cp(a) {
            return H(function(b) {
                if (b.h == 1) return !a.i || a.h.variants.includes(a.i) ? b.B(0) : b.g(jp(a.i), 3);
                a.i = hp(a);
                return a.i ? b.g(ip(a.i), 0) : b.B(0);
            });
        }
        function dp(a) {
            var b, c, d, e, f;
            return H(function(g) {
                !a.i && (b = hp(a)) && (a.i = b);
                if (!a.i) return g.B(0);
                c = a.h.presentationTimeline.U();
                d = [];
                e = a.i;
                e.video && d.push(kp(a, e.video, c));
                e.audio && d.push(kp(a, e.audio, c));
                (f = Gg(a.h.textStreams, a.g.preferredTextLanguage, a.g.preferredTextRole, a.g.preferForcedSubs)[0] || null) && Og(e.audio, f, a.g) && (d.push(kp(a, f, c)), a.R = f);
                return g.g(Promise.all(d), 0);
            });
        }
        function hp(a) {
            if (!a.A) {
                var b = a.g.abrFactory;
                a.A = b();
                a.A.configure(a.g.abr);
            }
            b = Fg(a.h.variants);
            b = a.D.create(b);
            a.A.setVariants(Array.from(b.values()));
            return a.A.chooseVariant(!0);
        }
        function kp(a, b, c) {
            var d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) return d = a.g.streaming.segmentPrefetchLimit || 2, e = new Om(d, b, function(l, m, n) {
                    return Jn(l, m, n || null, a.g.streaming.retryParameters, a.ya, a.F);
                }, !1), a.L.set(b.id, e), b.segmentIndex ? k.B(2) : k.g(b.createSegmentIndex(), 2);
                f = typeof a.o === "number" ? a.o : 0;
                g = b.segmentIndex.ac(f);
                h = null;
                g && (h = g.current(), h || (h = g.next().value));
                h || (h = b.segmentIndex.Fb());
                return h ? c ? h.ia ? k.g(Rm(e, h.ia), 0) : k.B(0) : k.g(Qm(e, h.startTime), 0) : k.B(0);
            });
        }
        function ip(a) {
            var b, c, d, e;
            return H(function(f) {
                b = [];
                c = u([
                    a.video,
                    a.audio
                ]);
                for(d = c.next(); !d.done; d = c.next())(e = d.value) && !e.segmentIndex && b.push(e.createSegmentIndex());
                return b.length > 0 ? f.g(Promise.all(b), 0) : f.B(0);
            });
        }
        function jp(a) {
            var b, c, d, e;
            return H(function(f) {
                b = [];
                c = u([
                    a.video,
                    a.audio
                ]);
                for(d = c.next(); !d.done; d = c.next())(e = d.value) && e.segmentIndex && e.closeSegmentIndex && b.push(e.closeSegmentIndex());
                return b.length > 0 ? f.g(Promise.all(b), 0) : f.B(0);
            });
        }
        p.Hm = function() {
            return this.C;
        };
        p.destroy = function() {
            var a = this, b, c, d;
            return H(function(e) {
                if (e.h == 1) return a.l = !0, !a.m || a.ba ? e.B(2) : e.g(a.m.stop(), 2);
                if (e.h != 4) return a.A && a.A.release(), a.I && !a.na && a.I.release(), !a.j || a.X ? e.B(4) : e.g(a.j.destroy(), 4);
                if (a.L.size > 0 && !a.ua) for(b = u(a.L.values()), c = b.next(); !c.done; c = b.next())d = c.value, Xm(d);
                e.j();
            });
        };
        function fp(a) {
            function b(c) {
                return c.video && c.audio || c.video && c.video.codecs.includes(",");
            }
            a.variants.some(b) && (a.variants = a.variants.filter(b));
        }
        O("shaka.media.PreloadManager", To);
        To.prototype.destroy = To.prototype.destroy;
        To.prototype.waitForFinish = To.prototype.Hm;
        To.prototype.getPrefetchedTextTrack = To.prototype.cl;
        To.prototype.getPrefetchedVariantTrack = To.prototype.fl;
        function mp(a, b) {
            fb.call(this);
            var c = this;
            this.i = a;
            this.l = b;
            this.g = new Map;
            this.m = [
                {
                    td: null,
                    sd: np,
                    ed: function(d, e) {
                        return op(c, "enter", d, e);
                    }
                },
                {
                    td: pp,
                    sd: np,
                    ed: function(d, e) {
                        return op(c, "enter", d, e);
                    }
                },
                {
                    td: qp,
                    sd: np,
                    ed: function(d, e) {
                        return op(c, "enter", d, e);
                    }
                },
                {
                    td: np,
                    sd: pp,
                    ed: function(d, e) {
                        return op(c, "exit", d, e);
                    }
                },
                {
                    td: np,
                    sd: qp,
                    ed: function(d, e) {
                        return op(c, "exit", d, e);
                    }
                },
                {
                    td: pp,
                    sd: qp,
                    ed: function(d, e) {
                        e ? op(c, "skip", d, e) : (op(c, "enter", d, e), op(c, "exit", d, e));
                    }
                },
                {
                    td: qp,
                    sd: pp,
                    ed: function(d, e) {
                        return op(c, "skip", d, e);
                    }
                }
            ];
            this.h = new fd;
            this.h.u(this.i, "regionremove", function(d) {
                c.g.delete(d.region);
            });
        }
        oa(mp, fb);
        mp.prototype.release = function() {
            this.i = null;
            this.g.clear();
            this.h.release();
            this.h = null;
            fb.prototype.release.call(this);
        };
        mp.prototype.j = function(a, b) {
            if (!this.l || a != 0) {
                this.l = !1;
                for(var c = u(this.i.h.values()), d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = this.g.get(d), f = a < d.startTime ? pp : a > d.endTime ? qp : np;
                    this.g.set(d, f);
                    for(var g = u(this.m), h = g.next(); !h.done; h = g.next())h = h.value, h.td == e && h.sd == f && h.ed(d, b);
                }
            }
        };
        function op(a, b, c, d) {
            b = new R(b, new Map([
                [
                    "region",
                    c
                ],
                [
                    "seeking",
                    d
                ]
            ]));
            a.dispatchEvent(b);
        }
        var pp = 1, np = 2, qp = 3; /*
 @license
 Copyright 2013 Ali Al Dallal

 Licensed under the MIT license.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ 
        for(var rp = {
            ach: "Lwo",
            ady: "\u0410\u0434\u044b\u0433\u044d\u0431\u0437\u044d",
            af: "Afrikaans",
            "af-NA": "Afrikaans (Namibia)",
            "af-ZA": "Afrikaans (South Africa)",
            ak: "T\u0255\u0265i",
            ar: "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-AR": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-MA": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629",
            "ar-SA": "\u0627\u0644\u0639\u0631\u0628\u064a\u0629 (\u0627\u0644\u0633\u0639\u0648\u062f\u064a\u0629)",
            "ay-BO": "Aymar aru",
            az: "Az\u0259rbaycan dili",
            "az-AZ": "Az\u0259rbaycan dili",
            "be-BY": "\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u043a\u0430\u044f",
            bg: "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
            "bg-BG": "\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438",
            bn: "\u09ac\u09be\u0982\u09b2\u09be",
            "bn-IN": "\u09ac\u09be\u0982\u09b2\u09be (\u09ad\u09be\u09b0\u09a4)",
            "bn-BD": "\u09ac\u09be\u0982\u09b2\u09be(\u09ac\u09be\u0982\u09b2\u09be\u09a6\u09c7\u09b6)",
            "bs-BA": "Bosanski",
            ca: "Catal\u00e0",
            "ca-ES": "Catal\u00e0",
            cak: "Maya Kaqchikel",
            "ck-US": "\u13e3\u13b3\u13a9 (tsalagi)",
            cs: "\u010ce\u0161tina",
            "cs-CZ": "\u010ce\u0161tina",
            cy: "Cymraeg",
            "cy-GB": "Cymraeg",
            da: "Dansk",
            "da-DK": "Dansk",
            de: "Deutsch",
            "de-AT": "Deutsch (\u00d6sterreich)",
            "de-DE": "Deutsch (Deutschland)",
            "de-CH": "Deutsch (Schweiz)",
            dsb: "Dolnoserb\u0161\u0107ina",
            el: "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
            "el-GR": "\u0395\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ac",
            en: "English",
            "en-GB": "English (UK)",
            "en-AU": "English (Australia)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-IN": "English (India)",
            "en-PI": "English (Pirate)",
            "en-UD": "English (Upside Down)",
            "en-US": "English (US)",
            "en-ZA": "English (South Africa)",
            "en@pirate": "English (Pirate)",
            eo: "Esperanto",
            "eo-EO": "Esperanto",
            es: "Espa\u00f1ol",
            "es-AR": "Espa\u00f1ol (Argentine)",
            "es-419": "Espa\u00f1ol (Latinoam\u00e9rica)",
            "es-CL": "Espa\u00f1ol (Chile)",
            "es-CO": "Espa\u00f1ol (Colombia)",
            "es-EC": "Espa\u00f1ol (Ecuador)",
            "es-ES": "Espa\u00f1ol (Espa\u00f1a)",
            "es-LA": "Espa\u00f1ol (Latinoam\u00e9rica)",
            "es-NI": "Espa\u00f1ol (Nicaragua)",
            "es-MX": "Espa\u00f1ol (M\u00e9xico)",
            "es-US": "Espa\u00f1ol (Estados Unidos)",
            "es-VE": "Espa\u00f1ol (Venezuela)",
            et: "eesti keel",
            "et-EE": "Eesti (Estonia)",
            eu: "Euskara",
            "eu-ES": "Euskara",
            fa: "\u0641\u0627\u0631\u0633\u06cc",
            "fa-IR": "\u0641\u0627\u0631\u0633\u06cc",
            "fb-LT": "Leet Speak",
            ff: "Fulah",
            fi: "Suomi",
            "fi-FI": "Suomi",
            "fo-FO": "F\u00f8royskt",
            fr: "Fran\u00e7ais",
            "fr-CA": "Fran\u00e7ais (Canada)",
            "fr-FR": "Fran\u00e7ais (France)",
            "fr-BE": "Fran\u00e7ais (Belgique)",
            "fr-CH": "Fran\u00e7ais (Suisse)",
            "fy-NL": "Frysk",
            ga: "Gaeilge",
            "ga-IE": "Gaeilge (Gaelic)",
            gl: "Galego",
            "gl-ES": "Galego",
            "gn-PY": "Ava\u00f1e'\u1ebd",
            "gu-IN": "\u0a97\u0ac1\u0a9c\u0ab0\u0abe\u0aa4\u0ac0",
            "gx-GR": "\u1f19\u03bb\u03bb\u03b7\u03bd\u03b9\u03ba\u03ae \u1f00\u03c1\u03c7\u03b1\u03af\u03b1",
            he: "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
            "he-IL": "\u05e2\u05d1\u05e8\u05d9\u05ea\u200f",
            hi: "\u0939\u093f\u0928\u094d\u0926\u0940",
            "hi-IN": "\u0939\u093f\u0928\u094d\u0926\u0940",
            hr: "Hrvatski",
            "hr-HR": "Hrvatski",
            hsb: "Hornjoserb\u0161\u0107ina",
            ht: "Krey\u00f2l",
            hu: "Magyar",
            "hu-HU": "Magyar",
            "hy-AM": "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
            id: "Bahasa Indonesia",
            "id-ID": "Bahasa Indonesia",
            is: "\u00cdslenska",
            "is-IS": "\u00cdslenska (Iceland)",
            it: "Italiano",
            "it-IT": "Italiano",
            ja: "\u65e5\u672c\u8a9e",
            "ja-JP": "\u65e5\u672c\u8a9e",
            "jv-ID": "Basa Jawa",
            "ka-GE": "\u10e5\u10d0\u10e0\u10d7\u10e3\u10da\u10d8",
            "kk-KZ": "\u049a\u0430\u0437\u0430\u049b\u0448\u0430",
            km: "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
            "km-KH": "\u1797\u17b6\u179f\u17b6\u1781\u17d2\u1798\u17c2\u179a",
            kab: "Taqbaylit",
            kn: "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1",
            "kn-IN": "\u0c95\u0ca8\u0ccd\u0ca8\u0ca1 (India)",
            ko: "\ud55c\uad6d\uc5b4",
            "ko-KR": "\ud55c\uad6d\uc5b4 (\u97e9\u56fd)",
            ku: "Kurd\u00ee",
            "ku-TR": "Kurd\u00ee",
            la: "Latin",
            "la-VA": "Latin",
            lb: "L\u00ebtzebuergesch",
            "li-NL": "L\u00e8mb\u00f6rgs",
            lt: "Lietuvi\u0173",
            "lt-LT": "Lietuvi\u0173",
            lv: "Latvie\u0161u",
            "lv-LV": "Latvie\u0161u",
            mai: "\u092e\u0948\u0925\u093f\u0932\u0940, \u09ae\u09c8\u09a5\u09bf\u09b2\u09c0",
            "mg-MG": "Malagasy",
            mk: "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438",
            "mk-MK": "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438 (\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0441\u043a\u0438)",
            ml: "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
            "ml-IN": "\u0d2e\u0d32\u0d2f\u0d3e\u0d33\u0d02",
            "mn-MN": "\u041c\u043e\u043d\u0433\u043e\u043b",
            mr: "\u092e\u0930\u093e\u0920\u0940",
            "mr-IN": "\u092e\u0930\u093e\u0920\u0940",
            ms: "Bahasa Melayu",
            "ms-MY": "Bahasa Melayu",
            mt: "Malti",
            "mt-MT": "Malti",
            my: "\u1017\u1019\u102c\u1005\u1000\u102c",
            nb: "Norsk (bokm\u00e5l)",
            "nb-NO": "Norsk (bokm\u00e5l)",
            ne: "\u0928\u0947\u092a\u093e\u0932\u0940",
            "ne-NP": "\u0928\u0947\u092a\u093e\u0932\u0940",
            nl: "Nederlands",
            "nl-BE": "Nederlands (Belgi\u00eb)",
            "nl-NL": "Nederlands (Nederland)",
            "nn-NO": "Norsk (nynorsk)",
            no: "Norsk",
            oc: "Occitan",
            "or-IN": "\u0b13\u0b21\u0b3c\u0b3f\u0b06",
            pa: "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40",
            "pa-IN": "\u0a2a\u0a70\u0a1c\u0a3e\u0a2c\u0a40 (\u0a2d\u0a3e\u0a30\u0a24 \u0a28\u0a42\u0a70)",
            pl: "Polski",
            "pl-PL": "Polski",
            "ps-AF": "\u067e\u069a\u062a\u0648",
            pt: "Portugu\u00eas",
            "pt-BR": "Portugu\u00eas (Brasil)",
            "pt-PT": "Portugu\u00eas (Portugal)",
            "qu-PE": "Qhichwa",
            "rm-CH": "Rumantsch",
            ro: "Rom\u00e2n\u0103",
            "ro-RO": "Rom\u00e2n\u0103",
            ru: "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
            "ru-RU": "\u0420\u0443\u0441\u0441\u043a\u0438\u0439",
            "sa-IN": "\u0938\u0902\u0938\u094d\u0915\u0943\u0924\u092e\u094d",
            "se-NO": "Davvis\u00e1megiella",
            "si-LK": "\u0db4\u0dc5\u0dcf\u0dad",
            sk: "Sloven\u010dina",
            "sk-SK": "Sloven\u010dina (Slovakia)",
            sl: "Sloven\u0161\u010dina",
            "sl-SI": "Sloven\u0161\u010dina",
            "so-SO": "Soomaaliga",
            sq: "Shqip",
            "sq-AL": "Shqip",
            sr: "\u0421\u0440\u043f\u0441\u043a\u0438",
            "sr-RS": "\u0421\u0440\u043f\u0441\u043a\u0438 (Serbia)",
            su: "Basa Sunda",
            sv: "Svenska",
            "sv-SE": "Svenska",
            sw: "Kiswahili",
            "sw-KE": "Kiswahili",
            ta: "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
            "ta-IN": "\u0ba4\u0bae\u0bbf\u0bb4\u0bcd",
            te: "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
            "te-IN": "\u0c24\u0c46\u0c32\u0c41\u0c17\u0c41",
            tg: "\u0437\u0430\u0431\u043e\u0301\u043d\u0438 \u0442\u043e\u04b7\u0438\u043a\u04e3\u0301",
            "tg-TJ": "\u0442\u043e\u04b7\u0438\u043a\u04e3",
            th: "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22",
            "th-TH": "\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22 (\u0e1b\u0e23\u0e30\u0e40\u0e17\u0e28\u0e44\u0e17\u0e22)",
            tl: "Filipino",
            "tl-PH": "Filipino",
            tlh: "tlhIngan-Hol",
            tr: "T\u00fcrk\u00e7e",
            "tr-TR": "T\u00fcrk\u00e7e",
            "tt-RU": "\u0442\u0430\u0442\u0430\u0440\u0447\u0430",
            uk: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
            "uk-UA": "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
            ur: "\u0627\u0631\u062f\u0648",
            "ur-PK": "\u0627\u0631\u062f\u0648",
            uz: "O'zbek",
            "uz-UZ": "O'zbek",
            vi: "Ti\u1ebfng Vi\u1ec7t",
            "vi-VN": "Ti\u1ebfng Vi\u1ec7t",
            "xh-ZA": "isiXhosa",
            yi: "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9",
            "yi-DE": "\u05d9\u05d9\u05b4\u05d3\u05d9\u05e9 (German)",
            zh: "\u4e2d\u6587",
            "zh-HANS": "\u4e2d\u6587\u7b80\u4f53",
            "zh-HANT": "\u4e2d\u6587\u7e41\u9ad4",
            "zh-CN": "\u4e2d\u6587\uff08\u4e2d\u56fd\uff09",
            "zh-HK": "\u4e2d\u6587\uff08\u9999\u6e2f\uff09",
            "zh-SG": "\u4e2d\u6587\uff08\u65b0\u52a0\u5761\uff09",
            "zh-TW": "\u4e2d\u6587\uff08\u53f0\u7063\uff09",
            "zu-ZA": "isiZulu"
        }, sp = u(Object.keys(rp)), tp = sp.next(); !tp.done; tp = sp.next()){
            var up = tp.value;
            rp[up.toLowerCase()] = rp[up];
        }
        function vp(a, b) {
            if (a.lineBreak) return "\n";
            if (a.nestedCues.length) return a.nestedCues.map(function(g) {
                return vp(g, a);
            }).join("");
            if (!a.payload) return a.payload;
            var c = [], d = a.fontWeight >= df, e = a.fontStyle == ef, f = a.textDecoration.includes(ff);
            d && c.push([
                "b"
            ]);
            e && c.push([
                "i"
            ]);
            f && c.push([
                "u"
            ]);
            e = a.color;
            e == "" && b && (e = b.color);
            d = "";
            (e = wp(e)) && (d += "." + e);
            e = a.backgroundColor;
            e == "" && b && (e = b.backgroundColor);
            (b = wp(e)) && (d += ".bg_" + b);
            d && c.push([
                "c",
                d
            ]);
            return c.reduceRight(function(g, h) {
                var k = u(h);
                h = k.next().value;
                k = k.next().value;
                return "<" + h + (k === void 0 ? "" : k) + ">" + g + "</" + h + ">";
            }, a.payload);
        }
        function wp(a) {
            a = a.toLowerCase();
            var b = a.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
            b ? a = "#" + (parseInt(b[1], 10) | 256).toString(16).slice(1) + (parseInt(b[2], 10) | 256).toString(16).slice(1) + (parseInt(b[3], 10) | 256).toString(16).slice(1) : a.startsWith("#") && a.length > 7 && (a = a.slice(0, 7));
            switch(a){
                case "white":
                case "#fff":
                case "#ffffff":
                    return "white";
                case "lime":
                case "#0f0":
                case "#00ff00":
                    return "lime";
                case "cyan":
                case "#0ff":
                case "#00ffff":
                    return "cyan";
                case "red":
                case "#f00":
                case "#ff0000":
                    return "red";
                case "yellow":
                case "#ff0":
                case "#ffff00":
                    return "yellow";
                case "magenta":
                case "#f0f":
                case "#ff00ff":
                    return "magenta";
                case "blue":
                case "#00f":
                case "#0000ff":
                    return "blue";
                case "black":
                case "#000":
                case "#000000":
                    return "black";
            }
            return null;
        }
        function xp(a, b) {
            var c = [];
            a = u(yp(a));
            for(var d = a.next(); !d.done; d = a.next())if (d = d.value, d.isContainer) c.push.apply(c, G(xp(d.nestedCues, d)));
            else {
                var e = d.clone();
                e.nestedCues = [];
                e.payload = vp(d, b);
                c.push(e);
            }
            return c;
        }
        function yp(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(), d = {}; !c.done; d = {
                Qg: void 0
            }, c = a.next())d.Qg = c.value, b.some(function(e) {
                return function(f) {
                    return Ve(e.Qg, f);
                };
            }(d)) || b.push(d.Qg);
            return b;
        }
        function zp(a) {
            function b(d) {
                for(var e = 5381, f = d.length; f;)e = e * 33 ^ d.charCodeAt(--f);
                return (e >>> 0).toString();
            }
            if (a.startTime >= a.endTime) return null;
            var c = new VTTCue(a.startTime, a.endTime, a.payload);
            c.id = b(a.startTime.toString()) + b(a.endTime.toString()) + b(a.payload);
            c.lineAlign = a.lineAlign;
            c.positionAlign = a.positionAlign;
            a.size && (c.size = a.size);
            try {
                c.align = a.textAlign;
            } catch (d) {}
            a.textAlign == "center" && c.align != "center" && (c.align = "middle");
            a.writingMode == "vertical-lr" ? c.vertical = "lr" : a.writingMode == "vertical-rl" && (c.vertical = "rl");
            a.lineInterpretation == 1 && (c.snapToLines = !1);
            a.line != null && (c.line = a.line);
            a.position != null && (c.position = a.position);
            return c;
        }
        function Ap(a, b) {
            var c = xp(b), d = [];
            b = a.cues ? Array.from(a.cues) : [];
            c = u(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                Gd: void 0
            }, e = c.next())f.Gd = e.value, !b.some(function(g) {
                return function(h) {
                    return h.startTime == g.Gd.startTime && h.endTime == g.Gd.endTime && h.text == g.Gd.payload ? !0 : !1;
                };
            }(f)) && f.Gd.payload && (e = zp(f.Gd)) && d.push(e);
            b = d.slice().sort(function(g, h) {
                return g.startTime != h.startTime ? g.startTime - h.startTime : g.endTime != h.endTime ? g.endTime - h.startTime : "line" in VTTCue.prototype ? d.indexOf(h) - d.indexOf(g) : d.indexOf(g) - d.indexOf(h);
            });
            b = u(b);
            for(c = b.next(); !c.done; c = b.next())a.addCue(c.value);
        }
        function Bp(a, b) {
            var c = !1;
            a.mode === "disabled" && (c = !0, a.mode = "hidden");
            for(var d = 0; d < a.cues.length;){
                var e = a.cues[d];
                b(e) ? a.removeCue(e) : d++;
            }
            c && (a.mode = "disabled");
        }
        function Cp(a) {
            var b = this;
            this.i = a;
            this.l = new fd;
            this.j = null;
            this.h = new Map;
            this.g = -1;
            this.A = !1;
            this.m = null;
            this.D = function() {
                var c;
                (c = b.m) == null || c.stop();
                b.m = null;
                b.l.Fa(b.i, "textchanged", b.o);
                b.l.Fa(b.j.textTracks, "change", b.C);
                c = u(b.h.values());
                for(var d = c.next(); !d.done; d = c.next())d.value.remove();
                b.h.clear();
                b.g = -1;
                b.j = null;
            };
            this.o = function() {
                var c = new Map, d = b.i.yc();
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next()){
                    e = e.value;
                    if (b.h.has(e.id)) {
                        var f = b.h.get(e.id);
                        e.active || f.track.mode === "disabled" || (f.track.mode = "disabled");
                        b.h.delete(e.id);
                    } else {
                        var g = f = b.j.ownerDocument.createElement("track");
                        var h = Xb();
                        h = e.forced && h.Ma() === "WEBKIT" ? "forced" : e.kind === "caption" ? "captions" : "subtitles";
                        g.kind = h;
                        g = f;
                        h = void 0;
                        if (e.label) h = e.label;
                        else if (e.language) {
                            if (e.language in rp) h = rp[e.language];
                            else {
                                var k = Pc(e.language);
                                k in rp && (h = rp[k] + " (" + e.language + ")");
                            }
                        }
                        h || (h = e.originalTextId, e.language && e.language !== e.originalTextId && (h += " (" + e.language + ")"));
                        g.label = h;
                        e.language ? e.language in rp ? f.srclang = e.language : (g = Pc(e.language), h = void 0, f.srclang = (h = g) != null ? h : "und") : f.srclang = "und";
                        f.src = "data:,WEBVTT";
                        f.track.mode = "disabled";
                        b.j.appendChild(f);
                    }
                    c.set(e.id, f);
                    e.active && (b.g = e.id);
                }
                d = u(b.h.values());
                for(e = d.next(); !e.done; e = d.next())e.value.remove();
                b.g > -1 && (c.has(b.g) ? (d = c.get(b.g).track, d.mode === "disabled" && (d.mode = b.A ? "showing" : "hidden")) : b.g = -1);
                b.h = c;
            };
            this.C = function() {
                if (!b.m) {
                    var c = b.j;
                    b.m = new Uf(function() {
                        b.m = null;
                        if (b.j === c) {
                            var d = -1, e = !1;
                            if (b.h.has(b.g)) {
                                var f = b.h.get(b.g);
                                f.track.mode === "showing" ? (d = b.g, e = !0) : f.track.mode === "hidden" && (d = b.g);
                            }
                            if (!e) for(e = u(b.h), f = e.next(); !f.done; f = e.next()){
                                var g = u(f.value);
                                f = g.next().value;
                                g = g.next().value;
                                if (g.track.mode === "showing") {
                                    d = f;
                                    break;
                                } else d < 0 && g.track.mode === "hidden" && (d = f);
                            }
                            e = u(b.h);
                            for(f = e.next(); !f.done; f = e.next())g = u(f.value), f = g.next().value, g = g.next().value, f !== d && g.track.mode !== "disabled" && (g.track.mode = "disabled");
                            b.g !== d && (b.g = d, d > -1 && b.i.gg({
                                id: d
                            }));
                            b.i.Xd(d > -1 && b.h.get(d).track.mode === "showing");
                        }
                    }).Z(0);
                }
            };
            this.l.u(a, "loaded", function() {
                return b.enableTextDisplayer();
            });
            this.enableTextDisplayer();
        }
        p = Cp.prototype;
        p.configure = function() {};
        p.remove = function(a, b) {
            if (this.i) this.h.has(this.g) && Bp(this.h.get(this.g).track, function(c) {
                return c.startTime < b && c.endTime > a;
            });
            else return !1;
            return !0;
        };
        p.append = function(a) {
            this.h.has(this.g) && Ap(this.h.get(this.g).track, a);
        };
        p.destroy = function() {
            this.i && (this.j && this.D(), this.i = null);
            var a;
            (a = this.m) == null || a.stop();
            this.m = null;
            var b;
            (b = this.l) == null || b.release();
            this.l = null;
            return Promise.resolve();
        };
        p.isTextVisible = function() {
            return this.A;
        };
        p.setTextVisibility = function(a) {
            this.A = a;
            if (this.h.has(this.g)) {
                var b = this.h.get(this.g).track;
                b.mode !== "disabled" && (a = a ? "showing" : "hidden", b.mode !== a && (b.mode = a));
            } else if (this.i && this.i.xc() === 3) {
                if (b = Array.from(this.i.vf().textTracks).filter(function(d) {
                    return [
                        "captions",
                        "subtitles",
                        "forced"
                    ].includes(d.kind);
                }), a) {
                    a = null;
                    b = u(b);
                    for(var c = b.next(); !c.done; c = b.next())if (c = c.value, c.mode === "showing") {
                        a = null;
                        break;
                    } else a || c.mode !== "hidden" || (a = c);
                    a && (a.mode = "showing");
                } else for(a = u(b), b = a.next(); !b.done; b = a.next())b = b.value, b.mode === "showing" && (b.mode = "hidden");
            }
        };
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {
            !this.j && this.i && this.i.xc() === 2 && (this.j = this.i.vf(), this.l.ra(this.i, "unloading", this.D), this.l.u(this.i, "textchanged", this.o), this.l.u(this.j.textTracks, "change", this.C), this.o());
        };
        O("shaka.text.NativeTextDisplayer", Cp);
        Cp.prototype.enableTextDisplayer = Cp.prototype.enableTextDisplayer;
        Cp.prototype.setTextLanguage = Cp.prototype.setTextLanguage;
        Cp.prototype.setTextVisibility = Cp.prototype.setTextVisibility;
        Cp.prototype.isTextVisible = Cp.prototype.isTextVisible;
        Cp.prototype.destroy = Cp.prototype.destroy;
        Cp.prototype.append = Cp.prototype.append;
        Cp.prototype.remove = Cp.prototype.remove;
        Cp.prototype.configure = Cp.prototype.configure;
        function Dp(a, b) {
            md("SimpleTextDisplayer", "Please migrate to NativeTextDisplayer");
            this.h = a;
            this.i = b;
            this.g = null;
            a = u(Array.from(this.h.textTracks));
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.kind !== "metadata" && b.kind !== "chapters" && (b.mode = "disabled", b.label == this.i && (this.g = b));
            this.g && (this.g.mode = "hidden");
        }
        p = Dp.prototype;
        p.configure = function() {};
        p.remove = function(a, b) {
            if (!this.g) return !1;
            Bp(this.g, function(c) {
                return c.startTime < b && c.endTime > a;
            });
            return !0;
        };
        p.append = function(a) {
            this.g && Ap(this.g, a);
        };
        p.destroy = function() {
            this.g && (Bp(this.g, function() {
                return !0;
            }), this.g.mode = "disabled");
            this.g = this.h = null;
            return Promise.resolve();
        };
        p.isTextVisible = function() {
            return this.g ? this.g.mode == "showing" : !1;
        };
        p.setTextVisibility = function(a) {
            a && !this.g && Ep(this);
            this.g && (this.g.mode = a ? "showing" : "hidden");
        };
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {
            Ep(this);
        };
        function Ep(a) {
            a.h && !a.g && (a.g = a.h.addTextTrack("subtitles", a.i), a.g.mode = "hidden");
        }
        O("shaka.text.SimpleTextDisplayer", Dp);
        Dp.prototype.enableTextDisplayer = Dp.prototype.enableTextDisplayer;
        Dp.prototype.setTextLanguage = Dp.prototype.setTextLanguage;
        Dp.prototype.setTextVisibility = Dp.prototype.setTextVisibility;
        Dp.prototype.isTextVisible = Dp.prototype.isTextVisible;
        Dp.prototype.destroy = Dp.prototype.destroy;
        Dp.prototype.append = Dp.prototype.append;
        Dp.prototype.remove = Dp.prototype.remove;
        Dp.prototype.configure = Dp.prototype.configure;
        function Fp() {}
        p = Fp.prototype;
        p.configure = function() {};
        p.remove = function() {};
        p.append = function() {};
        p.destroy = function() {};
        p.isTextVisible = function() {
            return !1;
        };
        p.setTextVisibility = function() {};
        p.setTextLanguage = function() {};
        p.enableTextDisplayer = function() {};
        O("shaka.text.StubTextDisplayer", Fp);
        Fp.prototype.enableTextDisplayer = Fp.prototype.enableTextDisplayer;
        Fp.prototype.setTextLanguage = Fp.prototype.setTextLanguage;
        Fp.prototype.setTextVisibility = Fp.prototype.setTextVisibility;
        Fp.prototype.isTextVisible = Fp.prototype.isTextVisible;
        Fp.prototype.destroy = Fp.prototype.destroy;
        Fp.prototype.append = Fp.prototype.append;
        Fp.prototype.remove = Fp.prototype.remove;
        Fp.prototype.configure = Fp.prototype.configure;
        function Gp(a, b) {
            var c = this;
            this.j = !1;
            this.h = [];
            this.m = a;
            this.l = b;
            this.D = this.A = null;
            this.g = U("div");
            this.g.classList.add("shaka-text-container");
            this.g.style.textAlign = "center";
            this.g.style.display = "flex";
            this.g.style.flexDirection = "column";
            this.g.style.alignItems = "center";
            this.g.style.justifyContent = "flex-end";
            this.C = new Uf(function() {
                c.m.paused || Hp(c);
            });
            Ip(this);
            this.o = new Map;
            this.i = new fd;
            this.i.u(document, "fullscreenchange", function() {
                Hp(c, !0);
            });
            this.i.u(this.m, "seeking", function() {
                Hp(c, !0);
            });
            this.i.u(this.m, "ratechange", function() {
                Ip(c);
            });
            this.i.u(this.m, "resize", function() {
                var d = c.m, e = d.videoWidth;
                d = d.videoHeight;
                e && d ? c.A = e / d : c.A = null;
            });
            this.H = !1;
            this.F = null;
            "ResizeObserver" in window1 && (this.F = new ResizeObserver(function() {
                c.H || (c.H = !0, requestAnimationFrame(function() {
                    c.H = !1;
                    c.g && c.g.parentElement && c.j && Hp(c, !0);
                }));
            }), this.F.observe(this.l));
            this.G = new Map;
        }
        p = Gp.prototype;
        p.configure = function(a) {
            this.D = a;
            Ip(this);
            Hp(this, !0);
        };
        p.append = function(a) {
            var b = [].concat(G(this.h));
            a = u(yp(a));
            for(var c = a.next(), d = {}; !c.done; d = {
                Rg: void 0
            }, c = a.next())d.Rg = c.value, b.some(function(e) {
                return function(f) {
                    return Ve(f, e.Rg);
                };
            }(d)) || this.h.push(d.Rg);
            this.h.length && Ip(this);
            Hp(this);
        };
        p.destroy = function() {
            if (!this.g) return Promise.resolve();
            this.g.parentElement && this.l.removeChild(this.g);
            this.g = null;
            this.j = !1;
            this.h = [];
            this.C && (this.C.stop(), this.C = null);
            this.o.clear();
            this.i && (this.i.release(), this.i = null);
            this.F && (this.F.disconnect(), this.F = null);
            return Promise.resolve();
        };
        p.remove = function(a, b) {
            if (!this.g) return !1;
            var c = this.h.length;
            this.h = this.h.filter(function(d) {
                return d.startTime < a || d.endTime >= b;
            });
            Hp(this, c > this.h.length);
            this.h.length || Ip(this);
            return !0;
        };
        p.isTextVisible = function() {
            return this.j;
        };
        p.setTextVisibility = function(a) {
            (this.j = a) ? (this.g.parentElement || this.l.appendChild(this.g), Hp(this, !0)) : this.g.parentElement && this.l.removeChild(this.g);
        };
        p.setTextLanguage = function(a) {
            a && a != "und" ? this.g.setAttribute("lang", a) : this.g.setAttribute("lang", "");
        };
        p.enableTextDisplayer = function() {};
        function Ip(a) {
            a.C && (a.h.length ? a.C.xa((a.D ? a.D.captionsUpdatePeriod : .25) / Math.max(1, Math.abs(a.m.playbackRate))) : a.C.stop());
        }
        function Jp(a, b) {
            for(; b != null;){
                if (b == a.g) return !0;
                b = b.parentElement;
            }
            return !1;
        }
        function Kp(a, b, c, d, e) {
            var f = !1, g = [], h = [];
            b = u(b);
            for(var k = b.next(); !k.done; k = b.next()){
                k = k.value;
                e.push(k);
                var l = a.o.get(k), m = k.startTime <= d && k.endTime > d, n = l ? l.nk : null;
                l && (g.push(l.Sg), l.kd && g.push(l.kd), m || (f = !0, a.o.delete(k), l = null));
                m && (h.push(k), l ? Jp(a, n) || (f = !0) : (Lp(a, k, e), l = a.o.get(k), n = l.nk, f = !0));
                k.nestedCues.length > 0 && n && Kp(a, k.nestedCues, n, d, e);
                e.pop();
            }
            if (f) {
                d = u(g);
                for(e = d.next(); !e.done; e = d.next())e = e.value, e.parentElement && e.parentElement.removeChild(e);
                h.sort(function(q, r) {
                    return q.startTime != r.startTime ? q.startTime - r.startTime : q.endTime - r.endTime;
                });
                h = u(h);
                for(d = h.next(); !d.done; d = h.next())d = a.o.get(d.value), d.kd ? (d.kd.contains(c) && d.kd.removeChild(c), c.appendChild(d.kd), d.kd.appendChild(d.Sg)) : c.appendChild(d.Sg);
            }
        }
        function Hp(a, b) {
            if (a.g) {
                var c = a.m.currentTime;
                if (!a.j || (b === void 0 ? 0 : b)) {
                    b = u(a.G.values());
                    for(var d = b.next(); !d.done; d = b.next())gk(d.value);
                    gk(a.g);
                    a.o.clear();
                    a.G.clear();
                }
                a.j && Kp(a, a.h, a.g, c, []);
            }
        }
        function Lp(a, b, c) {
            var d = c.length > 1, e = d ? "span" : "div";
            b.lineBreak && (e = "br");
            b.rubyTag && (e = b.rubyTag);
            d = !d && b.nestedCues.length > 0;
            var f = U(e);
            e != "br" && Mp(a, f, b, c, d);
            c = null;
            if (b.region && b.region.id) {
                var g = b.region, h = a.A === 4 / 3 ? 2.5 : 1.9;
                c = g.id + "_" + g.width + "x" + g.height + (g.heightUnits == Nd ? "%" : "px") + "-" + g.viewportAnchorX + "x" + g.viewportAnchorY + (g.viewportAnchorUnits == Nd ? "%" : "px") + "-" + g.regionAnchorX + "x" + g.regionAnchorY;
                if (a.G.has(c)) c = a.G.get(c);
                else {
                    e = U("span");
                    var k = g.heightUnits == Nd ? "%" : "px", l = g.widthUnits == Nd ? "%" : "px", m = g.viewportAnchorUnits == Nd ? "%" : "px";
                    e.id = "shaka-text-region---" + c;
                    e.classList.add("shaka-text-region");
                    e.style.position = "absolute";
                    var n = g.height, q = g.width;
                    g.heightUnits === 2 && (n = g.height * 5.33, k = "%");
                    g.widthUnits === 2 && (q = g.width * h, l = "%");
                    e.style.height = n + k;
                    e.style.width = q + l;
                    g.viewportAnchorUnits === 2 ? (h = g.viewportAnchorY / 75 * 100, k = g.viewportAnchorX / (a.A === 4 / 3 ? 160 : 210) * 100, h -= g.regionAnchorY * n / 100, k -= g.regionAnchorX * q / 100, e.style.top = h + "%", e.style.left = k + "%") : (e.style.top = g.viewportAnchorY - g.regionAnchorY * n / 100 + m, e.style.left = g.viewportAnchorX - g.regionAnchorX * q / 100 + m);
                    g.heightUnits !== 0 && g.widthUnits !== 0 && g.viewportAnchorUnits !== 0 && (g = Math.max(0, Math.min(100 - (parseInt(e.style.width.slice(0, -1), 10) || 0), parseInt(e.style.left.slice(0, -1), 10) || 0)), e.style.top = Math.max(0, Math.min(100 - (parseInt(e.style.height.slice(0, -1), 10) || 0), parseInt(e.style.top.slice(0, -1), 10) || 0)) + "%", e.style.left = g + "%");
                    e.style.display = "flex";
                    e.style.flexDirection = "column";
                    e.style.alignItems = "center";
                    e.style.justifyContent = b.displayAlign == "before" ? "flex-start" : b.displayAlign == "center" ? "center" : "flex-end";
                    a.G.set(c, e);
                    c = e;
                }
            }
            e = f;
            d && (e = U("span"), e.classList.add("shaka-text-wrapper"), e.style.backgroundColor = b.backgroundColor, e.style.lineHeight = "normal", f.appendChild(e));
            a.o.set(b, {
                Sg: f,
                nk: e,
                kd: c
            });
        }
        function Np(a) {
            var b = a.direction, c = a.positionAlign;
            a = a.textAlign;
            return c !== Je ? c : a === "left" || a === "start" && b === Le || a === "end" && b === "rtl" ? "line-left" : a === "right" || a === "start" && b === "rtl" || a === "end" && b === Le ? "line-right" : "center";
        }
        function Mp(a, b, c, d, e) {
            var f = b.style, g = c.nestedCues.length == 0, h = d.length > 1;
            f.whiteSpace = "pre-wrap";
            var k = c.payload.replace(/\s+$/g, function(m) {
                return "\u00a0".repeat(m.length);
            });
            f.webkitTextStrokeColor = c.textStrokeColor;
            f.webkitTextStrokeWidth = c.textStrokeWidth;
            f.color = c.color;
            f.direction = c.direction;
            f.opacity = c.opacity;
            f.paddingLeft = Op(c.linePadding, c, a.l);
            f.paddingRight = Op(c.linePadding, c, a.l);
            f.textCombineUpright = c.textCombineUpright;
            f.textShadow = c.textShadow;
            if (c.backgroundImage) f.backgroundImage = "url('" + c.backgroundImage.replace(/['"()\\]/g, "") + "')", f.backgroundRepeat = "no-repeat", f.backgroundSize = "contain", f.backgroundPosition = "center", c.backgroundColor && (f.backgroundColor = c.backgroundColor), f.width = "100%", f.height = "100%";
            else {
                if (c.nestedCues.length) var l = b;
                else l = U("span"), b.appendChild(l);
                c.border && (l.style.border = c.border);
                e || ((b = Pp(d, function(m) {
                    return m.backgroundColor;
                })) ? l.style.backgroundColor = b : k && (l.style.backgroundColor = "rgba(0, 0, 0, 0.8)"));
                k && (l.setAttribute("translate", "no"), l.textContent = k);
            }
            if (h && !d[d.length - 1].isContainer) f.display = "inline";
            else {
                f.display = "flex";
                f.flexDirection = "column";
                f.alignItems = "center";
                if (c.textAlign == "left" || c.textAlign == "start") f.width = "100%", f.alignItems = "flex-start";
                else if (c.textAlign == "right" || c.textAlign == "end") f.width = "100%", f.alignItems = "flex-end";
                f.justifyContent = c.displayAlign == "before" ? "flex-start" : c.displayAlign == "center" ? "center" : "flex-end";
            }
            g || (f.margin = "0");
            f.fontFamily = c.fontFamily;
            f.fontWeight = c.fontWeight.toString();
            f.fontStyle = c.fontStyle;
            f.letterSpacing = c.letterSpacing;
            d = a.D ? a.D.fontScaleFactor : 1;
            if (d !== 1 || c.fontSize) f.fontSize = Op(c.fontSize || "1em", c, a.l, d);
            d = c.line;
            d != null && (g = c.lineInterpretation, g == Ne && (g = 1, h = 16, a.A && a.A < 1 && (h = 32), d = d < 0 ? 100 + d / h * 100 : d / h * 100), g == 1 && (f.position = "absolute", c.writingMode == Me ? (f.width = "100%", c.lineAlign == Oe ? f.top = d + "%" : c.lineAlign == "end" && (f.bottom = 100 - d + "%")) : c.writingMode == "vertical-lr" ? (f.height = "100%", c.lineAlign == Oe ? f.left = d + "%" : c.lineAlign == "end" && (f.right = 100 - d + "%")) : (f.height = "100%", c.lineAlign == Oe ? f.right = d + "%" : c.lineAlign == "end" && (f.left = 100 - d + "%"))));
            f.lineHeight = c.lineHeight;
            a = Np(c);
            a == "line-left" ? (f.cssFloat = "left", c.position !== null && (f.position = "absolute", c.writingMode == Me ? (f.left = c.position + "%", f.width = "auto") : f.top = c.position + "%")) : a == "line-right" ? (f.cssFloat = "right", c.position !== null && (f.position = "absolute", c.writingMode == Me ? (f.right = 100 - c.position + "%", f.width = "auto") : f.bottom = c.position + "%")) : c.position !== null && c.position != 50 && (f.position = "absolute", c.writingMode == Me ? (f.left = c.position + "%", f.width = "auto") : f.top = c.position + "%", c.size && (f.transform = "translateX(-50%)"));
            f.textAlign = c.textAlign;
            f.textDecoration = c.textDecoration.join(" ");
            f.writingMode = c.writingMode;
            "writingMode" in document.documentElement.style && f.writingMode == c.writingMode || (f.webkitWritingMode = c.writingMode);
            c.size && (c.writingMode == Me ? f.width = c.size + "%" : f.height = c.size + "%");
        }
        function Op(a, b, c, d) {
            d = d === void 0 ? 1 : d;
            var e = (e = new RegExp(/(\d*\.?\d+)([a-z]+|%+)/).exec(a)) ? {
                value: Number(e[1]),
                unit: e[2]
            } : null;
            if (!e) return a;
            a = e.unit;
            d *= e.value;
            switch(a){
                case "%":
                    return d / 100 * c.clientHeight / b.cellResolution.rows + "px";
                case "c":
                    return c.clientHeight * d / b.cellResolution.rows + "px";
                default:
                    return d + a;
            }
        }
        function Pp(a, b) {
            for(var c = a.length - 1; c >= 0; c--){
                var d = b(a[c]);
                if (d || d === 0) return d;
            }
            return null;
        }
        O("shaka.text.UITextDisplayer", Gp);
        Gp.prototype.enableTextDisplayer = Gp.prototype.enableTextDisplayer;
        Gp.prototype.setTextLanguage = Gp.prototype.setTextLanguage;
        Gp.prototype.setTextVisibility = Gp.prototype.setTextVisibility;
        Gp.prototype.isTextVisible = Gp.prototype.isTextVisible;
        Gp.prototype.remove = Gp.prototype.remove;
        Gp.prototype.destroy = Gp.prototype.destroy;
        Gp.prototype.append = Gp.prototype.append;
        Gp.prototype.configure = Gp.prototype.configure;
        function Qp(a, b) {
            function c(f) {
                for(var g = f, h = u(b), k = h.next(); !k.done; k = h.next())k = k.value, k.end && k.start < f && (g += k.end - k.start);
                f = Math.floor(g / 3600);
                h = Math.floor(g / 60 % 60);
                k = Math.floor(g % 60);
                g = Math.floor(g * 1E3 % 1E3);
                return (f < 10 ? "0" : "") + f + ":" + (h < 10 ? "0" : "") + h + ":" + (k < 10 ? "0" : "") + k + "." + (g < 100 ? g < 10 ? "00" : "0" : "") + g;
            }
            var d = xp(a);
            a = "WEBVTT\n\n";
            d = u(d);
            for(var e = d.next(); !e.done; e = d.next())e = e.value, a += c(e.startTime) + " --\x3e " + c(e.endTime) + function(f) {
                var g = [];
                switch(f.textAlign){
                    case "left":
                        g.push("align:left");
                        break;
                    case "right":
                        g.push("align:right");
                        break;
                    case Ke:
                        g.push("align:middle");
                        break;
                    case "start":
                        g.push("align:start");
                        break;
                    case "end":
                        g.push("align:end");
                }
                switch(f.writingMode){
                    case "vertical-lr":
                        g.push("vertical:lr");
                        break;
                    case "vertical-rl":
                        g.push("vertical:rl");
                }
                return g.length ? " " + g.join(" ") : "";
            }(e) + "\n", a += e.payload + "\n\n";
            return a;
        }
        O("shaka.text.WebVttGenerator", function() {});
        function Rp(a, b) {
            this.g = b;
            this.j = a;
            this.m = new Map;
            this.l = void 0;
            this.F = !1;
            this.J = !0;
            this.A = this.I = !1;
            this.D = this.C = void 0;
            this.H = 0;
            this.K = {
                request: !1,
                response: !1,
                event: !1
            };
            this.o = {};
            this.i = new fd;
            this.G = [];
            this.h = null;
        }
        Rp.prototype.setMediaElement = function(a) {
            this.h = a;
            Sp(this);
        };
        Rp.prototype.configure = function(a) {
            this.g = a;
            Tp(this);
        };
        function Up(a) {
            a.m.clear();
            a.F = !1;
            a.J = !0;
            a.I = !1;
            a.A = !1;
            a.C = 0;
            a.D = 0;
            a.H = 0;
            a.K = {
                request: !1,
                response: !1,
                event: !1
            };
            Vp(a);
            a.o = {};
            a.h = null;
            a.i.Ta();
        }
        function Wp(a, b) {
            a.A = b;
            a.A ? a.l == Xp ? a.l = Yp : a.l == Zp && (a.l = $p) : a.l == Yp ? a.l = Xp : a.l == $p && (a.l = Zp);
        }
        function aq(a, b) {
            if (a.g && a.g.enabled && (bq(a, "ps", {
                nd: "d"
            }), a.h && a.h.autoplay)) {
                var c = a.h.play();
                c && c.then(function() {
                    a.H = b;
                }).catch(function() {
                    a.H = 0;
                });
            }
        }
        function cq(a, b, c) {
            try {
                if (!a.g.enabled) return b;
                var d = dq(a);
                a: {
                    switch(c.toLowerCase()){
                        case "audio/mp4":
                        case "audio/webm":
                        case "audio/ogg":
                        case "audio/mpeg":
                        case "audio/aac":
                        case "audio/flac":
                        case "audio/wav":
                            var e = eq;
                            break a;
                        case "video/webm":
                        case "video/mp4":
                        case "video/mpeg":
                        case "video/mp2t":
                            e = fq;
                            break a;
                        case "application/x-mpegurl":
                        case "application/vnd.apple.mpegurl":
                        case "audio/x-mpegurl":
                        case "application/dash+xml":
                        case "video/vnd.mpeg.dash.mpd":
                        case "application/vnd.ms-sstr+xml":
                            e = gq;
                            break a;
                    }
                    e = void 0;
                }
                d.ot = e;
                d.su = !0;
                var f = hq(d);
                return iq(b, f);
            } catch (g) {
                return $a("CMCD_SRC_ERROR", "Could not generate src CMCD data.", g), b;
            }
        }
        function Sp(a) {
            a.i.u(a.h, "playing", function() {
                a.D || (a.D = Date.now());
                bq(a, "ps", {
                    nd: "p"
                });
            });
            a.i.u(a.h, "volumechange", function() {
                bq(a, a.h.muted ? "m" : "um");
            });
            a.i.u(a.h, "play", function() {
                a.C || (a.C = Date.now(), bq(a, "ps", {
                    nd: "s"
                }));
            });
            a.i.u(a.h, "pause", function() {
                bq(a, "ps", {
                    nd: "a"
                });
            });
            a.i.u(a.j, "buffering", function() {
                bq(a, "ps", {
                    nd: "w"
                });
            });
            a.i.u(a.h, "seeking", function() {
                return bq(a, "ps", {
                    nd: "k"
                });
            });
            a.i.u(document, "fullscreenchange", function() {
                bq(a, document.fullscreenElement ? "pe" : "pc");
            });
            var b = a.h;
            (b.webkitPresentationMode || b.webkitSupportsFullscreen) && a.i.u(b, "webkitpresentationmodechanged", function() {
                b.webkitPresentationMode ? bq(a, b.webkitPresentationMode !== "inline" ? "pe" : "pc") : b.webkitSupportsFullscreen && bq(a, b.webkitDisplayingFullscreen ? "pe" : "pc");
            });
            a.i.u(a.h, "enterpictureinpicture", function() {
                bq(a, "pe");
            });
            a.i.u(a.h, "leavepictureinpicture", function() {
                bq(a, "pc");
            });
            "documentPictureInPicture" in window1 && a.i.u(window1.documentPictureInPicture, "enter", function(c) {
                bq(a, "pe");
                a.i.ra(c.window, "pagehide", function() {
                    bq(a, "pc");
                });
            });
            a.i.u(document, "visibilitychange", function() {
                document.hidden ? bq(a, "b", {
                    bg: !0
                }) : bq(a, "b");
            });
            a.i.u(a.j, "complete", function() {
                bq(a, "ps", {
                    nd: "e"
                });
            });
        }
        function Tp(a) {
            Vp(a);
            var b = jq(a);
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next())if (c = c.value.timeInterval, c === void 0 && (c = kq), c >= 1) {
                var d = new Uf(function() {
                    return bq(a, lq);
                });
                d.xa(c);
                a.G.push(d);
            }
        }
        function Vp(a) {
            if (a.G) for(var b = u(a.G), c = b.next(); !c.done; c = b.next())c.value.stop();
            a.G = [];
        }
        function jq(a) {
            return (a = a.g.targets) ? a.filter(function(b) {
                return b.mode === mq && b.enabled;
            }) : [];
        }
        function nq(a) {
            return (a = a.g.targets) ? a.filter(function(b) {
                return b.mode === oq && b.enabled === !0;
            }) : [];
        }
        function dq(a) {
            a.g.sessionId || (a.g.sessionId = window1.crypto.randomUUID());
            return {
                v: a.g.version,
                sf: a.l,
                sid: a.g.sessionId,
                cid: a.g.contentId,
                mtp: a.j.getBandwidthEstimate() / 1E3
            };
        }
        function bq(a, b, c) {
            c = c === void 0 ? {} : c;
            b = Object.assign({
                e: b,
                ts: Date.now()
            }, c);
            b = pq(a, b, mq);
            c = a.g.targets;
            if (!(a.g.version < qq) && c) {
                var d = jq(a);
                c = Array.from(new Set([].concat(G(rq), G(sq))));
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next()){
                    e = e.value;
                    var f = tq(e.includeKeys || [], c);
                    f.includes(Jq) || f.push(Jq);
                    f = Kq(b, f);
                    var g = e.events || [], h = f.e, k = f.sta;
                    h && (!Lq.includes(h) || !(h !== "ps" || k && Mq.includes(k)) || g && g.length > 0 && !g.includes(h)) || Nq(a, f, e);
                }
            }
        }
        function Oq(a, b, c) {
            if (a.g.enabled) {
                c = pq(a, c, Pq);
                var d = Qq({
                    mode: Pq,
                    useHeaders: a.g.useHeaders,
                    includeKeys: a.g.includeKeys || []
                });
                a.o[d] || (a.o[d] = {
                    request: 1,
                    response: 1
                });
                c.sn = a.o[d].request++;
                d = a.g.includeKeys || [];
                var e = a.g.version == qq ? Array.from(new Set([].concat(G(rq), G(Rq)))) : Sq;
                d = tq(d, e);
                c = Kq(c, d);
                Tq(a, c, b, a.g.useHeaders);
            }
        }
        function Nq(a, b, c, d) {
            var e = Wg(), f = c.url;
            if (c.useHeaders) {
                b = Uq(b);
                if (!Object.keys(b).length) return;
                d && Object.assign(d.headers, b);
                d = mh([
                    f
                ], e);
                Object.assign(d.headers, b);
            } else {
                b = hq(b);
                if (!b) return;
                f = iq(f, b);
                d && (d.uri = f);
                d = mh([
                    f
                ], e);
            }
            a.j.Qb().request(9, d);
        }
        function Tq(a, b, c, d) {
            if (d) {
                b = Uq(b);
                if (!Object.keys(b).length) return;
                Object.assign(c.headers, b);
            } else {
                var e = hq(b);
                if (!e) return;
                c.uris = c.uris.map(function(f) {
                    return iq(f, e);
                });
            }
            nq(a).length > 0 || !a.m.has(c) || a.m.delete(c);
        }
        function tq(a, b) {
            if (!a || a.length === 0) return b;
            for(var c = u(a), d = c.next(); !d.done; d = c.next())b.includes(d.value);
            return a = a.filter(function(e) {
                return b.includes(e);
            });
        }
        function Kq(a, b) {
            return Object.keys(a).reduce(function(c, d) {
                b.includes(d) && (c[d] = a[d]);
                return c;
            }, {});
        }
        function Vq(a) {
            if (a.type === 0) return Wq;
            if (a = a.stream) {
                var b = a.type;
                if (b == "video") return a.codecs && a.codecs.includes(",") ? fq : Xq;
                if (b == "audio") return eq;
                if (b == "text") return a.mimeType === "application/mp4" ? Yq : Zq;
            }
        }
        function Qq(a) {
            var b = Object.keys(a).sort().reduce(function(c, d) {
                d !== "enabled" && (c[d] = a[d]);
                return c;
            }, {});
            return JSON.stringify(b);
        }
        function $q(a, b) {
            b = a.j.Nc()[b];
            if (!b.length) return NaN;
            var c = a.h ? a.h.currentTime : 0;
            return (a = b.find(function(d) {
                return d.start <= c && d.end >= c;
            })) ? (a.end - c) * 1E3 : NaN;
        }
        function ar(a, b) {
            b = a.j.Nc()[b];
            if (!b.length) return 0;
            var c = a.h ? a.h.currentTime : 0;
            return (a = b.find(function(d) {
                return d.start <= c && d.end >= c;
            })) ? (a.end - c) * 1E3 : 0;
        }
        function br(a, b) {
            var c = a.j.Ib();
            if (!c.length) return NaN;
            a = c[0];
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next())d = d.value, d.type === "variant" && d.bandwidth > a.bandwidth && (a = d);
            switch(b){
                case Xq:
                    return a.videoBandwidth || NaN;
                case eq:
                    return a.audioBandwidth || NaN;
                default:
                    return a.bandwidth;
            }
        }
        function cr(a, b, c) {
            var d = b.segment, e = 0;
            d && (e = d.endTime - d.startTime);
            e = {
                d: e * 1E3,
                st: a.j.U() ? dr : er
            };
            e.ot = Vq(b);
            var f = e.ot === Xq || e.ot === eq || e.ot === fq || e.ot === Yq;
            if (b = b.stream) {
                var g = a.j.Wa();
                if (f && (e.bl = $q(a, b.type), e.ot !== Yq)) {
                    var h = ar(a, b.type);
                    e.dl = g ? h / Math.abs(g) : h;
                }
                b.bandwidth && (e.br = b.bandwidth / 1E3);
                if (b.segmentIndex && d) {
                    if ((g = b.segmentIndex.ac(d.endTime, !0, g < 0)) && (g = g.next().value) && g != d) {
                        if (c && !ed(d.T(), g.T())) {
                            var k = g.T()[0];
                            h = new URL(k);
                            var l = new URL(c);
                            if (h.origin !== l.origin) c = k;
                            else {
                                c = h.pathname.split("/").slice(1);
                                k = l.pathname.split("/").slice(1, -1);
                                l = Math.min(c.length, k.length);
                                for(var m = 0; m < l && c[m] === k[m]; m++)c.shift(), k.shift();
                                for(; k.length;)k.shift(), c.unshift("..");
                                c = c.join("/") + h.search + h.hash;
                            }
                            e.nor = c;
                        }
                        !g.startByte && !g.endByte || d.startByte == g.startByte && d.endByte == g.endByte || (c = g.startByte + "-", g.endByte && (c += g.endByte), e.nrr = c);
                    }
                    g = a.j.Wa() || 1;
                    c = ar(a, b.type) || 500;
                    d = (b = b.bandwidth) ? b * (d.endTime - d.startTime) / 1E3 / (c / g / 1E3) * a.g.rtpSafetyFactor : NaN;
                    isNaN(d) || (e.rtp = d);
                }
            }
            f && e.ot !== Yq && (e.tb = br(a, e.ot) / 1E3);
            return e;
        }
        function pq(a, b, c) {
            Object.assign(b, dq(a));
            b.pr = a.j.Wa();
            var d = b.ot === Xq || b.ot === fq;
            a.I && d && (b.bs = !0, b.su = !0, a.I = !1);
            b.su == null && (b.su = a.J);
            a.j.U() && (d = fr(a.j), b.ltc = d || void 0);
            document.hidden && (b.bg = !0);
            d = a.D && a.C ? a.D - (a.H || a.C) : void 0;
            d == void 0 || a.K[c] || (b.msd = d, a.K[c] = !0);
            return b;
        }
        function hq(a) {
            function b(n) {
                return c(n / 100) * 100;
            }
            function c(n) {
                return Math.round(n);
            }
            function d(n) {
                return !Number.isNaN(n) && n != null && n !== "" && n !== !1;
            }
            var e = [], f = {
                br: c,
                d: c,
                bl: b,
                dl: b,
                mtp: b,
                nor: function(n) {
                    return encodeURIComponent(n);
                },
                rtp: b,
                tb: c,
                ttfb: c,
                ttlb: c
            }, g = Object.keys(a || {}).sort();
            g = u(g);
            for(var h = g.next(); !h.done; h = g.next()){
                h = h.value;
                var k = a[h];
                if (d(k) && (h !== "v" || k !== 1) && (h != "pr" || k !== 1)) {
                    var l = f[h];
                    l && (k = l(k));
                    l = typeof k;
                    var m = void 0;
                    m = l === "string" && h !== "ot" && h !== "sf" && h !== "st" ? h + "=" + JSON.stringify(k) : l === "boolean" ? h : l === "symbol" ? h + "=" + k.description : h + "=" + k;
                    e.push(m);
                }
            }
            return e.join(",");
        }
        function Uq(a) {
            var b = Object.keys(a), c = {}, d = [
                "Object",
                "Request",
                "Session",
                "Status"
            ], e = [
                {},
                {},
                {},
                {}
            ], f = {
                br: 0,
                d: 0,
                ot: 0,
                tb: 0,
                url: 0,
                bl: 1,
                dl: 1,
                mtp: 1,
                nor: 1,
                nrr: 1,
                su: 1,
                ltc: 1,
                ttfb: 1,
                ttlb: 1,
                ts: 1,
                rc: 1,
                cmsdd: 1,
                cmsds: 1,
                sn: 1,
                cid: 2,
                pr: 2,
                sf: 2,
                sid: 2,
                st: 2,
                v: 2,
                msd: 2,
                bs: 3,
                rtp: 3,
                bg: 3
            };
            b = u(b);
            for(var g = b.next(); !g.done; g = b.next())g = g.value, e[f[g] != null ? f[g] : 1][g] = a[g];
            for(a = 0; a < e.length; a++)(f = hq(e[a])) && (c["CMCD-" + d[a]] = f);
            return c;
        }
        function iq(a, b) {
            if (!b || a.includes("offline:")) return a;
            a = new lb(a);
            a.g.set("CMCD", b);
            return a.toString();
        }
        var gq = "m", eq = "a", Xq = "v", fq = "av", Wq = "i", Zq = "c", Yq = "tt", qq = 2, er = "v", dr = "l", Xp = "d", Yp = "ld", Zp = "h", $p = "lh";
        O("shaka.util.CmcdManager.StreamingFormat", {
            DASH: Xp,
            hn: Yp,
            HLS: Zp,
            jn: $p,
            zn: "s",
            OTHER: "o"
        });
        var Sq = "br bl bs cid d dl mtp nor nrr ot pr rtp sf sid st su tb v".split(" "), rq = "br ab bl tbl bs cdn cid ltc mtp pr sf sid bg sta st ts tpb tb lb tab lab pt ec msd v sn".split(" "), Rq = "ab bl tbl bs cdn cid d dl ltc mtp nor ot pr rtp sf sid bg sta st su ts tpb tb lb tab lab pt ec msd v".split(" "), gr = "d dl nor ot rtp rc su ttfb ttfbb ttlb url cmsdd cmsds".split(" "), sq = [
            "e",
            "sta"
        ], Lq = "ps e t c b m um pe pc".split(" "), Mq = "spawkrfeqd".split(""), kq = 10, Jq = "ts", lq = "t", Pq = "request", oq = "response", mq = "event";
        function hr(a) {
            this.h = a;
            this.g = null;
        }
        p = hr.prototype;
        p.configure = function(a) {
            this.h = a;
        };
        p.aj = function() {
            return this.h.enabled && this.h.applyMaximumSuggestedBitrate && this.g && this.g.has(ir) ? this.g.get(ir) * 1E3 : null;
        };
        p.$i = function() {
            return this.h.enabled && this.g && this.g.has(jr) ? this.g.get(jr) * 1E3 : null;
        };
        p.il = function() {
            return this.h.enabled && this.g && this.g.has(kr) ? this.g.get(kr) : null;
        };
        p.jl = function() {
            return this.h.enabled && this.g && this.g.has(lr) ? this.g.get(lr) : null;
        };
        p.getBandwidthEstimate = function(a) {
            var b = this.$i();
            if (!b) return a;
            var c = this.h.estimatedThroughputWeightRatio;
            return c > 0 && c <= 1 ? a * (1 - c) + b * c : a;
        };
        function mr(a) {
            return a ? a.toLowerCase() === "false" ? !1 : /^[-0-9]/.test(a) ? parseInt(a, 10) : a.replace(/["]+/g, "") : !0;
        }
        O("shaka.util.CmsdManager", hr);
        hr.prototype.getBandwidthEstimate = hr.prototype.getBandwidthEstimate;
        hr.prototype.getRoundTripTime = hr.prototype.jl;
        hr.prototype.getResponseDelay = hr.prototype.il;
        hr.prototype.getEstimatedThroughput = hr.prototype.$i;
        hr.prototype.getMaxBitrate = hr.prototype.aj;
        var jr = "etp", ir = "mb", kr = "rd", lr = "rtt";
        function nr() {
            this.g = null;
            this.h = [];
        }
        function or(a, b) {
            return H(function(c) {
                if (c.h == 1) return a.g ? c.g(new Promise(function(d) {
                    return a.h.push(d);
                }), 2) : c.B(2);
                a.g = b;
                c.j();
            });
        }
        nr.prototype.release = function() {
            this.h.length > 0 ? this.h.shift()() : this.g = null;
        };
        function W(a, b, c) {
            b = b === void 0 ? null : b;
            fb.call(this);
            var d = this;
            this.m = pr;
            this.h = null;
            this.Oe = b;
            this.W = !1;
            this.Ye = new fd;
            this.Pe = new fd;
            this.j = new fd;
            this.jc = new fd;
            this.Td = new fd;
            this.G = this.H = this.F = this.M = null;
            this.Ze = 0;
            this.X = new nr;
            this.O = this.Ga = this.V = this.i = this.Gc = this.I = this.l = this.Le = this.R = this.Hi = this.na = this.K = this.jb = this.ya = this.Ne = this.P = this.Ia = this.L = this.Kb = null;
            this.Oa = !1;
            this.Te = this.o = null;
            this.Se = 1E9;
            this.Xe = [];
            this.Fc = new Map;
            this.kb = [];
            this.Bg = -1;
            this.g = qr(this);
            this.Dg = Do();
            this.S = null;
            this.$e = -1;
            this.hc = null;
            this.ua = {
                width: Infinity,
                height: Infinity
            };
            this.Re = new Li(this.g, this.ua, null);
            this.Ve = [];
            this.C = null;
            this.J = this.g.adaptationSetCriteriaFactory();
            this.J.configure({
                language: this.g.preferredAudioLanguage,
                role: this.g.preferredAudioRole,
                videoRole: this.g.preferredVideoRole,
                channelCount: 0,
                hdrLevel: this.g.preferredVideoHdrLevel,
                spatialAudio: this.g.preferSpatialAudio,
                videoLayout: this.g.preferredVideoLayout,
                audioLabel: this.g.preferredAudioLabel,
                videoLabel: this.g.preferredVideoLabel,
                codecSwitchingStrategy: this.g.mediaSource.codecSwitchingStrategy,
                audioCodec: "",
                activeAudioCodec: "",
                activeAudioChannelCount: 0,
                preferredAudioCodecs: this.g.preferredAudioCodecs,
                preferredAudioChannelCount: this.g.preferredAudioChannelCount
            });
            this.Zd = this.g.preferredTextLanguage;
            this.ce = this.g.preferredTextRole;
            this.be = this.g.preferForcedSubs;
            this.Qe = [];
            c && c(this);
            this.K = new Rp(this, this.g.cmcd);
            this.na = new hr(this.g.cmsd);
            this.M = rr(this);
            this.$ = this.ba = this.va = this.D = null;
            this.Fg = !1;
            this.Cg = [];
            this.Eg = new Uf(function() {
                return H(function(e) {
                    if (e.h == 1) return d.ba ? e.g(d.Ob(d.$, !0), 3) : e.B(0);
                    if (e.h != 4) return e.g(d.load(d.ba), 4);
                    d.Fg ? d.$.pause() : d.$.play();
                    d.ba = null;
                    d.Fg = !1;
                    e.j();
                });
            });
            sr && (this.D = sr(), this.D.configure(this.g.ads), this.Td.u(this.D, "ad-content-pause-requested", function(e) {
                var f, g;
                return H(function(h) {
                    if (h.h == 1) {
                        d.Eg.stop();
                        if (d.ba) return h.B(0);
                        d.$ = d.h;
                        d.Fg = d.isEnded();
                        f = e.saveLivePosition || !1;
                        g = !0;
                        d.U() && (g = f);
                        return h.g(d.Vi(!0, g), 3);
                    }
                    d.ba = h.i;
                    h.j();
                });
            }), this.Td.u(this.D, "ad-content-resume-requested", function(e) {
                e = e.offset || 0;
                if (d.ba) {
                    var f = d.ba;
                    f.o && e && (typeof f.o === "number" ? f.o += e : f.o.setTime(f.o.getTime() + e * 1E3));
                }
                d.Eg.Z(.1);
            }), this.Td.u(this.D, "ad-content-attach-requested", function() {
                return H(function(e) {
                    if (e.h == 1) return d.h || !d.$ ? e.B(0) : e.g(d.Ob(d.$, !0), 3);
                    d.$ = null;
                    e.j();
                });
            }));
            tr && (this.va = tr(this), this.va.configure(this.g.queue));
            this.Ye.u(window1, "online", function() {
                ur(d);
                d.bi();
            });
            this.Ue = new Uf(function() {
                for(var e = Date.now() / 1E3, f = !1, g = !0, h = u(d.i.variants), k = h.next(); !k.done; k = h.next())k = k.value, k.disabledUntilTime > 0 && k.disabledUntilTime <= e && (k.disabledUntilTime = 0, f = !0), k.disabledUntilTime > 0 && (g = !1);
                g && d.Ue.stop();
                f && vr(d, !1, void 0, !1, !1);
            });
            this.ab = null;
            a && (md("Player w/ mediaElement", "Please migrate from initializing Player with a mediaElement; use the attach method instead."), this.Ob(a, !0));
            this.A = null;
        }
        oa(W, fb);
        function wr(a) {
            a.R != null && (ud(a.R), a.R.release(), a.R = null);
        }
        function xr(a, b, c) {
            c || b.lcevc.enabled ? (wr(a), a.R == null && (a.R = new sd(a.h, a.Hi, b.lcevc, c), a.H && (a.H.D = a.R))) : wr(a);
        }
        function yr(a, b) {
            return new R(a, b);
        }
        p = W.prototype;
        p.destroy = function() {
            var a = this, b;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        if (a.m == zr) return c.return();
                        wr(a);
                        b = a.detach();
                        a.m = zr;
                        return c.g(b, 2);
                    case 2:
                        return c.g(a.Vg(), 3);
                    case 3:
                        a.Ye && (a.Ye.release(), a.Ye = null);
                        a.Pe && (a.Pe.release(), a.Pe = null);
                        a.j && (a.j.release(), a.j = null);
                        a.jc && (a.jc.release(), a.jc = null);
                        a.Td && (a.Td.release(), a.Td = null);
                        a.Te = null;
                        a.g = null;
                        a.C = null;
                        a.Oe = null;
                        a.K = null;
                        a.na = null;
                        if (!a.M) {
                            c.B(4);
                            break;
                        }
                        return c.g(a.M.destroy(), 5);
                    case 5:
                        a.M = null;
                    case 4:
                        a.o && (a.o.release(), a.o = null), a.va && (a.va.destroy(), a.va = null), fb.prototype.release.call(a), c.j();
                }
            });
        };
        function Ar(a, b) {
            Br.set(a, b);
        }
        function Cr() {
            window1.Promise || Za("A Promise implementation or polyfill is required");
            if (!(window1.Promise && window1.Uint8Array && Array.prototype.forEach) || (navigator.userAgent || "").includes("Trident/")) return !1;
            Xb();
            return Ad() ? !0 : Bd().canPlayType("application/x-mpegurl") != "";
        }
        function Dr(a, b) {
            a.dispatchEvent(yr("onstatechange", (new Map).set("state", b)));
        }
        p.Ob = function(a, b) {
            b = b === void 0 ? !0 : b;
            var c = this, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        if (c.m == zr) throw new T(2, 7, 7E3);
                        d = c.h && c.h == a;
                        if (!c.h || c.h == a) {
                            g.B(2);
                            break;
                        }
                        return g.g(c.detach(), 2);
                    case 2:
                        return g.g(Er(c, "attach"), 4);
                    case 4:
                        if (g.i) return g.return();
                        g.m(5, 6);
                        d || (Dr(c, "attach"), e = function() {
                            var h = Fr(c, !1);
                            h && Gr(c, h);
                        }, c.Pe.u(a, "error", e), c.h = a, c.K && c.K.setMediaElement(a));
                        Xb();
                        if (!b || !Ad() || c.H) {
                            g.B(6);
                            break;
                        }
                        return g.g(Hr(c), 6);
                    case 6:
                        g.A();
                        c.X.release();
                        g.C(0);
                        break;
                    case 5:
                        return f = g.l(), g.g(c.detach(), 10);
                    case 10:
                        throw f;
                }
            });
        };
        p.Ji = function(a) {
            this.Hi = a;
        };
        p.detach = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return H(function(c) {
                if (c.h == 1) {
                    if (b.m == zr) throw new T(2, 7, 7E3);
                    return c.g(b.tc(!1, a), 2);
                }
                if (c.h != 3) return c.g(Er(b, "detach"), 3);
                if (c.i) return c.return();
                try {
                    b.h && (b.Pe.Ta(), b.h = null), Dr(b, "detach"), b.D && !a && b.D.release();
                } finally{
                    b.X.release();
                }
                c.j();
            });
        };
        function Er(a, b) {
            var c;
            return H(function(d) {
                return d.h == 1 ? (c = ++a.Ze, d.g(or(a.X, b), 2)) : c != a.Ze ? (a.X.release(), d.return(!0)) : d.return(!1);
            });
        }
        p.tc = function(a, b) {
            a = a === void 0 ? !0 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        return c.m != zr && (c.m = pr), z.g(Er(c, "unload"), 2);
                    case 2:
                        if (z.i) return z.return();
                        z.F(3);
                        c.Oa = !1;
                        Dr(c, "unload");
                        wr(c);
                        d = c.Qe.map(function(A) {
                            return A();
                        });
                        c.Qe = [];
                        return z.g(Promise.all(d), 5);
                    case 5:
                        c.dispatchEvent(yr("unloading"));
                        c.Ne && (c.Ne.release(), c.Ne = null);
                        c.ya && (c.ya.release(), c.ya = null);
                        c.jb && (c.jb.release(), c.jb = null);
                        c.h && (c.j.Ta(), c.jc.Ta());
                        c.Ue.stop();
                        c.Kb && (c.Kb.release(), c.Kb = null);
                        c.Ia && (c.Ia.stop(), c.Ia = null);
                        if (!c.I) {
                            z.B(6);
                            break;
                        }
                        return z.g(c.I.stop(), 7);
                    case 7:
                        c.I = null, c.Gc = null;
                    case 6:
                        c.o && c.o.stop();
                        if (!c.l) {
                            z.B(8);
                            break;
                        }
                        return z.g(c.l.destroy(), 9);
                    case 9:
                        c.l = null;
                    case 8:
                        c.L && (c.L.release(), c.L = null);
                        c.G && (c.G.release(), c.G = null);
                        if ("webkit" !== window1.shakaMediaKeysPolyfill || !c.F) {
                            z.B(10);
                            break;
                        }
                        return z.g(c.F.destroy(), 11);
                    case 11:
                        c.F = null;
                    case 10:
                        if (!c.H) {
                            z.B(12);
                            break;
                        }
                        return z.g(c.H.destroy(), 13);
                    case 13:
                        c.H = null;
                    case 12:
                        if (c.D && !b) c.D.onAssetUnload();
                        c.ba && !b && (c.ba.destroy(), c.ba = null);
                        b || c.Eg.stop();
                        c.K && Up(c.K);
                        c.na && (c.na.g = null);
                        if (!c.A) {
                            z.B(14);
                            break;
                        }
                        return z.g(c.A.destroy(), 15);
                    case 15:
                        c.A = null;
                    case 14:
                        c.W = !1;
                        if (c.h) {
                            e = u(c.Cg);
                            for(f = e.next(); !f.done; f = e.next())g = f.value, g.src.startsWith("blob:") && URL.revokeObjectURL(g.src), g.remove();
                            c.Cg = [];
                            ek(c.h) && c.h.load();
                        }
                        if (!c.F) {
                            z.B(16);
                            break;
                        }
                        return z.g(c.F.destroy(), 17);
                    case 17:
                        c.F = null;
                    case 16:
                        c.ab && c.V != c.ab.dd() && (c.ab.l || c.ab.destroy(), c.ab = null);
                        c.V = null;
                        c.Ga = null;
                        c.P = null;
                        if (c.i) {
                            h = u(c.i.variants);
                            for(k = h.next(); !k.done; k = h.next())for(l = k.value, m = u([
                                l.audio,
                                l.video
                            ]), n = m.next(); !n.done; n = m.next())(q = n.value) && q.segmentIndex && q.segmentIndex.release();
                            r = u(c.i.textStreams);
                            for(t = r.next(); !t.done; t = r.next())v = t.value, v.segmentIndex && v.segmentIndex.release();
                        }
                        c.g && c.g.streaming.clearDecodingCache && (og.clear(), Ub.clear());
                        c.i = null;
                        c.C = new Ko;
                        c.Gi = null;
                        c.hc = null;
                        c.S = null;
                        c.$e = -1;
                        c.Xe = [];
                        w = u(c.Fc.values());
                        for(x = w.next(); !x.done; x = w.next())y = x.value, y.stop();
                        c.Fc.clear();
                        c.kb = [];
                        c.Bg = -1;
                        c.M && c.M.Ri();
                        Ir(c);
                    case 3:
                        z.A();
                        c.X.release();
                        z.C(4);
                        break;
                    case 4:
                        Xb();
                        if (a && Ad() && !c.H && c.h) return z.g(Hr(c), 0);
                        z.B(0);
                }
            });
        };
        p.Gm = function(a) {
            this.O = a;
        };
        p.load = function(a, b, c) {
            b = b === void 0 ? null : b;
            var d = this, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        if (d.m == zr) throw new T(2, 7, 7E3);
                        if (d.h || !d.$) {
                            z.B(2);
                            break;
                        }
                        return z.g(d.Ob(d.$, !0), 3);
                    case 3:
                        d.$ = null;
                    case 2:
                        e = null;
                        f = "";
                        c = (g = c) == null ? void 0 : g.toLowerCase();
                        if (a instanceof To) {
                            if (a.l) throw new T(2, 7, 7006);
                            e = a;
                            f = e.dd() || "";
                        } else f = a || "";
                        return z.g(or(d.X, "load"), 4);
                    case 4:
                        d.X.release();
                        if (!d.h) throw new T(2, 7, 7002);
                        if (!d.V) {
                            z.B(5);
                            break;
                        }
                        d.V = f;
                        return z.g(d.tc(!1), 5);
                    case 5:
                        h = ++d.Ze;
                        k = function() {
                            return H(function(A) {
                                if (A.h == 1) return d.Ze == h ? A.B(0) : e ? A.g(e.destroy(), 3) : A.B(3);
                                throw new T(2, 7, 7E3);
                            });
                        };
                        l = function(A, E) {
                            return H(function(C) {
                                switch(C.h){
                                    case 1:
                                        return C.F(2), C.g(or(d.X, E), 4);
                                    case 4:
                                        return C.g(k(), 5);
                                    case 5:
                                        return C.g(A(), 6);
                                    case 6:
                                        return C.g(k(), 7);
                                    case 7:
                                        e && d.g && (e.g = d.g);
                                    case 2:
                                        C.A(), d.X.release(), C.C(0);
                                }
                            });
                        };
                        z.m(7, 8);
                        b == null && e && (b = e.getStartTime());
                        d.O = b;
                        d.Oa = !1;
                        d.dispatchEvent(yr("loading"));
                        if (e) {
                            c = e.S;
                            z.B(10);
                            break;
                        }
                        if (c) {
                            z.B(10);
                            break;
                        }
                        return z.g(l(function() {
                            return H(function(A) {
                                if (A.h == 1) return A.g(Jr(d, f), 2);
                                c = A.i;
                                A.j();
                            });
                        }, "guessMimeType_"), 10);
                    case 10:
                        m = !!e;
                        if (e) {
                            Wo(e, d);
                            d.C = e.getStats();
                            z.B(13);
                            break;
                        }
                        return z.g(Kr(d, f, b, c, !0, d.g), 14);
                    case 14:
                        (e = z.i) ? (e.F = !1, Wo(e, d), d.C = e.getStats(), e.start(), e.C.catch(function() {})) : d.C = new Ko;
                    case 13:
                        n = !e;
                        q = Date.now() / 1E3;
                        d.C = e ? e.getStats() : new Ko;
                        d.V = f;
                        d.Ga = c || null;
                        Ir(d);
                        r = function() {
                            var A = d.h ? d.h.buffered : null;
                            return {
                                start: Uj(A) || 0,
                                end: Vj(A) || 0
                            };
                        };
                        d.ya = new Lm(r);
                        d.ya.addEventListener("regionadd", function(A) {
                            Lr(d, A.region, "metadataadded");
                        });
                        if (n) return z.g(l(function() {
                            return H(function(A) {
                                return A.g(Mr(d, c), 0);
                            });
                        }, "initializeSrcEqualsDrmInner_"), 25);
                        d.jb = new Lm(r);
                        return z.g(l(function() {
                            return H(function(A) {
                                if (A.h == 1) return A.g(Promise.race([
                                    e.$,
                                    e.C
                                ]), 2);
                                d.Gc = e.H;
                                var E = e;
                                E.ba = !0;
                                d.I = E.m;
                                d.i = e.sh();
                                A.j();
                            });
                        }, "waitForFinish"), 17);
                    case 17:
                        if (d.H) {
                            z.B(18);
                            break;
                        }
                        return z.g(l(function() {
                            return H(function(A) {
                                return A.g(Hr(d), 0);
                            });
                        }, "initializeMediaSourceEngineInner_"), 18);
                    case 18:
                        return d.i && d.i.textStreams.length && (d.A.enableTextDisplayer ? d.A.enableTextDisplayer() : md("Text displayer w/ enableTextDisplayer", 'Text displayer should have a "enableTextDisplayer" method!')), z.g(l(function() {
                            return H(function(A) {
                                return A.g(e.C, 0);
                            });
                        }, "waitForFinish"), 20);
                    case 20:
                        d.g = e.getConfiguration();
                        d.Re = e.G;
                        d.I && d.I.setMediaElement && d.h && d.I.setMediaElement(d.h);
                        d.Ne = Xo(e);
                        d.Le = e.Ga;
                        if (t = e.D) d.J = t;
                        m && d.h && d.h.nodeName === "AUDIO" && (Nr(d), d.configure("manifest.disableVideo", !0));
                        if (e.j) {
                            z.B(21);
                            break;
                        }
                        return z.g(l(function() {
                            return H(function(A) {
                                return A.g(bp(e, d.h), 0);
                            });
                        }, "drmEngine_.init"), 21);
                    case 21:
                        return d.F = Yo(e), z.g(l(function() {
                            return H(function(A) {
                                return A.g(d.F.Ob(d.h), 0);
                            });
                        }, "drmEngine_.attach"), 23);
                    case 23:
                        return v = d.g.abrFactory, d.o && d.Te == v || (d.Te = v, d.o && d.o.release(), d.o = v(), typeof d.o.setMediaElement != "function" && (md("AbrManager w/o setMediaElement", "Please use an AbrManager with setMediaElement function."), d.o.setMediaElement = function() {}), typeof d.o.setCmsdManager != "function" && (md("AbrManager w/o setCmsdManager", "Please use an AbrManager with setCmsdManager function."), d.o.setCmsdManager = function() {}), typeof d.o.trySuggestStreams != "function" && (md("AbrManager w/o trySuggestStreams", "Please use an AbrManager with trySuggestStreams function."), d.o.trySuggestStreams = function() {}), d.o.configure(d.g.abr)), w = Zo(e), x = e.i, z.g(l(function() {
                            return H(function(A) {
                                return A.g(Or(d, q, x, w), 0);
                            });
                        }, "loadInner_"), 24);
                    case 24:
                        Vo(e);
                        d.Ga && Xb().lg() && Hf(d.Ga) && Xk(d.H, d.V, d.Ga);
                        z.B(16);
                        break;
                    case 25:
                        return z.g(l(function() {
                            return H(function(A) {
                                return A.g(Pr(d, q, c), 0);
                            });
                        }, "srcEqualsInner_"), 16);
                    case 16:
                        d.dispatchEvent(yr("loaded"));
                    case 8:
                        z.A();
                        if (!e) {
                            z.B(27);
                            break;
                        }
                        return z.g(e.destroy(), 27);
                    case 27:
                        d.ab = null;
                        z.C(0);
                        break;
                    case 7:
                        y = z.l();
                        if (!y || y.code == 7E3) {
                            z.B(29);
                            break;
                        }
                        return z.g(d.tc(!1), 29);
                    case 29:
                        throw y;
                }
            });
        };
        function Nr(a) {
            for(var b = u(a.i.variants), c = b.next(); !c.done; c = b.next())c = c.value, c.video && (c.video.closeSegmentIndex(), c.video = null), c.bandwidth = c.audio && c.audio.bandwidth ? c.audio.bandwidth : 0;
            a.i.variants = a.i.variants.filter(function(d) {
                return d.audio;
            });
        }
        p.gk = function(a, b, c) {
            a = a === void 0 ? !0 : a;
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? !1 : c;
            var d = this, e;
            return H(function(f) {
                return f.h == 1 ? f.g(Qr(d, c), 2) : f.h != 3 ? (e = f.i, f.g(d.tc(a, b), 3)) : f.return(e);
            });
        };
        p.Vi = function(a, b) {
            a = a === void 0 ? !1 : a;
            b = b === void 0 ? !1 : b;
            var c = this, d;
            return H(function(e) {
                return e.h == 1 ? e.g(Qr(c, b), 2) : e.h != 3 ? (d = e.i, e.g(c.detach(a), 3)) : e.return(d);
            });
        };
        function Qr(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) {
                    c = null;
                    if (!(a.i && a.I && a.Gc && a.V && a.g)) return f.B(2);
                    d = a.h.currentTime;
                    b || (d = null);
                    return f.g(Rr(a, a.V, d, a.Ga, a.g, !0, !1), 3);
                }
                if (f.h != 2) {
                    c = f.i;
                    a.Ve.push(c);
                    a.I && a.I.setMediaElement && a.I.setMediaElement(null);
                    if (e = a.l ? a.l.o : null) c.i = e;
                    var g = c, h = a.I, k = a.Gc;
                    g.h = a.i;
                    g.m = h;
                    g.H = k;
                    c.D = a.J;
                    c.start();
                    a.i = null;
                    a.I = null;
                    a.Gc = null;
                    a.o = null;
                    a.Te = null;
                }
                return f.return(c);
            });
        }
        p.preload = function(a, b, c, d) {
            b = b === void 0 ? null : b;
            var e = this, f, g, h;
            return H(function(k) {
                if (k.h == 1) return c = (f = c) == null ? void 0 : f.toLowerCase(), g = qr(e), Eo(g, d || e.g, qr(e)), k.g(Kr(e, a, b, c, !1, g), 2);
                (h = k.i) ? h.start() : Gr(e, new T(2, 7, 7005));
                return k.return(h);
            });
        };
        p.Vg = function() {
            var a = this, b, c, d, e;
            return H(function(f) {
                b = [];
                c = u(a.Ve);
                for(d = c.next(); !d.done; d = c.next())e = d.value, e.l || b.push(e.destroy());
                a.Ve = [];
                return f.g(Promise.all(b), 0);
            });
        };
        function Kr(a, b, c, d, e, f) {
            e = e === void 0 ? !1 : e;
            var g, h, k, l;
            return H(function(m) {
                if (m.h == 1) return d ? m.B(2) : m.g(Jr(a, b), 3);
                m.h != 2 && (d = m.i);
                if (g = Sr(a, d)) return m.return(null);
                h = f || a.g;
                k = !1;
                e && a.h && a.h.nodeName === "AUDIO" && (k = !0);
                l = Rr(a, b, c, d || null, h, !e, k);
                l = e ? l.then(function(n) {
                    n.F = !1;
                    return n;
                }) : l.then(function(n) {
                    a.Ve.push(n);
                    return n;
                });
                return m.return(l);
            });
        }
        function Rr(a, b, c, d, e, f, g) {
            f = f === void 0 ? !0 : f;
            g = g === void 0 ? !1 : g;
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            return H(function(C) {
                if (C.h == 1) {
                    h = null;
                    k = Xd(e);
                    g && (k.manifest.disableVideo = !0);
                    l = function() {
                        return h.P && h.l ? null : h;
                    };
                    m = function() {
                        return l() ? l().getConfiguration() : a.g;
                    };
                    if (a.ua.width != Infinity || a.ua.height != Infinity || a.g.ignoreHardwareResolution) return C.B(2);
                    n = Xb();
                    return C.g(n.vc(), 3);
                }
                C.h != 2 && (q = C.i, a.ua.width = q.width, a.ua.height = q.height);
                r = new Li(k, a.ua, null);
                t = {
                    networkingEngine: a.M,
                    filter: function(D) {
                        var B, J;
                        return H(function(F) {
                            if (F.h == 1) return F.g(Mi(r, D), 2);
                            if (F.h != 4) {
                                B = F.i;
                                if (!B) return F.B(0);
                                J = yr("trackschanged");
                                return F.g(Promise.resolve(), 4);
                            }
                            h.dispatchEvent(J);
                            F.j();
                        });
                    },
                    makeTextStreamsForClosedCaptions: function(D) {
                        return Tr(a, D);
                    },
                    onTimelineRegionAdded: function(D) {
                        Mm(h.I, D);
                    },
                    onEvent: function(D) {
                        return h.dispatchEvent(D);
                    },
                    onError: function(D) {
                        return h.onError(D);
                    },
                    isLowLatencyMode: function() {
                        return m().streaming.lowLatencyMode;
                    },
                    updateDuration: function() {
                        a.l && h.P && a.l.updateDuration();
                    },
                    newDrmInfo: function(D) {
                        var B = h.j, J = B ? B.g : null;
                        J && B.C && Pi(r, J.keySystem, D);
                    },
                    onManifestUpdated: function() {
                        var D = (new Map).set("isLive", a.U());
                        h.dispatchEvent(yr("manifestupdated", D));
                        Uo(h, !1, function() {
                            if (a.D) a.D.onManifestUpdated(a.U());
                        });
                    },
                    getBandwidthEstimate: function() {
                        return a.o.getBandwidthEstimate();
                    },
                    onMetadata: function(D, B, J, F) {
                        var I = D;
                        if (D == "com.apple.hls.interstitial" || D == "com.apple.hls.overlay") {
                            if (I = "com.apple.quicktime.HLS", D = {
                                startTime: B,
                                endTime: J,
                                values: F
                            }, a.D) a.D.onHLSInterstitialMetadata(a, a.h, D);
                        }
                        F = u(F);
                        D = F.next();
                        for(var K = {}; !D.done; K = {
                            Uh: void 0
                        }, D = F.next())K.Uh = D.value, K.Uh.name != "ID" && Uo(h, !1, function(N) {
                            return function() {
                                Ur(a, B, J, I, N.Uh);
                            };
                        }(K));
                    },
                    disableStream: function(D) {
                        return a.disableStream(D, a.g.streaming.maxDisabledTime);
                    },
                    addFont: function(D, B) {
                        return a.addFont(D, B);
                    }
                };
                v = new Lm(function() {
                    return a.wa();
                });
                v.addEventListener("regionadd", function(D) {
                    var B = D.region;
                    Vr(a, "timelineregionadded", B, h);
                    Uo(h, !1, function() {
                        a.D && (a.D.onDashTimedMetadata(B), a.D.onDASHInterstitialMetadata(a, a.h, B));
                    });
                });
                w = null;
                k.streaming.observeQualityChanges && (w = new Fm(function() {
                    return a.Nc();
                }), w.addEventListener("qualitychange", function(D) {
                    Wr(a, D.quality, D.position);
                }), w.addEventListener("audiotrackchange", function(D) {
                    Wr(a, D.quality, D.position, !0);
                }));
                x = !0;
                y = {
                    Cc: a.M,
                    onError: function(D) {
                        return h.onError(D);
                    },
                    Uf: function(D) {
                        Uo(h, !0, function() {
                            a.F && Xr(a, D);
                        });
                    },
                    onExpirationUpdated: function(D, B) {
                        var J = yr("expirationupdated");
                        h.dispatchEvent(J);
                        if ((J = h.m) && J.onExpirationUpdated) J.onExpirationUpdated(D, B);
                    },
                    onEvent: function(D) {
                        h.dispatchEvent(D);
                        if (D.type == "drmsessionupdate" && x) {
                            x = !1;
                            D = Date.now() / 1E3 - h.va;
                            var B = a.C || h.getStats();
                            D >= 0 && (B.m = D);
                            a.R && ud(a.R);
                        }
                    }
                };
                z = rr(a, l);
                lh(a.M, z);
                A = function() {
                    return a.wd(y);
                };
                E = {
                    config: k,
                    Pl: t,
                    bm: v,
                    am: w,
                    wd: A,
                    Ol: r,
                    networkingEngine: z,
                    rk: f
                };
                h = new To(b, d, c, E);
                return C.return(h);
            });
        }
        function Jr(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) return c = a.g.manifest.retryParameters, g.g(fn(b, a.M, c), 2);
                d = g.i;
                Hf(d) ? (e = Xb(), e.Ma() === "WEBKIT" && (d = "application/vnd.apple.mpegurl")) : d === "video/quicktime" && (f = Xb(), f.Ma() === "CHROMIUM" && (d = "video/mp4"));
                return g.return(d);
            });
        }
        function Sr(a, b) {
            if (!Ad(Xb())) return !0;
            if (b) {
                if ((a.h || Bd()).canPlayType(b) == "") return !1;
                if (!Ad(Xb()) || !yd.has(b)) return !0;
                if (Hf(b)) return Xb().Ma() === "WEBKIT" && (a.g.drm.servers["com.apple.fps"] || a.g.drm.servers["com.apple.fps.1_0"]) ? a.g.streaming.useNativeHlsForFairPlay : a.g.streaming.preferNativeHls;
                if (b === "application/dash+xml" || b === "video/vnd.mpeg.dash.mpd") return a.g.streaming.preferNativeDash;
            }
            return !1;
        }
        function Yr(a, b) {
            var c = a.g.textDisplayFactory;
            a.Gi !== c || (b === void 0 ? 0 : b) ? (b = a.A, a.A = c(), a.A.configure ? a.A.configure(a.g.textDisplayer) : md("Text displayer w/ configure", 'Text displayer should have a "configure" method!'), a.A.setTextLanguage || md("Text displayer w/ setTextLanguage", 'Text displayer should have a "setTextLanguage" method!'), b ? (a.A.setTextVisibility(b.isTextVisible()), b.destroy().catch(function() {})) : a.A.setTextVisibility(a.W), a.H && El(a.H, a.A), a.Gi = c, a.l && An(a.l)) : a.A && a.A.configure && a.A.configure(a.g.textDisplayer);
        }
        function Hr(a) {
            var b, c, d;
            return H(function(e) {
                if (e.h == 1) return Xb(), Dr(a, "media-source"), a.g.mediaSource.useSourceElements && ek(a.h), Yr(a), b = Zr(a.h, a.A, {
                    Uk: function() {
                        return a.keySystem();
                    },
                    onMetadata: function(f, g, h) {
                        f = u(f);
                        for(var k = f.next(); !k.done; k = f.next())if (k = k.value, k.data && typeof k.cueTime == "number" && k.frames) {
                            var l = k.cueTime + g, m = h;
                            m && l > m && (m = l);
                            for(var n = u(k.frames), q = n.next(); !q.done; q = n.next())Ur(a, l, m, "org.id3", q.value);
                            if (a.D) a.D.onHlsTimedMetadata(k, l);
                        }
                    },
                    Vl: function(f) {
                        a.jb && Mm(a.jb, {
                            schemeIdUri: f.schemeIdUri,
                            startTime: f.startTime,
                            endTime: f.endTime,
                            id: String(f.id),
                            emsg: f
                        });
                    },
                    onEvent: function(f) {
                        return a.dispatchEvent(f);
                    },
                    Xl: function() {
                        a.I && a.I.update && a.I.update();
                    }
                }, a.R, a.g.mediaSource), c = a.g.manifest, d = c.segmentRelativeVttTiming, b.Ga = d, e.g(b.L, 2);
                a.H = b;
                e.j();
            });
        }
        function $r(a, b) {
            a.L = new Bm({
                wh: function() {
                    return b.playbackRate;
                },
                Cd: function() {
                    return b.defaultPlaybackRate;
                },
                Qj: function(c) {
                    b.playbackRate = c;
                },
                Tl: function(c) {
                    var d = b.currentTime;
                    if (Wj(b.buffered, d) && !(b.readyState <= HTMLMediaElement.HAVE_CURRENT_DATA)) {
                        c = d + c;
                        var e = a.wa();
                        c < e.start ? d !== e.start && (b.currentTime = e.start) : c > e.end ? d !== e.end && (b.currentTime = e.end) : b.currentTime = c;
                    }
                },
                isPaused: function() {
                    return b.paused;
                }
            });
        }
        function as(a, b, c) {
            function d() {
                return bs(a);
            }
            a.j.u(b, "playing", d);
            a.j.u(b, "pause", d);
            a.j.u(b, "ended", d);
            a.j.u(b, "ratechange", function() {
                return cs(a);
            });
            b.remote && (a.j.u(b.remote, "connect", function() {
                a.l && b.remote.state == "connected" && ds(a);
                es(a);
            }), a.j.u(b.remote, "connecting", function() {
                return es(a);
            }), a.j.u(b.remote, "disconnect", function() {
                return H(function(f) {
                    if (f.h == 1) return a.l && b.remote.state == "disconnected" ? f.g(On(a.l), 3) : f.B(2);
                    f.h != 2 && ds(a);
                    es(a);
                    f.j();
                });
            }));
            b.audioTracks && (a.j.u(b.audioTracks, "addtrack", function() {
                return es(a);
            }), a.j.u(b.audioTracks, "removetrack", function() {
                return es(a);
            }), a.j.u(b.audioTracks, "change", function() {
                return es(a);
            }));
            b.videoTracks && (a.j.u(b.videoTracks, "addtrack", function() {
                return es(a);
            }), a.j.u(b.videoTracks, "removetrack", function() {
                return es(a);
            }), a.j.u(b.videoTracks, "change", function() {
                return es(a);
            }));
            (b.webkitPresentationMode || b.webkitSupportsFullscreen) && a.j.u(b, "webkitpresentationmodechanged", function() {
                a.Oe && Yr(a, !0);
            });
            if (b.textTracks) {
                var e = function() {
                    a.m === fs && a.A instanceof Cp && ds(a);
                    es(a);
                };
                a.j.u(b.textTracks, "addtrack", function(f) {
                    if (f.track) switch(f = f.track, f.kind){
                        case "metadata":
                            gs(a, f);
                            break;
                        case "chapters":
                            hs(a, f);
                            break;
                        default:
                            e();
                    }
                });
                a.j.u(b.textTracks, "removetrack", e);
                a.j.u(b.textTracks, "change", e);
            }
            b.preload != "none" && a.j.ra(b, "loadedmetadata", function() {
                var f = a.C, g = Date.now() / 1E3 - c;
                g >= 0 && (f.G = g);
            });
        }
        function Or(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L;
            return H(function(Q) {
                switch(Q.h){
                    case 1:
                        Dr(a, "load");
                        e = a.h;
                        $r(a, e);
                        as(a, e, b);
                        "onchange" in window1.screen && a.j.u(window1.screen, "change", function() {
                            if (a.J.getConfiguration) {
                                var S = a.J.getConfiguration();
                                S.hdrLevel == "AUTO" ? is(a) : a.g.preferredVideoHdrLevel == "AUTO" && a.g.abr.enabled && (S.hdrLevel = "AUTO", a.J.configure(S), is(a));
                            }
                        });
                        f = !1;
                        g = u(a.i.variants);
                        for(h = g.next(); !h.done; h = g.next())k = h.value, (l = k.video && k.video.dependencyStream) && (f = vd(l));
                        xr(a, a.g, f);
                        a.Zd = a.g.preferredTextLanguage;
                        a.ce = a.g.preferredTextRole;
                        a.be = a.g.preferForcedSubs;
                        js(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
                        a.o.init(function(S, Z, pa) {
                            a.i && a.l && S != a.l.o && ks(a, S, !0, Z === void 0 ? !1 : Z, pa === void 0 ? 0 : pa);
                        });
                        a.o.setMediaElement(e);
                        a.o.setCmsdManager(a.na);
                        a.l = ls(a);
                        a.l.configure(a.g.streaming);
                        a.m = ms;
                        a.dispatchEvent(yr("streaming"));
                        m = c;
                    case 2:
                        q = a.l.o;
                        q || (r = ns(a, !0), c || (m = r));
                        t = [];
                        n = q || m;
                        v = u([
                            n.video,
                            n.audio
                        ]);
                        for(w = v.next(); !w.done; w = v.next())(x = w.value) && !x.segmentIndex && (t.push(x.createSegmentIndex()), x.dependencyStream && t.push(x.dependencyStream.createSegmentIndex()));
                        if (!(t.length > 0)) {
                            Q.B(4);
                            break;
                        }
                        return Q.g(Promise.all(t), 4);
                    case 4:
                        if (!n || n.disabledUntilTime != 0) {
                            Q.B(2);
                            break;
                        }
                        is(a);
                        if (a.I && a.I.onInitialVariantChosen) a.I.onInitialVariantChosen(n);
                        a.i.isLowLatency && (a.g.streaming.lowLatencyMode ? a.configure(a.Dg) : Za("Low-latency live stream detected, but low-latency streaming mode is not enabled in Shaka Player. Set streaming.lowLatencyMode configuration to true, and see https://bit.ly/3clctcj for details."));
                        a.K && (Wp(a.K, a.i.isLowLatency && a.g.streaming.lowLatencyMode), aq(a.K, b * 1E3));
                        js(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
                        qn(a.l, a.g.playRangeStart, a.g.playRangeEnd);
                        a.Oa = !0;
                        a.dispatchEvent(yr("canupdatestarttime"));
                        y = function(S) {
                            a.G = os(a, S);
                            a.Kb = ps(a, S);
                            qs(a, e, !1);
                        };
                        a.g.streaming.startAtSegmentBoundary || (z = a.O, z == null && a.i.startTime && (z = a.i.startTime), y(z));
                        if (q) {
                            Q.B(7);
                            break;
                        }
                        if (!a.g.streaming.startAtSegmentBoundary) {
                            Q.B(8);
                            break;
                        }
                        A = a.i.presentationTimeline;
                        a.O instanceof Date && (C = A.m || A.i, D = a.O.getTime() / 1E3 - C, D != null && (E = D));
                        E == null && (E = typeof a.O === "number" ? a.O : a.U() ? Infinity : a.h.currentTime);
                        a.O == null && a.i.startTime && (E = a.i.startTime);
                        B = A.cc();
                        J = A.Gb();
                        E < B ? E = B : E > J && (E = J);
                        return Q.g(rs(m, E), 9);
                    case 9:
                        F = Q.i, y(F);
                    case 8:
                        ks(a, m, !0, !1, 0);
                    case 7:
                        return a.G.ready(), I = a.yc().find(function(S) {
                            return S.active;
                        }), I || ((K = Gg(a.i.textStreams, a.Zd, a.ce, a.be)[0] || null) && Jo(a.C.h, K, !0), m && (K ? (Og(m.audio, K, a.g) && (a.W = !0), a.W && a.A.setTextVisibility(!0)) : (a.W = !1, a.A.setTextVisibility(!1)), ss(a)), K && (a.g.streaming.alwaysStreamText || a.Tc()) && (zn(a.l, K), ts(a))), Q.g(a.l.start(d), 10);
                    case 10:
                        a.g.abr.enabled && (a.o.enable(), us(a));
                        es(a);
                        a.i.variants.some(function(S) {
                            return S.primary;
                        });
                        if ((N = a.U()) && (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled || a.i.serviceDescription || a.g.streaming.liveSync.panicMode) || a.g.streaming.vodDynamicPlaybackRate) P = function() {
                            return vs(a);
                        }, a.j.u(e, "timeupdate", P);
                        N || (M = function() {
                            return ws(a);
                        }, a.j.u(e, "timeupdate", M), ws(a), a.i.nextUrl && (a.g.streaming.preloadNextUrlWindow > 0 && (L = function() {
                            var S;
                            return H(function(Z) {
                                if (Z.h == 1) {
                                    S = a.wa().end - a.h.currentTime;
                                    if (isNaN(S) || !(S <= a.g.streaming.preloadNextUrlWindow)) return Z.B(0);
                                    a.j.Fa(e, "timeupdate", L);
                                    return Z.g(a.preload(a.i.nextUrl), 4);
                                }
                                a.ab = Z.i;
                                Z.j();
                            });
                        }, a.j.u(e, "timeupdate", L)), a.j.u(e, "ended", function() {
                            a.load(a.ab || a.i.nextUrl);
                        })));
                        if (a.D) a.D.onManifestUpdated(N);
                        Q.j();
                }
            });
        }
        function Mr(a, b) {
            var c, d, e;
            return H(function(f) {
                return f.h == 1 ? (c = Date.now() / 1E3, d = !0, a.F = a.wd({
                    Cc: a.M,
                    onError: function(g) {
                        Gr(a, g);
                    },
                    Uf: function() {},
                    onExpirationUpdated: function() {
                        var g = yr("expirationupdated");
                        a.dispatchEvent(g);
                    },
                    onEvent: function(g) {
                        a.dispatchEvent(g);
                        if (g.type == "drmsessionupdate" && d) {
                            d = !1;
                            g = a.C;
                            var h = Date.now() / 1E3 - c;
                            h >= 0 && (g.m = h);
                        }
                    }
                }), a.F.configure(a.g.drm), e = Pg([
                    b
                ]), a.F.O = !0, f.g(Vh(a.F, [
                    e
                ], []), 2)) : f.g(a.F.Ob(a.h), 0);
            });
        }
        function Pr(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                switch(v.h){
                    case 1:
                        Dr(a, "src-equals");
                        d = a.h;
                        a.G = new nm(d);
                        e = !1;
                        a.Qe.push(function() {
                            e = !0;
                        });
                        a.dispatchEvent(yr("canupdatestarttime"));
                        a.O != null && a.G.Ag(a.O);
                        a.Kb = xs(a, a.O || 0);
                        $r(a, d);
                        qs(a, d, !0);
                        d.textTracks && (Yr(a), f = function(w) {
                            if (!(a.A instanceof Cp)) {
                                var x = ys(a).find(function(y) {
                                    return y.mode !== "disabled";
                                });
                                x && (x.mode = w ? "showing" : "hidden");
                                a.A instanceof Dp && (x = zs(a)) && (x.mode = !w && a.A.isTextVisible() ? "showing" : "hidden");
                            }
                        }, a.j.u(d, "enterpictureinpicture", function() {
                            return f(!0);
                        }), a.j.u(d, "leavepictureinpicture", function() {
                            return f(!1);
                        }), d.remote ? (a.j.u(d.remote, "connect", function() {
                            return f(!1);
                        }), a.j.u(d.remote, "connecting", function() {
                            return f(!1);
                        }), a.j.u(d.remote, "disconnect", function() {
                            return f(!1);
                        })) : "webkitCurrentPlaybackTargetIsWireless" in d && a.j.u(d, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                            return f(!1);
                        }), g = d, (g.webkitPresentationMode || g.webkitSupportsFullscreen) && a.j.u(g, "webkitpresentationmodechanged", function() {
                            g.webkitPresentationMode ? f(g.webkitPresentationMode !== "inline") : g.webkitSupportsFullscreen && f(g.webkitDisplayingFullscreen);
                        }));
                        as(a, d, b);
                        h = cq(a.K, a.V, c);
                        !h.includes("#t=") && (a.g.playRangeStart > 0 || isFinite(a.g.playRangeEnd)) && (h += "#t=", a.g.playRangeStart > 0 && (h += a.g.playRangeStart), isFinite(a.g.playRangeEnd) && (h += "," + a.g.playRangeEnd));
                        if (!a.H) {
                            v.B(2);
                            break;
                        }
                        return v.g(a.H.destroy(), 3);
                    case 3:
                        a.H = null;
                    case 2:
                        return ek(d), d.src = h, k = Xb(), k.Pa() == "TV" && d.load(), d.preload != "none" && !d.autoplay && Hf(c) && k.Ma() === "WEBKIT" && d.load(), a.m = fs, a.dispatchEvent(yr("streaming")), l = function() {
                            return new Promise(function(w) {
                                var x = new Uf(w);
                                a.j.u(d.textTracks, "change", function() {
                                    return x.Z(.5);
                                });
                                x.Z(.5);
                            });
                        }, m = new Yg, em(d, HTMLMediaElement.HAVE_METADATA, a.j, function() {
                            return H(function(w) {
                                if (w.h == 1) return a.G.ready(), a.Ga && Hf(a.Ga) ? w.g(l(), 3) : (m.resolve(), w.B(0));
                                m.resolve();
                                w.j();
                            });
                        }), em(d, HTMLMediaElement.HAVE_CURRENT_DATA, a.j, function() {
                            var w, x, y, z, A;
                            return H(function(E) {
                                if (E.h == 1) return E.g(l(), 2);
                                if (e) return E.return();
                                As(a);
                                w = ys(a);
                                w.some(function(C) {
                                    return C.mode === "showing";
                                }) && (a.W = !0, a.A.setTextVisibility(!0));
                                if (!(a.A instanceof Cp)) for(w.length && (a.A.enableTextDisplayer ? a.A.enableTextDisplayer() : md("Text displayer w/ enableTextDisplayer", 'Text displayer should have a "enableTextDisplayer" method')), x = !1, y = u(w), z = y.next(); !z.done; z = y.next())A = z.value, A.mode !== "disabled" && (x ? (A.mode = "disabled", Za("Found more than one enabled text track, disabling it", A)) : (Bs(a, A), x = !0));
                                Cs(a);
                                E.j();
                            });
                        }), d.error ? m.reject(Fr(a)) : d.preload == "none" && (Za('With <video preload="none">, the browser will not load anything until play() is called. We are unable to measure load latency in a meaningful way, and we cannot provide track info yet. Please do not use preload="none" with Shaka Player.'), m.resolve()), a.j.ra(d, "error", function() {
                            m.reject(Fr(a));
                        }), v.g($f(a.g.streaming.loadTimeout, m), 4);
                    case 4:
                        if ((n = a.U()) && (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled || a.g.streaming.liveSync.panicMode) || a.g.streaming.vodDynamicPlaybackRate) q = function() {
                            return vs(a);
                        }, a.j.u(d, "timeupdate", q);
                        n || (r = function() {
                            return ws(a);
                        }, a.j.u(d, "timeupdate", r), ws(a));
                        a.D && (a.D.onManifestUpdated(n), n && (t = a.wa().end, a.j.u(d, "progress", function() {
                            var w = a.wa().end;
                            t != w && (a.D.onManifestUpdated(a.U()), t = w);
                        })));
                        a.Oa = !0;
                        v.j();
                }
            });
        }
        function As(a) {
            var b = a.g.preferredAudioLanguage;
            b != "" && a.Ij(b, a.g.preferredAudioRole);
        }
        function Cs(a) {
            var b = a.g.preferredTextLanguage;
            b != "" && a.ei(b, a.g.preferredTextRole, a.g.preferForcedSubs);
        }
        function gs(a, b) {
            if (b.kind == "metadata") {
                b.mode = "hidden";
                a.j.u(b, "cuechange", function() {
                    if (b.activeCues) {
                        for(var d = u(b.activeCues), e = d.next(); !e.done; e = d.next())if (e = e.value, Ur(a, e.startTime, e.endTime, e.type, e.value), a.D) a.D.onCueMetadataChange(e.value);
                    }
                    if (b.cues) {
                        d = [];
                        e = u(b.cues);
                        for(var f = e.next(), g = {}; !f.done; g = {
                            Lc: void 0
                        }, f = e.next())g.Lc = f.value, g.Lc.type == "com.apple.quicktime.HLS" && g.Lc.startTime != null && (f = d.find(function(h) {
                            return function(k) {
                                return k.startTime == h.Lc.startTime && k.endTime == h.Lc.endTime;
                            };
                        }(g)), f || (f = {
                            startTime: g.Lc.startTime,
                            endTime: g.Lc.endTime,
                            values: []
                        }, d.push(f)), f.values.push(g.Lc.value));
                        d = u(d);
                        for(e = d.next(); !e.done; e = d.next())e = e.value, e.values.some(function(h) {
                            return h.key == "X-ASSET-URI" || h.key == "X-ASSET-LIST";
                        }) && a.D && (e.values.push({
                            key: "CUE",
                            description: "",
                            data: e.startTime != 0 || a.U() ? "ONCE" : "ONCE,PRE",
                            mimeType: null,
                            pictureType: null
                        }), a.D.onHLSInterstitialMetadata(a, a.h, e));
                    }
                });
                var c = new Uf(function() {
                    var d = Ds(a);
                    d = u(d);
                    for(var e = d.next(); !e.done; e = d.next())e.value.mode = "hidden";
                }).La().Z(.5);
                a.Qe.push(function() {
                    c.stop();
                });
            }
        }
        function Lr(a, b, c) {
            b = (new Map).set("startTime", b.startTime).set("endTime", b.endTime).set("metadataType", b.schemeIdUri).set("payload", b.payload);
            a.dispatchEvent(yr(c, b));
        }
        function Ur(a, b, c, d, e) {
            a.ya && (b = {
                schemeIdUri: d,
                startTime: b,
                endTime: c || Infinity,
                id: "",
                payload: e
            }, b.id = JSON.stringify(b), Mm(a.ya, b));
        }
        function hs(a, b) {
            if (b && b.kind == "chapters") {
                b.mode = "hidden";
                var c = new Uf(function() {
                    b.mode = "hidden";
                }).La().Z(.5);
                a.Qe.push(function() {
                    c.stop();
                });
            }
        }
        p.hm = function() {
            for(var a = this.X; a.g;)a.release();
        };
        p.wd = function(a) {
            return new Oh(a);
        };
        function rr(a, b) {
            function c(f) {
                b() ? b().dispatchEvent(f) : a.dispatchEvent(f);
            }
            function d(f) {
                b() ? Uo(b(), !0, f) : f();
            }
            b || (b = function() {
                return null;
            });
            var e = new hh(function(f, g, h, k, l) {
                d(function() {
                    a.o && a.o.segmentDownloaded(f, g, h, k, l);
                });
            }, function(f, g, h) {
                g = (new Map).set("headers", f).set("request", g).set("requestType", h);
                c(yr("downloadheadersreceived", g));
                d(function() {
                    if (a.na) {
                        var k = a.na;
                        if (k.h.enabled) {
                            var l = f["cmsd-static"];
                            if (l) try {
                                var m = new Map, n = l.split(",");
                                for(l = 0; l < n.length; l++){
                                    var q = n[l].split("=");
                                    m.set(q[0], mr(q[1]));
                                }
                            } catch (x) {}
                            if (m = f["cmsd-dynamic"]) {
                                a: {
                                    try {
                                        var r = new Map, t = m.split(";");
                                        for(m = 1; m < t.length; m++){
                                            var v = t[m].split("=");
                                            r.set(v[0], mr(v[1]));
                                        }
                                        var w = r;
                                        break a;
                                    } catch (x) {
                                        w = null;
                                        break a;
                                    }
                                    w = void 0;
                                }
                                w && (k.g = w);
                            }
                        }
                    }
                });
            }, function(f, g) {
                f = (new Map).set("request", f).set("response", g);
                c(yr("downloadcompleted", f));
            }, function(f, g, h, k) {
                f = (new Map).set("request", f).set("error", g).set("httpResponseCode", h).set("aborted", k);
                c(yr("downloadfailed", f));
            }, function(f, g, h) {
                d(function() {
                    if (a.K) {
                        var k = a.K, l = h;
                        l = l === void 0 ? {} : l;
                        if (k.g.enabled) {
                            if (g.method === "HEAD") Oq(k, g, {});
                            else switch(f){
                                case 0:
                                    try {
                                        if (k.g.enabled) {
                                            if (l.type) {
                                                a: {
                                                    switch(l.type){
                                                        case 4:
                                                            var m = k.A ? Yp : Xp;
                                                            break a;
                                                        case 3:
                                                        case 2:
                                                            m = k.A ? $p : Zp;
                                                            break a;
                                                        case 5:
                                                            m = "s";
                                                            break a;
                                                    }
                                                    m = void 0;
                                                }
                                                k.l = m;
                                            }
                                            Oq(k, g, {
                                                ot: gq,
                                                su: !k.F
                                            });
                                        }
                                    } catch (q) {
                                        $a("CMCD_MANIFEST_ERROR", "Could not generate manifest CMCD data.", q);
                                    }
                                    break;
                                case sh:
                                    try {
                                        if (k.g.enabled) {
                                            var n = cr(k, l, g.uris[0]);
                                            n.ts = Date.now();
                                            k.m.has(g) && k.m.delete(g);
                                            k.m.set(g, n.ts);
                                            Oq(k, g, n);
                                        }
                                    } catch (q) {
                                        $a("CMCD_SEGMENT_ERROR", "Could not generate segment CMCD data.", q);
                                    }
                                    break;
                                case 2:
                                case 5:
                                case 6:
                                    Oq(k, g, {
                                        ot: "k"
                                    });
                                    break;
                                case 4:
                                    Oq(k, g, {
                                        ot: "o"
                                    });
                            }
                        }
                    }
                });
            }, function(f, g, h, k) {
                (f = b() ? b().m : a.I) && f.banLocation && f.banLocation(k);
            }, function(f, g, h) {
                if (g.data) {
                    var k = g.data.byteLength, l = b() ? b().getStats() : a.C;
                    l && (Ro(l, k), f === 0 && (l.nj = k));
                    k = a.K;
                    h = h === void 0 ? {} : h;
                    if (nq(k).length !== 0) switch(f){
                        case sh:
                            try {
                                var m = cr(k, h, g.uri);
                                g.originalRequest && g.originalRequest.timeToFirstByte != null && (m.ttfb = g.originalRequest.timeToFirstByte);
                                g.timeMs != null && (m.ttlb = g.timeMs);
                                var n = g.originalUri || g.uri;
                                if (n.includes("CMCD=")) try {
                                    var q = new URL(n);
                                    q.searchParams.delete("CMCD");
                                    var r = q.toString();
                                } catch (D) {
                                    r = n;
                                }
                                else r = n;
                                m.url = r;
                                k.m.has(g.originalRequest) ? (m.ts = k.m.get(g.originalRequest), k.m.delete(g.originalRequest)) : m.ts || (m.ts = Date.now());
                                var t = nq(k);
                                if (t.length !== 0) {
                                    var v = k.g.version == qq ? Array.from(new Set([].concat(G(rq), G(gr)))) : Sq;
                                    m.rc = g.status || 0;
                                    var w = pq(k, m, oq);
                                    g.headers && g.headers["CMSD-Static"] && (w.cmsds = btoa(g.headers["CMSD-Static"]));
                                    g.headers && g.headers["CMSD-Dynamic"] && (w.cmsdd = btoa(g.headers["CMSD-Dynamic"]));
                                    for(var x = u(t), y = x.next(); !y.done; y = x.next()){
                                        var z = y.value, A = tq(z.includeKeys || [], v), E = Qq(z);
                                        k.o[E] || (k.o[E] = {
                                            request: 1,
                                            response: 1
                                        });
                                        w.sn = k.o[E].response++;
                                        var C = Kq(w, A);
                                        Nq(k, C, z, g);
                                    }
                                }
                            } catch (D) {
                                $a("CMCD_SEGMENT_ERROR", "Could not generate response segment CMCD data.", D);
                            }
                    }
                }
            });
            e.configure(a.g.networking);
            return e;
        }
        function os(a, b) {
            return new qm(a.h, a.i, a.g.streaming, b, function() {
                a.Kb && Em(a.Kb, !a.G.Ei());
                a.l && a.l.ld();
                a.P && Es(a, "seeking");
            }, function(c) {
                return a.dispatchEvent(c);
            });
        }
        function ps(a, b) {
            var c = a.U() || typeof b === "number" && b > 0;
            b = new mp(a.Ne, c);
            b.addEventListener("enter", function(f) {
                Vr(a, "timelineregionenter", f.region);
            });
            b.addEventListener("exit", function(f) {
                Vr(a, "timelineregionexit", f.region);
            });
            b.addEventListener("skip", function(f) {
                var g = f.region;
                f.seeking || (Vr(a, "timelineregionenter", g), Vr(a, "timelineregionexit", g));
            });
            var d = new mp(a.ya, c);
            d.addEventListener("enter", function(f) {
                Lr(a, f.region, "metadata");
            });
            c = new mp(a.jb, c);
            c.addEventListener("enter", function(f) {
                f = (new Map).set("detail", f.region.emsg);
                a.dispatchEvent(yr("emsg", f));
            });
            var e = new Dm(a.h);
            e.g.add(b);
            e.g.add(d);
            e.g.add(c);
            a.Le && e.g.add(a.Le);
            return e;
        }
        function xs(a, b) {
            b = new mp(a.ya, b instanceof Date || b > 0);
            b.addEventListener("enter", function(d) {
                Lr(a, d.region, "metadata");
            });
            var c = new Dm(a.h);
            c.g.add(b);
            return c;
        }
        function qs(a, b, c) {
            a.P = new Hi;
            Ki(a.P, Ji);
            Fs(a);
            Ir(a);
            a.Ia = new Uf(function() {
                Es(a);
            });
            a.g.streaming.rebufferingGoal && a.Ia.xa(.25);
            a.j.u(b, "waiting", function() {
                return Es(a, "waiting");
            });
            a.j.u(b, "canplaythrough", function() {
                return Es(a, "canplaythrough");
            });
            a.j.u(b, "playing", function() {
                return Es(a, "playing");
            });
            a.j.u(b, "seeked", function() {
                return Es(a, "seeked");
            });
            a.j.u(b, "timeupdate", function() {
                return Es(a, "timeupdate");
            });
            c && (a.j.u(b, "progress", function() {
                return Es(a, "progress");
            }), a.j.u(b, "stalled", function() {
                return Es(a, "stalled");
            }));
        }
        function Fs(a) {
            var b = a.g.streaming.rebufferingGoal;
            a.P.j.set(Ii, Math.min(.5, b / 2)).set(Ji, b);
        }
        function Es(a, b) {
            if (a.g.streaming.rebufferingGoal) {
                b = a.H ? $k(a.H) : !1;
                b = a.isEnded() || b || a.G.jj();
                var c = Xj(a.h.buffered, a.h.currentTime), d = a.P, e = d.j.get(d.g);
                Ki(d, b || c >= e && c > 0 ? Ii : Ji) && Ir(a);
            } else if (b) {
                c = a.P;
                d = a.h.currentTime;
                e = c.h;
                c.h = d;
                var f = void 0;
                switch(b){
                    case "seeking":
                    case "waiting":
                        c.h = -1;
                        f = Ji;
                        break;
                    case "canplaythrough":
                    case "playing":
                    case "seeked":
                        f = Ii;
                        break;
                    case "timeupdate":
                        e >= 0 && d - e > .01 && (f = Ii);
                }
                f !== void 0 && Ki(c, f) && Ir(a);
            }
        }
        function Zr(a, b, c, d, e) {
            return new Sk(a, b, c, e, d);
        }
        function ls(a) {
            return new kn(a.i, {
                bc: function() {
                    return a.G ? a.G.ee() : 0;
                },
                getBandwidthEstimate: function() {
                    return a.o.getBandwidthEstimate();
                },
                Wa: function() {
                    return a.Wa();
                },
                video: a.h,
                aa: a.H,
                Cc: a.M,
                onError: function(b) {
                    return Gr(a, b);
                },
                onEvent: function(b) {
                    return a.dispatchEvent(b);
                },
                Md: function(b, c, d, e) {
                    var f = b.startTime, g = b.endTime, h = c.type;
                    if (h != Ec) {
                        if (a.G) {
                            a.G.uj();
                            var k = gl(a.H, h);
                            !a.U() && a.h.paused && !a.h.seeking && k != null && k > 0 && a.G.ee() < k && !rk(a.G.ee(), k, .001) && a.G.Ag(k);
                        }
                        Es(a);
                    }
                    d = (new Map).set("start", f).set("end", g).set("contentType", h).set("isMuxed", d).set("isDependency", e);
                    a.dispatchEvent(yr("segmentappended", d));
                    a.o && c.fastSwitching && b.hd && b.we && a.o.trySuggestStreams();
                },
                Wl: function(b, c) {
                    (c = c.Kd) && a.Le && Hm(a.Le, c, b);
                },
                Ni: function(b, c) {
                    var d = a.F;
                    if (d.h.parseInbandPsshEnabled && !d.H && [
                        "audio",
                        "video"
                    ].includes(b)) {
                        b = new Mh(Fb(c));
                        c = 0;
                        for(var e = u(b.data), f = e.next(); !f.done; f = e.next())c += f.value.length;
                        if (c == 0) d = Promise.resolve();
                        else {
                            c = new Uint8Array(c);
                            e = 0;
                            b = u(b.data);
                            for(f = b.next(); !f.done; f = b.next())f = f.value, c.set(f, e), e += f.length;
                            di(d, "cenc", c);
                            d = d.m;
                        }
                    } else d = Promise.resolve();
                    return d;
                },
                disableStream: function(b, c) {
                    return a.disableStream(b, c);
                },
                Am: function(b, c) {
                    return a.g.abr.enabled && c.fastSwitching && b.hd && b.we ? !1 : !0;
                }
            });
        }
        p.configure = function(a, b) {
            var c = this.getConfiguration();
            arguments.length == 2 && typeof a == "string" && (a = co(a, b));
            "preferredVariantRole" in a && (md("preferredVariantRole configuration", "Please Use preferredAudioRole instead."), a.preferredAudioRole = a.preferredVariantRole, delete a.preferredVariantRole);
            a.streaming && "forceTransmuxTS" in a.streaming && (md("streaming.forceTransmuxTS configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.mediaSource = a.streaming.forceTransmuxTS, delete a.streaming.forceTransmuxTS);
            a.streaming && "forceTransmux" in a.streaming && (md("streaming.forceTransmux configuration", "Please Use mediaSource.forceTransmux instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.mediaSource = a.streaming.forceTransmux, delete a.streaming.forceTransmux);
            if (a.streaming && "useNativeHlsOnSafari" in a.streaming) {
                md("streaming.useNativeHlsOnSafari configuration", "Please Use streaming.useNativeHlsForFairPlay or streaming.preferNativeHls instead.");
                var d = Xb();
                a.streaming.preferNativeHls = a.streaming.useNativeHlsOnSafari && d.Ma() === "WEBKIT";
                delete a.streaming.useNativeHlsOnSafari;
            }
            a.streaming && typeof a.streaming.liveSync == "boolean" && (md("streaming.liveSync", "Please Use streaming.liveSync.enabled instead."), d = a.streaming.liveSync, a.streaming.liveSync = {}, a.streaming.liveSync.enabled = d);
            if (a.streaming && !(a.streaming.liveSync && "targetLatency" in a.streaming.liveSync) && ("liveSyncMinLatency" in a.streaming || "liveSyncMaxLatency" in a.streaming)) {
                d = a.streaming.liveSyncMinLatency || 0;
                var e = Math.abs((a.streaming.liveSyncMaxLatency || 1) - d) / 2;
                a.streaming.liveSync = a.streaming.liveSync || {};
                a.streaming.liveSync.targetLatency = d + e;
                a.streaming.liveSync.targetLatencyTolerance = e;
            }
            a.streaming && "liveSyncMaxLatency" in a.streaming && (md("streaming.liveSyncMaxLatency", "Please Use streaming.liveSync.targetLatency and streaming.liveSync.targetLatencyTolerance instead. Or, set the values in your DASH manifest"), delete a.streaming.liveSyncMaxLatency);
            a.streaming && "liveSyncMinLatency" in a.streaming && (md("streaming.liveSyncMinLatency", "Please Use streaming.liveSync.targetLatency and streaming.liveSync.targetLatencyTolerance instead. Or, set the values in your DASH manifest"), delete a.streaming.liveSyncMinLatency);
            a.streaming && "liveSyncTargetLatency" in a.streaming && (md("streaming.liveSyncTargetLatency", "Please Use streaming.liveSync.targetLatency instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.targetLatency = a.streaming.liveSyncTargetLatency, delete a.streaming.liveSyncTargetLatency);
            a.streaming && "liveSyncTargetLatencyTolerance" in a.streaming && (md("streaming.liveSyncTargetLatencyTolerance", "Please Use streaming.liveSync.targetLatencyTolerance instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.targetLatencyTolerance = a.streaming.liveSyncTargetLatencyTolerance, delete a.streaming.liveSyncTargetLatencyTolerance);
            a.streaming && "liveSyncPlaybackRate" in a.streaming && (md("streaming.liveSyncPlaybackRate", "Please Use streaming.liveSync.maxPlaybackRate instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.maxPlaybackRate = a.streaming.liveSyncPlaybackRate, delete a.streaming.liveSyncPlaybackRate);
            a.streaming && "liveSyncMinPlaybackRate" in a.streaming && (md("streaming.liveSyncMinPlaybackRate", "Please Use streaming.liveSync.minPlaybackRate instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.minPlaybackRate = a.streaming.liveSyncMinPlaybackRate, delete a.streaming.liveSyncMinPlaybackRate);
            a.streaming && "liveSyncPanicMode" in a.streaming && (md("streaming.liveSyncPanicMode", "Please Use streaming.liveSync.panicMode instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.panicMode = a.streaming.liveSyncPanicMode, delete a.streaming.liveSyncPanicMode);
            a.streaming && "liveSyncPanicThreshold" in a.streaming && (md("streaming.liveSyncPanicThreshold", "Please Use streaming.liveSync.panicThreshold instead."), a.streaming.liveSync = a.streaming.liveSync || {}, a.streaming.liveSync.panicThreshold = a.streaming.liveSyncPanicThreshold, delete a.streaming.liveSyncPanicThreshold);
            if (a.mediaSource && "sourceBufferExtraFeatures" in a.mediaSource) {
                md("mediaSource.sourceBufferExtraFeatures configuration", "Please Use mediaSource.addExtraFeaturesToSourceBuffer() instead.");
                var f = a.mediaSource.sourceBufferExtraFeatures;
                a.mediaSource.addExtraFeaturesToSourceBuffer = function() {
                    return f;
                };
                delete a.mediaSource.sourceBufferExtraFeatures;
            }
            a.manifest && a.manifest.hls && "useSafariBehaviorForLive" in a.manifest.hls && (md("manifest.hls.useSafariBehaviorForLive configuration", "Please Use liveSync config to keep on live Edge instead."), delete a.manifest.hls.useSafariBehaviorForLive);
            a.streaming && "parsePrftBox" in a.streaming && (md("streaming.parsePrftBox configuration", "Now fired without needing a configuration."), delete a.streaming.parsePrftBox);
            a.manifest && a.manifest.dash && "enableAudioGroups" in a.manifest.dash && (md("manifest.dash.enableAudioGroups configuration", "Please Use manifest.enableAudioGroups instead."), a.manifest.enableAudioGroups = a.manifest.dash.enableAudioGroups, delete a.manifest.dash.enableAudioGroups);
            a.streaming && "dispatchAllEmsgBoxes" in a.streaming && (md("streaming.dispatchAllEmsgBoxes configuration", "Please Use mediaSource.dispatchAllEmsgBoxes instead."), a.mediaSource = a.mediaSource || {}, a.mediaSource.dispatchAllEmsgBoxes = a.streaming.dispatchAllEmsgBoxes, delete a.streaming.dispatchAllEmsgBoxes);
            a.streaming && "autoLowLatencyMode" in a.streaming && (md("streaming.autoLowLatencyMode configuration", "Please Use streaming.lowLatencyMode instead."), a.streaming.lowLatencyMode = a.streaming.autoLowLatencyMode, delete a.streaming.autoLowLatencyMode);
            a.manifest && a.manifest.dash && "ignoreSupplementalCodecs" in a.manifest.dash && (md("manifest.dash.ignoreSupplementalCodecs configuration", "Please Use manifest.ignoreSupplementalCodecs instead."), a.manifest.ignoreSupplementalCodecs = a.manifest.dash.ignoreSupplementalCodecs, delete a.manifest.dash.ignoreSupplementalCodecs);
            a.manifest && a.manifest.hls && "ignoreSupplementalCodecs" in a.manifest.hls && (md("manifest.hls.ignoreSupplementalCodecs configuration", "Please Use manifest.ignoreSupplementalCodecs instead."), a.manifest.ignoreSupplementalCodecs = a.manifest.hls.ignoreSupplementalCodecs, delete a.manifest.hls.ignoreSupplementalCodecs);
            a.manifest && a.manifest.dash && "updatePeriod" in a.manifest.dash && (md("manifest.dash.updatePeriod configuration", "Please Use manifest.updatePeriod instead."), a.manifest.updatePeriod = a.manifest.dash.updatePeriod, delete a.manifest.dash.updatePeriod);
            a.manifest && a.manifest.hls && "updatePeriod" in a.manifest.hls && (md("manifest.hls.updatePeriod configuration", "Please Use manifest.updatePeriod instead."), a.manifest.updatePeriod = a.manifest.hls.updatePeriod, delete a.manifest.hls.updatePeriod);
            a.manifest && a.manifest.dash && "ignoreDrmInfo" in a.manifest.dash && (md("manifest.dash.ignoreDrmInfo configuration", "Please Use manifest.ignoreDrmInfo instead."), a.manifest.ignoreDrmInfo = a.manifest.dash.ignoreDrmInfo, delete a.manifest.dash.ignoreDrmInfo);
            if (a.drm && a.drm.advanced) {
                d = !1;
                for(var g in a.drm.advanced){
                    var h = a.drm.advanced[g];
                    e = h.videoRobustness;
                    h = h.audioRobustness;
                    "videoRobustness" in a.drm.advanced[g] && !Array.isArray(a.drm.advanced[g].videoRobustness) && (a.drm.advanced[g].videoRobustness = [
                        e
                    ], d = !0);
                    "audioRobustness" in a.drm.advanced[g] && !Array.isArray(a.drm.advanced[g].audioRobustness) && (a.drm.advanced[g].audioRobustness = [
                        h
                    ], d = !0);
                }
                d && md("AdvancedDrmConfiguration's videoRobustness and audioRobustness", "These properties are no longer strings but array of strings, please update your usage of these properties.");
            }
            a.streaming && "forceHTTP" in a.streaming && (md("streaming.forceHTTP configuration", "Please Use networking.forceHTTP instead."), a.networking = a.networking || {}, a.networking.forceHTTP = a.streaming.forceHTTP, delete a.streaming.forceHTTP);
            a.streaming && "forceHTTPS" in a.streaming && (md("streaming.forceHTTPS configuration", "Please Use networking.forceHTTP instead."), a.networking = a.networking || {}, a.networking.forceHTTPS = a.streaming.forceHTTPS, delete a.streaming.forceHTTPS);
            a.streaming && "minBytesForProgressEvents" in a.streaming && (md("streaming.minBytesForProgressEvents configuration", "Please Use networking.minBytesForProgressEvents instead."), a.networking = a.networking || {}, a.networking.minBytesForProgressEvents = a.streaming.minBytesForProgressEvents, delete a.streaming.minBytesForProgressEvents);
            g = Eo(this.g, a, qr(this));
            Gs(this, c);
            return g;
        };
        p.zk = function(a) {
            this.Dg = a;
        };
        function Gs(a, b) {
            a.Re = new Li(a.g, a.ua, a.F);
            if (a.I) {
                var c = Xd(a.g.manifest);
                a.h && a.h.nodeName === "AUDIO" && (c.disableVideo = !0);
                a.I.configure(c);
            }
            a.F && a.F.configure(a.g.drm);
            if (a.l) {
                a.l.configure(a.g.streaming);
                try {
                    a.m != zr && Ni(a.Re, a.i) && es(a);
                } catch (e) {
                    Gr(a, e);
                }
                a.o && is(a);
                c = a.l.o;
                !c || c.allowedByApplication && c.allowedByKeySystem || vr(a);
            }
            a.M && a.M.configure(a.g.networking);
            a.H && (a.H.configure(a.g.mediaSource), a.H.Ga = a.g.manifest.segmentRelativeVttTiming);
            a.A && Yr(a);
            a.o && (a.o.configure(a.g.abr), a.g.abr.enabled ? a.o.enable() : a.o.disable(), us(a));
            a.P && Fs(a);
            a.Ia && (a.g.streaming.rebufferingGoal ? a.Ia.xa(.25) : a.Ia.stop());
            a.i && js(a.i.presentationTimeline, a.g.playRangeStart, a.g.playRangeEnd);
            a.D && a.D.configure(a.g.ads);
            a.K && a.K.configure(a.g.cmcd);
            a.na && a.na.configure(a.g.cmsd);
            a.va && a.va.configure(a.g.queue);
            if (a.m == ms && a.J.getConfiguration) {
                c = a.J.getConfiguration();
                var d = !1;
                b.preferredVideoHdrLevel != a.g.preferredVideoHdrLevel && c.hdrLevel != a.g.preferredVideoHdrLevel && (c.hdrLevel = a.g.preferredVideoHdrLevel, d = !0);
                b.preferredVideoLayout != a.g.preferredVideoLayout && c.videoLayout != a.g.preferredVideoLayout && (c.videoLayout = a.g.preferredVideoLayout, d = !0);
                b.preferSpatialAudio != a.g.preferSpatialAudio && c.spatialAudio != a.g.preferSpatialAudio && (c.spatialAudio = a.g.preferSpatialAudio, d = !0);
                b.preferredVideoRole != a.g.preferredVideoRole && c.videoRole != a.g.preferredVideoRole && (c.videoRole = a.g.preferredVideoRole, d = !0);
                d && (a.J.configure(c), vr(a));
            }
        }
        p.getConfiguration = function() {
            var a = qr(this);
            Eo(a, this.g, qr(this));
            return a;
        };
        p.Lk = function() {
            return this.Dg;
        };
        p.bj = function() {
            var a = qr(this);
            Eo(a, this.g, qr(this));
            return fo(this.g, qr(this));
        };
        p.Zi = function() {
            if (this.h) {
                var a = this.h.buffered.length;
                a = a ? this.h.buffered.end(a - 1) : 0;
                var b = Math.min(this.h.currentTime + this.g.streaming.bufferingGoal, this.wa().end);
                if (a >= b) return 1;
                if (!(a <= this.h.currentTime) && a < b) return (a - this.h.currentTime) / (b - this.h.currentTime);
            }
            return 0;
        };
        p.Dj = function() {
            var a = this.getConfiguration(), b;
            for(b in this.g)delete this.g[b];
            Eo(this.g, qr(this), qr(this));
            Gs(this, a);
        };
        p.xc = function() {
            return this.m;
        };
        p.uh = function() {
            return this.i ? this.i.type : null;
        };
        p.vf = function() {
            return this.h;
        };
        p.Qb = function() {
            return this.M;
        };
        p.dd = function() {
            return this.V;
        };
        p.tf = function() {
            return this.D ? this.D : null;
        };
        p.wf = function() {
            return this.va ? this.va : null;
        };
        p.U = function() {
            return this.i && !this.Da() ? this.i.presentationTimeline.U() : this.h && (this.h.src || this.Da()) ? this.h.duration == Infinity : !1;
        };
        p.fd = function() {
            return this.i ? this.i.presentationTimeline.fd() : !1;
        };
        p.Hd = function() {
            if (this.i && !this.Da()) {
                var a = this.i.variants;
                return a.length ? !a[0].video : !1;
            }
            return this.h && (this.h.src || this.Da()) ? this.h.videoTracks ? this.h.videoTracks.length == 0 : this.h.videoHeight == 0 : !1;
        };
        p.Hf = function() {
            if (this.i && !this.Da()) {
                var a = this.i.variants;
                if (!a.length) return !1;
                a = a[0];
                return a.audio || !a.video ? !1 : !a.video.codecs.includes(",");
            }
            return this.h && (this.h.src || this.Da()) && this.h.audioTracks ? this.h.audioTracks.length == 0 : !1;
        };
        p.wa = function() {
            if (this.i && !this.Da()) {
                if (!this.Oa && this.i.type == "HLS") return {
                    start: 0,
                    end: 0
                };
                var a = this.i.presentationTimeline;
                return {
                    start: a.cc(),
                    end: a.Gb()
                };
            }
            if (this.h && (this.h.src || this.Da()) && (a = this.h.seekable) && a.length) {
                var b = this.g ? this.g.playRangeStart : 0;
                b = Math.max(a.start(0), b);
                var c = this.g ? this.g.playRangeEnd : Infinity;
                a = Math.min(a.end(a.length - 1), c);
                return {
                    start: b,
                    end: a
                };
            }
            return {
                start: 0,
                end: 0
            };
        };
        p.Bl = function() {
            this.U() && (this.h.currentTime = this.wa().end);
        };
        p.Gh = function() {
            return this.Oa;
        };
        p.keySystem = function() {
            var a = this.drmInfo();
            return a ? a.keySystem : "";
        };
        p.drmInfo = function() {
            return this.F ? this.F.g : null;
        };
        p.oe = function() {
            return this.F ? this.F.oe() : Infinity;
        };
        p.oh = function() {
            return this.F ? this.F.oh() : [];
        };
        p.uf = function() {
            return this.F ? this.F.uf() : {};
        };
        p.Df = function() {
            return this.P ? this.P.g == Ji : !!this.V;
        };
        p.Wa = function() {
            return this.h ? this.L ? this.L.h : 1 : 0;
        };
        p.Ci = function(a) {
            this.m == ms && this.l && wn(this.l, a);
        };
        p.sc = function(a, b) {
            b = b === void 0 ? !0 : b;
            if (a == 0) Za("A trick play rate of 0 is unsupported!");
            else {
                var c = this.h.playbackRate, d = this.L.h;
                this.L.set(a);
                this.m == ms && (this.o.playbackRateChanged(a), this.Ci(b && a != 1));
                Hs(this, a);
                c === 0 && this.h.playbackRate === 0 && a != d && cs(this);
            }
        };
        p.ud = function() {
            var a = this.L.Cd();
            this.m == fs && this.L.set(a);
            this.m == ms && (this.L.set(a), this.o.playbackRateChanged(a), this.Ci(!1));
            this.jc.Ta();
        };
        p.Ib = function() {
            if (this.i && !this.Da()) {
                for(var a = this.l ? this.l.o : null, b = [], c = 0, d = u(this.i.variants), e = d.next(); !e.done; e = d.next())if (e = e.value, Eg(e)) {
                    var f = wg(e);
                    f.active = e == a;
                    f.active || c == 1 || a == null || e.video != a.video || e.audio != a.audio || (f.active = !0);
                    f.active && c++;
                    b.push(f);
                }
                return b;
            }
            if (this.h && this.h.audioTracks) {
                var g = Is(this);
                a = Array.from(this.h.audioTracks);
                return a.length ? a.map(function(h) {
                    return Dg(h, g);
                }) : g ? [
                    Dg(null, g)
                ] : [];
            }
            return [];
        };
        p.yc = function() {
            if (this.i) {
                if (this.Da()) return [];
                for(var a = this.l ? this.l.C : null, b = [], c = u(this.i.textStreams), d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = xg(d);
                    e.active = d == a;
                    b.push(e);
                }
                return b;
            }
            return this.h && this.h.src && this.h.textTracks ? ys(this).map(function(f) {
                return Cg(f);
            }) : [];
        };
        p.rh = function() {
            var a = this.Xe;
            this.i && (a = this.i.imageStreams);
            return a.map(function(b) {
                return yg(b);
            });
        };
        p.Ck = function(a) {
            var b = this, c, d;
            return H(function(e) {
                if (e.h == 1) return e.g(Js(b, a), 2);
                c = e.i;
                if (!c) return e.return(null);
                d = [];
                c.segmentIndex.xb(function(f) {
                    var g = Ks(f.tilesLayout || c.tilesLayout);
                    if (g) for(var h = g.rows * g.columns, k = (f.j - f.startTime) / h, l = 0; l < h; l++){
                        var m = Ls(f, c, f.startTime + l * k, g);
                        if (!m) break;
                        d.push(m);
                    }
                });
                return e.return(d);
            });
        };
        function Ks(a) {
            return a ? (a = /(\d+)x(\d+)/.exec(a)) ? {
                columns: parseInt(a[1], 10),
                rows: parseInt(a[2], 10)
            } : null : null;
        }
        p.dj = function(a, b) {
            var c = this, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) return h.g(Js(c, a), 2);
                d = h.i;
                if (!d) return h.return(null);
                e = d.segmentIndex.find(b);
                if (e == null) return h.return(null);
                f = d.segmentIndex.get(e);
                return (g = Ks(f.tilesLayout || d.tilesLayout)) ? h.return(Ls(f, d, b, g)) : h.return(null);
            });
        };
        function Js(a, b) {
            var c, d, e;
            return H(function(f) {
                if (f.h == 1) {
                    if (a.m != ms && a.m != fs) return f.return(null);
                    c = a.Xe;
                    a.i && (c = a.i.imageStreams);
                    d = c[0];
                    if (!d) return f.return(null);
                    b != null && (d = c.find(function(g) {
                        return g.id == b;
                    }));
                    return d ? d.segmentIndex ? f.B(2) : f.g(d.createSegmentIndex(), 2) : f.return(null);
                }
                d.closeSegmentIndex && (a.Fc.has(d) || (e = new Uf(function() {
                    d && (d.closeSegmentIndex(), a.Fc.delete(d));
                }), a.Fc.set(d, e)), a.Fc.get(d).Z(5));
                return f.return(d);
            });
        }
        function Ls(a, b, c, d) {
            var e = b.width || 0, f = b.height || 0, g = e / d.columns, h = f / d.rows, k = d.columns * d.rows, l = a.j - a.startTime;
            l = a.C || l / k;
            var m = a.startTime, n = 0, q = 0;
            k > 1 && (q = Math.floor((c - a.startTime) / l + 1E-4), m = a.startTime + q * l, n = q % d.columns * g, q = Math.floor(q / d.columns) * h);
            if (m >= a.endTime || rk(m, a.endTime, 1E-4)) return null;
            d = !1;
            if (c = a.thumbnailSprite) d = !0, h = c.height, n = c.positionX, q = c.positionY, g = c.width;
            return {
                segment: a,
                imageHeight: f,
                imageWidth: e,
                height: h,
                positionX: n,
                positionY: q,
                startTime: m,
                duration: l,
                uris: a.T(),
                startByte: a.Qc(),
                endByte: a.Oc(),
                width: g,
                sprite: d,
                mimeType: a.mimeType || b.mimeType,
                codecs: a.codecs || b.codecs
            };
        }
        p.gg = function(a) {
            function b() {
                var d = c.i.textStreams.find(function(e) {
                    return e.id == a.id;
                });
                d && d != c.l.C && (Jo(c.C.h, d, !1), zn(c.l, d), ds(c), ts(c), c.Zd = d.language);
            }
            var c = this;
            if (this.i && this.G && (b(), !this.Da())) return;
            (function() {
                if (c.h && c.h.textTracks) {
                    var d = ys(c), e = d.find(function(h) {
                        return zg(h) === a.id;
                    });
                    if (e) {
                        if (c.A instanceof Cp) {
                            d = u(d);
                            for(var f = d.next(); !f.done; f = d.next()){
                                f = f.value;
                                var g = f === e ? c.W ? "showing" : "hidden" : "disabled";
                                f.mode !== g && (f.mode = g);
                            }
                        } else d = d.find(function(h) {
                            return h.mode !== "disabled";
                        }), d !== e && (d && (d.mode = "disabled", c.j.Fa(d, "cuechange"), c.A.remove(0, Infinity)), e && Bs(c, e));
                        ds(c);
                        ts(c);
                    }
                }
            })();
        };
        function Bs(a, b) {
            a.j.u(b, "cuechange", function() {
                a.A.remove(0, Math.max(0, a.h.currentTime - a.g.streaming.bufferBehind));
                var c = {
                    periodStart: 0,
                    segmentStart: 0,
                    segmentEnd: a.h.duration,
                    vttOffset: 0
                }, d = [], e = Array.from(b.activeCues || []);
                e = u(e);
                for(var f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    if (f.endTime === Infinity || f.endTime < f.startTime) f = null;
                    else {
                        var g = new Ie(f.startTime, f.endTime, f.text);
                        g.line = typeof f.line === "number" ? f.line : null;
                        f.lineAlign && (g.lineAlign = f.lineAlign);
                        g.lineInterpretation = f.snapToLines ? Ne : 1;
                        g.position = typeof f.position === "number" ? f.position : null;
                        f.positionAlign && (g.positionAlign = f.positionAlign);
                        g.size = f.size;
                        g.textAlign = f.align;
                        f.vertical === "lr" ? g.writingMode = "vertical-lr" : f.vertical === "rl" && (g.writingMode = "vertical-rl");
                        f.region && (g.region.id = f.region.id, g.region.height = f.region.lines, g.region.heightUnits = 2, g.region.regionAnchorX = f.region.regionAnchorX, g.region.regionAnchorY = f.region.regionAnchorY, g.region.scroll = f.region.scroll, g.region.viewportAnchorX = f.region.viewportAnchorX, g.region.viewportAnchorY = f.region.viewportAnchorY, g.region.viewportAnchorUnits = Nd, g.region.width = f.region.width, g.region.widthUnits = Nd);
                        We(g);
                        f = g;
                    }
                    f && ((g = a.g.mediaSource.modifyCueCallback) && g(f, null, c), d.push(f));
                }
                a.A.append(d);
            });
            b.mode = document.pictureInPictureElement ? "showing" : "hidden";
        }
        p.Ge = function(a, b, c) {
            function d() {
                var f = e.i.variants.find(function(h) {
                    return h.id == a.id;
                });
                if (f && Eg(f)) {
                    var g = e.l.o;
                    e.g.abr.enabled && (g.video != f.video || g.audio && f.audio && g.audio.language == f.audio.language && g.audio.channelsCount == f.audio.channelsCount && g.audio.label == f.audio.label) && Za("Changing tracks while abr manager is enabled will likely result in the selected track being overridden. Consider disabling abr before calling selectVariantTrack().");
                    e.Da() ? ks(e, f, !1, !1, 0) : ks(e, f, !1, b || !1, c || 0);
                    e.J.configure({
                        language: f.language,
                        role: f.audio && f.audio.roles && f.audio.roles[0] || "",
                        videoRole: f.video && f.video.roles && f.video.roles[0] || "",
                        channelCount: f.audio && f.audio.channelsCount ? f.audio.channelsCount : 0,
                        hdrLevel: f.video && f.video.hdr ? f.video.hdr : "",
                        spatialAudio: f.audio && f.audio.spatialAudio ? f.audio.spatialAudio : !1,
                        videoLayout: f.video && f.video.videoLayout ? f.video.videoLayout : "",
                        audioLabel: f.audio && f.audio.label ? f.audio.label : "",
                        videoLabel: f.video && f.video.label ? f.video.label : "",
                        codecSwitchingStrategy: e.g.mediaSource.codecSwitchingStrategy,
                        audioCodec: f.audio && f.audio.codecs ? f.audio.codecs : "",
                        activeAudioCodec: g.audio && g.audio.codecs ? g.audio.codecs : "",
                        activeAudioChannelCount: g.audio && g.audio.channelsCount ? g.audio.channelsCount : 0,
                        preferredAudioCodecs: e.g.preferredAudioCodecs,
                        preferredAudioChannelCount: e.g.preferredAudioChannelCount
                    });
                    is(e);
                }
            }
            var e = this;
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? 0 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                if (a.originalAudioId && e.h && e.h.audioTracks) {
                    var f = Array.from(e.h.audioTracks);
                    f = u(f);
                    for(var g = f.next(); !g.done; g = f.next())if (g = g.value, zg(g) == a.id) {
                        Ms(e, g);
                        break;
                    }
                }
            })();
        };
        p.Jj = function(a, b) {
            function c() {
                var e = d.J.getConfiguration();
                e.audioCodec = a.codecs || "";
                e.audioLabel = a.label || "";
                e.channelCount = a.channelsCount || 0;
                e.language = a.language;
                e.role = a.roles[0] || "";
                e.spatialAudio = a.spatialAudio;
                var f = d.l.o;
                if (f = f && f.audio) e.activeAudioCodec = f.codecs || "", e.activeAudioChannelCount = f.channelsCount || 0;
                d.J.configure(e);
                vr(d, !0, b, !1, !1);
            }
            var d = this;
            b = b === void 0 ? 0 : b;
            if (this.i && this.G && (c(), !this.Da())) return;
            (function() {
                if (d.h && d.h.audioTracks) {
                    var e = Kc(a.language), f = Array.from(d.h.audioTracks), g = null;
                    f = u(f);
                    for(var h = f.next(); !h.done; h = f.next()){
                        h = h.value;
                        var k = h.language || "und";
                        if (h.label == a.label && Kc(k) == e && h.kind == a.roles[0]) {
                            g = h;
                            break;
                        }
                    }
                    g && Ms(d, g);
                }
            })();
        };
        p.getAudioTracks = function() {
            if (this.i && !this.Da()) {
                var a = this.Ib();
                if (!a.length) return [];
                var b = a.find(function(f) {
                    return f.active;
                });
                if (!b) return [];
                var c = a;
                this.m != ms || this.Da() || (c = a.filter(function(f) {
                    return f.originalVideoId === b.originalVideoId && (f.audioCodec || yf.includes(f.audioMimeType || ""));
                }));
                if (!c.length) return [];
                a = new Map;
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next()){
                    var e = d.value;
                    d = [
                        e.language,
                        e.originalLanguage,
                        e.label || "",
                        (e.audioRoles || []).join(","),
                        e.channelsCount,
                        e.spatialAudio,
                        e.audioCodec || "",
                        e.accessibilityPurpose || ""
                    ].join("_");
                    e = {
                        active: e.active,
                        language: e.language,
                        label: e.label,
                        mimeType: e.audioMimeType,
                        codecs: e.audioCodec,
                        primary: e.primary,
                        roles: e.audioRoles || [],
                        accessibilityPurpose: e.accessibilityPurpose,
                        channelsCount: e.channelsCount,
                        audioSamplingRate: e.audioSamplingRate,
                        spatialAudio: e.spatialAudio,
                        originalLanguage: e.originalLanguage
                    };
                    a.has(d) ? !a.get(d).active && e.active && a.set(d, e) : a.set(d, e);
                }
                return Array.from(a.values());
            }
            return this.h && this.h.audioTracks ? Array.from(this.h.audioTracks).map(function(f) {
                var g = f.language;
                g = {
                    active: f.enabled,
                    language: Kc(g || "und"),
                    label: f.label,
                    mimeType: null,
                    codecs: null,
                    primary: f.kind == "main",
                    roles: [],
                    accessibilityPurpose: null,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    originalLanguage: g
                };
                f.kind && (f.kind == "description" && (g.accessibilityPurpose = "visually impaired"), g.roles.push(f.kind));
                f.configuration && (f.configuration.codec && (g.codecs = f.configuration.codec), f.configuration.sampleRate && (g.audioSamplingRate = f.configuration.sampleRate), f.configuration.numberOfChannels && (g.channelsCount = f.configuration.numberOfChannels));
                return g;
            }) : [];
        };
        p.Kj = function(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? 0 : c;
            var d = this.Ib();
            if (d.length) {
                var e = d.find(function(g) {
                    return g.active;
                });
                if (e) {
                    d = d.filter(function(g) {
                        return (g.videoBandwidth || g.bandwidth) == a.bandwidth && g.width == a.width && g.height == a.height && g.frameRate == a.frameRate && g.pixelAspectRatio == a.pixelAspectRatio && g.hdr == a.hdr && g.colorGamut == a.colorGamut && g.videoLayout == a.videoLayout && g.videoMimeType == a.mimeType && g.videoCodec == a.codecs && ed(g.videoRoles, a.roles) && g.videoLabel == a.label;
                    });
                    var f;
                    d.length == 1 ? f = d[0] : f = d.find(function(g) {
                        return g.audioId === e.audioId;
                    });
                    f || (f = d.find(function(g) {
                        return g.language == e.language && g.label === e.label && g.channelsCount === e.channelsCount && g.spatialAudio === e.spatialAudio && g.audioMimeType === e.audioMimeType && Cf(g.audioCodec || "") === Cf(e.audioCodec || "") && ed(g.audioRoles, e.audioRoles);
                    }));
                    f && !f.active && this.Ge(f, b, c);
                }
            }
        };
        p.getVideoTracks = function() {
            if (this.m == fs || this.Da()) return [];
            var a = this.Ib();
            if (!a.length) return [];
            var b = a.find(function(f) {
                return f.active;
            });
            if (!b) return [];
            var c = a;
            this.Hf() || (c = a.filter(function(f) {
                return f.videoCodec && f.audioGroupId === b.audioGroupId && f.originalAudioId === b.originalAudioId ? f.audioId === b.audioId ? !0 : f.language === b.language && f.label === b.label && f.channelsCount === b.channelsCount && f.spatialAudio === b.spatialAudio && f.audioMimeType === b.audioMimeType && Cf(f.audioCodec || "") === Cf(b.audioCodec || "") && ed(f.audioRoles, b.audioRoles) : !1;
            }));
            if (!c.length) return [];
            a = new Map;
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next()){
                d = d.value;
                var e = d.originalVideoId;
                e || d.videoId == null || (e = String(d.videoId));
                e && a.set(e, {
                    active: d.active,
                    bandwidth: d.videoBandwidth || d.bandwidth,
                    width: d.width,
                    height: d.height,
                    frameRate: d.frameRate,
                    pixelAspectRatio: d.pixelAspectRatio,
                    hdr: d.hdr,
                    colorGamut: d.colorGamut,
                    videoLayout: d.videoLayout,
                    mimeType: d.videoMimeType,
                    codecs: d.videoCodec,
                    roles: d.videoRoles || [],
                    label: d.videoLabel
                });
            }
            return Array.from(a.values());
        };
        p.Ek = function() {
            return Ns(this.Ib());
        };
        p.ql = function() {
            return Ns(this.yc());
        };
        p.Dk = function() {
            return Array.from(Os(this.Ib()));
        };
        p.ol = function() {
            return Array.from(Os(this.yc()));
        };
        p.Ij = function(a, b, c, d, e, f, g) {
            function h() {
                function l(t, v) {
                    return t.video || v.video ? t.video && v.video ? Math.abs((t.video.height || 0) - (v.video.height || 0)) + Math.abs((t.video.width || 0) - (v.video.width || 0)) : Infinity : 0;
                }
                var m = k.l.o;
                k.J = k.g.adaptationSetCriteriaFactory();
                k.J.configure({
                    language: a,
                    role: b || "",
                    videoRole: m.video && m.video.roles && m.video.roles[0] || "",
                    channelCount: c || 0,
                    hdrLevel: "",
                    spatialAudio: f || !1,
                    videoLayout: "",
                    audioLabel: g || "",
                    videoLabel: "",
                    codecSwitchingStrategy: k.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: e || "",
                    activeAudioCodec: m.audio && m.audio.codecs ? m.audio.codecs : "",
                    activeAudioChannelCount: m.audio && m.audio.channelsCount ? m.audio.channelsCount : 0,
                    preferredAudioCodecs: k.g.preferredAudioCodecs,
                    preferredAudioChannelCount: k.g.preferredAudioChannelCount
                });
                var n = k.J.create(k.i.variants), q = null;
                n = u(n.values());
                for(var r = n.next(); !r.done; r = n.next())r = r.value, Eg(r) && (!q || l(q, m) > l(r, m)) && (q = r);
                q != m && (q ? (m = wg(q), k.Ge(m, !0, d || 0)) : vr(k));
            }
            var k = this;
            c = c === void 0 ? 0 : c;
            d = d === void 0 ? 0 : d;
            e = e === void 0 ? "" : e;
            f = f === void 0 ? !1 : f;
            g = g === void 0 ? "" : g;
            if (this.i && this.G && (h(), !this.Da())) return;
            (function() {
                if (k.h && k.h.audioTracks) {
                    var l = Gg(k.Ib(), a, b || "", !1)[0];
                    l && k.Ge(l);
                }
            })();
        };
        p.ei = function(a, b, c) {
            function d() {
                e.Zd = a;
                e.ce = b || "";
                e.be = c || !1;
                var f = Gg(e.i.textStreams, e.Zd, e.ce, e.be)[0] || null;
                f && f != e.l.C && (Jo(e.C.h, f, !1), e.g.streaming.alwaysStreamText || e.Tc()) && (zn(e.l, f), ds(e), ts(e));
            }
            var e = this;
            c = c === void 0 ? !1 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                var f = Gg(e.yc(), a, b || "", c || !1)[0];
                f && e.gg(f);
            })();
        };
        p.sm = function(a, b, c) {
            function d() {
                for(var f = null, g = u(e.i.variants), h = g.next(); !h.done; h = g.next())if (h = h.value, h.audio.label == a) {
                    f = h;
                    break;
                }
                f != null && (e.J = e.g.adaptationSetCriteriaFactory(), e.J.configure({
                    language: f.language,
                    role: "",
                    videoRole: "",
                    channelCount: 0,
                    hdrLevel: "",
                    spatialAudio: !1,
                    videoLayout: "",
                    videoLabel: "",
                    audioLabel: a,
                    codecSwitchingStrategy: e.g.mediaSource.codecSwitchingStrategy,
                    audioCodec: "",
                    activeAudioCodec: "",
                    activeAudioChannelCount: 0,
                    preferredAudioCodecs: e.g.preferredAudioCodecs,
                    preferredAudioChannelCount: e.g.preferredAudioChannelCount
                }), vr(e, b, c));
            }
            var e = this;
            b = b === void 0 ? !0 : b;
            c = c === void 0 ? 0 : c;
            if (this.i && this.G && (d(), !this.Da())) return;
            (function() {
                if (e.h && e.h.audioTracks) {
                    var f = Array.from(e.h.audioTracks), g = null;
                    f = u(f);
                    for(var h = f.next(); !h.done; h = f.next())h = h.value, h.label == a && (g = h);
                    g && Ms(e, g);
                }
            })();
        };
        p.Tc = function() {
            var a = this.W;
            return this.A ? this.A.isTextVisible() : a;
        };
        p.Ik = function() {
            return this.kb.map(function(a) {
                return xg(a);
            });
        };
        p.Hk = function(a) {
            md("getChapters", "Please use an getChaptersAsync.");
            if (!this.kb.length) return [];
            var b = Kc(a);
            a = this.kb.filter(function(f) {
                return Kc(f.language) == b;
            });
            if (!a.length) return [];
            var c = [], d = new Set;
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())e = e.value, e.segmentIndex && e.segmentIndex.xb(function(f) {
                var g = f.T()[0], h = f.startTime + "-" + f.endTime + "-" + g;
                f = {
                    id: h,
                    title: g,
                    startTime: f.startTime,
                    endTime: f.endTime
                };
                d.has(h) || (c.push(f), d.add(h));
            });
            return c;
        };
        p.ph = function(a) {
            var b = this, c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        if (!b.kb.length) return l.return([]);
                        c = Kc(a);
                        d = b.kb.filter(function(m) {
                            return Kc(m.language) == c;
                        });
                        if (!d.length) return l.return([]);
                        e = [];
                        f = new Set;
                        g = u(d);
                        h = g.next();
                    case 2:
                        if (h.done) {
                            l.B(4);
                            break;
                        }
                        k = h.value;
                        if (k.segmentIndex) {
                            l.B(5);
                            break;
                        }
                        return l.g(k.createSegmentIndex(), 5);
                    case 5:
                        k.segmentIndex.xb(function(m) {
                            var n = m.T()[0], q = m.startTime + "-" + m.endTime + "-" + n;
                            m = {
                                id: q,
                                title: n,
                                startTime: m.startTime,
                                endTime: m.endTime
                            };
                            f.has(q) || (e.push(m), f.add(q));
                        });
                        h = g.next();
                        l.B(2);
                        break;
                    case 4:
                        return l.return(e);
                }
            });
        };
        function ys(a) {
            return Array.from(a.h.textTracks).filter(function(b) {
                return b.kind != "metadata" && b.kind != "chapters" && b.label != "Shaka Player TextTrack";
            });
        }
        function zs(a) {
            return Array.from(a.h.textTracks).find(function(b) {
                return b.label == "Shaka Player TextTrack";
            });
        }
        function Ds(a) {
            return Array.from(a.h.textTracks).filter(function(b) {
                return b.kind == "metadata";
            });
        }
        p.Xd = function(a) {
            a = !!a;
            this.W != a && (this.W = a, this.m == ms ? (this.A.setTextVisibility(a), this.g.streaming.alwaysStreamText || (a ? this.l.C || (a = Gg(this.i.textStreams, this.Zd, this.ce, this.be), a.length > 0 && (zn(this.l, a[0]), ds(this), ts(this))) : vn(this.l))) : this.h && this.h.src && this.h.textTracks && this.A.setTextVisibility(a), ss(this));
        };
        p.al = function() {
            if (this.G) var a = this.G.ee();
            else {
                if (this.O == null) return new Date;
                if (this.O instanceof Date) return this.O;
                a = this.O;
            }
            if (this.i && !this.Da()) {
                var b = this.i.presentationTimeline;
                return new Date(((b.m || b.i) + a) * 1E3);
            }
            return this.h && this.h.getStartDate ? (b = this.h.getStartDate(), b instanceof Date && !isNaN(b.getTime()) ? new Date(b.getTime() + a * 1E3) : null) : null;
        };
        p.cj = function() {
            if (this.i && !this.Da()) {
                var a = this.i.presentationTimeline;
                a = a.m || a.i;
                return a === null ? null : new Date(a * 1E3);
            }
            return this.h && this.h.getStartDate ? (a = this.h.getStartDate(), a instanceof Date && !isNaN(a.getTime()) ? a : null) : null;
        };
        p.xf = function() {
            return this.U() ? this.i ? this.i.presentationTimeline.xf() : null : null;
        };
        p.Nc = function() {
            if (this.m == ms) return this.H.Nc();
            var a = {
                total: [],
                audio: [],
                video: [],
                text: []
            };
            this.m == fs && (a.total = Yj(this.h.buffered));
            return a;
        };
        function fr(a) {
            if (!a.h || !a.h.currentTime) return null;
            var b = a.cj();
            return b ? Math.floor(Date.now() - (b.getTime() + a.h.currentTime * 1E3)) : null;
        }
        p.getBandwidthEstimate = function() {
            return this.o ? this.o.getBandwidthEstimate() : NaN;
        };
        p.getStats = function() {
            if (this.m != ms && this.m != fs) return {
                width: NaN,
                height: NaN,
                currentCodecs: "",
                streamBandwidth: NaN,
                decodedFrames: NaN,
                droppedFrames: NaN,
                corruptedFrames: NaN,
                stallsDetected: NaN,
                gapsJumped: NaN,
                estimatedBandwidth: NaN,
                completionPercent: NaN,
                loadLatency: NaN,
                manifestTimeSeconds: NaN,
                drmTimeSeconds: NaN,
                playTime: NaN,
                pauseTime: NaN,
                bufferingTime: NaN,
                licenseTime: NaN,
                liveLatency: NaN,
                maxSegmentDuration: NaN,
                manifestSizeBytes: NaN,
                bytesDownloaded: NaN,
                nonFatalErrorCount: NaN,
                manifestPeriodCount: NaN,
                manifestGapCount: NaN,
                switchHistory: [],
                stateHistory: []
            };
            bs(this);
            var a = this.h, b = a.currentTime / a.duration;
            isNaN(b) || this.U() || No(this.C, Math.round(100 * b));
            this.G && (this.C.R = this.G.Di(), this.C.S = this.G.Fi());
            a.getVideoPlaybackQuality && (b = a.getVideoPlaybackQuality(), Lo(this.C, Number(b.droppedVideoFrames), Number(b.totalVideoFrames)), this.C.M = Number(b.corruptedVideoFrames));
            Oo(this.C, this.F ? qi(this.F) : NaN);
            Mo(this.C, a.videoWidth || NaN, a.videoHeight || NaN);
            this.C.l = "";
            this.U() && (a = fr(this), a != null && Po(this.C, a / 1E3));
            b = this.Ib().find(function(e) {
                return e.active;
            });
            a = this.yc().find(function(e) {
                return e.active;
            });
            if (b) {
                if (b.bandwidth) {
                    var c = this.L ? this.L.h : 1, d = c * b.bandwidth;
                    a && a.bandwidth && (d += c * a.bandwidth);
                    this.C.C = d;
                }
                b.width && b.height && Mo(this.C, b.width || NaN, b.height || NaN);
                b = b.codecs;
                a && (b += "," + (a.codecs || a.mimeType));
                b && (this.C.l = b);
            }
            this.m != ms || this.Da() || (this.i && (this.C.I = this.i.periodCount, this.C.H = this.i.gapCount, this.i.presentationTimeline && Qo(this.C, this.i.presentationTimeline.h)), a = this.o.getBandwidthEstimate(), this.C.A = a);
            this.m == fs && Ro(this.C, NaN);
            return So(this.C);
        };
        p.fe = function(a, b, c, d, e, f, g) {
            g = g === void 0 ? !1 : g;
            var h = this, k, l, m, n, q, r, t, v, w, x, y, z;
            return H(function(A) {
                switch(A.h){
                    case 1:
                        if (h.m != ms && h.m != fs) throw new T(1, 7, 7004);
                        c != "subtitles" && c != "captions" && Za("Using a kind value different of `subtitles` or `captions` can cause unwanted issues.");
                        if (d) {
                            A.B(2);
                            break;
                        }
                        return A.g(Ps(h, a), 3);
                    case 3:
                        d = A.i;
                    case 2:
                        k = [];
                        h.D && (k = h.D.getCuePoints());
                        if (h.m != fs) {
                            A.B(4);
                            break;
                        }
                        l = Xb();
                        g && l.Ma() === "WEBKIT" && (c = "forced");
                        return A.g(Qs(h, a, b, c, d, f || "", k), 5);
                    case 5:
                        m = A.i;
                        if (m.track) return es(h), ds(h), A.return(Cg(m.track));
                        throw new T(1, 2, 2012);
                    case 4:
                        n = Gc;
                        q = h.wa();
                        r = q.end - q.start;
                        h.i && (r = h.i.presentationTimeline.getDuration());
                        if (r == Infinity) throw new T(1, 4, 4033);
                        if (!k.length) {
                            A.B(6);
                            break;
                        }
                        return A.g(Rs(h, a), 7);
                    case 7:
                        t = A.i, v = Ss(h, t, d, k), w = new Blob([
                            v
                        ], {
                            type: "text/vtt"
                        }), a = Vk(w), d = "text/vtt";
                    case 6:
                        x = {
                            id: h.Se++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: xm(0, r, [
                                a
                            ]),
                            mimeType: d || "",
                            codecs: e || "",
                            kind: c,
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: b,
                            originalLanguage: b,
                            label: f || null,
                            type: n.Va,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !!g,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf(d || "", e || "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        };
                        y = wf(x.mimeType, x.codecs);
                        z = Mf(y);
                        if (!z) throw new T(2, 2, 2014, d);
                        h.i.textStreams.push(x);
                        es(h);
                        ds(h);
                        return A.return(xg(x));
                }
            });
        };
        p.cf = function(a, b) {
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A;
            return H(function(E) {
                switch(E.h){
                    case 1:
                        if (c.m != ms && c.m != fs) throw new T(1, 7, 7004);
                        if (b) {
                            E.B(2);
                            break;
                        }
                        return E.g(Ps(c, a), 3);
                    case 3:
                        b = E.i;
                    case 2:
                        if (b != "text/vtt") throw new T(1, 2, 2017, a);
                        d = Gc;
                        e = c.wa();
                        f = e.end - e.start;
                        c.i && (f = c.i.presentationTimeline.getDuration());
                        if (f == Infinity) throw new T(1, 4, 4045);
                        return E.g(Rs(c, a), 4);
                    case 4:
                        g = E.i;
                        h = Lf(b);
                        if (!h) throw new T(2, 2, 2014, b);
                        k = h();
                        l = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: f,
                            vttOffset: 0
                        };
                        m = Fb(g);
                        n = k.parseMedia(m, l, a, []);
                        q = [];
                        r = u(n);
                        t = r.next();
                        for(v = {}; !t.done; v = {
                            xg: void 0,
                            xd: void 0
                        }, t = r.next())v.xd = t.value, v.xg = null, w = function(C) {
                            return function() {
                                C.xg == null && (C.xg = vc([
                                    a
                                ], [
                                    C.xd.payload
                                ]));
                                return C.xg || [];
                            };
                        }(v), x = new Oj(v.xd.startTime, v.xd.endTime, w, 0, null, null, 0, 0, Infinity), v.xd.payload.includes("#xywh") && (y = v.xd.payload.split("#xywh=")[1].split(","), y.length === 4 && x.kg({
                            height: parseInt(y[3], 10),
                            positionX: parseInt(y[0], 10),
                            positionY: parseInt(y[1], 10),
                            width: parseInt(y[2], 10)
                        })), q.push(x);
                        z = b;
                        if (!q.length) {
                            E.B(5);
                            break;
                        }
                        return E.g(Ps(c, q[0].T()[0]), 6);
                    case 6:
                        z = E.i;
                    case 5:
                        return A = {
                            id: c.Se++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new vm(q),
                            mimeType: z || "",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: "und",
                            originalLanguage: null,
                            label: null,
                            type: d.zg,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            tilesLayout: "1x1",
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf(z || "", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        }, c.m == fs ? c.Xe.push(A) : c.i.imageStreams.push(A), es(c), E.return(yg(A));
                }
            });
        };
        p.bf = function(a, b, c) {
            var d = this, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        if (d.m != ms && d.m != fs) throw new T(1, 7, 7004);
                        if (c) {
                            z.B(2);
                            break;
                        }
                        return z.g(Ps(d, a), 3);
                    case 3:
                        c = z.i;
                    case 2:
                        e = Gc;
                        f = d.wa();
                        g = f.end - f.start;
                        d.i && (g = d.i.presentationTimeline.getDuration());
                        if (g == Infinity) throw new T(1, 4, 4055);
                        h = Lf(c);
                        if (!h) throw new T(2, 2, 2014, c);
                        return z.g(Rs(d, a), 4);
                    case 4:
                        k = z.i;
                        l = h();
                        m = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: g,
                            vttOffset: 0
                        };
                        n = Fb(k);
                        q = l.parseMedia(n, m, a, []);
                        r = [];
                        t = u(q);
                        v = t.next();
                        for(w = {}; !v.done; w = {
                            mf: void 0
                        }, v = t.next())w.mf = v.value, x = new Oj(w.mf.startTime, w.mf.endTime, function(A) {
                            return function() {
                                return [
                                    A.mf.payload
                                ];
                            };
                        }(w), 0, null, null, 0, 0, Infinity), r.push(x);
                        y = {
                            id: d.Se++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new vm(r),
                            mimeType: "text/plain",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: b,
                            originalLanguage: b,
                            label: null,
                            type: e.Va,
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf("text/plain", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        };
                        d.kb.push(y);
                        es(d);
                        return z.return(xg(y));
                }
            });
        };
        function Ps(a, b) {
            var c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return d.m(2), d.g(fn(b, a.M, a.g.streaming.retryParameters), 4);
                    case 4:
                        c = d.i;
                        d.o(3);
                        break;
                    case 2:
                        d.l();
                    case 3:
                        if (c) return d.return(c);
                        throw new T(1, 2, 2011, b);
                }
            });
        }
        function Qs(a, b, c, d, e, f, g) {
            var h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return e != "text/vtt" || g.length ? n.g(Rs(a, b), 3) : n.B(2);
                n.h != 2 && (h = n.i, k = Ss(a, h, e, g), l = new Blob([
                    k
                ], {
                    type: "text/vtt"
                }), b = Vk(l), e = "text/vtt");
                m = document.createElement("track");
                a: {
                    var q = a.K, r = b;
                    try {
                        if (!q.g.enabled) {
                            var t = r;
                            break a;
                        }
                        var v = dq(q);
                        v.ot = Zq;
                        v.su = !0;
                        var w = hq(v);
                        t = iq(r, w);
                        break a;
                    } catch (x) {
                        $a("CMCD_TEXT_TRACK_ERROR", "Could not generate text track CMCD data.", x);
                        t = r;
                        break a;
                    }
                    t = void 0;
                }
                m.src = t;
                m.label = f;
                m.kind = d;
                m.srclang = c;
                a.h.getAttribute("crossorigin") || a.h.setAttribute("crossorigin", "anonymous");
                a.h.appendChild(m);
                a.Cg.push(m);
                return n.return(m);
            });
        }
        function Rs(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    c = sh;
                    d = a.g.streaming.retryParameters;
                    e = mh([
                        b
                    ], d);
                    e.method = "GET";
                    var h = a.K;
                    try {
                        h.g.enabled && Oq(h, e, {
                            ot: Zq,
                            su: !0
                        });
                    } catch (k) {
                        $a("CMCD_TEXT_ERROR", "Could not generate text CMCD data.", k);
                    }
                    return g.g(a.M.request(c, e).promise, 2);
                }
                f = g.i;
                return g.return(f.data);
            });
        }
        function Ss(a, b, c, d) {
            var e = Lf(c);
            if (e) return c = e(), a = {
                periodStart: 0,
                segmentStart: 0,
                segmentEnd: a.h.duration,
                vttOffset: 0
            }, b = Fb(b), b = c.parseMedia(b, a, null, []), Qp(b, d);
            throw new T(2, 2, 2014, c);
        }
        p.ym = function(a, b) {
            this.ua.width = a;
            this.ua.height = b;
        };
        p.bi = function(a) {
            if (this.m == ms) {
                var b = this.l;
                a = a === void 0 ? .1 : a;
                if (b.l.g) b = !1;
                else if (b.F) b = !1;
                else {
                    for(var c = u(b.h.values()), d = c.next(); !d.done; d = c.next())d = d.value, !d.Fd || d.Ra || d.rb || (d.Fd = !1, un(b, d, a));
                    b = !0;
                }
            } else b = !1;
            return b;
        };
        p.sh = function() {
            Za("Shaka Player's internal Manifest structure is NOT covered by semantic versioning compatibility guarantees.  It may change at any time!  Please consider filing a feature request for whatever you use getManifest() for.");
            return this.i;
        };
        p.Yk = function() {
            return this.Gc;
        };
        p.Rk = function() {
            var a = {
                video: null,
                audio: null,
                text: null
            };
            if (this.m != ms) return a;
            var b = this.l.o, c = this.h.currentTime;
            b = u([
                b.video,
                b.audio,
                this.l.C
            ]);
            for(var d = b.next(); !d.done; d = b.next())if ((d = d.value) && d.segmentIndex) {
                var e = d.segmentIndex.find(c);
                e = d.segmentIndex.get(e);
                e = {
                    codecs: e.codecs || d.codecs,
                    mimeType: e.mimeType || d.mimeType,
                    bandwidth: e.bandwidth || d.bandwidth
                };
                d.type == "video" ? (e.width = d.width, e.height = d.height, a.video = e) : d.type == "audio" ? a.audio = e : d.type == Ec && (a.text = e);
            }
            return a;
        };
        function qr(a) {
            var b = zo();
            b.streaming.failureCallback = function(c) {
                if (a.U()) {
                    var d = null;
                    c.code == 1001 || c.code == 1002 ? (d = 1, a.g.streaming.lowLatencyMode && (d = .1)) : c.code == 1003 && (d = .1);
                    d != null && (c.severity = 1, a.bi(d));
                }
            };
            b.textDisplayFactory = function() {
                if (a.Oe) {
                    var c = a.h;
                    c = c.webkitDisplayingFullscreen || c.webkitPresentationMode && c.webkitPresentationMode != "inline" ? !1 : !0;
                } else c = !1;
                return c ? new Gp(a.h, a.Oe) : "track" in document.createElement("track") ? new Cp(a) : new Fp;
            };
            return b;
        }
        p.mi = function(a) {
            this.Oe = a;
        };
        function Tr(a, b) {
            for(var c = new Set, d = u(b.textStreams), e = d.next(); !e.done; e = d.next())e = e.value, e.mimeType != "application/cea-608" && e.mimeType != "application/cea-708" || c.add(e.originalId);
            d = u(b.variants);
            for(e = d.next(); !e.done; e = d.next())if ((e = e.value.video) && e.closedCaptions) {
                for(var f = u(e.closedCaptions.keys()), g = f.next(); !g.done; g = f.next())if (g = g.value, !c.has(g)) {
                    var h = g.startsWith("CC") ? "application/cea-608" : "application/cea-708", k = new ym, l = e.closedCaptions.get(g);
                    h = {
                        id: a.Se++,
                        originalId: g,
                        groupId: null,
                        createSegmentIndex: function() {
                            return Promise.resolve();
                        },
                        segmentIndex: k,
                        mimeType: h,
                        codecs: "",
                        kind: "caption",
                        encrypted: !1,
                        drmInfos: [],
                        keyIds: new Set,
                        language: l,
                        originalLanguage: l,
                        label: null,
                        type: Ec,
                        primary: !1,
                        trickModeVideo: null,
                        dependencyStream: null,
                        emsgSchemeIdUris: null,
                        roles: e.roles,
                        forced: !1,
                        channelsCount: null,
                        audioSamplingRate: null,
                        spatialAudio: !1,
                        closedCaptions: null,
                        accessibilityPurpose: null,
                        external: !1,
                        fastSwitching: !1,
                        fullMimeTypes: new Set([
                            wf(h, "")
                        ]),
                        isAudioMuxedInVideo: !1,
                        baseOriginalId: null
                    };
                    b.textStreams.push(h);
                    c.add(g);
                }
            }
        }
        function rs(a, b) {
            var c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) return c = a.audio, d = a.video, e = function(k, l) {
                    var m, n, q;
                    return H(function(r) {
                        if (r.h == 1) return k ? k.segmentIndex ? r.B(2) : r.g(k.createSegmentIndex(), 2) : r.return(null);
                        n = (m = k.segmentIndex.ac(l)) ? m.next().value : null;
                        if (!n) return r.return(null);
                        q = n.startTime;
                        return r.return(q);
                    });
                }, h.g(e(c, b), 2);
                if (h.h != 3) return f = h.i, h.g(e(d, b), 3);
                g = h.i;
                return g != null && f != null ? h.return(Math.max(g, f)) : g != null ? h.return(g) : f != null ? h.return(f) : h.return(b);
            });
        }
        function Ir(a) {
            var b = a.Df();
            if (a.C && a.P && a.G) {
                if (a.g.streaming.rebufferingGoal == 0) {
                    var c = a.L;
                    c.j = !1;
                    Cm(c);
                } else c = a.L, c.j = b, Cm(c);
                a.K && (c = a.K, b || c.F || (c.F = !0), c.F && b && (c.I = !0, bq(c, "ps", {
                    nd: "r"
                })), c.J = b);
                bs(a);
                c = a.g.streaming.liveSync.dynamicTargetLatency.maxAttempts;
                if (a.g.streaming.liveSync.dynamicTargetLatency.enabled && b && a.$e < c) {
                    c = a.g.streaming.liveSync.dynamicTargetLatency.maxLatency;
                    var d = a.g.streaming.liveSync.targetLatencyTolerance, e = a.g.streaming.liveSync.dynamicTargetLatency.rebufferIncrement;
                    a.S && (a.S = Math.min(a.S + ++a.$e * e, c - d));
                }
            }
            b = (new Map).set("buffering", b);
            a.dispatchEvent(yr("buffering", b));
        }
        function cs(a) {
            var b = a.h.playbackRate;
            b == 0 ? (b = a.Wa(), b !== 0 && b !== 1 && (b = yr("ratechange"), a.dispatchEvent(b))) : (a.L && (a.L.set(b), a.m == ms && a.o.playbackRateChanged(b), Hs(a, b)), b = yr("ratechange"), a.dispatchEvent(b));
        }
        function Hs(a, b) {
            a.jc.Ta();
            a.jc.u(a.h, "timeupdate", function() {
                var c = a.h.currentTime, d = a.wa(), e = a.U(), f = e ? a.g.streaming.safeSeekOffset : 0;
                b > 0 ? e && b > 1 && Math.floor(c) >= Math.floor(d.end) && a.ud() : Math.floor(c) <= Math.floor(d.start + f) && a.ud();
            });
        }
        function bs(a) {
            if (a.C && a.P) {
                var b = a.C.g, c = "playing";
                a.P.g == Ji ? c = "buffering" : a.isEnded() ? c = "ended" : a.h.paused && (c = "paused");
                var d = c;
                if (b.g == null) b.g = {
                    timestamp: Date.now() / 1E3,
                    state: d,
                    duration: 0
                }, b = !0;
                else {
                    var e = Date.now() / 1E3;
                    b.g.duration = e - b.g.timestamp;
                    b.g.state == d ? b = !1 : (b.h.push(b.g), b.g = {
                        timestamp: e,
                        state: d,
                        duration: 0
                    }, b = !0);
                }
                b && (c = (new Map).set("newstate", c), a.dispatchEvent(yr("statechanged", c)));
            }
        }
        function vs(a) {
            var b = a.h.playbackRate, c = a.U();
            if (a.g.streaming.vodDynamicPlaybackRate && !c) {
                var d = a.g.streaming.vodDynamicPlaybackRateLowBufferRate, e = a.Zi();
                e <= a.g.streaming.vodDynamicPlaybackRateBufferRatio ? b != d && a.sc(d, !1) : e == 1 && b !== a.L.Cd() && a.ud();
            }
            if (c && (c = a.wa(), Number.isFinite(c.end) && !(a.h.currentTime < c.start || a.h.paused))) {
                d = a.g.streaming.liveSync.targetLatencyTolerance;
                e = a.g.streaming.liveSync.dynamicTargetLatency.enabled;
                var f = a.g.streaming.liveSync.dynamicTargetLatency.stabilityThreshold;
                if (a.g.streaming.liveSync && a.g.streaming.liveSync.enabled) {
                    var g = a.g.streaming.liveSync.targetLatency;
                    var h = g + d;
                    var k = Math.max(0, g - d);
                    var l = a.g.streaming.liveSync.maxPlaybackRate;
                    var m = a.g.streaming.liveSync.minPlaybackRate;
                } else a.i && a.i.serviceDescription && (g = a.i.serviceDescription.targetLatency, a.i.serviceDescription.targetLatency != null ? h = a.i.serviceDescription.targetLatency + d : a.i.serviceDescription.maxLatency != null && (h = a.i.serviceDescription.maxLatency), a.i.serviceDescription.targetLatency != null ? k = Math.max(0, a.i.serviceDescription.targetLatency - d) : a.i.serviceDescription.minLatency != null && (k = a.i.serviceDescription.minLatency), l = a.i.serviceDescription.maxPlaybackRate || a.g.streaming.liveSync.maxPlaybackRate, m = a.i.serviceDescription.minPlaybackRate || a.g.streaming.liveSync.minPlaybackRate);
                a.S || typeof g !== "number" || (a.S = g);
                var n = a.g.streaming.liveSync.dynamicTargetLatency.maxAttempts;
                e && a.hc && a.S !== null && typeof g === "number" && a.$e < n && Date.now() - a.hc > f * 1E3 && (f = a.g.streaming.liveSync.dynamicTargetLatency.minLatency, a.S = Math.max(a.S - (g - f) / 2, f + d), a.hc = Date.now());
                e && a.S !== null && (h = a.S + d, k = a.S - d);
                g = c.end - a.h.currentTime;
                d = 0;
                a.m == fs && (e = a.h.buffered, e.length > 0 && (d = e.end(e.length - 1), d = Math.max(l, d - c.end)));
                c = a.g.streaming.liveSync.panicMode;
                e = a.g.streaming.liveSync.panicThreshold * 1E3;
                f = Date.now() - a.P.i;
                c && !m && (m = a.g.streaming.liveSync.minPlaybackRate);
                c && m && f <= e ? b != m && a.sc(m, !1) : h != void 0 && l && g - d > h ? (b != l && a.sc(l, !1), a.hc = null) : k != void 0 && m && g - d < k ? (b != m && a.sc(m, !1), a.hc = null) : b !== a.L.Cd() && (a.ud(), a.hc = Date.now());
            }
        }
        function Ts(a, b, c) {
            return (rk(b, c, .01) || c > b) && a.Bg < b ? (a.Bg = b, !0) : !1;
        }
        function ws(a) {
            if (a.h) {
                var b = a.wa();
                b = b.end - b.start;
                b = b > 0 ? a.h.currentTime / b : 0;
                if (!isNaN(b)) {
                    b *= 100;
                    if (Ts(a, 0, b)) var c = yr("started");
                    else if (Ts(a, 25, b)) c = yr("firstquartile");
                    else if (Ts(a, 50, b)) c = yr("midpoint");
                    else if (Ts(a, 75, b)) c = yr("thirdquartile");
                    else {
                        if (Ts(a, 100, b) || b > 100) c = yr("complete");
                        a.g && a.g.playRangeEnd != Infinity && a.isEnded() && a.h.pause();
                    }
                    c && a.dispatchEvent(c);
                }
            }
        }
        function is(a) {
            try {
                Qi(a.Re, a.i);
            } catch (c) {
                return Gr(a, c), !1;
            }
            var b = Fg(a.i.variants);
            b = a.J.create(b);
            a = a.o.setVariants(Array.from(b.values()));
            return typeof a == "boolean" ? a : !0;
        }
        function ns(a, b) {
            b = b === void 0 ? !1 : b;
            if (is(a)) {
                if (!a.g.abr.enabled) {
                    var c = a.J;
                    typeof c.getLastAdaptationSet != "function" && (md("AdaptationSetCriteria w/o getLastAdaptationSet", "Please use an AdaptationSetCriteria with getLastAdaptationSet."), c.getLastAdaptationSet = function() {
                        return null;
                    });
                    if (c = c.getLastAdaptationSet()) {
                        if (c = Array.from(c.values()), c.length) {
                            var d = a.l.o;
                            if (d && d.video && (c = c.find(function(e) {
                                return e.video == d.video;
                            }))) return c;
                        }
                    }
                }
                return a.o.chooseVariant(b);
            }
            return null;
        }
        function vr(a, b, c, d, e) {
            b = b === void 0 ? !0 : b;
            c = c === void 0 ? 0 : c;
            d = d === void 0 ? !1 : d;
            e = e === void 0 ? !0 : e;
            var f = ns(a);
            f && ks(a, f, e, b, c, d);
        }
        function ks(a, b, c, d, e, f) {
            f = f === void 0 ? !1 : f;
            var g = a.l.o;
            if (b == g) d && yn(a.l, b, d, e, !0);
            else {
                var h = a.C.h;
                h.h != b && (h.h = b, h.g.push({
                    timestamp: Date.now() / 1E3,
                    id: b.id,
                    type: "variant",
                    fromAdaptation: c,
                    bandwidth: b.bandwidth
                }));
                yn(a.l, b, d, e, f, c);
                d = null;
                g && (d = wg(g));
                g = wg(b);
                g.active = !0;
                if (a.R && (e = a.R, b = b.video)) {
                    b.dependencyStream && (b = b.dependencyStream);
                    f = 0;
                    h = -1;
                    switch(b.mimeType){
                        case "video/webm":
                            f = 1;
                            break;
                        case "video/mp4":
                            f = 2;
                    }
                    switch(a.uh()){
                        case "DASH":
                            h = 1;
                            break;
                        case "HLS":
                            h = 0;
                    }
                    e.g && (e.g.setLevelSwitching(b.id, !0), e.g.setContainerFormat(f), e.j || e.g.setStreamingFormat(h));
                }
                c ? (c = (new Map).set("oldTrack", d).set("newTrack", g), c = yr("adaptation", c), Us(a, c)) : Vs(a, d, g);
                Ws(a, d, g);
            }
        }
        function Ms(a, b) {
            var c = Array.from(a.h.audioTracks).find(function(e) {
                return e.enabled;
            });
            b.enabled = !0;
            if (c) {
                b.id !== c.id && (c.enabled = !1);
                var d = Is(a);
                c = Dg(c, d);
                b = Dg(b, d);
                Vs(a, c, b);
                Ws(a, c, b);
            }
        }
        function Is(a) {
            return a.h && a.h.videoTracks ? Array.from(a.h.videoTracks).find(function(b) {
                return b.selected;
            }) : null;
        }
        function es(a) {
            var b = yr("trackschanged");
            Us(a, b);
            Xs(a);
        }
        function Vs(a, b, c) {
            b = (new Map).set("oldTrack", b).set("newTrack", c);
            b = yr("variantchanged", b);
            Us(a, b);
        }
        function Ws(a, b, c) {
            var d = !1;
            b && b.audioId == c.audioId && b.audioGroupId == c.audioGroupId || (d = !0);
            d && Xs(a);
        }
        function Xs(a) {
            var b = yr("audiotrackschanged");
            Us(a, b);
        }
        function ds(a) {
            var b = yr("textchanged");
            Us(a, b);
        }
        function ss(a) {
            var b = yr("texttrackvisibility");
            Us(a, b);
        }
        function us(a) {
            a.g.abr.enabled || ur(a);
            var b = (new Map).set("newStatus", a.g.abr.enabled);
            Us(a, yr("abrstatuschanged", b));
        }
        function ts(a) {
            var b = a.yc().find(function(c) {
                return c.active;
            });
            b && a.A && a.A.setTextLanguage && a.A.setTextLanguage(b.language);
        }
        function ur(a, b) {
            b = b === void 0 ? !0 : b;
            if (a.m == ms) {
                a.Ue.stop();
                for(var c = u(a.i.variants), d = c.next(); !d.done; d = c.next())d.value.disabledUntilTime = 0;
                b && is(a);
            }
        }
        p.disableStream = function(a, b) {
            if (!this.g.abr.enabled || this.m === zr || !navigator.onLine || b == 0 || !this.i) return !1;
            if (this.i.variants.some(function(h) {
                var k = h[a.type];
                return k && k.id !== a.id && !h.disabledUntilTime ? a.type == "audio" ? a.language === k.language : !0 : !1;
            })) {
                for(var c = !1, d = !1, e = u(this.i.variants), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = f[a.type];
                    g && (g.id === a.id ? (f.disabledUntilTime = Date.now() / 1E3 + b, c = !0) : g.trickModeVideo && g.trickModeVideo.id == a.id && (d = !0));
                }
                if (!c && d) return !1;
                this.Ue.xa(1);
                b = this.Nc().video.reduce(function(h, k) {
                    return h + k.end - k.start;
                }, 0);
                vr(this, !1, b, !0, !1);
                return !0;
            }
            return !1;
        };
        function Gr(a, b) {
            var c, d, e, f, g;
            return H(function(h) {
                switch(h.h){
                    case 1:
                        if (a.m == zr) return h.return();
                        b.severity === 1 && a.C.L++;
                        c = !0;
                        if (!(a.Oa && a.i && a.l) || b.code != 3016 && b.code != 3014 && b.code != 3015 && b.code != 3024 && b.code != 3018) {
                            h.B(2);
                            break;
                        }
                        d = Xb();
                        if (d.Ma() === "WEBKIT" && b.code == 3016) return h.return();
                        h.m(3);
                        return h.g(On(a.l), 5);
                    case 5:
                        e = h.i;
                        c = !e;
                        e && (f = yr("mediasourcerecovered"), a.dispatchEvent(f));
                        h.o(2);
                        break;
                    case 3:
                        h.l(), c = !0;
                    case 2:
                        if (!c) return h.return();
                        b.severity === 2 && ur(a, !1);
                        g = yr("error", (new Map).set("detail", b));
                        a.dispatchEvent(g);
                        g.defaultPrevented && (b.handled = !0);
                        h.j();
                }
            });
        }
        p.addFont = function(a, b) {
            return jk(a, b);
        };
        function Vr(a, b, c, d) {
            d = d === void 0 ? a : d;
            a = (new Map).set("detail", {
                schemeIdUri: c.schemeIdUri,
                value: c.value,
                startTime: c.startTime,
                endTime: c.endTime,
                id: c.id,
                timescale: c.timescale,
                eventElement: c.eventElement,
                eventNode: c.eventNode
            });
            d.dispatchEvent(yr(b, a));
        }
        function Wr(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            b = (new Map).set("mediaQuality", {
                bandwidth: b.bandwidth,
                audioSamplingRate: b.audioSamplingRate,
                codecs: b.codecs,
                contentType: b.contentType,
                frameRate: b.frameRate,
                height: b.height,
                mimeType: b.mimeType,
                channelsCount: b.channelsCount,
                pixelAspectRatio: b.pixelAspectRatio,
                width: b.width,
                label: b.label,
                roles: b.roles,
                language: b.language
            }).set("position", c);
            a.dispatchEvent(yr(d ? "audiotrackchanged" : "mediaqualitychanged", b));
        }
        function Fr(a, b) {
            b = b === void 0 ? !0 : b;
            if (!a.h.error) return b ? new T(2, 3, 3016) : null;
            var c = a.h.error.code;
            if (!b && c == 1) return null;
            if (b = a.h.error.msExtendedCode) b < 0 && (b += 4294967296), b = b.toString(16);
            return new T(2, 3, 3016, c, b, a.h.error.message);
        }
        function Xr(a, b) {
            if (a.l) {
                var c = yr("keystatuschanged");
                a.dispatchEvent(c);
                var d = Object.keys(b);
                d.length == 1 && d[0] == "" && (d = [
                    "00"
                ], b = {
                    "00": b[""]
                });
                var e = d.length == 1 && d[0] == "00";
                c = !1;
                if (d.length) {
                    d = a.keySystem();
                    for(var f = wh(a.g.drm.clearKeys), g = function(t, v) {
                        t.allowedByKeySystem = !0;
                        v = u(v);
                        for(var w = v.next(); !w.done; w = v.next())if (w = w.value, (w = b[e ? "00" : w]) || a.F.H) t.allowedByKeySystem = t.allowedByKeySystem && !!w && !Ri.includes(w);
                    }, h = u(a.i.variants), k = h.next(); !k.done; k = h.next()){
                        k = k.value;
                        var l = Mg(k);
                        l = u(l);
                        for(var m = l.next(); !m.done; m = l.next()){
                            m = m.value;
                            var n = k.allowedByKeySystem;
                            if (m.keyIds.size) {
                                if (m.drmInfos.length && !f.size && a.i.type == "HLS") for(var q = u(m.drmInfos), r = q.next(); !r.done; r = q.next())r = r.value, r.keySystem == d && (r.keyIds.size ? g(k, r.keyIds) : g(k, m.keyIds));
                                else g(k, m.keyIds);
                            }
                            n != k.allowedByKeySystem && (c = !0);
                        }
                    }
                }
                c && (es(a), (c = a.l.o) && !c.allowedByKeySystem ? vr(a) : is(a));
            }
        }
        function js(a, b, c) {
            b > 0 && (a.U() || a.Sj(b));
            b = a.getDuration();
            c < b && (a.U() || a.Ab(c));
        }
        function Us(a, b) {
            H(function(c) {
                if (c.h == 1) return c.g(Promise.resolve(), 2);
                a.m != zr && a.dispatchEvent(b);
                c.j();
            });
        }
        function Os(a) {
            var b = new Set;
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())c = c.value, c.language ? b.add(Kc(c.language)) : b.add("und");
            return b;
        }
        function Ns(a) {
            for(var b = new Map, c = new Map, d = 0; d < a.length; d++){
                var e = a[d], f = "und", g = [];
                e.language && (f = Kc(e.language));
                e.type == "variant" ? g = e.audioRoles : g = e.roles;
                g && g.length || (g = [
                    ""
                ]);
                b.has(f) || b.set(f, new Set);
                g = u(g);
                for(var h = g.next(); !h.done; h = g.next())h = h.value, b.get(f).add(h), e.label && (c.has(f) || c.set(f, new Map), c.get(f).set(h, e.label));
            }
            var k = [];
            b.forEach(function(l, m) {
                l = u(l);
                for(var n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    var q = null;
                    c.has(m) && c.get(m).has(n) && (q = c.get(m).get(n));
                    k.push({
                        language: m,
                        role: n,
                        label: q
                    });
                }
            });
            return k;
        }
        p.Da = function() {
            return this.h && this.h.remote ? this.h.remote.state != "disconnected" : !1;
        };
        p.isEnded = function() {
            return !this.h || this.h.ended ? !0 : this.Oa && !this.U() && this.h.currentTime >= this.wa().end;
        };
        O("shaka.Player", W);
        W.prototype.isEnded = W.prototype.isEnded;
        W.prototype.isRemotePlayback = W.prototype.Da;
        W.prototype.addFont = W.prototype.addFont;
        W.prototype.setVideoContainer = W.prototype.mi;
        W.prototype.getFetchedPlaybackInfo = W.prototype.Rk;
        W.prototype.getManifestParserFactory = W.prototype.Yk;
        W.prototype.getManifest = W.prototype.sh;
        W.prototype.retryStreaming = W.prototype.bi;
        W.prototype.setMaxHardwareResolution = W.prototype.ym;
        W.prototype.addChaptersTrack = W.prototype.bf;
        W.prototype.addThumbnailsTrack = W.prototype.cf;
        W.prototype.addTextTrackAsync = W.prototype.fe;
        W.prototype.getStats = W.prototype.getStats;
        W.prototype.getBufferedInfo = W.prototype.Nc;
        W.prototype.getSegmentAvailabilityDuration = W.prototype.xf;
        W.prototype.getPresentationStartTimeAsDate = W.prototype.cj;
        W.prototype.getPlayheadTimeAsDate = W.prototype.al;
        W.prototype.setTextTrackVisibility = W.prototype.Xd;
        W.prototype.getChaptersAsync = W.prototype.ph;
        W.prototype.getChapters = W.prototype.Hk;
        W.prototype.getChaptersTracks = W.prototype.Ik;
        W.prototype.isTextTrackVisible = W.prototype.Tc;
        W.prototype.selectVariantsByLabel = W.prototype.sm;
        W.prototype.selectTextLanguage = W.prototype.ei;
        W.prototype.selectAudioLanguage = W.prototype.Ij;
        W.prototype.getTextLanguages = W.prototype.ol;
        W.prototype.getAudioLanguages = W.prototype.Dk;
        W.prototype.getTextLanguagesAndRoles = W.prototype.ql;
        W.prototype.getAudioLanguagesAndRoles = W.prototype.Ek;
        W.prototype.getVideoTracks = W.prototype.getVideoTracks;
        W.prototype.selectVideoTrack = W.prototype.Kj;
        W.prototype.getAudioTracks = W.prototype.getAudioTracks;
        W.prototype.selectAudioTrack = W.prototype.Jj;
        W.prototype.selectVariantTrack = W.prototype.Ge;
        W.prototype.selectTextTrack = W.prototype.gg;
        W.prototype.getThumbnails = W.prototype.dj;
        W.prototype.getAllThumbnails = W.prototype.Ck;
        W.prototype.getImageTracks = W.prototype.rh;
        W.prototype.getTextTracks = W.prototype.yc;
        W.prototype.getVariantTracks = W.prototype.Ib;
        W.prototype.cancelTrickPlay = W.prototype.ud;
        W.prototype.trickPlay = W.prototype.sc;
        W.prototype.useTrickPlayTrackIfAvailable = W.prototype.Ci;
        W.prototype.getPlaybackRate = W.prototype.Wa;
        W.prototype.isBuffering = W.prototype.Df;
        W.prototype.getKeyStatuses = W.prototype.uf;
        W.prototype.getActiveSessionsMetadata = W.prototype.oh;
        W.prototype.getExpiration = W.prototype.oe;
        W.prototype.drmInfo = W.prototype.drmInfo;
        W.prototype.keySystem = W.prototype.keySystem;
        W.prototype.isFullyLoaded = W.prototype.Gh;
        W.prototype.goToLive = W.prototype.Bl;
        W.prototype.seekRange = W.prototype.wa;
        W.prototype.isVideoOnly = W.prototype.Hf;
        W.prototype.isAudioOnly = W.prototype.Hd;
        W.prototype.isInProgress = W.prototype.fd;
        W.prototype.isLive = W.prototype.U;
        W.prototype.getQueueManager = W.prototype.wf;
        W.prototype.getAdManager = W.prototype.tf;
        W.prototype.getAssetUri = W.prototype.dd;
        W.prototype.getNetworkingEngine = W.prototype.Qb;
        W.prototype.getMediaElement = W.prototype.vf;
        W.prototype.getManifestType = W.prototype.uh;
        W.prototype.getLoadMode = W.prototype.xc;
        W.prototype.resetConfiguration = W.prototype.Dj;
        W.prototype.getBufferFullness = W.prototype.Zi;
        W.prototype.getNonDefaultConfiguration = W.prototype.bj;
        W.prototype.getConfigurationForLowLatency = W.prototype.Lk;
        W.prototype.getConfiguration = W.prototype.getConfiguration;
        W.prototype.configurationForLowLatency = W.prototype.zk;
        W.prototype.configure = W.prototype.configure;
        W.prototype.releaseAllMutexes = W.prototype.hm;
        W.prototype.destroyAllPreloads = W.prototype.Vg;
        W.prototype.preload = W.prototype.preload;
        W.prototype.detachAndSavePreload = W.prototype.Vi;
        W.prototype.unloadAndSavePreload = W.prototype.gk;
        W.prototype.load = W.prototype.load;
        W.prototype.updateStartTime = W.prototype.Gm;
        W.prototype.unload = W.prototype.tc;
        W.prototype.detach = W.prototype.detach;
        W.prototype.attachCanvas = W.prototype.Ji;
        W.prototype.attach = W.prototype.Ob;
        W.probeSupport = function(a) {
            a = a === void 0 ? !0 : a;
            var b, c, d, e, f, g, h;
            return H(function(k) {
                switch(k.h){
                    case 1:
                        b = {};
                        if (!a) {
                            k.B(2);
                            break;
                        }
                        return k.g(Ei(), 3);
                    case 3:
                        b = k.i;
                    case 2:
                        return c = zd(), d = Zk(), e = Xb(), k.g(e.vc(), 4);
                    case 4:
                        return f = k.i, g = {
                            manifest: c,
                            media: d,
                            drm: b,
                            hardwareResolution: f
                        }, h = Br, h.forEach(function(l, m) {
                            g[m] = l();
                        }), k.return(g);
                }
            });
        };
        W.isBrowserSupported = Cr;
        W.setQueueManagerFactory = function(a) {
            tr = a;
        };
        W.setAdManagerFactory = function(a) {
            sr = a;
        };
        W.registerSupportPlugin = Ar;
        W.prototype.destroy = W.prototype.destroy;
        var zr = 0, pr = 1, ms = 2, fs = 3;
        W.LoadMode = {
            DESTROYED: zr,
            NOT_LOADED: pr,
            MEDIA_SOURCE: ms,
            SRC_EQUALS: fs
        };
        W.version = "v4.16.44";
        var Ys = [
            "4",
            "16"
        ];
        nd = new function(a) {
            this.g = a;
            this.i = od;
            this.h = pd;
        }(new ld(Number(Ys[0]), Number(Ys[1])));
        var Br = new Map, sr = null, tr = null;
        function Zs() {
            this.g = [];
            this.i = this.m = this.l = this.j = this.h = 0;
        }
        function $s(a) {
            return a.g.length ? a.g.reduce(function(b, c) {
                return b + c;
            }, 0) / a.g.length : 0;
        }
        function at(a, b, c) {
            var d = this;
            this.g = a;
            this.h = b;
            this.m = c;
            this.i = !1;
            this.j = this.h.getVolume();
            this.l = new fd;
            this.l.u(this.h, google.ima.AdEvent.Type.PAUSED, function() {
                d.i = !0;
            });
            this.l.u(this.h, google.ima.AdEvent.Type.RESUMED, function() {
                d.i = !1;
            });
        }
        p = at.prototype;
        p.needsSkipUI = function() {
            return !1;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return !0;
        };
        p.isUsingAnotherMediaElement = function() {
            return !0;
        };
        p.getDuration = function() {
            return this.g.getDuration();
        };
        p.getMinSuggestedDuration = function() {
            return this.g.getMinSuggestedDuration();
        };
        p.getRemainingTime = function() {
            return this.h.getRemainingTime();
        };
        p.isPaused = function() {
            return this.i;
        };
        p.isSkippable = function() {
            return this.g.getSkipTimeOffset() >= 0;
        };
        p.getTimeUntilSkippable = function() {
            var a = this.g.getSkipTimeOffset();
            a = this.getRemainingTime() - a;
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.h.getAdSkippableState();
        };
        p.skip = function() {
            return this.h.skip();
        };
        p.pause = function() {
            return this.h.pause();
        };
        p.play = function() {
            return this.h.resume();
        };
        p.getVolume = function() {
            return this.h.getVolume();
        };
        p.setVolume = function(a) {
            this.m.volume = a;
            return this.h.setVolume(a);
        };
        p.isMuted = function() {
            return this.h.getVolume() == 0;
        };
        p.isLinear = function() {
            return this.g.isLinear();
        };
        p.resize = function(a, b) {
            this.h.resize(a, b);
        };
        p.setMuted = function(a) {
            (this.m.muted = a) ? (this.j = this.getVolume(), this.h.setVolume(0)) : this.h.setVolume(this.j);
        };
        p.getSequenceLength = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getTotalAds();
        };
        p.getPositionInSequence = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getAdPosition();
        };
        p.getTitle = function() {
            return this.g.getTitle();
        };
        p.getDescription = function() {
            return this.g.getDescription();
        };
        p.getVastMediaBitrate = function() {
            return this.g.getVastMediaBitrate();
        };
        p.getVastMediaHeight = function() {
            return this.g.getVastMediaHeight();
        };
        p.getVastMediaWidth = function() {
            return this.g.getVastMediaWidth();
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.getAdId();
        };
        p.getCreativeAdId = function() {
            return this.g.getCreativeAdId();
        };
        p.getAdvertiserName = function() {
            return this.g.getAdvertiserName();
        };
        p.getMediaUrl = function() {
            return this.g.getMediaUrl();
        };
        p.getTimeOffset = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getTimeOffset();
        };
        p.getPodIndex = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getPodIndex();
        };
        p.release = function() {
            this.h = this.g = null;
        };
        O("shaka.ads.ClientSideAd", at);
        at.prototype.release = at.prototype.release;
        at.prototype.getPodIndex = at.prototype.getPodIndex;
        at.prototype.getTimeOffset = at.prototype.getTimeOffset;
        at.prototype.getMediaUrl = at.prototype.getMediaUrl;
        at.prototype.getAdvertiserName = at.prototype.getAdvertiserName;
        at.prototype.getCreativeAdId = at.prototype.getCreativeAdId;
        at.prototype.getAdId = at.prototype.getAdId;
        at.prototype.getVastAdId = at.prototype.getVastAdId;
        at.prototype.getVastMediaWidth = at.prototype.getVastMediaWidth;
        at.prototype.getVastMediaHeight = at.prototype.getVastMediaHeight;
        at.prototype.getVastMediaBitrate = at.prototype.getVastMediaBitrate;
        at.prototype.getDescription = at.prototype.getDescription;
        at.prototype.getTitle = at.prototype.getTitle;
        at.prototype.getPositionInSequence = at.prototype.getPositionInSequence;
        at.prototype.getSequenceLength = at.prototype.getSequenceLength;
        at.prototype.setMuted = at.prototype.setMuted;
        at.prototype.resize = at.prototype.resize;
        at.prototype.isLinear = at.prototype.isLinear;
        at.prototype.isMuted = at.prototype.isMuted;
        at.prototype.setVolume = at.prototype.setVolume;
        at.prototype.getVolume = at.prototype.getVolume;
        at.prototype.play = at.prototype.play;
        at.prototype.pause = at.prototype.pause;
        at.prototype.skip = at.prototype.skip;
        at.prototype.canSkipNow = at.prototype.canSkipNow;
        at.prototype.getTimeUntilSkippable = at.prototype.getTimeUntilSkippable;
        at.prototype.isSkippable = at.prototype.isSkippable;
        at.prototype.isPaused = at.prototype.isPaused;
        at.prototype.getRemainingTime = at.prototype.getRemainingTime;
        at.prototype.getMinSuggestedDuration = at.prototype.getMinSuggestedDuration;
        at.prototype.getDuration = at.prototype.getDuration;
        at.prototype.isUsingAnotherMediaElement = at.prototype.isUsingAnotherMediaElement;
        at.prototype.hasCustomClick = at.prototype.hasCustomClick;
        at.prototype.isClientRendering = at.prototype.isClientRendering;
        at.prototype.needsSkipUI = at.prototype.needsSkipUI;
        function bt() {}
        function ct(a, b) {
            var c = [];
            a = u(ie(a, "Ad"));
            for(var d = a.next(); !d.done; d = a.next())if (d = ne(d.value, "InLine")) {
                if (d = ne(d, "Creatives")) {
                    d = u(ie(d, "Creative"));
                    for(var e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        var f = ne(e, "Linear");
                        f && dt(c, b, f);
                        if (e = ne(e, "NonLinearAds")) {
                            e = ie(e, "NonLinear");
                            e = u(e);
                            for(var g = e.next(); !g.done; g = e.next())a: {
                                f = c;
                                var h = b, k = g.value, l = ne(k, "StaticResource");
                                if (l) g = l.attributes.creativeType;
                                else {
                                    l = ne(k, "HTMLResource");
                                    if (!l) break a;
                                    g = "text/html";
                                }
                                if (l = le(l)) {
                                    g === "text/html" && (l = "data:text/html;charset=UTF-8," + encodeURIComponent(l));
                                    var m = qe(k, "width", we) || qe(k, "expandedWidth", we), n = qe(k, "height", we) || qe(k, "expandedHeight", we);
                                    if (m || n) {
                                        var q = null, r = ne(k, "NonLinearClickThrough");
                                        r && (r = le(r)) && (q = r);
                                        r = null;
                                        (k = k.attributes.minSuggestedDuration) && (r = Vd(k));
                                        k = 0;
                                        h != null && (k = h);
                                        f.push({
                                            id: null,
                                            groupId: null,
                                            startTime: k,
                                            endTime: null,
                                            uri: l,
                                            mimeType: g,
                                            isSkippable: !1,
                                            skipOffset: null,
                                            skipFor: null,
                                            canJump: !1,
                                            resumeOffset: 0,
                                            playoutLimit: r,
                                            once: !0,
                                            pre: h == null,
                                            post: h == Infinity,
                                            timelineRange: !1,
                                            loop: !1,
                                            overlay: {
                                                viewport: {
                                                    x: 0,
                                                    y: 0
                                                },
                                                topLeft: {
                                                    x: 0,
                                                    y: 0
                                                },
                                                size: {
                                                    x: m || 0,
                                                    y: n || 0
                                                }
                                            },
                                            displayOnBackground: !1,
                                            currentVideo: null,
                                            background: null,
                                            clickThroughUrl: q
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return c;
        }
        function dt(a, b, c) {
            var d = 0;
            b != null && (d = b);
            var e = null;
            c.attributes.skipoffset && (e = Vd(c.attributes.skipoffset), isNaN(e) && (e = null));
            var f = ne(c, "MediaFiles");
            if (f) {
                var g = null;
                (c = ne(c, "VideoClicks")) && (c = ne(c, "ClickThrough")) && (c = le(c)) && (g = c);
                f = c = ie(f, "MediaFile");
                c = c.filter(function(k) {
                    return k.attributes.delivery == "streaming";
                });
                c.length && (f = c);
                f = f.sort(function(k, l) {
                    return (parseInt(l.attributes.height, 10) || 0) - (parseInt(k.attributes.height, 10) || 0);
                });
                f = u(f);
                for(c = f.next(); !c.done; c = f.next())if (c = c.value, !c.attributes.apiFramework) {
                    var h = le(c);
                    if (h) {
                        a.push({
                            id: null,
                            groupId: null,
                            startTime: d,
                            endTime: null,
                            uri: h,
                            mimeType: c.attributes.type || null,
                            isSkippable: e != null,
                            skipOffset: e,
                            skipFor: null,
                            canJump: !1,
                            resumeOffset: 0,
                            playoutLimit: null,
                            once: !0,
                            pre: b == null,
                            post: b == Infinity,
                            timelineRange: !1,
                            loop: !1,
                            overlay: null,
                            displayOnBackground: !1,
                            currentVideo: null,
                            background: null,
                            clickThroughUrl: g
                        });
                        break;
                    }
                }
            }
        }
        function et(a) {
            var b = [];
            a = u(ie(a, "vmap:AdBreak"));
            for(var c = a.next(); !c.done; c = a.next()){
                var d = c.value, e = d.attributes.timeOffset;
                e && (c = null, e == "start" ? c = null : e == "end" ? c = Infinity : c = Vd(e), (d = ne(d, "vmap:AdSource")) && (d = ne(d, "vmap:AdTagURI")) && (d = ke(d)) && b.push({
                    time: c,
                    uri: d
                }));
            }
            return b;
        }
        O("shaka.ads.Utils", bt);
        bt.ADS_LOADED = "ads-loaded";
        bt.AD_STARTED = "ad-started";
        bt.AD_FIRST_QUARTILE = "ad-first-quartile";
        bt.AD_MIDPOINT = "ad-midpoint";
        bt.AD_THIRD_QUARTILE = "ad-third-quartile";
        bt.AD_COMPLETE = "ad-complete";
        bt.AD_STOPPED = "ad-stopped";
        bt.AD_SKIPPED = "ad-skipped";
        bt.AD_VOLUME_CHANGED = "ad-volume-changed";
        bt.AD_MUTED = "ad-muted";
        bt.AD_PAUSED = "ad-paused";
        bt.AD_RESUMED = "ad-resumed";
        bt.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
        bt.CUEPOINTS_CHANGED = "ad-cue-points-changed";
        bt.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
        bt.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
        bt.AD_CLICKED = "ad-clicked";
        bt.AD_PROGRESS = "ad-progress";
        bt.AD_BUFFERING = "ad-buffering";
        bt.AD_IMPRESSION = "ad-impression";
        bt.AD_DURATION_CHANGED = "ad-duration-changed";
        bt.AD_CLOSED = "ad-closed";
        bt.AD_LOADED = "ad-loaded";
        bt.ALL_ADS_COMPLETED = "all-ads-completed";
        bt.AD_LINEAR_CHANGED = "ad-linear-changed";
        bt.AD_METADATA = "ad-metadata";
        bt.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
        bt.AD_ERROR = "ad-error";
        bt.AD_BREAK_READY = "ad-break-ready";
        bt.AD_INTERACTION = "ad-interaction";
        bt.AD_CONTENT_PAUSE_REQUESTED = "ad-content-pause-requested";
        bt.AD_CONTENT_RESUME_REQUESTED = "ad-content-resume-requested";
        bt.AD_CONTENT_ATTACH_REQUESTED = "ad-content-attach-requested";
        function ft(a, b, c, d, e) {
            var f = this;
            this.A = a;
            this.i = b;
            this.G = !1;
            this.C = this.o = null;
            this.H = NaN;
            this.l = e;
            this.j = null;
            this.h = new fd;
            google.ima.settings.setLocale(c);
            google.ima.settings.setDisableCustomPlaybackForIOS10Plus(!0);
            this.F = new google.ima.AdDisplayContainer(this.A, this.i);
            this.F.initialize();
            this.m = new google.ima.AdsLoader(this.F);
            this.m.getSettings().setPlayerType("shaka-player");
            this.m.getSettings().setPlayerVersion("v4.16.44");
            this.g = null;
            this.D = d || new google.ima.AdsRenderingSettings;
            this.h.u(this.m, google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function(g) {
                gt(f, g);
            });
            this.h.u(this.m, google.ima.AdErrorEvent.Type.AD_ERROR, function(g) {
                ht(f, g);
            });
            this.h.u(this.i, "ended", function() {
                f.m.contentComplete();
            });
            this.h.ra(this.i, "play", function() {
                f.G = !0;
            });
        }
        ft.prototype.configure = function(a) {
            this.o = a;
        };
        ft.prototype.stop = function() {
            this.g && this.g.stop();
            this.A && gk(this.A);
        };
        ft.prototype.release = function() {
            this.stop();
            this.C && this.C.disconnect();
            this.h && this.h.release();
            this.g && this.g.destroy();
            this.m.destroy();
            this.F.destroy();
        };
        function ht(a, b) {
            b.getError();
            b = (new Map).set("originalEvent", b);
            a.l(new R("ad-error", b));
            it(a, null);
            a.l(new R("ad-cue-points-changed", (new Map).set("cuepoints", [])));
        }
        function gt(a, b) {
            a.l(new R("ads-loaded", (new Map).set("loadTime", Date.now() / 1E3 - a.H)));
            if (a.o.customPlayheadTracker) {
                var c = {
                    currentTime: a.i.currentTime
                };
                a.g = b.getAdsManager(c, a.D);
                a.i.muted ? a.g.setVolume(0) : a.g.setVolume(a.i.volume);
                a.h.u(a.i, "timeupdate", function() {
                    a.i.duration && (c.currentTime = a.i.currentTime);
                });
                a.h.u(a.i, "volumechange", function() {
                    a.j && (a.j.setVolume(a.i.volume), a.i.muted && a.j.setMuted(!0));
                });
            } else a.g = b.getAdsManager(a.i, a.D);
            a.l(new R("ima-ad-manager-loaded", (new Map).set("imaAdManager", a.g)));
            var d = a.g.getCuePoints();
            if (d.length) {
                b = [];
                d = u(d);
                for(var e = d.next(); !e.done; e = d.next())b.push({
                    start: e.value,
                    end: null
                });
                a.l(new R("ad-cue-points-changed", (new Map).set("cuepoints", b)));
            }
            jt(a);
            try {
                a.g.init(a.i.offsetWidth, a.i.offsetHeight), a.h.u(a.i, "loadeddata", function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), "ResizeObserver" in window1 ? (a.C = new ResizeObserver(function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), a.C.observe(a.i)) : a.h.u(document, "fullscreenchange", function() {
                    a.g.resize(a.i.offsetWidth, a.i.offsetHeight);
                }), a.G || a.o.skipPlayDetection ? a.g.start() : a.h.ra(a.i, "play", function() {
                    a.G = !0;
                    a.g.start();
                });
            } catch (f) {
                it(a, null);
            }
        }
        function jt(a) {
            function b(c, d) {
                c = (new Map).set("originalEvent", c);
                a.l(new R(d, c));
            }
            a.h.u(a.g, google.ima.AdErrorEvent.Type.AD_ERROR, function(c) {
                ht(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function(c) {
                kt(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.STARTED, function(c) {
                kt(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.FIRST_QUARTILE, function(c) {
                b(c, "ad-first-quartile");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.MIDPOINT, function(c) {
                b(c, "ad-midpoint");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.THIRD_QUARTILE, function(c) {
                b(c, "ad-third-quartile");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.COMPLETE, function(c) {
                b(c, "ad-complete");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function(c) {
                it(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.ALL_ADS_COMPLETED, function(c) {
                b(c, "all-ads-completed");
                it(a, c);
            });
            a.h.u(a.g, google.ima.AdEvent.Type.SKIPPED, function(c) {
                b(c, "ad-skipped");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.VOLUME_CHANGED, function(c) {
                b(c, "ad-volume-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.VOLUME_MUTED, function(c) {
                b(c, "ad-muted");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.PAUSED, function(c) {
                a.j && (a.j.i = !0, b(c, "ad-paused"));
            });
            a.h.u(a.g, google.ima.AdEvent.Type.RESUMED, function(c) {
                a.j && (a.j.i = !1, b(c, "ad-resumed"));
            });
            a.h.u(a.g, google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, function(c) {
                a.j && b(c, "ad-skip-state-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.CLICK, function(c) {
                b(c, "ad-clicked");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_PROGRESS, function(c) {
                b(c, "ad-progress");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_BUFFERING, function(c) {
                b(c, "ad-buffering");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.IMPRESSION, function(c) {
                b(c, "ad-impression");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.DURATION_CHANGE, function(c) {
                b(c, "ad-duration-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.USER_CLOSE, function(c) {
                b(c, "ad-closed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.LOADED, function(c) {
                b(c, "ad-loaded");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.LINEAR_CHANGED, function(c) {
                b(c, "ad-linear-changed");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_METADATA, function(c) {
                b(c, "ad-metadata");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.LOG, function(c) {
                b(c, "ad-recoverable-error");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.AD_BREAK_READY, function(c) {
                b(c, "ad-break-ready");
            });
            a.h.u(a.g, google.ima.AdEvent.Type.INTERACTION, function(c) {
                b(c, "ad-interaction");
            });
        }
        function kt(a, b) {
            var c = b.getAd();
            c ? (a.j = new at(c, a.g, a.i), b.type != google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED || a.o.supportsMultipleMediaElements || a.l(new R("ad-content-pause-requested")), b = (new Map).set("ad", a.j).set("sdkAdObject", c).set("originalEvent", b), a.l(new R("ad-started", b)), a.j.isLinear() && (a.A.setAttribute("ad-active", "true"), a.o.customPlayheadTracker || a.i.pause(), a.i.muted ? (b = a.j, b.j = a.i.volume, b.h.setVolume(0)) : a.j.setVolume(a.i.volume))) : Za("The IMA SDK fired a " + b.type + " event with no associated ad. Unable to play ad!");
        }
        function it(a, b) {
            b && b.type == google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED && !a.o.supportsMultipleMediaElements && a.l(new R("ad-content-resume-requested"));
            a.l(new R("ad-stopped", (new Map).set("originalEvent", b)));
            a.j && a.j.isLinear() && (a.A.removeAttribute("ad-active"), a.o.customPlayheadTracker || a.i.ended || a.i.play());
        }
        function lt(a, b, c, d, e, f) {
            this.g = a;
            this.h = b;
            this.j = (this.i = b.isSkippable) ? b.skipOffset || 0 : b.skipOffset;
            this.l = b.skipFor;
            this.C = c;
            this.o = d;
            this.m = e;
            this.A = f;
            this.D = b.overlay;
        }
        p = lt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return this.h.clickThroughUrl != null;
        };
        p.isUsingAnotherMediaElement = function() {
            return this.A;
        };
        p.getDuration = function() {
            var a = this.g.duration;
            return isNaN(a) ? -1 : a;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            var a = this.g.duration;
            return isNaN(a) ? -1 : a - this.g.currentTime;
        };
        p.isPaused = function() {
            return this.g.paused;
        };
        p.isSkippable = function() {
            return this.i && this.l != null ? this.getDuration() - this.getRemainingTime() < this.j + this.l : this.i;
        };
        p.getTimeUntilSkippable = function() {
            if (this.isSkippable()) {
                var a = this.getRemainingTime() + this.j - this.getDuration();
                return Math.max(a, 0);
            }
            return Math.max(this.getRemainingTime(), 0);
        };
        p.canSkipNow = function() {
            return this.i && this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.canSkipNow() && this.C();
        };
        p.pause = function() {
            return this.g.pause();
        };
        p.play = function() {
            return this.g.play();
        };
        p.getVolume = function() {
            return this.g.volume;
        };
        p.setVolume = function(a) {
            this.g.volume = a;
        };
        p.isMuted = function() {
            return this.g.muted;
        };
        p.isLinear = function() {
            return this.D == null;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.g.muted = a;
        };
        p.getSequenceLength = function() {
            return this.o;
        };
        p.getPositionInSequence = function() {
            return this.m;
        };
        p.getTitle = function() {
            return "";
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.h.id || "";
        };
        p.getCreativeAdId = function() {
            return "";
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return this.h.uri;
        };
        p.getTimeOffset = function() {
            return this.h.pre ? 0 : this.h.post ? -1 : this.h.startTime;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {
            this.g = null;
        };
        O("shaka.ads.InterstitialAd", lt);
        lt.prototype.release = lt.prototype.release;
        lt.prototype.getPodIndex = lt.prototype.getPodIndex;
        lt.prototype.getTimeOffset = lt.prototype.getTimeOffset;
        lt.prototype.getMediaUrl = lt.prototype.getMediaUrl;
        lt.prototype.getAdvertiserName = lt.prototype.getAdvertiserName;
        lt.prototype.getCreativeAdId = lt.prototype.getCreativeAdId;
        lt.prototype.getAdId = lt.prototype.getAdId;
        lt.prototype.getVastAdId = lt.prototype.getVastAdId;
        lt.prototype.getVastMediaWidth = lt.prototype.getVastMediaWidth;
        lt.prototype.getVastMediaHeight = lt.prototype.getVastMediaHeight;
        lt.prototype.getVastMediaBitrate = lt.prototype.getVastMediaBitrate;
        lt.prototype.getDescription = lt.prototype.getDescription;
        lt.prototype.getTitle = lt.prototype.getTitle;
        lt.prototype.getPositionInSequence = lt.prototype.getPositionInSequence;
        lt.prototype.getSequenceLength = lt.prototype.getSequenceLength;
        lt.prototype.setMuted = lt.prototype.setMuted;
        lt.prototype.resize = lt.prototype.resize;
        lt.prototype.isLinear = lt.prototype.isLinear;
        lt.prototype.isMuted = lt.prototype.isMuted;
        lt.prototype.setVolume = lt.prototype.setVolume;
        lt.prototype.getVolume = lt.prototype.getVolume;
        lt.prototype.play = lt.prototype.play;
        lt.prototype.pause = lt.prototype.pause;
        lt.prototype.skip = lt.prototype.skip;
        lt.prototype.canSkipNow = lt.prototype.canSkipNow;
        lt.prototype.getTimeUntilSkippable = lt.prototype.getTimeUntilSkippable;
        lt.prototype.isSkippable = lt.prototype.isSkippable;
        lt.prototype.isPaused = lt.prototype.isPaused;
        lt.prototype.getRemainingTime = lt.prototype.getRemainingTime;
        lt.prototype.getMinSuggestedDuration = lt.prototype.getMinSuggestedDuration;
        lt.prototype.getDuration = lt.prototype.getDuration;
        lt.prototype.isUsingAnotherMediaElement = lt.prototype.isUsingAnotherMediaElement;
        lt.prototype.hasCustomClick = lt.prototype.hasCustomClick;
        lt.prototype.isClientRendering = lt.prototype.isClientRendering;
        lt.prototype.needsSkipUI = lt.prototype.needsSkipUI;
        function mt(a, b, c) {
            this.g = a;
            this.j = b;
            this.h = c;
            this.i = a.overlay == null;
        }
        p = mt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !0;
        };
        p.hasCustomClick = function() {
            return this.g.clickThroughUrl != null;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return -1;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return -1;
        };
        p.isPaused = function() {
            return !1;
        };
        p.isSkippable = function() {
            return !1;
        };
        p.getTimeUntilSkippable = function() {
            return 0;
        };
        p.canSkipNow = function() {
            return !1;
        };
        p.skip = function() {};
        p.pause = function() {};
        p.play = function() {};
        p.getVolume = function() {
            return 1;
        };
        p.setVolume = function() {};
        p.isMuted = function() {
            return !1;
        };
        p.isLinear = function() {
            return this.i;
        };
        p.resize = function() {};
        p.setMuted = function() {};
        p.getSequenceLength = function() {
            return this.j;
        };
        p.getPositionInSequence = function() {
            return this.h;
        };
        p.getTitle = function() {
            return "";
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.id || "";
        };
        p.getCreativeAdId = function() {
            return "";
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return this.g.uri;
        };
        p.getTimeOffset = function() {
            return this.g.pre ? 0 : this.g.post ? -1 : this.g.startTime;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {};
        O("shaka.ads.InterstitialStaticAd", mt);
        mt.prototype.release = mt.prototype.release;
        mt.prototype.getPodIndex = mt.prototype.getPodIndex;
        mt.prototype.getTimeOffset = mt.prototype.getTimeOffset;
        mt.prototype.getMediaUrl = mt.prototype.getMediaUrl;
        mt.prototype.getAdvertiserName = mt.prototype.getAdvertiserName;
        mt.prototype.getCreativeAdId = mt.prototype.getCreativeAdId;
        mt.prototype.getAdId = mt.prototype.getAdId;
        mt.prototype.getVastAdId = mt.prototype.getVastAdId;
        mt.prototype.getVastMediaWidth = mt.prototype.getVastMediaWidth;
        mt.prototype.getVastMediaHeight = mt.prototype.getVastMediaHeight;
        mt.prototype.getVastMediaBitrate = mt.prototype.getVastMediaBitrate;
        mt.prototype.getDescription = mt.prototype.getDescription;
        mt.prototype.getTitle = mt.prototype.getTitle;
        mt.prototype.getPositionInSequence = mt.prototype.getPositionInSequence;
        mt.prototype.getSequenceLength = mt.prototype.getSequenceLength;
        mt.prototype.setMuted = mt.prototype.setMuted;
        mt.prototype.resize = mt.prototype.resize;
        mt.prototype.isLinear = mt.prototype.isLinear;
        mt.prototype.isMuted = mt.prototype.isMuted;
        mt.prototype.setVolume = mt.prototype.setVolume;
        mt.prototype.getVolume = mt.prototype.getVolume;
        mt.prototype.play = mt.prototype.play;
        mt.prototype.pause = mt.prototype.pause;
        mt.prototype.skip = mt.prototype.skip;
        mt.prototype.canSkipNow = mt.prototype.canSkipNow;
        mt.prototype.getTimeUntilSkippable = mt.prototype.getTimeUntilSkippable;
        mt.prototype.isSkippable = mt.prototype.isSkippable;
        mt.prototype.isPaused = mt.prototype.isPaused;
        mt.prototype.getRemainingTime = mt.prototype.getRemainingTime;
        mt.prototype.getMinSuggestedDuration = mt.prototype.getMinSuggestedDuration;
        mt.prototype.getDuration = mt.prototype.getDuration;
        mt.prototype.isUsingAnotherMediaElement = mt.prototype.isUsingAnotherMediaElement;
        mt.prototype.hasCustomClick = mt.prototype.hasCustomClick;
        mt.prototype.isClientRendering = mt.prototype.isClientRendering;
        mt.prototype.needsSkipUI = mt.prototype.needsSkipUI;
        function nt(a, b, c, d) {
            function e(g) {
                return g ? g.overlay ? !0 : f.g.ended ? g.post : f.g.paused ? !1 : !0 : !1;
            }
            var f = this;
            this.L = null;
            this.m = a;
            this.D = b;
            this.g = c;
            this.G = null;
            this.A = !0;
            this.h = this.g;
            this.na = d;
            this.$ = new Set;
            this.R = new Set;
            this.H = new Set;
            this.F = new Map;
            this.K = new Map;
            this.i = new W;
            ot(this);
            this.I = new fd;
            this.j = new fd;
            this.J = !1;
            this.W = this.o = this.C = this.l = null;
            this.X = !1;
            this.O = -1;
            this.V = function() {
                if (!f.J && f.l && !f.D.Da()) {
                    f.l = f.g.currentTime;
                    var g = pt(f);
                    g && e(g) && qt(f, g, 1, 1, Date.now());
                }
            };
            this.S = function() {
                if (!(f.J || f.l || f.D.Da())) {
                    f.g.paused || (f.l = f.g.currentTime);
                    var g;
                    f.C || (g = pt(f, !0));
                    g || (g = pt(f));
                    g && e(g) && qt(f, g, 1, 1, Date.now());
                }
            };
            this.ba = function() {
                if (!f.J && f.l && !f.D.Da()) {
                    var g = f.g.currentTime;
                    f.C && !f.C.pre && !f.C.post && g < (f.C.endTime || f.C.startTime) && (f.C = null);
                }
            };
            this.P = new Uf(this.V);
            this.M = new Uf(function() {
                var g, h, k, l, m, n, q, r, t, v, w;
                return H(function(x) {
                    switch(x.h){
                        case 1:
                            if (!f.H.size || f.l == null) {
                                x.B(0);
                                break;
                            }
                            g = f.D.xc();
                            if (g == zr || g == pr) return x.return();
                            h = !1;
                            k = Array.from(f.H);
                            l = f.D.wa();
                            m = u(k);
                            n = m.next();
                        case 3:
                            if (n.done) {
                                x.B(5);
                                break;
                            }
                            q = n.value;
                            if (q == f.C) {
                                x.B(4);
                                break;
                            }
                            r = q.endTime || q.startTime;
                            if (!(l.start - r >= 1)) {
                                t = q.startTime - f.l;
                                t > 0 && t <= 10 && (!f.F.has(q) && rt(q) && f.F.set(q, f.i.preload(q.uri, null, q.mimeType || void 0)), st(f, q));
                                x.B(4);
                                break;
                            }
                            if (!f.F.has(q)) {
                                x.B(7);
                                break;
                            }
                            return x.g(f.F.get(q), 8);
                        case 8:
                            (v = x.i) && v.destroy(), f.F.delete(q);
                        case 7:
                            tt(f, q), w = q.id || JSON.stringify(q), f.R.has(w) && f.R.delete(w), f.H.delete(q), ut(f), q.overlay || (h = !0);
                        case 4:
                            n = m.next();
                            x.B(3);
                            break;
                        case 5:
                            h && vt(f), x.j();
                    }
                });
            });
            this.configure(this.D.getConfiguration().ads);
        }
        p = nt.prototype;
        p.configure = function(a) {
            this.L = a;
            this.J || wt(this);
        };
        function xt(a) {
            if (!a.X && a.H.size) {
                a.I.u(a.g, "playing", a.S);
                a.I.u(a.g, "timeupdate", a.S);
                a.I.u(a.g, "seeked", a.ba);
                a.I.u(a.g, "ended", a.V);
                if ("requestVideoFrameCallback" in a.g && !yt()) {
                    var b = a.g, c = function() {
                        a.O != -1 && (a.V(), a.O != -1 && (a.O = b.requestVideoFrameCallback(c)));
                    };
                    a.O = b.requestVideoFrameCallback(c);
                } else a.P.xa(.025);
                a.M && a.M.xa(1);
                a.X = !0;
            }
        }
        function ut(a) {
            a.X && !a.H.size && (a.I.Fa(a.g, "playing", a.S), a.I.Fa(a.g, "timeupdate", a.S), a.I.Fa(a.g, "seeked", a.ba), a.I.Fa(a.g, "ended", a.V), a.O != -1 && (a.g.cancelVideoFrameCallback(a.O), a.O = -1), a.P && a.P.stop(), a.M && a.M.stop(), a.X = !1);
        }
        function wt(a) {
            if (a.m && a.L) {
                var b = a.L.supportsMultipleMediaElements, c = a.g;
                c.controls ? b = !1 : c.webkitPresentationMode && c.webkitPresentationMode !== "inline" ? b = !1 : c.webkitDisplayingFullscreen && (b = !1);
                a.A == b && (a.A = !b, a.A ? (a.h = a.g, a.G && (a.G.parentElement && a.m.removeChild(a.G), a.G = null)) : (a.G || (b = document.createElement(a.g.tagName), b.autoplay = !0, b.style.position = "absolute", b.style.top = "0", b.style.left = "0", b.style.width = "100%", b.style.height = "100%", b.style.display = "none", b.setAttribute("playsinline", ""), a.G = b), a.h = a.G));
            } else a.A = !0;
        }
        p.stop = function() {
            this.j && this.j.Ta();
            this.$.clear();
            this.R.clear();
            this.H.clear();
            this.i.Vg();
            if (this.F.size) {
                var a = Array.from(this.F.values());
                a = u(a);
                for(var b = a.next(); !b.done; b = a.next())(b = b.value) && b.then(function(c) {
                    c && c.destroy();
                });
            }
            this.F.clear();
            if (this.K.size) for(a = Array.from(this.K.keys()), a = u(a), b = a.next(); !b.done; b = a.next())tt(this, b.value);
            this.K.clear();
            this.i.detach();
            this.J = !1;
            this.C = this.l = null;
            this.A = !0;
            this.h = this.g;
            this.G = null;
            zt(this);
            ut(this);
            this.m && gk(this.m);
            this.o && (this.o.stop(), this.o = null);
        };
        p.release = function() {
            this.stop();
            this.I && this.I.release();
            this.j && this.j.release();
            this.P && (this.P.stop(), this.P = null);
            this.M && (this.M.stop(), this.M = null);
            this.i.destroy();
        };
        p.Rb = function() {
            return this.i;
        };
        function At(a, b) {
            var c, d, e;
            H(function(f) {
                if (f.h == 1) {
                    c = null;
                    if (d = b.values.find(function(g) {
                        return g.key == "ID";
                    })) c = d.data;
                    if (c) {
                        if (a.$.has(c)) return f.return();
                        a.$.add(c);
                    }
                    ot(a);
                    e = [];
                    return b && b.values.find(function(g) {
                        return g.key == "X-OVERLAY-ID";
                    }) ? (e = Bt(b), f.B(2)) : f.g(Ct(a, b), 3);
                }
                f.h != 2 && (e = f.i);
                e.length ? Dt(a, e) : Za("Unsupported HLS interstitial", b);
                f.j();
            });
        }
        function Et(a, b) {
            var c = ne(b.eventNode, "OverlayEvent"), d = c.attributes.uri, e = c.attributes.mimeType, f = c.attributes.loop == "true", g = qe(c, "z", we);
            if (d && g != 0) {
                var h = null, k = ne(c, "Background");
                if (k) {
                    var l = k.attributes.uri;
                    l ? h = "center / contain no-repeat url('" + l + "')" : h = le(k);
                }
                k = 1920;
                l = 1080;
                var m = ne(c, "Viewport");
                if (m) {
                    k = qe(m, "x", we);
                    if (k == null) return;
                    l = qe(m, "y", we);
                    if (l == null) return;
                }
                var n = {
                    viewport: {
                        x: k,
                        y: l
                    },
                    topLeft: {
                        x: 0,
                        y: 0
                    },
                    size: {
                        x: k,
                        y: l
                    }
                }, q = ne(c, "Overlay");
                if (m && q) {
                    var r = ne(q, "TopLeft"), t = ne(q, "Size");
                    if (r && t) {
                        q = qe(r, "x", we);
                        if (q == null) return;
                        r = qe(r, "y", we);
                        if (r == null) return;
                        var v = qe(t, "x", we);
                        if (v == null) return;
                        t = qe(t, "y", we);
                        if (t == null) return;
                        n.topLeft.x = q;
                        n.topLeft.y = r;
                        n.size.x = v;
                        n.size.y = t;
                    }
                }
                q = null;
                c = ne(c, "Squeeze");
                if (m && c && (t = ne(c, "TopLeft"), c = ne(c, "Size"), t && c)) {
                    m = qe(t, "x", we);
                    if (m == null) return;
                    q = qe(t, "y", we);
                    if (q == null) return;
                    t = qe(c, "x", we);
                    if (t == null) return;
                    c = qe(c, "y", we);
                    if (c == null) return;
                    q = {
                        viewport: {
                            x: k,
                            y: l
                        },
                        topLeft: {
                            x: m,
                            y: q
                        },
                        size: {
                            x: t,
                            y: c
                        }
                    };
                }
                Dt(a, [
                    {
                        id: b.id,
                        groupId: null,
                        startTime: b.startTime,
                        endTime: b.endTime,
                        uri: d,
                        mimeType: e,
                        isSkippable: !1,
                        skipOffset: null,
                        skipFor: null,
                        canJump: !0,
                        resumeOffset: null,
                        playoutLimit: null,
                        once: !1,
                        pre: !1,
                        post: !1,
                        timelineRange: !0,
                        loop: f,
                        overlay: n,
                        displayOnBackground: g == -1,
                        currentVideo: q,
                        background: h,
                        clickThroughUrl: null
                    }
                ]);
            }
        }
        p.addAdUrlInterstitial = function(a) {
            var b = this, c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return c = {
                    type: 12
                }, n.g(Ft(b, a, c), 2);
                if (n.h != 3) {
                    d = n.i;
                    e = $d(d, "VAST,vmap:VMAP");
                    if (!e) throw new T(2, 10, 10007);
                    f = [];
                    if (e.tagName == "VAST") return f = ct(e, b.l), n.B(3);
                    if (e.tagName != "vmap:VMAP") return n.B(3);
                    g = function(q) {
                        var r, t;
                        return H(function(v) {
                            if (v.h == 1) return v.g(Ft(b, q.uri, c), 2);
                            r = v.i;
                            t = $d(r, "VAST");
                            if (!t) throw new T(2, 10, 10007);
                            f.push.apply(f, G(ct(t, q.time)));
                            v.j();
                        });
                    };
                    h = [];
                    k = u(et(e));
                    for(l = k.next(); !l.done; l = k.next())m = l.value, h.push(g(m));
                    return h.length ? n.g(Promise.all(h), 3) : n.B(3);
                }
                Dt(b, f);
                n.j();
            });
        };
        function Dt(a, b) {
            var c, d, e, f, g, h, k, l;
            H(function(m) {
                switch(m.h){
                    case 1:
                        c = !1, d = u(b), e = d.next();
                    case 2:
                        if (e.done) {
                            m.B(4);
                            break;
                        }
                        f = e.value;
                        if (!f.uri) {
                            Za("Missing URL in interstitial", f);
                            m.B(3);
                            break;
                        }
                        if (f.mimeType) {
                            m.B(5);
                            break;
                        }
                        m.m(6);
                        g = a.i.Qb();
                        return m.g(fn(f.uri, g, a.D.getConfiguration().streaming.retryParameters), 8);
                    case 8:
                        f.mimeType = m.i;
                        m.o(5);
                        break;
                    case 6:
                        m.l();
                    case 5:
                        h = f.id || JSON.stringify(f);
                        if (a.R.has(h)) {
                            m.B(3);
                            break;
                        }
                        f.loop && !f.overlay && Za("Loop is only supported in overlay interstitials", f);
                        f.overlay || (c = !0);
                        a.R.add(h);
                        a.H.add(f);
                        k = !1;
                        f.pre && a.l == null ? k = !0 : f.startTime != 0 || f.canJump ? a.l != null && (l = f.startTime - a.l, l > 0 && l <= 10 && (k = !0)) : k = !0;
                        k && (!a.F.has(f) && rt(f) && a.F.set(f, a.i.preload(f.uri, null, f.mimeType || void 0)), st(a, f));
                    case 3:
                        e = d.next();
                        m.B(2);
                        break;
                    case 4:
                        c && vt(a), xt(a), m.j();
                }
            });
        }
        function pt(a, b, c) {
            b = b === void 0 ? !1 : b;
            c = c === void 0 ? null : c;
            var d = 0, e = null;
            if (a.H.size && a.l != null) {
                var f = a.g.ended, g = Array.from(a.H).sort(function(n, q) {
                    return q.startTime - n.startTime;
                }), h = g;
                h = b ? g.filter(function(n) {
                    return n.pre;
                }) : f ? g.filter(function(n) {
                    return n.post;
                }) : g.filter(function(n) {
                    return !n.pre && !n.post;
                });
                g = u(h);
                for(h = g.next(); !h.done; h = g.next()){
                    h = h.value;
                    var k = !1;
                    if (b) k = h.pre;
                    else if (f) k = h.post;
                    else if (!h.pre && !h.post) {
                        var l = a.l - Math.round(h.startTime * 1E3) / 1E3, m = 1;
                        a.L.allowStartInMiddleOfInterstitial && h.endTime && h.endTime != Infinity && (m = h.endTime - h.startTime);
                        (l > 0 || l == 0 && a.l == 0) && (l <= m || !h.canJump) && (k = c == null && a.C && !a.C.pre && !a.C.post && a.C.startTime >= h.startTime ? !1 : !0);
                    }
                    k && (!a.C || h.startTime >= a.C.startTime) && (d == (c || 0) ? e = h : e && !h.canJump && Math.round(h.startTime * 1E3) / 1E3 - Math.round(e.startTime * 1E3) / 1E3 > .001 && (e = h, d = 0), d++);
                }
            }
            return e;
        }
        function qt(a, b, c, d, e, f) {
            f = f === void 0 ? 0 : f;
            a.C = b;
            wt(a);
            a.A || !a.m || a.h.parentElement || a.m.appendChild(a.h);
            d == 1 && c == 1 && (c = Array.from(a.H).filter(function(g) {
                return b.pre ? g.pre == b.pre : b.post ? g.post == b.post : Math.abs(g.startTime - b.startTime) < .001;
            }).length);
            b.once && (f++, a.H.delete(b), ut(a), b.overlay || vt(a));
            b.mimeType && (b.mimeType.startsWith("image/") || b.mimeType === "text/html") ? b.overlay ? Gt(a, b, c, d, f) : Za("Unsupported interstitial", b) : a.A && b.overlay ? Za("Unsupported interstitial", b) : Ht(a, b, c, d, e, f);
        }
        function Gt(a, b, c, d, e) {
            function f() {
                a.o && (a.o.stop(), a.o = null);
                a.m.removeChild(k);
                zt(a, b);
                It(a, "ad-stopped");
                a.j.Ta();
                var q = pt(a, b.pre, d - e);
                q ? qt(a, q, c, ++d, Date.now(), e) : a.J = !1;
            }
            a.J = !0;
            var g = b.overlay, h = b.mimeType == "text/html" ? "iframe" : "img", k = document.createElement(h);
            k.style.objectFit = "contain";
            k.style.position = "absolute";
            k.style.border = "none";
            Jt(a, b);
            var l = new mt(b, c, d);
            It(a, "ad-impression");
            It(a, "ad-started", (new Map).set("ad", l));
            h == "iframe" ? k.src = b.uri : (k.src = b.uri, k.onerror = function(q) {
                It(a, "ad-error", (new Map).set("originalEvent", q));
                f();
            });
            l = g.viewport;
            var m = g.topLeft;
            g = g.size;
            l.x == 0 && l.y == 0 ? (k.width = b.overlay.size.x, k.height = b.overlay.size.y, k.style.bottom = "10%", k.style.left = "0", k.style.right = "0", k.style.width = "100%", b.overlay.size.y || h != "iframe" || (k.style.height = "auto")) : (k.style.height = g.y / l.y * 100 + "%", k.style.left = m.x / l.x * 100 + "%", k.style.top = m.y / l.y * 100 + "%", k.style.width = g.x / l.x * 100 + "%");
            a.m.appendChild(k);
            var n = Date.now();
            a.o && a.o.stop();
            a.o = new Uf(function() {
                b.playoutLimit && (Date.now() - n) / 1E3 > b.playoutLimit ? (It(a, "ad-complete"), f()) : b.endTime && a.g.currentTime > b.endTime ? (It(a, "ad-complete"), f()) : a.g.currentTime < b.startTime && (It(a, "ad-skipped"), f());
            });
            b.playoutLimit && !b.endTime ? a.o.Z(b.playoutLimit) : b.endTime && a.o.xa(.025);
            a.j.u(a.g, "seeked", function() {
                var q = a.g.currentTime;
                if (q < b.startTime || b.endTime && q > b.endTime) a.o && a.o.stop(), It(a, "ad-skipped"), f();
            });
            b.clickThroughUrl && a.j.u(k, "click", function() {
                b.clickThroughUrl && (It(a, "ad-clicked"), Kt(b.clickThroughUrl) && window1.open(b.clickThroughUrl, "_blank"));
            });
        }
        function Ht(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F;
            H(function(I) {
                switch(I.h){
                    case 1:
                        g = Date.now();
                        a.J = !0;
                        h = !1;
                        k = function() {
                            if (!a.A && !b.overlay && b.resumeOffset == null) {
                                if (b.timelineRange && b.endTime && b.endTime != Infinity) a.g.currentTime != b.endTime && (a.g.currentTime = b.endTime);
                                else {
                                    var K = Date.now();
                                    a.g.currentTime += (K - e) / 1E3;
                                    e = K;
                                }
                            }
                        };
                        l = function(K) {
                            var N, P;
                            return H(function(M) {
                                if (M.h == 1) {
                                    k();
                                    N = pt(a, b.pre, d - f);
                                    if (K && b.groupId) for(; N && N.groupId == b.groupId;)d++, N = pt(a, b.pre, d - f);
                                    a.o && (!b.groupId || N && N.groupId != b.groupId) && (a.o.stop(), a.o = null);
                                    zt(a, b);
                                    if (N && !N.overlay) return M.B(2);
                                    b.post && (a.l = null, a.C = null);
                                    return a.A ? M.g(a.i.detach(), 4) : M.g(a.i.tc(), 4);
                                }
                                M.h != 2 && (a.A && (P = b.resumeOffset, P == null && (P = b.timelineRange && b.endTime && b.endTime != Infinity ? b.endTime - (a.l || 0) : (Date.now() - e) / 1E3), It(a, "ad-content-resume-requested", (new Map).set("offset", P))), It(a, "ad-stopped"), a.j.Ta(), a.J = !1, a.A ? vt(a) : (a.h.style.display = "none", k(), a.g.ended || a.g.play()));
                                wt(a);
                                N && (It(a, "ad-stopped"), a.j.Ta(), qt(a, N, c, ++d, e, f));
                                M.j();
                            });
                        };
                        m = function(K) {
                            return H(function(N) {
                                if (h) return N.return();
                                h = !0;
                                It(a, "ad-error", (new Map).set("originalEvent", K));
                                return N.g(l(!1), 0);
                            });
                        };
                        n = function() {
                            return H(function(K) {
                                if (K.h == 1) {
                                    if (h) return K.return();
                                    h = !0;
                                    return K.g(l(!1), 2);
                                }
                                It(a, "ad-complete");
                                K.j();
                            });
                        };
                        a.W = function() {
                            return H(function(K) {
                                if (h) return K.return();
                                h = !0;
                                It(a, "ad-skipped");
                                return K.g(l(!0), 0);
                            });
                        };
                        q = new lt(a.h, b, a.W, c, d, !a.A);
                        a.A || (q.setMuted(a.g.muted), q.setVolume(a.g.volume));
                        It(a, "ad-started", (new Map).set("ad", q));
                        (r = q.canSkipNow()) && It(a, "ad-skip-state-changed");
                        a.j.ra(a.i, "error", m);
                        a.j.u(a.h, "timeupdate", function() {
                            if (a.h.duration) {
                                var K = q.canSkipNow();
                                r != K && q.getRemainingTime() > 0 && q.getDuration() > 0 && It(a, "ad-skip-state-changed");
                                r = K;
                                !a.A && !b.overlay && b.resumeOffset == null && b.timelineRange && b.endTime && b.endTime != Infinity && a.g.currentTime != b.endTime && a.D.wa().end >= b.endTime && (a.g.currentTime = b.endTime);
                            }
                        });
                        a.j.ra(a.i, "firstquartile", function() {
                            k();
                            It(a, "ad-first-quartile");
                        });
                        a.j.ra(a.i, "midpoint", function() {
                            k();
                            It(a, "ad-midpoint");
                        });
                        a.j.ra(a.i, "thirdquartile", function() {
                            k();
                            It(a, "ad-third-quartile");
                        });
                        a.j.ra(a.i, "complete", n);
                        a.j.u(a.h, "play", function() {
                            It(a, "ad-resumed");
                        });
                        a.j.u(a.h, "pause", function() {
                            var K = a.i.getConfiguration();
                            a.h.currentTime >= K.playRangeEnd ? n() : It(a, "ad-paused");
                        });
                        a.j.u(a.h, "volumechange", function() {
                            a.h.muted ? It(a, "ad-muted") : It(a, "ad-volume-changed");
                            a.A || (a.g.volume = a.h.volume, a.g.muted = a.h.muted);
                        });
                        b.clickThroughUrl && (t = a.m || a.h, a.j.u(t, "click", function() {
                            b.clickThroughUrl && (q.isPaused() || q.pause(), Kt(b.clickThroughUrl) && window1.open(b.clickThroughUrl, "_blank"));
                        }));
                        if (!a.A || d != 1) {
                            I.B(2);
                            break;
                        }
                        It(a, "ad-content-pause-requested", (new Map).set("saveLivePosition", !0));
                        v = new Yg;
                        w = function(K) {
                            return H(function(N) {
                                if (N.h == 1) return K.state != "detach" ? N.B(0) : yt() ? N.g(new Promise(function(P) {
                                    return new Uf(P).Z(.1);
                                }), 3) : N.B(3);
                                v.resolve();
                                a.j.Fa(a.D, "onstatechange", w);
                                N.j();
                            });
                        };
                        a.j.u(a.D, "onstatechange", w);
                        return I.g(v, 2);
                    case 2:
                        return Jt(a, b), a.A || (a.h.style.display = "", b.overlay ? (a.h.loop = b.loop, x = b.overlay.viewport, y = b.overlay.topLeft, z = b.overlay.size, a.h.style.height = z.y / x.y * 100 + "%", a.h.style.left = y.x / x.x * 100 + "%", a.h.style.top = y.y / x.y * 100 + "%", a.h.style.width = z.x / x.x * 100 + "%") : (a.g.pause(), b.resumeOffset != null && b.resumeOffset != 0 && (a.g.currentTime += b.resumeOffset), a.h.loop = !1, a.h.style.height = "100%", a.h.style.left = "0", a.h.style.top = "0", a.h.style.width = "100%")), I.m(4), ot(a), b.startTime && b.endTime && b.endTime != Infinity && b.startTime != b.endTime && (A = b.endTime - b.startTime, A > 0 && a.i.configure("playRangeEnd", A)), b.playoutLimit && !a.o && (a.o = new Uf(function() {
                            a.W();
                        }).Z(b.playoutLimit), a.i.configure("playRangeEnd", b.playoutLimit)), I.g(a.i.Ob(a.h), 6);
                    case 6:
                        return E = null, b.pre || b.post || !a.L.allowStartInMiddleOfInterstitial || a.l == null || (C = a.l - b.startTime, Math.abs(C) > .25 && (E = C)), a.F.has(b) ? I.g(a.F.get(b), 10) : I.g(a.i.load(b.uri, E, b.mimeType || void 0), 8);
                    case 10:
                        return D = I.i, a.F.delete(b), D ? I.g(a.i.load(D), 8) : I.g(a.i.load(b.uri, E, b.mimeType || void 0), 8);
                    case 8:
                        b.overlay && a.g.paused ? a.h.pause() : a.h.play();
                        B = (Date.now() - g) / 1E3;
                        It(a, "ads-loaded", (new Map).set("loadTime", B));
                        a.A && a.g.play();
                        b.overlay && (b.pre || b.post || a.D.U() && !(b.startTime > 0) || (J = function() {
                            var K = a.g.currentTime - b.startTime;
                            Math.abs(K - a.h.currentTime) > .1 && (a.h.currentTime = K);
                        }, a.j.ra(a.h, "playing", J), a.j.u(a.g, "seeking", J)), a.j.u(a.g, "seeked", function() {
                            var K = a.g.currentTime;
                            (K < b.startTime || b.endTime && K > b.endTime) && a.W();
                        }));
                        I.o(0);
                        break;
                    case 4:
                        F = I.l();
                        if (!a.J) return I.return();
                        m(F);
                        I.j();
                }
            });
        }
        function Jt(a, b) {
            b.displayOnBackground && (a.g.style.zIndex = "1");
            if (b.currentVideo != null) {
                var c = b.currentVideo;
                a.g.style.transformOrigin = "top left";
                var d = !0, e = [], f = c.topLeft.x / c.viewport.x * 100;
                f > 0 && f <= 100 && (e.push("translateX(" + f + "%)"), d = !1);
                f = c.topLeft.y / c.viewport.y * 100;
                f > 0 && f <= 100 && (e.push("translateY(" + f + "%)"), d = !1);
                f = c.size.x / c.viewport.x;
                f < 1 && e.push("scaleX(" + f + ")");
                c = c.size.y / c.viewport.y;
                f < 1 && e.push("scaleY(" + c + ")");
                e.length && (a.g.style.transform = e.join(" "));
                d && (a.g.style.transition = "transform 250ms");
            }
            a.m && (b.clickThroughUrl ? (a.m.setAttribute("ad-active", "true"), a.m.style.pointerEvents = "") : a.m.style.pointerEvents = "none", b.background && (a.m.style.background = b.background));
            a.G && (a.G.style.background = b.overlay ? "" : "rgb(0, 0, 0)");
        }
        function zt(a, b) {
            if (!b || b.displayOnBackground) a.g.style.zIndex = "";
            b && b.currentVideo == null || (a.g.style.transformOrigin = "", a.g.style.transition = "", a.g.style.transform = "");
            a.m && (a.m.removeAttribute("ad-active"), a.m.style.pointerEvents = "", !b || b.background) && (a.m.style.background = "");
            a.G && (a.G.style.background = "");
        }
        function Ct(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa;
            return H(function(Ja) {
                switch(Ja.h){
                    case 1:
                        c = [];
                        if (!b) return Ja.return(c);
                        d = b.values.find(function(Aa) {
                            return Aa.key == "X-ASSET-URI";
                        });
                        e = b.values.find(function(Aa) {
                            return Aa.key == "X-ASSET-LIST";
                        });
                        if (!d && !e) return Ja.return(c);
                        f = null;
                        if (g = b.values.find(function(Aa) {
                            return Aa.key == "ID";
                        })) f = g.data;
                        h = f == null ? Math.floor(b.startTime * 10) / 10 : b.startTime;
                        (k = b.endTime) && b.endTime != Infinity && typeof b.endTime == "number" && (k = f == null ? Math.floor(b.endTime * 10) / 10 : b.endTime);
                        l = b.values.find(function(Aa) {
                            return Aa.key == "X-RESTRICT";
                        });
                        n = m = !0;
                        l && l.data && (q = l.data, m = !q.includes("SKIP"), n = !q.includes("JUMP"));
                        r = m ? 0 : null;
                        if (t = b.values.find(function(Aa) {
                            return Aa.key == "X-ENABLE-SKIP-AFTER";
                        })) v = t.data, r = parseFloat(v), isNaN(r) && (r = m ? 0 : null);
                        w = null;
                        if (x = b.values.find(function(Aa) {
                            return Aa.key == "X-ENABLE-SKIP-FOR";
                        })) y = x.data, w = parseFloat(y), isNaN(r) && (w = null);
                        z = null;
                        if (A = b.values.find(function(Aa) {
                            return Aa.key == "X-RESUME-OFFSET";
                        })) E = A.data, z = parseFloat(E), isNaN(z) && (z = null);
                        C = null;
                        if (D = b.values.find(function(Aa) {
                            return Aa.key == "X-PLAYOUT-LIMIT";
                        })) B = D.data, C = parseFloat(B), isNaN(C) && (C = null);
                        I = F = J = !1;
                        if (K = b.values.find(function(Aa) {
                            return Aa.key == "CUE";
                        })) N = K.data, J = N.includes("ONCE"), F = N.includes("PRE"), I = N.includes("POST");
                        P = !1;
                        (M = b.values.find(function(Aa) {
                            return Aa.key == "X-TIMELINE-OCCUPIES";
                        })) ? (L = M.data, P = L.includes("RANGE")) : !A && a.D.U() && (P = !F && !I);
                        if (d) {
                            Q = d.data;
                            if (!Q) return Ja.return(c);
                            c.push({
                                id: f,
                                groupId: null,
                                startTime: h,
                                endTime: k,
                                uri: Q,
                                mimeType: null,
                                isSkippable: m,
                                skipOffset: r,
                                skipFor: w,
                                canJump: n,
                                resumeOffset: z,
                                playoutLimit: C,
                                once: J,
                                pre: F,
                                post: I,
                                timelineRange: P,
                                loop: !1,
                                overlay: null,
                                displayOnBackground: !1,
                                currentVideo: null,
                                background: null,
                                clickThroughUrl: null
                            });
                            Ja.B(2);
                            break;
                        }
                        if (!e) {
                            Ja.B(2);
                            break;
                        }
                        S = e.data;
                        if (!S) return Ja.return(c);
                        Ja.m(4);
                        Z = {
                            type: 11
                        };
                        return Ja.g(Ft(a, S, Z), 6);
                    case 6:
                        pa = Ja.i;
                        va = bc(pa);
                        Ca = JSON.parse(va);
                        if (ua = Ca["SKIP-CONTROL"]) xa = ua["ENABLE-SKIP-AFTER"], typeof xa == "number" && (r = parseFloat(xa), isNaN(xa) && (r = m ? 0 : null)), Da = ua["ENABLE-SKIP-FOR"], typeof Da == "number" && (w = parseFloat(Da), isNaN(Da) && (w = null));
                        for(Ka = 0; Ka < Ca.ASSETS.length; Ka++)wa = Ca.ASSETS[Ka], wa.URI && c.push({
                            id: f + "_shaka_asset_" + Ka,
                            groupId: f,
                            startTime: h,
                            endTime: k,
                            uri: wa.URI,
                            mimeType: null,
                            isSkippable: m,
                            skipOffset: r,
                            skipFor: w,
                            canJump: n,
                            resumeOffset: z,
                            playoutLimit: C,
                            once: J,
                            pre: F,
                            post: I,
                            timelineRange: P,
                            loop: !1,
                            overlay: null,
                            displayOnBackground: !1,
                            currentVideo: null,
                            background: null,
                            clickThroughUrl: null
                        });
                        Ja.o(2);
                        break;
                    case 4:
                        Ja.l();
                    case 2:
                        return Ja.return(c);
                }
            });
        }
        function Bt(a) {
            var b = [];
            if (!a) return b;
            var c = a.values.find(function(w) {
                return w.key == "X-ASSET-URI";
            });
            if (!c) return b;
            c = c.data;
            if (!c) return b;
            var d = null, e = a.values.find(function(w) {
                return w.key == "X-OVERLAY-ID";
            });
            e && (d = e.data);
            e = d == null ? Math.floor(a.startTime * 10) / 10 : a.startTime;
            var f = a.endTime;
            a.endTime && a.endTime != Infinity && typeof a.endTime == "number" && (f = d == null ? Math.floor(a.endTime * 10) / 10 : a.endTime);
            var g = !1, h = !1, k = !1, l = a.values.find(function(w) {
                return w.key == "CUE";
            });
            l && (k = l.data, g = k.includes("ONCE"), h = k.includes("PRE"), k = k.includes("POST"));
            l = null;
            var m = a.values.find(function(w) {
                return w.key == "X-ASSET-MIMETYPE";
            });
            m && (l = m.data);
            m = !1;
            var n = a.values.find(function(w) {
                return w.key == "X-LOOP";
            });
            n && (m = n.data == "YES");
            n = 1;
            var q = a.values.find(function(w) {
                return w.key == "X-DEPTH";
            });
            q && (n = parseFloat(q.data), isNaN(n) && (n = 1));
            q = null;
            var r = a.values.find(function(w) {
                return w.key == "X-BACKGROUND";
            });
            r && (q = r.data);
            r = 1920;
            var t = 1080, v = a.values.find(function(w) {
                return w.key == "X-VIEWPORT";
            });
            if (v) {
                t = v.data.split("x");
                if (t.length != 2) return b;
                r = parseFloat(t[0]);
                t = parseFloat(t[1]);
            }
            r = {
                viewport: {
                    x: r,
                    y: t
                },
                topLeft: {
                    x: 0,
                    y: 0
                },
                size: {
                    x: r,
                    y: t
                }
            };
            if (t = a.values.find(function(w) {
                return w.key == "X-OVERLAY-POSITION";
            })) {
                t = t.data.split("x");
                if (t.length != 2) return b;
                r.topLeft.x = parseFloat(t[0]);
                r.topLeft.y = parseFloat(t[1]);
            }
            if (t = a.values.find(function(w) {
                return w.key == "X-OVERLAY-SIZE";
            })) {
                t = t.data.split("x");
                if (t.length != 2) return b;
                r.size.x = parseFloat(t[0]);
                r.size.y = parseFloat(t[1]);
            }
            t = null;
            if (v = a.values.find(function(w) {
                return w.key == "X-SQUEEZECURRENT";
            })) {
                if (t = parseFloat(v.data), isNaN(t) && (t = 1), t = {
                    viewport: {
                        x: 1920,
                        y: 1080
                    },
                    topLeft: {
                        x: 0,
                        y: 0
                    },
                    size: {
                        x: 1920 * t,
                        y: 1080 * t
                    }
                }, a = a.values.find(function(w) {
                    return w.key == "X-SQUEEZECURRENT-POSITION";
                })) {
                    a = a.data.split("x");
                    if (a.length != 2) return b;
                    t.topLeft.x = parseFloat(a[0]);
                    t.topLeft.y = parseFloat(a[1]);
                }
            }
            b.push({
                id: d,
                groupId: null,
                startTime: e,
                endTime: f,
                uri: c,
                mimeType: l,
                isSkippable: !1,
                skipOffset: null,
                skipFor: null,
                canJump: !0,
                resumeOffset: null,
                playoutLimit: null,
                once: g,
                pre: h,
                post: k,
                timelineRange: !0,
                loop: m,
                overlay: r,
                displayOnBackground: n == -1,
                currentVideo: t,
                background: q,
                clickThroughUrl: null
            });
            return b;
        }
        function vt(a) {
            for(var b = [], c = u(a.H), d = c.next(), e = {}; !d.done; e = {
                Ic: void 0
            }, d = c.next())d = d.value, d.overlay || (e.Ic = {
                start: d.startTime,
                end: null
            }, d.pre ? (e.Ic.start = 0, e.Ic.end = null) : d.post ? (e.Ic.start = -1, e.Ic.end = null) : d.timelineRange && (e.Ic.end = d.endTime), b.find(function(f) {
                return function(g) {
                    return f.Ic.start == g.start && f.Ic.end == g.end;
                };
            }(e)) || b.push(e.Ic));
            It(a, "ad-cue-points-changed", (new Map).set("cuepoints", b));
        }
        function ot(a) {
            a.i.configure(a.D.bj());
            a.i.configure("ads.disableHLSInterstitial", !0);
            a.i.configure("ads.disableDASHInterstitial", !0);
            a.i.configure("playRangeEnd", Infinity);
            lh(a.D.Qb(), a.i.Qb());
        }
        function Ft(a, b, c) {
            var d, e, f;
            return H(function(g) {
                if (g.h == 1) return d = mh([
                    b
                ], Wg()), e = a.D.Qb().request(7, d, c), g.g(e.promise, 2);
                f = g.i;
                return g.return(f.data);
            });
        }
        function rt(a) {
            return (a = a.mimeType) ? !a.startsWith("image/") && a !== "text/html" : !0;
        }
        function yt() {
            var a = Xb().Pa();
            return a == "TV" || a == "CONSOLE" || a == "CAST" ? !0 : !1;
        }
        function st(a, b) {
            if (!(a.K.has(b) || a.L && !a.L.allowPreloadOnDomElements)) {
                var c = function(f) {
                    var g = document.createElement("link");
                    g.rel = "preload";
                    g.href = f;
                    g.as = "image";
                    document.head.appendChild(g);
                    return g;
                }, d = [];
                if (b.background) {
                    var e = b.background.match(/url\(('|")?([^'"()]+)('|")\)?/);
                    e && d.push(c(e[2]));
                }
                b.mimeType && b.mimeType.startsWith("image/") && d.push(c(b.uri));
                a.K.set(b, d);
            }
        }
        function tt(a, b) {
            if (a.K.has(b)) {
                var c = a.K.get(b);
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, d.parentNode.removeChild(d);
                a.K.delete(b);
            }
        }
        function It(a, b, c) {
            a.na(new R(b, c));
        }
        function Kt(a) {
            a = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(a.replace(/[\u0000-\u0020]+/g, ""));
            if (!a) return !0;
            a = a[1].toLowerCase();
            return a == "http" || a == "https";
        }
        function Lt(a, b, c, d, e) {
            this.h = a;
            this.j = Vd(this.h.skipOffset);
            this.g = e;
            this.i = b;
            this.l = c;
            this.o = d;
            this.m = !1;
        }
        p = Lt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !1;
        };
        p.hasCustomClick = function() {
            return !1;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return this.h.durationInSeconds;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return this.h.startTimeInSeconds + this.h.durationInSeconds - this.g.currentTime;
        };
        p.isPaused = function() {
            return this.g.paused;
        };
        p.isSkippable = function() {
            return typeof this.j == "number" ? !0 : !1;
        };
        p.getTimeUntilSkippable = function() {
            if (typeof this.j != "number") return this.getRemainingTime();
            var a = this.getRemainingTime() + this.j - this.getDuration();
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.m = !0;
            this.g.currentTime += this.getRemainingTime();
        };
        p.pause = function() {
            return this.g.pause();
        };
        p.play = function() {
            return this.g.play();
        };
        p.getVolume = function() {
            return this.g.volume;
        };
        p.setVolume = function(a) {
            this.g.volume = a;
        };
        p.isMuted = function() {
            return this.g.muted;
        };
        p.isLinear = function() {
            return this.o;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.g.muted = a;
        };
        p.getSequenceLength = function() {
            return this.l ? this.l : 1;
        };
        p.getPositionInSequence = function() {
            return this.i ? this.i : 1;
        };
        p.getTitle = function() {
            return this.h.adTitle;
        };
        p.getDescription = function() {
            return "";
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return 0;
        };
        p.getVastMediaWidth = function() {
            return 0;
        };
        p.getVastAdId = function() {
            return this.h.vastAdId || "";
        };
        p.getAdId = function() {
            return this.h.adId;
        };
        p.getCreativeAdId = function() {
            return this.h.creativeId;
        };
        p.getAdvertiserName = function() {
            return "";
        };
        p.getMediaUrl = function() {
            return null;
        };
        p.getTimeOffset = function() {
            return 0;
        };
        p.getPodIndex = function() {
            return 0;
        };
        p.release = function() {
            this.l = this.i = this.g = this.h = null;
        };
        O("shaka.ads.MediaTailorAd", Lt);
        Lt.prototype.release = Lt.prototype.release;
        Lt.prototype.getPodIndex = Lt.prototype.getPodIndex;
        Lt.prototype.getTimeOffset = Lt.prototype.getTimeOffset;
        Lt.prototype.getMediaUrl = Lt.prototype.getMediaUrl;
        Lt.prototype.getAdvertiserName = Lt.prototype.getAdvertiserName;
        Lt.prototype.getCreativeAdId = Lt.prototype.getCreativeAdId;
        Lt.prototype.getAdId = Lt.prototype.getAdId;
        Lt.prototype.getVastAdId = Lt.prototype.getVastAdId;
        Lt.prototype.getVastMediaWidth = Lt.prototype.getVastMediaWidth;
        Lt.prototype.getVastMediaHeight = Lt.prototype.getVastMediaHeight;
        Lt.prototype.getVastMediaBitrate = Lt.prototype.getVastMediaBitrate;
        Lt.prototype.getDescription = Lt.prototype.getDescription;
        Lt.prototype.getTitle = Lt.prototype.getTitle;
        Lt.prototype.getPositionInSequence = Lt.prototype.getPositionInSequence;
        Lt.prototype.getSequenceLength = Lt.prototype.getSequenceLength;
        Lt.prototype.setMuted = Lt.prototype.setMuted;
        Lt.prototype.resize = Lt.prototype.resize;
        Lt.prototype.isLinear = Lt.prototype.isLinear;
        Lt.prototype.isMuted = Lt.prototype.isMuted;
        Lt.prototype.setVolume = Lt.prototype.setVolume;
        Lt.prototype.getVolume = Lt.prototype.getVolume;
        Lt.prototype.play = Lt.prototype.play;
        Lt.prototype.pause = Lt.prototype.pause;
        Lt.prototype.skip = Lt.prototype.skip;
        Lt.prototype.canSkipNow = Lt.prototype.canSkipNow;
        Lt.prototype.getTimeUntilSkippable = Lt.prototype.getTimeUntilSkippable;
        Lt.prototype.isSkippable = Lt.prototype.isSkippable;
        Lt.prototype.isPaused = Lt.prototype.isPaused;
        Lt.prototype.getRemainingTime = Lt.prototype.getRemainingTime;
        Lt.prototype.getMinSuggestedDuration = Lt.prototype.getMinSuggestedDuration;
        Lt.prototype.getDuration = Lt.prototype.getDuration;
        Lt.prototype.isUsingAnotherMediaElement = Lt.prototype.isUsingAnotherMediaElement;
        Lt.prototype.hasCustomClick = Lt.prototype.hasCustomClick;
        Lt.prototype.isClientRendering = Lt.prototype.isClientRendering;
        Lt.prototype.needsSkipUI = Lt.prototype.needsSkipUI;
        function Mt(a, b, c, d) {
            this.D = a;
            this.K = b;
            this.h = c;
            this.l = null;
            this.P = NaN;
            this.i = d;
            this.J = !1;
            this.C = null;
            this.j = [];
            this.M = [];
            this.L = this.F = this.g = null;
            this.G = new Map;
            this.m = [];
            this.A = [];
            this.H = "";
            this.O = !0;
            this.I = "";
            this.o = new fd;
        }
        Mt.prototype.stop = function() {
            for(var a = u(this.m), b = a.next(); !b.done; b = a.next())b = b.value, this.o.Fa(b.target, b.type, b.listener);
            Nt(this);
            this.m = [];
            this.A = [];
            this.H = "";
            this.O = !0;
            this.I = "";
            this.C = null;
            this.j = [];
            this.M = [];
            this.G.clear();
        };
        Mt.prototype.release = function() {
            this.stop();
            this.o && this.o.release();
        };
        Mt.prototype.onManifestUpdated = function(a) {
            this.J = a;
            this.H != "" && (Ot(this, this.H, this.O), this.O = !1);
        };
        Mt.prototype.getCuePoints = function() {
            for(var a = [], b = u(this.j), c = b.next(); !c.done; c = b.next()){
                c = u(c.value.ads);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, a.push({
                    start: d.startTimeInSeconds,
                    end: d.startTimeInSeconds + d.durationInSeconds
                });
            }
            return a;
        };
        function Pt(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            H(function(v) {
                if (v.h == 1) return d = {
                    type: 7
                }, e = mh([
                    b
                ], Wg()), e.method = "POST", c && (f = JSON.stringify(c), e.body = hc(f)), g = a.K.request(7, e, d), v.m(2), v.g(g.promise, 4);
                if (v.h != 2) {
                    h = v.i;
                    k = bc(h.data);
                    l = JSON.parse(k);
                    if (l.manifestUrl && l.trackingUrl) m = new lb(b), n = new lb(l.trackingUrl), a.H = m.resolve(n).toString(), q = Date.now() / 1E3, r = q - a.P, a.i(new R("ads-loaded", (new Map).set("loadTime", r))), t = new lb(l.manifestUrl), a.l.resolve(m.resolve(t).toString()), a.l = null;
                    else throw Error("Insufficient data from MediaTailor.");
                    return v.o(0);
                }
                v.l();
                if (!a.I.length) return a.l.reject("MediaTailor request returned an error and there was no backup asset uri provided."), a.l = null, v.return();
                a.l.resolve(a.I);
                a.l = null;
                v.j();
            });
        }
        function Ot(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            H(function(z) {
                if (z.h == 1) return d = {
                    type: 8
                }, e = mh([
                    b
                ], Wg()), f = a.K.request(7, e, d), z.m(2), z.g(f.promise, 4);
                if (z.h != 2) {
                    g = z.i;
                    h = [];
                    k = bc(g.data);
                    l = JSON.parse(k);
                    if (l.avails.length > 0) {
                        if (JSON.stringify(a.j) != JSON.stringify(l.avails)) {
                            a.j = l.avails;
                            m = u(a.j);
                            for(n = m.next(); !n.done; n = m.next())for(q = n.value, r = u(q.nonLinearAdsList), t = r.next(); !t.done; t = r.next())for(v = t.value, w = u(v.nonLinearAdList), x = w.next(); !x.done; x = w.next())y = x.value, Qt(a, y);
                            h = a.getCuePoints();
                            a.i(new R("ad-cue-points-changed", (new Map).set("cuepoints", h)));
                        }
                    } else a.j.length && a.i(new R("ad-cue-points-changed", (new Map).set("cuepoints", h))), Nt(a), a.j = [];
                    c && (a.J || h.length > 0) && Rt(a);
                    return z.o(0);
                }
                z.l();
                z.j();
            });
        }
        function Qt(a, b) {
            var c, d, e, f, g, h, k, l, m;
            H(function(n) {
                if (n.h == 1) {
                    if (!b.staticResource) return n.return();
                    c = St(b);
                    if (d = a.G.get(c)) return n.return();
                    e = {
                        type: 9
                    };
                    f = mh([
                        b.staticResource
                    ], Wg());
                    g = a.K.request(7, f, e);
                    n.m(2);
                    a.G.set(c, []);
                    return n.g(g.promise, 4);
                }
                if (n.h != 2) return h = n.i, k = bc(h.data), l = JSON.parse(k), m = l.apps, a.G.set(c, m), n.o(0);
                n.l();
                a.G.delete(c);
                n.j();
            });
        }
        function St(a) {
            return [
                a.adId,
                a.adParameters,
                a.adSystem,
                a.adTitle,
                a.creativeAdId,
                a.creativeId,
                a.creativeSequence,
                a.height,
                a.width,
                a.staticResource
            ].join("");
        }
        function Rt(a) {
            Tt(a);
            a.J || (Ut(a), a.o.u(a.h, "seeked", function() {
                Ut(a);
            }), a.o.u(a.h, "ended", function() {
                Nt(a);
            }));
            a.o.u(a.h, "timeupdate", function() {
                Tt(a);
            });
        }
        function Ut(a) {
            var b = a.h.currentTime;
            if (b != 0 && a.C == null) {
                for(var c, d, e = u(a.j), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    for(var g = u(f.ads), h = g.next(); !h.done; h = g.next())if (h = h.value, !d) h.startTimeInSeconds < b && (d = h, c = f);
                    else if (h.startTimeInSeconds < b && h.startTimeInSeconds > d.startTimeInSeconds + d.durationInSeconds) {
                        d = h;
                        c = f;
                        break;
                    }
                }
                c && d && !a.M.includes(d.adId) && (a.C = b, a.h.currentTime = c.startTimeInSeconds);
            }
        }
        function Tt(a) {
            if (a.h.duration && (a.g || a.j.length)) {
                var b = a.h.currentTime, c = !1;
                if (a.g) {
                    c = !0;
                    var d = a.F, e = d.startTimeInSeconds + .5 * d.durationInSeconds, f = d.startTimeInSeconds + .75 * d.durationInSeconds;
                    b >= d.startTimeInSeconds + .25 * d.durationInSeconds && !a.A.includes("firstQuartile") ? (a.A.push("firstQuartile"), Vt(a, "firstQuartile")) : b >= e && !a.A.includes("midpoint") ? (a.A.push("midpoint"), Vt(a, "midpoint")) : b >= f && !a.A.includes("thirdQuartile") && (a.A.push("thirdQuartile"), Vt(a, "thirdQuartile"));
                    d = a.g.getRemainingTime();
                    e = a.g.getDuration();
                    a.g.canSkipNow() && d > 0 && e > 0 && Vt(a, "skipStateChanged");
                    e > 0 && (d <= 0 || d > e) && Nt(a);
                }
                if (!a.g || !a.g.isLinear()) {
                    a: for(d = u(a.j), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        if (a.g && a.g.isLinear()) break;
                        for(f = 0; f < e.ads.length; f++){
                            var g = e.ads[f], h = g.startTimeInSeconds + g.durationInSeconds;
                            if (g.startTimeInSeconds <= b && h > b) {
                                if (a.M.includes(g.adId)) {
                                    if (a.h.ended) continue;
                                    a.h.currentTime = h;
                                    break a;
                                }
                                Nt(a);
                                a.L = e;
                                a.g = new Lt(g, f + 1, e.ads.length, !0, a.h);
                                a.F = g;
                                f === 0 && Vt(a, "breakStart");
                                Wt(a);
                                break;
                            }
                        }
                    }
                    if (!a.g) for(d = u(a.j), e = d.next(); !e.done; e = d.next()){
                        e = e.value;
                        if (a.g) break;
                        for(f = 0; f < e.nonLinearAdsList.length; f++)if (g = e.nonLinearAdsList[f], g.nonLinearAdList.length) {
                            h = e.startTimeInSeconds;
                            var k = a.G.get(St(g.nonLinearAdList[0]));
                            if (h <= b && k && k.length) {
                                Nt(a);
                                h = a;
                                k = u(k);
                                for(var l = k.next(); !l.done; l = k.next())if (l = l.value, l.data.source.length) {
                                    var m = document.createElement("img");
                                    m.src = l.data.source[0].url;
                                    m.style.top = (l.placeholder.top || 0) + "%";
                                    m.style.height = 100 - (l.placeholder.top || 0) + "%";
                                    m.style.left = (l.placeholder.left || 0) + "%";
                                    m.style.maxWidth = 100 - (l.placeholder.left || 0) + "%";
                                    m.style.objectFit = "contain";
                                    m.style.position = "absolute";
                                    h.D.appendChild(m);
                                }
                                a.L = e;
                                a.g = new Lt(g, f + 1, e.ads.length, !1, a.h);
                                a.F = g;
                                f === 0 && Vt(a, "breakStart");
                                Wt(a);
                                break;
                            }
                        }
                    }
                    c && !a.g && (b = a.h.currentTime, a.C && a.C > b && (a.h.currentTime = a.C), a.C = null);
                }
            }
        }
        function Nt(a) {
            if (a.g) {
                for(; a.D.lastChild;)a.D.removeChild(a.D.firstChild);
                a.J || a.M.push(a.F.adId);
                var b = a.g.m;
                (b === void 0 ? 0 : b) ? Vt(a, "skip") : Vt(a, "complete");
                b = u(a.m);
                for(var c = b.next(); !c.done; c = b.next())c = c.value, a.o.Fa(c.target, c.type, c.listener);
                a.m = [];
                a.A = [];
                b = a.g.getPositionInSequence();
                c = a.g.getSequenceLength();
                b === c && Vt(a, "breakEnd");
                a.g = null;
                a.F = null;
                a.L = null;
            }
        }
        function Wt(a) {
            var b = !1;
            a.h.paused ? b = !0 : (Vt(a, "impression"), Vt(a, "start"));
            a.m.push({
                target: a.h,
                type: "volumechange",
                listener: function() {
                    a.h.muted && Vt(a, "mute");
                }
            });
            a.m.push({
                target: a.h,
                type: "volumechange",
                listener: function() {
                    a.h.muted || Vt(a, "unmute");
                }
            });
            a.m.push({
                target: a.h,
                type: "play",
                listener: function() {
                    b ? (Vt(a, "impression"), Vt(a, "start"), b = !1) : Vt(a, "resume");
                }
            });
            a.m.push({
                target: a.h,
                type: "pause",
                listener: function() {
                    Vt(a, "pause");
                }
            });
            for(var c = u(a.m), d = c.next(); !d.done; d = c.next())d = d.value, a.o.u(d.target, d.type, d.listener);
        }
        function Vt(a, b) {
            var c = a.F.trackingEvents.find(function(f) {
                return f.eventType == b;
            });
            c || (c = a.L.adBreakTrackingEvents.find(function(f) {
                return f.eventType == b;
            }));
            if (c) {
                var d = {
                    type: 10
                };
                c = u(c.beaconUrls);
                for(var e = c.next(); !e.done; e = c.next())(e = e.value) && e != "" && (e = mh([
                    e
                ], Wg()), e.method = "POST", a.K.request(7, e, d));
            }
            switch(b){
                case "impression":
                    a.i(new R("ad-impression"));
                    break;
                case "start":
                    a.i(new R("ad-started", (new Map).set("ad", a.g)));
                    break;
                case "mute":
                    a.i(new R("ad-muted"));
                    break;
                case "unmute":
                    a.i(new R("ad-volume-changed"));
                    break;
                case "resume":
                    a.i(new R("ad-resumed"));
                    break;
                case "pause":
                    a.i(new R("ad-paused"));
                    break;
                case "firstQuartile":
                    a.i(new R("ad-first-quartile"));
                    break;
                case "midpoint":
                    a.i(new R("ad-midpoint"));
                    break;
                case "thirdQuartile":
                    a.i(new R("ad-third-quartile"));
                    break;
                case "complete":
                    a.i(new R("ad-complete"));
                    a.i(new R("ad-stopped"));
                    break;
                case "skip":
                    a.i(new R("ad-skipped"));
                    a.i(new R("ad-stopped"));
                    break;
                case "breakStart":
                    a.D.setAttribute("ad-active", "true");
                    break;
                case "breakEnd":
                    a.D.removeAttribute("ad-active");
                    break;
                case "skipStateChanged":
                    a.i(new R("ad-skip-state-changed"));
            }
        }
        function Xt(a, b) {
            this.g = a;
            this.i = null;
            this.h = b;
        }
        p = Xt.prototype;
        p.needsSkipUI = function() {
            return !0;
        };
        p.isClientRendering = function() {
            return !1;
        };
        p.hasCustomClick = function() {
            return !0;
        };
        p.isUsingAnotherMediaElement = function() {
            return !1;
        };
        p.getDuration = function() {
            return this.i ? this.i.duration : -1;
        };
        p.getMinSuggestedDuration = function() {
            return this.getDuration();
        };
        p.getRemainingTime = function() {
            return this.i ? this.i.duration - this.i.currentTime : -1;
        };
        p.isPaused = function() {
            return this.h.paused;
        };
        p.isSkippable = function() {
            return this.g.isSkippable();
        };
        p.getTimeUntilSkippable = function() {
            var a = this.g.getSkipTimeOffset();
            a = this.getRemainingTime() - a;
            return Math.max(a, 0);
        };
        p.canSkipNow = function() {
            return this.getTimeUntilSkippable() == 0;
        };
        p.skip = function() {
            this.h.currentTime += this.getRemainingTime();
        };
        p.pause = function() {
            return this.h.pause();
        };
        p.play = function() {
            return this.h.play();
        };
        p.getVolume = function() {
            return this.h.volume;
        };
        p.setVolume = function(a) {
            this.h.volume = a;
        };
        p.isMuted = function() {
            return this.h.muted;
        };
        p.isLinear = function() {
            return !0;
        };
        p.resize = function() {};
        p.setMuted = function(a) {
            this.h.muted = a;
        };
        p.getSequenceLength = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getTotalAds();
        };
        p.getPositionInSequence = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 1 : a.getAdPosition();
        };
        p.getTitle = function() {
            return this.g.getTitle();
        };
        p.getDescription = function() {
            return this.g.getDescription();
        };
        p.getVastMediaBitrate = function() {
            return 0;
        };
        p.getVastMediaHeight = function() {
            return this.g.getVastMediaHeight();
        };
        p.getVastMediaWidth = function() {
            return this.g.getVastMediaWidth();
        };
        p.getVastAdId = function() {
            return "";
        };
        p.getAdId = function() {
            return this.g.getAdId();
        };
        p.getCreativeAdId = function() {
            return this.g.getCreativeAdId();
        };
        p.getAdvertiserName = function() {
            return this.g.getAdvertiserName();
        };
        p.getMediaUrl = function() {
            return null;
        };
        p.getTimeOffset = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getTimeOffset();
        };
        p.getPodIndex = function() {
            var a = this.g.getAdPodInfo();
            return a == null ? 0 : a.getPodIndex();
        };
        p.release = function() {
            this.h = this.i = this.g = null;
        };
        O("shaka.ads.ServerSideAd", Xt);
        Xt.prototype.release = Xt.prototype.release;
        Xt.prototype.getPodIndex = Xt.prototype.getPodIndex;
        Xt.prototype.getTimeOffset = Xt.prototype.getTimeOffset;
        Xt.prototype.getMediaUrl = Xt.prototype.getMediaUrl;
        Xt.prototype.getAdvertiserName = Xt.prototype.getAdvertiserName;
        Xt.prototype.getCreativeAdId = Xt.prototype.getCreativeAdId;
        Xt.prototype.getAdId = Xt.prototype.getAdId;
        Xt.prototype.getVastAdId = Xt.prototype.getVastAdId;
        Xt.prototype.getVastMediaWidth = Xt.prototype.getVastMediaWidth;
        Xt.prototype.getVastMediaHeight = Xt.prototype.getVastMediaHeight;
        Xt.prototype.getVastMediaBitrate = Xt.prototype.getVastMediaBitrate;
        Xt.prototype.getDescription = Xt.prototype.getDescription;
        Xt.prototype.getTitle = Xt.prototype.getTitle;
        Xt.prototype.getPositionInSequence = Xt.prototype.getPositionInSequence;
        Xt.prototype.getSequenceLength = Xt.prototype.getSequenceLength;
        Xt.prototype.setMuted = Xt.prototype.setMuted;
        Xt.prototype.resize = Xt.prototype.resize;
        Xt.prototype.isLinear = Xt.prototype.isLinear;
        Xt.prototype.isMuted = Xt.prototype.isMuted;
        Xt.prototype.setVolume = Xt.prototype.setVolume;
        Xt.prototype.getVolume = Xt.prototype.getVolume;
        Xt.prototype.play = Xt.prototype.play;
        Xt.prototype.pause = Xt.prototype.pause;
        Xt.prototype.skip = Xt.prototype.skip;
        Xt.prototype.canSkipNow = Xt.prototype.canSkipNow;
        Xt.prototype.getTimeUntilSkippable = Xt.prototype.getTimeUntilSkippable;
        Xt.prototype.isSkippable = Xt.prototype.isSkippable;
        Xt.prototype.isPaused = Xt.prototype.isPaused;
        Xt.prototype.getRemainingTime = Xt.prototype.getRemainingTime;
        Xt.prototype.getMinSuggestedDuration = Xt.prototype.getMinSuggestedDuration;
        Xt.prototype.getDuration = Xt.prototype.getDuration;
        Xt.prototype.isUsingAnotherMediaElement = Xt.prototype.isUsingAnotherMediaElement;
        Xt.prototype.hasCustomClick = Xt.prototype.hasCustomClick;
        Xt.prototype.isClientRendering = Xt.prototype.isClientRendering;
        Xt.prototype.needsSkipUI = Xt.prototype.needsSkipUI;
        function Yt(a, b, c, d) {
            var e = this;
            this.A = a;
            this.l = b;
            this.j = null;
            this.G = NaN;
            this.i = d;
            this.H = !1;
            this.C = this.m = this.o = null;
            this.D = "";
            this.F = [];
            this.h = new fd;
            a = new google.ima.dai.api.UiSettings;
            a.setLocale(c);
            this.g = new google.ima.dai.api.StreamManager(this.l, this.A, a);
            this.i(new R("ima-stream-manager-loaded", (new Map).set("imaStreamManager", this.g)));
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.LOADED, function(f) {
                Zt(e, f);
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.ERROR, function() {
                e.D.length ? e.j.resolve(e.D) : e.j.reject("IMA Stream request returned an error and there was no backup asset uri provided.");
                e.j = null;
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, function() {});
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.STARTED, function(f) {
                f = f.getAd();
                e.m = new Xt(f, e.l);
                e.C && (e.m.i = e.C);
                e.i(new R("ad-started", (new Map).set("ad", e.m)));
                e.A.setAttribute("ad-active", "true");
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED, function() {
                e.A.removeAttribute("ad-active");
                var f = e.l.currentTime;
                e.o && e.o > f && (e.l.currentTime = e.o, e.o = null);
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.AD_PROGRESS, function(f) {
                e.C = f.getStreamData().adProgressData;
                e.m && (e.m.i = e.C);
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.FIRST_QUARTILE, function() {
                e.i(new R("ad-first-quartile"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.MIDPOINT, function() {
                e.i(new R("ad-midpoint"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.THIRD_QUARTILE, function() {
                e.i(new R("ad-third-quartile"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.COMPLETE, function() {
                e.i(new R("ad-complete"));
                e.i(new R("ad-stopped"));
                e.A.removeAttribute("ad-active");
                e.m = null;
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.SKIPPED, function() {
                e.i(new R("ad-skipped"));
                e.i(new R("ad-stopped"));
            });
            this.h.u(this.g, google.ima.dai.api.StreamEvent.Type.CUEPOINTS_CHANGED, function(f) {
                var g = f.getStreamData();
                f = [];
                g = u(g.cuepoints);
                for(var h = g.next(); !h.done; h = g.next())h = h.value, f.push({
                    start: h.start,
                    end: h.end
                });
                e.F = f;
                e.i(new R("ad-cue-points-changed", (new Map).set("cuepoints", f)));
            });
        }
        p = Yt.prototype;
        p.configure = function() {};
        p.stop = function() {
            this.D = "";
            this.o = null;
            this.F = [];
        };
        p.release = function() {
            this.stop();
            this.h && this.h.release();
        };
        p.onCueMetadataChange = function(a) {
            if (a.key && a.data) {
                var b = {};
                b[a.key] = a.data;
                this.g.onTimedMetadata(b);
            }
        };
        p.getCuePoints = function() {
            return this.F;
        };
        function Zt(a, b) {
            a.i(new R("ads-loaded", (new Map).set("loadTime", Date.now() / 1E3 - a.G)));
            b = b.getStreamData().url;
            a.j.resolve(b);
            a.j = null;
            a.H || a.h.u(a.l, "seeked", function() {
                var c = a.l.currentTime;
                if (c != 0) {
                    a.g.streamTimeForContentTime(c);
                    var d = a.g.previousCuePointForStreamTime(c);
                    d && !d.played && (a.o = c, a.l.currentTime = d.start);
                }
            });
        }
        function X() {
            fb.call(this);
            this.h = this.i = this.j = this.g = null;
            this.m = new Zs;
            this.o = navigator.language;
            this.l = null;
        }
        oa(X, fb);
        p = X.prototype;
        p.setLocale = function(a) {
            this.o = a;
        };
        p.configure = function(a) {
            this.l = a;
            this.g && this.g.configure(this.l);
            this.j && this.j.configure(this.l);
            this.h && this.h.configure(this.l);
        };
        p.initInterstitial = function(a, b, c) {
            var d = this;
            this.g && this.g.release();
            this.g = new nt(a, b, c, function(e) {
                return $t(d, e);
            });
            this.g.configure(this.l);
        };
        p.initClientSide = function(a, b, c) {
            var d = this;
            if (!window1.google || !google.ima || !google.ima.AdsLoader) throw new T(2, 10, 1E4);
            this.j && this.j.release();
            this.j = new ft(a, b, this.o, c, function(e) {
                return $t(d, e);
            });
            this.j.configure(this.l);
        };
        p.release = function() {
            this.g && (this.g.release(), this.g = null);
            this.j && (this.j.release(), this.j = null);
            this.i && (this.i.release(), this.i = null);
            this.h && (this.h.release(), this.h = null);
            fb.prototype.release.call(this);
        };
        p.onAssetUnload = function() {
            this.g && this.g.stop();
            this.j && this.j.stop();
            this.i && this.i.stop();
            this.h && this.h.stop();
            this.dispatchEvent(new R("ad-stopped"));
            this.dispatchEvent(new R("ad-content-attach-requested"));
            this.m = new Zs;
        };
        p.requestClientSideAds = function(a) {
            if (!this.j) throw new T(1, 10, 10001);
            var b = this.j;
            b.g && b.g.destroy();
            b.m && b.m.contentComplete();
            b.H = Date.now() / 1E3;
            b.m.requestAds(a);
        };
        p.updateClientSideAdsRenderingSettings = function(a) {
            if (!this.j) throw new T(1, 10, 10001);
            var b = this.j;
            b.D = a;
            b.g && b.g.updateAdsRenderingSettings(b.D);
        };
        p.initMediaTailor = function(a, b, c) {
            var d = this;
            this.i && this.i.release();
            this.i = new Mt(a, b, c, function(e) {
                return $t(d, e);
            });
        };
        p.requestMediaTailorStream = function(a, b, c) {
            if (!this.i) throw new T(1, 10, 10005);
            var d = this.i;
            c = c === void 0 ? "" : c;
            d.l ? a = Promise.reject(new T(1, 10, 10004)) : (d.l = new Yg, Pt(d, a, b), d.I = c || "", d.P = Date.now() / 1E3, a = d.l);
            return a;
        };
        p.addMediaTailorTrackingUrl = function(a) {
            if (!this.i) throw new T(1, 10, 10005);
            var b = this.i;
            b.H = a;
            b.i(new R("ads-loaded", (new Map).set("loadTime", 0)));
        };
        p.initServerSide = function(a, b) {
            var c = this;
            if (!window1.google || !google.ima || !google.ima.dai) throw new T(2, 10, 10002);
            this.h && this.h.release();
            this.h = new Yt(a, b, this.o, function(d) {
                return $t(c, d);
            });
            this.h.configure(this.l);
        };
        p.requestServerSideStream = function(a, b) {
            b = b === void 0 ? "" : b;
            if (!this.h) throw new T(1, 10, 10003);
            a.adTagParameters || (a.adTagParameters = {});
            var c = a.adTagParameters;
            (c.mpt || c.mpv) && Za('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overridden.');
            a.adTagParameters.mpt = "shaka-player";
            a.adTagParameters.mpv = "v4.16.44";
            c = this.h;
            c.j ? a = Promise.reject(new T(1, 10, 10004)) : (a instanceof google.ima.dai.api.LiveStreamRequest && (c.H = !0), c.j = new Yg, c.g.requestStream(a), c.D = b || "", c.G = Date.now() / 1E3, a = c.j);
            return a;
        };
        p.replaceServerSideAdTagParameters = function(a) {
            if (!this.h) throw new T(1, 10, 10003);
            (a.mpt || a.mpv) && Za('You have attempted to set "mpt" and/or "mpv" parameters of the ad tag. Please note that those parameters are used for Shaka adoption tracking and will be overridden.');
            a.mpt = "Shaka Player";
            a.mpv = "v4.16.44";
            this.h.g.replaceAdTagParameters(a);
        };
        p.getServerSideCuePoints = function() {
            md("AdManager.getServerSideCuePoints", "Please use getCuePoints function.");
            return this.getCuePoints();
        };
        p.getCuePoints = function() {
            var a = [];
            this.h && (a = a.concat(this.h.getCuePoints()));
            this.i && (a = a.concat(this.i.getCuePoints()));
            return a;
        };
        p.getStats = function() {
            var a = this.m;
            return {
                loadTimes: a.g,
                averageLoadTime: $s(a),
                started: a.h,
                overlayAds: a.j,
                playedCompletely: a.l,
                skipped: a.m,
                errors: a.i
            };
        };
        p.onManifestUpdated = function(a) {
            if (this.i) this.i.onManifestUpdated(a);
        };
        p.onDashTimedMetadata = function(a) {
            this.h && a.schemeIdUri == "urn:google:dai:2018" && this.h.g.processMetadata(a.schemeIdUri, a.eventNode ? a.eventNode.attributes.messageData : null, a.startTime);
        };
        p.onHlsTimedMetadata = function(a, b) {
            this.h && this.h.g.processMetadata("ID3", a.data, b);
        };
        p.onCueMetadataChange = function(a) {
            if (this.h) this.h.onCueMetadataChange(a);
        };
        p.onHLSInterstitialMetadata = function(a, b, c) {
            this.l && this.l.disableHLSInterstitial || (this.g || this.initInterstitial(null, a, b), this.g && At(this.g, c));
        };
        p.onDASHInterstitialMetadata = function(a, b, c) {
            if (!this.l || !this.l.disableDASHInterstitial) {
                var d = c.schemeIdUri;
                if (d == "urn:mpeg:dash:event:alternativeMPD:insert:2025" || d == "urn:mpeg:dash:event:alternativeMPD:replace:2025") {
                    if (this.g || this.initInterstitial(null, a, b), this.g && (a = this.g, b = c.schemeIdUri == "urn:mpeg:dash:event:alternativeMPD:replace:2025", d = c.schemeIdUri == "urn:mpeg:dash:event:alternativeMPD:insert:2025", b || d)) {
                        for(var e = c.startTime, f = c.endTime, g = null, h = 0, k, l = u(c.eventNode.children), m = l.next(); !m.done; m = l.next())if (m = m.value, m.tagName == "AlternativeMPD") {
                            if (m = m.attributes.uri) {
                                k = m;
                                break;
                            }
                        } else if (m.tagName == "InsertPresentation" || m.tagName == "ReplacePresentation") {
                            var n = m.attributes.uri || m.attributes.url;
                            if (n) {
                                k = jc(n);
                                (l = qe(m, "maxDuration", we)) && (g = l / c.timescale);
                                (l = qe(m, "returnOffset", we)) && (h = l / c.timescale);
                                b && h && (f = e + h);
                                break;
                            }
                        }
                        k && Dt(a, [
                            {
                                id: c.id,
                                groupId: null,
                                startTime: e,
                                endTime: f,
                                uri: k,
                                mimeType: null,
                                isSkippable: !1,
                                skipOffset: null,
                                skipFor: null,
                                canJump: !0,
                                resumeOffset: d ? h : null,
                                playoutLimit: g,
                                once: !1,
                                pre: !1,
                                post: !1,
                                timelineRange: b && !d,
                                loop: !1,
                                overlay: null,
                                displayOnBackground: !1,
                                currentVideo: null,
                                background: null,
                                clickThroughUrl: null
                            }
                        ]);
                    }
                } else (d == "urn:mpeg:dash:event:2012" || d == "urn:scte:dash:scte214-events") && c.eventNode && ne(c.eventNode, "OverlayEvent") && (this.g || this.initInterstitial(null, a, b), this.g && Et(this.g, c));
            }
        };
        p.addCustomInterstitial = function(a) {
            if (!this.g) throw new T(1, 10, 10006);
            Dt(this.g, [
                a
            ]);
        };
        p.addAdUrlInterstitial = function(a) {
            if (!this.g) throw new T(1, 10, 10006);
            return this.g.addAdUrlInterstitial(a);
        };
        p.getInterstitialPlayer = function() {
            if (!this.g) throw new T(1, 10, 10006);
            return this.g.Rb();
        };
        function $t(a, b) {
            if (b && b.type) switch(b.type){
                case "ads-loaded":
                    a.m.g.push(b.loadTime);
                    break;
                case "ad-started":
                    a.m.h++;
                    var c = b.ad;
                    c && !c.isLinear() && a.m.j++;
                    break;
                case "ad-complete":
                    a.m.l++;
                    break;
                case "ad-skipped":
                    a.m.m++;
                    break;
                case "ad-error":
                    a.m.i++;
            }
            a.dispatchEvent(b);
        }
        O("shaka.ads.AdManager", X);
        X.prototype.getInterstitialPlayer = X.prototype.getInterstitialPlayer;
        X.prototype.addAdUrlInterstitial = X.prototype.addAdUrlInterstitial;
        X.prototype.addCustomInterstitial = X.prototype.addCustomInterstitial;
        X.prototype.onDASHInterstitialMetadata = X.prototype.onDASHInterstitialMetadata;
        X.prototype.onHLSInterstitialMetadata = X.prototype.onHLSInterstitialMetadata;
        X.prototype.onCueMetadataChange = X.prototype.onCueMetadataChange;
        X.prototype.onHlsTimedMetadata = X.prototype.onHlsTimedMetadata;
        X.prototype.onDashTimedMetadata = X.prototype.onDashTimedMetadata;
        X.prototype.onManifestUpdated = X.prototype.onManifestUpdated;
        X.prototype.getStats = X.prototype.getStats;
        X.prototype.getCuePoints = X.prototype.getCuePoints;
        X.prototype.getServerSideCuePoints = X.prototype.getServerSideCuePoints;
        X.prototype.replaceServerSideAdTagParameters = X.prototype.replaceServerSideAdTagParameters;
        X.prototype.requestServerSideStream = X.prototype.requestServerSideStream;
        X.prototype.initServerSide = X.prototype.initServerSide;
        X.prototype.addMediaTailorTrackingUrl = X.prototype.addMediaTailorTrackingUrl;
        X.prototype.requestMediaTailorStream = X.prototype.requestMediaTailorStream;
        X.prototype.initMediaTailor = X.prototype.initMediaTailor;
        X.prototype.updateClientSideAdsRenderingSettings = X.prototype.updateClientSideAdsRenderingSettings;
        X.prototype.requestClientSideAds = X.prototype.requestClientSideAds;
        X.prototype.onAssetUnload = X.prototype.onAssetUnload;
        X.prototype.release = X.prototype.release;
        X.prototype.initClientSide = X.prototype.initClientSide;
        X.prototype.initInterstitial = X.prototype.initInterstitial;
        X.prototype.configure = X.prototype.configure;
        X.prototype.setLocale = X.prototype.setLocale;
        X.ADS_LOADED = "ads-loaded";
        X.AD_STARTED = "ad-started";
        X.AD_FIRST_QUARTILE = "ad-first-quartile";
        X.AD_MIDPOINT = "ad-midpoint";
        X.AD_THIRD_QUARTILE = "ad-third-quartile";
        X.AD_COMPLETE = "ad-complete";
        X.AD_STOPPED = "ad-stopped";
        X.AD_SKIPPED = "ad-skipped";
        X.AD_VOLUME_CHANGED = "ad-volume-changed";
        X.AD_MUTED = "ad-muted";
        X.AD_PAUSED = "ad-paused";
        X.AD_RESUMED = "ad-resumed";
        X.AD_SKIP_STATE_CHANGED = "ad-skip-state-changed";
        X.CUEPOINTS_CHANGED = "ad-cue-points-changed";
        X.IMA_AD_MANAGER_LOADED = "ima-ad-manager-loaded";
        X.IMA_STREAM_MANAGER_LOADED = "ima-stream-manager-loaded";
        X.AD_CLICKED = "ad-clicked";
        X.AD_PROGRESS = "ad-progress";
        X.AD_BUFFERING = "ad-buffering";
        X.AD_IMPRESSION = "ad-impression";
        X.AD_DURATION_CHANGED = "ad-duration-changed";
        X.AD_CLOSED = "ad-closed";
        X.AD_LOADED = "ad-loaded";
        X.ALL_ADS_COMPLETED = "all-ads-completed";
        X.AD_LINEAR_CHANGED = "ad-linear-changed";
        X.AD_METADATA = "ad-metadata";
        X.AD_RECOVERABLE_ERROR = "ad-recoverable-error";
        X.AD_ERROR = "ad-error";
        X.AD_BREAK_READY = "ad-break-ready";
        X.AD_INTERACTION = "ad-interaction";
        X.AD_CONTENT_PAUSE_REQUESTED = "ad-content-pause-requested";
        X.AD_CONTENT_RESUME_REQUESTED = "ad-content-resume-requested";
        X.AD_CONTENT_ATTACH_REQUESTED = "ad-content-attach-requested";
        sr = function() {
            return new X;
        };
        function au(a) {
            return JSON.stringify(a, function(b, c) {
                if (typeof c != "function") {
                    b = c instanceof R;
                    if (c instanceof Event || b) {
                        var d = {};
                        for(f in c){
                            var e = c[f];
                            e && typeof e == "object" ? f == "detail" ? d[f] = e : e instanceof Event || e instanceof R ? d[f] = {
                                __type__: "Event",
                                event: au(e)
                            } : b && Array.isArray(e) && (d[f] = e) : f in Event || (d[f] = e);
                        }
                        return d;
                    }
                    if (c instanceof Error) {
                        var f = new Set([
                            "name",
                            "message",
                            "stack"
                        ]);
                        for(d in c)f.add(d);
                        b = u(Object.getOwnPropertyNames(c));
                        for(d = b.next(); !d.done; d = b.next())f.add(d.value);
                        b = {};
                        f = u(f);
                        for(d = f.next(); !d.done; d = f.next())d = d.value, b[d] = c[d];
                        c = {
                            __type__: "Error",
                            contents: b
                        };
                    } else if (c instanceof TimeRanges) {
                        f = {
                            __type__: "TimeRanges",
                            length: c.length,
                            start: [],
                            end: []
                        };
                        c = u(Yj(c));
                        for(b = c.next(); !b.done; b = c.next())b = b.value, d = b.end, f.start.push(b.start), f.end.push(d);
                        c = f;
                    } else c = ArrayBuffer.isView(c) && c.BYTES_PER_ELEMENT === 1 ? {
                        __type__: "Uint8Array",
                        entries: Array.from(c)
                    } : typeof c == "number" ? isNaN(c) ? "NaN" : isFinite(c) ? c : c < 0 ? "-Infinity" : "Infinity" : c;
                    return c;
                }
            });
        }
        function bu(a) {
            return JSON.parse(a, function(b, c) {
                if (c == "NaN") var d = NaN;
                else if (c == "-Infinity") d = -Infinity;
                else if (c == "Infinity") d = Infinity;
                else if (c && typeof c == "object" && c.__type__ == "TimeRanges") d = cu(c);
                else if (c && typeof c == "object" && c.__type__ == "Uint8Array") d = new Uint8Array(c.entries);
                else if (c && typeof c == "object" && c.__type__ == "Error") {
                    b = c.contents;
                    c = Error(b.message);
                    for(d in b)c[d] = b[d];
                    d = c;
                } else d = c && typeof c == "object" && c.__type__ == "Event" ? bu(c.event) : c;
                return d;
            });
        }
        function cu(a) {
            return {
                length: a.length,
                start: function(b) {
                    return a.start[b];
                },
                end: function(b) {
                    return a.end[b];
                }
            };
        }
        var du = "ended play playing pause pausing ratechange seeked seeking timeupdate volumechange".split(" "), eu = "buffered currentTime duration ended loop muted paused playbackRate seeking videoHeight videoWidth volume".split(" "), fu = [
            "loop",
            "playbackRate"
        ], gu = [
            "pause",
            "play"
        ], hu = (new Map).set("getAssetUri", 2).set("getAudioLanguages", 4).set("getAudioLanguagesAndRoles", 4).set("getBufferFullness", 1).set("getBufferedInfo", 2).set("getExpiration", 2).set("getKeyStatuses", 2).set("getPlaybackRate", 2).set("getTextLanguages", 4).set("getTextLanguagesAndRoles", 4).set("isAudioOnly", 10).set("isBuffering", 1).set("isInProgress", 1).set("isLive", 10).set("isTextTrackVisible", 1).set("isVideoOnly", 10).set("keySystem", 10).set("seekRange", 1).set("getLoadMode", 10).set("getManifestType", 10).set("isFullyLoaded", 1).set("isEnded", 1).set("getBandwidthEstimate", 1).set("isRemotePlayback", 1), iu = (new Map).set("getConfiguration", 4).set("getConfigurationForLowLatency", 4).set("getStats", 5).set("getAudioTracks", 2).set("getChaptersTracks", 2).set("getImageTracks", 2).set("getVideoTracks", 2).set("getTextTracks", 2).set("getVariantTracks", 2), ju = (new Map).set("getPlayheadTimeAsDate", 1).set("getPresentationStartTimeAsDate", 20).set("getSegmentAvailabilityDuration", 20), ku = [
            [
                "getConfiguration",
                "configure",
                "getConfigurationForLowLatency",
                "configurationForLowLatency"
            ]
        ], lu = [
            [
                "isTextTrackVisible",
                "setTextTrackVisibility"
            ]
        ], mu = "cancelTrickPlay configure configurationForLowLatency getChapters resetConfiguration retryStreaming selectAudioLanguage selectAudioTrack selectTextLanguage selectTextTrack selectVariantTrack selectVariantsByLabel selectVideoTrack setTextTrackVisibility trickPlay updateStartTime goToLive useTrickPlayTrackIfAvailable".split(" "), nu = "addChaptersTrack addTextTrackAsync addThumbnailsTrack getAllThumbnails getChaptersAsync getThumbnails attach attachCanvas detach load unload".split(" ");
        function ou(a, b, c, d, e, f, g) {
            var h = this;
            this.H = a;
            this.K = g;
            this.l = new Uf(b);
            this.L = c;
            this.A = !1;
            this.C = d;
            this.G = e;
            this.M = f;
            this.i = this.m = !1;
            this.J = "";
            this.o = null;
            this.D = function() {
                return pu(h);
            };
            this.F = function(k, l) {
                k = bu(l);
                switch(k.type){
                    case "event":
                        var m = k.targetName, n = Va(k.event);
                        h.C(m, n);
                        break;
                    case "update":
                        m = k.update;
                        for(n in m){
                            k = h.g[n] || {};
                            for(var q in m[n])k[q] = m[n][q];
                        }
                        h.A && (h.L(), h.A = !1);
                        break;
                    case "asyncComplete":
                        if (q = k.id, n = k.error, l = k.res, k = h.h.get(q), h.h.delete(q), k) {
                            if (n) {
                                q = new T(n.severity, n.category, n.code);
                                for(m in n)q[m] = n[m];
                                k.reject(q);
                            } else k.resolve(l);
                        }
                }
            };
            this.g = {
                video: {},
                player: {}
            };
            this.I = 0;
            this.h = new Map;
            this.j = null;
            qu.add(this);
        }
        p = ou.prototype;
        p.destroy = function() {
            qu.delete(this);
            ru(this);
            su && tu(this);
            this.l && (this.l.stop(), this.l = null);
            this.G = this.C = null;
            this.i = this.m = !1;
            this.F = this.D = this.j = this.h = this.g = this.o = null;
            return Promise.resolve();
        };
        p.Qa = function() {
            return this.i;
        };
        p.Yf = function() {
            return this.J;
        };
        p.init = function() {
            if (this.H.length) {
                if (window1.chrome && chrome.cast && chrome.cast.isAvailable) {
                    this.m = !0;
                    this.l.La();
                    var a = new chrome.cast.SessionRequest(this.H, [], null, this.K, null);
                    a = new chrome.cast.ApiConfig(a, function(b) {
                        for(var c = u(qu), d = c.next(); !d.done; d = c.next()){
                            d = d.value;
                            var e = b;
                            d.j = new Yg;
                            d.A = !0;
                            uu(d, e);
                        }
                    }, function(b) {
                        for(var c = u(qu), d = c.next(); !d.done; d = c.next())d = d.value, vu = b == "available", d.l.La();
                    }, "origin_scoped");
                    chrome.cast.initialize(a, function() {}, function() {});
                    vu && this.l.Z(wu);
                    (a = su) && a.status != chrome.cast.SessionStatus.STOPPED ? (this.j = new Yg, this.A = !0, uu(this, a)) : su = null;
                } else window1.__onGCastApiAvailable !== xu && (yu = window1.__onGCastApiAvailable || null, window1.__onGCastApiAvailable = xu);
            }
        };
        p.gi = function(a) {
            this.o = a;
            this.i && zu(this, {
                type: "appData",
                appData: this.o
            });
        };
        p.cast = function() {
            var a = this;
            return H(function(b) {
                if (!a.m) throw new T(1, 8, 8E3);
                if (!vu) throw new T(1, 8, 8001);
                if (a.i) throw new T(1, 8, 8002);
                a.j = new Yg;
                chrome.cast.requestSession(function(c) {
                    return uu(a, c);
                }, function(c) {
                    return Au(a, c);
                });
                return b.g(a.j, 0);
            });
        };
        function Bu(a) {
            a.i && chrome.cast.requestSession(function(b) {
                return uu(a, b);
            }, function(b) {
                return Au(a, b);
            });
        }
        p.Bd = function() {
            if (this.i) {
                ru(this);
                if (su) {
                    tu(this);
                    try {
                        su.stop(function() {}, function() {});
                    } catch (a) {}
                    su = null;
                }
                pu(this);
            }
        };
        p.get = function(a, b) {
            var c = this;
            if (a == "video") {
                if (gu.includes(b)) return function() {
                    return c.Bj.apply(c, [
                        a,
                        b
                    ].concat(G(Ma.apply(0, arguments))));
                };
            } else if (a == "player") {
                if (ju.has(b) && !this.get("player", "isLive")()) return function() {};
                if (mu.includes(b)) return function() {
                    return c.Bj.apply(c, [
                        a,
                        b
                    ].concat(G(Ma.apply(0, arguments))));
                };
                if (nu.includes(b)) return function() {
                    return c.im.apply(c, [
                        a,
                        b
                    ].concat(G(Ma.apply(0, arguments))));
                };
                if (hu.has(b) || iu.has(b)) return function() {
                    return c.g[a][b];
                };
            }
            return this.g[a][b];
        };
        p.set = function(a, b, c) {
            this.g[a][b] = c;
            zu(this, {
                type: "set",
                targetName: a,
                property: b,
                value: c
            });
        };
        function uu(a, b) {
            var c = a.M();
            su = b;
            b.addUpdateListener(a.D);
            b.addMessageListener("urn:x-cast:com.google.shaka.v2", a.F);
            pu(a);
            zu(a, {
                type: "init",
                initState: c,
                appData: a.o
            });
            a.j.resolve();
        }
        function Au(a, b) {
            var c = 8003;
            switch(b.code){
                case "cancel":
                    c = 8004;
                    break;
                case "timeout":
                    c = 8005;
                    break;
                case "receiver_unavailable":
                    c = 8006;
            }
            a.j.reject(new T(2, 8, c, b));
        }
        p.Bj = function(a, b) {
            zu(this, {
                type: "call",
                targetName: a,
                methodName: b,
                args: Ma.apply(2, arguments)
            });
        };
        p.im = function(a, b) {
            var c = Ma.apply(2, arguments), d = new Yg, e = this.I.toString();
            this.I++;
            this.h.set(e, d);
            try {
                zu(this, {
                    type: "asyncCall",
                    targetName: a,
                    methodName: b,
                    args: c,
                    id: e
                });
            } catch (f) {
                d.reject(f);
            }
            return d;
        };
        function tu(a) {
            var b = su;
            b.removeUpdateListener(a.D);
            b.removeMessageListener("urn:x-cast:com.google.shaka.v2", a.F);
        }
        function pu(a) {
            var b = su ? su.status == "connected" : !1;
            if (a.i && !b) {
                a.G();
                for(var c in a.g)a.g[c] = {};
                ru(a);
            }
            a.i = b;
            a.J = b ? su.receiver.friendlyName : "";
            a.l.La();
        }
        function ru(a) {
            if (a.h) for(var b = u(a.h.keys()), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = a.h.get(c);
                a.h.delete(c);
                d.reject(new T(1, 7, 7E3));
            }
        }
        function zu(a, b) {
            b = au(b);
            var c = su;
            try {
                c.sendMessage("urn:x-cast:com.google.shaka.v2", b, function() {}, bb);
            } catch (d) {
                throw b = new T(2, 8, 8005, d), c = new R("error", (new Map).set("detail", b)), a.C("player", c), a.Bd(), b;
            }
        }
        var wu = .02, vu = !1, su = null, yu = null, qu = new Set;
        function xu(a) {
            yu ? window1.__onGCastApiAvailable = yu : delete window1.__onGCastApiAvailable;
            yu = null;
            if (a) for(var b = u(qu), c = b.next(); !c.done; c = b.next())c.value.init();
            typeof window1.__onGCastApiAvailable === "function" && window1.__onGCastApiAvailable(a);
        }
        function Cu(a, b, c, d) {
            d = d === void 0 ? !1 : d;
            fb.call(this);
            var e = this;
            this.i = a;
            this.h = b;
            this.l = this.o = this.m = this.A = this.j = null;
            this.I = c;
            this.H = d;
            this.F = [];
            this.D = [];
            this.C = [];
            this.G = new Map;
            this.g = null;
            window1.chrome && Xb().Pa() != "CAST" ? (this.g = new ou(c, function() {
                return Du(e);
            }, function() {
                return Eu(e);
            }, function(f, g) {
                return Fu(e, f, g);
            }, function() {
                return Gu(e);
            }, function() {
                return Hu(e);
            }, d), Iu(this)) : (this.j = this.i, this.A = this.h);
        }
        oa(Cu, fb);
        p = Cu.prototype;
        p.destroy = function(a) {
            this.g && (a === void 0 ? 0 : a) && this.g.Bd();
            this.l && (this.l.release(), this.l = null);
            a = [];
            this.h && (a.push(this.h.destroy()), this.h = null);
            this.g && (a.push(this.g.destroy()), this.g = null);
            this.A = this.j = this.i = null;
            fb.prototype.release.call(this);
            return Promise.all(a);
        };
        p.Rc = function() {
            return this.j;
        };
        p.Rb = function() {
            return this.A;
        };
        p.Kg = function() {
            return this.g ? this.g.m && vu : !1;
        };
        p.Qa = function() {
            return this.g ? this.g.Qa() : !1;
        };
        p.Yf = function() {
            return this.g ? this.g.Yf() : "";
        };
        p.cast = function() {
            var a = this;
            return H(function(b) {
                return b.h == 1 ? a.g ? b.g(a.g.cast(), 2) : b.return() : a.h ? b.g(a.h.tc(), 0) : b.return();
            });
        };
        p.gi = function(a) {
            this.g && this.g.gi(a);
        };
        p.Yj = function() {
            this.g && Bu(this.g);
        };
        p.Bd = function() {
            this.g && this.g.Bd();
        };
        p.Qi = function(a, b) {
            b = b === void 0 ? !1 : b;
            var c = this;
            return H(function(d) {
                if (d.h == 1) {
                    if (a == c.I && b == c.H) return d.return();
                    c.I = a;
                    c.H = b;
                    if (!c.g) return d.return();
                    c.g.Bd();
                    return d.g(c.g.destroy(), 2);
                }
                c.g = null;
                c.g = new ou(a, function() {
                    return Du(c);
                }, function() {
                    return Eu(c);
                }, function(e, f) {
                    return Fu(c, e, f);
                }, function() {
                    return Gu(c);
                }, function() {
                    return Hu(c);
                }, b);
                c.g.init();
                d.j();
            });
        };
        function Iu(a) {
            a.g.init();
            a.l = new fd;
            for(var b = u(du), c = b.next(); !c.done; c = b.next())a.l.u(a.i, c.value, function(f) {
                a.g.Qa() || (f = Va(f), a.m.dispatchEvent(f));
            });
            for(var d in Wa)a.l.u(a.h, Wa[d], function(f) {
                a.g.Qa() || a.o.dispatchEvent(f);
            });
            a.j = {};
            b = {};
            for(var e in a.i)b = {
                ve: b.ve
            }, b.ve = e, Object.defineProperty(a.j, b.ve, {
                configurable: !1,
                enumerable: !0,
                get: function(f) {
                    return function() {
                        return Ju(a, f.ve);
                    };
                }(b),
                set: function(f) {
                    return function(g) {
                        var h = f.ve;
                        a.g.Qa() ? a.g.set("video", h, g) : a.i[h] = g;
                    };
                }(b)
            });
            a.A = {};
            Ku(a, function(f) {
                Object.defineProperty(a.A, f, {
                    configurable: !1,
                    enumerable: !0,
                    get: function() {
                        return Lu(a, f);
                    }
                });
            });
            Mu(a);
            a.m = new fb;
            a.m.We = a.j;
            a.o = new fb;
            a.o.We = a.A;
            a.l.u(a.h, "unloading", function() {
                a.g && a.g.Qa() || Nu(a);
            });
        }
        function Mu(a) {
            var b = new Map;
            Ku(a, function(c, d) {
                b.has(d) ? (d = b.get(d), c.length < d.length ? a.G.set(c, d) : a.G.set(d, c)) : b.set(d, c);
            });
        }
        function Ku(a, b) {
            function c(k) {
                return k == "constructor" || typeof d[k] != "function" ? !1 : !e.has(k);
            }
            var d = a.h, e = new Set, f;
            for(f in d)c(f) && (e.add(f), b(f, d[f]));
            a = Object.getPrototypeOf(d);
            for(f = Object.getPrototypeOf({}); a && a != f;){
                for(var g = u(Object.getOwnPropertyNames(a)), h = g.next(); !h.done; h = g.next())h = h.value, c(h) && (e.add(h), b(h, d[h]));
                a = Object.getPrototypeOf(a);
            }
        }
        function Hu(a) {
            var b = {
                video: {},
                player: {},
                playerAfterLoad: {},
                manifest: a.h.dd(),
                startTime: null,
                addThumbnailsTrackCalls: a.F,
                addTextTrackAsyncCalls: a.D,
                addChaptersTrackCalls: a.C
            };
            a.i.pause();
            for(var c = u(fu), d = c.next(); !d.done; d = c.next())d = d.value, b.video[d] = a.i[d];
            a.i.ended || (b.startTime = a.i.currentTime);
            c = u(ku);
            for(d = c.next(); !d.done; d = c.next()){
                var e = d.value;
                d = e[1];
                e = a.h[e[0]]();
                b.player[d] = e;
            }
            c = u(lu);
            for(d = c.next(); !d.done; d = c.next())e = d.value, d = e[1], e = a.h[e[0]](), b.playerAfterLoad[d] = e;
            return b;
        }
        function Du(a) {
            var b = new R("caststatuschanged");
            a.dispatchEvent(b);
        }
        function Eu(a) {
            var b = new R(a.j.paused ? "pause" : "play");
            a.m.dispatchEvent(b);
        }
        function Gu(a) {
            for(var b = u(ku), c = b.next(); !c.done; c = b.next()){
                var d = c.value;
                c = d[1];
                d = a.g.get("player", d[0])();
                a.h[c](d);
            }
            var e = a.F, f = a.D, g = a.C;
            Nu(a);
            var h = a.g.get("player", "getAssetUri")();
            d = a.g.get("video", "ended");
            b = Promise.resolve();
            var k = a.i.autoplay;
            c = null;
            d || (c = a.g.get("video", "currentTime"));
            var l;
            (d = a.g.get("player", "getTextTracks")()) && d.length && (l = d.find(function(q) {
                return q.active;
            }));
            var m = a.g.get("player", "isTextTrackVisible")();
            h && (a.i.autoplay = !1, b = a.h.load(h, c));
            var n = {};
            c = u(fu);
            for(d = c.next(); !d.done; d = c.next())d = d.value, n[d] = a.g.get("video", d);
            b.then(function() {
                if (a.i) {
                    for(var q = u(e), r = q.next(); !r.done; r = q.next()){
                        r = r.value;
                        var t;
                        (t = a.Rb()).cf.apply(t, G(r));
                    }
                    q = u(f);
                    for(t = q.next(); !t.done; t = q.next()){
                        t = t.value;
                        var v;
                        (v = a.Rb()).fe.apply(v, G(t));
                    }
                    v = u(g);
                    for(q = v.next(); !q.done; q = v.next()){
                        q = q.value;
                        var w;
                        (w = a.Rb()).bf.apply(w, G(q));
                    }
                    w = u(fu);
                    for(v = w.next(); !v.done; v = w.next())v = v.value, a.i[v] = n[v];
                    w = u(lu);
                    for(v = w.next(); !v.done; v = w.next())q = v.value, v = q[1], q = a.g.get("player", q[0])(), a.h[v](q);
                    a.h.Xd(m);
                    l && a.h.ei(l.language, l.roles, l.forced);
                    a.i.autoplay = k;
                    h && a.i.play();
                }
            }, function(q) {
                q = (new Map).set("detail", q);
                q = new R("error", q);
                a.h.dispatchEvent(q);
            });
        }
        function Ju(a, b) {
            if (b == "addEventListener") return function(d, e, f) {
                return a.m.addEventListener(d, e, f);
            };
            if (b == "removeEventListener") return function(d, e, f) {
                return a.m.removeEventListener(d, e, f);
            };
            if (a.g.Qa() && Object.keys(a.g.g.video).length == 0) {
                var c = a.i[b];
                if (typeof c != "function") return c;
            }
            return a.g.Qa() ? a.g.get("video", b) : (b = a.i[b], typeof b == "function" && (b = b.bind(a.i)), b);
        }
        function Lu(a, b, c) {
            c = c === void 0 ? !1 : c;
            a.G.has(b) && (b = a.G.get(b));
            if (b == "addEventListener") return function(d, e, f) {
                return a.o.addEventListener(d, e, f);
            };
            if (b == "removeEventListener") return function(d, e, f) {
                return a.o.removeEventListener(d, e, f);
            };
            if (b == "getMediaElement") return function() {
                return a.j;
            };
            if (b == "getSharedConfiguration") return a.g.get("player", "getConfiguration");
            if (b == "getNetworkingEngine") return function() {
                return a.h.Qb();
            };
            if (b == "getDrmEngine") return function() {
                return a.h.F;
            };
            if (b == "getAdManager") return function() {
                return a.h.tf();
            };
            if (b == "getQueueManager") return function() {
                return a.h.wf();
            };
            if (b == "setVideoContainer") return function(d) {
                return a.h.mi(d);
            };
            if (!c) {
                if (b == "addThumbnailsTrack") return function() {
                    var d = Ma.apply(0, arguments);
                    a.F.push(d);
                    return Lu(a, b, !0).apply(null, G(d));
                };
                if (b == "addTextTrackAsync") return function() {
                    var d = Ma.apply(0, arguments);
                    a.D.push(d);
                    return Lu(a, b, !0).apply(null, G(d));
                };
                if (b == "addChaptersTrack") return function() {
                    var d = Ma.apply(0, arguments);
                    a.C.push(d);
                    return Lu(a, b, !0).apply(null, G(d));
                };
            }
            if (a.g.Qa()) {
                if (b == "getManifest" || b == "drmInfo") return function() {
                    Za(b + "() does not work while casting!");
                    return null;
                };
                if (b == "attach" || b == "detach") return function() {
                    Za(b + "() does not work while casting!");
                    return Promise.resolve();
                };
                if (b == "getChapters") return function() {
                    Za(b + "() does not work while casting!");
                    return [];
                };
            }
            return a.g.Qa() && Object.keys(a.g.g.video).length == 0 && (hu.has(b) || iu.has(b)) || !a.g.Qa() ? a.h[b].bind(a.h) : a.g.get("player", b);
        }
        function Fu(a, b, c) {
            a.g.Qa() && (b == "video" ? a.m.dispatchEvent(c) : b == "player" && (c.type == "unloading" && Nu(a), a.o.dispatchEvent(c)));
        }
        function Nu(a) {
            a.F = [];
            a.D = [];
            a.C = [];
        }
        O("shaka.cast.CastProxy", Cu);
        Cu.prototype.changeReceiverId = Cu.prototype.Qi;
        Cu.prototype.forceDisconnect = Cu.prototype.Bd;
        Cu.prototype.suggestDisconnect = Cu.prototype.Yj;
        Cu.prototype.setAppData = Cu.prototype.gi;
        Cu.prototype.cast = Cu.prototype.cast;
        Cu.prototype.receiverName = Cu.prototype.Yf;
        Cu.prototype.isCasting = Cu.prototype.Qa;
        Cu.prototype.canCast = Cu.prototype.Kg;
        Cu.prototype.getPlayer = Cu.prototype.Rb;
        Cu.prototype.getVideo = Cu.prototype.Rc;
        Cu.prototype.destroy = Cu.prototype.destroy;
        function Ou(a, b, c, d) {
            fb.call(this);
            var e = this;
            this.h = a;
            this.g = b;
            this.j = new fd;
            this.I = {
                video: a,
                player: b
            };
            this.G = c || function() {};
            this.J = d || function(f) {
                return f;
            };
            this.i = null;
            this.H = !1;
            this.o = !0;
            this.m = 0;
            this.D = !1;
            this.C = !0;
            this.A = this.l = null;
            this.F = new Uf(function() {
                Pu(e);
            });
            Qu(this);
        }
        oa(Ou, fb);
        p = Ou.prototype;
        p.isConnected = function() {
            return this.H;
        };
        p.Fl = function() {
            return this.o;
        };
        p.vm = function(a) {
            this.i = a;
        };
        p.yk = function() {
            this.i = null;
        };
        p.wm = function(a) {
            this.i || (this.i = {
                metadataType: cast.receiver.media.MetadataType.GENERIC
            });
            this.i.title = a;
        };
        p.um = function(a) {
            this.i || (this.i = {
                metadataType: cast.receiver.media.MetadataType.GENERIC
            });
            this.i.images = [
                {
                    url: a
                }
            ];
        };
        p.tm = function(a) {
            this.i || (this.i = {});
            this.i.artist = a;
            this.i.metadataType = cast.receiver.media.MetadataType.MUSIC_TRACK;
        };
        p.destroy = function() {
            var a = this, b, c;
            return H(function(d) {
                if (d.h == 1) return a.j && (a.j.release(), a.j = null), b = [], a.g && (b.push(a.g.destroy()), a.g = null), a.F && (a.F.stop(), a.F = null), a.h = null, a.I = null, a.G = null, a.H = !1, a.o = !0, a.l = null, a.A = null, fb.prototype.release.call(a), d.g(Promise.all(b), 2);
                c = cast.receiver.CastReceiverManager.getInstance();
                c.stop();
                d.j();
            });
        };
        function Qu(a) {
            var b = cast.receiver.CastReceiverManager.getInstance();
            b.onSenderConnected = function() {
                return Ru(a);
            };
            b.onSenderDisconnected = function() {
                return Ru(a);
            };
            b.onSystemVolumeChanged = function() {
                var e = cast.receiver.CastReceiverManager.getInstance().getSystemVolume();
                e && Su(a, {
                    type: "update",
                    update: {
                        video: {
                            volume: e.level,
                            muted: e.muted
                        }
                    }
                }, a.l);
                Su(a, {
                    type: "event",
                    targetName: "video",
                    event: {
                        type: "volumechange"
                    }
                }, a.l);
            };
            a.A = b.getCastMessageBus("urn:x-cast:com.google.cast.media");
            a.A.onMessage = function(e) {
                return Tu(a, e);
            };
            a.l = b.getCastMessageBus("urn:x-cast:com.google.shaka.v2");
            a.l.onMessage = function(e) {
                return Uu(a, e);
            };
            b.start();
            b = u(du);
            for(var c = b.next(); !c.done; c = b.next())a.j.u(a.h, c.value, function(e) {
                return Vu(a, "video", e);
            });
            for(var d in Wa)a.j.u(a.g, Wa[d], function(e) {
                return Vu(a, "player", e);
            });
            a.j.u(a.h, "loadeddata", function() {
                a.D = !0;
            });
            a.j.u(a.g, "loading", function() {
                a.o = !1;
                Wu(a);
            });
            a.j.u(a.h, "playing", function() {
                a.o = !1;
                Wu(a);
            });
            a.j.u(a.h, "pause", function() {
                Wu(a);
            });
            a.j.u(a.g, "unloading", function() {
                a.o = !0;
                Wu(a);
            });
            a.j.u(a.h, "ended", function() {
                new Uf(function() {
                    a.h && a.h.ended && (a.o = !0, Wu(a));
                }).Z(Xu);
            });
        }
        function Ru(a) {
            a.m = 0;
            a.C = !0;
            a.H = cast.receiver.CastReceiverManager.getInstance().getSenders().length != 0;
            Wu(a);
        }
        function Wu(a) {
            var b;
            H(function(c) {
                if (c.h == 1) return c.g(Promise.resolve(), 2);
                if (!a.g) return c.return();
                b = new R("caststatuschanged");
                a.dispatchEvent(b);
                Yu(a) || Zu(a);
                c.j();
            });
        }
        function $u(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            H(function(C) {
                switch(C.h){
                    case 1:
                        for(d in b.player)e = b.player[d], a.g[d](e);
                        a.G(c);
                        f = a.h.autoplay;
                        return b.manifest ? (a.h.autoplay = !1, C.m(5), C.g(a.g.load(b.manifest, b.startTime), 7)) : C.g(Promise.resolve(), 3);
                    case 7:
                        if (b.addThumbnailsTrackCalls) for(g = u(b.addThumbnailsTrackCalls), h = g.next(); !h.done; h = g.next())k = h.value, a.g.cf.apply(a.g, G(k));
                        if (b.addTextTrackAsyncCalls) for(l = u(b.addTextTrackAsyncCalls), m = l.next(); !m.done; m = l.next())n = m.value, a.g.fe.apply(a.g, G(n));
                        if (b.addChaptersTrackCalls) for(q = u(b.addChaptersTrackCalls), r = q.next(); !r.done; r = q.next())t = r.value, a.g.bf.apply(a.g, G(t));
                        C.o(3);
                        break;
                    case 5:
                        return v = C.l(), w = (new Map).set("detail", v), x = new R("error", w), a.g && a.g.dispatchEvent(x), C.return();
                    case 3:
                        if (!a.g) return C.return();
                        for(y in b.video)z = b.video[y], a.h[y] = z;
                        for(A in b.playerAfterLoad)E = b.playerAfterLoad[A], a.g[A](E);
                        a.h.autoplay = f;
                        b.manifest && (a.h.play(), Zu(a));
                        C.j();
                }
            });
        }
        function Vu(a, b, c) {
            a.g && (Pu(a), Su(a, {
                type: "event",
                targetName: b,
                event: c
            }, a.l));
        }
        function Pu(a) {
            a.F.Z(av);
            for(var b = {
                video: {},
                player: {}
            }, c = u(eu), d = c.next(); !d.done; d = c.next())d = d.value, b.video[d] = a.h[d];
            a.g.U() && ju.forEach(function(e, f) {
                a.m % e == 0 && (b.player[f] = a.g[f]());
            });
            hu.forEach(function(e, f) {
                a.m % e == 0 && (b.player[f] = a.g[f]());
            });
            if (c = cast.receiver.CastReceiverManager.getInstance().getSystemVolume()) b.video.volume = c.level, b.video.muted = c.muted;
            Su(a, {
                type: "update",
                update: b
            }, a.l);
            iu.forEach(function(e, f) {
                a.m % e == 0 && (e = {
                    player: {}
                }, e.player[f] = a.g[f](), Su(a, {
                    type: "update",
                    update: e
                }, a.l));
            });
            a.D && (a.m += 1);
            Yu(a);
        }
        function Yu(a) {
            return a.C && (a.h.duration || a.g.U()) ? (bv(a), a.C = !1, !0) : !1;
        }
        function bv(a, b) {
            var c = {
                contentId: a.g.dd(),
                streamType: a.g.U() ? "LIVE" : "BUFFERED",
                contentType: ""
            };
            a.g.U() || (c.duration = a.h.duration);
            a.i && (c.metadata = a.i);
            Zu(a, b === void 0 ? 0 : b, c);
        }
        function Uu(a, b) {
            var c = bu(b.data);
            switch(c.type){
                case "init":
                    a.m = 0;
                    a.D = !1;
                    a.C = !0;
                    $u(a, c.initState, c.appData);
                    Pu(a);
                    break;
                case "appData":
                    a.G(c.appData);
                    break;
                case "set":
                    var d = c.targetName, e = c.property;
                    c = c.value;
                    if (d == "video") {
                        if (b = cast.receiver.CastReceiverManager.getInstance(), e == "volume") {
                            b.setSystemVolumeLevel(c);
                            break;
                        } else if (e == "muted") {
                            b.setSystemVolumeMuted(c);
                            break;
                        }
                    }
                    a.I[d][e] = c;
                    break;
                case "call":
                    d = a.I[c.targetName];
                    d[c.methodName].apply(d, c.args);
                    break;
                case "asyncCall":
                    d = c.targetName;
                    e = c.methodName;
                    d == "player" && e == "load" && (a.m = 0, a.D = !1);
                    var f = c.id, g = b.senderId;
                    b = a.I[d];
                    c = b[e].apply(b, c.args);
                    d == "player" && e == "load" && (c = c.then(function() {
                        a.C = !0;
                    }));
                    c.then(function(h) {
                        return cv(a, g, f, null, h);
                    }, function(h) {
                        return cv(a, g, f, h, null);
                    });
            }
        }
        function Tu(a, b) {
            var c = bu(b.data);
            switch(c.type){
                case "PLAY":
                    a.h.play();
                    Zu(a);
                    break;
                case "PAUSE":
                    a.h.pause();
                    Zu(a);
                    break;
                case "SEEK":
                    b = c.currentTime;
                    var d = c.resumeState;
                    b != null && (a.h.currentTime = Number(b));
                    d && d == "PLAYBACK_START" ? (a.h.play(), Zu(a)) : d && d == "PLAYBACK_PAUSE" && (a.h.pause(), Zu(a));
                    break;
                case "STOP":
                    a.g.tc().then(function() {
                        a.g && Zu(a);
                    });
                    break;
                case "GET_STATUS":
                    bv(a, Number(c.requestId));
                    break;
                case "VOLUME":
                    d = c.volume;
                    b = d.level;
                    d = d.muted;
                    var e = a.h.volume, f = a.h.muted;
                    b != null && (a.h.volume = Number(b));
                    d != null && (a.h.muted = d);
                    e == a.h.volume && f == a.h.muted || Zu(a);
                    break;
                case "LOAD":
                    a.m = 0;
                    a.D = !1;
                    a.C = !1;
                    b = c.media;
                    d = c.currentTime;
                    e = a.J(b.contentId);
                    f = c.autoplay || !0;
                    a.G(b.customData);
                    f && (a.h.autoplay = !0);
                    a.g.load(e, d).then(function() {
                        a.g && bv(a);
                    }).catch(function(g) {
                        var h = "LOAD_FAILED";
                        g.category == 7 && g.code == 7E3 && (h = "LOAD_CANCELLED");
                        Su(a, {
                            requestId: Number(c.requestId),
                            type: h
                        }, a.A);
                    });
                    break;
                default:
                    Su(a, {
                        requestId: Number(c.requestId),
                        type: "INVALID_REQUEST",
                        reason: "INVALID_COMMAND"
                    }, a.A);
            }
        }
        function cv(a, b, c, d, e) {
            a.g && Su(a, {
                type: "asyncComplete",
                id: c,
                error: d,
                res: e
            }, a.l, b);
        }
        function Su(a, b, c, d) {
            a.H && (a = au(b), d ? c.getCastChannel(d).send(a) : c.broadcast(a));
        }
        function Zu(a, b, c) {
            c = c === void 0 ? null : c;
            var d = {
                mediaSessionId: 0,
                playbackRate: a.h.playbackRate,
                playerState: a.o ? dv : a.g.Df() ? ev : a.h.paused ? fv : gv,
                currentTime: a.h.currentTime,
                supportedMediaCommands: 63,
                volume: {
                    level: a.h.volume,
                    muted: a.h.muted
                }
            };
            c && (d.media = c);
            Su(a, {
                requestId: b === void 0 ? 0 : b,
                type: "MEDIA_STATUS",
                status: [
                    d
                ]
            }, a.A);
        }
        O("shaka.cast.CastReceiver", Ou);
        Ou.prototype.destroy = Ou.prototype.destroy;
        Ou.prototype.setContentArtist = Ou.prototype.tm;
        Ou.prototype.setContentImage = Ou.prototype.um;
        Ou.prototype.setContentTitle = Ou.prototype.wm;
        Ou.prototype.clearContentMetadata = Ou.prototype.yk;
        Ou.prototype.setContentMetadata = Ou.prototype.vm;
        Ou.prototype.isIdle = Ou.prototype.Fl;
        Ou.prototype.isConnected = Ou.prototype.isConnected;
        var av = .5, Xu = 5, dv = "IDLE", gv = "PLAYING", ev = "BUFFERING", fv = "PAUSED";
        function hv(a, b, c, d, e) {
            if (d >= e) return null;
            for(var f = -1, g = -1, h = 0; h < c.length; h++)if (c[h].some(function(A) {
                return A != null && A.g.trim() != "";
            })) {
                f = h;
                break;
            }
            for(h = c.length - 1; h >= 0; h--)if (c[h].some(function(A) {
                return A != null && A.g.trim() != "";
            })) {
                g = h;
                break;
            }
            if (f === -1 || g === -1) return null;
            for(var k = h = !1, l = "white", m = "black", n = iv(d, e, h, k, l, m); f <= g; f++){
                for(var q = c[f], r = -1, t = -1, v = 0; v < q.length; v++)if (q[v] != null && q[v].g.trim() !== "") {
                    r = v;
                    break;
                }
                for(v = q.length - 1; v >= 0; v--)if (q[v] != null && q[v].g.trim() !== "") {
                    t = v;
                    break;
                }
                if (r === -1 || t === -1) q = jv(d, e), a.nestedCues.push(q);
                else {
                    for(; r <= t; r++)if (v = q[r]) {
                        var w = v.l, x = v.i, y = v.j, z = v.h;
                        if (w != h || x != k || y != l || z != m) n.payload && a.nestedCues.push(n), n = iv(d, e, w, x, y, z), h = w, k = x, l = y, m = z;
                        n.payload += v.g;
                    } else n.payload += " ";
                    n.payload && a.nestedCues.push(n);
                    f !== g && (n = jv(d, e), a.nestedCues.push(n));
                    n = iv(d, e, h, k, l, m);
                }
            }
            return a.nestedCues.length ? {
                cue: a,
                stream: b
            } : null;
        }
        function iv(a, b, c, d, e, f) {
            a = new Ie(a, b, "");
            c && a.textDecoration.push(ff);
            d && (a.fontStyle = ef);
            a.color = e;
            a.backgroundColor = f;
            return a;
        }
        function jv(a, b) {
            a = new Ie(a, b, "");
            a.lineBreak = !0;
            return a;
        }
        function kv(a, b, c, d, e) {
            this.g = a;
            this.l = b;
            this.i = c;
            this.h = d;
            this.j = e;
        }
        function lv(a, b) {
            this.i = [];
            this.g = 1;
            this.h = 0;
            this.F = a;
            this.D = b;
            this.j = this.m = !1;
            this.l = "white";
            this.o = "black";
            this.A = this.C = null;
            mv(this);
        }
        function nv(a, b, c) {
            var d = "CC" + ((a.F << 1 | a.D) + 1), e = new Ie(b, c, "");
            e.lineInterpretation = 1;
            var f = ov.get(a.g);
            f && (e.line = f);
            a.A != null && a.C != null && (e.position = 10 + Math.min(70, a.A * 10) + a.C * 2.5);
            (b = hv(e, d, a.i, b, c)) && a.g + b.cue.nestedCues.length - 3 > 15 && (f = ov.get(a.g + 3 - b.cue.nestedCues.length)) && (e.line = f);
            return b;
        }
        function mv(a) {
            pv(a, 0, 15);
            a.g = 1;
        }
        function qv(a, b, c) {
            if (!(c < 32 || c > 127)) {
                var d = "";
                switch(b){
                    case 0:
                        d = rv.has(c) ? rv.get(c) : String.fromCharCode(c);
                        break;
                    case 1:
                        d = sv.get(c);
                        break;
                    case 2:
                        a.i[a.g].pop();
                        d = tv.get(c);
                        break;
                    case 3:
                        a.i[a.g].pop(), d = uv.get(c);
                }
                d && a.i[a.g].push(new kv(d, a.m, a.j, a.o, a.l));
            }
        }
        function vv(a, b, c, d) {
            if (!(c < 0 || b < 0)) {
                if (b >= c) for(--d; d >= 0; d--)a.i[b + d] = a.i[c + d].map(function(f) {
                    return f;
                });
                else for(var e = 0; e < d; e++)a.i[b + e] = a.i[c + e].map(function(f) {
                    return f;
                });
            }
        }
        function pv(a, b, c) {
            for(var d = 0; d <= c; d++)a.i[b + d] = [];
        }
        var rv = new Map([
            [
                39,
                "\u2019"
            ],
            [
                42,
                "\u00e1"
            ],
            [
                92,
                "\u00e9"
            ],
            [
                92,
                "\u00e9"
            ],
            [
                94,
                "\u00ed"
            ],
            [
                95,
                "\u00f3"
            ],
            [
                96,
                "\u00fa"
            ],
            [
                123,
                "\u00e7"
            ],
            [
                124,
                "\u00f7"
            ],
            [
                125,
                "\u00d1"
            ],
            [
                126,
                "\u00f1"
            ],
            [
                127,
                "\u2588"
            ]
        ]), sv = new Map([
            [
                48,
                "\u00ae"
            ],
            [
                49,
                "\u00b0"
            ],
            [
                50,
                "\u00bd"
            ],
            [
                51,
                "\u00bf"
            ],
            [
                52,
                "\u2122"
            ],
            [
                53,
                "\u00a2"
            ],
            [
                54,
                "\u00a3"
            ],
            [
                55,
                "\u266a"
            ],
            [
                56,
                "\u00e0"
            ],
            [
                57,
                " "
            ],
            [
                58,
                "\u00e8"
            ],
            [
                59,
                "\u00e2"
            ],
            [
                60,
                "\u00ea"
            ],
            [
                61,
                "\u00ee"
            ],
            [
                62,
                "\u00f4"
            ],
            [
                63,
                "\u00fb"
            ]
        ]), tv = new Map([
            [
                32,
                "\u00c1"
            ],
            [
                33,
                "\u00c9"
            ],
            [
                34,
                "\u00d3"
            ],
            [
                35,
                "\u00da"
            ],
            [
                36,
                "\u00dc"
            ],
            [
                37,
                "\u00fc"
            ],
            [
                38,
                "\u2018"
            ],
            [
                39,
                "\u00a1"
            ],
            [
                40,
                "*"
            ],
            [
                41,
                "'"
            ],
            [
                42,
                "\u2500"
            ],
            [
                43,
                "\u00a9"
            ],
            [
                44,
                "\u2120"
            ],
            [
                45,
                "\u00b7"
            ],
            [
                46,
                "\u201c"
            ],
            [
                47,
                "\u201d"
            ],
            [
                48,
                "\u00c0"
            ],
            [
                49,
                "\u00c2"
            ],
            [
                50,
                "\u00c7"
            ],
            [
                51,
                "\u00c8"
            ],
            [
                52,
                "\u00ca"
            ],
            [
                53,
                "\u00cb"
            ],
            [
                54,
                "\u00eb"
            ],
            [
                55,
                "\u00ce"
            ],
            [
                56,
                "\u00cf"
            ],
            [
                57,
                "\u00ef"
            ],
            [
                58,
                "\u00d4"
            ],
            [
                59,
                "\u00d9"
            ],
            [
                60,
                "\u00f9"
            ],
            [
                61,
                "\u00db"
            ],
            [
                62,
                "\u00ab"
            ],
            [
                63,
                "\u00bb"
            ]
        ]), uv = new Map([
            [
                32,
                "\u00c3"
            ],
            [
                33,
                "\u00e3"
            ],
            [
                34,
                "\u00cd"
            ],
            [
                35,
                "\u00cc"
            ],
            [
                36,
                "\u00ec"
            ],
            [
                37,
                "\u00d2"
            ],
            [
                38,
                "\u00f2"
            ],
            [
                39,
                "\u00d5"
            ],
            [
                40,
                "\u00f5"
            ],
            [
                41,
                "{"
            ],
            [
                42,
                "}"
            ],
            [
                43,
                "\\"
            ],
            [
                44,
                "^"
            ],
            [
                45,
                "_"
            ],
            [
                46,
                "|"
            ],
            [
                47,
                "~"
            ],
            [
                48,
                "\u00c4"
            ],
            [
                49,
                "\u00e4"
            ],
            [
                50,
                "\u00d6"
            ],
            [
                51,
                "\u00f6"
            ],
            [
                52,
                "\u00df"
            ],
            [
                53,
                "\u00a5"
            ],
            [
                54,
                "\u00a4"
            ],
            [
                55,
                "\u2502"
            ],
            [
                56,
                "\u00c5"
            ],
            [
                57,
                "\u00e5"
            ],
            [
                58,
                "\u00d8"
            ],
            [
                59,
                "\u00f8"
            ],
            [
                60,
                "\u250c"
            ],
            [
                61,
                "\u2510"
            ],
            [
                62,
                "\u2514"
            ],
            [
                63,
                "\u2518"
            ]
        ]), ov = new Map([
            [
                1,
                10
            ],
            [
                2,
                15.33
            ],
            [
                3,
                20.66
            ],
            [
                4,
                26
            ],
            [
                5,
                31.33
            ],
            [
                6,
                36.66
            ],
            [
                7,
                42
            ],
            [
                8,
                47.33
            ],
            [
                9,
                52.66
            ],
            [
                10,
                58
            ],
            [
                11,
                63.33
            ],
            [
                12,
                68.66
            ],
            [
                13,
                74
            ],
            [
                14,
                79.33
            ],
            [
                15,
                84.66
            ]
        ]);
        function wv(a, b) {
            this.h = 0;
            this.o = new lv(a, b);
            this.i = new lv(a, b);
            this.g = this.j = new lv(a, b);
            this.l = 0;
            this.m = null;
        }
        function xv(a, b, c) {
            a.g = a.i;
            var d = a.g, e = null;
            a.h !== 3 && a.h !== 4 && (e = nv(d, a.l, c), c = a.i, c.g = c.h > 0 ? c.h : 0, pv(c, 0, 15), c = a.j, c.g = c.h > 0 ? c.h : 0, pv(c, 0, 15), d.g = 15);
            a.h = 3;
            d.h = b;
            return e;
        }
        function yv(a) {
            a.h = 1;
            a.g = a.j;
            a.g.h = 0;
        }
        function zv(a) {
            $a("Cea608DataChannel", "CEA-608 text mode entered, but is unsupported");
            a.g = a.o;
            a.h = 4;
        }
        var Av = "black green blue cyan red yellow magenta black".split(" "), Bv = "white green blue cyan red yellow magenta white_italics".split(" ");
        function Cv(a, b) {
            this.J = b;
            this.M = a;
            this.K = this.l = !1;
            this.m = this.o = this.H = this.L = this.I = 0;
            this.G = 2;
            this.i = [];
            this.g = this.h = this.j = 0;
            this.F = this.C = !1;
            this.D = "white";
            this.A = "black";
            Dv(this);
        }
        function Dv(a) {
            a.i = [];
            for(var b = 0; b < 16; b++)a.i.push(Ev());
        }
        function Ev() {
            for(var a = [], b = 0; b < 42; b++)a.push(null);
            return a;
        }
        function Fv(a, b) {
            Gv(a) && (a.i[a.h][a.g] = new kv(b, a.F, a.C, a.A, a.D), a.g++);
        }
        function Gv(a) {
            var b = a.g < a.m && a.g >= 0;
            return a.h < a.o && a.h >= 0 && b;
        }
        Cv.prototype.isVisible = function() {
            return this.l;
        };
        function Hv(a) {
            for(var b = 0, c = 1; c < 16; c++, b++)a.i[b] = a.i[c];
            for(c = 0; c < 1; c++, b++)a.i[b] = Ev();
        }
        function Iv(a, b, c) {
            var d = new Ie(a.j, b, "");
            d.textAlign = a.G === 0 ? "left" : a.G === 1 ? "right" : Ke;
            var e = d.region;
            a.J && (e.id += "svc" + a.J);
            e.id += "win" + a.M;
            e.height = a.o;
            e.width = a.m;
            e.heightUnits = 2;
            e.widthUnits = 2;
            e.viewportAnchorX = a.I;
            e.viewportAnchorY = a.L;
            e.viewportAnchorUnits = a.K ? Nd : 2;
            switch(a.H){
                case 0:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 0;
                    break;
                case 1:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 0;
                    break;
                case 2:
                    e.regionAnchorX = 100;
                    e.regionAnchorY = 0;
                    break;
                case 3:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 50;
                    break;
                case 4:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 50;
                    break;
                case 5:
                    e.regionAnchorX = 100;
                    e.regionAnchorY = 50;
                    break;
                case 6:
                    e.regionAnchorX = 0;
                    e.regionAnchorY = 100;
                    break;
                case 7:
                    e.regionAnchorX = 50;
                    e.regionAnchorY = 100;
                    break;
                case 8:
                    e.regionAnchorX = 100, e.regionAnchorY = 100;
            }
            if (c = hv(d, "svc" + c, a.i, a.j, b)) a.j = b;
            return c;
        }
        Cv.prototype.display = function() {
            this.l = !0;
        };
        function Jv() {
            this.i = [];
            this.h = null;
            this.g = 0;
        }
        function Kv(a, b) {
            b.type === 3 ? (a.g = (b.value & 63) * 2 - 1, a.h = []) : a.h && (a.g > 0 && (a.h.push(b), a.g--), a.g === 0 && (a.i.push(new Lv(a.h)), a.h = null, a.g = 0));
        }
        function Lv(a) {
            this.g = 0;
            this.h = a;
        }
        Lv.prototype.Sa = function() {
            return this.g < this.h.length;
        };
        Lv.prototype.Xa = function() {
            return this.g;
        };
        function Mv(a) {
            if (!a.Sa()) throw new T(2, 2, 3E3);
            return a.h[a.g++];
        }
        Lv.prototype.skip = function(a) {
            if (this.g + a > this.h.length) throw new T(2, 2, 3E3);
            this.g += a;
        };
        Lv.prototype.Fj = function(a) {
            if (this.g - a < 0) throw new T(2, 2, 3E3);
            this.g -= a;
        };
        function Nv(a) {
            this.i = a;
            this.h = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
            this.g = null;
        }
        function Ov(a, b, c, d) {
            if (!a.g) return [];
            if (c == 24) return c = Mv(b).value, d = Mv(b).value, c = function(f) {
                return f.map(function(g) {
                    return ("0" + (g & 255).toString(16)).slice(-2);
                }).join("");
            }([
                c,
                d
            ]), Fv(a.g, String.fromCharCode(parseInt(c, 16))), [];
            b = a.g;
            var e = null;
            switch(c){
                case 8:
                    !Gv(b) || b.g <= 0 && b.h <= 0 || (b.g <= 0 ? (b.g = b.m - 1, b.h--) : b.g--, b.i[b.h][b.g] = null);
                    break;
                case 13:
                    b.isVisible() && (e = Iv(b, d, a.i));
                    b.h + 1 >= b.o ? Hv(b) : b.h++;
                    b.g = 0;
                    break;
                case 14:
                    b.isVisible() && (e = Iv(b, d, a.i));
                    b.i[b.h] = Ev();
                    b.g = 0;
                    break;
                case 12:
                    b.isVisible() && (e = Iv(b, d, a.i)), Dv(b), b.h = 0, b.g = 0;
            }
            return e ? [
                e
            ] : [];
        }
        function Pv(a, b, c, d) {
            if (c >= 128 && c <= 135) d = c & 7, a.h[d] && (a.g = a.h[d]);
            else {
                if (c === 136) {
                    c = Mv(b).value;
                    b = [];
                    c = u(Qv(a, c));
                    for(var e = c.next(); !e.done; e = c.next()){
                        e = a.h[e.value];
                        if (e.isVisible()) {
                            var f = Iv(e, d, a.i);
                            f && b.push(f);
                        }
                        Dv(e);
                    }
                    return b;
                }
                if (c === 137) for(b = Mv(b).value, b = u(Qv(a, b)), c = b.next(); !c.done; c = b.next())c = a.h[c.value], c.isVisible() || (c.j = d), c.display();
                else {
                    if (c === 138) {
                        c = Mv(b).value;
                        b = null;
                        c = u(Qv(a, c));
                        for(e = c.next(); !e.done; e = c.next())e = a.h[e.value], e.isVisible() && (b = Iv(e, d, a.i)), e.l = !1;
                        return b ? [
                            b
                        ] : [];
                    }
                    if (c === 139) {
                        c = Mv(b).value;
                        b = null;
                        c = u(Qv(a, c));
                        for(e = c.next(); !e.done; e = c.next())e = a.h[e.value], e.isVisible() ? b = Iv(e, d, a.i) : e.j = d, e.l = !e.l;
                        return b ? [
                            b
                        ] : [];
                    }
                    if (c === 140) return b = Mv(b).value, Rv(a, b, d);
                    if (c === 143) return d = Rv(a, 255, d), Sv(a), d;
                    if (c === 144) b.skip(1), d = Mv(b).value, a.g && (a.g.C = (d & 128) > 0, a.g.F = (d & 64) > 0);
                    else if (c === 145) d = Mv(b).value, c = Mv(b).value, b.skip(1), a.g && (b = Tv((c & 48) >> 4, (c & 12) >> 2, c & 3), a.g.D = Tv((d & 48) >> 4, (d & 12) >> 2, d & 3), a.g.A = b);
                    else if (c === 146) d = Mv(b).value, b = Mv(b).value, a.g && (a = a.g, a.h = d & 15, a.g = b & 63);
                    else if (c === 151) b.skip(1), b.skip(1), d = Mv(b).value, b.skip(1), a.g && (a.g.G = d & 3);
                    else if (c >= 152 && c <= 159) {
                        c = (c & 15) - 8;
                        e = a.h[c] !== null;
                        e || (f = new Cv(c, a.i), f.j = d, a.h[c] = f);
                        d = Mv(b).value;
                        f = Mv(b).value;
                        var g = Mv(b).value, h = Mv(b).value, k = Mv(b).value;
                        b = Mv(b).value;
                        e && (b & 7) === 0 || (b = a.h[c], b.h = 0, b.g = 0, b.F = !1, b.C = !1, b.D = "white", b.A = "black");
                        b = a.h[c];
                        b.l = (d & 32) > 0;
                        b.L = f & 127;
                        b.I = g;
                        b.H = (h & 240) >> 4;
                        b.K = (f & 128) > 0;
                        b.o = (h & 15) + 1;
                        b.m = (k & 63) + 1;
                        a.g = a.h[c];
                    }
                }
            }
            return [];
        }
        function Qv(a, b) {
            for(var c = [], d = 0; d < 8; d++)(b & 1) === 1 && a.h[d] && c.push(d), b >>= 1;
            return c;
        }
        function Rv(a, b, c) {
            var d = [];
            b = u(Qv(a, b));
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = a.h[e];
                f.isVisible() && (f = Iv(f, c, a.i)) && d.push(f);
                a.h[e] = null;
            }
            return d;
        }
        function Sv(a) {
            a.g = null;
            a.h = [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null
            ];
        }
        function Tv(a, b, c) {
            var d = {
                0: 0,
                1: 0,
                2: 1,
                3: 1
            };
            a = d[a];
            b = d[b];
            c = d[c];
            return Uv[a << 2 | b << 1 | c];
        }
        var Vv = new Map([
            [
                32,
                " "
            ],
            [
                33,
                "\u00a0"
            ],
            [
                37,
                "\u2026"
            ],
            [
                42,
                "\u0160"
            ],
            [
                44,
                "\u0152"
            ],
            [
                48,
                "\u2588"
            ],
            [
                49,
                "\u2018"
            ],
            [
                50,
                "\u2019"
            ],
            [
                51,
                "\u201c"
            ],
            [
                52,
                "\u201d"
            ],
            [
                53,
                "\u2022"
            ],
            [
                57,
                "\u2122"
            ],
            [
                58,
                "\u0161"
            ],
            [
                60,
                "\u0153"
            ],
            [
                61,
                "\u2120"
            ],
            [
                63,
                "\u0178"
            ],
            [
                118,
                "\u215b"
            ],
            [
                119,
                "\u215c"
            ],
            [
                120,
                "\u215d"
            ],
            [
                121,
                "\u215e"
            ],
            [
                122,
                "\u2502"
            ],
            [
                123,
                "\u2510"
            ],
            [
                124,
                "\u2514"
            ],
            [
                125,
                "\u2500"
            ],
            [
                126,
                "\u2518"
            ],
            [
                127,
                "\u250c"
            ]
        ]), Uv = "black blue green cyan red magenta yellow white".split(" ");
        function Wv() {
            this.h = [];
            this.g = [];
            this.i = new Jv;
            this.l = 0;
            this.m = new Map([
                [
                    "CC1",
                    new wv(0, 0)
                ],
                [
                    "CC2",
                    new wv(0, 1)
                ],
                [
                    "CC3",
                    new wv(1, 0)
                ],
                [
                    "CC4",
                    new wv(1, 1)
                ]
            ]);
            this.A = this.o = 0;
            this.j = new Map;
            this.D = !0;
            this.C = new Set;
            Xv(this);
        }
        Wv.prototype.clear = function() {
            this.l = 0;
            this.h = [];
            this.g = [];
            var a = this.i;
            a.i = [];
            a.h = [];
            a.g = 0;
            Xv(this);
            a = u(this.j.values());
            for(var b = a.next(); !b.done; b = a.next())Sv(b.value);
        };
        function Xv(a) {
            a.o = 0;
            a.A = 0;
            for(var b = u(a.m.values()), c = b.next(); !c.done; c = b.next())c = c.value, c.h = 0, c.g = c.j, c.m = null, mv(c.i), mv(c.j), mv(c.o);
            a.D = !0;
        }
        Wv.prototype.extract = function(a, b) {
            if (this.D) {
                for(var c = u(this.m.values()), d = c.next(); !d.done; d = c.next())d.value.l = b;
                this.D = !1;
            }
            a = new yh(a, 0);
            if (!(a.getLength() < 8) && a.ea() === 181 && a.Ka() === 49 && a.Y() === 1195456820 && a.ea() === 3 && (c = a.ea(), (c & 64) !== 0)) for(c &= 31, a.skip(1), d = 0; d < c; d++){
                var e = a.ea(), f = (e & 4) >> 2, g = a.ea(), h = a.ea();
                f && (e &= 3, e === 0 || e === 1 ? this.h.push({
                    pts: b,
                    type: e,
                    Db: g,
                    uc: h,
                    order: this.h.length
                }) : (this.g.push({
                    pts: b,
                    type: e,
                    value: g,
                    order: this.g.length
                }), this.g.push({
                    pts: b,
                    type: 2,
                    value: h,
                    order: this.g.length
                })));
            }
        };
        Wv.prototype.decode = function() {
            function a(e, f) {
                return e.pts - f.pts || e.order - f.order;
            }
            var b = [];
            this.h.sort(a);
            this.g.sort(a);
            for(var c = u(this.h), d = c.next(); !d.done; d = c.next())(d = Yv(this, d.value)) && b.push(d);
            c = u(this.g);
            for(d = c.next(); !d.done; d = c.next())Kv(this.i, d.value);
            c = u(this.i.i);
            for(d = c.next(); !d.done; d = c.next())d = Zv(this, d.value), b.push.apply(b, G(d));
            this.i.i = [];
            this.h = [];
            this.g = [];
            return b;
        };
        function Yv(a, b) {
            var c = b.type;
            if ((b.Db & 112) === 16) {
                var d = b.Db >> 3 & 1;
                c === 0 ? a.o = d : a.A = d;
            }
            d = "CC" + ((c << 1 | (c ? a.A : a.o)) + 1);
            c = a.m.get(d);
            if (b.Db === 255 && b.uc === 255 || !b.Db && !b.uc || !$v(b.Db) || !$v(b.uc)) return ++a.l >= 45 && Xv(a), null;
            a.l = 0;
            b.Db &= 127;
            b.uc &= 127;
            var e = b.Db;
            if (e >= 1 && e <= 15 || !b.Db && !b.uc) return null;
            e = null;
            if ((b.Db & 112) === 16) a: {
                a.C.add(d), d = b.Db;
                a = b.uc;
                if (c.m === (d << 8 | a)) c.m = null;
                else if (c.m = d << 8 | a, (d & 240) === 16 && (a & 192) === 64) {
                    b = [
                        11,
                        11,
                        1,
                        2,
                        3,
                        4,
                        12,
                        13,
                        14,
                        15,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ][(d & 7) << 1 | a >> 5 & 1];
                    d = "white";
                    e = !1;
                    var f = null;
                    var g = a > 95 ? a - 96 : a - 64;
                    g <= 13 ? d = Bv[Math.floor(g / 2)] : g <= 15 ? e = !0 : f = Math.floor((g - 16) / 2);
                    a = (a & 1) === 1;
                    c.h !== 4 && (g = c.g, c.h === 3 && b !== g.g && (c = 1 + b - g.h, vv(g, c, 1 + g.g - g.h, g.h), pv(g, 0, c - 1), pv(g, b + 1, 15 - b)), g.g = b, g.m = a, g.j = e, g.l = d, g.A = f, g.o = "black");
                } else if ((d & 247) === 17 && (a & 240) === 32) c.g.m = !1, c.g.j = !1, c.g.l = "white", qv(c.g, 0, 32), d = !1, b = Bv[(a & 14) >> 1], b === "white_italics" && (b = "white", d = !0), c.g.m = (a & 1) === 1, c.g.j = d, c.g.l = b;
                else if ((d & 247) === 16 && (a & 240) === 32 || (d & 247) === 23 && (a & 255) === 45) b = "black", (d & 7) === 0 && (b = Av[(a & 14) >> 1]), c.g.o = b;
                else if ((d & 247) === 17 && (a & 240) === 48) qv(c.g, 1, a);
                else if ((d & 246) === 18 && (a & 224) === 32) qv(c.g, d & 1 ? 3 : 2, a);
                else {
                    if ((d & 246) === 20 && (a & 240) === 32) {
                        a = b.pts;
                        d = null;
                        switch(b.uc){
                            case 32:
                                yv(c);
                                break;
                            case 33:
                                c = c.g;
                                c.i[c.g].pop();
                                break;
                            case 37:
                                d = xv(c, 2, a);
                                break;
                            case 38:
                                d = xv(c, 3, a);
                                break;
                            case 39:
                                d = xv(c, 4, a);
                                break;
                            case 40:
                                qv(c.g, 0, 32);
                                break;
                            case 41:
                                c.h = 2;
                                c.g = c.i;
                                c.g.h = 0;
                                c.l = a;
                                break;
                            case 42:
                                mv(c.o);
                                zv(c);
                                break;
                            case 43:
                                zv(c);
                                break;
                            case 44:
                                b = c.i;
                                d = null;
                                c.h !== 4 && (d = nv(b, c.l, a));
                                pv(b, 0, 15);
                                break;
                            case 45:
                                b = c.g;
                                c.h !== 3 ? d = null : (d = nv(b, c.l, a), e = b.g - b.h + 1, vv(b, e - 1, e, b.h), pv(b, 0, e - 1), pv(b, b.g, 15 - b.g), c.l = a);
                                break;
                            case 46:
                                pv(c.j, 0, 15);
                                break;
                            case 47:
                                b = null, c.h !== 4 && (b = nv(c.i, c.l, a)), d = c.j, c.j = c.i, c.i = d, yv(c), c.l = a, d = b;
                        }
                        e = d;
                        break a;
                    }
                    (d == 23 || d == 31) && a >= 33 && a <= 35 && (c.g.C = a - 32);
                }
                e = null;
            }
            else a = b.uc, qv(c.g, 0, b.Db), qv(c.g, 0, a);
            return e;
        }
        function Zv(a, b) {
            var c = [];
            try {
                for(; b.Sa();){
                    var d = Mv(b).value, e = (d & 224) >> 5, f = d & 31;
                    e === 7 && f != 0 && (e = Mv(b).value & 63);
                    if (e != 0) {
                        a.C.add("svc" + e);
                        a.j.has(e) || a.j.set(e, new Nv(e));
                        for(var g = a.j.get(e), h = b.Xa(); b.Xa() - h < f;){
                            e = g;
                            var k = b, l = Mv(k), m = l.value, n = l.pts;
                            if (m === 16) {
                                var q = Mv(k);
                                m = m << 16 | q.value;
                            }
                            if (m >= 0 && m <= 31) var r = Ov(e, k, m, n);
                            else if (m >= 128 && m <= 159) r = Pv(e, k, m, n);
                            else {
                                if (m >= 4096 && m <= 4127) e = k, k = m & 255, k >= 8 && k <= 15 ? e.skip(1) : k >= 16 && k <= 23 ? e.skip(2) : k >= 24 && k <= 31 && e.skip(3);
                                else if (m >= 4224 && m <= 4255) e = k, k = m & 255, k >= 128 && k <= 135 ? e.skip(4) : k >= 136 && k <= 143 && e.skip(5);
                                else if (m >= 32 && m <= 127) k = m, e.g && (k === 127 ? Fv(e.g, "\u266a") : Fv(e.g, String.fromCharCode(k)));
                                else if (m >= 160 && m <= 255) e.g && Fv(e.g, String.fromCharCode(m));
                                else if (m >= 4128 && m <= 4223) {
                                    if (k = m & 255, e.g) {
                                        if (Vv.has(k)) {
                                            var t = Vv.get(k);
                                            Fv(e.g, t);
                                        } else Fv(e.g, "_");
                                    }
                                } else m >= 4256 && m <= 4351 && e.g && ((m & 255) != 160 ? Fv(e.g, "_") : Fv(e.g, "[CC]"));
                                r = [];
                            }
                            c.push.apply(c, G(r));
                        }
                    }
                }
            } catch (v) {
                if (v instanceof T && v.code === 3E3) $a("CEA708_INVALID_DATA", "Buffer read out of bounds / invalid CEA-708 Data.");
                else throw v;
            }
            return c;
        }
        function $v(a) {
            for(var b = 0; a;)b ^= a & 1, a >>= 1;
            return b === 1;
        }
        Wv.prototype.getStreams = function() {
            return Array.from(this.C);
        };
        O("shaka.cea.CeaDecoder", Wv);
        Id = function() {
            return new Wv;
        };
        function aw(a) {
            for(var b = [], c = a, d = a = 0; d < c.length;)a == 2 && c[d] == 3 ? (a = 0, c = [].concat(G(c)), c.splice(d, 1), c = new Uint8Array(c)) : c[d] == 0 ? a++ : a = 0, d++;
            a = c;
            for(d = 0; d < a.length;){
                for(c = 0; a[d] == 255;)c += 255, d++;
                c += a[d++];
                for(var e = 0; a[d] == 255;)e += 255, d++;
                e += a[d++];
                c == 4 && b.push(a.subarray(d, d + e));
                d += e;
            }
            return b;
        }
        function bw() {
            this.j = new Map;
            this.i = this.h = 0;
            this.g = cw;
        }
        bw.prototype.init = function(a) {
            var b = this, c = [], d = [];
            (new Bh).boxes("moov trak mdia minf stbl mvex".split(" "), Gh).qa("trex", function(e) {
                var f = e.reader;
                f.skip(4);
                f.skip(4);
                e = f.Y();
                f = f.Y();
                b.h = e;
                b.i = f;
            }).qa("tkhd", function(e) {
                var f = e.reader;
                e = e.version;
                e == 1 ? (f.skip(8), f.skip(8)) : (f.skip(4), f.skip(4));
                var g = f.Y();
                e == 1 ? f.skip(8) : f.skip(4);
                f.skip(4);
                f.skip(8);
                f.skip(2);
                f.skip(2);
                f.skip(2);
                f.skip(2);
                f.skip(36);
                f.Ka();
                f.Ka();
                f.Ka();
                f.Ka();
                c.push(g);
            }).qa("mdhd", function(e) {
                e = Xi(e.reader, e.version);
                d.push(e.timescale);
            }).qa("stsd", Ih).boxes("avc1 avc3 dvav dva1 hev1 hvc1 dvh1 dvhe vvc1 vvi1 dvc1 dvi1".split(" "), function(e) {
                e = e.name;
                dw.has(e) && (b.g = dw.get(e));
            }).box("encv", Jh).box("sinf", Gh).box("frma", function(e) {
                e = $i(e.reader).codec;
                dw.has(e) && (b.g = dw.get(e));
            }).parse(a, !0, !0);
            if (!c.length || !d.length || c.length != d.length) throw new T(2, 2, 2010);
            this.g == cw && Za("Unable to determine bitstream format for CEA parsing!");
            c.forEach(function(e, f) {
                b.j.set(e, d[f]);
            });
        };
        bw.prototype.parse = function(a) {
            var b = this;
            if (this.g == cw) return [];
            var c = [], d = 0, e = [];
            (new Bh).box("moof", function(f) {
                d = f.start;
                e = [];
                Gh(f);
            }).box("traf", function(f) {
                e.push({
                    baseMediaDecodeTime: null,
                    ke: b.h,
                    le: b.i,
                    xj: [],
                    timescale: 9E4
                });
                Gh(f);
            }).qa("trun", function(f) {
                var g = e[e.length - 1];
                f = Yi(f.reader, f.version, f.flags);
                g.xj.push(f);
            }).qa("tfhd", function(f) {
                var g = e[e.length - 1];
                f = Vi(f.reader, f.flags);
                g.ke = f.ke || b.h;
                g.le = f.le || b.i;
                f = f.trackId;
                b.j.has(f) && (g.timescale = b.j.get(f));
            }).qa("tfdt", function(f) {
                var g = e[e.length - 1];
                f = Wi(f.reader, f.version);
                g.baseMediaDecodeTime = f.baseMediaDecodeTime;
            }).box("mdat", function(f) {
                for(var g = d - f.start - 8, h = f.reader.Xa(), k = u(e), l = k.next(); !l.done; l = k.next())l = l.value, l.baseMediaDecodeTime === null ? Za("Unable to find base media decode time for CEA captions!") : (f.reader.seek(h), ew(b, f.reader, l.baseMediaDecodeTime, l.timescale, l.ke, l.le, g, l.xj, c));
            }).parse(a, !1, !0);
            return c;
        };
        function ew(a, b, c, d, e, f, g, h, k) {
            var l = 0, m = f, n = h.map(function(t) {
                return t.ci;
            });
            n = [].concat.apply([], G(n));
            n.length && (m = n[0].sampleSize || f);
            for(b.skip(g + h[0].Ug); b.Sa();){
                g = b.Y();
                var q = b.ea(), r = null;
                r = !1;
                h = 1;
                switch(a.g){
                    case fw:
                        r = q & 31;
                        r = r == 6;
                        break;
                    case gw:
                        h = 2;
                        b.skip(1);
                        r = q >> 1 & 63;
                        r = r == 39 || r == 40;
                        break;
                    case hw:
                        h = 2;
                        b.skip(1);
                        r = q >> 1 & 63;
                        r = r == 23 || r == 24;
                        break;
                    default:
                        return;
                }
                if (r) for(q = 0, l < n.length && (q = n[l].dg || 0), q = (c + q) / d, h = b.Wb(g - h, !1), h = u(aw(h)), r = h.next(); !r.done; r = h.next())k.push({
                    packet: r.value,
                    pts: q
                });
                else try {
                    b.skip(g - h);
                } catch (t) {
                    break;
                }
                m -= g + 4;
                m == 0 && (c = l < n.length ? c + (n[l].di || e) : c + e, l++, l < n.length ? m = n[l].sampleSize || f : m = f);
            }
        }
        O("shaka.cea.Mp4CeaParser", bw);
        var cw = 0, fw = 1, gw = 2, hw = 3, dw = (new Map).set("avc1", fw).set("avc3", fw).set("dvav", fw).set("dva1", fw).set("hev1", gw).set("hvc1", gw).set("dvh1", gw).set("dvhe", gw).set("vvc1", hw).set("vvi1", hw).set("dvc1", hw).set("dvi1", hw);
        Kd("video/mp4", function() {
            return new bw;
        });
        function iw() {
            this.g = null;
        }
        iw.prototype.init = function() {};
        iw.prototype.parse = function(a) {
            this.g ? this.g.clearData() : this.g = new Ek;
            var b = [];
            a = Fb(a);
            if (!Rk(a)) return b;
            a = this.g.parse(a);
            var c = a.me(), d = a.yf();
            a = [];
            switch(c.video){
                case "avc":
                    a.push(6);
                    break;
                case "hvc":
                    a.push(39), a.push(40);
            }
            if (!a.length) return b;
            c = u(d);
            for(d = c.next(); !d.done; d = c.next())if (d = d.value, a.includes(d.type) && d.time != null) for(var e = u(aw(d.data)), f = e.next(); !f.done; f = e.next())b.push({
                packet: f.value,
                pts: d.time
            });
            return b;
        };
        O("shaka.cea.TsCeaParser", iw);
        Kd("video/mp2t", function() {
            return new iw;
        });
        function jw(a) {
            var b = 0, c = Jb(a), d = c.getUint32(b, !0);
            if (d != a.byteLength) return [];
            a: {
                a = b + 4 + 2;
                for(b = []; a < c.byteLength - 1;){
                    d = c.getUint16(a, !0);
                    a += 2;
                    var e = c.getUint16(a, !0);
                    a += 2;
                    if ((e & 1) != 0 || e + a > c.byteLength) {
                        c = [];
                        break a;
                    }
                    var f = Fb(c, a, e);
                    b.push({
                        type: d,
                        value: f
                    });
                    a += e;
                }
                c = b;
            }
            return c;
        }
        function kw(a) {
            a = qc(ke(a));
            a = jw(a).filter(function(b) {
                return b.type === lw;
            })[0];
            if (!a) return null;
            a = cc(a.value, !0);
            return (a = ae(a, "WRMHEADER")) ? a : null;
        }
        function mw(a) {
            try {
                var b = kw(a);
                if (b) a: {
                    for(var c = u(me(b, "DATA")), d = c.next(); !d.done; d = c.next()){
                        var e = d.value;
                        if (e.children) for(var f = u(e.children), g = f.next(); !g.done; g = f.next()){
                            var h = g.value;
                            if (h.tagName == "LA_URL") {
                                var k = ke(h);
                                break a;
                            }
                        }
                    }
                    k = "";
                }
                else k = "";
                return k;
            } catch (l) {
                return "";
            }
        }
        var lw = 1;
        function nw() {
            this.g = new Map;
        }
        nw.prototype.release = function() {
            this.g.clear();
        };
        function ow(a, b, c, d) {
            var e = pw(a, b), f = null;
            a = [];
            var g = [];
            b = null;
            var h = new Set(e.map(function(l) {
                return l.keyId;
            }));
            h.delete(null);
            var k = "cenc";
            if (h.size > 1) throw new T(2, 4, 4010);
            if (!c) {
                g = e.filter(function(l) {
                    return l.Ud == "urn:mpeg:dash:sea:2012";
                });
                if (g.length > 1) throw new T(2, 4, 4050);
                g.length && (b = qw(g[0]));
                (g = e.find(function(l) {
                    return l.Ud == "urn:mpeg:dash:mp4protection:2011";
                })) && g.encryptionScheme && (k = g.encryptionScheme);
                g = e.filter(function(l) {
                    return l.Ud == "urn:mpeg:dash:mp4protection:2011" ? (f = l.init || f, !1) : l.Ud != "urn:mpeg:dash:sea:2012";
                });
                g.length && (a = rw(f, k, g, d, h), a.length == 0 && (a = [
                    yc("", k, f)
                ]));
            }
            if (e.length && !b && (c || !g.length)) for(a = [], c = u(Object.values(d)), d = c.next(); !d.done; d = c.next())d = d.value, Ob(d) || (d = yc(d, k, f), a.push(d));
            if (h = Array.from(h)[0] || null) for(k = u(a), c = k.next(); !c.done; c = k.next())for(c = u(c.value.initData), d = c.next(); !d.done; d = c.next())d.value.keyId = h;
            return {
                Ti: h,
                Tn: f,
                drmInfos: a,
                Hg: b,
                Yi: !0
            };
        }
        function sw(a, b, c, d, e) {
            var f = ow(a, b, d, e);
            if (c.Yi) {
                a = c.drmInfos.length == 1 && !c.drmInfos[0].keySystem;
                b = f.drmInfos.length == 0;
                if (c.drmInfos.length == 0 || a && !b) c.drmInfos = f.drmInfos;
                c.Yi = !1;
            } else if (f.drmInfos.length > 0 && (c.drmInfos = c.drmInfos.filter(function(g) {
                return f.drmInfos.some(function(h) {
                    return h.keySystem == g.keySystem;
                });
            }), c.drmInfos.length == 0)) throw new T(2, 4, 4008);
            return f.Ti || c.Ti;
        }
        function tw(a) {
            var b = oe(a.node, "https://dashif.org/CPS", "Laurl");
            if (b && (b = ke(b))) return b;
            if ((b = oe(a.node, "urn:microsoft:playready", "pro")) && ke(b)) return mw(b);
            if (a = oe(a.node, "urn:mpeg:cenc:2013", "pssh")) {
                if (a = ke(a)) {
                    b = qc(a);
                    a = 8;
                    b = Jb(b);
                    var c = b.getUint8(a);
                    a += 20;
                    c > 0 && (a += 4 + 16 * b.getUint32(a));
                    a = Fb(b, a + 4);
                    a = lc(a);
                    a = ae("<pro>" + a + "</pro>");
                    return mw(a);
                }
            }
            return "";
        }
        function rw(a, b, c, d, e) {
            var f = [];
            c = u(c);
            for(var g = c.next(); !g.done; g = c.next()){
                g = g.value;
                var h = d[g.Ud];
                if (h) {
                    var k;
                    if ((k = oe(g.node, "urn:microsoft:playready", "pro")) && ke(k)) {
                        k = ke(k);
                        k = qc(k);
                        var l = new Uint8Array([
                            154,
                            4,
                            240,
                            121,
                            152,
                            64,
                            66,
                            134,
                            171,
                            146,
                            230,
                            91,
                            224,
                            136,
                            95,
                            149
                        ]);
                        k = [
                            {
                                initData: Nh(k, l, new Set, 0),
                                initDataType: "cenc",
                                keyId: g.keyId
                            }
                        ];
                    } else k = null;
                    l = null;
                    if (g.Ud === "urn:uuid:e2719d58-a985-b3c9-781a-b030af78d30e") {
                        l = g;
                        var m = e;
                        if (m.size == 0) l = null;
                        else {
                            var n = new Uint8Array([
                                16,
                                119,
                                239,
                                236,
                                192,
                                178,
                                77,
                                2,
                                172,
                                227,
                                60,
                                30,
                                82,
                                226,
                                251,
                                75
                            ]), q = new Uint8Array([]);
                            l = [
                                {
                                    initData: Nh(q, n, m, 1),
                                    initDataType: "cenc",
                                    keyId: l.keyId
                                }
                            ];
                        }
                    }
                    k = yc(h, b, g.init || a || k || l);
                    if (h = uw.get(h)) k.licenseServerUri = h(g);
                    a: {
                        if (g = oe(g.node, "https://dashif.org/CPS", "Certurl")) {
                            if (g = ke(g)) break a;
                        }
                        g = "";
                    }
                    k.serverCertificateUri = g;
                    f.push(k);
                }
            }
            return f;
        }
        function pw(a, b) {
            var c = [];
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())(d = vw(a, d.value)) && c.push(d);
            return c;
        }
        function vw(a, b) {
            var c = b.attributes.schemeIdUri, d = re(b, "urn:mpeg:cenc:2013", "default_KID"), e = pe(b, "urn:mpeg:cenc:2013", "pssh").map(le), f = b.attributes.value;
            if (!c) return null;
            c = c.toLowerCase();
            if (d && (d = d.replace(/-/g, "").toLowerCase(), d.includes(" "))) throw new T(2, 4, 4009);
            var g = [];
            try {
                g = e.map(function(h) {
                    if (!a.g.has(h)) {
                        var k = qc(h);
                        a.g.set(h, k);
                    }
                    return {
                        initDataType: "cenc",
                        initData: a.g.get(h),
                        keyId: null
                    };
                });
            } catch (h) {
                throw new T(2, 4, 4007);
            }
            return {
                node: b,
                Ud: c,
                keyId: d,
                init: g.length > 0 ? g : null,
                encryptionScheme: f
            };
        }
        function qw(a) {
            if (!window1.crypto || !window1.crypto.subtle) throw Za("Web Crypto API is not available to decrypt AES-128. (Web Crypto only exists in secure origins like https)"), new T(2, 4, 4042);
            var b = oe(a.node, "urn:mpeg:dash:schema:sea:2012", "SegmentEncryption");
            if (!b) throw new T(2, 4, 4051);
            if (b.attributes.schemeIdUri != "urn:mpeg:dash:sea:aes128-cbc:2013") throw new T(2, 4, 4051);
            b = oe(a.node, "urn:mpeg:dash:schema:sea:2012", "CryptoPeriod");
            if (!b) throw new T(2, 4, 4051);
            a = b.attributes.IV;
            b = jc(b.attributes.keyUriTemplate);
            if (!a || !b) throw new T(2, 4, 4051);
            a = rc(a.substr(2));
            if (a.byteLength != 16) throw new T(2, 4, 4048);
            return {
                Ll: b,
                iv: a
            };
        }
        var uw = (new Map).set("com.apple.fps", function(a) {
            if ("apple" === window1.shakaMediaKeysPolyfill) throw new T(2, 4, 4054);
            if (a = oe(a.node, "https://dashif.org/CPS", "Laurl")) {
                if (a = ke(a)) return a;
            }
            return "";
        }).set("com.widevine.alpha", function(a) {
            var b = oe(a.node, "https://dashif.org/CPS", "Laurl");
            return b && (b = ke(b)) ? b : (a = oe(a.node, "urn:microsoft", "laurl")) ? jc(a.attributes.licenseUrl) || "" : "";
        }).set("com.microsoft.playready", tw).set("com.microsoft.playready.recommendation", tw).set("com.microsoft.playready.software", tw).set("com.microsoft.playready.hardware", tw).set("org.w3.clearkey", function(a) {
            var b = oe(a.node, "https://dashif.org/CPS", "Laurl");
            return b && (b = ke(b)) ? b : (a = oe(a.node, "http://dashif.org/guidelines/clearKey", "Laurl")) && a.attributes.Lic_type === "EME-1.0" && a && (a = ke(a)) ? a : "";
        });
        function ww(a, b, c, d, e, f) {
            var g = (new Map).set("RepresentationID", b).set("Number", c).set("SubNumber", d).set("Bandwidth", e).set("Time", f);
            return a.replace(/\$(RepresentationID|Number|SubNumber|Bandwidth|Time)?(?:%0([0-9]+)([diouxX]))?\$/g, function(h, k, l, m) {
                if (h == "$$") return "$";
                var n = g.get(k);
                if (n == null) return h;
                k == "RepresentationID" && l && (l = void 0);
                k == "Time" && typeof n != "bigint" && (Math.abs(n - Math.round(n)) >= .2 && Za("Calculated $Time$ values must be close to integers"), n = Math.round(n));
                switch(m){
                    case void 0:
                    case "d":
                    case "i":
                    case "u":
                        h = n.toString();
                        break;
                    case "o":
                        h = n.toString(8);
                        break;
                    case "x":
                        h = n.toString(16);
                        break;
                    case "X":
                        h = n.toString(16).toUpperCase();
                        break;
                    default:
                        h = n.toString();
                }
                l = window1.parseInt(l, 10) || 1;
                return Array(Math.max(0, l - h.length) + 1).join("0") + h;
            });
        }
        function xw(a, b) {
            var c = yw(a, b, "timescale"), d = 1;
            c && (d = xe(c) || 1);
            c = yw(a, b, "duration");
            var e = (c = xe(c || "")) ? c / d : null, f = yw(a, b, "startNumber"), g = Number(yw(a, b, "presentationTimeOffset")) || 0, h = ye(f || "");
            if (f == null || h == null) h = 1;
            f = null;
            if (b = zw(a, b, "SegmentTimeline")) {
                b = ie(b, "S");
                f = d;
                a = a.sa.duration || Infinity;
                for(var k = h, l = [], m = -g, n = 0; n < b.length; ++n){
                    var q = b[n], r = b[n + 1], t = qe(q, "t", ye), v = qe(q, "d", ye), w = qe(q, "r", we);
                    q = qe(q, "k", we) || 0;
                    t != null && (t -= g);
                    if (v) {
                        t = t != null ? t : m;
                        w = w || 0;
                        if (w < 0) {
                            if (r) {
                                r = qe(r, "t", ye);
                                if (r == null) break;
                                else if (t >= r) break;
                                w = Math.ceil((r - t) / v) - 1;
                            } else {
                                if (a == Infinity) break;
                                else if (t / f >= a) break;
                                w = Math.ceil((a * f - t) / v) - 1;
                            }
                        }
                        l.length > 0 && t != m && (l[l.length - 1].end = t / f);
                        for(r = 0; r <= w; ++r)m = t + v, l.push({
                            start: t / f,
                            $d: t,
                            end: m / f,
                            Bi: m,
                            Dc: q,
                            rm: l.length + k
                        }), t = m;
                    }
                }
                f = l;
            }
            return {
                timescale: d,
                qg: c,
                pb: e,
                Ie: h,
                kc: g / d || 0,
                qd: g,
                timeline: f
            };
        }
        function Aw(a, b) {
            return [
                b(a.N),
                b(a.za),
                b(a.Ea)
            ].filter(Zf);
        }
        function yw(a, b, c) {
            b = Aw(a, b);
            a = null;
            b = u(b);
            for(var d = b.next(); !d.done && !(a = d.value.attributes[c]); d = b.next());
            return a;
        }
        function zw(a, b, c) {
            b = Aw(a, b);
            a = null;
            b = u(b);
            for(var d = b.next(); !d.done && !(a = ne(d.value, c)); d = b.next());
            return a;
        }
        function Bw(a, b, c, d, e, f) {
            for(var g = re(a, "http://www.w3.org/1999/xlink", "href"), h = re(a, "http://www.w3.org/1999/xlink", "actuate") || "onRequest", k = u(Object.keys(a.attributes)), l = k.next(); !l.done; l = k.next()){
                l = l.value;
                var m = l.split(":"), n = ce("http://www.w3.org/1999/xlink");
                m[0] == n && delete a.attributes[l];
            }
            if (f >= 5) return $g(new T(2, 4, 4028));
            if (h != "onLoad") return $g(new T(2, 4, 4027));
            var q = vc([
                d
            ], [
                g
            ]);
            return e.request(0, mh(q, b)).eb(function(r) {
                r = $d(r.data, a.tagName);
                if (!r) return $g(new T(2, 4, 4001, g));
                for(a.children = []; r.children.length;){
                    var t = r.children.shift();
                    a.children.push(t);
                }
                t = u(Object.keys(r.attributes));
                for(var v = t.next(); !v.done; v = t.next())v = v.value, a.attributes[v] = r.attributes[v];
                return Cw(a, b, c, q[0], e, f + 1);
            });
        }
        function Cw(a, b, c, d, e, f) {
            f = f === void 0 ? 0 : f;
            if (re(a, "http://www.w3.org/1999/xlink", "href")) {
                var g = Bw(a, b, c, d, e, f);
                c && (g = g.eb(void 0, function() {
                    return Cw(a, b, c, d, e, f);
                }));
                return g;
            }
            g = [];
            for(var h = u(ge(a)), k = h.next(), l = {}; !k.done; l = {
                ge: void 0
            }, k = h.next())l.ge = k.value, re(l.ge, "http://www.w3.org/1999/xlink", "href") == "urn:mpeg:dash:resolve-to-zero:2013" ? a.children = a.children.filter(function(m) {
                return function(n) {
                    return n !== m.ge;
                };
            }(l)) : l.ge.tagName != "SegmentTimeline" && g.push(Cw(l.ge, b, c, d, e, f));
            return dh(g).eb(function() {
                return a;
            });
        }
        function Dw(a, b, c, d, e, f, g, h) {
            var k, l = (new Bh).qa("sidx", function(m) {
                k = Ew(b, d, e, f, g, c, m, h);
            });
            a && l.parse(a);
            if (k) return k;
            throw new T(2, 3, 3004);
        }
        function Ew(a, b, c, d, e, f, g, h) {
            h = h === void 0 ? !1 : h;
            var k = [];
            g.reader.skip(4);
            var l = g.reader.Y();
            if (l == 0) throw new T(2, 3, 3005);
            if (g.version == 0) {
                var m = g.reader.Y();
                var n = g.reader.Y();
            } else m = g.reader.Rd(), n = g.reader.Rd();
            g.reader.skip(2);
            var q = g.reader.Ka();
            a = (h ? -g.size : a) + g.size + n;
            for(h = 0; h < q; h++){
                var r = g.reader.Y();
                n = (r & 2147483648) >>> 31;
                r &= 2147483647;
                var t = g.reader.Y();
                g.reader.skip(4);
                if (n == 1) throw new T(2, 3, 3006);
                k.push(new Oj(m / l + c, (m + t) / l + c, function() {
                    return f;
                }, a, a + r - 1, b, c, d, e));
                m += t;
                a += r;
            }
            g.parser.stop();
            return k;
        }
        function Fw(a) {
            this.h = Jb(a);
            this.g = new yh(this.h, 0);
        }
        Fw.prototype.Sa = function() {
            return this.g.Sa();
        };
        function Gw(a) {
            var b = Hw(a);
            if (b.length > 7) throw new T(2, 3, 3002);
            var c = 0;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())c = 256 * c + d.value;
            b = Hw(a);
            a: {
                d = u(Iw);
                for(var e = d.next(); !e.done; e = d.next())if (Eb(b, new Uint8Array(e.value))) {
                    d = !0;
                    break a;
                }
                d = !1;
            }
            if (d) b = a.h.byteLength - a.g.Xa();
            else {
                if (b.length == 8 && b[1] & 224) throw new T(2, 3, 3001);
                for(e = d = 0; e < b.length; e++){
                    var f = b[e];
                    d = e == 0 ? f & (1 << 8 - b.length) - 1 : 256 * d + f;
                }
                b = d;
            }
            b = a.g.Xa() + b <= a.h.byteLength ? b : a.h.byteLength - a.g.Xa();
            d = Jb(a.h, a.g.Xa(), b);
            a.g.skip(b);
            return new Jw(c, d);
        }
        function Hw(a) {
            var b = a.g.Xa(), c = a.g.ea();
            if (c == 0) throw new T(2, 3, 3002);
            c = 8 - Math.floor(Math.log2(c));
            a.g.skip(c - 1);
            return Fb(a.h, b, c);
        }
        var Iw = [
            [
                255
            ],
            [
                127,
                255
            ],
            [
                63,
                255,
                255
            ],
            [
                31,
                255,
                255,
                255
            ],
            [
                15,
                255,
                255,
                255,
                255
            ],
            [
                7,
                255,
                255,
                255,
                255,
                255
            ],
            [
                3,
                255,
                255,
                255,
                255,
                255,
                255
            ],
            [
                1,
                255,
                255,
                255,
                255,
                255,
                255,
                255
            ]
        ];
        function Jw(a, b) {
            this.id = a;
            this.g = b;
        }
        function Kw(a) {
            if (a.g.byteLength > 8) throw new T(2, 3, 3002);
            if (a.g.byteLength == 8 && a.g.getUint8(0) & 224) throw new T(2, 3, 3001);
            for(var b = 0, c = 0; c < a.g.byteLength; c++){
                var d = a.g.getUint8(c);
                b = 256 * b + d;
            }
            return b;
        }
        function Lw(a, b, c, d, e, f, g) {
            b = new Fw(b);
            if (Gw(b).id != 440786851) throw new T(2, 3, 3008);
            var h = Gw(b);
            if (h.id != 408125543) throw new T(2, 3, 3009);
            b = h.g.byteOffset;
            h = new Fw(h.g);
            for(var k = null; h.Sa();){
                var l = Gw(h);
                if (l.id == 357149030) {
                    k = l;
                    break;
                }
            }
            if (!k) throw new T(2, 3, 3010);
            k = new Fw(k.g);
            l = 1E6;
            for(h = null; k.Sa();){
                var m = Gw(k);
                if (m.id == 2807729) l = Kw(m);
                else if (m.id == 17545) {
                    if (m.g.byteLength == 4) h = m.g.getFloat32(0);
                    else if (m.g.byteLength == 8) h = m.g.getFloat64(0);
                    else throw new T(2, 3, 3003);
                }
            }
            if (h == null) throw new T(2, 3, 3011);
            k = l / 1E9;
            h *= k;
            a = Gw(new Fw(a));
            if (a.id != 475249515) throw new T(2, 3, 3007);
            return Mw(a, b, k, h, c, d, e, f, g);
        }
        function Mw(a, b, c, d, e, f, g, h, k) {
            function l() {
                return e;
            }
            var m = [];
            a = new Fw(a.g);
            for(var n = null, q = null; a.Sa();){
                var r = Gw(a);
                if (r.id == 187) {
                    var t = Nw(r);
                    t && (r = c * t.Fm, t = b + t.gm, n != null && m.push(new Oj(n + g, r + g, l, q, t - 1, f, g, h, k)), n = r, q = t);
                }
            }
            n != null && m.push(new Oj(n + g, d + g, l, q, null, f, g, h, k));
            return m;
        }
        function Nw(a) {
            var b = new Fw(a.g);
            a = Gw(b);
            if (a.id != 179) throw new T(2, 3, 3013);
            a = Kw(a);
            b = Gw(b);
            if (b.id != 183) throw new T(2, 3, 3012);
            b = new Fw(b.g);
            for(var c = 0; b.Sa();){
                var d = Gw(b);
                if (d.id == 241) {
                    c = Kw(d);
                    break;
                }
            }
            return {
                Fm: a,
                gm: c
            };
        }
        function Ow(a, b, c) {
            b = zw(a, b, "Initialization");
            if (!b) return null;
            var d = a.N.ib(), e = b.attributes.sourceURL;
            e && (d = vc(d, [
                jc(e)
            ], a.Mb()));
            e = 0;
            var f = null;
            if (b = qe(b, "range", ve)) e = b.start, f = b.end;
            c = new Mj(function() {
                return d;
            }, e, f, Pw(a), null, null, c, a.za.encrypted);
            c.codecs = a.N.codecs;
            c.mimeType = a.N.mimeType;
            a.sa && !a.sa.Ff && (c.g = a.sa.start + a.sa.duration);
            return c;
        }
        function Qw(a, b, c) {
            var d = Number(yw(a, Rw, "presentationTimeOffset")) || 0, e = yw(a, Rw, "timescale"), f = 1;
            e && (f = xe(e) || 1);
            var g = d / f || 0, h = Ow(a, Rw, c);
            Sw(a, h);
            var k = Yd(a);
            return {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    var l = zw(k, Rw, "RepresentationIndex");
                    var m = k.N.ib();
                    l && (l = jc(l.attributes.sourceURL)) && (m = vc(m, [
                        l
                    ], k.Mb()));
                    l = Tw(k);
                    return Uw(k, b, h, m, l.start, l.end, g);
                },
                timescale: f
            };
        }
        function Uw(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F;
            return H(function(I) {
                if (I.h == 1) return h = a.presentationTimeline, k = !a.wb || !a.sa.Ff, l = a.sa.start, m = a.sa.duration, n = a.N.mimeType.split("/")[1], q = b, r = null, t = [
                    q(d, e, f, !1),
                    n == "webm" ? q(c.T(), c.startByte, c.endByte, !0) : null
                ], q = null, I.g(Promise.all(t), 2);
                v = I.i;
                w = v[0];
                x = v[1] || null;
                y = null;
                z = l - g;
                A = l;
                E = m ? l + m : Infinity;
                C = a.N.ib();
                D = C.length != d.length || C.some(function(K, N) {
                    return K != d[N];
                });
                y = n == "mp4" ? Dw(w, e, C, c, z, A, E, D) : Lw(w, x, C, c, z, A, E);
                B = u(y);
                for(J = B.next(); !J.done; J = B.next())F = J.value, F.codecs = a.N.codecs, F.mimeType = a.N.mimeType, F.bandwidth = a.bandwidth;
                h.Ae(y);
                r = new vm(y);
                k && r.zd(A, E, !0);
                return I.return(r);
            });
        }
        function Rw(a) {
            return a.Vd;
        }
        function Tw(a) {
            var b = zw(a, Rw, "RepresentationIndex");
            a = yw(a, Rw, "indexRange");
            a = ve(a || "");
            b && (a = qe(b, "range", ve, a));
            return a;
        }
        function Sw(a, b) {
            Vw(a, b);
            if (!Tw(a)) throw new T(2, 4, 4002);
        }
        function Vw(a, b) {
            var c = a.N.mimeType.split("/")[1];
            if (a.N.contentType != Ec && c != "mp4" && c != "webm") throw new T(2, 4, 4006);
            if (c == "webm" && !b) throw new T(2, 4, 4005);
        }
        function Pw(a) {
            var b = a.N;
            return {
                bandwidth: a.bandwidth,
                audioSamplingRate: b.audioSamplingRate,
                codecs: b.codecs,
                contentType: b.contentType,
                frameRate: b.frameRate || null,
                height: b.height || null,
                mimeType: b.mimeType,
                channelsCount: b.Tf,
                pixelAspectRatio: b.pixelAspectRatio || null,
                width: b.width || null,
                label: a.za.label || null,
                roles: a.roles || null,
                language: a.za.language || null
            };
        }
        function Ww(a, b, c) {
            var d = Ow(a, Xw, c), e = Yw(a);
            if (!e.pb && !e.timeline && e.Ld.length > 1) throw new T(2, 4, 4002);
            if (!e.pb && !a.sa.duration && !e.timeline && e.Ld.length == 1) throw new T(2, 4, 4002);
            if (e.timeline && e.timeline.length == 0) throw new T(2, 4, 4002);
            var f = null, g = null;
            a.Ea.id && a.N.id && (g = b.get(a.Ea.id + "," + a.N.id)) && (f = g.segmentIndex);
            var h = Zw(a.sa.start, a.sa.duration, a.N.ib, e, d, c, a.N.mimeType, a.N.codecs, a.bandwidth, a.Mb);
            b = !f;
            f ? f.ye(h, a.presentationTimeline.Hb()) : f = new vm(h);
            a.presentationTimeline.Ae(h);
            a.wb && a.sa.Ff || f.zd(a.sa.start, a.sa.duration ? a.sa.start + a.sa.duration : Infinity, b);
            g && (g.segmentIndex = f);
            return {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    f && f.getNumReferences() != 0 || f.Of(h);
                    return Promise.resolve(f);
                },
                timescale: e.timescale
            };
        }
        function Xw(a) {
            return a.Hc;
        }
        function Yw(a) {
            var b = $w(a);
            a = xw(a, Xw);
            var c = a.Ie;
            c == 0 && (c = 1);
            var d = 0;
            a.pb ? d = a.pb * (c - 1) : a.timeline && a.timeline.length > 0 && (d = a.timeline[0].start);
            return {
                pb: a.pb,
                startTime: d,
                Ie: c,
                kc: a.kc,
                timescale: a.timescale,
                timeline: a.timeline,
                Ld: b
            };
        }
        function Zw(a, b, c, d, e, f, g, h, k, l) {
            var m = d.Ld.length;
            d.timeline && d.timeline.length != d.Ld.length && (m = Math.min(d.timeline.length, d.Ld.length));
            for(var n = a - d.kc, q = b ? a + b : Infinity, r = [], t = d.startTime, v = {}, w = 0; w < m; v = {
                sg: void 0,
                eg: void 0
            }, w++){
                v.eg = d.Ld[w];
                var x = t;
                t = void 0;
                t = d.pb != null ? x + d.pb : d.timeline ? d.timeline[w].end : x + b;
                v.sg = null;
                v = new Oj(a + x, a + t, function(y) {
                    return function() {
                        y.sg == null && (y.sg = vc(c(), [
                            y.eg.Sl
                        ], l()));
                        return y.sg;
                    };
                }(v), v.eg.start, v.eg.end, e, n, a, q, [], "", null, null, Pj, f);
                v.codecs = h;
                v.mimeType = g;
                v.bandwidth = k;
                r.push(v);
            }
            return r;
        }
        function $w(a) {
            return [
                a.N.Hc,
                a.za.Hc,
                a.Ea.Hc
            ].filter(Zf).map(function(b) {
                return ie(b, "SegmentURL");
            }).reduce(function(b, c) {
                return b.length > 0 ? b : c;
            }).map(function(b) {
                b.attributes.indexRange && !a.Dh && (a.Dh = !0);
                var c = jc(b.attributes.media);
                b = qe(b, "mediaRange", ve, {
                    start: 0,
                    end: null
                });
                return {
                    Sl: c,
                    start: b.start,
                    end: b.end
                };
            });
        }
        function ax(a, b, c, d, e, f, g, h, k, l) {
            k || a.N.Bf || (a.N.Bf = yw(a, bx, "initialization"));
            var m = a.N.Bf ? cx(a, g) : null, n = dx(a);
            ex(n);
            var q = Yd(a);
            if (n.se) return Vw(a, m), {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    var x = ww(n.se, q.N.originalId, null, null, q.bandwidth || null, null);
                    x = vc(q.N.ib(), [
                        x
                    ]);
                    return Uw(q, b, m, x, 0, null, n.kc);
                },
                timescale: n.timescale
            };
            if (n.pb) return d || a.za.contentType === "image" || a.za.contentType === "text" || (d = a.sa.start, l = a.Ea.id, c = a.sa.duration, l = (l = l != null && f.get(l) || c) ? d + l : Infinity, a.presentationTimeline.Oh(n.pb), a.presentationTimeline.vj(d, l)), {
                endTime: -1,
                timeline: -1,
                cd: function() {
                    return fx(q, n, e, m, f, g, h, a.N.fg);
                },
                timescale: n.timescale
            };
            var r = null;
            d = d = null;
            a.Ea.id && a.N.id && (d = a.Ea.id + "," + a.N.id, d = c.get(d)) && (r = d.segmentIndex);
            var t = a.sa.start, v = a.sa.duration ? t + a.sa.duration : Infinity;
            if (r) l = r, gx(l, n, t, v, m, a.wb), l.$a(a.presentationTimeline.Hb());
            else {
                c = 0;
                k = -1;
                if (a.Ea.id != null && a.N.id != null) {
                    var w = l.get(a.Ea.id);
                    if (w) k = w.timeline;
                    else for(l = u(l.values()), w = l.next(); !w.done; w = l.next())if (w = w.value, Math.abs(n.kc - w.endTime) <= Hc && w.Yh.includes(a.N.id)) {
                        k = w.timeline;
                        break;
                    } else w.timeline >= c && (c = w.timeline + 1);
                }
                k == -1 && (k = c);
                r = new hx(a.wb, n, a.N.originalId, a.bandwidth, a.N.ib, a.Mb, t, v, m, g, a.N.fg, k);
            }
            n.timeline && a.za.contentType !== "image" && a.za.contentType !== "text" && a.presentationTimeline.wj(r.h ? r.h.timeline : [], t);
            d && a.wb && (d.segmentIndex = r);
            d = (d = (d = n.timeline) && d[d.length - 1]) ? d.end + n.kc : -1;
            l = -1;
            r instanceof hx && (l = r.lf());
            return {
                endTime: d,
                timeline: l,
                cd: function() {
                    r instanceof hx && r.getNumReferences() == 0 && gx(r, n, t, v, m, a.wb);
                    return Promise.resolve(r);
                },
                timescale: n.timescale
            };
        }
        function bx(a) {
            return a.Wc;
        }
        function dx(a) {
            var b = xw(a, bx), c = yw(a, bx, "media"), d = yw(a, bx, "index"), e = yw(a, bx, "k"), f = 0;
            e && (f = parseInt(e, 10));
            return {
                qg: b.qg,
                pb: b.pb,
                timescale: b.timescale,
                Ie: b.Ie,
                kc: b.kc,
                qd: b.qd,
                timeline: b.timeline,
                fc: c && jc(c),
                se: d,
                mimeType: a.N.mimeType,
                codecs: a.N.codecs,
                bandwidth: a.bandwidth,
                Ul: f
            };
        }
        function ex(a) {
            var b = a.se ? 1 : 0;
            b += a.timeline ? 1 : 0;
            b += a.pb ? 1 : 0;
            if (b == 0) throw new T(2, 4, 4002);
            b != 1 && (a.se && (a.timeline = null), a.qg = null, a.pb = null);
            if (!a.se && !a.fc) throw new T(2, 4, 4002);
        }
        function fx(a, b, c, d, e, f, g, h) {
            function k(I) {
                var K = I - w, N = K * v, P = b.qg, M = K * P;
                "BigInt" in window1 && M > Number.MAX_SAFE_INTEGER && (M = BigInt(K) * BigInt(P));
                N += q;
                K = N + v;
                P = Math.min(K, m());
                var L = [], Q = b.Ul;
                if (Q) for(var S = (P - N) / Q, Z = {}, pa = 0; pa < Q; Z = {
                    Wj: void 0
                }, pa++){
                    var va = N + S * pa, Ca = va + S;
                    Z.Wj = pa;
                    Z = new Oj(va, Ca, function(ua) {
                        return function() {
                            var xa = ww(x, z, I, ua.Wj, y, M);
                            return vc(A(), [
                                xa
                            ], E());
                        };
                    }(Z), 0, null, d, C, q, m(), [], "", null, null, Pj, f);
                    Z.codecs = a.N.codecs;
                    Z.mimeType = a.N.mimeType;
                    h == 0 ? pa > 0 && Z.Jd() : pa % h != 0 && Z.Jd();
                    L.push(Z);
                }
                N = new Oj(N, P, function() {
                    if (Q) return [];
                    var ua = ww(x, z, I, null, y, M);
                    return vc(A(), [
                        ua
                    ], E());
                }, 0, null, d, C, q, m(), L, "", null, null, Pj, f, L.length > 0);
                N.codecs = a.N.codecs;
                N.mimeType = a.N.mimeType;
                N.bandwidth = a.bandwidth;
                N.j = K;
                return N;
            }
            function l() {
                var I = [
                    Math.max(n.Hb(), q),
                    Math.min(n.Pc(), m())
                ].map(function(K) {
                    return K - q;
                });
                I = [
                    Math.ceil(I[0] / v),
                    Math.ceil(I[1] / v) - 1
                ];
                a.N.sb && I[1]++;
                return I.map(function(K) {
                    return K + w;
                });
            }
            function m() {
                var I = r != null && e.get(r) || t;
                return I ? q + I : Infinity;
            }
            var n = a.presentationTimeline, q = a.sa.start, r = a.Ea.id, t = a.sa.duration, v = b.pb, w = b.Ie, x = b.fc, y = a.bandwidth || null, z = a.N.originalId, A = a.N.ib, E = a.Mb, C = q - b.kc, D = l();
            c = a.wb ? Math.max(D[0], D[1] - c + 1) : D[0];
            g = g || D[1];
            var B = new ix(c, g, w, q, v, k);
            D = n.Pc() < m();
            var J = n.U();
            if (D || J) {
                var F = Math.max(c, g + 1);
                c = v;
                a.N.sb && (c = .1);
                B.rg(c, function() {
                    var I = n.Hb();
                    B.$a(I);
                    var K = u(l());
                    K.next();
                    K = K.next().value;
                    for(var N = []; F <= K;){
                        var P = k(F);
                        N.push(P);
                        F++;
                    }
                    return I > m() && !N.length ? null : N;
                });
            }
            return Promise.resolve(B);
        }
        function cx(a, b) {
            var c = a.N.Bf;
            c || (c = yw(a, bx, "initialization"));
            if (!c) return null;
            c = jc(c);
            var d = a.N.originalId, e = a.bandwidth || null, f = a.N.ib, g = a.Mb;
            b = new Mj(function() {
                var h = ww(c, d, null, null, e, null);
                return vc(f(), [
                    h
                ], g());
            }, 0, null, Pw(a), null, null, b, a.za.encrypted);
            b.codecs = a.N.codecs;
            b.mimeType = a.N.mimeType;
            a.sa && !a.sa.Ff && (b.g = a.sa.start + a.sa.duration);
            return b;
        }
        function ix(a, b, c, d, e, f) {
            vm.call(this, Array(Math.max(0, b - a + 1)));
            this.h = a;
            this.A = c;
            this.j = d;
            this.l = e;
            this.C = f;
        }
        oa(ix, vm);
        p = ix.prototype;
        p.find = function(a) {
            var b = this.g.length - 1;
            if (b < 0) return null;
            var c = this.get(this.i);
            if (!c) return null;
            if (a < c.startTime) return this.i;
            c = Math.floor((a - this.j) / this.l) + this.A - this.h;
            if (c < this.i) return null;
            var d = this.get(c);
            if (!d) return null;
            b = (b = c - this.i < b ? this.get(c + 1) : null) ? b.startTime : d.endTime;
            return a >= d.startTime && a < b ? c : null;
        };
        p.get = function(a) {
            var b = a - this.i;
            if (b < 0 || b >= this.g.length) return null;
            var c = this.g[b];
            c || (c = this.C(this.h + a), this.g[b] = c);
            return c;
        };
        p.Fb = function() {
            return this.get(this.i);
        };
        p.xb = function(a) {
            for(var b = 0; b < this.g.length; b++){
                var c = this.get(b + this.i);
                c && a(c);
            }
        };
        p.$a = function(a) {
            if (!this.o) {
                var b = this.g.length - 1;
                if (!(b < 0)) {
                    var c = this.get(this.i);
                    !c || c.endTime > a || (a = (b = this.get(this.i + b)) && b.endTime <= a ? this.g.length : Math.max(0, Math.min(this.g.length, Math.floor((a - this.j) / this.l + this.A - 1) - (this.h + this.i) + 1)), a > 0 && (this.i += a, this.g = this.g.slice(a)));
                }
            }
        };
        function hx(a, b, c, d, e, f, g, h, k, l, m, n) {
            vm.call(this, []);
            this.F = a;
            this.h = b;
            this.H = c;
            this.D = d;
            this.G = e;
            this.J = f;
            this.j = g;
            this.l = h;
            this.A = k;
            this.C = l;
            this.I = m;
            this.K = n;
            jx(this);
        }
        oa(hx, vm);
        p = hx.prototype;
        p.getNumReferences = function() {
            return this.h ? this.h.timeline.length : 0;
        };
        p.release = function() {
            vm.prototype.release.call(this);
            this.h = null;
        };
        p.$a = function(a) {
            if (this.h) {
                var b = this.h.timeline;
                if (b) {
                    for(var c = 0; c < b.length && b[c].end + this.j <= a;)c++;
                    c > 0 && (this.h.timeline = b.slice(c), this.g.length >= c && (this.g = this.g.slice(c)), this.i += c, this.getNumReferences() === 0 && this.release());
                }
            }
        };
        function gx(a, b, c, d, e, f) {
            kx(a, e);
            a.F = f;
            if (a.h) {
                if (a.h.qd !== b.qd) for(c = b.qd - a.h.qd, e = 0; e < b.timeline.length; e++)f = b.timeline[e], f.$d += c, f.Bi += c, f.start = (f.$d + c) / b.timescale, f.end = (f.Bi + c) / b.timescale;
                a.h.fc !== b.fc && (a.h.fc = b.fc);
                c = a.h.timeline;
                if (c.length) {
                    var g = c[c.length - 1];
                    b = b.timeline.filter(function(h) {
                        return h.end > g.end;
                    });
                } else b = b.timeline.slice();
                b.length > 0 && a.h.timeline.push.apply(a.h.timeline, G(b));
                a.l !== d && (a.l = d);
            } else a.h = b, a.j = c, a.l = d;
            jx(a);
        }
        function kx(a, b) {
            if (a.A !== b) {
                a.A = b;
                a = u(a.g);
                for(var c = a.next(); !c.done; c = a.next())(c = c.value) && Sj(c, b);
            }
        }
        function jx(a) {
            if (a.h && !a.o) {
                for(var b = [], c = u(a.h.timeline), d = c.next(); !d.done; d = c.next())d = d.value, d.start >= a.l || d.end <= 0 || b.push(d);
                a.h.timeline = b;
                a.$a(a.j);
            }
        }
        p.find = function(a) {
            var b = this;
            if (this.h && this.h.timeline && this.h.timeline.length && a < this.h.timeline[0].start + this.j) return this.i;
            if (!this.h) return null;
            var c = this.h.timeline;
            if (a < this.j || a >= this.l) return null;
            var d = c.length - 1, e = dd(c, function(h) {
                return h.start + b.j <= a;
            }) - 1;
            if (e < 0) return null;
            var f = c[e], g = f.start + this.j;
            c = e < d ? c[e + 1].start + this.j : this.l === Infinity ? f.end + this.j : this.l;
            return a >= g && a < c ? e + this.i : null;
        };
        p.get = function(a) {
            var b = this;
            a -= this.i;
            if (a < 0 || a >= this.getNumReferences() || !this.h) return null;
            var c = this.g[a];
            if (!c) {
                c = this.h.timeline[a];
                var d = c.rm, e = c.$d + this.h.qd, f = this.j - this.h.kc, g = this.j + c.end, h = g;
                a === this.getNumReferences() - 1 && this.l !== Infinity && (h = this.F && Math.abs(h - this.l) > .1 ? Math.min(h, this.l) : this.l);
                var k = this.h.codecs, l = this.h.mimeType, m = this.h.bandwidth, n = [], q = !1;
                c.Dc && this.h && this.h.fc && (q = this.h.fc.includes("$SubNumber$"));
                if (q) {
                    q = (c.end - c.start) / c.Dc;
                    for(var r = {}, t = 0; t < c.Dc; r = {
                        ug: void 0,
                        Xj: void 0
                    }, t++){
                        var v = c.start + q * t, w = v + q;
                        r.Xj = t;
                        r.ug = null;
                        r = new Oj(this.j + v, this.j + w, function(x) {
                            return function() {
                                if (!b.h) return [];
                                x.ug == null && (x.ug = lx(b.h.fc, b.H, d, b.D, e, x.Xj, b.G, b.J));
                                return x.ug;
                            };
                        }(r), 0, null, this.A, f, this.j, this.l, [], "", null, null, Pj, this.C);
                        r.codecs = k;
                        r.mimeType = l;
                        r.bandwidth = m;
                        this.I == 0 ? t > 0 && r.Jd() : t % this.I != 0 && r.Jd();
                        n.push(r);
                    }
                }
                c = new Oj(this.j + c.start, h, function() {
                    return n.length > 0 || !b.h ? [] : lx(b.h.fc, b.H, d, b.D, e, null, b.G, b.J);
                }, 0, null, this.A, f, this.j, this.l, n, "", null, null, Pj, this.C, n.length > 0);
                c.codecs = k;
                c.mimeType = l;
                c.j = g;
                c.bandwidth = m;
                this.g[a] = c;
            }
            return c;
        };
        p.xb = function(a) {
            jx(this);
            for(var b = 0; b < this.getNumReferences(); b++){
                var c = this.get(b + this.i);
                c && a(c);
            }
        };
        function lx(a, b, c, d, e, f, g, h) {
            a = ww(a, b, c, f, d || null, e);
            return vc(g(), [
                a
            ], h()).map(function(k) {
                return k.toString();
            });
        }
        p.lf = function() {
            return this.K;
        };
        function mx(a) {
            this.o = null;
            this.C = a;
            this.H = new fh;
            this.i = [];
            this.h = null;
            this.m = [];
            this.D = null;
            this.G = [];
            this.F = 300;
            this.l = new Map;
            this.j = new Map;
            this.g = null;
            this.A = "UNKNOWN";
        }
        mx.prototype.configure = function(a) {
            this.o = a;
        };
        mx.prototype.destroy = function() {
            this.C = this.o = null;
            this.i = [];
            this.h = null;
            this.m = [];
            this.G = [];
            this.l.clear();
            this.g != null && (this.g.stop(), this.g = null);
            return this.H.destroy();
        };
        mx.prototype.setManifestType = function(a) {
            this.A = a;
        };
        function nx(a, b) {
            var c, d, e, f, g, h, k;
            return H(function(l) {
                if (l.h == 1) return c = vc(a.i, [
                    ox(a, b)
                ]), d = mh(c, a.o.retryParameters), e = a.C.networkingEngine.request(8, d), gh(a.H, e), l.m(2), l.g(e.promise, 4);
                if (l.h != 2) return f = l.i, g = bc(f.data), h = JSON.parse(g), h.VERSION == 1 && px(a, h, f.uri), l.o(0);
                if ((k = l.l()) && k.code == 7001) return l.return();
                a.g != null && (a.g.stop(), a.g = null);
                a.g = new Uf(function() {
                    nx(a, b);
                });
                a.g.Z(a.F);
                l.j();
            });
        }
        function ox(a, b) {
            if (!a.m.length) return b;
            b = new lb(b);
            var c = a.D || a.m[0], d = Math.round(a.C.getBandwidthEstimate()), e = b.g;
            a.A == "DASH" ? (e.add("_DASH_pathway", c), e.add("_DASH_throughput", String(d))) : a.A == "HLS" && (e.add("_HLS_pathway", c), e.add("_HLS_throughput", String(d)));
            Bb(e);
            e.je && pb(b, e);
            return b.toString();
        }
        function px(a, b, c) {
            a.g != null && (a.g.stop(), a.g = null);
            var d = b["RELOAD-URI"] || c;
            a.g = new Uf(function() {
                nx(a, d);
            });
            if (c = b.TTL) a.F = c;
            a.g.Z(a.F);
            a.m = b["PATHWAY-PRIORITY"] || [];
            a.G = b["PATHWAY-CLONES"] || [];
        }
        function qx(a, b, c, d) {
            var e = a.l.get(b);
            e || (e = new Map);
            e.set(c, d);
            a.l.set(b, e);
        }
        mx.prototype.banLocation = function(a) {
            this.j.set(a, Date.now() + 6E4);
        };
        function rx(a, b, c) {
            c = c === void 0 ? !1 : c;
            b = a.l.get(b) || new Map;
            for(var d = [], e = u(a.m), f = e.next(), g = {}; !f.done; g = {
                Od: void 0
            }, f = e.next())if (g.Od = f.value, f = b.get(g.Od)) d.push({
                Th: g.Od,
                location: f
            });
            else if (f = a.G.find(function(k) {
                return function(l) {
                    return l.cn == k.Od;
                };
            }(g))) {
                var h = b.get(f["BASE-ID"]);
                h && (f["URI-REPLACEMENT"].pk ? (h = new lb(h), nb(h, f["URI-REPLACEMENT"].pk), d.push({
                    Th: g.Od,
                    location: h.toString()
                })) : d.push({
                    Th: g.Od,
                    location: h
                }));
            }
            e = Date.now();
            g = u(a.j.keys());
            for(f = g.next(); !f.done; f = g.next())f = f.value, h = a.j.get(f), e > h && a.j.delete(f);
            d = d.filter(function(k) {
                for(var l = u(a.j.keys()), m = l.next(); !m.done; m = l.next())if (m.value.includes(new lb(k.location).Eb)) return !1;
                return !0;
            });
            d.length && (a.D = d[0].Th);
            d = d.map(function(k) {
                return k.location;
            });
            if (!d.length && a.h) {
                for(e = u(a.h.split(",")), g = e.next(); !g.done; g = e.next())if (g = b.get(g.value)) a.D = a.h, d.push(g);
            }
            if (!d.length) for(b = u(b.values()), e = b.next(); !e.done; e = b.next())d.push(e.value);
            return c ? d : vc(a.i, d);
        }
        function sx() {
            this.l = [];
            this.h = [];
            this.g = [];
            this.j = [];
            this.i = [];
            this.o = !1;
            this.m = new Set;
        }
        p = sx.prototype;
        p.release = function() {
            for(var a = u(this.h.concat(this.g, this.j, this.i)), b = a.next(); !b.done; b = a.next())b = b.value, b.segmentIndex && b.segmentIndex.release();
            this.h = [];
            this.g = [];
            this.j = [];
            this.i = [];
            this.l = [];
            this.o = !1;
            this.m.clear();
        };
        p.yl = function() {
            return this.l;
        };
        p.xh = function() {
            return this.j.slice();
        };
        p.Sk = function() {
            return this.i;
        };
        p.Ui = function(a, b) {
            if (a) {
                if (a.type == "audio") for(var c = u(this.h), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                else if (a.type == "video") for(c = u(this.g), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                }), d.trickModeVideo && (d.trickModeVideo.matchedStreams = d.trickModeVideo.matchedStreams.filter(function(e) {
                    return e !== a;
                })), d.dependencyStream && (d.dependencyStream.matchedStreams = d.dependencyStream.matchedStreams.filter(function(e) {
                    return e !== a;
                }));
                else if (a.type == Ec) for(c = u(this.j), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                else if (a.type == "image") for(c = u(this.i), d = c.next(); !d.done; d = c.next())d = d.value, d.matchedStreams = d.matchedStreams.filter(function(e) {
                    return e !== a;
                });
                a.segmentIndex && a.closeSegmentIndex();
                this.m.delete(b);
            }
        };
        function tx(a, b) {
            var c = [], d = [], e = [], f = [];
            a = u(a);
            for(var g = a.next(); !g.done; g = a.next()){
                var h = g.value;
                g = new Map(h.audioStreams.map(function(n) {
                    return [
                        ux(n),
                        n
                    ];
                }));
                var k = new Map(h.videoStreams.map(function(n) {
                    return [
                        vx(n),
                        n
                    ];
                })), l = new Map(h.textStreams.map(function(n) {
                    return [
                        wx(n),
                        n
                    ];
                }));
                h = new Map(h.imageStreams.map(function(n) {
                    return [
                        xx(n),
                        n
                    ];
                }));
                if (b) {
                    var m = yx(Ec);
                    l.set(wx(m), m);
                    m = yx("image");
                    h.set(xx(m), m);
                }
                c.push(g);
                d.push(k);
                e.push(l);
                f.push(h);
            }
            return {
                Li: c,
                kk: d,
                ck: e,
                ij: f
            };
        }
        p.Pg = function(a, b, c) {
            c = c === void 0 ? !1 : c;
            var d = this, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z;
            return H(function(pa) {
                if (pa.h == 1) {
                    e = Gc;
                    if (!b && a.length == 1) return f = tx(a, !1), g = f.Li, h = f.kk, k = f.ck, l = f.ij, d.h = Array.from(g[0].values()), d.g = Array.from(h[0].values()), d.j = Array.from(k[0].values()), d.i = Array.from(l[0].values()), pa.B(2);
                    m = c ? d.m.size : 0;
                    n = -1;
                    for(q = 0; q < a.length; q++)r = a[q], d.m.has(r.id) || (d.m.add(r.id), n == -1 && (n = q));
                    if (n == -1) return pa.return();
                    t = tx(a, !0);
                    v = t.Li;
                    w = t.kk;
                    x = t.ck;
                    y = t.ij;
                    return pa.g(Promise.all([
                        zx(d, d.h, v, n, Ax, Bx, m),
                        zx(d, d.g, w, n, Ax, Bx, m),
                        zx(d, d.j, x, n, Ax, Bx, m),
                        zx(d, d.i, y, n, Ax, Bx, m)
                    ]), 2);
                }
                z = 0;
                A = [];
                if (d.g.length && d.h.length) for(I = u(d.h), K = I.next(); !K.done; K = I.next())for(N = K.value, P = u(d.g), M = P.next(); !M.done; M = P.next())L = M.value, Q = Nb(N.drmInfos, L.drmInfos), N.drmInfos.length && L.drmInfos.length && !Q.length || (S = (N.bandwidth || 0) + (L.bandwidth || 0), N.dependencyStream && (S += N.dependencyStream.bandwidth || 0), L.dependencyStream && (S += L.dependencyStream.bandwidth || 0), Z = z++, A.push({
                    id: Z,
                    language: N.language,
                    disabledUntilTime: 0,
                    primary: N.primary,
                    audio: N,
                    video: L,
                    bandwidth: S,
                    drmInfos: Q,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }));
                else for(E = d.g.length ? d.g : d.h, C = u(E), D = C.next(); !D.done; D = C.next())B = D.value, J = z++, F = B.bandwidth || 0, B.dependencyStream && (F += B.dependencyStream.bandwidth || 0), A.push({
                    id: J,
                    language: B.language,
                    disabledUntilTime: 0,
                    primary: B.primary,
                    audio: B.type == e.ha ? B : null,
                    video: B.type == e.Ba ? B : null,
                    bandwidth: F,
                    drmInfos: B.drmInfos,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                });
                d.l = A;
                pa.j();
            });
        };
        function Cx(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P;
            return H(function(M) {
                switch(M.h){
                    case 1:
                        b = Gc;
                        if (a.length == 1) return M.return(a[0]);
                        c = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.ha;
                            }).map(function(Q) {
                                return [
                                    ux(Q),
                                    Q
                                ];
                            }));
                        });
                        d = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.Ba;
                            }).map(function(Q) {
                                return [
                                    vx(Q),
                                    Q
                                ];
                            }));
                        });
                        e = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.Va;
                            }).map(function(Q) {
                                return [
                                    wx(Q),
                                    Q
                                ];
                            }));
                        });
                        f = a.map(function(L) {
                            return new Map(L.filter(function(Q) {
                                return Q.type === b.zg;
                            }).map(function(Q) {
                                return [
                                    xx(Q),
                                    Q
                                ];
                            }));
                        });
                        g = u(e);
                        for(h = g.next(); !h.done; h = g.next())k = h.value, l = Dx(b.Va), k.set(wx(l), l);
                        m = u(f);
                        for(n = m.next(); !n.done; n = m.next())q = n.value, r = Dx(b.zg), q.set(xx(r), r);
                        t = new sx;
                        return M.g(zx(t, [], c, 0, Ex, Fx, 0), 2);
                    case 2:
                        return v = M.i, M.g(zx(t, [], d, 0, Ex, Fx, 0), 3);
                    case 3:
                        return w = M.i, M.g(zx(t, [], e, 0, Ex, Fx, 0), 4);
                    case 4:
                        return x = M.i, M.g(zx(t, [], f, 0, Ex, Fx, 0), 5);
                    case 5:
                        y = M.i;
                        z = 0;
                        if (w.length && v.length) for(B = u(v), J = B.next(); !J.done; J = B.next())for(F = J.value, I = u(w), K = I.next(); !K.done; K = I.next())N = K.value, P = z++, N.variantIds.push(P), F.variantIds.push(P);
                        else for(A = w.concat(v), E = u(A), C = E.next(); !C.done; C = E.next())D = C.value, D.variantIds = [
                            z++
                        ];
                        return M.return(w.concat(v).concat(x).concat(y));
                }
            });
        }
        function zx(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F;
            return H(function(I) {
                switch(I.h){
                    case 1:
                        h = [];
                        for(k = 0; k < c.length; k++)k >= d ? h.push(new Set(c[k].values())) : h.push(new Set);
                        l = u(b);
                        m = l.next();
                    case 2:
                        if (m.done) {
                            I.B(4);
                            break;
                        }
                        n = m.value;
                        return I.g(Gx(a, n, c, d, f, h, g), 5);
                    case 5:
                        q = I.i;
                        if (!q) throw new T(2, 4, 4037);
                        m = l.next();
                        I.B(2);
                        break;
                    case 4:
                        r = u(h);
                        for(t = r.next(); !t.done; t = r.next())for(v = t.value, w = u(v), x = w.next(); !x.done; x = w.next())y = x.value, (z = Hx(a, b, y, c, e, f, h)) && b.push(z);
                        A = u(h);
                        for(E = A.next(); !E.done; E = A.next())for(C = E.value, D = u(C), B = D.next(), J = {}; !B.done; J = {
                            oi: void 0
                        }, B = D.next())if (J.oi = B.value, !Ix(J.oi) && (F = b.some(function(K) {
                            return function(N) {
                                return Jx(K.oi, N);
                            };
                        }(J)))) throw new T(2, 4, 4037);
                        return I.return(b);
                }
            });
        }
        function Gx(a, b, c, d, e, f, g) {
            return H(function(h) {
                if (h.h == 1) return Kx(a, c, b, g > 0), b.matchedStreams ? b.segmentIndex ? h.g(Lx(b, d + g), 2) : h.B(2) : h.return(!1);
                Mx(b, d, e, f, g);
                return h.return(!0);
            });
        }
        function Lx(a, b) {
            var c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) {
                    c = [];
                    d = a.matchedStreams;
                    for(e = b; e < d.length; e++)f = d[e], c.push(f.createSegmentIndex()), f.trickModeVideo && !f.trickModeVideo.segmentIndex && c.push(f.trickModeVideo.createSegmentIndex()), f.dependencyStream && !f.dependencyStream.segmentIndex && c.push(f.dependencyStream.createSegmentIndex());
                    return k.g(Promise.all(c), 2);
                }
                if (a.segmentIndex instanceof ym) for(g = b; g < d.length; g++)h = d[g], h.segmentIndex && a.segmentIndex.h.push(h.segmentIndex);
                k.j();
            });
        }
        function Hx(a, b, c, d, e, f, g) {
            if (Ix(c)) return null;
            var h = e(c);
            Kx(a, d, h);
            h.createSegmentIndex && (h.createSegmentIndex = function() {
                return H(function(k) {
                    if (h.segmentIndex) return k.B(0);
                    h.segmentIndex = new ym;
                    return k.g(Lx(h, 0), 0);
                });
            }, h.closeSegmentIndex = function() {
                h.segmentIndex && (h.segmentIndex.release(), h.segmentIndex = null);
                if (h.matchedStreams) for(var k = u(h.matchedStreams), l = k.next(); !l.done; l = k.next()){
                    l = l.value;
                    var m;
                    if (m = l.segmentIndex) {
                        a: {
                            m = u(b);
                            for(var n = m.next(); !n.done; n = m.next())if (n = n.value, n !== h && n.segmentIndex && n.matchedStreams && n.matchedStreams.includes(l)) {
                                m = !0;
                                break a;
                            }
                            m = !1;
                        }
                        m = !m;
                    }
                    m && (l.segmentIndex.release(), l.segmentIndex = null);
                }
            });
            if (!h.matchedStreams || !h.matchedStreams.length) return null;
            Mx(h, 0, f, g, 0);
            return h;
        }
        function Mx(a, b, c, d, e) {
            var f = a.matchedStreams;
            for(b += e; b < f.length; b++){
                var g = f[b];
                c(a, g);
                var h = !0;
                a.type == "audio" && Qc(a.language, g.language) == 0 && (h = !1);
                if (h && ((h = d[b - e]) && h.delete(g), g.fullMimeTypes)) for(g = u(g.fullMimeTypes.values()), h = g.next(); !h.done; h = g.next())a.fullMimeTypes.add(h.value);
            }
        }
        function Ax(a) {
            var b = Object.assign({}, a);
            b.originalId = null;
            b.createSegmentIndex = function() {
                return Promise.resolve();
            };
            b.closeSegmentIndex = function() {};
            b.roles = b.roles.slice();
            b.segmentIndex = null;
            b.emsgSchemeIdUris = [];
            b.keyIds = new Set(a.keyIds);
            b.closedCaptions = a.closedCaptions ? new Map(a.closedCaptions) : null;
            b.trickModeVideo = null;
            b.dependencyStream = null;
            return b;
        }
        function Ex(a) {
            var b = Object.assign({}, a);
            b.roles = b.roles.slice();
            b.keyIds = new Set(a.keyIds);
            b.segments = [];
            b.variantIds = [];
            b.closedCaptions = a.closedCaptions ? new Map(a.closedCaptions) : null;
            return b;
        }
        function Bx(a, b) {
            function c(g, h) {
                g || (g = []);
                h = u(h);
                for(var k = h.next(); !k.done; k = h.next())k = k.value, g.includes(k) || g.push(k);
                return g;
            }
            a.roles = c(a.roles, b.roles);
            b.emsgSchemeIdUris && (a.emsgSchemeIdUris = c(a.emsgSchemeIdUris, b.emsgSchemeIdUris));
            for(var d = u(b.keyIds), e = d.next(); !e.done; e = d.next())a.keyIds.add(e.value);
            a.originalId == null ? a.originalId = b.originalId : (d = b.originalId || "") && !a.originalId.endsWith(d) && (a.originalId += "," + d);
            d = Nb(a.drmInfos, b.drmInfos);
            if (b.drmInfos.length && a.drmInfos.length && !d.length) throw new T(2, 4, 4038);
            a.drmInfos = d;
            a.encrypted = a.encrypted || b.encrypted;
            if (b.closedCaptions) for(a.closedCaptions || (a.closedCaptions = new Map), d = u(b.closedCaptions), e = d.next(); !e.done; e = d.next()){
                var f = u(e.value);
                e = f.next().value;
                f = f.next().value;
                a.closedCaptions.set(e, f);
            }
            a.bandwidth && b.bandwidth && (a.bandwidth = Math.max(a.bandwidth, b.bandwidth));
            b.trickModeVideo ? (a.trickModeVideo || (a.trickModeVideo = Ax(b.trickModeVideo), a.trickModeVideo.matchedStreams = [], a.trickModeVideo.createSegmentIndex = function() {
                if (a.trickModeVideo.segmentIndex) return Promise.resolve();
                for(var g = new ym, h = u(a.trickModeVideo.matchedStreams), k = h.next(); !k.done; k = h.next())g.h.push(k.value.segmentIndex);
                a.trickModeVideo.segmentIndex = g;
                return Promise.resolve();
            }), a.trickModeVideo.matchedStreams.push(b.trickModeVideo), Bx(a.trickModeVideo, b.trickModeVideo)) : a.trickModeVideo && (a.trickModeVideo.matchedStreams.push(b), Bx(a.trickModeVideo, b));
            b.dependencyStream ? (a.dependencyStream || (a.dependencyStream = Ax(b.dependencyStream), a.dependencyStream.matchedStreams = [], a.dependencyStream.createSegmentIndex = function() {
                if (a.dependencyStream.segmentIndex) return Promise.resolve();
                for(var g = new ym, h = u(a.dependencyStream.matchedStreams), k = h.next(); !k.done; k = h.next())g.h.push(k.value.segmentIndex);
                a.dependencyStream.segmentIndex = g;
                return Promise.resolve();
            }), a.dependencyStream.matchedStreams.push(b.dependencyStream), Bx(a.dependencyStream, b.dependencyStream)) : a.dependencyStream && (a.dependencyStream.matchedStreams.push(b), Bx(a.dependencyStream, b));
        }
        function Fx(a, b) {
            var c = a.roles;
            c || (c = []);
            for(var d = u(b.roles), e = d.next(); !e.done; e = d.next())e = e.value, c.includes(e) || c.push(e);
            a.roles = c;
            c = u(b.keyIds);
            for(d = c.next(); !d.done; d = c.next())a.keyIds.add(d.value);
            a.encrypted = a.encrypted && b.encrypted;
            a.segments.push.apply(a.segments, G(b.segments));
            if (b.closedCaptions) for(a.closedCaptions || (a.closedCaptions = new Map), b = u(b.closedCaptions), c = b.next(); !c.done; c = b.next())d = u(c.value), c = d.next().value, d = d.next().value, a.closedCaptions.set(c, d);
        }
        function Kx(a, b, c, d) {
            d = (d === void 0 ? 0 : d) ? c.matchedStreams : [];
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = Nx(a, e.value, c);
                if (!e) return;
                d.push(e);
            }
            c.matchedStreams = d;
        }
        function Nx(a, b, c) {
            var d = {
                audio: ux,
                video: vx,
                text: wx,
                image: xx
            }[c.type], e = null, f = d(c);
            if (b.has(f)) e = b.get(f);
            else {
                f = ({
                    audio: function(l, m) {
                        return Jx(l, m);
                    },
                    video: function(l, m) {
                        return Jx(l, m);
                    },
                    text: Ox,
                    image: Px
                })[c.type];
                for(var g = {
                    audio: Qx,
                    video: Rx,
                    text: Sx,
                    image: Tx
                }[c.type], h = u(b.values()), k = h.next(); !k.done; k = h.next())k = k.value, !f(c, k) || c.fastSwitching != k.fastSwitching || e && !g(c, e, k) || (e = k);
            }
            a.o && !Ix(e) && b.delete(d(e));
            return e;
        }
        function Ux(a, b) {
            return a.mimeType != b.mimeType ? !1 : Vx(a.codecs) === Vx(b.codecs);
        }
        p.Rj = function(a) {
            this.o = a;
        };
        function Jx(a, b) {
            return a.drmInfos && !Lb(a.drmInfos, b.drmInfos) ? !1 : !0;
        }
        function Ox(a, b) {
            return b.language ? a.forced !== b.forced || Qc(a.language, b.language) == 0 || b.kind != a.kind ? !1 : !0 : !0;
        }
        function Px() {
            return !0;
        }
        function Qx(a, b, c) {
            var d = Wx(a, b, c);
            if (d === Xx) return !0;
            if (d === Yx) return !1;
            d = Qc(a.language, b.language);
            var e = Qc(a.language, c.language);
            if (e > d) return !0;
            if (e < d) return !1;
            if (b.label !== c.label) {
                if (a.label === b.label) return !1;
                if (a.label === c.label) return !0;
            }
            if (a.roles.length) {
                d = b.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                e = c.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                if (e.length > d.length) return !0;
                if (e.length < d.length) return !1;
                if (c.roles.length !== b.roles.length) return c.roles.length < b.roles.length;
            } else {
                if (!c.roles.length && b.roles.length) return !0;
                if (c.roles.length && !b.roles.length) return !1;
            }
            if (!b.primary && c.primary) return !0;
            if (b.primary && !c.primary) return !1;
            d = Zx(a.channelsCount, b.channelsCount, c.channelsCount);
            if (d == Xx) return !0;
            if (d == Yx) return !1;
            d = Zx(a.audioSamplingRate, b.audioSamplingRate, c.audioSamplingRate);
            return d == Xx ? !0 : d == Yx ? !1 : a.bandwidth && $x(a.bandwidth, b.bandwidth, c.bandwidth) == Xx ? !0 : !1;
        }
        function Rx(a, b, c) {
            var d = Wx(a, b, c);
            if (d === Xx) return !0;
            if (d === Yx) return !1;
            d = Zx(a.width * a.height, b.width * b.height, c.width * c.height);
            if (d == Xx) return !0;
            if (d == Yx) return !1;
            if (a.frameRate) {
                d = Zx(a.frameRate, b.frameRate, c.frameRate);
                if (d == Xx) return !0;
                if (d == Yx) return !1;
            }
            return a.bandwidth && $x(a.bandwidth, b.bandwidth, c.bandwidth) == Xx ? !0 : !1;
        }
        function Sx(a, b, c) {
            var d = Qc(a.language, b.language), e = Qc(a.language, c.language);
            if (e > d) return !0;
            if (e < d) return !1;
            if (!b.primary && c.primary) return !0;
            if (b.primary && !c.primary) return !1;
            if (b.label !== c.label) {
                if (a.label === b.label) return !1;
                if (a.label === c.label) return !0;
            }
            if (a.roles.length) {
                d = b.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                e = c.roles.filter(function(f) {
                    return a.roles.includes(f);
                });
                if (e.length > d.length) return !0;
                if (e.length < d.length) return !1;
            } else {
                if (!c.roles.length && b.roles.length) return !0;
                if (c.roles.length && !b.roles.length) return !1;
            }
            return c.mimeType != a.mimeType || c.codecs != a.codecs || b.mimeType == a.mimeType && b.codecs == a.codecs ? !1 : !0;
        }
        function Tx(a, b, c) {
            return Zx(a.width * a.height, b.width * b.height, c.width * c.height) == Xx ? !0 : !1;
        }
        function Dx(a) {
            return {
                id: 0,
                originalId: "",
                groupId: null,
                primary: !1,
                type: a,
                mimeType: "",
                codecs: "",
                language: "",
                originalLanguage: null,
                label: null,
                width: null,
                height: null,
                encrypted: !1,
                keyIds: new Set,
                segments: [],
                variantIds: [],
                roles: [],
                forced: !1,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                closedCaptions: null,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function yx(a) {
            return {
                id: 0,
                originalId: "",
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: new vm([]),
                mimeType: "",
                codecs: "",
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set,
                language: "",
                originalLanguage: null,
                label: null,
                type: a,
                primary: !1,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                roles: [],
                forced: !1,
                channelsCount: null,
                audioSamplingRate: null,
                spatialAudio: !1,
                closedCaptions: null,
                accessibilityPurpose: null,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
        }
        function Zx(a, b, c) {
            if (b == a && a != c) return Yx;
            if (c == a && a != b) return Xx;
            if (b > a) {
                if (c <= a || c - a < b - a) return Xx;
                if (c - a > b - a) return Yx;
            } else {
                if (c > a) return Yx;
                if (a - c < a - b) return Xx;
                if (a - c > a - b) return Yx;
            }
            return ay;
        }
        function Wx(a, b, c) {
            var d = a.mimeType === b.mimeType && a.codecs === b.codecs, e = a.mimeType === c.mimeType && a.codecs === c.codecs;
            if (d && !e) return Yx;
            if (!d && e) return Xx;
            b = Ux(a, b);
            a = Ux(a, c);
            return b && !a ? Yx : !b && a ? Xx : ay;
        }
        function $x(a, b, c) {
            b = Math.abs(a - b);
            a = Math.abs(a - c);
            return a < b ? Xx : b < a ? Yx : ay;
        }
        function Ix(a) {
            switch(a.type){
                case Ec:
                    return !a.language;
                case "image":
                    return !a.tilesLayout;
                default:
                    return !1;
            }
        }
        function vx(a) {
            return by([
                a.fastSwitching,
                a.width,
                a.frameRate,
                a.codecs,
                a.mimeType,
                a.label,
                a.roles,
                a.closedCaptions ? Array.from(a.closedCaptions.entries()) : null,
                a.bandwidth,
                a.dependencyStream ? a.dependencyStream.baseOriginalId : null,
                Array.from(a.keyIds)
            ]);
        }
        function ux(a) {
            return by([
                a.fastSwitching,
                a.channelsCount,
                a.language,
                a.bandwidth,
                a.label,
                a.codecs,
                a.mimeType,
                a.roles,
                a.audioSamplingRate,
                a.primary,
                a.dependencyStream ? a.dependencyStream.baseOriginalId : null,
                Array.from(a.keyIds)
            ]);
        }
        function wx(a) {
            return by([
                a.language,
                a.label,
                a.codecs,
                a.mimeType,
                a.bandwidth,
                a.roles
            ]);
        }
        function xx(a) {
            return by([
                a.width,
                a.codecs,
                a.mimeType
            ]);
        }
        function by(a) {
            return JSON.stringify(a);
        }
        function Vx(a) {
            if (!cy.has(a)) {
                var b = Cf(a);
                cy.set(a, b);
            }
            return cy.get(a);
        }
        O("shaka.util.PeriodCombiner", sx);
        sx.prototype.setUseStreamOnce = sx.prototype.Rj;
        sx.prototype.combinePeriods = sx.prototype.Pg;
        sx.prototype.deleteStream = sx.prototype.Ui;
        sx.prototype.getImageStreams = sx.prototype.Sk;
        sx.prototype.getTextStreams = sx.prototype.xh;
        sx.prototype.getVariants = sx.prototype.yl;
        var Xx = 1, ay = 0, Yx = -1, cy = new Map;
        function dy(a, b) {
            var c = new DOMParser, d = ey.value()(a);
            a = null;
            try {
                a = c.parseFromString(d, "text/xml");
            } catch (e) {
                return null;
            }
            c = a.documentElement;
            if (!c || c.getElementsByTagName("parsererror").length || c.tagName != b) return null;
            if (!("createNodeIterator" in document)) return c;
            for(b = document.createNodeIterator(a, NodeFilter.SHOW_ALL); a = b.nextNode();)if (a instanceof HTMLElement || a instanceof SVGElement) return null;
            return c;
        }
        function fy(a, b) {
            try {
                var c = ec(a);
                return dy(c, b);
            } catch (d) {
                return null;
            }
        }
        var ey = new Kb(function() {
            if (typeof trustedTypes !== "undefined") {
                var a = trustedTypes.createPolicy("shaka-player#xml", {
                    createHTML: function(b) {
                        return b;
                    }
                });
                return function(b) {
                    return a.createHTML(b);
                };
            }
            return function(b) {
                return b;
            };
        });
        function gy() {
            var a = this;
            this.j = this.g = null;
            this.C = [];
            this.h = null;
            this.Ia = 1;
            this.I = [];
            this.l = {
                Qf: "",
                type: "",
                profiles: [],
                Bc: null,
                sb: 0,
                ib: null,
                De: 0
            };
            this.A = new Map;
            this.D = new Map;
            this.H = new Map;
            this.o = new Map;
            this.G = new Map;
            this.ya = new Map;
            this.m = new sx;
            this.L = 0;
            this.Ga = new Xc(5);
            this.M = new Uf(function() {
                if (a.K && !a.g.continueLoadingWhenPaused && (a.J.Fa(a.K, "timeupdate"), a.K.paused)) {
                    a.J.ra(a.K, "timeupdate", function() {
                        return hy(a);
                    });
                    return;
                }
                hy(a);
            });
            this.R = new fh;
            this.P = null;
            this.F = [];
            this.$ = Infinity;
            this.ua = !1;
            this.i = null;
            this.O = 0;
            this.S = !1;
            this.J = new fd;
            this.K = null;
            this.V = !1;
            this.X = "";
            this.na = function() {
                return !1;
            };
            this.W = [];
            this.ba = new Set;
            this.va = new nw;
        }
        p = gy.prototype;
        p.configure = function(a, b) {
            var c = this.j && a.updatePeriod != this.g.updatePeriod && a.updatePeriod >= 0;
            this.g = a;
            b && (this.na = b);
            c && this.h && this.h.presentationTimeline.U() && this.M.La();
            this.i && this.i.configure(this.g);
            this.m && this.m.Rj(this.g.dash.useStreamOnceInPeriodFlattening);
        };
        p.start = function(a, b) {
            var c = this, d;
            return H(function(e) {
                if (e.h == 1) return c.ua = b.isLowLatencyMode(), c.C = [
                    a
                ], c.j = b, e.g(iy(c), 2);
                d = e.i;
                c.j && jy(c, d);
                if (!c.j) throw new T(2, 7, 7001);
                return e.return(c.h);
            });
        };
        p.stop = function() {
            for(var a = u(this.o.values()), b = a.next(); !b.done; b = a.next())b = b.value, b.segmentIndex && b.segmentIndex.release();
            this.m && this.m.release();
            this.g = this.j = null;
            this.C = [];
            this.h = null;
            this.o.clear();
            this.G.clear();
            this.A.clear();
            this.D.clear();
            this.H.clear();
            this.l = {
                Qf: "",
                type: "",
                profiles: [],
                Bc: null,
                sb: 0,
                ib: null,
                De: 0
            };
            this.m = null;
            this.M != null && (this.M.stop(), this.M = null);
            this.i && this.i.destroy();
            this.J && (this.J.release(), this.J = null);
            this.ba.clear();
            this.va.release();
            return this.R.destroy();
        };
        p.update = function() {
            var a = this, b;
            return H(function(c) {
                if (c.h == 1) return c.m(2), c.g(iy(a), 4);
                if (c.h != 2) return c.o(0);
                b = c.l();
                if (!a.j || !b) return c.return();
                a.j.onError(b);
                c.j();
            });
        };
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function(a) {
            if (this.h && this.h.presentationTimeline.U()) {
                var b = a.video || a.audio;
                if (b && b.segmentIndex) {
                    a = this.h.presentationTimeline.Pc();
                    var c = b.segmentIndex.find(a);
                    c != null && (b = b.segmentIndex.get(c)) && (this.L = b.endTime - a, jy(this, 0));
                }
            }
        };
        p.banLocation = function(a) {
            this.i && this.i.banLocation(a);
        };
        p.setMediaElement = function(a) {
            this.K = a;
        };
        function iy(a) {
            var b, c, d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                if (q.h == 1) return b = 4, c = "MPD", d = ky(a), e = a.C, d.length ? (e = d, c = "Patch", b = 6) : a.C.length > 1 && a.i && (f = rx(a.i, "Location", !0), f.length && (e = f)), g = mh(e, a.g.retryParameters), h = Date.now(), q.g(ly(a, g, 0, {
                    type: b
                }), 2);
                if (q.h != 3) {
                    k = q.i;
                    if (!a.j) return q.return(0);
                    k.uri && k.uri != k.originalUri && !a.C.includes(k.uri) && a.C.unshift(k.uri);
                    l = new lb(k.uri);
                    a.X = l.g.toString();
                    return q.g(my(a, k.data, k.uri, c), 3);
                }
                m = Date.now();
                n = (m - h) / 1E3;
                a.Ga.sample(1, n);
                a.ba.clear();
                return q.return(n);
            });
        }
        function my(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                if (v.h == 1) {
                    e = b;
                    f = a.g.dash.manifestPreprocessor;
                    g = Ao;
                    if (f != g) {
                        md("manifest.dash.manifestPreprocessor configuration", "Please Use manifest.dash.manifestPreprocessorTXml instead.");
                        h = fy(e, d);
                        if (!h) throw new T(2, 4, 4001, c);
                        f(h);
                        e = hc(h.outerHTML);
                    }
                    k = $d(e, d);
                    if (!k) throw new T(2, 4, 4001, c);
                    l = a.g.dash.manifestPreprocessorTXml;
                    m = Bo;
                    l != m && l(k);
                    if (d === "Patch") return v.return(ny(a, k));
                    if (n = a.g.dash.disableXlinkProcessing) return v.return(oy(a, k, c));
                    q = a.g.dash.xlinkFailGracefully;
                    r = Cw(k, a.g.retryParameters, q, c, a.j.networkingEngine);
                    gh(a.R, r);
                    return v.g(r.promise, 2);
                }
                t = v.i;
                return v.return(oy(a, t, c));
            });
        }
        function oy(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa, Ga, sb, Wb, wb, wc, he, hd, qd, sf, Bg, rd, xc, nc, mi;
            return H(function(oc) {
                switch(oc.h){
                    case 1:
                        a.i && a.i.l.clear();
                        d = [
                            c
                        ];
                        e = [];
                        f = new Map;
                        g = ie(b, "Location");
                        h = u(g);
                        for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = l.attributes.serviceLocation, n = le(l)) q = vc(d, [
                            n
                        ])[0], m && (a.i ? qx(a.i, "Location", m, q) : f.set(m, q)), e.push(q);
                        a.i ? (r = rx(a.i, "Location", !0), r.length > 0 && (d = a.C = r)) : e.length && (d = a.C = e);
                        a.l.Qf = b.attributes.id || "";
                        a.l.De = qe(b, "publishTime", te) || 0;
                        a.I = ie(b, "PatchLocation");
                        t = Promise.resolve();
                        if ((v = ne(b, "ContentSteering")) && a.j) {
                            w = v.attributes.defaultServiceLocation;
                            if (a.i) a.i.i = d, a.i.h = w;
                            else if (a.i = new mx(a.j), a.i.configure(a.g), a.i.setManifestType("DASH"), a.i.i = d, a.i.h = w, x = le(v)) (y = qe(v, "queryBeforeStart", Ae, !1)) ? t = nx(a.i, x) : nx(a.i, x);
                            z = u(f.keys());
                            for(A = z.next(); !A.done; A = z.next())E = A.value, C = f.get(E), qx(a.i, "Location", E, C);
                        }
                        D = ie(b, "BaseURL");
                        B = !1;
                        if (a.i) for(J = u(D), F = J.next(); !F.done; F = J.next())I = F.value, K = I.attributes.serviceLocation, N = le(I), K && N && (qx(a.i, "BaseURL", K, N), B = !0);
                        a.W.splice(0);
                        B && a.i || (P = D.map(le), a.W.push.apply(a.W, G(vc(d, P))));
                        M = a.i;
                        L = a.W;
                        Q = py;
                        S = Q.call(gy, M, B, L);
                        a.l.ib = S;
                        Z = 0;
                        D && D.length && (Z = qe(D[0], "availabilityTimeOffset", ze) || 0);
                        a.l.sb = Z;
                        a.L = qe(b, "minimumUpdatePeriod", ue, -1);
                        pa = qe(b, "availabilityStartTime", te);
                        va = qe(b, "timeShiftBufferDepth", ue);
                        Ca = a.g.dash.ignoreSuggestedPresentationDelay;
                        ua = null;
                        Ca || (ua = qe(b, "suggestedPresentationDelay", ue));
                        xa = a.g.dash.ignoreMaxSegmentDuration;
                        Da = null;
                        xa || (Da = qe(b, "maxSegmentDuration", ue));
                        Ka = b.attributes.type || "static";
                        a.h && a.h.presentationTimeline && (a.V = a.h.presentationTimeline.U() && Ka == "static");
                        a.l.type = Ka;
                        if (a.h) for(wa = a.h.presentationTimeline, Ja = wa.Hb(), Aa = u(a.o.values()), Ga = Aa.next(); !Ga.done; Ga = Aa.next())sb = Ga.value, sb.segmentIndex && sb.segmentIndex.$a(Ja);
                        else Wb = a.g.dash.ignoreMinBufferTime, wb = 0, Wb || (wb = qe(b, "minBufferTime", ue) || 0), wc = 0, wc = ua != null ? Math.min(ua, va || Infinity) : a.g.defaultPresentationDelay > 0 ? a.g.defaultPresentationDelay : Math.min(wb * 1.5, va || Infinity), wa = new Wl(pa, wc, a.g.dash.autoCorrectDrift);
                        wa.md(Ka == "static");
                        (he = wa.U()) && !isNaN(a.g.availabilityWindowOverride) && (va = a.g.availabilityWindowOverride);
                        va == null && (va = Infinity);
                        wa.ig(va);
                        hd = b.attributes.profiles || "";
                        a.l.profiles = hd.split(",");
                        qd = {
                            wb: Ka != "static",
                            presentationTimeline: wa,
                            Ea: null,
                            sa: null,
                            za: null,
                            N: null,
                            bandwidth: 0,
                            Dh: !1,
                            sb: Z,
                            Bc: null,
                            profiles: hd.split(","),
                            roles: null,
                            Mb: qy
                        };
                        return oc.g(t, 2);
                    case 2:
                        a.O = 0;
                        sf = ry(a, qd, S, b, !1);
                        Bg = sf.duration;
                        rd = sf.periods;
                        (Ka != "static" || a.V) && sf.Wi || wa.Ab(Bg || Infinity);
                        a.S && a.ua && wa.Lj(a.$);
                        wa.Oh(Da || 1);
                        a.S && a.ua && (xc = ua != null ? ua : a.g.defaultPresentationDelay, wa.ii(xc));
                        if (!a.h) return oc.g(a.m.Pg(rd, qd.wb), 6);
                        a.h.periodCount = rd.length;
                        a.h.gapCount = a.O;
                        return oc.g(sy(a, rd, !1), 4);
                    case 6:
                        var tf = wa, ni = a.m.l, oi = a.m.xh(), lp = a.m.i, Yk = a.g.dash.sequenceMode;
                        var Db = ne(b, "ServiceDescription");
                        if (Db) {
                            var Ac = ne(Db, "Latency");
                            Db = ne(Db, "PlaybackRate");
                            if (Ac || Db) {
                                var pc = {};
                                Ac && ("target" in Ac.attributes && (pc.targetLatency = parseInt(Ac.attributes.target, 10) / 1E3), "max" in Ac.attributes && (pc.maxLatency = parseInt(Ac.attributes.max, 10) / 1E3), "min" in Ac.attributes && (pc.minLatency = parseInt(Ac.attributes.min, 10) / 1E3));
                                Db && ("max" in Db.attributes && (pc.maxPlaybackRate = parseFloat(Db.attributes.max)), "min" in Db.attributes && (pc.minPlaybackRate = parseFloat(Db.attributes.min)));
                                Ac = pc;
                            } else Ac = null;
                        } else Ac = null;
                        a: {
                            Db = ie(b, "SupplementalProperty");
                            if (Db.length) {
                                for(Db = u(Db), pc = Db.next(); !pc.done; pc = Db.next())if (pc = pc.value, pc.attributes.schemeIdUri == "urn:mpeg:dash:chaining:2016") {
                                    Db = pc.attributes.value;
                                    break a;
                                }
                            }
                            Db = null;
                        }
                        a.h = {
                            presentationTimeline: tf,
                            variants: ni,
                            textStreams: oi,
                            imageStreams: lp,
                            offlineSessionIds: [],
                            sequenceMode: Yk,
                            ignoreManifestTimestampsInSegmentsMode: !1,
                            type: "DASH",
                            serviceDescription: Ac,
                            nextUrl: Db,
                            periodCount: rd.length,
                            gapCount: a.O,
                            isLowLatency: a.S,
                            startTime: null
                        };
                        if (!wa.hk()) {
                            oc.B(7);
                            break;
                        }
                        nc = ie(b, "UTCTiming");
                        return oc.g(ty(a, S, nc), 8);
                    case 8:
                        mi = oc.i;
                        if (!a.j) return oc.return();
                        wa.Mj(mi);
                    case 7:
                        wa.Mf(), a.m && !a.h.presentationTimeline.U() && a.m.release();
                    case 4:
                        a.j.makeTextStreamsForClosedCaptions(a.h), uy(a), vy(a, rd), oc.j();
                }
            });
        }
        function sy(a, b, c) {
            var d;
            return H(function(e) {
                if (e.h == 1) return e.g(a.m.Pg(b, !0, c), 2);
                a.h.variants = a.m.l;
                d = a.m.xh();
                d.length > 0 && (a.h.textStreams = d);
                a.h.imageStreams = a.m.i;
                a.j.filter(a.h);
                e.j();
            });
        }
        function ny(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K;
            return H(function(N) {
                if (N.h == 1) {
                    c = b.attributes.mpdId;
                    d = qe(b, "originalPublishTime", te);
                    if (!c || c !== a.l.Qf || d !== a.l.De) throw a.I = [], new T(1, 4, 4052);
                    e = [];
                    f = [];
                    g = new Set;
                    h = u(ge(b));
                    for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = Ce(l.attributes.sel || ""), n = m[m.length - 1], q = le(l) || "", n.name === "MPD") {
                        if (n.Kc === "mediaPresentationDuration") {
                            r = le(l) || "";
                            var P = ue(r);
                            if (P != null) {
                                a.l.Bc = P;
                                for(var M = u(a.A.values()), L = M.next(); !L.done; L = M.next())L.value.Bc = P;
                            }
                        } else if (n.Kc === "type") {
                            a.h.presentationTimeline.md(q == "static");
                            a.l.type = q;
                            P = u(a.A.values());
                            for(M = P.next(); !M.done; M = P.next())M.value.wb = q == "dynamic";
                            q == "static" && (a.L = -1);
                        } else n.Kc === "publishTime" ? a.l.De = te(q) || 0 : n.Kc === null && l.tagName === "add" && f.push(l);
                    } else if (n.name === "PatchLocation") De(a.I, l);
                    else if (n.name === "Period") l.tagName === "add" ? f.push(l) : l.tagName === "remove" && n.id && wy(a, n.id);
                    else if (n.name === "SegmentTemplate") {
                        M = Ce(l.attributes.sel || "");
                        P = M[M.length - 1];
                        if (P.Kc) {
                            M = xy(a, M);
                            L = le(l) || "";
                            for(var Q = u(M), S = Q.next(); !S.done; S = Q.next())S = a.A.get(S.value), Fe(S.N.Wc, l.tagName, P.Kc, L);
                            P = M;
                        } else P = [];
                        t = P;
                        v = u(t);
                        for(w = v.next(); !w.done; w = v.next())x = w.value, g.add(x);
                    } else if (n.name === "SegmentTimeline" || n.name === "S") {
                        P = Ce(l.attributes.sel || "");
                        P = xy(a, P);
                        M = u(P);
                        for(L = M.next(); !L.done; L = M.next())L = a.A.get(L.value), L = zw(L, bx, "SegmentTimeline"), Q = ie(L, "S"), De(Q, l), L.children = Q;
                        y = P;
                        z = u(y);
                        for(A = z.next(); !A.done; A = z.next())E = A.value, g.add(E);
                    }
                    C = u(g);
                    for(D = C.next(); !D.done; D = C.next())B = D.value, yy(a, B);
                    J = u(f);
                    for(F = J.next(); !F.done; F = J.next())I = F.value, e.push.apply(e, G(ry(a, {
                        wb: a.l.type == "dynamic",
                        presentationTimeline: a.h.presentationTimeline,
                        Ea: null,
                        sa: null,
                        za: null,
                        N: null,
                        bandwidth: 0,
                        Dh: !1,
                        sb: a.l.sb,
                        profiles: a.l.profiles,
                        Bc: a.l.Bc,
                        roles: null,
                        Mb: qy
                    }, a.l.ib, I, !0).periods));
                    if (!e.length) return N.B(2);
                    a.h.periodCount += e.length;
                    a.h.gapCount = a.O;
                    return N.g(sy(a, e, !0), 2);
                }
                a.l.type == "static" && (K = a.l.Bc, a.h.presentationTimeline.Ab(K || Infinity));
                N.j();
            });
        }
        function wy(a, b) {
            a.h.periodCount--;
            for(var c = u(a.A.keys()), d = c.next(); !d.done; d = c.next())if (d = d.value, d.startsWith(b)) {
                var e = a.A.get(d);
                zw(e, bx, "SegmentTimeline").children = [];
                yy(a, d);
                a.A.delete(d);
            }
            a.F = a.F.filter(function(f) {
                return f !== b;
            });
            a.H.delete(b);
        }
        function xy(a, b) {
            var c = "", d = "", e = -1, f = "";
            b = u(b);
            for(var g = b.next(); !g.done; g = b.next())g = g.value, g.name === "Period" ? c = g.id : g.name === "AdaptationSet" ? (d = g.id, g.position !== null && (e = g.position)) : g.name === "Representation" && (f = g.id);
            b = [];
            if (f) b.push(c + "," + f);
            else if (d) for(e = u(a.A.values()), a = e.next(); !a.done; a = e.next())a = a.value, a.Ea.id === c && a.za.id === d && a.N.id && b.push(c + "," + a.N.id);
            else if (e > -1) for(d = u(a.A.values()), a = d.next(); !a.done; a = d.next())a = a.value, a.Ea.id === c && a.za.position === e && a.N.id && b.push(c + "," + a.N.id);
            return b;
        }
        function yy(a, b) {
            var c = a.A.get(b), d = a.o.get(b);
            d.segmentIndex && d.segmentIndex.$a(a.h.presentationTimeline.Hb());
            try {
                var e = ax(c, function(f, g, h, k) {
                    return zy(a, f, g, h, k);
                }, a.o, !0, a.g.dash.initialSegmentLimit, a.ya, c.N.aesKey, null, !0, a.D);
                d.createSegmentIndex = function() {
                    return H(function(f) {
                        if (f.h == 1) return d.segmentIndex ? f.B(0) : f.g(e.cd(), 3);
                        d.segmentIndex = f.i;
                        f.j();
                    });
                };
            } catch (f) {
                if (b = c.N.contentType, b != Ec && b != "application" && b != "image" || f.code != 4002) throw f;
            }
        }
        function ry(a, b, c, d, e) {
            var f = b.Bc;
            f || (f = qe(d, "mediaPresentationDuration", ue), a.l.Bc = f);
            var g = 0;
            a.h && a.h.presentationTimeline && a.V && (g = a.h.presentationTimeline.cc());
            var h = [], k = g;
            d = ie(d, "Period");
            var l = b.wb;
            l || a.H.clear();
            for(var m = l && !e ? new Set(a.F.slice(1, -1)) : null, n = 0; n < d.length; n++){
                var q = d[n], r = d[n + 1], t = qe(q, "start", ue, k), v = q.attributes.id, w = qe(q, "duration", ue);
                t = n == 0 && t == 0 && a.V ? g : t;
                var x = null;
                if (r) {
                    var y = qe(r, "start", ue);
                    y != null && (x = y - t + g);
                } else f != null && (x = f - t + g);
                y = Hc;
                x && w && Math.abs(x - w) > y && x > w && a.O++;
                x == null && (x = w);
                if (!(a.P !== null && v != null && t !== null && t < a.P) || a.F.includes(v) || n + 1 == d.length) {
                    t !== null && (a.P === null || t > a.P) && (a.P = t);
                    k = {
                        start: t,
                        duration: x,
                        node: q,
                        Ff: x == null || !r
                    };
                    q = null;
                    r = n > 0 && n < d.length - 1;
                    l && m && r && !e && (v != null || (v = "__shaka_period_" + t), m.has(v) && (v = a.H.get(v)) && (q = v));
                    q || (q = Ay(a, b, c, k), l && q.id && a.H.set(q.id, q));
                    h.push(q);
                    q.id && x && a.ya.set(q.id, x);
                    if (x == null) {
                        k = null;
                        break;
                    }
                    k = t + x;
                }
            }
            l && !e && By(a, h);
            if (e) for(b = u(h), c = b.next(); !c.done; c = b.next())c = c.value.id, a.F.includes(c) || a.F.push(c);
            else a.F = h.map(function(z) {
                return z.id;
            });
            return f != null ? {
                periods: h,
                duration: f + g,
                Wi: !1
            } : {
                periods: h,
                duration: k,
                Wi: !0
            };
        }
        function By(a, b) {
            b = new Set(b.map(function(e) {
                return e.id;
            }));
            for(var c = u(Array.from(a.H.keys())), d = c.next(); !d.done; d = c.next())d = d.value, b.has(d) || a.H.delete(d);
        }
        function uy(a) {
            var b = Array.from(a.G.keys()).filter(function(h) {
                return !a.F.includes(h);
            });
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value;
                for(var d = !0, e = u(a.G.get(c)), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = a.o.get(f);
                    g && (g.segmentIndex && g.segmentIndex.getNumReferences() != 0 ? d = !1 : (a.m && a.m.Ui(g, c), a.o.delete(f)));
                }
                d && a.G.delete(c);
            }
        }
        function vy(a, b) {
            b = new Set(b.map(function(e) {
                return e.id;
            }));
            for(var c = u(a.D.keys()), d = c.next(); !d.done; d = c.next())d = d.value, b.has(d) || a.D.delete(d);
        }
        function Ay(a, b, c, d) {
            b.Ea = Cy(a, d.node, null, c);
            b.sa = d;
            b.Ea.sb = b.sb;
            b.Ea.id || (b.Ea.id = "__shaka_period_" + d.start);
            var e = ie(d.node, "EventStream");
            c = b.presentationTimeline.Hb();
            e = u(e);
            for(var f = e.next(); !f.done; f = e.next())Dy(a, d.start, d.duration, f.value, c);
            c = ie(d.node, "SupplementalProperty");
            c = u(c);
            for(e = c.next(); !e.done; e = c.next())if (e = e.value, e.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014" && (e = Ey(a, e))) b.Mb = e;
            c = ie(d.node, "AdaptationSet").map(function(r, t) {
                return Fy(a, b, t, r);
            }).filter(Zf);
            if (b.wb) {
                e = [];
                f = u(c);
                for(var g = f.next(); !g.done; g = f.next()){
                    g = u(g.value.lm);
                    for(var h = g.next(); !h.done; h = g.next())e.push(h.value);
                }
                if (e.length != new Set(e).size) throw new T(2, 4, 4018);
            }
            e = new Map;
            f = u(c);
            for(g = f.next(); !g.done; g = f.next())for(g = u(g.value.Bk), h = g.next(); !h.done; h = g.next()){
                var k = u(h.value);
                h = k.next().value;
                k = k.next().value;
                e.set(h, k);
            }
            if (e.size) for(f = null, g = u(c), h = g.next(); !h.done; h = g.next()){
                h = h.value;
                k = [];
                for(var l = u(h.streams), m = l.next(), n = {}; !m.done; n = {
                    pi: void 0
                }, m = l.next())if (n.pi = m.value, e.has(n.pi.originalId)) {
                    f || (f = ie(d.node, "AdaptationSet").map(function(r, t) {
                        return Fy(a, b, t, r);
                    }).filter(Zf));
                    m = u(f);
                    for(var q = m.next(); !q.done; q = m.next())if (q = q.value.streams.find(function(r) {
                        return function(t) {
                            return t.originalId == r.pi.originalId;
                        };
                    }(n))) q.dependencyStream = e.get(q.originalId), q.originalId += q.dependencyStream.originalId, k.push(q);
                }
                k.length && h.streams.push.apply(h.streams, G(k));
            }
            d = u(cd(c, function(r) {
                return !!r.fk;
            }));
            c = d.next().value;
            d = d.next().value;
            if (!a.g.disableIFrames) {
                for(c = u(c), e = c.next(); !e.done; e = c.next())for(e = e.value, f = e.fk.split(" "), g = u(d), h = g.next(); !h.done; h = g.next())if (h = h.value, f.includes(h.id)) for(h = u(h.streams), k = h.next(); !k.done; k = h.next())Ng(k.value, e.streams);
            }
            c = Gy(a.g.disableAudio, d, "audio");
            e = Gy(a.g.disableVideo, d, "video");
            f = Gy(a.g.disableText, d, Ec);
            d = Gy(a.g.disableThumbnails, d, "image");
            if (e.length === 0 && c.length === 0) throw new T(2, 4, 4004);
            return {
                id: b.Ea.id,
                audioStreams: c,
                videoStreams: e,
                textStreams: f,
                imageStreams: d
            };
        }
        function Gy(a, b, c) {
            return a || !b.length ? [] : b.reduce(function(d, e) {
                if (e.contentType != c) return d;
                d.push.apply(d, G(e.streams));
                return d;
            }, []);
        }
        function Fy(a, b, c, d) {
            function e(K) {
                var N = K.attributes["dvb:fontFamily"];
                K = K.attributes["dvb:url"];
                N && K && (K = vc(b.za.ib(), [
                    K
                ], b.Mb()), a.j.addFont(N, K[0]));
            }
            function f(K) {
                switch(K){
                    case 1:
                    case 5:
                    case 6:
                    case 7:
                        return "srgb";
                    case 9:
                        return "rec2020";
                    case 11:
                    case 12:
                        return "p3";
                }
            }
            function g(K) {
                switch(K){
                    case 1:
                    case 6:
                    case 13:
                    case 14:
                    case 15:
                        return "SDR";
                    case 16:
                        return "PQ";
                    case 18:
                        return "HLG";
                }
            }
            b.za = Cy(a, d, b.Ea, null);
            b.za.position = c;
            var h = !1;
            c = ie(d, "Role");
            var k = c.map(function(K) {
                return K.attributes.value;
            }).filter(Zf), l = void 0, m = b.za.contentType == Ec;
            m && (l = "subtitle");
            c = u(c);
            for(var n = c.next(); !n.done; n = c.next()){
                n = n.value;
                var q = n.attributes.schemeIdUri;
                if (q == null || q == "urn:mpeg:dash:role:2011") switch(n = n.attributes.value, n){
                    case "main":
                        h = !0;
                        break;
                    case "caption":
                    case "subtitle":
                        l = n;
                }
            }
            var r = ie(d, "EssentialProperty");
            c = null;
            var t = !1;
            n = null;
            q = !1;
            r = u(r);
            for(var v = r.next(); !v.done; v = r.next()){
                v = v.value;
                var w = v.attributes.schemeIdUri;
                if (w == "http://dashif.org/guidelines/trickmode") c = v.attributes.value;
                else if (w == "urn:mpeg:mpegB:cicp:TransferCharacteristics") var x = g(parseInt(v.attributes.value, 10));
                else if (w == "urn:mpeg:mpegB:cicp:ColourPrimaries") var y = f(parseInt(v.attributes.value, 10));
                else w != "urn:mpeg:mpegB:cicp:MatrixCoefficients" && (w == "urn:mpeg:dash:ssr:2023" && a.g.dash.enableFastSwitching ? t = !0 : w == "urn:dvb:dash:fontdownload:2014" ? e(v) : w == "urn:mpeg:dash:urlparam:2014" ? (n = Ey(a, v)) || (q = !0) : q = !0);
            }
            if (q) return null;
            var z = null;
            q = ie(d, "SupplementalProperty");
            q = u(q);
            for(r = q.next(); !r.done; r = q.next())r = r.value, v = r.attributes.schemeIdUri, v == "http://dashif.org/guidelines/last-segment-number" ? z = parseInt(r.attributes.value, 10) - 1 : v == "urn:mpeg:mpegB:cicp:TransferCharacteristics" ? x = g(parseInt(r.attributes.value, 10)) : v == "urn:mpeg:mpegB:cicp:ColourPrimaries" ? y = f(parseInt(r.attributes.value, 10)) : v == "urn:dvb:dash:fontdownload:2014" ? e(r) : v == "urn:mpeg:dash:urlparam:2014" && (n = Ey(a, r));
            n && (b.Mb = n);
            n = ie(d, "Accessibility");
            var A = new Map, E;
            n = u(n);
            for(q = n.next(); !q.done; q = n.next())if (r = q.value, q = r.attributes.schemeIdUri, r = r.attributes.value, q != "urn:scte:dash:cc:cea-608:2015" || a.g.disableText) {
                if (q != "urn:scte:dash:cc:cea-708:2015" || a.g.disableText) q == "urn:mpeg:dash:role:2011" ? r != null && (k.push(r), r == "captions" && (l = "caption")) : q == "urn:tva:metadata:cs:AudioPurposeCS:2007" && (r == "1" ? E = "visually impaired" : r == "2" ? E = "hard of hearing" : r == "9" && (E = "spoken subtitles"));
                else if (q = 1, r != null) for(r = u(r.split(";")), v = r.next(); !v.done; v = r.next()){
                    w = v.value;
                    var C = v = void 0;
                    w.includes("=") ? (w = w.split("="), v = "svc" + w[0], C = w[1].split(",")[0].split(":").pop()) : (v = "svc" + q, q++, C = w);
                    A.set(v, Kc(C));
                }
                else A.set("svc1", "und");
            } else if (q = 1, r != null) for(r = r.split(";"), v = u(r), w = v.next(); !w.done; w = v.next()){
                C = w.value;
                var D = w = void 0;
                C.includes("=") ? (C = C.split("="), w = C[0].startsWith("CC") ? C[0] : "CC" + C[0], D = C[1] || "und") : (w = "CC" + q, r.length == 2 ? q += 2 : q++, D = C);
                A.set(w, Kc(D));
            }
            else A.set("CC1", "und");
            n = ie(d, "ContentProtection");
            var B = ow(a.va, n, a.g.ignoreDrmInfo, a.g.dash.keySystemsByURI);
            b.za.encrypted = n.length > 0;
            var J = Kc(b.za.language || "und"), F = b.za.label, I = new Map;
            d = ie(d, "Representation");
            if (!a.g.ignoreSupplementalCodecs) {
                n = [];
                q = u(d);
                for(r = q.next(); !r.done; r = q.next())if (v = r.value, r = re(v, "urn:scte:dash:scte214-extensions", "supplementalCodecs")) v = Xd(v), v.attributes.codecs = r.split(" ").join(","), v.attributes.id && (v.attributes.supplementalId = v.attributes.id + "_supplementalCodecs"), n.push(v);
                d.push.apply(d, G(n));
            }
            n = d.map(function(K) {
                var N = Hy(a, b, B, l, J, F, h, k, A, K, E, z);
                return N && (N.hdr = N.hdr || x, N.colorGamut = N.colorGamut || y, N.fastSwitching = t, K = K.attributes.dependencyId) ? (N.baseOriginalId = K, I.set(K, N), null) : N;
            }).filter(function(K) {
                return !!K;
            });
            if (n.length == 0 && I.size == 0) {
                c = b.za.contentType == "image";
                if (a.g.dash.ignoreEmptyAdaptationSet || m || c) return null;
                throw new T(2, 4, 4003);
            }
            if (!b.za.contentType || b.za.contentType == "application") for(b.za.contentType = Iy(n[0].mimeType, n[0].codecs), m = u(n), q = m.next(); !q.done; q = m.next())q.value.type = b.za.contentType;
            m = b.za.id || "__fake__" + a.Ia++;
            q = u(n);
            for(r = q.next(); !r.done; r = q.next()){
                r = r.value;
                v = u(B.drmInfos);
                for(w = v.next(); !w.done; w = v.next())w = w.value, w.keyIds = w.keyIds && r.keyIds ? new Set([].concat(G(w.keyIds), G(r.keyIds))) : w.keyIds || r.keyIds;
                a.g.enableAudioGroups && (r.groupId = m);
            }
            d = d.map(function(K) {
                return K.attributes.supplementalId || K.attributes.id;
            }).filter(Zf);
            return {
                id: m,
                contentType: b.za.contentType,
                language: J,
                Un: h,
                streams: n,
                drmInfos: B.drmInfos,
                fk: c,
                lm: d,
                Bk: I
            };
        }
        function Ey(a, b) {
            if ((b = oe(b, "urn:mpeg:dash:schema:urlparam:2014", "UrlQueryInfo")) && qe(b, "useMPDUrlQuery", Ae, !1)) {
                var c = b.attributes.queryTemplate;
                if (c) return function() {
                    return c == "$querypart$" ? a.X : c.split("&").map(function(d) {
                        if (d == "$querypart$") return a.X;
                        var e = /\$query:(.*?)\$/g.exec(d);
                        if (e && e.length == 2) {
                            e = e[1];
                            var f = new rb(a.X).get(e);
                            if (f.length) return e + "=" + f[0];
                        }
                        return d;
                    }).join("&");
                };
            }
            return null;
        }
        function Hy(a, b, c, d, e, f, g, h, k, l, m, n) {
            b.N = Cy(a, l, b.za, null);
            var q = b.N.id;
            a.$ = Math.min(a.$, b.N.sb);
            a.S = a.$ > 0;
            if (!Jy(b.N)) return null;
            var r = b.sa.start;
            b.bandwidth = qe(l, "bandwidth", xe) || 0;
            b.roles = h;
            var t = ie(l, "SupplementalProperty"), v = ie(l, "EssentialProperty"), w = ie(l, "ContentProtection");
            l = null;
            var x = v.find(function(M) {
                return M.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014";
            });
            x ? l = Ey(a, x) : (x = t.find(function(M) {
                return M.attributes.schemeIdUri == "urn:mpeg:dash:urlparam:2014";
            })) && (l = Ey(a, x));
            l && (b.Mb = l);
            x = b.N.contentType;
            l = x == Ec || x == "application";
            x = x == "image";
            w.length && (b.za.encrypted = !0);
            try {
                var y = void 0;
                if (c.Hg) {
                    var z = b.N.ib, A = b.Mb, E = vc(z(), [
                        c.Hg.Ll
                    ], A()), C = mh(E, a.g.retryParameters);
                    y = {
                        bitsKey: 128,
                        blockCipherMode: "CBC",
                        iv: c.Hg.iv,
                        firstMediaSequenceNumber: 0,
                        fetchKey: function() {
                            var M, L, Q;
                            return H(function(S) {
                                if (S.h == 1) return S.g(ly(a, C, 6), 2);
                                if (S.h != 3) {
                                    M = S.i;
                                    if (!M.data || M.data.byteLength != 16) throw new T(2, 4, 4049);
                                    L = {
                                        name: "AES-CBC"
                                    };
                                    Q = y;
                                    return S.g(window1.crypto.subtle.importKey("raw", M.data, L, !0, [
                                        "decrypt"
                                    ]), 3);
                                }
                                Q.cryptoKey = S.i;
                                y.fetchKey = void 0;
                                S.j();
                            });
                        }
                    };
                }
                b.N.aesKey = y;
                z = function(M, L, Q, S) {
                    return zy(a, M, L, Q, S);
                };
                if (b.N.Vd) var D = Qw(b, z, y);
                else if (b.N.Hc) D = Ww(b, a.o, y);
                else if (b.N.Wc) D = ax(b, z, a.o, !!a.h, a.g.dash.initialSegmentLimit, a.ya, y, n, !1, a.D);
                else {
                    var B = b.sa.duration || 0, J = b.N.ib, F = b.N.mimeType, I = b.N.codecs;
                    D = {
                        endTime: -1,
                        timeline: -1,
                        cd: function() {
                            var M = xm(r, B, J());
                            M.xb(function(L) {
                                L.mimeType = F;
                                L.codecs = I;
                            });
                            return Promise.resolve(M);
                        },
                        timescale: 1
                    };
                }
            } catch (M) {
                if ((l || x) && M.code == 4002) return null;
                throw M;
            }
            n = sw(a.va, w, c, a.g.ignoreDrmInfo, a.g.dash.keySystemsByURI);
            n = new Set(n ? [
                n
            ] : []);
            w = t.some(function(M) {
                return M.attributes.schemeIdUri == "tag:dolby.com,2018:dash:EC3_ExtensionType:2018" && M.attributes.value == "JOC";
            });
            t = t.some(function(M) {
                return M.attributes.schemeIdUri == "tag:dolby.com,2016:dash:virtualized_content:2016" && M.attributes.value == "1";
            });
            t = w || t;
            w = !1;
            l && (w = h.includes("forced_subtitle") || h.includes("forced-subtitle"));
            var K;
            if (x && ((v = v.find(function(M) {
                return [
                    "http://dashif.org/thumbnail_tile",
                    "http://dashif.org/guidelines/thumbnail_tile"
                ].includes(M.attributes.schemeIdUri);
            })) && (K = v.attributes.value), !K)) return null;
            var N;
            l = b.N.codecs;
            b.profiles.includes("http://dashif.org/guidelines/dash-if-uhd#hevc-hdr-pq10") && (l.includes("hvc1.2.4.L153.B0") || l.includes("hev1.2.4.L153.B0")) && (N = "PQ");
            v = b.N.id ? b.Ea.id + "," + b.N.id : "";
            a.I.length && q && a.A.set(b.Ea.id + "," + q, Ky(b));
            b.N.Wf && Ly(a, b.N.Wf, D, b.presentationTimeline);
            D.endTime != -1 && b.Ea.id != null && b.N.id != null && ((q = a.D.get(b.Ea.id)) ? (q.endTime = D.endTime, q.Yh.includes(b.N.id) || q.Yh.push(b.N.id), a.D.set(b.Ea.id, q)) : a.D.set(b.Ea.id, {
                endTime: D.endTime,
                timeline: D.timeline,
                Yh: [
                    b.N.id
                ]
            }));
            var P = v && a.o.has(v) ? a.o.get(v) : {
                id: a.Ia++,
                originalId: b.N.id,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                closeSegmentIndex: function() {
                    P.segmentIndex && (P.segmentIndex.release(), P.segmentIndex = null);
                },
                segmentIndex: null,
                mimeType: b.N.mimeType,
                codecs: l,
                frameRate: b.N.frameRate,
                pixelAspectRatio: b.N.pixelAspectRatio,
                bandwidth: b.bandwidth,
                width: b.N.width,
                height: b.N.height,
                kind: d,
                encrypted: c.drmInfos.length > 0,
                drmInfos: c.drmInfos,
                keyIds: n,
                language: e,
                originalLanguage: b.za.language,
                label: f,
                type: b.za.contentType,
                primary: g,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: b.N.emsgSchemeIdUris,
                roles: h,
                forced: w,
                channelsCount: b.N.Tf,
                audioSamplingRate: b.N.audioSamplingRate,
                spatialAudio: t,
                closedCaptions: k,
                hdr: N,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: K,
                accessibilityPurpose: m,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set([
                    wf(b.N.mimeType, b.N.codecs)
                ]),
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            P.createSegmentIndex = function() {
                var M;
                return H(function(L) {
                    if (L.h == 1) {
                        if (P.segmentIndex) return L.B(0);
                        M = P;
                        return L.g(D.cd(), 3);
                    }
                    M.segmentIndex = L.i;
                    L.j();
                });
            };
            v && b.wb && !a.o.has(v) && (b = b.Ea.id || "", a.G.has(b) || a.G.set(b, []), a.o.set(v, P), a.G.get(b).push(v));
            return P;
        }
        function Ly(a, b, c, d) {
            if (!a.ba.has(b)) {
                a.ba.add(b);
                var e = qe(b, "presentationTime", ye) || 0, f = ne(b, "UTCTiming"), g;
                if (g = f && f.attributes.schemeIdUri) f = f.attributes.schemeIdUri, g = !(f === "urn:mpeg:dash:utc:http-ntp:2014" || f === "urn:mpeg:dash:utc:ntp:2014" || f === "urn:mpeg:dash:utc:sntp:2014");
                g ? b = (qe(b, "wallClockTime", te) || 0) * 1E3 : (b = qe(b, "wallClockTime", ye) || 0, b = sk(b));
                c = new Date(b - e / c.timescale * 1E3);
                e = c.getTime() / 1E3;
                isNaN(e) || (d.o || d.ki(e), d = (new Map).set("detail", {
                    wallClockTime: b,
                    programStartDate: c
                }), d = new R("prft", d), a.j.onEvent(d));
            }
        }
        function Ky(a) {
            function b(c) {
                if (!c) return null;
                c = Yd(c);
                c.Vd = null;
                c.Hc = null;
                c.Wc = He(c.Wc);
                c.Wf = null;
                return c;
            }
            a = Yd(a);
            a.Ea = b(a.Ea);
            a.za = b(a.za);
            a.N = b(a.N);
            a.sa && (a.sa = Yd(a.sa), a.sa.node = null);
            return a;
        }
        function hy(a) {
            var b, c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return b = 0, d.m(2), d.g(iy(a), 4);
                    case 4:
                        b = d.i;
                        d.o(3);
                        break;
                    case 2:
                        if (c = d.l(), a.j) {
                            if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.j.onError(c), d.return();
                            c.severity = 1;
                            a.j.onError(c);
                        }
                    case 3:
                        if (!a.j) return d.return();
                        a.j.onManifestUpdated();
                        jy(a, b);
                        d.j();
                }
            });
        }
        function jy(a, b) {
            if (!(a.L < 0)) {
                var c = a.L;
                a.g.updatePeriod >= 0 && (c = a.g.updatePeriod);
                a.M.Z(Math.max(c - b, Yc(a.Ga)));
            }
        }
        function Cy(a, b, c, d) {
            c = c || {
                contentType: "",
                mimeType: "",
                codecs: "",
                emsgSchemeIdUris: [],
                frameRate: void 0,
                pixelAspectRatio: void 0,
                Tf: null,
                audioSamplingRate: null,
                sb: 0,
                fg: 1,
                encrypted: !1
            };
            d = d || c.ib;
            var e = b.attributes.id, f = b.attributes.supplementalId, g = ie(b, "BaseURL"), h, k = !1;
            if (a.i) for(var l = u(g), m = l.next(); !m.done; m = l.next()){
                var n = m.value;
                m = n.attributes.serviceLocation;
                n = le(n);
                m && n && (qx(a.i, e, m, n), k = !0);
            }
            k && a.i || (h = g.map(le));
            var q = a.i;
            a = b.attributes.contentType || c.contentType;
            l = b.attributes.mimeType || c.mimeType;
            m = bn([
                b.attributes.codecs || c.codecs
            ]).join(",");
            n = qe(b, "frameRate", Be) || c.frameRate;
            var r = b.attributes.sar || c.pixelAspectRatio, t = My(ie(b, "InbandEventStream"), c.emsgSchemeIdUris), v = ie(b, "AudioChannelConfiguration");
            v = Ny(v) || c.Tf;
            var w = qe(b, "audioSamplingRate", ye) || c.audioSamplingRate;
            a || (a = Iy(l, m));
            var x = ne(b, "SegmentBase"), y = ne(b, "SegmentTemplate"), z = x ? qe(x, "availabilityTimeOffset", ze) || 0 : 0, A = y ? qe(y, "availabilityTimeOffset", ze) || 0 : 0, E = g && g.length ? qe(g[0], "availabilityTimeOffset", ze) || 0 : 0;
            z = c.sb + E + z + A;
            A = null;
            (E = ne(b, "SegmentSequenceProperties")) && (E = qe(E, "cadence", xe)) && (A = E);
            E = b.attributes.label;
            var C = ie(b, "Label");
            C && C.length && (C = C[0], ke(C) && (E = ke(C)));
            return {
                ib: function() {
                    return vc(d(), g.length ? q && k ? rx(q, e) : h ? h : [] : []);
                },
                Vd: x || c.Vd,
                Hc: ne(b, "SegmentList") || c.Hc,
                Wc: y || c.Wc,
                Wf: ne(b, "ProducerReferenceTime") || c.Wf,
                width: qe(b, "width", ye) || c.width,
                height: qe(b, "height", ye) || c.height,
                contentType: a,
                mimeType: l,
                codecs: m,
                frameRate: n,
                pixelAspectRatio: r,
                emsgSchemeIdUris: t,
                id: f || e,
                originalId: e,
                language: b.attributes.lang,
                Tf: v,
                audioSamplingRate: w,
                sb: z,
                Bf: null,
                fg: A || c.fg,
                label: E || null,
                encrypted: !1
            };
        }
        function My(a, b) {
            b = b.slice();
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())c = c.value.attributes.schemeIdUri, b.includes(c) || b.push(c);
            return b;
        }
        function Ny(a) {
            a = u(a);
            for(var b = a.next(); !b.done; b = a.next()){
                b = b.value;
                var c = b.attributes.schemeIdUri;
                if (c && (b = b.attributes.value)) switch(c){
                    case "urn:mpeg:dash:outputChannelPositionList:2012":
                        return b.trim().split(/ +/).length;
                    case "urn:mpeg:dash:23003:3:audio_channel_configuration:2011":
                    case "urn:dts:dash:audio_channel_configuration:2012":
                        b = parseInt(b, 10);
                        if (!b) continue;
                        return b;
                    case "tag:dolby.com,2015:dash:audio_channel_configuration:2015":
                        c = [
                            2,
                            1,
                            2,
                            2,
                            2,
                            2,
                            1,
                            2,
                            2,
                            1,
                            1,
                            1,
                            1,
                            2,
                            1,
                            1,
                            2,
                            2
                        ];
                        b = parseInt(b, 16);
                        if (!b) continue;
                        for(var d = 0, e = 0; e < c.length; e++)b & 1 << e && (d += c[e]);
                        if (d) return d;
                        continue;
                    case "tag:dolby.com,2014:dash:audio_channel_configuration:2011":
                    case "urn:dolby:dash:audio_channel_configuration:2011":
                        c = [
                            1,
                            1,
                            1,
                            1,
                            1,
                            2,
                            2,
                            1,
                            1,
                            2,
                            2,
                            2,
                            1,
                            2,
                            1,
                            1
                        ].reverse();
                        b = parseInt(b, 16);
                        if (!b) continue;
                        for(e = d = 0; e < c.length; e++)b & 1 << e && (d += c[e]);
                        if (d) return d;
                        continue;
                    case "urn:mpeg:mpegB:cicp:ChannelConfiguration":
                        if (c = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            8,
                            2,
                            3,
                            4,
                            7,
                            8,
                            24,
                            8,
                            12,
                            10,
                            12,
                            14,
                            12,
                            14
                        ], (b = parseInt(b, 10)) && b > 0 && b < c.length) return c[b];
                }
            }
            return null;
        }
        function Jy(a) {
            var b = a.Vd ? 1 : 0;
            b += a.Hc ? 1 : 0;
            b += a.Wc ? 1 : 0;
            if (b == 0) return a.contentType == Ec || a.contentType == "application" ? !0 : !1;
            b != 1 && (a.Vd && (a.Hc = null), a.Wc = null);
            return !0;
        }
        function Oy(a, b, c, d) {
            var e, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) return e = [
                    jc(c)
                ], f = vc(b(), e), g = mh(f, a.g.retryParameters), g.method = d, h = a.j.networkingEngine.request(4, g, {
                    isPreload: a.na()
                }), gh(a.R, h), n.g(h.promise, 2);
                k = n.i;
                if (d == "HEAD") {
                    if (!k.headers || !k.headers.date) return n.return(0);
                    l = k.headers.date;
                } else l = bc(k.data);
                m = Date.parse(l);
                return isNaN(m) ? n.return(0) : n.return(m - Date.now());
            });
        }
        function ty(a, b, c) {
            var d, e, f, g, h, k, l, m;
            return H(function(n) {
                switch(n.h){
                    case 1:
                        d = c.map(function(q) {
                            return {
                                scheme: q.attributes.schemeIdUri,
                                value: q.attributes.value
                            };
                        }), e = a.g.dash.clockSyncUri, !d.length && e && d.push({
                            scheme: "urn:mpeg:dash:utc:http-head:2014",
                            value: e
                        }), f = u(d), g = f.next();
                    case 2:
                        if (g.done) {
                            n.B(4);
                            break;
                        }
                        h = g.value;
                        n.m(5);
                        k = h.scheme;
                        l = h.value;
                        switch(k){
                            case "urn:mpeg:dash:utc:http-head:2014":
                            case "urn:mpeg:dash:utc:http-head:2012":
                                return n.B(7);
                            case "urn:mpeg:dash:utc:http-xsdate:2014":
                            case "urn:mpeg:dash:utc:http-iso:2014":
                            case "urn:mpeg:dash:utc:http-xsdate:2012":
                            case "urn:mpeg:dash:utc:http-iso:2012":
                                return n.B(8);
                            case "urn:mpeg:dash:utc:direct:2014":
                            case "urn:mpeg:dash:utc:direct:2012":
                                return m = Date.parse(l), n.return(isNaN(m) ? 0 : m - Date.now());
                            case "urn:mpeg:dash:utc:http-ntp:2014":
                            case "urn:mpeg:dash:utc:ntp:2014":
                            case "urn:mpeg:dash:utc:sntp:2014":
                                Za("NTP UTCTiming scheme is not supported");
                                break;
                            default:
                                Za("Unrecognized scheme in UTCTiming element", k);
                        }
                        n.B(9);
                        break;
                    case 7:
                        return n.g(Oy(a, b, l, "HEAD"), 10);
                    case 10:
                        return n.return(n.i);
                    case 8:
                        return n.g(Oy(a, b, l, "GET"), 11);
                    case 11:
                        return n.return(n.i);
                    case 9:
                        n.o(3);
                        break;
                    case 5:
                        n.l();
                    case 3:
                        g = f.next();
                        n.B(2);
                        break;
                    case 4:
                        return Za("A UTCTiming element should always be given in live manifests! This content may not play on clients with bad clocks!"), n.return(0);
                }
            });
        }
        function Dy(a, b, c, d, e) {
            var f = d.attributes.schemeIdUri || "", g = d.attributes.value || "", h = qe(d, "timescale", ye) || 1, k = qe(d, "presentationTimeOffset", ye) || 0;
            d = u(ie(d, "Event"));
            for(var l = d.next(); !l.done; l = d.next()){
                l = l.value;
                var m = qe(l, "presentationTime", ye) || 0, n = qe(l, "duration", ye) || 0;
                m = Math.max((m - k) / h + b, b);
                n = m + n / h;
                c != null && (m = Math.min(m, b + c), n = Math.min(n, b + c));
                n < e || (l = {
                    schemeIdUri: f,
                    value: g,
                    startTime: m,
                    endTime: n,
                    id: l.attributes.id || "",
                    timescale: h,
                    eventElement: Ge(l),
                    eventNode: He(l)
                }, a.j.onTimelineRegionAdded(l));
            }
        }
        function zy(a, b, c, d, e) {
            var f, g, h, k;
            return H(function(l) {
                if (l.h == 1) return f = sh, g = e ? 0 : 1, h = jn(b, c, d, a.g.retryParameters), l.g(ly(a, h, f, {
                    type: g
                }), 2);
                k = l.i;
                return l.return(k.data);
            });
        }
        function Iy(a, b) {
            b = wf(a, b);
            return Mf(b) ? Ec : a.split("/")[0];
        }
        function ly(a, b, c, d) {
            d || (d = {});
            d.isPreload = a.na();
            b = a.j.networkingEngine.request(c, b, d);
            gh(a.R, b);
            return b.promise;
        }
        function ky(a) {
            var b = a.l.De;
            if (!a.l.Qf || !b || !a.I.length) return [];
            var c = Date.now() / 1E3, d = a.I.filter(function(e) {
                e = ye(e.attributes.ttl);
                return !e || b + e > c;
            }).map(le).filter(Zf);
            return d.length ? vc(a.C, d) : [];
        }
        function qy() {
            return "";
        }
        function py(a, b, c) {
            return function() {
                return a && b ? rx(a, "BaseURL") : c.slice();
            };
        }
        O("shaka.dash.DashParser", gy);
        xd("application/dash+xml", function() {
            return new gy;
        });
        xd("video/vnd.mpeg.dash.mpd", function() {
            return new gy;
        });
        function Py() {}
        O("shaka.dependencies", Py);
        Py.has = function(a) {
            return Qy.has(a);
        };
        Py.add = function(a, b) {
            if (!Ry[a]) throw Error(a + " is not supported");
            a == Sy ? md("mux.js", "mux.js is no longer used in Shaka Player.") : Qy.set(a, function() {
                return b;
            });
        };
        var Sy = "muxjs", Ry = {
            Vn: Sy,
            ISOBoxer: "ISOBoxer"
        };
        Py.Allowed = Ry;
        var Qy = new Map([
            [
                "ISOBoxer",
                function() {
                    return window1.ISOBoxer;
                }
            ]
        ]);
        function Ty() {
            this.j = new Kb(function() {
                for(var a = navigator.userAgent.toLowerCase(), b = u([
                    {
                        type: "VR",
                        Xh: /oculus|quest/
                    },
                    {
                        type: "TV",
                        Xh: /smart[ _]?tv|android ?tv/
                    },
                    {
                        type: "MOBILE",
                        Xh: /iphone|ipad|ipod|android/
                    }
                ]), c = b.next(); !c.done; c = b.next())if (c = c.value, c.Xh.test(a)) return c.type;
                a = navigator.userAgentData;
                var d;
                b = (a == null ? void 0 : (d = a.platform) == null ? void 0 : d.toLowerCase()) || "";
                if (a) {
                    if (a.mobile) return "MOBILE";
                    if (b.includes("android")) return "TV";
                }
                return "DESKTOP";
            });
            this.l = new Kb(function() {
                var a = navigator.userAgent;
                return navigator.vendor.includes("Apple") && (a.includes("Version/") || a.includes("OS/")) ? "WEBKIT" : a.includes("Edge/") ? "EDGE" : a.includes("Chrome/") ? "CHROMIUM" : a.includes("Firefox/") ? "GECKO" : "UNKNOWN";
            });
        }
        function Ad() {
            var a = window1.ManagedMediaSource || window1.MediaSource;
            return a && a.isTypeSupported ? !0 : !1;
        }
        p = Ty.prototype;
        p.mc = function() {
            return !!navigator.mediaCapabilities;
        };
        p.Pa = function() {
            return this.j.value();
        };
        p.Ma = function() {
            return this.l.value();
        };
        p.Sd = function() {
            return !1;
        };
        p.$h = function() {
            return !1;
        };
        p.Cf = function() {
            return !1;
        };
        p.Cj = function() {
            return !1;
        };
        p.Fe = function() {
            return !1;
        };
        p.pd = function() {
            return !0;
        };
        p.Bb = function() {
            var a = window1.ManagedSourceBuffer || window1.SourceBuffer;
            return !!a && !!a.prototype && !!a.prototype.changeType;
        };
        p.Je = function() {
            return !0;
        };
        p.Hj = function() {
            return 0;
        };
        p.vc = function() {
            return Promise.resolve({
                width: Infinity,
                height: Infinity
            });
        };
        p.Tj = function() {
            return !1;
        };
        p.ni = function() {
            return !1;
        };
        p.cb = function(a) {
            var b = this.Pa();
            if (b === "TV" || b === "CONSOLE" || b === "CAST") a.ads.customPlayheadTracker = !0, a.ads.skipPlayDetection = !0, a.ads.supportsMultipleMediaElements = !1;
            return a;
        };
        p.si = function() {
            return !!window1.indexedDB;
        };
        p.Aj = function() {
            return [];
        };
        p.Dd = function(a) {
            return window1.matchMedia !== void 0 && (window1.matchMedia("(color-gamut: p3)").matches || window1.matchMedia("(dynamic-range: high)").matches) ? a ? "HLG" : "PQ" : "SDR";
        };
        p.lg = function() {
            return !1;
        };
        p.rj = function() {
            return !1;
        };
        p.cg = function() {
            return !1;
        };
        p.ng = function() {
            return !0;
        };
        p.sj = function() {
            return !1;
        };
        p.bk = function() {
            return !0;
        };
        p.od = function() {
            return !1;
        };
        p.Nh = function(a) {
            return a === "com.apple.fps";
        };
        p.mg = function() {
            return !0;
        };
        p.toString = function() {
            return "Device: " + this.Pb() + " v" + this.Ja() + "; Type: " + this.Pa();
        };
        function Uy() {
            Ty.call(this);
            this.g = new Kb(function() {
                var a = navigator.userAgent.match(/Version\/(\d+)(?:\.(\d+))?/);
                a || (a = navigator.userAgent.match(/OS (\d+)(?:_(\d+))?/));
                return a ? [
                    parseInt(a[1], 10),
                    parseInt(a[2] || "0", 10)
                ] : [
                    0,
                    0
                ];
            });
            this.h = new Kb(function() {
                return /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 ? "xr" in navigator ? "APPLE_VR" : "MOBILE" : "xr" in navigator ? "APPLE_VR" : "DESKTOP";
            });
        }
        oa(Uy, Ty);
        p = Uy.prototype;
        p.Ja = function() {
            return this.g.value()[0];
        };
        p.Pb = function() {
            return "Apple Browser";
        };
        p.Pa = function() {
            return this.h.value();
        };
        p.Ma = function() {
            return "WEBKIT";
        };
        p.mc = function() {
            return !1;
        };
        p.Sd = function(a, b) {
            return !Vy(this) && b === "audio";
        };
        p.Cf = function() {
            return !Vy(this);
        };
        p.Cj = function(a) {
            return !Vy(this) && a === "audio";
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.abr.minTimeToSwitch = .5;
            return a;
        };
        p.lg = function() {
            return !0;
        };
        p.mg = function() {
            return !1;
        };
        function Vy(a) {
            a = a.g.value();
            return a[0] >= 27 ? !0 : a[0] === 26 && a[1] >= 4;
        }
        (navigator.vendor || "").includes("Apple") && (/(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 || navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform.toLowerCase() == "macos" || navigator.platform && navigator.platform.toLowerCase().includes("mac")) && (Zb = function() {
            return new Uy;
        });
        function Wy() {
            if (!Xy()) throw Error("Not a Chromecast device!");
            Ty.call(this);
            this.h = new Kb(function() {
                var a = navigator.userAgent.match(/Chrome\/(\d+)/);
                return a ? parseInt(a[1], 10) : null;
            });
            this.g = new Kb(function() {
                var a = navigator.userAgentData && navigator.userAgentData.platform || navigator.userAgent;
                a = a.toLowerCase();
                return a.includes("android") ? Yy : a.includes("fuchsia") ? Zy : $y;
            });
        }
        oa(Wy, Ty);
        p = Wy.prototype;
        p.Ja = function() {
            return this.h.value();
        };
        p.Pb = function() {
            return "Chromecast with " + this.g.value();
        };
        p.Pa = function() {
            return "CAST";
        };
        p.Ma = function() {
            return "CHROMIUM";
        };
        p.mc = function() {
            return Ty.prototype.mc.call(this) && this.g.value() !== $y;
        };
        p.Bb = function() {
            return Ty.prototype.Bb.call(this) && this.g.value() !== $y;
        };
        p.Hj = function() {
            switch(this.g.value()){
                case Yy:
                    return 0;
                case Zy:
                    return 3;
                default:
                    return 1;
            }
        };
        p.vc = function() {
            var a, b, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        a = window1.cast && cast.__platform__ && cast.__platform__.canDisplayType;
                        b = {
                            width: 1280,
                            height: 720
                        };
                        f.m(2);
                        if (!(c = a)) {
                            f.B(4);
                            break;
                        }
                        return f.g(cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=3840; height=2160'), 5);
                    case 5:
                        c = f.i;
                    case 4:
                        if (c) {
                            b.width = 3840;
                            b.height = 2160;
                            f.B(6);
                            break;
                        }
                        if (!(d = a)) {
                            f.B(7);
                            break;
                        }
                        return f.g(cast.__platform__.canDisplayType('video/mp4; codecs="avc1.640028"; width=1920; height=1080'), 8);
                    case 8:
                        d = f.i;
                    case 7:
                        d && (b.width = 1920, b.height = 1080);
                    case 6:
                        f.o(3);
                        break;
                    case 2:
                        e = f.l(), Ya("Failed to check canDisplayType:", e);
                    case 3:
                        return f.return(b);
                }
            });
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.streaming.stallSkip = 0;
            return a;
        };
        p.si = function() {
            return !1;
        };
        p.od = function() {
            return !0;
        };
        function Xy() {
            return navigator.userAgent.includes("CrKey") && !navigator.userAgent.includes("VIZIO SmartCast");
        }
        var Yy = "Android", Zy = "Fuchsia", $y = "Linux";
        Xy() && (Zb = function() {
            return new Wy;
        });
        function az() {
            Ty.call(this);
            var a = this;
            this.i = new Kb(function() {
                var b = navigator.userAgent.match(/(Chrome|Firefox)\/(\d+)/);
                return b ? parseInt(b[2], 10) : null;
            });
            this.g = new Kb(function() {
                return navigator.userAgent.match(/Edge?\//) ? "Edge" : navigator.userAgent.includes("Chrome") ? "Chrome" : navigator.userAgent.includes("Firefox") ? "Firefox" : "Unknown";
            });
            this.h = new Kb(function() {
                return navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "windows" : navigator.platform ? navigator.platform.toLowerCase().includes("win32") : !1;
            });
            this.A = new Kb(function() {
                return Ty.prototype.Bb.call(a) ? navigator.userAgent.match(/Edge?\//) ? !a.h.value() : !0 : !1;
            });
            this.o = new Kb(function() {
                return navigator.userAgent.includes("sony.hbbtv.tv");
            });
            this.m = new Kb(function() {
                return navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform.toLowerCase() == "android" : navigator.userAgent.includes("Android") ? !0 : !1;
            });
        }
        oa(az, Ty);
        p = az.prototype;
        p.Ja = function() {
            return this.i.value();
        };
        p.Pb = function() {
            return this.g.value();
        };
        p.Sd = function(a) {
            return Qb(a) ? this.g.value() === "Edge" && this.h.value() : !1;
        };
        p.$h = function() {
            return this.g.value() === "Edge" && this.h.value();
        };
        p.Cf = function() {
            return this.g.value() === "Edge" && this.h.value();
        };
        p.Bb = function() {
            return this.A.value();
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            if (this.h.value()) switch(this.g.value()){
                case "Firefox":
                    a.drm.keySystemsMapping = {
                        "com.microsoft.playready": "com.microsoft.playready.recommendation"
                    };
                    break;
                case "Chrome":
                    a.drm.keySystemsMapping = {
                        "com.microsoft.playready": "com.microsoft.playready.recommendation.3000",
                        "com.microsoft.playready.recommendation": "com.microsoft.playready.recommendation.3000"
                    };
            }
            this.m.value() && (a.drm.defaultAudioRobustnessForWidevine = "SW_SECURE_CRYPTO", a.drm.defaultVideoRobustnessForWidevine = "SW_SECURE_CRYPTO");
            return a;
        };
        p.cg = function() {
            return this.g.value() === "Edge" || this.o.value();
        };
        p.od = function() {
            if (this.Ma() === "GECKO") {
                var a = this.Ja();
                return a !== null ? a >= 100 : Ty.prototype.od.call(this);
            }
            return Ty.prototype.od.call(this);
        };
        p.Nh = function(a) {
            return this.Ma() === "GECKO" ? a.startsWith("com.microsoft.playready.recommendation") : Ty.prototype.Nh.call(this, a);
        };
        $b = function() {
            return new az;
        };
        function bz() {
            Ty.apply(this, arguments);
        }
        oa(bz, Ty);
        p = bz.prototype;
        p.Ja = function() {
            return null;
        };
        p.Pb = function() {
            return "Hisense";
        };
        p.Pa = function() {
            return "TV";
        };
        p.mc = function() {
            return !1;
        };
        p.Bb = function() {
            return !1;
        };
        p.vc = function() {
            var a = {
                width: 1920,
                height: 1080
            }, b = null;
            if (window1.Hisense_Get4KSupportState) try {
                b = window1.Hisense_Get4KSupportState();
            } catch (c) {}
            b == null && (b = navigator.userAgent.includes("UHD"));
            b && (a.width = 3840, a.height = 2160);
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.streaming.stallSkip = 0;
            return a;
        };
        if (navigator.userAgent.includes("Hisense") || navigator.userAgent.includes("VIDAA")) Zb = function() {
            return new bz;
        };
        function cz() {
            Ty.call(this);
            this.g = new Kb(function() {
                var a = navigator.userAgent.match(/PlayStation (\d+)/);
                return a ? parseInt(a[1], 10) : null;
            });
        }
        oa(cz, Ty);
        p = cz.prototype;
        p.Pb = function() {
            return "PlayStation";
        };
        p.Pa = function() {
            return "CONSOLE";
        };
        p.Ma = function() {
            return "WEBKIT";
        };
        p.Ja = function() {
            return this.g.value();
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            return !1;
        };
        p.Bb = function() {
            return !1;
        };
        p.ni = function() {
            return this.Ja() === 4;
        };
        p.vc = function() {
            var a, b, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return a = {
                            width: 1920,
                            height: 1080
                        }, b = !1, f.m(2), f.g(window1.msdk.device.getDisplayInfo(), 4);
                    case 4:
                        c = f.i;
                        b = c.resolution === "4K";
                        f.o(3);
                        break;
                    case 2:
                        return f.l(), f.m(5), f.g(window1.msdk.device.getDisplayInfoImmediate(), 7);
                    case 7:
                        d = f.i;
                        b = d.resolution === "4K";
                        f.o(3);
                        break;
                    case 5:
                        e = f.l(), Za("PlayStation: Failed to get the display info:", e);
                    case 3:
                        return b && (a.width = 3840, a.height = 2160), f.return(a);
                }
            });
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            this.Ja() === 4 && a.drm.preferredKeySystems.push("com.microsoft.playready");
            a.streaming.clearDecodingCache = !0;
            return a;
        };
        p.cg = function() {
            return this.Ja() === 4;
        };
        p.ng = function() {
            return this.Ja() !== 4;
        };
        navigator.userAgent.includes("PlayStation") && (Zb = function() {
            return new cz;
        });
        function dz() {
            Ty.call(this);
            var a = navigator.userAgent.match(/Tizen (\d+).(\d+)/);
            this.g = a ? parseInt(a[1], 10) : null;
            this.h = a ? parseInt(a[2], 10) : null;
        }
        oa(dz, Ty);
        p = dz.prototype;
        p.Ja = function() {
            return this.g;
        };
        p.Pb = function() {
            return "Tizen";
        };
        p.Ma = function() {
            return "CHROMIUM";
        };
        p.Pa = function() {
            return "TV";
        };
        p.Sd = function() {
            return !0;
        };
        p.Fe = function() {
            return this.Ja() === 3;
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            var a = this.Ja();
            return a !== null ? a >= 4 : Ty.prototype.pd.call(this);
        };
        p.Bb = function() {
            return !1;
        };
        p.Je = function() {
            return this.g && this.h ? this.g === 5 ? this.h >= 5 : this.g > 5 : Ty.prototype.Je.call(this);
        };
        p.vc = function() {
            var a = window1.devicePixelRatio;
            a = {
                width: window1.screen.width * a > 1920 ? 3840 : 1920,
                height: window1.screen.height * a > 1080 ? 2160 : 1080
            };
            try {
                if (webapis.systeminfo && webapis.systeminfo.getMaxVideoResolution) {
                    var b = webapis.systeminfo.getMaxVideoResolution();
                    a.width = b.width;
                    a.height = b.height;
                } else webapis.productinfo.is8KPanelSupported && webapis.productinfo.is8KPanelSupported() ? (a.width = 7680, a.height = 4320) : webapis.productinfo.isUdPanelSupported && webapis.productinfo.isUdPanelSupported() && (a.width = 3840, a.height = 2160);
            } catch (c) {
                Za("Tizen: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.drm.ignoreDuplicateInitData = this.Ja() !== 2;
            this.Ja() === 3 && (a.streaming.crossBoundaryStrategy = "reset_to_encrypted");
            a.streaming.shouldFixTimestampOffset = !0;
            a.streaming.stallSkip = 0;
            a.streaming.gapPadding = 2;
            return a;
        };
        p.Aj = function() {
            var a = [];
            this.g !== null && this.g < 5 && a.push("opus");
            return a;
        };
        p.Dd = function(a) {
            try {
                if (webapis.avinfo.isHdrTvSupport()) return a ? "HLG" : "PQ";
            } catch (b) {
                return Ty.prototype.Dd.call(this, a);
            }
            return "SDR";
        };
        p.rj = function() {
            return !0;
        };
        p.sj = function() {
            return this.Ja() === 3;
        };
        navigator.userAgent.includes("Tizen") && (Zb = function() {
            return new dz;
        });
        function ez() {
            Ty.apply(this, arguments);
        }
        oa(ez, Ty);
        ez.prototype.Ja = function() {
            return null;
        };
        ez.prototype.Pb = function() {
            return "Vizio";
        };
        ez.prototype.Pa = function() {
            return "TV";
        };
        ez.prototype.mc = function() {
            return !1;
        };
        navigator.userAgent.includes("VIZIO SmartCast") && (Zb = function() {
            return new ez;
        });
        function fz() {
            Ty.call(this);
            this.i = new Kb(function() {
                return navigator.userAgent.includes("DT_STB_BCM") || navigator.userAgent.includes("Sky_STB");
            });
            this.h = new Kb(function() {
                return navigator.userAgent.includes("SOPOpenBrowser");
            });
            this.g = new Kb(function() {
                if (navigator.userAgent.includes("DT_STB_BCM")) return 11;
                var a = navigator.userAgent.match(/Version\/(\d+)/);
                return a ? parseInt(a[1], 10) : (a = navigator.userAgent.match(/OS (\d+)(?:_\d+)?/)) ? parseInt(a[1], 10) : null;
            });
        }
        oa(fz, Ty);
        p = fz.prototype;
        p.Ja = function() {
            return this.g.value();
        };
        p.Pb = function() {
            return "WebKit STB";
        };
        p.Pa = function() {
            return "TV";
        };
        p.Ma = function() {
            return "WEBKIT";
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            var a = this.g.value();
            return a !== null ? a >= 15 : !0;
        };
        p.Sd = function() {
            return this.h.value();
        };
        p.vc = function() {
            return Promise.resolve({
                width: window1.screen.width * window1.devicePixelRatio,
                height: window1.screen.height * window1.devicePixelRatio
            });
        };
        p.ng = function() {
            return !this.i.value();
        };
        p.mg = function() {
            return !1;
        };
        if (navigator.userAgent.includes("PlayStation") ? 0 : navigator.userAgent.includes("SOPOpenBrowser") || navigator.userAgent.includes("DT_STB_BCM") || navigator.userAgent.includes("Sky_STB") || !(!(navigator.vendor || "").includes("Apple") || /(?:iPhone|iPad|iPod)/.test(navigator.userAgent) || navigator.maxTouchPoints > 1 || navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform.toLowerCase() == "macos" || navigator.platform && navigator.platform.toLowerCase().includes("mac"))) Zb = function() {
            return new fz;
        };
        function gz() {
            Ty.call(this);
            var a = this;
            this.h = hz();
            this.g = null;
            try {
                var b = new PalmServiceBridge;
                b.onservicecallback = function(c) {
                    c = JSON.parse(c);
                    var d, e, f, g;
                    a.g = (g = (f = (d = c.configs) == null ? void 0 : d["tv.model.supportHDR"]) != null ? f : (e = c.configs) == null ? void 0 : e["tv.config.supportDolbyHDRContents"]) != null ? g : !1;
                };
                b.call("luna://com.webos.service.config/getConfigs", JSON.stringify({
                    configNames: [
                        "tv.model.supportHDR",
                        "tv.config.supportDolbyHDRContents"
                    ]
                }));
            } catch (c) {
                Za("WebOS: getConfigs call failed", c);
            }
        }
        oa(gz, Ty);
        p = gz.prototype;
        p.Ja = function() {
            return this.h;
        };
        p.Pb = function() {
            return "WebOS";
        };
        p.Pa = function() {
            return "TV";
        };
        p.Ma = function() {
            return "CHROMIUM";
        };
        p.mc = function() {
            return !1;
        };
        p.pd = function() {
            var a = this.Ja();
            return a !== null ? a > 3 : Ty.prototype.pd.call(this);
        };
        p.Bb = function() {
            return !1;
        };
        p.Je = function() {
            var a = this.Ja();
            return a !== null ? a > 3 : Ty.prototype.Je.call(this);
        };
        p.vc = function() {
            var a = {
                width: 1920,
                height: 1080
            };
            try {
                var b = JSON.parse(window1.PalmSystem.deviceInfo);
                a.width = Math.max(1920, b.screenWidth);
                a.height = Math.max(1080, b.screenHeight);
            } catch (c) {
                Za("WebOS: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            this.Ja() === 3 && (a.streaming.crossBoundaryStrategy = "reset");
            a.streaming.shouldFixTimestampOffset = !0;
            a.streaming.stallSkip = 0;
            return a;
        };
        p.Dd = function(a) {
            return this.g == null ? (Za("WebOS: getConfigs call haven't finished"), Ty.prototype.Dd.call(this, a)) : this.g ? a ? "HLG" : "PQ" : "SDR";
        };
        function hz() {
            var a = null, b = navigator.userAgent.match(/Chrome\/(\d+)/);
            b && (a = parseInt(b[1], 10));
            switch(a){
                case 38:
                    return 3;
                case 53:
                    return 4;
                case 68:
                    return 5;
                case 79:
                    return 6;
                case 87:
                    return 22;
                case 94:
                    return 23;
                case 108:
                    return 24;
                case 120:
                    return 25;
                case 132:
                    return 26;
                default:
                    return null;
            }
        }
        p.bk = function() {
            return !1;
        };
        p.od = function() {
            var a = this.Ja();
            return a !== null ? a >= 6 : Ty.prototype.od.call(this);
        };
        if (navigator.userAgent.includes("Web0S")) {
            var iz = new gz;
            Zb = function() {
                return iz;
            };
        }
        function jz() {
            Ty.call(this);
            this.g = navigator.userAgent.includes("Edge/");
            var a = navigator.userAgent.match(/Edge?\/(\d+)/);
            this.h = a ? parseInt(a[1], 10) : null;
        }
        oa(jz, Ty);
        p = jz.prototype;
        p.Ja = function() {
            return this.h;
        };
        p.Pb = function() {
            return "Xbox";
        };
        p.Pa = function() {
            return "CONSOLE";
        };
        p.Ma = function() {
            return this.g ? "EDGE" : "CHROMIUM";
        };
        p.Sd = function() {
            return !0;
        };
        p.$h = function() {
            return !0;
        };
        p.Cf = function() {
            return !0;
        };
        p.Tj = function() {
            return this.g;
        };
        p.vc = function() {
            var a = {
                width: 1920,
                height: 1080
            }, b = kz();
            if (b) try {
                var c = new b.Media.Protection.ProtectionCapabilities, d = b.Media.Protection.ProtectionCapabilityResult;
                b = null;
                do b = c.isTypeSupported('video/mp4;codecs="hvc1,mp4a";features="decode-res-x=3840,decode-res-y=2160,decode-bitrate=20000,decode-fps=30,decode-bpc=10,display-res-x=3840,display-res-y=2160,display-bpc=8"', "com.microsoft.playready.recommendation");
                while (b === d.maybe);
                b === d.probably && (a.width = 3840, a.height = 2160);
            } catch (e) {
                Za("Xbox: Error detecting screen size, default screen size 1920x1080.");
            }
            return Promise.resolve(a);
        };
        p.cb = function(a) {
            Ty.prototype.cb.call(this, a);
            a.drm.parseInbandPsshEnabled = this.g;
            a.drm.preferredKeySystems.push("com.microsoft.playready");
            this.g && (a.streaming.gapPadding = .01);
            return a;
        };
        p.cg = function() {
            return !0;
        };
        p.si = function() {
            return !1;
        };
        function kz() {
            var a = null;
            try {
                a = typeof Windows !== "undefined" ? Windows : chrome.webview.hostObjects.sync.Windows;
            } catch (b) {}
            return a;
        }
        if (navigator.userAgent.includes("Xbox One") || kz() !== null) Zb = function() {
            return new jz;
        };
        function lz(a, b, c) {
            this.type = a;
            this.ka = b;
            this.segments = c || null;
        }
        function mz(a, b, c, d) {
            this.id = a;
            this.name = b;
            this.attributes = c;
            this.value = d === void 0 ? null : d;
        }
        mz.prototype.toString = function(a) {
            function b(e) {
                return e.name + "=" + (isNaN(Number(e.value)) ? '"' + e.value + '"' : e.value);
            }
            var c = "#" + this.name, d = this.attributes ? this.attributes.filter(function(e) {
                return a ? !a.has(e.name) : !0;
            }).map(b) : [];
            this.value && d.unshift(this.value);
            d.length > 0 && (c += ":" + d.join(","));
            return c;
        };
        function nz(a, b) {
            if (b) return a.toString();
            b = (new Set).add("AUDIO").add("VIDEO").add("SUBTITLES").add("PATHWAY-ID").add("GROUP-ID").add("URI");
            return a.toString(b);
        }
        function oz(a, b) {
            return a.attributes.find(function(c) {
                return c.name === b;
            }) || null;
        }
        function pz(a, b, c) {
            return (a = oz(a, b)) ? a.value : c || null;
        }
        function qz(a, b) {
            a = oz(a, b);
            if (!a) throw new T(2, 4, 4023, b);
            return a.value;
        }
        function rz(a, b, c) {
            c = c === void 0 ? [] : c;
            this.ka = b;
            this.g = a;
            this.Dc = c;
        }
        function sz(a, b) {
            this.name = a;
            this.value = b;
        }
        function tz(a, b) {
            return a.filter(function(c) {
                return c.name == b;
            });
        }
        function uz(a, b) {
            return a.filter(function(c) {
                return qz(c, "TYPE") == b;
            });
        }
        function vz(a, b) {
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next())if (c = c.value, c.name === b) return c;
            return null;
        }
        function wz(a, b, c) {
            c = c === void 0 ? 0 : c;
            return (a = vz(a, b)) ? Number(a.value) : c;
        }
        function xz(a, b, c) {
            return b ? yz(a, [
                b
            ], c) : [];
        }
        function yz(a, b, c) {
            if (!b.length) return [];
            var d = b;
            c && c.size && (d = b.map(function(e) {
                return zz(e, c);
            }));
            return vc(a, d);
        }
        function zz(a, b) {
            if (!b || !b.size) return a;
            a = String(a).replace(/%7B/g, "{").replace(/%7D/g, "}");
            var c = a.match(/{\$\w*}/g);
            if (c) {
                c = u(c);
                for(var d = c.next(); !d.done; d = c.next()){
                    d = d.value;
                    var e = d.slice(2, d.length - 1), f = b.get(e);
                    if (f) a = a.replace(d, f);
                    else throw new T(2, 4, 4039, e);
                }
            }
            return a;
        }
        function Az(a) {
            a = a.value;
            var b = a.indexOf(",");
            return Number(b === -1 ? a : a.substring(0, b));
        }
        function Bz() {
            this.g = 0;
        }
        function Cz(a, b) {
            var c = bc(b).trim().split(/[\r\n]+/);
            if (!c[0].startsWith("#EXTM3U")) throw new T(2, 4, 4015);
            b = 0;
            for(var d = !1, e = [], f = !0, g = 0; g < c.length; g++){
                var h = c[g], k = c[g + 1];
                if (h.startsWith("#") && !h.startsWith("#EXT") || f) f = !1;
                else {
                    h = Dz(a, h);
                    d || (Ez.has(h.name) ? (b = 1, d = !0) : h.name == "EXT-X-STREAM-INF" || h.name == "EXT-X-MEDIA" ? d = !0 : Fz.has(h.name) && (b = 1, d = !0));
                    if (Fz.has(h.name)) {
                        if (b != 1) throw new T(2, 4, 4017);
                        f = a;
                        a = Array(Math.max(100, Math.floor((c.length - g) / 2)));
                        d = 0;
                        h = [];
                        var l = [];
                        for(k = null; g < c.length; g++){
                            var m = c[g];
                            if (m.startsWith("#EXT")) m = Dz(f, m), Ez.has(m.name) ? e.push(m) : m.name == "EXT-X-MAP" ? k = m : m.name == "EXT-X-PART" ? l.push(m) : m.name == "EXT-X-PRELOAD-HINT" ? pz(m, "TYPE") == "PART" ? l.push(m) : pz(m, "TYPE") == "MAP" && (m.name = "EXT-X-MAP", k = m) : h.push(m);
                            else if (!m.startsWith("#") || m.startsWith("#EXT")) m = m.trim(), k && h.push(k), h = new rz(m, h, l), d < a.length ? a[d++] = h : (a.push(h), d++), h = [], l = [];
                        }
                        l.length && (k && h.push(k), c = new rz("", h, l), d < a.length ? a[d++] = c : (a.push(c), d++));
                        return new lz(b, e, d < a.length ? a.slice(0, d) : a);
                    }
                    e.push(h);
                    h.name == "EXT-X-STREAM-INF" && (h.attributes.push(new sz("URI", k)), f = !0);
                }
            }
            return new lz(b, e);
        }
        function Dz(a, b) {
            a = a.g++;
            var c = b.indexOf(":"), d = c === -1 ? b.substring(1) : b.substring(1, c);
            if (!d.startsWith("EXT")) throw new T(2, 4, 4016, b);
            b = c === -1 ? null : b.substring(c + 1);
            if (b === null) a = new mz(a, d, []);
            else if (b.indexOf("=") === -1) a = new mz(a, d, [], b);
            else {
                c = [];
                var e = null, f = 0, g = b.indexOf(","), h = b.indexOf("=");
                g !== -1 && g < h && (e = b.substring(0, g), f = g + 1);
                for(; f < b.length;){
                    for(; b[f] === " ";)f++;
                    h = b.indexOf("=", f);
                    if (h === -1) break;
                    g = b.substring(f, h);
                    f = h + 1;
                    if (b[f] === '"') {
                        f++;
                        var k = b.indexOf('"', f);
                        h = k === -1 ? b.substring(f) : b.substring(f, k);
                        f = k === -1 ? b.length : k + 1;
                    } else k = b.indexOf(",", f), h = k === -1 ? b.substring(f) : b.substring(f, k), f = k === -1 ? b.length : k;
                    f < b.length && b[f] === "," && f++;
                    c.push(new sz(g, h));
                }
                a = new mz(a, d, c, e);
            }
            return a;
        }
        var Ez = new Set("EXT-X-TARGETDURATION EXT-X-MEDIA-SEQUENCE EXT-X-DISCONTINUITY-SEQUENCE EXT-X-PLAYLIST-TYPE EXT-X-I-FRAMES-ONLY EXT-X-ENDLIST EXT-X-SERVER-CONTROL EXT-X-SKIP EXT-X-PART-INF EXT-X-DATERANGE".split(" ")), Fz = new Set("EXTINF EXT-X-BYTERANGE EXT-X-DISCONTINUITY EXT-X-PROGRAM-DATE-TIME EXT-X-KEY EXT-X-DATERANGE EXT-X-MAP EXT-X-GAP EXT-X-TILES".split(" "));
        function Gz() {}
        function Hz(a, b) {
            try {
                var c = Iz(a);
                return bh({
                    uri: a,
                    originalUri: a,
                    data: c.data,
                    headers: {
                        "content-type": c.contentType
                    },
                    originalRequest: b
                });
            } catch (d) {
                return $g(d);
            }
        }
        function Iz(a) {
            if (!a.startsWith("data:")) throw new T(2, 1, 1004, a);
            var b = a.substring(5), c = b.indexOf(",");
            if (c < 0) throw new T(2, 1, 1004, a);
            a = b.substring(0, c);
            b = decodeURIComponent(b.substring(c + 1));
            c = a.split(";");
            a = c[0];
            var d = !1;
            c.length > 1 && c[c.length - 1].toLowerCase() == "base64" && (d = !0, c.pop());
            var e;
            d ? e = qc(b) : e = hc(b);
            return {
                data: e,
                contentType: a,
                Ai: c
            };
        }
        O("shaka.net.DataUriPlugin", Gz);
        Gz.parse = Hz;
        ih("data", Hz);
        function Jz() {
            var a = this;
            this.g = this.i = null;
            this.G = 1;
            this.F = new Map;
            this.L = new Map;
            this.o = new Map;
            this.o.set("video", new Map);
            this.o.set("audio", new Map);
            this.o.set(Ec, new Map);
            this.o.set("image", new Map);
            this.jc = (new Map).set("com.apple.streamingkeydelivery", function(b, c, d) {
                return Kz(a, b, c, d);
            }).set("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", function(b) {
                var c = qz(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    var e = qz(b, "URI");
                    c = Iz(e.split("?")[0]);
                    e = e.split("?")[0];
                    if (!a.I.has(e)) {
                        var f = Fb(c.data);
                        a.I.set(e, f);
                    }
                    d = yc("com.widevine.alpha", d, [
                        {
                            initDataType: "cenc",
                            initData: a.I.get(e)
                        }
                    ], void 0, c.Ai);
                    (b = pz(b, "KEYID")) && d.keyIds.add(b.toLowerCase().substr(2));
                    b = Promise.resolve(d);
                } else b = Promise.resolve(null);
                return b;
            }).set("com.microsoft.playready", function(b) {
                var c = qz(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    b = qz(b, "URI");
                    c = Iz(b.split("?")[0]);
                    b = Fb(c.data);
                    var e = new Uint8Array([
                        154,
                        4,
                        240,
                        121,
                        152,
                        64,
                        66,
                        134,
                        171,
                        146,
                        230,
                        91,
                        224,
                        136,
                        95,
                        149
                    ]);
                    e = Nh(b, e, new Set, 0);
                    d = yc("com.microsoft.playready", d, [
                        {
                            initDataType: "cenc",
                            initData: e
                        }
                    ], void 0, c.Ai);
                    if (b = ae([
                        "<PLAYREADY>",
                        mc(b),
                        "</PLAYREADY>"
                    ].join("\n"))) d.licenseServerUri = mw(b);
                    d = Promise.resolve(d);
                } else d = Promise.resolve(null);
                return d;
            }).set("urn:uuid:3d5e6d35-9b9a-41e8-b843-dd3c6e72c42c", function(b) {
                var c = qz(b, "METHOD");
                if ([
                    "SAMPLE-AES",
                    "SAMPLE-AES-CTR"
                ].includes(c)) {
                    var d = "cenc";
                    c == "SAMPLE-AES" && (d = "cbcs");
                    var e = qz(b, "URI");
                    c = Iz(e.split("?")[0]);
                    e = e.split("?")[0];
                    if (!a.I.has(e)) {
                        var f = Fb(c.data);
                        a.I.set(e, f);
                    }
                    d = yc("com.huawei.wiseplay", d, [
                        {
                            initDataType: "cenc",
                            initData: a.I.get(e)
                        }
                    ], void 0, c.Ai);
                    (b = pz(b, "KEYID")) && d.keyIds.add(b.toLowerCase().substr(2));
                    b = Promise.resolve(d);
                } else b = Promise.resolve(null);
                return b;
            });
            this.kb = new Set;
            this.j = new Map;
            this.m = null;
            this.H = "";
            this.hb = new Bz;
            this.M = -1;
            this.$ = Infinity;
            this.P = this.Gc = this.jb = !1;
            this.D = new Uf(function() {
                if (a.W && !a.g.continueLoadingWhenPaused && (a.V.Fa(a.W, "timeupdate"), a.W.paused)) {
                    a.V.ra(a.W, "timeupdate", function() {
                        return Lz(a);
                    });
                    return;
                }
                Lz(a);
            });
            this.Ga = Mz;
            this.h = null;
            this.ab = 0;
            this.C = Infinity;
            this.Oa = this.Ia = this.S = 0;
            this.X = new fh;
            this.J = new Map;
            this.K = new Map;
            this.ya = new Map;
            this.na = new Map;
            this.O = new Map;
            this.ua = new Map;
            this.va = new Map;
            this.Fc = this.ba = !1;
            this.Kb = new Xc(5);
            this.l = null;
            this.R = !0;
            this.V = new fd;
            this.A = this.W = null;
            this.hc = function() {
                return !1;
            };
            this.I = new Map;
        }
        p = Jz.prototype;
        p.configure = function(a, b) {
            var c = this.i && a.updatePeriod != this.g.updatePeriod && a.updatePeriod >= 0;
            this.g = a;
            b && (this.hc = b);
            this.l && this.l.configure(this.g);
            c && this.h && this.h.presentationTimeline.U() && this.D.La();
        };
        p.start = function(a, b) {
            var c = this, d;
            return H(function(e) {
                return e.h == 1 ? (c.i = b, c.ba = b.isLowLatencyMode(), e.g(Nz(c, [
                    a
                ]).promise, 2)) : e.h != 3 ? (d = e.i, c.H = d.uri, e.g(Oz(c, d.data), 3)) : e.return(c.h);
            });
        };
        p.stop = function() {
            this.D && (this.D.stop(), this.D = null);
            var a = [];
            this.X && (a.push(this.X.destroy()), this.X = null);
            this.g = this.i = null;
            this.kb.clear();
            this.h = null;
            this.j.clear();
            this.L.clear();
            this.K.clear();
            this.F.clear();
            this.ya.clear();
            this.na.clear();
            this.O.clear();
            this.ua.clear();
            this.va.clear();
            this.I.clear();
            this.l && this.l.destroy();
            this.V && (this.V.release(), this.V = null);
            return Promise.all(a);
        };
        p.update = function() {
            var a = this, b, c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                if (n.h == 1) {
                    if (!Pz(a)) return n.return();
                    b = [];
                    c = Array.from(a.j.values());
                    d = c.filter(function(q) {
                        return !q.stream.isAudioMuxedInVideo && q.stream.segmentIndex;
                    });
                    if (d.length === 0) return n.return();
                    a.C = Infinity;
                    a.h.gapCount = 0;
                    e = u(d);
                    for(f = e.next(); !f.done; f = e.next())g = f.value, b.push(Qz(a, g));
                    return n.g(Promise.all(b), 2);
                }
                Rz(a, d.map(function(q) {
                    return q.stream;
                }));
                h = d.some(function(q) {
                    return q.qe == 0;
                });
                d.length && !h && (Sz(a, Mz), Tz(a));
                h && Tz(a);
                k = u(d);
                for(l = k.next(); !l.done; l = k.next())m = l.value, m.stream.isAudioMuxedInVideo || !m.stream.segmentIndex || m.stream.segmentIndex.Fb() || a.i.disableStream(m.stream);
                n.j();
            });
        };
        function Uz(a, b) {
            return Pz(a) ? a.o.get(b.type) : b.Nf;
        }
        function Qz(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca;
            return H(function(ua) {
                switch(ua.h){
                    case 1:
                        if (b.stream.isAudioMuxedInVideo) return ua.return();
                        c = [];
                        d = u(b.T());
                        for(e = d.next(); !e.done; e = d.next())f = e.value, g = new lb(f), h = g.g, b.jf && (b.Ub >= 0 && h.add("_HLS_msn", String(b.Ub)), b.Vb >= 0 && h.add("_HLS_part", String(b.Vb))), b.kf && h.add("_HLS_skip", "YES"), c.push(g.toString());
                        ua.m(2);
                        return ua.g(Nz(a, c, !0).promise, 4);
                    case 4:
                        k = ua.i;
                        ua.o(3);
                        break;
                    case 2:
                        throw l = ua.l(), a.i && a.i.disableStream(b.stream), l;
                    case 3:
                        if (!b.stream.segmentIndex) return ua.return();
                        m = Cz(a.hb, k.data);
                        if (m.type != 1) throw new T(2, 4, 4017);
                        n = k.uri;
                        n == k.originalUri || b.T().includes(n) || b.Zf.push(n);
                        q = tz(m.ka, "EXT-X-DEFINE");
                        r = Vz(a, q, n);
                        t = b.stream;
                        v = Uz(a, b);
                        return ua.g(Wz(a, m, t.mimeType, b.T, r), 5);
                    case 5:
                        w = ua.i;
                        x = w.keyIds;
                        y = w.drmInfos;
                        z = w.encrypted;
                        A = w.Ii;
                        t.encrypted || !z || A || (t.encrypted = !0);
                        E = function(xa, Da) {
                            return xa.size === Da.size && [].concat(G(xa)).every(function(Ka) {
                                return Da.has(Ka);
                            });
                        };
                        E(t.keyIds, x) || (t.keyIds = x, t.drmInfos = y, a.i.newDrmInfo(t));
                        C = Xz(a, m, v, r, b.T, b.type);
                        D = C.segments;
                        if (B = C.bandwidth) t.bandwidth = B;
                        J = Km(t);
                        F = u(D);
                        for(I = F.next(); !I.done; I = F.next())K = I.value, K.ia && (K.ia.Kd = J);
                        t.segmentIndex.ye(D, a.m.Hb());
                        D.length && (N = wz(m.ka, "EXT-X-MEDIA-SEQUENCE", 0), M = (P = vz(m.ka, "EXT-X-SKIP")) ? Number(pz(P, "SKIPPED-SEGMENTS")) : 0, L = Yz(N, D), Q = L.Ub, S = L.Vb, b.Ub = Q + M, b.Vb = S, Z = v.get(N), t.segmentIndex.$a(Z));
                        if (pa = t.segmentIndex.Fb()) b.gd = pa.startTime, va = D[D.length - 1], b.Uc = va.endTime;
                        if (Ca = vz(m.ka, "EXT-X-ENDLIST")) b.qe = !0;
                        Zz(a, m);
                        $z(a, m.ka, t.type, r, b.T);
                        ua.j();
                }
            });
        }
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function() {};
        p.banLocation = function(a) {
            this.l && this.l.banLocation(a);
        };
        p.setMediaElement = function(a) {
            this.W = a;
        };
        function aA(a, b, c) {
            c = c === void 0 ? !1 : c;
            for(var d = a.M == -1, e = u(b), f = e.next(); !f.done; f = e.next()){
                f = f.value;
                var g = f.stream.segmentIndex, h = Uz(a, f);
                if (g = g.Fb()) {
                    h = u(h);
                    for(var k = h.next(); !k.done; k = h.next()){
                        k = u(k.value);
                        var l = k.next().value;
                        if (k.next().value == g.startTime) {
                            d && (a.M = Math.max(a.M, l));
                            f.Wg = l;
                            break;
                        }
                    }
                }
            }
            if (!(a.M < 0)) {
                for(b = u(b), d = b.next(); !d.done; d = b.next())if (d = d.value, bA(a, d.type) || c) {
                    if (e = d.stream.segmentIndex) {
                        if (f = a.M - d.Wg, f > 0 && (e.g.splice(0, f), e = e.Fb())) e = -e.startTime, d.stream.segmentIndex.offset(e), cA(a, d, e);
                    }
                }
            }
        }
        function dA(a, b) {
            if (a.$ == Infinity) {
                b = u(b);
                for(var c = b.next(); !c.done; c = b.next())c = c.value.stream.segmentIndex.Fb(), c != null && c.h != null && (a.$ = Math.min(a.$, c.h));
            }
            b = a.$;
            if (b != Infinity) {
                c = u(a.j.values());
                for(var d = c.next(); !d.done; d = c.next())if (d = d.value, !bA(a, d.type)) {
                    var e = d.stream.segmentIndex;
                    if (e != null) {
                        var f = e.Fb();
                        if (f) {
                            if (f.h == null) Ya("Missing EXT-X-PROGRAM-DATE-TIME for stream", d.T(), "Expect AV sync issues!");
                            else for(cA(a, d, f.h - b - f.startTime), d = u(e), e = d.next(); !e.done; e = d.next())e.value.ti(b);
                        }
                    }
                }
            }
        }
        function cA(a, b, c) {
            if (!(Math.abs(c) < .001)) {
                b.gd += c;
                b.Uc += c;
                a = Uz(a, b);
                for(var d = u(a), e = d.next(); !e.done; e = d.next()){
                    var f = u(e.value);
                    e = f.next().value;
                    f = f.next().value;
                    a.set(e, f + c);
                }
                b.T();
            }
        }
        function Oz(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja;
            return H(function(Aa) {
                switch(Aa.h){
                    case 1:
                        c = Gc;
                        d = Cz(a.hb, b);
                        e = tz(d.ka, "EXT-X-DEFINE");
                        f = [];
                        g = [];
                        h = [];
                        a.m = new Wl(null, 0);
                        a.m.md(!0);
                        k = function() {
                            return [
                                a.H
                            ];
                        };
                        l = null;
                        m = new Map;
                        a.h = {
                            presentationTimeline: a.m,
                            variants: f,
                            textStreams: g,
                            imageStreams: h,
                            offlineSessionIds: [],
                            sequenceMode: a.g.hls.sequenceMode,
                            ignoreManifestTimestampsInSegmentsMode: a.g.hls.ignoreManifestTimestampsInSegmentsMode,
                            type: "HLS",
                            serviceDescription: null,
                            nextUrl: null,
                            periodCount: 1,
                            gapCount: 0,
                            isLowLatency: !1,
                            startTime: a.A
                        };
                        if (d.type == 1) return a.R = !1, Q = tz(d.ka, "EXT-X-DEFINE"), m = Vz(a, Q, a.H), l = c.Ba, S = "", Z = new Map, Aa.g(eA(a, a.G++, m, d, k, "", l, S, !0, "Media Playlist", null, Z, null, !1, null, !1), 7);
                        fA(a, e);
                        n = tz(d.ka, "EXT-X-MEDIA");
                        q = tz(d.ka, "EXT-X-STREAM-INF");
                        r = tz(d.ka, "EXT-X-IMAGE-STREAM-INF");
                        t = tz(d.ka, "EXT-X-I-FRAME-STREAM-INF");
                        v = tz(d.ka, "EXT-X-SESSION-KEY");
                        w = tz(d.ka, "EXT-X-SESSION-DATA");
                        x = tz(d.ka, "EXT-X-CONTENT-STEERING");
                        gA(a, w);
                        return Aa.g(hA(a, x), 4);
                    case 4:
                        if (!a.g.ignoreSupplementalCodecs) {
                            y = [];
                            z = u(q);
                            A = z.next();
                            for(E = {}; !A.done; E = {
                                Zj: void 0
                            }, A = z.next())if (C = A.value, D = pz(C, "SUPPLEMENTAL-CODECS")) E.Zj = D.split(/\s*,\s*/).map(function(Ga) {
                                return Ga.split("/")[0];
                            }), B = C.attributes.map(function(Ga) {
                                return function(sb) {
                                    var Wb = sb.name, wb = sb.value;
                                    Wb == "CODECS" && (wb = Ga.Zj.join(","), sb = sb.value.split(","), sb.length > 1 && (sb = Cc("audio", sb)) && (wb += "," + sb));
                                    return new sz(Wb, wb);
                                };
                            }(E)), y.push(new mz(C.id, C.name, B, null));
                            q.push.apply(q, G(y));
                            J = [];
                            F = u(t);
                            I = F.next();
                            for(K = {}; !I.done; K = {
                                $j: void 0
                            }, I = F.next())if (N = I.value, P = pz(N, "SUPPLEMENTAL-CODECS")) K.$j = P.split(/\s*,\s*/).map(function(Ga) {
                                return Ga.split("/")[0];
                            }), M = N.attributes.map(function(Ga) {
                                return function(sb) {
                                    var Wb = sb.name;
                                    sb = sb.value;
                                    Wb == "CODECS" && (sb = Ga.$j.join(","));
                                    return new sz(Wb, sb);
                                };
                            }(K)), J.push(new mz(N.id, N.name, M, null));
                            t.push.apply(t, G(J));
                        }
                        iA(a, q);
                        jA(a, n);
                        L = kA(a, t);
                        return Aa.g(lA(a, q, v, n, k, a.F, L), 5);
                    case 5:
                        return f = Aa.i, g = mA(a, n), Aa.g(nA(a, r, t), 6);
                    case 6:
                        h = Aa.i;
                        Aa.B(3);
                        break;
                    case 7:
                        pa = Aa.i, a.j.set(a.H, pa), pa.stream && (va = Km(pa.stream), pa.stream.segmentIndex.xb(function(Ga) {
                            Ga.ia && (Ga.ia.Kd = va);
                        })), l = pa.stream.type, Ca = !0, a.g.disableAudio && pa.type == "audio" ? Ca = !1 : a.g.disableVideo && pa.type == "video" && !pa.stream.codecs.includes(",") && (Ca = !1), Ca && f.push({
                            id: 0,
                            language: Kc(S || "und"),
                            disabledUntilTime: 0,
                            primary: !0,
                            audio: pa.type == "audio" ? pa.stream : null,
                            video: pa.type == "video" ? pa.stream : null,
                            bandwidth: pa.stream.bandwidth || 0,
                            allowedByApplication: !0,
                            allowedByKeySystem: !0,
                            decodingInfos: []
                        });
                    case 3:
                        if (!a.i) throw new T(2, 7, 7001);
                        oA(a, d);
                        d.type == 1 && (Pz(a) && (pA(a, d), ua = a.C, a.D.Z(ua)), xa = Array.from(a.j.values()), qA(a, xa), Tz(a), $z(a, d.ka, l, m, k));
                        a.h.variants = f;
                        a.h.textStreams = g;
                        a.h.imageStreams = h;
                        a.h.startTime = a.A;
                        if (a.P || !a.g.hls.disableCodecGuessing) {
                            Aa.B(8);
                            break;
                        }
                        Da = [];
                        Ka = u(a.h.variants);
                        for(wa = Ka.next(); !wa.done; wa = Ka.next())Ja = wa.value, Ja.audio && Ja.audio.codecs === "" && Da.push(Ja.audio.createSegmentIndex()), Ja.video && Ja.video.codecs === "" && Da.push(Ja.video.createSegmentIndex());
                        return Aa.g(Promise.all(Da), 8);
                    case 8:
                        a.i.makeTextStreamsForClosedCaptions(a.h), Aa.j();
                }
            });
        }
        function rA(a, b) {
            var c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x;
            return H(function(y) {
                if (y.h == 1) {
                    c = $m(a.g.hls.mediaPlaylistFullMimeType);
                    if (!b.length) return y.return(c);
                    d = sA(a, b);
                    e = d.segment;
                    f = d.segmentIndex;
                    g = e.T();
                    if (h = gn(g[0])) {
                        if (k = tA.get(h)) return y.return($m(k));
                    }
                    return y.g(Promise.all([
                        uA(a, e.ia, 0),
                        uA(a, e, f)
                    ]), 2);
                }
                l = y.i;
                m = l[1].mimeType;
                n = l[0].data;
                q = l[1].data;
                r = "mp4 mp4a m4s m4i m4a m4f cmfa mp4v m4v cmfv fmp4".split(" ");
                t = [
                    "audio/mp4",
                    "video/mp4",
                    "video/iso.segment"
                ];
                v = e.ia || t.includes(m);
                if (!v && Rk(Fb(q))) {
                    var z = q, A = a.g.disableAudio, E = a.g.disableVideo, C = a.g.disableText;
                    var D = Fb(z);
                    var B = (new Ek).parse(D), J = B.me();
                    D = B.yh();
                    var F = [], I = !1, K = !1;
                    if (!A) switch(J.audio){
                        case "aac":
                        case "aac-loas":
                            B.yb().length && (F.push("mp4a.40.2"), I = !0);
                            break;
                        case "mp3":
                            B.yb().length && (F.push("mp4a.40.34"), I = !0);
                            break;
                        case "ac3":
                            B.yb().length && (F.push("ac-3"), I = !0);
                            break;
                        case "ec3":
                            B.yb().length && (F.push("ec-3"), I = !0);
                            break;
                        case "opus":
                            B.yb().length && (F.push("opus"), I = !0);
                    }
                    if (!E) switch(J.video){
                        case "avc":
                            D.codec ? F.push(D.codec) : F.push("avc1.42E01E");
                            K = !0;
                            break;
                        case "hvc":
                            D.codec ? F.push(D.codec) : F.push("hvc1.1.6.L93.90");
                            K = !0;
                            break;
                        case "av1":
                            F.push("av01.0.01M.08"), K = !0;
                    }
                    if (F.length) {
                        A = I && !K;
                        E = new Map;
                        if (K && !C) {
                            C = new Fd("video/mp2t");
                            Jd(C, z);
                            z = u(C.g.getStreams());
                            for(K = z.next(); !K.done; K = z.next())K = K.value, E.set(K, K);
                            C.g.clear();
                        }
                        D = {
                            type: A ? "audio" : "video",
                            mimeType: "video/mp2t",
                            codecs: F.join(", "),
                            language: null,
                            height: D.height,
                            width: D.width,
                            channelCount: null,
                            sampleRate: null,
                            closedCaptions: E,
                            Me: null,
                            colorGamut: null,
                            frameRate: D.frameRate,
                            timescale: null
                        };
                    } else D = null;
                    if (w = D) return y.return(w);
                } else if (v || r.includes(h)) {
                    if (x = an(n, q, a.g.disableText)) return y.return(x);
                }
                return m ? y.return($m(m)) : y.return(c);
            });
        }
        function uA(a, b, c) {
            var d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        if (!b) return l.return({
                            mimeType: null,
                            data: null
                        });
                        d = sh;
                        e = jn(b.T(), b.Qc(), b.Oc(), a.g.retryParameters);
                        f = b instanceof Oj ? 1 : 0;
                        return l.g(vA(a, e, d, {
                            type: f
                        }).promise, 2);
                    case 2:
                        g = l.i;
                        h = g.data;
                        if (!b.aesKey) {
                            l.B(3);
                            break;
                        }
                        return l.g(en(h, b.aesKey, c), 4);
                    case 4:
                        h = l.i;
                    case 3:
                        return b instanceof Oj ? b.He(h, !0) : b.He(h), (k = g.headers["content-type"]) && (k = k.split(";")[0].toLowerCase()), l.return({
                            mimeType: k,
                            data: h
                        });
                }
            });
        }
        function Tz(a) {
            if (Pz(a)) {
                if (a.Ga == wA) {
                    for(var b = Infinity, c = Infinity, d = u(a.j.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.stream.segmentIndex && e.stream.type != "text" && !e.stream.isAudioMuxedInVideo && (b = Math.min(b, e.Uc), c = Math.min(c, e.gd));
                    b = b - c || 0;
                    isNaN(a.g.availabilityWindowOverride) || (b = a.g.availabilityWindowOverride);
                    a.m.ig(b);
                }
            } else a.m.Ab(xA(a));
            if (!a.m.o) for(b = u(a.j.values()), c = b.next(); !c.done; c = b.next())c = c.value, !c.stream.segmentIndex || c.type != "audio" && c.type != "video" || (c = c.stream.segmentIndex.Fb()) && c.h != null && a.m.ki(c.h);
            a.m.Mf();
        }
        function fA(a, b) {
            var c = new lb(a.H).g;
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next()){
                var e = d.value;
                d = pz(e, "NAME");
                var f = pz(e, "VALUE");
                e = pz(e, "QUERYPARAM");
                d && f && (a.F.has(d) || a.F.set(d, f));
                e && (d = c.get(e)[0]) && !a.F.has(d) && a.F.set(e, d);
            }
        }
        function Vz(a, b, c) {
            c = new lb(c).g;
            var d = new Map;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                var f = e.value, g = pz(f, "NAME"), h = pz(f, "VALUE");
                e = pz(f, "QUERYPARAM");
                f = pz(f, "IMPORT");
                g && h && (d.has(g) || d.set(g, h));
                e && (g = c.get(e)[0]) && !d.has(g) && d.set(e, g);
                f && (e = a.F.get(f)) && d.set(f, e);
            }
            return d;
        }
        function iA(a, b) {
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = pz(d, "AUDIO");
                c = pz(d, "VIDEO");
                var f = pz(d, "SUBTITLES");
                d = yA(a, d);
                if (f) {
                    var g = Cc(Ec, d);
                    a.K.set(f, g);
                    ad(d, g);
                }
                e && (f = Cc("audio", d), f || (f = a.g.hls.defaultAudioCodec), a.K.set(e, f));
                c && (e = Cc("video", d), e || (e = a.g.hls.defaultVideoCodec), a.K.set(c, e));
            }
        }
        function gA(a, b) {
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = pz(d, "DATA-ID");
                c = pz(d, "URI");
                var f = pz(d, "LANGUAGE");
                d = pz(d, "VALUE");
                e = (new Map).set("id", e);
                c && e.set("uri", xz([
                    a.H
                ], c, a.F)[0]);
                f && e.set("language", f);
                d && e.set("value", d);
                c = new R("sessiondata", e);
                if (a.i) a.i.onEvent(c);
            }
        }
        function hA(a, b) {
            var c, d, e, f, g, h;
            return H(function(k) {
                if (!a.i || !a.g) return k.return();
                d = u(b);
                for(e = d.next(); !e.done; e = d.next())if (f = e.value, g = pz(f, "PATHWAY-ID"), h = pz(f, "SERVER-URI"), g && h) {
                    a.l = new mx(a.i);
                    a.l.configure(a.g);
                    a.l.i = [
                        a.H
                    ];
                    a.l.setManifestType("HLS");
                    a.l.h = g;
                    c = nx(a.l, h);
                    break;
                }
                return k.g(c, 0);
            });
        }
        function mA(a, b) {
            var c = uz(b, "SUBTITLES"), d = {};
            b = u(c);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = nz(e, !a.l);
                d[f] ? d[f].push(e) : d[f] = [
                    e
                ];
            }
            b = [];
            if (!a.g.disableText) for(var g in d)try {
                b.push(zA(a, d[g], new Map).stream);
            } catch (h) {
                if (!a.g.hls.ignoreTextStreamFailures) throw h;
            }
            g = u(c);
            for(c = g.next(); !c.done; c = g.next())if (d = qz(c.value, "GROUP-ID"), c = a.K.get(d)) {
                if (d = a.L.get(d)) for(d = u(d), e = d.next(); !e.done; e = d.next())e = e.value, e.stream.codecs = c, e.stream.mimeType = AA(Ec, c) || BA(Ec), CA(e.stream);
            }
            return b.filter(function(h) {
                return h;
            });
        }
        function CA(a) {
            var b = new Set([
                wf(a.mimeType, a.codecs)
            ]);
            a.segmentIndex && a.segmentIndex.xb(function(c) {
                c.mimeType && b.add(wf(c.mimeType, a.codecs));
            });
            a.fullMimeTypes = b;
        }
        function nA(a, b, c) {
            var d, e;
            return H(function(f) {
                if (f.h == 1) return d = b.map(function(g) {
                    var h, k, l;
                    return H(function(m) {
                        if (m.h == 1) {
                            if (h = a.g.disableThumbnails) return m.return(null);
                            m.m(2);
                            return m.g(DA(a, g), 4);
                        }
                        if (m.h != 2) return k = m.i, m.return(k.stream);
                        l = m.l();
                        if (a.g.hls.ignoreImageStreamFailures) return m.return(null);
                        throw l;
                    });
                }).concat(c.map(function(g) {
                    if (a.g.disableThumbnails) return null;
                    try {
                        var h = EA(a, g);
                        return h.stream.type !== "image" ? null : h.stream;
                    } catch (k) {
                        if (a.g.hls.ignoreImageStreamFailures) return null;
                        throw k;
                    }
                })), f.g(Promise.all(d), 2);
                e = f.i;
                return f.return(e.filter(function(g) {
                    return g;
                }));
            });
        }
        function FA(a, b, c) {
            b = b.filter(function(h) {
                var k = pz(h, "URI") || "";
                h = pz(h, "TYPE");
                return h != "SUBTITLES" && (k != "" || h == "AUDIO");
            });
            var d = {};
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = nz(e, !a.l);
                d[f] ? d[f].push(e) : d[f] = [
                    e
                ];
            }
            for(var g in d)zA(a, d[g], c, !1);
        }
        function kA(a, b) {
            return b.map(function(c) {
                c = EA(a, c);
                return c.stream.type !== "video" ? null : c.stream;
            }).filter(function(c) {
                return c;
            });
        }
        function lA(a, b, c, d, e, f, g) {
            var h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka;
            return H(function(wa) {
                switch(wa.h){
                    case 1:
                        h = [];
                        k = new Set;
                        if (a.g.ignoreDrmInfo || !(c.length > 0)) {
                            wa.B(2);
                            break;
                        }
                        l = u(c);
                        m = l.next();
                    case 3:
                        if (m.done) {
                            wa.B(2);
                            break;
                        }
                        n = m.value;
                        q = qz(n, "METHOD");
                        r = pz(n, "KEYFORMAT") || "identity";
                        t = null;
                        if (q == "NONE") {
                            wa.B(4);
                            break;
                        }
                        if (GA(q)) {
                            v = xz(e(), qz(n, "URI"), f);
                            w = v.sort().join("");
                            a.O.has(w) || (x = mh(v, a.g.retryParameters), y = vA(a, x, 6).promise, a.O.set(w, y));
                            wa.B(4);
                            break;
                        }
                        if (r == "identity") return wa.g(HA(a, n, "", e, null, f), 12);
                        z = a.jc.get(r);
                        if (!z) {
                            A = null;
                            wa.B(10);
                            break;
                        }
                        return wa.g(z(n, "", null), 11);
                    case 11:
                        A = wa.i;
                    case 10:
                        t = A;
                        wa.B(6);
                        break;
                    case 12:
                        t = wa.i;
                    case 6:
                        if (t) {
                            if (t.keyIds) for(E = u(t.keyIds), C = E.next(); !C.done; C = E.next())D = C.value, k.add(D);
                            h.push(t);
                        }
                    case 4:
                        m = l.next();
                        wa.B(3);
                        break;
                    case 2:
                        B = {};
                        J = u(b);
                        for(F = J.next(); !F.done; F = J.next())I = F.value, K = nz(I, !a.l), B[K] ? B[K].push(I) : B[K] = [
                            I
                        ];
                        N = [];
                        for(P in B)M = B[P], L = M[0], Q = pz(L, "FRAME-RATE"), S = Number(qz(L, "BANDWIDTH")) || Number(pz(L, "AVERAGE-BANDWIDTH")), Z = pz(L, "RESOLUTION"), pa = u(Z ? Z.split("x") : [
                            null,
                            null
                        ]), va = pa.next().value, Ca = pa.next().value, ua = pz(L, "VIDEO-RANGE"), (xa = pz(L, "REQ-VIDEO-LAYOUT")) && xa.includes(",") && (Da = xa.split(",").filter(function(Ja) {
                            return Ja == "CH-STEREO" || Ja == "CH-MONO";
                        }), xa = Da[0]), xa = xa || "CH-MONO", Ka = IA(a, M, d), N.push.apply(N, G(JA(a, Ka.audio, Ka.video, S, va, Ca, Q, ua, xa, h, k, g)));
                        return wa.return(N.filter(function(Ja) {
                            return Ja != null;
                        }));
                }
            });
        }
        function IA(a, b, c) {
            for(var d = {
                audio: [],
                video: []
            }, e = new Map, f = [], g = !1, h = !1, k = u(b), l = k.next(); !l.done; l = k.next()){
                var m = l.value;
                l = pz(m, "AUDIO");
                var n = pz(m, "VIDEO"), q = l || n;
                q && (f.includes(q) || f.push(q), (m = pz(m, "PATHWAY-ID")) && e.set(q, m), l ? g = !0 : n && (h = !0));
            }
            f.length && c.length && (c = c.filter(function(t) {
                return f.includes(qz(t, "GROUP-ID"));
            }), FA(a, c, e));
            c = (e = f.sort().join(",")) && a.L.has(e) ? a.L.get(e) : [];
            g ? d.audio.push.apply(d.audio, G(c)) : h && d.video.push.apply(d.video, G(c));
            h = !1;
            var r = b.map(function(t) {
                return qz(t, "URI");
            });
            g = d.audio.find(function(t) {
                return t && t.T().find(function(v) {
                    return r.includes(v);
                });
            });
            c = yA(a, b[0]);
            k = Cc("video", c);
            (l = Cc("audio", c)) && !k ? (g = "audio", h = d.audio.length > 0 && !d.audio.some(function(t) {
                return t.stream.isAudioMuxedInVideo;
            })) : !d.audio.length && !d.video.length && l && k ? (g = "video", c = [
                [
                    k,
                    l
                ].join()
            ]) : d.audio.length && g ? (g = "audio", h = !0) : g = d.video.length && !d.audio.length ? "audio" : "video";
            h || (b = KA(a, b, c, g), e && a.g.enableAudioGroups && (b.stream.groupId = e), b.stream.type == "audio" && g === "audio" && d.audio.some(function(t) {
                return t.stream.isAudioMuxedInVideo;
            }) && (a = d.audio[0].stream, b.stream.language = a.language, b.stream.channelsCount = a.channelsCount, b.stream.label = a.label, b.stream.audioSamplingRate = a.audioSamplingRate, b.stream.originalId = a.originalId, b.stream.originalLanguage = a.originalLanguage), d[b.stream.type] = [
                b
            ]);
            return d;
        }
        function yA(a, b) {
            b = pz(b, "CODECS") || "";
            a.P = b.length > 0;
            a.P || a.g.hls.disableCodecGuessing || (b = [], a.g.disableVideo || b.push(a.g.hls.defaultVideoCodec), a.g.disableAudio || b.push(a.g.hls.defaultAudioCodec), b = b.join(","));
            return bn(b.split(/\s*,\s*/));
        }
        function LA(a) {
            return (a = pz(a, "CHANNELS")) ? parseInt(a.split("/")[0], 10) : null;
        }
        function MA(a) {
            return (a = pz(a, "SAMPLE-RATE")) ? parseInt(a, 10) : null;
        }
        function NA(a) {
            a = pz(a, "CHANNELS");
            if (!a) return !1;
            a = a.split("/");
            return a.length != 2 ? !1 : a[1] === "JOC" || a[1].includes("ATMOS") || a[1].includes("IMSA");
        }
        function ZA(a) {
            a = qz(a, "TYPE").toLowerCase();
            a == "subtitles" && (a = Ec);
            return a;
        }
        function JA(a, b, c, d, e, f, g, h, k, l, m, n) {
            for(var q = u(c), r = q.next(); !r.done; r = q.next())$A(r.value.stream, e, f, g, h, k, null);
            e = a.g.disableVideo;
            if (!c.length || e) c = [
                null
            ];
            e && (b = b.filter(function(x) {
                return !x.stream.isAudioMuxedInVideo;
            }));
            e = a.g.disableAudio;
            if (!b.length || e) b = [
                null
            ];
            e = [];
            b = u(b);
            for(f = b.next(); !f.done; f = b.next())for(f = f.value, g = u(c), h = g.next(); !h.done; h = g.next()){
                var t = h.value;
                if (h = f ? f.stream : null) h.drmInfos = l, h.keyIds = m;
                if (k = t ? t.stream : null) k.drmInfos = l, k.keyIds = m, a.g.disableIFrames || Ng(k, n);
                k && !h && (k.bandwidth = d);
                !k && h && (h.bandwidth = d);
                q = f ? f.stream.drmInfos : null;
                r = t ? t.stream.drmInfos : null;
                t = t ? t.T().sort().join(",") : "";
                var v = f ? f.T().sort().join(",") : "", w = [];
                h && h.codecs && w.push(h.codecs);
                k && k.codecs && w.push(k.codecs);
                t = [
                    t,
                    v,
                    w.sort()
                ].join("-");
                h && k && !Lb(q, r) || a.kb.has(t) || (h = {
                    id: a.G++,
                    language: h ? h.language : "und",
                    disabledUntilTime: 0,
                    primary: !!h && h.primary || !!k && k.primary,
                    audio: h,
                    video: k,
                    bandwidth: d,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }, e.push(h), a.kb.add(t));
            }
            return e;
        }
        function jA(a, b) {
            b = uz(b, "CLOSED-CAPTIONS");
            a.R = b.length == 0;
            b = u(b);
            for(var c = b.next(); !c.done; c = b.next()){
                var d = c.value, e = pz(d, "LANGUAGE");
                c = Kc(e || "und");
                e || (e = pz(d, "NAME")) && (c = e);
                e = qz(d, "GROUP-ID");
                d = qz(d, "INSTREAM-ID").replace("SERVICE", "svc");
                a.J.get(e) || a.J.set(e, new Map);
                a.J.get(e).set(d, c);
            }
        }
        function zA(a, b, c, d) {
            d = d === void 0 ? !0 : d;
            for(var e = [], f = [], g = new Map, h = u(b), k = h.next(), l = {}; !k.done; l = {
                hj: void 0
            }, k = h.next()){
                k = k.value;
                l.hj = ++a.G;
                l = function(v) {
                    return function() {
                        return "shaka://hls-muxed" + v.hj;
                    };
                }(l);
                var m = d ? qz(k, "URI") : pz(k, "URI") || l();
                l = qz(k, "GROUP-ID");
                e.push(m);
                f.push(l);
                g.set(l, m);
                (k = pz(k, "PATHWAY-ID")) && c.set(l, k);
            }
            d = f.sort().join(",");
            k = b[0];
            b = "";
            h = ZA(k);
            if (h == Ec) b = pz(k, "CODECS") || "";
            else for(f = u(f), l = f.next(); !l.done; l = f.next())if (l = l.value, a.K.has(l)) {
                b = a.K.get(l);
                break;
            }
            f = e.sort().join(",");
            h == "audio" && d && (f += d);
            if (a.j.has(f)) return a.j.get(f);
            l = a.G++;
            if (a.l) for(g = u(g), m = g.next(); !m.done; m = g.next()){
                var n = u(m.value);
                m = n.next().value;
                n = n.next().value;
                (m = c.get(m)) && qx(a.l, l, m, n);
            }
            c = pz(k, "LANGUAGE");
            g = pz(k, "NAME");
            m = pz(k, "DEFAULT") == "YES";
            n = h == "audio" ? LA(k) : null;
            var q = h == "audio" ? NA(k) : !1, r = pz(k, "CHARACTERISTICS"), t = pz(k, "FORCED") == "YES";
            k = h == "audio" ? MA(k) : null;
            e = aB(a, l, e, b, h, c, m, g, n, null, r, t, k, q);
            e.stream && a.g.enableAudioGroups && (e.stream.groupId = d);
            a.L.has(d) ? a.L.get(d).push(e) : a.L.set(d, [
                e
            ]);
            a.j.set(f, e);
            return e;
        }
        function DA(a, b) {
            var c, d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                if (q.h == 1) {
                    c = qz(b, "URI");
                    d = pz(b, "CODECS", "jpeg") || "";
                    if (a.j.has(c)) return q.return(a.j.get(c));
                    e = pz(b, "LANGUAGE");
                    f = pz(b, "NAME");
                    g = pz(b, "CHARACTERISTICS");
                    h = aB(a, a.G++, [
                        c
                    ], d, "image", e, !1, f, null, null, g, !1, null, !1);
                    return (k = pz(b, "RESOLUTION")) ? q.g(h.stream.createSegmentIndex(), 3) : q.B(2);
                }
                if (q.h != 2) {
                    l = h.stream.segmentIndex.Fb();
                    if (m = l.tilesLayout) h.stream.width = Number(k.split("x")[0]) * Number(m.split("x")[0]), h.stream.height = Number(k.split("x")[1]) * Number(m.split("x")[1]);
                    h.stream.closeSegmentIndex();
                }
                if (n = pz(b, "BANDWIDTH")) h.stream.bandwidth = Number(n);
                a.j.set(c, h);
                return q.return(h);
            });
        }
        function EA(a, b) {
            var c = "video", d = qz(b, "URI"), e = pz(b, "CODECS") || "";
            e == "mjpg" && (c = "image");
            if (a.j.has(d)) return a.j.get(d);
            var f = pz(b, "LANGUAGE"), g = pz(b, "NAME"), h = pz(b, "CHARACTERISTICS");
            c = aB(a, a.G++, [
                d
            ], e, c, f, !1, g, null, null, h, !1, null, !1);
            e = pz(b, "RESOLUTION");
            f = u(e ? e.split("x") : [
                null,
                null
            ]);
            e = f.next().value;
            f = f.next().value;
            c.stream.width = Number(e) || void 0;
            c.stream.height = Number(f) || void 0;
            if (b = pz(b, "BANDWIDTH")) c.stream.bandwidth = Number(b);
            a.j.set(d, c);
            return c;
        }
        function KA(a, b, c, d) {
            for(var e = a.G++, f = [], g = u(b), h = g.next(); !h.done; h = g.next()){
                var k = h.value;
                h = qz(k, "URI");
                k = pz(k, "PATHWAY-ID");
                a.l && k && qx(a.l, e, k, h);
                f.push(h);
            }
            g = f.sort().join(",") + c.sort().join(",");
            if (a.j.has(g)) return a.j.get(g);
            h = f.join(",");
            a: {
                b = pz(b[0], "CLOSED-CAPTIONS");
                if (d == "video") {
                    if (a.g.disableText) {
                        a.R = !1;
                        b = null;
                        break a;
                    }
                    if (b) {
                        if (b != "NONE") {
                            b = a.J.get(b);
                            break a;
                        }
                        a.R = !1;
                    } else if (!b && a.J.size) for(b = u(a.J.keys()), b = b.next(); !b.done; b = b.next()){
                        b = a.J.get(b.value);
                        break a;
                    }
                }
                b = null;
            }
            c = Bc(d, c);
            d = aB(a, e, f, c, d, null, !1, h, null, b, null, !1, null, !1);
            a.j.set(g, d);
            return d;
        }
        function aB(a, b, c, d, e, f, g, h, k, l, m, n, q, r) {
            function t(A) {
                var E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa;
                return H(function(Da) {
                    switch(Da.h){
                        case 1:
                            return E = Gc, Da.m(2), Da.g(A.promise, 4);
                        case 4:
                            C = Da.i;
                            if (A.aborted) return Da.return();
                            D = C.uri;
                            D != C.originalUri && (B = x.T(), B.includes(D) || x.Zf.push(D));
                            J = Cz(a.hb, C.data);
                            if (J.type != 1) throw new T(2, 4, 4017);
                            F = tz(J.ka, "EXT-X-DEFINE");
                            I = Vz(a, F, D);
                            K = !1;
                            (!a.P && a.g.hls.disableCodecGuessing || a.R && e == E.Ba && !a.g.hls.disableClosedCaptionsDetection) && J.segments.length > 0 && (a.R = !1, K = !0);
                            N = !a.P && a.g.hls.disableCodecGuessing;
                            P = Pz(a);
                            return Da.g(eA(a, 0, I, J, v, d, e, f, g, h, k, l, m, n, q, r, void 0, K, N), 5);
                        case 5:
                            M = Da.i;
                            if (A.aborted) return Da.return();
                            L = M.stream;
                            oA(a, J);
                            Pz(a) && !P && pA(a, J);
                            x.gd = M.gd;
                            x.Uc = M.Uc;
                            x.kf = M.kf;
                            x.jf = M.jf;
                            x.qe = M.qe;
                            x.Nf = M.Nf;
                            x.Ub = M.Ub;
                            x.Vb = M.Vb;
                            w.segmentIndex = L.segmentIndex;
                            w.encrypted = L.encrypted;
                            w.drmInfos = L.drmInfos;
                            w.keyIds = L.keyIds;
                            w.mimeType = L.mimeType;
                            w.bandwidth = w.bandwidth || L.bandwidth;
                            w.codecs = w.codecs || L.codecs;
                            w.closedCaptions = w.closedCaptions || L.closedCaptions;
                            w.width = w.width || L.width;
                            w.height = w.height || L.height;
                            w.hdr = w.hdr || L.hdr;
                            w.colorGamut = w.colorGamut || L.colorGamut;
                            w.frameRate = w.frameRate || L.frameRate;
                            w.language == "und" && L.language != "und" && (w.language = L.language);
                            w.language = w.language || L.language;
                            w.channelsCount = w.channelsCount || L.channelsCount;
                            w.audioSamplingRate = w.audioSamplingRate || L.audioSamplingRate;
                            CA(w);
                            x.type != E.Ba || M.type != E.ha || a.P && !yf.includes(w.mimeType) || bB(a, x, L);
                            w.drmInfos.length && a.i.newDrmInfo(w);
                            Q = !1;
                            if (!l && w.closedCaptions || l && w.closedCaptions && l.size != w.closedCaptions.size) Q = !0;
                            a.h && Q && a.i.makeTextStreamsForClosedCaptions(a.h);
                            e == E.Va && (S = L.segmentIndex.Fb()) && S.ia && (w.mimeType = "application/mp4", CA(w));
                            Z = Km(w);
                            w.segmentIndex.xb(function(Ka) {
                                Ka.ia && (Ka.ia.Kd = Z);
                            });
                            cB(a) && (a.Gc ? qA(a, [
                                x
                            ]) : (a.Gc = !0, pa = Array.from(a.j.values()), va = pa.filter(function(Ka) {
                                return Ka.stream.segmentIndex;
                            }), qA(a, va), Tz(a), Ca = a.C, Ca > 0 && a.D.Z(Ca)));
                            $z(a, J.ka, w.type, I, v);
                            a.h && (a.h.startTime = a.A);
                            Da.o(0);
                            break;
                        case 2:
                            ua = Da.l();
                            w.closeSegmentIndex();
                            if (ua.code === 7001) return Da.return();
                            xa = a.i.disableStream(w);
                            if (!xa) throw ua;
                            Da.j();
                    }
                });
            }
            function v() {
                return a.l && c.length > 1 ? rx(a.l, b) : x.Zf.concat(yz([
                    a.H
                ], c, a.F));
            }
            var w = dB(a, d, e, f, g, h, k, l, m, n, q, r);
            c.some(function(A) {
                return A.startsWith("shaka://hls-muxed");
            }) && (w.isAudioMuxedInVideo = !0, w.mimeType = "video/mp2t", CA(w));
            var x = {
                stream: w,
                type: e,
                Zf: [],
                gd: 0,
                Uc: 0,
                Nf: new Map,
                kf: !1,
                jf: !1,
                qe: !1,
                Wg: -1,
                Ub: -1,
                Vb: -1,
                T: v
            }, y = null, z;
            w.createSegmentIndex = function() {
                if (y) return y;
                if (w.isAudioMuxedInVideo) return w.segmentIndex = new vm([]), Promise.resolve();
                z = Nz(a, x.T(), !0);
                return y = new Promise(function(A) {
                    A(t(z));
                });
            };
            w.closeSegmentIndex = function() {
                y && !w.segmentIndex && z.abort();
                w.segmentIndex && (w.segmentIndex.release(), w.segmentIndex = null);
                y = null;
            };
            return x;
        }
        function bB(a, b, c) {
            var d = b.stream, e = c.type, f = b.type;
            Pz(a) && (a.o.set(e, a.o.get(f)), a.o.set(f, new Map));
            b.type = e;
            d.type = e;
            d.codecs = Cc(e, c.codecs.split(/\s*,\s*/)) || "";
            CA(d);
            if (a.h) {
                b = u(a.h.variants);
                for(c = b.next(); !c.done; c = b.next())c = c.value, e == "audio" && c.video == d && (c.video = null, c.audio || (c.audio = d, c.language = d.language));
                a.h.variants = a.h.variants.filter(function(g) {
                    return g.audio || g.video;
                });
            }
        }
        function xA(a) {
            var b = Infinity;
            a = u(a.j.values());
            for(var c = a.next(); !c.done; c = a.next())c = c.value, c.stream.segmentIndex && c.stream.type != "text" && !c.stream.isAudioMuxedInVideo && (b = Math.min(b, c.Uc));
            return b;
        }
        function Rz(a, b) {
            var c = [];
            b = u(b);
            for(var d = b.next(); !d.done; d = b.next())d = d.value, d.segmentIndex && d.segmentIndex.xb(function(e) {
                c.push(e);
            });
            a.m.Ae(c);
        }
        function qA(a, b) {
            if (!Pz(a)) for(var c = xA(a), d = u(b), e = d.next(); !e.done; e = d.next())e.value.stream.segmentIndex.zd(0, c);
            Rz(a, b.map(function(f) {
                return f.stream;
            }));
            d = Array.from(a.j.values()).filter(function(f) {
                return f.stream.segmentIndex;
            });
            c = d.some(function(f) {
                return f.stream.type == "audio";
            });
            e = d.some(function(f) {
                return f.stream.type == "video";
            });
            d = Pz(a) && !a.jb;
            c = !Pz(a) && a.jb && !(c && e);
            a.g.hls.ignoreManifestProgramDateTime || d || c ? aA(a, b, d) : (dA(a, b), a.g.hls.ignoreManifestProgramDateTimeForTypes.length > 0 && aA(a, b));
        }
        function bA(a, b) {
            return a.g.hls.ignoreManifestProgramDateTime ? !0 : a.g.hls.ignoreManifestProgramDateTimeForTypes.includes(b);
        }
        function cB(a) {
            if (!a.h || !a.h.variants.length) return !1;
            var b = [], c = [];
            a = u(a.h.variants);
            for(var d = a.next(); !d.done; d = a.next())d = d.value, d.video && b.push(d.video), d.audio && c.push(d.audio);
            return b.length > 0 && !b.some(function(e) {
                return e.segmentIndex;
            }) || c.length > 0 && !c.some(function(e) {
                return e.segmentIndex;
            }) ? !1 : !0;
        }
        function eA(a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y) {
            x = x === void 0 ? !0 : x;
            y = y === void 0 ? !0 : y;
            var z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q, S, Z, pa, va, Ca, ua, xa, Da, Ka, wa, Ja, Aa, Ga, sb, Wb;
            return H(function(wb) {
                switch(wb.h){
                    case 1:
                        z = g;
                        A = d.segments || [];
                        E = A.every(function(wc) {
                            return vz(wc.ka, "EXT-X-GAP") ? !0 : !1;
                        });
                        if (!A.length || E) throw new T(2, 4, 4053);
                        eB(a, d);
                        Pz(a) && Zz(a, d);
                        C = Pz(a) ? a.o.get(g) : new Map;
                        D = Xz(a, d, C, c, e, g);
                        B = D.segments;
                        J = D.bandwidth;
                        P = N = K = I = F = null;
                        if (!(B.length > 0 && x)) {
                            wb.B(2);
                            break;
                        }
                        return wb.g(rA(a, B), 3);
                    case 3:
                        M = wb.i, g != M.type && Pz(a) && (a.o.set(M.type, a.o.get(g)), a.o.set(g, new Map)), g = M.type, h = M.language, m = M.channelCount, t = M.sampleRate, a.g.disableText || (n = M.closedCaptions), I = M.height, F = M.width, K = M.Me, N = M.colorGamut, P = M.frameRate, y && (w = M.mimeType, f = M.codecs);
                    case 2:
                        if (w) {
                            wb.B(4);
                            break;
                        }
                        return wb.g(fB(a, g, f, B), 5);
                    case 5:
                        w = wb.i, g != Ec || f || w != "application/mp4" || !B[0] || B[0].ia || (w = "text/vtt");
                    case 4:
                        return z == "video" && yf.includes(w) && (g = "audio"), wb.g(Wz(a, d, w, e, c), 6);
                    case 6:
                        L = wb.i;
                        Q = L.drmInfos;
                        S = L.keyIds;
                        Z = L.encrypted;
                        pa = L.Ii;
                        if (Z && !Q.length && !pa) throw new T(2, 4, 4026);
                        va = dB(a, f, g, h, k, l, m, n, q, r, t, v);
                        va.encrypted = Z && !pa;
                        va.drmInfos = Q;
                        va.keyIds = S;
                        va.mimeType = w;
                        J && (va.bandwidth = J);
                        CA(va);
                        g == "video" && (F || I || K || N) && $A(va, F, I, P, K, null, N);
                        Pz(a) && Zz(a, d);
                        Ca = B[0].startTime;
                        ua = B[B.length - 1];
                        xa = ua.endTime;
                        Da = new vm(B);
                        va.segmentIndex = Da;
                        wa = (Ka = vz(d.ka, "EXT-X-SERVER-CONTROL")) ? oz(Ka, "CAN-SKIP-UNTIL") != null : !1;
                        Ja = Ka ? oz(Ka, "CAN-BLOCK-RELOAD") != null : !1;
                        Aa = wz(d.ka, "EXT-X-MEDIA-SEQUENCE", 0);
                        Ga = Yz(Aa, B);
                        sb = Ga.Ub;
                        Wb = Ga.Vb;
                        return wb.return({
                            stream: va,
                            type: g,
                            Zf: [],
                            T: e,
                            gd: Ca,
                            Uc: xa,
                            kf: wa,
                            jf: Ja,
                            qe: !1,
                            Wg: -1,
                            Ub: sb,
                            Vb: Wb,
                            Nf: C
                        });
                }
            });
        }
        function Yz(a, b) {
            a = a + b.length - 1;
            var c = -1;
            if (!b.length) return a++, {
                Ub: a,
                Vb: c
            };
            b = b[b.length - 1];
            var d = b.g;
            if (!b.g.length) return a++, b.o && (c = 0), {
                Ub: a,
                Vb: c
            };
            c = d.length - 1;
            d[d.length - 1].isPreload() || (a++, c = 0);
            return {
                Ub: a,
                Vb: c
            };
        }
        function dB(a, b, c, d, e, f, g, h, k, l, m, n) {
            var q = AA(c, b) || BA(c), r = [];
            if (k) {
                k = u(k.split(","));
                for(var t = k.next(); !t.done; t = k.next())r.push(t.value);
            }
            t = void 0;
            k = null;
            c == Ec ? t = r.includes("public.accessibility.transcribes-spoken-dialog") && r.includes("public.accessibility.describes-music-and-sound") ? "caption" : "subtitle" : r.includes("public.accessibility.describes-video") && (k = "visually impaired");
            r.length || t !== "subtitle" || r.push("subtitle");
            t = null;
            c != "video" && (t = f);
            a = {
                id: a.G++,
                originalId: f,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: q,
                codecs: b,
                kind: c == Ec ? "subtitle" : void 0,
                encrypted: !1,
                drmInfos: [],
                keyIds: new Set,
                language: Kc(d || "und"),
                originalLanguage: d,
                label: t,
                type: c,
                primary: e,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                frameRate: void 0,
                pixelAspectRatio: void 0,
                width: void 0,
                height: void 0,
                bandwidth: void 0,
                roles: r,
                forced: l,
                channelsCount: g,
                audioSamplingRate: m,
                spatialAudio: n,
                closedCaptions: h,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: void 0,
                accessibilityPurpose: k,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            CA(a);
            return a;
        }
        function Wz(a, b, c, d, e) {
            var f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q;
            return H(function(S) {
                switch(S.h){
                    case 1:
                        f = new Map;
                        if (!a.g.ignoreDrmInfo && b.segments) {
                            for(g = u(b.segments), h = g.next(); !h.done; h = g.next())if (k = h.value, l = tz(k.ka, "EXT-X-KEY"), m = null, l.length) for(m = gB(a, b, k.ka, d, e), n = u(l), q = n.next(); !q.done; q = n.next())r = q.value, f.set(r, m);
                        }
                        v = t = !1;
                        w = [];
                        x = new Set;
                        y = u(f);
                        z = y.next();
                    case 2:
                        if (z.done) {
                            S.B(4);
                            break;
                        }
                        A = z.value;
                        E = u(A);
                        C = E.next().value;
                        D = E.next().value;
                        B = C;
                        J = D;
                        F = qz(B, "METHOD");
                        if (F == "NONE") {
                            S.B(3);
                            break;
                        }
                        t = !0;
                        I = pz(B, "KEYFORMAT") || "identity";
                        K = null;
                        if (GA(F)) {
                            v = !0;
                            S.B(3);
                            break;
                        }
                        if (I == "identity") return S.g(HA(a, B, c, d, J, e), 11);
                        N = a.jc.get(I);
                        if (!N) {
                            P = null;
                            S.B(9);
                            break;
                        }
                        return S.g(N(B, c, J), 10);
                    case 10:
                        P = S.i;
                    case 9:
                        K = P;
                        S.B(6);
                        break;
                    case 11:
                        K = S.i;
                    case 6:
                        if (K) {
                            if (K.keyIds) for(M = u(K.keyIds), L = M.next(); !L.done; L = M.next())Q = L.value, x.add(Q);
                            w.push(K);
                        }
                    case 3:
                        z = y.next();
                        S.B(2);
                        break;
                    case 4:
                        return S.return({
                            drmInfos: w,
                            keyIds: x,
                            encrypted: t,
                            Ii: v
                        });
                }
            });
        }
        function hB(a, b, c, d, e) {
            if (!window1.crypto || !window1.crypto.subtle) throw Za("Web Crypto API is not available to decrypt AES. (Web Crypto only exists in secure origins like https)"), new T(2, 4, 4042);
            var f = 0, g = pz(b, "IV", "");
            if (g) {
                var h = rc(g.substr(2));
                if (h.byteLength != 16) throw new T(2, 4, 4048);
            } else f = wz(c.ka, "EXT-X-MEDIA-SEQUENCE", 0);
            var k = xz(d(), qz(b, "URI"), e), l = k.sort().join("");
            c = b.toString() + "-" + f + "-" + l;
            if (!a.na.has(c)) {
                var m = {
                    bitsKey: 128,
                    blockCipherMode: "CBC",
                    iv: h,
                    firstMediaSequenceNumber: f
                };
                switch(qz(b, "METHOD")){
                    case "AES-256":
                        m.bitsKey = 256;
                        break;
                    case "AES-256-CTR":
                        m.bitsKey = 256, m.blockCipherMode = "CTR";
                }
                m.fetchKey = function() {
                    var n, q, r, t;
                    return H(function(v) {
                        if (v.h == 1) return a.O.has(l) || (n = mh(k, a.g.retryParameters), q = vA(a, n, 6).promise, a.O.set(l, q)), v.g(a.O.get(l), 2);
                        if (v.h != 3) {
                            r = v.i;
                            if (!r.data || r.data.byteLength != m.bitsKey / 8) throw new T(2, 4, 4049);
                            t = {
                                name: m.blockCipherMode == "CTR" ? "AES-CTR" : "AES-CBC",
                                length: m.bitsKey
                            };
                            return v.g(window1.crypto.subtle.importKey("raw", r.data, t, !0, [
                                "decrypt"
                            ]), 3);
                        }
                        m.cryptoKey = v.i;
                        m.fetchKey = void 0;
                        v.j();
                    });
                };
                a.na.set(c, m);
            }
            return a.na.get(c);
        }
        function oA(a, b) {
            a.A == null && (b = vz(b.ka, "EXT-X-START")) && (a.A = Number(qz(b, "TIME-OFFSET")));
        }
        function eB(a, b) {
            var c = vz(b.ka, "EXT-X-PLAYLIST-TYPE");
            b = vz(b.ka, "EXT-X-ENDLIST");
            b = c && c.value == "VOD" || b;
            c = c && c.value == "EVENT" && !b;
            c = !b && !c;
            b ? Sz(a, Mz) : c ? Sz(a, wA) : Sz(a, iB);
        }
        function Zz(a, b) {
            var c = Infinity, d = b.segments;
            if (d.length) for(var e = d.length - 1; e >= 0;){
                var f = vz(d[e].ka, "EXTINF");
                if (f) {
                    c = Az(f);
                    break;
                }
                e--;
            }
            d = vz(b.ka, "EXT-X-TARGETDURATION");
            if (!d) throw new T(2, 4, 4024, "EXT-X-TARGETDURATION");
            d = Number(d.value);
            if (e = vz(b.ka, "EXT-X-PART-INF")) a.S = Number(qz(e, "PART-TARGET"));
            b = vz(b.ka, "EXT-X-SERVER-CONTROL");
            a.ba && a.S ? (a.C = a.Fc ? a.S * 5 <= c ? Math.min(a.S, a.C) : Math.min(c, a.C) : Math.min(a.S, a.C), a.Oa = b ? Number(qz(b, "PART-HOLD-BACK")) : 0) : (a.C = Math.min(c, a.C), c = b ? oz(b, "HOLD-BACK") : null, a.Ia = c ? Number(c.value) : 0);
            a.ab = Math.max(d, a.ab);
        }
        function pA(a, b) {
            var c = 0;
            if (a.g.defaultPresentationDelay) c = a.g.defaultPresentationDelay;
            else if (a.Oa) c = a.Oa;
            else if (a.Ia) c = a.Ia;
            else for(var d = b.segments.length, e = d - Math.min(d, a.g.hls.liveSegmentsDelay); e < d; e++){
                var f = vz(b.segments[e].ka, "EXTINF");
                c = f ? c + Az(f) : c + a.ab;
            }
            a.A && a.A < 0 && (c = Math.min(-a.A, c), a.A += c);
            a.m.Pj(0);
            a.m.ii(c);
            a.m.md(!1);
        }
        function gB(a, b, c, d, e) {
            var f = vz(c, "EXT-X-MAP");
            if (!f) return null;
            var g = qz(f, "URI"), h = xz(d(), g, e);
            g = [
                h.toString(),
                pz(f, "BYTERANGE", "")
            ].join("-");
            if (!a.ya.has(g)) {
                var k = void 0, l = null, m = !1;
                c = u(c);
                for(var n = c.next(); !n.done; n = c.next())n = n.value, n.name == "EXT-X-KEY" ? (m = qz(n, "METHOD"), GA(m) && n.id < f.id ? (m = !1, k = hB(a, n, b, d, e)) : m = m != "NONE") : n.name == "EXT-X-BYTERANGE" && n.id < f.id && (l = n);
                b = jB(h, f, l, k, m);
                a.ya.set(g, b);
            }
            return a.ya.get(g);
        }
        function jB(a, b, c, d, e) {
            var f = 0, g = null;
            b = pz(b, "BYTERANGE");
            !b && c && (b = c.value);
            b && (f = b.split("@"), g = Number(f[0]), f = Number(f[1]), g = f + g - 1, d && (c = g + 1 - f, c % 16 && (g += 16 - c % 16)));
            return new Mj(function() {
                return a;
            }, f, g, null, null, null, d, e);
        }
        function kB(a, b, c, d, e, f, g, h, k, l) {
            var m = d.ka, n = vz(m, "EXTINF"), q = 0, r = 0, t = null;
            d.Dc.length && (a.h.isLowLatency = !0);
            var v = null;
            if (!a.g.hls.ignoreManifestProgramDateTime) {
                var w = vz(m, "EXT-X-PROGRAM-DATE-TIME");
                w && w.value && (v = te(w.value), a.jb = !0);
            }
            var x = Pj;
            vz(m, "EXT-X-GAP") && (a.h.gapCount++, x = 2);
            if (!n) {
                if (d.Dc.length == 0) throw new T(2, 4, 4024, "EXTINF");
                if (!a.ba) return null;
            }
            var y = [];
            w = !1;
            var z = null, A = !1, E = !1;
            if (a.ba && d.Dc.length) {
                q = b && window1.ReadableStream && a.g.hls.allowLowLatencyByteRangeOptimization;
                for(var C = v, D = {}, B = 0; B < d.Dc.length; D = {
                    vg: void 0,
                    Ce: void 0
                }, B++){
                    var J = d.Dc[B], F = B == 0 ? c : y[y.length - 1], I = B == 0 ? e : F.endTime, K = Number(pz(J, "DURATION")) || a.S;
                    if (K) {
                        var N = I + K, P = 0, M = null;
                        J.name == "EXT-X-PRELOAD-HINT" ? (P = (P = pz(J, "BYTERANGE-START")) ? Number(P) : 0, (F = pz(J, "BYTERANGE-LENGTH")) ? M = P + Number(F) - 1 : P && (M = Number.MAX_SAFE_INTEGER)) : (P = pz(J, "BYTERANGE"), M = u(lB(F, P)), P = M.next().value, M = M.next().value);
                        D.Ce = pz(J, "URI");
                        if (D.Ce) {
                            F = Pj;
                            pz(J, "GAP") == "YES" && (a.h.gapCount++, F = 2, A = !0);
                            D.vg = null;
                            var L = function(S) {
                                return function() {
                                    S.vg == null && (S.vg = xz(h(), S.Ce, f));
                                    return S.vg;
                                };
                            }(D);
                            q && P >= 0 && M != null && (z = L, w = !0);
                            I = new Oj(I, N, L, P, M, b, 0, 0, Infinity, [], "", null, C, F, l);
                            J.name == "EXT-X-PRELOAD-HINT" && (I.Mh(), E = !0);
                            pz(J, "INDEPENDENT") != "YES" && B > 0 && I.Jd();
                            J = k;
                            J || (y.length && y[0].mimeType ? J = y[0].mimeType : D.Ce && (D = gn(D.Ce), J = mB.get(g).get(D) || null));
                            J && (I.mimeType = J, nB.has(J) && (I.ia = null));
                            y.push(I);
                            C && (C += K);
                        }
                    }
                }
            }
            if (n) {
                n = Az(n);
                if (n == 0) return null;
                q = e + n;
            } else if (y.length) q = y[y.length - 1].endTime;
            else return null;
            w && (A || y[0].startByte != 0 ? (w = !1, z = null) : y = []);
            (n = vz(m, "EXT-X-BYTERANGE")) ? (t = u(lB(c, n.value)), r = t.next().value, t = t.next().value) : y.length && (r = y[0].startByte, t = y[y.length - 1].endByte);
            c = "";
            n = null;
            g == "image" && (c = "1x1", g = vz(m, "EXT-X-TILES")) && (c = qz(g, "LAYOUT"), (g = pz(g, "DURATION")) && (n = Number(g)));
            var Q = null;
            b = new Oj(e, q, function() {
                if (z) return z();
                Q == null && (Q = xz(h(), d.g, f));
                return Q || [];
            }, r, t, b, 0, 0, Infinity, y, c, n, v, x, l, y.length > 0 && !!d.g);
            k && (b.mimeType = k, nB.has(k) && (b.ia = null));
            w && (a.Fc = !0, b.oj(), E && b.Mh());
            return b;
        }
        function lB(a, b) {
            var c = 0, d = null;
            b && (c = b.split("@"), b = Number(c[0]), c = c[1] ? Number(c[1]) : a.endByte + 1, d = c + b - 1);
            return [
                c,
                d
            ];
        }
        function $z(a, b, c, d, e) {
            if (c == "video" || c == "audio") {
                var f = a.m.m;
                if (f != null && !bA(a, c)) for(b = tz(b, "EXT-X-DATERANGE"), b = b.filter(function(F) {
                    return oz(F, "START-DATE") != null;
                }).sort(function(F, I) {
                    F = qz(F, "START-DATE");
                    I = qz(I, "START-DATE");
                    return F < I ? -1 : F > I ? 1 : 0;
                }), c = 0; c < b.length; c++){
                    var g = b[c];
                    try {
                        var h = qz(g, "START-DATE"), k = te(h);
                        if (!isNaN(k)) {
                            var l = Math.max(0, k - f), m = null, n = pz(g, "END-DATE");
                            if (n) {
                                var q = te(n);
                                if (!isNaN(q) && (m = q - f, m < 0)) continue;
                            }
                            if (m == null) {
                                var r = pz(g, "DURATION") || pz(g, "PLANNED-DURATION");
                                if (r) {
                                    var t = parseFloat(r);
                                    isNaN(t) || (m = l + t);
                                    if (k - f + t < 0) continue;
                                }
                            }
                            var v = pz(g, "CLASS") || "com.apple.quicktime.HLS", w = pz(g, "END-ON-NEXT") == "YES";
                            if (m == null && w) {
                                for(var x = c + 1; x < b.length; x++){
                                    var y = pz(b[x], "CLASS") || "com.apple.quicktime.HLS";
                                    if (v == y) {
                                        var z = qz(b[x], "START-DATE"), A = te(z);
                                        if (!isNaN(A) && A && A > k) {
                                            m = Math.max(0, A - f);
                                            break;
                                        }
                                    }
                                }
                                if (m == null) continue;
                            }
                            x = [
                                "CLASS",
                                "START-DATE",
                                "END-DATE",
                                "DURATION",
                                "END-ON-NEXT"
                            ];
                            for(var E = [], C = u(g.attributes), D = C.next(); !D.done; D = C.next()){
                                var B = D.value;
                                if (!x.includes(B.name)) {
                                    var J = zz(B.value, d);
                                    if (B.name == "X-ASSET-URI" || B.name == "X-ASSET-LIST") J = xz(e(), B.value, d)[0];
                                    E.push({
                                        key: B.name,
                                        description: "",
                                        data: J,
                                        mimeType: null,
                                        pictureType: null
                                    });
                                }
                            }
                            if (E.length > 1) a.i.onMetadata(v, l, m, E);
                        }
                    } catch (F) {}
                }
            }
        }
        function Xz(a, b, c, d, e, f) {
            function g(F) {
                F = gn(F);
                if (!F) return null;
                var I = mB.get(f).get(F);
                I || (I = tA.get(F));
                return I;
            }
            var h = b.segments, k = null, l = null, m = null, n = null, q = void 0, r = wz(b.ka, "EXT-X-DISCONTINUITY-SEQUENCE", -1), t = wz(b.ka, "EXT-X-MEDIA-SEQUENCE", 0), v = vz(b.ka, "EXT-X-SKIP"), w = v ? Number(pz(v, "SKIPPED-SEGMENTS")) : 0, x = t + w, y = 0;
            Pz(a) && c.has(x) && (y = c.get(x));
            y === 0 && a.Ga == wA && c.size > 0 && !c.has(x) && a.m.i != null && (y = a.m.Hb());
            var z = [], A = null;
            v = [];
            for(var E = 0; E < h.length; E++){
                var C = h[E];
                (x = vz(C.ka, "EXT-X-MAP")) && x.id !== l && (k = gB(a, b, C.ka, e, d), l = x.id);
                x = C.g;
                var D = "";
                x && (D = gn(x));
                D !== n && (m = g(x), n = D);
                D = E == 0 ? y : A.endTime;
                x = t + w + E;
                vz(C.ka, "EXT-X-DISCONTINUITY") && (r++, A && A.ia && (A.ia.g = D));
                for(var B = u(C.ka), J = B.next(); !J.done; J = B.next())J = J.value, J.name == "EXT-X-KEY" && (GA(qz(J, "METHOD")) ? q = hB(a, J, b, e, d) : q = void 0);
                c.set(x, D);
                if (D = kB(a, k, A, C, D, d, f, e, m, q)) {
                    if (A = wz(C.ka, "EXT-X-BITRATE")) v.push({
                        bitrate: A,
                        duration: D.endTime - D.startTime
                    }), D.bandwidth = A;
                    else if (D.endByte) {
                        if (C = Qj(D)) A = D.endTime - D.startTime, C = C * 8 / A / 1E3, v.push({
                            bitrate: C,
                            duration: A
                        }), D.bandwidth = C;
                    } else v.length && (A = v[v.length - 1], A.duration += D.endTime - D.startTime, D.bandwidth = A.bitrate);
                    if (D.bandwidth) for(A = u(D.g), C = A.next(); !C.done; C = A.next())C.value.bandwidth = D.bandwidth;
                    A = D;
                    D.i = r;
                    bA(a, f) && a.M != null && x < a.M || z.push(D);
                }
            }
            b = void 0;
            v.length && (b = v.reduce(function(F, I) {
                return F + I.duration;
            }, 0), b = Math.round(v.reduce(function(F, I) {
                return F + I.bitrate * I.duration;
            }, 0) / b * 1E3));
            if (v = z.some(function(F) {
                return F.h != null;
            })) {
                for(c = {}, d = 0; d < z.length; c = {
                    rf: void 0,
                    qf: void 0,
                    ef: void 0,
                    jd: void 0,
                    df: void 0
                }, d++)if (c.jd = z[d], c.jd.h == null) for(c.qf = 0, c.rf = d, e = function(F) {
                    return function() {
                        var I = z[F.rf];
                        if (I) {
                            if (I.h != null) return I.h + F.qf;
                            F.qf -= I.endTime - I.startTime;
                            F.rf += 1;
                        }
                        return null;
                    };
                }(c), c.df = 0, c.ef = d, h = function(F) {
                    return function() {
                        var I = z[F.ef];
                        if (I) {
                            I != F.jd && (F.df += I.endTime - I.startTime);
                            if (I.h != null) return I.h + F.df;
                            --F.ef;
                        }
                        return null;
                    };
                }(c); c.jd.h == null;)c.jd.h = h(), c.jd.h == null && (c.jd.h = e());
            }
            if (v) for(c = u(z), d = c.next(); !d.done; d = c.next())for(e = d.value, d = e.h, e = u(e.g), h = e.next(); !h.done; h = e.next())h = h.value, h.h = d, d += h.endTime - h.startTime;
            c = a.$;
            if (v && c != Infinity && !bA(a, f)) for(a = u(z), v = a.next(); !v.done; v = a.next())v.value.ti(c);
            return {
                segments: z,
                bandwidth: b
            };
        }
        function AA(a, b) {
            if (a == Ec) {
                if (b == "vtt" || b == "wvtt") return "text/vtt";
                if (b && b !== "") return "application/mp4";
            }
            return a != "image" || b && b != "jpeg" ? a == "audio" && b == "mp4a.40.34" ? "audio/mpeg" : b == "mjpg" ? "application/mp4" : null : "image/jpeg";
        }
        function BA(a) {
            return a == Ec ? "text/vtt" : mB.get(a).get("mp4");
        }
        function sA(a, b) {
            a = Pz(a) ? Math.trunc((b.length - 1) / 2) : 0;
            for(var c = b[a]; c.ec() == 2 && a + 1 < b.length;)a++, c = b[a];
            return {
                segment: c,
                segmentIndex: a
            };
        }
        function fB(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w;
            return H(function(x) {
                switch(x.h){
                    case 1:
                        e = sh;
                        f = sA(a, d);
                        g = f.segment;
                        if (g.status == 2) return x.return(BA(b));
                        k = g.T();
                        if (l = gn(k[0])) {
                            if (m = mB.get(b), (n = m.get(l)) || (n = tA.get(l))) return x.return(n);
                        }
                        if (h = AA(b, c)) return x.return(h);
                        r = 1;
                        t = mh(k, a.g.retryParameters);
                        x.m(2);
                        t.method = "HEAD";
                        return x.g(vA(a, t, e, {
                            type: r
                        }).promise, 4);
                    case 4:
                        v = x.i;
                        q = v.headers["content-type"];
                        x.o(3);
                        break;
                    case 2:
                        w = x.l();
                        if (!w || w.code != 1002 && w.code != 1001) {
                            x.B(3);
                            break;
                        }
                        t.method = "GET";
                        a.g.hls.allowRangeRequestsToGuessMimeType && (t.headers.Range = "bytes=0-0");
                        return x.g(vA(a, t, e, {
                            type: r
                        }).promise, 6);
                    case 6:
                        v = x.i, q = v.headers["content-type"];
                    case 3:
                        if (!q) {
                            x.B(7);
                            break;
                        }
                        h = q.toLowerCase().split(";")[0];
                        if (!oB.includes(h)) {
                            x.B(8);
                            break;
                        }
                        if (v.data.byteLength) {
                            x.B(9);
                            break;
                        }
                        t.method = "GET";
                        return x.g(vA(a, t, e, {
                            type: r
                        }).promise, 10);
                    case 10:
                        v = x.i;
                    case 9:
                        Rk(Fb(v.data)) && (h = "video/mp2t");
                    case 8:
                        if (!oB.includes(h)) return x.return(h);
                    case 7:
                        return x.return(BA(b));
                }
            });
        }
        function $A(a, b, c, d, e, f, g) {
            a && (a.width = Number(b) || void 0, a.height = Number(c) || void 0, a.frameRate = Number(d) || void 0, a.hdr = e || void 0, a.videoLayout = f || void 0, a.colorGamut = g || void 0);
        }
        function Nz(a, b, c) {
            return vA(a, mh(b, a.g.retryParameters), 0, {
                type: c ? 2 : 3
            });
        }
        function Lz(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                switch(h.h){
                    case 1:
                        if (!a.i) return h.return();
                        h.m(2);
                        b = Date.now();
                        return h.g(a.update(), 4);
                    case 4:
                        c = Date.now();
                        Pz(a) && (d = (c - b) / 1E3, a.Kb.sample(1, d), e = a.g.updatePeriod > 0 ? a.g.updatePeriod : a.C, f = Math.max(0, e - Yc(a.Kb)), isFinite(f) ? a.D.Z(f) : a.D.Z(1));
                        h.o(3);
                        break;
                    case 2:
                        g = h.l();
                        if (!a.i) return h.return();
                        if (a.g.raiseFatalErrorOnManifestUpdateRequestFailure) return a.i.onError(g), h.return();
                        g.severity = 1;
                        a.i.onError(g);
                        a.D.Z(.1);
                    case 3:
                        if (!a.i) return h.return();
                        a.i.onManifestUpdated();
                        h.j();
                }
            });
        }
        function Pz(a) {
            return a.Ga != Mz;
        }
        function Sz(a, b) {
            a.Ga = b;
            a.m && a.m.md(!Pz(a));
            Pz(a) || a.D.stop();
        }
        function vA(a, b, c, d) {
            if (!a.X) throw new T(2, 7, 7001);
            d || (d = {});
            d.isPreload = a.hc();
            b = a.i.networkingEngine.request(c, b, d);
            gh(a.X, b);
            return b;
        }
        function GA(a) {
            return a == "AES-128" || a == "AES-256" || a == "AES-256-CTR";
        }
        function Kz(a, b, c, d) {
            var e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    if (c == "video/mp2t") throw new T(2, 4, 4040);
                    if ("apple" === window1.shakaMediaKeysPolyfill) throw new T(2, 4, 4041);
                    e = qz(b, "METHOD");
                    f = [
                        "SAMPLE-AES",
                        "SAMPLE-AES-CTR"
                    ];
                    if (!f.includes(e)) return m.return(null);
                    g = "cenc";
                    e == "SAMPLE-AES" && (g = "cbcs");
                    h = qz(b, "URI");
                    k = yc("com.apple.fps", g, null, h);
                    var n = new lb(h).Eb.replace(/-/g, "").toLowerCase();
                    return (l = n.length === 32 && /^[0-9a-f]+$/.test(n) ? n : null) || !d ? m.B(2) : m.g(pB(a, d), 3);
                }
                m.h != 2 && (l = m.i);
                l && k.keyIds.add(l);
                return m.return(k);
            });
        }
        function HA(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, v, w, x;
            return H(function(y) {
                switch(y.h){
                    case 1:
                        if (c == "video/mp2t") throw new T(2, 4, 4040);
                        if ("apple" === window1.shakaMediaKeysPolyfill) throw new T(2, 4, 4041);
                        g = qz(b, "METHOD");
                        h = [
                            "SAMPLE-AES",
                            "SAMPLE-AES-CTR"
                        ];
                        if (!h.includes(g)) return y.return(null);
                        k = xz(d(), qz(b, "URI"), f);
                        if (k[0].startsWith("data:text/plain;base64,")) {
                            l = sc(qc(k[0].split("data:text/plain;base64,").pop()));
                            y.B(2);
                            break;
                        }
                        m = k.sort().join("");
                        a.ua.has(m) || (n = mh(k, a.g.retryParameters), q = vA(a, n, 6).promise, a.ua.set(m, q));
                        return y.g(a.ua.get(m), 3);
                    case 3:
                        r = y.i, l = sc(r.data);
                    case 2:
                        t = "00000000000000000000000000000000";
                        if (!e) {
                            y.B(4);
                            break;
                        }
                        return y.g(pB(a, e), 5);
                    case 5:
                        (v = y.i) && (t = v);
                    case 4:
                        return w = new Map, w.set(t, l), x = "cenc", g == "SAMPLE-AES" && (x = "cbcs"), y.return(zc(w, x));
                }
            });
        }
        function pB(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    c = null;
                    if (a.va.has(b)) return c = a.va.get(b), g.B(2);
                    d = jn(b.T(), b.Qc(), b.Oc(), a.g.retryParameters);
                    e = sh;
                    return g.g(vA(a, d, e, {
                        type: 0
                    }).promise, 3);
                }
                g.h != 2 && (f = g.i, b.He(f.data), c = dn(f.data), a.va.set(b, c));
                return g.return(c);
            });
        }
        O("shaka.hls.HlsParser", Jz);
        var tA = (new Map).set("aac", "audio/aac").set("ac3", "audio/ac3").set("ec3", "audio/ec3").set("mp3", "audio/mpeg"), qB = (new Map).set("mp4", "audio/mp4").set("mp4a", "audio/mp4").set("m4s", "audio/mp4").set("m4i", "audio/mp4").set("m4a", "audio/mp4").set("m4f", "audio/mp4").set("cmfa", "audio/mp4").set("ts", "video/mp2t").set("tsa", "video/mp2t"), rB = (new Map).set("mp4", "video/mp4").set("mp4v", "video/mp4").set("m4s", "video/mp4").set("m4i", "video/mp4").set("m4v", "video/mp4").set("m4f", "video/mp4").set("cmfv", "video/mp4").set("ts", "video/mp2t").set("tsv", "video/mp2t"), sB = (new Map).set("mp4", "application/mp4").set("m4s", "application/mp4").set("m4i", "application/mp4").set("m4f", "application/mp4").set("cmft", "application/mp4").set("vtt", "text/vtt").set("webvtt", "text/vtt").set("ttml", "application/ttml+xml"), tB = (new Map).set("jpg", "image/jpeg").set("png", "image/png").set("svg", "image/svg+xml").set("webp", "image/webp").set("avif", "image/avif"), mB = (new Map).set("audio", qB).set("video", rB).set("text", sB).set("image", tB), nB = new Set([
            "video/mp2t"
        ].concat(G(yf))), oB = [
            "application/octet-stream",
            "binary/octet-stream"
        ], Mz = "VOD", iB = "EVENT", wA = "LIVE";
        xd("application/x-mpegurl", function() {
            return new Jz;
        });
        xd("application/vnd.apple.mpegurl", function() {
            return new Jz;
        });
        xd("audio/x-mpegurl", function() {
            return new Jz;
        });
        function uB(a) {
            return mw(a);
        }
        var vB = (new Map).set("com.microsoft.playready", uB).set("com.microsoft.playready.recommendation", uB).set("com.microsoft.playready.software", uB).set("com.microsoft.playready.hardware", uB);
        function wB() {
            var a = this;
            this.h = this.g = null;
            this.l = [];
            this.j = null;
            this.A = 1;
            this.i = null;
            this.F = new Xc(5);
            this.o = new Uf(function() {
                xB(a);
            });
            this.D = new fh;
            this.m = new Map;
            this.C = function() {
                return !1;
            };
        }
        p = wB.prototype;
        p.configure = function(a, b) {
            this.g = a;
            b && (this.C = b);
        };
        p.start = function(a, b) {
            var c = this;
            return H(function(d) {
                if (d.h == 1) return c.l = [
                    a
                ], c.h = b, d.g(yB(c), 2);
                if (!c.h) throw new T(2, 7, 7001);
                return d.return(c.j);
            });
        };
        function xB(a) {
            var b;
            H(function(c) {
                switch(c.h){
                    case 1:
                        return c.m(2), c.g(yB(a), 4);
                    case 4:
                        c.o(3);
                        break;
                    case 2:
                        b = c.l(), a.h && (b.severity = 1, a.h.onError(b));
                    case 3:
                        if (!a.h) return c.return();
                        c.j();
                }
            });
        }
        p.stop = function() {
            this.g = this.h = null;
            this.l = [];
            this.j = null;
            this.o != null && (this.o.stop(), this.o = null);
            this.m.clear();
            return this.D.destroy();
        };
        p.update = function() {
            var a = this, b;
            return H(function(c) {
                if (c.h == 1) return c.m(2), c.g(yB(a), 4);
                if (c.h != 2) return c.o(0);
                b = c.l();
                if (!a.h || !b) return c.return();
                a.h.onError(b);
                c.j();
            });
        };
        p.onExpirationUpdated = function() {};
        p.onInitialVariantChosen = function() {};
        p.banLocation = function() {};
        p.setMediaElement = function() {};
        function yB(a) {
            var b, c, d, e, f, g, h;
            return H(function(k) {
                if (k.h == 1) return b = mh(a.l, a.g.retryParameters), c = a.h.networkingEngine, d = Date.now(), e = c.request(0, b, {
                    type: 5,
                    isPreload: a.C()
                }), gh(a.D, e), k.g(e.promise, 2);
                f = k.i;
                if (!a.h) return k.return();
                f.uri && !a.l.includes(f.uri) && a.l.unshift(f.uri);
                var l = f.uri, m = f.data, n = a.g.mss.manifestPreprocessor;
                if (n != Ao) {
                    md("manifest.mss.manifestPreprocessor configuration", "Please Use manifest.mss.manifestPreprocessorTXml instead.");
                    m = fy(m, "SmoothStreamingMedia");
                    if (!m) throw new T(2, 4, 4046, l);
                    n(m);
                    m = hc(m.outerHTML);
                }
                var q = $d(m, "SmoothStreamingMedia");
                if (!q) throw new T(2, 4, 4046, l);
                l = a.g.mss.manifestPreprocessorTXml;
                l != Bo && l(q);
                a.i || (a.i = new Wl(null, 0));
                if (l = qe(q, "IsLive", Ae, !1)) throw new T(2, 4, 4047);
                a.i.md(!l);
                n = qe(q, "TimeScale", ye, 1E7);
                m = qe(q, "DVRWindowLength", ye);
                l && (m === 0 || isNaN(m)) && (m = Infinity);
                var r = qe(q, "CanSeek", Ae, !1);
                m === 0 && r && (m = Infinity);
                r = null;
                m && m > 0 && (r = m / n);
                l && !isNaN(a.g.availabilityWindowOverride) && (r = a.g.availabilityWindowOverride);
                r == null && (r = Infinity);
                a.i.ig(r);
                m = qe(q, "Duration", ye, Infinity);
                l || a.i.Ab(m / n);
                l = {
                    variants: [],
                    textStreams: [],
                    timescale: n,
                    duration: m / n
                };
                var t;
                r = ie(q, "Protection");
                n = a.g.mss.keySystemsBySystemId;
                m = [];
                r = u(r);
                for(t = r.next(); !t.done; t = r.next())m = m.concat(ie(t.value, "ProtectionHeader"));
                if (m.length) {
                    r = [];
                    for(t = 0; t < m.length; t++){
                        var v = m[t], w = v.attributes.SystemID.toLowerCase(), x = n[w];
                        if (x) {
                            var y;
                            a: {
                                if (y = kw(v)) {
                                    y = u(me(y, "DATA"));
                                    for(var z = y.next(); !z.done; z = y.next())if (z = ne(z.value, "KID")) {
                                        y = qc(ke(z));
                                        y = new Uint8Array([
                                            y[3],
                                            y[2],
                                            y[1],
                                            y[0],
                                            y[5],
                                            y[4],
                                            y[7],
                                            y[6]
                                        ].concat(G(y.slice(8))));
                                        y = sc(y);
                                        break a;
                                    }
                                }
                                y = null;
                            }
                            z = qc(ke(v));
                            w = rc(w.replace(/-/g, ""));
                            w = [
                                {
                                    initData: Nh(z, w, new Set, 0),
                                    initDataType: "cenc",
                                    keyId: y
                                }
                            ];
                            w = yc(x, "cenc", w);
                            y && w.keyIds.add(y);
                            if (x = vB.get(x)) w.licenseServerUri = x(v);
                            r.push(w);
                        }
                    }
                    n = r;
                } else n = [];
                t = n;
                r = [];
                n = [];
                m = [];
                q = ie(q, "StreamIndex");
                q = u(q);
                for(v = q.next(); !v.done; v = q.next()){
                    v = v.value;
                    x = ie(v, "QualityLevel");
                    w = l.timescale;
                    y = l.duration;
                    z = ie(v, "c");
                    for(var A = [], E = 0, C = 0; C < z.length; ++C){
                        var D = z[C], B = z[C + 1], J = qe(D, "t", ye), F = qe(D, "d", ye);
                        D = qe(D, "r", we);
                        if (!F) break;
                        J = J != null ? J : E;
                        (D = D || 0) && D--;
                        if (D < 0) {
                            if (B) {
                                B = qe(B, "t", ye);
                                if (B == null) break;
                                else if (J >= B) break;
                                D = Math.ceil((B - J) / F) - 1;
                            } else {
                                if (y == Infinity) break;
                                else if (J / w >= y) break;
                                D = Math.ceil((y * w - J) / F) - 1;
                            }
                        }
                        for(B = 0; B <= D; ++B)E = J + F, A.push({
                            start: J / w,
                            end: E / w,
                            $d: J
                        }), J = E;
                    }
                    w = A;
                    x = u(x);
                    for(y = x.next(); !y.done; y = x.next())(y = zB(a, v, y.value, w, t, l)) && (y.type != "audio" || a.g.disableAudio ? y.type != "video" || a.g.disableVideo ? y.type != Ec || a.g.disableText || m.push(y) : n.push(y) : r.push(y));
                }
                q = [];
                r = u(r.length > 0 ? r : [
                    null
                ]);
                for(t = r.next(); !t.done; t = r.next())for(t = t.value, v = u(n.length > 0 ? n : [
                    null
                ]), A = v.next(); !A.done; A = v.next())x = q, w = x.push, y = a, z = t, A = A.value, C = 0, z && z.bandwidth && z.bandwidth > 0 && (C += z.bandwidth), A && A.bandwidth && A.bandwidth > 0 && (C += A.bandwidth), y = {
                    id: y.A++,
                    language: z ? z.language : "und",
                    disabledUntilTime: 0,
                    primary: !!z && z.primary || !!A && A.primary,
                    audio: z,
                    video: A,
                    bandwidth: C,
                    allowedByApplication: !0,
                    allowedByKeySystem: !0,
                    decodingInfos: []
                }, w.call(x, y);
                l.variants = q;
                l.textStreams = m;
                a.j ? (a.j.variants = l.variants, a.j.textStreams = l.textStreams, a.h.filter(a.j)) : (a.j = {
                    presentationTimeline: a.i,
                    variants: l.variants,
                    textStreams: l.textStreams,
                    imageStreams: [],
                    offlineSessionIds: [],
                    sequenceMode: a.g.mss.sequenceMode,
                    ignoreManifestTimestampsInSegmentsMode: !1,
                    type: "MSS",
                    serviceDescription: null,
                    nextUrl: null,
                    periodCount: 1,
                    gapCount: 0,
                    isLowLatency: !1,
                    startTime: null
                }, a.i.Mf());
                Promise.resolve();
                g = Date.now();
                h = (g - d) / 1E3;
                a.F.sample(1, h);
                k.j();
            });
        }
        function zB(a, b, c, d, e, f) {
            var g = b.attributes.Type;
            if (g !== "audio" && g !== "video" && g !== "text") return Za("Ignoring unrecognized type:", g), null;
            var h = b.attributes.Language, k = a.A++, l = qe(c, "Bitrate", xe), m = qe(c, "MaxWidth", xe), n = qe(c, "MaxHeight", xe), q = qe(c, "Channels", xe), r = qe(c, "SamplingRate", xe), t = f.duration;
            d.length && (t = d[d.length - 1].end - d[0].start);
            var v = a.i.getDuration();
            a.i.Ab(Math.min(t, v));
            (v = b.attributes.Name) && (v += c.attributes.Index);
            v || (v = String(k));
            var w = {
                id: k,
                originalId: v,
                groupId: null,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                closeSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: null,
                mimeType: "",
                codecs: "",
                frameRate: void 0,
                pixelAspectRatio: void 0,
                bandwidth: l || 0,
                width: m || void 0,
                height: n || void 0,
                kind: "",
                encrypted: e.length > 0,
                drmInfos: e,
                keyIds: new Set,
                language: Kc(h || "und"),
                originalLanguage: h,
                label: "",
                type: "",
                primary: !1,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: [],
                roles: [],
                forced: !1,
                channelsCount: q,
                audioSamplingRate: r,
                spatialAudio: !1,
                closedCaptions: null,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                tilesLayout: void 0,
                matchedStreams: [],
                mssPrivateData: {
                    duration: t,
                    timescale: f.timescale,
                    codecPrivateData: null
                },
                accessibilityPurpose: null,
                external: !1,
                fastSwitching: !1,
                fullMimeTypes: new Set,
                isAudioMuxedInVideo: !1,
                baseOriginalId: null
            };
            if (e = b.attributes.Subtype) (e = AB.get(e)) && w.roles.push(e), e === "main" && (w.primary = !0);
            e = c.attributes.FourCC;
            if (e === null || e === "") e = b.attributes.FourCC;
            if (!e) {
                if (g === "audio") e = "AAC";
                else if (g === "video") return Za('FourCC is not defined whereas it is required for a QualityLevel element for a StreamIndex of type "video"'), null;
            }
            if (!BB.includes(e.toUpperCase())) return Za("Codec not supported:", e), null;
            c = CB(c, g, e, w);
            w.mssPrivateData.codecPrivateData = c;
            switch(g){
                case "audio":
                    if (!c) return Za("Quality unsupported without CodecPrivateData", g), null;
                    w.type = "audio";
                    w.mimeType = "mss/audio/mp4";
                    w.codecs = DB(e, c);
                    break;
                case "video":
                    if (!c) return Za("Quality unsupported without CodecPrivateData", g), null;
                    w.type = "video";
                    w.mimeType = "mss/video/mp4";
                    w.codecs = EB(c);
                    break;
                case "text":
                    if (w.type = Ec, w.mimeType = "application/mp4", e === "TTML" || e === "DFXP") w.codecs = "stpp";
            }
            w.fullMimeTypes.add(wf(w.mimeType, w.codecs));
            w.createSegmentIndex = function() {
                if (w.segmentIndex) return Promise.resolve();
                if (a.m.has(w.id)) var x = a.m.get(w.id);
                else x = [], w.type == "video" && (x = w.mssPrivateData.codecPrivateData.split("00000001").slice(1)), x = {
                    id: w.id,
                    type: w.type,
                    codecs: w.codecs,
                    encrypted: w.encrypted,
                    timescale: w.mssPrivateData.timescale,
                    duration: w.mssPrivateData.duration,
                    Cb: x,
                    Ha: new Uint8Array([]),
                    Za: new Uint8Array([]),
                    fb: 0,
                    gb: 0,
                    data: null,
                    stream: w
                }, x = ej(new dj([
                    x
                ])), a.m.set(w.id, x);
                x = FB(a, new Mj(function() {
                    return [];
                }, 0, null, Km(w), w.mssPrivateData.timescale, x, null, w.encrypted), w, b, d);
                w.segmentIndex = new vm(x);
                return Promise.resolve();
            };
            w.closeSegmentIndex = function() {
                w.segmentIndex && (w.segmentIndex.release(), w.segmentIndex = null);
            };
            return w;
        }
        function CB(a, b, c, d) {
            if (a = a.attributes.CodecPrivateData) return a;
            if (b !== "audio") return null;
            b = d.channelsCount || 2;
            a = d.audioSamplingRate || 44100;
            var e = {
                96E3: 0,
                88200: 1,
                64E3: 2,
                48E3: 3,
                44100: 4,
                32E3: 5,
                24E3: 6,
                22050: 7,
                16E3: 8,
                12E3: 9,
                11025: 10,
                8E3: 11,
                7350: 12
            };
            d = e[a];
            if (c === "AACH") return c = new Uint8Array(4), a = e[a * 2], c[0] = 40 | d >> 1, c[1] = d << 7 | b << 3 | a >> 1, c[2] = a << 7 | 8, c[3] = 0, b = new Uint16Array(2), b[0] = (c[0] << 8) + c[1], b[1] = (c[2] << 8) + c[3], b[0].toString(16) + b[1].toString(16);
            c = new Uint8Array(2);
            c[0] = 16 | d >> 1;
            c[1] = d << 7 | b << 3;
            b = new Uint16Array(1);
            b[0] = (c[0] << 8) + c[1];
            return b[0].toString(16);
        }
        function DB(a, b) {
            var c = 0;
            a === "AACH" && (c = 5);
            b ? c === 0 && (c = (parseInt(b.substr(0, 2), 16) & 248) >> 3) : (c = 2, a === "AACH" && (c = 5));
            return "mp4a.40." + c;
        }
        function EB(a) {
            var b = /00000001[0-9]7/.exec(a);
            return b.length && a ? "avc1." + a.substr(a.indexOf(b[0]) + 10, 6) : "";
        }
        function FB(a, b, c, d, e) {
            var f = d.attributes.Url.replace("{bitrate}", String(c.bandwidth));
            d = [];
            e = u(e);
            for(var g = e.next(), h = {}; !g.done; h = {
                og: void 0
            }, g = e.next())h.og = g.value, d.push(new Oj(h.og.start, h.og.end, function(k) {
                return function() {
                    return vc(a.l, [
                        f.replace("{start time}", String(k.og.$d))
                    ]);
                };
            }(h), 0, null, b, 0, 0, c.mssPrivateData.duration));
            return d;
        }
        O("shaka.mss.MssParser", wB);
        var BB = "AAC AACL AACH AACP AVC1 H264 TTML DFXP".split(" "), AB = (new Map).set("CAPT", "main").set("SUBT", "alternate").set("DESC", "main");
        xd("application/vnd.ms-sstr+xml", function() {
            return new wB;
        });
        function GB(a, b, c, d, e, f, g) {
            if (c >= 200 && c <= 299 && c != 202 || c == 304) return {
                uri: e || d,
                originalUri: d,
                data: b,
                status: c,
                headers: a,
                fromCache: !!a["x-shaka-from-cache"],
                originalRequest: f
            };
            f = null;
            try {
                f = ec(b);
            } catch (h) {}
            throw new T(c == 401 || c == 403 ? 2 : 1, 1, 1001, d, c, f, a, g, e || d);
        }
        function HB() {}
        function IB(a, b, c, d, e, f) {
            var g = new JB;
            try {
                wh(b.headers).forEach(function(m, n) {
                    g.append(n, m);
                });
            } catch (m) {
                return $g(new T(1, 1, 1002, a, m, c));
            }
            var h = new KB, k = {
                Oi: !1,
                ek: !1
            };
            a = LB(a, b, c, {
                body: b.body || void 0,
                headers: g,
                method: b.method,
                signal: h.signal,
                credentials: b.allowCrossSiteCredentials ? "include" : void 0
            }, k, d, e, b.streamDataCallback, f.minBytesForProgressEvents || 0);
            a = new Zg(a, function() {
                k.Oi = !0;
                h.abort();
                return Promise.resolve();
            });
            if (b = b.retryParameters.timeout) {
                var l = new Uf(function() {
                    k.ek = !0;
                    h.abort();
                });
                l.Z(b / 1E3);
                a.finally(function() {
                    l.stop();
                });
            }
            return a;
        }
        function LB(a, b, c, d, e, f, g, h, k) {
            var l, m, n, q, r, t, v, w, x, y, z, A, E, C, D;
            return H(function(B) {
                switch(B.h){
                    case 1:
                        return l = MB, m = NB, q = new ArrayBuffer(0), t = r = 0, v = {}, w = Date.now(), B.m(2), B.g(l(a, d), 4);
                    case 4:
                        n = B.i;
                        v = OB(n.headers);
                        g(v);
                        if (d.method == "HEAD") {
                            B.B(5);
                            break;
                        }
                        y = (x = n.headers.get("Content-Length")) ? parseInt(x, 10) : 0;
                        if (!n.body) return B.g(n.arrayBuffer(), 9);
                        z = n.clone().body.getReader();
                        A = function(J) {
                            function F() {
                                var I, K, N, P;
                                return H(function(M) {
                                    switch(M.h){
                                        case 1:
                                            return M.m(2), M.g(z.read(), 4);
                                        case 4:
                                            I = M.i;
                                            M.o(3);
                                            break;
                                        case 2:
                                            return M.l(), M.return();
                                        case 3:
                                            if (I.done) {
                                                M.B(5);
                                                break;
                                            }
                                            r += I.value.byteLength;
                                            if (!h) {
                                                M.B(5);
                                                break;
                                            }
                                            return M.g(h(I.value), 5);
                                        case 5:
                                            K = Date.now();
                                            N = r - t;
                                            if (K - w > 100 && N >= k || I.done) P = I.done ? 0 : y - r, f(K - w, N, P), t = r, w = K;
                                            I.done ? J.close() : (J.enqueue(I.value), F());
                                            M.j();
                                    }
                                });
                            }
                            F();
                        };
                        new m({
                            start: A
                        });
                        return B.g(n.arrayBuffer(), 8);
                    case 8:
                        q = B.i;
                        B.B(5);
                        break;
                    case 9:
                        q = B.i, E = Date.now(), f(E - w, q.byteLength, 0);
                    case 5:
                        b.headers.Range && (C = b.headers.Range.replace("bytes=", "").split("-").filter(function(J) {
                            return J;
                        }).map(function(J) {
                            return parseInt(J, 10);
                        }), C.length == 2 && q.byteLength != C[1] - C[0] + 1 && Za("Payload length does not match range requested bytes", b, n));
                        B.o(3);
                        break;
                    case 2:
                        D = B.l();
                        if (e.Oi) throw new T(1, 1, 7001, a, c);
                        if (e.ek) throw new T(1, 1, 1003, a, c);
                        throw new T(1, 1, 1002, a, D, c);
                    case 3:
                        return B.return(GB(v, q, n.status, a, n.url, b, c));
                }
            });
        }
        function OB(a) {
            var b = {};
            a.forEach(function(c, d) {
                b[d.trim()] = c;
            });
            return b;
        }
        function PB() {
            if (window1.ReadableStream) try {
                new ReadableStream({});
            } catch (a) {
                return !1;
            }
            else return !1;
            if (window1.Response) {
                if (!new Response("").body) return !1;
            } else return !1;
            return !(!window1.fetch || "polyfill" in window1.fetch || !window1.AbortController);
        }
        O("shaka.net.HttpFetchPlugin", HB);
        HB.isSupported = PB;
        HB.parse = IB;
        var MB = window1.fetch, KB = window1.AbortController, NB = window1.ReadableStream, JB = window1.Headers;
        PB() && (ih("http", IB, 2, !0), ih("https", IB, 2, !0), ih("blob", IB, 2, !0));
        function QB() {}
        function RB(a, b, c, d, e, f) {
            var g = new SB, h = Date.now(), k = 0, l = new Promise(function(m, n) {
                g.open(b.method, a, !0);
                g.responseType = "arraybuffer";
                g.timeout = b.retryParameters.timeout;
                g.withCredentials = b.allowCrossSiteCredentials;
                var q = {};
                g.onabort = function() {
                    n(new T(1, 1, 7001, a, c));
                };
                g.onreadystatechange = function() {
                    if (g.readyState === XMLHttpRequest.HEADERS_RECEIVED) {
                        var t = g.getAllResponseHeaders().trim().split("\r\n"), v = {};
                        t = u(t);
                        for(var w = t.next(); !w.done; w = t.next()){
                            w = w.value;
                            var x = w.indexOf(": ");
                            x !== -1 && (v[w.slice(0, x).toLowerCase()] = w.slice(x + 2));
                        }
                        q = v;
                        e(q);
                    }
                };
                g.onload = function() {
                    var t = g.response;
                    try {
                        var v = GB(q, t, g.status, a, g.responseURL, b, c);
                        m(v);
                    } catch (w) {
                        n(w);
                    }
                };
                g.onerror = function(t) {
                    n(new T(1, 1, 1002, a, t, c));
                };
                g.ontimeout = function() {
                    n(new T(1, 1, 1003, a, c));
                };
                g.onprogress = function(t) {
                    var v = Date.now(), w = f.minBytesForProgressEvents || 0, x = t.loaded - k;
                    if (v - h > 100 && x >= w || t.lengthComputable && t.loaded == t.total) d(v - h, x, g.readyState == 4 ? 0 : t.total - t.loaded), k = t.loaded, h = v;
                };
                for(var r in b.headers)try {
                    g.setRequestHeader(r.toLowerCase(), b.headers[r]);
                } catch (t) {
                    throw new T(1, 1, 1002, a, t, c);
                }
                g.send(b.body);
            });
            return new Zg(l, function() {
                g.abort();
                return Promise.resolve();
            });
        }
        O("shaka.net.HttpXHRPlugin", QB);
        QB.parse = RB;
        var SB = window1.XMLHttpRequest;
        ih("http", RB, 1, !0);
        ih("https", RB, 1, !0);
        ih("blob", RB, 1, !0);
        function TB(a, b, c, d, e) {
            this.g = a;
            this.i = b;
            this.groupId = c;
            this.h = d;
            this.j = e;
        }
        function UB(a) {
            var b = a.dc(!1);
            return b ? mc(b) : a.T().map(function(c) {
                return "{" + encodeURI(c.split("#xywh=")[0]) + "}";
            }).join("") + ":" + a.startByte + ":" + a.endByte;
        }
        function VB(a, b) {
            return jn(a.g.T(), a.g.startByte, a.g.endByte, b.streaming.retryParameters);
        }
        function WB() {
            this.g = this.j = this.i = 0;
            this.h = new Map;
            this.l = 0;
        }
        function XB(a, b) {
            a.i += b;
            var c = a.l;
            a.l++;
            a.h.set(c, b);
            return c;
        }
        WB.prototype.close = function(a, b) {
            if (this.h.has(a)) {
                var c = this.h.get(a);
                this.h.delete(a);
                this.j += c;
                this.g += b;
            }
        };
        function YB(a) {
            return a.i == 0 ? 0 : a.j / a.i;
        }
        function ZB(a) {
            var b = this;
            this.A = a;
            this.i = new Map;
            this.h = new uh(function() {
                return $B(b).catch(function() {});
            });
            this.j = [];
            this.o = function() {};
            this.m = function() {};
            this.g = new WB;
            this.l = !1;
        }
        ZB.prototype.destroy = function() {
            return this.h.destroy();
        };
        function aC(a, b, c) {
            a.o = b;
            a.m = c;
        }
        function $B(a) {
            a.l = !0;
            var b = a.j.map(function(c) {
                return c();
            });
            a.j = [];
            return Promise.all(b);
        }
        ZB.prototype.queue = function(a, b, c, d, e) {
            var f = this;
            vh(this.h);
            var g = (this.i.get(a) || Promise.resolve()).then(function() {
                var h, k, l, m, n, q, r;
                return H(function(t) {
                    if (t.h == 1) return t.g(bC(f, b), 2);
                    h = t.i;
                    if (f.h.g) throw new T(2, 9, 7001);
                    if (d) for(m in k = Fb(h), l = new Mh(k), l.data)n = Number(m), q = l.data[n], r = l.g[n], f.m(q, r);
                    f.g.close(c, h.byteLength);
                    f.o(YB(f.g), f.g.g);
                    return t.return(e(h));
                });
            });
            this.i.set(a, g);
            return g;
        };
        function cC(a, b, c, d, e, f) {
            vh(a.h);
            var g = (a.i.get(b) || Promise.resolve()).then(function() {
                if (a.h.g) throw new T(2, 9, 7001);
                if (e) {
                    var h = Fb(c);
                    h = new Mh(h);
                    for(var k in h.data){
                        var l = Number(k);
                        a.m(h.data[l], h.g[l]);
                    }
                }
                a.g.close(d, c.byteLength);
                a.o(YB(a.g), a.g.g);
                return f(c);
            });
            a.i.set(b, g);
        }
        function dC(a) {
            return H(function(b) {
                return b.h == 1 ? b.g(Promise.all(a.i.values()), 2) : b.return(a.g.g);
            });
        }
        function bC(a, b) {
            var c, d, e, f;
            return H(function(g) {
                if (g.h == 1) return c = sh, d = a.A.request(c, b), e = function() {
                    return d.abort();
                }, a.j.push(e), g.g(d.promise, 2);
                f = g.i;
                ad(a.j, e);
                return g.return(f.data);
            });
        }
        function eC(a, b) {
            var c = this;
            this.i = a;
            this.h = a.objectStore(b);
            this.g = new Yg;
            a.onabort = function(d) {
                d.preventDefault();
                c.g.reject();
            };
            a.onerror = function(d) {
                d.preventDefault();
                c.g.reject();
            };
            a.oncomplete = function() {
                c.g.resolve();
            };
        }
        eC.prototype.abort = function() {
            var a = this;
            return H(function(b) {
                if (b.h == 1) {
                    try {
                        a.i.abort();
                    } catch (c) {}
                    b.m(2);
                    return b.g(a.g, 4);
                }
                if (b.h != 2) return b.o(0);
                b.l();
                b.j();
            });
        };
        function fC(a, b) {
            return new Promise(function(c, d) {
                var e = a.h.openCursor();
                e.onerror = d;
                e.onsuccess = function() {
                    var f;
                    return H(function(g) {
                        if (g.h == 1) {
                            if (e.result == null) return c(), g.return();
                            f = e.result;
                            return g.g(b(f.key, f.value, f), 2);
                        }
                        f.continue();
                        g.j();
                    });
                };
            });
        }
        eC.prototype.store = function() {
            return this.h;
        };
        eC.prototype.promise = function() {
            return this.g;
        };
        function gC(a) {
            this.h = a;
            this.g = [];
        }
        gC.prototype.destroy = function() {
            return Promise.all(this.g.map(function(a) {
                return a.abort();
            }));
        };
        function hC(a, b) {
            return iC(a, b, "readwrite");
        }
        function iC(a, b, c) {
            c = a.h.transaction([
                b
            ], c);
            var d = new eC(c, b);
            a.g.push(d);
            d.promise().then(function() {
                ad(a.g, d);
            }, function() {
                ad(a.g, d);
            });
            return d;
        }
        function jC(a, b, c) {
            this.h = new gC(a);
            this.i = b;
            this.g = c;
        }
        p = jC.prototype;
        p.destroy = function() {
            return this.h.destroy();
        };
        p.hasFixedKeySpace = function() {
            return !0;
        };
        p.addSegments = function() {
            return kC(this.i);
        };
        p.removeSegments = function(a, b) {
            return lC(this, this.i, a, b);
        };
        p.getSegments = function(a) {
            var b = this, c;
            return H(function(d) {
                if (d.h == 1) return d.g(mC(b, b.i, a), 2);
                c = d.i;
                return d.return(c.map(function(e) {
                    return b.Si(e);
                }));
            });
        };
        p.addManifests = function() {
            return kC(this.g);
        };
        p.updateManifest = function() {
            return Promise.reject(new T(2, 9, 9016, "Cannot modify values in " + this.g));
        };
        function nC(a, b, c) {
            a = hC(a.h, a.g);
            var d = a.store();
            d.get(b).onsuccess = function() {
                d.put(c, b);
            };
            return a.promise();
        }
        p.updateManifestExpiration = function(a, b) {
            var c = hC(this.h, this.g), d = c.store();
            d.get(a).onsuccess = function(e) {
                if (e = e.target.result) e.expiration = b, d.put(e, a);
            };
            return c.promise();
        };
        p.removeManifests = function(a, b) {
            return lC(this, this.g, a, b);
        };
        p.getManifests = function(a) {
            var b = this, c;
            return H(function(d) {
                if (d.h == 1) return d.g(mC(b, b.g, a), 2);
                c = d.i;
                return d.return(Promise.all(c.map(function(e) {
                    return b.ie(e);
                })));
            });
        };
        p.getAllManifests = function() {
            var a = this, b, c;
            return H(function(d) {
                return d.h == 1 ? (b = iC(a.h, a.g, "readonly"), c = new Map, d.g(fC(b, function(e, f) {
                    var g;
                    return H(function(h) {
                        if (h.h == 1) return h.g(a.ie(f), 2);
                        g = h.i;
                        c.set(e, g);
                        h.j();
                    });
                }), 2)) : d.h != 3 ? d.g(b.promise(), 3) : d.return(c);
            });
        };
        p.Si = function(a) {
            return a;
        };
        p.ie = function(a) {
            return Promise.resolve(a);
        };
        function kC(a) {
            return Promise.reject(new T(2, 9, 9011, "Cannot add new value to " + a));
        }
        p.add = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    d = hC(c.h, a);
                    e = d.store();
                    f = [];
                    g = u(b);
                    h = g.next();
                    for(k = {}; !h.done; k = {
                        Zh: void 0
                    }, h = g.next())l = h.value, k.Zh = e.add(l), k.Zh.onsuccess = function(n) {
                        return function() {
                            f.push(n.Zh.result);
                        };
                    }(k);
                    return m.g(d.promise(), 2);
                }
                return m.return(f);
            });
        };
        function lC(a, b, c, d) {
            a = hC(a.h, b);
            b = a.store();
            c = u(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                Lh: void 0
            }, e = c.next())f.Lh = e.value, b.delete(f.Lh).onsuccess = function(g) {
                return function() {
                    return d(g.Lh);
                };
            }(f);
            return a.promise();
        }
        function mC(a, b, c) {
            var d, e, f, g, h, k, l;
            return H(function(m) {
                if (m.h == 1) {
                    d = iC(a.h, b, "readonly");
                    e = d.store();
                    f = {};
                    g = [];
                    h = u(c);
                    k = h.next();
                    for(l = {}; !k.done; l = {
                        ag: void 0,
                        If: void 0
                    }, k = h.next())l.If = k.value, l.ag = e.get(l.If), l.ag.onsuccess = function(n) {
                        return function() {
                            n.ag.result == void 0 && g.push(n.If);
                            f[n.If] = n.ag.result;
                        };
                    }(l);
                    return m.g(d.promise(), 2);
                }
                if (g.length) throw new T(2, 9, 9012, "Could not find values for " + g);
                return m.return(c.map(function(n) {
                    return f[n];
                }));
            });
        }
        function oC(a) {
            this.g = new gC(a);
        }
        oC.prototype.destroy = function() {
            return this.g.destroy();
        };
        oC.prototype.getAll = function() {
            var a = this, b, c;
            return H(function(d) {
                return d.h == 1 ? (b = iC(a.g, "session-ids", "readonly"), c = [], d.g(fC(b, function(e, f) {
                    c.push(f);
                }), 2)) : d.h != 3 ? d.g(b.promise(), 3) : d.return(c);
            });
        };
        oC.prototype.add = function(a) {
            var b = hC(this.g, "session-ids"), c = b.store();
            a = u(a);
            for(var d = a.next(); !d.done; d = a.next())c.add(d.value);
            return b.promise();
        };
        oC.prototype.remove = function(a) {
            var b = this, c;
            return H(function(d) {
                return d.h == 1 ? (c = hC(b.g, "session-ids"), d.g(fC(c, function(e, f, g) {
                    a.includes(f.sessionId) && g.delete();
                }), 2)) : d.g(c.promise(), 0);
            });
        };
        function pC() {
            this.g = new Map;
        }
        pC.prototype.destroy = function() {
            for(var a = [], b = u(this.g.values()), c = b.next(); !c.done; c = b.next())a.push(c.value.destroy());
            this.g.clear();
            return Promise.all(a);
        };
        pC.prototype.init = function() {
            var a = this;
            qC.forEach(function(e, f) {
                (e = e()) && a.g.set(f, e);
            });
            for(var b = [], c = u(this.g.values()), d = c.next(); !d.done; d = c.next())b.push(d.value.init());
            return Promise.all(b);
        };
        function rC(a) {
            var b = null;
            a.g.forEach(function(c, d) {
                c.getCells().forEach(function(e, f) {
                    e.hasFixedKeySpace() || b || (b = {
                        path: {
                            Tb: d,
                            mb: f
                        },
                        mb: e
                    });
                });
            });
            if (b) return b;
            throw new T(2, 9, 9013, "Could not find a cell that supports add-operations");
        }
        function sC(a, b) {
            a.g.forEach(function(c, d) {
                c.getCells().forEach(function(e, f) {
                    b({
                        Tb: d,
                        mb: f
                    }, e);
                });
            });
        }
        function tC(a, b, c) {
            a = a.g.get(b);
            if (!a) throw new T(2, 9, 9013, "Could not find mechanism with name " + b);
            b = a.getCells().get(c);
            if (!b) throw new T(2, 9, 9013, "Could not find cell with name " + c);
            return b;
        }
        function uC(a, b) {
            a.g.forEach(function(c) {
                b(c.getEmeSessionCell());
            });
        }
        function vC(a) {
            var b = Array.from(a.g.keys());
            if (!b.length) throw new T(2, 9, 9E3, "No supported storage mechanisms found");
            return a.g.get(b[0]).getEmeSessionCell();
        }
        function wC(a) {
            var b, c, d;
            return H(function(e) {
                return e.h == 1 ? (b = Array.from(a.g.values()), c = b.length > 0, c || (d = qC, d.forEach(function(f) {
                    (f = f()) && b.push(f);
                })), e.g(Promise.all(b.map(function(f) {
                    return f.erase();
                })), 2)) : c ? e.B(0) : e.g(Promise.all(b.map(function(f) {
                    return f.destroy();
                })), 0);
            });
        }
        function xC(a, b) {
            qC.set(a, b);
        }
        O("shaka.offline.StorageMuxer", pC);
        pC.unregister = function(a) {
            qC.delete(a);
        };
        pC.register = xC;
        pC.prototype.destroy = pC.prototype.destroy;
        var qC = new Map;
        function yC() {
            jC.apply(this, arguments);
        }
        oa(yC, jC);
        yC.prototype.updateManifestExpiration = function(a, b) {
            var c = this, d, e, f;
            return H(function(g) {
                d = hC(c.h, c.g);
                e = d.store();
                f = new Yg;
                e.get(a).onsuccess = function(h) {
                    (h = h.target.result) ? (h.expiration = b, e.put(h), f.resolve()) : f.reject(new T(2, 9, 9012, "Could not find values for " + a));
                };
                return g.g(Promise.all([
                    d.promise(),
                    f
                ]), 0);
            });
        };
        yC.prototype.ie = function(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    b = [];
                    for(c = 0; c < a.periods.length; ++c)d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime, e = d - a.periods[c].startTime, f = zC(a.periods[c], e), b.push(f);
                    return h.g(Cx(b), 2);
                }
                g = h.i;
                return h.return({
                    creationTime: 0,
                    originalManifestUri: a.originalManifestUri,
                    duration: a.duration,
                    size: a.size,
                    expiration: a.expiration == null ? Infinity : a.expiration,
                    streams: g,
                    sessionIds: a.sessionIds,
                    drmInfo: a.drmInfo,
                    appMetadata: a.appMetadata,
                    sequenceMode: !1
                });
            });
        };
        function zC(a, b) {
            AC(a);
            for(var c = u(a.streams), d = c.next(); !d.done; d = c.next());
            return a.streams.map(function(e) {
                return BC(e, a.startTime, b);
            });
        }
        function BC(a, b, c) {
            var d = a.initSegmentUri ? CC(a.initSegmentUri) : null, e = b + a.presentationTimeOffset, f = b + c;
            return {
                id: a.id,
                originalId: null,
                groupId: null,
                primary: a.primary,
                type: a.contentType,
                mimeType: a.mimeType,
                codecs: a.codecs,
                frameRate: a.frameRate,
                pixelAspectRatio: void 0,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                kind: a.kind,
                language: a.language,
                originalLanguage: a.language || null,
                label: a.label,
                width: a.width,
                height: a.height,
                initSegmentKey: d,
                encrypted: a.encrypted,
                keyIds: new Set([
                    a.keyId
                ]),
                segments: a.segments.map(function(g) {
                    var h = CC(g.uri);
                    return {
                        startTime: b + g.startTime,
                        endTime: b + g.endTime,
                        dataKey: h,
                        initSegmentKey: d,
                        appendWindowStart: b,
                        appendWindowEnd: f,
                        timestampOffset: e,
                        tilesLayout: "",
                        mimeType: null,
                        codecs: null,
                        thumbnailSprite: null
                    };
                }),
                variantIds: a.variantIds,
                roles: [],
                forced: !1,
                audioSamplingRate: null,
                channelsCount: null,
                spatialAudio: !1,
                closedCaptions: null,
                tilesLayout: void 0,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1
            };
        }
        yC.prototype.Si = function(a) {
            return {
                data: a.data
            };
        };
        function CC(a) {
            var b;
            if ((b = /^offline:[0-9]+\/[0-9]+\/([0-9]+)$/.exec(a)) || (b = /^offline:segment\/([0-9]+)$/.exec(a))) return Number(b[1]);
            throw new T(2, 9, 9004, "Could not parse uri " + a);
        }
        function AC(a) {
            var b = a.streams.filter(function(h) {
                return h.contentType == "audio";
            });
            a = a.streams.filter(function(h) {
                return h.contentType == "video";
            });
            if (!b.every(function(h) {
                return h.variantIds;
            }) || !a.every(function(h) {
                return h.variantIds;
            })) {
                for(var c = u(b), d = c.next(); !d.done; d = c.next())d.value.variantIds = [];
                c = u(a);
                for(d = c.next(); !d.done; d = c.next())d.value.variantIds = [];
                c = 0;
                if (a.length && !b.length) {
                    d = c++;
                    for(var e = u(a), f = e.next(); !f.done; f = e.next())f.value.variantIds.push(d);
                }
                if (!a.length && b.length) for(d = c++, e = u(b), f = e.next(); !f.done; f = e.next())f.value.variantIds.push(d);
                if (a.length && b.length) for(b = u(b), d = b.next(); !d.done; d = b.next())for(d = d.value, e = u(a), f = e.next(); !f.done; f = e.next()){
                    f = f.value;
                    var g = c++;
                    d.variantIds.push(g);
                    f.variantIds.push(g);
                }
            }
        }
        function DC() {
            jC.apply(this, arguments);
        }
        oa(DC, jC);
        DC.prototype.ie = function(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    b = [];
                    for(c = 0; c < a.periods.length; ++c){
                        d = c == a.periods.length - 1 ? a.duration : a.periods[c + 1].startTime;
                        e = d - a.periods[c].startTime;
                        for(var k = a.periods[c], l = [], m = u(k.streams), n = m.next(); !n.done; n = m.next())n = n.value, n.variantIds.length != 0 && l.push(EC(n, k.startTime, k.startTime + e));
                        f = l;
                        b.push(f);
                    }
                    return h.g(Cx(b), 2);
                }
                g = h.i;
                return h.return({
                    appMetadata: a.appMetadata,
                    creationTime: 0,
                    drmInfo: a.drmInfo,
                    duration: a.duration,
                    expiration: a.expiration == null ? Infinity : a.expiration,
                    originalManifestUri: a.originalManifestUri,
                    sessionIds: a.sessionIds,
                    size: a.size,
                    streams: g,
                    sequenceMode: !1
                });
            });
        };
        function EC(a, b, c) {
            return {
                id: a.id,
                originalId: a.originalId,
                groupId: null,
                primary: a.primary,
                type: a.contentType,
                mimeType: a.mimeType,
                codecs: a.codecs,
                frameRate: a.frameRate,
                pixelAspectRatio: a.pixelAspectRatio,
                hdr: void 0,
                colorGamut: void 0,
                videoLayout: void 0,
                kind: a.kind,
                language: a.language,
                originalLanguage: a.language || null,
                label: a.label,
                width: a.width,
                height: a.height,
                encrypted: a.encrypted,
                keyIds: new Set([
                    a.keyId
                ]),
                segments: a.segments.map(function(d) {
                    return {
                        startTime: b + d.startTime,
                        endTime: b + d.endTime,
                        initSegmentKey: a.initSegmentKey,
                        appendWindowStart: b,
                        appendWindowEnd: c,
                        timestampOffset: b - a.presentationTimeOffset,
                        dataKey: d.dataKey,
                        tilesLayout: "",
                        mimeType: null,
                        codecs: null,
                        thumbnailSprite: null
                    };
                }),
                variantIds: a.variantIds,
                roles: [],
                forced: !1,
                audioSamplingRate: null,
                channelsCount: null,
                spatialAudio: !1,
                closedCaptions: null,
                tilesLayout: void 0,
                external: !1,
                fastSwitching: !1,
                isAudioMuxedInVideo: !1
            };
        }
        function FC() {
            jC.apply(this, arguments);
        }
        oa(FC, jC);
        p = FC.prototype;
        p.hasFixedKeySpace = function() {
            return !1;
        };
        p.addSegments = function(a) {
            return this.add(this.i, a);
        };
        p.addManifests = function(a) {
            return this.add(this.g, a);
        };
        p.updateManifest = function(a, b) {
            return nC(this, a, b);
        };
        p.ie = function(a) {
            a.expiration == null && (a.expiration = Infinity);
            return Promise.resolve(a);
        };
        function GC() {
            this.m = this.j = this.i = this.h = this.g = this.l = null;
        }
        p = GC.prototype;
        p.init = function() {
            var a = this, b = new Yg, c = !1, d = new Uf(function() {
                c = !0;
                b.reject(new T(2, 9, 9017));
            });
            typeof HC === "number" && HC > 0 && d.Z(HC);
            var e = window1.indexedDB.open("shaka_offline_db", 5);
            e.onsuccess = function() {
                if (!c) {
                    d.stop();
                    var f = e.result;
                    a.l = f;
                    var g = f.objectStoreNames;
                    g = g.contains("manifest") && g.contains("segment") ? new yC(f, "segment", "manifest") : null;
                    a.g = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v2") && g.contains("segment-v2") ? new DC(f, "segment-v2", "manifest-v2") : null;
                    a.h = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v3") && g.contains("segment-v3") ? new DC(f, "segment-v3", "manifest-v3") : null;
                    a.i = g;
                    g = f.objectStoreNames;
                    g = g.contains("manifest-v5") && g.contains("segment-v5") ? new FC(f, "segment-v5", "manifest-v5") : null;
                    a.j = g;
                    f = f.objectStoreNames.contains("session-ids") ? new oC(f) : null;
                    a.m = f;
                    b.resolve();
                }
            };
            e.onupgradeneeded = function() {
                for(var f = e.result, g = u([
                    "segment-v5",
                    "manifest-v5",
                    "session-ids"
                ]), h = g.next(); !h.done; h = g.next())h = h.value, f.objectStoreNames.contains(h) || f.createObjectStore(h, {
                    autoIncrement: !0
                });
            };
            e.onerror = function(f) {
                c || (d.stop(), b.reject(new T(2, 9, 9001, e.error)), f.preventDefault());
            };
            return b;
        };
        p.destroy = function() {
            var a = this;
            return H(function(b) {
                switch(b.h){
                    case 1:
                        if (!a.g) {
                            b.B(2);
                            break;
                        }
                        return b.g(a.g.destroy(), 2);
                    case 2:
                        if (!a.h) {
                            b.B(4);
                            break;
                        }
                        return b.g(a.h.destroy(), 4);
                    case 4:
                        if (!a.i) {
                            b.B(6);
                            break;
                        }
                        return b.g(a.i.destroy(), 6);
                    case 6:
                        if (!a.j) {
                            b.B(8);
                            break;
                        }
                        return b.g(a.j.destroy(), 8);
                    case 8:
                        if (!a.m) {
                            b.B(10);
                            break;
                        }
                        return b.g(a.m.destroy(), 10);
                    case 10:
                        a.l && a.l.close(), b.j();
                }
            });
        };
        p.getCells = function() {
            var a = new Map;
            this.g && a.set("v1", this.g);
            this.h && a.set("v2", this.h);
            this.i && a.set("v3", this.i);
            this.j && a.set("v5", this.j);
            return a;
        };
        p.getEmeSessionCell = function() {
            return this.m;
        };
        p.erase = function() {
            var a = this;
            return H(function(b) {
                switch(b.h){
                    case 1:
                        if (!a.g) {
                            b.B(2);
                            break;
                        }
                        return b.g(a.g.destroy(), 2);
                    case 2:
                        if (!a.h) {
                            b.B(4);
                            break;
                        }
                        return b.g(a.h.destroy(), 4);
                    case 4:
                        if (!a.i) {
                            b.B(6);
                            break;
                        }
                        return b.g(a.i.destroy(), 6);
                    case 6:
                        if (!a.j) {
                            b.B(8);
                            break;
                        }
                        return b.g(a.j.destroy(), 8);
                    case 8:
                        return a.l && a.l.close(), b.g(IC(), 10);
                    case 10:
                        return a.l = null, a.g = null, a.h = null, a.i = null, a.j = null, b.g(a.init(), 0);
                }
            });
        };
        function IC() {
            var a = new Yg, b = window1.indexedDB.deleteDatabase("shaka_offline_db");
            b.onblocked = function() {};
            b.onsuccess = function() {
                a.resolve();
            };
            b.onerror = function(c) {
                a.reject(new T(2, 9, 9001, b.error));
                c.preventDefault();
            };
            return a;
        }
        var HC = 5;
        O("shaka.offline.indexeddb.StorageMechanismOpenTimeout", HC);
        xC("idb", function() {
            return Xb().si() ? new GC : null;
        });
        function JC(a, b, c, d) {
            this.g = a;
            this.i = b;
            this.h = c;
            this.l = d;
            this.j = [
                "offline:",
                a,
                "/",
                b,
                "/",
                c,
                "/",
                d
            ].join("");
        }
        JC.prototype.Tb = function() {
            return this.i;
        };
        JC.prototype.mb = function() {
            return this.h;
        };
        JC.prototype.key = function() {
            return this.l;
        };
        JC.prototype.toString = function() {
            return this.j;
        };
        function KC(a) {
            a = /^offline:([a-z]+)\/([^/]+)\/([^/]+)\/([0-9]+)$/.exec(a);
            if (a == null) return null;
            var b = a[1];
            if (b != "manifest" && b != "segment") return null;
            var c = a[2];
            if (!c) return null;
            var d = a[3];
            return d && b != null ? new JC(b, c, d, Number(a[4])) : null;
        }
        function LC(a, b) {
            this.h = a;
            this.g = b;
        }
        function MC(a, b) {
            var c = new Wl(null, 0);
            c.Ab(b.duration);
            var d = b.streams.filter(function(l) {
                return l.type == "audio";
            }), e = b.streams.filter(function(l) {
                return l.type == "video";
            });
            d = NC(a, d, e, c);
            e = b.streams.filter(function(l) {
                return l.type == Ec;
            }).map(function(l) {
                return OC(a, l, c);
            });
            var f = b.streams.filter(function(l) {
                return l.type == "image";
            }).map(function(l) {
                return OC(a, l, c);
            }), g = b.drmInfo ? [
                b.drmInfo
            ] : [];
            if (b.drmInfo) for(var h = u(d.values()), k = h.next(); !k.done; k = h.next())k = k.value, k.audio && k.audio.encrypted && (k.audio.drmInfos = g), k.video && k.video.encrypted && (k.video.drmInfos = g);
            return {
                presentationTimeline: c,
                offlineSessionIds: b.sessionIds,
                variants: Array.from(d.values()),
                textStreams: e,
                imageStreams: f,
                sequenceMode: b.sequenceMode || !1,
                ignoreManifestTimestampsInSegmentsMode: !1,
                type: b.type || "UNKNOWN",
                serviceDescription: null,
                nextUrl: null,
                periodCount: 1,
                gapCount: 0,
                isLowLatency: !1,
                startTime: null
            };
        }
        function NC(a, b, c, d) {
            for(var e = new Set, f = u(b), g = f.next(); !g.done; g = f.next()){
                g = u(g.value.variantIds);
                for(var h = g.next(); !h.done; h = g.next())e.add(h.value);
            }
            f = u(c);
            for(g = f.next(); !g.done; g = f.next())for(g = u(g.value.variantIds), h = g.next(); !h.done; h = g.next())e.add(h.value);
            f = new Map;
            e = u(e);
            for(g = e.next(); !g.done; g = e.next())g = g.value, f.set(g, {
                id: g,
                language: "",
                disabledUntilTime: 0,
                primary: !1,
                audio: null,
                video: null,
                bandwidth: 0,
                allowedByApplication: !0,
                allowedByKeySystem: !0,
                decodingInfos: []
            });
            b = u(b);
            for(e = b.next(); !e.done; e = b.next())for(g = e.value, e = OC(a, g, d), g = u(g.variantIds), h = g.next(); !h.done; h = g.next())h = f.get(h.value), h.language = e.language, h.primary = h.primary || e.primary, h.audio = e;
            c = u(c);
            for(b = c.next(); !b.done; b = c.next())for(e = b.value, b = OC(a, e, d), e = u(e.variantIds), g = e.next(); !g.done; g = e.next())g = f.get(g.value), g.primary = g.primary || b.primary, g.video = b;
            return f;
        }
        function OC(a, b, c) {
            var d = b.segments.map(function(e) {
                return PC(a, e, b);
            });
            c.Ae(d);
            return {
                id: b.id,
                originalId: b.originalId,
                groupId: b.groupId,
                createSegmentIndex: function() {
                    return Promise.resolve();
                },
                segmentIndex: new vm(d),
                mimeType: b.mimeType,
                codecs: b.codecs,
                width: b.width || void 0,
                height: b.height || void 0,
                frameRate: b.frameRate,
                pixelAspectRatio: b.pixelAspectRatio,
                hdr: b.hdr,
                colorGamut: b.colorGamut,
                videoLayout: b.videoLayout,
                kind: b.kind,
                encrypted: b.encrypted,
                drmInfos: [],
                keyIds: b.keyIds,
                language: b.language,
                originalLanguage: b.originalLanguage || null,
                label: b.label,
                type: b.type,
                primary: b.primary,
                trickModeVideo: null,
                dependencyStream: null,
                emsgSchemeIdUris: null,
                roles: b.roles,
                forced: b.forced,
                channelsCount: b.channelsCount,
                audioSamplingRate: b.audioSamplingRate,
                spatialAudio: b.spatialAudio,
                closedCaptions: b.closedCaptions,
                tilesLayout: b.tilesLayout,
                mssPrivateData: b.mssPrivateData,
                accessibilityPurpose: null,
                external: b.external,
                fastSwitching: b.fastSwitching,
                fullMimeTypes: new Set([
                    wf(b.mimeType, b.codecs)
                ]),
                isAudioMuxedInVideo: b.isAudioMuxedInVideo || !1,
                baseOriginalId: null
            };
        }
        function PC(a, b, c) {
            var d = new JC("segment", a.h, a.g, b.dataKey);
            a = new Oj(b.startTime, b.endTime, function() {
                return [
                    d.toString()
                ];
            }, 0, null, b.initSegmentKey != null ? QC(a, b.initSegmentKey) : null, b.timestampOffset, b.appendWindowStart, b.appendWindowEnd, [], b.tilesLayout || "");
            a.mimeType = b.mimeType || c.mimeType || "";
            a.codecs = b.codecs || c.codecs || "";
            b.thumbnailSprite && a.kg(b.thumbnailSprite);
            return a;
        }
        function QC(a, b) {
            var c = new JC("segment", a.h, a.g, b);
            return new Mj(function() {
                return [
                    c.toString()
                ];
            }, 0, null);
        }
        function RC() {
            this.g = null;
        }
        p = RC.prototype;
        p.configure = function() {};
        p.start = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        d = KC(a);
                        c.g = d;
                        if (d == null || d.g != "manifest") throw new T(2, 1, 9004, a);
                        e = new pC;
                        m.F(2);
                        return m.g(e.init(), 4);
                    case 4:
                        return m.g(tC(e, d.Tb(), d.mb()), 5);
                    case 5:
                        return f = m.i, m.g(f.getManifests([
                            d.key()
                        ]), 6);
                    case 6:
                        return g = m.i, h = g[0], k = new LC(d.Tb(), d.mb()), l = MC(k, h), b.makeTextStreamsForClosedCaptions(l), m.return(l);
                    case 2:
                        return m.A(), m.g(e.destroy(), 7);
                    case 7:
                        m.C(0);
                }
            });
        };
        p.stop = function() {
            return Promise.resolve();
        };
        p.update = function() {};
        p.onExpirationUpdated = function(a, b) {
            var c = this, d, e, f, g, h, k, l;
            return H(function(m) {
                switch(m.h){
                    case 1:
                        return d = c.g, e = new pC, m.m(2, 3), m.g(e.init(), 5);
                    case 5:
                        return m.g(tC(e, d.Tb(), d.mb()), 6);
                    case 6:
                        return f = m.i, m.g(f.getManifests([
                            d.key()
                        ]), 7);
                    case 7:
                        g = m.i;
                        h = g[0];
                        k = h.sessionIds.includes(a);
                        l = h.expiration == void 0 || h.expiration > b;
                        if (!k || !l) {
                            m.B(3);
                            break;
                        }
                        return m.g(f.updateManifestExpiration(d.key(), b), 3);
                    case 3:
                        return m.A(), m.g(e.destroy(), 10);
                    case 10:
                        m.C(0);
                        break;
                    case 2:
                        m.l(), m.B(3);
                }
            });
        };
        p.onInitialVariantChosen = function() {};
        p.banLocation = function() {};
        p.setMediaElement = function() {};
        xd("application/x-offline-manifest", function() {
            return new RC;
        });
        function SC() {}
        function TC(a, b) {
            var c = KC(a);
            c && c.g == "manifest" ? (a = {
                uri: a,
                originalUri: a,
                data: new ArrayBuffer(0),
                headers: {
                    "content-type": "application/x-offline-manifest"
                },
                originalRequest: b
            }, a = bh(a)) : a = c && c.g == "segment" ? UC(c.key(), c, b) : $g(new T(2, 1, 9004, a));
            return a;
        }
        function UC(a, b, c) {
            var d = new pC;
            return bh(void 0).eb(function() {
                return d.init();
            }).eb(function() {
                return tC(d, b.Tb(), b.mb());
            }).eb(function(e) {
                return e.getSegments([
                    b.key()
                ]);
            }).eb(function(e) {
                return {
                    uri: b,
                    data: e[0].data,
                    headers: {},
                    originalRequest: c
                };
            }).finally(function() {
                return d.destroy();
            });
        }
        O("shaka.offline.OfflineScheme", SC);
        SC.plugin = TC;
        ih("offline", TC);
        function VC(a, b, c) {
            var d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        d = [];
                        for(var m = [], n = u(c), q = n.next(); !q.done; q = n.next()){
                            q = q.value;
                            for(var r = !1, t = u(m), v = t.next(); !v.done; v = t.next())if (v = v.value, WC(v.info, q)) {
                                v.sessionIds.push(q.sessionId);
                                r = !0;
                                break;
                            }
                            r || m.push({
                                info: q,
                                sessionIds: [
                                    q.sessionId
                                ]
                            });
                        }
                        e = u(m);
                        f = e.next();
                    case 2:
                        if (f.done) {
                            l.B(4);
                            break;
                        }
                        g = f.value;
                        h = XC(a, b, g);
                        return l.g(h, 5);
                    case 5:
                        k = l.i;
                        d = d.concat(k);
                        f = e.next();
                        l.B(2);
                        break;
                    case 4:
                        return l.return(d);
                }
            });
        }
        function XC(a, b, c) {
            var d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return d = new Oh({
                            Cc: b,
                            onError: function() {},
                            Uf: function() {},
                            onExpirationUpdated: function() {},
                            onEvent: function() {}
                        }), f.m(2), d.configure(a), f.g(Wh(d, c.info.keySystem, c.info.licenseUri, c.info.serverCertificate, c.info.audioCapabilities, c.info.videoCapabilities), 4);
                    case 4:
                        f.o(3);
                        break;
                    case 2:
                        return f.l(), f.g(d.destroy(), 5);
                    case 5:
                        return f.return([]);
                    case 3:
                        return e = [], f.g(Promise.all(c.sessionIds.map(function(g) {
                            return H(function(h) {
                                if (h.h == 1) return h.m(2), h.g(hi(d, g), 4);
                                if (h.h != 2) return e.push(g), h.o(0);
                                h.l();
                                h.j();
                            });
                        })), 6);
                    case 6:
                        return f.g(d.destroy(), 7);
                    case 7:
                        return f.return(e);
                }
            });
        }
        function WC(a, b) {
            function c(d, e) {
                return d.robustness == e.robustness && d.contentType == e.contentType;
            }
            return a.keySystem == b.keySystem && a.licenseUri == b.licenseUri && bd(a.audioCapabilities, b.audioCapabilities, c) && bd(a.videoCapabilities, b.videoCapabilities, c);
        }
        function YC(a, b, c) {
            var d = b.presentationTimeline.getDuration();
            b = ZC(b);
            return {
                offlineUri: null,
                originalManifestUri: a,
                duration: d,
                size: 0,
                expiration: Infinity,
                tracks: b,
                appMetadata: c,
                isIncomplete: !1
            };
        }
        function $C(a, b) {
            var c = MC(new LC(a.Tb(), a.mb()), b), d = b.appMetadata || {};
            c = ZC(c);
            return {
                offlineUri: a.toString(),
                originalManifestUri: b.originalManifestUri,
                duration: b.duration,
                size: b.size,
                expiration: b.expiration,
                tracks: c,
                appMetadata: d,
                isIncomplete: b.isIncomplete || !1
            };
        }
        function ZC(a) {
            var b = [], c = Fg(a.variants);
            c = u(c);
            for(var d = c.next(); !d.done; d = c.next())b.push(wg(d.value));
            a = u(a.textStreams);
            for(c = a.next(); !c.done; c = a.next())b.push(xg(c.value));
            return b;
        }
        function aD() {
            this.g = new Map;
        }
        function bD(a, b) {
            var c = b.audio, d = b.video;
            c && !d && a.g.set(c.id, c.bandwidth || b.bandwidth);
            !c && d && a.g.set(d.id, d.bandwidth || b.bandwidth);
            if (c && d) {
                var e = c.bandwidth || 393216, f = d.bandwidth || b.bandwidth - e;
                f <= 0 && (f = b.bandwidth);
                a.g.set(c.id, e);
                a.g.set(d.id, f);
            }
        }
        function cD(a, b) {
            a.g.set(b.id, b.bandwidth || 2048);
        }
        function dD(a, b) {
            a = a.g.get(b);
            a == null && (a = 0);
            return a;
        }
        function eD(a) {
            var b = this;
            if (a && a.constructor != W) throw new T(2, 9, 9008);
            this.g = this.h = null;
            a ? (this.h = a.g, this.g = a.Qb()) : (this.h = zo(), this.g = new hh, this.g.configure(this.h.networking));
            this.i = [];
            this.l = [];
            var c = !a;
            this.j = new uh(function() {
                var d, e, f, g, h;
                return H(function(k) {
                    switch(k.h){
                        case 1:
                            return k.g(Promise.all(b.l.map(function(l) {
                                return $B(l);
                            })), 2);
                        case 2:
                            d = function() {};
                            e = [];
                            f = u(b.i);
                            for(g = f.next(); !g.done; g = f.next())h = g.value, e.push(h.then(d, d));
                            return k.g(Promise.all(e), 3);
                        case 3:
                            if (!c) {
                                k.B(4);
                                break;
                            }
                            return k.g(b.g.destroy(), 4);
                        case 4:
                            b.h = null, b.g = null, k.j();
                    }
                });
            });
            this.m = 1E9;
        }
        function fD() {
            if (Ad(Xb())) a: {
                var a = u(qC.values());
                for(var b = a.next(); !b.done; b = a.next())if (b = b.value, b = b()) {
                    b.destroy();
                    a = !0;
                    break a;
                }
                a = !1;
            }
            else a = !1;
            return a;
        }
        p = eD.prototype;
        p.destroy = function() {
            return this.j.destroy();
        };
        p.configure = function(a, b) {
            arguments.length == 2 && typeof a == "string" && (a = co(a, b));
            return Eo(this.h, a);
        };
        p.getConfiguration = function() {
            var a = zo();
            Eo(a, this.h, zo());
            return a;
        };
        p.Qb = function() {
            return this.g;
        };
        p.store = function(a, b, c, d, e) {
            var f = this, g = this.getConfiguration(), h = new ZB(this.g);
            this.l.push(h);
            b = gD(this, a, b || {}, d || [], e || [], function() {
                var k;
                return H(function(l) {
                    if (l.h == 1) return c ? l.B(2) : l.g(fn(a, f.g, g.manifest.retryParameters), 3);
                    l.h != 2 && (c = l.i);
                    k = Cd(a, c || null);
                    return l.return(k());
                });
            }, g, h);
            b = new Zg(b, function() {
                return $B(h);
            });
            b.finally(function() {
                ad(f.l, h);
            });
            return hD(this, b);
        };
        function gD(a, b, c, d, e, f, g, h) {
            var k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M;
            return H(function(L) {
                switch(L.h){
                    case 1:
                        return iD(), l = k = null, m = new pC, r = q = n = null, L.m(2, 3), L.g(f(), 5);
                    case 5:
                        return k = L.i, L.g(jD(a, b, k, g), 6);
                    case 6:
                        t = L.i;
                        kD(a);
                        v = !t.presentationTimeline.U() && !t.presentationTimeline.fd();
                        if (!v) throw new T(2, 9, 9005, b);
                        w = u(d);
                        x = w.next();
                    case 7:
                        if (x.done) {
                            L.B(9);
                            break;
                        }
                        y = x.value;
                        return L.g(lD(a, y, t), 10);
                    case 10:
                        z = L.i;
                        t.imageStreams.push(z);
                        kD(a);
                        x = w.next();
                        L.B(7);
                        break;
                    case 9:
                        A = u(e), E = A.next();
                    case 11:
                        if (E.done) return Yh(g.drm.clearKeys, t.variants), B = t.variants.some(function(Q) {
                            if (Q.audio) {
                                for(var S = u(Q.audio.drmInfos), Z = S.next(); !Z.done; Z = S.next())if (Z.value.licenseServerUri.startsWith("data:")) return !0;
                            }
                            if (Q.video) {
                                for(Q = u(Q.video.drmInfos), S = Q.next(); !S.done; S = Q.next())if (S.value.licenseServerUri.startsWith("data:")) return !0;
                            }
                            return !1;
                        }), J = g.offline.usePersistentLicense, B && (J = !1), L.g(a.wd(t, function(Q) {
                            r = r || Q;
                        }, g, J), 15);
                        C = E.value;
                        return L.g(mD(a, t, C.uri, C.language, C.kind, C.mime, C.codecs), 14);
                    case 14:
                        D = L.i;
                        t.textStreams.push(D);
                        kD(a);
                        E = A.next();
                        L.B(11);
                        break;
                    case 15:
                        l = L.i;
                        kD(a);
                        if (r) throw r;
                        return L.g(nD(t, l, g, J), 16);
                    case 16:
                        return L.g(m.init(), 17);
                    case 17:
                        return kD(a), L.g(rC(m), 18);
                    case 18:
                        return n = L.i, kD(a), F = oD(l, t, b, c, g, h, J), I = F.Nl, K = F.zi, L.g(n.mb.addManifests([
                            I
                        ]), 19);
                    case 19:
                        N = L.i;
                        kD(a);
                        q = N[0];
                        kD(a);
                        if (r) throw r;
                        return L.g(pD(a, K, q, I, h, g, n.mb, t, l, J), 20);
                    case 20:
                        return kD(a), qD(t, I, l, J), L.g(n.mb.updateManifest(q, I), 21);
                    case 21:
                        return kD(a), P = new JC("manifest", n.path.Tb, n.path.mb, q), L.return($C(P, I));
                    case 3:
                        return L.A(), L.g(m.destroy(), 22);
                    case 22:
                        if (!k) {
                            L.B(23);
                            break;
                        }
                        return L.g(k.stop(), 23);
                    case 23:
                        if (!l) {
                            L.B(25);
                            break;
                        }
                        return L.g(l.destroy(), 25);
                    case 25:
                        L.C(0);
                        break;
                    case 2:
                        M = L.l();
                        if (q == null) {
                            L.B(27);
                            break;
                        }
                        return L.g(rD(q), 27);
                    case 27:
                        throw r || M;
                }
            });
        }
        function pD(a, b, c, d, e, f, g, h, k, l) {
            var m, n, q, r, t, v, w, x, y, z, A;
            return H(function(E) {
                switch(E.h){
                    case 1:
                        m = {};
                        n = 0;
                        q = function() {
                            if (a.j.g || e.l) throw new T(2, 9, 7001);
                        };
                        r = function(C, D) {
                            var B, J, F, I, K, N, P, M, L;
                            return H(function(Q) {
                                if (Q.h == 1) {
                                    B = u(C);
                                    J = B.next();
                                    for(F = {}; !J.done; F = {
                                        wc: void 0
                                    }, J = B.next())F.wc = J.value, q(), I = VB(F.wc, f), K = F.wc.i, N = F.wc.h, P = function(S) {
                                        return function(Z) {
                                            var pa, va, Ca, ua;
                                            return H(function(xa) {
                                                switch(xa.h){
                                                    case 1:
                                                        pa = S.wc.g;
                                                        va = pa.dc(!1);
                                                        if (!pa.aesKey || va) {
                                                            xa.B(2);
                                                            break;
                                                        }
                                                        return xa.g(en(Z, pa.aesKey, S.wc.j), 3);
                                                    case 3:
                                                        Z = xa.i;
                                                    case 2:
                                                        return Ca = UB(pa), xa.g(g.addSegments([
                                                            {
                                                                data: Z
                                                            }
                                                        ]), 4);
                                                    case 4:
                                                        ua = xa.i, q(), m[Ca] = ua[0], n += Z.byteLength, xa.j();
                                                }
                                            });
                                        };
                                    }(F), M = F.wc.g, (L = M.dc(!1)) ? cC(e, F.wc.groupId, L, K, N, P) : e.queue(F.wc.groupId, I, K, N, P);
                                    return Q.g(dC(e), 2);
                                }
                                q();
                                if (!D || e.l) return Q.B(0);
                                qD(h, d, k, l);
                                return Q.g(g.updateManifest(c, d), 0);
                            });
                        };
                        t = !1;
                        E.m(2);
                        if (!sD(h) || !t || tD(h)) {
                            E.B(4);
                            break;
                        }
                        return E.g(r(b.filter(function(C) {
                            return C.h;
                        }), !0), 5);
                    case 5:
                        return q(), b = b.filter(function(C) {
                            return !C.h;
                        }), v = m, w = n, m = {}, n = 0, E.g(uD(g, c, d, v, w, function() {
                            return kD(a);
                        }), 6);
                    case 6:
                        q();
                    case 4:
                        if (t) {
                            E.B(7);
                            break;
                        }
                        return E.g(r(b, !1), 8);
                    case 8:
                        return q(), x = m, y = n, m = {}, n = 0, E.g(uD(g, c, d, x, y, function() {
                            return q();
                        }), 9);
                    case 9:
                        q();
                    case 7:
                        E.o(0);
                        break;
                    case 2:
                        return z = E.l(), A = Object.values(m), E.g(g.removeSegments(A, function() {}), 10);
                    case 10:
                        throw z;
                }
            });
        }
        function rD(a) {
            var b, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return b = new pC, f.g(b.init(), 2);
                    case 2:
                        return f.g(rC(b), 3);
                    case 3:
                        return c = f.i, d = new JC("manifest", c.path.Tb, c.path.mb, a), f.g(b.destroy(), 4);
                    case 4:
                        return e = new eD, f.g(e.remove(d.toString()), 0);
                }
            });
        }
        function uD(a, b, c, d, e, f) {
            var g, h, k, l, m, n, q, r, t, v, w;
            return H(function(x) {
                switch(x.h){
                    case 1:
                        g = !1;
                        x.m(2);
                        h = !0;
                        k = u(c.streams);
                        for(l = k.next(); !l.done; l = k.next())for(m = l.value, n = u(m.segments), q = n.next(); !q.done; q = n.next())r = q.value, t = r.pendingSegmentRefId ? d[r.pendingSegmentRefId] : null, t != null && (r.dataKey = t, r.pendingSegmentRefId = void 0), t = r.pendingInitSegmentRefId ? d[r.pendingInitSegmentRefId] : null, t != null && (r.initSegmentKey = t, r.pendingInitSegmentRefId = void 0), r.pendingSegmentRefId && (h = !1), r.pendingInitSegmentRefId && (h = !1);
                        c.size += e;
                        h && (c.isIncomplete = !1);
                        return x.g(a.updateManifest(b, c), 4);
                    case 4:
                        g = !0;
                        f();
                        x.o(0);
                        break;
                    case 2:
                        return v = x.l(), x.g(rD(b), 5);
                    case 5:
                        if (g) {
                            x.B(6);
                            break;
                        }
                        w = Object.values(d);
                        return x.g(a.removeSegments(w, function() {}), 6);
                    case 6:
                        throw v;
                }
            });
        }
        function nD(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E, C, D, B, J, F, I, K, N, P, M, L, Q;
            return H(function(S) {
                switch(S.h){
                    case 1:
                        return e = {
                            width: Infinity,
                            height: Infinity
                        }, dg(a, c.restrictions, e), S.g(gg(b, a, d, c.drm.preferredKeySystems, c.drm.keySystemsMapping), 2);
                    case 2:
                        f = [];
                        g = c.preferredDecodingAttributes;
                        h = c.preferredVideoCodecs;
                        k = c.preferredAudioCodecs;
                        l = c.preferredTextFormats;
                        bg(a, h, k, g, l);
                        m = u(a.variants);
                        for(n = m.next(); !n.done; n = m.next())q = n.value, f.push(wg(q));
                        r = u(a.textStreams);
                        for(t = r.next(); !t.done; t = r.next())v = t.value, f.push(xg(v));
                        w = u(a.imageStreams);
                        for(x = w.next(); !x.done; x = w.next())y = x.value, f.push(yg(y));
                        return S.g(c.offline.trackSelectionCallback(f), 3);
                    case 3:
                        z = S.i;
                        A = a.presentationTimeline.getDuration();
                        E = 0;
                        C = u(z);
                        for(D = C.next(); !D.done; D = C.next())B = D.value, J = B.bandwidth * A / 8, E += J;
                        S.m(4);
                        return S.g(c.offline.downloadSizeCallback(E), 6);
                    case 6:
                        F = S.i;
                        if (!F) throw new T(2, 9, 9014);
                        S.o(5);
                        break;
                    case 4:
                        I = S.l();
                        if (I instanceof T) throw I;
                        throw new T(2, 9, 9015);
                    case 5:
                        K = new Set;
                        N = new Set;
                        P = new Set;
                        M = u(z);
                        for(L = M.next(); !L.done; L = M.next())Q = L.value, Q.type == "variant" && K.add(Q.id), Q.type == "text" && N.add(Q.id), Q.type == "image" && P.add(Q.id);
                        a.variants = a.variants.filter(function(Z) {
                            return K.has(Z.id);
                        });
                        a.textStreams = a.textStreams.filter(function(Z) {
                            return N.has(Z.id);
                        });
                        a.imageStreams = a.imageStreams.filter(function(Z) {
                            return P.has(Z.id);
                        });
                        vD(a);
                        S.j();
                }
            });
        }
        function oD(a, b, c, d, e, f, g) {
            var h = YC(c, b, d), k = e.offline.progressCallback;
            aC(f, function(t, v) {
                h.size = v;
                k(h, t);
            }, function(t, v) {
                l && g && m == v && di(a, "cenc", t);
            });
            var l = sD(b) && !tD(b), m = null;
            l && (m = wD.get(a.g.keySystem));
            for(var n = new aD, q = u(b.textStreams), r = q.next(); !r.done; r = q.next())n.g.set(r.value.id, 52);
            q = u(b.imageStreams);
            for(r = q.next(); !r.done; r = q.next())cD(n, r.value);
            q = u(b.variants);
            for(r = q.next(); !r.done; r = q.next())bD(n, r.value);
            f = xD(f, n, b, e);
            e = f.streams;
            f = f.zi;
            (n = a.g) && g && (n.initData = []);
            return {
                Nl: {
                    creationTime: Date.now(),
                    originalManifestUri: c,
                    duration: b.presentationTimeline.getDuration(),
                    size: 0,
                    expiration: a.oe(),
                    streams: e,
                    sessionIds: g ? pi(a) : [],
                    drmInfo: n,
                    appMetadata: d,
                    isIncomplete: !0,
                    sequenceMode: b.sequenceMode,
                    type: b.type
                },
                zi: f
            };
        }
        function sD(a) {
            return a.variants.some(function(b) {
                var c = b.audio && b.audio.encrypted;
                return b.video && b.video.encrypted || c;
            });
        }
        function tD(a) {
            return a.variants.some(function(b) {
                return (b.video ? b.video.drmInfos : []).concat(b.audio ? b.audio.drmInfos : []).some(function(c) {
                    return c.initData && c.initData.length;
                });
            });
        }
        function qD(a, b, c, d) {
            b.expiration = c.oe();
            c = pi(c);
            b.sessionIds = d ? c : [];
            if (sD(a) && d && !c.length) throw new T(2, 9, 9007);
        }
        p.remove = function(a) {
            return yD(this, zD(this, a));
        };
        function zD(a, b) {
            var c, d, e, f, g, h;
            return H(function(k) {
                switch(k.h){
                    case 1:
                        iD();
                        c = KC(b);
                        if (c == null || c.g != "manifest") throw new T(2, 9, 9004, b);
                        d = c;
                        e = new pC;
                        k.F(2);
                        return k.g(e.init(), 4);
                    case 4:
                        return k.g(tC(e, d.Tb(), d.mb()), 5);
                    case 5:
                        return f = k.i, k.g(f.getManifests([
                            d.key()
                        ]), 6);
                    case 6:
                        return g = k.i, h = g[0], k.g(Promise.all([
                            AD(a, h, e),
                            BD(f, d, h)
                        ]), 2);
                    case 2:
                        return k.A(), k.g(e.destroy(), 8);
                    case 8:
                        k.C(0);
                }
            });
        }
        function CD(a, b) {
            for(var c = [], d = u(a.streams), e = d.next(); !e.done; e = d.next())e = e.value, b && e.type == "video" ? c.push({
                contentType: wf(e.mimeType, e.codecs),
                robustness: a.drmInfo.videoRobustness
            }) : b || e.type != "audio" || c.push({
                contentType: wf(e.mimeType, e.codecs),
                robustness: a.drmInfo.audioRobustness
            });
            return c;
        }
        function AD(a, b, c) {
            return H(function(d) {
                return d.g(DD(a.g, a.h.drm, c, b), 0);
            });
        }
        function BD(a, b, c) {
            function d() {}
            var e = ED(c);
            $C(b, c);
            return Promise.all([
                a.removeSegments(e, d),
                a.removeManifests([
                    b.key()
                ], d)
            ]);
        }
        p.jm = function() {
            return yD(this, FD(this));
        };
        function FD(a) {
            var b, c, d, e, f, g, h, k, l, m;
            return H(function(n) {
                switch(n.h){
                    case 1:
                        return iD(), b = a.g, c = a.h.drm, d = new pC, e = !1, n.F(2), n.g(d.init(), 4);
                    case 4:
                        f = [], uC(d, function(q) {
                            return f.push(q);
                        }), g = u(f), h = g.next();
                    case 5:
                        if (h.done) {
                            n.B(2);
                            break;
                        }
                        k = h.value;
                        return n.g(k.getAll(), 8);
                    case 8:
                        return l = n.i, n.g(VC(c, b, l), 9);
                    case 9:
                        return m = n.i, n.g(k.remove(m), 10);
                    case 10:
                        m.length != l.length && (e = !0);
                        h = g.next();
                        n.B(5);
                        break;
                    case 2:
                        return n.A(), n.g(d.destroy(), 11);
                    case 11:
                        n.C(3);
                        break;
                    case 3:
                        return n.return(!e);
                }
            });
        }
        p.list = function() {
            return yD(this, GD());
        };
        function GD() {
            var a, b, c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return iD(), a = [], b = new pC, d.F(2), d.g(b.init(), 4);
                    case 4:
                        return c = Promise.resolve(), sC(b, function(e, f) {
                            c = c.then(function() {
                                var g;
                                return H(function(h) {
                                    if (h.h == 1) return h.g(f.getAllManifests(), 2);
                                    g = h.i;
                                    g.forEach(function(k, l) {
                                        k = $C(new JC("manifest", e.Tb, e.mb, l), k);
                                        a.push(k);
                                    });
                                    h.j();
                                });
                            });
                        }), d.g(c, 2);
                    case 2:
                        return d.A(), d.g(b.destroy(), 6);
                    case 6:
                        d.C(3);
                        break;
                    case 3:
                        return d.return(a);
                }
            });
        }
        function jD(a, b, c, d) {
            var e, f, g, h, k;
            return H(function(l) {
                if (l.h == 1) return e = null, f = a.g, g = {
                    networkingEngine: f,
                    filter: function() {
                        return Promise.resolve();
                    },
                    makeTextStreamsForClosedCaptions: function() {},
                    onTimelineRegionAdded: function() {},
                    onEvent: function() {},
                    onError: function(m) {
                        e = m;
                    },
                    isLowLatencyMode: function() {
                        return !1;
                    },
                    updateDuration: function() {},
                    newDrmInfo: function() {},
                    onManifestUpdated: function() {},
                    getBandwidthEstimate: function() {
                        return d.abr.defaultBandwidthEstimate;
                    },
                    onMetadata: function() {},
                    disableStream: function() {},
                    addFont: function() {}
                }, c.configure(d.manifest), kD(a), l.g(c.start(b, g), 2);
                if (l.h != 3) return h = l.i, kD(a), k = HD(h), l.g(Promise.all(gb(k, function(m) {
                    return m.createSegmentIndex();
                })), 3);
                kD(a);
                if (e) throw e;
                return l.return(h);
            });
        }
        function lD(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x;
            return H(function(y) {
                switch(y.h){
                    case 1:
                        return y.g(ID(a, b), 2);
                    case 2:
                        d = y.i;
                        if (d != "text/vtt") throw new T(1, 2, 2017, b);
                        return y.g(JD(b, a.g, a.h.streaming.retryParameters), 3);
                    case 3:
                        e = y.i;
                        f = Lf(d);
                        if (!f) throw new T(2, 2, 2014, d);
                        g = f();
                        h = {
                            periodStart: 0,
                            segmentStart: 0,
                            segmentEnd: c.presentationTimeline.getDuration(),
                            vttOffset: 0
                        };
                        k = Fb(e);
                        l = g.parseMedia(k, h, b, []);
                        m = [];
                        n = u(l);
                        q = n.next();
                        for(r = {}; !q.done; r = {
                            wg: void 0,
                            yd: void 0
                        }, q = n.next())r.yd = q.value, r.wg = null, t = function(z) {
                            return function() {
                                z.wg == null && (z.wg = vc([
                                    b
                                ], [
                                    z.yd.payload
                                ]));
                                return z.wg || [];
                            };
                        }(r), v = new Oj(r.yd.startTime, r.yd.endTime, t, 0, null, null, 0, 0, Infinity), r.yd.payload.includes("#xywh") && (w = r.yd.payload.split("#xywh=")[1].split(","), w.length === 4 && v.kg({
                            height: parseInt(w[3], 10),
                            positionX: parseInt(w[0], 10),
                            positionY: parseInt(w[1], 10),
                            width: parseInt(w[2], 10)
                        })), m.push(v);
                        x = d;
                        if (!m.length) {
                            y.B(4);
                            break;
                        }
                        return y.g(fn(m[0].T()[0], a.g, a.h.manifest.retryParameters), 5);
                    case 5:
                        x = y.i;
                    case 4:
                        return y.return({
                            id: a.m++,
                            originalId: null,
                            groupId: null,
                            createSegmentIndex: function() {
                                return Promise.resolve();
                            },
                            segmentIndex: new vm(m),
                            mimeType: x || "",
                            codecs: "",
                            kind: "",
                            encrypted: !1,
                            drmInfos: [],
                            keyIds: new Set,
                            language: "und",
                            originalLanguage: null,
                            label: null,
                            type: "image",
                            primary: !1,
                            trickModeVideo: null,
                            dependencyStream: null,
                            emsgSchemeIdUris: null,
                            roles: [],
                            forced: !1,
                            channelsCount: null,
                            audioSamplingRate: null,
                            spatialAudio: !1,
                            closedCaptions: null,
                            tilesLayout: "1x1",
                            accessibilityPurpose: null,
                            external: !0,
                            fastSwitching: !1,
                            fullMimeTypes: new Set([
                                wf(x || "", "")
                            ]),
                            isAudioMuxedInVideo: !1,
                            baseOriginalId: null
                        });
                }
            });
        }
        function mD(a, b, c, d, e, f, g) {
            var h, k, l;
            return H(function(m) {
                if (m.h == 1) return f ? m.B(2) : m.g(ID(a, c), 3);
                m.h != 2 && (f = m.i);
                h = {
                    id: a.m++,
                    originalId: null,
                    groupId: null,
                    createSegmentIndex: function() {
                        return Promise.resolve();
                    },
                    segmentIndex: xm(0, b.presentationTimeline.getDuration(), [
                        c
                    ]),
                    mimeType: f || "",
                    codecs: g || "",
                    kind: e,
                    encrypted: !1,
                    drmInfos: [],
                    keyIds: new Set,
                    language: d,
                    originalLanguage: d,
                    label: null,
                    type: Ec,
                    primary: !1,
                    trickModeVideo: null,
                    dependencyStream: null,
                    emsgSchemeIdUris: null,
                    roles: [],
                    forced: !1,
                    channelsCount: null,
                    audioSamplingRate: null,
                    spatialAudio: !1,
                    closedCaptions: null,
                    accessibilityPurpose: null,
                    external: !0,
                    fastSwitching: !1,
                    fullMimeTypes: new Set([
                        wf(f || "", g || "")
                    ]),
                    isAudioMuxedInVideo: !1,
                    baseOriginalId: null
                };
                k = wf(h.mimeType, h.codecs);
                l = Mf(k);
                if (!l) throw new T(2, 2, 2014, f);
                return m.return(h);
            });
        }
        function ID(a, b) {
            var c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        return d.m(2), d.g(fn(b, a.g, a.h.streaming.retryParameters), 4);
                    case 4:
                        c = d.i;
                        d.o(3);
                        break;
                    case 2:
                        d.l();
                    case 3:
                        if (c) return d.return(c);
                        throw new T(1, 2, 2011, b);
                }
            });
        }
        function JD(a, b, c) {
            var d, e, f;
            return H(function(g) {
                if (g.h == 1) return d = sh, e = mh([
                    a
                ], c), e.method = "GET", g.g(b.request(d, e).promise, 2);
                f = g.i;
                return g.return(f.data);
            });
        }
        p.wd = function(a, b, c, d) {
            var e = this, f;
            return H(function(g) {
                return g.h == 1 ? (f = new Oh({
                    Cc: e.g,
                    onError: b,
                    Uf: function() {},
                    onExpirationUpdated: function() {},
                    onEvent: function() {}
                }), f.configure(c.drm), g.g(Th(f, a.variants, d), 2)) : g.h != 3 ? d ? g.g(fi(f), 3) : g.B(3) : g.return(f);
            });
        };
        function xD(a, b, c, d) {
            var e = new Map, f = HD(c), g = new Map;
            f = u(f);
            for(var h = f.next(); !h.done; h = f.next()){
                h = h.value;
                var k = KD(a, b, c, h, d, e);
                g.set(h.id, k);
            }
            a = u(c.variants);
            for(b = a.next(); !b.done; b = a.next())b = b.value, b.audio && g.get(b.audio.id).variantIds.push(b.id), b.video && g.get(b.video.id).variantIds.push(b.id);
            return {
                streams: Array.from(g.values()),
                zi: Array.from(e.values())
            };
        }
        function KD(a, b, c, d, e, f) {
            var g = {
                id: d.id,
                originalId: d.originalId,
                groupId: d.groupId,
                primary: d.primary,
                type: d.type,
                mimeType: d.mimeType,
                codecs: d.codecs,
                frameRate: d.frameRate,
                pixelAspectRatio: d.pixelAspectRatio,
                hdr: d.hdr,
                colorGamut: d.colorGamut,
                videoLayout: d.videoLayout,
                kind: d.kind,
                language: d.language,
                originalLanguage: d.originalLanguage,
                label: d.label,
                width: d.width || null,
                height: d.height || null,
                encrypted: d.encrypted,
                keyIds: d.keyIds,
                segments: [],
                variantIds: [],
                roles: d.roles,
                forced: d.forced,
                channelsCount: d.channelsCount,
                audioSamplingRate: d.audioSamplingRate,
                spatialAudio: d.spatialAudio,
                closedCaptions: d.closedCaptions,
                tilesLayout: d.tilesLayout,
                mssPrivateData: d.mssPrivateData,
                external: d.external,
                fastSwitching: d.fastSwitching,
                isAudioMuxedInVideo: d.isAudioMuxedInVideo
            }, h = e.offline.numberOfParallelDownloads, k = h === 0 ? d.id : 0;
            LD(d, c.presentationTimeline.Hb(), function(l, m) {
                var n = UB(l), q = void 0;
                if (!f.has(n)) {
                    var r = l.endTime - l.startTime;
                    r = dD(b, d.id) * r;
                    r = XB(a.g, r);
                    f.set(n, new TB(l, r, k, !1, m));
                }
                l.ia && (q = UB(l.ia), f.has(q) || (r = dD(b, d.id) * .5, r = XB(a.g, r), f.set(q, new TB(l.ia, r, k, !0, m))));
                g.segments.push({
                    pendingInitSegmentRefId: q,
                    initSegmentKey: q ? 0 : null,
                    startTime: l.startTime,
                    endTime: l.endTime,
                    appendWindowStart: l.appendWindowStart,
                    appendWindowEnd: l.appendWindowEnd,
                    timestampOffset: l.timestampOffset,
                    tilesLayout: l.tilesLayout,
                    pendingSegmentRefId: n,
                    dataKey: 0,
                    mimeType: l.mimeType,
                    codecs: l.codecs,
                    thumbnailSprite: l.thumbnailSprite
                });
                h !== 0 && (k = (k + 1) % h);
            });
            return g;
        }
        function LD(a, b, c) {
            b = a.segmentIndex.find(b);
            if (b != null) for(var d = a.segmentIndex.get(b); d;)c(d, b), d = a.segmentIndex.get(++b);
        }
        function kD(a) {
            if (a.j.g) throw new T(2, 9, 7001);
        }
        function iD() {
            if (!fD()) throw new T(2, 9, 9E3);
        }
        function yD(a, b) {
            return H(function(c) {
                if (c.h == 1) return a.i.push(b), c.F(2), c.g(b, 4);
                if (c.h != 2) return c.return(c.i);
                c.A();
                ad(a.i, b);
                return c.C(0);
            });
        }
        function hD(a, b) {
            var c = b.promise;
            a.i.push(c);
            return b.finally(function() {
                ad(a.i, c);
            });
        }
        function ED(a) {
            var b = new Set;
            a = u(a.streams);
            for(var c = a.next(); !c.done; c = a.next()){
                c = u(c.value.segments);
                for(var d = c.next(); !d.done; d = c.next())d = d.value, d.initSegmentKey != null && b.add(d.initSegmentKey), b.add(d.dataKey);
            }
            return Array.from(b);
        }
        function DD(a, b, c, d) {
            var e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    if (!d.drmInfo) return h.return();
                    e = vC(c);
                    f = d.sessionIds.map(function(k) {
                        return {
                            sessionId: k,
                            keySystem: d.drmInfo.keySystem,
                            licenseUri: d.drmInfo.licenseServerUri,
                            serverCertificate: d.drmInfo.serverCertificate,
                            audioCapabilities: CD(d, !1),
                            videoCapabilities: CD(d, !0)
                        };
                    });
                    return h.g(VC(b, a, f), 2);
                }
                return h.h != 3 ? (g = h.i, h.g(e.remove(g), 3)) : h.g(e.add(f.filter(function(k) {
                    return !g.includes(k.sessionId);
                })), 0);
            });
        }
        function HD(a) {
            for(var b = new Set, c = u(a.variants), d = c.next(); !d.done; d = c.next())d = d.value, d.audio && b.add(d.audio), d.video && b.add(d.video);
            c = u(a.textStreams);
            for(d = c.next(); !d.done; d = c.next())b.add(d.value);
            a = u(a.imageStreams);
            for(c = a.next(); !c.done; c = a.next())b.add(c.value);
            return b;
        }
        function vD(a) {
            a.variants.map(function(f) {
                return f.video;
            });
            var b = new Set(a.variants.map(function(f) {
                return f.audio;
            }));
            a = a.textStreams;
            for(var c = u(b), d = c.next(); !d.done; d = c.next()){
                d = u(b);
                for(var e = d.next(); !e.done; e = d.next());
            }
            b = u(a);
            for(c = b.next(); !c.done; c = b.next())for(c = u(a), d = c.next(); !d.done; d = c.next());
        }
        O("shaka.offline.Storage", eD);
        eD.deleteAll = function() {
            var a;
            return H(function(b) {
                return b.h == 1 ? (a = new pC, b.F(2), b.g(wC(a), 2)) : b.h != 5 ? (b.A(), b.g(a.destroy(), 5)) : b.C(0);
            });
        };
        eD.prototype.list = eD.prototype.list;
        eD.prototype.removeEmeSessions = eD.prototype.jm;
        eD.prototype.remove = eD.prototype.remove;
        eD.prototype.store = eD.prototype.store;
        eD.prototype.getNetworkingEngine = eD.prototype.Qb;
        eD.prototype.getConfiguration = eD.prototype.getConfiguration;
        eD.prototype.configure = eD.prototype.configure;
        eD.prototype.destroy = eD.prototype.destroy;
        eD.support = fD;
        var wD = (new Map).set("org.w3.clearkey", "1077efecc0b24d02ace33c1e52e2fb4b").set("com.widevine.alpha", "edef8ba979d64acea3c827dcd51d21ed").set("com.microsoft.playready", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.recommendation", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.software", "9a04f07998404286ab92e65be0885f95").set("com.microsoft.playready.hardware", "9a04f07998404286ab92e65be0885f95").set("com.huawei.wiseplay", "3d5e6d359b9a41e8b843dd3c6e72c42c");
        Ar("offline", fD);
        function MD() {}
        function ND() {
            for(var a = u(OD), b = a.next(); !b.done; b = a.next()){
                b = b.value;
                try {
                    b.callback();
                } catch (c) {
                    Za("Error installing polyfill!", c);
                }
            }
        }
        function PD(a, b) {
            a = {
                priority: b || 0,
                callback: a
            };
            for(b = 0; b < OD.length; b++)if (OD[b].priority < a.priority) {
                OD.splice(b, 0, a);
                return;
            }
            OD.push(a);
        }
        O("shaka.polyfill", MD);
        MD.register = PD;
        MD.installAll = ND;
        var OD = [];
        function QD() {}
        function RD() {
            if (!Object.getOwnPropertyDescriptor(Element.prototype, "ariaHidden")) for(var a = u([
                "ariaHidden",
                "ariaLabel",
                "ariaPressed",
                "ariaSelected"
            ]), b = a.next(); !b.done; b = a.next())SD(b.value);
        }
        function SD(a) {
            var b = "aria-" + a.toLowerCase().replace(/^aria/, "");
            Object.defineProperty(Element.prototype, a, {
                get: function() {
                    return this.getAttribute(b);
                },
                set: function(c) {
                    c == null || c == void 0 ? this.removeAttribute(b) : this.setAttribute(b, c);
                }
            });
        }
        MD.Aria = QD;
        QD.install = RD;
        PD(RD);
        function TD(a, b, c) {
            this.g = a;
            this.i = b || null;
            this.h = c || null;
            this.keySystem = a.keySystem;
        }
        TD.prototype.getConfiguration = function() {
            var a = this.g.getConfiguration();
            if (a.videoCapabilities) for(var b = u(a.videoCapabilities), c = b.next(); !c.done; c = b.next())c.value.encryptionScheme = this.i;
            if (a.audioCapabilities) for(b = u(a.audioCapabilities), c = b.next(); !c.done; c = b.next())c.value.encryptionScheme = this.h;
            return a;
        };
        TD.prototype.createMediaKeys = function() {
            return this.g.createMediaKeys();
        };
        function UD(a) {
            if (Rb(a)) return "cbcs";
            if (Pb(a) || Qb(a) || Ob(a) || a === "com.huawei.wiseplay") return "cenc";
            Za("EmeEncryptionSchemePolyfill: Unknown key system:", a, "Please contribute!");
            return null;
        }
        function VD(a) {
            if (!a) return !1;
            a = a.getConfiguration();
            var b = a.audioCapabilities && a.audioCapabilities[0];
            return (a = a.videoCapabilities && a.videoCapabilities[0] || b) && a.encryptionScheme !== void 0 ? !0 : !1;
        }
        function WD(a, b) {
            return !a || a == b || (a == "cbcs" || a == "cbcs-1-9") && Xb().od() ? !0 : !1;
        }
        function XD() {}
        var YD;
        function ZD() {
            Xb().ng() && !YD && !navigator.emeEncryptionSchemePolyfilled && navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration && (YD = navigator.requestMediaKeySystemAccess, navigator.requestMediaKeySystemAccess = $D, navigator.emeEncryptionSchemePolyfilled = !0);
        }
        function $D(a, b) {
            var c = this, d, e;
            return H(function(f) {
                if (f.h == 1) return f.g(YD.call(c, a, b), 2);
                d = f.i;
                if (e = VD(d)) return navigator.requestMediaKeySystemAccess = YD, f.return(d);
                navigator.requestMediaKeySystemAccess = aE;
                return f.return(aE.call(c, a, b));
            });
        }
        function aE(a, b) {
            var c = this, d, e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                if (v.h == 1) {
                    d = UD(a);
                    e = [];
                    f = u(b);
                    for(g = f.next(); !g.done; g = f.next())h = g.value, k = bE(h.videoCapabilities, d), l = bE(h.audioCapabilities, d), h.videoCapabilities && h.videoCapabilities.length && !k.length || h.audioCapabilities && h.audioCapabilities.length && !l.length || (m = Object.assign({}, h), m.videoCapabilities = k, m.audioCapabilities = l, e.push(m));
                    if (!e.length) throw n = Error("Unsupported keySystem or supportedConfigurations."), n.name = "NotSupportedError", n.code = DOMException.NOT_SUPPORTED_ERR, n;
                    return v.g(YD.call(c, a, e), 2);
                }
                q = v.i;
                t = r = null;
                e[0] && (e[0].videoCapabilities && (r = e[0].videoCapabilities[0].encryptionScheme), e[0].audioCapabilities && (t = e[0].audioCapabilities[0].encryptionScheme));
                return v.return(new TD(q, r, t));
            });
        }
        function bE(a, b) {
            return a ? a.filter(function(c) {
                return WD(c.encryptionScheme, b);
            }) : a;
        }
        MD.EmeEncryptionScheme = XD;
        XD.install = ZD;
        PD(ZD);
        function cE() {}
        function dE() {
            if (window1.Document) {
                var a = Element.prototype;
                a.requestFullscreen = a.requestFullscreen || a.mozRequestFullScreen || a.webkitRequestFullscreen;
                a = Document.prototype;
                a.exitFullscreen = a.exitFullscreen || a.mozCancelFullScreen || a.webkitCancelFullScreen;
                "fullscreenElement" in document || (Object.defineProperty(document, "fullscreenElement", {
                    get: function() {
                        return document.mozFullScreenElement || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement;
                    }
                }), Object.defineProperty(document, "fullscreenEnabled", {
                    get: function() {
                        return document.mozFullScreenEnabled || document.webkitFullscreenEnabled;
                    }
                }));
                document.addEventListener("webkitfullscreenchange", eE);
                document.addEventListener("webkitfullscreenerror", eE);
                document.addEventListener("mozfullscreenchange", eE);
                document.addEventListener("mozfullscreenerror", eE);
            }
        }
        function eE(a) {
            var b = a.type.replace(/^(webkit|moz)/, "").toLowerCase(), c = document.createEvent("Event");
            c.initEvent(b, a.bubbles, a.cancelable);
            a.target.dispatchEvent(c);
        }
        MD.Fullscreen = cE;
        cE.install = dE;
        PD(dE);
        function fE() {}
        var gE;
        function hE() {
            Xb().ng() && !gE && !navigator.mediaCapabilitiesEncryptionSchemePolyfilled && navigator.mediaCapabilities && (gE = navigator.mediaCapabilities.decodingInfo, navigator.mediaCapabilities.decodingInfo = iE, navigator.mediaCapabilitiesEncryptionSchemePolyfilled = !0);
        }
        function iE(a) {
            var b = this, c, d, e;
            return H(function(f) {
                switch(f.h){
                    case 1:
                        return f.g(gE.call(b, a), 2);
                    case 2:
                        c = f.i;
                        if (!c.supported || !a.keySystemConfiguration) return f.return(c);
                        d = c.keySystemAccess;
                        if (e = VD(d)) return navigator.mediaCapabilities.decodingInfo = gE, f.return(c);
                        navigator.mediaCapabilities.decodingInfo = jE;
                        if (d) {
                            f.B(3);
                            break;
                        }
                        return f.g(kE(a), 4);
                    case 4:
                        return c.keySystemAccess = f.i, f.return(c);
                    case 3:
                        return f.return(jE.call(b, a));
                }
            });
        }
        function jE(a) {
            var b = this, c, d, e, f, g, h, k;
            return H(function(l) {
                switch(l.h){
                    case 1:
                        return d = c = null, !a.keySystemConfiguration || (e = a.keySystemConfiguration, f = e.keySystem, d = e.audio && e.audio.encryptionScheme, c = e.video && e.video.encryptionScheme, g = UD(f), h = {
                            powerEfficient: !1,
                            smooth: !1,
                            supported: !1,
                            keySystemAccess: null,
                            configuration: a
                        }, WD(d, g) && WD(c, g)) ? l.g(gE.call(b, a), 2) : l.return(h);
                    case 2:
                        k = l.i;
                        if (k.keySystemAccess) {
                            k.keySystemAccess = new TD(k.keySystemAccess, c, d);
                            l.B(3);
                            break;
                        }
                        if (!a.keySystemConfiguration) {
                            l.B(3);
                            break;
                        }
                        return l.g(kE(a), 5);
                    case 5:
                        k.keySystemAccess = l.i;
                    case 3:
                        return l.return(k);
                }
            });
        }
        function kE(a) {
            var b, c;
            return H(function(d) {
                if (d.h == 1) {
                    var e = a.keySystemConfiguration, f = [], g = [];
                    e.audio && f.push({
                        robustness: e.audio.robustness || "",
                        contentType: a.audio.contentType,
                        encryptionScheme: e.audio.encryptionScheme
                    });
                    e.video && g.push({
                        robustness: e.video.robustness || "",
                        contentType: a.video.contentType,
                        encryptionScheme: e.video.encryptionScheme
                    });
                    e = {
                        initDataTypes: e.initDataType ? [
                            e.initDataType
                        ] : [],
                        distinctiveIdentifier: e.distinctiveIdentifier,
                        persistentState: e.persistentState,
                        sessionTypes: e.sessionTypes
                    };
                    f.length && (e.audioCapabilities = f);
                    g.length && (e.videoCapabilities = g);
                    b = e;
                    return d.g(navigator.requestMediaKeySystemAccess(a.keySystemConfiguration.keySystem, [
                        b
                    ]), 2);
                }
                c = d.i;
                return d.return(c);
            });
        }
        MD.MCapEncryptionScheme = fE;
        fE.install = hE;
        PD(hE, -2);
        function lE() {}
        function mE() {
            Xb().mc() || (navigator.mediaCapabilities || (navigator.mediaCapabilities = {}), lE.originalMcap = navigator.mediaCapabilities, navigator.mediaCapabilities.decodingInfo = nE);
        }
        function nE(a) {
            var b, c, d, e, f, g, h, k, l, m, n;
            return H(function(q) {
                switch(q.h){
                    case 1:
                        b = {
                            supported: !1,
                            powerEfficient: !0,
                            smooth: !0,
                            keySystemAccess: null,
                            configuration: a
                        };
                        Xb();
                        c = a.video;
                        d = a.audio;
                        if (a.type != "media-source") {
                            if (a.type == "file") {
                                if (c && (e = c.contentType, f = Bd().canPlayType(e) != "", !f) || d && (g = d.contentType, h = Bd().canPlayType(g) != "", !h)) return q.return(b);
                            } else return q.return(b);
                            q.B(2);
                            break;
                        }
                        if (!Ad()) return q.return(b);
                        if (!c) {
                            q.B(3);
                            break;
                        }
                        return q.g(oE(c), 4);
                    case 4:
                        if (k = q.i, !k) return q.return(b);
                    case 3:
                        if (!d) {
                            q.B(2);
                            break;
                        }
                        return q.g(pE(d), 6);
                    case 6:
                        if (l = q.i, !l) return q.return(b);
                    case 2:
                        if (!a.keySystemConfiguration) return b.supported = !0, q.return(b);
                        m = a.keySystemConfiguration;
                        return q.g(qE(c, d, m), 8);
                    case 8:
                        if (n = q.i) b.supported = !0, b.keySystemAccess = n;
                    case 7:
                        return q.return(b);
                }
            });
        }
        function oE(a) {
            var b, c, d;
            return H(function(e) {
                return e.h == 1 ? (b = Xb(), c = b.Pa(), c !== "CAST" ? e.B(2) : e.g(rE(a), 3)) : e.h != 2 ? (d = e.i, e.return(d)) : e.return(Si(a.contentType));
            });
        }
        function pE(a) {
            var b, c, d, e, f;
            return H(function(g) {
                switch(g.h){
                    case 1:
                        b = Xb();
                        c = b.Pa();
                        d = a.contentType;
                        if (c !== "CAST" || !a.spatialRendering) {
                            g.B(2);
                            break;
                        }
                        d += "; spatialRendering=true";
                        if (!(window1.cast && cast.__platform__ && cast.__platform__.canDisplayType)) {
                            g.B(2);
                            break;
                        }
                        e = !1;
                        f = sE;
                        if (f.has(d)) {
                            e = f.get(d);
                            g.B(4);
                            break;
                        }
                        return g.g(cast.__platform__.canDisplayType(d), 5);
                    case 5:
                        e = g.i, f.set(d, e);
                    case 4:
                        return g.return(e);
                    case 2:
                        return g.return(Si(d));
                }
            });
        }
        function qE(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t;
            return H(function(v) {
                switch(v.h){
                    case 1:
                        d = [];
                        e = [];
                        f = [];
                        c.audio && (g = {
                            robustness: c.audio.robustness || "",
                            contentType: b.contentType
                        }, Xb().rj() && b.contentType.includes('codecs="ac-3"') && (g.contentType = 'audio/mp4; codecs="ec-3"'), c.audio.encryptionScheme && (g.encryptionScheme = c.audio.encryptionScheme, f.push(c.audio.encryptionScheme)), d.push(g));
                        c.video && (h = {
                            robustness: c.video.robustness || "",
                            contentType: a.contentType
                        }, c.video.encryptionScheme && (h.encryptionScheme = c.video.encryptionScheme, f.push(c.video.encryptionScheme)), e.push(h));
                        k = {
                            initDataTypes: [
                                c.initDataType
                            ],
                            distinctiveIdentifier: c.distinctiveIdentifier,
                            persistentState: c.persistentState,
                            sessionTypes: c.sessionTypes
                        };
                        d.length && (k.audioCapabilities = d);
                        e.length && (k.videoCapabilities = e);
                        l = a ? a.contentType : "";
                        m = b ? b.contentType : "";
                        n = Ff(l) + ";" + Ef(l);
                        q = Ff(m) + ";" + Ef(m);
                        r = c.keySystem;
                        t = null;
                        v.m(2);
                        var w = Sb(n, q, r, f);
                        if (Ub.has(w)) {
                            w = Sb(n, q, r, f);
                            t = Ub.get(w) || null;
                            v.B(4);
                            break;
                        }
                        return v.g(navigator.requestMediaKeySystemAccess(c.keySystem, [
                            k
                        ]), 5);
                    case 5:
                        w = t = v.i;
                        var x = Sb(n, q, r, f);
                        Ub.set(x, w);
                    case 4:
                        v.o(3);
                        break;
                    case 2:
                        v.l();
                    case 3:
                        return v.return(t);
                }
            });
        }
        function rE(a) {
            var b, c, d, e, f;
            return H(function(g) {
                if (g.h == 1) {
                    if (!(window1.cast && cast.__platform__ && cast.__platform__.canDisplayType)) return g.return(Si(a.contentType));
                    b = a.contentType;
                    a.width && a.height && a.width > 1280 && a.height > 720 && (b += "; width=" + a.width + "; height=" + a.height);
                    a.framerate && (c = Math.round(a.framerate), c < 24 || c > 30) && (b += "; framerate=" + a.framerate);
                    d = a.transferFunction || "";
                    switch(d){
                        case "":
                        case "srgb":
                            break;
                        case "pq":
                            b += "; eotf=smpte2084";
                            break;
                        case "hlg":
                            b += "; eotf=arib-std-b67";
                            break;
                        default:
                            return g.return(!1);
                    }
                    e = !1;
                    f = sE;
                    return f.has(b) ? (e = f.get(b), g.B(2)) : g.g(cast.__platform__.canDisplayType(b), 3);
                }
                g.h != 2 && (e = g.i, f.set(b, e));
                return g.return(e);
            });
        }
        MD.MediaCapabilities = lE;
        lE.install = mE;
        lE.originalMcap = null;
        var sE = new Map;
        PD(mE, -1);
        function tE() {}
        function uE() {
            var a = Xb(), b = a.Ma() === "WEBKIT" ? a.Ja() : null;
            (window1.MediaSource || window1.ManagedMediaSource) && b && window1.MediaSource && (b <= 12 ? (vE(), wE()) : b <= 15 && vE());
            a = u(a.Aj());
            for(b = a.next(); !b.done; b = a.next())xE(b.value);
            (window1.MediaSource || window1.ManagedMediaSource) && yE();
            window1.MediaSource && MediaSource.isTypeSupported('video/webm; codecs="vp9"') && !MediaSource.isTypeSupported('video/webm; codecs="vp09.00.10.08"') && zE();
        }
        function vE() {
            var a = MediaSource.prototype.addSourceBuffer;
            MediaSource.prototype.addSourceBuffer = function() {
                var b = a.apply(this, Ma.apply(0, arguments));
                b.abort = function() {};
                return b;
            };
        }
        function wE() {
            var a = SourceBuffer.prototype.remove;
            SourceBuffer.prototype.remove = function(b, c) {
                return a.call(this, b, c - .001);
            };
        }
        function yE() {
            if (window1.MediaSource) {
                var a = MediaSource.isTypeSupported.bind(MediaSource);
                MediaSource.isTypeSupported = function(c) {
                    return Bf(c) != "mp2t" && a(c);
                };
            }
            if (window1.ManagedMediaSource) {
                var b = ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
                window1.ManagedMediaSource.isTypeSupported = function(c) {
                    return Bf(c) != "mp2t" && b(c);
                };
            }
        }
        function xE(a) {
            var b = MediaSource.isTypeSupported.bind(MediaSource);
            MediaSource.isTypeSupported = function(d) {
                return Ef(d) != a && b(d);
            };
            if (window1.ManagedMediaSource) {
                var c = ManagedMediaSource.isTypeSupported.bind(ManagedMediaSource);
                window1.ManagedMediaSource.isTypeSupported = function(d) {
                    return Ef(d) != a && c(d);
                };
            }
        }
        function zE() {
            var a = MediaSource.isTypeSupported;
            Xb().bk() && (MediaSource.isTypeSupported = function(b) {
                var c = b.split(/ *; */), d = c.findIndex(function(g) {
                    return g.startsWith("codecs=");
                });
                if (d < 0) return a(b);
                var e = c[d].replace("codecs=", "").replace(/"/g, "").split(/\s*,\s*/), f = e.findIndex(function(g) {
                    return g.startsWith("vp09");
                });
                f >= 0 && (e[f] = "vp9", c[d] = 'codecs="' + e.join(",") + '"', b = c.join("; "));
                return a(b);
            });
        }
        MD.MediaSource = tE;
        tE.install = uE;
        PD(uE);
        function AE() {}
        function BE() {
            screen.orientation && screen.orientation.unlock || (screen.orientation != void 0 ? CE() : window1.orientation != void 0 && DE());
        }
        function CE() {
            var a = Object.getPrototypeOf(screen.orientation);
            screen.orientation.lock === void 0 && (a.lock = function() {
                return Promise.resolve();
            });
            screen.orientation.unlock === void 0 && (a.unlock = function() {});
        }
        function DE() {
            function a() {
                switch(window1.orientation){
                    case -90:
                        b.type = "landscape-secondary";
                        b.angle = 270;
                        break;
                    case 0:
                        b.type = "portrait-primary";
                        b.angle = 0;
                        break;
                    case 90:
                        b.type = "landscape-primary";
                        b.angle = 90;
                        break;
                    case 180:
                        b.type = "portrait-secondary", b.angle = 180;
                }
            }
            var b = new EE;
            screen.orientation = b;
            a();
            window1.addEventListener("orientationchange", function() {
                a();
                var c = new R("change");
                b.dispatchEvent(c);
            });
        }
        MD.Orientation = AE;
        AE.install = BE;
        function EE() {
            fb.call(this);
            this.type = "";
            this.angle = 0;
        }
        oa(EE, fb);
        EE.prototype.lock = function(a) {
            function b(d) {
                return screen.lockOrientation ? screen.lockOrientation(d) : screen.mozLockOrientation ? screen.mozLockOrientation(d) : !1;
            }
            var c = !1;
            switch(a){
                case "natural":
                    c = b("default");
                    break;
                case "any":
                    c = !0;
                    this.unlock();
                    break;
                default:
                    c = b(a);
            }
            if (c) return Promise.resolve();
            a = Error("screen.orientation.lock() is not available on this device");
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            return Promise.reject(a);
        };
        EE.prototype.unlock = function() {
            screen.unlockOrientation ? screen.unlockOrientation() : screen.mozUnlockOrientation && screen.mozUnlockOrientation();
        };
        PD(BE);
        function FE() {}
        var GE, HE, IE, JE, KE, LE;
        function ME(a) {
            if (window1.HTMLVideoElement && window1.WebKitMediaKeys && window1.shakaMediaKeysPolyfill != NE) {
                if (a === void 0 ? 0 : a) GE = !0, HE = Object.getOwnPropertyDescriptor(HTMLMediaElement.prototype, "mediaKeys"), IE = HTMLMediaElement.prototype.setMediaKeys, JE = window1.MediaKeys, KE = window1.MediaKeySystemAccess, LE = navigator.requestMediaKeySystemAccess;
                delete HTMLMediaElement.prototype.mediaKeys;
                HTMLMediaElement.prototype.mediaKeys = null;
                HTMLMediaElement.prototype.setMediaKeys = OE;
                window1.MediaKeys = PE;
                window1.MediaKeySystemAccess = QE;
                navigator.requestMediaKeySystemAccess = RE;
                window1.shakaMediaKeysPolyfill = NE;
                og.clear();
                Ub.clear();
            }
        }
        function RE(a, b) {
            try {
                var c = new QE(a, b);
                return Promise.resolve(c);
            } catch (d) {
                return Promise.reject(d);
            }
        }
        function OE(a) {
            var b = this.mediaKeys;
            b && b != a && SE(b, null);
            delete this.mediaKeys;
            return (this.mediaKeys = a) ? SE(a, this) : Promise.resolve();
        }
        function TE(a) {
            a = Fb(a.initData);
            if (Jb(a).getUint32(0, !0) + 4 != a.byteLength) throw new RangeError("Malformed FairPlay init data");
            a = cc(a.subarray(4), !0);
            a = hc(a);
            var b = new Event("encrypted");
            b.initDataType = "skd";
            b.initData = Gb(a);
            this.dispatchEvent(b);
        }
        MD.PatchedMediaKeysApple = FE;
        FE.uninstall = function() {
            window1.shakaMediaKeysPolyfill == NE && GE && (GE = !1, Object.defineProperty(HTMLMediaElement.prototype, "mediaKeys", HE), HTMLMediaElement.prototype.setMediaKeys = IE, window1.MediaKeys = JE, window1.MediaKeySystemAccess = KE, navigator.requestMediaKeySystemAccess = LE, HE = LE = IE = KE = JE = null, window1.shakaMediaKeysPolyfill = "", og.clear(), Ub.clear());
        };
        FE.install = ME;
        function QE(a, b) {
            this.keySystem = a;
            if (a.startsWith("com.apple.fps")) for(a = u(b), b = a.next(); !b.done; b = a.next()){
                var c = b.value;
                if (c.persistentState == "required") b = null;
                else {
                    b = {
                        audioCapabilities: [],
                        videoCapabilities: [],
                        persistentState: "optional",
                        distinctiveIdentifier: "optional",
                        initDataTypes: c.initDataTypes,
                        sessionTypes: [
                            "temporary"
                        ],
                        label: c.label
                    };
                    var d = !1, e = !1;
                    if (c.audioCapabilities) for(var f = u(c.audioCapabilities), g = f.next(); !g.done; g = f.next())g = g.value, g.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, g.contentType.split(";")[0]) && (b.audioCapabilities.push(g), e = !0));
                    if (c.videoCapabilities) for(c = u(c.videoCapabilities), f = c.next(); !f.done; f = c.next())f = f.value, f.contentType && (d = !0, WebKitMediaKeys.isTypeSupported(this.keySystem, f.contentType.split(";")[0]) && (b.videoCapabilities.push(f), e = !0));
                    d || (e = WebKitMediaKeys.isTypeSupported(this.keySystem, "video/mp4"));
                    b = e ? b : null;
                }
                if (b) {
                    this.g = b;
                    return;
                }
            }
            a = Error("Unsupported keySystem");
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            throw a;
        }
        QE.prototype.createMediaKeys = function() {
            var a = new PE(this.keySystem);
            return Promise.resolve(a);
        };
        QE.prototype.getConfiguration = function() {
            return this.g;
        };
        function PE(a) {
            this.h = new WebKitMediaKeys(a);
            this.g = new fd;
        }
        PE.prototype.createSession = function(a) {
            a = a || "temporary";
            if (a != "temporary") throw new TypeError("Session type " + a + " is unsupported on this platform.");
            return new UE(this.h, a);
        };
        PE.prototype.setServerCertificate = function() {
            return Promise.resolve(!1);
        };
        function SE(a, b) {
            a.g.Ta();
            if (!b) return Promise.resolve();
            a.g.u(b, "webkitneedkey", TE);
            try {
                return em(b, HTMLMediaElement.HAVE_METADATA, a.g, function() {
                    b.webkitSetMediaKeys(a.h);
                }), Promise.resolve();
            } catch (c) {
                return Promise.reject(c);
            }
        }
        PE.prototype.getStatusForPolicy = function() {
            return Promise.resolve("usable");
        };
        function UE(a) {
            fb.call(this);
            this.i = null;
            this.l = a;
            this.g = this.h = null;
            this.j = new fd;
            this.sessionId = "";
            this.expiration = NaN;
            this.closed = new Yg;
            this.keyStatuses = new VE;
            this.onkeystatuseschange = null;
        }
        oa(UE, fb);
        p = UE.prototype;
        p.generateRequest = function(a, b) {
            var c = this;
            this.h = new Yg;
            try {
                var d = this.l.createSession("video/mp4", Fb(b));
                this.i = d;
                this.sessionId = d.sessionId || "";
                this.j.u(this.i, "webkitkeymessage", function(e) {
                    c.h && (c.h.resolve(), c.h = null);
                    e = (new Map).set("messageType", c.keyStatuses.ec() == void 0 ? "license-request" : "license-renewal").set("message", Gb(e.message));
                    e = new R("message", e);
                    c.dispatchEvent(e);
                });
                this.j.u(d, "webkitkeyadded", function() {
                    c.g && (WE(c, "usable"), c.g.resolve(), c.g = null);
                });
                this.j.u(d, "webkitkeyerror", function() {
                    var e = Error("EME PatchedMediaKeysApple key error");
                    e.errorCode = c.i.error;
                    if (c.h != null) c.h.reject(e), c.h = null;
                    else if (c.g != null) c.g.reject(e), c.g = null;
                    else switch(c.i.error.code){
                        case WebKitMediaKeyError.MEDIA_KEYERR_OUTPUT:
                        case WebKitMediaKeyError.MEDIA_KEYERR_HARDWARECHANGE:
                            WE(c, "output-not-allowed");
                            break;
                        default:
                            WE(c, "internal-error");
                    }
                });
                WE(this, "status-pending");
            } catch (e) {
                this.h.reject(e);
            }
            return this.h;
        };
        p.load = function() {
            return Promise.reject(Error("MediaKeySession.load not yet supported"));
        };
        p.update = function(a) {
            this.g = new Yg;
            try {
                this.i.update(Fb(a));
            } catch (b) {
                this.g.reject(b);
            }
            return this.g;
        };
        p.close = function() {
            try {
                this.i.close(), this.closed.resolve(), this.j.Ta();
            } catch (a) {
                this.closed.reject(a);
            }
            return this.closed;
        };
        p.remove = function() {
            return Promise.reject(Error("MediaKeySession.remove is only applicable for persistent licenses, which are not supported on this platform"));
        };
        function WE(a, b) {
            var c = a.keyStatuses;
            c.size = b == void 0 ? 0 : 1;
            c.g = b;
            b = new R("keystatuseschange");
            a.dispatchEvent(b);
            if (a.onkeystatuseschange) a.onkeystatuseschange(b);
        }
        function VE() {
            this.size = 0;
            this.g = void 0;
        }
        p = VE.prototype;
        p.ec = function() {
            return this.g;
        };
        p.forEach = function(a) {
            this.g && a(this.g, Tb.value());
        };
        p.get = function(a) {
            if (this.has(a)) return this.g;
        };
        p.has = function(a) {
            var b = Tb.value();
            return this.g && Eb(a, b) ? !0 : !1;
        };
        p.entries = function() {};
        p.keys = function() {};
        p.values = function() {};
        var NE = "apple";
        PD(function() {
            window1.HTMLVideoElement && window1.WebKitMediaKeys && (navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration || ME());
        });
        function XE() {}
        function YE() {
            if (window1.MediaKeys) {
                var a = Xb();
                MediaKeys.prototype.setServerCertificate && a.Je() || (MediaKeys.prototype.setServerCertificate = ZE);
            }
        }
        function ZE() {
            return Promise.resolve(!1);
        }
        MD.PatchedMediaKeysCert = XE;
        XE.install = YE;
        PD(YE);
        function $E() {}
        function aF() {
            if (!(!window1.HTMLVideoElement || navigator.requestMediaKeySystemAccess && MediaKeySystemAccess.prototype.getConfiguration)) {
                if (HTMLMediaElement.prototype.webkitGenerateKeyRequest) bF = "webkit";
                else if (!HTMLMediaElement.prototype.generateKeyRequest) return;
                navigator.requestMediaKeySystemAccess = cF;
                delete HTMLMediaElement.prototype.mediaKeys;
                HTMLMediaElement.prototype.mediaKeys = null;
                HTMLMediaElement.prototype.setMediaKeys = dF;
                window1.MediaKeys = eF;
                window1.MediaKeySystemAccess = fF;
                window1.shakaMediaKeysPolyfill = gF;
            }
        }
        function hF(a) {
            var b = bF;
            return b ? b + a.charAt(0).toUpperCase() + a.slice(1) : a;
        }
        function cF(a, b) {
            try {
                var c = new fF(a, b);
                return Promise.resolve(c);
            } catch (d) {
                return Promise.reject(d);
            }
        }
        function dF(a) {
            var b = this.mediaKeys;
            b && b != a && iF(b, null);
            delete this.mediaKeys;
            (this.mediaKeys = a) && iF(a, this);
            return Promise.resolve();
        }
        MD.PatchedMediaKeysWebkit = $E;
        $E.install = aF;
        function fF(a, b) {
            this.g = this.keySystem = a;
            var c = !1;
            a == "org.w3.clearkey" && (this.g = "webkit-org.w3.clearkey", c = !1);
            var d = !1;
            var e = document.getElementsByTagName("video");
            e = e.length ? e[0] : document.createElement("video");
            b = u(b);
            for(var f = b.next(); !f.done; f = b.next()){
                f = f.value;
                var g = {
                    audioCapabilities: [],
                    videoCapabilities: [],
                    persistentState: "optional",
                    distinctiveIdentifier: "optional",
                    initDataTypes: f.initDataTypes,
                    sessionTypes: [
                        "temporary"
                    ],
                    label: f.label
                }, h = !1;
                if (f.audioCapabilities) for(var k = u(f.audioCapabilities), l = k.next(); !l.done; l = k.next())l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType.split(";")[0], this.g) && (g.audioCapabilities.push(l), d = !0));
                if (f.videoCapabilities) for(k = u(f.videoCapabilities), l = k.next(); !l.done; l = k.next())l = l.value, l.contentType && (h = !0, e.canPlayType(l.contentType, this.g) && (g.videoCapabilities.push(l), d = !0));
                h || (d = e.canPlayType("video/mp4", this.g) || e.canPlayType("video/webm", this.g));
                f.persistentState == "required" && (c ? (g.persistentState = "required", g.sessionTypes = [
                    "persistent-license"
                ]) : d = !1);
                if (d) {
                    this.h = g;
                    return;
                }
            }
            c = "Unsupported keySystem";
            if (a == "org.w3.clearkey" || a == "com.widevine.alpha") c = "None of the requested configurations were supported.";
            a = Error(c);
            a.name = "NotSupportedError";
            a.code = DOMException.NOT_SUPPORTED_ERR;
            throw a;
        }
        fF.prototype.createMediaKeys = function() {
            var a = new eF(this.g);
            return Promise.resolve(a);
        };
        fF.prototype.getConfiguration = function() {
            return this.h;
        };
        function eF(a) {
            this.l = a;
            this.h = null;
            this.g = new fd;
            this.i = [];
            this.j = new Map;
        }
        function iF(a, b) {
            a.h = b;
            a.g.Ta();
            var c = bF;
            b && (a.g.u(b, c + "needkey", function(d) {
                var e = new CustomEvent("encrypted");
                e.initDataType = "cenc";
                e.initData = Gb(d.initData);
                a.h.dispatchEvent(e);
            }), a.g.u(b, c + "keymessage", function(d) {
                var e = jF(a, d.sessionId);
                e && (d = (new Map).set("messageType", e.keyStatuses.ec() == void 0 ? "licenserequest" : "licenserenewal").set("message", d.message), d = new R("message", d), e.h && (e.h.resolve(), e.h = null), e.dispatchEvent(d));
            }), a.g.u(b, c + "keyadded", function(d) {
                (d = jF(a, d.sessionId)) && d.ready();
            }), a.g.u(b, c + "keyerror", function(d) {
                var e = jF(a, d.sessionId);
                if (e) {
                    var f = Error("EME v0.1b key error"), g = d.errorCode;
                    g.systemCode = d.systemCode;
                    f.errorCode = g;
                    !d.sessionId && e.h ? (d.systemCode == 45 && (f.message = "Unsupported session type."), e.h.reject(f), e.h = null) : d.sessionId && e.g ? (e.g.reject(f), e.g = null) : (f = d.systemCode, d.errorCode.code == MediaKeyError.MEDIA_KEYERR_OUTPUT ? kF(e, "output-restricted") : f == 1 ? kF(e, "expired") : kF(e, "internal-error"));
                }
            }));
        }
        eF.prototype.createSession = function(a) {
            a = a || "temporary";
            if (a != "temporary" && a != "persistent-license") throw new TypeError("Session type " + a + " is unsupported on this platform.");
            var b = this.h || document.createElement("video");
            b.src || (b.src = "about:blank");
            a = new lF(b, this.l, a);
            this.i.push(a);
            return a;
        };
        eF.prototype.setServerCertificate = function() {
            return Promise.resolve(!1);
        };
        eF.prototype.getStatusForPolicy = function() {
            return Promise.resolve("usable");
        };
        function jF(a, b) {
            var c = a.j.get(b);
            return c ? c : (c = a.i.shift()) ? (c.sessionId = b, a.j.set(b, c), c) : null;
        }
        function lF(a, b, c) {
            fb.call(this);
            this.j = a;
            this.m = !1;
            this.g = this.h = null;
            this.i = b;
            this.l = c;
            this.sessionId = "";
            this.expiration = NaN;
            this.closed = new Yg;
            this.keyStatuses = new mF;
            this.onkeystatuseschange = null;
        }
        oa(lF, fb);
        p = lF.prototype;
        p.ready = function() {
            kF(this, "usable");
            this.g && this.g.resolve();
            this.g = null;
        };
        function nF(a, b, c) {
            if (a.m) return Promise.reject(Error("The session is already initialized."));
            a.m = !0;
            try {
                if (a.l == "persistent-license") {
                    if (c) var d = Fb(hc("LOAD_SESSION|" + c));
                    else {
                        var e = hc("PERSISTENT|");
                        d = tc(e, b);
                    }
                } else d = Fb(b);
            } catch (g) {
                return Promise.reject(g);
            }
            a.h = new Yg;
            var f = hF("generateKeyRequest");
            try {
                a.j[f](a.i, d);
            } catch (g) {
                if (g.name != "InvalidStateError") return a.h = null, Promise.reject(g);
                new Uf(function() {
                    try {
                        a.j[f](a.i, d);
                    } catch (h) {
                        a.h.reject(h), a.h = null;
                    }
                }).Z(.01);
            }
            return a.h;
        }
        function oF(a, b, c) {
            if (a.g) a.g.then(function() {
                return oF(a, b, c);
            }).catch(function() {
                return oF(a, b, c);
            });
            else {
                a.g = b;
                if (a.i == "webkit-org.w3.clearkey") {
                    var d = bc(c);
                    var e = JSON.parse(d);
                    e.keys[0].kty != "oct" && (a.g.reject(Error("Response is not a valid JSON Web Key Set.")), a.g = null);
                    d = qc(e.keys[0].k);
                    e = qc(e.keys[0].kid);
                } else d = Fb(c), e = null;
                var f = hF("addKey");
                try {
                    a.j[f](a.i, d, e, a.sessionId);
                } catch (g) {
                    a.g.reject(g), a.g = null;
                }
            }
        }
        function kF(a, b) {
            var c = a.keyStatuses;
            c.size = b == void 0 ? 0 : 1;
            c.g = b;
            b = new R("keystatuseschange");
            a.dispatchEvent(b);
            if (a.onkeystatuseschange) a.onkeystatuseschange(b);
        }
        p.generateRequest = function(a, b) {
            return nF(this, b, null);
        };
        p.load = function(a) {
            return this.l == "persistent-license" ? nF(this, null, a) : Promise.reject(Error("Not a persistent session."));
        };
        p.update = function(a) {
            var b = new Yg;
            oF(this, b, a);
            return b;
        };
        p.close = function() {
            if (this.l != "persistent-license") {
                if (!this.sessionId) return this.closed.reject(Error("The session is not callable.")), this.closed;
                var a = hF("cancelKeyRequest");
                try {
                    this.j[a](this.i, this.sessionId);
                } catch (b) {}
            }
            this.closed.resolve();
            return this.closed;
        };
        p.remove = function() {
            return this.l != "persistent-license" ? Promise.reject(Error("Not a persistent session.")) : this.close();
        };
        function mF() {
            this.size = 0;
            this.g = void 0;
        }
        p = mF.prototype;
        p.ec = function() {
            return this.g;
        };
        p.forEach = function(a) {
            this.g && a(this.g, Tb.value());
        };
        p.get = function(a) {
            if (this.has(a)) return this.g;
        };
        p.has = function(a) {
            var b = Tb.value();
            return this.g && Eb(a, b) ? !0 : !1;
        };
        p.entries = function() {};
        p.keys = function() {};
        p.values = function() {};
        var bF = "", gF = "webkit";
        PD(aF);
        function pF() {}
        function qF() {
            if (window1.HTMLVideoElement) {
                var a = HTMLVideoElement.prototype;
                a.requestPictureInPicture && document.exitPictureInPicture || !a.webkitSupportsPresentationMode || (document.pictureInPictureEnabled = !0, document.pictureInPictureElement = null, a.requestPictureInPicture = rF, Object.defineProperty(a, "disablePictureInPicture", {
                    get: sF,
                    set: tF,
                    enumerable: !0,
                    configurable: !0
                }), document.exitPictureInPicture = uF, document.addEventListener("webkitpresentationmodechanged", vF, !0));
            }
        }
        function vF(a) {
            a = a.target;
            if (a.webkitPresentationMode == "picture-in-picture") {
                document.pictureInPictureElement = a;
                var b = new Event("enterpictureinpicture");
                a.dispatchEvent(b);
            } else document.pictureInPictureElement == a && (document.pictureInPictureElement = null), b = new Event("leavepictureinpicture"), a.dispatchEvent(b);
        }
        function rF() {
            return this.webkitSupportsPresentationMode("picture-in-picture") ? (this.webkitSetPresentationMode("picture-in-picture"), document.pictureInPictureElement = this, Promise.resolve()) : Promise.reject(Error("PiP not allowed by video element"));
        }
        function uF() {
            var a = document.pictureInPictureElement;
            return a ? (a.webkitSetPresentationMode("inline"), document.pictureInPictureElement = null, Promise.resolve()) : Promise.reject(Error("No picture in picture element found"));
        }
        function sF() {
            return this.hasAttribute("disablePictureInPicture") ? !0 : !this.webkitSupportsPresentationMode("picture-in-picture");
        }
        function tF(a) {
            a ? this.setAttribute("disablePictureInPicture", "") : this.removeAttribute("disablePictureInPicture");
        }
        MD.PiPWebkit = pF;
        pF.install = qF;
        PD(qF);
        function wF() {}
        function xF() {
            window1.crypto && ("randomUUID" in window1.crypto || (window1.crypto.randomUUID = yF));
        }
        function yF() {
            var a = URL.createObjectURL(new Blob), b = a.toString();
            URL.revokeObjectURL(a);
            return b.substr(b.lastIndexOf("/") + 1);
        }
        MD.RandomUUID = wF;
        wF.install = xF;
        PD(xF);
        function zF() {}
        function AF() {
            var a = Symbol.prototype;
            "description" in a || Object.defineProperty(a, "description", {
                get: BF
            });
        }
        function BF() {
            var a = /\((.*)\)/.exec(this.toString());
            return a ? a[1] : void 0;
        }
        MD.Symbol = zF;
        zF.install = AF;
        PD(AF);
        function CF() {}
        function DF() {
            for(var a = u([
                Uint8Array,
                Uint8ClampedArray,
                Uint16Array,
                Uint32Array,
                Int8Array,
                Int16Array,
                Int32Array,
                Float32Array,
                Float64Array
            ]), b = a.next(); !b.done; b = a.next()){
                b = b.value;
                var c = void 0;
                (c = b.prototype).indexOf != null || (c.indexOf = Array.prototype.indexOf);
                c = void 0;
                (c = b.prototype).lastIndexOf != null || (c.lastIndexOf = Array.prototype.lastIndexOf);
                c = void 0;
                (c = b.prototype).includes != null || (c.includes = Array.prototype.includes);
            }
        }
        MD.TypedArray = CF;
        CF.install = DF;
        PD(DF);
        function EF() {}
        function FF() {
            if (window1.HTMLMediaElement) {
                var a = HTMLMediaElement.prototype.play;
                HTMLMediaElement.prototype.play = function() {
                    var b = a.apply(this);
                    b && b.catch(function() {});
                    return b;
                };
            }
        }
        MD.VideoPlayPromise = EF;
        EF.install = FF;
        PD(FF);
        function GF() {}
        function HF() {
            if (window1.HTMLVideoElement) {
                var a = HTMLVideoElement.prototype;
                !a.getVideoPlaybackQuality && ("webkitDroppedFrameCount" in a || typeof Bd().webkitDroppedFrameCount === "number") && (a.getVideoPlaybackQuality = IF);
            }
        }
        function IF() {
            return {
                droppedVideoFrames: this.webkitDroppedFrameCount,
                totalVideoFrames: this.webkitDecodedFrameCount,
                corruptedVideoFrames: 0,
                creationTime: NaN,
                totalFrameDelay: 0
            };
        }
        MD.VideoPlaybackQuality = GF;
        GF.install = HF;
        PD(HF);
        function JF() {}
        function KF() {
            if (!window1.VTTCue && window1.TextTrackCue) {
                var a = null, b = TextTrackCue.length;
                if (b == 3) a = LF;
                else if (b == 6) a = MF;
                else {
                    try {
                        var c = !!LF(1, 2, "");
                    } catch (d) {
                        c = !1;
                    }
                    c && (a = LF);
                }
                a && (window1.VTTCue = function(d, e, f) {
                    return a(d, e, f);
                });
            }
        }
        function LF(a, b, c) {
            return new window1.TextTrackCue(a, b, c);
        }
        function MF(a, b, c) {
            return new window1.TextTrackCue(a + "-" + b + "-" + c, a, b, c);
        }
        MD.VTTCue = JF;
        JF.install = KF;
        PD(KF);
        function NF(a) {
            fb.call(this);
            this.g = a;
            this.m = null;
            this.h = [];
            this.j = -1;
            this.i = this.l = null;
            this.o = new fd;
        }
        oa(NF, fb);
        p = NF.prototype;
        p.destroy = function() {
            var a = this;
            return H(function(b) {
                if (b.h == 1) return b.g(a.removeAllItems(), 2);
                a.g = null;
                a.o && (a.o.release(), a.o = null);
                fb.prototype.release.call(a);
                b.j();
            });
        };
        p.configure = function(a) {
            this.m = a;
        };
        p.getConfiguration = function() {
            return this.m;
        };
        p.getCurrentItem = function() {
            return this.h.length && this.j >= 0 && this.j < this.h.length ? this.h[this.j] : null;
        };
        p.getCurrentItemIndex = function() {
            return this.j;
        };
        p.getItems = function() {
            return this.h.slice();
        };
        p.insertItems = function(a) {
            this.h.push.apply(this.h, G(a));
            this.dispatchEvent(new R("itemsinserted"));
        };
        p.removeAllItems = function() {
            var a = this, b, c, d, e;
            return H(function(f) {
                if (f.h == 1) return a.o.Ta(), a.h.length && a.j >= 0 ? f.g(a.g.tc(), 2) : f.B(2);
                if (f.h != 4) {
                    b = [];
                    a.i && (a.i.preloadManager.l || b.push(a.i.preloadManager.destroy()), a.i = null);
                    a.l && (a.l.preloadManager.l || b.push(a.l.preloadManager.destroy()), a.l = null);
                    c = u(a.h);
                    for(d = c.next(); !d.done; d = c.next())e = d.value, e.preloadManager && !e.preloadManager.l && b.push(e.preloadManager.destroy());
                    return b.length ? f.g(Promise.all(b), 4) : f.B(4);
                }
                a.h = [];
                a.j = -1;
                a.dispatchEvent(new R("itemsremoved"));
                f.j();
            });
        };
        p.playItem = function(a) {
            var b = this, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y;
            return H(function(z) {
                switch(z.h){
                    case 1:
                        b.o.Ta();
                        if (!b.h.length || a >= b.h.length) throw new T(2, 7, 7007);
                        c = b.getCurrentItem();
                        d = b.h[a];
                        b.j != a && (b.j = a, b.dispatchEvent(new R("currentitemchanged")));
                        e = b.g.vf();
                        f = b.m ? b.m.preloadNextUrlWindow : 0;
                        f > 0 && (g = !1, b.o.u(e, "timeupdate", function() {
                            var A, E, C, D;
                            return H(function(B) {
                                switch(B.h){
                                    case 1:
                                        if (b.l || b.h.length <= 1 || g || b.g.U() || !e.duration) return B.return();
                                        A = b.g.wa().end - e.currentTime;
                                        if (isNaN(A)) {
                                            B.B(0);
                                            break;
                                        }
                                        if (!(A <= f)) {
                                            B.B(0);
                                            break;
                                        }
                                        E = b.m && b.m.repeatMode;
                                        C = null;
                                        b.j + 1 < b.h.length ? C = b.h[b.j + 1] : E == 1 && (C = b.h[0]);
                                        if (!C || C.preloadManager && !C.preloadManager.l) {
                                            B.B(0);
                                            break;
                                        }
                                        g = !0;
                                        D = null;
                                        B.m(5);
                                        return B.g(b.g.preload(C.manifestUri, C.startTime, C.mimeType, C.config), 7);
                                    case 7:
                                        D = B.i;
                                        B.o(6);
                                        break;
                                    case 5:
                                        B.l(), D = null;
                                    case 6:
                                        b.l = {
                                            item: C,
                                            preloadManager: D
                                        }, g = !1, B.j();
                                }
                            });
                        }));
                        b.o.u(b.g, "complete", function() {
                            var A = b.m && b.m.repeatMode, E = !1;
                            if (A == 2) E = !0;
                            else {
                                var C = b.j + 1;
                                C < b.h.length ? b.playItem(C) : A == 1 && (b.h.length == 1 ? E = !0 : b.playItem(0));
                            }
                            E && (e.paused ? (e.currentTime = b.g.wa().start, e.play()) : b.o.u(e, "paused", function() {
                                e.currentTime = b.g.wa().start;
                                e.play();
                            }));
                        });
                        h = d.manifestUri;
                        d.preloadManager && !d.preloadManager.l && (h = d.preloadManager);
                        k = !1;
                        b.l && b.l.item == d && b.l.preloadManager ? h = b.l.preloadManager : b.i && b.i.item == d && b.i.preloadManager && (h = b.i.preloadManager, k = !0);
                        if (!b.i) {
                            z.B(2);
                            break;
                        }
                        if (k || b.i.preloadManager.l) {
                            z.B(3);
                            break;
                        }
                        return z.g(b.i.preloadManager.destroy(), 3);
                    case 3:
                        b.i = null;
                    case 2:
                        if (!(b.m && b.m.preloadPrevItem && c && b.g.xc() === ms)) {
                            z.B(5);
                            break;
                        }
                        l = null;
                        z.m(6);
                        return z.g(b.g.gk(), 8);
                    case 8:
                        l = z.i;
                        z.o(7);
                        break;
                    case 6:
                        z.l(), l = null;
                    case 7:
                        b.i = {
                            item: c,
                            preloadManager: l
                        };
                    case 5:
                        return d.config && (b.g.Dj(), b.g.configure(d.config)), z.g(b.g.load(h, d.startTime, d.mimeType), 9);
                    case 9:
                        b.l = null;
                        if (d.extraText) for(m = u(d.extraText), n = m.next(); !n.done; n = m.next())q = n.value, q.mime ? b.g.fe(q.uri, q.language, q.kind, q.mime, q.codecs) : b.g.fe(q.uri, q.language, q.kind);
                        if (d.extraThumbnail) for(r = u(d.extraThumbnail), t = r.next(); !t.done; t = r.next())v = t.value, b.g.cf(v);
                        if (d.extraChapter) for(w = u(d.extraChapter), x = w.next(); !x.done; x = w.next())y = x.value, b.g.bf(y.uri, y.language, y.mime);
                        z.j();
                }
            });
        };
        O("shaka.queue.QueueManager", NF);
        NF.prototype.playItem = NF.prototype.playItem;
        NF.prototype.removeAllItems = NF.prototype.removeAllItems;
        NF.prototype.insertItems = NF.prototype.insertItems;
        NF.prototype.getItems = NF.prototype.getItems;
        NF.prototype.getCurrentItemIndex = NF.prototype.getCurrentItemIndex;
        NF.prototype.getCurrentItem = NF.prototype.getCurrentItem;
        NF.prototype.getConfiguration = NF.prototype.getConfiguration;
        NF.prototype.configure = NF.prototype.configure;
        NF.prototype.destroy = NF.prototype.destroy;
        tr = function(a) {
            return new NF(a);
        };
        function OF() {}
        OF.prototype.parseInit = function() {};
        OF.prototype.setSequenceMode = function() {};
        OF.prototype.setManifestType = function() {};
        OF.prototype.parseMedia = function(a, b) {
            var c = null, d = [];
            a = bc(a).split(/\r?\n/);
            a = u(a);
            for(var e = a.next(); !e.done; e = a.next())if ((e = e.value) && !/^\s+$/.test(e) && (e = PF.exec(e))) {
                var f = QF.exec(e[1]);
                f = parseInt(f[1], 10) * 60 + parseFloat(f[2].replace(",", "."));
                e = new Ie(f, b.segmentEnd ? b.segmentEnd : f + 2, e[2]);
                c && (c.endTime = f, d.push(c));
                c = e;
            }
            c && d.push(c);
            return d;
        };
        O("shaka.text.LrcTextParser", OF);
        OF.prototype.parseMedia = OF.prototype.parseMedia;
        OF.prototype.setManifestType = OF.prototype.setManifestType;
        OF.prototype.setSequenceMode = OF.prototype.setSequenceMode;
        OF.prototype.parseInit = OF.prototype.parseInit;
        var PF = /^\[(\d{1,2}:\d{1,2}(?:[.,]\d{1,3})?)\](.*)/, QF = /^(\d+):(\d{1,2}(?:[.,]\d{1,3})?)$/;
        Jf("application/x-subtitle-lrc", function() {
            return new OF;
        });
        function RF() {
            this.g = "UNKNOWN";
        }
        RF.prototype.parseInit = function() {};
        RF.prototype.setSequenceMode = function() {};
        RF.prototype.setManifestType = function(a) {
            this.g = a;
        };
        RF.prototype.parseMedia = function(a, b, c, d) {
            var e = bc(a);
            a = [];
            if (e == "") return a;
            var f = ae(e, "tt", !0);
            if (!f) throw new T(2, 2, 2005, "Failed to parse TTML.");
            e = me(f, "body")[0];
            if (!e) return [];
            var g = se(f, SF, "frameRate"), h = se(f, SF, "subFrameRate"), k = se(f, SF, "frameRateMultiplier"), l = se(f, SF, "tickRate"), m = se(f, SF, "cellResolution"), n = f.attributes["xml:space"] || "default", q = se(f, TF, "extent");
            if (n != "default" && n != "preserve") throw new T(2, 2, 2005, "Invalid xml:space value: " + n);
            n = n == "default";
            g = new UF(g, h, k, l);
            m = VF(m);
            h = me(f, "metadata")[0];
            h = (h ? h.children : []).filter(function(v) {
                return v != "\n";
            });
            k = me(f, "style");
            f = me(f, "region");
            l = [];
            for(var r = u(f), t = r.next(); !t.done; t = r.next())(t = WF(this, t.value, k, q)) && l.push(t);
            if (ie(e, "p").length) throw new T(2, 2, 2001, "<p> can only be inside <div> in TTML");
            q = u(ie(e, "div"));
            for(r = q.next(); !r.done; r = q.next())if (ie(r.value, "span").length) throw new T(2, 2, 2001, "<span> can only be inside <p> in TTML");
            if (b = XF(this, e, b, g, h, k, f, l, n, m, null, !1, c, d)) b.backgroundColor || (b.backgroundColor = "transparent"), a.push(b);
            return a;
        };
        function XF(a, b, c, d, e, f, g, h, k, l, m, n, q, r) {
            var t = m;
            if (fe(b)) {
                if (!n) return null;
                var v = {
                    tagName: "span",
                    children: [
                        ke(b)
                    ],
                    attributes: {},
                    parent: null
                };
            } else v = b;
            for(var w = null, x = u(YF), y = x.next(); !y.done && !(w = ZF(v, "backgroundImage", e, "#", y.value)[0]); y = x.next());
            x = null;
            y = se(v, YF, "backgroundImage");
            var z = /^(urn:)(mpeg:[a-z0-9][a-z0-9-]{0,31}:)(subs:)([0-9]+)$/;
            if (y && z.test(y)) {
                x = parseInt(y.split(":").pop(), 10) - 1;
                if (x >= r.length) return null;
                x = r[x];
            } else q && y && !y.startsWith("#") && (z = new lb(q), y = new lb(y), (y = z.resolve(y).toString()) && (x = y));
            if (b.tagName == "p" || w || x) n = !0;
            b = n;
            y = (v.attributes["xml:space"] || (k ? "default" : "preserve")) == "default";
            z = v.children.every(fe);
            k = [];
            if (!z) for(var A = u(v.children), E = A.next(); !E.done; E = A.next())(E = XF(a, E.value, c, d, e, f, g, h, y, l, v, n, q, r)) && k.push(E);
            e = m != null;
            q = ke(v);
            q = v.children.length && q && /\S/.test(q);
            A = v.attributes.begin || v.attributes.end || v.attributes.dur;
            if (!(A || q || v.tagName == "br" || k.length != 0 || e && !y)) return null;
            r = $F(v, d);
            q = r.start;
            for(r = r.end; t && t.tagName && t.tagName != "tt";)r = aG(t, d, q, r), q = r.start, r = r.end, t = t.parent;
            q == null && (q = 0);
            q += c.periodStart;
            r = r == null ? Infinity : r + c.periodStart;
            a.g !== "HLS" && (q = Math.max(q, c.segmentStart), r = Math.min(r, c.segmentEnd));
            if (!A && k.length > 0) for(q = Infinity, r = 0, c = u(k), d = c.next(); !d.done; d = c.next())d = d.value, q = Math.min(q, d.startTime), r = Math.max(r, d.endTime);
            if (v.tagName == "br") return a = new Ie(q, r, ""), a.lineBreak = !0, a;
            c = "";
            z && (c = jc(ke(v) || ""), y && (c = c.replace(/\s+/g, " ")));
            c = new Ie(q, r, c);
            c.nestedCues = k;
            n || (c.isContainer = !0);
            l && (c.cellResolution = l);
            l = ZF(v, "region", g, "")[0];
            if (v.attributes.region && l && l.attributes["xml:id"]) {
                var C = l.attributes["xml:id"];
                c.region = h.filter(function(D) {
                    return D.id == C;
                })[0];
            }
            h = l;
            m && e && !v.attributes.region && !v.attributes.style && (h = ZF(m, "region", g, "")[0]);
            bG(a, c, v, h, w, x, f, b, k.length == 0);
            return c;
        }
        function WF(a, b, c, d) {
            var e = new Md, f = b.attributes["xml:id"];
            if (!f) return null;
            e.id = f;
            f = null;
            d && (f = cG.exec(d) || dG.exec(d));
            d = f ? Number(f[1]) : null;
            f = f ? Number(f[2]) : null;
            var g, h = eG(a, b, c, "extent");
            if (h) {
                var k = (g = cG.exec(h)) || dG.exec(h);
                k != null && (e.width = Number(k[1]), e.height = Number(k[2]), g || (d != null && (e.width = e.width * 100 / d), f != null && (e.height = e.height * 100 / f)), e.widthUnits = g || d != null ? Nd : 0, e.heightUnits = g || f != null ? Nd : 0);
            }
            if (a = eG(a, b, c, "origin")) {
                if (k = (g = cG.exec(a)) || dG.exec(a), k != null) e.viewportAnchorX = Number(k[1]), e.viewportAnchorY = Number(k[2]), g ? h || (e.width = 100 - e.viewportAnchorX, e.widthUnits = Nd, e.height = 100 - e.viewportAnchorY, e.heightUnits = Nd) : (f != null && (e.viewportAnchorY = e.viewportAnchorY * 100 / f), d != null && (e.viewportAnchorX = e.viewportAnchorX * 100 / d)), e.viewportAnchorUnits = g || d != null ? Nd : 0;
            }
            return e;
        }
        function fG(a) {
            var b = a.match(/rgba\(([^)]+)\)/);
            return b && (b = b[1].split(","), b.length == 4) ? (b[3] = String(Number(b[3]) / 255), "rgba(" + b.join(",") + ")") : a;
        }
        function bG(a, b, c, d, e, f, g, h, k) {
            h = h || k;
            gG(a, c, d, g, "direction", h) == "rtl" && (b.direction = "rtl");
            k = gG(a, c, d, g, "writingMode", h);
            k == "tb" || k == "tblr" ? b.writingMode = "vertical-lr" : k == "tbrl" ? b.writingMode = "vertical-rl" : k == "rltb" || k == "rl" ? b.direction = "rtl" : k && (b.direction = Le);
            (k = gG(a, c, d, g, "textAlign", !0)) ? (b.positionAlign = hG.get(k), b.lineAlign = iG.get(k), b.textAlign = gf[k.toUpperCase()]) : b.textAlign = Ke;
            if (k = gG(a, c, d, g, "displayAlign", !0)) b.displayAlign = hf[k.toUpperCase()];
            if (k = gG(a, c, d, g, "color", h)) b.color = fG(k);
            if (k = gG(a, c, d, g, "backgroundColor", h)) b.backgroundColor = fG(k);
            if (k = gG(a, c, d, g, "border", h)) b.border = k;
            if (k = gG(a, c, d, g, "fontFamily", h)) switch(k){
                case "monospaceSerif":
                    b.fontFamily = "Courier New,Liberation Mono,Courier,monospace";
                    break;
                case "proportionalSansSerif":
                    b.fontFamily = "Arial,Helvetica,Liberation Sans,sans-serif";
                    break;
                case "sansSerif":
                    b.fontFamily = "sans-serif";
                    break;
                case "monospaceSansSerif":
                    b.fontFamily = "Consolas,monospace";
                    break;
                case "proportionalSerif":
                    b.fontFamily = "serif";
                    break;
                default:
                    b.fontFamily = k.split(",").filter(function(l) {
                        return l != "default";
                    }).join(",");
            }
            (k = gG(a, c, d, g, "fontWeight", h)) && k == "bold" && (b.fontWeight = df);
            k = gG(a, c, d, g, "wrapOption", h);
            b.wrapLine = k && k == "noWrap" ? !1 : !0;
            (k = gG(a, c, d, g, "lineHeight", h)) && k.match(jG) && (b.lineHeight = k);
            (k = gG(a, c, d, g, "fontSize", h)) && (k.match(jG) || k.match(kG)) && (b.fontSize = k);
            if (k = gG(a, c, d, g, "fontStyle", h)) b.fontStyle = kf[k.toUpperCase()];
            e ? (f = e.attributes.imageType || e.attributes.imagetype, k = e.attributes.encoding, e = ke(e).trim(), f == "PNG" && k == "Base64" && e && (b.backgroundImage = "data:image/png;base64," + e)) : f && (b.backgroundImage = f);
            if (e = gG(a, c, d, g, "textOutline", h)) e = e.split(" "), e[0].match(jG) ? b.textStrokeColor = b.color : (b.textStrokeColor = fG(e[0]), e.shift()), e[0] && e[0].match(jG) ? b.textStrokeWidth = e[0] : b.textStrokeColor = "";
            (e = gG(a, c, d, g, "letterSpacing", h)) && e.match(jG) && (b.letterSpacing = e);
            (e = gG(a, c, d, g, "linePadding", h)) && e.match(jG) && (b.linePadding = e);
            if (e = gG(a, c, d, g, "opacity", h)) b.opacity = parseFloat(e);
            (e = eG(a, d, g, "textDecoration")) && lG(b, e);
            (e = mG(a, c, g, "textDecoration")) && lG(b, e);
            if (e = gG(a, c, d, g, "textCombine", h)) b.textCombineUpright = e;
            switch(gG(a, c, d, g, "ruby", h)){
                case "container":
                    b.rubyTag = "ruby";
                    break;
                case "text":
                    b.rubyTag = "rt";
            }
        }
        function lG(a, b) {
            b = u(b.split(" "));
            for(var c = b.next(); !c.done; c = b.next())switch(c.value){
                case "underline":
                    a.textDecoration.includes(ff) || a.textDecoration.push(ff);
                    break;
                case "noUnderline":
                    a.textDecoration.includes(ff) && ad(a.textDecoration, ff);
                    break;
                case "lineThrough":
                    a.textDecoration.includes("line-through") || a.textDecoration.push("line-through");
                    break;
                case "noLineThrough":
                    a.textDecoration.includes("line-through") && ad(a.textDecoration, "line-through");
                    break;
                case "overline":
                    a.textDecoration.includes("overline") || a.textDecoration.push("overline");
                    break;
                case "noOverline":
                    a.textDecoration.includes("overline") && ad(a.textDecoration, "overline");
            }
        }
        function gG(a, b, c, d, e, f) {
            f = f === void 0 ? !0 : f;
            return (b = mG(a, b, d, e)) ? b : f ? eG(a, c, d, e) : null;
        }
        function eG(a, b, c, d) {
            if (!b) return null;
            var e = se(b, TF, d);
            return e ? e : nG(a, b, c, d);
        }
        function mG(a, b, c, d) {
            var e = se(b, TF, d);
            return e ? e : nG(a, b, c, d);
        }
        function nG(a, b, c, d) {
            b = ZF(b, "style", c, "");
            for(var e = null, f = 0; f < b.length; f++){
                var g = re(b[f], "urn:ebu:tt:style", d);
                g || (g = se(b[f], TF, d));
                g || (g = mG(a, b[f], c, d));
                g && (e = g);
            }
            return e;
        }
        function ZF(a, b, c, d, e) {
            var f = [];
            if (!a || c.length < 1) return f;
            var g = a;
            for(a = null; !a && !(a = e ? re(g, e, b) : g.attributes[b]) && (g = g.parent, g););
            if (b = a) {
                for(b = u(b.split(" ")), e = b.next(); !e.done; e = b.next())for(e = e.value, a = u(c), g = a.next(); !g.done; g = a.next())if (g = g.value, d + g.attributes["xml:id"] == e) {
                    f.push(g);
                    break;
                }
            }
            return f;
        }
        function aG(a, b, c, d) {
            a = $F(a, b);
            c == null ? c = a.start : a.start != null && (c += a.start);
            d == null ? d = a.end : a.start != null && (d += a.start);
            return {
                start: c,
                end: d
            };
        }
        function $F(a, b) {
            var c = oG(a.attributes.begin, b), d = oG(a.attributes.end, b);
            a = oG(a.attributes.dur, b);
            d == null && a != null && (d = c + a);
            return {
                start: c,
                end: d
            };
        }
        function oG(a, b) {
            var c = null;
            if (pG.test(a)) {
                a = pG.exec(a);
                c = Number(a[1]);
                var d = Number(a[2]), e = Number(a[3]), f = Number(a[4]);
                f += (Number(a[5]) || 0) / b.h;
                e += f / b.frameRate;
                c = e + d * 60 + c * 3600;
            } else if (qG.test(a)) c = rG(qG, a);
            else if (sG.test(a)) c = rG(sG, a);
            else if (tG.test(a)) a = tG.exec(a), c = Number(a[1]) / b.frameRate;
            else if (uG.test(a)) a = uG.exec(a), c = Number(a[1]) / b.g;
            else if (vG.test(a)) c = rG(vG, a);
            else if (a) throw new T(2, 2, 2001, "Could not parse cue time range in TTML");
            return c;
        }
        function rG(a, b) {
            a = a.exec(b);
            return a == null || a[0] == "" ? null : (Number(a[4]) || 0) / 1E3 + (Number(a[3]) || 0) + (Number(a[2]) || 0) * 60 + (Number(a[1]) || 0) * 3600;
        }
        function VF(a) {
            return a ? (a = /^(\d+) (\d+)$/.exec(a)) ? {
                columns: parseInt(a[1], 10),
                rows: parseInt(a[2], 10)
            } : null : null;
        }
        O("shaka.text.TtmlTextParser", RF);
        RF.prototype.parseMedia = RF.prototype.parseMedia;
        RF.prototype.setManifestType = RF.prototype.setManifestType;
        RF.prototype.setSequenceMode = RF.prototype.setSequenceMode;
        RF.prototype.parseInit = RF.prototype.parseInit;
        function UF(a, b, c, d) {
            this.frameRate = Number(a) || 30;
            this.h = Number(b) || 1;
            this.g = Number(d);
            this.g == 0 && (this.g = a ? this.frameRate * this.h : 1);
            c && (a = /^(\d+) (\d+)$/g.exec(c)) && (this.frameRate *= Number(a[1]) / Number(a[2]));
        }
        var cG = /^(\d{1,2}(?:\.\d+)?|100(?:\.0+)?)% (\d{1,2}(?:\.\d+)?|100(?:\.0+)?)%$/, kG = /^(\d{1,4}(?:\.\d+)?|100)%$/, jG = /^(\d+px|\d+em|\d*\.?\d+c)$/, dG = /^(\d+)px (\d+)px$/, pG = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, qG = /^(?:(\d{2,}):)?(\d{2}):(\d{2})$/, sG = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d+)$/, tG = /^(\d*(?:\.\d*)?)f$/, uG = /^(\d*(?:\.\d*)?)t$/, vG = RegExp("^(?:(\\d*(?:\\.\\d*)?)h)?(?:(\\d*(?:\\.\\d*)?)m)?(?:(\\d*(?:\\.\\d*)?)s)?(?:(\\d*(?:\\.\\d*)?)ms)?$"), iG = (new Map).set("left", Oe).set("center", "center").set("right", "end").set("start", Oe).set("end", "end"), hG = (new Map).set("left", "line-left").set("center", "center").set("right", "line-right").set("start", "line-left").set("end", "line-right"), SF = [
            "http://www.w3.org/ns/ttml#parameter",
            "http://www.w3.org/2006/10/ttaf1#parameter"
        ], TF = [
            "http://www.w3.org/ns/ttml#styling",
            "http://www.w3.org/2006/10/ttaf1#styling"
        ], YF = [
            "http://www.smpte-ra.org/schemas/2052-1/2010/smpte-tt",
            "http://www.smpte-ra.org/schemas/2052-1/2013/smpte-tt"
        ];
        Jf("application/ttml+xml", function() {
            return new RF;
        });
        function wG() {
            this.g = new RF;
        }
        wG.prototype.parseInit = function(a) {
            var b = !1;
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], Gh).qa("stsd", Ih).box("stpp", function(c) {
                b = !0;
                c.parser.stop();
            }).parse(a);
            if (!b) throw new T(2, 2, 2007);
        };
        wG.prototype.setSequenceMode = function(a) {
            this.g.setSequenceMode(a);
        };
        wG.prototype.setManifestType = function(a) {
            this.g.setManifestType(a);
        };
        wG.prototype.parseMedia = function(a, b, c) {
            var d = [], e = null, f = [], g = new Map, h = [];
            (new Bh).boxes([
                "moof",
                "traf"
            ], Gh).qa("tfhd", function(x) {
                e = Vi(x.reader, x.flags).le;
            }).qa("trun", function(x) {
                x = Yi(x.reader, x.version, x.flags);
                x = u(x.ci);
                for(var y = x.next(); !y.done; y = x.next())h.push(y.value.sampleSize || e || 0);
            }).qa("subs", function(x) {
                for(var y = x.reader, z = y.Y(), A = -1, E = 0; E < z; E++){
                    var C = y.Y();
                    A += C;
                    C = y.Ka();
                    for(var D = [], B = 0; B < C; B++)x.version == 1 ? D.push(y.Y()) : D.push(y.Ka()), y.ea(), y.ea(), y.Y();
                    g.set(A, D);
                }
            }).box("mdat", Lh(function(x) {
                f.push(x);
            }, !1)).parse(a, !1);
            if (f.length == 0) throw new T(2, 2, 2007);
            a = tc.apply(kc, G(f));
            for(var k = 0, l = 0; l < h.length; l++){
                var m = Fb(a, k, h[l]);
                k += h[l];
                var n = g.get(l);
                if (n && n.length) {
                    for(var q = Fb(m, 0, n[0]), r = [], t = n[0], v = 1; v < n.length; v++){
                        var w = Fb(m, t, n[v]);
                        w = lc(w);
                        r.push("data:image/png;base64," + w);
                        t += n[v];
                    }
                    d = d.concat(this.g.parseMedia(q, b, c, r));
                } else d = d.concat(this.g.parseMedia(m, b, c, []));
            }
            return d;
        };
        O("shaka.text.Mp4TtmlParser", wG);
        wG.prototype.parseMedia = wG.prototype.parseMedia;
        wG.prototype.setManifestType = wG.prototype.setManifestType;
        wG.prototype.setSequenceMode = wG.prototype.setSequenceMode;
        wG.prototype.parseInit = wG.prototype.parseInit;
        Jf('application/mp4; codecs="stpp"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im1i"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im1t"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im2i"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im2t"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.etd1"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.etd1|im1t"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.ttml.im1t|etd1"', function() {
            return new wG;
        });
        Jf('application/mp4; codecs="stpp.TTML.im1t"', function() {
            return new wG;
        });
        function xG() {
            this.g = "UNKNOWN";
        }
        xG.prototype.parseInit = function() {};
        xG.prototype.setSequenceMode = function() {};
        xG.prototype.setManifestType = function(a) {
            this.g = a;
        };
        xG.prototype.parseMedia = function(a, b) {
            a = bc(a);
            a = a.replace(/\r\n|\r(?=[^\n]|$)/gm, "\n");
            var c = a.split(/\n{2,}/m);
            if (!/^WEBVTT($|[ \t\n])/m.test(c[0])) throw new T(2, 2, 2E3);
            a = b.vttOffset;
            if (this.g == "HLS" && c[0].includes("X-TIMESTAMP-MAP")) {
                var d = c[0];
                a = d.match(/LOCAL:((?:(\d{1,}):)?(\d{2}):(\d{2})\.(\d{3}))/m);
                d = d.match(/MPEGTS:(\d+)/m);
                if (!a || !d) throw new T(2, 2, 2E3);
                a = Vd(a[1]);
                if (a == null) throw new T(2, 2, 2E3);
                d = Number(d[1]);
                for(var e = b.segmentStart - b.periodStart; e >= 95443.7176888889;)e -= 95443.7176888889, d += 8589934592;
                a = b.periodStart + d / 9E4 - a;
            }
            b = [];
            d = u(c[0].split("\n"));
            for(e = d.next(); !e.done; e = d.next())if (e = e.value, /^Region:/.test(e)) {
                e = new Pd(e);
                var f = new Md;
                Sd(e);
                Qd(e);
                for(var g = Sd(e); g;){
                    var h = f, k = g;
                    (g = /^id=(.*)$/.exec(k)) ? h.id = g[1] : (g = /^width=(\d{1,2}|100)%$/.exec(k)) ? h.width = Number(g[1]) : (g = /^lines=(\d+)$/.exec(k)) ? (h.height = Number(g[1]), h.heightUnits = 2) : (g = /^regionanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.regionAnchorX = Number(g[1]), h.regionAnchorY = Number(g[2])) : (g = /^viewportanchor=(\d{1,2}|100)%,(\d{1,2}|100)%$/.exec(k)) ? (h.viewportAnchorX = Number(g[1]), h.viewportAnchorY = Number(g[2])) : /^scroll=up$/.exec(k) && (h.scroll = "up");
                    Qd(e);
                    g = Sd(e);
                }
                b.push(f);
            }
            d = new Map;
            Xe(d);
            e = [];
            c = u(c.slice(1));
            for(f = c.next(); !f.done; f = c.next()){
                f = f.value.split("\n");
                if ((f.length != 1 || f[0]) && !yG.test(f[0]) && f[0] == "STYLE") {
                    h = [];
                    g = -1;
                    for(k = 1; k < f.length; k++)f[k].includes("::cue") && (h.push([]), g = h.length - 1), g != -1 && (h[g].push(f[k]), f[k].includes("}") && (g = -1));
                    h = u(h);
                    for(g = h.next(); !g.done; g = h.next()){
                        var l = g.value;
                        g = "global";
                        (k = l[0].match(/\((.*)\)/)) && (g = k.pop());
                        k = l.slice(1, -1);
                        l[0].includes("}") && (l = /\{(.*?)\}/.exec(l[0])) && (k = l[1].split(";"));
                        (l = d.get(g)) || (l = new Ie(0, 0, ""));
                        for(var m = !1, n = 0; n < k.length; n++){
                            var q = /^\s*([^:]+):\s*(.*)/.exec(k[n]);
                            if (q) {
                                var r = q[2].trim().replace(";", "");
                                switch(q[1].trim()){
                                    case "background-color":
                                    case "background":
                                        m = !0;
                                        l.backgroundColor = r;
                                        break;
                                    case "color":
                                        m = !0;
                                        l.color = r;
                                        break;
                                    case "font-family":
                                        m = !0;
                                        l.fontFamily = r;
                                        break;
                                    case "font-size":
                                        m = !0;
                                        l.fontSize = r;
                                        break;
                                    case "font-weight":
                                        if (parseInt(r, 10) >= 700 || r == "bold") m = !0, l.fontWeight = df;
                                        break;
                                    case "font-style":
                                        switch(r){
                                            case "normal":
                                                m = !0;
                                                l.fontStyle = Te;
                                                break;
                                            case "italic":
                                                m = !0;
                                                l.fontStyle = ef;
                                                break;
                                            case "oblique":
                                                m = !0, l.fontStyle = "oblique";
                                        }
                                        break;
                                    case "opacity":
                                        m = !0;
                                        l.opacity = parseFloat(r);
                                        break;
                                    case "text-combine-upright":
                                        m = !0;
                                        l.textCombineUpright = r;
                                        break;
                                    case "text-shadow":
                                        m = !0;
                                        l.textShadow = r;
                                        break;
                                    case "white-space":
                                        m = !0, l.wrapLine = r != "noWrap";
                                }
                            }
                        }
                        m && d.set(g, l);
                    }
                }
                l = f;
                n = a;
                if (l.length == 1 && !l[0] || yG.test(l[0]) || l[0] == "STYLE" || l[0] == "REGION") f = null;
                else if (f = null, m = 0, l[0].includes("--\x3e") || (f = l[0], m = 1), h = new Pd(l[m]), g = Td(h), q = Rd(h, /[ \t]+--\x3e[ \t]+/g), k = Td(h), g == null || q == null || k == null) Za("Failed to parse VTT time code. Cue skipped:", f, l), f = null;
                else {
                    g += n;
                    k += n;
                    g < 0 && (g = 0);
                    n = "";
                    for(q = m + 1; q < l.length; q++)q > m + 1 && (n += "\n"), n += l[q];
                    n = n.trim();
                    d.has("global") ? (l = d.get("global").clone(), l.startTime = g, l.endTime = k, l.payload = n) : l = new Ie(g, k, n);
                    Qd(h);
                    for(g = Sd(h); g;)zG(l, g, b), Qd(h), g = Sd(h);
                    We(l, d);
                    f != null && (l.id = f);
                    f = l;
                }
                f && e.push(f);
            }
            return e;
        };
        function zG(a, b, c) {
            var d;
            if (d = AG.exec(b)) b = d[1], b == "middle" ? a.textAlign = Ke : a.textAlign = gf[b.toUpperCase()];
            else if (d = BG.exec(b)) a.writingMode = d[1] == "lr" ? "vertical-lr" : "vertical-rl";
            else if (d = CG.exec(b)) a.size = Number(d[1]);
            else if (d = DG.exec(b)) a.position = Number(d[1]), d[2] && (b = d[2], a.positionAlign = b == "line-left" || b == "start" ? "line-left" : b == "line-right" || b == "end" ? "line-right" : b == "center" || b == "middle" ? "center" : Je);
            else if (d = EG.exec(b)) {
                if (b = FG(c, d[1])) a.region = b;
            } else if (c = GG.exec(b)) a.lineInterpretation = 1, a.line = Number(c[1]), c[2] && (a.lineAlign = jf[c[2].toUpperCase()]);
            else if (c = HG.exec(b)) a.lineInterpretation = Ne, a.line = Number(c[1]), c[2] && (a.lineAlign = jf[c[2].toUpperCase()]);
        }
        function FG(a, b) {
            a = a.filter(function(c) {
                return c.id == b;
            });
            return a.length ? a[0] : null;
        }
        O("shaka.text.VttTextParser", xG);
        xG.prototype.parseMedia = xG.prototype.parseMedia;
        xG.prototype.setManifestType = xG.prototype.setManifestType;
        xG.prototype.setSequenceMode = xG.prototype.setSequenceMode;
        xG.prototype.parseInit = xG.prototype.parseInit;
        var yG = /^NOTE($|[ \t])/, AG = /^align:(start|middle|center|end|left|right)$/, BG = /^vertical:(lr|rl)$/, CG = /^size:([\d.]+)%$/, DG = /^position:([\d.]+)%(?:,(line-left|line-right|middle|center|start|end|auto))?$/, EG = /^region:(.*)$/, GG = /^line:([\d.]+)%(?:,(start|end|center))?$/, HG = /^line:(-?\d+)(?:,(start|end|center))?$/;
        Jf("text/vtt", function() {
            return new xG;
        });
        Jf('text/vtt; codecs="vtt"', function() {
            return new xG;
        });
        Jf('text/vtt; codecs="wvtt"', function() {
            return new xG;
        });
        function IG() {
            this.g = null;
        }
        IG.prototype.parseInit = function(a) {
            var b = this, c = !1;
            (new Bh).boxes([
                "moov",
                "trak",
                "mdia",
                "minf",
                "stbl"
            ], Gh).qa("mdhd", function(d) {
                d = Xi(d.reader, d.version);
                b.g = d.timescale;
            }).qa("stsd", Ih).box("wvtt", function() {
                c = !0;
            }).parse(a);
            if (!this.g) throw new T(2, 2, 2008);
            if (!c) throw new T(2, 2, 2008);
        };
        IG.prototype.setSequenceMode = function() {};
        IG.prototype.setManifestType = function() {};
        IG.prototype.parseMedia = function(a, b) {
            if (!a.length) return [];
            if (!this.g) throw new T(2, 2, 2008);
            var c = 0, d = [], e, f = [], g = !1, h = !1, k = !1, l = null;
            (new Bh).boxes([
                "moof",
                "traf"
            ], Gh).qa("tfdt", function(z) {
                g = !0;
                c = Wi(z.reader, z.version).baseMediaDecodeTime;
            }).qa("tfhd", function(z) {
                l = Vi(z.reader, z.flags).ke;
            }).qa("trun", function(z) {
                h = !0;
                d = Yi(z.reader, z.version, z.flags).ci;
            }).box("mdat", Lh(function(z) {
                k = !0;
                e = z;
            }, !1)).parse(a, !1);
            if (!k && !g && !h) throw new T(2, 2, 2008);
            a = c;
            for(var m = new yh(e, 0), n = u(d), q = n.next(); !q.done; q = n.next()){
                q = q.value;
                var r = q.di || l, t = q.dg ? c + q.dg : a;
                a = t + (r || 0);
                var v = 0;
                do {
                    var w = m.Y();
                    v += w;
                    var x = m.Y(), y = null;
                    Fh(x) == "vttc" ? w > 8 && (y = m.Wb(w - 8, !1)) : m.skip(w - 8);
                    r && y && (w = JG(y, b.periodStart + t / this.g, b.periodStart + a / this.g), f.push(w));
                }while (q.sampleSize && v < q.sampleSize);
            }
            return f.filter(Zf);
        };
        function JG(a, b, c) {
            var d, e, f;
            (new Bh).box("payl", Lh(function(g) {
                d = bc(g);
            }, !1)).box("iden", Lh(function(g) {
                e = bc(g);
            }, !1)).box("sttg", Lh(function(g) {
                f = bc(g);
            }, !1)).parse(a);
            return d ? KG(d, e, f, b, c) : null;
        }
        function KG(a, b, c, d, e) {
            a = new Ie(d, e, a);
            We(a);
            b && (a.id = b);
            if (c) for(b = new Pd(c), c = Sd(b); c;)zG(a, c, []), Qd(b), c = Sd(b);
            return a;
        }
        O("shaka.text.Mp4VttParser", IG);
        IG.prototype.parseMedia = IG.prototype.parseMedia;
        IG.prototype.setManifestType = IG.prototype.setManifestType;
        IG.prototype.setSequenceMode = IG.prototype.setSequenceMode;
        IG.prototype.parseInit = IG.prototype.parseInit;
        Jf('application/mp4; codecs="wvtt"', function() {
            return new IG;
        });
        function LG() {}
        LG.prototype.parseInit = function() {};
        LG.prototype.setSequenceMode = function() {};
        LG.prototype.setManifestType = function() {};
        LG.prototype.parseMedia = function(a) {
            var b = bc(a).replace(/\r+/g, "");
            b = b.trim();
            a = [];
            if (b == "") return a;
            b = u(b.split("\n\n"));
            for(var c = b.next(); !c.done; c = b.next()){
                c = c.value.split("\n");
                var d = new Pd(c[0]), e = Td(d), f = Rd(d, /,/g);
                d = Td(d);
                if (e == null || f == null || d == null) throw new T(2, 2, 2001, "Could not parse cue time range in SubViewer");
                a.push(new Ie(e, d, c.slice(1).join("\n").trim()));
            }
            return a;
        };
        O("shaka.text.SbvTextParser", LG);
        LG.prototype.parseMedia = LG.prototype.parseMedia;
        LG.prototype.setManifestType = LG.prototype.setManifestType;
        LG.prototype.setSequenceMode = LG.prototype.setSequenceMode;
        LG.prototype.parseInit = LG.prototype.parseInit;
        Jf("text/x-subviewer", function() {
            return new LG;
        });
        function MG() {
            this.g = new xG;
        }
        MG.prototype.parseInit = function() {};
        MG.prototype.setSequenceMode = function() {};
        MG.prototype.setManifestType = function() {};
        MG.prototype.parseMedia = function(a, b, c) {
            var d = bc(a);
            a = "WEBVTT\n\n";
            if (d != "") {
                d = d.replace(/\r+/g, "");
                d = d.trim();
                d = u(d.split("\n\n"));
                for(var e = d.next(); !e.done; e = d.next())e = e.value.split(/\n/), e[0].match(/\d+/) && e.shift(), e[0] = e[0].replace(/,/g, "."), a += e.join("\n").replace(/{b}/g, "<b>").replace(/{\/b}/g, "</b>").replace(/{i}/g, "<i>").replace(/{\/i}/g, "</i>").replace(/{u}/g, "<u>").replace(/{\/u}/g, "</u>") + "\n\n";
            }
            a = Fb(hc(a));
            return this.g.parseMedia(a, b, c, []);
        };
        O("shaka.text.SrtTextParser", MG);
        MG.prototype.parseMedia = MG.prototype.parseMedia;
        MG.prototype.setManifestType = MG.prototype.setManifestType;
        MG.prototype.setSequenceMode = MG.prototype.setSequenceMode;
        MG.prototype.parseInit = MG.prototype.parseInit;
        Jf("text/srt", function() {
            return new MG;
        });
        function NG() {}
        NG.prototype.parseInit = function() {};
        NG.prototype.setSequenceMode = function() {};
        NG.prototype.setManifestType = function() {};
        NG.prototype.parseMedia = function(a) {
            var b = "", c = "", d = null, e = null;
            e = bc(a).split(/\r?\n\s*\r?\n/);
            a = u(e);
            for(e = a.next(); !e.done; e = a.next()){
                var f = e.value;
                e = f;
                if (f = OG.exec(f)) d = f[1], e = f[2];
                d == "V4 Styles" || d == "V4+ Styles" ? (b = e, b = c ? b + ("\n" + e) : e) : d == "Events" && (c = c ? c + ("\n" + e) : e);
            }
            d = [];
            e = null;
            b = u(b.split(/\r?\n/));
            for(a = b.next(); !a.done; a = b.next())if (a = a.value, !/^\s*;/.test(a) && (f = PG.exec(a))) {
                if (a = f[1].trim(), f = f[2].trim(), a == "Format") e = f.split(QG);
                else if (a == "Style") {
                    a = f.split(QG);
                    f = {};
                    for(var g = 0; g < e.length && g < a.length; g++)f[e[g]] = a[g];
                    d.push(f);
                }
            }
            e = [];
            b = null;
            c = u(c.split(/\r?\n/));
            f = c.next();
            for(a = {}; !f.done; a = {
                Vj: void 0
            }, f = c.next())if (f = f.value, !/^\s*;/.test(f) && (g = PG.exec(f))) {
                if (f = g[1].trim(), g = g[2].trim(), f == "Format") b = g.split(QG);
                else if (f == "Dialogue") {
                    g = g.split(QG);
                    f = {};
                    for(var h = 0; h < b.length && h < g.length; h++)f[b[h]] = g[h];
                    h = RG(f.Start);
                    var k = RG(f.End);
                    g = new Ie(h, k, g.slice(b.length - 1).join(",").replace(/\\N/g, "\n").replace(/\{[^}]+\}/g, ""));
                    a.Vj = f.Style;
                    (a = d.find(function(l) {
                        return function(m) {
                            return m.Name == l.Vj;
                        };
                    }(a))) && SG(g, a);
                    e.push(g);
                }
            }
            return e;
        };
        function SG(a, b) {
            var c = b.Fontname;
            c && (a.fontFamily = c);
            if (c = b.Fontsize) a.fontSize = c + "px";
            if (c = b.PrimaryColour) {
                if (c = TG(c)) a.color = c;
            }
            if (c = b.BackColour) {
                if (c = TG(c)) a.backgroundColor = c;
            }
            b.Bold && (a.fontWeight = df);
            b.Italic && (a.fontStyle = ef);
            b.Underline && a.textDecoration.push(ff);
            if (c = b.Spacing) a.letterSpacing = c + "px";
            if (c = b.Alignment) switch(parseInt(c, 10)){
                case 1:
                    a.displayAlign = Re;
                    a.textAlign = "start";
                    break;
                case 2:
                    a.displayAlign = Re;
                    a.textAlign = Ke;
                    break;
                case 3:
                    a.displayAlign = Re;
                    a.textAlign = "end";
                    break;
                case 5:
                    a.displayAlign = "before";
                    a.textAlign = "start";
                    break;
                case 6:
                    a.displayAlign = "before";
                    a.textAlign = Ke;
                    break;
                case 7:
                    a.displayAlign = "before";
                    a.textAlign = "end";
                    break;
                case 9:
                    a.displayAlign = "center";
                    a.textAlign = "start";
                    break;
                case 10:
                    a.displayAlign = "center";
                    a.textAlign = Ke;
                    break;
                case 11:
                    a.displayAlign = "center", a.textAlign = "end";
            }
            if (b = b.AlphaLevel) a.opacity = parseFloat(b);
        }
        function TG(a) {
            a = parseInt(a.replace("&H", ""), 16);
            return a >= 0 ? "rgba(" + (a & 255) + "," + (a >> 8 & 255) + "," + (a >> 16 & 255) + "," + (a >> 24 & 255 ^ 255) / 255 + ")" : null;
        }
        function RG(a) {
            a = UG.exec(a);
            return (a[1] ? parseInt(a[1].replace(":", ""), 10) : 0) * 3600 + parseInt(a[2], 10) * 60 + parseFloat(a[3]);
        }
        O("shaka.text.SsaTextParser", NG);
        NG.prototype.parseMedia = NG.prototype.parseMedia;
        NG.prototype.setManifestType = NG.prototype.setManifestType;
        NG.prototype.setSequenceMode = NG.prototype.setSequenceMode;
        NG.prototype.parseInit = NG.prototype.parseInit;
        var OG = /^\s*\[([^\]]+)\]\r?\n([\s\S]*)/, PG = /^\s*([^:]+):\s*(.*)/, QG = /\s*,\s*/, UG = /^(\d+:)?(\d{1,2}):(\d{1,2}(?:[.]\d{1,3})?)?$/;
        Jf("text/x-ssa", function() {
            return new NG;
        });
        function VG(a, b) {
            var c = a[b + 1] & 1 ? 7 : 9;
            return b + c <= a.length && (a = ((a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5) - c, a > 0) ? {
                re: c,
                oa: a
            } : null;
        }
        function WG(a, b) {
            var c = [
                96E3,
                88200,
                64E3,
                48E3,
                44100,
                32E3,
                24E3,
                22050,
                16E3,
                12E3,
                11025,
                8E3,
                7350
            ], d = (a[b + 2] & 60) >>> 2;
            if (d > c.length - 1) return null;
            var e = ((a[b + 2] & 192) >>> 6) + 1, f = (a[b + 2] & 1) << 2;
            f |= (a[b + 3] & 192) >>> 6;
            return {
                sampleRate: c[d],
                channelCount: f,
                codec: "mp4a.40." + e
            };
        }
        function XG(a, b) {
            if (b + 1 < a.length && a[b] === 255 && (a[b + 1] & 246) === 240) {
                var c = a[b + 1] & 1 ? 7 : 9;
                if (b + c >= a.length) return !1;
                var d = (a[b + 3] & 3) << 11 | a[b + 4] << 3 | (a[b + 5] & 224) >>> 5;
                if (d <= c) return !1;
                b += d;
                return b === a.length || b + 1 < a.length && a[b] === 255 && (a[b + 1] & 246) === 240;
            }
            return !1;
        }
        function YG(a, b) {
            switch(a){
                case "mp4a.40.2":
                    if (b === 1) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        35,
                        128
                    ]);
                    if (b === 2) return new Uint8Array([
                        33,
                        0,
                        73,
                        144,
                        2,
                        25,
                        0,
                        35,
                        128
                    ]);
                    if (b === 3) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        142
                    ]);
                    if (b === 4) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        128,
                        44,
                        128,
                        8,
                        2,
                        56
                    ]);
                    if (b === 5) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        130,
                        48,
                        4,
                        153,
                        0,
                        33,
                        144,
                        2,
                        56
                    ]);
                    if (b === 6) return new Uint8Array([
                        0,
                        200,
                        0,
                        128,
                        32,
                        132,
                        1,
                        38,
                        64,
                        8,
                        100,
                        0,
                        130,
                        48,
                        4,
                        153,
                        0,
                        33,
                        144,
                        2,
                        0,
                        178,
                        0,
                        32,
                        8,
                        224
                    ]);
                    break;
                default:
                    if (b === 1) return new Uint8Array([
                        1,
                        64,
                        34,
                        128,
                        163,
                        78,
                        230,
                        128,
                        186,
                        8,
                        0,
                        0,
                        0,
                        28,
                        6,
                        241,
                        193,
                        10,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        94
                    ]);
                    if (b === 2 || b === 3) return new Uint8Array([
                        1,
                        64,
                        34,
                        128,
                        163,
                        94,
                        230,
                        128,
                        186,
                        8,
                        0,
                        0,
                        0,
                        0,
                        149,
                        0,
                        6,
                        241,
                        161,
                        10,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        90,
                        94
                    ]);
            }
            return null;
        }
        var ZG = Object.freeze({
            Hh: 0,
            Ef: 0,
            zf: 0,
            nf: 0,
            pf: 2,
            Jh: 0
        }), $G = Object.freeze({
            Hh: 0,
            Ef: 0,
            zf: 0,
            nf: 0,
            pf: 2,
            Jh: 0
        }), aH = Object.freeze({
            Hh: 0,
            Ef: 0,
            zf: 0,
            nf: 0,
            pf: 1,
            Jh: 1
        });
        function bH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = bH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/aac" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/aac" ? 'audio/mp4; codecs="' + (Gf(b) || "mp4a.40.2") + '"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            for(var e = Fb(a), f = qk(e), g = f.length; g < e.length && !XG(e, g); g++);
            a = c.endTime * 1E3;
            f = pk(f);
            f.length && c && (f = f.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (a = f.data);
            f = WG(e, g);
            if (!f) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            b.audioSamplingRate = f.sampleRate;
            b.channelsCount = f.channelCount;
            for(var h = []; g < e.length;){
                var k = VG(e, g);
                if (!k) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                var l = k.re + k.oa;
                g + l <= e.length && h.push({
                    data: e.subarray(g + k.re, g + l),
                    size: k.oa,
                    duration: 1024,
                    ub: 0,
                    flags: ZG
                });
                g += l;
            }
            e = f.sampleRate;
            a = Math.floor(a * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: f.codec,
                timescale: e,
                duration: d,
                Cb: [],
                Ha: new Uint8Array([]),
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    zb: h
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.AacTransmuxer", bH);
        bH.prototype.transmux = bH.prototype.transmux;
        bH.prototype.getOriginalMimeType = bH.prototype.getOriginalMimeType;
        bH.prototype.convertCodecs = bH.prototype.convertCodecs;
        bH.prototype.isSupported = bH.prototype.isSupported;
        bH.prototype.destroy = bH.prototype.destroy;
        mf("audio/aac", function() {
            return new bH("audio/aac");
        }, uf);
        function cH(a, b, c) {
            if (b + 8 > a.length || a[b] !== 11 || a[b + 1] !== 119) return !1;
            var d = a[b + 4] >> 6;
            if (d >= 3) return !1;
            var e = a[b + 4] & 63, f = [
                64,
                69,
                96,
                64,
                70,
                96,
                80,
                87,
                120,
                80,
                88,
                120,
                96,
                104,
                144,
                96,
                105,
                144,
                112,
                121,
                168,
                112,
                122,
                168,
                128,
                139,
                192,
                128,
                140,
                192,
                160,
                174,
                240,
                160,
                175,
                240,
                192,
                208,
                288,
                192,
                209,
                288,
                224,
                243,
                336,
                224,
                244,
                336,
                256,
                278,
                384,
                256,
                279,
                384,
                320,
                348,
                480,
                320,
                349,
                480,
                384,
                417,
                576,
                384,
                418,
                576,
                448,
                487,
                672,
                448,
                488,
                672,
                512,
                557,
                768,
                512,
                558,
                768,
                640,
                696,
                960,
                640,
                697,
                960,
                768,
                835,
                1152,
                768,
                836,
                1152,
                896,
                975,
                1344,
                896,
                976,
                1344,
                1024,
                1114,
                1536,
                1024,
                1115,
                1536,
                1152,
                1253,
                1728,
                1152,
                1254,
                1728,
                1280,
                1393,
                1920,
                1280,
                1394,
                1920
            ][e * 3 + d] * 2;
            if (b + f > a.length) return !1;
            var g = a[b + 6] >> 5, h = 0;
            g === 2 ? h += 2 : (g & 1 && g !== 1 && (h += 2), g & 4 && (h += 2));
            h = (a[b + 6] << 8 | a[b + 7]) >> 12 - h & 1;
            var k = a[b + 5] & 7;
            a = new Uint8Array([
                d << 6 | a[b + 5] >> 3 << 1 | k >> 2,
                (k & 3) << 6 | g << 3 | h << 2 | e >> 4,
                e << 4 & 224
            ]);
            c.sampleRate = [
                48E3,
                44100,
                32E3
            ][d];
            c.channelCount = [
                2,
                1,
                2,
                3,
                3,
                4,
                4,
                5
            ][g] + h;
            c.Ha = a;
            c.oa = f;
            return !0;
        }
        function dH(a, b) {
            if (a[b] === 11 && a[b + 1] === 119) {
                var c = 0, d = 5;
                b += d;
                for(var e, f; d > 0;){
                    f = a[b];
                    var g = Math.min(d, 8), h = 8 - g;
                    e = 4278190080 >>> 24 + h << h;
                    e = (f & e) >> h;
                    c = c ? c << g | e : e;
                    b += 1;
                    d -= g;
                }
                if (c < 16) return !0;
            }
            return !1;
        }
        function eH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = eH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/ac3" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/ac3" ? Xb().Fe() ? 'audio/mp4; codecs="ec-3"' : 'audio/mp4; codecs="ac-3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            a = Fb(a);
            for(var e = qk(a), f = e.length; f < a.length && !dH(a, f); f++);
            var g = c.endTime * 1E3;
            e = pk(e);
            e.length && c && (e = e.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (g = e.data);
            e = 0;
            for(var h = new Uint8Array([]), k = [], l = {
                sampleRate: 0,
                channelCount: 0,
                Ha: new Uint8Array(0),
                oa: 0
            }; f < a.length;){
                if (!cH(a, f, l)) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                b.audioSamplingRate = l.sampleRate;
                b.channelsCount = l.channelCount;
                e = l.sampleRate;
                h = l.Ha;
                k.push({
                    data: a.subarray(f, f + l.oa),
                    size: l.oa,
                    duration: 1536,
                    ub: 0,
                    flags: ZG
                });
                f += l.oa;
            }
            a = Math.floor(g * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: "ac-3",
                timescale: e,
                duration: d,
                Cb: [],
                Ha: h,
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    zb: k
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.Ac3Transmuxer", eH);
        eH.prototype.transmux = eH.prototype.transmux;
        eH.prototype.getOriginalMimeType = eH.prototype.getOriginalMimeType;
        eH.prototype.convertCodecs = eH.prototype.convertCodecs;
        eH.prototype.isSupported = eH.prototype.isSupported;
        eH.prototype.destroy = eH.prototype.destroy;
        mf("audio/ac3", function() {
            return new eH("audio/ac3");
        }, uf);
        function fH(a, b, c) {
            if (b + 8 > a.length || (a[b] << 8 | a[b + 1] << 0) !== 2935) return !1;
            var d = new tk(a.subarray(b + 2));
            vk(d, 2);
            vk(d, 3);
            var e = wk(d, 11) + 1 << 1, f = wk(d, 2);
            if (f == 3) {
                f = wk(d, 2);
                f = [
                    24E3,
                    22060,
                    16E3
                ][f];
                var g = 3;
            } else f = [
                48E3,
                44100,
                32E3
            ][f], g = wk(d, 2);
            var h = wk(d, 3), k = wk(d, 1);
            d = wk(d, 5);
            if (b + e > a.byteLength) return !1;
            a = Math.floor(e * f / ([
                1,
                2,
                3,
                6
            ][g] * 16));
            a = new Uint8Array([
                (a & 8160) >> 5,
                (a & 31) << 3,
                f << 6 | d << 1 | 0,
                0 | h << 1 | k << 0,
                0
            ]);
            c.sampleRate = f;
            c.channelCount = [
                2,
                1,
                2,
                3,
                3,
                4,
                4,
                5
            ][h] + k;
            c.Ha = a;
            c.oa = e;
            return !0;
        }
        function gH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = gH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/ec3" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/ec3" ? 'audio/mp4; codecs="ec-3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            a = Fb(a);
            for(var e = qk(a), f = e.length; f < a.length && (a[f] << 8 | a[f + 1] << 0) !== 2935; f++);
            var g = c.endTime * 1E3;
            e = pk(e);
            e.length && c && (e = e.find(function(m) {
                return m.description === "com.apple.streaming.transportStreamTimestamp";
            })) && (g = e.data);
            e = 0;
            for(var h = new Uint8Array([]), k = [], l = {
                sampleRate: 0,
                channelCount: 0,
                Ha: new Uint8Array(0),
                oa: 0
            }; f < a.length;){
                if (!fH(a, f, l)) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                b.audioSamplingRate = l.sampleRate;
                b.channelsCount = l.channelCount;
                e = l.sampleRate;
                h = l.Ha;
                k.push({
                    data: a.subarray(f, f + l.oa),
                    size: l.oa,
                    duration: 1536,
                    ub: 0,
                    flags: ZG
                });
                f += l.oa;
            }
            a = Math.floor(g * e / 1E3);
            d = {
                id: b.id,
                type: "audio",
                codecs: "ec-3",
                timescale: e,
                duration: d,
                Cb: [],
                Ha: h,
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: a,
                    zb: k
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.Ec3Transmuxer", gH);
        gH.prototype.transmux = gH.prototype.transmux;
        gH.prototype.getOriginalMimeType = gH.prototype.getOriginalMimeType;
        gH.prototype.convertCodecs = gH.prototype.convertCodecs;
        gH.prototype.isSupported = gH.prototype.isSupported;
        gH.prototype.destroy = gH.prototype.destroy;
        mf("audio/ec3", function() {
            return new gH("audio/ec3");
        }, uf);
        function hH(a) {
            if (!a.length) return null;
            var b = a.find(function(v) {
                return v.type == 7;
            });
            a = a.find(function(v) {
                return v.type == 8;
            });
            if (!b || !a) return null;
            var c = new tk(b.data), d = Bk(c);
            Bk(c);
            Bk(c);
            yk(c);
            if (iH.includes(d) && (d = V(c), d === 3 && vk(c, 1), yk(c), yk(c), vk(c, 1), Ak(c))) {
                d = d !== 3 ? 8 : 12;
                for(var e = 0; e < d; e++)Ak(c) && (e < 6 ? Ck(c, 16) : Ck(c, 64));
            }
            yk(c);
            d = V(c);
            if (d === 0) V(c);
            else if (d === 1) for(vk(c, 1), yk(c), yk(c), d = V(c), e = 0; e < d; e++)yk(c);
            yk(c);
            vk(c, 1);
            var f = V(c), g = V(c), h = wk(c, 1);
            h === 0 && vk(c, 1);
            vk(c, 1);
            var k = 0, l = 0, m = 0, n = 0;
            Ak(c) && (k = V(c), l = V(c), m = V(c), n = V(c));
            e = d = 1;
            if (Ak(c) && Ak(c)) {
                var q = Bk(c), r = [
                    1,
                    12,
                    10,
                    16,
                    40,
                    24,
                    20,
                    32,
                    80,
                    18,
                    15,
                    64,
                    160,
                    4,
                    3,
                    2
                ], t = [
                    1,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    33,
                    99,
                    3,
                    2,
                    1
                ];
                q > 0 && q <= 16 ? (d = r[q - 1], e = t[q - 1]) : q === 255 && (d = wk(c, 16), e = wk(c, 16));
            }
            c = (2 - h) * (g + 1) * 16 - m * 2 - n * 2;
            f = (f + 1) * 16 - k * 2 - l * 2;
            b = b.fullData;
            k = b.byteLength;
            a = a.fullData;
            l = a.byteLength;
            g = 0;
            h = new Uint8Array(11 + k + l);
            h[g++] = 1;
            h[g++] = b[1];
            h[g++] = b[2];
            h[g++] = b[3];
            h[g++] = 255;
            h[g++] = 225;
            h[g++] = k >>> 8 & 255;
            h[g++] = k & 255;
            h.set(b, g);
            g += k;
            h[g++] = 1;
            h[g++] = l >>> 8 & 255;
            h[g++] = l & 255;
            h.set(a, g);
            return {
                height: c,
                width: f,
                Za: h,
                fb: d,
                gb: e
            };
        }
        function jH(a) {
            function b(v) {
                e = {
                    data: g,
                    frame: !1,
                    isKeyframe: !1,
                    pts: v.pts,
                    dts: v.dts,
                    nalus: []
                };
            }
            function c() {
                if (e && e.nalus.length && e.frame) {
                    for(var v = e.nalus.length * 4, w = u(e.nalus), x = w.next(); !x.done; x = w.next())v += x.value.fullData.byteLength;
                    v = new Uint8Array(v);
                    w = 0;
                    x = u(e.nalus);
                    for(var y = x.next(); !y.done; y = x.next()){
                        y = y.value;
                        var z = y.fullData.byteLength;
                        v[w] = z >> 24 & 255;
                        v[w + 1] = z >> 16 & 255;
                        v[w + 2] = z >> 8 & 255;
                        v[w + 3] = z & 255;
                        v.set(y.fullData, w + 4);
                        w += 4 + z;
                    }
                    e.data = v;
                    d.push(e);
                }
            }
            for(var d = [], e = null, f = !1, g = new Uint8Array(0), h = 0; h < a.length; h++){
                var k = a[h], l = k.nalus, m = !1;
                e && l.length && !f && (c(), b(k));
                l = u(k.nalus);
                for(var n = l.next(); !n.done; n = l.next()){
                    n = n.value;
                    var q = !1;
                    switch(n.type){
                        case 1:
                            var r = !1;
                            q = !0;
                            var t = n.data;
                            m && t.length > 4 && (t = Dk(new tk(t)), t === 2 || t === 4 || t === 7 || t === 9) && (r = !0);
                            r && e && e.frame && !e.isKeyframe && (c(), e = null);
                            e || b(k);
                            e.frame = !0;
                            e.isKeyframe = r;
                            break;
                        case 5:
                            q = !0;
                            e && e.frame && !e.isKeyframe && (c(), e = null);
                            e || b(k);
                            e.frame = !0;
                            e.isKeyframe = !0;
                            break;
                        case 6:
                            q = !0;
                            break;
                        case 7:
                            m = q = !0;
                            break;
                        case 8:
                            q = !0;
                            break;
                        case 9:
                            f = q = !0;
                            e && e.frame && (c(), e = null);
                            e || b(k);
                            break;
                        case 12:
                            q = !0;
                            break;
                        default:
                            q = !1;
                    }
                    e && q && e.nalus.push(n);
                }
            }
            c();
            return d;
        }
        var iH = [
            100,
            110,
            122,
            244,
            44,
            83,
            86,
            118,
            128,
            138,
            139,
            134
        ];
        function kH(a) {
            if (!a.length) return null;
            var b = a.find(function(g) {
                return g.type == 32;
            }), c = a.find(function(g) {
                return g.type == 33;
            }), d = a.find(function(g) {
                return g.type == 34;
            });
            if (!b || !c || !d) return null;
            var e = lH(b.fullData);
            a = mH(c.fullData);
            var f = nH(d.fullData);
            b = oH(b.fullData, c.fullData, d.fullData, {
                Ph: e.Ph,
                wi: e.wi,
                mh: a.mh,
                nh: a.nh,
                fh: a.fh,
                kh: a.kh,
                gh: a.gh,
                hh: a.hh,
                ih: a.ih,
                jh: a.jh,
                Zg: a.Zg,
                $g: a.$g,
                ah: a.ah,
                bh: a.bh,
                dh: a.dh,
                eh: a.eh,
                Pf: a.Pf,
                Ng: a.Ng,
                Jg: a.Jg,
                Ig: a.Ig,
                Rh: f.Rh,
                Yg: a.Yg,
                Xg: a.Xg
            });
            return {
                height: a.height,
                width: a.width,
                Za: b,
                fb: a.qm,
                gb: a.pm
            };
        }
        function lH(a) {
            var b = new tk(a, !0);
            Bk(b);
            Bk(b);
            wk(b, 4);
            wk(b, 2);
            wk(b, 6);
            a = wk(b, 3);
            b = Ak(b);
            return {
                Ph: a + 1,
                wi: b
            };
        }
        function mH(a) {
            a = new tk(a, !0);
            Bk(a);
            Bk(a);
            var b = 0, c = 0, d = 0, e = 0;
            wk(a, 4);
            var f = wk(a, 3);
            Ak(a);
            for(var g = wk(a, 2), h = wk(a, 1), k = wk(a, 5), l = Bk(a), m = Bk(a), n = Bk(a), q = Bk(a), r = Bk(a), t = Bk(a), v = Bk(a), w = Bk(a), x = Bk(a), y = Bk(a), z = Bk(a), A = [], E = [], C = 0; C < f; C++)A.push(Ak(a)), E.push(Ak(a));
            if (f > 0) for(C = f; C < 8; C++)wk(a, 2);
            for(C = 0; C < f; C++)A[C] && wk(a, 88), E[C] && Bk(a);
            V(a);
            A = V(a);
            A == 3 && wk(a, 1);
            E = V(a);
            C = V(a);
            Ak(a) && (b += V(a), c += V(a), d += V(a), e += V(a));
            var D = V(a), B = V(a), J = V(a);
            if (Ak(a)) for(var F = 0; F <= f; F++)V(a), V(a), V(a);
            else V(a), V(a), V(a);
            V(a);
            V(a);
            V(a);
            V(a);
            V(a);
            V(a);
            if (Ak(a) && Ak(a)) for(F = 0; F < 4; F++)for(var I = 0; I < (F === 3 ? 2 : 6); I++)if (Ak(a)) {
                var K = Math.min(64, 1 << 4 + (F << 1));
                F > 1 && zk(a);
                for(var N = 0; N < K; N++)zk(a);
            } else V(a);
            Ak(a);
            Ak(a);
            Ak(a) && (Bk(a), V(a), V(a), Ak(a));
            F = V(a);
            for(K = I = 0; K < F; K++)if (N = !1, K !== 0 && (N = Ak(a)), N) {
                K === F && V(a);
                Ak(a);
                V(a);
                for(var P = N = 0; P <= I; P++){
                    var M = Ak(a), L = !1;
                    M || (L = Ak(a));
                    (M || L) && N++;
                }
                I = N;
            } else {
                P = V(a);
                N = V(a);
                I = P + N;
                for(M = 0; M < P; M++)V(a), Ak(a);
                for(P = 0; P < N; P++)V(a), Ak(a);
            }
            if (Ak(a)) for(F = V(a), I = 0; I < F; I++){
                for(K = 0; K < J + 4; K++)wk(a, 1);
                wk(a, 1);
            }
            F = J = 1;
            I = !0;
            K = 1;
            P = N = 0;
            Ak(a);
            Ak(a);
            if (Ak(a)) {
                if (Ak(a)) {
                    M = Bk(a);
                    L = [
                        1,
                        12,
                        10,
                        16,
                        40,
                        24,
                        20,
                        32,
                        80,
                        18,
                        15,
                        64,
                        160,
                        4,
                        3,
                        2
                    ];
                    var Q = [
                        1,
                        11,
                        11,
                        11,
                        33,
                        11,
                        11,
                        11,
                        33,
                        11,
                        11,
                        33,
                        99,
                        3,
                        2,
                        1
                    ];
                    M > 0 && M <= 16 ? (J = L[M - 1], F = Q[M - 1]) : M === 255 && (J = wk(a, 16), F = wk(a, 16));
                }
                Ak(a) && Ak(a);
                Ak(a) && (wk(a, 3), Ak(a), Ak(a) && (Bk(a), Bk(a), Bk(a)));
                Ak(a) && (V(a), V(a));
                Ak(a);
                Ak(a);
                Ak(a);
                if (M = Ak(a)) yk(a), yk(a), yk(a), yk(a);
                if (Ak(a) && (K = wk(a, 32), N = wk(a, 32), Ak(a) && V(a), Ak(a))) {
                    Q = !1;
                    M = Ak(a);
                    L = Ak(a);
                    if (M || L) {
                        if (Q = Ak(a)) Bk(a), wk(a, 5), Ak(a), wk(a, 5);
                        wk(a, 4);
                        wk(a, 4);
                        Q && wk(a, 4);
                        wk(a, 5);
                        wk(a, 5);
                        wk(a, 5);
                    }
                    for(var S = 0; S <= f; S++){
                        I = Ak(a);
                        var Z = !0, pa = 1;
                        I || (Z = Ak(a));
                        var va = !1;
                        Z ? V(a) : va = Ak(a);
                        va || (pa = V(a) + 1);
                        if (M) {
                            for(Z = 0; Z < pa; Z++)V(a), V(a), Q && (V(a), V(a));
                            Ak(a);
                        }
                        if (L) {
                            for(Z = 0; Z < pa; Z++)V(a), V(a), Q && (V(a), V(a));
                            Ak(a);
                        }
                    }
                }
                Ak(a) && (Ak(a), Ak(a), Ak(a), P = V(a), V(a), V(a), V(a), V(a));
            }
            return {
                fh: z,
                mh: g,
                nh: h,
                kh: k,
                gh: l,
                hh: m,
                ih: n,
                jh: q,
                Zg: r,
                $g: t,
                ah: v,
                bh: w,
                dh: x,
                eh: y,
                Pf: P,
                Ng: A,
                Jg: D,
                Ig: B,
                width: E - (b + c) * (A === 1 || A === 2 ? 2 : 1),
                height: C - (d + e) * (A === 1 ? 2 : 1),
                qm: J,
                pm: F,
                Yg: N / K,
                Xg: I
            };
        }
        function nH(a) {
            var b = new tk(a, !0);
            Bk(b);
            Bk(b);
            V(b);
            V(b);
            Ak(b);
            Ak(b);
            wk(b, 3);
            Ak(b);
            Ak(b);
            V(b);
            V(b);
            zk(b);
            Ak(b);
            Ak(b);
            Ak(b) && V(b);
            zk(b);
            zk(b);
            Ak(b);
            Ak(b);
            Ak(b);
            Ak(b);
            a = Ak(b);
            b = Ak(b);
            var c = 1;
            b && a ? c = 0 : b ? c = 3 : a && (c = 2);
            return {
                Rh: c
            };
        }
        function oH(a, b, c, d) {
            var e = new Uint8Array(23 + (5 + a.byteLength) + (5 + b.byteLength) + (5 + c.byteLength));
            e[0] = 1;
            e[1] = (d.mh & 3) << 6 | (d.nh ? 1 : 0) << 5 | d.kh & 31;
            e[2] = d.gh;
            e[3] = d.hh;
            e[4] = d.ih;
            e[5] = d.jh;
            e[6] = d.Zg;
            e[7] = d.$g;
            e[8] = d.ah;
            e[9] = d.bh;
            e[10] = d.dh;
            e[11] = d.eh;
            e[12] = d.fh;
            e[13] = 240 | (d.Pf & 3840) >> 8;
            e[14] = d.Pf & 255;
            e[15] = 252 | d.Rh & 3;
            e[16] = 252 | d.Ng & 3;
            e[17] = 248 | d.Jg & 7;
            e[18] = 248 | d.Ig & 7;
            e[19] = 0;
            e[20] = parseInt(d.Yg, 10);
            e[21] = ((d.Xg ? 1 : 0) & 3) << 6 | (d.Ph & 7) << 3 | (d.wi ? 1 : 0) << 2 | 3;
            e[22] = 3;
            a = [
                a,
                b,
                c
            ];
            b = 23;
            c = a.length - 1;
            for(d = 0; d < a.length; d += 1)e.set(new Uint8Array([
                32 + d | (d === c ? 128 : 0),
                0,
                1,
                a[d].byteLength >> 8,
                a[d].byteLength & 255
            ]), b), b += 5, e.set(a[d], b), b += a[d].byteLength;
            return e;
        }
        function pH(a, b) {
            var c = a[b + 1] >> 3 & 3, d = a[b + 1] >> 1 & 3, e = a[b + 2] >> 4 & 15, f = a[b + 2] >> 2 & 3;
            if (c !== 1 && e !== 0 && e !== 15 && f !== 3) {
                var g = a[b + 3] >> 6;
                e = qH[(c === 3 ? 3 - d : d === 3 ? 3 : 4) * 14 + e - 1] * 1E3;
                f = rH[(c === 3 ? 0 : c === 2 ? 1 : 2) * 3 + f];
                c = sH[c][d];
                var h = tH[d], k = Math.floor(c * e / f + (a[b + 2] >> 1 & 1)) * h, l = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
                (l = l ? parseInt(l[1], 10) : 0) && l <= 87 && d === 2 && e >= 224E3 && g === 0 && (a[b + 3] |= 128);
                return {
                    sampleRate: f,
                    channelCount: g === 3 ? 1 : 2,
                    oa: k,
                    om: c * 8 * h
                };
            }
            return null;
        }
        function uH(a, b) {
            return a[b] === 255 && (a[b + 1] & 224) === 224 && (a[b + 1] & 6) !== 0;
        }
        function vH(a, b) {
            if (b + 1 < a.length && uH(a, b)) {
                var c = pH(a, b), d = 4;
                c && c.oa && (d = c.oa);
                b += d;
                return b === a.length || b + 1 < a.length && uH(a, b);
            }
            return !1;
        }
        var qH = [
            32,
            64,
            96,
            128,
            160,
            192,
            224,
            256,
            288,
            320,
            352,
            384,
            416,
            448,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            384,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160,
            176,
            192,
            224,
            256,
            8,
            16,
            24,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160
        ], rH = [
            44100,
            48E3,
            32E3,
            22050,
            24E3,
            16E3,
            11025,
            12E3,
            8E3
        ], sH = [
            [
                0,
                72,
                144,
                12
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                72,
                144,
                12
            ],
            [
                0,
                144,
                144,
                12
            ]
        ], tH = [
            0,
            1,
            1,
            4
        ];
        function wH(a) {
            this.j = a;
            this.h = 0;
            this.g = new Map;
            this.i = null;
        }
        p = wH.prototype;
        p.destroy = function() {
            this.g.clear();
        };
        p.isSupported = function(a) {
            return a.toLowerCase().split(";")[0] == "audio/mpeg" ? Si(this.convertCodecs("audio", a)) : !1;
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "audio/mpeg" ? 'audio/mp4; codecs="mp3"' : b;
        };
        p.getOriginalMimeType = function() {
            return this.j;
        };
        p.transmux = function(a, b, c, d) {
            for(var e = Fb(a), f = qk(e).length; f < e.length && !vH(e, f); f++);
            var g;
            for(a = []; f < e.length;){
                var h = pH(e, f);
                if (!h) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                g || (g = h);
                f + h.oa <= e.length && a.push({
                    data: e.subarray(f, f + h.oa),
                    size: h.oa,
                    duration: 1152,
                    ub: 0,
                    flags: ZG
                });
                f += h.oa;
            }
            if (!g) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            e = g.om * 9E4 / g.sampleRate * this.h;
            d = {
                id: b.id,
                type: "audio",
                codecs: "mp3",
                timescale: g.sampleRate,
                duration: d,
                Cb: [],
                Ha: new Uint8Array([]),
                Za: new Uint8Array([]),
                fb: 0,
                gb: 0,
                data: {
                    sequenceNumber: this.h,
                    baseMediaDecodeTime: e,
                    zb: a
                },
                stream: b
            };
            d = new dj([
                d
            ]);
            c = b.id + "_" + c.i;
            this.g.has(c) ? b = this.g.get(c) : (b = ej(d), this.g.set(c, b));
            c = this.i !== b;
            d = Bj(d);
            this.i = b;
            this.h++;
            return Promise.resolve({
                data: d,
                init: c ? b : null
            });
        };
        O("shaka.transmuxer.Mp3Transmuxer", wH);
        wH.prototype.transmux = wH.prototype.transmux;
        wH.prototype.getOriginalMimeType = wH.prototype.getOriginalMimeType;
        wH.prototype.convertCodecs = wH.prototype.convertCodecs;
        wH.prototype.isSupported = wH.prototype.isSupported;
        wH.prototype.destroy = wH.prototype.destroy;
        mf("audio/mpeg", function() {
            return new wH("audio/mpeg");
        }, uf);
        function xH(a) {
            this.h = a;
            this.g = null;
        }
        p = xH.prototype;
        p.destroy = function() {};
        p.isSupported = function(a) {
            if (a.toLowerCase().split(";")[0] != "video/mp2t") return !1;
            var b = Gf(a).split(","), c = Cc("audio", b);
            b = Cc("video", b);
            return !c || b || Cf(c) != "mp3" ? !1 : Si(this.convertCodecs("audio", a));
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "video/mp2t" ? "audio/mpeg" : b;
        };
        p.getOriginalMimeType = function() {
            return this.h;
        };
        p.transmux = function(a, b, c, d, e) {
            this.g ? this.g.clearData() : this.g = new Ek;
            this.g.hg(c.i);
            a = Fb(a);
            a = this.g.parse(a);
            if (a.me().audio != "mp3" || e != "audio") return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            c = new Uint8Array([]);
            e = u(a.yb());
            for(a = e.next(); !a.done; a = e.next())if (a = a.value.data) for(b = 0; b < a.length;)(d = pH(a, b)) ? (b + d.oa <= a.length && (c = tc(c, a.subarray(b, b + d.oa))), b += d.oa) : b++;
            return Promise.resolve(c);
        };
        O("shaka.transmuxer.MpegTsTransmuxer", xH);
        xH.prototype.transmux = xH.prototype.transmux;
        xH.prototype.getOriginalMimeType = xH.prototype.getOriginalMimeType;
        xH.prototype.convertCodecs = xH.prototype.convertCodecs;
        xH.prototype.isSupported = xH.prototype.isSupported;
        xH.prototype.destroy = xH.prototype.destroy;
        mf("video/mp2t", function() {
            return new xH("video/mp2t");
        }, rf); /*
 @license
 MSS Transmuxer
 Copyright 2015 Dash Industry Forum
 SPDX-License-Identifier: BSD-3-Clause
*/ 
        function yH(a) {
            this.h = a;
            (this.g = Qy.get("ISOBoxer")()) && zH(this);
        }
        function zH(a) {
            function b() {
                this._procFullBox();
                this.flags & 1 && (this._procField("AlgorithmID", "uint", 24), this._procField("IV_size", "uint", 8), this._procFieldArray("KID", 16, "uint", 8));
                this._procField("sample_count", "uint", 32);
                this._procEntries("entry", this.sample_count, function(c) {
                    this._procEntryField(c, "InitializationVector", "data", 8);
                    this.flags & 2 && (this._procEntryField(c, "NumberOfEntries", "uint", 16), this._procSubEntries(c, "clearAndCryptedData", c.NumberOfEntries, function(d) {
                        this._procEntryField(d, "BytesOfClearData", "uint", 16);
                        this._procEntryField(d, "BytesOfEncryptedData", "uint", 32);
                    }));
                });
            }
            a.g.addBoxProcessor("saio", function() {
                this._procFullBox();
                this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));
                this._procField("entry_count", "uint", 32);
                this._procFieldArray("offset", this.entry_count, "uint", this.version === 1 ? 64 : 32);
            });
            a.g.addBoxProcessor("saiz", function() {
                this._procFullBox();
                this.flags & 1 && (this._procField("aux_info_type", "uint", 32), this._procField("aux_info_type_parameter", "uint", 32));
                this._procField("default_sample_info_size", "uint", 8);
                this._procField("sample_count", "uint", 32);
                this.default_sample_info_size === 0 && this._procFieldArray("sample_info_size", this.sample_count, "uint", 8);
            });
            a.g.addBoxProcessor("senc", b);
            a.g.addBoxProcessor("uuid", function() {
                for(var c = !0, d = 0; d < 16; d++)this.usertype[d] !== AH[d] && (c = !1);
                c && (this._parsing && (this.type = "sepiff"), b.call(this));
            });
        }
        p = yH.prototype;
        p.destroy = function() {};
        p.isSupported = function(a, b) {
            var c = a.startsWith("mss/");
            if (!this.g || !c) return !1;
            if (b) return Si(this.convertCodecs(b, a));
            b = this.convertCodecs("audio", a);
            a = this.convertCodecs("video", a);
            return Si(b) || Si(a);
        };
        p.convertCodecs = function(a, b) {
            return b.replace("mss/", "");
        };
        p.getOriginalMimeType = function() {
            return this.h;
        };
        p.transmux = function(a, b, c) {
            if (!c) return Promise.resolve(Fb(a));
            if (!b.mssPrivateData) return Promise.reject(new T(2, 3, 3020, c ? c.T()[0] : null));
            try {
                var d, e = this.g.parseBuffer(a), f = e.fetch("tfhd");
                f.track_ID = b.id + 1;
                var g = e.fetch("tfdt"), h = e.fetch("traf");
                g === null && (g = this.g.createFullBox("tfdt", h, f), g.version = 1, g.flags = 0, g.baseMediaDecodeTime = Math.floor(c.startTime * b.mssPrivateData.timescale));
                var k = e.fetch("trun"), l = e.fetch("tfxd");
                l && l._parent.boxes.splice(l._parent.boxes.indexOf(l), 1);
                var m = e.fetch("tfrf");
                m && m._parent.boxes.splice(m._parent.boxes.indexOf(m), 1);
                var n = e.fetch("sepiff");
                if (n !== null) {
                    n.type = "senc";
                    n.usertype = void 0;
                    var q = e.fetch("saio");
                    if (q === null) {
                        q = this.g.createFullBox("saio", h);
                        q.version = 0;
                        q.flags = 0;
                        q.entry_count = 1;
                        q.offset = [
                            0
                        ];
                        var r = this.g.createFullBox("saiz", h);
                        r.version = 0;
                        r.flags = 0;
                        r.sample_count = n.sample_count;
                        r.default_sample_info_size = 0;
                        r.sample_info_size = [];
                        if (n.flags & 2) for(d = 0; d < n.sample_count; d += 1)r.sample_info_size[d] = 10 + 6 * n.entry[d].NumberOfEntries;
                        else r.default_sample_info_size = 8;
                    }
                }
                f.flags &= 16777214;
                f.flags |= 131072;
                k.flags |= 1;
                var t = e.fetch("moof");
                k.data_offset = t.getLength() + 8;
                var v = e.fetch("saio");
                v !== null && (v.offset[0] = BH(t, "traf") + BH(h, "senc") + 16);
                var w = Fb(e.write());
                return Promise.resolve(w);
            } catch (x) {
                return x instanceof T ? Promise.reject(x) : Promise.reject(new T(2, 3, 3022, c ? c.T()[0] : null));
            }
        };
        function BH(a, b) {
            for(var c = 8, d = 0; d < a.boxes.length && a.boxes[d].type !== b; d++)c += a.boxes[d].size;
            return c;
        }
        O("shaka.transmuxer.MssTransmuxer", yH);
        yH.prototype.transmux = yH.prototype.transmux;
        yH.prototype.getOriginalMimeType = yH.prototype.getOriginalMimeType;
        yH.prototype.convertCodecs = yH.prototype.convertCodecs;
        yH.prototype.isSupported = yH.prototype.isSupported;
        yH.prototype.destroy = yH.prototype.destroy;
        var AH = new Uint8Array([
            162,
            57,
            79,
            82,
            90,
            155,
            79,
            20,
            162,
            68,
            108,
            66,
            124,
            100,
            141,
            244
        ]);
        mf("mss/audio/mp4", function() {
            return new yH("mss/audio/mp4");
        }, uf);
        mf("mss/video/mp4", function() {
            return new yH("mss/video/mp4");
        }, uf);
        function CH(a) {
            if (a.length < 1) return 960;
            var b = a[0], c = b & 3;
            b = DH[b >> 3 & 31];
            if (c === 0) a = 1;
            else if (c === 1 || c === 2) a = 2;
            else {
                if (a.length < 2) return b;
                a = a[1] & 63;
                if (a === 0) return b;
            }
            return b * a;
        }
        var DH = [
            480,
            960,
            1920,
            2880,
            480,
            960,
            1920,
            2880,
            480,
            960,
            1920,
            2880,
            480,
            960,
            480,
            960,
            120,
            240,
            480,
            960,
            120,
            240,
            480,
            960,
            120,
            240,
            480,
            960,
            120,
            240,
            480,
            960
        ];
        function EH(a) {
            this.m = a;
            this.g = 0;
            this.j = new Map;
            this.l = this.i = this.h = null;
        }
        p = EH.prototype;
        p.destroy = function() {
            this.j.clear();
            this.i && this.i.destroy();
        };
        p.isSupported = function(a, b) {
            if (a.toLowerCase().split(";")[0] != "video/mp2t") return !1;
            var c = a;
            b && (c = this.convertCodecs(b, a));
            var d = Gf(c).split(",");
            c = Cc("audio", d);
            d = Cc("video", d);
            if (c && (c = Cf(c), !FH.includes(c)) || d && (c = Cf(d), !GH.includes(c))) return !1;
            if (b) return Si(this.convertCodecs(b, a));
            b = this.convertCodecs("audio", a);
            a = this.convertCodecs("video", a);
            return Si(b) || Si(a);
        };
        p.convertCodecs = function(a, b) {
            return b.toLowerCase().split(";")[0] == "video/mp2t" ? (b = Gf(b).replace("mp4a.40.34", "mp3").split(",").map(function(c) {
                return rg(c, "audio/mp4");
            }).map(sg).join(","), a == "audio" ? 'audio/mp4; codecs="' + b + '"' : 'video/mp4; codecs="' + b + '"') : b;
        };
        p.getOriginalMimeType = function() {
            return this.m;
        };
        p.transmux = function(a, b, c, d, e) {
            var f = Fb(a);
            if (e == "audio" && !Rk(f)) {
                for(var g = qk(f), h = g.length; h < f.length; h++)if (vH(f, h)) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
                for(h = g.length; h < f.length; h++)if (XG(f, h)) return this.i || (this.i = new bH("audio/aac")), this.i.transmux(a, b, c, d, e);
                return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            }
            this.h ? this.h.clearData() : this.h = new Ek;
            this.h.hg(c.i);
            var k = this.h.parse(f), l = [], m = k.me();
            try {
                var n = null;
                if (e == "video") {
                    switch(m.video){
                        case "avc":
                            var q = [], r = null, t = k.Ed(), v = jH(t);
                            if (!v.length) throw new T(2, 3, 3023, c ? c.T()[0] : null);
                            for(var w = 0; w < v.length; w++){
                                var x = v[w];
                                r == null && (r = x.dts);
                                var y = void 0;
                                y = w + 1 < v.length ? (v[w + 1].dts || 0) - (x.dts || 0) : v.length > 1 ? (x.dts || 0) - (v[w - 1].dts || 0) : (c.endTime - c.startTime) * 9E4;
                                q.push({
                                    data: x.data,
                                    size: x.data.byteLength,
                                    duration: y,
                                    ub: Math.round((x.pts || 0) - (x.dts || 0)),
                                    flags: x.isKeyframe ? $G : aH
                                });
                            }
                            for(var z = [], A = u(t), E = A.next(); !E.done; E = A.next())z.push.apply(z, G(E.value.nalus));
                            var C = hH(z);
                            if (!C || r == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            b.height = b.height || C.height;
                            b.width = b.width || C.width;
                            n = {
                                id: b.id,
                                type: "video",
                                codecs: "avc1",
                                timescale: 9E4,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: C.Za,
                                fb: C.fb,
                                gb: C.gb,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: r,
                                    zb: q
                                },
                                stream: b
                            };
                            break;
                        case "hvc":
                            var D = [], B = null, J = [], F = k.Ed(), I = new Uint8Array(0), K = !1;
                            if (!F.length) throw new T(2, 3, 3023, c ? c.T()[0] : null);
                            for(var N = 0; N < F.length; N++){
                                var P = F[N], M = P.nalus;
                                J.push.apply(J, G(M));
                                for(var L = !1, Q = [], S = 0, Z = !1, pa = u(M), va = pa.next(); !va.done; va = pa.next()){
                                    var Ca = va.value;
                                    switch(Ca.type){
                                        case 1:
                                        case 0:
                                            var ua = Z = !0;
                                            break;
                                        case 19:
                                        case 20:
                                        case 21:
                                            L = ua = Z = !0;
                                            break;
                                        case 32:
                                        case 33:
                                        case 34:
                                            ua = !0;
                                            break;
                                        case 35:
                                            Z = ua = !0;
                                            break;
                                        case 39:
                                        case 40:
                                            ua = !0;
                                            break;
                                        default:
                                            ua = !1;
                                    }
                                    Z && ua && (Q.push(Ca.fullData), S += Ca.fullData.byteLength);
                                }
                                if (Q.length) {
                                    S += 4 * Q.length;
                                    for(var xa = new Uint8Array(S), Da = 0, Ka = u(Q), wa = Ka.next(); !wa.done; wa = Ka.next()){
                                        var Ja = wa.value, Aa = Ja.byteLength;
                                        xa[Da] = Aa >> 24 & 255;
                                        xa[Da + 1] = Aa >> 16 & 255;
                                        xa[Da + 2] = Aa >> 8 & 255;
                                        xa[Da + 3] = Aa & 255;
                                        xa.set(Ja, Da + 4);
                                        Da += Aa + 4;
                                    }
                                    I = xa;
                                    K = L;
                                    var Ga = !0;
                                } else Ga = !1;
                                if (Ga) {
                                    B == null && P.dts != null && (B = P.dts);
                                    var sb = void 0;
                                    sb = N + 1 < F.length ? (F[N + 1].dts || 0) - (P.dts || 0) : F.length > 1 ? (P.dts || 0) - (F[N - 1].dts || 0) : (c.endTime - c.startTime) * 9E4;
                                    D.push({
                                        data: I,
                                        size: I.byteLength,
                                        duration: sb,
                                        ub: Math.round((P.pts || 0) - (P.dts || 0)),
                                        flags: K ? $G : aH
                                    });
                                }
                            }
                            var Wb = kH(J);
                            if (!Wb || B == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            b.height = b.height || Wb.height;
                            b.width = b.width || Wb.width;
                            n = {
                                id: b.id,
                                type: "video",
                                codecs: "hvc1",
                                timescale: 9E4,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: Wb.Za,
                                fb: Wb.fb,
                                gb: Wb.gb,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: B,
                                    zb: D
                                },
                                stream: b
                            };
                    }
                    n && (l.push(n), n = null);
                }
                if (e == "audio") {
                    switch(m.audio){
                        case "aac":
                            for(var wb = [], wc, he = null, hd = null, qd = null, sf = u(k.yb()), Bg = sf.next(); !Bg.done; Bg = sf.next()){
                                var rd = Bg.value, xc = rd.data;
                                if (xc) {
                                    var nc = 0;
                                    if (hd == -1 && qd) xc = tc(qd, rd.data), hd = null;
                                    else if (hd != null && qd) {
                                        nc = Math.max(0, hd);
                                        var mi = tc(qd, xc.subarray(0, nc));
                                        wb.push({
                                            data: mi,
                                            size: mi.byteLength,
                                            duration: 1024,
                                            ub: 0,
                                            flags: ZG
                                        });
                                        hd = qd = null;
                                    }
                                    wc = WG(xc, nc);
                                    if (!wc) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                                    b.audioSamplingRate = wc.sampleRate;
                                    b.channelsCount = wc.channelCount;
                                    he == null && rd.pts !== null && (he = rd.pts);
                                    for(; nc < xc.length;){
                                        var oc = VG(xc, nc);
                                        if (!oc) {
                                            qd = xc.subarray(nc, xc.length);
                                            hd = -1;
                                            break;
                                        }
                                        var tf = oc.re + oc.oa;
                                        hd = Math.max(0, nc + tf - xc.length);
                                        hd != 0 ? qd = xc.subarray(nc + oc.re, nc + tf) : nc + tf <= xc.length && wb.push({
                                            data: xc.subarray(nc + oc.re, nc + tf),
                                            size: oc.oa,
                                            duration: 1024,
                                            ub: 0,
                                            flags: ZG
                                        });
                                        nc += tf;
                                    }
                                }
                            }
                            if (!wc || he == null) {
                                he = c.startTime * 9E4;
                                var ni = Cc("audio", b.codecs.split(","));
                                if (!ni || !b.channelsCount || !b.audioSamplingRate) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                                wc = {
                                    sampleRate: b.audioSamplingRate,
                                    channelCount: b.channelsCount,
                                    codec: ni
                                };
                                var oi = YG(ni, b.channelsCount);
                                if (!oi) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                                for(var lp = he + (c.endTime - c.startTime) * 9E4, Yk = he; Yk < lp;)wb.push({
                                    data: oi,
                                    size: oi.byteLength,
                                    duration: 1024,
                                    ub: 0,
                                    flags: ZG
                                }), Yk += 1024 / wc.sampleRate * 9E4;
                            }
                            var Db = wc.sampleRate, Ac = he / 9E4 * Db;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: wc.codec,
                                timescale: Db,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: Ac,
                                    zb: wb
                                },
                                stream: b
                            };
                            break;
                        case "ac3":
                            for(var pc = [], Gl = 0, uq = new Uint8Array([]), Hl = null, Pe = {
                                sampleRate: 0,
                                channelCount: 0,
                                Ha: new Uint8Array(0),
                                oa: 0
                            }, OA = u(k.yb()), vq = OA.next(); !vq.done; vq = OA.next()){
                                var wq = vq.value, xq = wq.data;
                                Hl == null && wq.pts !== null && (Hl = wq.pts);
                                for(var Hg = 0; Hg < xq.length;)cH(xq, Hg, Pe) ? (b.audioSamplingRate = Pe.sampleRate, b.channelsCount = Pe.channelCount, Gl = Pe.sampleRate, uq = Pe.Ha, pc.push({
                                    data: xq.subarray(Hg, Hg + Pe.oa),
                                    size: Pe.oa,
                                    duration: 1536,
                                    ub: 0,
                                    flags: ZG
                                }), Hg += Pe.oa) : Hg++;
                            }
                            if (Gl == 0 || uq.byteLength == 0 || Hl == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var AL = Hl / 9E4 * Gl;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "ac-3",
                                timescale: Gl,
                                duration: d,
                                Cb: [],
                                Ha: uq,
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: AL,
                                    zb: pc
                                },
                                stream: b
                            };
                            break;
                        case "ec3":
                            for(var PA = [], Il = 0, yq = new Uint8Array([]), Jl = null, Qe = {
                                sampleRate: 0,
                                channelCount: 0,
                                Ha: new Uint8Array(0),
                                oa: 0
                            }, QA = u(k.yb()), zq = QA.next(); !zq.done; zq = QA.next()){
                                var Aq = zq.value, Bq = Aq.data;
                                Jl == null && Aq.pts !== null && (Jl = Aq.pts);
                                for(var Ig = 0; Ig < Bq.length;)fH(Bq, Ig, Qe) ? (b.audioSamplingRate = Qe.sampleRate, b.channelsCount = Qe.channelCount, Il = Qe.sampleRate, yq = Qe.Ha, PA.push({
                                    data: Bq.subarray(Ig, Ig + Qe.oa),
                                    size: Qe.oa,
                                    duration: 1536,
                                    ub: 0,
                                    flags: ZG
                                }), Ig += Qe.oa) : Ig++;
                            }
                            if (Il == 0 || yq.byteLength == 0 || Jl == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var BL = Jl / 9E4 * Il;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "ec-3",
                                timescale: Il,
                                duration: d,
                                Cb: [],
                                Ha: yq,
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: BL,
                                    zb: PA
                                },
                                stream: b
                            };
                            break;
                        case "mp3":
                            for(var RA = [], Kl, Ll = null, SA = u(k.yb()), Cq = SA.next(); !Cq.done; Cq = SA.next()){
                                var Dq = Cq.value, Bi = Dq.data;
                                if (Bi) {
                                    Ll == null && Dq.pts !== null && (Ll = Dq.pts);
                                    for(var xf = 0; xf < Bi.length;){
                                        var Jg = pH(Bi, xf);
                                        Jg ? (Kl || (Kl = Jg), xf + Jg.oa <= Bi.length && RA.push({
                                            data: Bi.subarray(xf, xf + Jg.oa),
                                            size: Jg.oa,
                                            duration: 1152,
                                            ub: 0,
                                            flags: ZG
                                        }), xf += Jg.oa) : xf++;
                                    }
                                }
                            }
                            if (!Kl || Ll == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var TA = Kl.sampleRate, CL = Ll / 9E4 * TA;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "mp3",
                                timescale: TA,
                                duration: d,
                                Cb: [],
                                Ha: new Uint8Array([]),
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: CL,
                                    zb: RA
                                },
                                stream: b
                            };
                            break;
                        case "opus":
                            var UA = [], Ml = null, Gd = k.J;
                            if (!Gd) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            var fc = [];
                            switch(Gd.vk){
                                case 1:
                                case 2:
                                    fc = [
                                        0
                                    ];
                                    break;
                                case 0:
                                    fc = [
                                        255,
                                        1,
                                        1,
                                        0,
                                        1
                                    ];
                                    break;
                                case 128:
                                    fc = [
                                        255,
                                        2,
                                        0,
                                        0,
                                        1
                                    ];
                                    break;
                                case 3:
                                    fc = [
                                        1,
                                        2,
                                        1,
                                        0,
                                        2,
                                        1
                                    ];
                                    break;
                                case 4:
                                    fc = [
                                        1,
                                        2,
                                        2,
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 5:
                                    fc = [
                                        1,
                                        3,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 6:
                                    fc = [
                                        1,
                                        4,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3,
                                        5
                                    ];
                                    break;
                                case 7:
                                    fc = [
                                        1,
                                        4,
                                        2,
                                        0,
                                        4,
                                        1,
                                        2,
                                        3,
                                        5,
                                        6
                                    ];
                                    break;
                                case 8:
                                    fc = [
                                        1,
                                        5,
                                        3,
                                        0,
                                        6,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        7
                                    ];
                                    break;
                                case 130:
                                    fc = [
                                        1,
                                        1,
                                        2,
                                        0,
                                        1
                                    ];
                                    break;
                                case 131:
                                    fc = [
                                        1,
                                        1,
                                        3,
                                        0,
                                        1,
                                        2
                                    ];
                                    break;
                                case 132:
                                    fc = [
                                        1,
                                        1,
                                        4,
                                        0,
                                        1,
                                        2,
                                        3
                                    ];
                                    break;
                                case 133:
                                    fc = [
                                        1,
                                        1,
                                        5,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ];
                                    break;
                                case 134:
                                    fc = [
                                        1,
                                        1,
                                        6,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5
                                    ];
                                    break;
                                case 135:
                                    fc = [
                                        1,
                                        1,
                                        7,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ];
                                    break;
                                case 136:
                                    fc = [
                                        1,
                                        1,
                                        8,
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ];
                            }
                            var VA = new Uint8Array([
                                0,
                                Gd.channelCount,
                                0,
                                0,
                                Gd.sampleRate >>> 24 & 255,
                                Gd.sampleRate >>> 17 & 255,
                                Gd.sampleRate >>> 8 & 255,
                                Gd.sampleRate >>> 0 & 255,
                                0,
                                0
                            ].concat(G(fc)));
                            for(var WA = Gd.sampleRate, XA = u(k.yb()), Eq = XA.next(); !Eq.done; Eq = XA.next()){
                                var Fq = Eq.value, Kg = Fq.data;
                                Ml == null && Fq.pts !== null && (Ml = Fq.pts);
                                for(var Ci = 0; Ci < Kg.length;){
                                    for(var DL = (Kg[Ci + 1] & 16) !== 0, EL = (Kg[Ci + 1] & 8) !== 0, je = Ci + 2, Nl = 0; Kg[je] === 255;)Nl += 255, je += 1;
                                    Nl += Kg[je];
                                    je += 1;
                                    je += DL ? 2 : 0;
                                    je += EL ? 2 : 0;
                                    var Gq = Kg.slice(je, je + Nl);
                                    UA.push({
                                        data: Gq,
                                        size: Gq.byteLength,
                                        duration: CH(Gq),
                                        ub: 0,
                                        flags: ZG
                                    });
                                    Ci = je + Nl;
                                }
                            }
                            if (VA.byteLength == 0 || Ml == null) throw new T(2, 3, 3018, c ? c.T()[0] : null);
                            b.audioSamplingRate = Gd.sampleRate;
                            b.channelsCount = Gd.channelCount;
                            var FL = Ml / 9E4 * WA;
                            n = {
                                id: b.id,
                                type: "audio",
                                codecs: "opus",
                                timescale: WA,
                                duration: d,
                                Cb: [],
                                Ha: VA,
                                Za: new Uint8Array([]),
                                fb: 0,
                                gb: 0,
                                data: {
                                    sequenceNumber: this.g,
                                    baseMediaDecodeTime: FL,
                                    zb: UA
                                },
                                stream: b
                            };
                    }
                    n && (l.push(n), n = null);
                }
            } catch (Hq) {
                return Hq && Hq.code == 3023 ? Promise.resolve(new Uint8Array([])) : Promise.reject(Hq);
            }
            if (!l.length) return Promise.reject(new T(2, 3, 3018, c ? c.T()[0] : null));
            var YA = new dj(l), Iq = b.id + "_" + c.i;
            if (this.j.has(Iq)) var Di = this.j.get(Iq);
            else Di = ej(YA), this.j.set(Iq, Di);
            var GL = this.l !== Di, HL = Bj(YA);
            this.l = Di;
            this.g++;
            return Promise.resolve({
                data: HL,
                init: GL ? Di : null
            });
        };
        O("shaka.transmuxer.TsTransmuxer", EH);
        EH.prototype.transmux = EH.prototype.transmux;
        EH.prototype.getOriginalMimeType = EH.prototype.getOriginalMimeType;
        EH.prototype.convertCodecs = EH.prototype.convertCodecs;
        EH.prototype.isSupported = EH.prototype.isSupported;
        EH.prototype.destroy = EH.prototype.destroy;
        var FH = [
            "aac",
            "ac-3",
            "ec-3",
            "mp3",
            "opus"
        ], GH = [
            "avc",
            "hevc"
        ];
        mf("video/mp2t", function() {
            return new EH("video/mp2t");
        }, qf);
        function HH() {}
        oa(HH, go);
        O("shaka.util.FairPlayUtils", HH);
        function IH(a, b) {
            var c = this;
            this.parent = a;
            this.controls = b;
            this.eventManager = new fd;
            this.localization = this.controls.ya;
            this.player = this.controls.Rb();
            this.video = this.controls.Rc();
            this.adManager = this.player.tf();
            this.ad = b.getAd();
            this.eventManager.u(this.adManager, "ad-started", function(d) {
                c.ad = d.ad;
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                c.ad = null;
            });
        }
        IH.prototype.release = function() {
            this.eventManager.release();
            this.ad = this.adManager = this.video = this.player = this.localization = this.eventManager = this.controls = this.parent = null;
        };
        O("shaka.ui.Element", IH);
        IH.prototype.release = IH.prototype.release;
        function JH(a, b) {
            this.parent = a;
            this.g = bk("svg");
            this.h = bk("path");
            this.g.classList.add("material-svg-icon");
            this.g.setAttribute("viewBox", "0 -960 960 960");
            b && this.use(b);
            this.g.appendChild(this.h);
            this.parent && a.appendChild(this.g);
        }
        JH.prototype.use = function(a) {
            a && typeof a == "string" && this.h.setAttribute("d", a);
        };
        JH.prototype.ll = function() {
            return this.g;
        };
        O("shaka.ui.MaterialSVGIcon", JH);
        JH.prototype.getSvgElement = JH.prototype.ll;
        JH.prototype.use = JH.prototype.use;
        function KH(a) {
            return LH(a, "shaka-back-to-overflow-button");
        }
        function LH(a, b) {
            a = a.getElementsByClassName(b);
            return a.length ? a[0] : null;
        }
        function MH(a) {
            a && (a = LH(a, "shaka-chosen-item")) && a.parentElement.focus();
        }
        function NH() {
            var a = new JH(null, "m382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z").g;
            a.classList.add("shaka-chosen-item");
            a.ariaHidden = "true";
            return a;
        }
        function OH(a, b) {
            a && (b ? a.classList.remove("shaka-hidden") : a.classList.add("shaka-hidden"));
        }
        function PH(a, b) {
            var c = Math.floor(a / 86400), d = Math.floor(a % 86400 / 3600), e = Math.floor(a / 60 % 60);
            a = Math.floor(a % 60);
            a < 10 && (a = "0" + a);
            a = e + ":" + a;
            b && (e < 10 && (a = "0" + a), a = d + ":" + a, c > 0 && (d < 10 && (a = "0" + a), a = c + ":" + a));
            return a;
        }
        function QH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-ad-info");
            this.g.disabled = !0;
            this.parent.appendChild(this.g);
            this.h = new Uf(function() {
                if (c.ad.isLinear()) {
                    var d = "", e = c.ad.getSequenceLength();
                    e > 1 && (d = c.ad.getPositionInSequence(), d = c.localization.resolve("AD_PROGRESS").replace("[AD_ON]", String(d)).replace("[NUM_ADS]", String(e)));
                    var f = Math.round(c.ad.getRemainingTime()), g = c.ad.getDuration();
                    f != -1 && g != -1 && isFinite(f) && isFinite(g) ? f > 0 ? (f = PH(g - f, !1) + " / " + PH(g, !1), d = e > 1 ? d + ("\u00a0\u00a0" + f) : c.localization.resolve("AD_TIME").replace("[AD_TIME]", f), c.g.textContent = d, OH(c.g, d != "")) : (c.h.stop(), c.g.textContent = "") : (c.g.textContent = d, OH(c.g, d != ""));
                }
            });
            this.eventManager.u(this.localization, "locale-updated", function() {});
            this.eventManager.u(this.localization, "locale-changed", function() {});
            this.eventManager.u(this.adManager, "ad-started", function() {
                c.h.La();
                c.h.xa(.5);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                c.h.stop();
                c.g.textContent = "";
            });
            this.ad && (this.h.La(), this.h.xa(.5));
        }
        oa(QH, IH);
        QH.prototype.release = function() {
            this.h.stop();
            this.h = null;
            IH.prototype.release.call(this);
        };
        O("shaka.ui.AdInfo", QH);
        function RH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = this.controls.g;
            this.h = this.controls.i;
            this.i = [];
            this.g = U("div");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-context-menu");
            this.g.classList.add("shaka-hidden");
            this.h.appendChild(this.g);
            this.eventManager.u(this.h, "contextmenu", function(d) {
                if (c.g.classList.contains("shaka-hidden")) {
                    d.preventDefault();
                    var e = c.h.getBoundingClientRect();
                    c.g.style.left = d.clientX - e.left + "px";
                    c.g.style.top = d.clientY - e.top + "px";
                    OH(c.g, !0);
                } else OH(c.g, !1);
            });
            this.eventManager.u(window1, "click", function() {
                OH(c.g, !1);
            });
            this.eventManager.u(this.g, "click", function() {
                OH(c.g, !1);
            });
            this.eventManager.u(document, "click", function(d) {
                !c.h || c.g.classList.contains("shaka-hidden") || c.h.contains(d.target) || c.Og();
            });
            SH(this);
        }
        oa(RH, IH);
        RH.prototype.release = function() {
            this.h = null;
            for(var a = u(this.i), b = a.next(); !b.done; b = a.next())b.value.release();
            this.i = [];
            IH.prototype.release.call(this);
        };
        RH.prototype.Og = function() {
            OH(this.g, !1);
        };
        function TH(a, b) {
            UH.set(a, b);
        }
        function SH(a) {
            for(var b = u(a.j.contextMenuElements), c = b.next(); !c.done; c = b.next()){
                c = c.value;
                var d = UH.get(c);
                d ? a.i.push(d.create(a.g, a.controls)) : Za("Unrecognized context menu element:", c);
            }
        }
        O("shaka.ui.ContextMenu", RH);
        RH.registerElement = TH;
        RH.prototype.closeMenu = RH.prototype.Og;
        var UH = new Map;
        function VH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.button = ck();
            this.parent.appendChild(this.button);
            this.h = new JH(this.button);
            this.eventManager.u(this.localization, "locale-updated", function() {
                WH(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                WH(c);
            });
            this.eventManager.u(this.video, "play", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.video, "pause", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.video, "seeking", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.player, "loaded", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-paused", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-resumed", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                WH(c);
                c.g();
            });
            this.eventManager.u(this.button, "click", function() {
                c.controls.Ca() && XH(c.controls);
            });
            WH(this);
            this.g();
        }
        oa(VH, IH);
        VH.prototype.isPaused = function() {
            if (this.ad && this.ad.isLinear()) var a = this.ad.isPaused();
            else a = this.controls, a = a.C.paused && !a.V;
            return a;
        };
        VH.prototype.isEnded = function() {
            return this.ad && this.ad.isLinear() ? !1 : this.player ? this.player.isEnded() : !0;
        };
        function WH(a) {
            if (a.isEnded() && a.video.duration) a.button.ariaLabel = a.localization.resolve("REPLAY");
            else {
                var b = a.isPaused() ? "PLAY" : "PAUSE";
                a.button.ariaLabel = a.localization.resolve(b);
            }
        }
        VH.prototype.g = function() {
            this.isEnded() && this.video.duration ? this.h.use("M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440q0-17 11.5-28.5T160-480q17 0 28.5 11.5T200-440q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l34 34q12 12 11.5 28T508-630q-12 12-28.5 12.5T451-629L348-732q-12-12-12-28t12-28l103-103q12-12 28.5-11.5T508-890q11 12 11.5 28T508-834l-34 34h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z") : this.h.use(this.isPaused() ? "M320-273v-414q0-17 12-28.5t28-11.5q5 0 10.5 1.5T381-721l326 207q9 6 13.5 15t4.5 19q0 10-4.5 19T707-446L381-239q-5 3-10.5 4.5T360-233q-16 0-28-11.5T320-273Z" : "M640-200q-33 0-56.5-23.5T560-280v-400q0-33 23.5-56.5T640-760q33 0 56.5 23.5T720-680v400q0 33-23.5 56.5T640-200Zm-320 0q-33 0-56.5-23.5T240-280v-400q0-33 23.5-56.5T320-760q33 0 56.5 23.5T400-680v400q0 33-23.5 56.5T320-200Z");
        };
        O("shaka.ui.PlayButton", VH);
        function YH(a, b) {
            VH.call(this, a, b);
            this.button.classList.add("shaka-play-button");
            this.button.classList.add("shaka-no-propagation");
        }
        oa(YH, VH);
        YH.prototype.g = function() {
            this.isEnded() && this.video.duration ? this.button.setAttribute("icon", "replay") : this.isPaused() ? this.button.setAttribute("icon", "play") : this.button.setAttribute("icon", "pause");
        };
        O("shaka.ui.BigPlayButton", YH);
        function ZH(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.m = null;
            this.i = this.D = !1;
            this.C = this.A = null;
            this.j = new Uf(function() {
                parseInt(c.h.textContent, 10) === 0 && $H(c.controls, !0);
                var d = parseInt(c.h.textContent, 10);
                d !== 0 && (c.video.currentTime = c.controls.qh() + d);
                c.g.style.opacity = "0";
                c.D = !1;
                c.h.textContent = "0s";
            });
            this.g = U("div");
            this.g.classList.add("shaka-no-propagation");
            this.parent.appendChild(this.g);
            this.h = U("span");
            this.h.textContent = "0s";
            this.g.appendChild(this.h);
            this.o = new JH(this.g);
            this.o.g.classList.add("shaka-forward-rewind-container-icon");
            this.l = !1;
            this.eventManager.u(this.g, "touchstart", function(d) {
                d.touches.length > 0 && (c.A = d.touches[0].clientX, c.C = d.touches[0].clientY);
                c.i = !1;
            });
            this.eventManager.u(this.g, "touchmove", function(d) {
                if (d.touches.length > 0 && c.A != null && c.C != null) {
                    var e = d.touches[0].clientX - c.A;
                    d = d.touches[0].clientY - c.C;
                    Math.sqrt(e * e + d * d) > 10 && (c.i = !0);
                }
            });
            this.eventManager.u(this.g, "touchend", function(d) {
                if (!c.i) {
                    if (c.controls.Jc()) d.preventDefault(), c.controls.Sc();
                    else if (c.controls.g.tapSeekDistance > 0 && (!c.ad || !c.ad.isLinear())) {
                        if (d.preventDefault(), d = c.controls.g.tapSeekDistance, !c.D) c.D = !0, c.m = Date.now(), c.j.Z(.5);
                        else if (c.m + 500 > Date.now()) {
                            c.j.stop();
                            c.m = Date.now();
                            var e = parseInt(c.h.textContent, 10);
                            e = c.l ? e - d : e + d;
                            c.h.textContent = e.toString() + "s";
                            c.g.style.opacity = "1";
                            c.j.Z(.5);
                        }
                    }
                }
            });
        }
        oa(ZH, IH);
        O("shaka.ui.HiddenSeekButton", ZH);
        function aI(a, b) {
            ZH.call(this, a, b);
            this.g.classList.add("shaka-fast-forward-container");
            this.o.use("M100-315v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T428-480q0 10-4.5 18.5T410-447L162-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Zm400 0v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T828-480q0 10-4.5 18.5T810-447L562-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z");
            this.l = !1;
        }
        oa(aI, ZH);
        O("shaka.ui.HiddenFastForwardButton", aI);
        function bI(a, b) {
            ZH.call(this, a, b);
            this.g.classList.add("shaka-rewind-container");
            this.o.use("M798-281 550-447q-9-6-13.5-14.5T532-480q0-10 4.5-18.5T550-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Zm-400 0L150-447q-9-6-13.5-14.5T132-480q0-10 4.5-18.5T150-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z");
            this.l = !0;
        }
        oa(bI, ZH);
        O("shaka.ui.HiddenRewindButton", bI);
        function cI(a, b, c, d) {
            IH.call(this, a, b);
            var e = this;
            this.container = U("div");
            this.container.classList.add("shaka-range-container");
            this.container.classList.add.apply(this.container.classList, G(c));
            this.o = this.h = !1;
            this.bar = document.createElement("input");
            this.H = new Uf(function() {
                e.onChangeEnd();
                e.h = !1;
            });
            this.bar.classList.add("shaka-range-element");
            this.bar.classList.add.apply(this.bar.classList, G(d));
            this.bar.type = "range";
            this.bar.step = "any";
            this.bar.min = "0";
            this.bar.max = "1";
            this.bar.value = "0";
            this.bar.disabled = !this.controls.Ca();
            this.container.appendChild(this.bar);
            this.parent.appendChild(this.container);
            this.M = new Uf(function() {
                e.bar.disabled = !1;
            });
            this.eventManager.u(this.controls, "showingui", function() {
                e.M.Z(0);
            });
            this.eventManager.u(this.controls, "hidingui", function() {
                e.M.stop();
                e.bar.disabled = !0;
            });
            this.eventManager.u(this.bar, "mousedown", function(f) {
                e.bar.disabled || (f.preventDefault(), e.bar.focus(), e.h = !0, e.o = !0, dI(e, f), e.onChangeStart(), e.onChange(), f.stopPropagation());
            });
            this.eventManager.u(document, "mousemove", function(f) {
                e.o && (dI(e, f), e.onChange());
            });
            this.eventManager.u(document, "mouseup", function(f) {
                e.o && (e.o = !1, e.h && (e.h = !1, dI(e, f), e.onChangeEnd()));
            });
            this.eventManager.u(this.bar, "touchstart", function(f) {
                e.bar.disabled || (e.h = !0, eI(e, f), e.onChangeStart(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "input", function() {
                e.onChange();
            });
            this.eventManager.u(this.bar, "touchmove", function(f) {
                e.h && (eI(e, f), e.onChange(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "touchend", function(f) {
                e.h && (e.h = !1, eI(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "touchcancel", function(f) {
                e.h && (e.h = !1, eI(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "mouseup", function(f) {
                e.h && (e.h = !1, e.o = !1, dI(e, f), e.onChangeEnd(), f.stopPropagation());
            });
            this.eventManager.u(this.bar, "blur", function() {
                e.h && (e.h = !1, e.o = !1, e.onChangeEnd());
            });
            this.eventManager.u(this.bar, "contextmenu", function(f) {
                f.preventDefault();
                f.stopPropagation();
            });
        }
        oa(cI, IH);
        p = cI.prototype;
        p.release = function() {
            this.H && (this.H.stop(), this.H = null);
            IH.prototype.release.call(this);
        };
        p.setRange = function(a, b) {
            this.bar.min = a;
            this.bar.max = b;
        };
        p.onChangeStart = function() {};
        p.onChange = function() {};
        p.onChangeEnd = function() {};
        p.changeTo = function(a) {
            this.h || (this.h = !0, this.onChangeStart());
            var b = parseFloat(this.bar.min), c = parseFloat(this.bar.max);
            this.bar.value = a > c ? c : a < b ? b : a;
            this.onChange();
            this.H.Z(.5);
        };
        p.getValue = function() {
            return parseFloat(this.bar.value);
        };
        p.setValue = function(a) {
            this.h || (this.bar.value = a);
        };
        function fI(a, b) {
            var c = a.bar.getBoundingClientRect(), d = parseFloat(a.bar.min), e = parseFloat(a.bar.max);
            a = parseFloat(a.bar.step) || 1;
            var f = c.left + 6;
            c = c.right - 6;
            b = d + (Math.max(f, Math.min(c, b)) - f) / (c - f) * (e - d);
            b = Math.round((b - d) / a) * a + d;
            return b = Math.min(e, Math.max(d, b));
        }
        function dI(a, b) {
            a.bar.value = fI(a, b.clientX);
        }
        function eI(a, b) {
            b.preventDefault();
            a.bar.value = fI(a, b.changedTouches[0].clientX);
        }
        O("shaka.ui.RangeElement", cI);
        cI.prototype.setValue = cI.prototype.setValue;
        cI.prototype.getValue = cI.prototype.getValue;
        cI.prototype.changeTo = cI.prototype.changeTo;
        cI.prototype.onChangeEnd = cI.prototype.onChangeEnd;
        cI.prototype.onChange = cI.prototype.onChange;
        cI.prototype.onChangeStart = cI.prototype.onChangeStart;
        cI.prototype.setRange = cI.prototype.setRange;
        function gI(a, b) {
            cI.call(this, a, b, [
                "shaka-seek-bar-container"
            ], [
                "shaka-seek-bar",
                "shaka-no-propagation",
                "shaka-show-controls-on-mouse-over"
            ]);
            var c = this;
            this.G = U("div");
            this.G.classList.add("shaka-ad-markers");
            this.container.insertBefore(this.G, this.container.childNodes[0]);
            this.J = this.controls.g;
            this.D = new Uf(function() {
                var d = c.getValue();
                c.player.U() || d == c.video.duration && (d -= .001);
                c.video.currentTime = d;
            });
            this.F = new Uf(function() {
                hI(c);
            });
            this.O = !1;
            this.i = U("div");
            this.i.id = "shaka-player-ui-thumbnail-container";
            this.g = U("img");
            this.g.id = "shaka-player-ui-thumbnail-image";
            this.g.draggable = !1;
            this.L = U("div");
            this.L.id = "shaka-player-ui-thumbnail-time-container";
            this.I = U("div");
            this.I.id = "shaka-player-ui-thumbnail-time";
            this.L.appendChild(this.I);
            this.i.appendChild(this.g);
            this.i.appendChild(this.L);
            this.container.appendChild(this.i);
            this.j = U("div");
            this.j.id = "shaka-player-ui-time-container";
            this.container.appendChild(this.j);
            this.l = this.A = null;
            this.K = !1;
            this.C = new Uf(function() {
                iI(c);
            });
            this.m = [];
            this.eventManager.u(this.bar, "input", function() {
                c.controls.Sc();
            });
            this.eventManager.u(this.localization, "locale-updated", function() {
                return jI(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                return jI(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                kI(c) || OH(c.container, !1);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                kI(c) && OH(c.container, !0);
            });
            this.eventManager.u(this.adManager, "ad-cue-points-changed", function(d) {
                c.m = d.cuepoints;
                lI(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                c.m = [];
                lI(c);
                c.l && (c.l.abort(), c.l = null);
                c.A = null;
                iI(c);
                mI(c);
            });
            this.eventManager.u(this.bar, "mousemove", function(d) {
                if (c.controls.Jc()) mI(c), iI(c);
                else {
                    var e = fI(c, d.clientX), f = c.bar.getBoundingClientRect();
                    d = Math.max(0, d.clientX - f.left);
                    c.player.rh().length ? (mI(c), nI(c, d, e)) : (iI(c), oI(c, d, e));
                }
            });
            this.eventManager.u(this.container, "mouseleave", function() {
                mI(c);
                c.C.stop();
                c.C.Z(.25);
            });
            this.setValue(this.video.currentTime);
            this.update();
            jI(this);
            this.ad && OH(this.container, !1);
        }
        oa(gI, cI);
        p = gI.prototype;
        p.release = function() {
            this.D && (this.D.stop(), this.D = null, this.F.stop(), this.F = null);
            cI.prototype.release.call(this);
        };
        p.onChangeStart = function() {
            this.O = !this.video.paused;
            this.controls.li(!0);
            this.video.pause();
            this.C.stop();
            this.K = !0;
        };
        p.onChange = function() {
            if (this.video.duration) {
                if (this.update(), this.D.Z(.125), this.player.rh().length && !this.controls.Jc()) {
                    var a = parseFloat(this.bar.min), b = parseFloat(this.bar.max), c = this.bar.getBoundingClientRect(), d = Math.round(this.getValue());
                    nI(this, (d - a) / ((b - a) / c.width), d);
                } else iI(this);
            }
        };
        p.onChangeEnd = function() {
            this.D.La();
            this.controls.li(!1);
            this.O && this.video.play();
            this.K && (this.K = !1, this.C.stop(), this.C.Z(.25));
        };
        p.isShowing = function() {
            return !this.container.classList.contains("shaka-hidden");
        };
        p.update = function() {
            var a = this.J.seekBarColors, b = this.getValue(), c = this.video.buffered.length, d = c ? this.video.buffered.start(0) : 0, e = c ? this.video.buffered.end(c - 1) : 0;
            c = this.player.wa();
            var f = c.end - c.start;
            this.setRange(c.start, c.end);
            kI(this) ? (OH(this.container, !0), d = (Math.max(d, c.start) - c.start) / f || 0, e = (Math.min(e, c.end) - c.start) / f || 0, b = (Math.min(Math.max(b, c.start), c.end) - c.start) / f || 0, this.container.style.background = "linear-gradient(" + [
                "to right",
                (this.J.showUnbufferedStart ? a.base : a.played) + " " + d * 100 + "%",
                a.played + " " + d * 100 + "%",
                a.played + " " + b * 100 + "%",
                a.buffered + " " + b * 100 + "%",
                a.buffered + " " + e * 100 + "%",
                a.base + " " + e * 100 + "%"
            ].join() + ")") : OH(this.container, !1);
        };
        function hI(a) {
            if (a.m.length) {
                for(var b = a.player.wa(), c = b.end - b.start, d = [
                    "to right"
                ], e = [], f = a.J.seekBarColors.adBreaks, g = !1, h = u(a.m), k = h.next(); !k.done; k = h.next())if (k = k.value, k.start == -1 && !k.end) g = !0;
                else if (!k.end && k.start >= b.start || typeof k.end == "number" && k.end > b.start) {
                    var l = (Math.max(k.start, b.start) - b.start) / c || 0, m = l + .01;
                    k.end && (m = (k.end - b.start) / c || 0);
                    e.push({
                        start: l,
                        end: m
                    });
                }
                e = e.sort(function(n, q) {
                    return n.start - q.start;
                });
                b = u(e);
                for(c = b.next(); !c.done; c = b.next())c = c.value, d.push("transparent " + c.start * 100 + "%"), d.push(f + " " + c.start * 100 + "%"), d.push(f + " " + c.end * 100 + "%"), d.push("transparent " + c.end * 100 + "%");
                g && (d.push("transparent 99%"), d.push(f + " 99%"));
                a.G.style.background = "linear-gradient(" + d.join(",") + ")";
            } else a.G.style.background = "transparent", a.F.stop();
        }
        function lI(a) {
            function b() {
                hI(a);
                var c = a.player.wa();
                c = c.end - c.start;
                a.player.U() && c > 5 && a.F.xa(.25);
            }
            b();
            a.player.Gh() || a.eventManager.ra(a.player, "loaded", b);
        }
        function kI(a) {
            var b = a.player.wa();
            b = b.end - b.start;
            return a.player.U() && (b < 5 || !isFinite(b)) ? !1 : a.ad == null || !a.ad.isLinear();
        }
        function jI(a) {
            a.bar.ariaLabel = a.localization.resolve("SEEK");
        }
        function oI(a, b, c) {
            var d = a.j.clientWidth;
            a.j.style.width = "auto";
            a.j.style.height = "20px";
            a.j.style.top = "-30px";
            a.j.style.left = Math.min(a.bar.offsetWidth - d, Math.max(0, b - d / 2)) + "px";
            a.j.style.right = "";
            a.j.style.visibility = "visible";
            b = a.player.wa();
            a.player.U() ? (c = b.end - c, c < 1 ? (a.j.textContent = a.localization.resolve("LIVE"), a.j.style.left = "", a.j.style.right = "0px") : a.j.textContent = "-" + PH(c, c >= 3600)) : (c -= b.start, a.j.textContent = PH(c, c >= 3600));
        }
        function nI(a, b, c) {
            var d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A;
            H(function(E) {
                switch(E.h){
                    case 1:
                        c < 0 && (c = 0);
                        d = !1;
                        a.m.length && (d = a.m.some(function(C) {
                            return C.end ? c >= C.start && c <= C.end : !1;
                        }));
                        if (d) return iI(a), oI(a, b, c), E.return();
                        e = a.player.wa();
                        f = Math.max(Math.ceil(e.start), Math.min(Math.floor(e.end), c));
                        a.player.U() ? (g = e.end - c, a.I.textContent = g < 1 ? a.localization.resolve("LIVE") : "-" + PH(g, g >= 3600)) : a.I.textContent = PH(c, c >= 3600);
                        h = -10;
                        k = a.i.clientWidth;
                        l = Math.floor(k * 9 / 16);
                        a.i.style.height = l + "px";
                        a.i.style.top = -(l - h) + "px";
                        m = Math.min(a.bar.offsetWidth - k, Math.max(0, b - k / 2));
                        a.i.style.left = m + "px";
                        return E.g(a.player.dj(null, f), 2);
                    case 2:
                        n = E.i;
                        if (!n || !n.uris || !n.uris.length) return iI(a), oI(a, b, c), E.return();
                        n.width < n.height ? a.i.classList.add("portrait-thumbnail") : a.i.classList.remove("portrait-thumbnail");
                        a.i.style.visibility = "visible";
                        q = n.uris[0].split("#xywh=")[0];
                        if (a.A && q === a.A.uris[0].split("#xywh=")[0] && n.startByte == a.A.startByte && n.endByte == a.A.endByte) {
                            E.B(3);
                            break;
                        }
                        a.A = n;
                        a.l && (a.l.abort(), a.l = null);
                        if (n.codecs != "mjpg" && !q.startsWith("offline:")) {
                            E.B(4);
                            break;
                        }
                        a.g.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>';
                        E.m(5);
                        r = sh;
                        t = jn(n.uris, n.startByte, n.endByte, a.player.getConfiguration().streaming.retryParameters);
                        a.l = a.player.Qb().request(r, t, {
                            type: 1
                        });
                        return E.g(a.l.promise, 7);
                    case 7:
                        v = E.i;
                        a.l = null;
                        n.codecs == "mjpg" ? (w = (new Bh).box("mdat", Lh(function(C) {
                            q = URL.createObjectURL(new Blob([
                                C
                            ], {
                                type: "image/jpeg"
                            }));
                        }, !0)), w.parse(v.data, !1)) : (x = n.mimeType || "image/jpeg", y = new Blob([
                            v.data
                        ], {
                            type: x
                        }), q = URL.createObjectURL(y));
                        E.o(4);
                        break;
                    case 5:
                        z = E.l();
                        if (z.code == 7001) return E.return();
                        throw z;
                    case 4:
                        try {
                            a.i.removeChild(a.g);
                        } catch (C) {}
                        a.g = U("img");
                        a.g.id = "shaka-player-ui-thumbnail-image";
                        a.g.draggable = !1;
                        a.g.src = q;
                        a.g.onload = function() {
                            q.startsWith("blob:") && URL.revokeObjectURL(q);
                        };
                        a.i.insertBefore(a.g, a.i.firstChild);
                    case 3:
                        A = k / n.width, n.imageHeight ? a.g.height = n.imageHeight : n.sprite || (a.g.style.height = "100%", a.g.style.objectFit = "contain"), n.imageWidth ? a.g.width = n.imageWidth : n.sprite || (a.g.style.width = "100%", a.g.style.objectFit = "contain"), a.g.style.left = "-" + A * n.positionX + "px", a.g.style.top = "-" + A * n.positionY + "px", a.g.style.transform = "scale(" + A + ")", a.g.style.transformOrigin = "left top", l = Math.floor(k * n.height / n.width), a.i.style.height = l + "px", a.i.style.top = -(l - h) + "px", E.j();
                }
            });
        }
        function iI(a) {
            a.i.style.visibility = "hidden";
        }
        function mI(a) {
            a.j.style.visibility = "hidden";
        }
        O("shaka.ui.SeekBar", gI);
        function pI() {}
        pI.prototype.create = function(a, b) {
            return new gI(a, b);
        };
        gI.Factory = pI;
        function qI(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = U("div");
            this.j.classList.add("shaka-skip-ad-container");
            this.parent.appendChild(this.j);
            this.h = U("div");
            this.h.classList.add("shaka-skip-ad-counter");
            OH(this.h, !1);
            this.j.appendChild(this.h);
            this.g = ck();
            this.g.classList.add("shaka-skip-ad-button");
            this.g.disabled = !0;
            OH(this.g, !1);
            this.g.classList.add("shaka-no-propagation");
            this.j.appendChild(this.g);
            rI(this);
            this.i = new Uf(function() {
                if (c.ad.isSkippable()) {
                    var d = Math.round(c.ad.getTimeUntilSkippable());
                    d > 0 ? c.h.textContent = d : (c.i.stop(), OH(c.h, !1));
                } else sI(c);
            });
            this.eventManager.u(this.localization, "locale-updated", function() {
                rI(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                rI(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                tI(c);
            });
            this.eventManager.u(this.adManager, "ad-skip-state-changed", function() {
                c.ad.isSkippable() ? c.ad.canSkipNow() && (c.g.disabled = !1, c.i.stop(), OH(c.h, !1)) : sI(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                sI(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.ad.skip();
            });
            this.ad && tI(this);
        }
        oa(qI, IH);
        qI.prototype.release = function() {
            this.i.stop();
            this.i = null;
            IH.prototype.release.call(this);
        };
        function rI(a) {
            a.g.textContent = a.localization.resolve("SKIP_AD");
        }
        function tI(a) {
            a.ad.isSkippable() && a.ad.needsSkipUI() && (OH(a.g, !0), OH(a.h, !0), a.h.textContent = "", a.i.La(), a.i.xa(.5));
        }
        function sI(a) {
            a.i.stop();
            a.g.disabled = !0;
            OH(a.g, !1);
            OH(a.h, !1);
        }
        O("shaka.ui.SkipAdButton", qI); /*
 @license
 glMatrix: https://github.com/toji/gl-matrix/
 Copyright 2015-2021, Brandon Jones, Colin MacKenzie IV
 SPDX-License-Identifier: MIT
*/ 
        function uI() {
            var a = new Float32Array(16);
            a[0] = 1;
            a[5] = 1;
            a[10] = 1;
            a[15] = 1;
            return a;
        }
        function vI(a, b, c) {
            b = 1 / Math.tan(b / 2);
            a[0] = b / c;
            a[1] = 0;
            a[2] = 0;
            a[3] = 0;
            a[4] = 0;
            a[5] = b;
            a[6] = 0;
            a[7] = 0;
            a[8] = 0;
            a[9] = 0;
            a[11] = -1;
            a[12] = 0;
            a[13] = 0;
            a[15] = 0;
            c = 1 / -99.9;
            a[10] = 100.1 * c;
            a[14] = 20 * c;
        }
        function wI(a, b, c) {
            var d = b[0], e = b[1], f = b[2], g = b[3], h = b[4], k = b[5], l = b[6], m = b[7], n = b[8], q = b[9], r = b[10], t = b[11], v = b[12], w = b[13], x = b[14];
            b = b[15];
            var y = c[0], z = c[1], A = c[2], E = c[3];
            a[0] = y * d + z * h + A * n + E * v;
            a[1] = y * e + z * k + A * q + E * w;
            a[2] = y * f + z * l + A * r + E * x;
            a[3] = y * g + z * m + A * t + E * b;
            y = c[4];
            z = c[5];
            A = c[6];
            E = c[7];
            a[4] = y * d + z * h + A * n + E * v;
            a[5] = y * e + z * k + A * q + E * w;
            a[6] = y * f + z * l + A * r + E * x;
            a[7] = y * g + z * m + A * t + E * b;
            y = c[8];
            z = c[9];
            A = c[10];
            E = c[11];
            a[8] = y * d + z * h + A * n + E * v;
            a[9] = y * e + z * k + A * q + E * w;
            a[10] = y * f + z * l + A * r + E * x;
            a[11] = y * g + z * m + A * t + E * b;
            y = c[12];
            z = c[13];
            A = c[14];
            E = c[15];
            a[12] = y * d + z * h + A * n + E * v;
            a[13] = y * e + z * k + A * q + E * w;
            a[14] = y * f + z * l + A * r + E * x;
            a[15] = y * g + z * m + A * t + E * b;
        }
        function xI(a, b) {
            var c = new Float32Array(3), d = b[0], e = b[1], f = b[2], g = b[4], h = b[5], k = b[6], l = b[8], m = b[9], n = b[10];
            c[0] = Math.sqrt(d * d + e * e + f * f);
            c[1] = Math.sqrt(g * g + h * h + k * k);
            c[2] = Math.sqrt(l * l + m * m + n * n);
            k = 1 / c[0];
            l = 1 / c[1];
            m = 1 / c[2];
            g = b[0] * k;
            c = b[1] * l;
            d = b[2] * m;
            e = b[4] * k;
            h = b[5] * l;
            f = b[6] * m;
            k *= b[8];
            l *= b[9];
            b = b[10] * m;
            m = g + h + b;
            m > 0 ? (b = Math.sqrt(m + 1) * 2, a[3] = .25 * b, a[0] = (f - l) / b, a[1] = (k - d) / b, a[2] = (c - e) / b) : g > h && g > b ? (b = Math.sqrt(1 + g - h - b) * 2, a[3] = (f - l) / b, a[0] = .25 * b, a[1] = (c + e) / b, a[2] = (k + d) / b) : h > b ? (b = Math.sqrt(1 + h - g - b) * 2, a[3] = (k - d) / b, a[0] = (c + e) / b, a[1] = .25 * b, a[2] = (f + l) / b) : (b = Math.sqrt(1 + b - g - h) * 2, a[3] = (c - e) / b, a[0] = (k + d) / b, a[1] = (f + l) / b, a[2] = .25 * b);
        }
        function yI(a, b) {
            var c = b[0], d = b[1], e = b[2];
            b = b[3];
            var f = c + c, g = d + d, h = e + e;
            c *= f;
            var k = d * f;
            d *= g;
            var l = e * f, m = e * g;
            e *= h;
            f *= b;
            g *= b;
            b *= h;
            a[0] = 1 - d - e;
            a[1] = k + b;
            a[2] = l - g;
            a[3] = 0;
            a[4] = k - b;
            a[5] = 1 - c - e;
            a[6] = m + f;
            a[7] = 0;
            a[8] = l + g;
            a[9] = m - f;
            a[10] = 1 - c - d;
            a[11] = 0;
            a[12] = 0;
            a[13] = 0;
            a[14] = 0;
            a[15] = 1;
        }
        function zI() {
            var a = new Float32Array(4);
            a[3] = 1;
            return a;
        }
        function AI(a, b) {
            var c = b[0], d = b[1], e = b[2];
            b = b[3];
            var f = c * c + d * d + e * e + b * b;
            f > 0 && (f = 1 / Math.sqrt(f));
            a[0] = c * f;
            a[1] = d * f;
            a[2] = e * f;
            a[3] = b * f;
        }
        function BI(a) {
            var b = [], c = [], d = [], e = Math.PI;
            a = (a === void 0 ? 0 : a) ? e / 2 : e;
            for(var f = 0; f <= 100; f++){
                var g = f * e / 100, h = Math.sin(g);
                g = Math.cos(g);
                for(var k = 0; k <= 100; k++){
                    var l = k * 2 * a / 100;
                    b.push(Math.sin(l) * h, g, Math.cos(l) * h);
                    c.push(k / 100, f / 100);
                }
            }
            for(e = 0; e < 100; e++)for(a = 0; a < 100; a++)f = e * 101 + a, h = f + 100 + 1, d.push(f, h, f + 1), d.push(h, h + 1, f + 1);
            return {
                ik: b,
                dk: c,
                indices: d
            };
        }
        function CI(a, b, c, d, e) {
            this.i = a;
            this.ua = b;
            this.o = c;
            this.g = d;
            this.A = new fd;
            this.M = zI();
            this.h = zI();
            this.ba = this.na = this.$ = this.l = null;
            this.F = uI();
            this.J = uI();
            this.O = uI();
            this.W = uI();
            this.D = null;
            this.P = !1;
            this.K = this.C = null;
            this.va = this.ya = 0;
            this.X = this.R = this.S = this.L = null;
            this.I = this.H = 0;
            this.j = 75;
            this.V = 0;
            this.m = e;
            this.G = -1;
            DI(this);
        }
        CI.prototype.release = function() {
            this.G != -1 && (this.i.cancelVideoFrameCallback(this.G), this.G = -1);
            this.A && (this.A.release(), this.A = null);
            this.C && (this.C.stop(), this.C = null);
            this.K && (this.K.stop(), this.K = null);
        };
        CI.prototype.Yd = function() {
            (this.P = !this.P) || this.g.viewport(0, 0, this.o.width, this.o.height);
            EI(this, !1);
        };
        function DI(a) {
            FI(a);
            GI(a);
            HI(a);
            II(a);
            JI(a);
            em(a.i, HTMLMediaElement.HAVE_CURRENT_DATA, a.A, function() {
                a.i.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA && EI(a);
                if ("requestVideoFrameCallback" in a.i) {
                    var b = function() {
                        a.G != -1 && (EI(a), a.G != -1 && (a.G = a.i.requestVideoFrameCallback(b)));
                    };
                    a.G = a.i.requestVideoFrameCallback(b);
                } else {
                    var c;
                    a.A.u(a.i, "canplaythrough", function() {
                        EI(a);
                    });
                    a.A.u(a.i, "playing", function() {
                        a.C && a.C.stop();
                        if (!c) {
                            var d = a.ua.Ib();
                            d = u(d);
                            for(var e = d.next(); !e.done; e = d.next())(e = e.value.frameRate) && (!c || c < e) && (c = e);
                        }
                        c || (c = 60);
                        EI(a);
                        a.C = new Uf(function() {
                            EI(a);
                        }).La().xa(1 / c);
                    });
                    a.A.u(a.i, "pause", function() {
                        a.C && a.C.stop();
                        a.C = null;
                        EI(a);
                    });
                    a.A.u(a.i, "seeked", function() {
                        EI(a);
                    });
                    a.A.u(document, "visibilitychange", function() {
                        EI(a);
                    });
                }
            });
        }
        function FI(a) {
            var b = a.F, c = [
                0,
                0,
                0
            ], d = [
                1,
                0,
                0
            ], e = [
                0,
                1,
                0
            ], f = c[0], g = c[1];
            c = c[2];
            var h = e[0];
            var k = e[1];
            var l = e[2];
            var m = d[0];
            e = d[1];
            var n = d[2];
            if (Math.abs(f - m) < 1E-6 && Math.abs(g - e) < 1E-6 && Math.abs(c - n) < 1E-6) for(f = 0; f < 16; f++)b[f] = f % 5 == 0 ? 1 : 0;
            else {
                d = f - m;
                e = g - e;
                m = c - n;
                var q = 1 / Math.sqrt(d * d + e * e + m * m);
                d *= q;
                e *= q;
                m *= q;
                n = k * m - l * e;
                l = l * d - h * m;
                h = h * e - k * d;
                (q = Math.sqrt(n * n + l * l + h * h)) ? (q = 1 / q, n *= q, l *= q, h *= q) : h = l = n = 0;
                k = e * h - m * l;
                var r = m * n - d * h;
                var t = d * l - e * n;
                (q = Math.sqrt(k * k + r * r + t * t)) ? (q = 1 / q, k *= q, r *= q, t *= q) : t = r = k = 0;
                b[0] = n;
                b[1] = k;
                b[2] = d;
                b[3] = 0;
                b[4] = l;
                b[5] = r;
                b[6] = e;
                b[7] = 0;
                b[8] = h;
                b[9] = t;
                b[10] = m;
                b[11] = 0;
                b[12] = -(n * f + l * g + h * c);
                b[13] = -(k * f + r * g + t * c);
                b[14] = -(d * f + e * g + m * c);
                b[15] = 1;
            }
            xI(a.M, a.F);
            a = b = a.W;
            c = [
                4,
                4,
                4
            ];
            f = c[0];
            g = c[1];
            c = c[2];
            b[0] = a[0] * f;
            b[1] = a[1] * f;
            b[2] = a[2] * f;
            b[3] = a[3] * f;
            b[4] = a[4] * g;
            b[5] = a[5] * g;
            b[6] = a[6] * g;
            b[7] = a[7] * g;
            b[8] = a[8] * c;
            b[9] = a[9] * c;
            b[10] = a[10] * c;
            b[11] = a[11] * c;
            b[12] = a[12];
            b[13] = a[13];
            b[14] = a[14];
            b[15] = a[15];
        }
        function GI(a) {
            KI(a);
            a.g.viewport(0, 0, a.g.drawingBufferWidth, a.g.drawingBufferHeight);
            a.g.clearColor(0, 0, 0, 1);
            a.g.enable(a.g.CULL_FACE);
            a.g.cullFace(a.g.FRONT);
            a.g.clear(a.g.COLOR_BUFFER_BIT);
        }
        function HI(a) {
            var b = LI(a, a.g.VERTEX_SHADER), c = LI(a, a.g.FRAGMENT_SHADER);
            a.l = a.g.createProgram();
            a.g.attachShader(a.l, b);
            a.g.attachShader(a.l, c);
            a.g.linkProgram(a.l);
            a.m == "cubemap" ? (a.S = a.g.getAttribLocation(a.l, "aVertexPosition"), a.R = a.g.getAttribLocation(a.l, "aTextureCoord")) : (a.S = a.g.getAttribLocation(a.l, "a_vPosition"), a.g.enableVertexAttribArray(a.S), a.R = a.g.getAttribLocation(a.l, "a_TexCoordinate"), a.g.enableVertexAttribArray(a.R));
        }
        function LI(a, b) {
            switch(b){
                case a.g.VERTEX_SHADER:
                    var c = a.m == "cubemap" ? "attribute vec4 aVertexPosition;\nattribute vec2 aTextureCoord;\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nvarying highp vec2 vTextureCoord;\nvarying highp vec3 vLighting;\nvoid main(void) {\n  gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;\n  vTextureCoord = aTextureCoord;\n}" : "attribute vec4 a_vPosition;\n// Per-vertex texture coordinate info\nattribute vec2 a_TexCoordinate;\nuniform mat4 u_VPMatrix;\n// Passed into the fragment shader.\nvarying vec2 v_TexCoordinate;\nvarying vec3 pass_position;\nvoid main()\n{\n gl_Position = u_VPMatrix * a_vPosition;\n // Pass through texture coord\n v_TexCoordinate = a_TexCoordinate;\n pass_position = a_vPosition.xyz;\n}";
                    break;
                case a.g.FRAGMENT_SHADER:
                    c = a.m == "cubemap" ? "varying highp vec2 vTextureCoord;\nuniform sampler2D uSampler;\nvoid main(void) {\n  highp vec4 texelColor = texture2D(uSampler, vTextureCoord);\n  gl_FragColor = vec4(texelColor.rgb , texelColor.a);\n}" : "precision highp float;\n#define PI 3.141592653589793238462643383279\nvarying vec2 v_TexCoordinate;\nvarying vec3 pass_position;\nuniform sampler2D uSampler;\nvoid main(void) {\nhighp float xValue =\n      (PI + atan(pass_position.z, pass_position.x)) / (2.0 * PI);\n vec2 tc = vec2(xValue, v_TexCoordinate.t);\n tc = vec2(tc.x , tc.y);\nhighp vec4 texelColor =\n      texture2D(uSampler, tc);\n  gl_FragColor = vec4(texelColor.rgb, texelColor.a);\n}";
                    break;
                default:
                    return null;
            }
            b = a.g.createShader(b);
            a.g.shaderSource(b, c);
            a.g.compileShader(b);
            return b;
        }
        function II(a) {
            a.L = a.m == "cubemap" ? {
                ik: [
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ],
                dk: [
                    2 / 3,
                    .5,
                    1 / 3,
                    .5,
                    1 / 3,
                    0,
                    2 / 3,
                    0,
                    2 / 3,
                    .5,
                    2 / 3,
                    0,
                    1,
                    0,
                    1,
                    .5,
                    1,
                    1,
                    2 / 3,
                    1,
                    2 / 3,
                    .5,
                    1,
                    .5,
                    0,
                    .5,
                    0,
                    0,
                    1 / 3,
                    0,
                    1 / 3,
                    .5,
                    0,
                    .5,
                    1 / 3,
                    .5,
                    1 / 3,
                    1,
                    0,
                    1,
                    1 / 3,
                    1,
                    1 / 3,
                    .5,
                    2 / 3,
                    .5,
                    2 / 3,
                    1
                ],
                indices: [
                    0,
                    1,
                    2,
                    0,
                    2,
                    3,
                    4,
                    5,
                    6,
                    4,
                    6,
                    7,
                    8,
                    9,
                    10,
                    8,
                    10,
                    11,
                    12,
                    13,
                    14,
                    12,
                    14,
                    15,
                    16,
                    17,
                    18,
                    16,
                    18,
                    19,
                    20,
                    21,
                    22,
                    20,
                    22,
                    23
                ]
            } : a.m == "halfequirectangular" ? BI(!0) : BI();
            a.$ = a.g.createBuffer();
            a.g.bindBuffer(a.g.ARRAY_BUFFER, a.$);
            a.g.bufferData(a.g.ARRAY_BUFFER, new Float32Array(a.L.ik), a.g.STATIC_DRAW);
            a.na = a.g.createBuffer();
            a.g.bindBuffer(a.g.ARRAY_BUFFER, a.na);
            a.g.bufferData(a.g.ARRAY_BUFFER, new Float32Array(a.L.dk), a.g.STATIC_DRAW);
            a.ba = a.g.createBuffer();
            a.g.bindBuffer(a.g.ELEMENT_ARRAY_BUFFER, a.ba);
            a.g.bufferData(a.g.ELEMENT_ARRAY_BUFFER, new Uint16Array(a.L.indices), a.g.STATIC_DRAW);
        }
        function JI(a) {
            a.X = a.g.createTexture();
            a.g.bindTexture(a.g.TEXTURE_2D, a.X);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_WRAP_S, a.g.CLAMP_TO_EDGE);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_WRAP_T, a.g.CLAMP_TO_EDGE);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_MIN_FILTER, a.g.NEAREST);
            a.g.texParameteri(a.g.TEXTURE_2D, a.g.TEXTURE_MAG_FILTER, a.g.NEAREST);
        }
        function EI(a, b) {
            b = b === void 0 ? !0 : b;
            var c = a.ua.xc() == ms;
            if (!(!a.i || a.i.readyState < 2 || !c && a.i.playbackRate == 0)) {
                vI(a.J, a.j * Math.PI / 180, 1.5625);
                a.m == "cubemap" ? vI(a.J, a.j * Math.PI / 180, 2.5) : vI(a.J, a.j * Math.PI / 180, 1.5625);
                a.g.useProgram(a.l);
                a.g.clear(a.g.COLOR_BUFFER_BIT);
                KI(a);
                b && (a.g.activeTexture(a.g.TEXTURE0), a.g.bindTexture(a.g.TEXTURE_2D, a.X), a.g.pixelStorei(a.g.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0), a.g.texImage2D(a.g.TEXTURE_2D, 0, a.g.RGBA, a.g.RGBA, a.g.UNSIGNED_BYTE, a.i));
                if (a.m == "equirectangular" || a.m == "halfequirectangular") wI(a.O, a.F, a.W), wI(a.O, a.J, a.O);
                a.g.bindBuffer(a.g.ARRAY_BUFFER, a.$);
                a.g.vertexAttribPointer(a.S, 3, a.g.FLOAT, !1, 0, 0);
                a.g.enableVertexAttribArray(a.S);
                a.g.bindBuffer(a.g.ARRAY_BUFFER, a.na);
                a.g.vertexAttribPointer(a.R, 2, a.g.FLOAT, !1, 0, 0);
                a.g.enableVertexAttribArray(a.R);
                a.g.bindBuffer(a.g.ELEMENT_ARRAY_BUFFER, a.ba);
                a.m == "cubemap" ? (a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "uProjectionMatrix"), !1, a.J), a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "uModelViewMatrix"), !1, a.O)) : a.g.uniformMatrix4fv(a.g.getUniformLocation(a.l, "u_VPMatrix"), !1, a.O);
                a.g.uniform1i(a.g.getUniformLocation(a.l, "uSampler"), 0);
                a.P && a.g.viewport(0, 0, a.o.width / 2, a.o.height);
                a.g.drawElements(a.g.TRIANGLES, a.L.indices.length, a.g.UNSIGNED_SHORT, 0);
                a.P && (a.g.viewport(a.o.width / 2, 0, a.o.width / 2, a.o.height), a.g.drawElements(a.g.TRIANGLES, a.L.indices.length, a.g.UNSIGNED_SHORT, 0));
            }
        }
        function KI(a) {
            var b = a.i.videoWidth;
            b || (b = a.o.scrollWidth);
            var c = a.i.videoHeight;
            c || (c = a.o.scrollHeight);
            if (a.ya !== b || a.va !== c) {
                a.o.width = b;
                a.o.height = c;
                a.ya = b;
                a.va = c;
                var d = b / c, e = a.J, f = -d, g = 1 / (d - f);
                e[0] = 0 * g;
                e[1] = 0;
                e[2] = 0;
                e[3] = 0;
                e[4] = 0;
                e[5] = 0;
                e[6] = 0;
                e[7] = 0;
                e[8] = (d + f) * g;
                e[9] = 0;
                e[10] = -1;
                e[11] = -1;
                e[12] = 0;
                e[13] = 0;
                e[14] = -0;
                e[15] = 0;
                a.J = e;
                a.g.viewport(0, 0, b, c);
            }
        }
        function MI(a, b, c, d) {
            var e = Infinity, f = 90 * Math.PI / 180;
            a.m == "halfequirectangular" && (e = 90 * Math.PI / 180, f /= 2);
            var g = a.m == "cubemap" ? a.O : a.F;
            a.H += b;
            a.I += c;
            if (a.H < e && a.H > -e) {
                e = Math.sin(b);
                b = Math.cos(b);
                var h = g[0], k = g[1], l = g[2], m = g[3], n = g[8], q = g[9], r = g[10], t = g[11];
                g !== g && (g[4] = g[4], g[5] = g[5], g[6] = g[6], g[7] = g[7], g[12] = g[12], g[13] = g[13], g[14] = g[14], g[15] = g[15]);
                g[0] = h * b - n * e;
                g[1] = k * b - q * e;
                g[2] = l * b - r * e;
                g[3] = m * b - t * e;
                g[8] = h * e + n * b;
                g[9] = k * e + q * b;
                g[10] = l * e + r * b;
                g[11] = m * e + t * b;
            } else a.H -= b;
            a.I < f && a.I > -f ? (f = uI(), e = uI(), b = -1 * c, c = Math.sin(b), b = Math.cos(b), h = e[4], k = e[5], l = e[6], m = e[7], n = e[8], q = e[9], r = e[10], t = e[11], e !== f && (f[0] = e[0], f[1] = e[1], f[2] = e[2], f[3] = e[3], f[12] = e[12], f[13] = e[13], f[14] = e[14], f[15] = e[15]), f[4] = h * b + n * c, f[5] = k * b + q * c, f[6] = l * b + r * c, f[7] = m * b + t * c, f[8] = n * b - h * c, f[9] = q * b - k * c, f[10] = r * b - l * c, f[11] = t * b - m * c, wI(g, f, g)) : a.I -= c;
            c = uI();
            f = uI();
            e = Math.sin(d);
            d = Math.cos(d);
            b = f[0];
            h = f[1];
            k = f[2];
            l = f[3];
            m = f[4];
            n = f[5];
            q = f[6];
            r = f[7];
            f !== c && (c[8] = f[8], c[9] = f[9], c[10] = f[10], c[11] = f[11], c[12] = f[12], c[13] = f[13], c[14] = f[14], c[15] = f[15]);
            c[0] = b * d + m * e;
            c[1] = h * d + n * e;
            c[2] = k * d + q * e;
            c[3] = l * d + r * e;
            c[4] = m * d - b * e;
            c[5] = n * d - h * e;
            c[6] = q * d - k * e;
            c[7] = r * d - l * e;
            wI(g, c, g);
            EI(a, !1);
        }
        function NI(a, b) {
            if (b === void 0 || b) xI(a.h, a.F), a.V = 0, a.D = zI(), a.D[0] = (a.h[0] - a.M[0]) / 20, a.D[1] = (a.h[1] - a.M[1]) / 20, a.D[2] = (a.h[2] - a.M[2]) / 20, a.D[3] = (a.h[3] - a.M[3]) / 20;
            a.h[0] -= a.D[0];
            a.h[1] -= a.D[1];
            a.h[2] -= a.D[2];
            a.h[3] -= a.D[3];
            b = uI();
            AI(a.h, a.h);
            yI(b, a.h);
            a.F = b;
            a.K && (a.K.stop(), a.K = null);
            a.V < 20 ? a.K = new Uf(function() {
                NI(a, !1);
                a.H = 0;
                a.I = 0;
                a.V++;
                EI(a, !1);
            }).Z(.025) : (yI(b, a.M), a.F = b);
        }
        function OI(a, b, c, d, e, f) {
            fb.call(this);
            var g = this;
            this.i = a;
            this.j = b;
            this.G = c;
            this.L = d;
            this.F = e;
            this.H = f;
            this.o = new fd;
            this.h = new fd;
            this.A = PI(this.j);
            this.g = null;
            this.m = !1;
            this.K = this.J = this.I = this.D = this.C = 0;
            this.l = null;
            this.o.u(d, "loading", function() {
                g.g && NI(g.g);
                QI(g);
            });
            this.o.u(d, "spatialvideoinfo", function(h) {
                h = h.detail;
                switch(h.projection){
                    case "rect":
                        g.l = null;
                        break;
                    case "equi":
                        g.l = "equirectangular";
                        break;
                    case "hequ":
                        switch(h.hfov){
                            case 360:
                                g.l = "equirectangular";
                                break;
                            case 180:
                                g.l = "halfequirectangular";
                                break;
                            default:
                                h.hfov == null ? g.l = "halfequirectangular" : g.l = null;
                        }
                        break;
                    case "fish":
                        g.l = "halfequirectangular";
                        break;
                    default:
                        g.l = null;
                }
                QI(g);
            });
            this.o.u(d, "nospatialvideoinfo", function() {
                g.l = null;
                QI(g);
            });
            this.o.u(d, "unloading", function() {
                g.l = null;
                QI(g);
            });
            this.o.u(this.H, "caststatuschanged", function() {
                QI(g);
            });
            QI(this);
        }
        oa(OI, fb);
        p = OI.prototype;
        p.release = function() {
            this.o && (this.o.release(), this.o = null);
            this.h && (this.h.release(), this.h = null);
            this.g && (this.g.release(), this.g = null);
            fb.prototype.release.call(this);
        };
        p.configure = function(a) {
            this.F = a;
            QI(this);
        };
        p.Lg = function() {
            return this.j ? !!this.A : !!PI(document.createElement("canvas"));
        };
        p.Sb = function() {
            return !!this.g;
        };
        p.Yd = function() {
            this.g ? this.g.Yd() : Za("Not playing VR content");
        };
        p.Ch = function(a) {
            this.g ? MI(this.g, a * RI, 0, 0) : Za("Not playing VR content");
        };
        p.Ah = function(a) {
            this.g ? MI(this.g, 0, a * RI, 0) : Za("Not playing VR content");
        };
        p.Bh = function(a) {
            this.g ? MI(this.g, 0, 0, a * RI) : Za("Not playing VR content");
        };
        function QI(a) {
            var b = a.H.F.Qa();
            !a.F.displayInVrMode && !a.l || b ? a.j && a.g && (a.j.style.display = "none", a.h.Ta(), a.g.release(), a.g = null, a.dispatchEvent(new R("vrstatuschanged", (new Map).set("newStatus", a.Sb())))) : (a.j || (a.j = document.createElement("canvas"), a.j.classList.add("shaka-vr-canvas-container"), a.G.parentElement.insertBefore(a.j, a.G.nextElementSibling), a.A = PI(a.j)), b = a.l || a.F.defaultVrProjectionMode, a.g) ? a.g.m != b && (a.h.Ta(), a.g.release(), SI(a, b)) : (a.j.style.display = "", SI(a, b), a.dispatchEvent(new R("vrstatuschanged", (new Map).set("newStatus", a.Sb()))));
        }
        function SI(a, b) {
            a.A && a.j && (a.g = new CI(a.G, a.L, a.j, a.A, b), TI(a));
        }
        function PI(a) {
            if (!a || !window1.WebGLRenderingContext) return null;
            for(var b = u([
                "webgl2",
                "webgl"
            ]), c = b.next(); !c.done; c = b.next())if (c = a.getContext(c.value)) return c;
            return null;
        }
        function TI(a) {
            a.h.u(a.i, "mousedown", function(d) {
                if (!a.m) {
                    var e = d.clientX;
                    d = d.clientY;
                    a.m = !0;
                    a.C = e;
                    a.D = d;
                }
            });
            navigator.maxTouchPoints > 0 && a.h.u(a.i, "touchstart", function(d) {
                if (!a.m) {
                    var e = d.touches[0].clientX;
                    d = d.touches[0].clientY;
                    a.m = !0;
                    a.C = e;
                    a.D = d;
                }
            });
            a.h.u(a.i, "wheel", function(d) {
                if (!a.m) {
                    var e = a.g, f = d.deltaY;
                    f /= 50;
                    e.j >= 20 && e.j <= 100 && (e.j += f);
                    e.j < 20 ? e.j = 20 : e.j > 100 && (e.j = 100);
                    EI(e, !1);
                    d.preventDefault();
                    d.stopPropagation();
                }
            });
            a.h.u(a.i, "mousemove", function(d) {
                a.m && UI(a, d.clientX, d.clientY);
            });
            navigator.maxTouchPoints > 0 && a.h.u(a.i, "touchmove", function(d) {
                a.m && UI(a, d.touches[0].clientX, d.touches[0].clientY);
                d.preventDefault();
            });
            a.h.u(a.i, "mouseleave", function() {
                a.m = !1;
            });
            a.h.u(a.i, "mouseup", function() {
                a.m = !1;
            });
            navigator.maxTouchPoints > 0 && a.h.u(a.i, "touchend", function() {
                a.m = !1;
            });
            var b = !1;
            if (window1.DeviceOrientationEvent) {
                if (typeof DeviceMotionEvent.requestPermission == "function") {
                    var c = function() {
                        DeviceMotionEvent.requestPermission().then(function(d) {
                            d !== "granted" || b || (b = !0, VI(a));
                        });
                    };
                    DeviceMotionEvent.requestPermission().then(function(d) {
                        a.h.Fa(a.i, "click", c);
                        a.h.Fa(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.Fa(a.i, "touchend", c);
                        d !== "granted" ? (a.h.ra(a.i, "click", c), a.h.ra(a.i, "mouseup", c), navigator.maxTouchPoints > 0 && a.h.ra(a.i, "touchend", c)) : (b = !0, VI(a));
                    }).catch(function() {
                        a.h.Fa(a.i, "click", c);
                        a.h.Fa(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.Fa(a.i, "touchend", c);
                        a.h.ra(a.i, "click", c);
                        a.h.ra(a.i, "mouseup", c);
                        navigator.maxTouchPoints > 0 && a.h.ra(a.i, "touchend", c);
                    });
                } else b = !0, VI(a);
            }
        }
        function VI(a) {
            a.h.u(window1, "deviceorientation", function(b) {
                if (a.g) {
                    var c = (b.alpha || 0) - a.I, d = (b.beta || 0) - a.J, e = (b.gamma || 0) - a.K;
                    if (Math.abs(c) > 10 || Math.abs(d) > 10 || Math.abs(e) > 5) d = e = c = 0;
                    a.I = b.alpha || 0;
                    a.J = b.beta || 0;
                    a.K = b.gamma || 0;
                    b = screen.orientation.angle;
                    b == 90 || b == -90 ? MI(a.g, c * RI * -1, e * RI * -1, 0) : MI(a.g, c * RI * -1, d * RI, 0);
                }
            });
        }
        function UI(a, b, c) {
            var d = -0.6 * Math.PI / 180;
            MI(a.g, (b - a.C) * d, (c - a.D) * -1 * d, 0);
            a.C = b;
            a.D = c;
        }
        var RI = Math.PI / 180;
        function Y(a, b, c, d, e) {
            fb.call(this);
            var f = this;
            this.X = !0;
            this.g = e;
            this.F = new Cu(c, a, this.g.castReceiverAppId, this.g.castAndroidReceiverCompatible);
            this.va = !0;
            this.C = this.F.Rc();
            this.o = c;
            this.m = this.F.Rb();
            this.$ = a;
            this.l = b;
            this.Kb = d;
            this.ua = this.m.tf();
            this.A = this.j = null;
            this.V = !1;
            this.K = [];
            this.ab = [];
            this.Oa = !1;
            this.L = new Uf(function() {
                f.l.classList.add("no-cursor");
                f.Oa = !1;
                WI(f);
            });
            this.ba = new Uf(function() {
                f.i.removeAttribute("shown");
                XI(f);
                YI(f);
                f.W && f.W.Og();
                f.P.Z(f.g.closeMenusDelay);
            });
            this.P = new Uf(function() {
                for(var g = u(f.K), h = g.next(); !h.done; h = g.next())OH(h.value, !1);
                f.g.enableTooltips && f.H.classList.add("shaka-tooltips-on");
            });
            this.Ga = new Uf(function() {
                f.Ca() && ZI(f);
            });
            this.R = null;
            this.J = [];
            this.ya = $I();
            this.h = new fd;
            this.D = null;
            this.configure(this.g);
            aJ(this);
            bJ(this);
            this.na = new Set;
            cJ(this);
            this.Ga.xa(this.g.refreshTickInSeconds);
            this.h.u(this.ya, "locale-changed", function(g) {
                g = g.locales[0];
                f.ua.setLocale(g);
                f.l.setAttribute("lang", g);
            });
            this.ua.initInterstitial(this.G, this.$, this.o);
            this.h.u(this.m, "texttrackvisibility", function() {
                YI(f);
            });
            this.h.u(this.m, "unloading", function() {
                f.j || (f.Jb() && dJ(f), f.Id() && f.Yc());
            });
        }
        oa(Y, fb);
        p = Y.prototype;
        p.destroy = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return H(function(c) {
                switch(c.h){
                    case 1:
                        if (document.pictureInPictureElement != b.o) {
                            c.B(2);
                            break;
                        }
                        return c.g(document.exitPictureInPicture(), 2);
                    case 2:
                        b.h && (b.h.release(), b.h = null);
                        b.L && (b.L.stop(), b.L = null);
                        b.ba && (b.ba.stop(), b.ba = null);
                        b.P && (b.P.stop(), b.P = null);
                        b.Ga && (b.Ga.stop(), b.Ga = null);
                        b.D && (b.D.release(), b.D = null);
                        eJ(b);
                        b.i && (b.l.removeChild(b.i), b.i = null);
                        if (!b.F) {
                            c.B(4);
                            break;
                        }
                        return c.g(b.F.destroy(a), 5);
                    case 5:
                        b.F = null;
                    case 4:
                        b.M && (b.l.removeChild(b.M), b.M = null);
                        b.G && (b.l.removeChild(b.G), b.G = null);
                        b.I && (b.l.removeChild(b.I), b.I = null);
                        if (!b.$) {
                            c.B(6);
                            break;
                        }
                        return c.g(b.$.destroy(), 7);
                    case 7:
                        b.$ = null;
                    case 6:
                        b.m = null, b.o = null, b.C = null, b.ya = null, b.na.clear(), fJ(b), fb.prototype.release.call(b), c.j();
                }
            });
        };
        function eJ(a) {
            for(var b = u(a.J), c = b.next(); !c.done; c = b.next())c.value.release();
            a.J = [];
        }
        function gJ(a, b) {
            hJ.set(a, b);
        }
        p.qk = function(a) {
            this.va = a;
            cJ(this);
        };
        p.Ml = function() {
            WI(this);
        };
        p.configure = function(a) {
            var b = this;
            this.g = a;
            this.F.Qi(a.castReceiverAppId, a.castAndroidReceiverCompatible);
            this.A && (this.A = null);
            this.Ia && (this.Ia = null);
            this.W && (this.W = null);
            this.D && this.D.configure(a);
            this.i ? (gk(this.i), eJ(this)) : (iJ(this), jJ(this), this.D = new OI(this.i, this.Kb, this.o, this.m, this.g, this));
            this.l.classList.add("shaka-video-container");
            this.o.classList.add("shaka-video");
            kJ(this);
            this.g.addBigPlayButton && lJ(this);
            this.g.customContextMenu && (this.W = new RH(this.H, this), this.J.push(this.W));
            this.M || mJ(this);
            this.g.seekOnTaps && (nJ(this), oJ(this));
            pJ(this);
            this.K = Array.from(this.l.getElementsByClassName("shaka-settings-menu"));
            this.K.push.apply(this.K, G(Array.from(this.l.getElementsByClassName("shaka-overflow-menu"))));
            this.ab = Array.from(this.l.getElementsByClassName("shaka-show-controls-on-mouse-over"));
            WI(this);
            a = u(this.l.getElementsByClassName("shaka-no-propagation"));
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                var d = function(e) {
                    return e.stopPropagation();
                };
                this.h.u(c, "click", d);
                this.h.u(c, "dblclick", d);
                navigator.maxTouchPoints > 0 && this.h.u(c, "touchend", function(e) {
                    b.Ca() && e.stopPropagation();
                });
            }
        };
        p.ji = function(a) {
            (this.X = a) ? (this.l.setAttribute("shaka-controls", "true"), this.o.tabIndex = -1, this.o.controls = !1) : this.l.removeAttribute("shaka-controls");
            WI(this);
        };
        p.Nj = function(a) {
            this.o.controls = a;
            this.o.tabIndex = a ? 0 : -1;
            a && this.ji(!1);
        };
        p.getAd = function() {
            return this.j;
        };
        p.Gk = function() {
            return this.F;
        };
        p.Xk = function() {
            return this.ya;
        };
        p.zl = function() {
            return this.l;
        };
        p.Rc = function() {
            return this.C;
        };
        p.Wk = function() {
            return this.o;
        };
        p.Rb = function() {
            return this.m;
        };
        p.Vk = function() {
            return this.$;
        };
        p.Nk = function() {
            return this.i;
        };
        p.kl = function() {
            return this.I;
        };
        p.Jk = function() {
            return this.G;
        };
        p.Kk = function() {
            return this.g;
        };
        p.Jl = function() {
            return this.V;
        };
        p.li = function(a) {
            (this.V = a) ? this.L.stop() : this.L.Z(3);
        };
        p.El = function() {
            return this.va;
        };
        p.qh = function() {
            return this.A ? this.A.getValue() : this.C.currentTime;
        };
        p.Oj = function(a) {
            this.R = a;
        };
        p.Jc = function() {
            return this.K.some(function(a) {
                return !a.classList.contains("shaka-hidden");
            });
        };
        p.Sc = function() {
            this.P.La();
        };
        function qJ(a) {
            return !document.fullscreenEnabled || a.o.webkitSupportsFullscreen && a.g.preferVideoFullScreenInVisionOS && Xb().Pa() == "APPLE_VR" ? !1 : !0;
        }
        function rJ(a) {
            return "documentPictureInPicture" in window1 && a.g.preferDocumentPictureInPicture;
        }
        p.ue = function() {
            return this.F.Qa() ? !1 : qJ(this) || (!this.j || !this.j.isUsingAnotherMediaElement()) && this.o.webkitSupportsFullscreen ? !0 : !1;
        };
        p.Jb = function() {
            if (qJ(this)) return !!document.fullscreenElement;
            var a = this.o;
            return a.webkitSupportsFullscreen ? a.webkitDisplayingFullscreen : !1;
        };
        function sJ(a) {
            var b, c, d;
            return H(function(e) {
                switch(e.h){
                    case 1:
                        e.m(2);
                        if (!qJ(a)) {
                            b = a.o;
                            b.webkitSupportsFullscreen && b.webkitEnterFullscreen();
                            e.B(4);
                            break;
                        }
                        if (!a.Id()) {
                            e.B(5);
                            break;
                        }
                        return e.g(a.Yc(), 6);
                    case 6:
                        if (!rJ(a)) {
                            e.B(5);
                            break;
                        }
                        return e.g(new Promise(function(f) {
                            new Uf(f).Z(.05);
                        }), 5);
                    case 5:
                        return c = a.g.fullScreenElement, e.g(c.requestFullscreen({
                            navigationUI: "hide"
                        }), 9);
                    case 9:
                        if (!a.g.forceLandscapeOnFullscreen || !screen.orientation) {
                            e.B(4);
                            break;
                        }
                        e.m(11);
                        return e.g(screen.orientation.lock("landscape"), 13);
                    case 13:
                        e.o(4, 2);
                        break;
                    case 11:
                        e.l(2);
                    case 4:
                        e.o(0);
                        break;
                    case 2:
                        d = e.l(), a.dispatchEvent(new R("error", (new Map).set("detail", d))), e.j();
                }
            });
        }
        function dJ(a) {
            var b;
            return H(function(c) {
                if (!qJ(a)) return b = a.o, b.webkitSupportsFullscreen && b.webkitExitFullscreen(), c.B(0);
                screen.orientation && screen.orientation.unlock();
                return c.g(document.exitFullscreen(), 0);
            });
        }
        p.pg = function() {
            var a = this;
            return H(function(b) {
                return a.Jb() ? b.g(dJ(a), 0) : b.g(sJ(a), 0);
            });
        };
        p.Gf = function() {
            return this.F.Qa() ? !1 : document.pictureInPictureEnabled || rJ(this) ? !this.o.disablePictureInPicture : !1;
        };
        p.Id = function() {
            return !!(window1.documentPictureInPicture && window1.documentPictureInPicture.window || document.pictureInPictureElement);
        };
        p.Yc = function() {
            var a = this, b, c;
            return H(function(d) {
                switch(d.h){
                    case 1:
                        d.m(2);
                        if (rJ(a)) {
                            if (!a.Jb()) {
                                d.B(10);
                                break;
                            }
                            return d.g(dJ(a), 10);
                        }
                        return document.pictureInPictureElement ? d.g(document.exitPictureInPicture(), 5) : (a.Jb() && dJ(a), b = a.o, d.g(b.requestPictureInPicture(), 5));
                    case 10:
                        return d.g(tJ(a), 5);
                    case 5:
                        d.o(0);
                        break;
                    case 2:
                        c = d.l(), a.dispatchEvent(new R("error", (new Map).set("detail", c))), d.j();
                }
            });
        };
        function tJ(a) {
            var b, c, d, e, f, g;
            return H(function(h) {
                if (h.h == 1) {
                    if (window1.documentPictureInPicture.window) return window1.documentPictureInPicture.window.close(), h.return();
                    b = a.l;
                    c = b.getBoundingClientRect();
                    return h.g(window1.documentPictureInPicture.requestWindow({
                        width: c.width,
                        height: c.height
                    }), 2);
                }
                d = h.i;
                uJ(d);
                e = b.parentNode || document.body;
                f = a.l.cloneNode(!0);
                f.style.visibility = "hidden";
                f.style.height = getComputedStyle(b).height;
                e.appendChild(f);
                g = document.createElement("style");
                g.append("[data-shaka-player-container] {\n      width: 100% !important; max-height: 100%}");
                d.document.head.append(g);
                d.document.body.append(b);
                a.h.ra(d, "pagehide", function() {
                    f.replaceWith(b);
                });
                h.j();
            });
        }
        function uJ(a) {
            var b = [].concat(G(document.styleSheets)).map(function(d) {
                try {
                    return [].concat(G(d.cssRules)).map(function(f) {
                        return f.cssText;
                    }).join("");
                } catch (f) {
                    var e = document.createElement("link");
                    e.rel = "stylesheet";
                    e.type = d.type;
                    e.media = d.media;
                    e.href = d.href;
                    a.document.head.appendChild(e);
                }
                return "";
            }).filter(Boolean).join("\n"), c = document.createElement("style");
            c.textContent = b;
            a.document.head.appendChild(c);
        }
        p.Uj = function() {
            OH(this.S, !0);
            this.G && this.G.hasChildNodes() && OH(this.G, !0);
            this.I && this.I.hasChildNodes() && OH(this.I, !0);
            this.j.hasCustomClick() ? this.i.setAttribute("ad-active", "true") : this.i.removeAttribute("ad-active");
        };
        p.ej = function() {
            OH(this.S, !1);
            OH(this.G, !1);
            OH(this.I, !1);
            this.i.removeAttribute("ad-active");
        };
        function XH(a) {
            if (a.X) {
                if (a.j && (a.j && a.j.isPaused() ? a.j.play() : a.j && a.j.pause(), a.j.isLinear())) return;
                a.C.duration && (a.C.paused && !a.V ? (a.m.isEnded() && (a.C.currentTime = a.m.wa().start), a.C.play()) : a.C.pause());
            }
        }
        function iJ(a) {
            a.i = U("div");
            a.i.classList.add("shaka-controls-container");
            a.l.appendChild(a.i);
            a.l.setAttribute("shaka-controls", "true");
            a.h.u(a.i, "touchend", function(b) {
                a.C.duration && (a.Ca() ? (a.R = Date.now(), $H(a, !0)) : vJ(a, b), b.cancelable && b.preventDefault());
            });
            a.h.u(a.i, "click", function() {
                $H(a);
            });
            a.h.u(a.i, "dblclick", function() {
                a.g.doubleClickForFullscreen && a.ue() && a.pg();
            });
        }
        function lJ(a) {
            var b = U("div");
            b.classList.add("shaka-play-button-container");
            a.i.appendChild(b);
            a.Ia = new YH(b, a);
            a.J.push(a.Ia);
        }
        function kJ(a) {
            var b = U("div");
            b.classList.add("shaka-scrim-container");
            a.i.appendChild(b);
        }
        function wJ(a) {
            a.S = U("div");
            a.S.classList.add("shaka-ad-controls");
            var b = a.j != null && a.j.isLinear();
            OH(a.S, b);
            a.O.appendChild(a.S);
            b = new qI(a.S, a);
            a.J.push(b);
        }
        function mJ(a) {
            a.M = U("div");
            a.M.classList.add("shaka-spinner-container");
            a.l.appendChild(a.M);
            var b = U("div");
            b.classList.add("shaka-spinner");
            a.M.appendChild(b);
            b.insertAdjacentHTML("beforeend", '<svg focusable="false" stroke="currentColor"\n         viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"\n         width="50px" height="50px" class="q-spinner text-grey-9">\n      <g transform="translate(1 1)" stroke-width="6" fill="none"\n        fill-rule="evenodd">\n        <circle stroke-opacity=".5" cx="18" cy="18" r="16"></circle>\n        <path d="M34 18c0-9.94-8.06-16-16-16">\n          <animateTransform attributeName="transform" type="rotate"\n            from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite">\n          </animateTransform>\n        </path>\n      </g>\n    </svg>');
        }
        function nJ(a) {
            var b = U("div");
            b.classList.add("shaka-hidden-fast-forward-container");
            a.i.appendChild(b);
            a.jb = new aI(b, a);
            a.J.push(a.jb);
        }
        function oJ(a) {
            var b = U("div");
            b.classList.add("shaka-hidden-rewind-container");
            a.i.appendChild(b);
            a.kb = new bI(b, a);
            a.J.push(a.kb);
        }
        function pJ(a) {
            a.O = U("div");
            a.O.classList.add("shaka-bottom-controls");
            a.O.classList.add("shaka-no-propagation");
            a.i.appendChild(a.O);
            a.h.u(a.O, "click", function(e) {
                e.target.closest(".shaka-overflow-button") || a.Sc();
            });
            wJ(a);
            xJ(a);
            a.H = U("div");
            a.H.classList.add("shaka-controls-button-panel");
            a.H.classList.add("shaka-show-controls-on-mouse-over");
            a.g.enableTooltips && a.H.classList.add("shaka-tooltips-on");
            a.O.appendChild(a.H);
            for(var b = u(a.g.controlPanelElements), c = b.next(); !c.done; c = b.next())if (c = c.value, hJ.get(c)) {
                var d = hJ.get(c).create(a.H, a);
                a.J.push(d);
                c == "time_and_duration" && (c = new QH(a.H, a), a.J.push(c));
            } else Za("Unrecognized control panel element requested:", c);
        }
        function xJ(a) {
            if (a.g.addSeekBar) a.A = yJ.create(a.O, a), a.J.push(a.A);
            else {
                for(var b = u(a.K), c = b.next(); !c.done; c = b.next())c.value.classList.add("shaka-low-position");
                a = a.H;
                a.classList.contains("shaka-tooltips-on") && a.classList.add("shaka-tooltips-low-position");
            }
        }
        function jJ(a) {
            a.G = U("div");
            a.G.classList.add("shaka-client-side-ad-container");
            OH(a.G, !1);
            a.h.u(a.G, "click", function() {
                $H(a);
            });
            a.l.appendChild(a.G);
            a.I = U("div");
            a.I.classList.add("shaka-server-side-ad-container");
            OH(a.I, !1);
            a.h.u(a.I, "click", function() {
                $H(a);
            });
            a.l.appendChild(a.I);
        }
        function aJ(a) {
            a.h.u(a.m, "buffering", function() {
                zJ(a);
            });
            zJ(a);
            a.h.u(window1, "keydown", function(b) {
                AJ(a, b);
            });
            a.h.u(window1, "click", function() {
                return a.Sc();
            });
            a.h.u(a, "submenuopen", function() {
                a.Sc();
            });
            a.h.u(a.C, "play", function() {
                WI(a);
            });
            a.h.u(a.C, "pause", function() {
                WI(a);
            });
            a.h.u(a.l, "mousemove", function(b) {
                vJ(a, b);
            });
            a.h.u(a.l, "touchmove", function(b) {
                vJ(a, b);
            }, {
                passive: !0
            });
            a.h.u(a.l, "touchend", function(b) {
                vJ(a, b);
            }, {
                passive: !0
            });
            a.h.u(a.l, "mouseleave", function() {
                a.R || a.L.La();
            });
            a.h.u(a.l, "wheel", function(b) {
                vJ(a, b);
            }, {
                passive: !0
            });
            a.h.u(a.F, "caststatuschanged", function() {
                cJ(a);
            });
            a.h.u(a.D, "vrstatuschanged", function() {
                a.dispatchEvent(new R("vrstatuschanged"));
            });
            BJ(a, a.l, function() {
                return !a.g.enableKeyboardPlaybackControlsInWindow && !a.Jb();
            });
            BJ(a, window1, function() {
                return a.g.enableKeyboardPlaybackControlsInWindow || a.Jb();
            });
            a.h.u(a.ua, "ad-started", function(b) {
                a.j = b.ad;
                a.Uj();
                zJ(a);
            });
            a.h.u(a.ua, "ad-stopped", function() {
                a.j = null;
                a.ej();
                zJ(a);
            });
            screen.orientation && a.h.u(screen.orientation, "change", function() {
                return H(function(b) {
                    return b.g(CJ(a), 0);
                });
            });
        }
        function bJ(a) {
            if (a.g.setupMediaSession && navigator.mediaSession) {
                var b = function(f, g) {
                    try {
                        navigator.mediaSession.setActionHandler(f, function(h) {
                            g(h);
                        });
                    } catch (h) {}
                }, c = function() {
                    if (a.j && a.j.isLinear()) d();
                    else {
                        var f = a.m.wa(), g = f.end - f.start;
                        f = parseFloat((a.C.currentTime - f.start).toFixed(2));
                        a.m.U() && Math.abs(g - f) < 1 && (g = Infinity);
                        try {
                            navigator.mediaSession.setPositionState({
                                duration: Math.max(0, g),
                                playbackRate: a.C.playbackRate,
                                position: Math.max(0, f)
                            });
                        } catch (h) {}
                    }
                }, d = function() {
                    try {
                        navigator.mediaSession.setPositionState();
                    } catch (f) {}
                }, e = function(f) {
                    var g = a.g.keyboardSeekDistance;
                    switch(f.action){
                        case "pause":
                            XH(a);
                            break;
                        case "play":
                            XH(a);
                            break;
                        case "seekbackward":
                            if (f.seekOffset && !isFinite(f.seekOffset)) break;
                            a.j && a.j.isLinear() || DJ(a, a.A.getValue() - (f.seekOffset || g));
                            break;
                        case "seekforward":
                            if (f.seekOffset && !isFinite(f.seekOffset)) break;
                            a.j && a.j.isLinear() || DJ(a, a.A.getValue() + (f.seekOffset || g));
                            break;
                        case "seekto":
                            if (f.seekTime && !isFinite(f.seekTime)) break;
                            a.j && a.j.isLinear() || DJ(a, a.m.wa().start + f.seekTime);
                            break;
                        case "stop":
                            a.m.tc();
                            break;
                        case "enterpictureinpicture":
                            a.j && a.j.isLinear() || a.Yc();
                    }
                };
                b("pause", e);
                b("play", e);
                b("seekbackward", e);
                b("seekforward", e);
                b("seekto", e);
                b("stop", e);
                ("documentPictureInPicture" in window1 || document.pictureInPictureEnabled) && b("enterpictureinpicture", e);
                b = function() {
                    a.m.U() || a.m.wa().start != 0 ? (c(), a.h.u(a.C, "timeupdate", c)) : d();
                };
                a.m.Gh() && b();
                a.h.u(a.m, "loaded", b);
                a.h.u(a.m, "unloading", function() {
                    a.h.Fa(a.C, "timeupdate", c);
                });
                a.h.u(a.m, "metadata", function(f) {
                    if (f = f.payload) {
                        var g;
                        f.key == "TIT2" && f.data && (g = f.data);
                        var h;
                        f.key == "APIC" && f.mimeType == "--\x3e" && (h = f.data);
                        g && (f = {
                            title: g,
                            artwork: []
                        }, navigator.mediaSession.metadata && (f = navigator.mediaSession.metadata, f.title = g), navigator.mediaSession.metadata = new MediaMetadata(f));
                        h && (g = a.o, h != g.poster && (g.poster = h), g = {
                            title: "",
                            artwork: [
                                {
                                    src: h
                                }
                            ]
                        }, navigator.mediaSession.metadata && (g = navigator.mediaSession.metadata, g.artwork = [
                            {
                                src: h
                            }
                        ]), navigator.mediaSession.metadata = new MediaMetadata(g));
                    }
                });
            }
        }
        function fJ(a) {
            if (a.g.setupMediaSession && navigator.mediaSession) {
                try {
                    navigator.mediaSession.setPositionState();
                } catch (b) {}
                a = function(b) {
                    try {
                        navigator.mediaSession.setActionHandler(b, null);
                    } catch (c) {}
                };
                a("pause");
                a("play");
                a("seekbackward");
                a("seekforward");
                a("seekto");
                a("stop");
                a("enterpictureinpicture");
            }
        }
        function CJ(a) {
            return H(function(b) {
                return a.C && a.C.readyState != 0 && !a.F.Qa() && a.g.enableFullscreenOnRotation && a.ue() ? screen.orientation.type.includes("landscape") && !a.Jb() ? b.g(sJ(a), 0) : screen.orientation.type.includes("portrait") && a.Jb() ? b.g(dJ(a), 0) : b.B(0) : b.return();
            });
        }
        function vJ(a, b) {
            b.type == "mousemove" && (a.i.classList.remove("shaka-keyboard-navigation"), WI(a));
            b.type == "touchstart" || b.type == "touchmove" || b.type == "touchend" || b.type == "keyup" ? a.R = Date.now() : a.R + 1E3 < Date.now() && (a.R = null);
            a.R && b.type == "mousemove" || (a.l.classList.remove("no-cursor"), a.Oa = !0, a.P.stop(), a.Ca() || (ZI(a), WI(a)), a.L.stop(), b.type != "touchend" && b.type != "wheel" && b.type != "keyup" && a.R || a.L.Z(3));
        }
        function EJ(a) {
            return window1.matchMedia("hover: hover").matches ? a.ab.some(function(b) {
                return b.matches(":hover");
            }) : !1;
        }
        function YI(a) {
            var b = a.l.getElementsByClassName("shaka-text-container")[0];
            b && (a.Ca() ? b.style.bottom = a.O.clientHeight + "px" : b.style.bottom = "0px");
        }
        function WI(a) {
            var b = a.j ? a.j.isPaused() : !1, c = a.C.paused && !a.V, d = a.i.classList.contains("shaka-keyboard-navigation");
            b || (!a.j || !a.j.isLinear()) && c || a.Oa || d || EJ(a) ? (ZI(a), a.i.getAttribute("shown") == null && (a.i.setAttribute("shown", "true"), XI(a)), YI(a), a.ba.stop()) : a.ba.Z(a.g.fadeDelay);
            a.Jc() && a.H.classList.remove("shaka-tooltips-on");
        }
        function $H(a, b) {
            b = b === void 0 ? !1 : b;
            a.X && !a.Sb() && (a.Jc() ? a.P.La() : a.g.singleClickForPlayAndPause ? XH(a) : b && a.Ca() && a.fj());
        }
        function cJ(a) {
            var b = a.F.Qa();
            a.dispatchEvent(new R("caststatuschanged", (new Map).set("newStatus", b)));
            b ? a.i.getAttribute("casting") == null && (a.i.setAttribute("casting", "true"), XI(a)) : a.i.getAttribute("casting") != null && (a.i.removeAttribute("casting"), XI(a));
        }
        function BJ(a, b, c) {
            a.h.u(b, "keydown", function(d) {
                if (c()) {
                    var e = document.activeElement, f = e && e.classList ? e.classList.contains("shaka-volume-bar") : !1, g = e && e.classList && e.classList.contains("shaka-seek-bar"), h = a.Jb();
                    e = a.i.contains(e);
                    h = h || a.g.enableKeyboardPlaybackControlsInWindow;
                    e && vJ(a, d);
                    if (a.g.enableKeyboardPlaybackControls && a.m.dd()) {
                        var k = a.g.keyboardSeekDistance, l = a.g.keyboardLargeSeekDistance;
                        switch(d.key){
                            case "ArrowLeft":
                                a.A && k > 0 && (g || h) && !f && (d.preventDefault(), DJ(a, a.A.getValue() - k));
                                break;
                            case "ArrowRight":
                                a.A && k > 0 && (g || h) && !f && (d.preventDefault(), DJ(a, a.A.getValue() + k));
                                break;
                            case "PageDown":
                                a.A && l > 0 && (g || h) && (d.preventDefault(), DJ(a, a.A.getValue() - l));
                                break;
                            case "PageUp":
                                a.A && l > 0 && (g || h) && (d.preventDefault(), DJ(a, a.A.getValue() + l));
                                break;
                            case "Home":
                                a.A && DJ(a, a.m.wa().start);
                                break;
                            case "End":
                                a.A && DJ(a, a.m.wa().end);
                                break;
                            case "c":
                                a.m.Xd(!a.m.Tc());
                                break;
                            case "f":
                                a.ue() && a.pg();
                                break;
                            case "m":
                                a.j && a.j.isLinear() ? a.j.setMuted(!a.j.isMuted()) : a.o.muted = !a.o.muted;
                                break;
                            case "p":
                                a.Gf() && a.Yc();
                                break;
                            case ">":
                                d = a.g.playbackRates.indexOf(a.m.Wa());
                                d > -1 && d + 1 < a.g.playbackRates.length && a.m.sc(a.g.playbackRates[d + 1], !1);
                                break;
                            case "<":
                                d = a.g.playbackRates.indexOf(a.m.Wa());
                                d > -1 && d - 1 >= 0 && a.m.sc(a.g.playbackRates[d - 1], !1);
                                break;
                            case " ":
                                (g || h && !e) && XH(a);
                        }
                    }
                }
            });
            a.h.u(b, "keyup", function(d) {
                c() && a.na.delete(d.key);
            });
        }
        function zJ(a) {
            a.X && (a.j && a.j.isClientRendering() && a.j.isLinear() ? OH(a.M, !1) : OH(a.M, a.m.Df()));
        }
        p.Ca = function() {
            return this.X ? this.i.getAttribute("shown") != null || this.i.getAttribute("casting") != null : !1;
        };
        function XI(a) {
            a.Ca() ? a.dispatchEvent(new R("showingui")) : a.dispatchEvent(new R("hidingui"));
        }
        function DJ(a, b) {
            a.C.currentTime = b;
            ZI(a);
        }
        function ZI(a) {
            if (a.A) {
                if (a.A.setValue(a.C.currentTime), a.A.update(), a.A.isShowing()) {
                    for(var b = u(a.K), c = b.next(); !c.done; c = b.next())c.value.classList.remove("shaka-low-position");
                    b = a.H;
                    b.classList.contains("shaka-tooltips-on") && b.classList.remove("shaka-tooltips-low-position");
                } else {
                    b = u(a.K);
                    for(c = b.next(); !c.done; c = b.next())c.value.classList.add("shaka-low-position");
                    b = a.H;
                    b.classList.contains("shaka-tooltips-on") && b.classList.add("shaka-tooltips-low-position");
                }
            }
            a.dispatchEvent(new R("timeandseekrangeupdated"));
        }
        function AJ(a, b) {
            a.na.add(b.key);
            var c = a.Jc();
            b.key == "Tab" && (a.i.classList.add("shaka-keyboard-navigation"), WI(a), a.h.u(window1, "mousedown", function() {
                a.h.Fa(window1, "mousedown");
            }));
            b.key == "Escape" && a.P.La();
            c && a.na.has("Tab") && FJ(a, b);
        }
        function FJ(a, b) {
            var c = a.K.filter(function(f) {
                return !f.classList.contains("shaka-hidden");
            });
            if (c.length) {
                var d = c[0];
                if (d.childNodes.length) {
                    for(c = d.firstElementChild; c && c.classList.contains("shaka-hidden");)c = c.nextElementSibling;
                    for(d = d.lastElementChild; d && d.classList.contains("shaka-hidden");)d = d.previousElementSibling;
                    var e = document.activeElement;
                    a.na.has("Shift") ? e == c && (b.preventDefault(), d.focus()) : e == d && (b.preventDefault(), c.focus());
                }
            }
        }
        p.Bm = function() {
            var a = new Event("mousemove", {
                bubbles: !1,
                cancelable: !1
            });
            vJ(this, a);
        };
        p.fj = function() {
            this.L.La();
        };
        p.Lg = function() {
            return this.D.Lg();
        };
        p.Sb = function() {
            return this.D.Sb();
        };
        p.xl = function() {
            var a = this.D;
            if (a.g) {
                a = a.g;
                xI(a.h, a.F);
                var b = a.h, c = 0;
                a = 0;
                a = b[0];
                var d = b[1], e = b[2];
                b = b[3];
                c = d * d;
                var f = e * e, g = b * b;
                c = a * a + c + f + g;
                var h = a * b - d * e;
                h > .499995 * c ? (c = Math.PI / 2, a = 2 * Math.atan2(d, a)) : h < -0.499995 * c ? (c = -Math.PI / 2, a = 2 * Math.atan2(d, a)) : (c = Math.asin(2 * (a * e - b * d)), a = Math.atan2(2 * (a * b + d * e), 1 - 2 * (f + g)));
                a = Math.acos(Math.cos(a) * Math.cos(c)) * 180 / Math.PI;
            } else Za("Not playing VR content"), a = null;
            return a;
        };
        p.wl = function() {
            var a = this.D;
            a.g ? a = a.g.j : (Za("Not playing VR content"), a = null);
            return a;
        };
        p.zm = function(a) {
            var b = this.D;
            b.g ? (a < 0 ? (Za("Field of view should be greater than 0"), a = 0) : a > 100 && (Za("Field of view should be less than 100"), a = 100), b = b.g, b.j = a, EI(b, !1)) : Za("Not playing VR content");
        };
        p.Yd = function() {
            this.D.Yd();
        };
        p.Ch = function(a) {
            this.D.Ch(a);
        };
        p.Ah = function(a) {
            this.D.Ah(a);
        };
        p.Bh = function(a) {
            this.D.Bh(a);
        };
        function $I() {
            var a = new Tc("en");
            a.Ya("ar", new Map([
                [
                    "AD_DURATION",
                    "\u0645\u062f\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646"
                ],
                [
                    "AD_PROGRESS",
                    "\u0627\u0644\u0625\u0639\u0644\u0627\u0646 [AD_ON] \u0645\u0646 [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u0625\u062d\u0635\u0627\u0621\u0627\u062a \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062a"
                ],
                [
                    "AD_TIME",
                    "\u0627\u0644\u0625\u0639\u0644\u0627\u0646: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u062a\u0644\u0642\u0627\u0626\u064a"
                ],
                [
                    "BACK",
                    "\u0631\u062c\u0648\u0639"
                ],
                [
                    "CAPTIONS",
                    "\u0627\u0644\u062a\u0631\u062c\u0645\u0629 \u0648\u0627\u0644\u0634\u0631\u062d"
                ],
                [
                    "CAST",
                    "\u0625\u0631\u0633\u0627\u0644..."
                ],
                [
                    "CHAPTERS",
                    "\u0627\u0644\u0641\u0635\u0648\u0644"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u062d\u0641\u0638 \u0625\u0637\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    '\u0627\u0644\u062f\u062e\u0648\u0644 \u0641\u064a \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u0625\u0646\u0647\u0627\u0621 \u0648\u0636\u0639 \u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u0625\u064a\u0642\u0627\u0641 \u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0641\u064a\u062f\u064a\u0648 \u0627\u0644\u062d\u0627\u0644\u064a"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    '\u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0648\u0636\u0639 "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0646\u0627\u0641\u0630\u0629"'
                ],
                [
                    "FAST_FORWARD",
                    "\u062a\u0642\u062f\u064a\u0645 \u0633\u0631\u064a\u0639"
                ],
                [
                    "FULL_SCREEN",
                    "\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629"
                ],
                [
                    "LANGUAGE",
                    "\u0627\u0644\u0644\u063a\u0629"
                ],
                [
                    "LIVE",
                    "\u0645\u0628\u0627\u0634\u0631"
                ],
                [
                    "LOOP",
                    "\u062a\u0643\u0631\u0627\u0631"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0645\u0632\u064a\u062f \u0645\u0646 \u0627\u0644\u0625\u0639\u062f\u0627\u062f\u0627\u062a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u0644\u063a\u0627\u062a \u0645\u062a\u0639\u062f\u062f\u0629"
                ],
                [
                    "MUTE",
                    "\u0643\u062a\u0645 \u0627\u0644\u0635\u0648\u062a"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u063a\u064a\u0631 \u0633\u0627\u0631\u064d"
                ],
                [
                    "OFF",
                    "\u0625\u064a\u0642\u0627\u0641"
                ],
                [
                    "ON",
                    "\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "PAUSE",
                    "\u0625\u064a\u0642\u0627\u0641 \u0645\u0624\u0642\u062a"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u0646\u0627\u0641\u0630\u0629 \u0636\u0645\u0646 \u0627\u0644\u0646\u0627\u0641\u0630\u0629"
                ],
                [
                    "PLAY",
                    "\u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0633\u0631\u0639\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "QUALITY",
                    "\u0627\u0644\u062c\u0648\u062f\u0629"
                ],
                [
                    "RECENTER_VR",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u0633\u064a\u0637"
                ],
                [
                    "REPLAY",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0634\u063a\u064a\u0644"
                ],
                [
                    "RESOLUTION",
                    "\u062f\u0631\u062c\u0629 \u0627\u0644\u062f\u0642\u0629"
                ],
                [
                    "REWIND",
                    "\u062a\u0631\u062c\u064a\u0639"
                ],
                [
                    "SEEK",
                    "\u0627\u0644\u0628\u062d\u062b \u0628\u0627\u0644\u062a\u0645\u0631\u064a\u0631"
                ],
                [
                    "SKIP_AD",
                    "\u062a\u062e\u0637\u0651\u064a \u0627\u0644\u0625\u0639\u0644\u0627\u0646"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0625\u0644\u0649 \u0628\u062b \u0645\u0628\u0627\u0634\u0631"
                ],
                [
                    "STATISTICS",
                    "\u0627\u0644\u0625\u062d\u0635\u0627\u0621\u0627\u062a"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0639\u0631\u0636 \u0625\u062c\u0628\u0627\u0631\u064a"
                ],
                [
                    "SURROUND",
                    "\u0635\u0648\u062a \u0645\u062d\u064a\u0637\u064a"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0625\u064a\u0642\u0627\u0641 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u062c\u0633\u0651\u0645 \u0623\u0648 \u062a\u0641\u0639\u064a\u0644\u0647"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u063a\u064a\u0631 \u0645\u062d\u062f\u062f"
                ],
                [
                    "UNMUTE",
                    "\u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u0635\u0648\u062a"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641"
                ],
                [
                    "VOLUME",
                    "\u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0635\u0648\u062a"
                ]
            ]));
            a.Ya("de", new Map([
                [
                    "AD_DURATION",
                    "Dauer der Werbeanzeige"
                ],
                [
                    "AD_PROGRESS",
                    "Werbung\u00a0[AD_ON] von\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Anzeigenstatistiken"
                ],
                [
                    "AD_TIME",
                    "Werbeanzeige: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatisch"
                ],
                [
                    "BACK",
                    "Zur\u00fcck"
                ],
                [
                    "CAPTIONS",
                    "Untertitel"
                ],
                [
                    "CAST",
                    "Streamen..."
                ],
                [
                    "CHAPTERS",
                    "Kapitel"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Videoframe speichern"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "In Endlosschleife spielen"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Bild im Bild aktivieren"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Vollbildmodus beenden"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Endlosschleife stoppen"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Bild im Bild beenden"
                ],
                [
                    "FAST_FORWARD",
                    "Vorspulen"
                ],
                [
                    "FULL_SCREEN",
                    "Vollbildmodus"
                ],
                [
                    "LANGUAGE",
                    "Sprache"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Schleife"
                ],
                [
                    "MORE_SETTINGS",
                    "Weitere Einstellungen"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Mehrere Sprachen"
                ],
                [
                    "MUTE",
                    "Stummschalten"
                ],
                [
                    "NOT_APPLICABLE",
                    "Nicht zutreffend"
                ],
                [
                    "OFF",
                    "Aus"
                ],
                [
                    "ON",
                    "Ein"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Bild im Bild"
                ],
                [
                    "PLAY",
                    "Wiedergabe"
                ],
                [
                    "PLAYBACK_RATE",
                    "Geschwindigkeit"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e4t"
                ],
                [
                    "RECENTER_VR",
                    "Zentrieren"
                ],
                [
                    "REPLAY",
                    "Noch einmal wiedergeben"
                ],
                [
                    "RESOLUTION",
                    "Aufl\u00f6sung"
                ],
                [
                    "REWIND",
                    "Zur\u00fcckspulen"
                ],
                [
                    "SEEK",
                    "Suche"
                ],
                [
                    "SKIP_AD",
                    "\u00dcberspringen"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Zum Live-Videostream wechseln"
                ],
                [
                    "STATISTICS",
                    "Statistiken"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Erzwungen"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Einstellung \u201estereoskopisch\u201c ein\u2011/ausschalten"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Unbestimmt"
                ],
                [
                    "UNMUTE",
                    "Stummschaltung aufheben"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unbekannt"
                ],
                [
                    "VOLUME",
                    "Lautst\u00e4rke"
                ]
            ]));
            a.Ya("en", new Map([
                [
                    "AD_DURATION",
                    "Ad duration"
                ],
                [
                    "AD_PROGRESS",
                    "Ad [AD_ON] of [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Ad statistics"
                ],
                [
                    "AD_TIME",
                    "Ad: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Auto"
                ],
                [
                    "BACK",
                    "Back"
                ],
                [
                    "CAPTIONS",
                    "Captions"
                ],
                [
                    "CAST",
                    "Cast..."
                ],
                [
                    "CHAPTERS",
                    "Chapters"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Save video frame"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Loop the current video"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Enter Picture-in-Picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Exit full screen"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Stop looping the current video"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Exit Picture-in-Picture"
                ],
                [
                    "FAST_FORWARD",
                    "Fast-forward"
                ],
                [
                    "FULL_SCREEN",
                    "Full screen"
                ],
                [
                    "LANGUAGE",
                    "Language"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Loop"
                ],
                [
                    "MORE_SETTINGS",
                    "More settings"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Multiple languages"
                ],
                [
                    "MUTE",
                    "Mute"
                ],
                [
                    "NOT_APPLICABLE",
                    "Not applicable"
                ],
                [
                    "OFF",
                    "Off"
                ],
                [
                    "ON",
                    "On"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-Picture"
                ],
                [
                    "PLAY",
                    "Play"
                ],
                [
                    "PLAYBACK_RATE",
                    "Playback speed"
                ],
                [
                    "QUALITY",
                    "Quality"
                ],
                [
                    "RECENTER_VR",
                    "Recenter"
                ],
                [
                    "REPLAY",
                    "Replay"
                ],
                [
                    "RESOLUTION",
                    "Resolution"
                ],
                [
                    "REWIND",
                    "Rewind"
                ],
                [
                    "SEEK",
                    "Seek"
                ],
                [
                    "SKIP_AD",
                    "Skip Ad"
                ],
                [
                    "SKIP_NEXT",
                    "Next"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Previous"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Skip ahead to live"
                ],
                [
                    "STATISTICS",
                    "Statistics"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forced"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Toggle stereoscopic"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Undetermined"
                ],
                [
                    "UNMUTE",
                    "Unmute"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unrecognized"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("en-GB", new Map([
                [
                    "AD_DURATION",
                    "Ad duration"
                ],
                [
                    "AD_PROGRESS",
                    "Ad [AD_ON] of [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Ad statistics"
                ],
                [
                    "AD_TIME",
                    "Ad: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Auto"
                ],
                [
                    "BACK",
                    "Back"
                ],
                [
                    "CAPTIONS",
                    "Captions"
                ],
                [
                    "CAST",
                    "Cast..."
                ],
                [
                    "CHAPTERS",
                    "Chapters"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Save video frame"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Loop the current video"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Enter picture-in-picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Exit full screen"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Stop looping the current video"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Exit picture-in-picture"
                ],
                [
                    "FAST_FORWARD",
                    "Fast-forward"
                ],
                [
                    "FULL_SCREEN",
                    "Full screen"
                ],
                [
                    "LANGUAGE",
                    "Language"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Loop"
                ],
                [
                    "MORE_SETTINGS",
                    "More settings"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Multiple languages"
                ],
                [
                    "MUTE",
                    "Mute"
                ],
                [
                    "NOT_APPLICABLE",
                    "Not applicable"
                ],
                [
                    "OFF",
                    "Off"
                ],
                [
                    "ON",
                    "On"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-picture"
                ],
                [
                    "PLAY",
                    "Play"
                ],
                [
                    "PLAYBACK_RATE",
                    "Playback speed"
                ],
                [
                    "QUALITY",
                    "Quality"
                ],
                [
                    "RECENTER_VR",
                    "Recentre"
                ],
                [
                    "REPLAY",
                    "Replay"
                ],
                [
                    "RESOLUTION",
                    "Resolution"
                ],
                [
                    "REWIND",
                    "Rewind"
                ],
                [
                    "SEEK",
                    "Seek"
                ],
                [
                    "SKIP_AD",
                    "Skip ad"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Skip ahead to live"
                ],
                [
                    "STATISTICS",
                    "Statistics"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forced"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Toggle stereoscopic"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Undetermined"
                ],
                [
                    "UNMUTE",
                    "Unmute"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Unrecognised"
                ],
                [
                    "VOLUME",
                    "volume"
                ]
            ]));
            a.Ya("es", new Map([
                [
                    "AD_DURATION",
                    "Duraci\u00f3n del anuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Anuncio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estad\u00edsticas del anuncio"
                ],
                [
                    "AD_TIME",
                    "Anuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tico"
                ],
                [
                    "BACK",
                    "Atr\u00e1s"
                ],
                [
                    "CAPTIONS",
                    "Subt\u00edtulos"
                ],
                [
                    "CAST",
                    "Enviar..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Guardar fotograma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Reproducir en bucle el v\u00eddeo actual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Activar el modo imagen en imagen"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Salir del modo de pantalla completa"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Dejar de reproducir en bucle el v\u00eddeo actual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Salir del modo imagen en imagen"
                ],
                [
                    "FAST_FORWARD",
                    "Avanzar r\u00e1pidamente"
                ],
                [
                    "FULL_SCREEN",
                    "Pantalla completa"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "En directo"
                ],
                [
                    "LOOP",
                    "Reproducir en bucle"
                ],
                [
                    "MORE_SETTINGS",
                    "M\u00e1s ajustes"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Varios idiomas"
                ],
                [
                    "MUTE",
                    "Silenciar"
                ],
                [
                    "NOT_APPLICABLE",
                    "No aplicable"
                ],
                [
                    "OFF",
                    "Desactivado"
                ],
                [
                    "ON",
                    "Activado"
                ],
                [
                    "PAUSE",
                    "Pausar"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Imagen en imagen"
                ],
                [
                    "PLAY",
                    "Reproducir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidad de reproducci\u00f3n"
                ],
                [
                    "QUALITY",
                    "Calidad"
                ],
                [
                    "RECENTER_VR",
                    "Volver a centrar"
                ],
                [
                    "REPLAY",
                    "Volver a reproducir"
                ],
                [
                    "RESOLUTION",
                    "Resoluci\u00f3n"
                ],
                [
                    "REWIND",
                    "Rebobinar"
                ],
                [
                    "SEEK",
                    "Buscar"
                ],
                [
                    "SKIP_AD",
                    "Saltar anuncio"
                ],
                [
                    "SKIP_NEXT",
                    "Siguiente"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Anterior"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Ir al v\u00eddeo en directo"
                ],
                [
                    "STATISTICS",
                    "Estad\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzado"
                ],
                [
                    "SURROUND",
                    "Envolvente"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activar/Desactivar estereosc\u00f3pica"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Sin especificar"
                ],
                [
                    "UNMUTE",
                    "Activar sonido"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "No reconocida"
                ],
                [
                    "VOLUME",
                    "Volumen"
                ]
            ]));
            a.Ya("es-419", new Map([
                [
                    "AD_DURATION",
                    "Duraci\u00f3n del anuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Anuncio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estad\u00edsticas de anuncios"
                ],
                [
                    "AD_TIME",
                    "Anuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tico"
                ],
                [
                    "BACK",
                    "Atr\u00e1s"
                ],
                [
                    "CAPTIONS",
                    "Subt\u00edtulos"
                ],
                [
                    "CAST",
                    "Transmitir..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Guardar fotograma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Repetir indefinidamente el video actual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Ingresar al modo de pantalla en pantalla"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Salir de pantalla completa"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Detener la repetici\u00f3n indefinida del video actual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Salir del modo de pantalla en pantalla"
                ],
                [
                    "FAST_FORWARD",
                    "Avanzar"
                ],
                [
                    "FULL_SCREEN",
                    "Pantalla completa"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "En directo"
                ],
                [
                    "LOOP",
                    "Repetir indefinidamente"
                ],
                [
                    "MORE_SETTINGS",
                    "M\u00e1s opciones de configuraci\u00f3n"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Varios idiomas"
                ],
                [
                    "MUTE",
                    "Silenciar"
                ],
                [
                    "NOT_APPLICABLE",
                    "No aplicable"
                ],
                [
                    "OFF",
                    "Desactivado"
                ],
                [
                    "ON",
                    "Activado"
                ],
                [
                    "PAUSE",
                    "Detener"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Pantalla en pantalla"
                ],
                [
                    "PLAY",
                    "Reproducir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidad de reproducci\u00f3n"
                ],
                [
                    "QUALITY",
                    "Calidad"
                ],
                [
                    "RECENTER_VR",
                    "Volver a centrar"
                ],
                [
                    "REPLAY",
                    "Volver a reproducir"
                ],
                [
                    "RESOLUTION",
                    "Resoluci\u00f3n"
                ],
                [
                    "REWIND",
                    "Retroceder"
                ],
                [
                    "SEEK",
                    "Buscar"
                ],
                [
                    "SKIP_AD",
                    "Omitir anuncio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Adelantar hasta la transmisi\u00f3n en vivo"
                ],
                [
                    "STATISTICS",
                    "Estad\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzado"
                ],
                [
                    "SURROUND",
                    "Sonido envolvente"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activar o desactivar el modo estereosc\u00f3pico"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Sin especificar"
                ],
                [
                    "UNMUTE",
                    "Dejar de silenciar"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "No reconocida"
                ],
                [
                    "VOLUME",
                    "Volumen"
                ]
            ]));
            a.Ya("fr", new Map([
                [
                    "AD_DURATION",
                    "Dur\u00e9e de l'annonce"
                ],
                [
                    "AD_PROGRESS",
                    "Annonce\u00a0[AD_ON] sur\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statistiques sur les annonces"
                ],
                [
                    "AD_TIME",
                    "Annonce\u00a0: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatique"
                ],
                [
                    "BACK",
                    "Retour"
                ],
                [
                    "CAPTIONS",
                    "Sous-titres"
                ],
                [
                    "CAST",
                    "Caster\u2026"
                ],
                [
                    "CHAPTERS",
                    "Chapitres"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "T\u00e9l\u00e9charger l'image de la vid\u00e9o"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Lire en boucle la vid\u00e9o en cours"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Utiliser le mode Picture-in-Picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Quitter le mode plein \u00e9cran"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Arr\u00eater la lecture en boucle de la vid\u00e9o en cours"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Quitter le mode\u00a0PIP (Picture-in-picture)"
                ],
                [
                    "FAST_FORWARD",
                    "Avance rapide"
                ],
                [
                    "FULL_SCREEN",
                    "Plein \u00e9cran"
                ],
                [
                    "LANGUAGE",
                    "Langue"
                ],
                [
                    "LIVE",
                    "En direct"
                ],
                [
                    "LOOP",
                    "R\u00e9p\u00e9ter"
                ],
                [
                    "MORE_SETTINGS",
                    "Plus de param\u00e8tres"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Plusieurs langues"
                ],
                [
                    "MUTE",
                    "Couper le son"
                ],
                [
                    "NOT_APPLICABLE",
                    "Non applicable"
                ],
                [
                    "OFF",
                    "D\u00e9sactiv\u00e9e"
                ],
                [
                    "ON",
                    "Activ\u00e9e"
                ],
                [
                    "PAUSE",
                    "Pause"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-Picture"
                ],
                [
                    "PLAY",
                    "Visionner"
                ],
                [
                    "PLAYBACK_RATE",
                    "Vitesse de lecture"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e9"
                ],
                [
                    "RECENTER_VR",
                    "Recentrer"
                ],
                [
                    "REPLAY",
                    "Revoir"
                ],
                [
                    "RESOLUTION",
                    "R\u00e9solution"
                ],
                [
                    "REWIND",
                    "Retour arri\u00e8re"
                ],
                [
                    "SEEK",
                    "Chercher"
                ],
                [
                    "SKIP_AD",
                    "Passer l'annonce"
                ],
                [
                    "SKIP_NEXT",
                    "Suivante"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Pr\u00e9c\u00e9dente"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Acc\u00e9der \u00e0 la partie la plus r\u00e9cente du direct"
                ],
                [
                    "STATISTICS",
                    "Statistiques"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forc\u00e9"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Activer/D\u00e9sactiver le mode st\u00e9r\u00e9oscopique"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Langue ind\u00e9termin\u00e9e"
                ],
                [
                    "UNMUTE",
                    "R\u00e9activer le son"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Non reconnu"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("it", new Map([
                [
                    "AD_DURATION",
                    "Durata dell'annuncio"
                ],
                [
                    "AD_PROGRESS",
                    "Annuncio [AD_ON] di [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statistiche sugli annunci"
                ],
                [
                    "AD_TIME",
                    "Annuncio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatica"
                ],
                [
                    "BACK",
                    "Indietro"
                ],
                [
                    "CAPTIONS",
                    "Sottotitoli"
                ],
                [
                    "CAST",
                    "Trasmetti..."
                ],
                [
                    "CHAPTERS",
                    "Capitoli"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Salva fotogramma"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Riproduci in loop il video corrente"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Attiva Picture in picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Esci da schermo intero"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Interrompi riproduzione in loop del video corrente"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Esci da Picture in picture"
                ],
                [
                    "FAST_FORWARD",
                    "Avanti veloce"
                ],
                [
                    "FULL_SCREEN",
                    "Schermo intero"
                ],
                [
                    "LANGUAGE",
                    "Lingua"
                ],
                [
                    "LIVE",
                    "Dal vivo"
                ],
                [
                    "LOOP",
                    "Riproduci in loop"
                ],
                [
                    "MORE_SETTINGS",
                    "Altre impostazioni"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Pi\u00f9 lingue"
                ],
                [
                    "MUTE",
                    "Disattiva audio"
                ],
                [
                    "NOT_APPLICABLE",
                    "Non applicabile"
                ],
                [
                    "OFF",
                    "Disattivo"
                ],
                [
                    "ON",
                    "Attivo"
                ],
                [
                    "PAUSE",
                    "Metti in pausa"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture in picture"
                ],
                [
                    "PLAY",
                    "Riproduci"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocit\u00e0 di riproduzione"
                ],
                [
                    "QUALITY",
                    "Qualit\u00e0"
                ],
                [
                    "RECENTER_VR",
                    "Ricentra"
                ],
                [
                    "REPLAY",
                    "Riproduci di nuovo"
                ],
                [
                    "RESOLUTION",
                    "Risoluzione"
                ],
                [
                    "REWIND",
                    "Riavvolgi"
                ],
                [
                    "SEEK",
                    "Cerca"
                ],
                [
                    "SKIP_AD",
                    "Salta annuncio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Passa alla trasmissione dal vivo"
                ],
                [
                    "STATISTICS",
                    "Statistiche"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Forzata"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Pulsante di attivazione/disattivazione stereoscopico"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Indeterminata"
                ],
                [
                    "UNMUTE",
                    "Riattiva audio"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Non riconosciuto"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("ja", new Map([
                [
                    "AD_DURATION",
                    "\u5e83\u544a\u518d\u751f\u6642\u9593"
                ],
                [
                    "AD_PROGRESS",
                    "[AD_ON] \u756a\u76ee\u306e\u5e83\u544a\uff08\u5168 [NUM_ADS] \u500b\uff09"
                ],
                [
                    "AD_STATISTICS",
                    "\u5e83\u544a\u306e\u7d71\u8a08\u60c5\u5831"
                ],
                [
                    "AD_TIME",
                    "\u5e83\u544a: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52d5"
                ],
                [
                    "BACK",
                    "\u623b\u308b"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u30ad\u30e3\u30b9\u30c8..."
                ],
                [
                    "CHAPTERS",
                    "\u7ae0"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u52d5\u753b\u30d5\u30ec\u30fc\u30e0\u3092\u4fdd\u5b58"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u73fe\u5728\u306e\u52d5\u753b\u3092\u30eb\u30fc\u30d7\u518d\u751f"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u958b\u59cb"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u5168\u753b\u9762\u8868\u793a\u3092\u7d42\u4e86"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u73fe\u5728\u306e\u52d5\u753b\u306e\u30eb\u30fc\u30d7\u518d\u751f\u3092\u505c\u6b62"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc\u3092\u7d42\u4e86"
                ],
                [
                    "FAST_FORWARD",
                    "\u65e9\u9001\u308a"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u753b\u9762\u8868\u793a"
                ],
                [
                    "LANGUAGE",
                    "\u8a00\u8a9e"
                ],
                [
                    "LIVE",
                    "\u30e9\u30a4\u30d6"
                ],
                [
                    "LOOP",
                    "\u30eb\u30fc\u30d7"
                ],
                [
                    "MORE_SETTINGS",
                    "\u8a73\u7d30\u8a2d\u5b9a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u8a00\u8a9e"
                ],
                [
                    "MUTE",
                    "\u30df\u30e5\u30fc\u30c8"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u8a72\u5f53\u306a\u3057"
                ],
                [
                    "OFF",
                    "\u30aa\u30d5"
                ],
                [
                    "ON",
                    "\u30aa\u30f3"
                ],
                [
                    "PAUSE",
                    "\u4e00\u6642\u505c\u6b62"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u30d4\u30af\u30c1\u30e3\u30fc \u30a4\u30f3 \u30d4\u30af\u30c1\u30e3\u30fc"
                ],
                [
                    "PLAY",
                    "\u518d\u751f"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u518d\u751f\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u54c1\u8cea"
                ],
                [
                    "RECENTER_VR",
                    "\u4e2d\u5fc3\u3092\u518d\u8a2d\u5b9a"
                ],
                [
                    "REPLAY",
                    "\u3082\u3046\u4e00\u5ea6\u518d\u751f"
                ],
                [
                    "RESOLUTION",
                    "\u89e3\u50cf\u5ea6"
                ],
                [
                    "REWIND",
                    "\u5dfb\u304d\u623b\u3057"
                ],
                [
                    "SEEK",
                    "\u30b7\u30fc\u30af\u518d\u751f"
                ],
                [
                    "SKIP_AD",
                    "\u5e83\u544a\u3092\u30b9\u30ad\u30c3\u30d7"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u30e9\u30a4\u30d6\u914d\u4fe1\u307e\u3067\u30b9\u30ad\u30c3\u30d7"
                ],
                [
                    "STATISTICS",
                    "\u7d71\u8a08\u60c5\u5831"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5f37\u5236"
                ],
                [
                    "SURROUND",
                    "\u30b5\u30e9\u30a6\u30f3\u30c9"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u7acb\u4f53\u753b\u50cf\u3092\u5207\u308a\u66ff\u3048\u308b"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "UNMUTE",
                    "\u30df\u30e5\u30fc\u30c8\u3092\u89e3\u9664"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Ya("ko", new Map([
                [
                    "AD_DURATION",
                    "\uad11\uace0 \uae30\uac04"
                ],
                [
                    "AD_PROGRESS",
                    "\uad11\uace0 [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\uad11\uace0 \ud1b5\uacc4"
                ],
                [
                    "AD_TIME",
                    "\uad11\uace0: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\uc790\ub3d9"
                ],
                [
                    "BACK",
                    "\ub4a4\ub85c"
                ],
                [
                    "CAPTIONS",
                    "\uc790\ub9c9"
                ],
                [
                    "CAST",
                    "\uc804\uc1a1..."
                ],
                [
                    "CHAPTERS",
                    "\uc7a5"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\ub3d9\uc601\uc0c1 \ud504\ub808\uc784 \uc800\uc7a5"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc \uc2dc\uc791"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\uc804\uccb4\ud654\uba74 \ub2eb\uae30"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\ud604\uc7ac \ub3d9\uc601\uc0c1 \ubc18\ubcf5 \uc7ac\uc0dd \uc911\uc9c0"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc \uc885\ub8cc"
                ],
                [
                    "FAST_FORWARD",
                    "\ube68\ub9ac \uac10\uae30"
                ],
                [
                    "FULL_SCREEN",
                    "\uc804\uccb4\ud654\uba74"
                ],
                [
                    "LANGUAGE",
                    "\uc5b8\uc5b4"
                ],
                [
                    "LIVE",
                    "\uc2e4\uc2dc\uac04"
                ],
                [
                    "LOOP",
                    "\ubc18\ubcf5 \uc7ac\uc0dd"
                ],
                [
                    "MORE_SETTINGS",
                    "\uc124\uc815 \ub354\ubcf4\uae30"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\uc5ec\ub7ec \uc5b8\uc5b4"
                ],
                [
                    "MUTE",
                    "\uc74c\uc18c\uac70"
                ],
                [
                    "NOT_APPLICABLE",
                    "\ud574\ub2f9 \uc0ac\ud56d \uc5c6\uc74c"
                ],
                [
                    "OFF",
                    "\uc0ac\uc6a9 \uc548\ud568"
                ],
                [
                    "ON",
                    "\uc0ac\uc6a9"
                ],
                [
                    "PAUSE",
                    "\uc77c\uc2dc\uc911\uc9c0"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "PIP \ubaa8\ub4dc"
                ],
                [
                    "PLAY",
                    "\uc7ac\uc0dd"
                ],
                [
                    "PLAYBACK_RATE",
                    "\uc7ac\uc0dd \uc18d\ub3c4"
                ],
                [
                    "QUALITY",
                    "\ud488\uc9c8"
                ],
                [
                    "RECENTER_VR",
                    "\uc911\uc2ec \uc7ac\uc124\uc815"
                ],
                [
                    "REPLAY",
                    "\ub2e4\uc2dc\ubcf4\uae30"
                ],
                [
                    "RESOLUTION",
                    "\ud574\uc0c1\ub3c4"
                ],
                [
                    "REWIND",
                    "\ub418\uac10\uae30"
                ],
                [
                    "SEEK",
                    "\ucc3e\uae30"
                ],
                [
                    "SKIP_AD",
                    "\uad11\uace0 \uac74\ub108\ub6f0\uae30"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\ub77c\uc774\ube0c \ub3d9\uc601\uc0c1\uc73c\ub85c \uac74\ub108\ub6f0\uae30"
                ],
                [
                    "STATISTICS",
                    "\ud1b5\uacc4"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\uac15\uc81c"
                ],
                [
                    "SURROUND",
                    "\uc11c\ub77c\uc6b4\ub4dc"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\uc785\uccb4 \ubcf4\uae30 \uc804\ud658"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\ubbf8\uc815"
                ],
                [
                    "UNMUTE",
                    "\uc74c\uc18c\uac70 \ud574\uc81c"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\uc54c \uc218 \uc5c6\uc74c"
                ],
                [
                    "VOLUME",
                    "\ubcfc\ub968"
                ]
            ]));
            a.Ya("nl", new Map([
                [
                    "AD_DURATION",
                    "Advertentieduur"
                ],
                [
                    "AD_PROGRESS",
                    "Advertentie [AD_ON] van [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Advertentiestatistieken"
                ],
                [
                    "AD_TIME",
                    "Advertentie: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatisch"
                ],
                [
                    "BACK",
                    "Terug"
                ],
                [
                    "CAPTIONS",
                    "Ondertiteling"
                ],
                [
                    "CAST",
                    "Casten..."
                ],
                [
                    "CHAPTERS",
                    "Hoofdstukken"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Videoframe opslaan"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "De huidige video lussen"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Scherm-in-scherm openen"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Volledig scherm sluiten"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "De huidige video niet meer lussen"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Scherm-in-scherm afsluiten"
                ],
                [
                    "FAST_FORWARD",
                    "Vooruitspoelen"
                ],
                [
                    "FULL_SCREEN",
                    "Volledig scherm"
                ],
                [
                    "LANGUAGE",
                    "Taal"
                ],
                [
                    "LIVE",
                    "Live"
                ],
                [
                    "LOOP",
                    "Lussen"
                ],
                [
                    "MORE_SETTINGS",
                    "Meer instellingen"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Meerdere talen"
                ],
                [
                    "MUTE",
                    "Geluid uitzetten"
                ],
                [
                    "NOT_APPLICABLE",
                    "Niet van toepassing"
                ],
                [
                    "OFF",
                    "Uit"
                ],
                [
                    "ON",
                    "Aan"
                ],
                [
                    "PAUSE",
                    "Onderbreken"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Scherm-in-scherm"
                ],
                [
                    "PLAY",
                    "Afspelen"
                ],
                [
                    "PLAYBACK_RATE",
                    "Afspeelsnelheid"
                ],
                [
                    "QUALITY",
                    "Kwaliteit"
                ],
                [
                    "RECENTER_VR",
                    "Opnieuw centreren"
                ],
                [
                    "REPLAY",
                    "Opnieuw afspelen"
                ],
                [
                    "RESOLUTION",
                    "Resolutie"
                ],
                [
                    "REWIND",
                    "Terugspoelen"
                ],
                [
                    "SEEK",
                    "Zoeken"
                ],
                [
                    "SKIP_AD",
                    "Advertentie overslaan"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Doorgaan naar live"
                ],
                [
                    "STATISTICS",
                    "Statistieken"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Afgedwongen"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Stereoscopisch aan-/uitzetten"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Onbepaald"
                ],
                [
                    "UNMUTE",
                    "Geluid aanzetten"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Onbekend"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("pl", new Map([
                [
                    "AD_DURATION",
                    "Czas trwania reklamy"
                ],
                [
                    "AD_PROGRESS",
                    "Reklama\u00a0[AD_ON] z\u00a0[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Statystyki reklam"
                ],
                [
                    "AD_TIME",
                    "Reklama: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Automatycznie"
                ],
                [
                    "BACK",
                    "Wstecz"
                ],
                [
                    "CAPTIONS",
                    "Napisy"
                ],
                [
                    "CAST",
                    "Przesy\u0142aj..."
                ],
                [
                    "CHAPTERS",
                    "Rozdzia\u0142y"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Zapisz klatk\u0119 filmu"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Odtwarzaj bie\u017c\u0105cy film w\u00a0p\u0119tli"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "W\u0142\u0105cz tryb obrazu w\u00a0obrazie"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Zamknij pe\u0142ny ekran"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Wy\u0142\u0105cz odtwarzanie bie\u017c\u0105cego filmu w\u00a0p\u0119tli"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Wy\u0142\u0105cz tryb obrazu w\u00a0obrazie"
                ],
                [
                    "FAST_FORWARD",
                    "Przewi\u0144 do przodu"
                ],
                [
                    "FULL_SCREEN",
                    "Pe\u0142ny ekran"
                ],
                [
                    "LANGUAGE",
                    "J\u0119zyk"
                ],
                [
                    "LIVE",
                    "Na \u017cywo"
                ],
                [
                    "LOOP",
                    "Odtwarzaj w\u00a0p\u0119tli"
                ],
                [
                    "MORE_SETTINGS",
                    "Wi\u0119cej ustawie\u0144"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Wiele j\u0119zyk\u00f3w"
                ],
                [
                    "MUTE",
                    "Wycisz"
                ],
                [
                    "NOT_APPLICABLE",
                    "Nie dotyczy"
                ],
                [
                    "OFF",
                    "Wy\u0142\u0105czone"
                ],
                [
                    "ON",
                    "W\u0142\u0105czone"
                ],
                [
                    "PAUSE",
                    "Wstrzymaj"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Obraz w\u00a0obrazie"
                ],
                [
                    "PLAY",
                    "Odtw\u00f3rz"
                ],
                [
                    "PLAYBACK_RATE",
                    "Szybko\u015b\u0107 odtwarzania"
                ],
                [
                    "QUALITY",
                    "Jako\u015b\u0107"
                ],
                [
                    "RECENTER_VR",
                    "Wy\u015brodkuj"
                ],
                [
                    "REPLAY",
                    "Odtw\u00f3rz ponownie"
                ],
                [
                    "RESOLUTION",
                    "Rozdzielczo\u015b\u0107"
                ],
                [
                    "REWIND",
                    "Przewi\u0144 do ty\u0142u"
                ],
                [
                    "SEEK",
                    "Szukaj"
                ],
                [
                    "SKIP_AD",
                    "Pomi\u0144 reklam\u0119"
                ],
                [
                    "SKIP_NEXT",
                    "Dalej"
                ],
                [
                    "SKIP_PREVIOUS",
                    "Poprzedni"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Przejd\u017a do transmisji na \u017cywo"
                ],
                [
                    "STATISTICS",
                    "Statystyki"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Wymuszone"
                ],
                [
                    "SURROUND",
                    "Przestrzenny"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Prze\u0142\u0105cz tryb stereoskopowy"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Nie okre\u015blono"
                ],
                [
                    "UNMUTE",
                    "Wy\u0142\u0105cz wyciszenie"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Nierozpoznany"
                ],
                [
                    "VOLUME",
                    "G\u0142o\u015bno\u015b\u0107"
                ]
            ]));
            a.Ya("pt-BR", new Map([
                [
                    "AD_DURATION",
                    "Dura\u00e7\u00e3o do an\u00fancio"
                ],
                [
                    "AD_PROGRESS",
                    "An\u00fancio [AD_ON] de [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "Estat\u00edsticas de an\u00fancios"
                ],
                [
                    "AD_TIME",
                    "An\u00fancio: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Autom\u00e1tica"
                ],
                [
                    "BACK",
                    "Voltar"
                ],
                [
                    "CAPTIONS",
                    "Legendas"
                ],
                [
                    "CAST",
                    "Transmitir..."
                ],
                [
                    "CHAPTERS",
                    "Cap\u00edtulos"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Salvar frame do v\u00eddeo"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Repetir o v\u00eddeo atual"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Entrar no modo picture-in-picture"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Sair do modo tela cheia"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Parar repeti\u00e7\u00e3o do v\u00eddeo atual"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Sair de picture-in-picture"
                ],
                [
                    "FAST_FORWARD",
                    "Avan\u00e7ar"
                ],
                [
                    "FULL_SCREEN",
                    "Tela cheia"
                ],
                [
                    "LANGUAGE",
                    "Idioma"
                ],
                [
                    "LIVE",
                    "Ao vivo"
                ],
                [
                    "LOOP",
                    "Repetir"
                ],
                [
                    "MORE_SETTINGS",
                    "Mais defini\u00e7\u00f5es"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "V\u00e1rios idiomas"
                ],
                [
                    "MUTE",
                    "Desativar som"
                ],
                [
                    "NOT_APPLICABLE",
                    "N\u00e3o relevante"
                ],
                [
                    "OFF",
                    "Desativado"
                ],
                [
                    "ON",
                    "Ativado"
                ],
                [
                    "PAUSE",
                    "Pausar"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Picture-in-picture"
                ],
                [
                    "PLAY",
                    "Reproduzir"
                ],
                [
                    "PLAYBACK_RATE",
                    "Velocidade da reprodu\u00e7\u00e3o"
                ],
                [
                    "QUALITY",
                    "Qualidade"
                ],
                [
                    "RECENTER_VR",
                    "Centralizar"
                ],
                [
                    "REPLAY",
                    "Repetir"
                ],
                [
                    "RESOLUTION",
                    "Resolu\u00e7\u00e3o"
                ],
                [
                    "REWIND",
                    "Voltar"
                ],
                [
                    "SEEK",
                    "Procurar"
                ],
                [
                    "SKIP_AD",
                    "Pular an\u00fancio"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Pular para transmiss\u00e3o ao vivo"
                ],
                [
                    "STATISTICS",
                    "Estat\u00edsticas"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Exibi\u00e7\u00e3o for\u00e7ada"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Alternar imagem estereosc\u00f3pica"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Indeterminado"
                ],
                [
                    "UNMUTE",
                    "Ativar som"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "N\u00e3o reconhecido"
                ],
                [
                    "VOLUME",
                    "Volume"
                ]
            ]));
            a.Ya("ru", new Map([
                [
                    "AD_DURATION",
                    "\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0441\u0442\u044c \u0440\u0435\u043a\u043b\u0430\u043c\u044b"
                ],
                [
                    "AD_PROGRESS",
                    "\u0420\u0435\u043a\u043b\u0430\u043c\u0430 [AD_ON] \u0438\u0437 [NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430 \u043e\u0431\u044a\u044f\u0432\u043b\u0435\u043d\u0438\u0439"
                ],
                [
                    "AD_TIME",
                    "\u0420\u0435\u043a\u043b\u0430\u043c\u0430: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u0410\u0432\u0442\u043e"
                ],
                [
                    "BACK",
                    "\u041d\u0430\u0437\u0430\u0434"
                ],
                [
                    "CAPTIONS",
                    "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b"
                ],
                [
                    "CAST",
                    "\u0422\u0440\u0430\u043d\u0441\u043b\u0438\u0440\u043e\u0432\u0430\u0442\u044c..."
                ],
                [
                    "CHAPTERS",
                    "\u042d\u043f\u0438\u0437\u043e\u0434\u044b"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043a\u0430\u0434\u0440 \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c \u0442\u0435\u043a\u0443\u0449\u0435\u0435 \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    '\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u0440\u0435\u0436\u0438\u043c "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u041e\u0431\u044b\u0447\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c \u0437\u0430\u0446\u0438\u043a\u043b\u0438\u0432\u0430\u043d\u0438\u0435 \u0442\u0435\u043a\u0443\u0449\u0435\u0433\u043e \u0432\u0438\u0434\u0435\u043e"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    '\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 \u0440\u0435\u0436\u0438\u043c\u0430 "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"'
                ],
                [
                    "FAST_FORWARD",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430 \u0432\u043f\u0435\u0440\u0435\u0434"
                ],
                [
                    "FULL_SCREEN",
                    "\u041f\u043e\u043b\u043d\u043e\u044d\u043a\u0440\u0430\u043d\u043d\u044b\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "LANGUAGE",
                    "\u042f\u0437\u044b\u043a"
                ],
                [
                    "LIVE",
                    "\u041f\u0440\u044f\u043c\u043e\u0439 \u044d\u0444\u0438\u0440"
                ],
                [
                    "LOOP",
                    "\u0417\u0430\u0446\u0438\u043a\u043b\u0438\u0442\u044c"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0414\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0435 \u043d\u0430\u0441\u0442\u0440\u043e\u0439\u043a\u0438"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u041d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u044f\u0437\u044b\u043a\u043e\u0432"
                ],
                [
                    "MUTE",
                    "\u041e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u041d\u0435\u043f\u0440\u0438\u043c\u0435\u043d\u0438\u043c\u043e"
                ],
                [
                    "OFF",
                    "\u0412\u044b\u043a\u043b."
                ],
                [
                    "ON",
                    "\u0412\u043a\u043b."
                ],
                [
                    "PAUSE",
                    "\u041f\u0430\u0443\u0437\u0430"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u041a\u0430\u0440\u0442\u0438\u043d\u043a\u0430 \u0432 \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0435"
                ],
                [
                    "PLAY",
                    "\u0412\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0441\u0442\u0438"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0421\u043a\u043e\u0440\u043e\u0441\u0442\u044c \u0432\u043e\u0441\u043f\u0440\u043e\u0438\u0437\u0432\u0435\u0434\u0435\u043d\u0438\u044f"
                ],
                [
                    "QUALITY",
                    "\u041a\u0430\u0447\u0435\u0441\u0442\u0432\u043e"
                ],
                [
                    "RECENTER_VR",
                    "\u0426\u0435\u043d\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0437\u0430\u043d\u043e\u0432\u043e"
                ],
                [
                    "REPLAY",
                    "\u041f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u044c"
                ],
                [
                    "RESOLUTION",
                    "\u0420\u0430\u0437\u0440\u0435\u0448\u0435\u043d\u0438\u0435"
                ],
                [
                    "REWIND",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u0430\u0442\u044c \u043d\u0430\u0437\u0430\u0434"
                ],
                [
                    "SEEK",
                    "\u041f\u0435\u0440\u0435\u043c\u043e\u0442\u043a\u0430"
                ],
                [
                    "SKIP_AD",
                    "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u041f\u0440\u043e\u043f\u0443\u0441\u0442\u0438\u0442\u044c \u0438 \u043f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a \u043f\u0440\u044f\u043c\u043e\u0439 \u0442\u0440\u0430\u043d\u0441\u043b\u044f\u0446\u0438\u0438"
                ],
                [
                    "STATISTICS",
                    "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0430"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0421\u0443\u0431\u0442\u0438\u0442\u0440\u044b \u043f\u0440\u0438\u043d\u0443\u0434\u0438\u0442\u0435\u043b\u044c\u043d\u043e"
                ],
                [
                    "SURROUND",
                    "\u041e\u0431\u044a\u0435\u043c\u043d\u044b\u0439 \u0437\u0432\u0443\u043a"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0438\u043b\u0438 \u043e\u0442\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0441\u0442\u0435\u0440\u0435\u043e\u0441\u043a\u043e\u043f\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u0440\u0435\u0436\u0438\u043c"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u041d\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043e"
                ],
                [
                    "UNMUTE",
                    "\u0412\u043a\u043b\u044e\u0447\u0438\u0442\u044c \u0437\u0432\u0443\u043a"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u041d\u0435 \u0440\u0430\u0441\u043f\u043e\u0437\u043d\u0430\u043d\u043e"
                ],
                [
                    "VOLUME",
                    "\u0413\u0440\u043e\u043c\u043a\u043e\u0441\u0442\u044c"
                ]
            ]));
            a.Ya("th", new Map([
                [
                    "AD_DURATION",
                    "\u0e23\u0e30\u0e22\u0e30\u0e40\u0e27\u0e25\u0e32\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "AD_PROGRESS",
                    "\u0e42\u0e06\u0e29\u0e13\u0e32 [AD_ON] \u0e08\u0e32\u0e01 [NUM_ADS] \u0e23\u0e32\u0e22\u0e01\u0e32\u0e23"
                ],
                [
                    "AD_STATISTICS",
                    "\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "AD_TIME",
                    "\u0e42\u0e06\u0e29\u0e13\u0e32: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34"
                ],
                [
                    "BACK",
                    "\u0e01\u0e25\u0e31\u0e1a"
                ],
                [
                    "CAPTIONS",
                    "\u0e04\u0e33\u0e1a\u0e23\u0e23\u0e22\u0e32\u0e22\u0e41\u0e17\u0e19\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "CAST",
                    "\u0e41\u0e04\u0e2a\u0e15\u0e4c..."
                ],
                [
                    "CHAPTERS",
                    "\u0e1a\u0e17"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e40\u0e1f\u0e23\u0e21\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e41\u0e1a\u0e1a\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u0e2b\u0e22\u0e38\u0e14\u0e27\u0e19\u0e0b\u0e49\u0e33\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "FAST_FORWARD",
                    "\u0e01\u0e23\u0e2d\u0e44\u0e1b\u0e02\u0e49\u0e32\u0e07\u0e2b\u0e19\u0e49\u0e32"
                ],
                [
                    "FULL_SCREEN",
                    "\u0e40\u0e15\u0e47\u0e21\u0e2b\u0e19\u0e49\u0e32\u0e08\u0e2d"
                ],
                [
                    "LANGUAGE",
                    "\u0e20\u0e32\u0e29\u0e32"
                ],
                [
                    "LIVE",
                    "\u0e2a\u0e14"
                ],
                [
                    "LOOP",
                    "\u0e25\u0e39\u0e1b"
                ],
                [
                    "MORE_SETTINGS",
                    "\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u0e2b\u0e25\u0e32\u0e22\u0e20\u0e32\u0e29\u0e32"
                ],
                [
                    "MUTE",
                    "\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u0e44\u0e21\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07"
                ],
                [
                    "OFF",
                    "\u0e1b\u0e34\u0e14"
                ],
                [
                    "ON",
                    "\u0e40\u0e1b\u0e34\u0e14"
                ],
                [
                    "PAUSE",
                    "\u0e2b\u0e22\u0e38\u0e14\u0e0a\u0e31\u0e48\u0e27\u0e04\u0e23\u0e32\u0e27"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u0e01\u0e32\u0e23\u0e41\u0e2a\u0e14\u0e07\u0e20\u0e32\u0e1e\u0e0b\u0e49\u0e2d\u0e19\u0e20\u0e32\u0e1e"
                ],
                [
                    "PLAY",
                    "\u0e40\u0e25\u0e48\u0e19"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u0e04\u0e27\u0e32\u0e21\u0e40\u0e23\u0e47\u0e27\u0e43\u0e19\u0e01\u0e32\u0e23\u0e40\u0e25\u0e48\u0e19"
                ],
                [
                    "QUALITY",
                    "\u0e04\u0e38\u0e13\u0e20\u0e32\u0e1e"
                ],
                [
                    "RECENTER_VR",
                    "\u0e08\u0e31\u0e14\u0e01\u0e36\u0e48\u0e07\u0e01\u0e25\u0e32\u0e07\u0e43\u0e2b\u0e21\u0e48"
                ],
                [
                    "REPLAY",
                    "\u0e40\u0e25\u0e48\u0e19\u0e0b\u0e49\u0e33"
                ],
                [
                    "RESOLUTION",
                    "\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14"
                ],
                [
                    "REWIND",
                    "\u0e01\u0e23\u0e2d\u0e01\u0e25\u0e31\u0e1a"
                ],
                [
                    "SEEK",
                    "\u0e04\u0e49\u0e19\u0e2b\u0e32"
                ],
                [
                    "SKIP_AD",
                    "\u0e02\u0e49\u0e32\u0e21\u0e42\u0e06\u0e29\u0e13\u0e32"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u0e02\u0e49\u0e32\u0e21\u0e44\u0e1b\u0e17\u0e35\u0e48\u0e01\u0e32\u0e23\u0e16\u0e48\u0e32\u0e22\u0e17\u0e2d\u0e14\u0e2a\u0e14"
                ],
                [
                    "STATISTICS",
                    "\u0e2a\u0e16\u0e34\u0e15\u0e34"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u0e1a\u0e31\u0e07\u0e04\u0e31\u0e1a"
                ],
                [
                    "SURROUND",
                    "\u0e40\u0e0b\u0e2d\u0e23\u0e4c\u0e23\u0e32\u0e27\u0e14\u0e4c"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u0e40\u0e1b\u0e34\u0e14/\u0e1b\u0e34\u0e14\u0e1f\u0e35\u0e40\u0e08\u0e2d\u0e23\u0e4c\u0e2a\u0e32\u0e21\u0e21\u0e34\u0e15\u0e34"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u0e44\u0e21\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14"
                ],
                [
                    "UNMUTE",
                    "\u0e40\u0e1b\u0e34\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u0e17\u0e35\u0e48\u0e44\u0e21\u0e48\u0e23\u0e39\u0e49\u0e08\u0e31\u0e01"
                ],
                [
                    "VOLUME",
                    "\u0e23\u0e30\u0e14\u0e31\u0e1a\u0e40\u0e2a\u0e35\u0e22\u0e07"
                ]
            ]));
            a.Ya("tr", new Map([
                [
                    "AD_DURATION",
                    "Reklam s\u00fcresi"
                ],
                [
                    "AD_PROGRESS",
                    "[AD_ON]/[NUM_ADS] reklam"
                ],
                [
                    "AD_STATISTICS",
                    "Reklam istatistikleri"
                ],
                [
                    "AD_TIME",
                    "Reklam: [AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "Otomatik"
                ],
                [
                    "BACK",
                    "Geri"
                ],
                [
                    "CAPTIONS",
                    "Altyaz\u0131lar"
                ],
                [
                    "CAST",
                    "Yay\u0131nla..."
                ],
                [
                    "CHAPTERS",
                    "B\u00f6l\u00fcmler"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "Video karesini kaydet"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "Mevcut videoyu d\u00f6ng\u00fcye al"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "Pencere i\u00e7inde Pencere moduna gir"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "Tam ekrandan \u00e7\u0131k"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "Mevcut videonun d\u00f6ng\u00fcs\u00fcn\u00fc durdur"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "Pencere \u0130\u00e7inde Pencereden \u00c7\u0131k"
                ],
                [
                    "FAST_FORWARD",
                    "\u0130leri sar"
                ],
                [
                    "FULL_SCREEN",
                    "Tam ekran"
                ],
                [
                    "LANGUAGE",
                    "Dil"
                ],
                [
                    "LIVE",
                    "Canl\u0131"
                ],
                [
                    "LOOP",
                    "D\u00f6ng\u00fc"
                ],
                [
                    "MORE_SETTINGS",
                    "Daha fazla ayar"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "Birden \u00e7ok dil"
                ],
                [
                    "MUTE",
                    "Sesi kapat"
                ],
                [
                    "NOT_APPLICABLE",
                    "Ge\u00e7erli de\u011fil"
                ],
                [
                    "OFF",
                    "Kapal\u0131"
                ],
                [
                    "ON",
                    "A\u00e7\u0131k"
                ],
                [
                    "PAUSE",
                    "Duraklat"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "Pencere \u0130\u00e7inde Pencere"
                ],
                [
                    "PLAY",
                    "Oynat"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u00c7alma h\u0131z\u0131"
                ],
                [
                    "QUALITY",
                    "Kalite"
                ],
                [
                    "RECENTER_VR",
                    "Ortala"
                ],
                [
                    "REPLAY",
                    "Tekrar Oynat"
                ],
                [
                    "RESOLUTION",
                    "\u00c7\u00f6z\u00fcn\u00fcrl\u00fck"
                ],
                [
                    "REWIND",
                    "Geri sar"
                ],
                [
                    "SEEK",
                    "Ara"
                ],
                [
                    "SKIP_AD",
                    "Reklam\u0131 Atla"
                ],
                [
                    "SKIP_TO_LIVE",
                    "Canl\u0131 yay\u0131na atla"
                ],
                [
                    "STATISTICS",
                    "\u0130statistikler"
                ],
                [
                    "SUBTITLE_FORCED",
                    "Zorunlu"
                ],
                [
                    "SURROUND",
                    "Surround"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "Stereoskopik modu a\u00e7/kapat"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "Belirsiz"
                ],
                [
                    "UNMUTE",
                    "Sesi a\u00e7"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "Tan\u0131nmayan"
                ],
                [
                    "VOLUME",
                    "Ses"
                ]
            ]));
            a.Ya("zh", new Map([
                [
                    "AD_DURATION",
                    "\u5e7f\u544a\u6301\u7eed\u65f6\u95f4"
                ],
                [
                    "AD_PROGRESS",
                    "\u5e7f\u544a [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u5e7f\u544a\u7edf\u8ba1\u4fe1\u606f"
                ],
                [
                    "AD_TIME",
                    "\u5e7f\u544a\uff1a[AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52a8"
                ],
                [
                    "BACK",
                    "\u8fd4\u56de"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u6295\u653e\u2026"
                ],
                [
                    "CHAPTERS",
                    "\u7ae0\u8282"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u4fdd\u5b58\u89c6\u9891\u5e27"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u8fdb\u5165\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u9000\u51fa\u5168\u5c4f\u6a21\u5f0f"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u505c\u6b62\u5faa\u73af\u64ad\u653e\u5f53\u524d\u89c6\u9891"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u9000\u51fa\u201c\u753b\u4e2d\u753b\u201d\u6a21\u5f0f"
                ],
                [
                    "FAST_FORWARD",
                    "\u5feb\u8fdb"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u5c4f"
                ],
                [
                    "LANGUAGE",
                    "\u8bed\u8a00"
                ],
                [
                    "LIVE",
                    "\u76f4\u64ad"
                ],
                [
                    "LOOP",
                    "\u5faa\u73af\u64ad\u653e"
                ],
                [
                    "MORE_SETTINGS",
                    "\u66f4\u591a\u8bbe\u7f6e"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u79cd\u8bed\u8a00"
                ],
                [
                    "MUTE",
                    "\u9759\u97f3"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u4e0d\u9002\u7528"
                ],
                [
                    "OFF",
                    "\u5173\u95ed"
                ],
                [
                    "ON",
                    "\u5f00\u542f"
                ],
                [
                    "PAUSE",
                    "\u6682\u505c"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u753b\u4e2d\u753b"
                ],
                [
                    "PLAY",
                    "\u64ad\u653e"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u64ad\u653e\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u753b\u8d28"
                ],
                [
                    "RECENTER_VR",
                    "\u91cd\u65b0\u7f6e\u4e2d"
                ],
                [
                    "REPLAY",
                    "\u91cd\u653e"
                ],
                [
                    "RESOLUTION",
                    "\u5206\u8fa8\u7387"
                ],
                [
                    "REWIND",
                    "\u5feb\u9000"
                ],
                [
                    "SEEK",
                    "\u8fdb\u5ea6"
                ],
                [
                    "SKIP_AD",
                    "\u8df3\u8fc7\u5e7f\u544a"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"
                ],
                [
                    "STATISTICS",
                    "\u7edf\u8ba1\u4fe1\u606f"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5df2\u5f3a\u5236\u663e\u793a"
                ],
                [
                    "SURROUND",
                    "\u73af\u7ed5\u58f0"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u5207\u6362\u7acb\u4f53\u58f0"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u672a\u786e\u5b9a"
                ],
                [
                    "UNMUTE",
                    "\u53d6\u6d88\u9759\u97f3"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u65e0\u6cd5\u8bc6\u522b"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Ya("zh-TW", new Map([
                [
                    "AD_DURATION",
                    "\u5ee3\u544a\u9577\u5ea6"
                ],
                [
                    "AD_PROGRESS",
                    "\u5ee3\u544a [AD_ON]/[NUM_ADS]"
                ],
                [
                    "AD_STATISTICS",
                    "\u5ee3\u544a\u7d71\u8a08\u8cc7\u6599"
                ],
                [
                    "AD_TIME",
                    "\u5ee3\u544a\uff1a[AD_TIME]"
                ],
                [
                    "AIRPLAY",
                    "AirPlay"
                ],
                [
                    "AUTO_QUALITY",
                    "\u81ea\u52d5"
                ],
                [
                    "BACK",
                    "\u8fd4\u56de"
                ],
                [
                    "CAPTIONS",
                    "\u5b57\u5e55"
                ],
                [
                    "CAST",
                    "\u6295\u653e..."
                ],
                [
                    "CHAPTERS",
                    "\u7ae0\u7bc0"
                ],
                [
                    "DOWNLOAD_VIDEO_FRAME",
                    "\u5132\u5b58\u5f71\u7247\u5f71\u683c"
                ],
                [
                    "ENTER_LOOP_MODE",
                    "\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"
                ],
                [
                    "ENTER_PICTURE_IN_PICTURE",
                    "\u9032\u5165\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "EXIT_FULL_SCREEN",
                    "\u9000\u51fa\u5168\u87a2\u5e55\u6a21\u5f0f"
                ],
                [
                    "EXIT_LOOP_MODE",
                    "\u505c\u6b62\u5faa\u74b0\u64ad\u653e\u76ee\u524d\u7684\u5f71\u7247"
                ],
                [
                    "EXIT_PICTURE_IN_PICTURE",
                    "\u96e2\u958b\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "FAST_FORWARD",
                    "\u5feb\u8f49"
                ],
                [
                    "FULL_SCREEN",
                    "\u5168\u87a2\u5e55"
                ],
                [
                    "LANGUAGE",
                    "\u8a9e\u8a00"
                ],
                [
                    "LIVE",
                    "\u76f4\u64ad"
                ],
                [
                    "LOOP",
                    "\u5faa\u74b0\u64ad\u653e"
                ],
                [
                    "MORE_SETTINGS",
                    "\u986f\u793a\u66f4\u591a\u8a2d\u5b9a"
                ],
                [
                    "MULTIPLE_LANGUAGES",
                    "\u591a\u7a2e\u8a9e\u8a00"
                ],
                [
                    "MUTE",
                    "\u975c\u97f3"
                ],
                [
                    "NOT_APPLICABLE",
                    "\u4e0d\u9069\u7528"
                ],
                [
                    "OFF",
                    "\u95dc\u9589"
                ],
                [
                    "ON",
                    "\u958b\u555f"
                ],
                [
                    "PAUSE",
                    "\u66ab\u505c"
                ],
                [
                    "PICTURE_IN_PICTURE",
                    "\u5b50\u6bcd\u756b\u9762"
                ],
                [
                    "PLAY",
                    "\u64ad\u653e"
                ],
                [
                    "PLAYBACK_RATE",
                    "\u64ad\u653e\u901f\u5ea6"
                ],
                [
                    "QUALITY",
                    "\u97f3\u8cea"
                ],
                [
                    "RECENTER_VR",
                    "\u91cd\u65b0\u7f6e\u4e2d"
                ],
                [
                    "REPLAY",
                    "\u91cd\u64ad"
                ],
                [
                    "RESOLUTION",
                    "\u89e3\u6790\u5ea6"
                ],
                [
                    "REWIND",
                    "\u5012\u8f49"
                ],
                [
                    "SEEK",
                    "\u641c\u5c0b"
                ],
                [
                    "SKIP_AD",
                    "\u7565\u904e\u5ee3\u544a"
                ],
                [
                    "SKIP_TO_LIVE",
                    "\u8df3\u81f3\u5f53\u524d\u76f4\u64ad"
                ],
                [
                    "STATISTICS",
                    "\u7d71\u8a08\u8cc7\u6599"
                ],
                [
                    "SUBTITLE_FORCED",
                    "\u5f37\u5236\u986f\u793a"
                ],
                [
                    "SURROUND",
                    "\u74b0\u5834\u97f3\u6548"
                ],
                [
                    "TOGGLE_STEREOSCOPIC",
                    "\u5207\u63db\u7acb\u9ad4\u5f71\u50cf"
                ],
                [
                    "UNDETERMINED_LANGUAGE",
                    "\u4e0d\u660e"
                ],
                [
                    "UNMUTE",
                    "\u53d6\u6d88\u975c\u97f3"
                ],
                [
                    "UNRECOGNIZED_LANGUAGE",
                    "\u7121\u6cd5\u8fa8\u8b58"
                ],
                [
                    "VOLUME",
                    "\u97f3\u91cf"
                ]
            ]));
            a.Pi(navigator.languages || []);
            return a;
        }
        O("shaka.ui.Controls", Y);
        Y.prototype.incrementRoll = Y.prototype.Bh;
        Y.prototype.incrementPitch = Y.prototype.Ah;
        Y.prototype.incrementYaw = Y.prototype.Ch;
        Y.prototype.toggleStereoscopicMode = Y.prototype.Yd;
        Y.prototype.setVRFieldOfView = Y.prototype.zm;
        Y.prototype.getVRFieldOfView = Y.prototype.wl;
        Y.prototype.getVRNorth = Y.prototype.xl;
        Y.prototype.isPlayingVR = Y.prototype.Sb;
        Y.prototype.canPlayVR = Y.prototype.Lg;
        Y.prototype.hideUI = Y.prototype.fj;
        Y.prototype.showUI = Y.prototype.Bm;
        Y.prototype.isOpaque = Y.prototype.Ca;
        Y.prototype.hideAdUI = Y.prototype.ej;
        Y.prototype.showAdUI = Y.prototype.Uj;
        Y.prototype.togglePiP = Y.prototype.Yc;
        Y.prototype.isPiPEnabled = Y.prototype.Id;
        Y.prototype.isPiPAllowed = Y.prototype.Gf;
        Y.prototype.toggleFullScreen = Y.prototype.pg;
        Y.prototype.isFullScreenEnabled = Y.prototype.Jb;
        Y.prototype.isFullScreenSupported = Y.prototype.ue;
        Y.prototype.hideSettingsMenus = Y.prototype.Sc;
        Y.prototype.anySettingsMenusAreOpen = Y.prototype.Jc;
        Y.prototype.setLastTouchEventTime = Y.prototype.Oj;
        Y.prototype.getDisplayTime = Y.prototype.qh;
        Y.prototype.isCastAllowed = Y.prototype.El;
        Y.prototype.setSeeking = Y.prototype.li;
        Y.prototype.isSeeking = Y.prototype.Jl;
        Y.prototype.getConfig = Y.prototype.Kk;
        Y.prototype.getClientSideAdContainer = Y.prototype.Jk;
        Y.prototype.getServerSideAdContainer = Y.prototype.kl;
        Y.prototype.getControlsContainer = Y.prototype.Nk;
        Y.prototype.getLocalPlayer = Y.prototype.Vk;
        Y.prototype.getPlayer = Y.prototype.Rb;
        Y.prototype.getLocalVideo = Y.prototype.Wk;
        Y.prototype.getVideo = Y.prototype.Rc;
        Y.prototype.getVideoContainer = Y.prototype.zl;
        Y.prototype.getLocalization = Y.prototype.Xk;
        Y.prototype.getCastProxy = Y.prototype.Gk;
        Y.prototype.getAd = Y.prototype.getAd;
        Y.prototype.setEnabledNativeControls = Y.prototype.Nj;
        Y.prototype.setEnabledShakaControls = Y.prototype.ji;
        Y.prototype.configure = Y.prototype.configure;
        Y.prototype.loadComplete = Y.prototype.Ml;
        Y.prototype.allowCast = Y.prototype.qk;
        Y.registerSeekBar = function(a) {
            yJ = a;
        };
        Y.registerElement = gJ;
        Y.prototype.destroy = Y.prototype.destroy;
        var hJ = new Map, yJ = new pI;
        function GJ(a, b) {
            function c() {
                return HJ(d);
            }
            IH.call(this, a, b);
            var d = this;
            this.m = this.controls.g;
            this.l = this.controls.i;
            this.o = this.controls.l;
            this.j = [];
            IJ(this);
            this.g = U("div");
            this.g.classList.add("shaka-overflow-menu");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-show-controls-on-mouse-over");
            this.g.classList.add("shaka-hidden");
            this.l.appendChild(this.g);
            JJ(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                KJ(d);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                KJ(d);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                d.ad && d.ad.isLinear() && OH(d.h, !1);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                OH(d.h, !0);
            });
            this.eventManager.u(this.controls, "submenuopen", function() {
                OH(d.g, !1);
            });
            this.eventManager.u(this.g, "touchstart", function(e) {
                d.controls.Oj(Date.now());
                e.stopPropagation();
            });
            this.eventManager.u(this.h, "click", function() {
                d.controls.Ca() && LJ(d);
            });
            KJ(this);
            this.ad && this.ad.isLinear() && OH(this.h, !1);
            this.i = null;
            window1.ResizeObserver ? (this.i = new ResizeObserver(c), this.i.observe(this.controls.l)) : this.eventManager.u(window1, "resize", c);
        }
        oa(GJ, IH);
        GJ.prototype.release = function() {
            this.l = null;
            for(var a = u(this.j), b = a.next(); !b.done; b = a.next())b.value.release();
            this.j = [];
            this.i && (this.i.disconnect(), this.i = null);
            IH.prototype.release.call(this);
        };
        function MJ(a, b) {
            NJ.set(a, b);
        }
        function IJ(a) {
            a.h = ck();
            a.h.classList.add("shaka-overflow-menu-button");
            a.h.classList.add("shaka-no-propagation");
            a.h.classList.add("shaka-tooltip");
            new JH(a.h).use("M433-80q-27 0-46.5-18T363-142l-9-66q-13-5-24.5-12T307-235l-62 26q-25 11-50 2t-39-32l-47-82q-14-23-8-49t27-43l53-40q-1-7-1-13.5v-27q0-6.5 1-13.5l-53-40q-21-17-27-43t8-49l47-82q14-23 39-32t50 2l62 26q11-8 23-15t24-12l9-66q4-26 23.5-44t46.5-18h94q27 0 46.5 18t23.5 44l9 66q13 5 24.5 12t22.5 15l62-26q25-11 50-2t39 32l47 82q14 23 8 49t-27 43l-53 40q1 7 1 13.5v27q0 6.5-2 13.5l53 40q21 17 27 43t-8 49l-48 82q-14 23-39 32t-50-2l-60-26q-11 8-23 15t-24 12l-9 66q-4 26-23.5 44T527-80h-94Zm49-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z");
            var b = U("span");
            b.classList.add("shaka-overflow-quality-mark");
            b.style.display = "none";
            a.h.appendChild(b);
            a.parent.appendChild(a.h);
        }
        function JJ(a) {
            for(var b = u(a.m.overflowMenuButtons), c = b.next(); !c.done; c = b.next())c = c.value, NJ.get(c) ? (c = NJ.get(c), a.j.push(c.create(a.g, a.controls))) : Za("Unrecognized overflow menu element requested:", c);
        }
        function LJ(a) {
            if (a.controls.Jc()) a.controls.Sc();
            else {
                OH(a.g, !0);
                WI(a.controls);
                var b = function(c) {
                    return c.classList.contains("shaka-hidden") == 0;
                };
                ib(a.g.childNodes, b) && jb(a.g.childNodes, b)[0].focus();
                HJ(a);
            }
        }
        function KJ(a) {
            a.h.ariaLabel = a.localization.resolve("MORE_SETTINGS");
        }
        function HJ(a) {
            var b = a.g.getBoundingClientRect(), c = window1.getComputedStyle(a.g), d = parseFloat(c.paddingTop);
            c = parseFloat(c.paddingBottom);
            var e = a.o.getBoundingClientRect();
            a.g.style.maxHeight = b.bottom - e.top - d - c - 5 + "px";
        }
        O("shaka.ui.OverflowMenu", GJ);
        GJ.registerElement = MJ;
        function OJ() {}
        OJ.prototype.create = function(a, b) {
            return new GJ(a, b);
        };
        gJ("overflow_menu", new OJ);
        var NJ = new Map;
        function PJ(a, b) {
            function c(e) {
                return d.i[e];
            }
            IH.call(this, a, b);
            var d = this;
            this.h = ck();
            this.h.classList.add("shaka-ad-statistics-button");
            this.o = new JH(this.h, "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.A = U("span");
            a.appendChild(this.A);
            this.l = U("span");
            this.l.classList.add("shaka-current-selection-span");
            a.appendChild(this.l);
            this.h.appendChild(a);
            this.parent.appendChild(this.h);
            this.g = U("div");
            this.g.classList.add("shaka-no-propagation");
            this.g.classList.add("shaka-show-controls-on-mouse-over");
            this.g.classList.add("shaka-ad-statistics-container");
            this.g.classList.add("shaka-hidden");
            this.controls.i.appendChild(this.g);
            this.D = [];
            this.i = this.adManager.getStats();
            OH(this.h, this.i.started > 0);
            this.m = new Map;
            this.C = (new Map).set("loadTimes", function(e) {
                var f = 0;
                e = u(d.i[e]);
                for(var g = e.next(); !g.done; g = e.next())f += parseFloat(g.value);
                return f;
            }).set("averageLoadTime", c).set("started", c).set("overlayAds", c).set("playedCompletely", c).set("skipped", c).set("errors", c);
            this.j = new Uf(function() {
                d.i = d.adManager.getStats();
                for(var e = u(d.D), f = e.next(); !f.done; f = e.next())f = f.value, d.m.get(f).textContent = d.C.get(f)(f);
            });
            QJ(this);
            RJ(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                QJ(d);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                QJ(d);
            });
            this.eventManager.u(this.h, "click", function() {
                d.controls.Ca() && (SJ(d), QJ(d));
            });
            this.eventManager.u(this.player, "loading", function() {
                OH(d.h, !1);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                OH(d.h, !0);
            });
        }
        oa(PJ, IH);
        function SJ(a) {
            a.g.classList.contains("shaka-hidden") ? (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-440q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.xa(.1), OH(a.g, !0)) : (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.stop(), OH(a.g, !1));
        }
        function QJ(a) {
            a.A.textContent = a.localization.resolve("AD_STATISTICS");
            a.h.ariaLabel = a.localization.resolve("AD_STATISTICS");
            a.l.textContent = a.localization.resolve(a.g.classList.contains("shaka-hidden") ? "OFF" : "ON");
        }
        function TJ(a, b) {
            var c = U("div"), d = U("label");
            d.textContent = b + ":";
            c.appendChild(d);
            d = U("span");
            d.textContent = a.C.get(b)(b);
            c.appendChild(d);
            a.m.set(b, d);
            return c;
        }
        function RJ(a) {
            var b = U("div");
            b.classList.add("shaka-no-propagation");
            b.classList.add("shaka-statistics-close");
            var c = new JH(b, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z").g;
            c.classList.add("material-icons", "notranslate");
            a.g.appendChild(b);
            a.eventManager.u(c, "click", function() {
                SJ(a);
            });
            b = u(a.controls.g.adStatisticsList);
            for(c = b.next(); !c.done; c = b.next())c = c.value, c in a.i ? (a.g.appendChild(TJ(a, c)), a.D.push(c)) : Za("Unrecognized ad statistic element:", c);
        }
        PJ.prototype.release = function() {
            this.j.stop();
            this.j = null;
            IH.prototype.release.call(this);
        };
        O("shaka.ui.AdStatisticsButton", PJ);
        function UJ() {}
        UJ.prototype.create = function(a, b) {
            return new PJ(a, b);
        };
        MJ("ad_statistics", new UJ);
        TH("ad_statistics", new UJ);
        function VJ(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-airplay-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new JH(this.g).use("M80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200h-80q-17 0-28.5-11.5T680-240q0-17 11.5-28.5T720-280h80v-480H160v480h80q17 0 28.5 11.5T280-240q0 17-11.5 28.5T240-200h-80q-33 0-56.5-23.5T80-280Zm232 160q-14 0-22-9.5t-8-20.5q0-5 2-10.5t7-10.5l161-161q6-6 13-9t15-3q8 0 15 3t13 9l161 161q5 5 7 10.5t2 10.5q0 11-8 20.5t-22 9.5H312Zm168-360Z");
            window1.WebKitPlaybackTargetAvailabilityEvent || this.g.classList.add("shaka-hidden");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = U("span");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            WJ(this);
            XJ(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                WJ(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                WJ(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.controls.Rc().webkitShowPlaybackTargetPicker();
            });
            a = this.controls.Rc();
            this.eventManager.u(a, "webkitplaybacktargetavailabilitychanged", function(d) {
                var e = c.player.xc() == fs;
                OH(c.g, d.availability == "available" && e);
            });
            this.eventManager.u(a, "webkitcurrentplaybacktargetiswirelesschanged", function() {
                XJ(c);
            });
        }
        oa(VJ, IH);
        function XJ(a) {
            var b = a.controls.Rc();
            a.g.ariaPressed = b && b.webkitCurrentPlaybackTargetIsWireless ? "true" : "false";
        }
        function WJ(a) {
            a.g.ariaLabel = a.localization.resolve("AIRPLAY");
            a.i.textContent = a.localization.resolve("AIRPLAY");
        }
        O("shaka.ui.AirPlayButton", VJ);
        function YJ() {}
        YJ.prototype.create = function(a, b) {
            return new VJ(a, b);
        };
        MJ("airplay", new YJ);
        gJ("airplay", new YJ);
        function ZJ(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = document.createElement("canvas");
            this.g.style.position = "absolute";
            this.g.style.top = "0";
            this.g.style.left = "0";
            this.g.style.pointerEvents = "none";
            this.parent.appendChild(this.g);
            $J(this);
            this.i = this.h = null;
            window1.ResizeObserver ? (this.i = new ResizeObserver(function() {
                return $J(c);
            }), this.i.observe(this.parent)) : window1.addEventListener("resize", function() {
                return $J(c);
            });
        }
        oa(ZJ, IH);
        function aK(a) {
            return (a = a.g.getContext("2d")) ? a : null;
        }
        function $J(a) {
            a.g.width = a.parent.offsetWidth;
            a.g.height = a.parent.offsetHeight;
        }
        ZJ.prototype.jg = function(a, b) {
            a = {
                type: "static",
                text: a,
                position: "top-right",
                color: "rgba(255, 255, 255, 0.7)",
                size: 20,
                alpha: .7,
                interval: 2E3,
                skip: 500,
                displayDuration: 2E3,
                transitionDuration: .5
            };
            b = Object.assign({}, a, b || a);
            if (b.type === "static") {
                if (a = aK(this)) {
                    a.clearRect(0, 0, this.g.width, this.g.height);
                    a.globalAlpha = b.alpha;
                    a.fillStyle = b.color;
                    a.font = b.size + "px Arial";
                    var c = a.measureText(b.text);
                    switch(b.position){
                        case "top-left":
                            c = 20;
                            var d = b.size + 20;
                            break;
                        case "top-right":
                            c = this.g.width - c.width - 20;
                            d = b.size + 20;
                            break;
                        case "bottom-left":
                            c = 20;
                            d = this.g.height - 20;
                            break;
                        case "bottom-right":
                            c = this.g.width - c.width - 20;
                            d = this.g.height - 20;
                            break;
                        default:
                            c = (this.g.width - c.width) / 2, d = (this.g.height + b.size) / 2;
                    }
                    a.fillText(b.text, c, d);
                }
            } else b.type === "dynamic" && bK(this, b);
        };
        function bK(a, b) {
            function c() {
                if (a.h) {
                    e.clearRect(0, 0, a.g.width, a.g.height);
                    switch(h){
                        case "fadeIn":
                            g = Math.min(b.alpha, g + l);
                            g >= b.alpha && (h = "display");
                            break;
                        case "display":
                            --k <= 0 && (h = "fadeOut");
                            break;
                        case "fadeOut":
                            g = Math.max(0, g - l), g <= 0 && (h = "transition", f = d(), k = Math.round(b.displayDuration * 60), h = "fadeIn");
                    }
                    g > 0 && (e.globalAlpha = g, e.fillStyle = b.color, e.font = b.size + "px Arial", e.fillText(b.text, f.left, f.top));
                    a.h && (a.h = requestAnimationFrame(c));
                }
            }
            function d() {
                e.font = b.size + "px Arial";
                var n = e.measureText(b.text).width, q = b.size;
                n = [
                    {
                        left: 20,
                        top: q + 20
                    },
                    {
                        left: a.g.width - n - 20,
                        top: q + 20
                    },
                    {
                        left: 20,
                        top: a.g.height - 20
                    },
                    {
                        left: a.g.width - n - 20,
                        top: a.g.height - 20
                    },
                    {
                        left: (a.g.width - n) / 2,
                        top: (a.g.height + q) / 2
                    }
                ];
                q = n[m];
                m = (m + 1) % n.length;
                return q;
            }
            var e = a.g.getContext("2d"), f = {
                left: 0,
                top: 0
            }, g = 0, h = "fadeIn", k = Math.round(b.displayDuration * 60), l = 1 / (Math.round(b.transitionDuration * 60) / 2), m = 0;
            f = d();
            a.h = requestAnimationFrame(c);
        }
        ZJ.prototype.$f = function() {
            this.h && (cancelAnimationFrame(this.h), this.h = null);
            var a = aK(this);
            a && a.clearRect(0, 0, this.g.width, this.g.height);
        };
        ZJ.prototype.release = function() {
            var a = this;
            this.g && this.g.parentNode && this.g.parentNode.removeChild(this.g);
            this.i ? (this.i.disconnect(), this.i = null) : window1.removeEventListener("resize", function() {
                return $J(a);
            });
            IH.prototype.release.call(this);
        };
        O("shaka.ui.Watermark", ZJ);
        ZJ.prototype.removeWatermark = ZJ.prototype.$f;
        ZJ.prototype.setTextWatermark = ZJ.prototype.jg;
        function cK(a, b, c, d) {
            d = d === void 0 ? null : d;
            this.j = a;
            this.l = b;
            this.h = dK(this);
            var e = "", f = !1;
            b.dataset && b.dataset.shakaPlayerCastReceiverId ? (f = b.dataset, e = f.shakaPlayerCastReceiverId, f = f.shakaPlayerCastAndroidReceiverCompatible === "true") : c.dataset && c.dataset.shakaPlayerCastReceiverId && (f = c.dataset, e = f.shakaPlayerCastReceiverId, f = f.shakaPlayerCastAndroidReceiverCompatible === "true");
            e.length && (this.h.castReceiverAppId = e, this.h.castAndroidReceiverCompatible = f);
            b.dataset.shakaPlayerContainer = "";
            b.ui = this;
            this.Ih() && b.classList.add("shaka-mobile");
            this.g = new Y(a, b, c, d, this.h);
            c.controls || a.mi(b);
            b.ui = this;
            c.ui = this;
            this.i = null;
        }
        p = cK.prototype;
        p.destroy = function(a) {
            a = a === void 0 ? !1 : a;
            var b = this;
            return H(function(c) {
                if (c.h == 1) return b.g ? c.g(b.g.destroy(a), 2) : c.B(2);
                if (c.h != 4) return b.g = null, b.j ? c.g(b.j.destroy(), 4) : c.B(4);
                b.j = null;
                b.i = null;
                c.j();
            });
        };
        p.Ih = function() {
            return Xb().Pa() == "MOBILE";
        };
        p.Kh = function() {
            return Xb().Pa() == "TV";
        };
        p.getConfiguration = function() {
            var a = dK(this);
            bo(a, this.h, dK(this), {}, "");
            return a;
        };
        p.configure = function(a, b) {
            arguments.length == 2 && typeof a == "string" && (a = co(a, b));
            var c = Object.assign({}, this.h);
            bo(c, a, dK(this), {}, "");
            var d = fo(c, this.h);
            if (Object.keys(d).length && (this.h = c, this.g.configure(this.h), this.g.dispatchEvent(new R("uiupdated")), (c = this.h.castSenderUrl) && this.h.castReceiverAppId && window1.chrome && !chrome.cast && !this.Kh())) {
                d = !1;
                for(var e = u(document.getElementsByTagName("script")), f = e.next(); !f.done; f = e.next())if (f.value.src === c) {
                    d = !0;
                    break;
                }
                d || (d = document.createElement("script"), d.src = c, d.defer = !0, document.head.appendChild(d));
            }
        };
        p.Mk = function() {
            return this.g;
        };
        p.xm = function(a) {
            this.g.ji(a);
        };
        p.jg = function(a, b) {
            a && !this.i && this.l && this.g && (this.i = new ZJ(this.l, this.g));
            this.i && this.i.jg(a, b);
        };
        p.$f = function() {
            this.i && this.i.$f();
        };
        function dK(a) {
            var b = "play_pause skip_previous skip_next mute_volume time_and_duration spacer overflow_menu".split(" ");
            window1.chrome && b.push("cast");
            "remote" in HTMLMediaElement.prototype ? b.push("remote") : window1.WebKitPlaybackTargetAvailabilityEvent && b.push("airplay");
            b.push("fullscreen");
            b = {
                controlPanelElements: b,
                overflowMenuButtons: "captions quality language chapter picture_in_picture playback_rate recenter_vr toggle_stereoscopic".split(" "),
                statisticsList: "width height currentCodecs corruptedFrames decodedFrames droppedFrames drmTimeSeconds licenseTime liveLatency loadLatency bufferingTime manifestTimeSeconds estimatedBandwidth streamBandwidth maxSegmentDuration pauseTime playTime completionPercent manifestSizeBytes bytesDownloaded nonFatalErrorCount manifestPeriodCount manifestGapCount".split(" "),
                adStatisticsList: "loadTimes averageLoadTime started overlayAds playedCompletely skipped errors".split(" "),
                contextMenuElements: [
                    "loop",
                    "picture_in_picture",
                    "save_video_frame",
                    "statistics",
                    "ad_statistics"
                ],
                playbackRates: [
                    .5,
                    .75,
                    1,
                    1.25,
                    1.5,
                    1.75,
                    2
                ],
                fastForwardRates: [
                    2,
                    4,
                    8,
                    1
                ],
                rewindRates: [
                    -1,
                    -2,
                    -4,
                    -8
                ],
                addSeekBar: !0,
                addBigPlayButton: !1,
                customContextMenu: !1,
                castReceiverAppId: "",
                castAndroidReceiverCompatible: !1,
                clearBufferOnQualityChange: !0,
                showUnbufferedStart: !1,
                seekBarColors: {
                    base: "rgba(255, 255, 255, 0.3)",
                    buffered: "rgba(255, 255, 255, 0.54)",
                    played: "rgb(255, 255, 255)",
                    adBreaks: "rgb(255, 204, 0)"
                },
                volumeBarColors: {
                    base: "rgba(255, 255, 255, 0.54)",
                    level: "rgb(255, 255, 255)"
                },
                qualityMarks: {
                    720: "",
                    1080: "HD",
                    1440: "2K",
                    2160: "4K",
                    4320: "8K"
                },
                trackLabelFormat: eK,
                textTrackLabelFormat: eK,
                fadeDelay: 0,
                closeMenusDelay: 2,
                doubleClickForFullscreen: !0,
                singleClickForPlayAndPause: !0,
                enableKeyboardPlaybackControls: !0,
                enableFullscreenOnRotation: !1,
                forceLandscapeOnFullscreen: !1,
                enableTooltips: !0,
                keyboardSeekDistance: 5,
                keyboardLargeSeekDistance: 60,
                fullScreenElement: a.l,
                preferDocumentPictureInPicture: !0,
                showAudioChannelCountVariants: !0,
                seekOnTaps: !1,
                tapSeekDistance: 10,
                refreshTickInSeconds: .125,
                displayInVrMode: !1,
                defaultVrProjectionMode: "equirectangular",
                setupMediaSession: !0,
                preferVideoFullScreenInVisionOS: !0,
                showAudioCodec: !0,
                showVideoCodec: !0,
                castSenderUrl: "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js",
                enableKeyboardPlaybackControlsInWindow: !1,
                alwaysShowVolumeBar: !1
            };
            if (a.Ih()) {
                b.addBigPlayButton = !0;
                b.singleClickForPlayAndPause = !1;
                b.seekOnTaps = !0;
                b.enableTooltips = !1;
                b.doubleClickForFullscreen = !1;
                a = Xb();
                b.enableFullscreenOnRotation = a.Ma() !== "WEBKIT";
                b.forceLandscapeOnFullscreen = !0;
                var c = [
                    "play_pause",
                    "skip_previous",
                    "skip_next",
                    "volume"
                ];
                b.controlPanelElements = b.controlPanelElements.filter(function(e) {
                    return !c.includes(e);
                });
                b.overflowMenuButtons = b.overflowMenuButtons.filter(function(e) {
                    return !c.includes(e);
                });
                b.contextMenuElements = b.contextMenuElements.filter(function(e) {
                    return !c.includes(e);
                });
            } else if (a.Kh()) {
                b.addBigPlayButton = !0;
                b.singleClickForPlayAndPause = !1;
                b.enableTooltips = !1;
                b.doubleClickForFullscreen = !1;
                var d = "play_pause cast remote airplay volume save_video_frame".split(" ");
                b.controlPanelElements = b.controlPanelElements.filter(function(e) {
                    return !d.includes(e);
                });
                b.overflowMenuButtons = b.overflowMenuButtons.filter(function(e) {
                    return !d.includes(e);
                });
                b.contextMenuElements = b.contextMenuElements.filter(function(e) {
                    return !d.includes(e);
                });
            }
            return b;
        }
        function fK() {
            var a, b, c, d, e, f, g, h, k, l, m, n, q, r, t, v, w, x, y, z, A, E;
            return H(function(C) {
                switch(C.h){
                    case 1:
                        ND();
                        if (!Cr()) return gK("shaka-ui-load-failed", hK), C.return();
                        a = document.querySelectorAll("[data-shaka-player-container]");
                        b = document.querySelectorAll("[data-shaka-player]");
                        c = document.querySelectorAll("[data-shaka-player-canvas]");
                        d = document.querySelectorAll("[data-shaka-player-vr-canvas]");
                        if (!b.length && !a.length) {
                            C.B(2);
                            break;
                        }
                        if (b.length && !a.length) {
                            C.B(3);
                            break;
                        }
                        e = u(a);
                        f = e.next();
                    case 5:
                        if (f.done) {
                            C.B(2);
                            break;
                        }
                        g = f.value;
                        if (g.ui) {
                            C.B(6);
                            break;
                        }
                        h = null;
                        k = u(b);
                        for(l = k.next(); !l.done; l = k.next())if (m = l.value, m.parentElement == g) {
                            h = m;
                            break;
                        }
                        h || (h = document.createElement("video"), h.setAttribute("playsinline", ""), g.appendChild(h));
                        n = iK(g, c, d);
                        q = n.mj;
                        r = n.lk;
                        C.m(8);
                        return C.g(jK(g, h, q, r), 10);
                    case 10:
                        C.o(6);
                        break;
                    case 8:
                        return C.l(), gK("shaka-ui-load-failed", kK), C.return();
                    case 6:
                        f = e.next();
                        C.B(5);
                        break;
                    case 3:
                        t = u(b), v = t.next();
                    case 11:
                        if (v.done) {
                            C.B(2);
                            break;
                        }
                        w = v.value;
                        if (w.ui) {
                            C.B(12);
                            break;
                        }
                        x = document.createElement("div");
                        y = w.parentElement;
                        y.replaceChild(x, w);
                        x.appendChild(w);
                        z = iK(x, c, d);
                        A = z.mj;
                        E = z.lk;
                        C.m(14);
                        return C.g(jK(x, w, A, E), 16);
                    case 16:
                        C.o(12);
                        break;
                    case 14:
                        return C.l(), gK("shaka-ui-load-failed", kK), C.return();
                    case 12:
                        v = t.next();
                        C.B(11);
                        break;
                    case 2:
                        gK("shaka-ui-loaded"), C.j();
                }
            });
        }
        function gK(a, b) {
            var c = null;
            b != void 0 && (c = {
                reasonCode: b
            });
            a = new CustomEvent(a, {
                detail: c
            });
            document.dispatchEvent(a);
        }
        function jK(a, b, c, d) {
            var e, f, g, h, k, l, m, n, q, r;
            return H(function(t) {
                switch(t.h){
                    case 1:
                        e = new W;
                        f = [];
                        if (g = b.getAttribute("src")) f.push(g), b.removeAttribute("src");
                        h = u(b.getElementsByTagName("source"));
                        for(k = h.next(); !k.done; k = h.next())l = k.value, f.push(l.src), b.removeChild(l);
                        return t.g(e.Ob(b), 2);
                    case 2:
                        e.Ji(c), m = new cK(e, a, b, d ? d : null), b.controls && m.g.Nj(!0), n = u(f), q = n.next();
                    case 3:
                        if (q.done) {
                            t.B(0);
                            break;
                        }
                        r = q.value;
                        t.m(6);
                        return t.g(m.g.Rb().load(r), 8);
                    case 8:
                        t.B(0);
                        break;
                    case 6:
                        t.l();
                    case 4:
                        q = n.next(), t.B(3);
                }
            });
        }
        function iK(a, b, c) {
            var d = null;
            b = u(b);
            for(var e = b.next(); !e.done; e = b.next())if (e = e.value, e.parentElement == a) {
                d = e;
                break;
            }
            d || (d = document.createElement("canvas"), d.classList.add("shaka-canvas-container"), a.appendChild(d));
            b = null;
            c = u(c);
            for(e = c.next(); !e.done; e = c.next())if (e = e.value, e.parentElement == a) {
                b = e;
                break;
            }
            return {
                mj: d,
                lk: b
            };
        }
        O("shaka.ui.Overlay", cK);
        cK.prototype.removeWatermark = cK.prototype.$f;
        cK.prototype.setTextWatermark = cK.prototype.jg;
        cK.prototype.setEnabled = cK.prototype.xm;
        cK.prototype.getControls = cK.prototype.Mk;
        cK.prototype.configure = cK.prototype.configure;
        cK.prototype.getConfiguration = cK.prototype.getConfiguration;
        cK.prototype.isSmartTV = cK.prototype.Kh;
        cK.prototype.isMobile = cK.prototype.Ih;
        cK.prototype.destroy = cK.prototype.destroy;
        var eK = 0;
        cK.TrackLabelFormat = {
            LANGUAGE: eK,
            ROLE: 1,
            LANGUAGE_ROLE: 2,
            LABEL: 3
        };
        var hK = 0, kK = 1;
        cK.FailReasonCode = {
            NO_BROWSER_SUPPORT: hK,
            PLAYER_FAILED_TO_LOAD: kK
        };
        document.readyState == "complete" ? H(function(a) {
            if (a.h == 1) return a.g(Promise.resolve(), 2);
            fK();
            a.j();
        }) : window1.addEventListener("load", fK);
        function lK(a) {
            function b(d) {
                return {
                    codecs: d.codecs,
                    channelCount: d.channelCount,
                    language: d.language,
                    roles: d.roles,
                    spatialAudio: d.spatialAudio
                };
            }
            var c = b(a[0]);
            return a.every(function(d) {
                return JSON.stringify(b(d)) === JSON.stringify(c);
            });
        }
        function mK(a, b, c, d, e, f, g, h) {
            function k(F) {
                var I = "";
                F == "aac" ? I = "AAC" : F === "ac-3" ? I = "Dolby" : F === "ec-3" ? I = "DD+" : F === "ac-4" ? I = "Dolby AC-4" : F === "opus" ? I = "Opus" : F === "flac" && (I = "fLaC");
                return I ? " " + I : I;
            }
            function l(F) {
                var I = "";
                F >= 5 && (I = " " + e.resolve("SURROUND"));
                return I;
            }
            function m(F, I, K, N, P, M) {
                I = [
                    F,
                    I,
                    M
                ];
                g && N != null && I.push(N);
                h && n(F) && P && I.push(P);
                K && f == 3 && I.push(K);
                return I.join(": ");
            }
            function n(F) {
                return r.has(F) && r.get(F).size > 1;
            }
            var q = a.find(function(F) {
                return F.active == 1;
            });
            a.length > 1 && a[0].label && f != 3 && lK(a) && (f = 3);
            for(var r = new Map, t = u(a), v = t.next(); !v.done; v = t.next())v = v.value, v.codecs && (r.has(v.language) || r.set(v.language, new Set), r.get(v.language).add(Cf(v.codecs)));
            t = KH(b);
            gk(b);
            b.appendChild(t);
            t = new Set;
            q = q ? m(q.language, q.roles.join(", "), q.label, q.channelsCount, q.codecs && Cf(q.codecs), q.spatialAudio) : "";
            a = u(a);
            var w = a.next();
            for(v = {}; !w.done; v = {
                Xb: void 0
            }, w = a.next()){
                v.Xb = w.value;
                w = v.Xb.language;
                var x = v.Xb.roles.join(", "), y = v.Xb.label, z = v.Xb.channelsCount, A = v.Xb.codecs && Cf(v.Xb.codecs), E = v.Xb.spatialAudio, C = m(w, x, y, z, A, E);
                if (!t.has(C)) {
                    t.add(C);
                    var D = ck();
                    D.addEventListener("click", function(F) {
                        return function() {
                            c(F.Xb);
                        };
                    }(v));
                    var B = U("span");
                    D.appendChild(B);
                    B.textContent = nK(w, e);
                    var J = "";
                    h && g && E && (A == "ec-3" || A == "ac-4") ? J += " Dolby Atmos" : (h && n(w) && (J += k(A)), g && (J += l(z)));
                    switch(f){
                        case eK:
                            B.textContent += J;
                            break;
                        case 1:
                            B.textContent += J;
                            x ? B.textContent = x : (Za("Track #" + JSON.stringify(v.Xb) + " does not have a role, but the UI is configured to only show role."), B.textContent = "?");
                            break;
                        case 2:
                            B.textContent += J;
                            x && (B.textContent += ": " + x);
                            break;
                        case 3:
                            y ? B.textContent = y : (Za("Track #" + JSON.stringify(v.Xb) + " does not have a label, but the UI is configured to only show labels."), B.textContent = "?");
                    }
                    C == q && (D.appendChild(NH()), B.classList.add("shaka-chosen-item"), D.ariaSelected = "true", d.textContent = B.textContent);
                    b.appendChild(D);
                }
            }
        }
        function oK(a, b, c, d, e, f, g) {
            function h(z, A, E, C) {
                z = [
                    z,
                    A,
                    C
                ];
                E && g == 3 && z.push(E);
                return z.join(": ");
            }
            var k = a.find(function(z) {
                return z.active == 1;
            }), l = KH(b);
            gk(b);
            b.appendChild(l);
            l = new Set;
            k = k ? h(k.language, k.roles.join(", "), k.label, k.forced) : "";
            a = u(a);
            for(var m = a.next(), n = {}; !m.done; n = {
                Zc: void 0
            }, m = a.next()){
                n.Zc = m.value;
                m = n.Zc.language;
                var q = n.Zc.forced, r = f.resolve("SUBTITLE_FORCED"), t = n.Zc.roles.join(", "), v = n.Zc.label, w = h(m, t, v, q);
                if (!l.has(w)) {
                    l.add(w);
                    var x = ck();
                    x.addEventListener("click", function(z) {
                        return function() {
                            c(z.Zc);
                        };
                    }(n));
                    var y = U("span");
                    x.appendChild(y);
                    y.textContent = nK(m, f);
                    switch(g){
                        case eK:
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 1:
                            t ? y.textContent = t : (Za("Track #" + n.Zc.id + " does not have a role, but the UI is configured to only show role."), y.textContent = "?");
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 2:
                            t && (y.textContent += ": " + t);
                            q && (y.textContent += " (" + r + ")");
                            break;
                        case 3:
                            v ? y.textContent = v : (Za("Track #" + n.Zc.id + " does not have a label, but the UI is configured to only show labels."), y.textContent = "?");
                    }
                    d && w == k && (x.appendChild(NH()), y.classList.add("shaka-chosen-item"), x.ariaSelected = "true", e.textContent = y.textContent);
                    b.appendChild(x);
                }
            }
        }
        function nK(a, b) {
            if (!a && !b) return "";
            switch(a){
                case "mul":
                    return b.resolve("MULTIPLE_LANGUAGES");
                case "und":
                    return b.resolve("UNDETERMINED_LANGUAGE");
                case "zxx":
                    return b.resolve("NOT_APPLICABLE");
            }
            var c = Pc(a);
            return a in rp ? rp[a] : c in rp ? rp[c] + " (" + a + ")" : b.resolve("UNRECOGNIZED_LANGUAGE") + " (" + a + ")";
        }
        function pK(a, b, c) {
            function d() {
                return qK(e);
            }
            IH.call(this, a, b);
            var e = this;
            this.m = this.controls.l;
            rK(this, c);
            sK(this);
            tK(this);
            this.eventManager.u(this.button, "click", function() {
                e.controls.Ca() && (e.menu.classList.contains("shaka-hidden") ? (e.controls.dispatchEvent(new R("submenuopen")), OH(e.menu, !0), MH(e.menu), qK(e)) : OH(e.menu, !1));
            });
            this.j = null;
            window1.ResizeObserver ? (this.j = new ResizeObserver(d), this.j.observe(this.controls.l)) : this.eventManager.u(window1, "resize", d);
        }
        oa(pK, IH);
        pK.prototype.release = function() {
            this.j && (this.j.disconnect(), this.j = null);
            IH.prototype.release.call(this);
        };
        function rK(a, b) {
            a.button = ck();
            a.button.classList.add("shaka-overflow-button");
            a.icon = new JH(a.button, b);
            b = U("label");
            b.classList.add("shaka-overflow-button-label");
            b.classList.add("shaka-overflow-menu-only");
            b.classList.add("shaka-overflow-button-label-inline");
            a.nameSpan = U("span");
            b.appendChild(a.nameSpan);
            a.currentSelection = U("span");
            a.currentSelection.classList.add("shaka-current-selection-span");
            b.appendChild(a.currentSelection);
            a.button.appendChild(b);
            a.parent.appendChild(a.button);
        }
        function sK(a) {
            a.menu = U("div");
            a.menu.classList.add("shaka-no-propagation");
            a.menu.classList.add("shaka-show-controls-on-mouse-over");
            a.menu.classList.add("shaka-settings-menu");
            a.menu.classList.add("shaka-hidden");
            a.backButton = ck();
            a.backButton.classList.add("shaka-back-to-overflow-button");
            a.menu.appendChild(a.backButton);
            a.eventManager.u(a.backButton, "click", function() {
                a.controls.Sc();
            });
            a.o = new JH(a.backButton, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z");
            a.backSpan = U("span");
            a.backButton.appendChild(a.backSpan);
            a.controls.i.appendChild(a.menu);
        }
        function tK(a) {
            a.parent.classList.contains("shaka-overflow-menu") && (a.o.use("m432-480 156 156q11 11 11 28t-11 28q-11 11-28 11t-28-11L348-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l184-184q11-11 28-11t28 11q11 11 11 28t-11 28L432-480Z"), a.eventManager.u(a.menu, "click", function() {
                function b(c) {
                    return c.classList.contains("shaka-hidden") == 0;
                }
                OH(a.menu, !1);
                OH(a.parent, !0);
                ib(a.parent.childNodes, b) && jb(a.parent.childNodes, b)[0].focus();
                WI(a.controls);
                qK(a);
            }));
        }
        function qK(a) {
            var b = a.menu.getBoundingClientRect(), c = window1.getComputedStyle(a.menu), d = parseFloat(c.paddingTop);
            c = parseFloat(c.paddingBottom);
            var e = a.m.getBoundingClientRect();
            a.menu.style.maxHeight = b.bottom - e.top - d - c - 5 + "px";
        }
        O("shaka.ui.SettingsMenu", pK);
        function uK(a, b) {
            pK.call(this, a, b, "M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Zm0-82q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z");
            var c = this;
            this.button.classList.add("shaka-language-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-audio-languages");
            this.eventManager.u(this.localization, "locale-updated", function() {
                vK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                vK(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                wK(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                wK(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                wK(c);
            });
            this.eventManager.u(this.player, "audiotrackschanged", function() {
                wK(c);
            });
            vK(this);
            wK(this);
        }
        oa(uK, pK);
        function wK(a) {
            var b = a.player.getAudioTracks() || [];
            mK(b, a.menu, function(c) {
                a.player.Jj(c);
                var d = {
                    preferredAudioLanguage: c.language,
                    preferSpatialAudio: c.spatialAudio
                };
                c.label && (d.preferredAudioLabel = c.label);
                c.channelsCount && (d.preferredAudioChannelCount = c.channelsCount);
                a.player.configure(d);
            }, a.currentSelection, a.localization, a.controls.g.trackLabelFormat, a.controls.g.showAudioChannelCountVariants, a.controls.g.showAudioCodec);
            MH(a.menu);
            a.controls.dispatchEvent(new R("languageselectionupdated"));
            a.button.setAttribute("shaka-status", a.currentSelection.innerText);
            OH(a.button, a.menu.getElementsByTagName("button").length > 2);
        }
        function vK(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("LANGUAGE");
            a.nameSpan.textContent = a.localization.resolve("LANGUAGE");
            a.backSpan.textContent = a.localization.resolve("LANGUAGE");
        }
        O("shaka.ui.AudioLanguageSelection", uK);
        function xK() {}
        xK.prototype.create = function(a, b) {
            return new uK(a, b);
        };
        MJ("language", new xK);
        gJ("language", new xK);
        function yK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.h = this.controls.F;
            this.g = ck();
            this.g.classList.add("shaka-cast-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            this.l = new JH(this.g, "M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.j = U("span");
            a.appendChild(this.j);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            zK(this);
            AK(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                zK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                zK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && BK(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                AK(c);
            });
        }
        oa(yK, IH);
        function BK(a) {
            var b;
            H(function(c) {
                if (c.h == 1) {
                    if (a.h.Qa()) return a.h.Yj(), c.B(0);
                    c.m(3);
                    a.g.disabled = !0;
                    return c.g(a.h.cast(), 5);
                }
                if (c.h != 3) return a.g.disabled = !1, c.o(0);
                b = c.l();
                a.g.disabled = !1;
                b.code != 8004 && a.controls.dispatchEvent(new R("error", (new Map).set("detail", b)));
                c.j();
            });
        }
        function AK(a) {
            var b = a.h.Kg() && a.controls.va, c = a.h.Qa();
            OH(a.g, b);
            a.l.use(c ? "M720-600v240q0 17-11.5 28.5T680-320h-87q-8 0-14.5-4.5T569-337q-29-81-81.5-147T364-596q-16-10-11.5-27t21.5-17h306q17 0 28.5 11.5T720-600ZM320-160q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125.5T518-201q2 17-9.5 29T480-160Zm-340 0q-25 0-42.5-17.5T80-220q0-25 17.5-42.5T140-280q25 0 42.5 17.5T200-220q0 25-17.5 42.5T140-160Zm740-560v480q0 33-23.5 56.5T800-160H638q-17 0-28.5-11.5T598-200q0-17 11.5-28.5T638-240h162v-480H160v6q0 17-11.5 28.5T120-674q-17 0-28.5-11.5T80-714v-6q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720Z" : "M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z");
            b && (a.g.ariaPressed = c ? "true" : "false");
            CK(a);
        }
        function CK(a) {
            a.i.textContent = a.h.Qa() ? a.h.Yf() : a.localization.resolve("OFF");
        }
        function zK(a) {
            a.g.ariaLabel = a.localization.resolve("CAST");
            a.j.textContent = a.localization.resolve("CAST");
            CK(a);
        }
        O("shaka.ui.CastButton", yK);
        function DK() {}
        DK.prototype.create = function(a, b) {
            return new yK(a, b);
        };
        MJ("cast", new DK);
        gJ("cast", new DK);
        function EK(a, b) {
            pK.call(this, a, b, "m400-200-182 91q-20 10-39-1.5T160-145v-495q0-33 23.5-56.5T240-720h320q33 0 56.5 23.5T640-640v495q0 23-19 34.5t-39 1.5l-182-91Zm360-40q-17 0-28.5-11.5T720-280v-520H320q-17 0-28.5-11.5T280-840q0-17 11.5-28.5T320-880h400q33 0 56.5 23.5T800-800v520q0 17-11.5 28.5T760-240Z");
            var c = this;
            this.button.classList.add("shaka-chapter-button");
            this.menu.classList.add("shaka-chapters");
            this.button.classList.add("shaka-tooltip-status");
            this.g = [];
            this.h = "und";
            this.eventManager.u(this.localization, "locale-updated", function() {
                FK(c);
                GK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                FK(c);
                GK(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                HK(c);
                c.h = "und";
                c.g = [];
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                GK(c);
            });
            FK(this);
            GK(this);
        }
        oa(EK, pK);
        function FK(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("CHAPTERS");
            a.nameSpan.textContent = a.localization.resolve("CHAPTERS");
            a.backSpan.textContent = a.localization.resolve("CHAPTERS");
        }
        function HK(a) {
            var b = KH(a.menu);
            gk(a.menu);
            a.menu.appendChild(b);
            OH(a.button, !1);
        }
        function GK(a) {
            var b, c, d, e, f, g, h, k, l, m, n, q, r, t;
            H(function(v) {
                switch(v.h){
                    case 1:
                        b = function(w, x) {
                            return !w && !x || w.id === x.id && w.title === x.title && w.startTime === x.startTime && w.endTime === x.endTime;
                        }, c = "und", d = [], e = a.localization.g, f = u(Array.from(e)), g = f.next();
                    case 2:
                        if (g.done) {
                            v.B(4);
                            break;
                        }
                        c = h = g.value;
                        if (!a.player) {
                            v.B(5);
                            break;
                        }
                        return v.g(a.player.ph(c), 6);
                    case 6:
                        d = v.i || [];
                    case 5:
                        if (d.length) {
                            v.B(4);
                            break;
                        }
                        g = f.next();
                        v.B(2);
                        break;
                    case 4:
                        if (d.length) {
                            v.B(7);
                            break;
                        }
                        c = "und";
                        if (!a.player) {
                            v.B(7);
                            break;
                        }
                        return v.g(a.player.ph(c), 9);
                    case 9:
                        d = v.i || [];
                    case 7:
                        k = c !== a.h;
                        l = a.g.length !== d.length || !a.g.some(function(w, x) {
                            x = d.at(x);
                            return b(w, x) || d.some(function(y) {
                                return b(w, y);
                            });
                        });
                        a.h = c;
                        a.g = d;
                        if (!d.length) HK(a);
                        else if (k || l) {
                            m = u(a.g);
                            n = m.next();
                            for(q = {}; !n.done; q = {
                                Mg: void 0
                            }, n = m.next())q.Mg = n.value, r = ck(), t = U("span"), t.classList.add("shaka-chapter"), t.textContent = q.Mg.title, r.appendChild(t), a.eventManager.u(r, "click", function(w) {
                                return function() {
                                    a.controls.Ca() && (a.video.currentTime = w.Mg.startTime);
                                };
                            }(q)), a.menu.appendChild(r);
                            OH(a.button, !0);
                            MH(a.menu);
                        }
                        v.j();
                }
            });
        }
        O("shaka.ui.ChapterSelection", EK);
        function IK() {}
        IK.prototype.create = function(a, b) {
            return new EK(a, b);
        };
        MJ("chapter", new IK);
        gJ("chapter", new IK);
        function JK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-fast-forward-button");
            this.g.classList.add("shaka-tooltip-status");
            this.g.setAttribute("shaka-status", "1x");
            new JH(this.g).use("M100-315v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T428-480q0 10-4.5 18.5T410-447L162-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Zm400 0v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T828-480q0 10-4.5 18.5T810-447L562-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z");
            this.parent.appendChild(this.g);
            KK(this);
            this.h = this.controls.g.fastForwardRates;
            this.eventManager.u(this.localization, "locale-updated", function() {
                KK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                KK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                if (c.controls.Ca() && c.video.duration) {
                    var d = c.h.indexOf(c.player.Wa()) + 1;
                    d = d != c.h.length ? c.h[d] : c.h[0];
                    c.video.paused && c.video.play();
                    c.player.sc(d);
                    c.g.setAttribute("shaka-status", d + "x");
                }
            });
            this.eventManager.u(this.player, "ratechange", function() {
                c.g.setAttribute("shaka-status", c.player.Wa() + "x");
            });
        }
        oa(JK, IH);
        function KK(a) {
            a.g.ariaLabel = a.localization.resolve("FAST_FORWARD");
        }
        O("shaka.ui.FastForwardButton", JK);
        function LK() {}
        LK.prototype.create = function(a, b) {
            return new JK(a, b);
        };
        gJ("fast_forward", new LK);
        function MK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.h = this.controls.o;
            this.g = ck();
            this.g.classList.add("shaka-fullscreen-button");
            this.g.classList.add("shaka-tooltip");
            this.i = new JH(this.g, "M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z");
            NK(this);
            this.parent.appendChild(this.g);
            OK(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                OK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                OK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                return H(function(d) {
                    return c.controls.Ca() ? d.g(c.controls.pg(), 0) : d.return();
                });
            });
            this.eventManager.u(document, "fullscreenchange", function() {
                c.i.use(c.controls.Jb() ? "M240-240h-80q-17 0-28.5-11.5T120-280q0-17 11.5-28.5T160-320h120q17 0 28.5 11.5T320-280v120q0 17-11.5 28.5T280-120q-17 0-28.5-11.5T240-160v-80Zm480 0v80q0 17-11.5 28.5T680-120q-17 0-28.5-11.5T640-160v-120q0-17 11.5-28.5T680-320h120q17 0 28.5 11.5T840-280q0 17-11.5 28.5T800-240h-80ZM240-720v-80q0-17 11.5-28.5T280-840q17 0 28.5 11.5T320-800v120q0 17-11.5 28.5T280-640H160q-17 0-28.5-11.5T120-680q0-17 11.5-28.5T160-720h80Zm480 0h80q17 0 28.5 11.5T840-680q0 17-11.5 28.5T800-640H680q-17 0-28.5-11.5T640-680v-120q0-17 11.5-28.5T680-840q17 0 28.5 11.5T720-800v80Z" : "M200-200h80q17 0 28.5 11.5T320-160q0 17-11.5 28.5T280-120H160q-17 0-28.5-11.5T120-160v-120q0-17 11.5-28.5T160-320q17 0 28.5 11.5T200-280v80Zm560 0v-80q0-17 11.5-28.5T800-320q17 0 28.5 11.5T840-280v120q0 17-11.5 28.5T800-120H680q-17 0-28.5-11.5T640-160q0-17 11.5-28.5T680-200h80ZM200-760v80q0 17-11.5 28.5T160-640q-17 0-28.5-11.5T120-680v-120q0-17 11.5-28.5T160-840h120q17 0 28.5 11.5T320-800q0 17-11.5 28.5T280-760h-80Zm560 0h-80q-17 0-28.5-11.5T640-800q0-17 11.5-28.5T680-840h120q17 0 28.5 11.5T840-800v120q0 17-11.5 28.5T800-640q-17 0-28.5-11.5T760-680v-80Z");
                OK(c);
            });
            this.eventManager.u(this.h, "loadedmetadata", function() {
                NK(c);
            });
            this.eventManager.u(this.h, "loadeddata", function() {
                NK(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                NK(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                NK(c);
            });
        }
        oa(MK, IH);
        function NK(a) {
            a.controls.ue() ? a.g.classList.remove("shaka-hidden") : a.g.classList.add("shaka-hidden");
        }
        function OK(a) {
            var b = a.controls.Jb() ? "EXIT_FULL_SCREEN" : "FULL_SCREEN";
            a.g.ariaLabel = a.localization.resolve(b);
        }
        O("shaka.ui.FullscreenButton", MK);
        function PK() {}
        PK.prototype.create = function(a, b) {
            return new MK(a, b);
        };
        gJ("fullscreen", new PK);
        function QK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-loop-button");
            this.g.classList.add("shaka-tooltip");
            this.m = new JH(this.g, "m274-200 34 34q12 12 11.5 28T308-110q-12 12-28.5 12.5T251-109L148-212q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l103-103q12-12 28.5-11.5T308-370q11 12 11.5 28T308-314l-34 34h406v-120q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400v120q0 33-23.5 56.5T680-200H274Zm412-480H280v120q0 17-11.5 28.5T240-520q-17 0-28.5-11.5T200-560v-120q0-33 23.5-56.5T280-760h406l-34-34q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T709-851l103 103q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L709-589q-12 12-28.5 11.5T652-590q-11-12-11.5-28t11.5-28l34-34Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.j = U("span");
            this.j.textContent = this.localization.resolve("LOOP");
            a.appendChild(this.j);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            RK(this);
            this.parent.appendChild(this.g);
            this.eventManager.u(this.localization, "locale-updated", function() {
                RK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                RK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && (c.video.loop = !c.video.loop, c.h.La(), c.h.xa(1));
            });
            this.l = this.video.loop;
            this.h = new Uf(function() {
                c.l != c.video.loop && (RK(c), c.l = c.video.loop);
            });
            this.h.xa(1);
            this.eventManager.u(this.player, "unloading", function() {
                SK(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                SK(c);
            });
            this.eventManager.u(this.player, "manifestupdated", function() {
                SK(c);
            });
            this.eventManager.u(this.video, "durationchange", function() {
                SK(c);
            });
        }
        oa(QK, IH);
        QK.prototype.release = function() {
            this.h.stop();
            this.h = null;
            IH.prototype.release.call(this);
        };
        function RK(a) {
            a.j.textContent = a.localization.resolve("LOOP");
            a.i.textContent = a.localization.resolve(a.video.loop ? "ON" : "OFF");
            a.m.use(a.video.loop ? "M120-40q-33 0-56.5-23.5T40-120v-720q0-33 23.5-56.5T120-920h720q33 0 56.5 23.5T920-840v720q0 33-23.5 56.5T840-40H120Zm154-160h406q33 0 56.5-23.5T760-280v-120q0-17-11.5-28.5T720-440q-17 0-28.5 11.5T680-400v120H274l34-34q12-12 11.5-28T308-370q-12-12-28.5-12.5T251-371L148-268q-6 6-8.5 13t-2.5 15q0 8 2.5 15t8.5 13l103 103q12 12 28.5 11.5T308-110q11-12 11.5-28T308-166l-34-34Zm412-480-34 34q-12 12-11.5 28t11.5 28q12 12 28.5 12.5T709-589l103-103q6-6 8.5-13t2.5-15q0-8-2.5-15t-8.5-13L709-851q-12-12-28.5-11.5T652-850q-11 12-11.5 28t11.5 28l34 34H280q-33 0-56.5 23.5T200-680v120q0 17 11.5 28.5T240-520q17 0 28.5-11.5T280-560v-120h406Z" : "m274-200 34 34q12 12 11.5 28T308-110q-12 12-28.5 12.5T251-109L148-212q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l103-103q12-12 28.5-11.5T308-370q11 12 11.5 28T308-314l-34 34h406v-120q0-17 11.5-28.5T720-440q17 0 28.5 11.5T760-400v120q0 33-23.5 56.5T680-200H274Zm412-480H280v120q0 17-11.5 28.5T240-520q-17 0-28.5-11.5T200-560v-120q0-33 23.5-56.5T280-760h406l-34-34q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T709-851l103 103q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L709-589q-12 12-28.5 11.5T652-590q-11-12-11.5-28t11.5-28l34-34Z");
            a.g.ariaLabel = a.localization.resolve(a.video.loop ? "EXIT_LOOP_MODE" : "ENTER_LOOP_MODE");
        }
        function SK(a) {
            OH(a.g, !a.player.U());
        }
        O("shaka.ui.LoopButton", QK);
        function TK() {}
        TK.prototype.create = function(a, b) {
            return new QK(a, b);
        };
        MJ("loop", new TK);
        gJ("loop", new TK);
        TH("loop", new TK);
        function UK(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-mute-button");
            this.g.classList.add("shaka-tooltip");
            this.j = new JH(this.g, "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.h = U("span");
            this.h.textContent = this.localization.resolve("MUTE");
            a.appendChild(this.h);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            VK(this);
            WK(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                VK(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                VK(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && (c.ad && c.ad.isLinear() ? c.ad.setMuted(!c.ad.isMuted()) : c.video.muted || c.video.volume != 0 ? c.video.muted = !c.video.muted : c.video.volume = 1);
            });
            this.eventManager.u(this.video, "volumechange", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                XK(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                XK(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                XK(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.adManager, "ad-volume-changed", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.adManager, "ad-muted", function() {
                VK(c);
                WK(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                XK(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                c.ad = null;
                VK(c);
                WK(c);
                XK(c);
            });
            XK(this);
        }
        oa(UK, IH);
        function VK(a) {
            var b = a.ad ? a.ad.isMuted() ? "UNMUTE" : "MUTE" : a.video.muted || a.video.volume == 0 ? "UNMUTE" : "MUTE";
            a.g.ariaLabel = a.localization.resolve(b);
            a.h.textContent = a.localization.resolve(b);
        }
        function WK(a) {
            var b = a.ad ? a.ad.isMuted() ? "M671-177q-11 7-22 13t-23 11q-15 7-30.5 0T574-176q-6-15 1.5-29.5T598-227q4-2 7.5-4t7.5-4L480-368v111q0 27-24.5 37.5T412-228L280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h88L84-764q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-93-93Zm89-304q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131t58 197q0 33-6 65.5T817-353q-8 22-24.5 27.5t-30.5.5q-14-5-22.5-18t-.5-30q11-26 16-52.5t5-55.5ZM591-623q33 21 51 63t18 80v10q0 5-1 10-2 13-14 17t-22-6l-51-51q-6-6-9-13.5t-3-15.5v-77q0-12 10.5-17.5t20.5.5Zm-201-59q-6-6-6-14t6-14l22-22q19-19 43.5-8.5T480-703v63q0 14-12 19t-22-5l-56-56Z" : "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z" : a.video.muted || a.video.volume == 0 ? "M671-177q-11 7-22 13t-23 11q-15 7-30.5 0T574-176q-6-15 1.5-29.5T598-227q4-2 7.5-4t7.5-4L480-368v111q0 27-24.5 37.5T412-228L280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h88L84-764q-11-11-11-28t11-28q11-11 28-11t28 11l680 680q11 11 11 28t-11 28q-11 11-28 11t-28-11l-93-93Zm89-304q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131t58 197q0 33-6 65.5T817-353q-8 22-24.5 27.5t-30.5.5q-14-5-22.5-18t-.5-30q11-26 16-52.5t5-55.5ZM591-623q33 21 51 63t18 80v10q0 5-1 10-2 13-14 17t-22-6l-51-51q-6-6-9-13.5t-3-15.5v-77q0-12 10.5-17.5t20.5.5Zm-201-59q-6-6-6-14t6-14l22-22q19-19 43.5-8.5T480-703v63q0 14-12 19t-22-5l-56-56Z" : "M760-481q0-83-44-151.5T598-735q-15-7-22-21.5t-2-29.5q6-16 21.5-23t31.5 0q97 43 155 131.5T840-481q0 108-58 196.5T627-153q-16 7-31.5 0T574-176q-5-15 2-29.5t22-21.5q74-34 118-102.5T760-481ZM280-360H160q-17 0-28.5-11.5T120-400v-160q0-17 11.5-28.5T160-600h120l132-132q19-19 43.5-8.5T480-703v446q0 27-24.5 37.5T412-228L280-360Zm380-120q0 42-19 79.5T591-339q-10 6-20.5.5T560-356v-250q0-12 10.5-17.5t20.5.5q31 25 50 63t19 80Z";
            a.j.use(b);
        }
        function XK(a) {
            var b = !0;
            a.ad && a.ad.isLinear() ? b = !0 : a.player.Hf() && (b = !1);
            OH(a.g, b);
        }
        O("shaka.ui.MuteButton", UK);
        function YK() {}
        YK.prototype.create = function(a, b) {
            return new UK(a, b);
        };
        MJ("mute", new YK);
        gJ("mute", new YK);
        TH("mute", new YK);
        function ZK(a, b) {
            cI.call(this, a, b, [
                "shaka-volume-bar-container"
            ], [
                "shaka-volume-bar"
            ]);
            var c = this;
            this.g = this.controls.g;
            this.g.alwaysShowVolumeBar || this.container.classList.add("shaka-volume-bar-container-allow-hiding");
            this.setRange(0, 100);
            this.eventManager.u(this.video, "volumechange", function() {
                return $K(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                return $K(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                return aL(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                return aL(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                return aL(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                return $K(c);
            });
            this.eventManager.u(this.adManager, "ad-volume-changed", function() {
                return bL(c);
            });
            this.eventManager.u(this.adManager, "ad-muted", function() {
                return bL(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                return aL(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                aL(c);
                $K(c);
            });
            this.eventManager.u(this.localization, "locale-updated", function() {
                return cL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                return cL(c);
            });
            $K(this);
            cL(this);
            if (this.ad) this.onChange();
            aL(this);
        }
        oa(ZK, cI);
        ZK.prototype.onChange = function() {
            this.ad && this.ad.isLinear() ? this.ad.setVolume(this.getValue() / 100) : (this.video.volume = this.getValue() / 100, this.video.volume > 0 && (this.video.muted = !1));
        };
        function $K(a) {
            a.video.muted ? a.setValue(0) : a.setValue(a.video.volume * 100);
            dL(a);
        }
        function bL(a) {
            var b = a.ad.getVolume();
            a.setValue(b * 100);
            dL(a);
        }
        function dL(a) {
            var b = a.g.volumeBarColors, c = [
                "to right"
            ];
            c.push(b.level + a.getValue() + "%");
            c.push(b.base + a.getValue() + "%");
            c.push(b.base + "100%");
            a.container.style.background = "linear-gradient(" + c.join(",") + ")";
        }
        function cL(a) {
            a.bar.ariaLabel = a.localization.resolve("VOLUME");
        }
        function aL(a) {
            var b = !0;
            a.ad && a.ad.isLinear() ? b = !0 : a.player.Hf() && (b = !1);
            OH(a.container, b);
        }
        O("shaka.ui.VolumeBar", ZK);
        function eL() {}
        eL.prototype.create = function(a, b) {
            return new ZK(a, b);
        };
        gJ("volume", new eL);
        function fL(a, b) {
            IH.call(this, a, b);
            this.g = U("div");
            this.g.classList.add("shaka-mute-volume-container");
            this.parent.appendChild(this.g);
            this.h = new UK(this.g, b);
            this.i = new ZK(this.g, b);
        }
        oa(fL, IH);
        fL.prototype.release = function() {
            this.h.release();
            this.i.release();
            IH.prototype.release.call(this);
        };
        O("shaka.ui.MuteVolumeBar", fL);
        function gL() {}
        gL.prototype.create = function(a, b) {
            return new fL(a, b);
        };
        gJ("mute_volume", new gL);
        function hL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = this.controls.o;
            this.g = ck();
            this.g.classList.add("shaka-pip-button");
            this.g.classList.add("shaka-tooltip");
            this.l = new JH(this.g, "M120-520q-17 0-28.5-11.5T80-560q0-17 11.5-28.5T120-600h104L80-743q-12-12-12-28.5T80-800q12-12 28.5-12t28.5 12l143 144v-104q0-17 11.5-28.5T320-800q17 0 28.5 11.5T360-760v200q0 17-11.5 28.5T320-520H120Zm40 360q-33 0-56.5-23.5T80-240v-160q0-17 11.5-28.5T120-440q17 0 28.5 11.5T160-400v160h280q17 0 28.5 11.5T480-200q0 17-11.5 28.5T440-160H160Zm680-280q-17 0-28.5-11.5T800-480v-240H480q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v240q0 17-11.5 28.5T840-440ZM600-160q-17 0-28.5-11.5T560-200v-120q0-17 11.5-28.5T600-360h240q17 0 28.5 11.5T880-320v120q0 17-11.5 28.5T840-160H600Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.i = U("span");
            this.i.textContent = this.localization.resolve("PICTURE_IN_PICTURE");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            iL(this);
            this.parent.appendChild(this.g);
            this.controls.Gf() || OH(this.g, !1);
            this.eventManager.u(this.localization, "locale-updated", function() {
                iL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                iL(c);
            });
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.controls.Yc();
            });
            this.eventManager.u(this.j, "enterpictureinpicture", function() {
                jL(c);
            });
            this.eventManager.u(this.j, "leavepictureinpicture", function() {
                kL(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                lL(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                lL(c);
            });
            "documentPictureInPicture" in window1 && this.eventManager.u(window1.documentPictureInPicture, "enter", function(d) {
                jL(c);
                c.eventManager.ra(d.window, "pagehide", function() {
                    kL(c);
                });
            });
        }
        oa(hL, IH);
        function jL(a) {
            a.l.use("M160-160q-33 0-56.5-23.5T80-240v-240q0-17 11.5-28.5T120-520q17 0 28.5 11.5T160-480v240h640v-480H480q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm400-263 95 95q12 12 28 12t28-12q12-12 12-28.5T711-385l-95-95h64q17 0 28.5-11.5T720-520q0-17-11.5-28.5T680-560H520q-17 0-28.5 11.5T480-520v160q0 17 11.5 28.5T520-320q17 0 28.5-11.5T560-360v-63ZM120-600q-17 0-28.5-11.5T80-640v-120q0-17 11.5-28.5T120-800h200q17 0 28.5 11.5T360-760v120q0 17-11.5 28.5T320-600H120Zm360 120Z");
            a.g.ariaLabel = a.localization.resolve("EXIT_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve("ON");
        }
        function kL(a) {
            a.l.use("M120-520q-17 0-28.5-11.5T80-560q0-17 11.5-28.5T120-600h104L80-743q-12-12-12-28.5T80-800q12-12 28.5-12t28.5 12l143 144v-104q0-17 11.5-28.5T320-800q17 0 28.5 11.5T360-760v200q0 17-11.5 28.5T320-520H120Zm40 360q-33 0-56.5-23.5T80-240v-160q0-17 11.5-28.5T120-440q17 0 28.5 11.5T160-400v160h280q17 0 28.5 11.5T480-200q0 17-11.5 28.5T440-160H160Zm680-280q-17 0-28.5-11.5T800-480v-240H480q-17 0-28.5-11.5T440-760q0-17 11.5-28.5T480-800h320q33 0 56.5 23.5T880-720v240q0 17-11.5 28.5T840-440ZM600-160q-17 0-28.5-11.5T560-200v-120q0-17 11.5-28.5T600-360h240q17 0 28.5 11.5T880-320v120q0 17-11.5 28.5T840-160H600Z");
            a.g.ariaLabel = a.localization.resolve("ENTER_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve("OFF");
        }
        function iL(a) {
            a.i.textContent = a.localization.resolve("PICTURE_IN_PICTURE");
            var b = a.controls.Id();
            a.g.ariaLabel = a.localization.resolve(b ? "EXIT_PICTURE_IN_PICTURE" : "ENTER_PICTURE_IN_PICTURE");
            a.h.textContent = a.localization.resolve(b ? "ON" : "OFF");
        }
        function lL(a) {
            H(function(b) {
                if (!a.controls.Gf()) return OH(a.g, !1), a.controls.Id() ? b.g(a.controls.Yc(), 0) : b.B(0);
                if (!a.player || !a.player.Hd()) return OH(a.g, !0), b.B(0);
                OH(a.g, !1);
                return a.controls.Id() ? b.g(a.controls.Yc(), 0) : b.B(0);
            });
        }
        O("shaka.ui.PipButton", hL);
        function mL() {}
        mL.prototype.create = function(a, b) {
            return new hL(a, b);
        };
        MJ("picture_in_picture", new mL);
        gJ("picture_in_picture", new mL);
        TH("picture_in_picture", new mL);
        function nL(a, b) {
            pK.call(this, a, b, "m426-330 195-125q14-9 14-25t-14-25L426-630q-15-10-30.5-1.5T380-605v250q0 18 15.5 26.5T426-330ZM121-440q17 0 30.5 11t18.5 28q6 23 14.5 43.5T204-317q9 15 7.5 32T198-256q-11 11-27 10t-25-14q-22-31-37-66.5T86-400q-3-16 7.5-28t27.5-12Zm77-264q12 12 13 29t-7 31q-11 20-19.5 41T170-559q-5 17-18.5 28T121-520q-17 0-27.5-12.5T87-561q8-38 23-73.5t36-66.5q9-13 25-13.5t27 10.5Zm56 505q12-13 29.5-14t32.5 8q20 11 40.5 20t42.5 15q17 5 28 18t11 30q0 17-12.5 27T397-88q-38-8-71.5-23T260-146q-14-9-15.5-25t9.5-28Zm186-639q0 17-10.5 30T402-790q-23 6-44 14.5T317-755q-15 9-32.5 7.5T255-761q-12-12-10.5-28.5T260-815q32-20 66.5-34.5T399-872q16-3 28.5 7t12.5 27Zm360 358q0-113-69.5-199.5T553-792q-15-4-24-17t-9-29q0-16 11-26.5t25-7.5q140 28 232 137t92 255q0 146-92 255T556-88q-14 3-25-7.5T520-122q0-16 9-29t24-17q108-26 177.5-112.5T800-480Z");
            var c = this;
            this.button.classList.add("shaka-playbackrate-button");
            this.menu.classList.add("shaka-playback-rates");
            this.button.classList.add("shaka-tooltip-status");
            Array.from(a.classList).includes("shaka-overflow-menu") || (this.g = U("span"), this.g.classList.add("shaka-overflow-playback-rate-mark"), this.button.appendChild(this.g));
            this.eventManager.u(this.localization, "locale-updated", function() {
                oL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                oL(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                pL(c);
            });
            this.eventManager.u(this.player, "ratechange", function() {
                pL(c);
            });
            oL(this);
            qL(this);
            pL(this);
        }
        oa(nL, pK);
        function oL(a) {
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.button.ariaLabel = a.localization.resolve("PLAYBACK_RATE");
            a.nameSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
            a.backSpan.textContent = a.localization.resolve("PLAYBACK_RATE");
        }
        function pL(a) {
            var b = a.player.Wa(), c = LH(a.menu, "material-svg-icon shaka-chosen-item");
            if (c) {
                var d = c.parentElement;
                d.removeAttribute("aria-selected");
                var e = d.getElementsByTagName("span")[0];
                e && e.classList.remove("shaka-chosen-item");
                d.removeChild(c);
            }
            if (c = Array.from(a.menu.querySelectorAll("span")).find(function(f) {
                return f.textContent == b + "x";
            })) d = c.parentElement, d.appendChild(NH()), d.ariaSelected = "true", c.classList.add("shaka-chosen-item");
            a.currentSelection.textContent = b + "x";
            a.button.setAttribute("shaka-status", b + "x");
            a.g && (a.g.textContent = b + "x");
        }
        function qL(a) {
            for(var b = u(a.controls.g.playbackRates), c = b.next(), d = {}; !c.done; d = {
                Xf: void 0
            }, c = b.next()){
                d.Xf = c.value;
                c = ck();
                var e = U("span");
                e.textContent = d.Xf + "x";
                c.appendChild(e);
                a.eventManager.u(c, "click", function(f) {
                    return function() {
                        f.Xf == a.video.defaultPlaybackRate ? a.player.ud() : a.player.sc(f.Xf, !1);
                    };
                }(d));
                a.menu.appendChild(c);
            }
            MH(a.menu);
        }
        O("shaka.ui.PlaybackRateSelection", nL);
        function rL() {}
        rL.prototype.create = function(a, b) {
            return new nL(a, b);
        };
        MJ("playback_rate", new rL);
        gJ("playback_rate", new rL);
        function sL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-current-time");
            tL(this, "0:00");
            this.parent.appendChild(this.g);
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.player.U() && (c.video.currentTime = c.player.wa().end);
            });
            this.eventManager.u(this.player, "loading", function() {
                OH(c.g, !0);
            });
            this.eventManager.u(this.controls, "timeandseekrangeupdated", function() {
                var d = c.controls.V, e = c.controls.qh(), f = c.player.wa(), g = f.end - f.start;
                isFinite(g) ? c.player.U() ? (e = Math.max(0, Math.floor(f.end - e)), g = g >= 3600, e >= 1 || d ? (tL(c, "- " + PH(e, g)), c.g.disabled = !1) : (tL(c, c.localization.resolve("LIVE")), c.g.disabled = !0)) : (d = g >= 3600, e = Math.max(0, e - f.start), g && (e = Math.min(e, g)), e = PH(e, d), g && (e += " / " + PH(g, d)), tL(c, e), c.g.disabled = !0) : (tL(c, c.localization.resolve("LIVE")), c.g.disabled = !0);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                c.player.U() && (c.g.ariaLabel = c.localization.resolve("SKIP_TO_LIVE"));
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                OH(c.g, !c.ad.isLinear());
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                OH(c.g, !0);
            });
        }
        oa(sL, IH);
        function tL(a, b) {
            b != a.g.textContent && (a.g.textContent = b);
        }
        O("shaka.ui.PresentationTimeTracker", sL);
        function uL() {}
        uL.prototype.create = function(a, b) {
            return new sL(a, b);
        };
        gJ("time_and_duration", new uL);
        function vL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-recenter-vr-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new JH(this.g, "M479-359q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm-57 222-85-85q-12-12-11.5-28.5T338-279q12-12 28.5-12t28.5 12l85 86 85-85q11-11 28-11t28 11q11 11 11 28t-11 28l-85 85q-12 12-27 18t-30 6q-15 0-30-6t-27-18ZM221-337l-85-85q-12-12-18-27t-6-30q0-15 6-30t18-27l85-85q12-12 28.5-12t28.5 12q12 12 12 28.5T278-564l-86 86 85 85q11 11 11 28t-11 28q-11 11-28 11t-28-11Zm116-401 85-85q12-12 27-18t30-6q15 0 30 6t27 18l85 85q12 12 12 28t-12 28q-12 12-28.5 12T564-682l-86-85-85 85q-11 11-28 11t-28-11q-11-11-11-28t11-28Zm344 343 85-85-85-85q-11-11-11-28t11-28q11-11 28-11t28 11l85 85q12 12 18 27t6 30q0 15-6 30t-18 27l-85 85q-12 12-28 11.5T681-338q-12-12-12-28.5t12-28.5Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = U("span");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            wL(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                wL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                wL(c);
            });
            var d = this.controls.D;
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && (d.g ? NI(d.g) : Za("Not playing VR content"));
            });
            this.eventManager.u(d, "vrstatuschanged", function() {
                OH(c.g, c.controls.Sb());
            });
            OH(this.g, this.controls.Sb());
        }
        oa(vL, IH);
        function wL(a) {
            a.g.ariaLabel = a.localization.resolve("RECENTER_VR");
            a.i.textContent = a.localization.resolve("RECENTER_VR");
        }
        O("shaka.ui.RecenterVRButton", vL);
        function xL() {}
        xL.prototype.create = function(a, b) {
            return new vL(a, b);
        };
        MJ("recenter_vr", new xL);
        gJ("recenter_vr", new xL);
        function yL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.i = Xb().lg();
            this.g = ck();
            this.g.classList.add("shaka-remote-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            this.l = new JH(this.g, this.i ? "M80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200h-80q-17 0-28.5-11.5T680-240q0-17 11.5-28.5T720-280h80v-480H160v480h80q17 0 28.5 11.5T280-240q0 17-11.5 28.5T240-200h-80q-33 0-56.5-23.5T80-280Zm232 160q-14 0-22-9.5t-8-20.5q0-5 2-10.5t7-10.5l161-161q6-6 13-9t15-3q8 0 15 3t13 9l161 161q5 5 7 10.5t2 10.5q0 11-8 20.5t-22 9.5H312Zm168-360Z" : "M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.m = U("span");
            a.appendChild(this.m);
            this.j = U("span");
            this.j.classList.add("shaka-current-selection-span");
            a.appendChild(this.j);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            this.h = -1;
            zL(this);
            OH(this.g, !1);
            this.video.remote ? (this.eventManager.u(this.localization, "locale-updated", function() {
                zL(c);
            }), this.eventManager.u(this.localization, "locale-changed", function() {
                zL(c);
            }), this.eventManager.u(this.controls, "caststatuschanged", function() {
                IL(c);
            }), this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && c.video.remote.prompt().catch(function() {});
            }), this.eventManager.u(this.video.remote, "connect", function() {
                IL(c);
                JL(c);
            }), this.eventManager.u(this.video.remote, "connecting", function() {
                IL(c);
                JL(c);
            }), this.eventManager.u(this.video.remote, "disconnect", function() {
                IL(c);
                JL(c);
            }), this.eventManager.u(this.player, "loaded", function() {
                IL(c);
            }), IL(this, !0), JL(this)) : this.g.classList.add("shaka-hidden");
        }
        oa(yL, IH);
        yL.prototype.release = function() {
            this.video.remote && this.h != -1 && this.video.remote.cancelWatchAvailability(this.h).catch(function() {});
            IH.prototype.release.call(this);
        };
        function IL(a, b) {
            b = b === void 0 ? !1 : b;
            var c, d;
            H(function(e) {
                switch(e.h){
                    case 1:
                        if (a.controls.F.Kg() && a.controls.va || !a.video.remote) {
                            OH(a.g, !1);
                            a.h != -1 && (a.video.remote.cancelWatchAvailability(a.h), a.h = -1);
                            e.B(0);
                            break;
                        }
                        if (a.video.remote.state == "disconnected" || b) {
                            c = function(f) {
                                if (a.player) {
                                    var g = a.video.disableRemotePlayback, h = !0;
                                    Xb().lg() && a.player.xc() == ms && a.player.uh() != "HLS" && (h = !1);
                                    OH(a.g, h && f && !g);
                                } else OH(a.g, !1);
                            };
                            e.m(7);
                            if (a.h == -1) {
                                e.B(9);
                                break;
                            }
                            return e.g(a.video.remote.cancelWatchAvailability(a.h), 10);
                        }
                        OH(a.g, !0);
                        if (a.h == -1) {
                            e.B(0);
                            break;
                        }
                        return e.g(a.video.remote.cancelWatchAvailability(a.h), 6);
                    case 6:
                        a.h = -1;
                        e.B(0);
                        break;
                    case 10:
                        a.h = -1;
                    case 9:
                        e.o(8);
                        break;
                    case 7:
                        e.l();
                    case 8:
                        return e.m(11), e.g(a.video.remote.watchAvailability(c), 13);
                    case 13:
                        d = e.i;
                        a.h = d;
                        e.o(0);
                        break;
                    case 11:
                        e.l(), c(!0), e.j();
                }
            });
        }
        function zL(a) {
            var b = a.i ? a.localization.resolve("AIRPLAY") : a.localization.resolve("CAST");
            a.g.ariaLabel = b;
            a.m.textContent = b;
        }
        function JL(a) {
            a.i || (a.video.remote.state == "disconnected" ? a.l.use("M480-480Zm320 320H600q0-20-1.5-40t-4.5-40h206v-480H160v46q-20-3-40-4.5T80-680v-40q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160Zm-720 0v-120q50 0 85 35t35 85H80Zm200 0q0-83-58.5-141.5T80-360v-80q117 0 198.5 81.5T360-160h-80Zm160 0q0-75-28.5-140.5t-77-114q-48.5-48.5-114-77T80-520v-80q91 0 171 34.5T391-471q60 60 94.5 140T520-160h-80Z") : a.l.use("M720-600v240q0 17-11.5 28.5T680-320h-87q-8 0-14.5-4.5T569-337q-29-81-81.5-147T364-596q-16-10-11.5-27t21.5-17h306q17 0 28.5 11.5T720-600ZM320-160q-16 0-28-9.5T277-195q-11-63-56.5-107T112-357q-15-2-23.5-14.5T80-400q0-17 11-28.5t26-9.5q94 12 160.5 79T357-198q2 16-9 27t-28 11Zm160 0q-17 0-28.5-11T438-199q-14-128-104.5-217T115-518q-16-2-25.5-14T80-560q0-17 10.5-29t25.5-10q161 13 274 125.5T518-201q2 17-9.5 29T480-160Zm-340 0q-25 0-42.5-17.5T80-220q0-25 17.5-42.5T140-280q25 0 42.5 17.5T200-220q0 25-17.5 42.5T140-160Zm740-560v480q0 33-23.5 56.5T800-160H638q-17 0-28.5-11.5T598-200q0-17 11.5-28.5T638-240h162v-480H160v6q0 17-11.5 28.5T120-674q-17 0-28.5-11.5T80-714v-6q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720Z"));
        }
        O("shaka.ui.RemoteButton", yL);
        function KL() {}
        KL.prototype.create = function(a, b) {
            return new yL(a, b);
        };
        MJ("remote", new KL);
        gJ("remote", new KL);
        function LL(a, b) {
            pK.call(this, a, b, "M480-120q-17 0-28.5-11.5T440-160v-160q0-17 11.5-28.5T480-360q17 0 28.5 11.5T520-320v40h280q17 0 28.5 11.5T840-240q0 17-11.5 28.5T800-200H520v40q0 17-11.5 28.5T480-120Zm-320-80q-17 0-28.5-11.5T120-240q0-17 11.5-28.5T160-280h160q17 0 28.5 11.5T360-240q0 17-11.5 28.5T320-200H160Zm160-160q-17 0-28.5-11.5T280-400v-40H160q-17 0-28.5-11.5T120-480q0-17 11.5-28.5T160-520h120v-40q0-17 11.5-28.5T320-600q17 0 28.5 11.5T360-560v160q0 17-11.5 28.5T320-360Zm160-80q-17 0-28.5-11.5T440-480q0-17 11.5-28.5T480-520h320q17 0 28.5 11.5T840-480q0 17-11.5 28.5T800-440H480Zm160-160q-17 0-28.5-11.5T600-640v-160q0-17 11.5-28.5T640-840q17 0 28.5 11.5T680-800v40h120q17 0 28.5 11.5T840-720q0 17-11.5 28.5T800-680H680v40q0 17-11.5 28.5T640-600Zm-480-80q-17 0-28.5-11.5T120-720q0-17 11.5-28.5T160-760h320q17 0 28.5 11.5T520-720q0 17-11.5 28.5T480-680H160Z");
            var c = this;
            this.button.classList.add("shaka-resolution-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-resolutions");
            this.h = U("span");
            this.h.classList.add("shaka-current-auto-quality");
            this.h.style.display = "none";
            this.i = U("sup");
            this.i.classList.add("shaka-current-quality-mark");
            this.i.style.display = "none";
            Array.from(a.classList).includes("shaka-overflow-menu") ? this.parent.parentElement && (this.g = fk(this.parent.parentElement)) : (this.g = U("span"), this.g.classList.add("shaka-overflow-playback-rate-mark"), this.button.appendChild(this.g));
            a = U("span");
            this.button.childNodes[1].appendChild(a);
            a.appendChild(this.currentSelection);
            a.appendChild(this.h);
            a.appendChild(this.i);
            this.eventManager.u(this.localization, "locale-updated", function() {
                ML(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                ML(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "variantchanged", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "abrstatuschanged", function() {
                NL(c);
                OL(c);
            });
            this.eventManager.u(this.player, "adaptation", function() {
                NL(c);
                OL(c);
            });
            NL(this);
        }
        oa(LL, pK);
        function OL(a) {
            var b = a.player.getConfiguration().abr.enabled;
            if (a.player.Hd()) {
                a.i.textContent = "";
                a.i.style.display = "none";
                a.g && (a.g.textContent = "", a.g.style.display = "none");
                var c = a.player.Ib() || [], d = c.find(function(e) {
                    return e.active;
                });
                d && (b ? (a.h.textContent = d.bandwidth ? PL(a, d, c) : "Unknown", a.h.style.display = "") : a.h.style.display = "none");
            } else c = a.player.getVideoTracks() || [], (d = c.find(function(e) {
                return e.active;
            })) ? (b ? (a.h.textContent = d.height && d.width ? QL(a, d, c) : d.bandwidth ? RL(d.bandwidth) : "Unknown", a.h.style.display = "") : a.h.style.display = "none", b = SL(a, d.width, d.height), a.i.textContent = b, a.i.style.display = b !== "" ? "" : "none", a.g && (a.g.textContent = b, a.g.style.display = b !== "" ? "" : "none")) : a.g && (b = a.player.getStats(), b = SL(a, b.width, b.height), a.g.textContent = b, a.g.style.display = b !== "" ? "" : "none");
        }
        function SL(a, b, c) {
            if (!b || !c) return "";
            c > b && (c = u([
                c,
                b
            ]), b = c.next().value, c = c.next().value);
            b / c > 16 / 9 && (c = Math.round(b * 9 / 16));
            a = a.controls.g.qualityMarks;
            return c >= 8640 ? c + "p" : c >= 4320 ? a["4320"] : c >= 2160 ? a["2160"] : c >= 1440 ? a["1440"] : c >= 1080 ? a["1080"] : c >= 720 ? a["720"] : "";
        }
        function NL(a) {
            var b = KH(a.menu);
            gk(a.menu);
            a.menu.appendChild(b);
            b = 0;
            b = a.player.Hd() ? TL(a) : UL(a);
            var c = ck();
            c.classList.add("shaka-enable-abr-button");
            a.eventManager.u(c, "click", function() {
                a.player.configure({
                    abr: {
                        enabled: !0
                    }
                });
                NL(a);
            });
            a.l = U("span");
            a.l.textContent = a.localization.resolve("AUTO_QUALITY");
            c.appendChild(a.l);
            a.player.getConfiguration().abr.enabled && (c.ariaSelected = "true", c.appendChild(NH()), a.l.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
            a.button.setAttribute("shaka-status", a.currentSelection.textContent);
            a.menu.appendChild(c);
            MH(a.menu);
            a.controls.dispatchEvent(new R("resolutionselectionupdated"));
            ML(a);
            OH(a.button, b > 0);
        }
        function TL(a) {
            var b = [];
            a.player.xc() == fs || a.player.Da() || (b = a.player.Ib() || []);
            var c = b.find(function(k) {
                return k.active;
            });
            c && (b = b.filter(function(k) {
                if (k.language != c.language || a.controls.g.showAudioChannelCountVariants && k.channelsCount && c.channelsCount && k.channelsCount != c.channelsCount) return !1;
                var l = a.controls.g.trackLabelFormat;
                return (l == 1 || l == 2) && JSON.stringify(k.audioRoles) != JSON.stringify(c.audioRoles) || l == 3 && k.label != c.label || !k.bandwidth ? !1 : !0;
            }));
            b = b.filter(function(k, l) {
                return b.findIndex(function(m) {
                    return m.bandwidth == k.bandwidth;
                }) == l;
            });
            b.sort(function(k, l) {
                return l.bandwidth - k.bandwidth;
            });
            for(var d = a.player.getConfiguration().abr.enabled, e = u(b), f = e.next(), g = {}; !f.done; g = {
                Ke: void 0
            }, f = e.next()){
                g.Ke = f.value;
                f = ck();
                f.classList.add("explicit-resolution");
                a.eventManager.u(f, "click", function(k) {
                    return function() {
                        var l = k.Ke;
                        a.player.configure({
                            abr: {
                                enabled: !1
                            }
                        });
                        a.player.Ge(l, a.controls.g.clearBufferOnQualityChange);
                    };
                }(g));
                var h = U("span");
                h.textContent = g.Ke.bandwidth ? PL(a, g.Ke, b) : "Unknown";
                f.appendChild(h);
                d || g.Ke != c || (f.ariaSelected = "true", f.appendChild(NH()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
                a.menu.appendChild(f);
            }
            return b.length;
        }
        function UL(a) {
            var b = a.player.getVideoTracks() || [], c = b.find(function(m) {
                return m.active;
            });
            b = b.filter(function(m, n) {
                return b.findIndex(function(q) {
                    var r = q.height == m.height && q.bandwidth == m.bandwidth && q.frameRate == m.frameRate && q.hdr == m.hdr && q.videoLayout == m.videoLayout && ed(q.roles, m.roles);
                    r && a.controls.g.showVideoCodec && q.codecs && m.codecs && (r = Cf(q.codecs) == Cf(m.codecs));
                    return r;
                }) == n;
            });
            b.sort(function(m, n) {
                return n.height == m.height || m.height == null || n.height == null ? n.bandwidth - m.bandwidth : n.height - m.height;
            });
            for(var d = a.player.getConfiguration().abr.enabled, e = u(b), f = e.next(), g = {}; !f.done; g = {
                nc: void 0
            }, f = e.next()){
                g.nc = f.value;
                f = ck();
                f.classList.add("explicit-resolution");
                a.eventManager.u(f, "click", function(m) {
                    return function() {
                        var n = m.nc;
                        a.player.configure({
                            abr: {
                                enabled: !1
                            }
                        });
                        a.player.Kj(n, a.controls.g.clearBufferOnQualityChange);
                    };
                }(g));
                var h = U("span");
                h.textContent = g.nc.height && g.nc.width ? QL(a, g.nc, b) : g.nc.bandwidth ? RL(g.nc.bandwidth) : "Unknown";
                f.appendChild(h);
                var k = SL(a, g.nc.width, g.nc.height);
                if (k !== "") {
                    var l = U("sup");
                    l.classList.add("shaka-quality-mark");
                    l.textContent = k;
                    f.appendChild(l);
                }
                d || g.nc != c || (f.ariaSelected = "true", f.appendChild(NH()), h.classList.add("shaka-chosen-item"), a.currentSelection.textContent = h.textContent);
                a.menu.appendChild(f);
            }
            return b.length;
        }
        function QL(a, b, c) {
            function d(n, q) {
                return n != q && n.height == q.height && n.hdr == q.hdr && f(n) == f(q) && e(n) == e(q) && Math.round(n.frameRate || 0) == Math.round(q.frameRate || 0);
            }
            function e(n) {
                return n.codecs ? Cf(n.codecs).startsWith("lcevc") : !1;
            }
            function f(n) {
                return n.codecs ? Cf(n.codecs).startsWith("dovi-") : !1;
            }
            var g = b.height || 0, h = b.width || 0, k = !0;
            if (b.pixelAspectRatio) {
                var l = b.pixelAspectRatio.split(":").map(function(n) {
                    return Number(n);
                });
                l.length === 2 ? k = l[0] === l[1] : l.length === 1 && (k = l[0] === 1);
            }
            g > h && k && (g = u([
                g,
                h
            ]), h = g.next().value, g = g.next().value);
            k = g;
            h / g > 16 / 9 && (k = Math.round(h * 9 / 16));
            h = k + "p";
            g = new Set;
            k = u(c);
            for(l = k.next(); !l.done; l = k.next())l = l.value, l.frameRate && g.add(Math.round(l.frameRate));
            g.size > 1 && (g = b.frameRate) && (g >= 50 || g <= 20) && (h += Math.round(b.frameRate));
            if (f(b)) h += " Dolby Vision";
            else if (b.hdr == "PQ" || b.hdr == "HLG") h += " HDR";
            e(b) && (h += " LCEVC");
            (b.videoLayout || "").includes("CH-STEREO") && (h += " 3D");
            if (c.some(function(n) {
                return d(b, n);
            }) && (c.some(function(n) {
                return d(b, n) && n.bandwidth == b.bandwidth;
            }) || (h += " (" + RL(b.bandwidth) + ")"), a.controls.g.showVideoCodec)) {
                var m = function(n) {
                    var q = "";
                    n && (q = Cf(n).toUpperCase());
                    return q ? " " + q : q;
                };
                c.some(function(n) {
                    return d(b, n) && m(n.codecs) != m(b.codecs);
                }) && (h += m(b.codecs));
            }
            return h;
        }
        function PL(a, b, c) {
            var d = RL(b.bandwidth);
            if (a.controls.g.showAudioCodec) {
                var e = function(f) {
                    var g = "";
                    f && (g = Cf(f).toUpperCase());
                    return g ? " " + g : g;
                };
                c.some(function(f) {
                    return e(f.codecs) != e(b.codecs);
                }) && (d += e(b.codecs));
            }
            return d;
        }
        function RL(a) {
            return a >= 1E6 ? (a / 1E6).toFixed(1).replace(".0", "") + " Mbps" : Math.floor(a / 1E3) + " Kbps";
        }
        function ML(a) {
            var b = a.player.Hd() ? "QUALITY" : "RESOLUTION";
            a.button.ariaLabel = a.localization.resolve(b);
            a.backButton.ariaLabel = a.localization.resolve(b);
            a.backSpan.textContent = a.localization.resolve(b);
            a.nameSpan.textContent = a.localization.resolve(b);
            a.l.textContent = a.localization.resolve("AUTO_QUALITY");
            a.player.getConfiguration().abr.enabled && (a.currentSelection.textContent = a.localization.resolve("AUTO_QUALITY"));
        }
        O("shaka.ui.ResolutionSelection", LL);
        function VL() {}
        VL.prototype.create = function(a, b) {
            return new LL(a, b);
        };
        MJ("quality", new VL);
        gJ("quality", new VL);
        function WL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-rewind-button");
            this.g.classList.add("shaka-tooltip-status");
            this.g.setAttribute("shaka-status", this.localization.resolve("OFF"));
            new JH(this.g).use("M798-281 550-447q-9-6-13.5-14.5T532-480q0-10 4.5-18.5T550-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Zm-400 0L150-447q-9-6-13.5-14.5T132-480q0-10 4.5-18.5T150-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z");
            this.parent.appendChild(this.g);
            XL(this);
            this.h = this.controls.g.rewindRates;
            this.eventManager.u(this.localization, "locale-updated", function() {
                XL(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                XL(c);
            });
            this.eventManager.u(this.g, "click", function() {
                if (c.controls.Ca() && c.video.duration) {
                    var d = c.h.indexOf(c.player.Wa()) + 1;
                    d = d != c.h.length ? c.h[d] : c.h[0];
                    c.video.paused && c.video.play();
                    c.player.sc(d);
                    c.g.setAttribute("shaka-status", d + "x");
                }
            });
            this.eventManager.u(this.player, "ratechange", function() {
                c.g.setAttribute("shaka-status", c.player.Wa() + "x");
            });
        }
        oa(WL, IH);
        function XL(a) {
            a.g.ariaLabel = a.localization.resolve("REWIND");
        }
        O("shaka.ui.RewindButton", WL);
        function YL() {}
        YL.prototype.create = function(a, b) {
            return new WL(a, b);
        };
        gJ("rewind", new YL);
        function ZL(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.j = this.controls.F;
            this.g = ck();
            this.g.classList.add("shaka-save.video-frame-button");
            this.g.classList.add("shaka-tooltip");
            new JH(this.g, "M480-337q-8 0-15-2.5t-13-8.5L308-492q-12-12-11.5-28t11.5-28q12-12 28.5-12.5T365-549l75 75v-286q0-17 11.5-28.5T480-800q17 0 28.5 11.5T520-760v286l75-75q12-12 28.5-11.5T652-548q11 12 11.5 28T652-492L508-348q-6 6-13 8.5t-15 2.5ZM240-160q-33 0-56.5-23.5T160-240v-80q0-17 11.5-28.5T200-360q17 0 28.5 11.5T240-320v80h480v-80q0-17 11.5-28.5T760-360q17 0 28.5 11.5T800-320v80q0 33-23.5 56.5T720-160H240Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.h = U("span");
            this.h.textContent = this.localization.resolve("DOWNLOAD_VIDEO_FRAME");
            a.appendChild(this.h);
            this.i = U("span");
            this.i.classList.add("shaka-current-selection-span");
            a.appendChild(this.i);
            this.g.appendChild(a);
            $L(this);
            this.parent.appendChild(this.g);
            this.eventManager.u(this.localization, "locale-updated", function() {
                $L(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                $L(c);
            });
            this.eventManager.u(this.g, "click", function() {
                var d = document.createElement("canvas"), e = d.getContext("2d"), f = c.controls.o;
                d.width = f.videoWidth;
                d.height = f.videoHeight;
                e.drawImage(f, 0, 0, d.width, d.height);
                d = d.toDataURL("image/png");
                e = document.createElement("a");
                e.href = d;
                e.download = "videoframe_" + f.currentTime.toFixed(3) + ".png";
                e.click();
            });
            this.eventManager.u(this.controls.D, "vrstatuschanged", function() {
                aM(c);
            });
            this.eventManager.u(this.adManager, "ad-started", function() {
                aM(c);
            });
            this.eventManager.u(this.adManager, "ad-stopped", function() {
                aM(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                aM(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                aM(c);
            });
            this.eventManager.u(this.video, "play", function() {
                aM(c);
            });
            this.eventManager.u(this.video, "pause", function() {
                aM(c);
            });
            this.eventManager.u(this.video, "seeking", function() {
                aM(c);
            });
            this.eventManager.u(this.controls, "caststatuschanged", function() {
                aM(c);
            });
            aM(this);
        }
        oa(ZL, IH);
        function aM(a) {
            var b = !0;
            a.controls.Sb() && (b = !1);
            b && a.j.Qa() && (b = !1);
            b && (a.player.drmInfo() || a.player.Hd()) && (b = !1);
            b && a.ad && (b = !1);
            b && a.video.remote && a.video.remote.state != "disconnected" && (b = !1);
            OH(a.g, b);
        }
        function $L(a) {
            a.g.ariaLabel = a.localization.resolve("DOWNLOAD_VIDEO_FRAME");
            a.h.textContent = a.localization.resolve("DOWNLOAD_VIDEO_FRAME");
        }
        O("shaka.ui.SaveVideoFrameButton", ZL);
        function bM() {}
        bM.prototype.create = function(a, b) {
            return new ZL(a, b);
        };
        MJ("save_video_frame", new bM);
        TH("save_video_frame", new bM);
        function cM(a, b) {
            IH.call(this, a, b);
            var c = this;
            if (this.g = this.player.wf()) this.h = ck(), this.h.classList.add("shaka-skip-next-button"), this.h.classList.add("shaka-tooltip"), new JH(this.h).use("M660-280v-400q0-17 11.5-28.5T700-720q17 0 28.5 11.5T740-680v400q0 17-11.5 28.5T700-240q-17 0-28.5-11.5T660-280Zm-440-35v-330q0-18 12-29t28-11q5 0 11 1t11 5l248 166q9 6 13.5 14.5T548-480q0 10-4.5 18.5T530-447L282-281q-5 4-11 5t-11 1q-16 0-28-11t-12-29Z"), this.parent.appendChild(this.h), dM(this), eM(this), this.eventManager.u(this.localization, "locale-updated", function() {
                dM(c);
            }), this.eventManager.u(this.localization, "locale-changed", function() {
                dM(c);
            }), this.eventManager.u(this.h, "click", function() {
                c.controls.Ca() && c.g.playItem(c.g.getCurrentItemIndex() + 1);
            }), this.eventManager.u(this.g, "currentitemchanged", function() {
                eM(c);
            }), this.eventManager.u(this.g, "itemsinserted", function() {
                eM(c);
            }), this.eventManager.u(this.g, "itemsremoved", function() {
                eM(c);
            }), this.eventManager.u(this.player, "loading", function() {
                eM(c);
            });
        }
        oa(cM, IH);
        function dM(a) {
            a.h.ariaLabel = a.localization.resolve("SKIP_NEXT");
        }
        function eM(a) {
            var b = a.g.getItems().length;
            b = b > 1 && a.g.getCurrentItemIndex() + 1 < b;
            OH(a.h, b);
        }
        O("shaka.ui.SkipNextButton", cM);
        function fM() {}
        fM.prototype.create = function(a, b) {
            return new cM(a, b);
        };
        gJ("skip_next", new fM);
        function gM(a, b) {
            IH.call(this, a, b);
            var c = this;
            if (this.g = this.player.wf()) this.h = ck(), this.h.classList.add("shaka-skip-previous-button"), this.h.classList.add("shaka-tooltip"), new JH(this.h).use("M220-280v-400q0-17 11.5-28.5T260-720q17 0 28.5 11.5T300-680v400q0 17-11.5 28.5T260-240q-17 0-28.5-11.5T220-280Zm458-1L430-447q-9-6-13.5-14.5T412-480q0-10 4.5-18.5T430-513l248-166q5-4 11-5t11-1q16 0 28 11t12 29v330q0 18-12 29t-28 11q-5 0-11-1t-11-5Z"), this.parent.appendChild(this.h), hM(this), iM(this), this.eventManager.u(this.localization, "locale-updated", function() {
                hM(c);
            }), this.eventManager.u(this.localization, "locale-changed", function() {
                hM(c);
            }), this.eventManager.u(this.h, "click", function() {
                c.controls.Ca() && c.g.playItem(c.g.getCurrentItemIndex() - 1);
            }), this.eventManager.u(this.g, "currentitemchanged", function() {
                iM(c);
            }), this.eventManager.u(this.g, "itemsinserted", function() {
                iM(c);
            }), this.eventManager.u(this.g, "itemsremoved", function() {
                iM(c);
            }), this.eventManager.u(this.player, "loading", function() {
                iM(c);
            });
        }
        oa(gM, IH);
        function hM(a) {
            a.h.ariaLabel = a.localization.resolve("SKIP_PREVIOUS");
        }
        function iM(a) {
            var b = a.g.getItems().length > 1 && a.g.getCurrentItemIndex() > 0;
            OH(a.h, b);
        }
        O("shaka.ui.SkipPreviousButton", gM);
        function jM() {}
        jM.prototype.create = function(a, b) {
            return new gM(a, b);
        };
        gJ("skip_previous", new jM);
        function kM(a, b) {
            VH.call(this, a, b);
            this.button.classList.add("shaka-small-play-button");
            this.button.classList.add("shaka-tooltip");
        }
        oa(kM, VH);
        O("shaka.ui.SmallPlayButton", kM);
        function lM() {}
        lM.prototype.create = function(a, b) {
            return new kM(a, b);
        };
        gJ("play_pause", new lM);
        function mM(a, b) {
            IH.call(this, a, b);
            a = U("div");
            a.classList.add("shaka-spacer");
            a.ariaHidden = "true";
            this.parent.appendChild(a);
        }
        oa(mM, IH);
        O("shaka.ui.Spacer", mM);
        function nM() {}
        nM.prototype.create = function(a, b) {
            return new mM(a, b);
        };
        gJ("spacer", new nM);
        function oM(a, b) {
            function c(m) {
                m = parseInt(l.g[m], 10);
                return m > 2E9 ? (m / 1E9).toFixed(2) + "GB" : m > 1E6 ? (m / 1E6).toFixed(2) + "MB" : m > 1E3 ? (m / 1E3).toFixed(2) + "KB" : m + "B";
            }
            function d(m) {
                return l.g[m] + " (gaps)";
            }
            function e(m) {
                m = l.g[m];
                return PH(m, m > 3600);
            }
            function f(m) {
                return Math.round(l.g[m] / 1E3) + " (kbits/s)";
            }
            function g(m) {
                return l.g[m].toFixed(2) + " (s)";
            }
            function h(m) {
                return l.g[m] + " (frames)";
            }
            function k(m) {
                return l.g[m] + " (px)";
            }
            IH.call(this, a, b);
            var l = this;
            this.i = ck();
            this.i.classList.add("shaka-statistics-button");
            this.o = new JH(this.i, "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-simple-overflow-button-label-inline");
            this.A = U("span");
            a.appendChild(this.A);
            this.l = U("span");
            this.l.classList.add("shaka-current-selection-span");
            a.appendChild(this.l);
            this.i.appendChild(a);
            this.parent.appendChild(this.i);
            this.h = U("div");
            this.h.classList.add("shaka-no-propagation");
            this.h.classList.add("shaka-show-controls-on-mouse-over");
            this.h.classList.add("shaka-statistics-container");
            this.h.classList.add("shaka-hidden");
            this.controls.i.appendChild(this.h);
            this.D = [];
            this.F = [
                "stateHistory",
                "switchHistory"
            ];
            this.g = this.player.getStats();
            this.m = new Map;
            this.C = (new Map).set("width", k).set("height", k).set("currentCodecs", function(m) {
                return l.g[m];
            }).set("completionPercent", function(m) {
                return l.g[m] + " (%)";
            }).set("bufferingTime", g).set("drmTimeSeconds", g).set("licenseTime", g).set("liveLatency", g).set("loadLatency", g).set("manifestTimeSeconds", g).set("estimatedBandwidth", f).set("streamBandwidth", f).set("maxSegmentDuration", g).set("pauseTime", e).set("playTime", e).set("corruptedFrames", h).set("decodedFrames", h).set("droppedFrames", h).set("stallsDetected", function(m) {
                return l.g[m] + " (stalls)";
            }).set("gapsJumped", d).set("manifestSizeBytes", c).set("bytesDownloaded", c).set("nonFatalErrorCount", function(m) {
                return l.g[m] + " (errors)";
            }).set("manifestPeriodCount", function(m) {
                return l.g[m] + " (periods)";
            }).set("manifestGapCount", d);
            this.j = new Uf(function() {
                l.g = l.player.getStats();
                for(var m = u(l.D), n = m.next(); !n.done; n = m.next()){
                    var q = n.value;
                    n = l.m.get(q);
                    n.textContent = l.C.get(q)(q);
                    n && n.parentElement && (q = l.g[q], typeof q == "string" ? OH(n.parentElement, q != "") : OH(n.parentElement, !isNaN(q)));
                }
            });
            pM(this);
            qM(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                pM(l);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                pM(l);
            });
            this.eventManager.u(this.i, "click", function() {
                rM(l);
                pM(l);
            });
        }
        oa(oM, IH);
        function rM(a) {
            a.h.classList.contains("shaka-hidden") ? (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm120-440q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.xa(.1), OH(a.h, !0)) : (a.o.use("M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Zm120 200q-17 0-28.5 11.5T280-520v200q0 17 11.5 28.5T320-280q17 0 28.5-11.5T360-320v-200q0-17-11.5-28.5T320-560Zm160-120q-17 0-28.5 11.5T440-640v320q0 17 11.5 28.5T480-280q17 0 28.5-11.5T520-320v-320q0-17-11.5-28.5T480-680Zm160 240q-17 0-28.5 11.5T600-400v80q0 17 11.5 28.5T640-280q17 0 28.5-11.5T680-320v-80q0-17-11.5-28.5T640-440Z"), a.j.stop(), OH(a.h, !1));
        }
        function pM(a) {
            a.A.textContent = a.localization.resolve("STATISTICS");
            a.i.ariaLabel = a.localization.resolve("STATISTICS");
            a.l.textContent = a.localization.resolve(a.h.classList.contains("shaka-hidden") ? "OFF" : "ON");
        }
        function sM(a, b) {
            var c = U("div"), d = U("label");
            d.textContent = b + ":";
            c.appendChild(d);
            d = U("span");
            d.textContent = a.C.get(b)(b);
            c.appendChild(d);
            a.m.set(b, d);
            return c;
        }
        function qM(a) {
            var b = U("div");
            b.classList.add("shaka-no-propagation");
            b.classList.add("shaka-statistics-close");
            var c = new JH(b, "M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z").g;
            c.classList.add("material-icons", "notranslate");
            a.h.appendChild(b);
            a.eventManager.u(c, "click", function() {
                rM(a);
            });
            b = u(a.controls.g.statisticsList);
            for(c = b.next(); !c.done; c = b.next())if (c = c.value, c in a.g && !a.F.includes(c)) {
                var d = sM(a, c);
                a.h.appendChild(d);
                a.D.push(c);
            } else Za("Unrecognized statistic element:", c);
        }
        oM.prototype.release = function() {
            this.j.stop();
            this.j = null;
            IH.prototype.release.call(this);
        };
        O("shaka.ui.StatisticsButton", oM);
        function tM() {}
        tM.prototype.create = function(a, b) {
            return new oM(a, b);
        };
        MJ("statistics", new tM);
        TH("statistics", new tM);
        function uM(a, b) {
            pK.call(this, a, b, "M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm400-240H560q-17 0-28.5 11.5T520-560v160q0 17 11.5 28.5T560-360h120q17 0 28.5-11.5T720-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T680-600Z");
            var c = this;
            this.button.classList.add("shaka-caption-button");
            this.button.classList.add("shaka-tooltip-status");
            this.menu.classList.add("shaka-text-languages");
            this.player && this.player.Tc() ? this.button.ariaPressed = "true" : this.button.ariaPressed = "false";
            vM(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                wM(c);
                xM(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                wM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "loading", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "loaded", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "unloading", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "texttrackvisibility", function() {
                yM(c);
                xM(c);
            });
            this.eventManager.u(this.player, "textchanged", function() {
                xM(c);
            });
            this.eventManager.u(this.player, "trackschanged", function() {
                xM(c);
            });
            yM(this);
            wM(this);
            xM(this);
        }
        oa(uM, pK);
        function vM(a) {
            var b = ck();
            b.ariaSelected = "true";
            a.menu.appendChild(b);
            b.appendChild(NH());
            a.g = U("span");
            b.appendChild(a.g);
        }
        function yM(a) {
            a.player.Tc() ? (a.icon.use("M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm400-240H560q-17 0-28.5 11.5T520-560v160q0 17 11.5 28.5T560-360h120q17 0 28.5-11.5T720-400v-20q0-9-6-15t-15-6h-18q-9 0-15 6t-6 15h-80v-120h80q0 9 6 15t15 6h18q9 0 15-6t6-15v-20q0-17-11.5-28.5T680-600Z"), a.button.ariaPressed = "true") : (a.icon.use("M791-57 687-160H200q-33 0-56.5-23.5T120-240v-487l-65-65q-12-12-12-28.5T55-849q12-12 28.5-12t28.5 12l736 736q12 12 12 28t-12 28q-12 12-28.5 12T791-57ZM280-360h120q17 0 28.5-11.5T440-400v-25q0-8-6-14t-14-6h-20q-8 0-14 6t-6 14v5h-80v-127l-45-45v1q-7 5-11 13t-4 18v160q0 17 11.5 28.5T280-360Zm560-360v388q0 27-24.5 37.5T772-303l-66-66q7-5 10.5-13.5T720-400v-20q0-8-6-14t-14-6h-20q-8 0-14 6t-6 14h-5l-75-75v-45h80v5q0 8 6 14t14 6h20q8 0 14-6t6-14v-25q0-17-11.5-28.5T680-600H560q-17 0-28.5 11.5T520-560v5L343-732q-19-19-8.5-43.5T372-800h388q33 0 56.5 23.5T840-720Z"), a.button.ariaPressed = "false");
            a.controls.dispatchEvent(new R("captionselectionupdated"));
        }
        function xM(a) {
            var b = a.player.yc() || [];
            oK(b, a.menu, function(d) {
                return zM(a, d);
            }, a.player.Tc(), a.currentSelection, a.localization, a.controls.g.textTrackLabelFormat);
            var c = ck();
            c.classList.add("shaka-turn-captions-off-button");
            a.eventManager.u(c, "click", function() {
                a.player.Xd(!1);
                xM(a);
            });
            c.appendChild(a.g);
            a.menu.appendChild(c);
            a.player.Tc() ? a.g.classList.remove("shaka-chosen-item") : (c.ariaSelected = "true", c.appendChild(NH()), a.g.classList.add("shaka-chosen-item"), a.currentSelection.textContent = a.localization.resolve("OFF"));
            a.button.setAttribute("shaka-status", a.currentSelection.textContent);
            MH(a.menu);
            a.controls.dispatchEvent(new R("captionselectionupdated"));
            OH(a.button, b.length > 0);
        }
        function zM(a, b) {
            return H(function(c) {
                if (c.h == 1) return a.player.gg(b), c.g(a.player.Xd(!0), 2);
                a.player.configure({
                    preferredTextLanguage: b.language,
                    preferForcedSubs: b.forced
                });
                c.j();
            });
        }
        function wM(a) {
            a.button.ariaLabel = a.localization.resolve("CAPTIONS");
            a.backButton.ariaLabel = a.localization.resolve("BACK");
            a.nameSpan.textContent = a.localization.resolve("CAPTIONS");
            a.backSpan.textContent = a.localization.resolve("CAPTIONS");
            a.g.textContent = a.localization.resolve("OFF");
        }
        O("shaka.ui.TextSelection", uM);
        function AM() {}
        AM.prototype.create = function(a, b) {
            return new uM(a, b);
        };
        MJ("captions", new AM);
        gJ("captions", new AM);
        function BM(a, b) {
            IH.call(this, a, b);
            var c = this;
            this.g = ck();
            this.g.classList.add("shaka-toggle-stereoscopic-button");
            this.g.classList.add("shaka-tooltip");
            this.g.ariaPressed = "false";
            new JH(this.g, "M620-360H520q-8 0-14-6t-6-14v-200q0-8 6-14t14-6h100q17 0 28.5 11.5T660-560v160q0 17-11.5 28.5T620-360Zm-200 0h-90q-13 0-21.5-8.5T300-390q0-13 8.5-21.5T330-420h70v-40h-40q-8 0-14-6t-6-14q0-8 6-14t14-6h40v-40h-70q-13 0-21.5-8.5T300-570q0-13 8.5-21.5T330-600h90q17 0 28.5 11.5T460-560v160q0 17-11.5 28.5T420-360Zm140-60h40v-120h-40v120Zm280-20q-17 0-28.5-11.5T800-480q0-115-72.5-203T542-794l30 30q11 11 11 28t-11 28q-11 11-28 11t-28-11L387-837q-8-8-4.5-20t14.5-15q20-5 41-6.5t42-1.5q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 17-11.5 28.5T840-440ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-17 11.5-28.5T120-520q17 0 28.5 11.5T160-480q0 115 72.5 203T418-166l-30-30q-11-11-11-28t11-28q11-11 28-11t28 11l129 129q8 8 4.5 20T563-88q-20 5-41 6.5T480-80Z");
            a = U("label");
            a.classList.add("shaka-overflow-button-label");
            a.classList.add("shaka-overflow-menu-only");
            this.i = U("span");
            a.appendChild(this.i);
            this.h = U("span");
            this.h.classList.add("shaka-current-selection-span");
            a.appendChild(this.h);
            this.g.appendChild(a);
            this.parent.appendChild(this.g);
            CM(this);
            this.eventManager.u(this.localization, "locale-updated", function() {
                CM(c);
            });
            this.eventManager.u(this.localization, "locale-changed", function() {
                CM(c);
            });
            var d = this.controls.D;
            this.eventManager.u(this.g, "click", function() {
                c.controls.Ca() && d.Yd();
            });
            this.eventManager.u(d, "vrstatuschanged", function() {
                OH(c.g, c.controls.Sb());
            });
            OH(this.g, this.controls.Sb());
        }
        oa(BM, IH);
        function CM(a) {
            a.g.ariaLabel = a.localization.resolve("TOGGLE_STEREOSCOPIC");
            a.i.textContent = a.localization.resolve("TOGGLE_STEREOSCOPIC");
        }
        O("shaka.ui.ToggleStereoscopicButton", BM);
        function DM() {}
        DM.prototype.create = function(a, b) {
            return new BM(a, b);
        };
        MJ("toggle_stereoscopic", new DM);
        gJ("toggle_stereoscopic", new DM);
    }).call(exportTo, innerGlobal, innerGlobal, undefined);
    for(var k in exportTo.shaka)module.exports[k] = exportTo.shaka[k];
})();

});


parcelRegister("5pxJW", function(module, exports) {



module.exports = function(app) {
    var env = window.nomalab.aws;
    var Evaporate = (parcelRequire("kB1JX"));
    var SparkMD5 = (parcelRequire("3D2Yk"));
    var sha256 = (parcelRequire("aPr3M")).sha256;
    var evaporateInstance;
    var uploadCount = 0;
    var wakeLocking = null;
    var elmToJs = app.ports.uploadToJs;
    var jsToElm = app.ports.uploadToElm;
    function evaporateIdGen(key) {
        return decodeURIComponent(evaporateInstance.config.bucket + '/' + key);
    }
    elmToJs.subscribe(function(evt) {
        console.log("Upload to Js", evt.name, evt.event);
        switch(evt.name){
            case 'Upload':
                upload(evt.event);
                break;
            case 'Pause':
                evaporateInstance.pause(evaporateIdGen(evt.event), {
                    force: true
                });
                break;
            case 'Resume':
                evaporateInstance.resume(evaporateIdGen(evt.event));
                break;
            case 'Cancel':
                evaporateInstance.cancel(evaporateIdGen(evt.event));
                break;
        }
    });
    function onEvent(name, event) {
        // console.log("Upload to Elm", name, event)
        jsToElm.send({
            name: name,
            event: event
        });
    }
    Evaporate.create({
        signerUrl: "/v3/aws/signature",
        aws_key: env.awsKey,
        bucket: env.s3Bucket,
        awsRegion: env.awsRegion,
        awsSignatureVersion: env.awsSigVersion.slice(-1),
        s3Acceleration: true,
        logging: false,
        onlyRetryForSameFileName: true,
        cryptoMd5Method: function(data) {
            return btoa(SparkMD5.ArrayBuffer.hash(data, true));
        },
        // cryptoHmacMethod: function (signingKey, stringToSign) {
        //   return '';
        // },
        cryptoHexEncodedHash256: function(data) {
            return sha256(data);
        },
        computeContentMd5: true,
        allowS3ExistenceOptimization: true,
        s3FileCacheHoursAgo: 5,
        partSize: 104857600,
        encodeFilename: false,
        cloudfront: true
    }).then(function(instance) {
        if (instance.supported) evaporateInstance = instance;
        else onUnsupported();
    }).catch(function(err) {
        console.log("couldn't start Evaporate", err);
        onUnsupported();
    });
    function onUnsupported() {
        onEvent("Unsupported");
    }
    function upload(settings) {
        var source = settings.source;
        var fileId = settings.fileId;
        var key = settings.key;
        var userId = settings.userId;
        var file = settings.file;
        // This is actually the same id as the internal of Evaporate
        // but do not rely on it
        var evaporateId = evaporateIdGen(key);
        var lastProgress = 0, progressThrottle = 10000;
        var config = {
            name: key,
            file: file.blob,
            xAmzHeadersAtInitiate: {
                'x-amz-meta-user': '' + userId,
                'x-amz-meta-filename': '' + btoa(encodeURI(file.name)),
                'x-amz-meta-mime_type': '' + encodeURI(file.mimeType),
                'x-amz-meta-upload_start_time': new Date().toISOString()
            },
            started: onStarted,
            pausing: onPausing,
            paused: onPaused,
            resumed: onResumed,
            complete: onComplete,
            error: onError,
            uploadInitiated: onUploadInitiated,
            cancelled: onCancelled,
            progress: function(percentage, stats) {
                if (percentage >= 1 || Date.now() - progressThrottle > lastProgress) {
                    lastProgress = Date.now();
                    onProgress(percentage, stats);
                }
            }
        };
        try {
            evaporateInstance.add(config, {
                signParams: {
                    fileId: fileId,
                    source: source
                }
            }).catch(function(err) {
                // the user probably cancelled the operation
                // but we will react on the event rather than here
                console.log("Upload break", err);
            });
            onInit();
        } catch (err) {
            onError(err);
        }
        function onInit() {
            uploadStarted();
            onEvent("Created", {
                id: evaporateId,
                fileId: fileId,
                s3Id: null,
                name: file.name,
                progress: 0,
                progressedAt: new Date().toISOString(),
                pausing: false,
                pausedAt: null,
                size: file.size,
                mimeType: file.mimeType,
                blob: file.blob,
                secondsLeft: null,
                completedAt: null,
                error: null
            });
        }
        function onStarted() {
            onEvent("Started", {
                fileId: fileId
            });
        }
        function onComplete(xhr, awsObjectKey, stats) {
            uploadEnded();
            onEvent("Completed", {
                fileId: fileId,
                stats: normalizeStats(stats),
                s3Key: awsObjectKey,
                completedAt: new Date().toISOString()
            });
        }
        function onError(error) {
            uploadEnded();
            onEvent("Error", {
                fileId: fileId,
                error: error.toString()
            });
        }
        function onProgress(percentage, stats) {
            onEvent("Progress", {
                fileId: fileId,
                stats: normalizeStats(stats),
                progress: percentage,
                at: new Date().toISOString()
            });
        }
        function onPausing() {
            onEvent("Pausing", {
                fileId: fileId
            });
        }
        function onPaused() {
            uploadEnded();
            onEvent("Paused", {
                fileId: fileId,
                at: new Date().toISOString()
            });
        }
        function onResumed() {
            uploadStarted();
            onEvent("Resumed", {
                fileId: fileId
            });
        }
        function onUploadInitiated(s3UploadId) {
            onEvent("UploadInitiated", {
                fileId: fileId,
                s3UploadId: s3UploadId
            });
        }
        function onNameChanged(awsObjectKey) {
            onEvent("NameChanged", {
                fileId: fileId,
                s3Key: awsObjectKey
            });
        }
        function onCancelled() {
            uploadEnded();
            onEvent("Cancelled", {
                fileId: fileId
            });
        }
    }
    function uploadStarted() {
        uploadCount++;
        if ('wakeLock' in navigator && !wakeLocking) navigator.wakeLock.request('screen').then(function(w) {
            wakeLocking = w;
        });
    }
    function uploadEnded() {
        uploadCount--;
        if (uploadCount < 1 && wakeLocking && wakeLocking.release) {
            wakeLocking.release('screen');
            wakeLocking = null;
        }
    }
    function normalizeStats(stats) {
        if (stats.secondsLeft < 0) stats.secondsLeft = null;
        else stats.secondsLeft = stats.secondsLeft;
        // Looks like Evaporate might have a speed at NaN when resuming an upload
        if (isNaN(stats.speed)) {
            stats.speed = 0;
            stats.readableSpeed = '';
        }
        return stats;
    }
    window.addEventListener('beforeunload', function(e) {
        if (uploadCount > 0) {
            var message = "Vous avez des uploads en cours, voulez-vous abandonner ?";
            e.returnValue = message;
            return message;
        } else return true;
    });
} // enf of exports
;

});
parcelRegister("kB1JX", function(module, exports) {
/*Copyright (c) 2016, TT Labs, Inc.
 All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.

 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

 Neither the name of the TT Labs, Inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.*/ /***************************************************************************************************
 *                                                                                                 *
 *  version 2.1.4                                                                                  *
 *                                                                                                 *
 ***************************************************************************************************/ (function() {
    "use strict";
    var FAR_FUTURE = new Date('2060-10-22'), HOURS_AGO, PENDING = 0, EVAPORATING = 2, COMPLETE = 3, PAUSED = 4, CANCELED = 5, ERROR = 10, ABORTED = 20, PAUSING = 30, PAUSED_STATUSES = [
        PAUSED,
        PAUSING
    ], ACTIVE_STATUSES = [
        PENDING,
        EVAPORATING,
        ERROR
    ], ETAG_OF_0_LENGTH_BLOB = '"d41d8cd98f00b204e9800998ecf8427e"', PARTS_MONITOR_INTERVAL_MS = 120000, IMMUTABLE_OPTIONS = [
        'maxConcurrentParts',
        'logging',
        'cloudfront',
        'encodeFilename',
        'computeContentMd5',
        'allowS3ExistenceOptimization',
        'onlyRetryForSameFileName',
        'timeUrl',
        'cryptoMd5Method',
        'cryptoHexEncodedHash256',
        'awsRegion',
        'awsSignatureVersion',
        'evaporateChanged'
    ], S3_EXTRA_ENCODED_CHARS = {
        33: "%21",
        39: "%27",
        40: "%28",
        41: "%29",
        42: "%2A" // *
    }, l;
    var Evaporate = function(config) {
        this.config = extend({
            readableStreams: false,
            readableStreamPartMethod: null,
            bucket: null,
            logging: true,
            maxConcurrentParts: 5,
            partSize: 6291456,
            retryBackoffPower: 2,
            maxRetryBackoffSecs: 300,
            progressIntervalMS: 1000,
            cloudfront: false,
            s3Acceleration: false,
            mockLocalStorage: false,
            encodeFilename: true,
            computeContentMd5: false,
            allowS3ExistenceOptimization: false,
            onlyRetryForSameFileName: false,
            timeUrl: null,
            cryptoMd5Method: null,
            cryptoHexEncodedHash256: null,
            aws_key: null,
            awsRegion: 'us-east-1',
            awsSignatureVersion: '4',
            sendCanonicalRequestToSignerUrl: false,
            s3FileCacheHoursAgo: null,
            signParams: {},
            signHeaders: {},
            customAuthMethod: undefined,
            maxFileSize: null,
            signResponseHandler: null,
            xhrWithCredentials: false,
            // undocumented, experimental
            localTimeOffset: undefined,
            evaporateChanged: function() {},
            abortCompletionThrottlingMs: 1000
        }, config);
        if (typeof window !== 'undefined' && window.console) {
            l = window.console;
            l.d = l.log;
            l.w = window.console.warn ? l.warn : l.d;
            l.e = window.console.error ? l.error : l.d;
        }
        this._instantiationError = this.validateEvaporateOptions();
        if (typeof this._instantiationError === 'string') {
            this.supported = false;
            return;
        } else delete this._instantiationError;
        if (!this.config.logging) // Reset the logger to be a no_op
        l = noOpLogger();
        var _d = new Date();
        HOURS_AGO = new Date(_d.setHours(_d.getHours() - (this.config.s3FileCacheHoursAgo || -100)));
        if (typeof config.localTimeOffset === 'number') this.localTimeOffset = config.localTimeOffset;
        else {
            var self = this;
            Evaporate.getLocalTimeOffset(this.config).then(function(offset) {
                self.localTimeOffset = offset;
            });
        }
        this.pendingFiles = {};
        this.queuedFiles = [];
        this.filesInProcess = [];
        historyCache = new HistoryCache(this.config.mockLocalStorage);
    };
    Evaporate.create = function(config) {
        var evapConfig = extend({}, config);
        return Evaporate.getLocalTimeOffset(evapConfig).then(function(offset) {
            evapConfig.localTimeOffset = offset;
            return new Promise(function(resolve, reject) {
                var e = new Evaporate(evapConfig);
                if (e.supported === true) resolve(e);
                else reject(e._instantiationError);
            });
        });
    };
    Evaporate.getLocalTimeOffset = function(config) {
        return new Promise(function(resolve, reject) {
            if (typeof config.localTimeOffset === 'number') return resolve(config.localTimeOffset);
            if (config.timeUrl) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", config.timeUrl + '?requestTime=' + new Date().getTime());
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var server_date = new Date(Date.parse(xhr.responseText)), offset = server_date - new Date();
                            l.d('localTimeOffset is', offset, 'ms');
                            resolve(offset);
                        }
                    }
                };
                xhr.onerror = function(xhr) {
                    l.e('xhr error timeUrl', xhr);
                    reject('Fetching offset time failed with status: ' + xhr.status);
                };
                xhr.send();
            } else resolve(0);
        });
    };
    Evaporate.prototype.config = {};
    Evaporate.prototype.localTimeOffset = 0;
    Evaporate.prototype.supported = false;
    Evaporate.prototype._instantiationError = undefined;
    Evaporate.prototype.evaporatingCount = 0;
    Evaporate.prototype.pendingFiles = {};
    Evaporate.prototype.filesInProcess = [];
    Evaporate.prototype.queuedFiles = [];
    Evaporate.prototype.startNextFile = function(reason) {
        if (!this.queuedFiles.length || this.evaporatingCount >= this.config.maxConcurrentParts) return;
        var fileUpload = this.queuedFiles.shift();
        if (fileUpload.status === PENDING) {
            l.d('Starting', decodeURIComponent(fileUpload.name), 'reason:', reason);
            this.evaporatingCnt(1);
            fileUpload.start();
        } else {
            // Add the file back to the stack, it's not ready
            l.d('Requeued', decodeURIComponent(fileUpload.name), 'status:', fileUpload.status, 'reason:', reason);
            this.queuedFiles.push(fileUpload);
        }
    };
    Evaporate.prototype.fileCleanup = function(fileUpload) {
        removeAtIndex(this.queuedFiles, fileUpload);
        if (removeAtIndex(this.filesInProcess, fileUpload)) this.evaporatingCnt(-1);
        fileUpload.done();
        this.consumeRemainingSlots();
    };
    Evaporate.prototype.queueFile = function(fileUpload) {
        this.filesInProcess.push(fileUpload);
        this.queuedFiles.push(fileUpload);
        if (this.filesInProcess.length === 1) this.startNextFile('first file');
    };
    Evaporate.prototype.add = function(file, pConfig) {
        var self = this, fileConfig;
        return new Promise(function(resolve, reject) {
            var c = extend(pConfig, {});
            IMMUTABLE_OPTIONS.forEach(function(a) {
                delete c[a];
            });
            fileConfig = extend(self.config, c);
            if (typeof file === 'undefined' || typeof file.file === 'undefined') return reject('Missing file');
            if (fileConfig.maxFileSize && file.file.size > fileConfig.maxFileSize) return reject('File size too large. Maximum size allowed is ' + fileConfig.maxFileSize);
            if (typeof file.name === 'undefined') return reject('Missing attribute: name');
            if (fileConfig.encodeFilename) // correctly encode to an S3 object name, considering '/' and ' '
            file.name = s3EncodedObjectName(file.name);
            var fileUpload = new FileUpload(extend({
                started: function() {},
                uploadInitiated: function() {},
                progress: function() {},
                complete: function() {},
                cancelled: function() {},
                paused: function() {},
                resumed: function() {},
                pausing: function() {},
                nameChanged: function() {},
                info: function() {},
                warn: function() {},
                error: function() {},
                beforeSigner: undefined,
                xAmzHeadersAtInitiate: {},
                notSignedHeadersAtInitiate: {},
                xAmzHeadersCommon: null,
                xAmzHeadersAtUpload: {},
                xAmzHeadersAtComplete: {}
            }, file, {
                status: PENDING,
                priority: 0,
                loadedBytes: 0,
                sizeBytes: file.file.size,
                eTag: ''
            }), fileConfig, self), fileKey = fileUpload.id;
            self.pendingFiles[fileKey] = fileUpload;
            self.queueFile(fileUpload);
            // Resolve or reject the Add promise based on how the fileUpload completes
            fileUpload.deferredCompletion.promise.then(function() {
                self.fileCleanup(fileUpload);
                resolve(decodeURIComponent(fileUpload.name));
            }, function(reason) {
                self.fileCleanup(fileUpload);
                reject(reason);
            });
        });
    };
    Evaporate.prototype.cancel = function(id) {
        return typeof id === 'undefined' ? this._cancelAll() : this._cancelOne(id);
    };
    Evaporate.prototype._cancelAll = function() {
        l.d('Canceling all file uploads');
        var promises = [];
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (ACTIVE_STATUSES.indexOf(file.status) > -1) promises.push(file.stop());
        }
        if (!promises.length) promises.push(Promise.reject('No files to cancel.'));
        return Promise.all(promises);
    };
    Evaporate.prototype._cancelOne = function(id) {
        var promise = [];
        if (this.pendingFiles[id]) promise.push(this.pendingFiles[id].stop());
        else promise.push(Promise.reject('File does not exist'));
        return Promise.all(promise);
    };
    Evaporate.prototype.pause = function(id, options) {
        options = options || {};
        var force = typeof options.force === 'undefined' ? false : options.force;
        return typeof id === 'undefined' ? this._pauseAll(force) : this._pauseOne(id, force);
    };
    Evaporate.prototype._pauseAll = function(force) {
        l.d('Pausing all file uploads');
        var promises = [];
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (ACTIVE_STATUSES.indexOf(file.status) > -1) this._pause(file, force, promises);
        }
        return Promise.all(promises);
    };
    Evaporate.prototype._pauseOne = function(id, force) {
        var promises = [], file = this.pendingFiles[id];
        if (typeof file === 'undefined') promises.push(Promise.reject('Cannot pause a file that has not been added.'));
        else if (file.status === PAUSED) promises.push(Promise.reject('Cannot pause a file that is already paused.'));
        if (!promises.length) this._pause(file, force, promises);
        return Promise.all(promises);
    };
    Evaporate.prototype._pause = function(fileUpload, force, promises) {
        promises.push(fileUpload.pause(force));
        removeAtIndex(this.filesInProcess, fileUpload);
        removeAtIndex(this.queuedFiles, fileUpload);
    };
    Evaporate.prototype.resume = function(id) {
        return typeof id === 'undefined' ? this._resumeAll() : this._resumeOne(id);
    };
    Evaporate.prototype._resumeAll = function() {
        l.d('Resuming all file uploads');
        for(var key in this.pendingFiles)if (this.pendingFiles.hasOwnProperty(key)) {
            var file = this.pendingFiles[key];
            if (PAUSED_STATUSES.indexOf(file.status) > -1) this.resumeFile(file);
        }
        return Promise.resolve();
    };
    Evaporate.prototype._resumeOne = function(id) {
        var file = this.pendingFiles[id], promises = [];
        if (typeof file === 'undefined') promises.push(Promise.reject('Cannot pause a file that does not exist.'));
        else if (PAUSED_STATUSES.indexOf(file.status) === -1) promises.push(Promise.reject('Cannot resume a file that has not been paused.'));
        else this.resumeFile(file);
        return Promise.all(promises);
    };
    Evaporate.prototype.resumeFile = function(fileUpload) {
        fileUpload.resume();
        this.queueFile(fileUpload);
    };
    Evaporate.prototype.forceRetry = function() {};
    Evaporate.prototype.consumeRemainingSlots = function() {
        var avail = this.config.maxConcurrentParts - this.evaporatingCount;
        if (!avail) return;
        for(var i = 0; i < this.filesInProcess.length; i++){
            var file = this.filesInProcess[i];
            var consumed = file.consumeSlots();
            if (consumed < 0) continue;
            avail -= consumed;
            if (!avail) return;
        }
    };
    Evaporate.prototype.validateEvaporateOptions = function() {
        this.supported = !(typeof File === 'undefined' || typeof Promise === 'undefined');
        if (!this.supported) return 'Evaporate requires support for File and Promise';
        if (this.config.readableStreams) {
            if (typeof this.config.readableStreamPartMethod !== 'function') return "Option readableStreamPartMethod is required when readableStreams is set.";
        } else {
            if (typeof Blob === 'undefined' || typeof (Blob.prototype.webkitSlice || Blob.prototype.mozSlice || Blob.prototype.slice) === 'undefined') return 'Evaporate requires support for Blob [webkitSlice || mozSlice || slice]';
        }
        if (!this.config.signerUrl && typeof this.config.customAuthMethod !== 'function') return "Option signerUrl is required unless customAuthMethod is present.";
        if (!this.config.bucket) return "The AWS 'bucket' option must be present.";
        if (this.config.computeContentMd5) {
            this.supported = typeof FileReader.prototype.readAsArrayBuffer !== 'undefined';
            if (!this.supported) return 'The browser\'s FileReader object does not support readAsArrayBuffer';
            if (typeof this.config.cryptoMd5Method !== 'function') return 'Option computeContentMd5 has been set but cryptoMd5Method is not defined.';
            if (this.config.awsSignatureVersion === '4') {
                if (typeof this.config.cryptoHexEncodedHash256 !== 'function') return 'Option awsSignatureVersion is 4 but cryptoHexEncodedHash256 is not defined.';
            }
        } else if (this.config.awsSignatureVersion === '4') return 'Option awsSignatureVersion is 4 but computeContentMd5 is not enabled.';
        return true;
    };
    Evaporate.prototype.evaporatingCnt = function(incr) {
        this.evaporatingCount = Math.max(0, this.evaporatingCount + incr);
        this.config.evaporateChanged(this, this.evaporatingCount);
    };
    function FileUpload(file, con, evaporate) {
        this.fileTotalBytesUploaded = 0;
        this.s3Parts = [];
        this.partsOnS3 = [];
        this.partsInProcess = [];
        this.partsToUpload = [];
        this.numParts = -1;
        this.con = extend({}, con);
        this.evaporate = evaporate;
        this.localTimeOffset = evaporate.localTimeOffset;
        this.deferredCompletion = defer();
        extend(this, file);
        this.id = decodeURIComponent(this.con.bucket + '/' + this.name);
        this.signParams = con.signParams;
    }
    FileUpload.prototype.con = undefined;
    FileUpload.prototype.evaporate = undefined;
    FileUpload.prototype.localTimeOffset = 0;
    FileUpload.prototype.id = undefined;
    FileUpload.prototype.status = PENDING;
    FileUpload.prototype.numParts = -1;
    FileUpload.prototype.fileTotalBytesUploaded = 0;
    FileUpload.prototype.partsInProcess = [];
    FileUpload.prototype.partsToUpload = [];
    FileUpload.prototype.s3Parts = [];
    FileUpload.prototype.partsOnS3 = [];
    FileUpload.prototype.deferredCompletion = undefined;
    FileUpload.prototype.abortedByUser = false;
    // Progress and Stats
    FileUpload.prototype.progressInterval = undefined;
    FileUpload.prototype.startTime = undefined;
    FileUpload.prototype.loaded = 0;
    FileUpload.prototype.totalUploaded = 0;
    FileUpload.prototype.updateLoaded = function(loadedNow) {
        this.loaded += loadedNow;
        this.fileTotalBytesUploaded += loadedNow;
    };
    FileUpload.prototype.progessStats = function() {
        // Adapted from https://github.com/fkjaekel
        // https://github.com/TTLabs/EvaporateJS/issues/13
        if (this.fileTotalBytesUploaded === 0) return {
            speed: 0,
            readableSpeed: "",
            loaded: 0,
            totalUploaded: 0,
            remainingSize: this.sizeBytes,
            secondsLeft: -1,
            fileSize: this.sizeBytes
        };
        this.totalUploaded += this.loaded;
        var delta = (new Date() - this.startTime) / 1000, avgSpeed = this.totalUploaded / delta, remainingSize = this.sizeBytes - this.fileTotalBytesUploaded, stats = {
            speed: avgSpeed,
            readableSpeed: readableFileSize(avgSpeed),
            loaded: this.loaded,
            totalUploaded: this.fileTotalBytesUploaded,
            remainingSize: remainingSize,
            secondsLeft: -1,
            fileSize: this.sizeBytes
        };
        if (avgSpeed > 0) stats.secondsLeft = Math.round(remainingSize / avgSpeed);
        return stats;
    };
    FileUpload.prototype.onProgress = function() {
        if ([
            ABORTED,
            PAUSED
        ].indexOf(this.status) === -1) {
            this.progress(this.fileTotalBytesUploaded / this.sizeBytes, this.progessStats());
            this.loaded = 0;
        }
    };
    FileUpload.prototype.startMonitor = function() {
        clearInterval(this.progressInterval);
        this.startTime = new Date();
        this.loaded = 0;
        this.totalUploaded = 0;
        this.onProgress();
        this.progressInterval = setInterval(this.onProgress.bind(this), this.con.progressIntervalMS);
    };
    FileUpload.prototype.stopMonitor = function() {
        clearInterval(this.progressInterval);
    };
    // Evaporate proxies
    FileUpload.prototype.startNextFile = function(reason) {
        this.evaporate.startNextFile(reason);
    };
    FileUpload.prototype.evaporatingCnt = function(incr) {
        this.evaporate.evaporatingCnt(incr);
    };
    FileUpload.prototype.consumeRemainingSlots = function() {
        this.evaporate.consumeRemainingSlots();
    };
    FileUpload.prototype.getRemainingSlots = function() {
        var evapCount = this.evaporate.evaporatingCount;
        if (!this.partsInProcess.length && evapCount > 0) // we can use our file slot
        evapCount -= 1;
        return this.con.maxConcurrentParts - evapCount;
    };
    FileUpload.prototype.lastPartSatisfied = Promise.resolve('onStart');
    FileUpload.prototype.start = function() {
        this.status = EVAPORATING;
        this.startMonitor();
        this.started(this.id);
        if (this.uploadId) {
            l.d('resuming FileUpload ', this.id);
            return this.consumeSlots();
        }
        var awsKey = this.name;
        this.getUnfinishedFileUpload();
        var existenceOptimized = this.con.computeContentMd5 && this.con.allowS3ExistenceOptimization && typeof this.firstMd5Digest !== 'undefined' && typeof this.eTag !== 'undefined';
        if (this.uploadId) {
            if (existenceOptimized) return this.reuseS3Object(awsKey).then(this.deferredCompletion.resolve).catch(this.uploadFileFromScratch.bind(this));
            this.resumeInterruptedUpload().then(this._uploadComplete.bind(this)).catch(this.uploadFileFromScratch.bind(this));
        } else this.uploadFileFromScratch("");
    };
    FileUpload.prototype.uploadFileFromScratch = function(reason) {
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return;
        l.d(reason);
        this.uploadId = undefined;
        return this.uploadFile(this.name).then(this._uploadComplete.bind(this)).catch(this._abortUpload.bind(this));
    };
    FileUpload.prototype._uploadComplete = function() {
        this.completeUpload().then(this.deferredCompletion.resolve);
    };
    FileUpload.prototype.stop = function() {
        l.d('stopping FileUpload ', this.id);
        this.setStatus(CANCELED);
        this.info('Canceling uploads...');
        this.abortedByUser = true;
        var self = this;
        return this.abortUpload().then(function() {
            throw "User aborted the upload";
        }).catch(function(reason) {
            self.deferredCompletion.reject(reason);
        });
    };
    FileUpload.prototype.pause = function(force) {
        l.d('pausing FileUpload, force:', !!force, this.id);
        var promises = [];
        this.info('Pausing uploads...');
        this.status = PAUSING;
        if (force) this.abortParts(true);
        else {
            promises = this.partsInProcess.map(function(p) {
                return this.s3Parts[p].awsRequest.awsDeferred.promise;
            }, this);
            this.pausing();
        }
        return Promise.all(promises).then((function() {
            this.stopMonitor();
            this.status = PAUSED;
            this.startNextFile('pause');
            this.paused();
        }).bind(this));
    };
    FileUpload.prototype.resume = function() {
        this.status = PENDING;
        this.resumed();
    };
    FileUpload.prototype.done = function() {
        clearInterval(this.progressInterval);
        this.startNextFile('file done');
        this.partsOnS3 = [];
        this.s3Parts = [];
    };
    FileUpload.prototype._startCompleteUpload = function(callComplete) {
        return function() {
            var promise = callComplete ? this.completeUpload() : Promise.resolve();
            promise.then(this.deferredCompletion.resolve.bind(this));
        };
    };
    FileUpload.prototype._abortUpload = function() {
        if (!this.abortedByUser) {
            var self = this;
            this.abortUpload().then(function() {
                self.deferredCompletion.reject('File upload aborted due to a part failing to upload');
            }, this.deferredCompletion.reject.bind(this));
        }
    };
    FileUpload.prototype.abortParts = function(pause) {
        var self = this;
        var toAbort = this.partsInProcess.slice(0);
        toAbort.forEach(function(i) {
            var s3Part = self.s3Parts[i];
            if (s3Part) {
                s3Part.awsRequest.abort();
                if (pause) s3Part.status = PENDING;
                removeAtIndex(self.partsInProcess, s3Part.partNumber);
                if (self.partsToUpload.length) self.evaporatingCnt(-1);
            }
        });
    };
    FileUpload.prototype.makeParts = function(firstPart) {
        this.numParts = Math.ceil(this.sizeBytes / this.con.partSize) || 1; // issue #58
        var partsDeferredPromises = [];
        var self = this;
        function cleanUpAfterPart(s3Part) {
            removeAtIndex(self.partsToUpload, s3Part.partNumber);
            removeAtIndex(self.partsInProcess, s3Part.partNumber);
            if (self.partsToUpload.length) self.evaporatingCnt(-1);
        }
        function resolve(s3Part) {
            return function() {
                cleanUpAfterPart(s3Part);
                if (self.partsToUpload.length) self.consumeRemainingSlots();
                if (self.partsToUpload.length < self.con.maxConcurrentParts) self.startNextFile('part resolve');
            };
        }
        function reject(s3Part) {
            return function() {
                cleanUpAfterPart(s3Part);
            };
        }
        var limit = firstPart ? 1 : this.numParts;
        for(var part = 1; part <= limit; part++){
            var s3Part = this.s3Parts[part];
            if (typeof s3Part !== "undefined") {
                if (s3Part.status === COMPLETE) continue;
            } else s3Part = this.makePart(part, PENDING, this.sizeBytes);
            s3Part.awsRequest = new PutPart(this, s3Part);
            s3Part.awsRequest.awsDeferred.promise.then(resolve(s3Part), reject(s3Part));
            this.partsToUpload.push(part);
            partsDeferredPromises.push(this.s3Parts[part].awsRequest.awsDeferred.promise);
        }
        return partsDeferredPromises;
    };
    FileUpload.prototype.makePart = function(partNumber, status, size) {
        var s3Part = {
            status: status,
            loadedBytes: 0,
            loadedBytesPrevious: null,
            isEmpty: size === 0,
            md5_digest: null,
            partNumber: partNumber
        };
        this.s3Parts[partNumber] = s3Part;
        return s3Part;
    };
    FileUpload.prototype.setStatus = function(s) {
        this.status = s;
    };
    FileUpload.prototype.createUploadFile = function() {
        if (this.status === ABORTED) return;
        var fileKey = uploadKey(this), newUpload = {
            awsKey: this.name,
            bucket: this.con.bucket,
            uploadId: this.uploadId,
            fileSize: this.sizeBytes,
            fileType: this.file.type,
            lastModifiedDate: dateISOString(this.file.lastModified),
            partSize: this.con.partSize,
            signParams: this.con.signParams,
            createdAt: new Date().toISOString()
        };
        saveUpload(fileKey, newUpload);
    };
    FileUpload.prototype.updateUploadFile = function(updates) {
        var fileKey = uploadKey(this), uploads = getSavedUploads(), upload = extend({}, uploads[fileKey], updates);
        saveUpload(fileKey, upload);
    };
    FileUpload.prototype.completeUploadFile = function(xhr) {
        var uploads = getSavedUploads(), upload = uploads[uploadKey(this)];
        if (typeof upload !== 'undefined') {
            upload.completedAt = new Date().toISOString();
            upload.eTag = this.eTag;
            upload.firstMd5Digest = this.firstMd5Digest;
            uploads[uploadKey(this)] = upload;
            historyCache.setItem('awsUploads', JSON.stringify(uploads));
        }
        this.complete(xhr, this.name, this.progessStats());
        this.setStatus(COMPLETE);
        this.onProgress();
    };
    FileUpload.prototype.removeUploadFile = function() {
        if (typeof this.file !== 'undefined') removeUpload(uploadKey(this));
    };
    FileUpload.prototype.getUnfinishedFileUpload = function() {
        var savedUploads = getSavedUploads(true), u = savedUploads[uploadKey(this)];
        if (this.canRetryUpload(u)) {
            this.uploadId = u.uploadId;
            this.name = u.awsKey;
            this.eTag = u.eTag;
            this.firstMd5Digest = u.firstMd5Digest;
            this.signParams = u.signParams;
        }
    };
    FileUpload.prototype.canRetryUpload = function(u) {
        // Must be the same file name, file size, last_modified, file type as previous upload
        if (typeof u === 'undefined') return false;
        var completedAt = new Date(u.completedAt || FAR_FUTURE);
        // check that the part sizes and bucket match, and if the file name of the upload
        // matches if onlyRetryForSameFileName is true
        return this.con.partSize === u.partSize && completedAt > HOURS_AGO && this.con.bucket === u.bucket && (this.con.onlyRetryForSameFileName ? this.name === u.awsKey : true);
    };
    FileUpload.prototype.partSuccess = function(eTag, putRequest) {
        var part = putRequest.part;
        l.d(putRequest.request.step, 'ETag:', eTag);
        if (part.isEmpty || eTag !== ETAG_OF_0_LENGTH_BLOB) {
            part.eTag = eTag;
            part.status = COMPLETE;
            this.partsOnS3.push(part);
            return true;
        } else {
            part.status = ERROR;
            putRequest.resetLoadedBytes();
            var msg = [
                'eTag matches MD5 of 0 length blob for part #',
                putRequest.partNumber,
                'Retrying part.'
            ].join(" ");
            l.w(msg);
            this.warn(msg);
        }
    };
    FileUpload.prototype.listPartsSuccess = function(listPartsRequest, partsXml) {
        this.info('uploadId', this.uploadId, 'is not complete. Fetching parts from part marker', listPartsRequest.partNumberMarker);
        partsXml = partsXml.replace(/(\r\n|\n|\r)/gm, ""); // strip line breaks to ease the regex requirements
        var partRegex = /<Part>(.+?)<\/Part\>/g;
        while(true){
            var cp = (partRegex.exec(partsXml) || [])[1];
            if (!cp) break;
            var partSize = parseInt(elementText(cp, "Size"), 10);
            this.fileTotalBytesUploaded += partSize;
            this.partsOnS3.push({
                eTag: elementText(cp, "ETag").replace(/&quot;/g, '"'),
                partNumber: parseInt(elementText(cp, "PartNumber"), 10),
                size: partSize,
                LastModified: elementText(cp, "LastModified")
            });
        }
        return elementText(partsXml, "IsTruncated") === 'true' ? elementText(partsXml, "NextPartNumberMarker") : undefined;
    };
    FileUpload.prototype.makePartsfromPartsOnS3 = function() {
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return;
        this.nameChanged(this.name);
        this.partsOnS3.forEach((function(cp) {
            var uploadedPart = this.makePart(cp.partNumber, COMPLETE, cp.size);
            uploadedPart.eTag = cp.eTag;
            uploadedPart.loadedBytes = cp.size;
            uploadedPart.loadedBytesPrevious = cp.size;
            uploadedPart.finishedUploadingAt = cp.LastModified;
        }).bind(this));
    };
    FileUpload.prototype.completeUpload = function() {
        var self = this;
        return new CompleteMultipartUpload(this).send().then(function(xhr) {
            self.eTag = elementText(xhr.responseText, "ETag").replace(/&quot;/g, '"');
            self.completeUploadFile(xhr);
        });
    };
    FileUpload.prototype.getCompletedPayload = function() {
        var completeDoc = [];
        completeDoc.push('<CompleteMultipartUpload>');
        this.s3Parts.forEach(function(part, partNumber) {
            if (partNumber > 0) [
                '<Part><PartNumber>',
                partNumber,
                '</PartNumber><ETag>',
                part.eTag,
                '</ETag></Part>'
            ].forEach(function(a) {
                completeDoc.push(a);
            });
        });
        completeDoc.push('</CompleteMultipartUpload>');
        return completeDoc.join("");
    };
    FileUpload.prototype.consumeSlots = function() {
        if (this.partsToUpload.length === 0) return -1;
        if (this.partsToUpload.length !== this.partsInProcess.length && this.status === EVAPORATING) {
            var partsToUpload = Math.min(this.getRemainingSlots(), this.partsToUpload.length);
            if (!partsToUpload) return -1;
            var satisfied = 0;
            for(var i = 0; i < this.partsToUpload.length; i++){
                var s3Part = this.s3Parts[this.partsToUpload[i]];
                if (s3Part.status === EVAPORATING) continue;
                if (this.canStartPart(s3Part)) {
                    if (this.partsInProcess.length && this.partsToUpload.length > 1) this.evaporatingCnt(1);
                    this.partsInProcess.push(s3Part.partNumber);
                    var awsRequest = s3Part.awsRequest;
                    this.lastPartSatisfied.then(awsRequest.delaySend.bind(awsRequest));
                    this.lastPartSatisfied = awsRequest.getStartedPromise();
                } else continue;
                satisfied += 1;
                if (satisfied === partsToUpload) break;
            }
            var allInProcess = this.partsToUpload.length === this.partsInProcess.length, remainingSlots = this.getRemainingSlots();
            if (allInProcess && remainingSlots > 0) // We don't need any more slots...
            this.startNextFile('consume slots');
            return remainingSlots;
        }
        return 0;
    };
    FileUpload.prototype.canStartPart = function(part) {
        return this.partsInProcess.indexOf(part.partNumber) === -1 && !part.awsRequest.errorExceptionStatus();
    };
    FileUpload.prototype.uploadFile = function(awsKey) {
        this.removeUploadFile();
        var self = this;
        return new InitiateMultipartUpload(self, awsKey).send().then(function() {
            self.uploadInitiated(self.uploadId);
            self.partsToUpload = [];
            return self.uploadParts().then(function() {}, function(reason) {
                throw reason;
            });
        });
    };
    FileUpload.prototype.uploadParts = function() {
        this.loaded = 0;
        this.totalUploaded = 0;
        if (ACTIVE_STATUSES.indexOf(this.status) === -1) return Promise.reject('Part uploading stopped because the file was canceled');
        var promises = this.makeParts();
        this.setStatus(EVAPORATING);
        this.startTime = new Date();
        this.consumeSlots();
        return Promise.all(promises);
    };
    FileUpload.prototype.abortUpload = function() {
        return new Promise((function(resolve, reject) {
            if (typeof this.uploadId === 'undefined') {
                resolve();
                return;
            }
            new DeleteMultipartUpload(this).send().then(resolve, reject);
        }).bind(this)).then((function() {
            this.setStatus(ABORTED);
            this.cancelled();
            this.removeUploadFile();
        }).bind(this), this.deferredCompletion.reject.bind(this));
    };
    FileUpload.prototype.resumeInterruptedUpload = function() {
        return new ResumeInterruptedUpload(this).send().then(this.uploadParts.bind(this));
    };
    FileUpload.prototype.reuseS3Object = function(awsKey) {
        var self = this;
        // Attempt to reuse entire uploaded object on S3
        this.makeParts(1);
        this.partsToUpload = [];
        var firstS3Part = this.s3Parts[1];
        function reject(reason) {
            self.name = awsKey;
            throw reason;
        }
        return firstS3Part.awsRequest.getPartMd5Digest().then(function() {
            if (self.firstMd5Digest === firstS3Part.md5_digest) return new ReuseS3Object(self, awsKey).send().then(function(xhr) {
                l.d('headObject found matching object on S3.');
                self.completeUploadFile(xhr);
                self.nameChanged(self.name);
            }).catch(reject);
            else {
                var msg = self.con.allowS3ExistenceOptimization ? 'File\'s first part MD5 digest does not match what was stored.' : 'allowS3ExistenceOptimization is not enabled.';
                reject(msg);
            }
        });
    };
    function SignedS3AWSRequest(fileUpload, request) {
        this.fileUpload = fileUpload;
        this.con = fileUpload.con;
        this.attempts = 1;
        this.localTimeOffset = this.fileUpload.localTimeOffset;
        this.awsDeferred = defer();
        this.started = defer();
        this.awsUrl = awsUrl(this.con);
        this.awsHost = uri(this.awsUrl).hostname;
        var r = extend({}, request);
        if (fileUpload.contentType) r.contentType = fileUpload.contentType;
        this.updateRequest(r);
    }
    SignedS3AWSRequest.prototype.fileUpload = undefined;
    SignedS3AWSRequest.prototype.con = undefined;
    SignedS3AWSRequest.prototype.awsUrl = undefined;
    SignedS3AWSRequest.prototype.awsHost = undefined;
    SignedS3AWSRequest.prototype.authorize = function() {};
    SignedS3AWSRequest.prototype.localTimeOffset = 0;
    SignedS3AWSRequest.prototype.awsDeferred = undefined;
    SignedS3AWSRequest.prototype.started = undefined;
    SignedS3AWSRequest.prototype.getPath = function() {
        var path = '/' + this.con.bucket + '/' + this.fileUpload.name;
        if (this.con.cloudfront || this.awsUrl.indexOf('cloudfront') > -1) path = '/' + this.fileUpload.name;
        return path;
    };
    SignedS3AWSRequest.prototype.updateRequest = function(request) {
        this.request = request;
        var SigningClass = signingVersion(this, l);
        this.signer = new SigningClass(request);
    };
    SignedS3AWSRequest.prototype.success = function() {
        this.awsDeferred.resolve(this.currentXhr);
    };
    SignedS3AWSRequest.prototype.backOffWait = function() {
        return this.attempts === 1 ? 0 : 1000 * Math.min(this.con.maxRetryBackoffSecs, Math.pow(this.con.retryBackoffPower, this.attempts - 2));
    };
    SignedS3AWSRequest.prototype.error = function(reason) {
        if (this.errorExceptionStatus()) return;
        this.signer.error();
        l.d(this.request.step, 'error:', this.fileUpload.id, reason);
        if (typeof this.errorHandler(reason) !== 'undefined') return;
        this.fileUpload.warn('Error in ', this.request.step, reason);
        this.fileUpload.setStatus(ERROR);
        var self = this, backOffWait = this.backOffWait();
        this.attempts += 1;
        setTimeout(function() {
            if (!self.errorExceptionStatus()) self.trySend();
        }, backOffWait);
    };
    SignedS3AWSRequest.prototype.errorHandler = function() {};
    SignedS3AWSRequest.prototype.errorExceptionStatus = function() {
        return false;
    };
    SignedS3AWSRequest.prototype.getPayload = function() {
        return Promise.resolve(null);
    };
    SignedS3AWSRequest.prototype.success_status = function(xhr) {
        return xhr.status >= 200 && xhr.status <= 299 || this.request.success404 && xhr.status === 404;
    };
    SignedS3AWSRequest.prototype.stringToSign = function() {
        return encodeURIComponent(this.signer.stringToSign());
    };
    SignedS3AWSRequest.prototype.canonicalRequest = function() {
        return this.signer.canonicalRequest();
    };
    SignedS3AWSRequest.prototype.signResponse = function(payload, stringToSign, signatureDateTime) {
        var self = this;
        return new Promise(function(resolve) {
            if (typeof self.con.signResponseHandler === 'function') return self.con.signResponseHandler(payload, stringToSign, signatureDateTime).then(resolve);
            resolve(payload);
        });
    };
    SignedS3AWSRequest.prototype.sendRequestToAWS = function() {
        var self = this;
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            self.currentXhr = xhr;
            var url = [
                self.awsUrl,
                self.getPath(),
                self.request.path
            ].join(""), all_headers = {};
            if (self.request.query_string) url += self.request.query_string;
            extend(all_headers, self.request.not_signed_headers);
            extend(all_headers, self.request.x_amz_headers);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (self.success_status(xhr)) {
                        if (self.request.response_match && xhr.response.match(new RegExp(self.request.response_match)) === undefined) reject('AWS response does not match set pattern: ' + self.request.response_match);
                        else resolve();
                    } else {
                        var reason = xhr.responseText ? getAwsResponse(xhr) : ' ';
                        reason += 'status:' + xhr.status;
                        reject(reason);
                    }
                }
            };
            xhr.open(self.request.method, url);
            xhr.setRequestHeader('Authorization', self.signer.authorizationString());
            for(var key in all_headers)if (all_headers.hasOwnProperty(key)) xhr.setRequestHeader(key, all_headers[key]);
            self.signer.setHeaders(xhr);
            if (self.request.contentType) xhr.setRequestHeader('Content-Type', self.request.contentType);
            if (self.request.md5_digest) xhr.setRequestHeader('Content-MD5', self.request.md5_digest);
            xhr.onerror = function(xhr) {
                var reason = xhr.responseText ? getAwsResponse(xhr) : 'transport error';
                reject(reason);
            };
            if (typeof self.request.onProgress === 'function') xhr.upload.onprogress = self.request.onProgress;
            self.getPayload().then(xhr.send.bind(xhr), reject);
            setTimeout(function() {
                self.started.resolve('request sent ' + self.request.step);
            }, 20);
            self.signer.payload = null;
            self.payloadPromise = undefined;
        });
    };
    //see: http://docs.amazonwebservices.com/AmazonS3/latest/dev/RESTAuthentication.html#ConstructingTheAuthenticationHeader
    SignedS3AWSRequest.prototype.authorize = function() {
        this.request.dateString = this.signer.dateString(this.localTimeOffset);
        this.request.x_amz_headers = extend(this.request.x_amz_headers, {
            'x-amz-date': this.request.dateString
        });
        return this.signer.getPayload().then((function() {
            return authorizationMethod(this).authorize();
        }).bind(this));
    };
    SignedS3AWSRequest.prototype.authorizationSuccess = function(authorization) {
        l.d(this.request.step, 'signature:', authorization);
        this.request.auth = authorization;
    };
    SignedS3AWSRequest.prototype.trySend = function() {
        var self = this;
        return this.authorize().then(function(value) {
            self.authorizationSuccess(value);
            if (self.fileUpload.status === ABORTED) return;
            self.sendRequestToAWS().then(self.success.bind(self), self.error.bind(self));
        }, self.error.bind(self));
    };
    SignedS3AWSRequest.prototype.send = function() {
        this.trySend();
        return this.awsDeferred.promise;
    };
    function CancelableS3AWSRequest(fileUpload, request) {
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    CancelableS3AWSRequest.prototype = Object.create(SignedS3AWSRequest.prototype);
    CancelableS3AWSRequest.prototype.constructor = CancelableS3AWSRequest;
    CancelableS3AWSRequest.prototype.errorExceptionStatus = function() {
        return [
            ABORTED,
            CANCELED
        ].indexOf(this.fileUpload.status) > -1;
    };
    function SignedS3AWSRequestWithRetryLimit(fileUpload, request, maxRetries) {
        if (maxRetries > -1) this.maxRetries = maxRetries;
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    SignedS3AWSRequestWithRetryLimit.prototype = Object.create(CancelableS3AWSRequest.prototype);
    SignedS3AWSRequestWithRetryLimit.prototype.constructor = SignedS3AWSRequestWithRetryLimit;
    SignedS3AWSRequestWithRetryLimit.prototype.maxRetries = 1;
    SignedS3AWSRequestWithRetryLimit.prototype.errorHandler = function(reason) {
        if (this.attempts > this.maxRetries) {
            var msg = [
                'MaxRetries exceeded. Will re-upload file id ',
                this.fileUpload.id,
                ', ',
                reason
            ].join("");
            l.w(msg);
            this.awsDeferred.reject(msg);
            return true;
        }
    };
    SignedS3AWSRequestWithRetryLimit.prototype.rejectedSuccess = function() {
        var reason = Array.prototype.slice.call(arguments, 1).join("");
        this.awsDeferred.reject(reason);
        return false;
    };
    // see: http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadInitiate.html
    function InitiateMultipartUpload(fileUpload, awsKey) {
        var request = {
            method: 'POST',
            path: '?uploads',
            step: 'initiate',
            x_amz_headers: fileUpload.xAmzHeadersAtInitiate,
            not_signed_headers: fileUpload.notSignedHeadersAtInitiate,
            response_match: '<UploadId>(.+)<\/UploadId>'
        };
        CancelableS3AWSRequest.call(this, fileUpload, request);
        this.awsKey = awsKey;
    }
    InitiateMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
    InitiateMultipartUpload.prototype.constructor = InitiateMultipartUpload;
    InitiateMultipartUpload.prototype.success = function() {
        var match = this.currentXhr.response.match(new RegExp(this.request.response_match));
        this.fileUpload.uploadId = match[1];
        this.fileUpload.awsKey = this.awsKey;
        l.d('InitiateMultipartUpload ID is', this.fileUpload.uploadId);
        this.fileUpload.createUploadFile();
        this.awsDeferred.resolve(this.currentXhr);
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
    function CompleteMultipartUpload(fileUpload) {
        fileUpload.info('will attempt to complete upload');
        var request = {
            method: 'POST',
            contentType: 'application/xml; charset=UTF-8',
            path: '?uploadId=' + fileUpload.uploadId,
            x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtComplete,
            step: 'complete'
        };
        CancelableS3AWSRequest.call(this, fileUpload, request);
    }
    CompleteMultipartUpload.prototype = Object.create(CancelableS3AWSRequest.prototype);
    CompleteMultipartUpload.prototype.constructor = CompleteMultipartUpload;
    CompleteMultipartUpload.prototype.getPayload = function() {
        return Promise.resolve(this.fileUpload.getCompletedPayload());
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadComplete.html
    function ReuseS3Object(fileUpload, awsKey) {
        this.awsKey = awsKey;
        fileUpload.info('will attempt to verify existence of the file');
        var request = {
            method: 'HEAD',
            path: '',
            x_amz_headers: fileUpload.xAmzHeadersCommon,
            success404: true,
            step: 'head_object'
        };
        SignedS3AWSRequestWithRetryLimit.call(this, fileUpload, request);
    }
    ReuseS3Object.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
    ReuseS3Object.prototype.constructor = ReuseS3Object;
    ReuseS3Object.prototype.awsKey = undefined;
    ReuseS3Object.prototype.success = function() {
        var eTag = this.currentXhr.getResponseHeader('Etag');
        if (eTag !== this.fileUpload.eTag && !this.rejectedSuccess('uploadId ', this.fileUpload.id, ' found on S3 but the Etag doesn\'t match.')) return;
        this.awsDeferred.resolve(this.currentXhr);
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadListParts.html
    function ResumeInterruptedUpload(fileUpload) {
        SignedS3AWSRequestWithRetryLimit.call(this, fileUpload);
        this.updateRequest(this.setupRequest(0));
    }
    ResumeInterruptedUpload.prototype = Object.create(SignedS3AWSRequestWithRetryLimit.prototype);
    ResumeInterruptedUpload.prototype.constructor = ResumeInterruptedUpload;
    ResumeInterruptedUpload.prototype.awsKey = undefined;
    ResumeInterruptedUpload.prototype.partNumberMarker = 0;
    ResumeInterruptedUpload.prototype.setupRequest = function(partNumberMarker) {
        var msg = [
            'setupRequest() for uploadId:',
            this.fileUpload.uploadId,
            'for part marker:',
            partNumberMarker
        ].join(" ");
        l.d(msg);
        this.fileUpload.info(msg);
        this.awsKey = this.fileUpload.name;
        this.partNumberMarker = partNumberMarker;
        var request = {
            method: 'GET',
            path: [
                '?uploadId=',
                this.fileUpload.uploadId
            ].join(""),
            query_string: "&part-number-marker=" + partNumberMarker,
            x_amz_headers: this.fileUpload.xAmzHeadersCommon,
            step: 'get upload parts',
            success404: true
        };
        this.request = request;
        return request;
    };
    ResumeInterruptedUpload.prototype.success = function() {
        if (this.currentXhr.status === 404) {
            // Success! Upload is no longer recognized, so there is nothing to fetch
            if (this.rejectedSuccess('uploadId ', this.fileUpload.id, ' not found on S3.')) this.awsDeferred.resolve(this.currentXhr);
            return;
        }
        var nextPartNumber = this.fileUpload.listPartsSuccess(this, this.currentXhr.responseText);
        if (nextPartNumber) {
            var request = this.setupRequest(nextPartNumber); // let's fetch the next set of parts
            this.updateRequest(request);
            this.trySend();
        } else {
            this.fileUpload.makePartsfromPartsOnS3();
            this.awsDeferred.resolve(this.currentXhr);
        }
    };
    //http://docs.aws.amazon.com/AmazonS3/latest/API/mpUploadUploadPart.html
    function PutPart(fileUpload, part) {
        this.part = part;
        this.partNumber = part.partNumber;
        this.start = (this.partNumber - 1) * fileUpload.con.partSize;
        this.end = Math.min(this.partNumber * fileUpload.con.partSize, fileUpload.sizeBytes);
        var request = {
            method: 'PUT',
            path: '?partNumber=' + this.partNumber + '&uploadId=' + fileUpload.uploadId,
            step: 'upload #' + this.partNumber,
            x_amz_headers: fileUpload.xAmzHeadersCommon || fileUpload.xAmzHeadersAtUpload,
            contentSha256: "UNSIGNED-PAYLOAD",
            onProgress: this.onProgress.bind(this)
        };
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    PutPart.prototype = Object.create(SignedS3AWSRequest.prototype);
    PutPart.prototype.constructor = PutPart;
    PutPart.prototype.part = 1;
    PutPart.prototype.payloadPromise = undefined;
    PutPart.prototype.start = 0;
    PutPart.prototype.end = 0;
    PutPart.prototype.partNumber = undefined;
    PutPart.prototype.getPartMd5Digest = function() {
        var self = this, part = this.part;
        return new Promise(function(resolve, reject) {
            if (self.con.computeContentMd5 && !part.md5_digest) self.getPayload().then(function(data) {
                var md5_digest = self.con.cryptoMd5Method(data);
                if (self.partNumber === 1 && self.con.computeContentMd5 && typeof self.fileUpload.firstMd5Digest === "undefined") {
                    self.fileUpload.firstMd5Digest = md5_digest;
                    self.fileUpload.updateUploadFile({
                        firstMd5Digest: md5_digest
                    });
                }
                resolve(md5_digest);
            }, reject);
            else resolve(part.md5_digest);
        }).then(function(md5_digest) {
            if (md5_digest) {
                l.d(self.request.step, 'MD5 digest:', md5_digest);
                self.request.md5_digest = md5_digest;
                self.part.md5_digest = md5_digest;
            }
        });
    };
    PutPart.prototype.sendRequestToAWS = function() {
        this.stalledInterval = setInterval(this.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
        this.stalledPartMonitor();
        return SignedS3AWSRequest.prototype.sendRequestToAWS.call(this);
    };
    PutPart.prototype.send = function() {
        if (this.part.status !== COMPLETE && [
            ABORTED,
            PAUSED,
            CANCELED
        ].indexOf(this.fileUpload.status) === -1) {
            l.d('uploadPart #', this.partNumber, this.attempts === 1 ? 'submitting' : 'retrying');
            this.part.status = EVAPORATING;
            this.attempts += 1;
            this.part.loadedBytesPrevious = null;
            var self = this;
            return this.getPartMd5Digest().then(function() {
                l.d('Sending', self.request.step);
                SignedS3AWSRequest.prototype.send.call(self);
            });
        }
    };
    PutPart.prototype.success = function() {
        clearInterval(this.stalledInterval);
        var eTag = this.currentXhr.getResponseHeader('ETag');
        this.currentXhr = null;
        if (this.fileUpload.partSuccess(eTag, this)) this.awsDeferred.resolve(this.currentXhr);
    };
    PutPart.prototype.onProgress = function(evt) {
        if (evt.loaded > 0) {
            var loadedNow = evt.loaded - this.part.loadedBytes;
            if (loadedNow) {
                this.part.loadedBytes = evt.loaded;
                this.fileUpload.updateLoaded(loadedNow);
            }
        }
    };
    PutPart.prototype.stalledPartMonitor = function() {
        var lastLoaded = this.part.loadedBytes;
        var self = this;
        return function() {
            clearInterval(self.stalledInterval);
            if ([
                EVAPORATING,
                ERROR,
                PAUSING,
                PAUSED
            ].indexOf(self.fileUpload.status) === -1 && self.part.status !== ABORTED && self.part.loadedBytes < this.size) {
                if (lastLoaded === self.part.loadedBytes) {
                    l.w('Part stalled. Will abort and retry:', self.partNumber, decodeURIComponent(self.fileUpload.name));
                    self.abort();
                    if (!self.errorExceptionStatus()) self.delaySend();
                } else self.stalledInterval = setInterval(self.stalledPartMonitor(), PARTS_MONITOR_INTERVAL_MS);
            }
        };
    };
    PutPart.prototype.resetLoadedBytes = function() {
        this.fileUpload.updateLoaded(-this.part.loadedBytes);
        this.part.loadedBytes = 0;
        this.fileUpload.onProgress();
    };
    PutPart.prototype.errorExceptionStatus = function() {
        return [
            CANCELED,
            ABORTED,
            PAUSED,
            PAUSING
        ].indexOf(this.fileUpload.status) > -1;
    };
    PutPart.prototype.delaySend = function() {
        var backOffWait = this.backOffWait();
        this.attempts += 1;
        setTimeout(this.send.bind(this), backOffWait);
    };
    PutPart.prototype.errorHandler = function(reason) {
        clearInterval(this.stalledInterval);
        if (reason.match(/status:404/)) {
            var errMsg = '404 error on part PUT. The part and the file will abort. ' + reason;
            l.w(errMsg);
            this.fileUpload.error(errMsg);
            this.part.status = ABORTED;
            this.awsDeferred.reject(errMsg);
            return true;
        }
        this.resetLoadedBytes();
        this.part.status = ERROR;
        if (!this.errorExceptionStatus()) this.delaySend();
        return true;
    };
    PutPart.prototype.abort = function() {
        if (this.currentXhr) this.currentXhr.abort();
        this.resetLoadedBytes();
        this.attempts = 1;
    };
    PutPart.size = 0;
    PutPart.prototype.streamToArrayBuffer = function(stream) {
        return new Promise((function(resolve, reject) {
            // stream is empty or ended
            if (!stream.readable) return resolve([]);
            var arr = new Uint8Array(Math.min(this.con.partSize, this.end - this.start)), i = 0;
            stream.on('data', onData);
            stream.on('end', onEnd);
            stream.on('error', onEnd);
            stream.on('close', onClose);
            function onData(data) {
                if (data.byteLength === 1) return;
                arr.set(data, i);
                i += data.byteLength;
            }
            function onEnd(err) {
                if (err) reject(err);
                else resolve(arr);
                cleanup();
            }
            function onClose() {
                resolve(arr);
                cleanup();
            }
            function cleanup() {
                arr = null;
                stream.removeListener('data', onData);
                stream.removeListener('end', onEnd);
                stream.removeListener('error', onEnd);
                stream.removeListener('close', onClose);
            }
        }).bind(this));
    };
    PutPart.prototype.getPayload = function() {
        if (typeof this.payloadPromise === 'undefined') this.payloadPromise = this.con.readableStreams ? this.payloadFromStream() : this.payloadFromBlob();
        return this.payloadPromise;
    };
    PutPart.prototype.payloadFromStream = function() {
        var stream = this.con.readableStreamPartMethod(this.fileUpload.file, this.start, this.end - 1);
        return new Promise((function(resolve, reject) {
            var streamPromise = this.streamToArrayBuffer(stream);
            streamPromise.then((function(data) {
                resolve(data);
            }).bind(this), reject);
        }).bind(this));
    };
    PutPart.prototype.payloadFromBlob = function() {
        // browsers' implementation of the Blob.slice function has been renamed a couple of times, and the meaning of the
        // 2nd parameter changed. For example Gecko went from slice(start,length) -> mozSlice(start, end) -> slice(start, end).
        // As of 12/12/12, it seems that the unified 'slice' is the best bet, hence it being first in the list. See
        // https://developer.mozilla.org/en-US/docs/DOM/Blob for more info.
        var file = this.fileUpload.file, slicerFn = file.slice ? 'slice' : file.mozSlice ? 'mozSlice' : 'webkitSlice', blob = file[slicerFn](this.start, this.end);
        if (this.con.computeContentMd5) return new Promise(function(resolve) {
            var reader = new FileReader();
            reader.onloadend = function() {
                var buffer = this.result && typeof this.result.buffer !== 'undefined', result = buffer ? new Uint8Array(this.result.buffer) : this.result;
                resolve(result);
            };
            reader.readAsArrayBuffer(blob);
        });
        return Promise.resolve(blob);
    };
    PutPart.prototype.stalledInterval = -1;
    PutPart.prototype.getStartedPromise = function() {
        return this.started.promise;
    };
    //http://docs.amazonwebservices.com/AmazonS3/latest/API/mpUploadAbort.html
    function DeleteMultipartUpload(fileUpload) {
        fileUpload.info('will attempt to abort the upload');
        fileUpload.abortParts();
        var request = {
            method: 'DELETE',
            path: '?uploadId=' + fileUpload.uploadId,
            x_amz_headers: fileUpload.xAmzHeadersCommon,
            success404: true,
            step: 'abort'
        };
        SignedS3AWSRequest.call(this, fileUpload, request);
    }
    DeleteMultipartUpload.prototype = Object.create(SignedS3AWSRequest.prototype);
    DeleteMultipartUpload.prototype.constructor = DeleteMultipartUpload;
    DeleteMultipartUpload.prototype.maxRetries = 1;
    DeleteMultipartUpload.prototype.success = function() {
        this.fileUpload.setStatus(ABORTED);
        this.awsDeferred.resolve(this.currentXhr);
    };
    DeleteMultipartUpload.prototype.errorHandler = function(reason) {
        if (this.attempts > this.maxRetries) {
            var msg = 'Error aborting upload, Exceeded retries deleting the file upload: ' + reason;
            l.w(msg);
            this.fileUpload.error(msg);
            this.awsDeferred.reject(msg);
            return true;
        }
    };
    function signingVersion(awsRequest, l) {
        var con = awsRequest.con;
        function AwsSignature(request) {
            this.request = request;
        }
        AwsSignature.prototype.request = {};
        AwsSignature.prototype.error = function() {};
        AwsSignature.prototype.authorizationString = function() {};
        AwsSignature.prototype.stringToSign = function() {};
        AwsSignature.prototype.canonicalRequest = function() {};
        AwsSignature.prototype.setHeaders = function() {};
        AwsSignature.prototype.datetime = function(timeOffset) {
            return new Date(new Date().getTime() + timeOffset);
        };
        AwsSignature.prototype.dateString = function(timeOffset) {
            return this.datetime(timeOffset).toISOString().slice(0, 19).replace(/-|:/g, '') + "Z";
        };
        function AwsSignatureV2(request) {
            AwsSignature.call(this, request);
        }
        AwsSignatureV2.prototype = Object.create(AwsSignature.prototype);
        AwsSignatureV2.prototype.constructor = AwsSignatureV2;
        AwsSignatureV2.prototype.authorizationString = function() {
            return [
                'AWS ',
                con.aws_key,
                ':',
                this.request.auth
            ].join('');
        };
        AwsSignatureV2.prototype.stringToSign = function() {
            var x_amz_headers = '', result, header_key_array = [];
            for(var key in this.request.x_amz_headers)if (this.request.x_amz_headers.hasOwnProperty(key)) header_key_array.push(key);
            header_key_array.sort();
            header_key_array.forEach((function(header_key) {
                x_amz_headers += header_key + ':' + this.request.x_amz_headers[header_key] + '\n';
            }).bind(this));
            result = this.request.method + '\n' + (this.request.md5_digest || '') + '\n' + (this.request.contentType || '') + '\n' + '\n' + x_amz_headers + (con.cloudfront ? '/' + con.bucket : '') + awsRequest.getPath() + this.request.path;
            l.d('V2 stringToSign:', result);
            return result;
        };
        AwsSignatureV2.prototype.dateString = function(timeOffset) {
            return this.datetime(timeOffset).toUTCString();
        };
        AwsSignatureV2.prototype.getPayload = function() {
            return Promise.resolve();
        };
        function AwsSignatureV4(request) {
            this._cr = undefined;
            AwsSignature.call(this, request);
        }
        AwsSignatureV4.prototype = Object.create(AwsSignature.prototype);
        AwsSignatureV4.prototype.constructor = AwsSignatureV4;
        AwsSignatureV4.prototype._cr = undefined;
        AwsSignatureV4.prototype.payload = null;
        AwsSignatureV4.prototype.error = function() {
            this._cr = undefined;
        };
        AwsSignatureV4.prototype.getPayload = function() {
            return awsRequest.getPayload().then((function(data) {
                this.payload = data;
            }).bind(this));
        };
        AwsSignatureV4.prototype.authorizationString = function() {
            var authParts = [];
            var credentials = this.credentialString();
            var headers = this.canonicalHeaders();
            authParts.push([
                'AWS4-HMAC-SHA256 Credential=',
                con.aws_key,
                '/',
                credentials
            ].join(''));
            authParts.push('SignedHeaders=' + headers.signedHeaders);
            authParts.push('Signature=' + this.request.auth);
            return authParts.join(', ');
        };
        AwsSignatureV4.prototype.stringToSign = function() {
            var signParts = [];
            signParts.push('AWS4-HMAC-SHA256');
            signParts.push(this.request.dateString);
            signParts.push(this.credentialString());
            signParts.push(con.cryptoHexEncodedHash256(this.canonicalRequest()));
            var result = signParts.join('\n');
            l.d('V4 stringToSign:', result);
            return result;
        };
        AwsSignatureV4.prototype.credentialString = function() {
            var credParts = [];
            credParts.push(this.request.dateString.slice(0, 8));
            credParts.push(con.awsRegion);
            credParts.push('s3');
            credParts.push('aws4_request');
            return credParts.join('/');
        };
        AwsSignatureV4.prototype.canonicalQueryString = function() {
            var qs = awsRequest.request.query_string || '', search = uri([
                awsRequest.awsUrl,
                this.request.path,
                qs
            ].join("")).search, searchParts = search.length ? search.split('&') : [], encoded = [], nameValue, i;
            for(i = 0; i < searchParts.length; i++){
                nameValue = searchParts[i].split("=");
                encoded.push({
                    name: encodeURIComponent(nameValue[0]),
                    value: nameValue.length > 1 ? encodeURIComponent(nameValue[1]) : null
                });
            }
            var sorted = encoded.sort(function(a, b) {
                if (a.name < b.name) return -1;
                else if (a.name > b.name) return 1;
                return 0;
            });
            var result = [];
            for(i = 0; i < sorted.length; i++){
                nameValue = sorted[i].value ? [
                    sorted[i].name,
                    sorted[i].value
                ].join("=") : sorted[i].name + '=';
                result.push(nameValue);
            }
            return result.join('&');
        };
        AwsSignatureV4.prototype.getPayloadSha256Content = function() {
            var result = this.request.contentSha256 || con.cryptoHexEncodedHash256(this.payload || '');
            l.d(this.request.step, 'getPayloadSha256Content:', result);
            return result;
        };
        AwsSignatureV4.prototype.canonicalHeaders = function() {
            var canonicalHeaders = [], keys = [], i;
            function addHeader(name, value) {
                var key = name.toLowerCase();
                keys.push(key);
                canonicalHeaders[key] = value.replace(/\s+/g, ' ');
            }
            if (this.request.md5_digest) addHeader("Content-Md5", this.request.md5_digest);
            addHeader('Host', awsRequest.awsHost);
            if (this.request.contentType) addHeader('Content-Type', this.request.contentType || '');
            var amzHeaders = this.request.x_amz_headers || {};
            for(var key in amzHeaders)if (amzHeaders.hasOwnProperty(key)) addHeader(key, amzHeaders[key]);
            var sortedKeys = keys.sort(function(a, b) {
                if (a < b) return -1;
                else if (a > b) return 1;
                return 0;
            });
            var result = [];
            var unsigned_headers = [], not_signed = this.request.not_signed_headers || [], signed_headers = [];
            for(i = 0; i < not_signed.length; i++)unsigned_headers.push(not_signed[i].toLowerCase());
            for(i = 0; i < sortedKeys.length; i++){
                var k = sortedKeys[i];
                result.push([
                    k,
                    canonicalHeaders[k]
                ].join(":"));
                if (unsigned_headers.indexOf(k) === -1) signed_headers.push(k);
            }
            return {
                canonicalHeaders: result.join("\n"),
                signedHeaders: signed_headers.join(";")
            };
        };
        AwsSignatureV4.prototype.canonicalRequest = function() {
            if (typeof this._cr !== 'undefined') return this._cr;
            var canonParts = [];
            canonParts.push(this.request.method);
            canonParts.push(uri([
                awsRequest.awsUrl,
                awsRequest.getPath(),
                this.request.path
            ].join("")).pathname);
            canonParts.push(this.canonicalQueryString() || '');
            var headers = this.canonicalHeaders();
            canonParts.push(headers.canonicalHeaders + '\n');
            canonParts.push(headers.signedHeaders);
            canonParts.push(this.getPayloadSha256Content());
            this._cr = canonParts.join("\n");
            l.d(this.request.step, 'V4 CanonicalRequest:', this._cr);
            return this._cr;
        };
        AwsSignatureV4.prototype.setHeaders = function(xhr) {
            xhr.setRequestHeader("x-amz-content-sha256", this.getPayloadSha256Content());
        };
        return con.awsSignatureVersion === '4' ? AwsSignatureV4 : AwsSignatureV2;
    }
    function authorizationMethod(awsRequest) {
        var fileUpload = awsRequest.fileUpload, con = fileUpload.con, request = awsRequest.request;
        function AuthorizationMethod() {
            this.request = request;
        }
        AuthorizationMethod.prototype = Object.create(AuthorizationMethod.prototype);
        AuthorizationMethod.prototype.request = {};
        AuthorizationMethod.makeSignParamsObject = function(params) {
            var out = {};
            for(var param in params){
                if (!params.hasOwnProperty(param)) continue;
                if (typeof params[param] === 'function') out[param] = params[param]();
                else out[param] = params[param];
            }
            return out;
        };
        AuthorizationMethod.prototype.authorize = function() {
            return new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest();
                awsRequest.currentXhr = xhr;
                var stringToSign = awsRequest.stringToSign(), url = [
                    con.signerUrl,
                    '?to_sign=',
                    stringToSign,
                    '&datetime=',
                    request.dateString
                ];
                if (con.sendCanonicalRequestToSignerUrl) {
                    url.push('&canonical_request=');
                    url.push(encodeURIComponent(awsRequest.canonicalRequest()));
                }
                url = url.join("");
                var signParams = AuthorizationMethod.makeSignParamsObject(fileUpload.signParams);
                for(var param in signParams){
                    if (!signParams.hasOwnProperty(param)) continue;
                    url += '&' + encodeURIComponent(param) + '=' + encodeURIComponent(signParams[param]);
                }
                if (con.xhrWithCredentials) xhr.withCredentials = true;
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) awsRequest.signResponse(xhr.response, stringToSign, request.dateString).then(resolve);
                        else {
                            if ([
                                401,
                                403
                            ].indexOf(xhr.status) > -1) {
                                var reason = "status:" + xhr.status;
                                fileUpload.deferredCompletion.reject('Permission denied ' + reason);
                                return reject(reason);
                            }
                            reject("Signature fetch returned status: " + xhr.status);
                        }
                    }
                };
                xhr.onerror = function(xhr) {
                    reject('authorizedSend transport error: ' + xhr.responseText);
                };
                xhr.open('GET', url);
                var signHeaders = AuthorizationMethod.makeSignParamsObject(con.signHeaders);
                for(var header in signHeaders){
                    if (!signHeaders.hasOwnProperty(header)) continue;
                    xhr.setRequestHeader(header, signHeaders[header]);
                }
                if (typeof fileUpload.beforeSigner === 'function') fileUpload.beforeSigner(xhr, url);
                xhr.send();
            });
        };
        function AuthorizationCustom() {
            AuthorizationMethod.call(this);
        }
        AuthorizationCustom.prototype = Object.create(AuthorizationMethod.prototype);
        AuthorizationCustom.prototype.authorize = function() {
            return con.customAuthMethod(AuthorizationMethod.makeSignParamsObject(fileUpload.signParams), AuthorizationMethod.makeSignParamsObject(con.signHeaders), awsRequest.stringToSign(), request.dateString, awsRequest.canonicalRequest()).catch(function(reason) {
                fileUpload.deferredCompletion.reject(reason);
                throw reason;
            });
        };
        if (typeof con.customAuthMethod === 'function') return new AuthorizationCustom();
        return new AuthorizationMethod();
    }
    function awsUrl(con) {
        var url;
        if (con.aws_url) url = [
            con.aws_url
        ];
        else {
            if (con.s3Acceleration) {
                url = [
                    "https://",
                    con.bucket,
                    ".s3-accelerate"
                ];
                con.cloudfront = true;
            } else {
                url = [
                    "https://",
                    con.cloudfront ? con.bucket + "." : "",
                    "s3"
                ];
                if (con.awsRegion !== "us-east-1") url.push("-", con.awsRegion);
            }
            url.push(".amazonaws.com");
        }
        return url.join("");
    }
    function s3EncodedObjectName(fileName) {
        var fileParts = fileName.split('/'), encodedParts = [];
        fileParts.forEach(function(p) {
            var buf = [], enc = encodeURIComponent(p);
            for(var i = 0; i < enc.length; i++)buf.push(S3_EXTRA_ENCODED_CHARS[enc.charCodeAt(i)] || enc.charAt(i));
            encodedParts.push(buf.join(""));
        });
        return encodedParts.join('/');
    }
    function uri(url) {
        var p, href = url || '/';
        try {
            p = new URL(href);
        } catch (e) {
            p = document.createElement('a');
            p.href = href;
        }
        return {
            protocol: p.protocol,
            hostname: p.hostname,
            // IE omits the leading slash, so add it if it's missing
            pathname: p.pathname.replace(/(^\/?)/, "/"),
            port: p.port,
            search: p.search[0] === '?' ? p.search.substr(1) : p.search,
            hash: p.hash,
            host: p.host // => "example.com:3000"
        };
    }
    function dateISOString(date) {
        // Try to get the modified date as an ISO String, if the date exists
        return date ? new Date(date).toISOString() : '';
    }
    function getAwsResponse(xhr) {
        var code = elementText(xhr.responseText, "Code"), msg = elementText(xhr.responseText, "Message");
        return code.length ? [
            'AWS Code: ',
            code,
            ', Message:',
            msg
        ].join("") : '';
    }
    function elementText(source, element) {
        var match = source.match([
            "<",
            element,
            ">(.+)</",
            element,
            ">"
        ].join(""));
        return match ? match[1] : '';
    }
    function defer() {
        var deferred = {}, promise;
        promise = new Promise(function(resolve, reject) {
            deferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            resolve: deferred.resolve,
            reject: deferred.reject,
            promise: promise
        };
    }
    function extend(obj1, obj2, obj3) {
        function ext(target, source) {
            if (typeof source !== 'object') return;
            for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
        }
        obj1 = obj1 || {};
        obj2 = obj2 || {};
        obj3 = obj3 || {};
        ext(obj2, obj3);
        ext(obj1, obj2);
        return obj1;
    }
    function getSavedUploads(purge) {
        var uploads = JSON.parse(historyCache.getItem('awsUploads') || '{}');
        if (purge) {
            for(var key in uploads)if (uploads.hasOwnProperty(key)) {
                var upload = uploads[key], completedAt = new Date(upload.completedAt || FAR_FUTURE);
                if (completedAt < HOURS_AGO) // The upload is recent, let's keep it
                delete uploads[key];
            }
            historyCache.setItem('awsUploads', JSON.stringify(uploads));
        }
        return uploads;
    }
    function uploadKey(fileUpload) {
        // The key tries to give a signature to a file in the absence of its path.
        // "<filename>-<mimetype>-<modifieddate>-<filesize>"
        return [
            fileUpload.file.name,
            fileUpload.file.type,
            dateISOString(fileUpload.file.lastModified),
            fileUpload.sizeBytes
        ].join("-");
    }
    function saveUpload(uploadKey, upload) {
        var uploads = getSavedUploads();
        uploads[uploadKey] = upload;
        historyCache.setItem('awsUploads', JSON.stringify(uploads));
    }
    function removeUpload(uploadKey) {
        var uploads = getSavedUploads();
        delete uploads[uploadKey];
        historyCache.setItem('awsUploads', JSON.stringify(uploads));
    }
    function removeAtIndex(a, i) {
        var idx = a.indexOf(i);
        if (idx > -1) {
            a.splice(idx, 1);
            return true;
        }
    }
    function readableFileSize(size) {
        // Adapted from https://github.com/fkjaekel
        // https://github.com/TTLabs/EvaporateJS/issues/13
        var units = [
            'B',
            'Kb',
            'Mb',
            'Gb',
            'Tb',
            'Pb',
            'Eb',
            'Zb',
            'Yb'
        ], i = 0;
        while(size >= 1024){
            size /= 1024;
            ++i;
        }
        return [
            size.toFixed(2).replace('.00', ''),
            units[i]
        ].join(" ");
    }
    var historyCache;
    function HistoryCache(mockLocalStorage) {
        var supported = HistoryCache.supported();
        this.cacheStore = mockLocalStorage ? {} : supported ? localStorage : undefined;
    }
    HistoryCache.prototype.supported = false;
    HistoryCache.prototype.cacheStore = undefined;
    HistoryCache.prototype.getItem = function(key) {
        if (this.cacheStore) return this.cacheStore[key];
    };
    HistoryCache.prototype.setItem = function(key, value) {
        if (this.cacheStore) this.cacheStore[key] = value;
    };
    HistoryCache.prototype.removeItem = function(key) {
        if (this.cacheStore) return delete this.cacheStore[key];
    };
    HistoryCache.supported = function() {
        var result = false;
        if (typeof window !== 'undefined') {
            if (!('localStorage' in window)) return result;
        } else return result;
        // Try to use storage (it might be disabled, e.g. user is in private mode)
        try {
            var k = '___test';
            localStorage[k] = 'OK';
            var test = localStorage[k];
            delete localStorage[k];
            return test === 'OK';
        } catch (e) {
            return result;
        }
    };
    function noOpLogger() {
        return {
            d: function() {},
            w: function() {},
            e: function() {}
        };
    }
    l = noOpLogger();
    if (module.exports) module.exports = Evaporate;
    else if (typeof window !== 'undefined') window.Evaporate = Evaporate;
})();

});

parcelRegister("3D2Yk", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});

parcelRegister("aPr3M", function(module, exports) {
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 1.0.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2026
 * @license MIT
 */ 'use strict';
var $ca2137e69176009d$var$INPUT_ERROR = 'input is invalid type';
var $ca2137e69176009d$var$FINALIZE_ERROR = 'finalize already called';
var $ca2137e69176009d$var$ARRAY_BUFFER = typeof ArrayBuffer !== 'undefined';
var $ca2137e69176009d$var$formatMessage = function(message) {
    var type = typeof message;
    if (type === 'string') return [
        message,
        true
    ];
    if (Array.isArray(message)) return [
        message,
        false
    ];
    if ($ca2137e69176009d$var$ARRAY_BUFFER && message) {
        if (message.constructor === ArrayBuffer) return [
            new Uint8Array(message),
            false
        ];
        else if (ArrayBuffer.isView(message)) return [
            message,
            false
        ];
    }
    throw new Error($ca2137e69176009d$var$INPUT_ERROR);
};
var $ca2137e69176009d$var$HEX_CHARS = '0123456789abcdef'.split('');
var $ca2137e69176009d$var$EXTRA = [
    -2147483648,
    8388608,
    32768,
    128
];
var $ca2137e69176009d$var$SHIFT = [
    24,
    16,
    8,
    0
];
var $ca2137e69176009d$var$K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
var $ca2137e69176009d$var$OUTPUT_TYPES = [
    'hex',
    'array',
    'digest',
    'arrayBuffer'
];
var $ca2137e69176009d$var$blocks = [];
var $ca2137e69176009d$var$createOutputMethod = function(outputType, is224) {
    return function(message) {
        return new $ca2137e69176009d$var$Sha256(is224, true).update(message)[outputType]();
    };
};
var $ca2137e69176009d$var$createMethod = function(is224) {
    var method = $ca2137e69176009d$var$createOutputMethod('hex', is224);
    method.create = function() {
        return new $ca2137e69176009d$var$Sha256(is224);
    };
    method.update = function(message) {
        return method.create().update(message);
    };
    for(var i = 0; i < $ca2137e69176009d$var$OUTPUT_TYPES.length; ++i){
        var type = $ca2137e69176009d$var$OUTPUT_TYPES[i];
        method[type] = $ca2137e69176009d$var$createOutputMethod(type, is224);
    }
    return method;
};
var $ca2137e69176009d$var$createHmacOutputMethod = function(outputType, is224) {
    return function(key, message) {
        return new $ca2137e69176009d$var$HmacSha256(key, is224, true).update(message)[outputType]();
    };
};
var $ca2137e69176009d$var$createHmacMethod = function(is224) {
    var method = $ca2137e69176009d$var$createHmacOutputMethod('hex', is224);
    method.create = function(key) {
        return new $ca2137e69176009d$var$HmacSha256(key, is224);
    };
    method.update = function(key, message) {
        return method.create(key).update(message);
    };
    for(var i = 0; i < $ca2137e69176009d$var$OUTPUT_TYPES.length; ++i){
        var type = $ca2137e69176009d$var$OUTPUT_TYPES[i];
        method[type] = $ca2137e69176009d$var$createHmacOutputMethod(type, is224);
    }
    return method;
};
function $ca2137e69176009d$var$Sha256(is224, sharedMemory) {
    if (sharedMemory) {
        $ca2137e69176009d$var$blocks[0] = $ca2137e69176009d$var$blocks[16] = $ca2137e69176009d$var$blocks[1] = $ca2137e69176009d$var$blocks[2] = $ca2137e69176009d$var$blocks[3] = $ca2137e69176009d$var$blocks[4] = $ca2137e69176009d$var$blocks[5] = $ca2137e69176009d$var$blocks[6] = $ca2137e69176009d$var$blocks[7] = $ca2137e69176009d$var$blocks[8] = $ca2137e69176009d$var$blocks[9] = $ca2137e69176009d$var$blocks[10] = $ca2137e69176009d$var$blocks[11] = $ca2137e69176009d$var$blocks[12] = $ca2137e69176009d$var$blocks[13] = $ca2137e69176009d$var$blocks[14] = $ca2137e69176009d$var$blocks[15] = 0;
        this.blocks = $ca2137e69176009d$var$blocks;
    } else this.blocks = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    if (is224) {
        this.h0 = 0xc1059ed8;
        this.h1 = 0x367cd507;
        this.h2 = 0x3070dd17;
        this.h3 = 0xf70e5939;
        this.h4 = 0xffc00b31;
        this.h5 = 0x68581511;
        this.h6 = 0x64f98fa7;
        this.h7 = 0xbefa4fa4;
    } else {
        this.h0 = 0x6a09e667;
        this.h1 = 0xbb67ae85;
        this.h2 = 0x3c6ef372;
        this.h3 = 0xa54ff53a;
        this.h4 = 0x510e527f;
        this.h5 = 0x9b05688c;
        this.h6 = 0x1f83d9ab;
        this.h7 = 0x5be0cd19;
    }
    this.block = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
    this.is224 = is224;
}
$ca2137e69176009d$var$Sha256.prototype.update = function(message) {
    if (this.finalized) throw new Error($ca2137e69176009d$var$FINALIZE_ERROR);
    var result = $ca2137e69176009d$var$formatMessage(message);
    message = result[0];
    var isString = result[1];
    var code, index = 0, i, length = message.length, blocks = this.blocks;
    while(index < length){
        if (this.hashed) {
            this.hashed = false;
            blocks[0] = this.block;
            this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        if (isString) for(i = this.start; index < length && i < 64; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >>> 2] |= code << $ca2137e69176009d$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >>> 2] |= (0xc0 | code >>> 6) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >>> 2] |= (0xe0 | code >>> 12) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >>> 2] |= (0xf0 | code >>> 18) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
                blocks[i >>> 2] |= (0x80 | code & 0x3f) << $ca2137e69176009d$var$SHIFT[i++ & 3];
            }
        }
        else for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << $ca2137e69176009d$var$SHIFT[i++ & 3];
        this.lastByteIndex = i;
        this.bytes += i - this.start;
        if (i >= 64) {
            this.block = blocks[16];
            this.start = i - 64;
            this.hash();
            this.hashed = true;
        } else this.start = i;
    }
    if (this.bytes > 4294967295) {
        this.hBytes += this.bytes / 4294967296 << 0;
        this.bytes = this.bytes % 4294967296;
    }
    return this;
};
$ca2137e69176009d$var$Sha256.prototype.finalize = function() {
    if (this.finalized) return;
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >>> 2] |= $ca2137e69176009d$var$EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
        if (!this.hashed) this.hash();
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
    blocks[15] = this.bytes << 3;
    this.hash();
};
$ca2137e69176009d$var$Sha256.prototype.hash = function() {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
    for(j = 16; j < 64; ++j){
        // rightrotate
        t1 = blocks[j - 15];
        s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
        t1 = blocks[j - 2];
        s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
        blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
    }
    bc = b & c;
    for(j = 0; j < 64; j += 4){
        if (this.first) {
            if (this.is224) {
                ab = 300032;
                t1 = blocks[0] - 1413257819;
                h = t1 - 150054599 << 0;
                d = t1 + 24177077 << 0;
            } else {
                ab = 704751109;
                t1 = blocks[0] - 210244248;
                h = t1 - 1521486534 << 0;
                d = t1 + 143694565 << 0;
            }
            this.first = false;
        } else {
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            ab = a & b;
            maj = ab ^ a & c ^ bc;
            ch = e & f ^ ~e & g;
            t1 = h + s1 + ch + $ca2137e69176009d$var$K[j] + blocks[j];
            t2 = s0 + maj;
            h = d + t1 << 0;
            d = t1 + t2 << 0;
        }
        s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
        s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
        da = d & a;
        maj = da ^ d & b ^ ab;
        ch = h & e ^ ~h & f;
        t1 = g + s1 + ch + $ca2137e69176009d$var$K[j + 1] + blocks[j + 1];
        t2 = s0 + maj;
        g = c + t1 << 0;
        c = t1 + t2 << 0;
        s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
        s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
        cd = c & d;
        maj = cd ^ c & a ^ da;
        ch = g & h ^ ~g & e;
        t1 = f + s1 + ch + $ca2137e69176009d$var$K[j + 2] + blocks[j + 2];
        t2 = s0 + maj;
        f = b + t1 << 0;
        b = t1 + t2 << 0;
        s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
        s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
        bc = b & c;
        maj = bc ^ b & d ^ cd;
        ch = f & g ^ ~f & h;
        t1 = e + s1 + ch + $ca2137e69176009d$var$K[j + 3] + blocks[j + 3];
        t2 = s0 + maj;
        e = a + t1 << 0;
        a = t1 + t2 << 0;
        this.chromeBugWorkAround = true;
    }
    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
    this.h5 = this.h5 + f << 0;
    this.h6 = this.h6 + g << 0;
    this.h7 = this.h7 + h << 0;
};
$ca2137e69176009d$var$Sha256.prototype.hex = function() {
    this.finalize();
    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
    var hex = $ca2137e69176009d$var$HEX_CHARS[h0 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h0 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h1 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h2 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h3 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h5 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h6 & 0x0F];
    if (!this.is224) hex += $ca2137e69176009d$var$HEX_CHARS[h7 >>> 28 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 24 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 20 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 16 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 12 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 8 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 >>> 4 & 0x0F] + $ca2137e69176009d$var$HEX_CHARS[h7 & 0x0F];
    return hex;
};
$ca2137e69176009d$var$Sha256.prototype.toString = $ca2137e69176009d$var$Sha256.prototype.hex;
$ca2137e69176009d$var$Sha256.prototype.digest = function() {
    this.finalize();
    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
    var arr = [
        h0 >>> 24 & 0xFF,
        h0 >>> 16 & 0xFF,
        h0 >>> 8 & 0xFF,
        h0 & 0xFF,
        h1 >>> 24 & 0xFF,
        h1 >>> 16 & 0xFF,
        h1 >>> 8 & 0xFF,
        h1 & 0xFF,
        h2 >>> 24 & 0xFF,
        h2 >>> 16 & 0xFF,
        h2 >>> 8 & 0xFF,
        h2 & 0xFF,
        h3 >>> 24 & 0xFF,
        h3 >>> 16 & 0xFF,
        h3 >>> 8 & 0xFF,
        h3 & 0xFF,
        h4 >>> 24 & 0xFF,
        h4 >>> 16 & 0xFF,
        h4 >>> 8 & 0xFF,
        h4 & 0xFF,
        h5 >>> 24 & 0xFF,
        h5 >>> 16 & 0xFF,
        h5 >>> 8 & 0xFF,
        h5 & 0xFF,
        h6 >>> 24 & 0xFF,
        h6 >>> 16 & 0xFF,
        h6 >>> 8 & 0xFF,
        h6 & 0xFF
    ];
    if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
    return arr;
};
$ca2137e69176009d$var$Sha256.prototype.array = $ca2137e69176009d$var$Sha256.prototype.digest;
$ca2137e69176009d$var$Sha256.prototype.arrayBuffer = function() {
    this.finalize();
    var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    dataView.setUint32(20, this.h5);
    dataView.setUint32(24, this.h6);
    if (!this.is224) dataView.setUint32(28, this.h7);
    return buffer;
};
function $ca2137e69176009d$var$HmacSha256(key, is224, sharedMemory) {
    var i, result = $ca2137e69176009d$var$formatMessage(key);
    key = result[0];
    if (result[1]) {
        var bytes = [], length = key.length, index = 0, code;
        for(i = 0; i < length; ++i){
            code = key.charCodeAt(i);
            if (code < 0x80) bytes[index++] = code;
            else if (code < 0x800) {
                bytes[index++] = 0xc0 | code >>> 6;
                bytes[index++] = 0x80 | code & 0x3f;
            } else if (code < 0xd800 || code >= 0xe000) {
                bytes[index++] = 0xe0 | code >>> 12;
                bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                bytes[index++] = 0x80 | code & 0x3f;
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                bytes[index++] = 0xf0 | code >>> 18;
                bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                bytes[index++] = 0x80 | code & 0x3f;
            }
        }
        key = bytes;
    }
    if (key.length > 64) key = new $ca2137e69176009d$var$Sha256(is224, true).update(key).array();
    var oKeyPad = [], iKeyPad = [];
    for(i = 0; i < 64; ++i){
        var b = key[i] || 0;
        oKeyPad[i] = 0x5c ^ b;
        iKeyPad[i] = 0x36 ^ b;
    }
    $ca2137e69176009d$var$Sha256.call(this, is224, sharedMemory);
    this.update(iKeyPad);
    this.oKeyPad = oKeyPad;
    this.inner = true;
    this.sharedMemory = sharedMemory;
}
$ca2137e69176009d$var$HmacSha256.prototype = new $ca2137e69176009d$var$Sha256();
$ca2137e69176009d$var$HmacSha256.prototype.finalize = function() {
    $ca2137e69176009d$var$Sha256.prototype.finalize.call(this);
    if (this.inner) {
        this.inner = false;
        var innerHash = this.array();
        $ca2137e69176009d$var$Sha256.call(this, this.is224, this.sharedMemory);
        this.update(this.oKeyPad);
        this.update(innerHash);
        $ca2137e69176009d$var$Sha256.prototype.finalize.call(this);
    }
};
var $ca2137e69176009d$var$sha256 = $ca2137e69176009d$var$createMethod();
var $ca2137e69176009d$var$sha224 = $ca2137e69176009d$var$createMethod(true);
$ca2137e69176009d$var$sha256.sha256 = $ca2137e69176009d$var$sha256;
$ca2137e69176009d$var$sha256.sha224 = $ca2137e69176009d$var$sha224;
$ca2137e69176009d$var$sha256.hmac = $ca2137e69176009d$var$createHmacMethod();
$ca2137e69176009d$var$sha224.hmac = $ca2137e69176009d$var$createHmacMethod(true);
module.exports = $ca2137e69176009d$var$sha256;

});


parcelRegister("kRPup", function(module, exports) {
module.exports = function player(app) {
    var key = 'nomalabLastAudioQualification';
    function init() {
        if (localStorage.getItem(key) === null) localStorage.setItem(key, JSON.stringify({}));
    }
    function clean() {
        if (localStorage.getItem(key) != null) {
            localStorage.setItem(key, JSON.stringify({}));
            app.ports.content.send(getContent());
        }
    }
    function set(k, v, l, t) {
        var s = JSON.parse(localStorage.getItem(key));
        s[k] = {
            v: v,
            l: l,
            t: t
        };
        localStorage.setItem(key, JSON.stringify(s));
    }
    function get(record) {
        return {
            fileId: record.fileId,
            channels: record.channels,
            result: getContent()
        };
    }
    function getContent() {
        var store = JSON.parse(localStorage.getItem(key));
        var r = [];
        Object.keys(store).forEach(function(k) {
            r.push({
                index: parseInt(k, 10),
                version: store[k].v,
                layout: store[k].l,
                typeVersion: store[k].t
            });
        });
        return r;
    }
    init();
    app.ports.get.subscribe(function(record) {
        app.ports.lastAudioQualification.send(get(record));
    });
    app.ports.info.subscribe(function() {
        app.ports.content.send(getContent());
    });
    app.ports.clean.subscribe(clean);
    app.ports.save.subscribe(function(recordList) {
        recordList.forEach(function(record) {
            if (record.layout !== null && record.typeVersion !== null) set(record.index, record.version, record.layout, record.typeVersion);
        });
        app.ports.content.send(getContent());
    });
    return app;
};

});

"use strict";
const $be336afef88fa60f$var$global_ = window || self || $parcel$global || Function('return this')();
const $be336afef88fa60f$var$setTimeout_ = setTimeout;
const $be336afef88fa60f$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $be336afef88fa60f$var$secret = -Math.random();
let $be336afef88fa60f$var$promiseSlot; // 👻
Object.defineProperty(Object.prototype, "_elm_ffi_read_", {
    get () {
        return this.value;
    },
    set (code) {
        try {
            this.value = Function(code)();
        } catch (e) {
            console.error(e);
        }
    }
});
Object.defineProperty(Object.prototype, "_elm_ffi_create_", {
    get () {
        return this.value;
    },
    set ({ args: args, code: code }) {
        this.value = $be336afef88fa60f$var$AsyncFunction(...args, code);
    }
});
Object.defineProperty(Object.prototype, "_elm_ffi_apply_", {
    get () {
        return this.value;
    },
    set ({ holder: holder, params: params }) {
        try {
            const f = this;
            this.value = {
                "AW": $be336afef88fa60f$var$secret
            };
            $be336afef88fa60f$var$promiseSlot = ()=>holder["_elm_ffi_create_"](...params).then((val)=>f.value = {
                        "OK": val
                    }).catch((err)=>f.value = {
                        "ER": err
                    });
        } catch (err) {
            this.value = {
                "ER": err
            };
        }
    }
});
$be336afef88fa60f$var$global_.setTimeout = (callback, time, ...args)=>time === $be336afef88fa60f$var$secret ? $be336afef88fa60f$var$promiseSlot().finally(callback) : $be336afef88fa60f$var$setTimeout_(callback, time, ...args);


// needed for ie11
if (!Object.assign) Object.assign = function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (source.hasOwnProperty(key)) target[key] = source[key];
    }
    return target;
};
// safari
// from https://github.com/uxitten/polyfill
if (!String.prototype.padStart) String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) return String(this);
    else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) padString += padString.repeat(targetLength / padString.length);
        return padString.slice(0, targetLength) + String(this);
    }
};
/*
ES6 classes shim for custom elements

> See: https://github.com/webcomponents/custom-elements/blob/d8ecb29ad12abf79cc40ddfb4771d7673e59fce0/tests/html/shim.html
> and: https://github.com/webcomponents/custom-elements/blob/master/src/native-shim.js

EXAMPLE:

function MyTag() {
  return HTMLElement.apply(this);
}

MyTag.prototype = Object.create(HTMLElement.prototype);
MyTag.prototype.constructor = MyTag;

MyTag.prototype.connectedCallback = function() {
    // when added
}
MyTag.prototype.disconnectedCallback = function() {
    // when removed
}
MyTag.prototype.attributeChangedCallback = function() {
    // when attribute changed
}
MyTag.prototype.adoptedCallback = function() {
    // when added too?
}

*/ (function() {
    if (window.Reflect === undefined || window.customElements === undefined || window.customElements.polyfillWrapFlushCallback) return;
    var BuiltInHTMLElement = HTMLElement;
    var wrapperForTheName = {
        'HTMLElement': function HTMLElement1() {
            return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
        }
    };
    window.HTMLElement = wrapperForTheName['HTMLElement'];
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();
//
window.toArray = function(e) {
    return Array.prototype.slice.call(e);
};
// LOGGING (HACK)
Object.defineProperty(Object.prototype, "_elm_ffi_log_str_", {
    get () {
        return this.value;
    },
    set (str) {
        console.log(str);
        this.value = str;
    }
});


var $53dd92cf139b6a84$exports = {};
// hi-tech versioning system
if (localStorage.getItem('version') != 'v01') {
    localStorage.clear();
    localStorage.setItem('version', 'v01');
}
function $53dd92cf139b6a84$var$defaults(name, def) {
    return {
        showAside: $53dd92cf139b6a84$var$get('showAside', '/settings'),
        browserArchive: $53dd92cf139b6a84$var$get('browserArchive', 'seeAll'),
        browserAccept: $53dd92cf139b6a84$var$get('browserAccept', 'seeAll')
    };
}
function $53dd92cf139b6a84$var$subscribe(app) {
    app.ports.setPreference.subscribe(function(value) {
        // sent as a tuple
        $53dd92cf139b6a84$var$set(value[0], value[1]);
    });
    app.ports.resetPreference.subscribe(function(value) {
        localStorage.clear();
    });
    app.ports.downloadAll.subscribe(function(className) {
        let elems = document.getElementsByClassName(className);
        for(let i = 0; i < elems.length; i++)elems[i].click();
    });
}
function $53dd92cf139b6a84$var$get(name, def) {
    return localStorage.getItem(name) || def;
}
function $53dd92cf139b6a84$var$set(name, value) {
    localStorage.setItem(name, value);
}
$53dd92cf139b6a84$exports = {
    defaults: $53dd92cf139b6a84$var$defaults,
    subscribe: $53dd92cf139b6a84$var$subscribe
};


var $cc2b0350e0cbd02a$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return n(r, t, e, u, a, i, o, c);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return n(r, t, e, u, a, i, o, c, s);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    function A8(n, r, t, e, u, a, i, o, c) {
        return 8 === n.a ? n.f(r, t, e, u, a, i, o, c) : n(r)(t)(e)(u)(a)(i)(o)(c);
    }
    function A9(n, r, t, e, u, a, i, o, c, s) {
        return 9 === n.a ? n.f(r, t, e, u, a, i, o, c, s) : n(r)(t)(e)(u)(a)(i)(o)(c)(s);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, m(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = o(n, r, 0, e); u && (t = e.pop()); u = o(t.a, t.b, 0, e));
        return u;
    }
    function o(n, r, t, e) {
        if (t > 100) return e.push(m(n, r)), !0;
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        for(var u in 0 > n.$ && (n = pt(n), r = pt(r)), n)if (!o(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var c = F2(i), s = F2(function(n, r) {
        return !i(n, r);
    });
    function f(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = f(n.a, r.a)) || (t = f(n.b, r.b)) ? t : f(n.c, r.c);
        for(; n.b && r.b && !(t = f(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        var t = f(n, r);
        return 0 > t ? ht : t ? gt : $t;
    });
    function m(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function d(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function b(n) {
        return n;
    }
    function p(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var v = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = h(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = h(n.a, r);
        return t;
    }
    var g = {
        $: 0
    };
    function h(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var k = F2(h);
    function T(n) {
        for(var r = g, t = n.length; t--;)r = h(n[t], r);
        return r;
    }
    function w(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var C = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return T(e);
    }), N = F2(function(n, r) {
        return T(w(r).sort(function(r, t) {
            return f(n(r), n(t));
        }));
    }), A = F2(function(n, r) {
        return T(w(r).sort(function(r, t) {
            var e = A2(n, r, t);
            return e === $t ? 0 : e === ht ? -1 : 1;
        }));
    }), S = F2(function(n, r) {
        return n + r;
    }), L = F2(function(n, r) {
        return n - r;
    }), y = F2(function(n, r) {
        return n * r;
    }), F = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), j = Math.ceil, P = Math.floor, I = Math.round, B = Math.log, M = isNaN, O = F2(function(n, r) {
        return n + r;
    }), q = F2(function(n, r) {
        return n + r;
    }), D = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u;){
            var a = t[u], i = t.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += t[u], u++), r = A2(n, b(a), r);
        }
        return r;
    }), x = F2(function(n, r) {
        return r.split(n);
    }), R = F2(function(n, r) {
        return r.join(n);
    }), V = F3(function(n, r, t) {
        return t.slice(n, r);
    }), E = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(b(e))) return !1;
        }
        return !0;
    }), z = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), U = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), H = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), W = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return g;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return T(u);
    });
    function Q(n) {
        return n + "";
    }
    function Z(n) {
        return {
            $: 2,
            b: n
        };
    }
    var K = Z(function(n) {
        return "number" != typeof n ? pn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? St(n) : !isFinite(n) || n % 1 ? pn("an INT", n) : St(n);
    }), Y = Z(function(n) {
        return "boolean" == typeof n ? St(n) : pn("a BOOL", n);
    }), X = Z(function(n) {
        return "number" == typeof n ? St(n) : pn("a FLOAT", n);
    }), J = Z(function(n) {
        return St(n);
    }), G = Z(function(n) {
        return "string" == typeof n ? St(n) : n instanceof String ? St(n + "") : pn("a STRING", n);
    }), _ = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), nn = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function rn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var tn = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), en = F2(function(n, r) {
        return rn(n, [
            r
        ]);
    }), un = F3(function(n, r, t) {
        return rn(n, [
            r,
            t
        ]);
    }), an = F4(function(n, r, t, e) {
        return rn(n, [
            r,
            t,
            e
        ]);
    }), on = F5(function(n, r, t, e, u) {
        return rn(n, [
            r,
            t,
            e,
            u
        ]);
    }), cn = F9(function(n, r, t, e, u, a, i, o, c) {
        return rn(n, [
            r,
            t,
            e,
            u,
            a,
            i,
            o,
            c
        ]);
    }), sn = F2(function(n, r) {
        try {
            return ln(n, JSON.parse(r));
        } catch (n) {
            return wt(A2(Ct, "This is not valid JSON! " + n.message, r));
        }
    }), fn = F2(function(n, r) {
        return ln(n, r);
    });
    function ln(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? St(n.c) : pn("null", r);
            case 3:
                return dn(r) ? mn(n.b, r, T) : pn("a LIST", r);
            case 4:
                return dn(r) ? mn(n.b, r, bn) : pn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return pn("an OBJECT with a field named `" + t + "`", r);
                var e = ln(n.b, r[t]);
                return we(e) ? e : wt(A2(Nt, t, e.a));
            case 7:
                var u = n.e;
                return dn(r) ? r.length > u ? (e = ln(n.b, r[u]), we(e) ? e : wt(A2(At, u, e.a))) : pn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : pn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || dn(r)) return pn("an OBJECT", r);
                var a = g;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = ln(n.b, r[i]), !we(e)) return wt(A2(Nt, i, e.a));
                    a = h(m(i, e.a), a);
                }
                return St(Kt(a));
            case 9:
                for(var o = n.f, c = n.g, s = 0; c.length > s; s++){
                    if (e = ln(c[s], r), !we(e)) return e;
                    o = o(e.a);
                }
                return St(o);
            case 10:
                return e = ln(n.b, r), we(e) ? ln(n.h(e.a), r) : e;
            case 11:
                for(var f = g, l = n.g; l.b; l = l.b){
                    if (e = ln(l.a, r), we(e)) return e;
                    f = h(e.a, f);
                }
                return wt(Lt(Kt(f)));
            case 1:
                return wt(A2(Ct, n.a, r));
            case 0:
                return St(n.a);
        }
    }
    function mn(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = ln(n, r[a]);
            if (!we(i)) return wt(A2(At, a, i.a));
            u[a] = i.a;
        }
        return St(t(u));
    }
    function dn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function bn(n) {
        return A2(Te, n.length, function(r) {
            return n[r];
        });
    }
    function pn(n, r) {
        return wt(A2(Ct, "Expecting " + n, r));
    }
    function vn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return vn(n.b, r.b);
            case 6:
                return n.d === r.d && vn(n.b, r.b);
            case 7:
                return n.e === r.e && vn(n.b, r.b);
            case 9:
                return n.f === r.f && $n(n.g, r.g);
            case 10:
                return n.h === r.h && vn(n.b, r.b);
            case 11:
                return $n(n.g, r.g);
        }
    }
    function $n(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!vn(n[e], r[e])) return !1;
        return !0;
    }
    var gn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function hn(n) {
        return n;
    }
    function kn(n) {
        return n;
    }
    var Tn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function wn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Cn(n) {
        return {
            $: 1,
            a: n
        };
    }
    function Nn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var An = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Sn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), Ln = 0;
    function yn(n) {
        var r = {
            $: 0,
            e: Ln++,
            f: n,
            g: null,
            h: []
        };
        return Mn(r), r;
    }
    function Fn(n) {
        return Nn(function(r) {
            r(wn(yn(n)));
        });
    }
    function jn(n, r) {
        n.h.push(r), Mn(n);
    }
    var Pn = F2(function(n, r) {
        return Nn(function(t) {
            jn(n, r), t(wn(0));
        });
    }), In = !1, Bn = [];
    function Mn(n) {
        if (Bn.push(n), !In) {
            for(In = !0; n = Bn.shift();)On(n);
            In = !1;
        }
    }
    function On(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Mn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function qn(n) {
        return Nn(function(r) {
            var t = setTimeout(function() {
                r(wn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var Dn = {};
    function xn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function Rn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(An, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = yn(A2(An, o, n.b));
    }
    var Vn = F2(function(n, r) {
        return Nn(function(t) {
            n.g(r), t(wn(0));
        });
    }), En = F2(function(n, r) {
        return A2(Pn, n.h, {
            $: 0,
            a: r
        });
    });
    function zn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function Un(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Hn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    });
    function Wn(n, r, t) {
        var e = {};
        for(var u in Qn(!0, r, e, null), Qn(!1, t, e, null), n)jn(n[u], {
            $: "fx",
            a: e[u] || {
                i: g,
                j: g
            }
        });
    }
    function Qn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.q)n = r.p(n);
                        return n;
                    }
                    return A2(n ? Dn[r].e : Dn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: g,
                        j: g
                    }, n ? t.i = h(r, t.i) : t.j = h(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Qn(n, i.a, t, e);
                return;
            case 3:
                return void Qn(n, r.o, t, {
                    p: r.n,
                    q: e
                });
        }
    }
    function Zn(n) {
        Dn[n] && a(3);
    }
    function Kn(n, r) {
        return Zn(n), Dn[n] = {
            e: Yn,
            r: r,
            a: Xn
        }, zn(n);
    }
    var Yn = F2(function(n, r) {
        return r;
    });
    function Xn(n) {
        var r = [], t = Dn[n].r, e = qn(0);
        return Dn[n].b = e, Dn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = kn(t(u.a)), o = 0; a.length > o; o++)a[o](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Jn(n, r) {
        return Zn(n), Dn[n] = {
            f: Gn,
            r: r,
            a: _n
        }, zn(n);
    }
    var Gn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function _n(n, r) {
        var t = g, e = Dn[n].r, u = wn(null);
        return Dn[n].b = u, Dn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(fn, e, n);
                we(u) || a(4);
                for(var i = u.a, o = t; o.b; o = o.b)r(o.a(i));
            }
        };
    }
    var nr = "undefined" != typeof document ? document : {};
    function rr(n, r) {
        n.appendChild(r);
    }
    function tr(n) {
        return {
            $: 0,
            a: n
        };
    }
    var er = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: wr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), ur = er(void 0), ar = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: wr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), ir = ar(void 0), or = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    });
    function cr(n, r) {
        return {
            $: 5,
            l: n,
            m: r,
            k: void 0
        };
    }
    var sr = F3(function(n, r, t) {
        return cr([
            n,
            r,
            t
        ], function() {
            return A2(n, r, t);
        });
    }), fr = F4(function(n, r, t, e) {
        return cr([
            n,
            r,
            t,
            e
        ], function() {
            return A3(n, r, t, e);
        });
    }), lr = F5(function(n, r, t, e, u) {
        return cr([
            n,
            r,
            t,
            e,
            u
        ], function() {
            return A4(n, r, t, e, u);
        });
    }), mr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), dr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), br = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), pr = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function vr(n) {
        return "script" == n ? "p" : n;
    }
    function $r(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    var gr, hr = F2(function(n, r) {
        return "a0" === r.$ ? A2(mr, r.n, function(n, r) {
            var t = Pe(r);
            return {
                $: r.$,
                a: t ? A3(Fe, 3 > t ? kr : Tr, je(n), r.a) : A2(ye, n, r.a)
            };
        }(n, r.o)) : r;
    }), kr = F2(function(n, r) {
        return m(n(r.a), r.b);
    }), Tr = F2(function(n, r) {
        return {
            nO: n(r.nO),
            rf: r.rf,
            pe: r.pe
        };
    });
    function wr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Cr(i, u, a) : i[u] = a;
            } else "className" === u ? Cr(r, u, kn(a)) : r[u] = kn(a);
        }
        return r;
    }
    function Cr(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Nr(n, r) {
        var t = n.$;
        if (5 === t) return Nr(n.k || (n.k = n.m()), r);
        if (0 === t) return nr.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Nr(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Ar(i = n.h(n.g), r, n.d), i;
        var i = n.f ? nr.createElementNS(n.f, n.c) : nr.createElement(n.c);
        Ar(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)rr(i, Nr(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function Ar(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Sr(n, u) : "a0" === e ? Fr(n, r, u) : "a3" === e ? Lr(n, u) : "a4" === e ? yr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Sr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Lr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function yr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Fr(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = jr(r, a), n.addEventListener(u, i, gr && {
                    passive: 2 > Pe(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                gr = !0;
            }
        }));
    } catch (n) {}
    function jr(n, r) {
        function t(r) {
            var e = t.q, u = ln(e.a, r);
            if (we(u)) {
                for(var a, i = Pe(e), o = u.a, c = i ? 3 > i ? o.a : o.nO : o, s = 1 == i ? o.b : 3 == i && o.rf, f = (s && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.pe) && r.preventDefault(), n); a = f.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var l = a.length; l--;)c = a[l](c);
                    f = f.p;
                }
                f(c, s);
            }
        }
        return t.q = r, t;
    }
    function Pr(n, r) {
        return n.$ == r.$ && vn(n.a, r.a);
    }
    function Ir(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Br(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Ir(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, s = c === o.length; s && c--;)s = i[c] === o[c];
                    if (s) return void (r.k = n.k);
                    r.k = r.m();
                    var f = [];
                    return Br(n.k, r.k, f, 0), void (f.length > 0 && Ir(t, 1, e, f));
                case 4:
                    for(var l = n.j, m = r.j, d = !1, b = n.k; 4 === b.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        b.j
                    ] : l.push(b.j), b = b.k;
                    for(var p = r.k; 4 === p.$;)d = !0, "object" != typeof m ? m = [
                        m,
                        p.j
                    ] : m.push(p.j), p = p.k;
                    return d && l.length !== m.length ? void Ir(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, m) : l === m) || Ir(t, 2, e, m), void Br(b, p, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Ir(t, 3, e, r.a));
                case 1:
                    return void Mr(n, r, t, e, qr);
                case 2:
                    return void Mr(n, r, t, e, Dr);
                case 3:
                    if (n.h !== r.h) return void Ir(t, 0, e, r);
                    var v = Or(n.d, r.d);
                    v && Ir(t, 4, e, v);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Ir(t, 5, e, $));
            }
        }
    }
    function Mr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Or(n.d, r.d);
            a && Ir(t, 4, e, a), u(n, r, t, e);
        } else Ir(t, 0, e, r);
    }
    function Or(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Pr(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Or(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function qr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Ir(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Ir(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, s = 0; c > s; s++){
            var f = u[s];
            Br(f, a[s], t, ++e), e += f.b || 0;
        }
    }
    function Dr(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, s = o.length, f = c.length, l = 0, m = 0, d = e; s > l && f > m;){
            var b = (S = o[l]).a, p = (L = c[m]).a, v = S.b, $ = L.b, g = void 0, h = void 0;
            if (b !== p) {
                var k = o[l + 1], T = c[m + 1];
                if (k) {
                    var w = k.a, C = k.b;
                    h = p === w;
                }
                if (T) {
                    var N = T.a, A = T.b;
                    g = b === N;
                }
                if (g && h) Br(v, A, u, ++d), Rr(a, u, b, $, m, i), d += v.b || 0, Vr(a, u, b, C, ++d), d += C.b || 0, l += 2, m += 2;
                else if (g) d++, Rr(a, u, p, $, m, i), Br(v, A, u, d), d += v.b || 0, l += 1, m += 2;
                else if (h) Vr(a, u, b, v, ++d), d += v.b || 0, Br(C, $, u, ++d), d += C.b || 0, l += 2, m += 1;
                else {
                    if (!k || w !== N) break;
                    Vr(a, u, b, v, ++d), Rr(a, u, p, $, m, i), d += v.b || 0, Br(C, A, u, ++d), d += C.b || 0, l += 2, m += 2;
                }
            } else Br(v, $, u, ++d), d += v.b || 0, l++, m++;
        }
        for(; s > l;){
            var S;
            d++, Vr(a, u, (S = o[l]).a, v = S.b, d), d += v.b || 0, l++;
        }
        for(; f > m;){
            var L, y = y || [];
            Rr(a, u, (L = c[m]).a, L.b, void 0, y), m++;
        }
        (u.length > 0 || i.length > 0 || y) && Ir(t, 8, e, {
            w: u,
            x: i,
            y: y
        });
    }
    var xr = "_elmW6BL";
    function Rr(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Br(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Rr(n, r, t + xr, e, u, a);
    }
    function Vr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Br(e, a.z, i, u), void Ir(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Vr(n, r, t + xr, e, u);
        } else {
            var o = Ir(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function Er(n, r, t, e) {
        zr(n, r, t, 0, 0, r.b, e);
    }
    function zr(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var s = o.$;
            if (1 === s) Er(n, r.k, o.s, i);
            else if (8 === s) o.t = n, o.u = i, (f = o.s.w).length > 0 && zr(n, r, f, 0, u, a, i);
            else if (9 === s) {
                o.t = n, o.u = i;
                var f, l = o.s;
                l && (l.A.s = n, (f = l.w).length > 0 && zr(n, r, f, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var m = r.$;
        if (4 === m) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return zr(n, d, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var b = r.e, p = n.childNodes, v = 0; b.length > v; v++){
            u++;
            var $ = 1 === m ? b[v] : b[v].b, g = u + ($.b || 0);
            if (!(u > c || c > g || (o = t[e = zr(p[v], $, t, e, u, g, i)]) && (c = o.r) <= a)) return e;
            u = g;
        }
        return e;
    }
    function Ur(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Hr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Hr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Nr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Ar(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Ur(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(Nr(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = Ur(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = nr.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                rr(t, 2 === u.c ? u.s : Nr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Ur(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : Nr(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && rr(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Wr(n) {
        if (3 === n.nodeType) return tr(n.textContent);
        if (1 !== n.nodeType) return tr("");
        for(var r = g, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = h(A2(pr, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = g, o = n.childNodes;
        for(e = o.length; e--;)i = h(Wr(o[e]), i);
        return A3(ur, a, r, i);
    }
    var Qr = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var o = A2(fn, n, r ? r.flags : void 0);
            we(o) || a(2);
            var c = {}, s = (o = t(o.a)).a, f = i(m, s), l = function(n, r) {
                var t;
                for(var e in Dn){
                    var u = Dn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Rn(u, r);
                }
                return t;
            }(c, m);
            function m(n, r) {
                f(s = (o = A2(e, n, s)).a, r), Wn(c, o.b, u(s));
            }
            return Wn(c, o.b, u(s)), l ? {
                ports: l
            } : {};
        }(r, e, n.m, n.q, n.rl, function(r, t) {
            var u = n.r, a = e.node, i = Wr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Zr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Zr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Br(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Er(n, r, t, e), Ur(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), Zr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Kr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Yr = "undefined" != typeof document ? document : Kr, Xr = "undefined" != typeof window ? window : Kr, Jr = F3(function(n, r, t) {
        return Fn(Nn(function() {
            function e(n) {
                yn(t(n));
            }
            return n.addEventListener(r, e, gr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Gr = F2(function(n, r) {
        var t = ln(n, r);
        return we(t) ? kt(t.a) : Tt;
    });
    var _r = F2(function(n, r) {
        return function(n, r) {
            return Nn(function(t) {
                Zr(function() {
                    var e = document.getElementById(n);
                    t(e ? wn(r(e)) : Cn(Be(n)));
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    }), nt = F3(function(n, r, t) {
        return Nn(function(e) {
            function u(n) {
                e(r(t.cN.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(ao);
            }), a.addEventListener("timeout", function() {
                u(co);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? uo : to, function(n) {
                        return {
                            sn: n.responseURL,
                            bo: n.status,
                            rd: n.statusText,
                            l3: rt(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.cN.b, a));
            }), so(t.h_) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || yn(A2(fo, n, m(t, oo({
                        qw: e.loaded,
                        qO: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || yn(A2(fo, n, m(t, io({
                        pz: e.loaded,
                        qO: e.lengthComputable ? kt(e.total) : Tt
                    }))));
                });
            }(n, a, t.h_.a);
            try {
                a.open(t.aP, t.sn, !0);
            } catch (n) {
                return u(eo(t.sn));
            }
            return function(n, r) {
                for(var t = r.l3; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.dE.a || 0, n.responseType = r.cN.d, n.withCredentials = r.iF;
            }(a, t), t.eh.a && a.setRequestHeader("Content-Type", t.eh.a), a.send(t.eh.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function rt(n) {
        if (!n) return Au;
        for(var r = Au, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), o = u.substring(a + 2);
                r = A3(ko, i, function(n) {
                    return kt(so(n) ? o + ", " + n.a : o);
                }, r);
            }
        }
        return r;
    }
    var tt = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), et = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    }), ut = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), at = F5(function(n, r, t, e, u) {
        for(var a = n.length, i = u.length >= r + a, o = 0; i && a > o;){
            var c = u.charCodeAt(r);
            i = n[o++] === u[r++] && (10 === c ? (t++, e = 1) : (e++, 55296 == (63488 & c) ? n[o++] === u[r++] : 1));
        }
        return d(i ? r : -1, t, e);
    }), it = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), ot = F2(function(n, r) {
        return Nn(function() {
            var t = setInterval(function() {
                yn(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), ct = F2(function(n, r) {
        var t = "g";
        n.n3 && (t += "m"), n.jD && (t += "i");
        try {
            return kt(RegExp(r, t));
        } catch (n) {
            return Tt;
        }
    }), st = F2(function(n, r) {
        return null !== r.match(n);
    }), ft = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, o = r.lastIndex, c = -1; a++ < n && (e = r.exec(i)) && c != r.lastIndex;){
            for(var s = e.length - 1, f = Array(s); s > 0;){
                var l = e[s];
                f[--s] = l ? kt(l) : Tt;
            }
            u.push(A4(Uh, e[0], e.index, a, T(f))), c = r.lastIndex;
        }
        return r.lastIndex = o, T(u);
    }), lt = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var i = arguments[e];
                a[--e] = i ? kt(i) : Tt;
            }
            return t(A4(Uh, r, arguments[arguments.length - 2], u, T(a)));
        });
    }), mt = 1 / 0, dt = k, bt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(bt, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), pt = function(n) {
        return A3(bt, F3(function(n, r, t) {
            return A2(dt, m(n, r), t);
        }), g, n);
    }, vt = function(n) {
        return A3(bt, F3(function(n, r, t) {
            return A2(dt, n, t);
        }), g, n);
    }, $t = 1, gt = 2, ht = 0, kt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tt = {
        $: 1
    }, wt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ct = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Nt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), At = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), St = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yt = S, Ft = E, jt = v, Pt = gn, It = Q, Bt = F2(function(n, r) {
        return A2(R, n, w(r));
    }), Mt = F2(function(n, r) {
        return T(A2(x, n, r));
    }), Ot = function(n) {
        return A2(Bt, "\n    ", A2(Mt, "\n", n));
    }, qt = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Dt = function(n) {
        return A3(qt, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, xt = C, Rt = L, Vt = F3(function(n, r, t) {
        for(;;){
            if (f(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(dt, r, t);
            n = e, r = u, t = a;
        }
    }), Et = F2(function(n, r) {
        return A3(Vt, n, r, g);
    }), zt = F2(function(n, r) {
        return A3(xt, n, A2(Et, 0, Dt(r) - 1), r);
    }), Ut = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Ht = function(n) {
        var r = Ut(n);
        return r >= 97 && 122 >= r;
    }, Wt = function(n) {
        var r = Ut(n);
        return 90 >= r && r >= 65;
    }, Qt = function(n) {
        var r = Ut(n);
        return 57 >= r && r >= 48;
    }, Zt = function(n) {
        return Ht(n) || Wt(n) || Qt(n);
    }, Kt = function(n) {
        return A3(qt, dt, g, n);
    }, Yt = F2(function(n, r) {
        return "\n\n(" + It(n + 1) + ") " + Ot(Xt(r));
    }), Xt = function(n) {
        return A2(Jt, n, g);
    }, Jt = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0)) ? kt(55296 > r || r > 56319 ? m(n[0], n.slice(1)) : m(n[0] + n[1], n.slice(2))) : Tt;
                    if (1 === e.$) return !1;
                    var u, a = e.a, i = a.b;
                    return (Ht(u = a.a) || Wt(u)) && A2(Ft, Zt, i);
                }();
                n = e, r = A2(dt, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + It(n.a) + "]";
                n = e, r = A2(dt, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = function() {
                            return r.b ? "The Json.Decode.oneOf at json" + A2(Bt, "", Kt(r)) : "Json.Decode.oneOf";
                        }() + " failed in the following " + It(Dt(i)) + " ways:";
                        return A2(Bt, "\n\n", A2(dt, o, A2(zt, Yt, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + function() {
                    return r.b ? " at json" + A2(Bt, "", Kt(r)) : "!";
                }();
            default:
                var c = n.a, s = n.b;
                return (o = function() {
                    return r.b ? "Problem with the value at json" + A2(Bt, "", Kt(r)) + ":\n\n    " : "Problem with the given value:\n\n";
                }()) + (Ot(A2(Pt, 4, s)) + "\n\n") + c;
        }
    }), Gt = 32, _t = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), ne = [], re = j, te = F2(function(n, r) {
        return B(r) / B(n);
    }), ee = re(A2(te, 2, Gt)), ue = A4(_t, 0, ee, ne, ne), ae = t, ie = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oe = F2(function(n, r) {
        return n(r);
    }), ce = F2(function(n, r) {
        return r(n);
    }), se = c, fe = P, le = function(n) {
        return n.length;
    }, me = F2(function(n, r) {
        return f(n, r) > 0 ? n : r;
    }), de = y, be = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pe = e, ve = F2(function(n, r) {
        for(;;){
            var t = A2(pe, Gt, n), e = t.b, u = A2(dt, be(t.a), r);
            if (!e.b) return Kt(u);
            n = e, r = u;
        }
    }), $e = function(n) {
        return n.a;
    }, ge = F2(function(n, r) {
        for(;;){
            var t = re(r / Gt);
            if (1 === t) return A2(pe, Gt, n).a;
            n = A2(ve, n, g), r = t;
        }
    }), he = F2(function(n, r) {
        if (r.n) {
            var t = r.n * Gt, e = fe(A2(te, Gt, t - 1)), u = n ? Kt(r.t) : r.t, a = A2(ge, u, r.n);
            return A4(_t, le(r.s) + t, A2(me, 5, e * ee), a, r.s);
        }
        return A4(_t, le(r.s), ee, ne, r.s);
    }), ke = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(he, !1, {
                t: e,
                n: t / Gt | 0,
                s: u
            });
            var a = ie(A3(ae, Gt, r, n));
            r -= Gt, e = A2(dt, a, e);
        }
    }), Te = F2(function(n, r) {
        if (n > 0) {
            var t = n % Gt;
            return A5(ke, r, n - t - Gt, n, g, A3(ae, t, n - t, r));
        }
        return ue;
    }), we = function(n) {
        return !n.$;
    }, Ce = tn, Ne = Y, Ae = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Se = Ae, Le = Se("div"), ye = en, Fe = un, je = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pe = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Ie = function(n) {
        return n;
    }, Be = Ie, Me = F6(function(n, r, t, e, u, a) {
        return {
            fb: a,
            fp: r,
            gp: e,
            gw: t,
            pk: n,
            pw: u
        };
    }), Oe = z, qe = function(n) {
        return n.length;
    }, De = V, xe = F2(function(n, r) {
        return 1 > n ? r : A3(De, n, qe(r), r);
    }), Re = W, Ve = function(n) {
        return "" === n;
    }, Ee = F2(function(n, r) {
        return 1 > n ? "" : A3(De, 0, n, r);
    }), ze = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Tt;
            r = 10 * r + a - 48;
        }
        return u == e ? Tt : kt(45 == t ? -r : r);
    }, Ue = F5(function(n, r, t, e, u) {
        if (Ve(u) || A2(Oe, "@", u)) return Tt;
        var a = A2(Re, ":", u);
        if (a.b) {
            if (a.b.b) return Tt;
            var i = a.a, o = ze(A2(xe, i + 1, u));
            if (1 === o.$) return Tt;
            var c = o;
            return kt(A6(Me, n, A2(Ee, i, u), c, r, t, e));
        }
        return kt(A6(Me, n, u, Tt, r, t, e));
    }), He = F4(function(n, r, t, e) {
        if (Ve(e)) return Tt;
        var u = A2(Re, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(Ue, n, A2(xe, a, e), r, t, A2(Ee, a, e));
        }
        return A5(Ue, n, "/", r, t, e);
    }), We = F3(function(n, r, t) {
        if (Ve(t)) return Tt;
        var e = A2(Re, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(He, n, kt(A2(xe, u + 1, t)), r, A2(Ee, u, t));
        }
        return A4(He, n, Tt, r, t);
    }), Qe = F2(function(n, r) {
        if (Ve(r)) return Tt;
        var t = A2(Re, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(We, n, kt(A2(xe, e + 1, r)), A2(Ee, e, r));
        }
        return A3(We, n, Tt, r);
    }), Ze = U, Ke = wn, Ye = Ke(0), Xe = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, s = o.b;
                    if (s.b) {
                        var f = s.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, s.a, t > 500 ? A3(qt, n, r, Kt(f)) : A4(Xe, n, r, t + 1, f)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Je = F3(function(n, r, t) {
        return A4(Xe, n, r, 0, t);
    }), Ge = F2(function(n, r) {
        return A3(Je, F2(function(r, t) {
            return A2(dt, n(r), t);
        }), g, r);
    }), _e = An, nu = F2(function(n, r) {
        return A2(_e, function(r) {
            return Ke(n(r));
        }, r);
    }), ru = F3(function(n, r, t) {
        return A2(_e, function(r) {
            return A2(_e, function(t) {
                return Ke(A2(n, r, t));
            }, t);
        }, r);
    }), tu = function(n) {
        return A3(Je, ru(dt), Ke(g), n);
    }, eu = Vn, uu = F2(function(n, r) {
        var t = r;
        return Fn(A2(_e, eu(n), t));
    }), au = F3(function(n, r) {
        return A2(nu, function() {
            return 0;
        }, tu(A2(Ge, uu(n), r)));
    }), iu = F3(function() {
        return Ke(0);
    }), ou = F2(function(n, r) {
        return A2(nu, n, r);
    });
    Dn.Task = xn(Ye, au, iu, ou);
    var cu, su = zn("Task"), fu = F2(function(n, r) {
        return su(A2(nu, n, r));
    }), lu = Qr, mu = _, du = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), bu = F3(function(n, r, t) {
        return n(r(t));
    }), pu = function(n) {
        return !n;
    }, vu = F2(function(n, r) {
        return !A2(du, A2(bu, pu, n), r);
    }), $u = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), gu = {
        $: -2
    }, hu = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5($u, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5($u, 0, e.b, e.c, A5($u, 1, a.b, a.c, a.d, a.e), A5($u, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, s = u.d, f = u.e;
        return -1 !== e.$ || e.a ? A5($u, n, o, c, A5($u, 0, r, t, e, s), f) : A5($u, 0, r, t, A5($u, 1, e.b, e.c, e.d, i = e.e), A5($u, 1, o, c, s, f));
    }), ku = l, Tu = F3(function(n, r, t) {
        if (-2 === t.$) return A5($u, 0, n, r, gu, gu);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(ku, n, u)){
            case 0:
                return A5(hu, e, u, a, A3(Tu, n, r, i), o);
            case 1:
                return A5($u, e, u, r, i, o);
            default:
                return A5(hu, e, u, a, i, A3(Tu, n, r, o));
        }
    }), wu = F3(function(n, r, t) {
        var e = A3(Tu, n, r, t);
        return -1 !== e.$ || e.a ? e : A5($u, 1, e.b, e.c, e.d, e.e);
    }), Cu = function(n) {
        return !n.b;
    }, Nu = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return Cu(n.a.c) ? m(t, e) : m(t, A2(dt, n, e));
            case 1:
                return m(t, A2(vu, function(n) {
                    return Cu(n.c);
                }, n.b) ? e : A2(dt, n, e));
            case 2:
            case 4:
                return Cu(n.b) ? m(t, e) : m(t, A2(dt, n, e));
            case 3:
                return m(t, A2(dt, n, e));
            case 5:
            case 7:
            case 8:
                return Cu(n.a) ? m(t, e) : m(t, A2(dt, n, e));
            case 6:
                var u = n.a;
                return Ve(u.kz) ? m(t, e) : m(A3(wu, u.n5, u.kz, t), e);
            default:
                return m(t, A2(vu, function(n) {
                    return Cu(n.b);
                }, n.a) ? e : A2(dt, n, e));
        }
    }), Au = gu, Su = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Lu = F2(function(n, r) {
        return r.b ? A3(Je, dt, r, n) : n;
    }), yu = F2(function(n, r) {
        return A2(Lu, A2(Ge, function(n) {
            return Su({
                kz: n.b,
                n5: n.a
            });
        }, pt(n)), r);
    }), Fu = F2(function(n, r) {
        return r.$ ? Tt : kt(n(r.a));
    }), ju = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Pu = function(n) {
        return A2(ju, "", A2(Fu, function(n) {
            return '@charset "' + n + '"';
        }, n));
    }, Iu = F2(function(n, r) {
        return A3(Je, F2(function(r, t) {
            return n(r) ? A2(dt, r, t) : t;
        }), g, r);
    }), Bu = function(n) {
        return "(" + n.e5 + A2(ju, "", A2(Fu, jt(": "), n.ss)) + ")";
    }, Mu = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(Bt, " and ", A2(dt, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(Ge, Bu, t)));
        });
        switch(n.$){
            case 0:
                return A2(Bt, " and ", A2(Ge, Bu, n.a));
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, Ou = F2(function(n, r) {
        return '@import "' + n + Mu(r) + '"';
    }), qu = function(n) {
        var r = n.b;
        return A2(Bt, "\n", A2(Ge, Ou(n.a), r));
    }, Du = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, xu = "    ", Ru = function(n) {
        return $(xu, n);
    }, Vu = function(n) {
        return n + ";";
    }, Eu = function(n) {
        return A2(Bt, "\n", A2(Ge, A2(bu, Ru, Vu), n));
    }, zu = q, Uu = function(n) {
        return "::" + n;
    }, Hu = function(n) {
        switch(n){
            case 0:
                return "+";
            case 1:
                return "~";
            case 2:
                return ">";
            default:
                return "";
        }
    }, Wu = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, Qu = function(n) {
        switch(n.$){
            case 0:
            default:
                return A2(Bt, "", A2(dt, n.a, A2(Ge, Wu, r = n.b)));
            case 1:
                var r;
                return Cu(r = n.a) ? "*" : A2(Bt, "", A2(Ge, Wu, r));
        }
    }, Zu = function(n) {
        var r = n.b;
        return A2(Bt, " ", T([
            Hu(n.a),
            Qu(r)
        ]));
    }, Ku = function(n) {
        var r = n.b, t = n.c, e = A2(dt, Qu(n.a), A2(Ge, Zu, r)), u = A2(Bt, "", T([
            A2(ju, "", A2(Fu, Uu, t))
        ]));
        return A2(zu, A2(Bt, " ", A2(Iu, A2(bu, pu, Ve), e)), u);
    }, Yu = F2(function(n, r) {
        var t = r.c;
        return A2(Bt, "", T([
            A2(Bt, ", ", A2(Ge, Ku, A2(dt, r.a, r.b))),
            " {\n",
            n,
            Eu(t),
            "\n",
            n,
            "}"
        ]));
    }), Xu = function(n) {
        switch(n.$){
            case 0:
                return A2(Yu, "", n.a);
            case 1:
                var r = n.b;
                return "@media " + A2(Bt, ",\n", A2(Ge, Mu, n.a)) + " {\n" + A2(Bt, "\n\n", A2(Ge, A2(bu, Ru, Yu(xu)), r)) + "\n}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.n5 + " {\n" + n.a.kz + "\n}";
        }
    }, Ju = function(n) {
        return A3(Je, Lu, g, n);
    }, Gu = F2(function(n, r) {
        return Ju(A2(Ge, n, r));
    }), _u = function(n) {
        return {
            $: 8,
            a: n
        };
    }, na = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ra = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ta = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ea = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ua = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aa = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ia = function(n) {
        return {
            $: 7,
            a: n
        };
    }, oa = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ca = F2(function(n, r) {
        return r.b ? r.b.b ? A2(dt, r.a, A2(ca, n, r.b)) : T([
            n(r.a)
        ]) : r;
    }), sa = F2(function(n, r) {
        return A3(ea, r.a, r.b, $(r.c, T([
            n
        ])));
    }), fa = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(dt, r.a, A2(fa, n, r.b));
        switch(r.a.$){
            case 0:
                return T([
                    ua(A2(sa, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return T([
                    A2(oa, t.a, A2(ca, sa(n), e))
                ]);
            default:
                return r;
        }
    }), la = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, u = (i = r.c, A2(Ge, n, e)), a = n(t);
            return T([
                A3(ea, t, e, i),
                A3(ea, a, u, g)
            ]);
        }
        var i, o = r.a;
        return T([
            A3(ea, o, g, i = r.c),
            A3(ea, n(o), g, g)
        ]);
    }), ma = F2(function(n, r) {
        return A3(ta, r.a, r.b, kt(n));
    }), da = F2(function(n, r) {
        return A2(la, ma(n), r);
    }), ba = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), pa = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), va = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $a = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(pa, r.a, $(r.b, T([
                    n
                ])));
            case 1:
                return va($(r.a, T([
                    n
                ])));
            default:
                return A2(ba, r.a, $(r.b, T([
                    n
                ])));
        }
    }), ga = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(dt, r.a, A2(ga, n, r.b));
            var t = r.a;
            return T([
                m(t.a, A2($a, n, t.b))
            ]);
        }
        return g;
    }), ha = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(ta, r.a, A2(ga, n, r.b), t);
        var t = r.c;
        return A3(ta, A2($a, n, r.a), g, t);
    }), ka = F2(function(n, r) {
        return A2(la, ha(n), r);
    }), Ta = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return $(A2(dt, r.a, r.b), Ta(t));
            }
            return g;
        }
    }, wa = F5(function(n, r, t, e, u) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Ca = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(Ge, ua, n(f = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, u = e.a, a = A2(Ca, n, T([
                                A2(oa, t.a, e.b)
                            ]));
                            if (a.b && 1 === a.a.$ && !a.b.b) {
                                var i = a.a;
                                return T([
                                    A2(oa, i.a, A2(dt, u, i.b))
                                ]);
                            }
                            return a;
                        }
                        var o = r.a;
                        return T([
                            A2(oa, o.a, n(f = o.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var c = r.a;
                    return T([
                        A2(aa, c.a, A2(Ca, n, c.b))
                    ]);
                case 3:
                    var s = r.a, f = s.e;
                    return A2(Ge, A4(wa, s.a, s.b, s.c, s.d), n(f));
                default:
                    return r;
            }
        }
        return A2(dt, u = r.a, A2(Ca, n, r.b));
    }), Na = O, Aa = F4(function(n, r, t, e) {
        return {
            aD: e,
            l2: t,
            au: r,
            qy: n
        };
    }), Sa = 3432918353, La = 461845907, ya = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), Fa = s, ja = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), Pa = D, Ia = F2(function(n, r) {
        return A2(ya, 5, A2(ja, 13, n ^ A2(ya, La, A2(ja, 15, A2(ya, Sa, r))))) + 3864292196;
    }), Ba = F2(function(n, r) {
        var t = r.l2 | (255 & Ut(n)) << r.qy;
        return 24 === r.qy ? {
            aD: r.aD + 1,
            l2: 0,
            au: A2(Ia, r.au, t),
            qy: 0
        } : {
            aD: r.aD + 1,
            l2: t,
            au: r.au,
            qy: r.qy + 8
        };
    }), Ma = F2(function(n, r) {
        var t, e, u, a;
        return ((a = A2(ya, 3266489909, (u = A2(ya, 2246822507, (e = ((t = A3(Pa, Ba, A4(Aa, 0, n, 0, 0), r)).l2 ? t.au ^ A2(ya, La, A2(ja, 15, A2(ya, Sa, t.l2))) : t.au) ^ t.aD) ^ e >>> 16)) ^ u >>> 13)) ^ a >>> 16) >>> 0;
    }), Oa = function(n) {
        return w(n).join("");
    }, qa = F, Da = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, xa = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(dt, Da(r), n);
            n = A2(dt, Da(A2(qa, 16, r)), n), r = r / 16 | 0;
        }
    }), Ra = function(n) {
        return Oa(0 > n ? A2(dt, "-", A2(xa, g, -n)) : A2(xa, g, n));
    }, Va = function(n) {
        return n.b ? kt(n.a) : Tt;
    }, Ea = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return kt(T([
                    n.a
                ]));
            }
            return Tt;
        }
    }, za = function(n) {
        var r, t = function(n) {
            return n.b ? A2(dt, n.a, t(n.b)) : g;
        };
        return T([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, Ua = function(n) {
        return T([
            n
        ]);
    }, Ha = F2(function(n, r) {
        return r.$ ? r : A2(oa, n, T([
            r.a
        ]));
    }), Wa = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(dt, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Qa = F2(function(n, r) {
        return Kt(A3(Wa, n, r, g));
    }), Za = F3(function(n, r, t) {
        if (r > 0) {
            var e = m(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return T([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return T([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, c = o.b, s = c.b, f = s.b, l = f.b;
                                return A2(dt, o.a, A2(dt, c.a, A2(dt, s.a, A2(dt, f.a, n > 1e3 ? A2(Qa, r - 4, l) : A3(Za, n + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return T([
                e.b.a
            ]);
        }
        return g;
    }), Ka = F2(function(n, r) {
        return A3(Za, 0, n, r);
    }), Ya = F5(function(n, r, t, e, u) {
        return u.$ ? u : A5(wa, n, r, t, e, u.a);
    }), Xa = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(oa, n, T([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(oa, $(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(aa, r.a, A2(Ge, Xa(n), e));
            case 3:
                return A5(wa, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), Ja = function(n) {
        return n;
    }, Ga = F4(function(n, r, t, e) {
        var u = function(n) {
            var r;
            return A2(ju, g, (r = n).b ? kt(r.b) : Tt);
        }, a = A2(_a, r, A2(ju, g, Ea(e))), o = function() {
            var n = m(Va(a), function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return kt(n.a);
                    }
                    return Tt;
                }
            }(e));
            if (n.a.$ || n.b.$) return e;
            var r = n.a.a, t = n.b.a;
            return $(A2(Ka, Dt(e) - 1, e), T([
                i(t, r) ? t : r
            ]));
        }();
        return $(o, $(u(A2(ju, g, A2(Fu, function(r) {
            return Ju(A2(ca, _a(n), A2(Ge, Ua, A2(Ca, t, r))));
        }, Ea(e)))), u(a)));
    }), _a = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(_a, i = n.b, A2(fa, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(Ga, p = t.b, i = n.b, ka(t.a), r);
            case 2:
                var e = n.a, u = e.a, a = e.b, i = n.b, o = F2(function(n, r) {
                    var t = n.c, e = r.b, a = r.c;
                    return A3(ta, n.a, $(n.b, A2(dt, m(u, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return Tt;
                        }
                    }(T([
                        a,
                        t
                    ])));
                }), c = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, u = t.b, a = t.c, i = A2(Gu, function(n) {
                                return A2(Ge, o(n), A2(dt, e, u));
                            }, Ta(r)), c = i.b ? T([
                                ua(A3(ea, i.a, i.b, g))
                            ]) : g;
                            return A2(_a, a, c);
                        case 1:
                            return A2(ti, n.a, n.b);
                        case 2:
                            return A2(ei, n.a, n.b);
                        case 3:
                            var s = n.e;
                            return A2(Ge, A4(Ya, n.a, n.b, n.c, n.d), ni(s));
                        case 4:
                            return T([
                                A2(ra, n.a, n.b)
                            ]);
                        case 5:
                            return T([
                                na(n.a)
                            ]);
                        case 6:
                            return T([
                                ia(n.a)
                            ]);
                        case 7:
                            return T([
                                _u(n.a)
                            ]);
                        default:
                            return za(n.a);
                    }
                };
                return Ju($(T([
                    A2(_a, i, r)
                ]), A2(Ge, c, A2(Gu, Ja, a))));
            case 3:
                var s = n.a;
                return A4(Ga, p = s.b, i = n.b, da(s.a), r);
            case 5:
                var f = n.a.a, l = (i = n.b, function(n) {
                    return A2(Na, "_", Ra(A2(Ma, 15739, n)));
                }(f));
                return A2(Lu, A2(_a, i, A2(fa, "animation-name:" + l, r)), T([
                    Su({
                        kz: f,
                        n5: l
                    })
                ]));
            case 4:
                var d = n.a, b = d.a, p = d.b, v = (i = n.b, function() {
                    var n = Ta(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(Ge, Ha(b), A2(_a, p, Ua(ua(A3(ea, t, e, g)))));
                    }
                    return g;
                }());
                return $(A2(_a, i, r), v);
            default:
                return A2(_a, $(n.a.a, i = n.b), r);
        }
    }), ni = function(n) {
        return A2(_a, n.c, T([
            ua(A3(ea, n.a, n.b, g))
        ]));
    }, ri = function(n) {
        if (n.b) {
            var r = n.b;
            return $(ui(n.a), ri(r));
        }
        return g;
    }, ti = F2(function(n, r) {
        return A2(Gu, function(r) {
            return A2(Ge, Xa(n), ni(r));
        }, r);
    }), ei = F2(function(n, r) {
        var t = ri(A2(Gu, Ja, r));
        return T([
            A2(aa, n, t)
        ]);
    }), ui = function(n) {
        switch(n.$){
            case 0:
                return ni(r = n.a);
            case 1:
                return A2(ti, n.a, n.b);
            case 2:
                return A2(ei, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(Ge, A4(Ya, n.a, n.b, n.c, n.d), ni(r));
            case 4:
                return T([
                    A2(ra, n.a, n.b)
                ]);
            case 5:
                return T([
                    na(n.a)
                ]);
            case 6:
                return T([
                    ia(n.a)
                ]);
            case 7:
                return T([
                    _u(n.a)
                ]);
            default:
                return za(n.a);
        }
    }, ai = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.eq, t = n.fs, e = n.gb, u = n.kA;
            return A2(Bt, "\n\n", A2(Iu, A2(bu, pu, Ve), T([
                Pu(r),
                A2(Bt, "\n", A2(Ge, qu, t)),
                A2(Bt, "\n", A2(Ge, Du, e)),
                A2(Bt, "\n\n", A2(Ge, Xu, u))
            ])));
        }(function(n) {
            var r = n.eq, t = n.fs, e = n.gb, u = n.kA, a = A3(Je, Nu, m(Au, g), u);
            return {
                eq: r,
                kA: A2(yu, a.a, a.b),
                fs: t,
                gb: e
            };
        }((t = (r = n).fs, e = r.gb, {
            eq: r.eq,
            kA: ri(A2(Gu, Ja, r.hb)),
            fs: t,
            gb: e
        })));
    }, ii = function(n) {
        return A2(Bt, "\n\n", A2(Ge, ai, n));
    }, oi = function(n) {
        return ur(vr(n));
    }, ci = function(n) {
        return {
            eq: Tt,
            fs: g,
            gb: g,
            hb: n
        };
    }, si = tr, fi = function(n) {
        return {
            $: 4,
            a: n
        };
    }, li = fi, mi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, di = fn, bi = function(n) {
        return n.e;
    }, pi = null, vi = {
        lA: Au,
        c$: 1,
        nO: "",
        ar: pi,
        N: !1,
        P: 400,
        ag: !1
    }, $i = function(n) {
        return A3(qt, F2(function(n, r) {
            return A3(Tn, n.a, n.b, r);
        }), {}, n);
    }, gi = hn, hi = F2(function(n, r) {
        return r.$ ? wt(n(r.a)) : St(r.a);
    }), ki = F2(function(n, r) {
        return p(r, {
            nO: n
        });
    }), Ti = hi(function(n) {
        var r;
        return r = Xt(n), $i(T([
            m("_elm_ffi_log_str_", gi(r))
        ])), A2(ki, Xt(n), vi);
    }), wi = F2(function(n, r) {
        return Ti(A2(di, bi(n), r));
    }), Ci = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ni = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ai = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Si = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Li = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yi = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Fi = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ji = "Have you setup elm-ffi? https://github.com/Warry/elm-ffi#readme", Pi = J, Ii = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Bi = G, Mi = A2(Ii, "en", A2(di, Bi, A2(Ii, gi(ji), A2(di, A2(mu, "_elm_ffi_read_", Pi), $i(T([
        m("_elm_ffi_read_", gi('\n    const hashLocationLang = window.location.hash.startsWith("#lang=") ? window.location.hash.slice(6,8) : undefined;\n    const navigatorLang = window.navigator.language;\n    return hashLocationLang ?? navigatorLang;\n    '))
    ])))))), Oi = A2(Ze, "fr", Mi) ? function(n) {
        return n.bT;
    } : function(n) {
        return n.bN;
    }, qi = Oi({
        bN: "End date",
        bT: "Date de fin"
    }), Di = F2(function(n, r) {
        return {
            e: r,
            g: n
        };
    }), xi = A2(Di, gi, Bi), Ri = function(n) {
        return n({
            ja: Tt,
            d7: !1,
            kv: xi,
            kQ: !1,
            kV: "",
            ln: g,
            lQ: !1,
            fh: !1,
            l5: "",
            mQ: !0,
            m6: "",
            n6: !0,
            gt: "",
            ss: ""
        });
    }, Vi = F2(function(n, r) {
        return {
            jL: r,
            eY: !0,
            m6: n,
            st: Au
        };
    }), Ei = Oi({
        bN: "Select organizations: ",
        bT: "S\xe9lectionnez les organisations: "
    }), zi = N, Ui = Oi({
        bN: "Start date",
        bT: "Date de d\xe9but"
    }), Hi = function(n) {
        return n.toLowerCase();
    }, Wi = function(n) {
        var r = A2(Ge, function(n) {
            return m(n.oN, n.gj);
        }, A2(zi, A2(bu, Hi, function(n) {
            return n.gj;
        }), n.oP));
        return {
            lh: Ri(function(n) {
                return p(n, {
                    m6: qi,
                    gt: "DD/MM/YY"
                });
            }),
            lm: Tt,
            oP: A2(Vi, Ei, r),
            q1: Ri(function(n) {
                return p(n, {
                    m6: Ui,
                    gt: "DD/MM/YY"
                });
            })
        };
    }, Qi = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Zi = Sn, Ki = F2(function(n, r) {
        return su(A2(Zi, A2(bu, A2(bu, Ke, n), wt), A2(_e, A2(bu, A2(bu, Ke, n), St), r)));
    }), Yi = Ki, Xi = Oi({
        bN: "Confirmation",
        bT: "Confirmation"
    }), Ji = Oi({
        bN: "Disable organization emails",
        bT: "D\xe9sactiver les mails de l'organisation"
    }), Gi = Oi({
        bN: "Email",
        bT: "Email"
    }), _i = hn, no = A2(Di, _i, Ne), ro = function(n) {
        return n({
            kv: no,
            kQ: !1,
            ln: g,
            lQ: !1,
            fh: !1,
            l5: "",
            mm: "",
            mQ: !0,
            m6: "",
            gt: "",
            ss: !1
        });
    }, to = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), eo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uo = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), ao = {
        $: 2
    }, io = function(n) {
        return {
            $: 1,
            a: n
        };
    }, oo = function(n) {
        return {
            $: 0,
            a: n
        };
    }, co = {
        $: 1
    }, so = function(n) {
        return !n.$;
    }, fo = En, lo = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Tt;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(ku, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return kt(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), mo = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, f = t.e, A5($u, 1, n.b, n.c, A5($u, 0, r.b, r.c, r.d, r.e), A5($u, 0, i, o, e, f));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, c = (e = a.d).d, s = e.e, f = a.e;
            return A5($u, 0, e.b, e.c, A5($u, 1, n.b, n.c, A5($u, 0, u.b, u.c, u.d, u.e), c), A5($u, 1, i, o, s, f));
        }
        return n;
    }, bo = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return s = t.b, f = t.c, l = t.d, m = t.e, A5($u, 1, e = n.b, u = n.c, A5($u, 0, r.b, r.c, r.d, o = r.e), A5($u, 0, s, f, l, m));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, s = c.b, f = c.c, l = c.d, m = c.e;
            return A5($u, 0, a.b, a.c, A5($u, 1, i.b, i.c, i.d, i.e), A5($u, 1, e, u, o, A5($u, 0, s, f, l, m)));
        }
        return n;
    }, po = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return bo(r);
                        break n;
                    }
                    return bo(r);
                }
                break n;
            }
            return r;
        }
        return A5($u, t, a.b, a.c, a.d, A5($u, 0, e, u, a.e, i));
    }), vo = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = mo(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(hu, o.a, o.b, o.c, vo(o.d), c);
                    }
                    return gu;
                }
                return A5($u, r, t, e, vo(u), i);
            }
            return A5($u, r, t, e, vo(u), i);
        }
        return gu;
    }, $o = F2(function(n, r) {
        if (-2 === r.$) return gu;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > f(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var o = a.d;
                if (-1 !== o.$ || o.a) {
                    var c = mo(r);
                    if (-1 === c.$) {
                        var s = c.e;
                        return A5(hu, c.a, c.b, c.c, A2($o, n, c.d), s);
                    }
                    return gu;
                }
                return A5($u, t, e, u, A2($o, n, a), i);
            }
            return A5($u, t, e, u, A2($o, n, a), i);
        }
        return A2(go, n, A7(po, n, r, t, e, u, a, i));
    }), go = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, o = r.e;
            if (i(n, e)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(hu, t, c.b, c.c, a, vo(o)) : gu;
            }
            return A5(hu, t, e, u, a, A2($o, n, o));
        }
        return gu;
    }), ho = F2(function(n, r) {
        var t = A2($o, n, r);
        return -1 !== t.$ || t.a ? t : A5($u, 1, t.b, t.c, t.d, t.e);
    }), ko = F3(function(n, r, t) {
        var e = r(A2(lo, n, t));
        return e.$ ? A2(ho, n, t) : A3(wu, n, e.a, t);
    }), To = {
        $: 0
    }, wo = F2(function(n, r) {
        return {
            eh: To,
            aP: n,
            b8: St,
            O: g,
            sn: r
        };
    }), Co = function(n) {
        return A2(Bt, "", n);
    }, No = F3(function(n, r, t) {
        return r(n(t));
    }), Ao = function(n) {
        return n.$ ? "/v4" + function(n) {
            switch(n.$){
                case 0:
                    return "/organizations" + (1 === (u = n.a).$ ? "" : "/" + (u.a + function(n) {
                        switch(n){
                            case 1:
                                return "";
                            case 0:
                                return "/audioMapping";
                            case 2:
                                return "/segmentationRules";
                            case 3:
                                return "/formats";
                            case 4:
                                return "/extraFormats";
                            case 5:
                                return "/metadata/schema";
                            default:
                                return "/summary";
                        }
                    }(u.b)));
                case 1:
                    return "/shows/" + (i = n.a).a + (i.b ? "/events" : "/metadata");
                case 2:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/files/csv";
                            case 1:
                                return "/metadata/schemas";
                            case 2:
                                return "/metadata/schemas/" + n.a;
                            case 3:
                                return "/app" + function(n) {
                                    return n.$ ? "/" + n.a : "";
                                }(n.a);
                            default:
                                return "/dowload";
                        }
                    }(n.a);
                case 3:
                    return "/broadcastables/" + ((a = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "/analysis";
                            case 1:
                                return "/delivery";
                            case 2:
                                return "/deliver";
                            default:
                                return "/transcode/ad";
                        }
                    }(a.b));
                case 4:
                    return "/segmentationRules" + ((e = n.a).$ ? "/" + e.a : "");
                case 5:
                    return "/users" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/login";
                            case 1:
                                return "/logout";
                            case 2:
                                var r = n.b;
                                return "/sso?email=" + (n.a + A2(No, Fu(jt("&redirect=")), ju(""))(r));
                            case 3:
                                return "/askResetPassword";
                            case 4:
                                return "/resetPassword";
                            default:
                                return "/revoke";
                        }
                    }(n.a);
                case 6:
                    return "/audioMappings" + ((t = n.a).$ ? "/" + t.a : "");
                default:
                    return "/files/" + (r = n.a).a + (r.b ? "/qualifySubtitles" : "/qualifyAudio");
            }
            var r, t, e, u, a, i;
        }(n.a) : "/v3" + function(n) {
            switch(n.$){
                case 0:
                    return "/unitaries" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 1:
                    return "/collections" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 2:
                    return "/seasons" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 3:
                    return "/episodes" + function(n) {
                        return n.$ ? "/" + n.a : "";
                    }(n.a);
                case 4:
                    return "/hierarchy" + function(n) {
                        var r = n.a;
                        switch(n.b){
                            case 0:
                                return "/" + r;
                            case 1:
                                return "/" + r + "/archive";
                            case 2:
                                return "/" + r + "/unarchive";
                            case 3:
                                return "/" + r + "/trash";
                            case 4:
                                return "/" + r + "/untrash";
                            case 5:
                                return "/" + r + "/invitations";
                            case 6:
                                return "/" + r + "/shows";
                            default:
                                return "/" + r + "/events";
                        }
                    }(n.a);
                case 5:
                    return "/shows/" + ((o = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "";
                            case 1:
                                return "/invitations";
                            case 2:
                                return "/metadata";
                            case 3:
                                return "/files";
                            case 4:
                                return "/versions";
                            case 5:
                                return "/versions/admin";
                            case 6:
                                return "/accept";
                            case 7:
                                return "/archive";
                            case 8:
                                return "/unarchive";
                            case 9:
                                return "/trash";
                            default:
                                return "/untrash";
                        }
                    }(o.b));
                case 6:
                    return "/organizations" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 2:
                                return "/" + (n.a + function(n) {
                                    switch(n){
                                        case 0:
                                            return "";
                                        case 1:
                                            return "/filelist";
                                        case 2:
                                            return "/jobs";
                                        case 3:
                                            return "/subtitleFormats";
                                        default:
                                            return "/shows/deliveries";
                                    }
                                }(n.b));
                            default:
                                return "/deliverables";
                        }
                    }(n.a);
                case 7:
                    return "/channels" + ((i = n.a).$ ? "/" + i.a : "");
                case 8:
                    return "/webhooks" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/api";
                            case 2:
                                return "/api/" + n.a;
                            case 3:
                                return "/email";
                            default:
                                return "/email/" + n.a;
                        }
                    }(n.a);
                case 9:
                    return "/testplans" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "S3";
                        }
                    }(n.a);
                case 10:
                    return "/formats" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "/framerates";
                        }
                    }(n.a);
                case 11:
                    return "/subtitleFormats" + function(n) {
                        switch(n.$){
                            case 0:
                                return "";
                            case 1:
                                return "/" + n.a;
                            default:
                                return "/framerates";
                        }
                    }(n.a);
                case 12:
                    return "/users" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/logout";
                            case 1:
                                return "/impersonate";
                            case 2:
                                return "";
                            case 3:
                                return "/" + n.a;
                            case 4:
                                return "/password";
                            case 5:
                                return "/switch";
                            default:
                                return "/invitation";
                        }
                    }(n.a);
                case 13:
                    return "/uploads";
                case 14:
                    return "/invitations" + ((a = n.a).$ ? "/" + a.a + "/sftp" : "/" + a.a);
                case 15:
                    return "/reports?start=" + (u = n.a).a + "&end=" + (u.b + Co(A2(Ge, function(n) {
                        return "&organization=" + n;
                    }, u.c)));
                case 16:
                    return "/comments/" + (e = n.a).a + (e.b ? "/answers" : "");
                case 17:
                    return "/answers/answers/" + n.a;
                case 18:
                    return "/broadcastables/" + ((t = n.a).a + function(n) {
                        switch(n){
                            case 0:
                                return "/copyToShow";
                            case 1:
                                return "/copyToOrganization";
                            case 2:
                                return "/qualify";
                            case 3:
                                return "/comments";
                            default:
                                return "/audioMapping";
                        }
                    }(t.b));
                case 19:
                    return "/files" + (1 === (r = n.a).$ ? "/search?keyName=" + r.a : "/" + (r.a + function(n) {
                        switch(n){
                            case 0:
                                return "";
                            case 1:
                                return "/download";
                            case 2:
                                return "/pause";
                            case 3:
                                return "/markDelivery";
                            case 4:
                                return "/restartVerification";
                            case 5:
                                return "/restartProxyTranscode";
                            case 6:
                                return "/startProxyHiResTranscode";
                            case 7:
                                return "/uploads";
                            case 8:
                                return "/uploads/name";
                            case 9:
                                return "/uploads/progress";
                            case 10:
                                return "/uploads/s3Id";
                            case 11:
                                return "/uploads/error";
                            case 12:
                                return "/uploads/pause";
                            default:
                                return "/segments";
                        }
                    }(r.b)));
                case 20:
                    return "/dashboard";
                case 21:
                    return "/aws/copy";
                case 22:
                    return "/admin/ftp/copy";
                case 23:
                    return "/status";
                case 24:
                    return function(n) {
                        switch(n.$){
                            case 0:
                                return "/organizations/" + n.a + "/jobs";
                            case 1:
                                return "/jobs/" + n.a + "/start";
                            case 2:
                                return "/jobs/" + n.a + "/complete";
                            default:
                                return "/jobs/notcompleted";
                        }
                    }(n.a);
                case 25:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/files/" + n.a + "/probe";
                            case 1:
                                return "/analysis";
                            case 2:
                                return "/analysis/simple";
                            case 3:
                                return "/analysis/" + n.a;
                            case 4:
                                return "/analysis/tasks/organization/" + n.a;
                            default:
                                return "/analysis/tasks/show/" + n.a;
                        }
                    }(n.a);
                case 26:
                    return "/admin" + function(n) {
                        switch(n.$){
                            case 0:
                                return "/shows/path";
                            case 2:
                                return "/files/csv";
                            default:
                                return "/jobs/" + n.a + "/acknowledge";
                        }
                    }(n.a);
                default:
                    return "/segments/" + n.a;
            }
            var r, t, e, u, a, i, o;
        }(n.a);
    }, So = function(n) {
        return A2(wo, "GET", Ao(n));
    }, Lo = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yo = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Fo = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jo = F2(function(n, r) {
        return Lo(Fo(A2(yo, n, r)));
    }), Po = function(n) {
        var r = n;
        return {
            e: r.e,
            g: function(n) {
                return $i(r.g(n));
            }
        };
    }, Io = function(n) {
        return {
            e: je(n),
            g: function() {
                return g;
            }
        };
    }, Bo = function(n) {
        return n.g;
    }, Mo = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Oo = function(n) {
        return Mo(T([
            A2(ye, kt, n),
            je(Tt)
        ]));
    }, qo = function(n) {
        return {
            e: Oo(bi(n)),
            g: function(r) {
                return 1 === r.$ ? pi : A2(Bo, n, r.a);
            }
        };
    }, Do = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: A3(Fe, F2(function(n, r) {
                return n(r);
            }), u.e, Oo(A2(mu, n, bi(t)))),
            g: function(e) {
                return A2(dt, m(n, A2(Bo, qo(t), r(e))), u.g(e));
            }
        };
    }), xo = Po(A4(Do, "sso", function(n) {
        return n.q$;
    }, xi, Io(function(n) {
        return {
            q$: n
        };
    }))), Ro = sn, Vo = F2(function(n, r) {
        return Ti(A2(Ro, bi(n), r));
    }), Eo = "Une erreur est survenue. Merci de contacter notre service op\xe9rations via le chat ou par mail \xe0 ops@nomalab.com", zo = F2(function(n, r) {
        var t = A2(Vo, n, r);
        return t.$ ? wt({
            lA: Au,
            nO: "Impossible de lire les donn\xe9es. " + Eo,
            P: 500
        }) : St(t.a);
    }), Uo = F2(function(n, r) {
        return {
            eh: r.eh,
            aP: r.aP,
            b8: n,
            O: r.O,
            sn: r.sn
        };
    }), Ho = A2(bu, Uo, zo), Wo = Cn, Qo = F2(function(n, r) {
        return A2(Zi, A2(bu, Wo, n), r);
    }), Zo = function(n) {
        return encodeURIComponent(n);
    }, Ko = function(n) {
        return n.b;
    }, Yo = F3(function(n, r, t) {
        return {
            lA: t,
            nO: r,
            P: n
        };
    }), Xo = F3(function(n, r, t) {
        var e = t;
        return {
            e: r(e.e),
            g: n(e.g)
        };
    }), Jo = function(n) {
        return A3(qt, F2(function(n, r) {
            return A3(wu, n.a, n.b, r);
        }), Au, n);
    }, Go = function(n) {
        return A2(ye, Jo, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, _o = F2(function(n, r) {
        if (-2 === r.$) return gu;
        var t = r.b, e = r.d, u = r.e;
        return A5($u, r.a, t, A2(n, t, r.c), A2(_o, n, e), A2(_o, n, u));
    }), nc = A2(Xo, function(n) {
        return A2(bu, A2(bu, $i, pt), _o(function() {
            return n;
        }));
    }, Go), rc = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: A3(Fe, F2(function(n, r) {
                return n(r);
            }), u.e, A2(mu, n, bi(t))),
            g: function(e) {
                return A2(dt, m(n, A2(Bo, t, r(e))), u.g(e));
            }
        };
    }), tc = K, ec = hn, uc = A2(Di, ec, tc), ac = function(n) {
        return {
            $: 3,
            b: n
        };
    }, ic = F2(function(n, r) {
        return A3(qt, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), oc = A2(Xo, ic, ac), cc = Po(A4(rc, "fields", function(n) {
        return n.lA;
    }, nc(oc(xi)), A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(rc, "status", function(n) {
        return n.P;
    }, uc, Io(Yo))))), sc = Po(A4(rc, "message", function(n) {
        return n.nO;
    }, xi, Io(function(n) {
        return {
            nO: n
        };
    }))), fc = Po(A4(rc, "error", function(n) {
        return n.lm;
    }, sc, Io(function(n) {
        return {
            lm: n
        };
    }))), lc = A2(tt, "", Ie), mc = function(n) {
        return n.$ ? Wo(n.a) : Ke(n.a);
    }, dc = function(n) {
        var r, t, e;
        return A2(Qo, function(n) {
            return n;
        }, (r = {
            eh: n.eh,
            l3: g,
            aP: n.aP,
            pH: (e = n.b8, lc(function(n) {
                switch(n.$){
                    case 1:
                        return wt({
                            lA: Au,
                            nO: "Timeout",
                            P: 0
                        });
                    case 2:
                        return wt({
                            lA: Au,
                            nO: "NetworkError",
                            P: 0
                        });
                    case 0:
                        return wt({
                            lA: Au,
                            nO: "BadUrl",
                            P: 0
                        });
                    case 3:
                        var r = n.a, t = n.b, u = A2(Vo, cc, t);
                        if (u.$) {
                            var a = A2(Vo, sc, t);
                            if (a.$) {
                                var i = A2(Vo, fc, t);
                                return wt(i.$ ? {
                                    lA: Au,
                                    nO: Eo,
                                    P: 500
                                } : {
                                    lA: Au,
                                    nO: i.a.lm.nO,
                                    P: r.bo
                                });
                            }
                            return wt({
                                lA: Au,
                                nO: a.a.nO,
                                P: r.bo
                            });
                        }
                        return wt(u.a);
                    default:
                        var o = n.b;
                        if (400 > (r = n.a).bo) return e(o);
                        var c = A2(Vo, cc, o);
                        if (c.$) {
                            var s = A2(Vo, sc, o);
                            if (s.$) {
                                var f = A2(Vo, fc, o);
                                return wt(f.$ ? {
                                    lA: Au,
                                    nO: Eo,
                                    P: 500
                                } : {
                                    lA: Au,
                                    nO: f.a.lm.nO,
                                    P: r.bo
                                });
                            }
                            return wt({
                                lA: Au,
                                nO: s.a.nO,
                                P: r.bo
                            });
                        }
                        return wt(c.a);
                }
            })),
            dE: Tt,
            sn: $(n.sn, (t = n.O, Cu(t) ? "" : A2(zu, "?", A2(Bt, "&", A2(Ge, function(n) {
                return Zo(n.a) + "=" + Zo(n.b);
            }, t)))))
        }, A3(nt, 0, mc, {
            iF: !1,
            eh: r.eh,
            cN: r.pH,
            l3: r.l3,
            aP: r.aP,
            dE: r.dE,
            h_: Tt,
            sn: r.sn
        })));
    }, bc = Un, pc = F2(function(n, r) {
        return m(r, bc(n));
    }), vc = Oi({
        bN: "Name",
        bT: "Nom"
    }), $c = Oi({
        bN: "New password",
        bT: "Nouveau mot de passe"
    }), gc = Oi({
        bN: "Password",
        bT: "Mot de passe"
    }), hc = F2(function(n, r) {
        var t;
        return A2(pc, T([
            A2(Yi, Qi, (t = n.k8, dc(A2(Ho, xo, So(A2(jo, t, Tt))))))
        ]), {
            kP: ro(function(r) {
                return p(r, {
                    m6: Ji,
                    ss: n.kP
                });
            }),
            k8: Ri(function(r) {
                return p(r, {
                    kQ: !0,
                    m6: Gi,
                    ss: n.k8
                });
            }),
            lm: Tt,
            mS: Tt,
            n5: Ri(function(r) {
                return p(r, {
                    m6: vc,
                    ss: n.n5
                });
            }),
            od: Ri(function(n) {
                return p(n, {
                    m6: $c
                });
            }),
            oe: Ri(function(n) {
                return p(n, {
                    m6: Xi
                });
            }),
            oZ: Ri(function(n) {
                return p(n, {
                    m6: gc
                });
            }),
            o_: Tt,
            rv: Tt,
            sv: r
        });
    }), kc = (cu = Tt, function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                cq: i,
                                                                                cz: o,
                                                                                cE: cu,
                                                                                cF: v,
                                                                                cX: l,
                                                                                cY: n,
                                                                                cZ: b,
                                                                                c2: p,
                                                                                db: t,
                                                                                dc: f,
                                                                                oP: r,
                                                                                dh: $,
                                                                                dl: c,
                                                                                $7: d,
                                                                                dw: m,
                                                                                dA: a,
                                                                                dJ: u,
                                                                                dK: e,
                                                                                dQ: s
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt)(Tt), Tc = A2(pc, g, {
        oV: kc
    }), wc = F3(function(n, r, t) {
        return {
            d1: !1,
            bL: n.bL,
            e$: {
                dt: It(n.oo)
            },
            mK: n.mK,
            _: g,
            fX: "",
            b$: !1,
            sn: t,
            sp: r,
            dN: {
                fk: n.fk,
                mP: !1,
                id: n.id
            }
        };
    }), Cc = Au, Nc = Ri(Ie), Ac = {
        kv: Tt,
        lm: Tt,
        nl: !0
    }, Sc = function(n) {
        return {
            ii: p(Nc, {
                ss: n.bL.jr
            }),
            is: Tt,
            it: p(Nc, {
                d7: !0,
                kV: "addInBrowserInput"
            }),
            iR: p(Nc, {
                ss: n.bL.js
            }),
            jJ: g,
            jK: g,
            k1: Tt,
            k3: p(Nc, {
                d7: !0,
                kV: "editInBrowserInput"
            }),
            lm: Tt,
            fB: g,
            mH: g,
            mK: n.mK,
            of: Tt,
            oB: Cc,
            oJ: Tt,
            oK: p(Nc, {
                ss: "alphabetical"
            }),
            pM: !0,
            qr: Tt,
            P: Ac,
            rk: Cc,
            sq: n.sp.oL
        };
    }, Lc = {
        qb: p(Ri(Ie), {
            kV: "searchInBrowserInput",
            n6: !1,
            gt: Oi({
                bN: "Search...",
                bT: "Rechercher..."
            })
        }),
        qc: g,
        qd: !1
    }, yc = {
        $: 0
    }, Fc = {
        $: 1
    }, jc = function(n) {
        return {
            iL: yc,
            kY: Tt,
            kZ: Tt,
            lm: Tt,
            bQ: g,
            oX: Fc,
            pt: "",
            so: !1,
            sp: n
        };
    }, Pc = F2(function(n, r) {
        return A3(tt, "", Ie, A2(No, r, n));
    }), Ic = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Bc = {
        $: 2
    }, Mc = {
        $: 1
    }, Oc = F2(function(n, r) {
        switch(r.$){
            case 0:
                return wt({
                    $: 0,
                    a: r.a
                });
            case 1:
                return wt(Mc);
            case 2:
                return wt(Bc);
            case 3:
                return wt(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(r.a.bo));
            default:
                return A2(hi, Ic, n(r.b));
        }
    }), qc = F2(function(n, r) {
        return A2(Pc, n, Oc(function(n) {
            return A2(hi, Xt, A2(Ro, r, n));
        }));
    }), Dc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xc = nn, Rc = F4(function(n, r, t, e) {
        return A2(xc, t, A2(Ce, function(u) {
            return i(u, r) ? e : 10 > t ? A4(Rc, n, r, t + 1, e) : Dc("Can't find : " + r);
        }, A2(mu, n, Bi)));
    }), Vc = A2(mu, "refs", A4(Rc, "id", "master", 0, A2(mu, "ref", Bi))), Ec = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zc = F2(function(n, r) {
        return {
            gO: n,
            hz: r
        };
    }), Uc = Ke(A2(zc, Au, g)), Hc = function(n) {
        return Nn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(wn(0));
        });
    }, Wc = Fn, Qc = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(_e, function(r) {
                        var e = a.h_;
                        return A3(Qc, n, u, 1 === e.$ ? t : A3(wu, e.a, r, t));
                    }, Wc(A3(nt, n, eu(n), a)));
                }
                var i = e.a, o = A2(lo, i, t);
                if (1 === o.$) {
                    r = u;
                    continue n;
                }
                return A2(_e, function() {
                    return A3(Qc, n, u, A2(ho, i, t));
                }, Hc(o.a));
            }
            return Ke(t);
        }
    }), Zc = F4(function(n, r, t, e) {
        return A2(_e, function(n) {
            return Ke(A2(zc, n, t));
        }, A3(Qc, n, r, e.gO));
    }), Kc = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(dt, e.a, t);
    }), Yc = F2(function(n, r) {
        return A3(Je, Kc(n), g, r);
    }), Xc = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? kt(A2(eu, n, u(t))) : Tt;
    }), Jc = F3(function(n, r, t) {
        return A2(_e, function() {
            return Ke(t);
        }, tu(A2(Yc, A3(Xc, n, r.a, r.b), t.hz)));
    }), Gc = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return Ec({
                iF: t.iF,
                eh: t.eh,
                cN: A2(et, n, t.cN),
                l3: t.l3,
                aP: t.aP,
                dE: t.dE,
                h_: t.h_,
                sn: t.sn
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), _c = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ns = F2(function(n, r) {
        return A2(_c, r.a, A2(No, r.b, n));
    });
    Dn.Http = xn(Uc, Zc, Jc, Gc, ns);
    var rs, ts, es, us, as, is, os, cs, ss, fs, ls = zn("Http"), ms = (zn("Http"), function(n) {
        return function(n) {
            return ls(Ec({
                iF: !1,
                eh: n.eh,
                cN: n.cN,
                l3: n.l3,
                aP: n.aP,
                dE: n.dE,
                h_: n.h_,
                sn: n.sn
            }));
        }({
            eh: To,
            cN: n.cN,
            l3: g,
            aP: "GET",
            dE: Tt,
            h_: Tt,
            sn: n.sn
        });
    }), ds = "https://nomalab.prismic.io/api/v2", bs = m({
        fX: "",
        oU: Tt,
        b7: Tt
    }, (rs = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ms({
        cN: A2(qc, rs, Vc),
        sn: ds
    }))), ps = Oi({
        bN: "Can downlaod",
        bT: "Autoriser \xe0 t\xe9l\xe9charger"
    }), vs = ro(function(n) {
        return p(n, {
            mm: "checkbox-canDownload",
            m6: ps
        });
    }), $s = Oi({
        bN: "Can upload",
        bT: "Autoriser \xe0 uploader"
    }), gs = ro(function(n) {
        return p(n, {
            mm: "checkbox-canUpload",
            m6: $s
        });
    }), hs = Oi({
        bN: "Email",
        bT: "Email"
    }), ks = Oi({
        bN: "Invited user\u2019s email",
        bT: "Email de l\u2019utilisateur invit\xe9"
    }), Ts = Ri(function(n) {
        return p(n, {
            m6: hs,
            gt: ks
        });
    }), ws = Oi({
        bN: "Expiration date",
        bT: "Date d\u2019Expiration"
    }), Cs = Ri(function(n) {
        return p(n, {
            m6: ws
        });
    }), Ns = Oi({
        bN: "Message",
        bT: "Message"
    }), As = Ri(function(n) {
        return p(n, {
            m6: Ns,
            gt: Ns
        });
    }), Ss = {
        jx: vs,
        jy: gs,
        kS: !1,
        k8: Ts,
        lm: Tt,
        lr: Cs,
        lY: Tt,
        nO: As
    }, Ls = {
        $: 0
    }, ys = {
        oC: !1,
        oE: !1,
        P: Ls,
        r3: Ls,
        sd: Ls
    }, Fs = {
        lY: {
            $: 0
        },
        fz: "",
        gh: !1
    }, js = {
        d1: ys,
        iW: 0,
        cJ: Fs,
        e0: Ac,
        mm: "",
        fB: Ss,
        nm: !0,
        nn: !0,
        P: Ac,
        rR: Au
    }, Ps = {
        aL: 0
    }, Is = F2(function(n, r) {
        return A3(wu, n, 0, r);
    }), Bs = function(n) {
        return A3(qt, Is, Cc, n);
    }, Ms = {
        i3: g,
        d6: g,
        oD: Bs(g),
        sA: g
    }, Os = F8(function(n, r, t, e, u, a, i, o) {
        return {
            eR: t,
            lT: o,
            fe: n,
            j: r,
            ff: i,
            mi: e,
            n_: u,
            qf: a
        };
    }), qs = I, Ds = function(n) {
        return qs(n);
    }, xs = F2(function(n, r) {
        return fe(r) % fe(n);
    }), Rs = F2(function(n, r) {
        var t = 24 * qs(3600 * r.fe), e = qs(60 * r.fe * 10), u = 0 > n % t ? t + n : n % t, a = u % e, i = qs(.066666 * r.fe), o = fe(u / e), c = f(a, i) > 0 ? u + 9 * i * o + i * fe((a - i) / e) : u + 9 * i * o;
        return T([
            fe(fe(fe(c / r.j) / 60) / 60),
            A2(xs, 60, fe(c / r.j) / 60),
            A2(xs, 60, c / r.j),
            c % r.j
        ]);
    }), Vs = F3(function(n, r, t) {
        for(;;){
            var e = A2(pe, Gt, n), u = e.a, a = e.b;
            if (0 > f(le(u), Gt)) return A2(he, !0, {
                t: r,
                n: t,
                s: u
            });
            n = a, r = A2(dt, ie(u), r), t += 1;
        }
    }), Es = 4294967295 >>> 32 - ee, zs = u, Us = F3(function(n, r, t) {
        for(;;){
            var e = A2(zs, Es & r >>> n, t);
            if (e.$) return A2(zs, Es & r, e.a);
            n -= ee, t = e.a;
        }
    }), Hs = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || f(n, t) > -1 ? Tt : f(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? kt(A2(zs, Es & n, a)) : kt(A3(Us, e, n, u));
    }), Ws = function(n) {
        if (n.eR) {
            var r = A2(Rs, n.lT, n), t = F2(function(n, r) {
                var t;
                return A2(Hs, n, (t = r).b ? A3(Vs, t, g, 0) : ue);
            });
            return p(n, {
                ff: A2(ju, 0, A2(t, 3, r)),
                mi: A2(ju, 0, A2(t, 0, r)),
                n_: A2(ju, 0, A2(t, 1, r)),
                qf: A2(ju, 0, A2(t, 2, r))
            });
        }
        var e = fe(n.lT / (3600 * n.j)), u = e > 23 ? m(e % 24, n.lT - 82800 * n.j) : m(e, n.lT), a = u.b;
        return p(n, {
            ff: a % (3600 * n.j) % (60 * n.j) % n.j,
            mi: u.a,
            n_: fe(a % (3600 * n.j) / (60 * n.j)),
            qf: fe(a % (3600 * n.j) % (60 * n.j) / n.j)
        });
    }, Qs = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Tt;
        var r = +n;
        return r == r ? kt(r) : Tt;
    }, Zs = F2(function(n, r) {
        var t = Qs(r);
        return t.$ ? n : t.a;
    }), Ks = F2(function(n, r) {
        var t = ze(r);
        return t.$ ? n : t.a;
    }), Ys = F2(function(n, r) {
        var t = 11 === qe(n) ? A3(De, 9, 11, n) : "00";
        return p(r, {
            ff: r.ff + A2(Ks, 0, t),
            mi: r.mi + A2(Zs, 0, A3(De, 0, 2, n)),
            n_: r.n_ + A2(Zs, 0, A3(De, 3, 5, n)),
            qf: r.qf + A2(Zs, 0, A3(De, 6, 8, n))
        });
    }), Xs = F2(function(n, r) {
        return Ws(function(n) {
            var r = n.eR ? function(n) {
                var r = n.qf, t = n.n_, e = 60 * n.j, u = n.mi, a = 60 * u + t, i = 3600 * n.j, o = n.ff, c = qs(.066666 * n.fe), s = i * u + e * t + n.j * r + o - c * (a - fe(a / 10));
                return qs(s);
            }(n) : function(n) {
                return qs(3600 * n.j * n.mi + 60 * n.j * n.n_ + n.j * n.qf + n.ff);
            }(n);
            return p(n, {
                lT: r
            });
        }(A2(Ys, n, r)));
    }), Js = F3(function(n, r, t) {
        return A2(Xs, "00:00:00:00", A8(Os, A2(Zs, 29.97, n), Ds(A2(Zs, 29.97, n)), t, 0, 0, 0, r, 0));
    }), Gs = A3(Js, "25", 0, !1), _s = {
        iu: !1,
        iY: !1,
        em: g,
        kn: 0,
        kp: Gs,
        lU: 25,
        mL: !1,
        mN: !1,
        mR: !1,
        gu: 1,
        q4: "00:00:00:00",
        ro: kt("")
    }, nf = {
        $: 0
    }, rf = Oi({
        bN: "Choose a delivery channel",
        bT: "Choisissez une chaine de livraison"
    }), tf = Oi({
        bN: "Request reason",
        bT: "Donnez le motif du refus"
    }), ef = {
        nF: Ri(function(n) {
            return p(n, {
                gt: rf
            });
        }),
        nG: Ri(function(n) {
            return p(n, {
                gt: tf
            });
        }),
        nH: nf,
        gh: !1
    }, uf = {
        $: 0
    }, af = {
        $: 0
    }, of = Oi({
        bN: "Add timecode",
        bT: "Ajouter le timecode"
    }), cf = Oi({
        bN: "Comment",
        bT: "Commenter"
    }), sf = {
        jL: g,
        eY: !0,
        m6: "",
        gh: !1,
        gt: "",
        ss: Tt
    }, ff = Oi({
        bN: "Job's type choice",
        bT: "Choix type de Job"
    }), lf = Oi({
        bN: "Ads",
        bT: "Publicit\xe9s"
    }), mf = Oi({
        bN: "End credits",
        bT: "G\xe9n\xe9rique de fin"
    }), df = Oi({
        bN: "Introduction",
        bT: "Introduction"
    }), bf = Oi({
        bN: "Textless elements",
        bT: "Fonds neutres"
    }), pf = Oi({
        bN: "Opening credits",
        bT: "G\xe9n\xe9rique de d\xe9but"
    }), vf = Oi({
        bN: "Program",
        bT: "Programme"
    }), $f = Oi({
        bN: "Clip",
        bT: "Extrait"
    }), gf = T([
        m("openingCredits", pf),
        m("endingCredits", mf),
        m("introduction", df),
        m("program", vf),
        m("trailer", $f),
        m("advertising", lf),
        m("neutralBases", bf)
    ]), hf = Oi({
        bN: "Segment choice",
        bT: "Choix Segments"
    }), kf = function(n) {
        switch(n){
            case 0:
                return "Spotcheck";
            case 1:
                return "QC";
            case 2:
                return "DownloadAsIs";
            case 3:
                return "SimpleTranscode";
            default:
                return "PADTranscode";
        }
    }, Tf = T([
        m(kf(1), kf(1)),
        m(kf(0), kf(0))
    ]), wf = {
        io: !1,
        ip: !1,
        iN: {
            cU: 3,
            su: af
        },
        d0: Au,
        j_: !1,
        j$: uf,
        kd: uf,
        kr: Tt,
        k2: Au,
        k4: Au,
        k5: Au,
        lm: Tt,
        l1: !1,
        mX: p(sf, {
            jL: Tf,
            gt: ff
        }),
        nO: Ri(function(n) {
            return p(n, {
                gt: cf
            });
        }),
        qh: Tt,
        qi: p(sf, {
            jL: gf,
            gt: hf
        }),
        qG: !1,
        q2: uf,
        q3: uf,
        q4: "00:00:00:00",
        ry: 0,
        hV: ro(function(n) {
            return p(n, {
                mm: "commentTitmecode",
                m6: of
            });
        })
    }, Cf = {
        eY: !0,
        lm: Tt,
        pv: g,
        p$: Tt,
        qo: Tt,
        sx: Au
    }, Nf = {
        ko: Tt
    }, Af = {
        $: 0
    }, Sf = Af, Lf = {
        $: 0
    }, yf = {
        $: 0
    }, Ff = Oi({
        bN: "title",
        bT: "titre"
    }), jf = {
        ln: Au,
        oD: Cc,
        pm: Au,
        pF: Au,
        hE: Au
    }, Pf = Oi({
        bN: "Can download (extra costs apply)",
        bT: "Autoriser le t\xe9l\xe9chargement (soumis \xe0 facturation)"
    }), If = ro(function(n) {
        return p(n, {
            mm: "checkbox-canDownload",
            m6: Pf
        });
    }), Bf = Oi({
        bN: "Can Upload",
        bT: "Autoriser \xe0 l'upload"
    }), Mf = ro(function(n) {
        return p(n, {
            mm: "checkbox-canUpload",
            m6: Bf
        });
    }), Of = Oi({
        bN: "Email",
        bT: "Email"
    }), qf = Oi({
        bN: "Invited user\u2019s email",
        bT: "Email de l\u2019utilisateur invit\xe9"
    }), Df = Ri(function(n) {
        return p(n, {
            m6: Of,
            gt: qf
        });
    }), xf = Oi({
        bN: "Expiration date",
        bT: "Date d\u2019Expiration"
    }), Rf = Ri(function(n) {
        return p(n, {
            m6: xf
        });
    }), Vf = Oi({
        bN: "Message",
        bT: "Message"
    }), Ef = Ri(function(n) {
        return p(n, {
            m6: Vf,
            gt: Vf
        });
    }), zf = {
        jx: If,
        jy: Mf,
        kS: !1,
        k8: Df,
        lm: Tt,
        lr: Rf,
        nO: Ef
    }, Uf = {
        $: 0
    }, Hf = Oi({
        bN: "audio mapping",
        bT: "mapping audio"
    }), Wf = Oi({
        bN: "channel",
        bT: "chaine"
    }), Qf = Oi({
        bN: "URL (s3:// ftp:// sftp:// https://)",
        bT: "URL (s3:// ftp:// sftp:// https://)"
    }), Zf = Oi({
        bN: "file\u2019s type",
        bT: "type de fichier"
    }), Kf = {
        lm: Tt,
        mz: Ri(function(n) {
            return p(n, {
                m6: Qf,
                gt: Qf
            });
        }),
        qn: Ri(function(n) {
            return p(n, {
                m6: "",
                gt: Zf,
                ss: "Material"
            });
        })
    }, Yf = Oi({
        bN: "host",
        bT: "host"
    }), Xf = Oi({
        bN: "password",
        bT: "mot de passe"
    }), Jf = Oi({
        bN: "path",
        bT: "path"
    }), Gf = Oi({
        bN: "port (default 21)",
        bT: "port (default 21)"
    }), _f = Oi({
        bN: "user",
        bT: "utilisateur"
    }), nl = Oi({
        bN: "file\u2019s type",
        bT: "type de fichier"
    }), rl = {
        lm: Tt,
        mt: Ri(function(n) {
            return p(n, {
                m6: Yf,
                gt: Yf
            });
        }),
        mu: Ri(function(n) {
            return p(n, {
                m6: Xf,
                gt: Xf
            });
        }),
        mv: Ri(function(n) {
            return p(n, {
                m6: Jf,
                gt: Jf
            });
        }),
        mw: Ri(function(n) {
            return p(n, {
                m6: Gf,
                gt: Gf
            });
        }),
        mA: Ri(function(n) {
            return p(n, {
                m6: _f,
                gt: _f
            });
        }),
        qn: Ri(function(n) {
            return p(n, {
                m6: "",
                gt: nl,
                ss: "Material"
            });
        })
    }, tl = Oi({
        bN: "S3 file\u2019s bucket",
        bT: "bucket du fichier S3"
    }), el = Oi({
        bN: "S3 file\u2019s key",
        bT: "cl\xe9 du fichier S3"
    }), ul = Oi({
        bN: "file\u2019s type",
        bT: "type de fichier"
    }), al = {
        mx: Ri(function(n) {
            return p(n, {
                m6: tl,
                gt: tl
            });
        }),
        my: Ri(function(n) {
            return p(n, {
                m6: el,
                gt: el
            });
        }),
        qn: Ri(function(n) {
            return p(n, {
                m6: "",
                gt: ul,
                ss: "Material"
            });
        })
    }, il = Oi({
        bN: "Request reason",
        bT: "Raison de la demande"
    }), ol = Oi({
        bN: "Segmentation rules",
        bT: "R\xe8gles de segmentation"
    }), cl = {
        ix: Kf,
        iK: Uf,
        d1: Uf,
        i2: Ri(function(n) {
            return p(n, {
                gt: Hf
            });
        }),
        bE: Ri(function(n) {
            return p(n, {
                gt: Wf
            });
        }),
        ke: Uf,
        kf: Ri(function(n) {
            return p(n, {
                gt: il
            });
        }),
        ko: Tt,
        kB: Ri(function(n) {
            return p(n, {
                gt: "Choose Deep Probe Template"
            });
        }),
        kE: Uf,
        kF: Uf,
        lZ: rl,
        l7: !0,
        l8: !0,
        l9: !0,
        pf: Uf,
        pg: g,
        dh: g,
        po: Tt,
        pI: Uf,
        pJ: Uf,
        pK: Uf,
        pX: al,
        $7: g,
        qj: Ri(function(n) {
            return p(n, {
                gt: ol
            });
        }),
        g6: Tt,
        qF: Ri(function(n) {
            return p(n, {
                gt: "Choose File"
            });
        }),
        se: Uf
    }, sl = {
        eY: !0,
        pv: Tt,
        sx: Au
    }, fl = function(n) {
        return {
            ig: ef,
            $9: wf,
            d1: ys,
            iW: 0,
            iX: !1,
            i4: Cf,
            i7: Nf,
            jo: !1,
            j8: Ms,
            kH: Sf,
            cJ: Fs,
            k1: {
                jH: Au,
                mB: Au,
                c2: g,
                p4: Tt,
                P: yf,
                rb: Lf,
                rc: Lf,
                rT: Ri(function(n) {
                    return p(n, {
                        m6: Ff,
                        gt: ""
                    });
                })
            },
            e0: Ac,
            bQ: jf,
            mm: "",
            fB: zf,
            nj: !1,
            no: !0,
            oI: cl,
            oL: n.sp.oL,
            oW: {
                bD: Tt,
                cf: Tt
            },
            o2: Tt,
            o4: !0,
            o5: _s,
            pn: Tt,
            pv: Tt,
            qC: !1,
            qD: !1,
            qE: !1,
            P: Ac,
            rp: sl,
            rt: Au,
            r1: !0
        };
    }, ll = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ml = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dl = ml({
        $: 20
    }), bl = function(n) {
        return {
            $: 14,
            a: n
        };
    }, pl = function(n) {
        return {
            $: 8,
            a: n
        };
    }, vl = function(n) {
        return {
            $: 3,
            a: n
        };
    }, $l = function(n) {
        return {
            $: 12,
            a: n
        };
    }, gl = function(n) {
        return {
            $: 7,
            a: n
        };
    }, hl = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kl = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Tl = function(n) {
        return {
            $: 4,
            a: n
        };
    }, wl = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Cl = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nl = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Al = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sl = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ll = function(n) {
        return {
            $: 11,
            a: n
        };
    }, yl = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Fl = function(n) {
        return {
            $: 5,
            a: n
        };
    }, jl = function(n) {
        switch(n){
            case "segmentation":
                return St(0);
            case "deep_probe":
                return St(1);
            default:
                return wt("can't handle this analyze job kind");
        }
    }, Pl = function(n) {
        return n ? "deep_probe" : "segmentation";
    }, Il = F2(function(n, r) {
        return {
            e: A2(Ce, function(n) {
                var t = r(n);
                return t.$ ? Dc("unknown enum: " + n) : je(t.a);
            }, Bi),
            g: A2(bu, gi, n)
        };
    }), Bl = A2(Il, Pl, jl), Ml = F2(function(n) {
        return n;
    }), Ol = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ql = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Dl = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Ol, e.a, e.b);
            var u = e.a, a = e.c, i = n(e.b)(a);
            if (1 === i.$) {
                var o = i.a;
                return A2(Ol, u || o, i.b);
            }
            return o = i.a, A3(ql, u || o, i.b, i.c);
        };
    }), xl = Dl, Rl = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Vl = F4(function(n, r, t, e) {
        return {
            et: r,
            j6: e,
            gx: t,
            pQ: n
        };
    }), El = {
        $: 0
    }, zl = F2(function(n, r) {
        return A2(Rl, El, A4(Vl, n.pQ, n.et, r, n.ak));
    }), Ul = (ts = {
        $: 10
    }, function(n) {
        return i(qe(n.a), n.b2) ? A3(ql, !1, 0, n) : A2(Ol, !1, A2(zl, n, ts));
    }), Hl = it, Wl = F5(function(n, r, t, e, u) {
        for(;;){
            var a = A3(Hl, n, r, u.a);
            if (i(a, -1)) return A3(ql, 0 > f(u.b2, r), 0, {
                et: e,
                ak: u.ak,
                f: u.f,
                b2: r,
                pQ: t,
                a: u.a
            });
            i(a, -2) ? (r += 1, t += 1, e = 1) : (r = a, e += 1);
        }
    }), Ql = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Ol, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(ql, e.a, A2(n, A3(De, r.b2, a.b2, r.a), u), a);
        };
    }), Zl = function(n) {
        return A2(Ql, Ml, n);
    }, Kl = function(n) {
        return function(n) {
            return function(r) {
                return A2(Ol, !1, A2(zl, r, n));
            };
        }({
            $: 12,
            a: n
        });
    }, Yl = function(n) {
        return function(r) {
            return A3(ql, !1, n, r);
        };
    }, Xl = A2(xl, function(n) {
        if (qe(n) > 9) return Kl("Expected at most 9 digits, but got " + It(qe(n)));
        var r = Qs("0." + n);
        return r.$ ? Kl('Invalid float: "' + n + '"') : Yl(qs(1e3 * r.a));
    }, Zl((fs = Qt, function(n) {
        return A5(Wl, fs, n.b2, n.pQ, n.et, n);
    }))), Jl = Ie, Gl = F6(function(n, r, t, e, u, a) {
        return Jl(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), _l = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Ol, t.a, t.b);
            var a = t.a, i = t.b, o = u(t.c);
            if (1 === o.$) {
                var c = o.a;
                return A2(Ol, a || c, o.b);
            }
            c = o.a;
            var s = o.c;
            return A3(ql, a || c, A2(n, i, o.b), s);
        };
    }), nm = F2(function(n, r) {
        return A3(_l, Ml, n, r);
    }), rm = nm, tm = F2(function(n, r) {
        return A3(_l, oe, n, r);
    }), em = tm, um = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), am = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(um, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(Ol, !1, r);
        }
    }), im = function(n) {
        return function(r) {
            return A3(am, r, El, n);
        };
    }, om = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cm = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sm = {
        $: 11
    }, fm = F2(function(n, r) {
        return function(t) {
            var e = A3(Hl, n, t.b2, t.a);
            return i(e, -1) ? A2(Ol, !1, A2(zl, t, r)) : i(e, -2) ? A3(ql, !0, 0, {
                et: 1,
                ak: t.ak,
                f: t.f,
                b2: t.b2 + 1,
                pQ: t.pQ + 1,
                a: t.a
            }) : A3(ql, !0, 0, {
                et: t.et + 1,
                ak: t.ak,
                f: t.f,
                b2: e,
                pQ: t.pQ,
                a: t.a
            });
        };
    }), lm = function(n) {
        return A2(fm, n, sm);
    }, mm = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(Ol, n || a, u.b);
            var a = u.a, i = u.b, o = u.c;
            if (i.$) return A3(ql, n || a, i.a, o);
            n = n || a, r = i.a, e = o;
        }
    }), dm = F2(function(n, r) {
        return function(t) {
            return A4(mm, !1, n, r, t);
        };
    }), bm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Ol, e.a, e.b);
            var u = e.c;
            return A3(ql, e.a, n(e.b), u);
        };
    }), pm = bm, vm = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, $m = F2(function(n, r) {
        return A2(dm, n, function(n) {
            return A2(pm, vm, r(n));
        });
    }), gm = function(n) {
        return A2($m, "", function(r) {
            if (i(qe(r), n)) {
                var t = ze(r);
                return t.$ ? Kl('Invalid integer: "' + r + '"') : A2(pm, om, Yl(t.a));
            }
            return A2(pm, function(n) {
                return cm(A2(zu, r, n));
            }, Zl(lm(Qt)));
        });
    }, hm = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), km = at, Tm = function(n) {
        return function(n) {
            var r = n.a, t = n.b, e = !Ve(r);
            return function(n) {
                var u = A5(km, r, n.b2, n.pQ, n.et, n.a), a = u.a, o = u.b, c = u.c;
                return i(a, -1) ? A2(Ol, !1, A2(zl, n, t)) : A3(ql, e, 0, {
                    et: c,
                    ak: n.ak,
                    f: n.f,
                    b2: a,
                    pQ: o,
                    a: n.a
                });
            };
        }(A2(hm, n, {
            $: 8,
            a: n
        }));
    }, wm = function(n) {
        return Kl("Invalid day: " + It(n));
    }, Cm = function(n) {
        return !(A2(qa, 4, n) || !A2(qa, 100, n) && A2(qa, 400, n));
    }, Nm = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, Am = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return wm(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !Cm(r) ? e - 1 : e) + (Nm(r) - Nm(1970)));
            return Yl(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? wm(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !Cm(r) ? wm(e) : u(26784e5);
            case 3:
                return e > 31 ? wm(e) : u(50976e5);
            case 4:
                return e > 30 ? wm(e) : u(7776e6);
            case 5:
                return e > 31 ? wm(e) : u(10368e6);
            case 6:
                return e > 30 ? wm(e) : u(130464e5);
            case 7:
                return e > 31 ? wm(e) : u(156384e5);
            case 8:
                return e > 31 ? wm(e) : u(183168e5);
            case 9:
                return e > 30 ? wm(e) : u(209952e5);
            case 10:
                return e > 31 ? wm(e) : u(235872e5);
            case 11:
                return e > 30 ? wm(e) : u(262656e5);
            case 12:
                return e > 31 ? wm(e) : u(288576e5);
            default:
                return Kl('Invalid month: "' + It(t) + '"');
        }
    }, Sm = A2(xl, Am, A2(em, A2(em, A2(em, Yl(F3(function(n, r, t) {
        return d(n, r, t);
    })), gm(4)), im(T([
        A2(em, A2(rm, Yl(Ie), Tm("-")), gm(2)),
        gm(2)
    ]))), im(T([
        A2(em, A2(rm, Yl(Ie), Tm("-")), gm(2)),
        gm(2)
    ])))), Lm = (es = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(em, Yl(Ie), im(T([
        A2(pm, function() {
            return 0;
        }, Tm("Z")),
        A2(em, A2(em, A2(em, Yl(es), im(T([
            A2(pm, function() {
                return 1;
            }, Tm("+")),
            A2(pm, function() {
                return -1;
            }, Tm("-"))
        ]))), gm(2)), im(T([
            A2(em, A2(rm, Yl(Ie), Tm(":")), gm(2)),
            gm(2),
            Yl(0)
        ]))),
        A2(rm, Yl(0), Ul)
    ])))), ym = A2(xl, function(n) {
        return im(T([
            A2(em, A2(em, A2(em, A2(em, A2(em, A2(rm, Yl(Gl(n)), Tm("T")), gm(2)), im(T([
                A2(em, A2(rm, Yl(Ie), Tm(":")), gm(2)),
                gm(2)
            ]))), im(T([
                A2(em, A2(rm, Yl(Ie), Tm(":")), gm(2)),
                gm(2)
            ]))), im(T([
                A2(em, A2(rm, Yl(Ie), Tm(".")), Xl),
                Yl(0)
            ]))), A2(rm, Lm, Ul)),
            A2(rm, Yl(A6(Gl, n, 0, 0, 0, 0, 0)), Ul)
        ]));
    }, Sm), Fm = F3(function(n, r, t) {
        return {
            et: r,
            gx: t,
            pQ: n
        };
    }), jm = function(n) {
        return A3(Fm, n.pQ, n.et, n.gx);
    }, Pm = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(dt, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Pm, e, r);
                continue n;
        }
    }), Im = F2(function(n, r) {
        var t = n({
            et: 1,
            ak: g,
            f: 1,
            b2: 0,
            pQ: 1,
            a: r
        });
        return t.$ ? wt(A2(Pm, t.b, g)) : St(t.b);
    }), Bm = F2(function(n, r) {
        var t = A2(Im, n, r);
        return t.$ ? wt(A2(Ge, jm, t.a)) : St(t.a);
    }), Mm = function(n) {
        return A2(Bm, ym, n);
    }, Om = A2(No, Mm, hi(Ml("Can't parse date"))), qm = A2(Ce, function(n) {
        var r = Om(n);
        return r.$ ? Dc(r.a) : je(r.a);
    }, Bi), Dm = F2(function(n, r) {
        return fe(n / r);
    }), xm = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > f(e.hp, r)) return r + e.b2;
            t = u;
        }
    }), Rm = F2(function(n, r) {
        var t = n.b;
        return A3(xm, n.a, A2(Dm, r, 6e4), t);
    }), Vm = function(n) {
        var r = A2(Dm, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, a = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, o = i + (10 > i ? 3 : -9);
        return {
            eJ: a - ((153 * i + 2) / 5 | 0) + 1,
            f4: o,
            ie: u + 400 * t + (o > 2 ? 0 : 1)
        };
    }, Em = F2(function(n, r) {
        return Vm(A2(Rm, n, r)).eJ;
    }), zm = F2(function(n, r) {
        return A2(qa, 24, A2(Dm, A2(Rm, n, r), 60));
    }), Um = F2(function(n, r) {
        return A2(qa, 1e3, r);
    }), Hm = F2(function(n, r) {
        return A2(qa, 60, A2(Rm, n, r));
    }), Wm = F2(function(n, r) {
        switch(Vm(A2(Rm, n, r)).f4){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), Qm = function(n) {
        return A2(Na, n, "");
    }, Zm = F3(function(n, r, t) {
        return n > 0 ? A3(Zm, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), Km = F2(function(n, r) {
        return A3(Zm, n, r, "");
    }), Ym = F3(function(n, r, t) {
        return $(A2(Km, n - qe(t), Qm(r)), t);
    }), Xm = F2(function(n, r) {
        return A3(Ym, n, "0", It(r));
    }), Jm = F2(function(n, r) {
        return A2(qa, 60, A2(Dm, r, 1e3));
    }), Gm = F2(function(n, r) {
        return Vm(A2(Rm, n, r)).ie;
    }), _m = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), nd = A2(_m, 0, g), rd = function(n) {
        return A2(Xm, 4, A2(Gm, nd, n)) + "-" + A2(Xm, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(Wm, nd, n))) + "-" + A2(Xm, 2, A2(Em, nd, n)) + "T" + A2(Xm, 2, A2(zm, nd, n)) + ":" + A2(Xm, 2, A2(Hm, nd, n)) + ":" + A2(Xm, 2, A2(Jm, nd, n)) + "." + A2(Xm, 3, A2(Um, nd, n)) + "Z";
    }, td = {
        e: qm,
        g: function(n) {
            return gi(rd(n));
        }
    }, ed = function(n) {
        switch(n){
            case "Request":
                return St(0);
            case "Finish":
                return St(1);
            default:
                return wt("not a Analyze kind");
        }
    }, ud = function(n) {
        return n ? "Finish" : "Request";
    }, ad = A2(Il, ud, ed), id = Po(A4(Do, "ruleName", function(n) {
        return n.dm;
    }, xi, A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(Do, "fileName", function(n) {
        return n.cS;
    }, xi, A4(Do, "fileId", function(n) {
        return n.z;
    }, xi, A4(rc, "sourceName", function(n) {
        return n.du;
    }, xi, A4(rc, "sourceId", function(n) {
        return n.hd;
    }, xi, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "analyzeKind", function(n) {
        return n.cp;
    }, Bl, A4(rc, "kind", function(n) {
        return n.c$;
    }, ad, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return {
                                                            cp: e,
                                                            lm: l,
                                                            z: s,
                                                            cS: f,
                                                            mm: n,
                                                            c$: t,
                                                            dm: m,
                                                            g6: r,
                                                            hd: o,
                                                            du: c,
                                                            hA: a,
                                                            hX: i,
                                                            rS: u
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), od = F6(function(n, r, t, e, u, a) {
        return {
            mm: n,
            g6: r,
            dt: u,
            hA: e,
            hX: a,
            rS: t
        };
    }), cd = F6(function(n, r, t, e, u, a) {
        return {
            bz: a,
            k8: t,
            mm: n,
            n5: r,
            oL: e,
            gj: u
        };
    }), sd = Po(A4(rc, "avatar", function(n) {
        return n.bz;
    }, xi, A4(Do, "organizationName", function(n) {
        return n.gj;
    }, xi, A4(Do, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(cd)))))))), fd = Po(A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(od)))))))), ld = function(n) {
        var r = n;
        return {
            e: A2(Ce, function(n) {
                return A2(r.e, n, Dc(n + "did not match"));
            }, A2(xc, 0, Bi)),
            g: function(n) {
                return r.b_(n);
            }
        };
    }, md = F8(function(n, r, t, e, u, a, i, o) {
        return {
            mm: n,
            nO: i,
            g6: r,
            dt: a,
            hA: e,
            hV: o,
            hX: u,
            rS: t
        };
    }), dd = Po(A4(Do, "timecode", function(n) {
        return n.hV;
    }, xi, A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(md)))))))))), bd = function(n) {
        return {
            e: function() {
                return Ie;
            },
            b_: n
        };
    }, pd = F7(function(n, r, t, e, u, a, i) {
        return {
            cT: i,
            mm: n,
            g6: r,
            dt: a,
            hA: e,
            hX: u,
            rS: t
        };
    }), vd = Po(A4(rc, "fileName", function(n) {
        return n.cT;
    }, xi, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(pd))))))))), $d = F8(function(n, r, t, e, u, a, i, o) {
        return {
            lB: i,
            cS: o,
            mm: n,
            g6: r,
            dt: u,
            hA: e,
            hX: a,
            rS: t
        };
    }), gd = Po(A4(rc, "fileName", function(n) {
        return n.cS;
    }, xi, A4(rc, "file", function(n) {
        return n.lB;
    }, xi, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io($d)))))))))), hd = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            cQ: o,
            z: a,
            cR: c,
            cS: i,
            mm: n,
            g6: r,
            hA: e,
            hX: u,
            rS: t
        };
    }), kd = Po(A4(rc, "fileKey", function(n) {
        return n.cR;
    }, xi, A4(rc, "fileBucket", function(n) {
        return n.cQ;
    }, xi, A4(rc, "fileName", function(n) {
        return n.cS;
    }, xi, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(hd))))))))))), Td = function(n) {
        switch(n){
            case "Add":
                return St(0);
            case "Remove":
                return St(1);
            default:
                return St(2);
        }
    }, wd = function(n) {
        switch(n){
            case 0:
                return "Add";
            case 1:
                return "Remove";
            default:
                return "NoChanges";
        }
    }, Cd = A2(Il, wd, Td), Nd = function(n) {
        switch(n){
            case "Add":
                return St(0);
            case "Update":
                return St(1);
            case "Delete":
                return St(2);
            default:
                return wt("not a kind of inviatation");
        }
    }, Ad = function(n) {
        switch(n){
            case 0:
                return "Add";
            case 1:
                return "Update";
            default:
                return "Delete";
        }
    }, Sd = A2(Il, Ad, Nd), Ld = function(n) {
        switch(n){
            case "Delivery":
                return St(0);
            case "Master":
                return St(1);
            default:
                return wt("not ShowKind");
        }
    }, yd = function(n) {
        return n ? "Master" : "Delivery";
    }, Fd = A2(Il, yd, Ld), jd = Po(A4(Do, "expireAt", function(n) {
        return n.cO;
    }, td, A4(rc, "upload", function(n) {
        return n.sg;
    }, Cd, A4(rc, "download", function(n) {
        return n.cJ;
    }, Cd, A4(rc, "target", function(n) {
        return n.rL;
    }, sd, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(rc, "kind", function(n) {
        return n.c$;
    }, Sd, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "showKind", function(n) {
        return n.qJ;
    }, Fd, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return {
                                                        cJ: s,
                                                        cO: l,
                                                        mm: n,
                                                        c$: i,
                                                        g6: r,
                                                        qJ: t,
                                                        dt: o,
                                                        hA: u,
                                                        rL: c,
                                                        hX: a,
                                                        rS: e,
                                                        sg: f
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), Pd = F7(function(n, r, t, e, u, a, i) {
        return {
            mm: n,
            c$: a,
            g6: r,
            dt: i,
            hA: e,
            hX: u,
            rS: t
        };
    }), Id = function(n) {
        switch(n){
            case "Create":
                return St(0);
            case "Accept":
                return St(1);
            case "NewVersion":
                return St(2);
            default:
                return wt("Not an event kind");
        }
    }, Bd = function(n) {
        switch(n){
            case 0:
                return "Create";
            case 1:
                return "Accept";
            default:
                return "NewVersion";
        }
    }, Md = A2(Il, Bd, Id), Od = Po(A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(rc, "kind", function(n) {
        return n.c$;
    }, Md, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Pd))))))))), qd = F6(function(n, r, t, e, u, a) {
        return {
            mm: n,
            g6: r,
            dt: u,
            hA: e,
            hX: a,
            rS: t
        };
    }), Dd = Po(A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "source", function(n) {
        return n.dt;
    }, sd, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(qd)))))))), xd = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            kg: c,
            mm: n,
            fA: i,
            g4: o,
            g6: r,
            dt: u,
            hA: e,
            hX: a,
            rS: t
        };
    }), Rd = Po(A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "sftpUser", function(n) {
        return n.g4;
    }, xi, A4(rc, "invitationId", function(n) {
        return n.fA;
    }, xi, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(xd))))))))))), Vd = function(n) {
        switch(n){
            case "Request":
                return St(0);
            case "Finish":
                return St(1);
            default:
                return wt("not a Transcode kind");
        }
    }, Ed = function(n) {
        return n ? "Finish" : "Request";
    }, zd = A2(Il, Ed, Vd), Ud = function(n) {
        switch(n){
            case "deliverable":
            case "deliverable_subtitle":
                return St(2);
            case "proxy_hi_res":
                return St(1);
            case "proxy_low_res":
            case "proxy_audio":
            case "proxy_subtitle":
                return St(0);
            case "copy":
                return St(3);
            case "audio_merge":
                return St(4);
            case "proxy_dcp":
                return St(5);
            case "proxy_imf":
                return St(6);
            default:
                return wt("can't handle this transcode job kind");
        }
    }, Hd = function(n) {
        switch(n){
            case 0:
                return "proxy";
            case 1:
                return "proxy_hi_res";
            case 2:
                return "deliverable";
            case 3:
                return "copy";
            case 4:
                return "audio_merge";
            case 5:
                return "proxy_dcp";
            default:
                return "proxy_imf";
        }
    }, Wd = A2(Il, Hd, Ud), Qd = {
        $: 12
    }, Zd = {
        $: 11
    }, Kd = {
        $: 0
    }, Yd = {
        $: 7
    }, Xd = {
        $: 10
    }, Jd = {
        $: 9
    }, Gd = {
        $: 5
    }, _d = {
        $: 8
    }, nb = {
        $: 2
    }, rb = {
        $: 3
    }, tb = {
        $: 4
    }, eb = {
        $: 1
    }, ub = {
        $: 6
    }, ab = function(n) {
        switch(n){
            case "VD":
                return St(Kd);
            case "VO":
                return St(eb);
            case "VI":
                return St(nb);
            case "VIVD":
                return St(rb);
            case "VIVO":
                return St(tb);
            case "VDVO":
                return St(Gd);
            case "VOAD":
                return St(ub);
            case "VDAD":
                return St(Yd);
            case "VDVOAD":
                return St(_d);
            case "VDVIVONLY":
                return St(Jd);
            case "VDVIMEVONLY":
                return St(Xd);
            case "NoSound":
                return St(Zd);
            case "AsMaster":
                return St(Qd);
            default:
                return St({
                    $: 13,
                    a: n
                });
        }
    }, ib = function(n) {
        switch(n.$){
            case 1:
                return "VO";
            case 0:
                return "VD";
            case 2:
                return "VI";
            case 3:
                return "VIVD";
            case 4:
                return "VIVO";
            case 5:
                return "VDVO";
            case 6:
                return "VOAD";
            case 7:
                return "VDAD";
            case 8:
                return "VDVOAD";
            case 9:
                return "VDVIVONLY";
            case 10:
                return "VDVIMEVONLY";
            case 11:
                return "NoSound";
            case 12:
                return "AsMaster";
            default:
                return n.a;
        }
    }, ob = A2(Il, ib, ab), cb = Po(A4(rc, "transcodeKind", function(n) {
        return n.dI;
    }, Wd, A4(Do, "targetOrganization", function(n) {
        return n.dx;
    }, xi, A4(Do, "subtitlesFileName", function(n) {
        return n.aX;
    }, xi, A4(Do, "mxfVersion", function(n) {
        return n.c5;
    }, ob, A4(Do, "mxfOut", function(n) {
        return n.c4;
    }, xi, A4(Do, "mxfIn", function(n) {
        return n.c3;
    }, xi, A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(rc, "nbWarning", function(n) {
        return n.c7;
    }, uc, A4(rc, "formatName", function(n) {
        return n.cW;
    }, xi, A4(rc, "fileName", function(n) {
        return n.cS;
    }, xi, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, A4(rc, "kind", function(n) {
        return n.c$;
    }, zd, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            lm: f,
                                                                            z: i,
                                                                            cS: o,
                                                                            cW: c,
                                                                            mm: n,
                                                                            c$: a,
                                                                            c3: l,
                                                                            c4: m,
                                                                            c5: d,
                                                                            c7: s,
                                                                            g6: r,
                                                                            hA: e,
                                                                            aX: b,
                                                                            dx: p,
                                                                            hX: u,
                                                                            rS: t,
                                                                            dI: v
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), sb = F6(function(n, r, t, e, u, a) {
        return {
            mm: n,
            g6: r,
            dt: u,
            hA: e,
            hX: a,
            rS: t
        };
    }), fb = Po(A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(sb)))))))), lb = F6(function(n, r, t, e, u, a) {
        return {
            mm: n,
            g6: r,
            dt: u,
            hA: e,
            hX: a,
            rS: t
        };
    }), mb = Po(A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(rc, "source", function(n) {
        return n.dt;
    }, sd, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(lb)))))))), db = function(n) {
        switch(n){
            case "Start":
                return St(0);
            case "Finish":
                return St(1);
            default:
                return wt("not an Upload kind");
        }
    }, bb = function(n) {
        return n ? "Finish" : "Start";
    }, pb = A2(Il, bb, db), vb = Po(A4(Do, "nbFiles", function(n) {
        return n.c6;
    }, uc, A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(rc, "fileName", function(n) {
        return n.cS;
    }, xi, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, A4(rc, "kind", function(n) {
        return n.c$;
    }, pb, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return {
                                                lm: c,
                                                z: i,
                                                cS: o,
                                                mm: n,
                                                c$: a,
                                                c6: s,
                                                g6: r,
                                                hA: e,
                                                hX: u,
                                                rS: t
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), $b = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: F2(function(r, e) {
                return i(r, n) ? t : A2(u.e, r, e);
            }),
            b_: u.b_(r(function(r) {
                return A2(ic, Ie, A2(dt, gi(n), r));
            }))
        };
    }), gb = F3(function(n, r, t) {
        return A3($b, n, F2(function(n, r) {
            return n(T([
                A2(Bo, t, r)
            ]));
        }), A2(ye, r, A2(xc, 1, bi(t))));
    }), hb = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            lm: c,
            z: a,
            cS: i,
            mm: n,
            bl: o,
            g6: r,
            hA: e,
            hX: u,
            rS: t
        };
    }), kb = F2(function(n, r) {
        return {
            n7: n,
            aq: r
        };
    }), Tb = Po(A4(rc, "nbWarnings", function(n) {
        return n.aq;
    }, uc, A4(rc, "nbErrors", function(n) {
        return n.n7;
    }, uc, Io(kb)))), wb = Po(A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(Do, "result", function(n) {
        return n.bl;
    }, Tb, A4(rc, "fileName", function(n) {
        return n.cS;
    }, xi, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, A4(rc, "timestamp", function(n) {
        return n.hX;
    }, td, A4(Do, "subtitle", function(n) {
        return n.hA;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(hb))))))))))), Cb = ld(A4(gb, "Analyze", bl, id, A4(gb, "ProxyPlayed", wl, Dd, A4(gb, "Invitation", kl, jd, A4(gb, "Delete", $l, vd, A4(gb, "Untrash", yl, fb, A4(gb, "Trash", Sl, fb, A4(gb, "Unarchive", Ll, mb, A4(gb, "Archive", pl, fd, A4(gb, "Download", gl, gd, A4(gb, "SftpLogin", Nl, Rd, A4(gb, "Upload", Fl, vb, A4(gb, "Transcode", Al, cb, A4(gb, "QualityCheck", Cl, wb, A4(gb, "Ingest", hl, kd, A4(gb, "Comment", vl, dd, A4(gb, "Lifecycle", Tl, Od, bd(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        switch(v.$){
                                                                            case 4:
                                                                                return n(v.a);
                                                                            case 3:
                                                                                return r(v.a);
                                                                            case 1:
                                                                                return t(v.a);
                                                                            case 0:
                                                                                return e(v.a);
                                                                            case 2:
                                                                                return u(v.a);
                                                                            case 5:
                                                                                return a(v.a);
                                                                            case 7:
                                                                                return o(v.a);
                                                                            case 6:
                                                                                return i(v.a);
                                                                            case 8:
                                                                                return c(v.a);
                                                                            case 11:
                                                                                return s(v.a);
                                                                            case 9:
                                                                                return f(v.a);
                                                                            case 10:
                                                                                return l(v.a);
                                                                            case 12:
                                                                                return m(v.a);
                                                                            case 13:
                                                                                return d(v.a);
                                                                            case 14:
                                                                                return p(v.a);
                                                                            default:
                                                                                return b(v.a);
                                                                        }
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))), Nb = oc(Cb), Ab = dc(A2(Ho, Nb, So(dl))), Sb = A2(pc, T([
        A2(Yi, ll, Ab)
    ]), {
        lm: Tt,
        oU: 0,
        rR: Au
    }), Lb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fb = ml(yb({
        $: 0
    })), jb = F4(function(n, r, t, e) {
        return {
            bH: r,
            gj: e,
            gT: n,
            g$: t
        };
    }), Pb = F6(function(n, r, t, e, u, a) {
        return {
            kg: t,
            bK: r,
            mm: n,
            n5: u,
            oN: e,
            hs: a
        };
    }), Ib = function(n) {
        switch(n){
            case "active":
                return St(0);
            case "archived":
                return St(1);
            case "restoring":
                return St(2);
            default:
                return wt("Unrecognized state: " + n);
        }
    }, Bb = function(n) {
        switch(n){
            case 0:
                return "active";
            case 1:
                return "archived";
            default:
                return "restoring";
        }
    }, Mb = A2(Il, Bb, Ib), Ob = Po(A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "organizationId", function(n) {
        return n.oN;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Pb)))))))), qb = function(n) {
        return St("Own" === n ? 0 : 1);
    }, Db = function(n) {
        return n ? "Invited" : "Own";
    }, xb = A2(Il, Db, qb), Rb = F2(function(n, r) {
        return {
            cM: r,
            dn: n
        };
    }), Vb = F2(function(n, r) {
        return {
            cL: n,
            dr: r
        };
    }), Eb = F6(function(n, r, t, e, u, a) {
        return {
            kg: t,
            bK: r,
            mm: n,
            n5: u,
            bm: e,
            hs: a
        };
    }), zb = Po(A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "seasonId", function(n) {
        return n.bm;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Eb)))))))), Ub = function(n) {
        return A4(rc, "updatedAt", function(n) {
            return n.cl;
        }, td, A4(rc, "updater", function(n) {
            return n.cm;
        }, xi, A4(rc, "createdAt", function(n) {
            return n.kg;
        }, td, A4(rc, "creator", function(n) {
            return n.bK;
        }, xi, A4(rc, "id", function(n) {
            return n.mm;
        }, xi, Io(n))))));
    }, Hb = A2(Di, Ie, Pi), Wb = Po(A4(rc, "trashed", function(n) {
        return n.h2;
    }, no, A4(rc, "parent", function(n) {
        return n.gn;
    }, xi, A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "kind", function(n) {
        return n.c$;
    }, Fd, A4(Do, "commandInfoXML", function(n) {
        return n.ev;
    }, Hb, A4(rc, "accepted", function(n) {
        return n.ih;
    }, no, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(Do, "title2", function(n) {
        return n.rU;
    }, xi, A4(rc, "title1", function(n) {
        return n.rT;
    }, xi, Ub(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return {
                                                                ih: c,
                                                                ev: s,
                                                                kg: t,
                                                                bK: r,
                                                                mm: n,
                                                                c$: f,
                                                                oL: o,
                                                                gn: m,
                                                                hs: l,
                                                                rT: a,
                                                                rU: i,
                                                                h2: d,
                                                                cl: u,
                                                                cm: e
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), Qb = Po(A4(rc, "shows", function(n) {
        return n.dr;
    }, oc(Wb), A4(rc, "episode", function(n) {
        return n.cL;
    }, zb, Io(Vb)))), Zb = F6(function(n, r, t, e, u, a) {
        return {
            a5: e,
            kg: t,
            bK: r,
            mm: n,
            n5: u,
            hs: a
        };
    }), Kb = Po(A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "collectionId", function(n) {
        return n.a5;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Zb)))))))), Yb = Po(A4(rc, "episodes", function(n) {
        return n.cM;
    }, oc(Qb), A4(rc, "season", function(n) {
        return n.dn;
    }, Kb, Io(Rb)))), Xb = Po(A4(rc, "organizationName", function(n) {
        return n.gj;
    }, xi, A4(rc, "seasons", function(n) {
        return n.g$;
    }, oc(Yb), A4(rc, "collection", function(n) {
        return n.bH;
    }, Ob, A4(rc, "role", function(n) {
        return n.gT;
    }, xb, Io(jb)))))), Jb = oc(Xb), Gb = nu, _b = function(n) {
        var r = n.b;
        return A2(_e, function(n) {
            return A2(nu, function(r) {
                return m(n, r);
            }, r);
        }, n.a);
    }, np = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rp = ml(np({
        $: 0
    })), tp = F4(function(n, r, t, e) {
        return {
            gj: e,
            gT: n,
            dr: t,
            sb: r
        };
    }), ep = F6(function(n, r, t, e, u, a) {
        return {
            kg: t,
            bK: r,
            mm: n,
            n5: u,
            oN: e,
            hs: a
        };
    }), up = Po(A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "organizationId", function(n) {
        return n.oN;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(ep)))))))), ap = Po(A4(rc, "organizationName", function(n) {
        return n.gj;
    }, xi, A4(rc, "shows", function(n) {
        return n.dr;
    }, oc(Wb), A4(rc, "unitary", function(n) {
        return n.sb;
    }, up, A4(rc, "role", function(n) {
        return n.gT;
    }, xb, Io(tp)))))), ip = oc(ap), op = (us = F2(function(n, r) {
        return dc(A2(Ho, r, So(n)));
    }), as = A2(Gb, Ge(function(n) {
        return {
            $: 1,
            a: n
        };
    }), A2(us, rp, ip)), is = function(n) {
        return $(n.a, n.b);
    }, os = A2(Gb, Ge(function(n) {
        return {
            $: 0,
            a: n
        };
    }), A2(us, Fb, Jb)), A2(Yi, Lb, A2(Gb, is, _b(m(os, as))))), cp = Hn, sp = function(n) {
        return {
            $: 10,
            a: n
        };
    }, fp = F2(function(n, r) {
        return r.$ ? Tt : n(r.a);
    }), lp = F5(function(n, r, t, e, u) {
        return {
            an: e,
            oW: t,
            ae: r,
            ss: u,
            ay: n
        };
    }), mp = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(dt, n.a, mp(n.b)) : g;
    }, dp = F2(function(n, r) {
        return kt(1 === r.$ ? T([
            n
        ]) : A2(dt, n, r.a));
    }), bp = function(n) {
        try {
            return kt(decodeURIComponent(n));
        } catch (n) {
            return Tt;
        }
    }, pp = F2(function(n, r) {
        var t = A2(Mt, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = bp(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = bp(e);
            return 1 === i.$ ? r : A3(ko, a, dp(i.a), r);
        }
        return r;
    }), vp = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.ae;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return kt(r.ss);
                    }
                    return kt(r.ss);
                }
                return Tt;
            }
        }(n(A5(lp, g, function(n) {
            var r = A2(Mt, "/", n);
            return mp(r.b && "" === r.a ? r.b : r);
        }(r.gp), 1 === (t = r.pw).$ ? Au : A3(Je, pp, Au, A2(Mt, "&", t.a)), r.fb, Ie)));
    }), $p = F3(function(n, r, t) {
        var e;
        return A2(ju, t, A2(fp, vp(r), A2(Ze, "http://", e = "http://domain.co" + n) ? A2(Qe, 0, A2(xe, 7, e)) : A2(Ze, "https://", e) ? A2(Qe, 1, A2(xe, 8, e)) : Tt));
    }), gp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kp = {
        $: 6
    }, Tp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, wp = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Cp = {
        $: 9
    }, Np = {
        $: 8
    }, Ap = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Sp = {
        $: 0
    }, Lp = {
        $: 7
    }, yp = F2(function(n, r) {
        return A5(lp, r.ay, r.ae, r.oW, r.an, n(r.ss));
    }), Fp = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.ay, u = r.ae, a = r.oW, i = r.an;
            return A2(Ge, yp(r.ss), t(A5(lp, e, u, a, i, n)));
        };
    }), jp = function(n) {
        return function(r) {
            return A2(Gu, function(n) {
                return n(r);
            }, n);
        };
    }, Pp = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Gu, e, t(n));
        };
    }), Ip = F2(function(n, r) {
        return A2(Pp, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.oW;
                return T([
                    A5(lp, n.ay, n.ae, t, n.an, (0, n.ss)(r(t)))
                ]);
            };
        }(r));
    }), Bp = {
        $: 1
    }, Mp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Op = function(n) {
        return {
            lX: n
        };
    }, qp = function(n) {
        return function(r) {
            var t = r.ay, e = r.ae, u = r.oW, a = r.an, o = r.ss;
            if (e.b) {
                var c = e.a, s = e.b;
                return i(c, n) ? T([
                    A5(lp, A2(dt, c, t), s, u, a, o)
                ]) : g;
            }
            return g;
        };
    }, Dp = F2(function(n, r) {
        return function(t) {
            return r(A2(ju, g, A2(lo, n, t)));
        };
    }), xp = function(n) {
        return A2(Dp, n, function(n) {
            return n.b && !n.b.b ? kt(n.a) : Tt;
        });
    }, Rp = jp(T([
        A2(Fp, A2(bu, A2(bu, Mp, Op), fp(bp)), A2(Ip, qp("login"), xp("from"))),
        A2(Fp, Bp, qp("forgotPassword")),
        A2(Fp, F2(function(n, r) {
            return {
                $: 2,
                a: {
                    k8: A2(ju, "", n),
                    rY: A2(ju, "", r)
                }
            };
        }), A2(Ip, A2(Ip, qp("resetPassword"), xp("email")), xp("token"))),
        A2(Fp, F3(function(n, r, t) {
            return {
                $: 3,
                a: {
                    k8: A2(ju, "", r),
                    pA: A2(ju, "/", A2(fp, bp, n)),
                    rY: A2(ju, "", t)
                }
            };
        }), A2(Ip, A2(Ip, A2(Ip, qp("invitation"), xp("redirect")), xp("email")), xp("token")))
    ])), Vp = {
        $: 6
    }, Ep = {
        $: 7
    }, zp = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Up = {
        $: 16
    }, Hp = {
        $: 11
    }, Wp = {
        $: 0
    }, Qp = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Zp = {
        $: 15
    }, Kp = {
        $: 2
    }, Yp = {
        $: 10
    }, Xp = {
        $: 1
    }, Jp = {
        $: 17
    }, Gp = {
        $: 8
    }, _p = {
        $: 13
    }, nv = {
        $: 12
    }, rv = {
        $: 5
    }, tv = {
        $: 4
    }, ev = {
        $: 3
    }, uv = {
        $: 9
    }, av = function(n) {
        return {
            c$: n
        };
    }, iv = jp(T([
        A2(Fp, function(n) {
            return av(n);
        }, A2(Ip, qp("dashboard"), xp("kind")))
    ])), ov = F4(function(n, r, t, e) {
        return {
            B: e,
            c$: r,
            oL: n,
            P: t
        };
    }), cv = F2(function(n, r) {
        return A2(Dp, n, function(n) {
            return n.b && !n.b.b ? A2(lo, n.a, r) : Tt;
        });
    }), sv = jp(T([
        A2(Fp, F4(function(n, r, t, e) {
            return A4(ov, n, r, t, e);
        }), A2(Ip, A2(Ip, A2(Ip, A2(Ip, qp("jobs"), xp("organization")), xp("kind")), xp("status")), A2(cv, "acknowledge", Jo(T([
            m("true", !0),
            m("false", !1)
        ])))))
    ])), fv = function(n) {
        return T([
            n
        ]);
    }, lv = jp(T([
        A2(Fp, Wp, fv),
        A2(Fp, Xp, qp("adminOrganizations")),
        A2(Fp, Kp, qp("onboarding")),
        A2(Fp, ev, qp("adminUsers")),
        A2(Fp, tv, qp("adminUploads")),
        A2(Fp, rv, qp("adminTestPlans")),
        A2(Fp, Vp, qp("adminAudioMappings")),
        A2(Fp, Ep, qp("adminChannels")),
        A2(Fp, Gp, qp("adminResearchs")),
        A2(Fp, uv, qp("adminWebhooks")),
        A2(Fp, Yp, qp("adminOrganizationFileListings")),
        A2(Fp, Hp, qp("adminFormats")),
        A2(Fp, nv, qp("adminSubtitleFormats")),
        A2(Fp, _p, qp("adminSegmentationRules")),
        A2(Fp, Qp, sv),
        A2(Fp, Zp, qp("metadata")),
        A2(Fp, Up, qp("deepProbe")),
        A2(Fp, Jp, qp("probes")),
        A2(Fp, zp, iv)
    ])), mv = jp(T([
        A2(Fp, 0, fv),
        A2(Fp, 1, qp("settings"))
    ])), dv = jp(T([
        A2(Fp, 0, fv),
        A2(Fp, 1, qp("actions")),
        A2(Fp, 2, qp("settings")),
        A2(Fp, 3, qp("events")),
        A2(Fp, 4, qp("verif")),
        A2(Fp, 5, qp("comments"))
    ])), bv = F2(function(n, r) {
        return function(n) {
            var t = n.ay, e = n.ae, u = n.oW, a = n.an, i = n.ss;
            if (e.b) {
                var o = e.a, c = e.b, s = r(o);
                if (s.$) return g;
                var f = s.a;
                return T([
                    A5(lp, A2(dt, o, t), c, u, a, i(f))
                ]);
            }
            return g;
        };
    }), pv = A2(bv, "STRING", kt), vv = jp(T([
        A2(Fp, Sp, fv),
        A2(Fp, F4(function(n, r, t, e) {
            return A3(Ap, n, r, {
                bD: t,
                cf: A2(Fu, Ml(!1), e)
            });
        }), A2(Pp, jp(T([
            qp("show"),
            qp("master")
        ])), A2(Pp, pv, A2(Ip, A2(Ip, dv, xp("broadcastable")), xp("sortVerifByDate"))))),
        A2(Fp, wp, A2(Pp, qp("hierarchy"), A2(Pp, pv, mv))),
        A2(Fp, gp, A2(Pp, qp("account"), Rp)),
        A2(Fp, hp, A2(Pp, qp("admin"), lv)),
        A2(Fp, Tp, A2(Pp, qp("help"), pv)),
        A2(Fp, kp, qp("archive")),
        A2(Fp, Np, qp("settings")),
        A2(Fp, Cp, qp("report")),
        A2(Fp, Lp, qp("upload")),
        A2(Fp, sp, A2(Pp, qp("notFound"), pv))
    ])), $v = function(n) {
        return A3($p, n, vv, sp(n));
    }, gv = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hv = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), kv = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "/actions";
            case 2:
                return "/settings";
            case 3:
                return "/events";
            case 4:
                return "/verif";
            default:
                return "/comments";
        }
    }, Tv = function(n) {
        return A3($p, n, dv, 2);
    }, wv = Kn("setPreference", function(n) {
        var r = n.b;
        return A2(ic, Ie, T([
            gi(n.a),
            gi(r)
        ]));
    }), Cv = function(n) {
        var r = n.a, t = n.b, e = r.g6, u = r.ak, a = u.bL, i = a.qz, o = e.iW, c = kv(o);
        return o ? m(p(r, {
            ak: p(u, {
                bL: p(a, {
                    qz: c
                })
            })
        }), bc(T([
            t,
            wv(m("showAside", c))
        ]))) : m(p(r, {
            g6: p(e, {
                iW: Tv(i)
            })
        }), t);
    }, Nv = function(n) {
        var r = n.ak.sn;
        switch(r.$){
            case 1:
            case 2:
                return kt(r.a);
            default:
                return Tt;
        }
    }, Av = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lv = function(n) {
        return {
            $: 4,
            a: n
        };
    }, yv = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Fv = function(n) {
        return dc(A2(Ho, Nb, So(function(n) {
            return ml(Lv(A2(yv, n, 7)));
        }(n))));
    }, jv = F2(function(n, r) {
        return {
            be: n,
            fB: r
        };
    }), Pv = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            kg: t,
            bK: r,
            mm: n,
            c$: i,
            n5: e,
            oL: u,
            gn: a,
            hs: o,
            h2: c
        };
    }), Iv = function(n) {
        switch(n){
            case "Collection":
                return St(0);
            case "Season":
                return St(2);
            case "Episode":
                return St(3);
            default:
                return St(1);
        }
    }, Bv = function(n) {
        switch(n){
            case 0:
                return "Collection";
            case 1:
                return "Unitary";
            case 2:
                return "Season";
            default:
                return "Episode";
        }
    }, Mv = A2(Il, Bv, Iv), Ov = Po(A4(rc, "trashed", function(n) {
        return n.h2;
    }, no, A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "kind", function(n) {
        return n.c$;
    }, Mv, A4(Do, "parent", function(n) {
        return n.gn;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Pv))))))))))), qv = F2(function(n, r) {
        return {
            fz: r,
            sp: n
        };
    }), Dv = F8(function(n, r, t, e, u, a, i, o) {
        return {
            cJ: e,
            cO: u,
            mm: n,
            c$: i,
            qI: o,
            hf: a,
            sg: t,
            sp: r
        };
    }), xv = function(n) {
        switch(n){
            case "Collection":
                return St(0);
            case "Season":
                return St(2);
            case "Episode":
                return St(3);
            default:
                return St(1);
        }
    }, Rv = function(n) {
        switch(n){
            case 0:
                return "Collection";
            case 1:
                return "Unitary";
            case 2:
                return "Season";
            default:
                return "Episode";
        }
    }, Vv = A2(Il, Rv, xv), Ev = Po(A4(Do, "showId", function(n) {
        return n.qI;
    }, xi, A4(Do, "kind", function(n) {
        return n.c$;
    }, Vv, A4(Do, "sourceNodeId", function(n) {
        return n.hf;
    }, xi, A4(Do, "expireAt", function(n) {
        return n.cO;
    }, td, A4(rc, "download", function(n) {
        return n.cJ;
    }, no, A4(rc, "upload", function(n) {
        return n.sg;
    }, no, A4(rc, "user", function(n) {
        return n.sp;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Dv)))))))))), zv = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            iw: i,
            bz: e,
            kg: c,
            kP: o,
            k8: t,
            mm: n,
            n5: r,
            oL: u,
            oP: a
        };
    }), Uv = F3(function(n, r, t) {
        return {
            nq: t,
            oN: n,
            gj: r
        };
    }), Hv = Po(A4(Do, "logo", function(n) {
        return n.nq;
    }, xi, A4(rc, "organizationName", function(n) {
        return n.gj;
    }, xi, A4(rc, "organizationId", function(n) {
        return n.oN;
    }, xi, Io(Uv))))), Wv = Po(A4(Do, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "disableOrganizationEmails", function(n) {
        return n.kP;
    }, no, A4(rc, "admin", function(n) {
        return n.iw;
    }, no, A4(rc, "organizations", function(n) {
        return n.oP;
    }, oc(Hv), A4(Do, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "avatar", function(n) {
        return n.bz;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(zv))))))))))), Qv = Po(A4(rc, "invitation", function(n) {
        return n.fz;
    }, Ev, A4(rc, "user", function(n) {
        return n.sp;
    }, Wv, Io(qv)))), Zv = Po(A4(rc, "invitations", function(n) {
        return n.fB;
    }, oc(Qv), A4(rc, "node", function(n) {
        return n.be;
    }, Ov, Io(jv)))), Kv = function(n) {
        return dc(A2(Ho, Zv, So(function(n) {
            return ml(Lv(A2(yv, n, 0)));
        }(n))));
    }, Yv = function(n) {
        return bc(T([
            A2(Yi, Sv, Kv(n)),
            A2(Yi, Av, Fv(n))
        ]));
    }, Xv = {
        $: 1
    }, Jv = (cs = Jl, Nn(function(n) {
        n(wn(cs(Date.now())));
    })), Gv = fu, _v = A2(Gv, Ml(Xv), Jv), n$ = bc(g), r$ = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return g;
            var e = t.a, u = t.b, a = e.eA;
            if (a.$) {
                if (i(e.mm, n)) return A2(dt, e.mm, r);
                t = u;
            } else {
                var o = a.b, c = A3(r$, n, A2(dt, e.mm, r), o);
                if (c.b) return c;
                t = u;
            }
        }
    }), t$ = function(n) {
        var r = n.qr;
        return r.$ ? n : p(n, {
            oB: A3(qt, Is, n.oB, A3(r$, r.a, g, $(n.jJ, n.fB)))
        });
    }, e$ = F2(function(n, r) {
        return t$(p(r, {
            pM: !0,
            qr: kt(n)
        }));
    }), u$ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), a$ = function(n) {
        return A2(u$, n, !1);
    }, i$ = {
        cq: g,
        kN: Tt,
        lm: Tt,
        oP: Au,
        pw: Ri(function(n) {
            return p(n, {
                gt: "Search Audio Mapping by Organization, Name or Tracks",
                ss: ""
            });
        }),
        rv: Tt,
        rJ: a$("Organization")
    }, o$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, c$ = F6(function(n, r, t, e, u, a) {
        return {
            mm: n,
            mM: u,
            mO: a,
            n5: t,
            oL: r,
            r0: e
        };
    }), s$ = F3(function(n, r, t) {
        return {
            nc: n,
            r5: r,
            sv: t
        };
    }), f$ = {
        lA: Au,
        c$: 0,
        nO: "",
        ar: pi,
        N: !1,
        P: 400,
        ag: !1
    }, l$ = function(n) {
        switch(n){
            case "Stereo":
                return St(0);
            case "OneTrackStereo":
                return St(1);
            case "OneTrack5.1":
                return St(2);
            case "OneTrack7.1":
                return St(3);
            case "5.1SMPTE(L/R/C/LFE/SL/SR)":
                return St(4);
            case "5.1ISO(L/R/SL/SR/C/LFE)":
                return St(5);
            default:
                return wt(A2(ki, "Unknown output layout", f$));
        }
    }, m$ = function(n) {
        switch(n){
            case 0:
                return "Stereo";
            case 1:
                return "OneTrackStereo";
            case 2:
                return "OneTrack5.1";
            case 3:
                return "OneTrack7.1";
            case 4:
                return "5.1SMPTE(L/R/C/LFE/SL/SR)";
            default:
                return "5.1ISO(L/R/SL/SR/C/LFE)";
        }
    }, d$ = A2(Il, m$, l$), b$ = function(n) {
        switch(n){
            case "Original":
                return St(0);
            case "Dubbed":
                return St(1);
            case "AudioDescription":
                return St(2);
            case "International":
                return St(3);
            case "VoiceOnly":
                return St(4);
            case "Silence":
                return St(5);
            case "MusicAndEffects":
                return St(6);
            case "Custom1":
                return St(7);
            case "Custom2":
                return St(8);
            case "Custom3":
                return St(9);
            case "Custom4":
                return St(10);
            case "Custom5":
                return St(11);
            case "Custom6":
                return St(12);
            case "Custom7":
                return St(13);
            case "Custom8":
                return St(14);
            case "Custom9":
                return St(15);
            case "Custom10":
                return St(16);
            default:
                return wt(A2(ki, "Unknown output type version", f$));
        }
    }, p$ = function(n) {
        switch(n){
            case 0:
                return "Original";
            case 1:
                return "Dubbed";
            case 2:
                return "AudioDescription";
            case 3:
                return "International";
            case 4:
                return "VoiceOnly";
            case 5:
                return "Silence";
            case 6:
                return "MusicAndEffects";
            case 7:
                return "Custom1";
            case 8:
                return "Custom2";
            case 9:
                return "Custom3";
            case 10:
                return "Custom4";
            case 11:
                return "Custom5";
            case 12:
                return "Custom6";
            case 13:
                return "Custom7";
            case 14:
                return "Custom8";
            case 15:
                return "Custom9";
            default:
                return "Custom10";
        }
    }, v$ = A2(Il, p$, b$), $$ = function(n) {
        switch(n){
            case "ARA":
                return St(0);
            case "BUL":
                return St(1);
            case "CHI":
                return St(2);
            case "CZE":
                return St(3);
            case "KOR":
                return St(4);
            case "DAN":
                return St(5);
            case "DUT":
                return St(6);
            case "GRE":
                return St(9);
            case "HEB":
                return St(7);
            case "HIN":
                return St(8);
            case "NLD":
                return St(10);
            case "RUS":
                return St(11);
            case "SWE":
                return St(14);
            case "SLV":
                return St(12);
            case "SRP":
                return St(13);
            case "TAM":
                return St(15);
            case "THA":
                return St(16);
            case "FRA":
                return St(17);
            case "FRE_CA":
                return St(18);
            case "GER":
                return St(19);
            case "ITA":
                return St(20);
            case "POR":
                return St(21);
            case "ENG":
                return St(22);
            case "SPA":
                return St(23);
            case "JPN":
                return St(24);
            case "NOR":
                return St(25);
            case "UKR":
                return St(26);
            case "FIN":
                return St(27);
            case "ESP":
                return St(28);
            case "POR_BR":
                return St(29);
            case "RON":
                return St(30);
            case "HRV":
                return St(31);
            case "GLA":
                return St(32);
            case "HUN":
                return St(33);
            case "IND":
                return St(34);
            case "TUR":
                return St(35);
            case "POL":
                return St(36);
            case "INT":
                return St(37);
            case "NOTHING":
                return St(38);
            default:
                return wt("Not a version");
        }
    }, g$ = function(n) {
        switch(n){
            case 0:
                return "ARA";
            case 1:
                return "BUL";
            case 2:
                return "CHI";
            case 3:
                return "CZE";
            case 4:
                return "KOR";
            case 5:
                return "DAN";
            case 6:
                return "DUT";
            case 9:
                return "GRE";
            case 7:
                return "HEB";
            case 8:
                return "HIN";
            case 10:
                return "NLD";
            case 11:
                return "RUS";
            case 12:
                return "SLV";
            case 13:
                return "SRP";
            case 14:
                return "SWE";
            case 15:
                return "TAM";
            case 16:
                return "THA";
            case 17:
                return "FRA";
            case 18:
                return "FRE_CA";
            case 19:
                return "GER";
            case 20:
                return "ITA";
            case 21:
                return "POR";
            case 22:
                return "ENG";
            case 23:
                return "SPA";
            case 24:
                return "JPN";
            case 25:
                return "NOR";
            case 26:
                return "UKR";
            case 27:
                return "FIN";
            case 28:
                return "ESP";
            case 29:
                return "POR_BR";
            case 30:
                return "RON";
            case 31:
                return "HRV";
            case 32:
                return "GLA";
            case 33:
                return "HUN";
            case 34:
                return "IND";
            case 35:
                return "TUR";
            case 36:
                return "POL";
            case 37:
                return "INT";
            default:
                return "";
        }
    }, h$ = A2(Il, g$, $$), k$ = Po(A4(rc, "version", function(n) {
        return n.sv;
    }, qo(h$), A4(rc, "typeVersion", function(n) {
        return n.r5;
    }, v$, A4(rc, "layout", function(n) {
        return n.nc;
    }, d$, Io(s$))))), T$ = Po(A4(rc, "isExtraDefault", function(n) {
        return n.mO;
    }, no, A4(rc, "isDefault", function(n) {
        return n.mM;
    }, no, A4(rc, "tracks", function(n) {
        return n.r0;
    }, oc(k$), A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(c$)))))))), w$ = oc(T$), C$ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, N$ = Lo(C$({
        $: 0
    })), A$ = dc(A2(Ho, w$, So(N$))), S$ = function(n) {
        switch(n){
            case "CanalPlus":
                return St(0);
            case "CanalPlusPub":
                return St(1);
            case "Lagardere":
                return St(2);
            case "M6":
                return St(3);
            case "M6Pub":
                return St(4);
            case "M6PubDigital":
                return St(5);
            case "Salto":
                return St(6);
            case "FranceTV":
                return St(7);
            case "AmauryMediaPub":
                return St(8);
            case "Ligue1PlusPub":
                return St(9);
            case "MediawanPub":
                return St(10);
            case "MediawanLigue1PlusPub":
                return St(11);
            case "Tf1Pub":
                return St(12);
            case "RmcBfmPub":
                return St(13);
            case "RmcBfmPubTV":
                return St(14);
            case "Novo19":
                return St(15);
            case "GameOnePub":
                return St(16);
            case "ParamountPub":
                return St(17);
            case "BeinSportPub":
                return St(18);
            case "FTVPub":
                return St(19);
            case "ETF1":
                return St(20);
            default:
                return wt(A2(ki, "Unknown broadcaster", f$));
        }
    }, L$ = function(n) {
        switch(n){
            case 0:
                return "CanalPlus";
            case 1:
                return "CanalPlusPub";
            case 2:
                return "Lagardere";
            case 3:
                return "M6";
            case 4:
                return "M6Pub";
            case 5:
                return "M6PubDigital";
            case 6:
                return "Salto";
            case 7:
                return "FranceTV";
            case 8:
                return "AmauryMediaPub";
            case 9:
                return "Ligue1PlusPub";
            case 10:
                return "MediawanPub";
            case 11:
                return "MediawanLigue1PlusPub";
            case 12:
                return "Tf1Pub";
            case 13:
                return "RmcBfmPub";
            case 14:
                return "RmcBfmPubTV";
            case 15:
                return "Novo19";
            case 16:
                return "GameOnePub";
            case 17:
                return "ParamountPub";
            case 18:
                return "BeinSportPub";
            case 19:
                return "FTVPub";
            default:
                return "ETF1";
        }
    }, y$ = A2(Il, L$, S$), F$ = F2(function(n, r) {
        return {
            mm: n,
            mM: r
        };
    }), j$ = Po(A4(rc, "isDefault", function(n) {
        return n.mM;
    }, no, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(F$)))), P$ = Po(A4(Do, "metadataSchema", function(n) {
        return n.nR;
    }, xi, A4(rc, "autoDeleteShows", function(n) {
        return n.i9;
    }, no, A4(rc, "staticIp", function(n) {
        return n.dv;
    }, no, A4(rc, "needAccept", function(n) {
        return n.n9;
    }, no, A4(rc, "adNomalabDest", function(n) {
        return n.ir;
    }, no, A4(rc, "isAdvertiser", function(n) {
        return n.mK;
    }, no, A4(rc, "segmentationRules", function(n) {
        return n.$7;
    }, oc(xi), A4(rc, "extraFormats", function(n) {
        return n.e3;
    }, oc(j$), A4(rc, "subtitleFormats", function(n) {
        return n.dw;
    }, oc(xi), A4(rc, "formats", function(n) {
        return n.cX;
    }, oc(j$), A4(Do, "logo", function(n) {
        return n.nq;
    }, xi, A4(rc, "replication", function(n) {
        return n.pE;
    }, no, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iG;
    }, no, A4(rc, "manualDelivery", function(n) {
        return n.nJ;
    }, no, A4(Do, "broadcaster", function(n) {
        return n.jp;
    }, y$, A4(rc, "enableAutoReject", function(n) {
        return n.lb;
    }, no, A4(rc, "enableAutoAccept", function(n) {
        return n.la;
    }, no, A4(rc, "enableUploadSuccessEmail", function(n) {
        return n.le;
    }, no, A4(rc, "enableVideoReadyEmail", function(n) {
        return n.lf;
    }, no, A4(rc, "enableCreationEmail", function(n) {
        return n.lc;
    }, no, A4(Do, "downloadFileName", function(n) {
        return n.kX;
    }, xi, A4(Do, "destination", function(n) {
        return n.kM;
    }, xi, A4(rc, "qcMasterReportTemplate", function(n) {
        return n.pp;
    }, xi, A4(rc, "qcMasterTestPlan", function(n) {
        return n.pq;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(T) {
                                                                                            return function(w) {
                                                                                                return function(C) {
                                                                                                    return function(N) {
                                                                                                        return function(A) {
                                                                                                            return function(S) {
                                                                                                                return {
                                                                                                                    ir: w,
                                                                                                                    iG: b,
                                                                                                                    i9: A,
                                                                                                                    jp: m,
                                                                                                                    kg: r,
                                                                                                                    kM: a,
                                                                                                                    kX: i,
                                                                                                                    la: f,
                                                                                                                    lb: l,
                                                                                                                    lc: o,
                                                                                                                    le: s,
                                                                                                                    lf: c,
                                                                                                                    e3: h,
                                                                                                                    cX: $,
                                                                                                                    mm: n,
                                                                                                                    mK: T,
                                                                                                                    nq: v,
                                                                                                                    nJ: d,
                                                                                                                    nR: S,
                                                                                                                    n5: t,
                                                                                                                    n9: C,
                                                                                                                    pp: u,
                                                                                                                    pq: e,
                                                                                                                    pE: p,
                                                                                                                    $7: k,
                                                                                                                    dv: N,
                                                                                                                    dw: g
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))), I$ = oc(P$), B$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, M$ = Lo(B$({
        $: 1
    })), O$ = A2(Gb, Jo, A2(Gb, Ge(function(n) {
        return m(n.mm, n);
    }), dc(A2(Ho, I$, So(M$))))), q$ = A2(Yi, o$, _b(m(A$, O$))), D$ = m(i$, q$), x$ = F2(function(n, r) {
        return m(n, r);
    }), R$ = F2(function(n, r) {
        return function(t) {
            var e = d(Ri(function(n) {
                return p(n, {
                    m6: "Layout",
                    ss: m$(r.nc)
                });
            }), Ri(function(n) {
                return p(n, {
                    m6: "TypeVersion",
                    ss: p$(r.r5)
                });
            }), Ri(function(n) {
                var t;
                return p(n, {
                    m6: "Version",
                    ss: (t = r.sv, t.$ ? n.ss : g$(t.a))
                });
            }));
            return p(t, {
                mm: n,
                qk: e.a,
                ql: e.b,
                qm: e.c
            });
        }({
            mm: 0,
            qk: Ri(Ie),
            ql: Ri(Ie),
            qm: Ri(Ie)
        });
    }), V$ = function(n) {
        var r = function(n) {
            return A2(No, Fu(n), ju(""));
        };
        return {
            mM: ro(function(r) {
                return p(r, {
                    m6: "Set default",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.mM;
                    }, n))
                });
            }),
            mO: ro(function(r) {
                return p(r, {
                    m6: "Set extra default",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.mO;
                    }, n))
                });
            }),
            n5: Ri(function(t) {
                return p(t, {
                    m6: "Name",
                    ss: A2(r, function(n) {
                        return n.n5;
                    }, n)
                });
            }),
            oL: Ri(function(t) {
                return p(t, {
                    m6: "Organization",
                    ss: A2(r, function(n) {
                        return n.oL;
                    }, n)
                });
            }),
            oR: n,
            r0: n.$ ? Au : A2(_o, R$, Jo(A2(zt, x$, n.a.r0)))
        };
    }, E$ = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), z$ = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(z$, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), U$ = F2(function(n, r) {
        return A3(z$, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(wu, r, t, e) : e;
        }), Au, r);
    }), H$ = function(n) {
        return n.b ? kt(A3(qt, me, n.a, n.b)) : Tt;
    }, W$ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Q$ = Po(A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return {
            mm: n
        };
    }))), Z$ = F5(function(n, r, t, e, u) {
        return {
            mM: e,
            mO: u,
            n5: r,
            oL: n,
            r0: t
        };
    }), K$ = Po(A4(rc, "isExtraDefault", function(n) {
        return n.mO;
    }, no, A4(rc, "isDefault", function(n) {
        return n.mM;
    }, no, A4(rc, "tracks", function(n) {
        return n.r0;
    }, oc(k$), A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, Io(Z$))))))), Y$ = function(n) {
        return {
            lA: Au,
            c$: 0,
            nO: n,
            ar: pi,
            N: !1,
            P: 400,
            ag: !1
        };
    }, X$ = F2(function(n, r) {
        return r.$ ? wt(r.a) : St(n(r.a));
    }), J$ = F4(function(n, r, t, e) {
        if (1 === r.$) return wt(r.a);
        var u = r.a;
        if (1 === t.$) return wt(t.a);
        var a = t.a;
        return 1 === e.$ ? wt(e.a) : St(A3(n, u, a, e.a));
    }), G$ = F2(function(n, r) {
        return A2(du, function(r) {
            return i(r, n);
        }, r);
    }), _$ = function(n) {
        return A2(Ii, g, A3(Je, F2(function(n, r) {
            var t = m(n, r);
            return t.b.$ ? wt(t.b.a) : t.a.$ ? wt(t.a.a) : St(A2(dt, t.a.a, t.b.a));
        }), St(g), A2(Ge, function(n) {
            var r = n.b;
            return A4(J$, s$, l$(r.qk.ss), b$(r.ql.ss), A2(G$, r.ql.ss, T([
                "Original",
                "Dubbed",
                "AudioDescription"
            ])) && "" !== r.qm.ss ? A2(hi, Y$, A2(X$, kt, $$(r.qm.ss))) : St(Tt));
        }, pt(n))));
    }, ng = A2(bu, Uo, zo), rg = function(n) {
        return A2(wo, "POST", Ao(n));
    }, tg = function(n) {
        return Bo(n);
    }, eg = function(n) {
        return A2(ut, "application/json", A2(Pt, 0, n));
    }, ug = F2(function(n, r) {
        return p(r, {
            eh: n
        });
    }), ag = F2(function(n, r) {
        return ug(eg(A2(tg, n, r)));
    }), ig = function(n) {
        var r;
        return A2(Yi, W$, dc(A2(ng, Q$, A3(ag, K$, {
            mM: (r = n).mM.ss,
            mO: r.mO.ss,
            n5: r.n5.ss,
            oL: r.oL.ss,
            r0: _$(r.r0)
        }, rg(N$)))));
    }, og = function(n) {
        return {
            $: 11,
            a: n
        };
    }, cg = function(n) {
        return Lo(C$({
            $: 1,
            a: n
        }));
    }, sg = function(n) {
        return A2(wo, "DELETE", Ao(n));
    }, fg = Uo(Ml(St(0))), lg = function(n) {
        return {
            $: 9,
            a: n
        };
    }, mg = function(n) {
        return A2(wo, "PUT", Ao(n));
    }, dg = F2(function(n, r) {
        return dc(fg(A3(ag, K$, {
            mM: r.mM.ss,
            mO: r.mO.ss,
            n5: r.n5.ss,
            oL: r.oL.ss,
            r0: _$(r.r0)
        }, mg(cg(n.mm)))));
    }), bg = F2(function(n, r) {
        return A2(Yi, lg, A2(dg, n, r));
    }), pg = F2(function(n, r) {
        return p(n, {
            ss: r
        });
    }), vg = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pg, r, t = n.a);
            case 1:
                return p(e = A2(pg, r, t = n.a), {
                    lQ: !0
                });
            default:
                var t = n.a, e = p(r, {
                    lQ: !1,
                    fh: !0
                });
                return A2(pg, e, t);
        }
    }), $g = F2(function(n, r) {
        return p(n, {
            fh: !0,
            ss: r
        });
    }), gg = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2($g, r, t = n.a);
            case 1:
                return p(e = A2($g, r, t = n.a), {
                    lQ: !0
                });
            default:
                var t = n.a, e = p(r, {
                    lQ: !1,
                    fh: !0
                });
                return A2($g, e, t);
        }
    }), hg = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, {
                    qk: A2(gg, n.a, r.qk)
                });
            case 1:
                return p(r, {
                    ql: A2(gg, n.a, r.ql)
                });
            default:
                return p(r, {
                    qm: A2(gg, n.a, r.qm)
                });
        }
    }), kg = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(V$(kt(n.a)))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(V$(Tt))
                }));
            case 4:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 3:
                return A2(pc, g, p(r, {
                    lm: Tt,
                    rv: Tt
                }));
            case 5:
                var t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oL: A2(gg, t, n.oL)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: e
                }));
            case 6:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 7:
                var u = r.kN;
                return A2(pc, T(1 === u.$ ? [
                    n$
                ] : 1 === (m = (e = u.a).oR).$ ? [
                    ig(e)
                ] : [
                    A2(bg, m.a, e)
                ]), r);
            case 10:
                return A2(pc, T([
                    (l = n.a, A2(Yi, og, function(n) {
                        return dc(fg(sg(cg(n.mm))));
                    }(l)))
                ]), r);
            case 8:
                return (a = n.a).$ ? A2(pc, g, A2(E$, a.a, r)) : A2(pc, T([
                    q$
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Audio mapping created")
                }));
            case 9:
                return (a = n.a).$ ? A2(pc, g, A2(E$, a.a, r)) : A2(pc, T([
                    q$
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Audio mapping updated")
                }));
            case 11:
                return (a = n.a).$ ? A2(pc, g, A2(E$, a.a, r)) : A2(pc, T([
                    q$
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Audio mapping deleted")
                }));
            case 0:
                var a;
                if ((a = n.a).$) return A2(pc, g, A2(E$, a.a, r));
                var o = a.a;
                return A2(pc, g, p(r, {
                    cq: o.a,
                    oP: o.b
                }));
            case 12:
                t = n.a;
                var c = n.b;
                n: for(; !t.a.$;)return e = A2(Fu, function(n) {
                    return p(n, {
                        r0: A2(_o, F2(function(n, r) {
                            return i(n, c) ? A2(hg, t, r) : r;
                        }), n.r0)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
                return A2(pc, g, r);
            case 14:
                return c = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        r0: A2(U$, F2(function(n) {
                            return !i(n, c);
                        }), n.r0)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 13:
                var s = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.r0)));
                }, r.kN)), f = A2(R$, s + 1, A3(s$, 0, 5, Tt));
                return e = A2(Fu, function(n) {
                    return p(n, {
                        r0: A3(wu, s + 1, f, n.r0)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 16:
                return A2(pc, g, p(r, {
                    pw: A2(gg, t = n.a, r.pw)
                }));
            case 15:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 17:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        mM: A2(vg, t, n.mM)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            default:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        mO: A2(vg, t, n.mO)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
        }
        var l, m;
    }), Tg = {
        $: 1
    }, wg = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Cg = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, A2(lo, r.oL, n)));
    }), Ng = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ag = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Sg = Se("button"), Lg = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), yg = F2(function(n, r) {
        return A2(pr, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), $r(r));
    }), Fg = F2(function(n, r) {
        return A3(Lg, A2(yg, n, r), g, "");
    }), jg = Fg("class"), Pg = jg, Ig = mr, Bg = F2(function(n, r) {
        return A3(Lg, A2(Ig, n, r), g, "");
    }), Mg = F2(function(n, r) {
        return A2(Bg, n, {
            $: 0,
            a: r
        });
    }), Og = F2(function(n, r) {
        var t;
        return A2(Sg, T([
            (t = r, A2(Mg, "click", je(t))),
            Pg("IconButton")
        ]), T([
            n
        ]));
    }), qg = F2(function(n, r) {
        return A2(br, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), $r(r));
    }), Dg = F2(function(n, r) {
        return A3(Lg, A2(qg, n, r), g, "");
    }), xg = F2(function(n, r) {
        return A2(Dg, n, gi(r));
    }), Rg = xg("className"), Vg = F2(function(n, r) {
        return {
            u: n,
            jJ: r
        };
    }), Eg = function(n) {
        return {
            $: 3,
            a: zi(n)
        };
    }, zg = Fg("height"), Ug = Fg("points"), Hg = F4(function(n, r, t, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Wg = Hg, Qg = Wg("http://www.w3.org/2000/svg"), Zg = Qg("polygon"), Kg = Qg("svg"), Yg = Fg("viewBox"), Xg = Fg("width"), Jg = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconKo")
    ]), T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("4 5 6 3 13 11 11 13")
        ]), g),
        A2(Zg, T([
            Pg("Fg"),
            Ug("13 5 11 3 3 11 5 13")
        ]), g)
    ])), Gg = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconOk")
    ]), T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("2 8 7 13 15 5 13 3 7 9 4 6")
        ]), g)
    ])), _g = Ie, nh = F2(function(n, r) {
        return _g({
            n5: n,
            ds: Eg(function(n) {
                return r(n) ? "1" : "0";
            }),
            dM: function(n) {
                return A2(Vg, g, T([
                    r(n) ? Gg : Jg
                ]));
            }
        });
    }), rh = {
        $: 0
    }, th = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), eh = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: th(r)
        });
    }), uh = function(n) {
        var r = n.rV, t = n.rW, e = n.kt;
        return {
            jY: A2(Ge, function(n) {
                return n;
            }, n.jY),
            kt: e,
            rV: r,
            rW: t
        };
    }, ah = F3(function(n, r, t) {
        return {
            n5: n,
            ds: t,
            dM: r
        };
    }), ih = function(n) {
        return fi(si(n));
    }, oh = function(n) {
        return A2(Vg, g, T([
            ih(n)
        ]));
    }, ch = function(n) {
        var r = n.ds;
        return A3(ah, n.n5, A2(bu, oh, n.dM), r);
    }, sh = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), fh = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, lh = Oa(T([
        fh(160)
    ])), mh = Se("span"), dh = dr, bh = F2(function(n, r) {
        return A3(Lg, A2(dh, n, r), g, "");
    }), ph = bh, vh = function(n) {
        return A2(mh, T([
            A2(ph, "color", "#555")
        ]), T([
            ih($(lh, n))
        ]));
    }, $h = function(n) {
        return A2(mh, T([
            A2(ph, "color", "#ccc")
        ]), T([
            ih($(lh, n))
        ]));
    }, gh = Se("th"), hh = function(n) {
        var r = n.a, t = n.b, e = n.c, u = function() {
            switch(t.$){
                case 0:
                    return T([
                        ih(r)
                    ]);
                case 1:
                    var n = t.a;
                    return T([
                        ih(r),
                        n ? vh("\u2193") : $h("\u2193")
                    ]);
                default:
                    if (1 === t.a.$) return T([
                        ih(r),
                        $h("\u2195")
                    ]);
                    var e = t.a.a;
                    return T([
                        ih(r),
                        vh(e ? "\u2191" : "\u2193")
                    ]);
            }
        }();
        return A2(gh, T([
            e
        ]), u);
    }, kh = {
        jA: Tt,
        pR: function() {
            return g;
        },
        rA: g,
        rM: g,
        dC: Tt,
        dD: function(n) {
            return A2(Vg, g, A2(Ge, hh, n));
        }
    }, Th = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconDelete")
    ]), T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("4 5 6 3 13 11 11 13")
        ]), g),
        A2(Zg, T([
            Pg("Fg"),
            Ug("13 5 11 3 3 11 5 13")
        ]), g)
    ])), wh = function(n) {
        return A2(Mg, "click", je(n));
    }, Ch = xg("type"), Nh = F2(function(n, r) {
        return A2(Sg, T([
            Ch("button"),
            wh(r),
            Rg("ButtonMini")
        ]), T([
            ih(n)
        ]));
    }), Ah = T([
        Rg("Table")
    ]), Sh = function(n) {
        return A6(c$, n.mm, n.oL, n.n5, n.r0, n.mM, n.mO);
    }, Lh = function(n) {
        var r = n.r5;
        return m$(n.nc) + " " + p$(r);
    }, yh = uh({
        jY: T([
            A2(eh, "Edit", A2(bu, A2(bu, Nh("Edit"), Ng), Sh)),
            A2(sh, "Organization", function(n) {
                return n.gj;
            }),
            A2(sh, "Name", function(n) {
                return n.n5;
            }),
            A2(nh, "Default", function(n) {
                return n.mM || n.mO;
            }),
            A2(sh, "Tracks", A2(No, function(n) {
                return n.r0;
            }, A2(No, Ge(Lh), Bt(", ")))),
            A2(eh, "Delete", A2(bu, A2(bu, Og(Th), Ag), Sh))
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: Ah,
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: function(n) {
            return n.mm;
        },
        rW: function(n) {
            return {
                $: 15,
                a: n
            };
        }
    }), Fh = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jh = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ph = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ih = function(n) {
        return A2(xg, "autocomplete", n ? "on" : "off");
    }, Bh = F2(function(n, r) {
        return A2(Dg, n, _i(r));
    }), Mh = Bh("autofocus"), Oh = function(n) {
        return Rg(A2(Bt, " ", A2(Ge, $e, A2(Iu, Ko, n))));
    }, qh = F3(function(n, r, t) {
        return A2(n, r, T([
            ih(t)
        ]));
    }), Dh = qh(mh), xh = function(n) {
        return Cu(n) ? ih("") : A2(Le, T([
            Rg("InputErrors")
        ]), A2(Ge, Dh(T([
            Rg("InputError")
        ])), n));
    }, Rh = F2(function(n, r) {
        return A2(Le, T([
            Rg("InputWrapper"),
            Oh(T([
                m("InputHasError", Cu(n.ln))
            ]))
        ]), T([
            r,
            xh(n.ln)
        ]));
    }), Vh = Bh("disabled"), Eh = Se("input"), zh = xg("name"), Uh = F4(function(n, r, t, e) {
        return {
            ft: r,
            b_: n,
            os: t,
            rj: e
        };
    }), Hh = ct, Wh = function(n) {
        return A2(Hh, {
            jD: !1,
            n3: !1
        }, n);
    }, Qh = /.^/, Zh = lt(mt), Kh = function(n) {
        return "" !== n ? A3(Zh, A2(ju, Qh, Wh("[^a-z0-9]+")), function() {
            return "_";
        }, Hi(n)) : n;
    }, Yh = xg("id"), Xh = function(n) {
        return "" === n ? Oh(g) : Yh(n);
    }, Jh = F2(function(n, r) {
        return A3(Je, mu, r, n);
    }), Gh = A2(Jh, T([
        "target",
        "value"
    ]), Bi), _h = function(n) {
        return A2(Mg, "blur", A2(ye, n, Gh));
    }, nk = function(n) {
        return A2(Mg, "focus", A2(ye, n, Gh));
    }, rk = function(n) {
        return m(n, !0);
    }, tk = F2(function(n, r) {
        return A2(Bg, n, {
            $: 1,
            a: r
        });
    }), ek = function(n) {
        return A2(tk, "input", A2(ye, rk, A2(ye, n, Gh)));
    }, uk = xg("placeholder"), ak = xg("value"), ik = function(n) {
        return A2(Rh, n, A2(Eh, T([
            Rg("InputText"),
            Xh(n.kV),
            Ch("text"),
            ek(Fh),
            _h(jh),
            nk(Ph),
            ak(n.ss),
            uk(n.gt),
            zh(Kh(n.m6)),
            Vh(n.kQ),
            Ih(n.n6),
            n.d7 ? Mh(!0) : Oh(g)
        ]), g));
    }, ok = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), ck = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), sk = or, fk = hr, lk = F2(function(n, r) {
        var t = r.b, e = r.c;
        return A3(Lg, A2(fk, n, r.a), t, e);
    }), mk = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = r.c;
                return A3(Ae, r.a, A2(Ge, lk(n), t), A2(Ge, mk(n), e));
            case 1:
                return t = r.c, e = r.d, A4(Hg, r.a, r.b, A2(Ge, lk(n), t), A2(Ge, mk(n), e));
            case 2:
                return t = r.b, e = r.c, A3(ok, r.a, A2(Ge, lk(n), t), A2(Ge, function(r) {
                    return m(r.a, A2(mk, n, r.b));
                }, e));
            case 3:
                return t = r.c, e = r.d, A4(ck, r.a, r.b, A2(Ge, lk(n), t), A2(Ge, function(r) {
                    return m(r.a, A2(mk, n, r.b));
                }, e));
            default:
                return fi(A2(sk, n, r.a));
        }
    }), dk = mk, bk = Se("caption"), pk = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return t;
            case 1:
                return (e = r.a)(t);
            case 2:
                return Kt((e = r.a)(t));
            case 3:
                var e = r.a;
                return n ? Kt(e(t)) : e(t);
            default:
                return e = r.a, n ? e(t) : Kt(e(t));
        }
    }), vk = F2(function(n, r) {
        for(;;){
            if (!r.b) return Tt;
            var t = r.a.ds, e = r.b;
            if (i(r.a.n5, n)) return kt(t);
            r = e;
        }
    }), $k = F3(function(n, r, t) {
        var e = n.b, u = A2(vk, n.a, r);
        return 1 === u.$ ? t : A3(pk, e, u.a, t);
    }), gk = F3(function(n, r, t) {
        return A3($k, r, n.jY, t);
    }), hk = ok, kk = hk, Tk = Se("table"), wk = Se("tfoot"), Ck = Se("thead"), Nk = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ak = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sk = {
        $: 0
    }, Lk = F3(function(n, r, t) {
        return A2(Mg, "click", A2(ye, t, A3(Fe, u$, je(n), je(r))));
    }), yk = F3(function(n, r, t) {
        var e = n.a, u = n.b, a = t.n5;
        switch(t.ds.$){
            case 0:
                return d(a, Sk, A3(Lk, e, u, r));
            case 1:
                return d(a, Ak(!i(a, e)), A3(Lk, a, !1, r));
            case 2:
                return d(a, Ak(i(a, e)), A3(Lk, a, !1, r));
            case 3:
                return i(a, e) ? d(a, Nk(kt(!u)), A3(Lk, a, !u, r)) : d(a, Nk(Tt), A3(Lk, a, !1, r));
            default:
                return i(a, e) ? d(a, Nk(kt(u)), A3(Lk, a, !u, r)) : d(a, Nk(Tt), A3(Lk, a, !1, r));
        }
    }), Fk = Se("tr"), jk = lr, Pk = F2(function(n, r) {
        var t = n.b, e = n.c;
        return Cu(t) ? r : A3(wu, e, t, r);
    }), Ik = function(n) {
        return n.a;
    }, Bk = function(n) {
        return ir(vr(n));
    }, Mk = F2(function(n, r) {
        return A2(ar, n, vr(r));
    }), Ok = function(n) {
        return er(vr(n));
    }, qk = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.a, a = r.b;
        switch(e.$){
            case 4:
                return m(A2(dt, m(t, l = e.a), u), a);
            case 0:
                var i = e.a, o = e.c, c = A3(qt, Dk, m(g, A3(qt, Pk, a, v = e.b)), o), s = c.a, f = c.b, l = A3(oi, i, A2(Ge, Ik, v), Kt(s));
                return m(A2(dt, m(t, l), u), f);
            case 1:
                var d = e.a, b = (i = e.b, o = e.d, A3(qt, Dk, m(g, A3(qt, Pk, a, v = e.c)), o));
                return s = b.a, f = b.b, l = A4(Ok, d, i, A2(Ge, Ik, v), Kt(s)), m(A2(dt, m(t, l), u), f);
            case 2:
                i = e.a, o = e.c;
                var p = A3(qt, qk, m(g, A3(qt, Pk, a, v = e.b)), o);
                return s = p.a, f = p.b, l = A3(Bk, i, A2(Ge, Ik, v), Kt(s)), m(A2(dt, m(t, l), u), f);
            default:
                d = e.a, i = e.b, o = e.d;
                var v, $ = A3(qt, qk, m(g, A3(qt, Pk, a, v = e.c)), o);
                return s = $.a, f = $.b, l = A4(Mk, d, i, A2(Ge, Ik, v), Kt(s)), m(A2(dt, m(t, l), u), f);
        }
    }), Dk = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return m(A2(dt, s = n.a, t), e);
            case 0:
                var u = n.a, a = n.c, i = A3(qt, Dk, m(g, A3(qt, Pk, e, b = n.b)), a), o = i.a, c = i.b, s = A3(oi, u, A2(Ge, Ik, b), Kt(o));
                return m(A2(dt, s, t), c);
            case 1:
                var f = n.a, l = (u = n.b, a = n.d, A3(qt, Dk, m(g, A3(qt, Pk, e, b = n.c)), a));
                return o = l.a, c = l.b, s = A4(Ok, f, u, A2(Ge, Ik, b), Kt(o)), m(A2(dt, s, t), c);
            case 2:
                u = n.a, a = n.c;
                var d = A3(qt, qk, m(g, A3(qt, Pk, e, b = n.b)), a);
                return o = d.a, c = d.b, s = A3(Bk, u, A2(Ge, Ik, b), Kt(o)), m(A2(dt, s, t), c);
            default:
                f = n.a, u = n.b, a = n.d;
                var b, p = A3(qt, qk, m(g, A3(qt, Pk, e, b = n.c)), a);
                return o = p.a, c = p.b, s = A4(Mk, f, u, A2(Ge, Ik, b), Kt(o)), m(A2(dt, s, t), c);
        }
    }), xk = F2(function(n, r) {
        return A5($u, 1, n, r, gu, gu);
    }), Rk = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.a, e = t.b, u = t.c, a = r.b;
            Ve(u) || (n = kt(m(u, e))), r = a;
        }
    }), Vk = function(n) {
        var r = A2(Rk, Tt, n);
        if (1 === r.$) return Au;
        var t = r.a;
        return A2(xk, t.a, t.b);
    }, Ek = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zk = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Uk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hk = F2(function(n, r) {
        return T([
            Uk(A3(zk, A3(ta, r, g, Tt), g, n))
        ]);
    }), Wk = function(n) {
        return A2(Hk, n.b, va(T([
            Ek(n.a)
        ])));
    }, Qk = function(n) {
        return A3(oi, "style", g, Ua(si(ii(Ua(ci(A2(Ge, Wk, pt(n))))))));
    }, Zk = F3(function(n, r, t) {
        var e = A2(Ge, Ik, r), u = Vk(r), a = A3(qt, Dk, m(g, u), t), i = a.a, o = Qk(a.b);
        return A3(oi, n, e, A2(dt, o, Kt(i)));
    }), Kk = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (i(n, r.a.a)) return !0;
            r = t;
        }
    }), Yk = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(Kk, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), Xk = F2(function(n, r) {
        return m(A2(Yk, "_", r), Qk(n));
    }), Jk = F3(function(n, r, t) {
        var e = A2(Ge, Ik, r), u = Vk(r), a = A3(qt, qk, m(g, u), t), i = a.a;
        return A3(Bk, n, e, A2(dt, A2(Xk, a.b, i), Kt(i)));
    }), Gk = F4(function(n, r, t, e) {
        var u = A2(Ge, Ik, t), a = Vk(t), i = A3(qt, qk, m(g, a), e), o = i.a;
        return A4(Mk, n, r, u, A2(dt, A2(Xk, i.b, o), Kt(o)));
    }), _k = F4(function(n, r, t, e) {
        var u = A2(Ge, Ik, t), a = Vk(t), i = A3(qt, Dk, m(g, a), e), o = i.a, c = Qk(i.b);
        return A4(Ok, n, r, u, A2(dt, c, Kt(o)));
    }), nT = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A3(Zk, n.a, n.b, n.c);
            case 1:
                return A4(_k, n.a, n.b, n.c, n.d);
            case 2:
                return A3(Jk, n.a, n.b, n.c);
            default:
                return A4(Gk, n.a, n.b, n.c, n.d);
        }
    }, rT = F4(function(n, r, t, e) {
        return nT(A3(n, r, t, e));
    }), tT = F4(function(n, r, t, e) {
        return fi(A5(jk, rT, n, r, t, e));
    }), eT = tT, uT = Se("td"), aT = F2(function(n, r) {
        var t = (0, r.dM)(n);
        return A2(uT, t.u, t.jJ);
    }), iT = F3(function(n, r, t) {
        return A2(Fk, r(t), A2(Ge, aT(t), n));
    }), oT = F4(function(n, r, t, e) {
        return m(n(e), A4(eT, iT, r, t, e));
    }), cT = F3(function(n, r, t) {
        var e, u, a = n.rV, i = n.jY, o = n.kt, c = o.dD(A2(Ge, A2(yk, r, n.rW), i)), s = A2(Ck, c.u, T([
            A2(Fk, g, c.jJ)
        ])), f = A3(gk, n, r, t), l = A3(kk, "tbody", o.rM, A2(Ge, A3(oT, a, i, o.pR), f)), m = 1 === (e = o.dC).$ ? A2(dt, l, g) : A2(dt, A2(wk, e.a.u, e.a.jJ), A2(dt, l, g));
        return A2(Tk, o.rA, 1 === (u = o.jA).$ ? A2(dt, s, m) : A2(dt, A2(bk, u.a.u, u.a.jJ), A2(dt, s, m)));
    }), sT = {
        $: 3
    }, fT = function(n) {
        return A2(Le, T([
            Rg("BannerInvalid")
        ]), T([
            Jg,
            A2(Dh, T([
                Rg("BannerContent")
            ]), n)
        ]));
    }, lT = function(n) {
        return A2(Le, T([
            Rg("BannerValid")
        ]), T([
            Gg,
            A2(Dh, T([
                Rg("BannerContent")
            ]), n)
        ]));
    }, mT = function(n) {
        var r = n.lm;
        if (r.$) {
            var t = n.rv;
            if (t.$) return ih("");
            var e = t.a;
            return A2(Le, T([
                wh(sT)
            ]), T([
                lT(e)
            ]));
        }
        var u = r.a;
        return A2(Le, T([
            wh(sT)
        ]), T([
            fT(u)
        ]));
    }, dT = {
        $: 4
    }, bT = function(n) {
        return {
            $: 17,
            a: n
        };
    }, pT = function(n) {
        return {
            $: 18,
            a: n
        };
    }, vT = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $T = function(n) {
        return {
            $: 5,
            a: n
        };
    }, gT = {
        $: 13
    }, hT = {
        $: 7
    }, kT = ih(""), TT = ju(kT), wT = function(n) {
        return A2(No, Fu(n), TT);
    }, CT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NT = Bh("checked"), AT = A2(Jh, T([
        "target",
        "checked"
    ]), Ne), ST = function(n) {
        return A2(Mg, "change", A2(ye, n, AT));
    }, LT = function(n) {
        var r;
        return A2(Rh, n, A2(Eh, T([
            Rg("InputCheckbox"),
            (r = n.mm, "" === r ? Oh(g) : Yh(r)),
            Ch("checkbox"),
            ST(CT),
            NT(n.ss),
            Vh(n.kQ)
        ]), g));
    }, yT = Se("label"), FT = yT, jT = F2(function(n, r) {
        return "" === n.m6 ? r : A2(FT, T([
            Rg("InputLabel")
        ]), T([
            A2(Le, T([
                Rg("InputLabelText")
            ]), T([
                ih(n.m6),
                n.mQ ? ih("") : A2(Dh, T([
                    Rg("InputMandatory")
                ]), "*")
            ])),
            r
        ]));
    }), PT = function(n) {
        return A2(jT, n, LT(n));
    }, IT = function(n) {
        return A2(jT, n, ik(n));
    }, BT = Qg("g"), MT = A2(Kg, T([
        zg("20px"),
        Xg("20px"),
        Yg("0 0 20 20"),
        Pg("IconChoice")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(Zg, T([
                Ug("10 4 7 8 13 8")
            ]), g),
            A2(Zg, T([
                Ug("10 16 7 12 13 12")
            ]), g)
        ]))
    ])), OT = F2(function(n, r) {
        return A2(ju, "", Va(A2(Ge, Ko, A2(Iu, function(r) {
            return i(r.a, n);
        }, r))));
    }), qT = Se("option"), DT = Se("select"), xT = Bh("selected"), RT = F2(function(n, r) {
        var t = A2(qT, T([
            ak(""),
            xT("" === n.ss)
        ]), T([
            ih(n.gt)
        ]));
        return A2(DT, T([
            Rg("InputSelectSelect"),
            ek(Fh),
            uk(n.gt),
            Vh(n.kQ)
        ]), A2(dt, t, A2(Ge, function(r) {
            var t = r.a, e = r.b;
            return A2(qT, T([
                ak(t),
                xT(i(t, n.ss))
            ]), T([
                ih(e)
            ]));
        }, r)));
    }), VT = F2(function(n, r) {
        return A2(Le, T([
            Rg("InputWrapper"),
            Oh(T([
                m("InputWrapperDisabled", n.kQ),
                m("InputHasError", Cu(n.ln))
            ]))
        ]), T([
            A2(Le, T([
                Rg("InputSelect"),
                Oh(T([
                    m("InputSelectEmpty", "" === n.ss)
                ]))
            ]), T([
                A2(Le, T([
                    Rg("InputSelectChoice")
                ]), T([
                    MT
                ])),
                A2(Dh, T([
                    Rg("InputSelectValue")
                ]), "" === n.ss || Cu(r) ? n.gt : A2(OT, n.ss, r)),
                A2(RT, n, r)
            ])),
            xh(n.ln)
        ]));
    }), ET = F2(function(n, r) {
        return A2(jT, n, A2(VT, n, r));
    }), zT = Se("form"), UT = function(n) {
        return m(n, !0);
    }, HT = F2(function(n, r) {
        return A2(Bg, n, {
            $: 2,
            a: r
        });
    }), WT = function(n) {
        return A2(HT, "submit", A2(ye, UT, je(n)));
    }, QT = function(n) {
        return A2(Sg, T([
            Ch("submit"),
            Rg("Button")
        ]), T([
            ih(n)
        ]));
    }, ZT = F4(function(n, r, t, e) {
        var u = r.a, a = r.b, i = t.a, o = t.b;
        return A2(Le, T([
            Rg("ModalWrapper")
        ]), T([
            A2(Le, T([
                Rg("ModalTitle")
            ]), T([
                ih(n),
                A2(Nh, i, o)
            ])),
            A2(zT, T([
                WT(a),
                Rg("ModalForm")
            ]), T([
                A2(Le, T([
                    Rg("ModalContent")
                ]), e),
                A2(Le, T([
                    Rg("ModalSubmit")
                ]), T([
                    A2(Nh, i, o),
                    QT(u)
                ]))
            ]))
        ]));
    }), KT = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), YT = function(n) {
        switch(n){
            case 0:
                return Oi({
                    bN: "Arabic",
                    bT: "Arabe"
                });
            case 1:
                return Oi({
                    bN: "Bulgarian",
                    bT: "Bulgare"
                });
            case 2:
                return Oi({
                    bN: "Chinese",
                    bT: "Chinois"
                });
            case 3:
                return Oi({
                    bN: "Czech",
                    bT: "Tch\xe8que"
                });
            case 4:
                return Oi({
                    bN: "Korean",
                    bT: "Cor\xe9en"
                });
            case 5:
                return Oi({
                    bN: "Danish",
                    bT: "Danois"
                });
            case 6:
                return Oi({
                    bN: "Flemish",
                    bT: "Flamand"
                });
            case 9:
                return Oi({
                    bN: "Greek",
                    bT: "Grec"
                });
            case 7:
                return Oi({
                    bN: "Hebrew",
                    bT: "H\xe9breu"
                });
            case 8:
                return Oi({
                    bN: "Hindi",
                    bT: "Hindi"
                });
            case 10:
                return Oi({
                    bN: "Dutch",
                    bT: "N\xe9erlandais"
                });
            case 11:
                return Oi({
                    bN: "Russian",
                    bT: "Russe"
                });
            case 14:
                return Oi({
                    bN: "Swedish",
                    bT: "Su\xe9dois"
                });
            case 12:
                return Oi({
                    bN: "Slovenian",
                    bT: "Slov\xe8ne"
                });
            case 13:
                return Oi({
                    bN: "Serbian",
                    bT: "Serbe"
                });
            case 15:
                return Oi({
                    bN: "Tamil",
                    bT: "Tamoul"
                });
            case 16:
                return Oi({
                    bN: "Thai",
                    bT: "Tha\xef"
                });
            case 17:
                return Oi({
                    bN: "French",
                    bT: " Fran\xe7ais"
                });
            case 18:
                return Oi({
                    bN: "Canadian french",
                    bT: "Fran\xe7ais canadien"
                });
            case 19:
                return Oi({
                    bN: "German",
                    bT: "Allemand"
                });
            case 20:
                return Oi({
                    bN: "Italian",
                    bT: "Italien"
                });
            case 21:
                return Oi({
                    bN: "Portuguese",
                    bT: "Portugais"
                });
            case 22:
                return Oi({
                    bN: " English",
                    bT: "Anglais"
                });
            case 23:
                return Oi({
                    bN: "Spanish",
                    bT: "Espagnol"
                });
            case 24:
                return Oi({
                    bN: "Japanese",
                    bT: "Japonais"
                });
            case 25:
                return Oi({
                    bN: "Norwegian",
                    bT: "Norv\xe9gien"
                });
            case 26:
                return Oi({
                    bN: "Ukrainian",
                    bT: "Ukrainien"
                });
            case 27:
                return Oi({
                    bN: "Finnish",
                    bT: "Finnois"
                });
            case 28:
                return Oi({
                    bN: "Castilian Spanish",
                    bT: "Espagnol castillan"
                });
            case 29:
                return Oi({
                    bN: "Brazilian portuguese",
                    bT: "Portugais br\xe9silien"
                });
            case 30:
                return Oi({
                    bN: "Romanian",
                    bT: "Roumain"
                });
            case 31:
                return Oi({
                    bN: "Croatian",
                    bT: "Croate"
                });
            case 32:
                return Oi({
                    bN: "Scottish Gaelic",
                    bT: "Ga\xe9lique \xe9cossais"
                });
            case 33:
                return Oi({
                    bN: "Hungarian",
                    bT: "Hongrois"
                });
            case 34:
                return Oi({
                    bN: "Indonesian",
                    bT: "Indon\xe9sien"
                });
            case 35:
                return Oi({
                    bN: "Turkish",
                    bT: "Turc"
                });
            case 36:
                return Oi({
                    bN: "Polish",
                    bT: "Polonais"
                });
            case 37:
                return Oi({
                    bN: " International",
                    bT: " International"
                });
            default:
                return Oi({
                    bN: "",
                    bT: ""
                });
        }
    }, XT = A2(zi, Ko, T([
        m(g$(0), YT(0)),
        m(g$(1), YT(1)),
        m(g$(2), YT(2)),
        m(g$(3), YT(3)),
        m(g$(4), YT(4)),
        m(g$(5), YT(5)),
        m(g$(6), YT(6)),
        m(g$(7), YT(7)),
        m(g$(8), YT(8)),
        m(g$(9), YT(9)),
        m(g$(10), YT(10)),
        m(g$(11), YT(11)),
        m(g$(12), YT(12)),
        m(g$(13), YT(13)),
        m(g$(14), YT(14)),
        m(g$(15), YT(15)),
        m(g$(16), YT(16)),
        m(g$(17), YT(17)),
        m(g$(18), YT(18)),
        m(g$(19), YT(19)),
        m(g$(20), YT(20)),
        m(g$(21), YT(21)),
        m(g$(22), YT(22)),
        m(g$(23), YT(23)),
        m(g$(24), YT(24)),
        m(g$(25), YT(25)),
        m(g$(26), YT(26)),
        m(g$(27), YT(27)),
        m(g$(28), YT(28)),
        m(g$(29), YT(29)),
        m(g$(30), YT(30)),
        m(g$(31), YT(31)),
        m(g$(32), YT(32)),
        m(g$(33), YT(33)),
        m(g$(34), YT(34)),
        m(g$(35), YT(35)),
        m(g$(36), YT(36)),
        m(g$(38), YT(38))
    ])), JT = F3(function(n, r, t) {
        return A2(Sg, $(T([
            Ch("button"),
            wh(t),
            Rg("ButtonMini")
        ]), A2(Ge, function(n) {
            return A2(ph, n.a, n.b);
        }, r)), T([
            ih(n)
        ]));
    }), GT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _T = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nw = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rw = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("Select2Container")
        ]), T([
            A2(dk, GT, A2(ET, n.qk, r)),
            A2(dk, _T, A2(ET, n.ql, t)),
            A2(G$, n.ql.ss, T([
                "Original",
                "Dubbed",
                "AudioDescription"
            ])) ? A2(dk, nw, A2(ET, n.qm, e)) : ih("")
        ]));
    }), tw = function(n) {
        return A2(wT, function(r) {
            var t = A2(dt, m("", ""), A2(zi, A2(bu, Hi, Ko), A2(Ge, function(n) {
                return m(n.a, n.b.n5);
            }, pt(n.oP)))), e = function(n) {
                return 1 !== n.oR.$;
            }(r) ? m("Save", "Edit AudioMapping") : m("Create", "New AudioMapping");
            return A4(ZT, e.b, m(e.a, hT), m("Close", dT), $(T([
                mT(n),
                A2(dk, $T, A2(ET, r.oL, t)),
                A2(dk, bT, PT(r.mM)),
                A2(dk, pT, PT(r.mO)),
                A2(dk, vT, IT(r.n5))
            ]), $(function(n) {
                var r = XT, t = T([
                    m(p$(0), p$(0)),
                    m(p$(1), p$(1)),
                    m(p$(2), p$(2)),
                    m(p$(3), p$(3)),
                    m(p$(4), p$(4)),
                    m(p$(6), p$(6)),
                    m(p$(5), p$(5)),
                    m(p$(7), p$(7)),
                    m(p$(8), p$(8)),
                    m(p$(9), p$(9)),
                    m(p$(10), p$(10)),
                    m(p$(11), p$(11)),
                    m(p$(12), p$(12)),
                    m(p$(13), p$(13)),
                    m(p$(14), p$(14)),
                    m(p$(15), p$(15)),
                    m(p$(16), p$(16)),
                    m("", "")
                ]), e = T([
                    m(m$(0), m$(0)),
                    m(m$(1), m$(1)),
                    m(m$(2), m$(2)),
                    m(m$(3), m$(3)),
                    m(m$(4), m$(4)),
                    m(m$(5), m$(5))
                ]);
                return A2(Ge, Ko, pt(A2(_o, F2(function(n, u) {
                    var a;
                    return A2(Le, T([
                        A2(ph, "position", "relative"),
                        A2(ph, "margin", "25px 0")
                    ]), T([
                        A2(dk, function(r) {
                            return A2(KT, r, n);
                        }, A4(rw, u, e, t, r)),
                        A3(JT, "remove", T([
                            m("position", "absolute"),
                            m("right", "0")
                        ]), (a = n, {
                            $: 14,
                            a: a
                        }))
                    ]));
                }), n.r0)));
            }(r), T([
                A2(Nh, "Add New Track", gT)
            ]))));
        }, n.kN);
    }, ew = F7(function(n, r, t, e, u, a, i) {
        return {
            mm: n,
            mM: a,
            mO: i,
            n5: e,
            oL: r,
            gj: t,
            r0: u
        };
    }), uw = F2(function(n, r) {
        return A7(ew, r.mm, r.oL, n, r.n5, r.r0, r.mM, r.mO);
    }), aw = Se("a"), iw = Fg("d"), ow = Qg("path"), cw = A2(Kg, T([
        zg("20px"),
        Xg("20px"),
        Yg("29 30 20 20"),
        Pg("IconBack")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M29.8248086,42.1420204 L40.1751914,49.0422759 C40.6277051,49.3439517 41,49.1402383 41,48.5827792 L41,46.6015165 C41,46.0355006 40.6434763,45.3247546 40.2036819,44.9949089 L35.6666667,41.592148 L48.0081969,41.592148 C48.5446944,41.592148 49,41.1402382 49,40.5827791 L49,38.6015169 C49,38.0355012 48.5559546,37.592148 48.0081969,37.592148 L35.6666669,37.592148 L40.2036819,34.1893866 C40.6354685,33.8655467 41,33.1402382 41,32.5827791 L41,30.6015169 C41,30.0355012 40.6307206,29.8383343 40.1751914,30.1420204 L29.8248086,37.0422756 C29.3725854,37.3437578 29.000478,39.0431593 29.0000005,39.6004433 C29,40.1487948 29.3692794,41.8383343 29.8248086,42.1420204 Z")
            ]), g)
        ]))
    ])), sw = function(n) {
        return A2(xg, "href", n);
    }, fw = function(n) {
        return Le(A2(dt, A2(ph, "display", "flex"), A2(dt, A2(ph, "flex-direction", "row"), n)));
    }, lw = A2(Kg, T([
        zg("27px"),
        Xg("27px"),
        Yg("0 0 27 27"),
        Pg("IconSettings")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M13.5,18.1264335 L11.8004065,19 L10.913745,17.2428633 L9.05040653,16.8991869 L9.31535158,14.9296466 L8,13.5 L9.31535158,12.0703534 L9.05040653,10.1008131 L10.913745,9.75713667 L11.8004065,8 L13.5,8.87356649 L15.1995935,8 L16.086255,9.75713667 L17.9495935,10.1008131 L17.6846484,12.0703534 L19,13.5 L17.6846484,14.9296466 L17.9495935,16.8991869 L16.086255,17.2428633 L15.1995935,19 L13.5,18.1264335 Z M13.5,16 C14.8807119,16 16,14.8807119 16,13.5 C16,12.1192881 14.8807119,11 13.5,11 C12.1192881,11 11,12.1192881 11,13.5 C11,14.8807119 12.1192881,16 13.5,16 Z")
            ]), g)
        ]))
    ])), mw = Se("h3"), dw = F2(function(n, r) {
        return A2(n, g, T([
            ih(r)
        ]));
    }), bw = dw(mw), pw = Se("h1"), vw = dw(pw), $w = function(n) {
        return A2(Le, T([
            Rg("LayoutAppBarWrapper")
        ]), T([
            A2(wT, function(n) {
                return A2(aw, T([
                    Rg("LayoutHomeButton"),
                    sw(n)
                ]), T([
                    cw
                ]));
            }, n.fo),
            A2(wT, function(n) {
                return A2(aw, T([
                    Rg("LayoutBackButton"),
                    sw(n)
                ]), T([
                    cw
                ]));
            }, n.d8),
            A2(Le, T([
                Rg("LayoutAppBar")
            ]), T([
                A2(Le, T([
                    Rg("LayoutAppBarTitle")
                ]), T([
                    bw(A2(ju, "\xa0", n.mm)),
                    A2(fw, g, T([
                        vw(n.rS)
                    ])),
                    bw("\xa0")
                ])),
                A2(Le, T([
                    Rg("LayoutAppBarActions")
                ]), T([
                    A2(ju, ih(""), n.dU)
                ]))
            ])),
            A2(wT, function(n) {
                return A2(aw, T([
                    Rg("LayoutFwdButton"),
                    sw(n)
                ]), T([
                    lw
                ]));
            }, n.fa)
        ]));
    }, gw = {
        dU: Tt,
        d8: Tt,
        fa: Tt,
        fo: Tt,
        mm: Tt,
        rS: ""
    }, hw = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("LayoutPageWrapper")
        ]), T([
            $w(p(gw, {
                dU: r,
                rS: n
            })),
            A2(Le, T([
                Rg("LayoutPageContent")
            ]), T([
                A2(aw, T([
                    sw("#"),
                    Yh("LayoutPageTop")
                ]), T([
                    ih(" ")
                ])),
                t
            ]))
        ]));
    }), kw = F2(function(n, r) {
        var t = Hi(r.pw.ss), e = A2(Iu, function(n) {
            return A2(bu, A2(bu, Oe(t), Hi), function(n) {
                return n.gj;
            })(n) || A2(bu, A2(bu, Oe(t), Hi), function(n) {
                return n.n5;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Oe(t), Hi), Bt("/")), Ge(Lh)), function(n) {
                return n.r0;
            })(n);
        }, A2(Ge, function(n) {
            return A2(uw, A2(Cg, r.oP, n), n);
        }, r.cq));
        return A3(hw, "Audio Mappings", kt(A2(Nh, "New\u2026", Tg)), A2(Le, g, T([
            A2(dk, wg, ik(r.pw)),
            mT(r),
            tw(r),
            A3(cT, yh, r.rJ, e)
        ])));
    }), Tw = {
        l: function(n) {
            return n.cq;
        },
        m: D$,
        o: F2(function(n, r) {
            return p(n, {
                cq: r
            });
        }),
        p: function(n) {
            return {
                $: 7,
                a: n
            };
        },
        q: kg,
        r: kw
    }, ww = {
        cz: g,
        kN: Tt,
        lm: Tt,
        oP: Au,
        rv: Tt
    }, Cw = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Nw = F3(function(n, r, t) {
        return {
            mm: n,
            oL: r,
            ss: t
        };
    }), Aw = Po(A4(rc, "value", function(n) {
        return n.ss;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Nw))))), Sw = oc(Aw), Lw = function(n) {
        return {
            $: 7,
            a: n
        };
    }, yw = ml(Lw({
        $: 0
    })), Fw = dc(A2(Ho, Sw, So(yw))), jw = A2(Gb, Jo, A2(Gb, Ge(function(n) {
        return m(n.mm, n);
    }), dc(A2(Ho, I$, So(M$))))), Pw = A2(Yi, Cw, _b(m(Fw, jw))), Iw = m(ww, Pw), Bw = function(n) {
        return {
            n5: Ri(function(r) {
                return p(r, {
                    m6: "Name",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.ss;
                    }, n))
                });
            }),
            oL: Ri(function(r) {
                return p(r, {
                    m6: "Organization",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.oL;
                    }, n))
                });
            }),
            oR: n
        };
    }, Mw = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), Ow = function(n) {
        return {
            $: 7,
            a: n
        };
    }, qw = F2(function(n, r) {
        return {
            oL: n,
            ss: r
        };
    }), Dw = Po(A4(rc, "value", function(n) {
        return n.ss;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, Io(qw)))), xw = function(n) {
        var r;
        return A2(Yi, Ow, dc(A2(ng, Aw, A3(ag, Dw, {
            oL: (r = n).oL.ss,
            ss: r.n5.ss
        }, rg(yw)))));
    }, Rw = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Vw = function(n) {
        return ml(Lw({
            $: 1,
            a: n
        }));
    }, Ew = function(n) {
        return {
            $: 8,
            a: n
        };
    }, zw = F2(function(n, r) {
        return dc(A2(Ho, Aw, A3(ag, Dw, {
            oL: r.oL.ss,
            ss: r.n5.ss
        }, mg(Vw(n.mm)))));
    }), Uw = F2(function(n, r) {
        return A2(Yi, Ew, A2(zw, n, r));
    }), Hw = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(Bw(kt(n.a)))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(Bw(Tt))
                }));
            case 3:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 4:
                var t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oL: A2(gg, t, n.oL)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: e
                }));
            case 5:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 6:
                var u = r.kN;
                return A2(pc, T(1 === u.$ ? [
                    n$
                ] : 1 === (c = (e = u.a).oR).$ ? [
                    xw(e)
                ] : [
                    A2(Uw, c.a, e)
                ]), r);
            case 9:
                return A2(pc, T([
                    (o = n.a, A2(Yi, Rw, function(n) {
                        return A2(Gb, Ml(n), dc(fg(sg(Vw(n.mm)))));
                    }(o)))
                ]), r);
            case 7:
                return (a = n.a).$ ? A2(pc, g, A2(Mw, a.a, r)) : A2(pc, T([
                    Pw
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Channel created")
                }));
            case 8:
                return (a = n.a).$ ? A2(pc, g, A2(Mw, a.a, r)) : A2(pc, T([
                    Pw
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Channel updated")
                }));
            case 10:
                return (a = n.a).$ ? A2(pc, g, A2(Mw, a.a, r)) : A2(pc, T([
                    Pw
                ]), r);
            default:
                var a;
                if ((a = n.a).$) return A2(pc, g, A2(Mw, a.a, r));
                var i = a.a;
                return A2(pc, g, p(r, {
                    cz: i.a,
                    oP: i.b
                }));
        }
        var o, c;
    }), Ww = {
        $: 1
    }, Qw = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Zw = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, A2(lo, r.oL, n)));
    }), Kw = T([
        ih("Edit"),
        ih("Organization"),
        ih("Name"),
        ih("Delete")
    ]), Yw = F3(function(n, r, t) {
        return A2(uT, T([
            Rg("TableTd"),
            Oh(T([
                m("TableRight", i(n - 1, r))
            ]))
        ]), T([
            t
        ]));
    }), Xw = F3(function(n, r, t) {
        return A2(uT, T([
            Rg("TableHeader")
        ]), T([
            t
        ]));
    }), Jw = F2(function(n, r) {
        return A2(Fk, T([
            Rg("TableTr")
        ]), A2(zt, n(Dt(r)), r));
    }), Gw = F2(function(n, r) {
        return A2(Tk, T([
            Rg("Table")
        ]), A2(dt, A2(Jw, Xw, n), A2(Ge, Jw(Yw), r)));
    }), _w = {
        $: 3
    }, nC = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rC = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tC = {
        $: 6
    }, eC = sr, uC = F2(function(n, r) {
        return nT(n(r));
    }), aC = F2(function(n, r) {
        return fi(A3(eC, uC, n, r));
    }), iC = aC, oC = T([
        m("A", "A"),
        m("\u24B6", "A"),
        m("\uFF21", "A"),
        m("\xc0", "A"),
        m("\xc1", "A"),
        m("\xc2", "A"),
        m("\u1EA6", "A"),
        m("\u1EA4", "A"),
        m("\u1EAA", "A"),
        m("\u1EA8", "A"),
        m("\xc3", "A"),
        m("\u0100", "A"),
        m("\u0102", "A"),
        m("\u1EB0", "A"),
        m("\u1EAE", "A"),
        m("\u1EB4", "A"),
        m("\u1EB2", "A"),
        m("\u0226", "A"),
        m("\u01E0", "A"),
        m("\xc4", "A"),
        m("\u01DE", "A"),
        m("\u1EA2", "A"),
        m("\xc5", "A"),
        m("\u01FA", "A"),
        m("\u01CD", "A"),
        m("\u0200", "A"),
        m("\u0202", "A"),
        m("\u1EA0", "A"),
        m("\u1EAC", "A"),
        m("\u1EB6", "A"),
        m("\u1E00", "A"),
        m("\u0104", "A"),
        m("\u023A", "A"),
        m("\u2C6F", "A"),
        m("\uA732", "AA"),
        m("\xc6", "AE"),
        m("\u01FC", "AE"),
        m("\u01E2", "AE"),
        m("\uA734", "AO"),
        m("\uA736", "AU"),
        m("\uA738", "AV"),
        m("\uA73A", "AV"),
        m("\uA73C", "AY"),
        m("B", "B"),
        m("\u24B7", "B"),
        m("\uFF22", "B"),
        m("\u1E02", "B"),
        m("\u1E04", "B"),
        m("\u1E06", "B"),
        m("\u0243", "B"),
        m("\u0182", "B"),
        m("\u0181", "B"),
        m("C", "C"),
        m("\u24B8", "C"),
        m("\uFF23", "C"),
        m("\u0106", "C"),
        m("\u0108", "C"),
        m("\u010A", "C"),
        m("\u010C", "C"),
        m("\xc7", "C"),
        m("\u1E08", "C"),
        m("\u0187", "C"),
        m("\u023B", "C"),
        m("\uA73E", "C"),
        m("D", "D"),
        m("\u24B9", "D"),
        m("\uFF24", "D"),
        m("\u1E0A", "D"),
        m("\u010E", "D"),
        m("\u1E0C", "D"),
        m("\u1E10", "D"),
        m("\u1E12", "D"),
        m("\u1E0E", "D"),
        m("\u0110", "D"),
        m("\u018B", "D"),
        m("\u018A", "D"),
        m("\u0189", "D"),
        m("\uA779", "D"),
        m("\u01F1", "DZ"),
        m("\u01C4", "DZ"),
        m("\u01F2", "Dz"),
        m("\u01C5", "Dz"),
        m("E", "E"),
        m("\u24BA", "E"),
        m("\uFF25", "E"),
        m("\xc8", "E"),
        m("\xc9", "E"),
        m("\xca", "E"),
        m("\u1EC0", "E"),
        m("\u1EBE", "E"),
        m("\u1EC4", "E"),
        m("\u1EC2", "E"),
        m("\u1EBC", "E"),
        m("\u0112", "E"),
        m("\u1E14", "E"),
        m("\u1E16", "E"),
        m("\u0114", "E"),
        m("\u0116", "E"),
        m("\xcb", "E"),
        m("\u1EBA", "E"),
        m("\u011A", "E"),
        m("\u0204", "E"),
        m("\u0206", "E"),
        m("\u1EB8", "E"),
        m("\u1EC6", "E"),
        m("\u0228", "E"),
        m("\u1E1C", "E"),
        m("\u0118", "E"),
        m("\u1E18", "E"),
        m("\u1E1A", "E"),
        m("\u0190", "E"),
        m("\u018E", "E"),
        m("F", "F"),
        m("\u24BB", "F"),
        m("\uFF26", "F"),
        m("\u1E1E", "F"),
        m("\u0191", "F"),
        m("\uA77B", "F"),
        m("G", "G"),
        m("\u24BC", "G"),
        m("\uFF27", "G"),
        m("\u01F4", "G"),
        m("\u011C", "G"),
        m("\u1E20", "G"),
        m("\u011E", "G"),
        m("\u0120", "G"),
        m("\u01E6", "G"),
        m("\u0122", "G"),
        m("\u01E4", "G"),
        m("\u0193", "G"),
        m("\uA7A0", "G"),
        m("\uA77D", "G"),
        m("\uA77E", "G"),
        m("H", "H"),
        m("\u24BD", "H"),
        m("\uFF28", "H"),
        m("\u0124", "H"),
        m("\u1E22", "H"),
        m("\u1E26", "H"),
        m("\u021E", "H"),
        m("\u1E24", "H"),
        m("\u1E28", "H"),
        m("\u1E2A", "H"),
        m("\u0126", "H"),
        m("\u2C67", "H"),
        m("\u2C75", "H"),
        m("\uA78D", "H"),
        m("I", "I"),
        m("\u24BE", "I"),
        m("\uFF29", "I"),
        m("\xcc", "I"),
        m("\xcd", "I"),
        m("\xce", "I"),
        m("\u0128", "I"),
        m("\u012A", "I"),
        m("\u012C", "I"),
        m("\u0130", "I"),
        m("\xcf", "I"),
        m("\u1E2E", "I"),
        m("\u1EC8", "I"),
        m("\u01CF", "I"),
        m("\u0208", "I"),
        m("\u020A", "I"),
        m("\u1ECA", "I"),
        m("\u012E", "I"),
        m("\u1E2C", "I"),
        m("\u0197", "I"),
        m("J", "J"),
        m("\u24BF", "J"),
        m("\uFF2A", "J"),
        m("\u0134", "J"),
        m("\u0248", "J"),
        m("K", "K"),
        m("\u24C0", "K"),
        m("\uFF2B", "K"),
        m("\u1E30", "K"),
        m("\u01E8", "K"),
        m("\u1E32", "K"),
        m("\u0136", "K"),
        m("\u1E34", "K"),
        m("\u0198", "K"),
        m("\u2C69", "K"),
        m("\uA740", "K"),
        m("\uA742", "K"),
        m("\uA744", "K"),
        m("\uA7A2", "K"),
        m("L", "L"),
        m("\u24C1", "L"),
        m("\uFF2C", "L"),
        m("\u013F", "L"),
        m("\u0139", "L"),
        m("\u013D", "L"),
        m("\u1E36", "L"),
        m("\u1E38", "L"),
        m("\u013B", "L"),
        m("\u1E3C", "L"),
        m("\u1E3A", "L"),
        m("\u0141", "L"),
        m("\u023D", "L"),
        m("\u2C62", "L"),
        m("\u2C60", "L"),
        m("\uA748", "L"),
        m("\uA746", "L"),
        m("\uA780", "L"),
        m("\u01C7", "LJ"),
        m("\u01C8", "Lj"),
        m("M", "M"),
        m("\u24C2", "M"),
        m("\uFF2D", "M"),
        m("\u1E3E", "M"),
        m("\u1E40", "M"),
        m("\u1E42", "M"),
        m("\u2C6E", "M"),
        m("\u019C", "M"),
        m("N", "N"),
        m("\u24C3", "N"),
        m("\uFF2E", "N"),
        m("\u01F8", "N"),
        m("\u0143", "N"),
        m("\xd1", "N"),
        m("\u1E44", "N"),
        m("\u0147", "N"),
        m("\u1E46", "N"),
        m("\u0145", "N"),
        m("\u1E4A", "N"),
        m("\u1E48", "N"),
        m("\u0220", "N"),
        m("\u019D", "N"),
        m("\uA790", "N"),
        m("\uA7A4", "N"),
        m("\u01CA", "NJ"),
        m("\u01CB", "Nj"),
        m("O", "O"),
        m("\u24C4", "O"),
        m("\uFF2F", "O"),
        m("\xd2", "O"),
        m("\xd3", "O"),
        m("\xd4", "O"),
        m("\u1ED2", "O"),
        m("\u1ED0", "O"),
        m("\u1ED6", "O"),
        m("\u1ED4", "O"),
        m("\xd5", "O"),
        m("\u1E4C", "O"),
        m("\u022C", "O"),
        m("\u1E4E", "O"),
        m("\u014C", "O"),
        m("\u1E50", "O"),
        m("\u1E52", "O"),
        m("\u014E", "O"),
        m("\u022E", "O"),
        m("\u0230", "O"),
        m("\xd6", "O"),
        m("\u022A", "O"),
        m("\u1ECE", "O"),
        m("\u0150", "O"),
        m("\u01D1", "O"),
        m("\u020C", "O"),
        m("\u020E", "O"),
        m("\u01A0", "O"),
        m("\u1EDC", "O"),
        m("\u1EDA", "O"),
        m("\u1EE0", "O"),
        m("\u1EDE", "O"),
        m("\u1EE2", "O"),
        m("\u1ECC", "O"),
        m("\u1ED8", "O"),
        m("\u01EA", "O"),
        m("\u01EC", "O"),
        m("\xd8", "O"),
        m("\u01FE", "O"),
        m("\u0186", "O"),
        m("\u019F", "O"),
        m("\uA74A", "O"),
        m("\uA74C", "O"),
        m("\u01A2", "OI"),
        m("\uA74E", "OO"),
        m("\u0222", "OU"),
        m("\x8c", "OE"),
        m("\u0152", "OE"),
        m("\x9c", "oe"),
        m("\u0153", "oe"),
        m("P", "P"),
        m("\u24C5", "P"),
        m("\uFF30", "P"),
        m("\u1E54", "P"),
        m("\u1E56", "P"),
        m("\u01A4", "P"),
        m("\u2C63", "P"),
        m("\uA750", "P"),
        m("\uA752", "P"),
        m("\uA754", "P"),
        m("Q", "Q"),
        m("\u24C6", "Q"),
        m("\uFF31", "Q"),
        m("\uA756", "Q"),
        m("\uA758", "Q"),
        m("\u024A", "Q"),
        m("R", "R"),
        m("\u24C7", "R"),
        m("\uFF32", "R"),
        m("\u0154", "R"),
        m("\u1E58", "R"),
        m("\u0158", "R"),
        m("\u0210", "R"),
        m("\u0212", "R"),
        m("\u1E5A", "R"),
        m("\u1E5C", "R"),
        m("\u0156", "R"),
        m("\u1E5E", "R"),
        m("\u024C", "R"),
        m("\u2C64", "R"),
        m("\uA75A", "R"),
        m("\uA7A6", "R"),
        m("\uA782", "R"),
        m("S", "S"),
        m("\u24C8", "S"),
        m("\uFF33", "S"),
        m("\u1E9E", "S"),
        m("\u015A", "S"),
        m("\u1E64", "S"),
        m("\u015C", "S"),
        m("\u1E60", "S"),
        m("\u0160", "S"),
        m("\u1E66", "S"),
        m("\u1E62", "S"),
        m("\u1E68", "S"),
        m("\u0218", "S"),
        m("\u015E", "S"),
        m("\u2C7E", "S"),
        m("\uA7A8", "S"),
        m("\uA784", "S"),
        m("T", "T"),
        m("\u24C9", "T"),
        m("\uFF34", "T"),
        m("\u1E6A", "T"),
        m("\u0164", "T"),
        m("\u1E6C", "T"),
        m("\u021A", "T"),
        m("\u0162", "T"),
        m("\u1E70", "T"),
        m("\u1E6E", "T"),
        m("\u0166", "T"),
        m("\u01AC", "T"),
        m("\u01AE", "T"),
        m("\u023E", "T"),
        m("\uA786", "T"),
        m("\uA728", "TZ"),
        m("U", "U"),
        m("\u24CA", "U"),
        m("\uFF35", "U"),
        m("\xd9", "U"),
        m("\xda", "U"),
        m("\xdb", "U"),
        m("\u0168", "U"),
        m("\u1E78", "U"),
        m("\u016A", "U"),
        m("\u1E7A", "U"),
        m("\u016C", "U"),
        m("\xdc", "U"),
        m("\u01DB", "U"),
        m("\u01D7", "U"),
        m("\u01D5", "U"),
        m("\u01D9", "U"),
        m("\u1EE6", "U"),
        m("\u016E", "U"),
        m("\u0170", "U"),
        m("\u01D3", "U"),
        m("\u0214", "U"),
        m("\u0216", "U"),
        m("\u01AF", "U"),
        m("\u1EEA", "U"),
        m("\u1EE8", "U"),
        m("\u1EEE", "U"),
        m("\u1EEC", "U"),
        m("\u1EF0", "U"),
        m("\u1EE4", "U"),
        m("\u1E72", "U"),
        m("\u0172", "U"),
        m("\u1E76", "U"),
        m("\u1E74", "U"),
        m("\u0244", "U"),
        m("V", "V"),
        m("\u24CB", "V"),
        m("\uFF36", "V"),
        m("\u1E7C", "V"),
        m("\u1E7E", "V"),
        m("\u01B2", "V"),
        m("\uA75E", "V"),
        m("\u0245", "V"),
        m("\uA760", "VY"),
        m("W", "W"),
        m("\u24CC", "W"),
        m("\uFF37", "W"),
        m("\u1E80", "W"),
        m("\u1E82", "W"),
        m("\u0174", "W"),
        m("\u1E86", "W"),
        m("\u1E84", "W"),
        m("\u1E88", "W"),
        m("\u2C72", "W"),
        m("X", "X"),
        m("\u24CD", "X"),
        m("\uFF38", "X"),
        m("\u1E8A", "X"),
        m("\u1E8C", "X"),
        m("Y", "Y"),
        m("\u24CE", "Y"),
        m("\uFF39", "Y"),
        m("\u1EF2", "Y"),
        m("\xdd", "Y"),
        m("\u0176", "Y"),
        m("\u1EF8", "Y"),
        m("\u0232", "Y"),
        m("\u1E8E", "Y"),
        m("\u0178", "Y"),
        m("\u1EF6", "Y"),
        m("\u1EF4", "Y"),
        m("\u01B3", "Y"),
        m("\u024E", "Y"),
        m("\u1EFE", "Y"),
        m("Z", "Z"),
        m("\u24CF", "Z"),
        m("\uFF3A", "Z"),
        m("\u0179", "Z"),
        m("\u1E90", "Z"),
        m("\u017B", "Z"),
        m("\u017D", "Z"),
        m("\u1E92", "Z"),
        m("\u1E94", "Z"),
        m("\u01B5", "Z"),
        m("\u0224", "Z"),
        m("\u2C7F", "Z"),
        m("\u2C6B", "Z"),
        m("\uA762", "Z"),
        m("a", "a"),
        m("\u24D0", "a"),
        m("\uFF41", "a"),
        m("\u1E9A", "a"),
        m("\xe0", "a"),
        m("\xe1", "a"),
        m("\xe2", "a"),
        m("\u1EA7", "a"),
        m("\u1EA5", "a"),
        m("\u1EAB", "a"),
        m("\u1EA9", "a"),
        m("\xe3", "a"),
        m("\u0101", "a"),
        m("\u0103", "a"),
        m("\u1EB1", "a"),
        m("\u1EAF", "a"),
        m("\u1EB5", "a"),
        m("\u1EB3", "a"),
        m("\u0227", "a"),
        m("\u01E1", "a"),
        m("\xe4", "a"),
        m("\u01DF", "a"),
        m("\u1EA3", "a"),
        m("\xe5", "a"),
        m("\u01FB", "a"),
        m("\u01CE", "a"),
        m("\u0201", "a"),
        m("\u0203", "a"),
        m("\u1EA1", "a"),
        m("\u1EAD", "a"),
        m("\u1EB7", "a"),
        m("\u1E01", "a"),
        m("\u0105", "a"),
        m("\u2C65", "a"),
        m("\u0250", "a"),
        m("\uA733", "aa"),
        m("\xe6", "ae"),
        m("\u01FD", "ae"),
        m("\u01E3", "ae"),
        m("\uA735", "ao"),
        m("\uA737", "au"),
        m("\uA739", "av"),
        m("\uA73B", "av"),
        m("\uA73D", "ay"),
        m("b", "b"),
        m("\u24D1", "b"),
        m("\uFF42", "b"),
        m("\u1E03", "b"),
        m("\u1E05", "b"),
        m("\u1E07", "b"),
        m("\u0180", "b"),
        m("\u0183", "b"),
        m("\u0253", "b"),
        m("c", "c"),
        m("\u24D2", "c"),
        m("\uFF43", "c"),
        m("\u0107", "c"),
        m("\u0109", "c"),
        m("\u010B", "c"),
        m("\u010D", "c"),
        m("\xe7", "c"),
        m("\u1E09", "c"),
        m("\u0188", "c"),
        m("\u023C", "c"),
        m("\uA73F", "c"),
        m("\u2184", "c"),
        m("d", "d"),
        m("\u24D3", "d"),
        m("\uFF44", "d"),
        m("\u1E0B", "d"),
        m("\u010F", "d"),
        m("\u1E0D", "d"),
        m("\u1E11", "d"),
        m("\u1E13", "d"),
        m("\u1E0F", "d"),
        m("\u0111", "d"),
        m("\u018C", "d"),
        m("\u0256", "d"),
        m("\u0257", "d"),
        m("\uA77A", "d"),
        m("\u01F3", "dz"),
        m("\u01C6", "dz"),
        m("e", "e"),
        m("\u24D4", "e"),
        m("\uFF45", "e"),
        m("\xe8", "e"),
        m("\xe9", "e"),
        m("\xea", "e"),
        m("\u1EC1", "e"),
        m("\u1EBF", "e"),
        m("\u1EC5", "e"),
        m("\u1EC3", "e"),
        m("\u1EBD", "e"),
        m("\u0113", "e"),
        m("\u1E15", "e"),
        m("\u1E17", "e"),
        m("\u0115", "e"),
        m("\u0117", "e"),
        m("\xeb", "e"),
        m("\u1EBB", "e"),
        m("\u011B", "e"),
        m("\u0205", "e"),
        m("\u0207", "e"),
        m("\u1EB9", "e"),
        m("\u1EC7", "e"),
        m("\u0229", "e"),
        m("\u1E1D", "e"),
        m("\u0119", "e"),
        m("\u1E19", "e"),
        m("\u1E1B", "e"),
        m("\u0247", "e"),
        m("\u025B", "e"),
        m("\u01DD", "e"),
        m("f", "f"),
        m("\u24D5", "f"),
        m("\uFF46", "f"),
        m("\u1E1F", "f"),
        m("\u0192", "f"),
        m("\uA77C", "f"),
        m("g", "g"),
        m("\u24D6", "g"),
        m("\uFF47", "g"),
        m("\u01F5", "g"),
        m("\u011D", "g"),
        m("\u1E21", "g"),
        m("\u011F", "g"),
        m("\u0121", "g"),
        m("\u01E7", "g"),
        m("\u0123", "g"),
        m("\u01E5", "g"),
        m("\u0260", "g"),
        m("\uA7A1", "g"),
        m("\u1D79", "g"),
        m("\uA77F", "g"),
        m("h", "h"),
        m("\u24D7", "h"),
        m("\uFF48", "h"),
        m("\u0125", "h"),
        m("\u1E23", "h"),
        m("\u1E27", "h"),
        m("\u021F", "h"),
        m("\u1E25", "h"),
        m("\u1E29", "h"),
        m("\u1E2B", "h"),
        m("\u1E96", "h"),
        m("\u0127", "h"),
        m("\u2C68", "h"),
        m("\u2C76", "h"),
        m("\u0265", "h"),
        m("\u0195", "hv"),
        m("i", "i"),
        m("\u24D8", "i"),
        m("\uFF49", "i"),
        m("\xec", "i"),
        m("\xed", "i"),
        m("\xee", "i"),
        m("\u0129", "i"),
        m("\u012B", "i"),
        m("\u012D", "i"),
        m("\xef", "i"),
        m("\u1E2F", "i"),
        m("\u1EC9", "i"),
        m("\u01D0", "i"),
        m("\u0209", "i"),
        m("\u020B", "i"),
        m("\u1ECB", "i"),
        m("\u012F", "i"),
        m("\u1E2D", "i"),
        m("\u0268", "i"),
        m("\u0131", "i"),
        m("j", "j"),
        m("\u24D9", "j"),
        m("\uFF4A", "j"),
        m("\u0135", "j"),
        m("\u01F0", "j"),
        m("\u0249", "j"),
        m("k", "k"),
        m("\u24DA", "k"),
        m("\uFF4B", "k"),
        m("\u1E31", "k"),
        m("\u01E9", "k"),
        m("\u1E33", "k"),
        m("\u0137", "k"),
        m("\u1E35", "k"),
        m("\u0199", "k"),
        m("\u2C6A", "k"),
        m("\uA741", "k"),
        m("\uA743", "k"),
        m("\uA745", "k"),
        m("\uA7A3", "k"),
        m("l", "l"),
        m("\u24DB", "l"),
        m("\uFF4C", "l"),
        m("\u0140", "l"),
        m("\u013A", "l"),
        m("\u013E", "l"),
        m("\u1E37", "l"),
        m("\u1E39", "l"),
        m("\u013C", "l"),
        m("\u1E3D", "l"),
        m("\u1E3B", "l"),
        m("\u017F", "l"),
        m("\u0142", "l"),
        m("\u019A", "l"),
        m("\u026B", "l"),
        m("\u2C61", "l"),
        m("\uA749", "l"),
        m("\uA781", "l"),
        m("\uA747", "l"),
        m("\u01C9", "lj"),
        m("m", "m"),
        m("\u24DC", "m"),
        m("\uFF4D", "m"),
        m("\u1E3F", "m"),
        m("\u1E41", "m"),
        m("\u1E43", "m"),
        m("\u0271", "m"),
        m("\u026F", "m"),
        m("n", "n"),
        m("\u24DD", "n"),
        m("\uFF4E", "n"),
        m("\u01F9", "n"),
        m("\u0144", "n"),
        m("\xf1", "n"),
        m("\u1E45", "n"),
        m("\u0148", "n"),
        m("\u1E47", "n"),
        m("\u0146", "n"),
        m("\u1E4B", "n"),
        m("\u1E49", "n"),
        m("\u019E", "n"),
        m("\u0272", "n"),
        m("\u0149", "n"),
        m("\uA791", "n"),
        m("\uA7A5", "n"),
        m("\u01CC", "nj"),
        m("o", "o"),
        m("\u24DE", "o"),
        m("\uFF4F", "o"),
        m("\xf2", "o"),
        m("\xf3", "o"),
        m("\xf4", "o"),
        m("\u1ED3", "o"),
        m("\u1ED1", "o"),
        m("\u1ED7", "o"),
        m("\u1ED5", "o"),
        m("\xf5", "o"),
        m("\u1E4D", "o"),
        m("\u022D", "o"),
        m("\u1E4F", "o"),
        m("\u014D", "o"),
        m("\u1E51", "o"),
        m("\u1E53", "o"),
        m("\u014F", "o"),
        m("\u022F", "o"),
        m("\u0231", "o"),
        m("\xf6", "o"),
        m("\u022B", "o"),
        m("\u1ECF", "o"),
        m("\u0151", "o"),
        m("\u01D2", "o"),
        m("\u020D", "o"),
        m("\u020F", "o"),
        m("\u01A1", "o"),
        m("\u1EDD", "o"),
        m("\u1EDB", "o"),
        m("\u1EE1", "o"),
        m("\u1EDF", "o"),
        m("\u1EE3", "o"),
        m("\u1ECD", "o"),
        m("\u1ED9", "o"),
        m("\u01EB", "o"),
        m("\u01ED", "o"),
        m("\xf8", "o"),
        m("\u01FF", "o"),
        m("\u0254", "o"),
        m("\uA74B", "o"),
        m("\uA74D", "o"),
        m("\u0275", "o"),
        m("\u01A3", "oi"),
        m("\u0223", "ou"),
        m("\uA74F", "oo"),
        m("p", "p"),
        m("\u24DF", "p"),
        m("\uFF50", "p"),
        m("\u1E55", "p"),
        m("\u1E57", "p"),
        m("\u01A5", "p"),
        m("\u1D7D", "p"),
        m("\uA751", "p"),
        m("\uA753", "p"),
        m("\uA755", "p"),
        m("q", "q"),
        m("\u24E0", "q"),
        m("\uFF51", "q"),
        m("\u024B", "q"),
        m("\uA757", "q"),
        m("\uA759", "q"),
        m("r", "r"),
        m("\u24E1", "r"),
        m("\uFF52", "r"),
        m("\u0155", "r"),
        m("\u1E59", "r"),
        m("\u0159", "r"),
        m("\u0211", "r"),
        m("\u0213", "r"),
        m("\u1E5B", "r"),
        m("\u1E5D", "r"),
        m("\u0157", "r"),
        m("\u1E5F", "r"),
        m("\u024D", "r"),
        m("\u027D", "r"),
        m("\uA75B", "r"),
        m("\uA7A7", "r"),
        m("\uA783", "r"),
        m("s", "s"),
        m("\u24E2", "s"),
        m("\uFF53", "s"),
        m("\xdf", "s"),
        m("\u015B", "s"),
        m("\u1E65", "s"),
        m("\u015D", "s"),
        m("\u1E61", "s"),
        m("\u0161", "s"),
        m("\u1E67", "s"),
        m("\u1E63", "s"),
        m("\u1E69", "s"),
        m("\u0219", "s"),
        m("\u015F", "s"),
        m("\u023F", "s"),
        m("\uA7A9", "s"),
        m("\uA785", "s"),
        m("\u1E9B", "s"),
        m("t", "t"),
        m("\u24E3", "t"),
        m("\uFF54", "t"),
        m("\u1E6B", "t"),
        m("\u1E97", "t"),
        m("\u0165", "t"),
        m("\u1E6D", "t"),
        m("\u021B", "t"),
        m("\u0163", "t"),
        m("\u1E71", "t"),
        m("\u1E6F", "t"),
        m("\u0167", "t"),
        m("\u01AD", "t"),
        m("\u0288", "t"),
        m("\u2C66", "t"),
        m("\uA787", "t"),
        m("\uA729", "tz"),
        m("u", "u"),
        m("\u24E4", "u"),
        m("\uFF55", "u"),
        m("\xf9", "u"),
        m("\xfa", "u"),
        m("\xfb", "u"),
        m("\u0169", "u"),
        m("\u1E79", "u"),
        m("\u016B", "u"),
        m("\u1E7B", "u"),
        m("\u016D", "u"),
        m("\xfc", "u"),
        m("\u01DC", "u"),
        m("\u01D8", "u"),
        m("\u01D6", "u"),
        m("\u01DA", "u"),
        m("\u1EE7", "u"),
        m("\u016F", "u"),
        m("\u0171", "u"),
        m("\u01D4", "u"),
        m("\u0215", "u"),
        m("\u0217", "u"),
        m("\u01B0", "u"),
        m("\u1EEB", "u"),
        m("\u1EE9", "u"),
        m("\u1EEF", "u"),
        m("\u1EED", "u"),
        m("\u1EF1", "u"),
        m("\u1EE5", "u"),
        m("\u1E73", "u"),
        m("\u0173", "u"),
        m("\u1E77", "u"),
        m("\u1E75", "u"),
        m("\u0289", "u"),
        m("v", "v"),
        m("\u24E5", "v"),
        m("\uFF56", "v"),
        m("\u1E7D", "v"),
        m("\u1E7F", "v"),
        m("\u028B", "v"),
        m("\uA75F", "v"),
        m("\u028C", "v"),
        m("\uA761", "vy"),
        m("w", "w"),
        m("\u24E6", "w"),
        m("\uFF57", "w"),
        m("\u1E81", "w"),
        m("\u1E83", "w"),
        m("\u0175", "w"),
        m("\u1E87", "w"),
        m("\u1E85", "w"),
        m("\u1E98", "w"),
        m("\u1E89", "w"),
        m("\u2C73", "w"),
        m("x", "x"),
        m("\u24E7", "x"),
        m("\uFF58", "x"),
        m("\u1E8B", "x"),
        m("\u1E8D", "x"),
        m("y", "y"),
        m("\u24E8", "y"),
        m("\uFF59", "y"),
        m("\u1EF3", "y"),
        m("\xfd", "y"),
        m("\u0177", "y"),
        m("\u1EF9", "y"),
        m("\u0233", "y"),
        m("\u1E8F", "y"),
        m("\xff", "y"),
        m("\u1EF7", "y"),
        m("\u1E99", "y"),
        m("\u1EF5", "y"),
        m("\u01B4", "y"),
        m("\u024F", "y"),
        m("\u1EFF", "y"),
        m("z", "z"),
        m("\u24E9", "z"),
        m("\uFF5A", "z"),
        m("\u017A", "z"),
        m("\u1E91", "z"),
        m("\u017C", "z"),
        m("\u017E", "z"),
        m("\u1E93", "z"),
        m("\u1E95", "z"),
        m("\u01B6", "z")
    ]), cC = Jo(oC), sC = function(n) {
        return A3(Pa, F2(function(n, r) {
            var t = A2(lo, n, cC);
            return $(r, t.$ ? Qm(n) : t.a);
        }), "", n);
    }, fC = A2(bu, Hi, sC), lC = F2(function(n, r) {
        var t = m(n, r);
        if (t.a.$) return t.b.$ ? A2(ku, t.a.a, t.b.a) : 0;
        if (t.b.$) return 2;
        var e = t.b.a;
        return A2(ku, fC(t.a.a), fC(e));
    }), mC = F2(function(n, r) {
        n: for(;;){
            var t = m(n, r);
            if (t.a.b) {
                if (t.b.b) {
                    var e = t.a, u = e.b, a = t.b, i = a.b, o = A2(lC, e.a, a.a);
                    if (1 === o) {
                        n = u, r = i;
                        continue n;
                    }
                    return o;
                }
                return 2;
            }
            return t.b.b ? 0 : 1;
        }
    }), dC = A2(ju, Qh, Wh("[0-9]+|[^0-9]+")), bC = ft(mt), pC = M, vC = function(n) {
        return pC(n) ? Tt : kt({
            $: 1,
            a: n
        });
    }, $C = function(n) {
        return A2(ju, {
            $: 0,
            a: n
        }, A2(fp, vC, ze(n)));
    }, gC = function(n) {
        return A2(Ge, A2(bu, $C, function(n) {
            return n.b_;
        }), A2(bC, dC, n));
    }, hC = F3(function(n, r, t) {
        return A2(mC, gC(n(r)), gC(n(t)));
    }), kC = A, TC = kC(hC(Ko)), wC = F2(function(n, r) {
        return A2(iC, A2(bu, r, TC), n);
    }), CC = function(n) {
        return A2(wT, function(r) {
            var t = A2(dt, m("", ""), A2(Ge, function(n) {
                return m(n.a, n.b.n5);
            }, pt(n.oP))), e = function(n) {
                return 1 !== n.oR.$;
            }(r) ? m("Save", "Edit Channel") : m("Create", "New Channel");
            return A4(ZT, e.b, m(e.a, tC), m("Cancel", _w), T([
                A2(dk, rC, A2(wC, t, ET(r.oL))),
                A2(dk, nC, IT(r.n5))
            ]));
        }, n.kN);
    }, NC = F2(function(n, r) {
        var t, e;
        return A3(hw, "Channels", kt(A2(Nh, "New\u2026", Ww)), A2(Le, g, T([
            CC(r),
            A2(Gw, Kw, (t = m(r.cz, r.oP), e = t.b, A2(Ge, function(n) {
                var r;
                return T([
                    A2(Nh, "Edit", (r = n, {
                        $: 2,
                        a: r
                    })),
                    ih(A2(Zw, e, n)),
                    ih(n.ss),
                    A2(Og, Th, Qw(n))
                ]);
            }, t.a)))
        ])));
    }), AC = {
        l: function(n) {
            return n.cz;
        },
        m: Iw,
        o: F2(function(n, r) {
            return p(n, {
                cz: r
            });
        }),
        p: function(n) {
            return {
                $: 8,
                a: n
            };
        },
        q: Hw,
        r: NC
    }, SC = function(n) {
        return {
            $: 5,
            a: n
        };
    }, LC = A2(Yi, SC, dc(A2(Ho, I$, So(M$)))), yC = function(n) {
        return {
            $: 6,
            a: n
        };
    }, FC = oc(Wv), jC = function(n) {
        return {
            $: 12,
            a: n
        };
    }, PC = ml(jC({
        $: 2
    })), IC = A2(Yi, yC, dc(A2(Ho, FC, So(PC)))), BC = {
        kv: g,
        m5: !1,
        nl: !1,
        oP: g,
        oW: av(Tt),
        rJ: a$("Completed At"),
        dK: g
    }, MC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, OC = _e, qC = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return {
                                                            B: l,
                                                            ik: m,
                                                            j0: u,
                                                            j1: f,
                                                            kg: t,
                                                            lu: i,
                                                            mm: n,
                                                            fG: r,
                                                            oL: o,
                                                            pG: c,
                                                            g6: a,
                                                            q5: e,
                                                            q6: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, DC = function(n) {
        switch(n){
            case "DownloadAsIs":
                return St(0);
            case "PADTranscode":
                return St(1);
            case "SimpleTranscode":
                return St(2);
            case "QC":
                return St(3);
            case "Spotcheck":
                return St(4);
            default:
                return wt("job type not found");
        }
    }, xC = function(n) {
        switch(n){
            case 0:
                return "DownloadAsIs";
            case 1:
                return "PADTranscode";
            case 2:
                return "SimpleTranscode";
            case 3:
                return "QC";
            default:
                return "Spotcheck";
        }
    }, RC = A2(Il, xC, DC), VC = Po(A4(rc, "acknowledgedBy", function(n) {
        return n.ik;
    }, qo(xi), A4(rc, "acknowledge", function(n) {
        return n.B;
    }, no, A4(rc, "completedBy", function(n) {
        return n.j1;
    }, qo(xi), A4(rc, "startedBy", function(n) {
        return n.q6;
    }, qo(xi), A4(rc, "requester", function(n) {
        return n.pG;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(Do, "externalJobId", function(n) {
        return n.lu;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(Do, "completedAt", function(n) {
        return n.j0;
    }, td, A4(Do, "startedAt", function(n) {
        return n.q5;
    }, td, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "jobType", function(n) {
        return n.fG;
    }, RC, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(qC))))))))))))))), EC = oc(VC), zC = function(n) {
        return {
            $: 24,
            a: n
        };
    }, UC = ml(zC({
        $: 3
    })), HC = dc(A2(Ho, EC, So(UC))), WC = function(n) {
        return {
            g7: n
        };
    }, QC = function(n) {
        return {
            $: 26,
            a: n
        };
    }, ZC = ml(QC({
        $: 0
    })), KC = Po(A4(rc, "showIds", function(n) {
        return n.g7;
    }, oc(xi), Io(WC))), YC = F2(function(n, r) {
        return {
            gp: r,
            qI: n
        };
    }), XC = function(n) {
        return {
            ss: n
        };
    }, JC = Po(A4(rc, "value", function(n) {
        return n.ss;
    }, xi, Io(XC))), GC = Po(A4(rc, "path", function(n) {
        return n.gp;
    }, oc(JC), A4(rc, "showId", function(n) {
        return n.qI;
    }, xi, Io(YC)))), _C = oc(GC), nN = F2(function(n, r) {
        var t;
        return (t = n.mm, function(n) {
            return function(r) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return {
                                                            B: l,
                                                            ik: m,
                                                            j0: u,
                                                            j1: f,
                                                            kg: r,
                                                            lu: i,
                                                            mm: t,
                                                            fG: n,
                                                            oL: o,
                                                            pG: c,
                                                            qK: a,
                                                            q5: e,
                                                            q6: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(n.fG)(n.kg)(n.q5)(n.j0)(r)(n.lu)(n.oL)(n.pG)(n.q6)(n.j1)(n.B)(n.ik);
    }), rN = F2(function(n, r) {
        return A2(nN, r, A2(ju, A2(YC, r.mm, T([
            XC(r.mm)
        ])), Va(A2(Iu, function(n) {
            return i(n.qI, r.g6);
        }, n))));
    }), tN = function(n) {
        return A2(Gb, function(r) {
            return A2(Ge, rN(r), n);
        }, dc(A2(Ho, _C, A3(ag, KC, WC(A2(Ge, function(n) {
            return n.g6;
        }, n)), rg(ZC)))));
    }, eN = A2(OC, tN, HC), uN = A2(Yi, MC, eN), aN = A2(pc, T([
        uN,
        LC,
        IC
    ]), BC), iN = function(n) {
        return {
            $: 11,
            a: n
        };
    }, oN = Ke, cN = function(n) {
        return A2(Gv, Ml({
            $: 8,
            a: n
        }), oN(0));
    }, sN = function(n) {
        return bc(T([
            uN,
            cN(n)
        ]));
    }, fN = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, r);
            case 9:
                return A2(pc, g, p(r, {
                    kv: g
                }));
            case 4:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 7:
                return A2(pc, g, p(r, {
                    m5: !r.m5
                }));
            case 2:
                return A2(pc, g, p(r, (u = n.a).$ ? {
                    kv: g
                } : {
                    kv: u.a,
                    nl: !1
                }));
            case 1:
                return A2(pc, T([
                    uN
                ]), r);
            case 5:
                return A2(pc, g, (u = n.a).$ ? r : p(r, {
                    oP: u.a
                }));
            case 6:
                return A2(pc, g, (u = n.a).$ ? r : p(r, {
                    dK: u.a
                }));
            case 8:
                return A2(pc, g, p(r, {
                    oW: e = n.a
                }));
            case 3:
                var t = n.a, e = t.a;
                return A2(pc, g, (u = t.b).$ ? r : p(r, {
                    kv: u.a,
                    nl: !1,
                    oW: e
                }));
            case 10:
                return A2(pc, T([
                    A2(Yi, iN, (a = n.a.mm, dc(fg(mg(ml(QC({
                        $: 1,
                        a: a
                    })))))))
                ]), r);
            default:
                var u;
                return A2(pc, (u = n.a).$ ? g : T([
                    sN(r.oW)
                ]), r);
        }
        var a;
    }), lN = {
        $: 1
    }, mN = Se("h2"), dN = F3(function(n, r, t) {
        return A2(Le, T([
            A2(ph, "margin", "10px")
        ]), T([
            A2(mN, g, T([
                ih(r)
            ])),
            t
        ]));
    }), bN = function(n) {
        return qC(n.mm)(n.fG)(n.kg)(n.q5)(n.j0)(n.qK.qI)(n.lu)(n.oL)(n.pG)(n.q6)(n.j1)(n.B)(n.ik);
    }, pN = {
        $: 7
    }, vN = F2(function(n, r) {
        return A2(ju, n, A2(Fu, function(r) {
            return $(n, r ? "true" : "false");
        }, r));
    }), $N = function(n) {
        var r = d(n.oL, n.c$, n.P);
        return 1 === r.a.$ ? 1 === r.b.$ ? 1 === r.c.$ ? "/jobs" + A2(vN, "?acknowledge=", n.B) : "/jobs?status=" + (r.c.a + A2(vN, "&acknowledge=", n.B)) : r.c.$ ? "/jobs?kind=" + (r.b.a + A2(vN, "&acknowledge=", n.B)) : "/jobs?kind=" + r.b.a + "&status=" + (r.c.a + A2(vN, "&acknowledge=", n.B)) : r.b.$ ? 1 === r.c.$ ? "/jobs?organization=" + (r.a.a + A2(vN, "&acknowledge=", n.B)) : "/jobs?organization=" + r.a.a + "&status=" + (r.c.a + A2(vN, "&acknowledge=", n.B)) : 1 === r.c.$ ? "/jobs?organization=" + r.a.a + "&kind=" + (r.b.a + A2(vN, "&acknowledge=", n.B)) : "/jobs?organization=" + r.a.a + "&kind=" + r.b.a + "&status=" + (r.c.a + A2(vN, "&acknowledge=", n.B));
    }, gN = function(n) {
        switch(n.$){
            case 0:
                return "/";
            case 1:
                var r = n.c;
                return "/show/" + (n.a + (kv(n.b) + function() {
                    var n = m(r.bD, r.cf);
                    n: for(;;){
                        if (1 === n.a.$) {
                            if (n.b.$ || n.b.a) break n;
                            return "?sortVerifByDate=";
                        }
                        if (1 === n.b.$) return "?broadcastable=" + n.a.a;
                        if (n.b.a) break n;
                        return "?broadcastable=" + n.a.a + "&sortVerifByDate=";
                    }
                    return "";
                }()));
            case 2:
                return "/hierarchy/" + n.a + (n.b ? "/settings" : "");
            case 3:
                return function(n) {
                    switch(n.$){
                        case 1:
                            return "/account/forgotPassword";
                        case 0:
                            var r = n.a.lX;
                            if (1 === r.$) return "/account/login";
                            switch(r.a){
                                case "/":
                                case "/logout":
                                    return "/account/login";
                                default:
                                    return "/account/login?from=" + r.a;
                            }
                        case 2:
                            return "/account/resetPassword?email=" + n.a.k8 + "&token=" + n.a.rY;
                        default:
                            var t = n.a;
                            return "/account/invitation?redirect=" + t.pA + "&email=" + t.k8 + "&token=" + t.rY;
                    }
                }(n.a);
            case 4:
                switch(n.a.$){
                    case 0:
                        return "/admin";
                    case 1:
                        return "/admin/adminOrganizations";
                    case 2:
                        return "/admin/onboarding";
                    case 3:
                        return "/admin/adminUsers";
                    case 4:
                        return "/admin/adminUploads";
                    case 5:
                        return "/admin/adminTestPlans";
                    case 6:
                        return "/admin/adminAudioMappings";
                    case 7:
                        return "/admin/adminChannels";
                    case 8:
                        return "/admin/adminResearchs";
                    case 9:
                        return "/admin/adminWebhooks";
                    case 10:
                        return "/admin/adminOrganizationFileListings";
                    case 11:
                        return "/admin/adminFormats";
                    case 12:
                        return "/admin/adminSubtitleFormats";
                    case 13:
                        return "/admin/adminSegmentationRules";
                    case 14:
                        return "/admin" + $N(r = n.a.a);
                    case 15:
                        return "/admin/metadata";
                    case 16:
                        return "/admin/deepProbe";
                    case 17:
                        return "/admin/probes";
                    default:
                        return "/admin" + function(n) {
                            var r = n.c$;
                            return r.$ ? "/dashboard" : "/dashboard?kind=" + r.a;
                        }(r = n.a.a);
                }
            case 5:
                return "/help/" + n.a;
            case 6:
                return "/archive";
            case 7:
                return "/upload";
            case 8:
                return "/settings";
            case 9:
                return "/report";
            default:
                return "/404";
        }
    }, hN = function(n) {
        return gN(hp(zp(n)));
    }, kN = F2(function(n, r) {
        return d(i(n.oW.c$, kt(Hi(r.a))), hN({
            c$: kt(Hi(r.a))
        }), r.b);
    }), TN = function(n) {
        return n ? Yh("CatchClickAll") : Oh(g);
    }, wN = function(n) {
        var r = n.a, t = n.b, e = n.c;
        return A2(aw, T([
            Rg("SelectItem"),
            Oh(T([
                m("SelectItemSelected", r)
            ])),
            sw(t)
        ]), T([
            ih(e)
        ]));
    }, CN = F4(function(n, r, t, e) {
        var u = A2(ju, e, Va(A2(Yc, function(n) {
            return n.a ? kt(n.c) : Tt;
        }, t)));
        return A2(Le, T([
            Rg("Select"),
            Oh(T([
                m("SelectOpened", n)
            ])),
            wh(r),
            TN(n)
        ]), T([
            A2(Le, T([
                Rg("SelectButton")
            ]), T([
                A2(Le, T([
                    Rg("SelectButtonIcon")
                ]), T([
                    MT
                ])),
                A2(Dh, T([
                    Rg("SelectButtonTitle")
                ]), u)
            ])),
            A2(Le, T([
                Rg("SelectList")
            ]), A2(Ge, wN, t))
        ]));
    }), NN = function(n) {
        var r = T([
            m("", "All Types"),
            m("DownloadAsIs", "DownloadAsIs"),
            m("PadTranscode", "PadTranscode"),
            m("SimpleTranscode", "SimpleTranscode"),
            m("QC", "QC"),
            m("Spotcheck", "Spotcheck")
        ]);
        return A4(CN, n.m5, pN, A2(Ge, kN(n), r), "Filter by type");
    }, AN = function(n) {
        return {
            $: 10,
            a: n
        };
    }, SN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, LN = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), yN = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: LN(r)
        });
    }), FN = function(n) {
        return {
            $: 4,
            a: zi(n)
        };
    }, jN = function(n) {
        return n;
    }, PN = F3(function(n, r, t) {
        return _g({
            n5: n,
            ds: FN(A2(bu, jN, t)),
            dM: LN(r)
        });
    }), IN = Fg("datetime"), BN = function(n) {
        return A3(Se, "format-time", T([
            IN(rd(n))
        ]), T([
            ih(rd(n))
        ]));
    }, MN = F2(function(n, r) {
        return A3(PN, n, function(n) {
            return BN(r(n));
        }, r);
    }), ON = F2(function(n, r) {
        if (r.$) return "";
        var t = r.a;
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, Va(A2(Iu, function(n) {
            return i(n.mm, t);
        }, n))));
    }), qN = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, Va(A2(Iu, function(n) {
            return i(n.mm, r);
        }, n.oP))));
    }), DN = F2(function(n, r) {
        return _g({
            n5: n,
            ds: FN(A2(bu, A2(bu, function(n) {
                return A2(ju, 0, n);
            }, Fu(jN)), r)),
            dM: LN(function(n) {
                return A2(ju, A2(Le, g, g), A2(Fu, BN, r(n)));
            })
        });
    }), xN = function(n) {
        return A3(qt, F2(function(n, r) {
            return r + "/" + n;
        }), "", A2(Ge, function(n) {
            return n.ss;
        }, n.gp));
    }, RN = F2(function(n, r) {
        return {
            n5: n,
            ds: Eg(r),
            dM: A2(bu, oh, r)
        };
    }), VN = T([
        Rg("Table")
    ]), EN = function() {
        return T([
            Rg("TableTr")
        ]);
    }, zN = function(n) {
        return uh({
            jY: T([
                A2(yN, "Acknowledge", A2(bu, Nh("Acknowledge"), AN)),
                A2(RN, "Organization", A2(bu, qN(n), function(n) {
                    return n.oL;
                })),
                A2(RN, "Type", A2(bu, xC, function(n) {
                    return n.fG;
                })),
                A2(MN, "Created At", function(n) {
                    return n.kg;
                }),
                A2(RN, "Requester", A2(bu, A2(bu, ON(n.dK), kt), function(n) {
                    return n.pG;
                })),
                A2(DN, "Started At", function(n) {
                    return n.q5;
                }),
                A2(RN, "Started By", A2(bu, ON(n.dK), function(n) {
                    return n.q6;
                })),
                A2(RN, "External Job Id", A2(bu, ju(""), function(n) {
                    return n.lu;
                })),
                A2(yN, "Show", A2(bu, function(n) {
                    return A2(aw, T([
                        sw("/show/" + n.qI)
                    ]), T([
                        ih(xN(n))
                    ]));
                }, function(n) {
                    return n.qK;
                })),
                A2(RN, "Id", function(n) {
                    return n.mm;
                })
            ]),
            kt: p(kh, {
                pR: EN,
                rA: VN,
                rM: T([
                    Rg("TableTd")
                ])
            }),
            rV: function(n) {
                return n.mm;
            },
            rW: SN
        });
    }, UN = F2(function(n, r) {
        return A2(Le, T([
            A2(ph, "margin", "10px")
        ]), T([
            Cu(n.kv) ? ih("All jobs are completed !") : A3(cT, zN(n), n.rJ, r)
        ]));
    }), HN = F2(function(n, r) {
        var t = r.oW.c$, e = A2(Iu, function(n) {
            if (t.$) return !0;
            var r = t.a;
            if (qe(r) > 0) {
                var e = bN(n);
                return i(Hi(xC(e.fG)), r);
            }
            return !0;
        }, r.kv);
        return A3(hw, "Dashboard", kt(A2(Nh, "Refresh", lN)), A2(Le, g, T([
            A2(Le, T([
                Rg("DarkZone"),
                Rg("Filter")
            ]), T([
                A2(Le, T([
                    Rg("JobsFilters")
                ]), T([
                    NN(r)
                ]))
            ])),
            A3(dN, r, "Not Completed Jobs: (" + It(Dt(e)) + ")", A2(UN, r, e))
        ])));
    }), WN = {
        l: function(n) {
            return n.cE;
        },
        m: aN,
        o: F2(function(n, r) {
            return p(n, {
                cE: r
            });
        }),
        p: function(n) {
            return {
                $: 0,
                a: n
            };
        },
        q: fN,
        r: HN
    }, QN = {
        kv: g,
        kN: Tt,
        lm: Tt,
        rv: Tt,
        rJ: a$("Id")
    }, ZN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, KN = function(n) {
        return {
            $: 25,
            a: n
        };
    }, YN = ml(KN({
        $: 1
    })), XN = F2(function(n, r) {
        return {
            jI: r,
            aj: n
        };
    }), JN = F3(function(n, r, t) {
        return {
            nK: t,
            nT: r,
            n5: n
        };
    }), GN = function(n) {
        switch(n){
            case "silence":
                return St(0);
            case "blackframe":
                return St(1);
            default:
                return wt("Deep Probe Kind not found");
        }
    }, _N = function(n) {
        return n ? "blackframe" : "silence";
    }, nA = A2(Il, _N, GN), rA = Po(A4(rc, "max", function(n) {
        return n.nK;
    }, uc, A4(rc, "min", function(n) {
        return n.nT;
    }, uc, A4(rc, "name", function(n) {
        return n.n5;
    }, nA, Io(JN))))), tA = oc(rA), eA = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), uA = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(eA)))), aA = Po(A4(rc, "checks", function(n) {
        return n.jI;
    }, tA, A4(rc, "configuration", function(n) {
        return n.aj;
    }, uA, Io(XN)))), iA = oc(aA), oA = A2(Gb, zi(A2(No, function(n) {
        return n.aj;
    }, function(n) {
        return n.mm;
    })), dc(A2(Ho, iA, So(YN)))), cA = A2(Yi, ZN, oA), sA = A2(pc, T([
        cA
    ]), QN), fA = function(n) {
        return d(Ri(function(r) {
            return p(r, {
                m6: "Type",
                ss: _N(n.n5)
            });
        }), Ri(function(r) {
            return p(r, {
                m6: "Min (ms for silence, frame for blackframe)",
                ss: It(n.nT)
            });
        }), Ri(function(r) {
            return p(r, {
                m6: "Max (ms for silence, frame for blackframe)",
                ss: It(n.nK)
            });
        }));
    }, lA = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), mA = function(n) {
        return {
            $: 11,
            a: n
        };
    }, dA = F2(function(n, r) {
        return {
            jI: r,
            n5: n
        };
    }), bA = F2(function(n, r) {
        return {
            n5: n,
            aR: r
        };
    }), pA = F2(function(n, r) {
        return {
            nK: r,
            nT: n
        };
    }), vA = Po(A4(rc, "max", function(n) {
        return n.nK;
    }, uc, A4(rc, "min", function(n) {
        return n.nT;
    }, uc, Io(pA)))), $A = Po(A4(rc, "parameters", function(n) {
        return n.aR;
    }, vA, A4(rc, "name", function(n) {
        return n.n5;
    }, nA, Io(bA)))), gA = oc($A), hA = Po(A4(rc, "checks", function(n) {
        return n.jI;
    }, gA, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(dA)))), kA = function(n) {
        return A2(Yc, Ko, pt(A2(_o, F2(function(n, r) {
            var t = r.b, e = r.c, u = GN(r.a.ss);
            return u.$ ? Tt : kt(A2(bA, u.a, A2(pA, A2(ju, 0, ze(t.ss)), A2(ju, 0, ze(e.ss)))));
        }), n)));
    }, TA = function(n) {
        return A2(Yi, mA, function(n) {
            return dc(fg(A3(ag, hA, {
                jI: kA(n.jI),
                n5: n.n5.ss
            }, rg(YN))));
        }(n));
    }, wA = function(n) {
        return {
            $: 13,
            a: n
        };
    }, CA = function(n) {
        return ml(KN({
            $: 3,
            a: n
        }));
    }, NA = F3(function(n, r, t) {
        return {
            jI: t,
            mm: n,
            n5: r
        };
    }), AA = Po(A4(rc, "checks", function(n) {
        return n.jI;
    }, gA, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(NA))))), SA = function(n) {
        return {
            $: 12,
            a: n
        };
    }, LA = function(n) {
        return A2(Yi, SA, function(n) {
            var r = CA(A2(ju, "", A2(Fu, A2(No, function(n) {
                return n.aj;
            }, function(n) {
                return n.mm;
            }), n.oR)));
            return dc(fg(A3(ag, AA, {
                jI: kA(n.jI),
                mm: A2(ju, "", A2(Fu, A2(bu, function(n) {
                    return n.mm;
                }, function(n) {
                    return n.aj;
                }), n.oR)),
                n5: n.n5.ss
            }, mg(r))));
        }(n));
    }, yA = function(n) {
        return A2(_o, F2(function(n, r) {
            return fA(r);
        }), Jo(A2(zt, x$, n)));
    }, FA = function(n) {
        return {
            jI: A2(ju, Au, A2(Fu, A2(bu, yA, function(n) {
                return n.jI;
            }), n)),
            n5: Ri(function(r) {
                return p(r, {
                    m6: "Name",
                    ss: A2(ju, "", A2(Fu, A2(bu, function(n) {
                        return n.n5;
                    }, function(n) {
                        return n.aj;
                    }), n))
                });
            }),
            oR: n
        };
    }, jA = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(FA(Tt))
                }));
            case 3:
                return A2(pc, g, p(r, {
                    kN: kt(FA(kt(n.a)))
                }));
            case 4:
                var t = r.kN;
                return A2(pc, 1 === t.$ ? g : T(1 === (u = t.a).oR.$ ? [
                    TA(u)
                ] : [
                    LA(u)
                ]), r);
            case 5:
                return A2(pc, T([
                    (f = n.a, A2(Yi, wA, function(n) {
                        return dc(fg(A3(ag, AA, {
                            jI: g,
                            mm: n.aj.mm,
                            n5: n.aj.n5
                        }, sg(CA(n.aj.mm)))));
                    }(f)))
                ]), r);
            case 6:
                return A2(pc, g, p(r, {
                    kN: Tt
                }));
            case 7:
                var e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, e, n.n5)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: u
                }));
            case 11:
                return (a = n.a).$ ? A2(pc, g, A2(lA, a.a, r)) : A2(pc, T([
                    cA
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Template created")
                }));
            case 12:
                return (a = n.a).$ ? A2(pc, g, A2(lA, a.a, r)) : A2(pc, T([
                    cA
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Template updated")
                }));
            case 13:
                return (a = n.a).$ ? A2(pc, g, A2(lA, a.a, r)) : A2(pc, T([
                    cA
                ]), r);
            case 1:
                var a;
                return A2(pc, g, (a = n.a).$ ? A2(lA, a.a, r) : p(r, {
                    kv: a.a
                }));
            case 14:
                var o = fA(A3(JN, 0, 1e3, 2e3)), c = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.jI)));
                }, r.kN));
                return u = A2(Fu, function(n) {
                    return p(n, {
                        jI: A3(wu, c + 1, o, n.jI)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 8:
                e = n.a;
                var s = n.b;
                return u = A2(Fu, function(n) {
                    return p(n, {
                        jI: A2(_o, F2(function(n, r) {
                            var t = r.a, u = r.b, a = r.c;
                            return i(n, s) ? d(A2(gg, e, t), u, a) : d(t, u, a);
                        }), n.jI)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 9:
                return e = n.a, s = n.b, u = A2(Fu, function(n) {
                    return p(n, {
                        jI: A2(_o, F2(function(n, r) {
                            var t = r.a, u = r.b, a = r.c;
                            return i(n, s) ? d(t, A2(gg, e, u), a) : d(t, u, a);
                        }), n.jI)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 10:
                return e = n.a, s = n.b, u = A2(Fu, function(n) {
                    return p(n, {
                        jI: A2(_o, F2(function(n, r) {
                            var t = r.a, u = r.b, a = r.c;
                            return i(n, s) ? d(t, u, A2(gg, e, a)) : d(t, u, a);
                        }), n.jI)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            default:
                return s = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        jI: A2(U$, F2(function(n) {
                            return !i(n, s);
                        }), n.jI)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
        }
        var f;
    }), PA = {
        $: 2
    }, IA = function(n) {
        return {
            $: 3,
            a: n
        };
    }, BA = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MA = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), OA = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: MA(r)
        });
    }), qA = T([
        Rg("Table")
    ]), DA = function(n) {
        return n.n5 ? "blackframe \u2208 [ frame " + It(n.nT) + ", frame " + It(n.nK) + "]" : "silence \u2208 [" + It(n.nT) + " ms, " + It(n.nK) + " ms]";
    }, xA = function(n) {
        return A3(qt, F2(function(n, r) {
            return $(r, $(qe(r) > 0 ? ", " : "", DA(n)));
        }), "", n);
    }, RA = uh({
        jY: T([
            A2(RN, "Name", A2(No, function(n) {
                return n.aj;
            }, function(n) {
                return n.n5;
            })),
            A2(RN, "Description", A2(bu, xA, function(n) {
                return n.jI;
            })),
            A2(OA, "", A2(bu, Nh("Edit"), IA)),
            A2(OA, "", A2(bu, Nh("Delete"), BA))
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: qA,
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: A2(No, function(n) {
            return n.aj;
        }, function(n) {
            return n.mm;
        }),
        rW: function(n) {
            return {
                $: 0,
                a: n
            };
        }
    }), VA = {
        $: 6
    }, EA = function(n) {
        return {
            $: 7,
            a: n
        };
    }, zA = {
        $: 14
    }, UA = {
        $: 4
    }, HA = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), WA = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), QA = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), ZA = xg("max"), KA = xg("min"), YA = F3(function(n, r, t) {
        return A2(Rh, n, A2(Eh, T([
            Rg("InputText"),
            Xh(n.kV),
            Ch("number"),
            ek(Fh),
            _h(jh),
            nk(Ph),
            ak(n.ss),
            uk(n.gt),
            zh(Kh(n.m6)),
            Vh(n.kQ),
            KA(A2(ju, "", A2(Fu, It, r))),
            ZA(A2(ju, "", A2(Fu, It, t))),
            n.d7 ? Mh(!0) : Oh(g)
        ]), g));
    }), XA = F3(function(n, r, t) {
        return A2(jT, n, A3(YA, n, r, t));
    }), JA = function(n) {
        return A2(wT, function(n) {
            var r, t, e, u = function(n) {
                return A2(ju, !1, A2(Fu, function() {
                    return !0;
                }, n.oR));
            }(n) ? m("Save", "Edit Template") : m("Create", "New Template");
            return A4(ZT, u.b, m(u.a, UA), m("Cancel", VA), T([
                A2(dk, EA, IT(n.n5)),
                (r = n.jI, t = T([
                    m("silence", "silence"),
                    m("blackframe", "blackframe")
                ]), e = F2(function(n, r) {
                    var e, u = r.a, a = r.b, i = r.c;
                    return A2(Le, T([
                        A2(ph, "position", "relative"),
                        A2(ph, "margin", "10px"),
                        A2(ph, "padding", "5px")
                    ]), T([
                        A2(dk, function(r) {
                            return A2(QA, r, n);
                        }, A2(ET, u, t)),
                        A2(dk, function(r) {
                            return A2(WA, r, n);
                        }, A3(XA, a, kt(0), Tt)),
                        A2(dk, function(r) {
                            return A2(HA, r, n);
                        }, A3(XA, i, kt(0), Tt)),
                        A3(JT, "remove", T([
                            m("position", "absolute"),
                            m("left", "0")
                        ]), (e = n, {
                            $: 15,
                            a: e
                        }))
                    ]));
                }), A2(Le, T([
                    A2(ph, "padding", "10px 0")
                ]), A2(Ge, Ko, pt(A2(_o, e, r))))),
                A2(Nh, "Add New Check", zA)
            ]));
        }, n.kN);
    }, GA = F2(function(n, r) {
        return A3(hw, "Deep Probe Templates", kt(A2(Nh, "New\u2026", PA)), A2(Le, g, T([
            JA(r),
            A3(cT, RA, r.rJ, r.kv)
        ])));
    }), _A = {
        l: function(n) {
            return n.cF;
        },
        m: sA,
        o: F2(function(n, r) {
            return p(n, {
                cF: r
            });
        }),
        p: function(n) {
            return {
                $: 17,
                a: n
            };
        },
        q: jA,
        r: GA
    }, nS = {
        kN: Tt,
        lm: Tt,
        cX: g,
        lV: g,
        pw: Ri(function(n) {
            return p(n, {
                gt: "Search Formats by Name, Specification, AudioCodec, Start Timecode, Frame Rate or FFMpeg Args",
                ss: ""
            });
        }),
        dw: g,
        rv: Tt,
        rJ: a$("Name"),
        dA: Au
    }, rS = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tS = F4(function(n, r, t, e) {
        return {
            cX: n,
            lW: r,
            dw: e,
            dA: t
        };
    }), eS = function(n) {
        switch(n){
            case "pcm_s16le":
                return St(1);
            case "pcm_s24le":
                return St(0);
            case "pcm_s24be":
                return St(2);
            case "libfdk_aac":
                return St(3);
            case "libmp3lame":
                return St(4);
            case "MOV_Conteneur":
                return St(5);
            default:
                return wt(p(A2(ki, "can't parse str to audio codec", f$), {
                    N: !0,
                    ag: !0
                }));
        }
    }, uS = function(n) {
        switch(n){
            case 1:
                return "pcm_s16le";
            case 0:
                return "pcm_s24le";
            case 2:
                return "pcm_s24be";
            case 3:
                return "libfdk_aac";
            case 4:
                return "libmp3lame";
            default:
                return "MOV_Conteneur";
        }
    }, aS = A2(Il, uS, eS), iS = F2(function(n, r) {
        return {
            jQ: r,
            jR: n
        };
    }), oS = Po(A4(rc, "clipMax", function(n) {
        return n.jQ;
    }, uc, A4(rc, "clipMin", function(n) {
        return n.jR;
    }, uc, Io(iS)))), cS = F4(function(n, r, t, e) {
        return {
            ej: e,
            fM: n,
            gS: r,
            hZ: t
        };
    }), sS = Po(A4(rc, "bottomPx", function(n) {
        return n.ej;
    }, uc, A4(rc, "topPx", function(n) {
        return n.hZ;
    }, uc, A4(rc, "rightPx", function(n) {
        return n.gS;
    }, uc, A4(rc, "leftPx", function(n) {
        return n.fM;
    }, uc, Io(cS)))))), fS = X, lS = hn, mS = A2(Di, lS, fS), dS = function(n) {
        switch(n){
            case "Mxf":
                return St(0);
            case "Mp4":
                return St(1);
            case "ProRes422":
                return St(2);
            case "ProRes4444":
                return St(3);
            case "TwoPass":
                return St(4);
            case "AVCIntra100":
                return St(5);
            case "IMX50":
                return St(6);
            case "Mp4Salto":
                return St(7);
            case "MxfProgressive":
                return St(12);
            case "MovH264":
                return St(8);
            case "MkvH264":
                return St(9);
            case "MovHevc":
                return St(10);
            case "Mp4Hevc":
                return St(11);
            case "XAVCIntra300":
                return St(13);
            case "WMV":
                return St(14);
            case "Demux":
                return St(15);
            case "AudioExtract":
                return St(16);
            default:
                return wt(A2(ki, "Unknown format spec", f$));
        }
    }, bS = function(n) {
        switch(n){
            case 0:
                return "Mxf";
            case 1:
                return "Mp4";
            case 2:
                return "ProRes422";
            case 3:
                return "ProRes4444";
            case 4:
                return "TwoPass";
            case 5:
                return "AVCIntra100";
            case 6:
                return "IMX50";
            case 7:
                return "Mp4Salto";
            case 12:
                return "MxfProgressive";
            case 8:
                return "MovH264";
            case 9:
                return "MkvH264";
            case 10:
                return "MovHevc";
            case 11:
                return "Mp4Hevc";
            case 13:
                return "XAVCIntra300";
            case 14:
                return "WMV";
            case 15:
                return "Demux";
            default:
                return "AudioExtract";
        }
    }, pS = A2(Il, bS, dS), vS = F3(function(n, r, t) {
        return {
            cG: t,
            mm: n,
            c9: r
        };
    }), $S = Po(A4(rc, "denominator", function(n) {
        return n.cG;
    }, uc, A4(rc, "numerator", function(n) {
        return n.c9;
    }, uc, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(vS))))), gS = F8(function(n, r, t, e, u, a, i, o) {
        return {
            jU: u,
            jV: e,
            ks: a,
            mc: i,
            m3: o,
            ne: t,
            pd: r,
            pi: n
        };
    }), hS = Po(A4(rc, "keyframe", function(n) {
        return n.m3;
    }, uc, A4(rc, "highTiers", function(n) {
        return n.mc;
    }, no, A4(rc, "curveTransfert", function(n) {
        return n.ks;
    }, xi, A4(rc, "colorPrimaries", function(n) {
        return n.jU;
    }, xi, A4(rc, "colorspace", function(n) {
        return n.jV;
    }, xi, A4(rc, "level", function(n) {
        return n.ne;
    }, xi, A4(rc, "preset", function(n) {
        return n.pd;
    }, xi, A4(rc, "profil", function(n) {
        return n.pi;
    }, xi, Io(gS)))))))))), kS = F8(function(n, r, t, e, u, a, i, o) {
        return {
            iy: u,
            iU: r,
            iV: t,
            jw: e,
            j7: n,
            kD: i,
            pu: o,
            sw: a
        };
    }), TS = Po(A4(Do, "qmax", function(n) {
        return n.pu;
    }, uc, A4(rc, "deint", function(n) {
        return n.kD;
    }, no, A4(rc, "version12", function(n) {
        return n.sw;
    }, no, A4(Do, "afd", function(n) {
        return n.iy;
    }, uc, A4(rc, "BWF", function(n) {
        return n.jw;
    }, no, A4(rc, "as11", function(n) {
        return n.iV;
    }, no, A4(rc, "as10", function(n) {
        return n.iU;
    }, no, A4(rc, "controlInstantaneousBitrate", function(n) {
        return n.j7;
    }, no, Io(kS)))))))))), wS = F4(function(n, r, t, e) {
        return {
            fk: r,
            p0: t,
            p2: e,
            id: n
        };
    }), CS = Po(A4(rc, "scaleLetterbox", function(n) {
        return n.p2;
    }, no, A4(rc, "scaleAspectRatio", function(n) {
        return n.p0;
    }, no, A4(rc, "heightScale", function(n) {
        return n.fk;
    }, uc, A4(rc, "widthScale", function(n) {
        return n.id;
    }, uc, Io(wS)))))), NS = function(n) {
        switch(n){
            case "PARTIAL":
                return St(0);
            case "COMPLETE":
                return St(1);
            case "COMPLETE_WITHOUT_PARTIAL":
                return St(2);
            case "SDH":
                return St(3);
            default:
                return wt("Not a subtitle type version");
        }
    }, AS = function(n) {
        switch(n){
            case 0:
                return "PARTIAL";
            case 1:
                return "COMPLETE";
            case 2:
                return "COMPLETE_WITHOUT_PARTIAL";
            default:
                return "SDH";
        }
    }, SS = A2(Il, AS, NS), LS = F2(function(n, r) {
        return {
            dX: r,
            eb: n
        };
    }), yS = F8(function(n, r, t, e, u, a, i, o) {
        return {
            dW: e,
            eS: t,
            ft: n,
            c$: r,
            hc: a,
            he: i,
            du: u,
            hF: o
        };
    }), FS = function(n) {
        switch(n){
            case "Mire":
                return St(0);
            case "Black":
                return St(1);
            case "Slate":
                return St(2);
            case "Video":
                return St(3);
            case "Countdown":
                return St(4);
            default:
                return wt("not a Segment Kind");
        }
    }, jS = function(n) {
        switch(n){
            case 0:
                return "Mire";
            case 1:
                return "Black";
            case 2:
                return "Slate";
            case 3:
                return "Video";
            default:
                return "Countdown";
        }
    }, PS = A2(Il, jS, FS), IS = Po(A4(rc, "subtract", function(n) {
        return n.hF;
    }, no, A4(Do, "sourceKey", function(n) {
        return n.he;
    }, xi, A4(Do, "sourceBucket", function(n) {
        return n.hc;
    }, xi, A4(Do, "sourceName", function(n) {
        return n.du;
    }, xi, A4(rc, "additionalFrameCount", function(n) {
        return n.dW;
    }, uc, A4(rc, "duration", function(n) {
        return n.eS;
    }, uc, A4(rc, "kind", function(n) {
        return n.c$;
    }, PS, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, Io(yS)))))))))), BS = Po(A4(rc, "after", function(n) {
        return n.dX;
    }, oc(IS), A4(rc, "before", function(n) {
        return n.eb;
    }, oc(IS), Io(LS)))), MS = Po(A4(rc, "copyMetadata", function(n) {
        return n.ka;
    }, no, A4(Do, "subtitleFormat", function(n) {
        return n.rm;
    }, xi, A4(Do, "subtitleTypeVersion", function(n) {
        return n.rr;
    }, SS, A4(Do, "subtitleVersion", function(n) {
        return n.rs;
    }, h$, A4(rc, "qcReportTemplate", function(n) {
        return n.pr;
    }, xi, A4(rc, "qcTestPlan", function(n) {
        return n.ps;
    }, xi, A4(Do, "hevcParams", function(n) {
        return n.F;
    }, hS, A4(Do, "clip", function(n) {
        return n.bG;
    }, oS, A4(Do, "scale", function(n) {
        return n.aU;
    }, CS, A4(Do, "crop", function(n) {
        return n.aG;
    }, sS, A4(rc, "encodeSubtitle", function(n) {
        return n.lg;
    }, no, A4(Do, "videoBitrate", function(n) {
        return n.sB;
    }, mS, A4(rc, "writeTimecode", function(n) {
        return n.sJ;
    }, no, A4(Do, "videoEdit", function(n) {
        return n.dL;
    }, BS, A4(Do, "audioGain", function(n) {
        return n.i1;
    }, mS, A4(Do, "loudnessTruePeak", function(n) {
        return n.nt;
    }, mS, A4(Do, "loudnessProgram", function(n) {
        return n.nr;
    }, mS, A4(Do, "loudnessRange", function(n) {
        return n.ns;
    }, mS, A4(Do, "noLoudness", function(n) {
        return n.oi;
    }, no, A4(Do, "options", function(n) {
        return n.M;
    }, TS, A4(Do, "bmxArgs", function(n) {
        return n.jh;
    }, xi, A4(Do, "audioArgs", function(n) {
        return n.iZ;
    }, xi, A4(Do, "ffmpegArgs", function(n) {
        return n.lz;
    }, xi, A4(rc, "noFrameRateConversion", function(n) {
        return n.oh;
    }, no, A4(rc, "frameRate", function(n) {
        return n.lU;
    }, $S, A4(rc, "startTimecode", function(n) {
        return n.q4;
    }, xi, A4(Do, "audioBitrate", function(n) {
        return n.i_;
    }, uc, A4(rc, "audioCodec", function(n) {
        return n.i$;
    }, aS, A4(rc, "specification", function(n) {
        return n.qY;
    }, pS, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(T) {
                                                                                            return function(w) {
                                                                                                return function(C) {
                                                                                                    return function(N) {
                                                                                                        return function(A) {
                                                                                                            return function(S) {
                                                                                                                return function(L) {
                                                                                                                    return function(y) {
                                                                                                                        return function(F) {
                                                                                                                            return function(j) {
                                                                                                                                return {
                                                                                                                                    iZ: s,
                                                                                                                                    i_: u,
                                                                                                                                    i$: e,
                                                                                                                                    i1: v,
                                                                                                                                    jh: f,
                                                                                                                                    bG: C,
                                                                                                                                    ka: j,
                                                                                                                                    aG: T,
                                                                                                                                    lg: k,
                                                                                                                                    lz: c,
                                                                                                                                    lU: i,
                                                                                                                                    F: N,
                                                                                                                                    mm: n,
                                                                                                                                    nr: b,
                                                                                                                                    ns: d,
                                                                                                                                    nt: p,
                                                                                                                                    n5: r,
                                                                                                                                    oh: o,
                                                                                                                                    oi: m,
                                                                                                                                    M: l,
                                                                                                                                    pr: S,
                                                                                                                                    ps: A,
                                                                                                                                    aU: w,
                                                                                                                                    qY: t,
                                                                                                                                    q4: a,
                                                                                                                                    rm: F,
                                                                                                                                    rr: y,
                                                                                                                                    rs: L,
                                                                                                                                    sB: h,
                                                                                                                                    dL: $,
                                                                                                                                    sJ: g
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))))))), OS = oc(MS), qS = function(n) {
        return {
            $: 10,
            a: n
        };
    }, DS = ml(qS({
        $: 0
    })), xS = dc(A2(Ho, OS, So(DS))), RS = oc($S), VS = ml(qS({
        $: 2
    })), ES = dc(A2(Ho, RS, So(VS))), zS = F7(function(n, r, t, e, u, a, i) {
        return {
            kT: a,
            lC: t,
            mm: n,
            n5: r,
            b2: i,
            rn: u,
            rq: e
        };
    }), US = function(n) {
        switch(n){
            case "open_subtitling":
                return St(0);
            case "teletext_level_1":
                return St(1);
            case "teletext_level_2":
                return St(2);
            default:
                return wt(A2(ki, "Unknown subtitle display standard", f$));
        }
    }, HS = function(n) {
        switch(n){
            case 0:
                return "open_subtitling";
            case 1:
                return "teletext_level_1";
            default:
                return "teletext_level_2";
        }
    }, WS = A2(Il, HS, US), QS = function(n) {
        switch(n){
            case "STL":
                return St(0);
            case "WebVTT":
                return St(1);
            case "SRT":
                return St(2);
            case "ASS":
                return St(3);
            default:
                return wt(A2(ki, "Unknown subtitle file format", f$));
        }
    }, ZS = function(n) {
        switch(n){
            case 0:
                return "STL";
            case 1:
                return "WebVTT";
            case 2:
                return "SRT";
            default:
                return "ASS";
        }
    }, KS = A2(Il, ZS, QS), YS = Po(A4(Do, "offset", function(n) {
        return n.b2;
    }, xi, A4(Do, "display_standard", function(n) {
        return n.kT;
    }, WS, A4(Do, "frame_rate", function(n) {
        return n.rn;
    }, $S, A4(Do, "start_timecode", function(n) {
        return n.rq;
    }, xi, A4(rc, "format", function(n) {
        return n.lC;
    }, KS, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(zS))))))))), XS = oc(YS), JS = function(n) {
        return {
            $: 11,
            a: n
        };
    }, GS = ml(JS({
        $: 0
    })), _S = dc(A2(Ho, XS, So(GS))), nL = F3(function(n, r, t) {
        return {
            bA: t,
            mm: n,
            n5: r
        };
    }), rL = Po(A4(rc, "batonIdentifier", function(n) {
        return n.bA;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(nL))))), tL = oc(rL), eL = function(n) {
        return {
            $: 9,
            a: n
        };
    }, uL = ml(eL({
        $: 0
    })), aL = A2(Gb, Jo, A2(Gb, Ge(function(n) {
        return m(n.mm, n);
    }), dc(A2(Ho, tL, So(uL))))), iL = F5(function(n, r, t, e, u) {
        return A2(_e, function(r) {
            return A2(_e, function(t) {
                return A2(_e, function(e) {
                    return A2(_e, function(u) {
                        return Ke(A4(n, r, t, e, u));
                    }, u);
                }, e);
            }, t);
        }, r);
    }), oL = iL, cL = A2(Yi, rS, A5(oL, tS, xS, ES, aL, _S)), sL = m(nS, cL), fL = function(n) {
        return {
            $: 59,
            a: n
        };
    }, lL = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), mL = Q, dL = Oi({
        bN: "Add after video...",
        bT: "Ajouter apr\xe8s la vid\xe9o..."
    }), bL = Oi({
        bN: "Add before video...",
        bT: "Ajouter avant la vid\xe9o..."
    }), pL = T([
        m("Mire", "Mire"),
        m("Black", "Noir"),
        m("Slate", "Panneau"),
        m("Video", "Video"),
        m("Countdown", "Compte \xe0 rebours")
    ]), vL = function(n) {
        var r, t = A2(ju, "", A2(Fu, g$, A2(fp, function(n) {
            return n.rs;
        }, n))), e = A2(ju, "", A2(Fu, AS, A2(fp, function(n) {
            return n.rr;
        }, n))), u = A2(ju, "", A2(fp, function(n) {
            return n.rm;
        }, n)), a = function(n) {
            return A2(No, Fu(n), ju(""));
        };
        return {
            iy: Ri(function(r) {
                return p(r, {
                    m6: "AFD",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return A2(fp, function(n) {
                            return n.iy;
                        }, n.M);
                    }, n)))
                });
            }),
            iU: ro(function(r) {
                return p(r, {
                    m6: "AS10",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.iU;
                        }, n.M);
                    }, n))
                });
            }),
            iV: ro(function(r) {
                return p(r, {
                    m6: "AS11",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.iV;
                        }, n.M);
                    }, n))
                });
            }),
            iZ: Ri(function(r) {
                return p(r, {
                    m6: "Args",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.iZ;
                    }, n))
                });
            }),
            i_: Ri(function(r) {
                return p(r, {
                    m6: "Audio Bitrate (kb/s)",
                    ss: A2(ju, "384", A2(Fu, It, A2(fp, function(n) {
                        return n.i_;
                    }, n)))
                });
            }),
            i$: Ri(function(r) {
                return p(r, {
                    m6: "Codec",
                    ss: A2(a, A2(No, function(n) {
                        return n.i$;
                    }, uS), n)
                });
            }),
            i1: Ri(function(r) {
                return p(r, {
                    m6: "Gain",
                    ss: A2(ju, "0", A2(Fu, mL, A2(fp, function(n) {
                        return n.i1;
                    }, n)))
                });
            }),
            jh: Ri(function(r) {
                return p(r, {
                    m6: "BMX Args",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.jh;
                    }, n))
                });
            }),
            ju: ro(function(n) {
                return p(n, {
                    m6: "Burned subtitle",
                    ss: "" !== t && "" !== e
                });
            }),
            jw: ro(function(r) {
                return p(r, {
                    m6: "BWF wrapping",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.jw;
                        }, n.M);
                    }, n))
                });
            }),
            jQ: Ri(function(r) {
                return p(r, {
                    m6: "value max (luminance)",
                    ss: A2(ju, "235", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.jQ);
                        }, n.bG);
                    }, n))
                });
            }),
            jR: Ri(function(r) {
                return p(r, {
                    m6: "Value min (luminance)",
                    ss: A2(ju, "16", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.jR);
                        }, n.bG);
                    }, n))
                });
            }),
            jU: Ri(function(r) {
                return p(r, {
                    m6: "Color Primaries",
                    ss: A2(ju, "bt709", A2(Fu, function(n) {
                        return n.jU;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            jV: Ri(function(r) {
                return p(r, {
                    m6: "Colorspace",
                    ss: A2(ju, "bt709", A2(Fu, function(n) {
                        return n.jV;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            j7: ro(function(r) {
                return p(r, {
                    m6: "Control instantaneous bitrate",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.j7;
                        }, n.M);
                    }, n))
                });
            }),
            ka: ro(function(r) {
                return p(r, {
                    m6: "Copy metadata",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.ka;
                    }, n))
                });
            }),
            kh: Ri(function(r) {
                return p(r, {
                    m6: "Crop pixel bottom",
                    ss: A2(ju, "0", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.ej);
                        }, n.aG);
                    }, n))
                });
            }),
            ki: Ri(function(r) {
                return p(r, {
                    m6: "Crop pixel left",
                    ss: A2(ju, "0", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.fM);
                        }, n.aG);
                    }, n))
                });
            }),
            kj: Ri(function(r) {
                return p(r, {
                    m6: "Crop pixel right",
                    ss: A2(ju, "0", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.gS);
                        }, n.aG);
                    }, n))
                });
            }),
            kk: Ri(function(r) {
                return p(r, {
                    m6: "Crop pixel top",
                    ss: A2(ju, "0", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.hZ);
                        }, n.aG);
                    }, n))
                });
            }),
            ks: Ri(function(r) {
                return p(r, {
                    m6: "CurveTransfert",
                    ss: A2(ju, "bt709", A2(Fu, function(n) {
                        return n.ks;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            kD: ro(function(r) {
                return p(r, {
                    m6: "Force deinterlacing",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.kD;
                        }, n.M);
                    }, n))
                });
            }),
            lg: ro(function(r) {
                return p(r, {
                    m6: "Encode ASS Subtitle File",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.lg;
                    }, n))
                });
            }),
            lz: Ri(function(r) {
                return p(r, {
                    m6: "Args",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.lz;
                    }, n))
                });
            }),
            lU: Ri(function(r) {
                return p(r, {
                    m6: "FrameRate",
                    ss: A2(a, A2(No, function(n) {
                        return n.lU;
                    }, function(n) {
                        return n.mm;
                    }), n)
                });
            }),
            mc: ro(function(r) {
                return p(r, {
                    m6: "HighTiers",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.mc;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            m3: Ri(function(r) {
                return p(r, {
                    m6: "Keyframe",
                    ss: A2(ju, "250", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.m3);
                        }, n.F);
                    }, n))
                });
            }),
            ne: Ri(function(r) {
                return p(r, {
                    m6: "Level",
                    ss: A2(ju, "0", A2(Fu, function(n) {
                        return n.ne;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            nr: Ri(function(r) {
                return p(r, {
                    m6: "Target Program Loudness",
                    ss: A2(ju, "-23", A2(Fu, mL, A2(fp, function(n) {
                        return n.nr;
                    }, n)))
                });
            }),
            ns: Ri(function(r) {
                return p(r, {
                    m6: "Target Loudness Range",
                    ss: A2(ju, "11", A2(Fu, mL, A2(fp, function(n) {
                        return n.ns;
                    }, n)))
                });
            }),
            nt: Ri(function(r) {
                return p(r, {
                    m6: "Target True Peak",
                    ss: A2(ju, "-1.3", A2(Fu, mL, A2(fp, function(n) {
                        return n.nt;
                    }, n)))
                });
            }),
            n5: Ri(function(r) {
                return p(r, {
                    m6: "Name",
                    ss: A2(a, function(n) {
                        return n.n5;
                    }, n)
                });
            }),
            oh: ro(function(r) {
                return p(r, {
                    m6: "No FrameRate Conversion",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.oh;
                    }, n))
                });
            }),
            oi: ro(function(r) {
                return p(r, {
                    m6: "No Loudness",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return n.oi;
                    }, n))
                });
            }),
            oR: n,
            pd: Ri(function(r) {
                return p(r, {
                    m6: "Preset",
                    ss: A2(ju, "medium", A2(Fu, function(n) {
                        return n.pd;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            pi: Ri(function(r) {
                return p(r, {
                    m6: "Profil",
                    ss: A2(ju, "main", A2(Fu, function(n) {
                        return n.pi;
                    }, A2(fp, function(n) {
                        return n.F;
                    }, n)))
                });
            }),
            pr: Ri(function(r) {
                return p(r, {
                    m6: "QC report template",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.pr;
                    }, n))
                });
            }),
            ps: Ri(function(r) {
                return p(r, {
                    m6: "QC test plan",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.ps;
                    }, n))
                });
            }),
            pu: Ri(function(r) {
                return p(r, {
                    m6: "Overwrite qmax",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return A2(fp, function(n) {
                            return n.pu;
                        }, n.M);
                    }, n)))
                });
            }),
            p0: ro(function(r) {
                return p(r, {
                    m6: "Enable Keep aspect ratio",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.p0;
                    }, A2(fp, function(n) {
                        return n.aU;
                    }, n)))
                });
            }),
            p1: Ri(function(r) {
                return p(r, {
                    m6: "Height",
                    ss: A2(ju, "1080", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.fk);
                        }, n.aU);
                    }, n))
                });
            }),
            p2: ro(function(r) {
                return p(r, {
                    m6: "Enable Letterbox and Pillarbox",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.p2;
                    }, A2(fp, function(n) {
                        return n.aU;
                    }, n)))
                });
            }),
            p3: Ri(function(r) {
                return p(r, {
                    m6: "Width",
                    ss: A2(ju, "1920", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return It(n.id);
                        }, n.aU);
                    }, n))
                });
            }),
            qA: ro(function(r) {
                return p(r, {
                    m6: "Clip / PSE Parameters",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function() {
                            return !0;
                        }, n.bG);
                    }, n))
                });
            }),
            qB: ro(function(r) {
                return p(r, {
                    m6: "Crop Parameters",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function() {
                            return !0;
                        }, n.aG);
                    }, n))
                });
            }),
            qH: ro(function(r) {
                return p(r, {
                    m6: "HEVC : ",
                    ss: A2(ju, !0, A2(fp, function(n) {
                        return A2(Fu, function() {
                            return !0;
                        }, n.F);
                    }, n))
                });
            }),
            qL: ro(function(r) {
                return p(r, {
                    m6: "Scale Parameters",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function() {
                            return !0;
                        }, n.aU);
                    }, n))
                });
            }),
            qY: Ri(function(r) {
                return p(r, {
                    m6: "Specification",
                    ss: A2(a, A2(No, function(n) {
                        return n.qY;
                    }, bS), n)
                });
            }),
            q4: Ri(function(r) {
                return p(r, {
                    m6: "Start Timecode",
                    ss: A2(a, function(n) {
                        return n.q4;
                    }, n)
                });
            }),
            re: kt((r = n.$ ? Tt : n.a.dL, {
                iz: p(sf, {
                    jL: pL,
                    gt: dL
                }),
                jd: p(sf, {
                    jL: pL,
                    gt: bL
                }),
                dL: A2(ju, A2(LS, g, g), r)
            })),
            rm: Ri(function(n) {
                return p(n, {
                    m6: "Subtitle format",
                    ss: u
                });
            }),
            rr: Ri(function(n) {
                return p(n, {
                    m6: "Subtitle type version",
                    ss: e
                });
            }),
            rs: Ri(function(n) {
                return p(n, {
                    m6: "Subtitle version",
                    ss: t
                });
            }),
            sw: ro(function(r) {
                return p(r, {
                    m6: "Version 1.2",
                    ss: A2(ju, !1, A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.sw;
                        }, n.M);
                    }, n))
                });
            }),
            sB: Ri(function(r) {
                return p(r, {
                    m6: "Bitrate (Mbits/s)",
                    ss: A2(ju, "5", A2(Fu, mL, A2(fp, function(n) {
                        return n.sB;
                    }, n)))
                });
            }),
            sJ: ro(function(r) {
                return p(r, {
                    m6: "Write Timecode",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.sJ;
                    }, n))
                });
            })
        };
    }, $L = T([
        0,
        12
    ]), gL = T([
        1,
        11,
        7,
        8,
        10,
        9,
        4,
        14
    ]), hL = function(n) {
        return {
            $: 53,
            a: n
        };
    }, kL = T([
        16
    ]), TL = {
        lA: Au,
        c$: 3,
        nO: "",
        ar: pi,
        N: !0,
        P: 500,
        ag: !1
    }, wL = T([
        0,
        2,
        3,
        5,
        6,
        12,
        13,
        1,
        11,
        7,
        8,
        10,
        9,
        4,
        14
    ]), CL = F4(function(n, r, t, e) {
        return {
            d5: r,
            hl: n,
            hC: e,
            hD: t
        };
    }), NL = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Tt : kt(A2(n, r.a, t.a));
    }), AL = F5(function(n, r, t, e, u) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ || 1 === u.$ ? Tt : kt(A4(n, r.a, t.a, e.a, u.a));
    }), SL = F5(function(n, r, t, e, u) {
        if (1 === r.$) return wt(r.a);
        var a = r.a;
        if (1 === t.$) return wt(t.a);
        var i = t.a;
        if (1 === e.$) return wt(e.a);
        var o = e.a;
        return 1 === u.$ ? wt(u.a) : St(A4(n, a, i, o, u.a));
    }), LL = T([
        1,
        4,
        7,
        8,
        10,
        11,
        9
    ]), yL = T([
        0,
        5,
        6,
        12,
        13
    ]), FL = T([
        0,
        12,
        6
    ]), jL = function(n) {
        var r = function(r) {
            return A2(G$, r, kL) ? n.sJ.ss : !A2(G$, r, LL) || n.sJ.ss;
        }, t = function(r) {
            return 1 === r || 11 === r || 10 === r || 8 === r || 9 === r || 14 === r ? Qs(n.sB.ss) : Tt;
        }, e = "" === n.rs.ss ? St(Tt) : A2(X$, function(n) {
            return kt(n);
        }, $$(n.rs.ss)), u = A2(hi, function(n) {
            return A2(ki, n, TL);
        }, e), a = "" === n.rm.ss ? Tt : kt(n.rm.ss), i = "" === n.rr.ss ? St(Tt) : A2(X$, function(n) {
            return kt(n);
        }, NS(n.rr.ss)), o = A2(hi, function(n) {
            return A2(ki, n, TL);
        }, i), c = dS(n.qY.ss), s = function(r) {
            return 6 !== r && 4 !== r && n.qL.ss ? A3(NL, F2(function(r, t) {
                return {
                    fk: t,
                    p0: n.p0.ss,
                    p2: n.p2.ss,
                    id: r
                };
            }), ze(n.p3.ss), ze(n.p1.ss)) : Tt;
        }, f = function(r) {
            return A2(G$, r, yL) ? kt({
                iy: "" === n.iy.ss ? Tt : ze(n.iy.ss),
                iU: !!A2(G$, r, $L) && n.iU.ss,
                iV: 5 === r && n.iV.ss,
                jw: n.jw.ss,
                j7: !!A2(G$, r, $L) && n.j7.ss,
                kD: n.kD.ss,
                pu: A2(G$, r, FL) && "" !== n.pu.ss ? ze(n.pu.ss) : Tt,
                sw: !!A2(G$, r, $L) && n.sw.ss
            }) : Tt;
        }, l = function(r) {
            return A2(G$, r, wL) ? kt(n.oi.ss) : Tt;
        }, m = function(r) {
            return A2(G$, r, wL) && !n.oi.ss ? Qs(n.nt.ss) : Tt;
        }, d = function(r) {
            return A2(G$, r, wL) && !n.oi.ss ? Qs(n.ns.ss) : Tt;
        }, b = function(r) {
            return A2(G$, r, wL) && !n.oi.ss ? Qs(n.nr.ss) : Tt;
        }, p = function(r) {
            return n.qH.ss || 11 === r || 10 === r ? A2(Fu, function(r) {
                return {
                    jU: n.jU.ss,
                    jV: n.jV.ss,
                    ks: n.ks.ss,
                    mc: n.mc.ss,
                    m3: r,
                    ne: n.ne.ss,
                    pd: n.pd.ss,
                    pi: n.pi.ss
                };
            }, ze(n.m3.ss)) : Tt;
        }, v = "" === n.lz.ss ? Tt : kt(n.lz.ss), $ = function(r) {
            return 4 === r && n.lg.ss;
        }, g = function(r) {
            return 4 !== r && n.qB.ss ? A5(AL, F4(function(n, r, t, e) {
                return {
                    ej: e,
                    fM: n,
                    gS: r,
                    hZ: t
                };
            }), ze(n.ki.ss), ze(n.kj.ss), ze(n.kk.ss), ze(n.kh.ss)) : Tt;
        }, h = n.qA.ss ? A3(NL, F2(function(n, r) {
            return {
                jQ: r,
                jR: n
            };
        }), ze(n.jR.ss), ze(n.jQ.ss)) : Tt, k = "" === n.jh.ss ? Tt : kt(n.jh.ss), T = function(r) {
            return A2(G$, r, wL) && !n.oi.ss ? Qs(n.i1.ss) : Tt;
        }, w = eS(n.i$.ss), C = "" === n.iZ.ss ? Tt : kt(n.iZ.ss);
        return A2(X$, function(e) {
            var u, i = e.hl, o = e.d5, c = e.hD, w = e.hC;
            return {
                iZ: C,
                i_: (u = i, 1 === u || 16 === u || 11 === u || 10 === u || 8 === u || 9 === u || 14 === u ? ze(n.i_.ss) : Tt),
                i$: o,
                i1: T(i),
                jh: k,
                bG: h,
                ka: n.ka.ss,
                aG: g(i),
                lg: $(i),
                lz: v,
                lU: n.lU.ss,
                F: p(i),
                nr: b(i),
                ns: d(i),
                nt: m(i),
                n5: n.n5.ss,
                oh: n.oh.ss,
                oi: l(i),
                M: f(i),
                pr: n.pr.ss,
                ps: n.ps.ss,
                aU: s(i),
                qY: i,
                q4: n.q4.ss,
                rm: a,
                rr: w,
                rs: c,
                sB: t(i),
                dL: A2(Fu, function(n) {
                    return n.dL;
                }, n.re),
                sJ: r(i)
            };
        }, A5(SL, CL, c, w, u, o));
    }, PL = Po(A4(rc, "copyMetadata", function(n) {
        return n.ka;
    }, no, A4(Do, "subtitleFormat", function(n) {
        return n.rm;
    }, xi, A4(Do, "subtitleTypeVersion", function(n) {
        return n.rr;
    }, SS, A4(Do, "subtitleVersion", function(n) {
        return n.rs;
    }, h$, A4(rc, "qcReportTemplate", function(n) {
        return n.pr;
    }, xi, A4(rc, "qcTestPlan", function(n) {
        return n.ps;
    }, xi, A4(Do, "hevcParams", function(n) {
        return n.F;
    }, hS, A4(Do, "clip", function(n) {
        return n.bG;
    }, oS, A4(Do, "scale", function(n) {
        return n.aU;
    }, CS, A4(Do, "crop", function(n) {
        return n.aG;
    }, sS, A4(Do, "videoEdit", function(n) {
        return n.dL;
    }, BS, A4(rc, "encodeSubtitle", function(n) {
        return n.lg;
    }, no, A4(Do, "videoBitrate", function(n) {
        return n.sB;
    }, mS, A4(rc, "writeTimecode", function(n) {
        return n.sJ;
    }, no, A4(Do, "audioGain", function(n) {
        return n.i1;
    }, mS, A4(Do, "loudnessTruePeak", function(n) {
        return n.nt;
    }, mS, A4(Do, "loudnessProgram", function(n) {
        return n.nr;
    }, mS, A4(Do, "loudnessRange", function(n) {
        return n.ns;
    }, mS, A4(Do, "noLoudness", function(n) {
        return n.oi;
    }, no, A4(Do, "options", function(n) {
        return n.M;
    }, TS, A4(Do, "bmxArgs", function(n) {
        return n.jh;
    }, xi, A4(Do, "audioArgs", function(n) {
        return n.iZ;
    }, xi, A4(Do, "ffmpegArgs", function(n) {
        return n.lz;
    }, xi, A4(rc, "noFrameRateConversion", function(n) {
        return n.oh;
    }, no, A4(rc, "frameRate", function(n) {
        return n.lU;
    }, xi, A4(rc, "startTimecode", function(n) {
        return n.q4;
    }, xi, A4(Do, "audioBitrate", function(n) {
        return n.i_;
    }, uc, A4(rc, "audioCodec", function(n) {
        return n.i$;
    }, aS, A4(rc, "specification", function(n) {
        return n.qY;
    }, pS, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(T) {
                                                                                            return function(w) {
                                                                                                return function(C) {
                                                                                                    return function(N) {
                                                                                                        return function(A) {
                                                                                                            return function(S) {
                                                                                                                return function(L) {
                                                                                                                    return function(y) {
                                                                                                                        return function(F) {
                                                                                                                            return {
                                                                                                                                iZ: c,
                                                                                                                                i_: e,
                                                                                                                                i$: t,
                                                                                                                                i1: p,
                                                                                                                                jh: s,
                                                                                                                                bG: w,
                                                                                                                                ka: F,
                                                                                                                                aG: k,
                                                                                                                                lg: g,
                                                                                                                                lz: o,
                                                                                                                                lU: a,
                                                                                                                                F: C,
                                                                                                                                nr: d,
                                                                                                                                ns: m,
                                                                                                                                nt: b,
                                                                                                                                n5: n,
                                                                                                                                oh: i,
                                                                                                                                oi: l,
                                                                                                                                M: f,
                                                                                                                                pr: A,
                                                                                                                                ps: N,
                                                                                                                                aU: T,
                                                                                                                                qY: r,
                                                                                                                                q4: u,
                                                                                                                                rm: y,
                                                                                                                                rr: L,
                                                                                                                                rs: S,
                                                                                                                                sB: $,
                                                                                                                                dL: h,
                                                                                                                                sJ: v
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))))), IL = function(n) {
        return n.N || n.ag ? {
            lA: Au,
            nO: Eo,
            P: n.P
        } : {
            lA: n.lA,
            nO: n.nO,
            P: n.P
        };
    }, BL = Wo, ML = function(n) {
        return n.$ ? BL(n.a) : oN(n.a);
    }, OL = function(n) {
        return A2(Yi, hL, A2(OC, function(n) {
            return dc(A2(ng, MS, A3(ag, PL, n, rg(DS))));
        }, A2(Qo, IL, ML(jL(n)))));
    }, qL = function(n) {
        return {
            $: 56,
            a: n
        };
    }, DL = function(n) {
        return ml(qS({
            $: 1,
            a: n
        }));
    }, xL = function(n) {
        return {
            $: 54,
            a: n
        };
    }, RL = F2(function(n, r) {
        return A2(OC, function(r) {
            return dc(A2(Ho, MS, A3(ag, PL, r, mg(DL(n.mm)))));
        }, A2(Qo, IL, ML(jL(r))));
    }), VL = F2(function(n, r) {
        return A2(Yi, xL, A2(RL, n, r));
    }), EL = F2(function(n, r) {
        var t = r.b;
        return m(n(r.a), t);
    }), zL = F2(function(n, r) {
        return "Mire" === n ? {
            dW: 0,
            eS: 10,
            ft: r,
            c$: 0,
            hc: Tt,
            he: Tt,
            du: Tt,
            hF: !1
        } : "Slate" === n ? {
            dW: 0,
            eS: 10,
            ft: r,
            c$: 2,
            hc: Tt,
            he: Tt,
            du: Tt,
            hF: !1
        } : "Video" === n ? {
            dW: 0,
            eS: 10,
            ft: r,
            c$: 3,
            hc: Tt,
            he: Tt,
            du: Tt,
            hF: !1
        } : "Countdown" === n ? {
            dW: 0,
            eS: 10,
            ft: r,
            c$: 4,
            hc: Tt,
            he: Tt,
            du: Tt,
            hF: !1
        } : {
            dW: 0,
            eS: 10,
            ft: r,
            c$: 1,
            hc: Tt,
            he: Tt,
            du: Tt,
            hF: !1
        };
    }), UL = F3(function(n, r, t) {
        var e = n ? t.eb : t.dX, u = $(e, T([
            A2(zL, r, Dt(e))
        ]));
        return p(t, n ? {
            eb: u
        } : {
            dX: u
        });
    }), HL = F2(function(n, r) {
        return A2(Ge, function(n) {
            return p(n.b, {
                ft: n.a
            });
        }, A2(zt, x$, A2(Yc, function(r) {
            var t = r.b;
            return i(r.a, n) ? Tt : kt(t);
        }, A2(Ge, function(n) {
            return m(n.ft, n);
        }, r))));
    }), WL = F2(function(n, r) {
        return p(r, {
            dX: A2(HL, n, r.dX)
        });
    }), QL = F2(function(n, r) {
        return p(r, {
            eb: A2(HL, n, r.eb)
        });
    }), ZL = function(n) {
        return p(n, {
            gh: !n.gh
        });
    }, KL = F2(function(n, r) {
        switch(n.$){
            case 0:
                return r;
            case 1:
                var t = ze(n.a);
                return t.$ ? r : p(r, {
                    eS: t.a
                });
            case 2:
                var e = ze(n.a);
                return e.$ ? r : p(r, {
                    dW: e.a
                });
            case 4:
                return p(r, {
                    du: kt(n.a)
                });
            case 3:
                return p(r, {
                    hc: kt(n.a)
                });
            case 5:
                return p(r, {
                    he: kt(n.a)
                });
            default:
                return p(r, {
                    hF: n.a
                });
        }
    }), YL = F4(function(n, r, t, e) {
        var u = A2(Ge, function(n) {
            return i(r, n.ft) ? A2(KL, t, n) : n;
        }, n ? e.eb : e.dX);
        return p(e, n ? {
            eb: u
        } : {
            dX: u
        });
    }), XL = F2(function(n, r) {
        n: for(;;){
            if (n.$) return A2(pc, g, p(r, n.b.$ ? {
                dL: A3(UL, n.a, n.b.a, r.dL)
            } : n.a ? {
                jd: ZL(r.jd)
            } : {
                iz: ZL(r.iz)
            }));
            if (n.a) {
                if (n.c.$) break n;
                return A2(pc, g, p(r, {
                    dL: A2(QL, n.b, r.dL)
                }));
            }
            if (n.c.$) break n;
            return A2(pc, g, p(r, {
                dL: A2(WL, n.b, r.dL)
            }));
        }
        return A2(pc, g, p(r, {
            dL: A4(YL, n.a, n.b, n.c, r.dL)
        }));
    }), JL = F2(function(n, r) {
        var t, e = (t = r.re).$ ? m(Tt, n$) : A2(EL, kt, A2(XL, n, t.a)), u = e.b;
        return m(kt(p(r, {
            re: e.a
        })), u);
    }), GL = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(vL(kt(n.a)))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(vL(Tt))
                }));
            case 3:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 4:
                var t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: e
                }));
            case 5:
                t = n.a;
                var u = A2(Fu, function(n) {
                    var r = A2(G$, n.qY.ss, A2(Ge, bS, gL)), t = A2(G$, n.qY.ss, A2(Ge, bS, $L));
                    return p(n, {
                        oi: n.oi.fh ? n.oi : A2(pg, n.oi, r),
                        qA: n.qA.fh ? n.qA : A2(pg, n.qA, t)
                    });
                }, e = A2(Fu, function(n) {
                    return p(n, {
                        qY: A2(gg, t, n.qY)
                    });
                }, r.kN));
                return A2(pc, g, p(r, {
                    kN: u
                }));
            case 6:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        i$: A2(gg, t, n.i$)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 7:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        i_: A2(gg, t, n.i_)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 8:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        q4: A2(gg, t, n.q4)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 9:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lU: A2(gg, t, n.lU)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 10:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oh: A2(vg, t, n.oh)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 11:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lz: A2(gg, t, n.lz)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 12:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        iZ: A2(gg, t, n.iZ)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 13:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jh: A2(gg, t, n.jh)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 14:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        j7: A2(vg, t, n.j7)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 15:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        iU: A2(vg, t, n.iU)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 16:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        iV: A2(vg, t, n.iV)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 17:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jw: A2(vg, t, n.jw)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 18:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        iy: A2(gg, t, n.iy)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 19:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        sw: A2(vg, t, n.sw)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 20:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oi: A2(vg, t, n.oi)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 21:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ns: A2(gg, t, n.ns)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 22:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nr: A2(gg, t, n.nr)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 23:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nt: A2(gg, t, n.nt)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 24:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        i1: A2(gg, t, n.i1)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 33:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        sJ: A2(vg, t, n.sJ)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 34:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lg: A2(vg, t, n.lg)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 35:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        kD: A2(vg, t, n.kD)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 36:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pu: A2(gg, t, n.pu)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 41:
                t = n.a;
                var a = A2(Fu, function(n) {
                    return n.qH.ss ? p(n, {
                        m3: A2($g, n.m3, "250")
                    }) : n;
                }, e = A2(Fu, function(n) {
                    return p(n, {
                        qH: A2(vg, t, n.qH)
                    });
                }, r.kN));
                return A2(pc, g, p(r, {
                    kN: a
                }));
            case 25:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pi: A2(gg, t, n.pi)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 26:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pd: A2(gg, t, n.pd)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 27:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ne: A2(gg, t, n.ne)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 32:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        m3: A2(gg, t, n.m3)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 28:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        mc: A2(vg, t, n.mc)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 29:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jV: A2(gg, t, n.jV)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 30:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jU: A2(gg, t, n.jU)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 31:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ks: A2(gg, t, n.ks)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 37:
                return t = n.a, a = A2(Fu, function(n) {
                    return n.qB.ss ? p(n, {
                        kh: A2($g, n.kh, "0"),
                        ki: A2($g, n.ki, "0"),
                        kj: A2($g, n.kj, "0"),
                        kk: A2($g, n.kk, "0")
                    }) : n;
                }, e = A2(Fu, function(n) {
                    return p(n, {
                        qB: A2(vg, t, n.qB)
                    });
                }, r.kN)), A2(pc, g, p(r, {
                    kN: a
                }));
            case 48:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ki: A2(gg, t, n.ki)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 49:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        kj: A2(gg, t, n.kj)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 50:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        kk: A2(gg, t, n.kk)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 51:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        kh: A2(gg, t, n.kh)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 39:
                return t = n.a, a = A2(Fu, function(n) {
                    return n.qL.ss ? p(n, {
                        p1: A2($g, n.p1, "1080"),
                        p3: A2($g, n.p3, "1920")
                    }) : n;
                }, e = A2(Fu, function(n) {
                    return p(n, {
                        qL: A2(vg, t, n.qL)
                    });
                }, r.kN)), A2(pc, g, p(r, {
                    kN: a
                }));
            case 40:
                t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        qA: A2(vg, t, n.qA)
                    });
                }, r.kN);
                var i = function(n) {
                    switch(n){
                        case "ProRes422":
                        case "ProRes4444":
                        case "AVCIntra100":
                        case "XAVCIntra300":
                            return m("70", "935");
                        default:
                            return m("16", "235");
                    }
                }(A2(ju, "", A2(Fu, A2(No, function(n) {
                    return n.qY;
                }, function(n) {
                    return n.ss;
                }), r.kN))), o = i.a, c = i.b;
                return a = A2(Fu, function(n) {
                    return n.qA.ss ? p(n, {
                        jQ: A2($g, n.jQ, c),
                        jR: A2($g, n.jR, o)
                    }) : n;
                }, e), A2(pc, g, p(r, {
                    kN: a
                }));
            case 42:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jR: A2(gg, t, n.jR)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 43:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jQ: A2(gg, t, n.jQ)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 38:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        sB: A2(gg, t, n.sB)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 46:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        p3: A2(gg, t, n.p3)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 47:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        p1: A2(gg, t, n.p1)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 44:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        p0: A2(vg, t, n.p0)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 45:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        p2: A2(vg, t, n.p2)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 59:
                t = n.a;
                var s = A2(ju, m(Tt, n$), A2(Fu, JL(t), r.kN));
                return e = s.a, A2(pc, T([
                    A2(cp, fL, s.b)
                ]), p(r, {
                    kN: e
                }));
            case 52:
                var f = r.kN;
                return A2(pc, T(1 === f.$ ? [
                    n$
                ] : 1 === (v = (e = f.a).oR).$ ? [
                    OL(e)
                ] : [
                    A2(VL, v.a, e)
                ]), r);
            case 55:
                return A2(pc, T([
                    (b = n.a, A2(Yi, qL, function(n) {
                        return A2(Gb, Ml(n), dc(fg(sg(DL(n.mm)))));
                    }(b)))
                ]), r);
            case 53:
                return (l = n.a).$ ? A2(pc, g, A2(lL, l.a, r)) : A2(pc, T([
                    cL
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Audio mapping created")
                }));
            case 54:
                return (l = n.a).$ ? A2(pc, g, A2(lL, l.a, r)) : A2(pc, T([
                    cL
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Audio mapping updated")
                }));
            case 56:
                return (l = n.a).$ ? A2(pc, g, A2(lL, l.a, r)) : A2(pc, T([
                    cL
                ]), r);
            case 0:
                var l;
                if ((l = n.a).$) return A2(pc, g, A2(lL, l.a, r));
                var d = l.a;
                return A2(pc, g, p(r, {
                    cX: d.cX,
                    lV: d.lW,
                    dw: d.dw,
                    dA: d.dA
                }));
            case 58:
                return A2(pc, g, p(r, {
                    pw: A2(gg, t = n.a, r.pw)
                }));
            case 57:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 60:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ps: A2(gg, t, n.ps)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 61:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pr: A2(gg, t, n.pr)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 62:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, n.ju.ss ? {
                        ju: A2(vg, t, n.ju),
                        rm: A2($g, n.rm, ""),
                        rr: A2($g, n.rr, ""),
                        rs: A2($g, n.rs, "")
                    } : {
                        ju: A2(vg, t, n.ju)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 63:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        rs: A2(gg, t, n.rs)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 64:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        rr: A2(gg, t, n.rr)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 65:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        rm: A2(gg, t, n.rm)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            default:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ka: A2(vg, t, n.ka)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
        }
        var b, v;
    }), _L = {
        $: 1
    }, ny = function(n) {
        return {
            $: 58,
            a: n
        };
    }, ry = function(n) {
        return n ? "True" : "False";
    }, ty = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ey = function(n) {
        return {
            $: 57,
            a: n
        };
    }, uy = function(n) {
        return {
            $: 55,
            a: n
        };
    }, ay = function(n) {
        return "left: " + It(n.fM) + ", right: " + It(n.gS) + ", top: " + It(n.hZ) + ", bottom: " + It(n.ej);
    }, iy = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), oy = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: iy(r)
        });
    }), cy = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), sy = function(n) {
        return It(n.c9) + "/" + It(n.cG);
    }, fy = function(n) {
        return "profil: " + n.pi + ", preset: " + n.pd + ", level: " + n.ne + ", colorspace: " + n.jV + ", colorPrimaries: " + n.jU + ", curveTransfert: " + n.ks + ", highTiers: " + ry(n.mc) + ", keyframe: " + It(n.m3);
    }, ly = function(n) {
        var r, t;
        return "control instanstaneous bitrate: " + ry(n.j7) + ", as10: " + ry(n.iU) + ", as11: " + ry(n.iV) + ", use bwf wrapping: " + ry(n.jw) + ", afd: " + (1 === (t = n.iy).$ ? "N/A" : It(t.a)) + ", mxf version 1.2: " + ry(n.sw) + ", force deinterlacing: " + ry(n.kD) + ", overwritten qmax: " + (1 === (r = n.pu).$ ? "N/A" : It(r.a));
    }, my = function(n) {
        return "width: " + It(n.id) + ", height: " + It(n.fk) + ", keep aspect ratio: " + ry(n.p0) + ", letter/pillar box: " + ry(n.p2);
    }, dy = F2(function(n, r) {
        var t = r.rm;
        if (t.$) return "N/A";
        var e = t.a;
        return A2(ju, "N/A", Va(A2(Ge, function(n) {
            return n.n5;
        }, A2(Iu, function(n) {
            return i(n.mm, e);
        }, n))));
    }), by = T([
        Rg("Table")
    ]), py = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, A2(lo, r.ps, n)));
    }), vy = function() {
        return T([
            Rg("TableTr")
        ]);
    }, $y = F2(function(n, r) {
        return uh({
            jY: T([
                A2(oy, "Edit", A2(bu, Nh("Edit"), ty)),
                A2(cy, "Name", function(n) {
                    return n.n5;
                }),
                A2(cy, "Specification", A2(bu, bS, function(n) {
                    return n.qY;
                })),
                A2(cy, "Test plan", py(n)),
                A2(cy, "Report template", function(n) {
                    return n.pr;
                }),
                A2(cy, "startTimecode", function(n) {
                    return n.q4;
                }),
                A2(cy, "FrameRate", A2(bu, sy, function(n) {
                    return n.lU;
                })),
                A2(cy, "Video Args", A2(bu, ju("N/A"), function(n) {
                    return n.lz;
                })),
                A2(cy, "Audio Args", A2(bu, ju("N/A"), function(n) {
                    return n.iZ;
                })),
                A2(cy, "BMX Args", A2(bu, ju("N/A"), function(n) {
                    return n.jh;
                })),
                A2(cy, "Crop Parameters", A2(bu, A2(bu, ju("N/A"), Fu(ay)), function(n) {
                    return n.aG;
                })),
                A2(cy, "Scale Parameters", A2(bu, A2(bu, ju("N/A"), Fu(my)), function(n) {
                    return n.aU;
                })),
                A2(cy, "Hevc Parameters", A2(bu, A2(bu, ju("N/A"), Fu(fy)), function(n) {
                    return n.F;
                })),
                A2(cy, "MXF Options", A2(bu, A2(bu, ju("N/A"), Fu(ly)), function(n) {
                    return n.M;
                })),
                A2(cy, "No Loudness", A2(bu, A2(bu, ju("N/A"), Fu(ry)), function(n) {
                    return n.oi;
                })),
                A2(cy, "Subtitle Version", A2(bu, A2(bu, ju("N/A"), Fu(g$)), function(n) {
                    return n.rs;
                })),
                A2(cy, "Subtitle Type Version", A2(bu, A2(bu, ju("N/A"), Fu(AS)), function(n) {
                    return n.rr;
                })),
                A2(cy, "Subtitle Format", dy(r)),
                A2(oy, "Delete", A2(bu, Og(Th), uy))
            ]),
            kt: p(kh, {
                pR: vy,
                rA: by,
                rM: T([
                    Rg("TableTd")
                ])
            }),
            rV: function(n) {
                return n.mm;
            },
            rW: ey
        });
    }), gy = function(n) {
        return {
            $: 15,
            a: n
        };
    }, hy = function(n) {
        return {
            $: 16,
            a: n
        };
    }, ky = function(n) {
        return {
            $: 62,
            a: n
        };
    }, Ty = function(n) {
        return {
            $: 17,
            a: n
        };
    }, wy = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Cy = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Ny = function(n) {
        return {
            $: 37,
            a: n
        };
    }, Ay = function(n) {
        return {
            $: 35,
            a: n
        };
    }, Sy = function(n) {
        return {
            $: 41,
            a: n
        };
    }, Ly = function(n) {
        return {
            $: 28,
            a: n
        };
    }, yy = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Fy = function(n) {
        return {
            $: 20,
            a: n
        };
    }, jy = function(n) {
        return {
            $: 39,
            a: n
        };
    }, Py = function(n) {
        return {
            $: 34,
            a: n
        };
    }, Iy = function(n) {
        return {
            $: 33,
            a: n
        };
    }, By = function(n) {
        return {
            $: 19,
            a: n
        };
    }, My = {
        $: 3
    }, Oy = function(n) {
        return {
            $: 66,
            a: n
        };
    }, qy = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Dy = function(n) {
        return {
            $: 44,
            a: n
        };
    }, xy = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Ry = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Vy = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ey = function(n) {
        return {
            $: 24,
            a: n
        };
    }, zy = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Uy = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Hy = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Wy = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Qy = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Zy = function(n) {
        return {
            $: 51,
            a: n
        };
    }, Ky = function(n) {
        return {
            $: 48,
            a: n
        };
    }, Yy = function(n) {
        return {
            $: 49,
            a: n
        };
    }, Xy = function(n) {
        return {
            $: 50,
            a: n
        };
    }, Jy = function(n) {
        return {
            $: 31,
            a: n
        };
    }, Gy = function(n) {
        return {
            $: 11,
            a: n
        };
    }, _y = function(n) {
        return {
            $: 9,
            a: n
        };
    }, nF = function(n) {
        return {
            $: 47,
            a: n
        };
    }, rF = function(n) {
        return {
            $: 32,
            a: n
        };
    }, tF = function(n) {
        return {
            $: 45,
            a: n
        };
    }, eF = function(n) {
        return {
            $: 27,
            a: n
        };
    }, uF = function(n) {
        return {
            $: 22,
            a: n
        };
    }, aF = function(n) {
        return {
            $: 21,
            a: n
        };
    }, iF = function(n) {
        return {
            $: 23,
            a: n
        };
    }, oF = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cF = function(n) {
        return {
            $: 26,
            a: n
        };
    }, sF = function(n) {
        return {
            $: 25,
            a: n
        };
    }, fF = function(n) {
        return {
            $: 61,
            a: n
        };
    }, lF = function(n) {
        return {
            $: 60,
            a: n
        };
    }, mF = function(n) {
        return {
            $: 36,
            a: n
        };
    }, dF = function(n) {
        return {
            $: 5,
            a: n
        };
    }, bF = function(n) {
        return {
            $: 8,
            a: n
        };
    }, pF = function(n) {
        return {
            $: 65,
            a: n
        };
    }, vF = function(n) {
        return {
            $: 64,
            a: n
        };
    }, $F = function(n) {
        return {
            $: 63,
            a: n
        };
    }, gF = function(n) {
        return {
            $: 38,
            a: n
        };
    }, hF = function(n) {
        return {
            $: 46,
            a: n
        };
    }, kF = {
        $: 52
    }, TF = T([
        3,
        4
    ]), wF = Se("br"), CF = T([
        "bt709",
        "bt2020",
        "unknown"
    ]), NF = T([
        "bt709",
        "bt2020_ncl",
        "bt2020_cl",
        "unknown"
    ]), AF = T([
        "bt709",
        "bt2020-10",
        "bt2020-12",
        "unknown"
    ]), SF = Se("h4"), LF = T([
        10,
        11
    ]), yF = Se("hr"), FF = F2(function(n, r) {
        return n ? r : kT;
    }), jF = T([
        0,
        5,
        6
    ]), PF = T([
        "0",
        "1",
        "2.1",
        "2",
        "3",
        "3.1",
        "4",
        "4.1",
        "5",
        "5.1",
        "5.2",
        "6",
        "6.1",
        "6.2",
        "8.5"
    ]), IF = T([
        10,
        8
    ]), BF = T([
        1,
        11
    ]), MF = T([
        "ultrafast",
        "superfast",
        "veryfast",
        "faster",
        "fast",
        "medium",
        "slow",
        "slower",
        "veryslow",
        "placebo"
    ]), OF = T([
        "main",
        "main-intra",
        "main444-8",
        "main444-intra",
        "main10",
        "main10-intra",
        "main422-10",
        "main422-10-intra",
        "main444-10",
        "main444-10-intra",
        "main12",
        "main12-intra",
        "main422-12",
        "main422-12-intra",
        "main444-12-intra",
        "main444-12"
    ]), qF = function(n) {
        switch(n){
            case 0:
                return Oi({
                    bN: "Partial",
                    bT: "Partiel"
                });
            case 1:
                return Oi({
                    bN: "Complete",
                    bT: "Complet"
                });
            case 2:
                return Oi({
                    bN: "Complete without partial",
                    bT: "Complet sans partiel"
                });
            default:
                return Oi({
                    bN: "SDH",
                    bT: "SME"
                });
        }
    }, DF = A2(zi, Ko, T([
        m(AS(0), qF(0)),
        m(AS(1), qF(1)),
        m(AS(2), qF(2)),
        m(AS(3), qF(3))
    ])), xF = A2(zi, Ko, T([
        m(g$(0), YT(0)),
        m(g$(1), YT(1)),
        m(g$(2), YT(2)),
        m(g$(3), YT(3)),
        m(g$(4), YT(4)),
        m(g$(5), YT(5)),
        m(g$(6), YT(6)),
        m(g$(7), YT(7)),
        m(g$(8), YT(8)),
        m(g$(9), YT(9)),
        m(g$(10), YT(10)),
        m(g$(11), YT(11)),
        m(g$(12), YT(12)),
        m(g$(13), YT(13)),
        m(g$(14), YT(14)),
        m(g$(15), YT(15)),
        m(g$(16), YT(16)),
        m(g$(17), YT(17)),
        m(g$(18), YT(18)),
        m(g$(19), YT(19)),
        m(g$(20), YT(20)),
        m(g$(21), YT(21)),
        m(g$(22), YT(22)),
        m(g$(23), YT(23)),
        m(g$(24), YT(24)),
        m(g$(25), YT(25)),
        m(g$(26), YT(26)),
        m(g$(27), YT(27)),
        m(g$(28), YT(28)),
        m(g$(29), YT(29)),
        m(g$(30), YT(30)),
        m(g$(31), YT(31)),
        m(g$(32), YT(32)),
        m(g$(33), YT(33)),
        m(g$(34), YT(34)),
        m(g$(35), YT(35)),
        m(g$(36), YT(36)),
        m(g$(37), YT(37))
    ])), RF = xg("target"), VF = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), EF = {
        $: 0
    }, zF = F2(function(n, r) {
        var t, e = r.a, u = r.b;
        return A2(Le, T([
            Rg("SelectItem"),
            Oh(T([
                m("SelectItemSelected", i(n.ss, kt(e)))
            ])),
            wh((t = e, {
                $: 1,
                a: t
            }))
        ]), T([
            ih(u)
        ]));
    }), UF = function(n) {
        return A2(Le, T([
            Rg("Select"),
            Oh(T([
                m("SelectDisabled", !n.eY),
                m("SelectOpened", n.gh)
            ])),
            wh(EF),
            TN(n.gh)
        ]), T([
            A2(Le, T([
                Rg("SelectButton")
            ]), T([
                A2(Le, T([
                    Rg("SelectButtonIcon")
                ]), T([
                    MT
                ])),
                A2(Dh, T([
                    Rg("SelectButtonTitle")
                ]), A2(ju, n.gt, A2(Fu, Ko, Va(A2(Iu, function(r) {
                    return i(kt(r.a), n.ss);
                }, n.jL)))))
            ])),
            A2(Le, T([
                Rg("SelectList")
            ]), A2(Ge, zF(n), n.jL))
        ]));
    }, HF = function(n) {
        return {
            $: 6,
            a: n
        };
    }, WF = {
        $: 0
    }, QF = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ZF = function(n) {
        return {
            $: 2,
            a: n
        };
    }, KF = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YF = Oi({
        bN: "Frame Count",
        bT: "Images suppl\xe9mentaires"
    }), XF = Oi({
        bN: "Black",
        bT: "Noir"
    }), JF = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18"),
        Pg("IconPlus")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(Zg, T([
                Ug("4 5.5 7.5 9 4 12.5 5.5 14 9 10.5 12.5 14 14 12.5 10.5 9 14 5.5 12.5 4 9 7.5 5.5 4")
            ]), g)
        ]))
    ])), GF = Oi({
        bN: "Countdown",
        bT: "Compte \xe0 rebours"
    }), _F = Oi({
        bN: "Duration",
        bT: "Dur\xe9e"
    }), nj = Oi({
        bN: "(Frames)",
        bT: "(Images)"
    }), rj = Oi({
        bN: "Mire",
        bT: "Mire"
    }), tj = Oi({
        bN: "(Seconds)",
        bT: "(Secondes)"
    }), ej = Oi({
        bN: "Slate",
        bT: "Panneau"
    }), uj = Oi({
        bN: "Shift start timecode",
        bT: "D\xe9caler le start timecode"
    }), aj = F2(function(n, r) {
        switch(r.c$){
            case 3:
                return A2(Le, T([
                    Rg("StichSegment")
                ]), T([
                    A2(Le, T([
                        Rg("StichSegmentDelete"),
                        wh(A3(QF, n, r.ft, WF))
                    ]), T([
                        JF
                    ])),
                    A2(Dh, T([
                        Rg("StichSegmentTitle")
                    ]), "video"),
                    A2(FF, n, A2(Le, T([
                        Rg("StichSegmentSubtract")
                    ]), T([
                        A2(Eh, T([
                            Ch("checkbox"),
                            NT(r.hF),
                            ST(function(t) {
                                return A3(QF, n, r.ft, HF(t));
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentTitle")
                        ]), uj)
                    ]))),
                    A2(Le, T([
                        Rg("StichVideoSegment")
                    ]), T([
                        A2(Dh, T([
                            Rg("StichSegmentUnit")
                        ]), "name"),
                        A2(Eh, T([
                            uk("source name"),
                            ak(A2(ju, "", r.du)),
                            Rg("StichSegmentUrl"),
                            ek(function(t) {
                                return A3(QF, n, r.ft, {
                                    $: 4,
                                    a: t
                                });
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentUnit")
                        ]), "bucket"),
                        A2(Eh, T([
                            uk("source bucket"),
                            ak(A2(ju, "", r.hc)),
                            Rg("StichSegmentUrl"),
                            ek(function(t) {
                                return A3(QF, n, r.ft, {
                                    $: 3,
                                    a: t
                                });
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentUnit")
                        ]), "key"),
                        A2(Eh, T([
                            uk("source key"),
                            ak(A2(ju, "", r.he)),
                            Rg("StichSegmentUrl"),
                            ek(function(t) {
                                return A3(QF, n, r.ft, {
                                    $: 5,
                                    a: t
                                });
                            })
                        ]), g)
                    ]))
                ]));
            case 0:
                return A2(Le, T([
                    Rg("StichSegment")
                ]), T([
                    A2(Le, T([
                        Rg("StichSegmentDelete"),
                        wh(A3(QF, n, r.ft, WF))
                    ]), T([
                        JF
                    ])),
                    A2(Dh, T([
                        Rg("StichSegmentTitle")
                    ]), rj),
                    A2(FF, n, A2(Le, T([
                        Rg("StichSegmentSubtract")
                    ]), T([
                        A2(Eh, T([
                            Ch("checkbox"),
                            NT(r.hF),
                            ST(function(t) {
                                return A3(QF, n, r.ft, HF(t));
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentTitle")
                        ]), uj)
                    ]))),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), tj),
                    A2(Eh, T([
                        uk(_F),
                        ak(It(r.eS)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, KF(t));
                        })
                    ]), g),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), nj),
                    A2(Eh, T([
                        uk(YF),
                        ak(It(r.dW)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, ZF(t));
                        })
                    ]), g)
                ]));
            case 1:
                return A2(Le, T([
                    Rg("StichSegment")
                ]), T([
                    A2(Le, T([
                        Rg("StichSegmentDelete"),
                        wh(A3(QF, n, r.ft, WF))
                    ]), T([
                        JF
                    ])),
                    A2(Dh, T([
                        Rg("StichSegmentTitle")
                    ]), XF),
                    A2(FF, n, A2(Le, T([
                        Rg("StichSegmentSubtract")
                    ]), T([
                        A2(Eh, T([
                            Ch("checkbox"),
                            NT(r.hF),
                            ST(function(t) {
                                return A3(QF, n, r.ft, HF(t));
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentTitle")
                        ]), uj)
                    ]))),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), tj),
                    A2(Eh, T([
                        uk(_F),
                        ak(It(r.eS)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, KF(t));
                        })
                    ]), g),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), nj),
                    A2(Eh, T([
                        uk(YF),
                        ak(It(r.dW)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, ZF(t));
                        })
                    ]), g)
                ]));
            case 4:
                return A2(Le, T([
                    Rg("StichSegment")
                ]), T([
                    A2(Le, T([
                        Rg("StichSegmentDelete"),
                        wh(A3(QF, n, r.ft, WF))
                    ]), T([
                        JF
                    ])),
                    A2(Dh, T([
                        Rg("StichSegmentTitle")
                    ]), GF),
                    A2(FF, n, A2(Le, T([
                        Rg("StichSegmentSubtract")
                    ]), T([
                        A2(Eh, T([
                            Ch("checkbox"),
                            NT(r.hF),
                            ST(function(t) {
                                return A3(QF, n, r.ft, HF(t));
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentTitle")
                        ]), uj)
                    ]))),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), tj),
                    A2(Eh, T([
                        uk(_F),
                        ak(It(r.eS)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, KF(t));
                        })
                    ]), g)
                ]));
            default:
                return A2(Le, T([
                    Rg("StichSegment")
                ]), T([
                    A2(Le, T([
                        Rg("StichSegmentDelete"),
                        wh(A3(QF, n, r.ft, WF))
                    ]), T([
                        JF
                    ])),
                    A2(Dh, T([
                        Rg("StichSegmentTitle")
                    ]), ej),
                    A2(FF, n, A2(Le, T([
                        Rg("StichSegmentSubtract")
                    ]), T([
                        A2(Eh, T([
                            Ch("checkbox"),
                            NT(r.hF),
                            ST(function(t) {
                                return A3(QF, n, r.ft, HF(t));
                            })
                        ]), g),
                        A2(Dh, T([
                            Rg("StichSegmentTitle")
                        ]), uj)
                    ]))),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), tj),
                    A2(Eh, T([
                        uk(_F),
                        ak(It(r.eS)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, KF(t));
                        })
                    ]), g),
                    A2(Dh, T([
                        Rg("StichSegmentUnit")
                    ]), nj),
                    A2(Eh, T([
                        uk(YF),
                        ak(It(r.dW)),
                        Rg("StichSegmentDuration"),
                        ek(function(t) {
                            return A3(QF, n, r.ft, ZF(t));
                        })
                    ]), g)
                ]));
        }
    }), ij = function(n) {
        return A2(Le, T([
            Rg("StitchAdd")
        ]), $(A2(Ge, aj(!1), A2(zi, function(n) {
            return n.ft;
        }, n.dL.dX)), T([
            A2(dk, VF(!1), UF(n.iz))
        ])));
    }, oj = function(n) {
        return A2(Le, T([
            Rg("StitchAdd")
        ]), $(A2(Ge, aj(!0), A2(zi, function(n) {
            return n.ft;
        }, n.dL.eb)), T([
            A2(dk, VF(!0), UF(n.jd))
        ])));
    }, cj = function(n) {
        return A2(wT, function(r) {
            var t = A2(Ge, function(n) {
                return m(n.a, n.b.n5);
            }, A2(zi, A2(No, Ko, A2(No, function(n) {
                return n.n5;
            }, Hi)), pt(n.dA))), e = A2(Ge, function(n) {
                return m(n.mm, n.n5);
            }, n.dw), u = A2(Ge, function(n) {
                return m(n, n);
            }, OF), a = A2(Ge, function(n) {
                return m(n, n);
            }, MF), o = A2(Ge, function(n) {
                return m(n, n);
            }, PF), c = i(r.qY.ss, bS(14)), s = i(r.qY.ss, bS(4)), f = i(r.qY.ss, bS(9)), l = function(n) {
                return A2(G$, r.qY.ss, A2(Ge, bS, n));
            }, d = l(IF), b = l(LL), p = l(BF), v = l(yL), $ = l($L), h = l(FL), k = l(wL), w = l(jF), C = i(r.qY.ss, bS(6)), N = l(LF), A = r.ju.ss, S = i(r.qY.ss, bS(16)), L = A2(G$, r.i$.ss, A2(Ge, uS, TF)), y = i(r.qY.ss, bS(5)), F = A2(Ge, function(n) {
                return m(n.mm, sy(n));
            }, n.lV), j = A2(Ge, function(n) {
                return m(n, n);
            }, A2(Ge, bS, T([
                0,
                1,
                9,
                2,
                3,
                4,
                10,
                11,
                5,
                6,
                7,
                12,
                8,
                13,
                14,
                15,
                16
            ]))), P = A2(Ge, function(n) {
                return m(n, n);
            }, AF), I = A2(Ge, function(n) {
                return m(n, n);
            }, NF), B = A2(Ge, function(n) {
                return m(n, n);
            }, CF), M = A2(Ge, function(n) {
                return m(uS(n), function(n) {
                    switch(n){
                        case 1:
                            return "pcm_s16le (.wav 16 bits)";
                        case 0:
                            return "pcm_s24le (.wav 24 bits)";
                        case 2:
                            return "pcm_s24be (.aif)";
                        case 3:
                            return "libfdk_aac (.aac)";
                        case 4:
                            return "libmp3lame (.mp3)";
                        default:
                            return "pcm_s24le (.mov)";
                    }
                }(n));
            }, T([
                1,
                0,
                2,
                3,
                4,
                5
            ])), O = A2(Ge, function(n) {
                return m(n, n);
            }, A2(Ge, uS, T([
                1,
                0
            ]))), q = function(n) {
                return 1 !== n.oR.$;
            }(r) ? m("Save", "Edit Format") : m("Create", "New Format");
            return A4(ZT, q.b, m(q.a, kF), m("Cancel", My), T([
                A2(aw, T([
                    sw("https://docs.google.com/document/d/1INml9A9VneiIqDZlNB8FnKTU_NkmstV5SAEFFO2nSmQ"),
                    RF("_blank")
                ]), T([
                    ih("Help Format Creation")
                ])),
                A2(dk, oF, IT(r.n5)),
                A2(dk, dF, A2(ET, r.qY, j)),
                A2(FF, b || S, A2(dk, Iy, PT(r.sJ))),
                A2(FF, r.sJ.ss || !(b || S), A2(dk, bF, IT(r.q4))),
                A2(dk, Oy, PT(r.ka)),
                A2(wF, g, g),
                A2(yF, g, g),
                A2(wF, g, g),
                A2(SF, g, T([
                    ih("QC")
                ])),
                A2(dk, lF, A2(ET, r.ps, t)),
                A2(dk, fF, IT(r.pr)),
                A2(FF, !S, A2(Le, g, T([
                    A2(wF, g, g),
                    A2(yF, g, g),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("Video")
                    ])),
                    A2(FF, p || d || f || c, A2(dk, gF, IT(r.sB))),
                    A2(dk, _y, A2(ET, r.lU, F)),
                    A2(dk, yy, PT(r.oh))
                ]))),
                A2(FF, w, A2(dk, Ay, PT(r.kD))),
                A2(FF, !S, A2(dk, Gy, IT(r.lz))),
                A2(FF, v, A2(Le, g, T([
                    A2(wF, g, g),
                    A2(yF, g, g),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("MXf Parameters")
                    ]))
                ]))),
                A2(FF, h, A2(dk, mF, IT(r.pu))),
                A2(FF, $, A2(Le, g, T([
                    A2(dk, wy, PT(r.j7)),
                    A2(dk, gy, PT(r.iU)),
                    A2(dk, By, PT(r.sw))
                ]))),
                A2(FF, y, A2(dk, hy, PT(r.iV))),
                A2(FF, v, A2(Le, g, T([
                    A2(dk, Ty, PT(r.jw)),
                    A2(dk, qy, IT(r.iy)),
                    A2(dk, zy, IT(r.jh))
                ]))),
                A2(FF, N, A2(Le, g, T([
                    A2(wF, g, g),
                    A2(yF, g, g),
                    A2(wF, g, g),
                    A2(Le, g, T([
                        A2(dk, Sy, A2(SF, g, T([
                            PT(r.qH)
                        ]))),
                        A2(FF, r.qH.ss, A2(Le, T([
                            Rg("EditContainer")
                        ]), T([
                            A2(dk, sF, A2(ET, r.pi, u)),
                            A2(dk, eF, A2(ET, r.ne, o)),
                            A2(dk, cF, A2(ET, r.pd, a)),
                            A2(dk, Ly, PT(r.mc)),
                            A2(dk, rF, IT(r.m3)),
                            A2(dk, Qy, A2(ET, r.jV, I)),
                            A2(dk, Wy, A2(ET, r.jU, B)),
                            A2(dk, Jy, A2(ET, r.ks, P))
                        ])))
                    ]))
                ]))),
                A2(wF, g, g),
                A2(yF, g, g),
                A2(wF, g, g),
                A2(SF, g, T([
                    ih("Audio")
                ])),
                A2(FF, !S, A2(dk, Vy, A2(ET, r.i$, O))),
                A2(FF, p || d || f || c, A2(dk, Ry, IT(r.i_))),
                A2(FF, k && !S, A2(Le, g, T([
                    A2(dk, Fy, PT(r.oi)),
                    A2(FF, !r.oi.ss, A2(Le, g, T([
                        A2(dk, aF, IT(r.ns)),
                        A2(dk, uF, IT(r.nr)),
                        A2(dk, iF, IT(r.nt)),
                        A2(dk, Ey, IT(r.i1))
                    ])))
                ]))),
                A2(FF, !S, A2(dk, xy, IT(r.iZ))),
                A2(FF, S, A2(Le, g, T([
                    A2(dk, Vy, A2(ET, r.i$, M)),
                    A2(FF, L, A2(dk, Ry, IT(r.i_))),
                    A2(dk, _y, A2(ET, r.lU, F))
                ]))),
                A2(FF, !(s || S), A2(Le, g, T([
                    A2(wF, g, g),
                    A2(yF, g, g),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("Effects")
                    ])),
                    A2(dk, Ny, PT(r.qB)),
                    A2(FF, r.qB.ss, A2(Le, T([
                        Rg("EditContainer")
                    ]), T([
                        A2(dk, Ky, IT(r.ki)),
                        A2(dk, Yy, IT(r.kj)),
                        A2(dk, Xy, IT(r.kk)),
                        A2(dk, Zy, IT(r.kh))
                    ])))
                ]))),
                A2(FF, !(C || s || S), A2(Le, g, T([
                    A2(dk, jy, PT(r.qL)),
                    A2(FF, r.qL.ss, A2(Le, T([
                        Rg("EditContainer")
                    ]), T([
                        A2(dk, hF, IT(r.p3)),
                        A2(dk, nF, IT(r.p1)),
                        A2(dk, Dy, PT(r.p0)),
                        A2(dk, tF, PT(r.p2))
                    ])))
                ]))),
                A2(FF, !(s || S), A2(Le, g, T([
                    A2(dk, Cy, PT(r.qA)),
                    A2(FF, r.qA.ss, A2(Le, T([
                        Rg("EditContainer")
                    ]), T([
                        A2(dk, Hy, IT(r.jR)),
                        A2(dk, Uy, IT(r.jQ))
                    ])))
                ]))),
                A2(FF, !S, A2(Le, g, T([
                    A2(wT, function(n) {
                        return A2(Le, T([
                            Rg("EditSection")
                        ]), T([
                            A2(wF, g, g),
                            A2(yF, g, g),
                            A2(wF, g, g),
                            A2(SF, g, T([
                                ih("Edit Options")
                            ])),
                            A2(Le, T([
                                Rg("EditContainer")
                            ]), T([
                                A2(dk, fL, oj(n)),
                                A2(dk, fL, ij(n))
                            ]))
                        ]));
                    }, r.re)
                ]))),
                A2(FF, !S, A2(Le, g, T([
                    A2(wF, g, g),
                    A2(yF, g, g),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("Subtitle")
                    ])),
                    A2(FF, s, A2(Le, g, T([
                        A2(dk, Py, PT(r.lg))
                    ]))),
                    A2(dk, ky, PT(r.ju)),
                    A2(FF, A, A2(Le, T([
                        Rg("EditContainer")
                    ]), T([
                        A2(dk, $F, A2(ET, r.rs, xF)),
                        A2(dk, vF, A2(ET, r.rr, DF)),
                        A2(dk, pF, A2(ET, r.rm, e))
                    ])))
                ])))
            ]));
        }, n.kN);
    }, sj = F2(function(n, r) {
        var t = Hi(r.pw.ss), e = A2(Iu, function(n) {
            return A2(bu, A2(bu, Oe(t), Hi), function(n) {
                return n.n5;
            })(n) || A2(bu, A2(bu, A2(bu, Oe(t), Hi), bS), function(n) {
                return n.qY;
            })(n) || A2(bu, A2(bu, Oe(t), Hi), function(n) {
                return n.q4;
            })(n) || A2(bu, A2(bu, A2(bu, Oe(t), Hi), sy), function(n) {
                return n.lU;
            })(n) || A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), function(n) {
                return n.lz;
            })(n) || A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), function(n) {
                return n.iZ;
            })(n) || A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), function(n) {
                return n.jh;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), Fu(ly)), function(n) {
                return n.M;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), Fu(ry)), function(n) {
                return n.oi;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), Fu(g$)), function(n) {
                return n.rs;
            })(n) || A2(bu, A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), Fu(AS)), function(n) {
                return n.rr;
            })(n) || A2(bu, A2(bu, A2(bu, Oe(t), Hi), ju("N/A")), function(n) {
                return n.rm;
            })(n);
        }, r.cX);
        return A3(hw, "Formats", kt(A2(Nh, "New\u2026", _L)), A2(Le, g, T([
            A2(dk, ny, ik(r.pw)),
            cj(r),
            A3(cT, A2($y, r.dA, r.dw), r.rJ, e)
        ])));
    }), fj = {
        l: function(n) {
            return n.cX;
        },
        m: sL,
        o: F2(function(n, r) {
            return p(n, {
                cX: r
            });
        }),
        p: function(n) {
            return {
                $: 12,
                a: n
            };
        },
        q: GL,
        r: sj
    }, lj = F2(function(n, r) {
        return {
            eK: n,
            sv: r
        };
    }), mj = F2(function(n, r) {
        return {
            jb: n,
            lm: r
        };
    }), dj = Po(A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(rc, "available", function(n) {
        return n.jb;
    }, no, Io(mj)))), bj = Po(A4(rc, "version", function(n) {
        return n.sv;
    }, xi, A4(rc, "db", function(n) {
        return n.eK;
    }, dj, Io(lj)))), pj = ml({
        $: 23
    }), vj = dc(A2(Ho, bj, So(pj))), $j = A2(Yi, Ie, vj), gj = m({
        ll: Tt
    }, $j), hj = F2(function(n, r) {
        return A2(pc, g, p(r, {
            ll: kt(n)
        }));
    }), kj = F2(function(n, r) {
        return A2(Fk, T([
            Rg("KeyValueRow")
        ]), T([
            A2(uT, T([
                Rg("KeyValueKey")
            ]), T([
                n
            ])),
            A2(uT, T([
                Rg("KeyValueValue")
            ]), T([
                r
            ]))
        ]));
    }), Tj = kj, wj = F2(function(n, r) {
        return A2(Tj, ih(n), ih(r));
    }), Cj = Fg("transform"), Nj = A2(Kg, T([
        zg("40px"),
        Xg("40px"),
        Yg("0 0 40 40"),
        Pg("IconSpinner")
    ]), T([
        A2(BT, T([
            Cj("translate(5, 9)")
        ]), T([
            A2(ow, T([
                iw("M15,0 C21.0751322,0 26,4.92486775 26,11 C26,17.0751322 21.0751322,22 15,22 C9.26195744,22 4.55007179,17.6065 4.04484302,12 L6.05492878,12 C6.55237307,16.4999505 10.3674463,20 15,20 C19.9705627,20 24,15.9705627 24,11 C24,6.02943725 19.9705627,2 15,2 L15,0 Z"),
                Pg("Fg")
            ]), g),
            A2(Zg, T([
                Pg("Fg"),
                Ug("5 6 10 12 0 12")
            ]), g)
        ]))
    ])), Aj = F2(function(n, r) {
        return A3(hw, "Flubber status", Tt, A2(Le, g, function() {
            var n = r.ll;
            if (1 === n.$) return T([
                Nj
            ]);
            var t = n.a;
            if (t.$) {
                var e = t.a;
                return T([
                    A2(Dh, T([
                        Rg("failed")
                    ]), e.nO)
                ]);
            }
            var u = t.a;
            return T([
                A2(wj, "Version", u.sv),
                A2(wj, "Database", u.eK.jb ? "OK" : "KO: " + A2(ju, "No error", u.eK.lm))
            ]);
        }()));
    }), Sj = {
        l: function(n) {
            return n.cY;
        },
        m: gj,
        o: F2(function(n, r) {
            return p(n, {
                cY: r
            });
        }),
        p: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        q: hj,
        r: Aj
    }, Lj = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yj = A2(Yi, Lj, dc(A2(Ho, I$, So(M$)))), Fj = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jj = A2(Yi, Fj, dc(A2(Ho, FC, So(PC)))), Pj = {
        ij: !1,
        kv: g,
        m5: !1,
        nl: !1,
        oO: !1,
        oP: g,
        oW: A4(ov, Tt, Tt, Tt, Tt),
        ra: !1,
        rJ: a$("Completed At"),
        dK: g
    }, Ij = A2(pc, T([
        yj,
        jj
    ]), Pj), Bj = F2(function(n, r) {
        switch(n.$){
            case 10:
                return A2(pc, g, p(r, {
                    kv: g
                }));
            case 4:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 5:
                return A2(pc, g, p(r, {
                    oO: !r.oO
                }));
            case 6:
                return A2(pc, g, p(r, {
                    m5: !r.m5
                }));
            case 7:
                return A2(pc, g, p(r, {
                    ra: !r.ra
                }));
            case 8:
                return A2(pc, g, p(r, {
                    ij: !r.ij
                }));
            case 2:
                return A2(pc, g, (u = n.a).$ ? r : p(r, {
                    oP: u.a
                }));
            case 9:
                return A2(pc, g, p(r, {
                    oW: e = n.a
                }));
            case 1:
                var t = n.a, e = t.a;
                return A2(pc, g, p(r, (u = t.b).$ ? {
                    kv: g
                } : {
                    kv: u.a,
                    nl: !1,
                    oW: e
                }));
            case 0:
                return A2(pc, g, p(r, (u = n.a).$ ? {
                    kv: g
                } : {
                    kv: u.a,
                    nl: !1
                }));
            default:
                var u;
                return A2(pc, g, (u = n.a).$ ? r : p(r, {
                    dK: u.a
                }));
        }
    }), Mj = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Oj = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), qj = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: Oj(r)
        });
    }), Dj = F3(function(n, r, t) {
        return _g({
            n5: n,
            ds: FN(A2(bu, jN, t)),
            dM: Oj(r)
        });
    }), xj = F2(function(n, r) {
        return A3(Dj, n, function(n) {
            return BN(r(n));
        }, r);
    }), Rj = F2(function(n, r) {
        if (r.$) return "";
        var t = r.a;
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, Va(A2(Iu, function(n) {
            return i(n.mm, t);
        }, n))));
    }), Vj = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, Va(A2(Iu, function(n) {
            return i(n.mm, r);
        }, n.oP))));
    }), Ej = F2(function(n, r) {
        return _g({
            n5: n,
            ds: FN(A2(bu, A2(bu, function(n) {
                return A2(ju, 0, n);
            }, Fu(jN)), r)),
            dM: Oj(function(n) {
                return A2(ju, A2(Le, g, g), A2(Fu, BN, r(n)));
            })
        });
    }), zj = T([
        Rg("Table")
    ]), Uj = function() {
        return T([
            Rg("TableTr")
        ]);
    }, Hj = function(n) {
        return uh({
            jY: T([
                A2(RN, "Organization", A2(bu, Vj(n), function(n) {
                    return n.oL;
                })),
                A2(RN, "Type", A2(bu, xC, function(n) {
                    return n.fG;
                })),
                A2(xj, "Created At", function(n) {
                    return n.kg;
                }),
                A2(RN, "Requester", A2(bu, A2(bu, Rj(n.dK), kt), function(n) {
                    return n.pG;
                })),
                A2(Ej, "Started At", function(n) {
                    return n.q5;
                }),
                A2(RN, "Started By", A2(bu, Rj(n.dK), function(n) {
                    return n.q6;
                })),
                A2(Ej, "Completed At", function(n) {
                    return n.j0;
                }),
                A2(RN, "Completed By", A2(bu, Rj(n.dK), function(n) {
                    return n.j1;
                })),
                A2(RN, "Acknowledge By", A2(bu, Rj(n.dK), function(n) {
                    return n.ik;
                })),
                A2(RN, "External Job Id", A2(bu, ju(""), function(n) {
                    return n.lu;
                })),
                A2(qj, "Show", A2(bu, function(n) {
                    return A2(aw, T([
                        sw("/show/" + n.qI)
                    ]), T([
                        ih(xN(n))
                    ]));
                }, function(n) {
                    return n.qK;
                })),
                A2(RN, "Id", function(n) {
                    return n.mm;
                })
            ]),
            kt: p(kh, {
                pR: Uj,
                rA: zj,
                rM: T([
                    Rg("TableTd")
                ])
            }),
            rV: function(n) {
                return n.mm;
            },
            rW: Mj
        });
    }, Wj = {
        $: 5
    }, Qj = F2(function(n, r) {
        return d(i(n.oW.oL, kt(r.mm)), "/admin" + $N({
            B: n.oW.B,
            c$: n.oW.c$,
            oL: kt(r.mm),
            P: n.oW.P
        }), r.n5);
    }), Zj = Se("p"), Kj = {
        $: 8
    }, Yj = function(n) {
        switch(Hi(n)){
            case "true":
                return kt(!0);
            case "false":
                return kt(!1);
            default:
                return Tt;
        }
    }, Xj = F2(function(n, r) {
        return d(i(n.oW.B, Yj(Hi(r.a))), "/admin" + $N({
            B: Yj(Hi(r.a)),
            c$: n.oW.c$,
            oL: n.oW.oL,
            P: n.oW.P
        }), r.b);
    }), Jj = function(n) {
        var r = T([
            m("", "Acknowledged and Not Acknowledged"),
            m("true", "Acknowledged"),
            m("false", "Not Acknowledged")
        ]);
        return A4(CN, n.ij, Kj, A2(Ge, Xj(n), r), "Filter by Acknowledged");
    }, Gj = {
        $: 7
    }, _j = F2(function(n, r) {
        return d(i(n.oW.P, kt(Hi(r.a))), "/admin" + $N({
            B: n.oW.B,
            c$: n.oW.c$,
            oL: n.oW.oL,
            P: kt(Hi(r.a))
        }), r.b);
    }), nP = function(n) {
        var r = T([
            m("", "All Status"),
            m("true", "true"),
            m("false", "false")
        ]);
        return A4(CN, n.ra, Gj, A2(Ge, _j(n), r), "Filter by Status");
    }, rP = {
        $: 6
    }, tP = F2(function(n, r) {
        return d(i(n.oW.c$, kt(Hi(r.a))), "/admin" + $N({
            B: n.oW.B,
            c$: kt(Hi(r.a)),
            oL: n.oW.oL,
            P: n.oW.P
        }), r.b);
    }), eP = function(n) {
        var r = T([
            m("", "All Types"),
            m("DownloadAsIs", "DownloadAsIs"),
            m("PadTranscode", "PadTranscode"),
            m("SimpleTranscode", "SimpleTranscode"),
            m("QC", "QC"),
            m("Spotcheck", "Spotcheck")
        ]);
        return A4(CN, n.m5, rP, A2(Ge, tP(n), r), "Filter by type");
    }, uP = F2(function(n, r) {
        return A2(Le, T([
            Rg("DarkZone"),
            Rg("Filter")
        ]), T([
            A2(Le, T([
                Rg("JobsFilters")
            ]), T([
                eP(n),
                nP(n),
                Jj(n)
            ])),
            A2(Le, T([
                Rg("Summary")
            ]), T([
                A2(mN, g, T([
                    ih("Summary")
                ])),
                A2(Zj, g, T([
                    ih("")
                ])),
                A2(Zj, g, T([
                    ih("Total Jobs: " + It(Dt(r)))
                ]))
            ]))
        ]));
    }), aP = F2(function(n, r) {
        var t = r.oW.c$, e = r.oW.P, u = r.oW.B, a = A2(Iu, function(n) {
            return i(kt(n.B), u) || i(u, Tt);
        }, A2(Iu, function(n) {
            if (t.$) return !0;
            var r = t.a;
            if (qe(r) > 0) {
                var e = bN(n);
                return i(Hi(xC(e.fG)), r);
            }
            return !0;
        }, A2(Iu, function(n) {
            n: for(; !e.$;)switch(e.a){
                case "true":
                    return !i(n.j0, Tt);
                case "false":
                    return i(n.j0, Tt);
                default:
                    break n;
            }
            return !0;
        }, r.kv)));
        return A3(hw, "Jobs", kt(function(n) {
            var r = A2(zi, A2(bu, Hi, function(n) {
                return n.n5;
            }), n.oP);
            return A4(CN, n.oO, Wj, A2(Ge, Qj(n), r), "Choose origanization");
        }(r)), r.nl ? A2(Le, T([
            Rg("EmptySection")
        ]), T([
            A2(Le, g, T([
                ih("loading...")
            ]))
        ])) : A2(Le, g, T([
            A2(uP, r, a),
            A3(cT, Hj(r), r.rJ, a)
        ])));
    }), iP = {
        l: function(n) {
            return n.cZ;
        },
        m: Ij,
        o: F2(function(n, r) {
            return p(n, {
                cZ: r
            });
        }),
        p: function(n) {
            return {
                $: 15,
                a: n
            };
        },
        q: Bj,
        r: aP
    }, oP = {
        $: 10
    }, cP = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sP = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), fP = function(n) {
        return {
            $: 6,
            a: n
        };
    }, lP = F2(function(n, r) {
        return A2(nN, r, A2(ju, A2(YC, r.mm, T([
            XC(r.mm)
        ])), Va(A2(Iu, function(n) {
            return i(n.qI, r.g6);
        }, n))));
    }), mP = function(n) {
        return A2(Gb, function(r) {
            return A2(Ge, lP(r), n);
        }, dc(A2(Ho, _C, A3(ag, KC, WC(A2(Ge, function(n) {
            return n.g6;
        }, n)), rg(ZC)))));
    }, dP = function(n) {
        return A2(Yi, cP, function(n) {
            return A2(OC, mP, function(n) {
                return dc(A2(Ho, EC, So(ml(fP(A2(sP, n, 2))))));
            }(n));
        }(n));
    }, bP = function(n) {
        return A2(Gv, Ml({
            $: 9,
            a: n
        }), oN(0));
    }, pP = {
        kN: Tt,
        lm: Tt,
        pw: Ri(function(n) {
            return p(n, {
                gt: "Search Audio Mapping by Organization, Name or Tracks",
                ss: ""
            });
        }),
        p5: g,
        rv: Tt,
        rJ: a$("Organization")
    }, vP = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $P = F4(function(n, r, t, e) {
        return {
            kL: t,
            lA: e,
            mm: n,
            n5: r
        };
    }), gP = F5(function(n, r, t, e, u) {
        var a = u;
        return {
            e: A3(Fe, F2(function(n, r) {
                return n(r);
            }), a.e, Mo(T([
                A2(mu, n, bi(t)),
                je(e)
            ]))),
            g: function(e) {
                return A2(dt, m(n, A2(Bo, t, r(e))), a.g(e));
            }
        };
    }), hP = F5(function(n, r, t, e, u) {
        return {
            m7: t,
            m8: r,
            n5: n,
            r6: e,
            st: u
        };
    }), kP = Po(A4(rc, "values", function(n) {
        return n.st;
    }, oc(xi), A4(rc, "type", function(n) {
        return n.r6;
    }, xi, A4(rc, "label_en", function(n) {
        return n.m7;
    }, xi, A4(rc, "label_fr", function(n) {
        return n.m8;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(hP))))))), TP = Po(A5(gP, "fields", function(n) {
        return n.lA;
    }, oc(kP), g, A4(rc, "description", function(n) {
        return n.kL;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io($P)))))), wP = function(n) {
        return {
            $: 2,
            a: n
        };
    }, CP = Lo(wP({
        $: 1
    })), NP = dc(A2(Ho, oc(TP), So(CP))), AP = A2(Yi, vP, NP), SP = m(pP, AP), LP = function(n) {
        return {
            $: 3,
            a: n
        };
    }, yP = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), FP = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), jP = function(n) {
        return Lo(wP({
            $: 2,
            a: n
        }));
    }, PP = function(n) {
        return Ri(function(r) {
            return p(r, {
                m6: "Value",
                ss: n
            });
        });
    }, IP = function(n) {
        return {
            m7: Ri(function(r) {
                return p(r, {
                    m6: "Label EN",
                    ss: n.m7
                });
            }),
            m8: Ri(function(r) {
                return p(r, {
                    m6: "Label FR",
                    ss: n.m8
                });
            }),
            n5: Ri(function(r) {
                return p(r, {
                    m6: "Name",
                    ss: n.n5
                });
            }),
            r6: Ri(function(r) {
                return p(r, {
                    m6: "Type",
                    ss: n.r6
                });
            }),
            st: A2(Ge, PP, n.st)
        };
    }, BP = IP({
        m7: "",
        m8: "",
        n5: "",
        r6: "",
        st: g
    }), MP = function(n) {
        return {
            $: 8,
            a: n
        };
    }, OP = F3(function(n, r, t) {
        return {
            kL: r,
            lA: t,
            n5: n
        };
    }), qP = Po(A4(rc, "fields", function(n) {
        return n.lA;
    }, oc(kP), A4(rc, "description", function(n) {
        return n.kL;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(OP))))), DP = function(n) {
        return A2(Yi, MP, function(n) {
            return dc(fg(A3(ag, qP, {
                kL: n.kL.ss,
                lA: A2(Ge, function(n) {
                    return {
                        m7: n.m7.ss,
                        m8: n.m8.ss,
                        n5: n.n5.ss,
                        r6: n.r6.ss,
                        st: A2(Ge, function(n) {
                            return n.ss;
                        }, n.st)
                    };
                }, n.lA),
                n5: n.n5.ss
            }, rg(CP))));
        }(n));
    }, xP = function(n) {
        return {
            $: 10,
            a: n
        };
    }, RP = function(n) {
        return {
            $: 9,
            a: n
        };
    }, VP = F2(function(n, r) {
        return dc(fg(A3(ag, qP, {
            kL: r.kL.ss,
            lA: A2(Ge, function(n) {
                return {
                    m7: n.m7.ss,
                    m8: n.m8.ss,
                    n5: n.n5.ss,
                    r6: n.r6.ss,
                    st: A2(Ge, function(n) {
                        return n.ss;
                    }, n.st)
                };
            }, r.lA),
            n5: r.n5.ss
        }, mg(jP(n.mm)))));
    }), EP = F2(function(n, r) {
        return A2(Yi, RP, A2(VP, n, r));
    }), zP = function(n) {
        var r = function(n) {
            return A2(No, Fu(n), ju(""));
        };
        return {
            kL: Ri(function(t) {
                return p(t, {
                    m6: "Description",
                    ss: A2(r, function(n) {
                        return n.kL;
                    }, n)
                });
            }),
            lA: n.$ ? g : A2(Ge, IP, n.a.lA),
            n5: Ri(function(t) {
                return p(t, {
                    m6: "Name",
                    ss: A2(r, function(n) {
                        return n.n5;
                    }, n)
                });
            }),
            oR: n
        };
    }, UP = F2(function(n, r) {
        var t = n.kN;
        return t.$ ? n : p(n, {
            kN: kt(r(t.a))
        });
    }), HP = F3(function(n, r, t) {
        return A2(UP, n, function(n) {
            return p(n, {
                lA: A2(zt, F2(function(n, e) {
                    return i(n, r) ? t(e) : e;
                }), n.lA)
            });
        });
    }), WP = F4(function(n, r, t, e) {
        return A3(HP, n, r, function(n) {
            return p(n, {
                st: A2(zt, F2(function(n, r) {
                    return i(n, t) ? A2(gg, e, r) : r;
                }), n.st)
            });
        });
    }), QP = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, T([
                    A2(Yi, LP, (s = n.a.mm, dc(A2(Ho, TP, So(jP(s))))))
                ]), r);
            case 3:
                return A2(pc, g, n.a.$ ? A2(FP, n.a.a, r) : p(r, {
                    kN: kt(zP(kt(n.a.a)))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(zP(Tt))
                }));
            case 6:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 4:
                var t = n.a;
                return A2(pc, g, A2(UP, r, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }));
            case 5:
                return t = n.a, A2(pc, g, A2(UP, r, function(n) {
                    return p(n, {
                        kL: A2(gg, t, n.kL)
                    });
                }));
            case 7:
                var e = r.kN;
                if (1 === e.$) return A2(pc, T([
                    n$
                ]), r);
                var u = e.a;
                return A2(pc, T([
                    (f = u.oR, 1 === f.$ ? DP(u) : A2(EP, f.a, u))
                ]), r);
            case 11:
                return A2(pc, T([
                    (c = n.a, A2(Yi, xP, function(n) {
                        return dc(fg(sg(jP(n.mm))));
                    }(c)))
                ]), r);
            case 8:
                return (a = n.a).$ ? A2(pc, g, A2(FP, a.a, r)) : A2(pc, T([
                    AP
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Schema created")
                }));
            case 9:
                return (a = n.a).$ ? A2(pc, g, A2(FP, a.a, r)) : A2(pc, T([
                    AP
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Schema updated")
                }));
            case 10:
                return (a = n.a).$ ? A2(pc, g, A2(FP, a.a, r)) : A2(pc, T([
                    AP
                ]), r);
            case 0:
                var a;
                return A2(pc, g, (a = n.a).$ ? A2(FP, a.a, r) : p(r, {
                    p5: a.a
                }));
            case 22:
                return A2(pc, g, p(r, {
                    pw: A2(gg, t = n.a, r.pw)
                }));
            case 21:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 12:
                return A2(pc, g, A2(UP, r, function(n) {
                    return p(n, {
                        lA: Ju(T([
                            n.lA,
                            T([
                                BP
                            ])
                        ]))
                    });
                }));
            case 13:
                return A2(pc, g, A3(HP, r, i = n.a, function(n) {
                    return p(n, {
                        st: Ju(T([
                            n.st,
                            T([
                                PP("")
                            ])
                        ]))
                    });
                }));
            case 14:
                return t = n.b, A2(pc, g, A3(HP, r, n.a, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }));
            case 15:
                return t = n.b, A2(pc, g, A3(HP, r, n.a, function(n) {
                    return p(n, {
                        m7: A2(gg, t, n.m7)
                    });
                }));
            case 16:
                return t = n.b, A2(pc, g, A3(HP, r, n.a, function(n) {
                    return p(n, {
                        m8: A2(gg, t, n.m8)
                    });
                }));
            case 17:
                return t = n.b, A2(pc, g, A3(HP, r, n.a, function(n) {
                    return p(n, {
                        r6: A2(gg, t, n.r6)
                    });
                }));
            case 18:
                return A2(pc, g, A4(WP, r, i = n.a, o = n.b, t = n.c));
            case 19:
                var i = n.a;
                return A2(pc, g, A2(UP, r, function(n) {
                    return p(n, {
                        lA: Ju(T([
                            A2(Ka, i, n.lA),
                            A2(yP, i + 1, n.lA)
                        ]))
                    });
                }));
            default:
                var o = n.b;
                return A2(pc, g, A3(HP, r, i = n.a, function(n) {
                    return p(n, {
                        st: Ju(T([
                            A2(Ka, o, n.st),
                            A2(yP, o + 1, n.st)
                        ]))
                    });
                }));
        }
        var c, s, f;
    }), ZP = {
        $: 1
    }, KP = function(n) {
        return {
            $: 22,
            a: n
        };
    }, YP = function(n) {
        return {
            $: 2,
            a: n
        };
    }, XP = function(n) {
        return {
            $: 11,
            a: n
        };
    }, JP = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), GP = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: JP(r)
        });
    }), _P = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), nI = T([
        Rg("Table")
    ]), rI = uh({
        jY: T([
            A2(GP, "Edit", A2(bu, Nh("Edit"), YP)),
            A2(_P, "Name", function(n) {
                return n.n5;
            }),
            A2(_P, "Description", function(n) {
                return n.kL;
            }),
            A2(GP, "Delete", A2(bu, Og(Th), XP))
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: nI,
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: function(n) {
            return n.mm;
        },
        rW: function(n) {
            return {
                $: 21,
                a: n
            };
        }
    }), tI = {
        $: 6
    }, eI = function(n) {
        return {
            $: 5,
            a: n
        };
    }, uI = F2(function(n, r) {
        return {
            $: 15,
            a: n,
            b: r
        };
    }), aI = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), iI = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), oI = F2(function(n, r) {
        return {
            $: 17,
            a: n,
            b: r
        };
    }), cI = F3(function(n, r, t) {
        return {
            $: 18,
            a: n,
            b: r,
            c: t
        };
    }), sI = function(n) {
        return {
            $: 4,
            a: n
        };
    }, fI = {
        $: 12
    }, lI = function(n) {
        return {
            $: 13,
            a: n
        };
    }, mI = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), dI = {
        $: 7
    }, bI = F2(function(n, r) {
        return A2(Le, T([
            Rg("ButtonIcon"),
            wh(r)
        ]), T([
            n
        ]));
    }), pI = Se("textarea"), vI = function(n) {
        return A2(Rh, n, A2(pI, T([
            Rg("InputTextarea"),
            Xh(n.kV),
            ek(Fh),
            _h(jh),
            nk(Ph),
            ak(n.ss),
            uk(n.gt),
            zh(Kh(n.m6)),
            Vh(n.kQ)
        ]), g));
    }, $I = function(n) {
        return A2(jT, n, vI(n));
    }, gI = T([
        m("string", "String"),
        m("date", "Date"),
        m("number", "Number"),
        m("boolean", "Boolean")
    ]), hI = function(n) {
        return A2(wT, function(n) {
            var r = function(n) {
                return 1 !== n.oR.$;
            }(n) ? m("Save", "Edit Schema") : m("Create", "New Schema");
            return A4(ZT, r.b, m(r.a, dI), m("Cancel", tI), T([
                A2(dk, sI, IT(n.n5)),
                A2(dk, eI, $I(n.kL)),
                A2(Le, g, T([
                    A2(Le, g, A2(zt, F2(function(n, r) {
                        var t;
                        return A2(Le, g, T([
                            A2(Le, T([
                                Rg("FieldTitle")
                            ]), T([
                                A2(bI, Th, (t = n, {
                                    $: 19,
                                    a: t
                                })),
                                bw("Field #" + It(n + 1))
                            ])),
                            A2(dk, iI(n), IT(r.n5)),
                            A2(dk, uI(n), IT(r.m7)),
                            A2(dk, aI(n), IT(r.m8)),
                            A2(dk, oI(n), A2(ET, r.r6, gI)),
                            A2(FF, "string" === r.r6.ss, A2(Le, T([
                                Rg("InputLabel")
                            ]), T([
                                A2(mh, T([
                                    Rg("InputLabelText")
                                ]), T([
                                    ih("Possible values:")
                                ])),
                                A2(Le, T([
                                    Rg("FieldBloc")
                                ]), $(i(r.st, g) ? T([
                                    ih("All values are accepted.")
                                ]) : A2(zt, F2(function(r, t) {
                                    return A2(Le, T([
                                        Rg("FieldLine")
                                    ]), T([
                                        A2(dk, A2(cI, n, r), IT(t)),
                                        A2(bI, Th, A2(mI, n, r))
                                    ]));
                                }), r.st), T([
                                    A2(Nh, "Add possible Value", lI(n))
                                ])))
                            ])))
                        ]));
                    }), n.lA)),
                    A2(Le, g, T([
                        A2(Nh, "Add New Field", fI)
                    ]))
                ])),
                A2(yF, g, g)
            ]));
        }, n.kN);
    }, kI = F2(function(n, r) {
        var t = Hi(r.pw.ss), e = A2(Iu, function(n) {
            return A2(bu, A2(bu, Oe(t), Hi), function(n) {
                return n.n5;
            })(n) || A2(bu, A2(bu, Oe(t), Hi), function(n) {
                return n.kL;
            })(n);
        }, r.p5);
        return A3(hw, "Metadata Schemas", kt(A2(Nh, "New\u2026", ZP)), A2(Le, g, T([
            A2(dk, KP, ik(r.pw)),
            hI(r),
            A3(cT, rI, r.rJ, e)
        ])));
    }), TI = {
        l: function(n) {
            return n.c2;
        },
        m: SP,
        o: F2(function(n, r) {
            return p(n, {
                c2: r
            });
        }),
        p: function(n) {
            return {
                $: 16,
                a: n
            };
        },
        q: QP,
        r: kI
    }, wI = {
        iP: Au,
        kN: Tt,
        lm: Tt,
        oM: g,
        oP: g,
        pw: Ri(function(n) {
            return p(n, {
                gt: "Search Organizations",
                ss: ""
            });
        }),
        rv: Tt,
        rJ: a$("Organization")
    }, CI = function(n) {
        return {
            $: 0,
            a: n
        };
    }, NI = function(n) {
        return {
            $: 3,
            a: n
        };
    }, AI = Lo(wP(NI({
        $: 0
    }))), SI = F3(function(n, r, t) {
        return {
            iO: r,
            eX: t,
            oN: n
        };
    }), LI = Po(A4(Do, "enablePayment", function(n) {
        return n.eX;
    }, no, A4(rc, "app", function(n) {
        return n.iO;
    }, xi, A4(rc, "organizationId", function(n) {
        return n.oN;
    }, xi, Io(SI))))), yI = oc(LI), FI = dc(A2(Ho, yI, So(AI))), jI = dc(A2(Ho, I$, So(M$))), PI = A2(Yi, CI, _b(m(jI, FI))), II = m(wI, PI), BI = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MI = F3(function(n, r, t) {
        return {
            iO: r,
            eX: t,
            oN: n
        };
    }), OI = Po(A4(rc, "enablePayment", function(n) {
        return n.eX;
    }, no, A4(rc, "app", function(n) {
        return n.iO;
    }, xi, A4(rc, "organizationId", function(n) {
        return n.oN;
    }, xi, Io(MI))))), qI = function(n) {
        return dc(fg(A3(ag, OI, n, rg(AI))));
    }, DI = {
        ob: Tt,
        oN: Tt
    }, xI = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), RI = F2(function(n, r) {
        for(;;){
            if (!r.b) return Tt;
            var t = r.a, e = r.b;
            if (i(n, t.mm)) return kt(t);
            r = e;
        }
    }), VI = function(n) {
        return {
            $: 6,
            a: n
        };
    }, EI = F2(function(n, r) {
        return {
            iO: n,
            eX: r
        };
    }), zI = Po(A4(rc, "enablePayment", function(n) {
        return n.eX;
    }, no, A4(rc, "app", function(n) {
        return n.iO;
    }, xi, Io(EI)))), UI = F2(function(n, r) {
        return dc(fg(A3(ag, zI, r, mg(function(n) {
            return Lo(wP(NI({
                $: 1,
                a: n
            })));
        }(n)))));
    }), HI = F3(function(n, r, t) {
        return A2(Yi, VI, A2(UI, n, {
            iO: r,
            eX: t
        }));
    }), WI = F2(function(n, r) {
        switch(n.$){
            case 0:
                if (n.a.$) return A2(pc, g, A2(xI, n.a.a, r));
                var t = n.a.a, e = t.a, u = t.b, a = A3(Je, F2(function(n, r) {
                    return A3(ko, n.oN, function(r) {
                        if (r.$) {
                            var t = A2(RI, n.oN, e);
                            if (t.$) return Tt;
                            var u = t.a;
                            return kt({
                                iO: n,
                                oL: u,
                                qa: Hi(u.n5)
                            });
                        }
                        return kt(p(r.a, {
                            iO: n
                        }));
                    }, r);
                }), Au, u);
                return A2(pc, g, p(r, {
                    iP: a,
                    oM: u,
                    oP: e
                }));
            case 2:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 3:
                var i = A2(Ge, A2(bu, Yi(BI), qI), A2(ju, g, A2(Fu, Ua, A2(fp, function(n) {
                    var r = m(n.oN, n.ob);
                    return r.a.$ || r.b.$ ? Tt : kt({
                        iO: r.b.a,
                        eX: !1,
                        oN: r.a.a
                    });
                }, r.kN))));
                return A2(pc, i, p(r, {
                    kN: A2(Fu, function(n) {
                        return p(n, {
                            ob: Tt
                        });
                    }, r.kN),
                    lm: Tt,
                    rv: Tt
                }));
            case 4:
                var o = n.a;
                return A2(pc, g, p(r, {
                    kN: kt(p(A2(ju, DI, r.kN), {
                        oN: "" === o ? Tt : kt(o)
                    }))
                }));
            case 11:
                var c = n.a;
                return A2(pc, g, p(r, {
                    kN: kt(p(A2(ju, DI, r.kN), {
                        ob: "" === c ? Tt : kt(c)
                    }))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    lm: Tt,
                    rv: Tt
                }));
            case 5:
                return (s = n.a).$ ? A2(pc, g, A2(xI, s.a, r)) : A2(pc, T([
                    PI
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Onboarded organization onto app")
                }));
            case 6:
                var s;
                return (s = n.a).$ ? A2(pc, g, A2(xI, s.a, r)) : A2(pc, T([
                    PI
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Updated onboarded organization onto app")
                }));
            case 8:
                return A2(pc, g, p(r, {
                    kN: kt(p(DI, {
                        oN: kt(n.a.oL.mm)
                    }))
                }));
            case 9:
                return A2(pc, g, p(r, {
                    kN: kt(DI),
                    lm: Tt,
                    rv: Tt
                }));
            case 7:
                return A2(pc, g, p(r, {
                    pw: A2(gg, n.a, r.pw)
                }));
            case 10:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            default:
                return A2(pc, T([
                    A3(HI, o = n.a, n.b, n.c)
                ]), p(r, {
                    lm: Tt,
                    rv: Tt
                }));
        }
    }), QI = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ZI = {
        $: 9
    }, KI = function(n) {
        return {
            $: 8,
            a: n
        };
    }, YI = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), XI = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: YI(r)
        });
    }), JI = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), GI = uh({
        jY: T([
            A2(XI, "Edit", A2(bu, Nh("Edit"), KI)),
            A2(JI, "Organization", A2(No, function(n) {
                return n.oL;
            }, function(n) {
                return n.n5;
            })),
            A2(XI, "Apps (checked is ACTIVATED payment)", function(n) {
                return A2(Le, g, T([
                    A2(mh, T([
                        Rg("OrganizationOnboarding")
                    ]), T([
                        A2(mh, T([
                            Rg("OrganizationOnboardingCheck")
                        ]), T([
                            i(n.iO.eX, kt(!0)) ? ih("\u2705") : ih("\u274C")
                        ])),
                        ih(n.iO.iO)
                    ]))
                ]));
            })
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: T([
                Rg("Table")
            ]),
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: A2(No, function(n) {
            return n.oL;
        }, function(n) {
            return n.mm;
        }),
        rW: function(n) {
            return {
                $: 10,
                a: n
            };
        }
    }), _I = function(n) {
        return A3(bt, F3(function(n, r, t) {
            return A2(dt, r, t);
        }), g, n);
    }, nB = {
        $: 1
    }, rB = function(n) {
        var r = n.lm;
        if (r.$) {
            var t = n.rv;
            if (t.$) return ih("");
            var e = t.a;
            return A2(Le, T([
                wh(nB)
            ]), T([
                lT(e)
            ]));
        }
        var u = r.a;
        return A2(Le, T([
            wh(nB)
        ]), T([
            fT(u)
        ]));
    }, tB = {
        $: 2
    }, eB = {
        $: 3
    }, uB = function(n) {
        return {
            $: 11,
            a: n
        };
    }, aB = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iB = T([
        "adnomalab",
        "m6pub",
        "nomalab",
        "via"
    ]), oB = {
        jO: Tt,
        bF: g,
        kQ: !1,
        lv: g,
        ml: Tt,
        mI: !1,
        bf: !1,
        bg: !1,
        m6: "",
        ox: Tt,
        rS: "",
        sn: Tt
    }, cB = Oh(g), sB = ju(cB), fB = function(n) {
        return A2(bu, sB, Fu(n));
    }, lB = function(n) {
        return A2(i(n.sn, Tt) ? Le : aw, A2(Lu, n.lv, T([
            A2(fB, wh, n.ox),
            A2(fB, Rg, n.jO),
            A2(fB, sw, n.sn),
            Oh(T([
                m("CustomButtonActive", n.mI),
                m("CustomButtonDisabled", n.kQ),
                m("CustomButtonPrimary", n.bf)
            ])),
            Oh(n.bF),
            Rg("CustomButton"),
            Rg("CustomButtonMini")
        ])), T([
            function() {
                var r = n.ml;
                if (r.$) return ih("");
                var t = r.a;
                return A2(Le, T([
                    Rg("CustomButtonIcon")
                ]), T([
                    t
                ]));
            }(),
            n.bg ? A2(Sg, T([
                Rg("CustomButtonLabel"),
                Ch("submit")
            ]), T([
                ih(n.m6)
            ])) : A2(Dh, T([
                Rg("CustomButtonLabel")
            ]), n.m6)
        ]));
    }, mB = F3(function(n, r, t) {
        return {
            $: 12,
            a: n,
            b: r,
            c: t
        };
    }), dB = F2(function(n, r) {
        return A2(yT, T([
            Rg("OrganizationEditApp")
        ]), T([
            A2(Eh, T([
                Ch("checkbox"),
                NT(i(r.eX, kt(!0))),
                ST(A2(mB, n, r.iO))
            ]), g),
            A2(mh, g, T([
                ih(r.iO)
            ]))
        ]));
    }), bB = function(n) {
        return A2(wT, function(r) {
            return A4(ZT, "Edit Organization", m("Close", tB), m("Close", tB), function() {
                var t = A2(fp, function(r) {
                    return A2(RI, r, n.oP);
                }, r.oN);
                if (t.$) return T([
                    rB(n),
                    A2(DT, T([
                        ek(aB)
                    ]), A2(dt, A2(qT, T([
                        ak("")
                    ]), T([
                        ih("Choose organization...")
                    ])), A2(Ge, function(n) {
                        return A2(qT, T([
                            ak(n.mm)
                        ]), T([
                            ih(n.n5)
                        ]));
                    }, n.oP)))
                ]);
                var e = t.a, u = A2(Fu, function(n) {
                    return n.iO;
                }, A2(lo, e.mm, n.iP));
                return T([
                    A2(mw, g, T([
                        ih("Editing "),
                        ih(e.n5)
                    ])),
                    rB(n),
                    A2(Le, g, T([
                        A2(wT, dB(e.mm), u)
                    ])),
                    A2(FF, i(u, Tt), A2(Le, g, T([
                        A2(DT, T([
                            ek(uB),
                            A2(ju, Oh(g), A2(Fu, ak, r.ob))
                        ]), A2(dt, A2(qT, T([
                            ak("")
                        ]), T([
                            ih("Add app...")
                        ])), A2(Ge, function(n) {
                            return A2(qT, T([
                                ak(n)
                            ]), T([
                                ih(n)
                            ]));
                        }, iB))),
                        lB(p(oB, {
                            mI: !i(r.ob, Tt),
                            m6: "Add New App",
                            ox: kt(eB)
                        }))
                    ])))
                ]);
            }());
        }, n.kN);
    }, pB = F2(function(n, r) {
        var t = Hi(r.pw.ss), e = A2(Iu, A2(bu, Oe(t), function(n) {
            return n.qa;
        }), _I(r.iP));
        return A3(hw, "Organizations: onboarding", kt(A2(Nh, "New\u2026", ZI)), A2(Le, g, T([
            A2(dk, QI, ik(r.pw)),
            rB(r),
            bB(r),
            A3(cT, GI, r.rJ, e)
        ])));
    }), vB = {
        l: function(n) {
            return n.db;
        },
        m: II,
        o: F2(function(n, r) {
            return p(n, {
                db: r
            });
        }),
        p: function(n) {
            return {
                $: 3,
                a: n
            };
        },
        q: WI,
        r: pB
    }, $B = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gB = A2(Yi, $B, dc(A2(Ho, I$, So(M$)))), hB = {
        iQ: Ri(Ie),
        kv: g,
        kw: Tt,
        n0: Ri(Ie),
        oP: g,
        oQ: Ri(Ie),
        rJ: a$("Name"),
        sQ: Ri(Ie)
    }, kB = A2(pc, T([
        gB
    ]), hB), TB = function(n) {
        return {
            $: 6,
            a: n
        };
    }, wB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CB = Po(A4(rc, "path", function(n) {
        return n.gp;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "showName", function(n) {
        return n.g8;
    }, xi, A4(Do, "duration", function(n) {
        return n.eS;
    }, mS, A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "key", function(n) {
        return n.m2;
    }, xi, A4(rc, "bucket", function(n) {
        return n.jt;
    }, xi, A4(Do, "mimeType", function(n) {
        return n.nS;
    }, xi, A4(rc, "size", function(n) {
        return n.qO;
    }, mS, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return {
                                                    jt: u,
                                                    kg: r,
                                                    eS: o,
                                                    m2: a,
                                                    nS: e,
                                                    n5: n,
                                                    gp: f,
                                                    g6: s,
                                                    g8: c,
                                                    qO: t,
                                                    hs: i
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), NB = oc(CB), AB = function(n) {
        return A2(Yi, wB, function(n) {
            return dc(A2(Ho, NB, So(ml(fP(A2(sP, n, 1))))));
        }(n));
    }, SB = F2(function(n, r) {
        switch(n.$){
            case 7:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 2:
                return A2(pc, (t = n.a).$ ? g : T([
                    AB(t.a)
                ]), p(r, {
                    oQ: A2(gg, t, r.oQ)
                }));
            case 3:
                var t = n.a;
                return A2(pc, T([
                    AB(r.oQ.ss)
                ]), p(r, {
                    iQ: A2(gg, t, r.iQ)
                }));
            case 4:
                return t = n.a, A2(pc, T([
                    AB(r.oQ.ss)
                ]), p(r, {
                    n0: A2(gg, t, r.n0)
                }));
            case 5:
                return t = n.a, A2(pc, T([
                    AB(r.oQ.ss)
                ]), p(r, {
                    sQ: A2(gg, t, r.sQ)
                }));
            case 1:
                return A2(pc, g, (e = n.a).$ ? r : p(r, {
                    oP: e.a
                }));
            case 6:
                return A2(pc, g, p(r, {
                    kw: kt(n.a)
                }));
            default:
                var e;
                if ((e = n.a).$) return A2(pc, g, p(r, {
                    kv: g
                }));
                var u = e.a;
                return A2(pc, T([
                    A2(Gv, TB, Jv)
                ]), p(r, {
                    kv: u
                }));
        }
    }), LB = F2(function(n, r) {
        return n ? r : cB;
    }), yB = xg("title"), FB = function(n) {
        return A2(i(n.sn, Tt) ? Le : aw, A2(Lu, n.lv, T([
            A2(LB, !n.kQ, A2(fB, wh, n.ox)),
            A2(fB, Rg, n.jO),
            A2(LB, !n.kQ, A2(fB, sw, n.sn)),
            yB(n.rS),
            Vh(n.kQ),
            Oh(T([
                m("CustomButtonActive", n.mI),
                m("CustomButtonDisabled", n.kQ),
                m("CustomButtonPrimary", n.bf)
            ])),
            Oh(n.bF),
            Rg("CustomButton")
        ])), T([
            function() {
                var r = n.ml;
                if (r.$) return ih("");
                var t = r.a;
                return A2(Le, T([
                    Rg("CustomButtonIcon")
                ]), T([
                    t
                ]));
            }(),
            n.bg ? A2(Sg, T([
                Rg("CustomButtonLabel")
            ]), T([
                ih(n.m6)
            ])) : A2(Dh, T([
                Rg("CustomButtonLabel")
            ]), n.m6)
        ]));
    }, jB = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconOk")
    ]), T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("8 4 12 12 4 12")
        ]), g)
    ])), PB = F2(function(n, r) {
        return A2(Le, T([
            Rg("BannerCTA")
        ]), T([
            A2(Le, T([
                Rg("BannerCTAIcon")
            ]), T([
                jB
            ])),
            A2(Dh, T([
                Rg("BannerCTALabel")
            ]), n),
            FB(r)
        ]));
    }), IB = Fg, BB = Lo(wP({
        $: 0
    })), MB = A2(PB, "Download organizations files listing", p(oB, {
        lv: T([
            A2(IB, "target", "_blank"),
            A2(IB, "data-prevent-history", "true"),
            A2(IB, "download", "organizations-files-listing.csv")
        ]),
        m6: "Generate CSV",
        sn: kt(Ao(BB))
    })), OB = F2(function() {
        return A3(hw, "Organization File Listing", Tt, A2(Le, T([
            Rg("AdminPadding")
        ]), T([
            MB
        ])));
    }), qB = {
        l: function(n) {
            return n.dc;
        },
        m: kB,
        o: F2(function(n, r) {
            return p(n, {
                dc: r
            });
        }),
        p: function(n) {
            return {
                $: 11,
                a: n
            };
        },
        q: SB,
        r: OB
    }, DB = {
        kN: Tt,
        lm: Tt,
        e3: g,
        cX: g,
        f0: g,
        oP: g,
        pw: Ri(function(n) {
            return p(n, {
                gt: "Search Organization by Name, Test Plan or Format",
                ss: ""
            });
        }),
        $7: g,
        dw: g,
        rv: Tt,
        rJ: a$("Name"),
        dA: Au
    }, xB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, RB = dc(A2(Ho, OS, So(DS))), VB = dc(A2(Ho, I$, So(M$))), EB = F5(function(n, r, t, e, u) {
        return {
            lH: n,
            nb: r,
            nL: e,
            nU: t,
            px: u
        };
    }), zB = F3(function(n, r, t) {
        return {
            cK: t,
            al: r,
            dH: n
        };
    }), UB = Po(A4(rc, "durationMax", function(n) {
        return n.cK;
    }, uc, A4(rc, "durationMin", function(n) {
        return n.al;
    }, uc, A4(rc, "totalBreaks", function(n) {
        return n.dH;
    }, uc, Io(zB))))), HB = Po(A4(rc, "ranges", function(n) {
        return n.px;
    }, oc(UB), A4(Do, "maxInterval", function(n) {
        return n.nL;
    }, uc, A4(Do, "minInterval", function(n) {
        return n.nU;
    }, uc, A4(Do, "lastPoint", function(n) {
        return n.nb;
    }, uc, A4(Do, "firstPoint", function(n) {
        return n.lH;
    }, uc, Io(EB))))))), WB = F3(function(n, r, t) {
        return {
            al: t,
            b2: r,
            rS: n
        };
    }), QB = Po(A4(Do, "durationMin", function(n) {
        return n.al;
    }, uc, A4(Do, "offset", function(n) {
        return n.b2;
    }, uc, A4(Do, "title", function(n) {
        return n.rS;
    }, xi, Io(WB))))), ZB = F3(function(n, r, t) {
        return {
            eL: t,
            fU: r,
            fV: n
        };
    }), KB = Po(A4(rc, "deepProbeAnalysis", function(n) {
        return n.eL;
    }, no, A4(rc, "m2cAnalysis", function(n) {
        return n.fU;
    }, no, A4(rc, "m2cProxy", function(n) {
        return n.fV;
    }, no, Io(ZB))))), YB = function(n) {
        switch(n){
            case "anime":
                return St(0);
            case "telenovela":
                return St(1);
            case "other":
                return St(2);
            default:
                return wt(A2(ki, "can't parse str to typology", f$));
        }
    }, XB = function(n) {
        switch(n){
            case 0:
                return "anime";
            case 1:
                return "telenovela";
            default:
                return "other";
        }
    }, JB = A2(Il, XB, YB), GB = Po(A4(rc, "skipJobs", function(n) {
        return n.ce;
    }, KB, A4(rc, "typology", function(n) {
        return n.r7;
    }, JB, A4(rc, "postCredits", function(n) {
        return n.o8;
    }, no, A4(Do, "minOutro", function(n) {
        return n.nX;
    }, uc, A4(Do, "minIntro", function(n) {
        return n.nV;
    }, uc, A4(rc, "skipIntro", function(n) {
        return n.qP;
    }, no, A4(rc, "endingCredits", function(n) {
        return n.bO;
    }, QB, A4(rc, "openingCredits", function(n) {
        return n.b3;
    }, QB, A4(rc, "adBreaks", function(n) {
        return n.az;
    }, HB, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return {
                                                    az: t,
                                                    bO: u,
                                                    mm: n,
                                                    nV: i,
                                                    nX: o,
                                                    n5: r,
                                                    b3: e,
                                                    o8: c,
                                                    qP: a,
                                                    ce: f,
                                                    r7: s
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), _B = oc(GB), nM = function(n) {
        return {
            $: 4,
            a: n
        };
    }, rM = Lo(nM({
        $: 0
    })), tM = dc(A2(Ho, _B, So(rM))), eM = dc(A2(Ho, XS, So(GS))), uM = A2(Gb, Jo, A2(Gb, Ge(function(n) {
        return m(n.mm, n);
    }), dc(A2(Ho, tL, So(uL))))), aM = F6(function(n, r, t, e, u, a) {
        return A2(_e, function(r) {
            return A2(_e, function(t) {
                return A2(_e, function(e) {
                    return A2(_e, function(u) {
                        return A2(_e, function(a) {
                            return Ke(A5(n, r, t, e, u, a));
                        }, a);
                    }, u);
                }, e);
            }, t);
        }, r);
    }), iM = aM, oM = F7(function(n, r, t, e, u, a, i) {
        return A2(OC, function(n) {
            return A2(Gb, n, i);
        }, A6(iM, n, r, t, e, u, a));
    }), cM = A2(Yi, xB, A7(oM, F6(function(n, r, t, e, u, a) {
        return {
            cX: t,
            f0: a,
            oP: n,
            $7: u,
            dw: e,
            dA: r
        };
    }), VB, uM, RB, eM, tM, NP)), sM = m(DB, cM), fM = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), lM = F2(function(n, r) {
        var t = ro(function(t) {
            return p(t, {
                m6: r ? "Select default extra format" : "Select default format",
                ss: n.mM
            });
        });
        return {
            mm: Ri(function(t) {
                return p(t, {
                    m6: r ? "Extra Format" : "Format",
                    ss: n.mm
                });
            }),
            mM: t
        };
    }), mM = T([
        "\\${originalFileName}",
        "\\${broadcasterId}",
        "\\${collectionName}",
        "\\${seasonName}",
        "\\${episodeName}",
        "\\${showTitle}",
        "\\${date}"
    ]), dM = function(n) {
        return {
            ir: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Ad.nomalab destination",
                    ss: !1
                } : {
                    m6: "Ad.nomalab destination",
                    ss: n.a.ir
                });
            }),
            iv: A2(Vi, "Formats", g),
            iG: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Allow Delivery Without Transcoding",
                    ss: !1
                } : {
                    m6: "Toggle Allow Delivery Without Transcoding",
                    ss: n.a.iG
                });
            }),
            i9: Ri(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "\u26A0 Automatic Show Deletion \u26A0",
                    ss: "false"
                } : {
                    m6: "\u26A0 Automatic Show Deletion \u26A0",
                    ss: n.a.i9 ? "true" : "false"
                });
            }),
            jp: Ri(function(r) {
                var t = A2(fp, function(n) {
                    return n.jp;
                }, n);
                return p(r, 1 === t.$ ? {
                    m6: "Broadcaster",
                    ss: ""
                } : {
                    m6: "Broadcaster",
                    ss: L$(t.a)
                });
            }),
            kM: Ri(function(r) {
                if (1 === n.$) return p(r, {
                    m6: "Delivery destination",
                    gt: A3(qt, F2(function(n, r) {
                        return r + "_" + n;
                    }), "ex : ftp://test:test@localhost/upload/", A2(Ge, xe(1), mM)),
                    ss: ""
                });
                var t = n.a;
                return p(r, {
                    m6: "Delivery destination",
                    gt: A3(qt, F2(function(n, r) {
                        return r + (n + "_");
                    }), "ex : ftp://test:test@localhost/upload/", A2(Ge, xe(1), mM)),
                    ss: A2(ju, "", t.kM)
                });
            }),
            kX: Ri(function(r) {
                if (1 === n.$) return p(r, {
                    m6: "Download File Name",
                    gt: A3(qt, F2(function(n, r) {
                        return r + "_" + n;
                    }), "", A2(Ge, xe(1), mM)),
                    ss: ""
                });
                var t = n.a;
                return p(r, {
                    m6: "Download File Name",
                    gt: A3(qt, F2(function(n, r) {
                        return r + (n + "_");
                    }), "", A2(Ge, xe(1), mM)),
                    ss: A2(ju, "", t.kX)
                });
            }),
            la: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle auto accept feature",
                    ss: !1
                } : {
                    m6: "Toggle auto accept feature",
                    ss: n.a.la
                });
            }),
            lb: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle auto reject feature",
                    ss: !1
                } : {
                    m6: "Toggle auto reject feature",
                    ss: n.a.lb
                });
            }),
            lc: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle creation mail",
                    ss: !1
                } : {
                    m6: "Toggle creation mail",
                    ss: n.a.lc
                });
            }),
            ld: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle static ip for delivery",
                    ss: !1
                } : {
                    m6: "Toggle static ip for delivery",
                    ss: n.a.dv
                });
            }),
            le: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle upload success mail",
                    ss: !1
                } : {
                    m6: "Toggle upload success mail",
                    ss: n.a.le
                });
            }),
            lf: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle video ready mail",
                    ss: !0
                } : {
                    m6: "Toggle video ready mail",
                    ss: n.a.lf
                });
            }),
            e3: function() {
                if (n.$) return Au;
                var r = n.a;
                return A2(_o, F2(function(n, r) {
                    return A2(lM, r, !0);
                }), Jo(A2(zt, x$, r.e3)));
            }(),
            cX: function() {
                if (n.$) return Au;
                var r = n.a;
                return A2(_o, F2(function(n, r) {
                    return A2(lM, r, !1);
                }), Jo(A2(zt, x$, r.cX)));
            }(),
            mK: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Advertiser",
                    ss: !1
                } : {
                    m6: "Advertiser",
                    ss: n.a.mK
                });
            }),
            nq: Ri(function(r) {
                var t = A2(fp, function(n) {
                    return n.nq;
                }, n);
                return p(r, t.$ ? {
                    m6: "Logo",
                    ss: ""
                } : {
                    m6: "Logo",
                    ss: t.a
                });
            }),
            nJ: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle manual delivery",
                    ss: !1
                } : {
                    m6: "Toggle manual delivery",
                    ss: n.a.nJ
                });
            }),
            nR: Ri(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Metadata Schema",
                    ss: ""
                } : {
                    m6: "Metadata Schema",
                    ss: A2(ju, "", n.a.nR)
                });
            }),
            n5: Ri(function(r) {
                return p(r, {
                    m6: "Name",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.n5;
                    }, n))
                });
            }),
            n9: Ri(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Need accept before launching transcode",
                    ss: "false"
                } : {
                    m6: "Need accept before launching transcode",
                    ss: n.a.n9 ? "true" : "false"
                });
            }),
            oR: n,
            pp: Ri(function(r) {
                return p(r, {
                    m6: "QC master report template",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.pp;
                    }, n))
                });
            }),
            pq: Ri(function(r) {
                return p(r, {
                    m6: "QC master test plan",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.pq;
                    }, n))
                });
            }),
            pE: ro(function(r) {
                return p(r, 1 === n.$ ? {
                    m6: "Toggle files replication",
                    ss: !1
                } : {
                    m6: "Toggle files replication",
                    ss: n.a.pE
                });
            }),
            $7: function() {
                if (n.$) return Au;
                var r = n.a;
                return A2(_o, F2(function(n, r) {
                    return Ri(function(n) {
                        return p(n, {
                            m6: "Segmentation rule",
                            ss: r
                        });
                    });
                }), Jo(A2(zt, x$, r.$7)));
            }(),
            dw: function() {
                if (n.$) return Au;
                var r = n.a;
                return A2(_o, F2(function(n, r) {
                    return Ri(function(n) {
                        return p(n, {
                            m6: "Subtitle Format",
                            ss: r
                        });
                    });
                }), Jo(A2(zt, x$, r.dw)));
            }()
        };
    }, bM = function(n) {
        return {
            $: 38,
            a: n
        };
    }, pM = F3(function(n, r, t) {
        if (1 === r.$) return wt(r.a);
        var e = r.a;
        return 1 === t.$ ? wt(t.a) : St(A2(n, e, t.a));
    }), vM = function(n) {
        return A2(Ii, g, A3(Je, F2(function(n, r) {
            var t = m(n, r);
            return t.b.$ ? wt(t.b.a) : t.a.$ ? wt(t.a.a) : St(A2(dt, t.a.a, t.b.a));
        }), St(g), A2(Ge, function(n) {
            var r = n.b;
            return A3(pM, F$, St(r.mm.ss), St(r.mM.ss));
        }, pt(n))));
    }, $M = Po(A4(rc, "needAccept", function(n) {
        return n.n9;
    }, no, A4(rc, "autoDeleteShows", function(n) {
        return n.i9;
    }, no, A4(rc, "staticIp", function(n) {
        return n.dv;
    }, no, A5(gP, "additionalVideoFormats", function(n) {
        return n.iv;
    }, oc(xi), g, A4(rc, "metadataSchema", function(n) {
        return n.nR;
    }, xi, A4(rc, "adNomalabDest", function(n) {
        return n.ir;
    }, no, A4(rc, "noProxy", function(n) {
        return n.gd;
    }, no, A4(rc, "noQC", function(n) {
        return n.ge;
    }, no, A4(rc, "isAdvertiser", function(n) {
        return n.mK;
    }, no, A4(rc, "segmentationRules", function(n) {
        return n.$7;
    }, oc(xi), A4(rc, "extraFormats", function(n) {
        return n.e3;
    }, oc(j$), A4(rc, "subtitleFormats", function(n) {
        return n.dw;
    }, oc(xi), A4(rc, "formats", function(n) {
        return n.cX;
    }, oc(j$), A4(Do, "logo", function(n) {
        return n.nq;
    }, xi, A4(rc, "replication", function(n) {
        return n.pE;
    }, no, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iG;
    }, no, A4(rc, "manualDelivery", function(n) {
        return n.nJ;
    }, no, A4(Do, "broadcaster", function(n) {
        return n.jp;
    }, y$, A4(rc, "enableAutoReject", function(n) {
        return n.lb;
    }, no, A4(rc, "enableAutoAccept", function(n) {
        return n.la;
    }, no, A4(rc, "enableUploadSuccessEmail", function(n) {
        return n.le;
    }, no, A4(rc, "enableVideoReadyEmail", function(n) {
        return n.lf;
    }, no, A4(rc, "enableCreationEmail", function(n) {
        return n.lc;
    }, no, A4(Do, "downloadFileName", function(n) {
        return n.kX;
    }, xi, A4(Do, "destination", function(n) {
        return n.kM;
    }, xi, A4(rc, "qcMasterReportTemplate", function(n) {
        return n.pp;
    }, xi, A4(rc, "qcMasterTestPlan", function(n) {
        return n.pq;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return function(g) {
                                                                                return function(h) {
                                                                                    return function(k) {
                                                                                        return function(T) {
                                                                                            return function(w) {
                                                                                                return function(C) {
                                                                                                    return function(N) {
                                                                                                        return function(A) {
                                                                                                            return function(S) {
                                                                                                                return function(L) {
                                                                                                                    return {
                                                                                                                        ir: w,
                                                                                                                        iv: N,
                                                                                                                        iG: m,
                                                                                                                        i9: S,
                                                                                                                        jp: f,
                                                                                                                        kM: e,
                                                                                                                        kX: u,
                                                                                                                        la: c,
                                                                                                                        lb: s,
                                                                                                                        lc: a,
                                                                                                                        le: o,
                                                                                                                        lf: i,
                                                                                                                        e3: $,
                                                                                                                        cX: p,
                                                                                                                        mK: h,
                                                                                                                        nq: b,
                                                                                                                        nJ: l,
                                                                                                                        nR: C,
                                                                                                                        n5: n,
                                                                                                                        n9: L,
                                                                                                                        gd: T,
                                                                                                                        ge: k,
                                                                                                                        pp: t,
                                                                                                                        pq: r,
                                                                                                                        pE: d,
                                                                                                                        $7: g,
                                                                                                                        dv: A,
                                                                                                                        dw: v
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))), gM = F2(function(n, r) {
        return Ve(r) ? St(Tt) : A2(X$, kt, n(r));
    }), hM = Po(A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return {
            mm: n
        };
    }))), kM = function(n) {
        var r;
        return A2(Yi, bM, A2(OC, function(n) {
            return dc(A2(ng, hM, A3(ag, $M, {
                ir: r.ir.ss,
                iv: vt(r.iv.st),
                iG: r.iG.ss,
                i9: "true" === r.i9.ss,
                jp: n,
                kM: Ve(r.kM.ss) ? Tt : kt(r.kM.ss),
                kX: Ve(r.kX.ss) ? Tt : kt(r.kX.ss),
                la: r.la.ss,
                lb: r.lb.ss,
                lc: r.lc.ss,
                le: r.le.ss,
                lf: r.lf.ss,
                e3: vM(r.e3),
                cX: vM(r.cX),
                mK: r.mK.ss,
                nq: Ve(r.nq.ss) ? Tt : kt(r.nq.ss),
                nJ: r.nJ.ss,
                nR: r.nR.ss,
                n5: r.n5.ss,
                n9: "true" === r.n9.ss,
                gd: !1,
                ge: !1,
                pp: r.pp.ss,
                pq: r.pq.ss,
                pE: r.pE.ss,
                $7: A2(Ge, function(n) {
                    return n.b.ss;
                }, pt(r.$7)),
                dv: r.ld.ss,
                dw: A2(Ge, function(n) {
                    return n.b.ss;
                }, pt(r.dw))
            }, rg(M$))));
        }, A2(Qo, IL, ML(A2(gM, S$, (r = n).jp.ss)))));
    }, TM = function(n) {
        return {
            $: 41,
            a: n
        };
    }, wM = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), CM = function(n) {
        return Lo(B$(A2(wM, n, 1)));
    }, NM = function(n) {
        return {
            $: 39,
            a: n
        };
    }, AM = F2(function(n, r) {
        return A2(OC, function(t) {
            return dc(fg(A3(ag, $M, {
                ir: r.ir.ss,
                iv: vt(r.iv.st),
                iG: r.iG.ss,
                i9: "true" === r.i9.ss,
                jp: t,
                kM: Ve(r.kM.ss) ? Tt : kt(r.kM.ss),
                kX: Ve(r.kX.ss) ? Tt : kt(r.kX.ss),
                la: r.la.ss,
                lb: r.lb.ss,
                lc: r.lc.ss,
                le: r.le.ss,
                lf: r.lf.ss,
                e3: vM(r.e3),
                cX: vM(r.cX),
                mK: r.mK.ss,
                nq: Ve(r.nq.ss) ? Tt : kt(r.nq.ss),
                nJ: r.nJ.ss,
                nR: r.nR.ss,
                n5: r.n5.ss,
                n9: "true" === r.n9.ss,
                gd: !1,
                ge: !1,
                pp: r.pp.ss,
                pq: r.pq.ss,
                pE: r.pE.ss,
                $7: A2(Ge, function(n) {
                    return n.b.ss;
                }, pt(r.$7)),
                dv: r.ld.ss,
                dw: A2(Ge, function(n) {
                    return n.b.ss;
                }, pt(r.dw))
            }, mg(CM(n.mm)))));
        }, A2(Qo, IL, ML(A2(gM, S$, r.jp.ss))));
    }), SM = F2(function(n, r) {
        return A2(Yi, NM, A2(AM, n, r));
    }), LM = F2(function(n, r) {
        return !A2(lo, n, r).$;
    }), yM = F2(function(n, r) {
        var t = n.a, e = n.b, u = r.st;
        return p(r, A2(LM, t, u) ? {
            st: A2(ho, t, u)
        } : {
            st: A3(wu, t, e, u)
        });
    }), FM = F2(function(n, r) {
        return p(r, n.$ ? {
            mM: A2(vg, n.a, r.mM)
        } : {
            mm: A2(gg, n.a, r.mm)
        });
    }), jM = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(dM(kt(n.a)))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(dM(Tt))
                }));
            case 3:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 5:
                var t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: e
                }));
            case 6:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pq: A2(gg, t, n.pq)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 9:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pp: A2(gg, t, n.pp)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 7:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        kM: A2(gg, t, n.kM)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 8:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        kX: A2(gg, t, n.kX)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 42:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nq: A2(gg, t, n.nq)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 10:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lc: A2(vg, t, n.lc)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 11:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lf: A2(vg, t, n.lf)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 12:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        le: A2(vg, t, n.le)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 13:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        la: A2(vg, t, n.la)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 14:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lb: A2(vg, t, n.lb)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 15:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        jp: A2(gg, t, n.jp)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 16:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nR: A2(gg, t, n.nR)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 17:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nJ: A2(vg, t, n.nJ)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 18:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        iG: A2(vg, t, n.iG)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 19:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        pE: A2(vg, t, n.pE)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 20:
                t = n.a;
                var u = n.b;
                return e = A2(Fu, function(n) {
                    return p(n, {
                        cX: A2(_o, F2(function(n, r) {
                            return i(n, u) ? A2(FM, t, r) : r;
                        }), n.cX)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 33:
                return u = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        cX: A2(U$, F2(function(n) {
                            return !i(n, u);
                        }), n.cX)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 29:
                var a = A2(lM, {
                    mm: "",
                    mM: !1
                }, !1), o = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.cX)));
                }, r.kN));
                return e = A2(Fu, function(n) {
                    return p(n, {
                        cX: A3(wu, o + 1, a, n.cX)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 21:
                return t = n.a, u = n.b, e = A2(Fu, function(n) {
                    return p(n, {
                        dw: A2(_o, F2(function(n, r) {
                            return i(n, u) ? A2(gg, t, r) : r;
                        }), n.dw)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 34:
                return u = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        dw: A2(U$, F2(function(n) {
                            return !i(n, u);
                        }), n.dw)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 30:
                return a = Ri(function(n) {
                    return p(n, {
                        m6: "Subtitle Format",
                        ss: ""
                    });
                }), o = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.dw)));
                }, r.kN)), e = A2(Fu, function(n) {
                    return p(n, {
                        dw: A3(wu, o + 1, a, n.dw)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 22:
                return t = n.a, u = n.b, e = A2(Fu, function(n) {
                    return p(n, {
                        e3: A2(_o, F2(function(n, r) {
                            return i(n, u) ? A2(FM, t, r) : r;
                        }), n.e3)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 35:
                return u = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        e3: A2(U$, F2(function(n) {
                            return !i(n, u);
                        }), n.e3)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 31:
                return a = A2(lM, {
                    mm: "",
                    mM: !1
                }, !0), o = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.e3)));
                }, r.kN)), e = A2(Fu, function(n) {
                    return p(n, {
                        e3: A3(wu, o + 1, a, n.e3)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 23:
                return t = n.a, u = n.b, e = A2(Fu, function(n) {
                    return p(n, {
                        $7: A2(_o, F2(function(n, r) {
                            return i(n, u) ? A2(gg, t, r) : r;
                        }), n.$7)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 36:
                return u = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        $7: A2(U$, F2(function(n) {
                            return !i(n, u);
                        }), n.$7)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 32:
                return a = Ri(function(n) {
                    return p(n, {
                        m6: "Segmentation Rule",
                        ss: ""
                    });
                }), o = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.$7)));
                }, r.kN)), e = A2(Fu, function(n) {
                    return p(n, {
                        $7: A3(wu, o + 1, a, n.$7)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 24:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        mK: A2(vg, t, n.mK)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 25:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ir: A2(vg, t, n.ir)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 26:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        n9: A2(gg, t, n.n9)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 27:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        ld: A2(vg, t, n.ld)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 28:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        i9: A2(gg, t, n.i9)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 37:
                var c = r.kN;
                return A2(pc, T(1 === c.$ ? [
                    n$
                ] : 1 === (d = (e = c.a).oR).$ ? [
                    kM(e)
                ] : [
                    A2(SM, d.a, e)
                ]), r);
            case 40:
                return A2(pc, T([
                    (m = n.a, A2(Yi, TM, function(n) {
                        return dc(fg(sg(CM(n.mm))));
                    }(m)))
                ]), r);
            case 38:
                return (s = n.a).$ ? A2(pc, g, A2(fM, s.a, r)) : A2(pc, T([
                    cM
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Organization created")
                }));
            case 39:
                return (s = n.a).$ ? A2(pc, g, A2(fM, s.a, r)) : A2(pc, T([
                    cM
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Organization updated")
                }));
            case 4:
                return A2(pc, g, p(r, {
                    lm: Tt
                }));
            case 41:
                return (s = n.a).$ ? A2(pc, g, A2(fM, s.a, r)) : A2(pc, T([
                    cM
                ]), r);
            case 0:
                var s;
                if ((s = n.a).$) return A2(pc, g, A2(fM, s.a, r));
                var f = s.a;
                return A2(pc, g, p(r, {
                    cX: f.cX,
                    f0: f.f0,
                    oP: f.oP,
                    $7: f.$7,
                    dw: f.dw,
                    dA: f.dA
                }));
            case 44:
                return A2(pc, g, p(r, {
                    pw: A2(gg, t = n.a, r.pw)
                }));
            case 43:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            default:
                var l = n.a;
                return e = A2(Fu, function(n) {
                    return p(n, {
                        iv: A2(yM, l, n.iv)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
        }
        var m, d;
    }), PM = {
        $: 1
    }, IM = function(n) {
        return {
            $: 44,
            a: n
        };
    }, BM = function(n) {
        return {
            $: 2,
            a: n
        };
    }, MM = function(n) {
        return {
            $: 43,
            a: n
        };
    }, OM = function(n) {
        return {
            $: 40,
            a: n
        };
    }, qM = F2(function(n, r) {
        return _g({
            n5: n,
            ds: Eg(function(n) {
                return r(n) ? "1" : "0";
            }),
            dM: function(n) {
                return A2(Vg, g, T([
                    r(n) ? Gg : Jg
                ]));
            }
        });
    }), DM = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), xM = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: DM(r)
        });
    }), RM = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), VM = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Iu, function(n) {
                return i(n.mm, r.mm);
            }, n);
            return t.b ? t.a.n5 : "";
        }, r.e3);
    }), EM = F2(function(n, r) {
        return function(n) {
            for(;;){
                if (!n.b) return "?unknown";
                var t = n.a, e = n.b;
                if (i(t.mm, r)) return t.n5;
                n = e;
            }
        }(n);
    }), zM = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Iu, function(n) {
                return i(n.mm, r.mm);
            }, n);
            return t.b ? t.a.n5 : "";
        }, r.cX);
    }), UM = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, A2(lo, r.pq, n)));
    }), HM = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Iu, function(n) {
                return i(n.mm, r);
            }, n);
            return t.b ? t.a.n5 : "";
        }, r.$7);
    }), WM = F2(function(n, r) {
        return A2(Ge, function(r) {
            var t = A2(Iu, function(n) {
                return i(n.mm, r);
            }, n);
            return t.b ? t.a.n5 : "";
        }, r.dw);
    }), QM = T([
        Rg("Table")
    ]), ZM = function() {
        return T([
            Rg("TableTr")
        ]);
    }, KM = F5(function(n, r, t, e, u) {
        return uh({
            jY: T([
                A2(xM, "Edit", A2(bu, Nh("Edit"), BM)),
                A2(RM, "Name", function(n) {
                    return n.n5;
                }),
                A2(RM, "Master Test plan", UM(n)),
                A2(RM, "Master Report template", function(n) {
                    return n.pp;
                }),
                A2(RM, "Destination", A2(bu, ju(""), function(n) {
                    return n.kM;
                })),
                A2(qM, "Manual Delivery", function(n) {
                    return n.nJ;
                }),
                A2(qM, "Allow Delivery Without Transcoding", function(n) {
                    return n.iG;
                }),
                A2(qM, "Replication", function(n) {
                    return n.pE;
                }),
                A2(qM, "Toggle creation mail", function(n) {
                    return n.lc;
                }),
                A2(qM, "Toggle video ready mail", function(n) {
                    return n.lf;
                }),
                A2(qM, "Toggle upload success mail", function(n) {
                    return n.le;
                }),
                A2(qM, "Toggle auto accept feature", function(n) {
                    return n.la;
                }),
                A2(qM, "Toggle auto reject feature", function(n) {
                    return n.lb;
                }),
                A2(RM, "Broadcaster workflow", function(n) {
                    return A2(ju, "", A2(Fu, L$, n.jp));
                }),
                A2(RM, "Formats", A2(No, zM(r), Bt(", "))),
                A2(RM, "SubtitleFormats", A2(No, WM(t), Bt(", "))),
                A2(RM, "SegmentationRules", A2(No, HM(e), Bt(", "))),
                A2(RM, "ExtraFormats", A2(No, VM(r), Bt(", "))),
                A2(RM, "Metadata Schema", function(n) {
                    return A2(ju, "", A2(Fu, EM(u), n.nR));
                }),
                A2(qM, "Advertiser", function(n) {
                    return n.mK;
                }),
                A2(qM, "Ad.Nomalab destination", function(n) {
                    return n.ir;
                }),
                A2(RM, "\u26A0 Automatic Show Deletion \u26A0", function(n) {
                    return n.i9 ? "true" : "false";
                }),
                A2(RM, "Need accept before launching transcode", function(n) {
                    return n.n9 ? "true" : "false";
                }),
                A2(xM, "Delete", A2(bu, Og(Th), OM)),
                A2(qM, "Toggle static ip for delivery", function(n) {
                    return n.dv;
                })
            ]),
            kt: p(kh, {
                pR: ZM,
                rA: QM,
                rM: T([
                    Rg("TableTd")
                ])
            }),
            rV: function(n) {
                return n.mm;
            },
            rW: MM
        });
    }), YM = {
        $: 4
    }, XM = function(n) {
        var r = n.lm;
        if (r.$) return A2(Le, g, g);
        var t = r.a;
        return A2(Le, T([
            wh(YM)
        ]), T([
            fT(t)
        ]));
    }, JM = {
        $: 3
    }, GM = function(n) {
        return {
            $: 18,
            a: n
        };
    }, _M = function(n) {
        return {
            $: 28,
            a: n
        };
    }, nO = function(n) {
        return {
            $: 15,
            a: n
        };
    }, rO = function(n) {
        return {
            $: 7,
            a: n
        };
    }, tO = function(n) {
        return {
            $: 8,
            a: n
        };
    }, eO = function(n) {
        return {
            $: 25,
            a: n
        };
    }, uO = function(n) {
        return {
            $: 24,
            a: n
        };
    }, aO = function(n) {
        return {
            $: 42,
            a: n
        };
    }, iO = function(n) {
        return {
            $: 17,
            a: n
        };
    }, oO = function(n) {
        return {
            $: 16,
            a: n
        };
    }, cO = function(n) {
        return {
            $: 5,
            a: n
        };
    }, sO = function(n) {
        return {
            $: 26,
            a: n
        };
    }, fO = function(n) {
        return {
            $: 9,
            a: n
        };
    }, lO = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mO = function(n) {
        return {
            $: 19,
            a: n
        };
    }, dO = function(n) {
        return {
            $: 13,
            a: n
        };
    }, bO = function(n) {
        return {
            $: 14,
            a: n
        };
    }, pO = function(n) {
        return {
            $: 10,
            a: n
        };
    }, vO = function(n) {
        return {
            $: 27,
            a: n
        };
    }, $O = function(n) {
        return {
            $: 12,
            a: n
        };
    }, gO = function(n) {
        return {
            $: 11,
            a: n
        };
    }, hO = {
        $: 31
    }, kO = {
        $: 29
    }, TO = {
        $: 32
    }, wO = {
        $: 30
    }, CO = function(n) {
        return {
            $: 45,
            a: n
        };
    }, NO = {
        $: 37
    }, AO = F2(function(n, r) {
        var t = "true" === n.ss && n.fh;
        return A2(Le, T([
            Rg("InputLabelWrapper"),
            Oh(T([
                m("InputLabelDanger", t)
            ]))
        ]), T([
            A2(yT, T([
                Rg("InputLabel")
            ]), T([
                A2(Le, T([
                    Rg("InputLabelText")
                ]), T([
                    ih(n.m6),
                    n.mQ ? ih("") : A2(Dh, T([
                        Rg("InputMandatory")
                    ]), "*")
                ])),
                A2(VT, n, r)
            ])),
            t ? A2(Zj, g, T([
                ih("Attention vous vous appr\xeatez \xe0 changer l'\xe9tat de suppression de cette organisation est-ce que c'est bien ce que vous voulez faire ?")
            ])) : ih("")
        ]));
    }), SO = Se("details"), LO = function(n) {
        return A2(mh, g, T([
            ih(n)
        ]));
    }, yO = Se("summary"), FO = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(Le, T([
            Rg("SelectMultipleItem"),
            Oh(T([
                m("SelectMultipleItemSelected", A2(LM, t, n.st))
            ])),
            wh(m(t, e))
        ]), T([
            ih(e)
        ]));
    }), jO = function(n) {
        var r = A2(Le, T([
            Rg("SelectMultiple"),
            Oh(T([
                m("SelectMultipleDisabled", !n.eY)
            ]))
        ]), T([
            A2(Le, T([
                Rg("SelectMultipleList")
            ]), A2(Ge, FO(n), n.jL))
        ]));
        return "" === n.m6 ? r : A2(yT, T([
            Rg("SelectMultipleLabel")
        ]), T([
            A2(Le, T([
                Rg("SelectMultipleLabelText")
            ]), T([
                ih(n.m6)
            ])),
            r
        ]));
    }, PO = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), IO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MO = F2(function(n, r) {
        return A2(Le, g, T([
            A2(dk, BO, A2(ET, n.mm, r)),
            A2(dk, IO, PT(n.mM))
        ]));
    }), OO = F2(function(n, r) {
        var t = A2(dt, m("", ""), A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, A2(zi, A2(No, function(n) {
            return n.n5;
        }, Hi), r)));
        return A2(Ge, Ko, pt(A2(_o, F2(function(n, r) {
            var e;
            return A2(Le, T([
                A2(ph, "position", "relative"),
                A2(ph, "margin", "25px 0")
            ]), T([
                A2(dk, function(r) {
                    return A2(PO, r, n);
                }, A2(MO, r, t)),
                A3(JT, "remove", T([
                    m("position", "absolute"),
                    m("right", "0")
                ]), (e = n, {
                    $: 35,
                    a: e
                }))
            ]));
        }), n.e3)));
    }), qO = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), DO = F2(function(n, r) {
        var t = A2(dt, m("", ""), A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, A2(zi, A2(No, function(n) {
            return n.n5;
        }, Hi), r)));
        return A2(Ge, Ko, pt(A2(_o, F2(function(n, r) {
            var e;
            return A2(Le, T([
                A2(ph, "position", "relative"),
                A2(ph, "margin", "25px 0")
            ]), T([
                A2(dk, function(r) {
                    return A2(qO, r, n);
                }, A2(MO, r, t)),
                A3(JT, "remove", T([
                    m("position", "absolute"),
                    m("right", "0")
                ]), (e = n, {
                    $: 33,
                    a: e
                }))
            ]));
        }), n.cX)));
    }), xO = F2(function(n, r) {
        return {
            $: 23,
            a: n,
            b: r
        };
    }), RO = F2(function(n, r) {
        var t = A2(dt, m("", ""), A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, A2(zi, A2(No, function(n) {
            return n.n5;
        }, Hi), r)));
        return A2(Ge, Ko, pt(A2(_o, F2(function(n, r) {
            var e;
            return A2(Le, T([
                A2(ph, "position", "relative"),
                A2(ph, "margin", "25px 0")
            ]), T([
                A2(dk, function(r) {
                    return A2(xO, r, n);
                }, A2(ET, r, t)),
                A3(JT, "remove", T([
                    m("position", "absolute"),
                    m("right", "0")
                ]), (e = n, {
                    $: 36,
                    a: e
                }))
            ]));
        }), n.$7)));
    }), VO = F2(function(n, r) {
        return {
            $: 21,
            a: n,
            b: r
        };
    }), EO = F2(function(n, r) {
        var t = A2(dt, m("", ""), A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, A2(zi, A2(No, function(n) {
            return n.n5;
        }, Hi), r)));
        return A2(Ge, Ko, pt(A2(_o, F2(function(n, r) {
            var e;
            return A2(Le, T([
                A2(ph, "position", "relative"),
                A2(ph, "margin", "25px 0")
            ]), T([
                A2(dk, function(r) {
                    return A2(VO, r, n);
                }, A2(ET, r, t)),
                A3(JT, "remove", T([
                    m("position", "absolute"),
                    m("right", "0")
                ]), (e = n, {
                    $: 34,
                    a: e
                }))
            ]));
        }), n.dw)));
    }), zO = function(n) {
        return A2(wT, function(r) {
            var t, e = A2(Ge, function(n) {
                return m(n.a, n.b.n5);
            }, A2(zi, A2(No, Ko, A2(No, function(n) {
                return n.n5;
            }, Hi)), pt(n.dA))), u = A2(zi, A2(No, Ko, Hi), A2(Ge, function(n) {
                return m(n.mm, n.n5);
            }, n.f0)), a = T([
                m("", ""),
                m(L$(0), L$(0)),
                m(L$(1), L$(1)),
                m(L$(3), L$(3)),
                m(L$(4), L$(4)),
                m(L$(5), L$(5)),
                m(L$(2), L$(2)),
                m(L$(6), L$(6)),
                m(L$(7), L$(7)),
                m(L$(8), L$(8)),
                m(L$(9), L$(9)),
                m(L$(10), L$(10)),
                m(L$(11), L$(11)),
                m(L$(12), L$(12)),
                m(L$(13), L$(13)),
                m(L$(14), L$(14)),
                m(L$(15), L$(15)),
                m(L$(16), L$(16)),
                m(L$(17), L$(17)),
                m(L$(18), L$(18)),
                m(L$(19), L$(19)),
                m(L$(20), L$(20))
            ]), i = function(n) {
                return 1 !== n.oR.$;
            }(r) ? m("Save", "Edit Organization") : m("Create", "New Organization");
            return A4(ZT, i.b, m(i.a, NO), m("Cancel", JM), $(T([
                XM(n),
                A2(dk, cO, IT(r.n5)),
                A2(dk, lO, A2(ET, r.pq, e)),
                A2(dk, fO, IT(r.pp)),
                A2(dk, rO, IT(r.kM)),
                A2(dk, tO, IT(r.kX)),
                A2(dk, iO, PT(r.nJ)),
                A2(dk, GM, PT(r.iG)),
                A2(dk, pO, PT(r.lc)),
                A2(dk, gO, PT(r.lf)),
                A2(dk, $O, PT(r.le)),
                A2(dk, dO, PT(r.la)),
                A2(dk, bO, PT(r.lb)),
                A2(dk, vO, PT(r.ld)),
                A2(dk, nO, A2(ET, r.jp, a)),
                A2(dk, aO, IT(r.nq)),
                A2(yF, g, g),
                A2(yF, g, g),
                A2(SF, g, T([
                    ih("Advertisement")
                ])),
                A2(dk, uO, PT(r.mK)),
                A2(dk, eO, PT(r.ir)),
                A2(dk, sO, A2(ET, r.n9, T([
                    m("false", "Deactivate"),
                    m("true", "activate")
                ]))),
                A2(wF, g, g),
                A2(wF, g, g),
                A2(SF, g, T([
                    ih("Metadata (Schema)")
                ])),
                A2(dk, oO, A2(ET, r.nR, u)),
                A2(SF, g, T([
                    ih("Replication")
                ])),
                A2(dk, mO, PT(r.pE)),
                A2(wF, g, g),
                A2(wF, g, g),
                A2(SF, g, T([
                    ih("Maintenance Task")
                ])),
                A2(dk, _M, A2(AO, r.i9, T([
                    m("false", "no automatic deletion"),
                    m("true", "ACTIVATE AUTOMATIC DELETION")
                ]))),
                A2(wF, g, g),
                A2(wF, g, g)
            ]), $(A2(DO, r, n.cX), $(T([
                A2(Nh, "Add New Format", kO),
                A2(wF, g, g),
                A2(wF, g, g)
            ]), $(A2(EO, r, n.dw), $(T([
                A2(Nh, "Add New Subtitle Format", wO),
                A2(wF, g, g),
                A2(wF, g, g)
            ]), $(A2(OO, r, n.cX), $(T([
                A2(Nh, "Add New Extra Format", hO),
                A2(wF, g, g),
                A2(wF, g, g)
            ]), $(A2(RO, r, n.$7), T([
                A2(Nh, "Add New Segmentation rule", TO),
                A2(wF, g, g),
                A2(wF, g, g),
                A2(SO, g, T([
                    A2(yO, g, T([
                        A2(mh, T([
                            Rg("AdminDetailsSummary")
                        ]), T([
                            ih("Additional videos")
                        ])),
                        A2(mh, T([
                            Rg("AdminDetailsSelection")
                        ]), A2(Ge, LO, _I(r.iv.st)))
                    ])),
                    A2(Le, g, T([
                        (t = p(r.iv, {
                            jL: A2(Ge, function(n) {
                                return m(n.mm, n.n5);
                            }, n.cX)
                        }), A2(dk, CO, jO(t)))
                    ]))
                ]))
            ]))))))))));
        }, n.kN);
    }, UO = F2(function(n, r) {
        var t, e, u, a = Hi(r.pw.ss), i = A2(Iu, (t = m(r.dA, r.cX), e = t.a, u = t.b, function(n) {
            return A2(bu, A2(bu, Oe(a), Hi), function(n) {
                return n.n5;
            })(n) || A2(Oe, a, Hi(A2(UM, e, n))) || A2(Oe, a, Hi(A2(Bt, ", ", A2(zM, u, n))));
        }), r.oP);
        return A3(hw, "Organizations", kt(A2(Nh, "New\u2026", PM)), A2(Le, g, T([
            XM(r),
            A2(dk, IM, ik(r.pw)),
            zO(r),
            A3(cT, A5(KM, r.dA, r.cX, r.dw, r.$7, r.f0), r.rJ, i)
        ])));
    }), HO = {
        l: function(n) {
            return n.oP;
        },
        m: sM,
        o: F2(function(n, r) {
            return p(n, {
                oP: r
            });
        }),
        p: function(n) {
            return {
                $: 2,
                a: n
            };
        },
        q: jM,
        r: UO
    }, WO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QO = A2(Yi, WO, dc(A2(Ho, I$, So(M$)))), ZO = {
        kv: g,
        oP: g,
        oQ: Ri(Ie),
        rJ: a$("Completed At")
    }, KO = A2(pc, T([
        QO
    ]), ZO), YO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, XO = F4(function(n, r, t, e) {
        return {
            lB: t,
            bl: r,
            gR: e,
            g6: n
        };
    }), JO = F4(function(n, r, t, e) {
        return {
            eZ: e,
            ft: n,
            n5: r,
            hp: t
        };
    }), GO = Po(A4(rc, "end_millis", function(n) {
        return n.eZ;
    }, uc, A4(rc, "start_millis", function(n) {
        return n.hp;
    }, uc, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, Io(JO)))))), _O = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), nq = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(_O)))), rq = F7(function(n, r, t, e, u, a, i) {
        return {
            jI: u,
            j0: e,
            kg: t,
            lm: r,
            mm: n,
            fS: a,
            rO: i
        };
    }), tq = F2(function(n, r) {
        return {
            n5: n,
            aR: r
        };
    }), eq = F2(function(n, r) {
        return {
            nK: r,
            nT: n
        };
    }), uq = Po(A4(rc, "max", function(n) {
        return n.nK;
    }, uc, A4(rc, "min", function(n) {
        return n.nT;
    }, uc, Io(eq)))), aq = Po(A4(rc, "duration", function(n) {
        return n.eS;
    }, uq, Io(function(n) {
        return {
            eS: n
        };
    }))), iq = Po(A4(rc, "parameters", function(n) {
        return n.aR;
    }, aq, A4(rc, "name", function(n) {
        return n.n5;
    }, nA, Io(tq)))), oq = Po(A4(rc, "templateName", function(n) {
        return n.rO;
    }, xi, A4(rc, "log", function(n) {
        return n.fS;
    }, xi, A4(rc, "checks", function(n) {
        return n.jI;
    }, oc(iq), A4(Do, "completedAt", function(n) {
        return n.j0;
    }, td, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(rq))))))))), cq = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), sq = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(cq)))), fq = Po(A4(rc, "check_results", function(n) {
        return n.gR;
    }, oc(GO), A4(rc, "file", function(n) {
        return n.lB;
    }, nq, A4(rc, "result", function(n) {
        return n.bl;
    }, oq, A4(rc, "show", function(n) {
        return n.g6;
    }, sq, Io(XO)))))), lq = oc(fq), mq = F2(function(n, r) {
        return {
            cF: r,
            qK: n
        };
    }), dq = F2(function(n, r) {
        return A2(mq, A2(ju, A2(YC, r.g6.mm, T([
            XC(r.g6.mm)
        ])), Va(A2(Iu, function(n) {
            return i(n.qI, r.g6.mm);
        }, n))), r);
    }), bq = function(n) {
        return A2(Gb, function(r) {
            return A2(Ge, dq(r), n);
        }, dc(A2(Ho, _C, A3(ag, KC, WC(A2(Ge, A2(No, function(n) {
            return n.g6;
        }, function(n) {
            return n.mm;
        }), n)), rg(ZC)))));
    }, pq = function(n) {
        return A2(Yi, YO, function(n) {
            return A2(OC, bq, function(n) {
                return dc(A2(Ho, lq, So(ml(KN({
                    $: 4,
                    a: n
                })))));
            }(n));
        }(n));
    }, vq = F2(function(n, r) {
        switch(n.$){
            case 3:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 2:
                var t = n.a;
                return A2(pc, t.$ ? g : T([
                    pq(t.a)
                ]), p(r, {
                    oQ: A2(gg, t, r.oQ)
                }));
            case 1:
                return A2(pc, g, (e = n.a).$ ? r : p(r, {
                    oP: e.a
                }));
            default:
                var e;
                return A2(pc, g, p(r, (e = n.a).$ ? {
                    kv: g
                } : {
                    kv: e.a
                }));
        }
    }), $q = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), gq = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: $q(r)
        });
    }), hq = F3(function(n, r, t) {
        return _g({
            n5: n,
            ds: FN(A2(bu, jN, t)),
            dM: $q(r)
        });
    }), kq = F2(function(n, r) {
        return A3(hq, n, function(n) {
            return BN(r(n));
        }, r);
    }), Tq = F2(function(n, r) {
        return _g({
            n5: n,
            ds: FN(A2(bu, A2(bu, function(n) {
                return A2(ju, 0, n);
            }, Fu(jN)), r)),
            dM: $q(function(n) {
                return A2(ju, A2(Le, g, g), A2(Fu, BN, r(n)));
            })
        });
    }), wq = T([
        Rg("Table")
    ]), Cq = function(n) {
        return A3(JN, n.n5, n.aR.eS.nT, n.aR.eS.nK);
    }, Nq = uh({
        jY: T([
            A2(gq, "Show", function(n) {
                return A2(aw, T([
                    sw("/show/" + n.cF.g6.mm)
                ]), T([
                    ih(xN(n.qK))
                ]));
            }),
            A2(kq, "Created At", A2(No, function(n) {
                return n.cF;
            }, A2(No, function(n) {
                return n.bl;
            }, function(n) {
                return n.kg;
            }))),
            A2(Tq, "Completed At", A2(No, function(n) {
                return n.cF;
            }, A2(No, function(n) {
                return n.bl;
            }, function(n) {
                return n.j0;
            }))),
            A2(RN, "Deep probe Name", A2(bu, A2(bu, function(n) {
                return n.rO;
            }, function(n) {
                return n.bl;
            }), function(n) {
                return n.cF;
            })),
            A2(RN, "Configuration", A2(bu, A2(bu, A2(bu, A2(bu, A2(bu, Bt(", "), Ge(DA)), Ge(Cq)), function(n) {
                return n.jI;
            }), function(n) {
                return n.bl;
            }), function(n) {
                return n.cF;
            }))
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: wq,
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: A2(No, function(n) {
            return n.cF;
        }, A2(No, function(n) {
            return n.bl;
        }, function(n) {
            return n.mm;
        })),
        rW: function(n) {
            return {
                $: 3,
                a: n
            };
        }
    }), Aq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sq = F2(function(n, r) {
        var t = A2(Le, T([
            Rg("InputSelect"),
            Oh(T([
                m("InputSelectEmpty", "" === n.ss)
            ]))
        ]), T([
            A2(Le, T([
                Rg("InputSelectChoice")
            ]), T([
                MT
            ])),
            A2(Dh, T([
                Rg("InputSelectValue")
            ]), "" === n.ss || Cu(r) ? n.gt : A2(OT, n.ss, r)),
            A2(DT, T([
                Rg("InputSelectSelect"),
                ek(Fh),
                ak(n.ss),
                uk(n.gt),
                Vh(n.kQ)
            ]), A2(Ge, function(r) {
                var t = r.a, e = r.b;
                return A2(qT, T([
                    ak(t),
                    xT(i(t, n.ss))
                ]), T([
                    ih(e)
                ]));
            }, r))
        ]));
        return A2(Le, T([
            Rg("InputWrapperDark"),
            Oh(T([
                m("InputHasError", Cu(n.ln))
            ]))
        ]), T([
            t,
            xh(n.ln)
        ]));
    }), Lq = F2(function(n, r) {
        return A2(Le, T([
            Rg("DarkZone"),
            Rg("Filter")
        ]), T([
            A2(Le, g, g),
            A2(Le, T([
                Rg("Summary")
            ]), T([
                A2(mN, g, T([
                    ih("Summary")
                ])),
                A2(Zj, g, T([
                    ih("")
                ])),
                A2(Zj, g, T([
                    ih("Total Probes: " + It(Dt(r)))
                ]))
            ]))
        ]));
    }), yq = F2(function(n, r) {
        return A3(hw, "Deep Probes", kt(function(n) {
            var r = A2(zi, A2(bu, Hi, Ko), A2(Ge, function(n) {
                return m(n.mm, n.n5);
            }, n.oP)), t = A2(dt, m("", ""), r);
            return A2(Le, T([
                A2(ph, "min-width", "100px")
            ]), T([
                A2(dk, Aq, A2(Sq, n.oQ, t))
            ]));
        }(r)), qe(r.oQ.ss) > 0 ? A2(Le, g, T([
            A2(Lq, r, r.kv),
            A3(cT, Nq, r.rJ, r.kv)
        ])) : A2(Le, T([
            Rg("EmptySection")
        ]), T([
            A2(Le, g, T([
                ih("Choose Organization")
            ]))
        ])));
    }), Fq = {
        l: function(n) {
            return n.dh;
        },
        m: KO,
        o: F2(function(n, r) {
            return p(n, {
                dh: r
            });
        }),
        p: function(n) {
            return {
                $: 18,
                a: n
            };
        },
        q: vq,
        r: yq
    }, jq = {
        kv: g,
        lm: Tt,
        qb: Ri(function(n) {
            return p(n, {
                m6: "fileToFind"
            });
        })
    }, Pq = A2(pc, g, jq), Iq = function(n) {
        return A2($g, n, "");
    }, Bq = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mq = function(n) {
        switch(n){
            case "ProxyManifest":
                return St(0);
            case "ProxyDashVideo":
                return St(1);
            case "ProxyAudio":
                return St(2);
            case "ProxySubtitle":
                return St(3);
            case "VerificationReportPdf":
                return St(4);
            case "VerificationReportXml":
                return St(5);
            case "Video":
                return St(6);
            case "Audio":
                return St(7);
            case "Subtitle":
                return St(8);
            default:
                return St(9);
        }
    }, Oq = function(n) {
        switch(n){
            case 0:
                return "ProxyManifest";
            case 1:
                return "ProxyDashVideo";
            case 2:
                return "ProxyAudio";
            case 3:
                return "ProxySubtitle";
            case 4:
                return "VerificationReportPdf";
            case 5:
                return "VerificationReportXml";
            case 6:
                return "Video";
            case 7:
                return "Audio";
            case 8:
                return "Subtitle";
            default:
                return "Extra";
        }
    }, qq = A2(Il, Oq, Mq), Dq = Po(A4(rc, "parent", function(n) {
        return n.gn;
    }, xi, A4(Do, "stateExpireAt", function(n) {
        return n.ht;
    }, td, A4(rc, "showState", function(n) {
        return n.g9;
    }, Mb, A4(rc, "showKind", function(n) {
        return n.qJ;
    }, Fd, A4(rc, "accepted", function(n) {
        return n.ih;
    }, no, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(Do, "title2", function(n) {
        return n.rU;
    }, xi, A4(rc, "title1", function(n) {
        return n.rT;
    }, xi, A4(rc, "showId", function(n) {
        return n.qI;
    }, xi, A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(rc, "kind", function(n) {
        return n.c$;
    }, qq, A4(rc, "key", function(n) {
        return n.m2;
    }, xi, A4(rc, "bucket", function(n) {
        return n.jt;
    }, xi, A4(Do, "mimeType", function(n) {
        return n.nS;
    }, xi, A4(rc, "size", function(n) {
        return n.qO;
    }, uc, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                ih: d,
                                                                                jt: a,
                                                                                kg: r,
                                                                                mm: n,
                                                                                m2: i,
                                                                                c$: o,
                                                                                nS: u,
                                                                                n5: t,
                                                                                oL: m,
                                                                                gn: $,
                                                                                qI: s,
                                                                                qJ: b,
                                                                                g9: p,
                                                                                qO: e,
                                                                                hs: c,
                                                                                ht: v,
                                                                                rT: f,
                                                                                rU: l
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), xq = oc(Dq), Rq = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Vq = function(n) {
        return dc(A2(Ho, xq, So(ml(Rq({
            $: 1,
            a: n
        })))));
    }, Eq = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(pc, g, p(r, {
                    lm: Tt,
                    qb: A2(gg, n.a, r.qb)
                }));
            case 2:
                return A2(pc, T([
                    (u = r.qb.ss, A2(Yi, Bq, Vq(u)))
                ]), r);
            default:
                var t = n.a;
                if (!t.$ && t.a.b) {
                    var e = t.a;
                    return A2(pc, g, p(r, {
                        kv: A2(dt, e.a, e.b),
                        lm: Tt,
                        qb: Iq(r.qb)
                    }));
                }
                return A2(pc, g, p(r, {
                    kv: g,
                    lm: kt("le fichier " + r.qb.ss + " n'a pas \xe9t\xe9 trouv\xe9"),
                    qb: Iq(r.qb)
                }));
        }
        var u;
    }), zq = dw(SF), Uq = F2(function(n, r) {
        return A2(Le, T([
            Rg("BannerError")
        ]), T([
            A2(Le, T([
                Rg("BannerHeader")
            ]), T([
                Th,
                zq(n)
            ])),
            A2(Le, T([
                Rg("BannerContent")
            ]), T([
                r
            ]))
        ]));
    }), Hq = function(n) {
        var r = n.lm;
        return 1 === r.$ ? A2(Le, T([
            A2(ph, "margin", "50px auto"),
            A2(ph, "text-align", "center")
        ]), T([
            ih("Search file by id")
        ])) : A2(Uq, "File not found", ih(r.a));
    }, Wq = function(n) {
        return f(n, 1073741824) > -1 ? It(re(n / 1073741824)) + " GB" : f(n, 1048576) > -1 ? It(re(n / 1048576)) + " MB" : 1024 > n ? n > 1 ? It(n) + " bytes" : 1 === n ? It(n) + " byte" : "0 bytes" : It(re(n / 1024)) + " KB";
    }, Qq = Le(T([
        Rg("LayoutHeader")
    ])), Zq = F2(function(n, r) {
        return A2(Fk, T([
            Rg("KeyValueWrapperHeader")
        ]), T([
            A2(uT, T([
                Rg("KeyValueHeader")
            ]), T([
                n
            ])),
            A2(uT, T([
                Rg("KeyValueValue")
            ]), T([
                r
            ]))
        ]));
    }), Kq = Zq, Yq = function(n) {
        return A2(Dh, T([
            Rg("LayoutHeaderTitle")
        ]), n);
    }, Xq = function(n) {
        var r, t, e;
        return T([
            Qq(T([
                Yq(n.n5),
                Yq(n.m2)
            ])),
            A2(Kq, ih("FILE"), A2(Le, g, g)),
            A2(wj, "Id", n.mm),
            A2(Tj, ih("Created At"), BN(n.kg)),
            A2(wj, "Size", Wq(n.qO)),
            A2(wj, "MimeType", (e = n.nS, 1 === e.$ ? "No mime type" : e.a)),
            A2(wj, "Bucket", n.jt),
            A2(wj, "Kind", Oq(n.c$)),
            A2(wj, "File Archived", Bb(n.hs)),
            A2(Kq, ih("SHOW"), A2(Le, g, g)),
            A2(Tj, ih("Id"), A2(aw, T([
                sw("/show/" + n.qI)
            ]), T([
                ih(n.qI)
            ]))),
            A2(wj, "title", n.rT),
            A2(wj, "title2", (t = n.rU, 1 === t.$ ? "No title" : t.a)),
            A2(wj, "Organization", n.oL),
            A2(wj, "Accepted", (r = n.ih, r ? "\u2714" : "\u2716")),
            A2(wj, "kind", yd(n.qJ)),
            A2(wj, "Archived", Bb(n.hs)),
            A2(Tj, ih("Parent"), A2(aw, T([
                sw("/hierarchy/" + n.gn)
            ]), T([
                ih(n.gn)
            ])))
        ]);
    }, Jq = F2(function(n, r) {
        if (n.b) {
            if (n.b.b) {
                var t = n.b;
                return $(Xq(n.a), A2(Jq, t, r));
            }
            return Xq(n.a);
        }
        return T([
            Hq(r)
        ]);
    }), Gq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _q = {
        $: 2
    }, nD = F2(function(n, r) {
        return A3(hw, "Researchs", kt(function(n) {
            return A2(Le, T([
                A2(ph, "display", "flex")
            ]), T([
                A2(zT, T([
                    WT(_q)
                ]), T([
                    A2(dk, Gq, ik(n.qb)),
                    A2(Nh, "search", _q)
                ]))
            ]));
        }(r)), A2(Le, g, A2(Jq, r.kv, r)));
    }), rD = {
        l: function(n) {
            return n.dl;
        },
        m: Pq,
        o: F2(function(n, r) {
            return p(n, {
                dl: r
            });
        }),
        p: function(n) {
            return {
                $: 9,
                a: n
            };
        },
        q: Eq,
        r: nD
    }, tD = F6(function(n, r, t, e, u, a) {
        var i, o = u, c = 1 === (i = o.l(r)).$ ? m(n, m(o.m.a, bc(T([
            o.m.b,
            a
        ])))) : m(r, m(i.a, a)), s = c.b, f = s.b;
        return m(A2(o.o, c.a, kt(s.a)), A2(cp, o.p, f));
    }), eD = F5(function(n, r, t, e, u) {
        return A6(tD, n, r, t, e, u, n$);
    }), uD = {
        kN: Tt,
        lm: Tt,
        $7: g,
        rv: Tt,
        rJ: a$("Name")
    }, aD = function(n) {
        return {
            $: 0,
            a: n
        };
    }, iD = dc(A2(Ho, _B, So(rM))), oD = A2(Yi, aD, iD), cD = m(uD, oD), sD = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), fD = function(n) {
        return {
            $: 27,
            a: n
        };
    }, lD = F2(function(n, r) {
        return r.$ ? wt(n) : St(r.a);
    }), mD = function(n) {
        var r, t = YB(n.r7.ss), e = {
            eL: n.qQ.ss,
            fU: n.qR.ss,
            fV: n.qS.ss
        }, u = {
            al: Ve(n.oF.ss) ? Tt : ze(n.oF.ss),
            b2: Ve(n.oG.ss) ? Tt : ze(n.oG.ss),
            rS: Ve(n.oH.ss) ? Tt : kt(n.oH.ss)
        }, a = Ve(n.nX.ss) ? Tt : ze(n.nX.ss), i = Ve(n.nV.ss) ? Tt : ze(n.nV.ss), o = {
            al: Ve(n.li.ss) ? Tt : ze(n.li.ss),
            b2: Ve(n.lj.ss) ? Tt : ze(n.lj.ss),
            rS: Ve(n.lk.ss) ? Tt : kt(n.lk.ss)
        }, c = {
            lH: Ve(n.lH.ss) ? Tt : ze(n.lH.ss),
            nb: Ve(n.nb.ss) ? Tt : ze(n.nb.ss),
            nL: Ve(n.nL.ss) ? Tt : ze(n.nL.ss),
            nU: Ve(n.nU.ss) ? Tt : ze(n.nU.ss),
            px: (r = n.px, A2(Ii, g, A3(Je, F2(function(n, r) {
                var t = m(n, r);
                return t.b.$ ? wt(t.b.a) : t.a.$ ? wt(t.a.a) : St(A2(dt, t.a.a, t.b.a));
            }), St(g), A2(Ge, function(n) {
                var r = n.b;
                return A4(J$, zB, A2(lD, "Invalid ad value", ze(r.iq.ss)), A2(lD, "Invalid min value", ze(r.nT.ss)), A2(lD, "Invalid max value", ze(r.nK.ss)));
            }, pt(r)))))
        };
        return A2(X$, function(r) {
            return {
                az: c,
                bO: o,
                nV: i,
                nX: a,
                n5: n.n5.ss,
                b3: u,
                o8: n.o8.ss,
                qP: n.qP.ss,
                ce: e,
                r7: r
            };
        }, t);
    }, dD = Po(A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return {
            mm: n
        };
    }))), bD = Po(A4(rc, "skipJobs", function(n) {
        return n.ce;
    }, KB, A4(rc, "typology", function(n) {
        return n.r7;
    }, JB, A4(rc, "postCredits", function(n) {
        return n.o8;
    }, no, A4(Do, "minOutro", function(n) {
        return n.nX;
    }, uc, A4(Do, "minIntro", function(n) {
        return n.nV;
    }, uc, A4(rc, "skipIntro", function(n) {
        return n.qP;
    }, no, A4(rc, "endingCredits", function(n) {
        return n.bO;
    }, QB, A4(rc, "openingCredits", function(n) {
        return n.b3;
    }, QB, A4(rc, "adBreaks", function(n) {
        return n.az;
    }, HB, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return {
                                                az: r,
                                                bO: e,
                                                nV: a,
                                                nX: i,
                                                n5: n,
                                                b3: t,
                                                o8: o,
                                                qP: u,
                                                ce: s,
                                                r7: c
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), pD = function(n) {
        return A2(Yi, fD, A2(OC, function(n) {
            return dc(A2(ng, dD, A3(ag, bD, n, rg(rM))));
        }, A2(Qo, IL, ML(mD(n)))));
    }, vD = function(n) {
        return {
            $: 30,
            a: n
        };
    }, $D = function(n) {
        return Lo(nM({
            $: 1,
            a: n
        }));
    }, gD = function(n) {
        return {
            $: 28,
            a: n
        };
    }, hD = F2(function(n, r) {
        return A2(OC, function(r) {
            return dc(fg(A3(ag, bD, r, mg($D(n.mm)))));
        }, A2(Qo, IL, ML(mD(r))));
    }), kD = F2(function(n, r) {
        return A2(Yi, gD, A2(hD, n, r));
    }), TD = function(n) {
        var r = function(n) {
            return A2(No, Fu(n), ju(""));
        };
        return {
            li: Ri(function(r) {
                return p(r, {
                    m6: "Minimum credits duration to detect (in seconds)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.al;
                    }, A2(Fu, function(n) {
                        return n.bO;
                    }, n))))
                });
            }),
            lj: Ri(function(r) {
                return p(r, {
                    m6: "Credits Duration (in seconds)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.b2;
                    }, A2(Fu, function(n) {
                        return n.bO;
                    }, n))))
                });
            }),
            lk: Ri(function(r) {
                return p(r, {
                    m6: "Text to detect in the first shot of the end credits (enter one line of text maximum)",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.rS;
                    }, A2(Fu, function(n) {
                        return n.bO;
                    }, n)))
                });
            }),
            lH: Ri(function(r) {
                return p(r, {
                    m6: "Minimum distance between the start of the program and the first ad break (in minutes)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.lH;
                    }, A2(Fu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nb: Ri(function(r) {
                return p(r, {
                    m6: "Minimum distance between the last ad break and the end of the program (in minutes)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.nb;
                    }, A2(Fu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nL: Ri(function(r) {
                return p(r, {
                    m6: "Maximum interval between two ad breaks (in minutes)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.nL;
                    }, A2(Fu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nU: Ri(function(r) {
                return p(r, {
                    m6: "Minimum interval between two ad breaks (in minutes)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.nU;
                    }, A2(Fu, function(n) {
                        return n.az;
                    }, n))))
                });
            }),
            nV: Ri(function(r) {
                return p(r, {
                    m6: "Minimum intro duration (in seconds)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.nV;
                    }, n)))
                });
            }),
            nX: Ri(function(r) {
                return p(r, {
                    m6: "Minimum outro duration (in seconds)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.nX;
                    }, n)))
                });
            }),
            n5: Ri(function(t) {
                return p(t, {
                    m6: "Name",
                    ss: A2(r, function(n) {
                        return n.n5;
                    }, n)
                });
            }),
            oF: Ri(function(r) {
                return p(r, {
                    m6: "Minimum credits duration to detect (in seconds)",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.al;
                    }, A2(Fu, function(n) {
                        return n.b3;
                    }, n))))
                });
            }),
            oG: Ri(function(r) {
                return p(r, {
                    m6: "Credits duration (in seconds). Enter a negative value if the series title appears at the end of the credits.",
                    ss: A2(ju, "", A2(Fu, It, A2(fp, function(n) {
                        return n.b2;
                    }, A2(Fu, function(n) {
                        return n.b3;
                    }, n))))
                });
            }),
            oH: Ri(function(r) {
                return p(r, {
                    m6: "Series Title (enter one line of text maximum)",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.rS;
                    }, A2(Fu, function(n) {
                        return n.b3;
                    }, n)))
                });
            }),
            oR: n,
            o8: ro(function(r) {
                return p(r, {
                    m6: "Enable outro detection",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.o8;
                    }, n))
                });
            }),
            px: A2(_o, F2(function(n, r) {
                return {
                    iq: Ri(function(n) {
                        return p(n, {
                            m6: "Number of ad breaks",
                            ss: It(r.dH)
                        });
                    }),
                    nK: Ri(function(n) {
                        return p(n, {
                            m6: "To program duration (in minutes)",
                            ss: It(r.cK)
                        });
                    }),
                    nT: Ri(function(n) {
                        return p(n, {
                            m6: "From program duration (in minutes)",
                            ss: It(r.al)
                        });
                    })
                };
            }), Jo(A2(zt, x$, A2(ju, g, A2(Fu, A2(No, function(n) {
                return n.az;
            }, function(n) {
                return n.px;
            }), n))))),
            qP: ro(function(r) {
                return p(r, {
                    m6: "Enable intro detection",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.qP;
                    }, n))
                });
            }),
            qQ: ro(function(r) {
                return p(r, {
                    m6: "Skip Deep probe job",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.eL;
                    }, A2(Fu, function(n) {
                        return n.ce;
                    }, n)))
                });
            }),
            qR: ro(function(r) {
                return p(r, {
                    m6: "Skip M2C analysis job",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.fU;
                    }, A2(Fu, function(n) {
                        return n.ce;
                    }, n)))
                });
            }),
            qS: ro(function(r) {
                return p(r, {
                    m6: "Skip M2C proxy creation",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.fV;
                    }, A2(Fu, function(n) {
                        return n.ce;
                    }, n)))
                });
            }),
            r7: Ri(function(t) {
                return p(t, {
                    m6: "Typology",
                    ss: A2(r, A2(No, function(n) {
                        return n.r7;
                    }, XB), n)
                });
            })
        };
    }, wD = F2(function(n, r) {
        switch(n.$){
            case 0:
                return p(r, {
                    iq: A2(gg, n.a, r.iq)
                });
            case 1:
                return p(r, {
                    nT: A2(gg, n.a, r.nT)
                });
            default:
                return p(r, {
                    nK: A2(gg, n.a, r.nK)
                });
        }
    }), CD = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, (s = n.a).$ ? A2(sD, s.a, r) : p(r, {
                    $7: s.a
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(TD(Tt))
                }));
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(TD(kt(n.a)))
                }));
            case 3:
                var t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, t, n.n5)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: e
                }));
            case 4:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lH: A2(gg, t, n.lH)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 5:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nb: A2(gg, t, n.nb)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 6:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nU: A2(gg, t, n.nU)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 7:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nL: A2(gg, t, n.nL)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 11:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oH: A2(gg, t, n.oH)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 12:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oG: A2(gg, t, n.oG)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 13:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oF: A2(gg, t, n.oF)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 14:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lk: A2(gg, t, n.lk)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 15:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lj: A2(gg, t, n.lj)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 16:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        li: A2(gg, t, n.li)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 17:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        qP: A2(vg, t, n.qP)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 18:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nV: A2(gg, t, n.nV)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 19:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        nX: A2(gg, t, n.nX)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 20:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        o8: A2(vg, t, n.o8)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 21:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        r7: A2(gg, t, n.r7)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 10:
                var u = n.a;
                return e = A2(Fu, function(n) {
                    return p(n, {
                        px: A2(U$, F2(function(n) {
                            return !i(n, u);
                        }), n.px)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 8:
                t = n.a, u = n.b;
                n: for(; !t.a.$;)return e = A2(Fu, function(n) {
                    return p(n, {
                        px: A2(_o, F2(function(n, r) {
                            return i(n, u) ? A2(wD, t, r) : r;
                        }), n.px)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
                return A2(pc, g, r);
            case 9:
                var a = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.px)));
                }, r.kN)), o = (m = {
                    cK: 0,
                    al: 0,
                    dH: a + 1
                }, d = Ri(function(n) {
                    return p(n, {
                        m6: "From program duration (in minutes)",
                        ss: It(m.al)
                    });
                }), b = Ri(function(n) {
                    return p(n, {
                        m6: "To program duration (in minutes)",
                        ss: It(m.cK)
                    });
                }), {
                    iq: Ri(function(n) {
                        return p(n, {
                            m6: "Number of ad breaks",
                            ss: It(m.dH)
                        });
                    }),
                    nK: b,
                    nT: d
                });
                return e = A2(Fu, function(n) {
                    return p(n, {
                        px: A3(wu, a + 1, o, n.px)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 22:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        qS: A2(vg, t, n.qS)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 23:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        qR: A2(vg, t, n.qR)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 24:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        qQ: A2(vg, t, n.qQ)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 25:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 26:
                var c = r.kN;
                return A2(pc, T(1 === c.$ ? [
                    n$
                ] : 1 === (l = (e = c.a).oR).$ ? [
                    pD(e)
                ] : [
                    A2(kD, l.a, e)
                ]), r);
            case 27:
                return (s = n.a).$ ? A2(pc, g, A2(sD, s.a, r)) : A2(pc, T([
                    oD
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Segmentation rule created")
                }));
            case 28:
                return (s = n.a).$ ? A2(pc, g, A2(sD, s.a, r)) : A2(pc, T([
                    oD
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Segmentation rule updated")
                }));
            case 29:
                return A2(pc, T([
                    (f = n.a, A2(Yi, vD, function(n) {
                        return dc(fg(sg($D(n.mm))));
                    }(f)))
                ]), r);
            case 30:
                var s;
                return (s = n.a).$ ? A2(pc, g, A2(sD, s.a, r)) : A2(pc, T([
                    oD
                ]), r);
            default:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
        }
        var f, l, m, d, b;
    }), ND = {
        $: 1
    }, AD = function(n) {
        return {
            $: 2,
            a: n
        };
    }, SD = function(n) {
        return {
            $: 29,
            a: n
        };
    }, LD = F2(function(n, r) {
        if (r.b) {
            var t = r.a, e = r.b, u = F2(function(r, t) {
                return A2(dt, n, A2(dt, r, t));
            });
            return A2(dt, t, A3(Je, u, g, e));
        }
        return g;
    }), yD = function(n) {
        return A2(mh, g, A2(LD, A2(wF, g, g), A2(Ge, ih, A2(Mt, "\n", function(n) {
            var r, t, e, u, a = (r = n.nU).$ ? "N/A" : It(r.a), i = (t = n.nL).$ ? "N/A" : It(t.a), o = (e = n.nb).$ ? "N/A" : It(e.a);
            return "first point: " + ((u = n.lH).$ ? "N/A" : It(u.a)) + "\nlast point: " + o + "\nmininum interval: " + a + "\nmaximum interval: " + i + "\nranges:" + (Cu(n.px) ? "N/A" : A2(Bt, "", A2(Ge, function(n) {
                return "\n- total breaks: " + It(n.dH) + ", duration min: " + It(n.al) + ", duration max: " + It(n.cK);
            }, n.px)));
        }(n)))));
    }, FD = function(n) {
        return A2(mh, g, A2(LD, A2(wF, g, g), A2(Ge, ih, A2(Mt, "\n", function(n) {
            return "title: " + A2(ju, "N/A", n.rS) + "\noffset: " + A2(ju, "N/A", A2(Fu, It, n.b2)) + "\nminimum credits duration: " + A2(ju, "N/A", A2(Fu, It, n.al));
        }(n)))));
    }, jD = F2(function(n, r) {
        return _g({
            n5: n,
            ds: Eg(function(n) {
                return r(n) ? "1" : "0";
            }),
            dM: function(n) {
                return A2(Vg, g, T([
                    r(n) ? Gg : Jg
                ]));
            }
        });
    }), PD = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), ID = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: PD(r)
        });
    }), BD = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), MD = function(n) {
        return A2(Le, g, T([
            A2(Le, g, T([
                ih("M2C proxy: "),
                n.fV ? Gg : Jg
            ])),
            A2(Le, g, T([
                ih("M2C analysis: "),
                n.fU ? Gg : Jg
            ])),
            A2(Le, g, T([
                ih("Deep probe analysis: "),
                n.eL ? Gg : Jg
            ]))
        ]));
    }, OD = uh({
        jY: T([
            A2(ID, "Edit", A2(bu, Nh("Edit"), AD)),
            A2(BD, "Name", function(n) {
                return n.n5;
            }),
            A2(BD, "Typology", A2(bu, XB, function(n) {
                return n.r7;
            })),
            A2(ID, "Opening Credits", A2(bu, FD, function(n) {
                return n.b3;
            })),
            A2(ID, "End Credits", A2(bu, FD, function(n) {
                return n.bO;
            })),
            A2(ID, "Ad breaks", A2(bu, yD, function(n) {
                return n.az;
            })),
            A2(jD, "Intro Detection", function(n) {
                return n.qP;
            }),
            A2(BD, "Minimum Intro Duration", A2(bu, A2(bu, ju("N/A"), Fu(It)), function(n) {
                return n.nV;
            })),
            A2(jD, "Outro Detection", function(n) {
                return n.o8;
            }),
            A2(BD, "Minimum Outro Duration", A2(bu, A2(bu, ju("N/A"), Fu(It)), function(n) {
                return n.nX;
            })),
            A2(ID, "Skip Jobs", A2(bu, MD, function(n) {
                return n.ce;
            })),
            A2(ID, "Delete", A2(bu, Og(Th), SD))
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: T([
                Rg("Table")
            ]),
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: function(n) {
            return n.mm;
        },
        rW: function(n) {
            return {
                $: 31,
                a: n
            };
        }
    }), qD = function(n) {
        return {
            $: 20,
            a: n
        };
    }, DD = function(n) {
        return {
            $: 17,
            a: n
        };
    }, xD = function(n) {
        return {
            $: 24,
            a: n
        };
    }, RD = function(n) {
        return {
            $: 23,
            a: n
        };
    }, VD = function(n) {
        return {
            $: 22,
            a: n
        };
    }, ED = {
        $: 25
    }, zD = function(n) {
        return {
            $: 16,
            a: n
        };
    }, UD = function(n) {
        return {
            $: 15,
            a: n
        };
    }, HD = function(n) {
        return {
            $: 14,
            a: n
        };
    }, WD = function(n) {
        return {
            $: 4,
            a: n
        };
    }, QD = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ZD = function(n) {
        return {
            $: 7,
            a: n
        };
    }, KD = function(n) {
        return {
            $: 6,
            a: n
        };
    }, YD = function(n) {
        return {
            $: 18,
            a: n
        };
    }, XD = function(n) {
        return {
            $: 19,
            a: n
        };
    }, JD = function(n) {
        return {
            $: 3,
            a: n
        };
    }, GD = function(n) {
        return {
            $: 13,
            a: n
        };
    }, _D = function(n) {
        return {
            $: 12,
            a: n
        };
    }, nx = function(n) {
        return {
            $: 11,
            a: n
        };
    }, rx = function(n) {
        return {
            $: 21,
            a: n
        };
    }, tx = {
        $: 9
    }, ex = {
        $: 26
    }, ux = function(n) {
        return -2 === n.$;
    }, ax = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), ix = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ox = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cx = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sx = function(n) {
        return A2(Ge, Ko, pt(A2(_o, F2(function(n, r) {
            var t, e;
            return A2(Le, T([
                A2(ph, "position", "relative"),
                A2(ph, "margin", "0 0 25px 0")
            ]), T([
                A2(dk, function(r) {
                    return A2(ax, r, n);
                }, (e = r, A2(Le, g, T([
                    A2(dk, ix, IT(e.iq)),
                    A2(dk, cx, IT(e.nT)),
                    A2(dk, ox, IT(e.nK))
                ])))),
                A3(JT, "remove", T([
                    m("position", "absolute"),
                    m("right", "0")
                ]), (t = n, {
                    $: 10,
                    a: t
                }))
            ]));
        }), n.px)));
    }, fx = function(n) {
        return A2(wT, function(n) {
            var r = A2(Ge, function(n) {
                return m(n, n);
            }, A2(Ge, XB, T([
                0,
                1,
                2
            ]))), t = function(n) {
                return 1 !== n.oR.$;
            }(n) ? m("Save", "Edit Rule") : m("Create", "New Rule");
            return A4(ZT, t.b, m(t.a, ex), m("Cancel", ED), T([
                A2(dk, JD, IT(n.n5)),
                A2(dk, rx, A2(ET, n.r7, r)),
                A2(wF, g, g),
                A2(Le, g, $(T([
                    A2(mw, g, T([
                        ih("Ad breaks")
                    ])),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("Ranges")
                    ])),
                    A2(Zj, g, T([
                        ih("Define the number of ad breaks required for a program duration.")
                    ])),
                    A2(Zj, g, T([
                        ih("Example:")
                    ])),
                    A2(Zj, g, T([
                        ih("- Number of ad breaks: 1, from program duration 0 to 45 (exclusive) min")
                    ])),
                    A2(Zj, g, T([
                        ih("- Number of ad breaks: 2, from program duration 45 (inclusive) to 60 min")
                    ])),
                    A2(Zj, g, T([
                        ih("If a program is less than 45 minutes long, it requires 1 ad break.")
                    ])),
                    A2(Zj, g, T([
                        ih("If a program is between 45 and 60 minutes long, it requires 2 ad breaks.")
                    ])),
                    A2(wF, g, g)
                ]), $(sx(n), A2(dt, A2(Nh, "New range", tx), ux(n.px) ? g : T([
                    A2(wF, g, g),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("Limits")
                    ])),
                    A2(dk, WD, IT(n.lH)),
                    A2(dk, QD, IT(n.nb)),
                    A2(wF, g, g),
                    A2(SF, g, T([
                        ih("Interval")
                    ])),
                    A2(dk, KD, IT(n.nU)),
                    A2(dk, ZD, IT(n.nL))
                ]))))),
                A2(wF, g, g),
                A2(mw, g, T([
                    ih("Opening credits")
                ])),
                A2(dk, GD, IT(n.oF)),
                A2(dk, nx, IT(n.oH)),
                A2(dk, _D, IT(n.oG)),
                A2(wF, g, g),
                A2(mw, g, T([
                    ih("End credits")
                ])),
                A2(dk, zD, IT(n.li)),
                A2(dk, HD, IT(n.lk)),
                A2(dk, UD, IT(n.lj)),
                A2(wF, g, g),
                A2(mw, g, T([
                    ih("Other detections")
                ])),
                A2(dk, DD, PT(n.qP)),
                A2(dk, YD, IT(n.nV)),
                A2(dk, qD, PT(n.o8)),
                A2(dk, XD, IT(n.nX)),
                A2(wF, g, g),
                A2(mw, g, T([
                    ih("Skip Jobs")
                ])),
                A2(dk, VD, PT(n.qS)),
                A2(dk, RD, PT(n.qR)),
                A2(dk, xD, PT(n.qQ))
            ]));
        }, n.kN);
    }, lx = F2(function(n, r) {
        return A3(hw, "Segmentation Rules", kt(A2(Nh, "New\u2026", ND)), A2(Le, g, T([
            fx(r),
            A3(cT, OD, r.rJ, r.$7)
        ])));
    }), mx = {
        l: function(n) {
            return n.$7;
        },
        m: cD,
        o: F2(function(n, r) {
            return p(n, {
                $7: r
            });
        }),
        p: function(n) {
            return {
                $: 14,
                a: n
            };
        },
        q: CD,
        r: lx
    }, dx = {
        kN: Tt,
        lm: Tt,
        lV: g,
        dw: g,
        rv: Tt,
        rJ: a$("Name")
    }, bx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, px = ml(JS({
        $: 2
    })), vx = dc(A2(Ho, RS, So(px))), $x = A2(Yi, bx, _b(m(_S, vx))), gx = m(dx, $x), hx = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), kx = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Tx = function(n) {
        return n.$ ? Tt : kt(n.a);
    }, wx = function(n) {
        var r = "" === n.rq.ss ? Tt : kt(n.rq.ss), t = "" === n.rn.ss ? Tt : kt(n.rn.ss), e = "" === n.b2.ss ? Tt : kt(n.b2.ss), u = QS(n.lC.ss);
        return A2(X$, function(u) {
            var a;
            return {
                kT: (a = u, a ? Tt : Tx(US(n.kT.ss))),
                lC: u,
                n5: n.n5.ss,
                b2: e,
                rn: t,
                rq: r
            };
        }, u);
    }, Cx = F6(function(n, r, t, e, u, a) {
        return {
            kT: u,
            lC: r,
            n5: n,
            b2: a,
            rn: e,
            rq: t
        };
    }), Nx = Po(A4(Do, "offset", function(n) {
        return n.b2;
    }, xi, A4(Do, "displayStandard", function(n) {
        return n.kT;
    }, WS, A4(Do, "frameRate", function(n) {
        return n.rn;
    }, xi, A4(Do, "startTimecode", function(n) {
        return n.rq;
    }, xi, A4(rc, "format", function(n) {
        return n.lC;
    }, KS, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(Cx)))))))), Ax = function(n) {
        return A2(Yi, kx, A2(OC, function(n) {
            return dc(A2(ng, YS, A3(ag, Nx, n, rg(GS))));
        }, A2(Qo, IL, ML(wx(n)))));
    }, Sx = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Lx = function(n) {
        return ml(JS({
            $: 1,
            a: n
        }));
    }, yx = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Fx = F2(function(n, r) {
        return A2(OC, function(r) {
            return dc(A2(Ho, YS, A3(ag, Nx, r, mg(Lx(n.mm)))));
        }, A2(Qo, IL, ML(wx(r))));
    }), jx = F2(function(n, r) {
        return A2(Yi, yx, A2(Fx, n, r));
    }), Px = function(n) {
        var r = function(n) {
            return A2(No, Fu(n), ju(""));
        };
        return {
            kT: Ri(function(r) {
                return p(r, {
                    m6: "Display Standard",
                    ss: A2(ju, "teletext_level_1", A2(Fu, HS, A2(fp, function(n) {
                        return n.kT;
                    }, n)))
                });
            }),
            lC: Ri(function(t) {
                return p(t, {
                    m6: "File Format",
                    ss: A2(r, A2(No, function(n) {
                        return n.lC;
                    }, ZS), n)
                });
            }),
            n5: Ri(function(t) {
                return p(t, {
                    m6: "Name",
                    ss: A2(r, function(n) {
                        return n.n5;
                    }, n)
                });
            }),
            b2: Ri(function(r) {
                return p(r, {
                    m6: "Offset Timecode",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.b2;
                    }, n))
                });
            }),
            oR: n,
            rn: Ri(function(r) {
                return p(r, {
                    m6: "Frame Rate",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return A2(Fu, function(n) {
                            return n.mm;
                        }, n.rn);
                    }, n))
                });
            }),
            rq: Ri(function(r) {
                return p(r, {
                    m6: "Start Timecode",
                    ss: A2(ju, "", A2(fp, function(n) {
                        return n.rq;
                    }, n))
                });
            })
        };
    }, Ix = F2(function(n, r) {
        switch(n.$){
            case 0:
                if ((i = n.a).$) return A2(pc, g, A2(hx, i.a, r));
                var t = i.a;
                return A2(pc, g, p(r, {
                    lV: t.b,
                    dw: t.a
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(Px(Tt))
                }));
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(Px(kt(n.a)))
                }));
            case 3:
                var e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, e, n.n5)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: u
                }));
            case 4:
                return e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        lC: A2(gg, e, n.lC)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 5:
                return e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        rq: A2(gg, e, n.rq)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 6:
                return e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        rn: A2(gg, e, n.rn)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 7:
                return e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        kT: A2(gg, e, n.kT)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 8:
                return e = n.a, u = A2(Fu, function(n) {
                    return p(n, {
                        b2: A2(gg, e, n.b2)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: u
                }));
            case 9:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 10:
                var a = r.kN;
                return A2(pc, T(1 === a.$ ? [
                    n$
                ] : 1 === (c = (u = a.a).oR).$ ? [
                    Ax(u)
                ] : [
                    A2(jx, c.a, u)
                ]), r);
            case 11:
                return (i = n.a).$ ? A2(pc, g, A2(hx, i.a, r)) : A2(pc, T([
                    $x
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Subtitle format created")
                }));
            case 12:
                return (i = n.a).$ ? A2(pc, g, A2(hx, i.a, r)) : A2(pc, T([
                    $x
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("Subtitle format updated")
                }));
            case 13:
                return A2(pc, T([
                    (o = n.a, A2(Yi, Sx, function(n) {
                        return A2(Gb, Ml(n), dc(fg(sg(Lx(n.mm)))));
                    }(o)))
                ]), r);
            case 14:
                var i;
                return (i = n.a).$ ? A2(pc, g, A2(hx, i.a, r)) : A2(pc, T([
                    $x
                ]), r);
            default:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
        }
        var o, c;
    }), Bx = {
        $: 1
    }, Mx = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ox = function(n) {
        return {
            $: 13,
            a: n
        };
    }, qx = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), Dx = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: qx(r)
        });
    }), xx = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), Rx = uh({
        jY: T([
            A2(Dx, "Edit", A2(bu, Nh("Edit"), Mx)),
            A2(xx, "Name", function(n) {
                return n.n5;
            }),
            A2(xx, "File Format", A2(bu, ZS, function(n) {
                return n.lC;
            })),
            A2(xx, "Start Timecode", A2(bu, ju("N/A"), function(n) {
                return n.rq;
            })),
            A2(xx, "Frame Rate", A2(bu, A2(bu, ju("N/A"), Fu(sy)), function(n) {
                return n.rn;
            })),
            A2(xx, "Display Standard", A2(bu, A2(bu, ju("N/A"), Fu(HS)), function(n) {
                return n.kT;
            })),
            A2(xx, "Offset Timecode", A2(bu, ju("N/A"), function(n) {
                return n.b2;
            })),
            A2(Dx, "Delete", A2(bu, Og(Th), Ox))
        ]),
        kt: p(kh, {
            pR: function() {
                return T([
                    Rg("TableTr")
                ]);
            },
            rA: T([
                Rg("Table")
            ]),
            rM: T([
                Rg("TableTd")
            ])
        }),
        rV: function(n) {
            return n.mm;
        },
        rW: function(n) {
            return {
                $: 15,
                a: n
            };
        }
    }), Vx = {
        $: 9
    }, Ex = function(n) {
        return {
            $: 7,
            a: n
        };
    }, zx = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ux = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hx = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Wx = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Qx = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Zx = {
        $: 10
    }, Kx = function(n) {
        return A2(wT, function(r) {
            var t = A2(Ge, function(n) {
                return m(n.mm, sy(n));
            }, n.lV), e = A2(Ge, function(n) {
                return m(n, n);
            }, A2(Ge, ZS, T([
                0,
                1,
                2,
                3
            ]))), u = A2(Ge, function(n) {
                return m(n, n);
            }, A2(Ge, HS, T([
                0,
                1,
                2
            ]))), a = function(n) {
                return 1 !== n.oR.$;
            }(r) ? m("Save", "Edit Format") : m("Create", "New Format");
            return A4(ZT, a.b, m(a.a, Zx), m("Cancel", Vx), T([
                A2(dk, Ux, IT(r.n5)),
                A2(dk, zx, A2(ET, r.lC, e)),
                A2(dk, Qx, IT(r.rq)),
                A2(dk, Wx, A2(ET, r.rn, t)),
                A2(FF, i(r.lC.ss, ZS(0)), A2(dk, Ex, A2(ET, r.kT, u))),
                A2(dk, Hx, IT(r.b2))
            ]));
        }, n.kN);
    }, Yx = F2(function(n, r) {
        return A3(hw, "Subtitle Formats", kt(A2(Nh, "New\u2026", Bx)), A2(Le, g, T([
            Kx(r),
            A3(cT, Rx, r.rJ, r.dw)
        ])));
    }), Xx = {
        l: function(n) {
            return n.dw;
        },
        m: gx,
        o: F2(function(n, r) {
            return p(n, {
                dw: r
            });
        }),
        p: function(n) {
            return {
                $: 13,
                a: n
            };
        },
        q: Ix,
        r: Yx
    }, Jx = {
        iE: St(m(g, g)),
        lm: Tt,
        rv: Tt
    }, Gx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _x = dc(A2(Ho, tL, So(uL))), nR = ml(eL({
        $: 2
    })), rR = dc(A2(Ho, oc(xi), So(nR))), tR = A2(Yi, Gx, _b(m(_x, rR))), eR = A2(pc, T([
        tR
    ]), Jx), uR = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), aR = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iR = function(n) {
        return A2(Yi, aR, function(n) {
            return A2(Gb, function() {
                return n;
            }, dc(fg(sg(ml(eL({
                $: 1,
                a: n.mm
            }))))));
        }(n));
    }, oR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cR = Po(A4(rc, "tpKey", function(n) {
        return n.r$;
    }, xi, Io(function(n) {
        return {
            r$: n
        };
    }))), sR = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(pc, T([
                    (u = n.a, A2(Yi, oR, dc(A2(ng, rL, A3(ag, cR, {
                        r$: u
                    }, rg(uL))))))
                ]), r);
            case 2:
                return (t = n.a).$ ? A2(pc, g, A2(uR, e = t.a, r)) : A2(pc, T([
                    tR
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Test plan imported")
                }));
            case 0:
                return A2(pc, g, (t = n.a).$ ? p(A2(uR, e = t.a, r), {
                    iE: wt(e)
                }) : p(r, {
                    iE: St(t.a)
                }));
            case 3:
                return A2(pc, T([
                    iR(n.a)
                ]), r);
            default:
                var t, e;
                return (t = n.a).$ ? A2(pc, g, A2(uR, e = t.a, r)) : A2(pc, T([
                    tR
                ]), p(r, {
                    lm: Tt,
                    rv: kt("Test plan deleted")
                }));
        }
        var u;
    }), fR = Se("b"), lR = dw(fR), mR = T([
        ih("Name"),
        ih("Import")
    ]), dR = T([
        ih("Name"),
        ih("Delete")
    ]), bR = F2(function(n, r) {
        var t = function() {
            var n = r.iE;
            if (n.$) {
                var t = n.a;
                return m(A2(Dh, T([
                    Rg("failed")
                ]), t.nO), A2(Dh, T([
                    Rg("failed")
                ]), t.nO));
            }
            var e, u = n.a, a = u.b;
            return m(A2(Gw, dR, (e = u.a, A2(Ge, function(n) {
                var r;
                return T([
                    lR(n.n5),
                    A2(Og, Th, (r = n, {
                        $: 3,
                        a: r
                    }))
                ]);
            }, A2(zi, A2(bu, Hi, function(n) {
                return n.n5;
            }), e)))), A2(Gw, mR, A2(Ge, function(n) {
                var r;
                return T([
                    lR(n),
                    A2(Nh, "import", (r = n, {
                        $: 1,
                        a: r
                    }))
                ]);
            }, A2(zi, Hi, a))));
        }(), e = t.a, u = t.b;
        return A3(hw, "Verification parameters", Tt, A2(Le, g, T([
            A2(yF, g, g),
            bw("Imported test plans"),
            e,
            bw("Available in S3"),
            u
        ])));
    }), pR = {
        l: function(n) {
            return n.dA;
        },
        m: eR,
        o: F2(function(n, r) {
            return p(n, {
                dA: r
            });
        }),
        p: function(n) {
            return {
                $: 6,
                a: n
            };
        },
        q: sR,
        r: bR
    }, vR = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $R = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gR = F2(function(n, r) {
        return {
            oY: r,
            dJ: n
        };
    }), hR = F6(function(n, r, t, e, u, a) {
        return {
            fS: u,
            o1: n,
            pj: r,
            gG: e,
            q5: t,
            dO: a
        };
    }), kR = A2(Ce, function(n) {
        var r = function(n) {
            switch(n){
                case "Waiting":
                    return St(0);
                case "Downloading":
                    return St(1);
                case "Encoding":
                    return St(2);
                case "Packaging":
                    return St(3);
                case "Uploading":
                    return St(4);
                case "Finished":
                    return St(5);
                default:
                    return wt("can't get phase from string " + n);
            }
        }(n);
        return r.$ ? Dc(r.a) : je(r.a);
    }, Bi), TR = function(n) {
        return gi(function(n) {
            switch(n){
                case 0:
                    return "Waiting";
                case 1:
                    return "Downloading";
                case 2:
                    return "Encoding";
                case 3:
                    return "Packaging";
                case 4:
                    return "Uploading";
                default:
                    return "Finished";
            }
        }(n));
    }, wR = A2(Di, TR, kR), CR = F3(function(n, r, t) {
        return {
            eB: r,
            e7: t,
            n5: n
        };
    }), NR = Po(A4(rc, "firstFrameApprox", function(n) {
        return n.e7;
    }, uc, A4(rc, "count", function(n) {
        return n.eB;
    }, uc, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(CR))))), AR = Po(A4(rc, "warning", function(n) {
        return n.dO;
    }, oc(NR), A4(Do, "log", function(n) {
        return n.fS;
    }, xi, A4(rc, "progressedAt", function(n) {
        return n.gG;
    }, td, A4(rc, "startedAt", function(n) {
        return n.q5;
    }, td, A4(Do, "progress", function(n) {
        return n.pj;
    }, mS, A4(rc, "phase", function(n) {
        return n.o1;
    }, wR, Io(hR)))))))), SR = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            j0: e,
            lm: u,
            df: t,
            pj: n,
            gG: r,
            pY: a,
            aV: o,
            dt: c,
            qZ: i
        };
    }), LR = Po(A4(Do, "source", function(n) {
        return n.dt;
    }, xi, A4(Do, "secondsLeft", function(n) {
        return n.aV;
    }, uc, A4(rc, "speed", function(n) {
        return n.qZ;
    }, mS, A4(Do, "s3Id", function(n) {
        return n.pY;
    }, xi, A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(Do, "completedAt", function(n) {
        return n.j0;
    }, td, A4(Do, "pausedAt", function(n) {
        return n.df;
    }, td, A4(rc, "progressedAt", function(n) {
        return n.gG;
    }, td, A4(rc, "progress", function(n) {
        return n.pj;
    }, mS, Io(SR))))))))))), yR = F3(function(n, r, t) {
        return {
            lm: r,
            pj: n,
            bl: t
        };
    }), FR = F3(function(n, r, t) {
        return {
            n7: n,
            aq: r,
            b9: t
        };
    }), jR = F2(function(n, r) {
        return {
            lB: n,
            av: r
        };
    }), PR = F3(function(n, r, t) {
        return {
            lR: n,
            fL: r,
            qO: t
        };
    }), IR = Po(A4(Do, "size", function(n) {
        return n.qO;
    }, uc, A4(Do, "lastModified", function(n) {
        return n.fL;
    }, td, A4(Do, "format", function(n) {
        return n.lR;
    }, xi, Io(PR))))), BR = F6(function(n, r, t, e, u, a) {
        return {
            mm: n,
            bY: a,
            n5: e,
            b0: t,
            gn: r,
            gH: u
        };
    }), MR = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            d2: a,
            u: n,
            fW: i,
            f6: e,
            ga: t,
            gE: c,
            g5: o,
            hI: u,
            ia: r
        };
    }), OR = F2(function(n, r) {
        return {
            n5: n,
            ss: r
        };
    }), qR = Po(A4(Do, "value", function(n) {
        return n.ss;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(OR)))), DR = F2(function(n, r) {
        return {
            m2: n,
            ss: r
        };
    }), xR = Po(A4(rc, "$", function(n) {
        return n.u;
    }, Po(A4(Do, "value", function(n) {
        return n.ss;
    }, xi, A4(Do, "key", function(n) {
        return n.m2;
    }, xi, Io(DR)))), Io(function(n) {
        return {
            u: n
        };
    }))), RR = nc(oc(xR)), VR = Po(A4(Do, "ProgramLoudnessEBU", function(n) {
        return n.gE;
    }, oc(RR), A4(Do, "MaxShortTermLoudness", function(n) {
        return n.g5;
    }, oc(xR), A4(Do, "mapping", function(n) {
        return n.fW;
    }, oc(xR), A4(Do, "area", function(n) {
        return n.d2;
    }, oc(xR), A4(Do, "SystemItem", function(n) {
        return n.hI;
    }, oc(RR), A4(Do, "TimeCodeTrack", function(n) {
        return n.f6;
    }, oc(RR), A4(Do, "TimecodeTrack", function(n) {
        return n.ga;
    }, oc(RR), A4(Do, "VideoTrackProperty", function(n) {
        return n.ia;
    }, oc(RR), A4(rc, "$", function(n) {
        return n.u;
    }, qR, Io(MR))))))))))), ER = F2(function(n, r) {
        return {
            ln: r,
            dP: n
        };
    }), zR = F8(function(n, r, t, e, u, a, i, o) {
        return {
            er: r,
            kL: u,
            e_: o,
            mm: n,
            g3: t,
            hr: i,
            hH: e,
            hT: a
        };
    }), UR = Po(A4(Do, "endsmptetimecode", function(n) {
        return n.e_;
    }, xi, A4(Do, "startsmptetimecode", function(n) {
        return n.hr;
    }, xi, A4(Do, "smptetimecode", function(n) {
        return n.hT;
    }, xi, A4(rc, "description", function(n) {
        return n.kL;
    }, xi, A4(rc, "synopsis", function(n) {
        return n.hH;
    }, xi, A4(rc, "severity", function(n) {
        return n.g3;
    }, xi, A4(Do, "checkId", function(n) {
        return n.er;
    }, xi, A4(Do, "id", function(n) {
        return n.mm;
    }, xi, Io(zR)))))))))), HR = Po(A4(rc, "$", function(n) {
        return n.u;
    }, UR, Io(function(n) {
        return {
            u: n
        };
    }))), WR = Po(A4(rc, "errors", function(n) {
        return n.ln;
    }, oc(HR), A4(rc, "warnings", function(n) {
        return n.dP;
    }, oc(HR), Io(ER)))), QR = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ZR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, KR = {
        $: 3
    }, YR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, XR = F4(function(n, r, t, e) {
        return {
            cz: t,
            fD: e,
            ns: r,
            gE: n
        };
    }), JR = F2(function(n, r) {
        return {
            m6: n,
            h3: r
        };
    }), GR = Po(A4(rc, "truePeakLevel", function(n) {
        return n.h3;
    }, xi, A4(rc, "label", function(n) {
        return n.m6;
    }, xi, Io(JR)))), _R = Po(A4(rc, "isMute", function(n) {
        return n.fD;
    }, no, A4(rc, "channels", function(n) {
        return n.cz;
    }, oc(GR), A4(Do, "loudnessRange", function(n) {
        return n.ns;
    }, xi, A4(Do, "programLoudness", function(n) {
        return n.gE;
    }, xi, Io(XR)))))), nV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tV = {
        $: 2
    }, eV = F2(function(n, r) {
        return {
            eS: r,
            q4: n
        };
    }), uV = Po(A4(Do, "duration", function(n) {
        return n.eS;
    }, xi, A4(Do, "startTimecode", function(n) {
        return n.q4;
    }, xi, Io(eV)))), aV = F3(function(n, r, t) {
        return {
            gi: n,
            gA: t,
            hU: r
        };
    }), iV = F3(function(n, r, t) {
        return {
            fF: t,
            n5: n,
            sv: r
        };
    }), oV = Po(A4(Do, "issuer", function(n) {
        return n.fF;
    }, xi, A4(Do, "version", function(n) {
        return n.sv;
    }, xi, A4(Do, "name", function(n) {
        return n.n5;
    }, xi, Io(iV))))), cV = F5(function(n, r, t, e, u) {
        return {
            eS: n,
            fj: u,
            fZ: e,
            hg: t,
            hJ: r
        };
    }), sV = Po(A4(Do, "hasVitc", function(n) {
        return n.fj;
    }, xi, A4(Do, "materialPackageStart", function(n) {
        return n.fZ;
    }, xi, A4(Do, "sourcePackageStart", function(n) {
        return n.hg;
    }, xi, A4(Do, "systemItemStart", function(n) {
        return n.hJ;
    }, xi, A4(Do, "duration", function(n) {
        return n.eS;
    }, xi, Io(cV))))))), fV = Po(A4(rc, "product", function(n) {
        return n.gA;
    }, oV, A4(rc, "timeCodes", function(n) {
        return n.hU;
    }, sV, A4(Do, "operationalPattern", function(n) {
        return n.gi;
    }, xi, Io(aV))))), lV = F2(function(n, r) {
        return A3($b, n, function(n) {
            return n(g);
        }, je(r));
    }), mV = ld(A3(lV, "UnsupportedContainer", tV, A4(gb, "Mov", nV, uV, A4(gb, "Mxf", rV, fV, bd(F4(function(n, r, t, e) {
        switch(e.$){
            case 0:
                return n(e.a);
            case 1:
                return r(e.a);
            default:
                return t;
        }
    })))))), dV = F6(function(n, r, t, e, u, a) {
        return {
            dV: t,
            en: e,
            es: u,
            eQ: n,
            lU: r,
            gY: a
        };
    }), bV = Po(A4(Do, "scanningType", function(n) {
        return n.gY;
    }, xi, A4(Do, "chromaFormat", function(n) {
        return n.es;
    }, xi, A4(Do, "cadencePattern", function(n) {
        return n.en;
    }, xi, A4(Do, "activePixelsArea", function(n) {
        return n.dV;
    }, xi, A4(Do, "frameRate", function(n) {
        return n.lU;
    }, xi, A4(Do, "displayAspectRatio", function(n) {
        return n.eQ;
    }, xi, Io(dV)))))))), pV = ld(A3(lV, "UnknownNodeType", KR, A4(gb, "Container", ZR, mV, A4(gb, "VideoProgram", YR, bV, A4(gb, "AudioProgram", QR, _R, bd(F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return n(u.a);
            case 1:
                return r(u.a);
            case 2:
                return t(u.a);
            default:
                return e;
        }
    }))))))), vV = Po(A4(rc, "issues", function(n) {
        return n.bY;
    }, WR, A4(rc, "properties", function(n) {
        return n.gH;
    }, nc(VR), A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "nodeType", function(n) {
        return n.b0;
    }, pV, A4(rc, "parent", function(n) {
        return n.gn;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(BR)))))))), $V = Po(A4(rc, "streams", function(n) {
        return n.av;
    }, nc(vV), A4(rc, "file", function(n) {
        return n.lB;
    }, IR, Io(jR)))), gV = Po(A4(Do, "report", function(n) {
        return n.b9;
    }, $V, A4(rc, "nbWarnings", function(n) {
        return n.aq;
    }, uc, A4(rc, "nbErrors", function(n) {
        return n.n7;
    }, uc, Io(FR))))), hV = Po(A4(Do, "result", function(n) {
        return n.bl;
    }, gV, A4(Do, "error", function(n) {
        return n.lm;
    }, xi, A4(rc, "progress", function(n) {
        return n.pj;
    }, mS, Io(yR))))), kV = Po(A4(Do, "format", function(n) {
        return n.lR;
    }, MS, A4(Do, "stateExpireAt", function(n) {
        return n.ht;
    }, td, A4(rc, "state", function(n) {
        return n.hs;
    }, Mb, A4(Do, "transcoding", function(n) {
        return n.r2;
    }, AR, A4(Do, "sourceId", function(n) {
        return n.hd;
    }, xi, A4(Do, "verification", function(n) {
        return n.su;
    }, hV, A4(Do, "uploadedAt", function(n) {
        return n.h6;
    }, td, A4(Do, "upload", function(n) {
        return n.sg;
    }, LR, A4(Do, "uploaderId", function(n) {
        return n.si;
    }, xi, A4(rc, "kind", function(n) {
        return n.c$;
    }, qq, A4(rc, "key", function(n) {
        return n.m2;
    }, xi, A4(rc, "bucket", function(n) {
        return n.jt;
    }, xi, A4(Do, "mimeType", function(n) {
        return n.nS;
    }, xi, A4(rc, "size", function(n) {
        return n.qO;
    }, uc, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            jt: a,
                                                                            kg: r,
                                                                            lR: v,
                                                                            mm: n,
                                                                            m2: i,
                                                                            c$: o,
                                                                            nS: u,
                                                                            n5: t,
                                                                            qO: e,
                                                                            hd: m,
                                                                            hs: b,
                                                                            ht: p,
                                                                            r2: d,
                                                                            sg: s,
                                                                            h6: f,
                                                                            si: c,
                                                                            su: l
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), TV = F2(function(n, r) {
        return {
            m2: r,
            sh: n
        };
    }), wV = Po(A4(rc, "key", function(n) {
        return n.m2;
    }, xi, A4(rc, "uploadId", function(n) {
        return n.sh;
    }, xi, Io(TV)))), CV = Po(A4(rc, "parts", function(n) {
        return n.oY;
    }, oc(wV), A4(rc, "uploads", function(n) {
        return n.dJ;
    }, oc(kV), Io(gR)))), NV = ml({
        $: 13,
        a: 0
    }), AV = dc(A2(Ho, CV, So(NV))), SV = dc(A2(Ho, FC, So(PC))), LV = _b(m(AV, SV)), yV = {
        iA: g,
        c1: Tt,
        dE: Tt
    }, FV = {
        iA: yV,
        oo: 0,
        sc: g,
        dJ: g
    }, jV = m(FV, A2(Yi, $R, LV)), PV = function(n) {
        return {
            $: 6,
            a: n
        };
    }, IV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BV = function(n) {
        return {
            $: 4,
            a: n
        };
    }, MV = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), OV = function(n) {
        return ml(Rq(A2(MV, n, 7)));
    }, qV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, DV = F2(function(n, r) {
        return A2(Gv, qV, A2(Gb, function(t) {
            return {
                d4: t,
                nO: r,
                g3: n
            };
        }, Jv));
    }), xV = DV(1), RV = F2(function(n, r) {
        var t = F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? m(A2(dt, r, e), u) : m(e, A2(dt, r, u));
        });
        return A3(Je, t, m(g, g), r);
    }), VV = F3(function(n, r, t) {
        return A3(qt, F2(function(n, r) {
            var e = r.a, u = r.b, a = Va(A2(Iu, function(r) {
                return i(n.si, kt(r.mm));
            }, t)), o = A2(RV, function(r) {
                return i(kt(r.sh), A2(fp, function(n) {
                    return n.pY;
                }, n.sg));
            }, u), c = o.b;
            return m(A2(dt, {
                lB: n,
                oY: o.a,
                sp: a
            }, e), c);
        }), m(g, r), Kt(n));
    }), EV = DV(0), zV = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, n$);
            case 1:
                var t = n.a;
                return m(p(r, {
                    iA: 1 === (e = r.c1).$ ? A2(dt, t, r.iA) : A2(Ka, e.a, A2(dt, t, r.iA))
                }), n$);
            default:
                return t = n.a, m(p(r, {
                    iA: A2(Iu, function(n) {
                        return !i(n, t);
                    }, r.iA)
                }), n$);
        }
        var e;
    }), UV = F2(function(n, r) {
        switch(n.$){
            case 1:
                return A2(pc, g, p(r, {
                    oo: n.a
                }));
            case 0:
                return A2(pc, g, r);
            case 2:
                if ((o = n.a).$) return A2(pc, T([
                    A2(cp, PV, xV(o.a.nO))
                ]), r);
                var t = o.a, e = t.a, u = A3(VV, e.dJ, e.oY, t.b), a = u.a, i = u.b;
                return A2(pc, T([
                    A2(Gv, IV, Jv)
                ]), p(r, {
                    sc: i,
                    dJ: a
                }));
            case 3:
                return A2(pc, T([
                    A2(Yi, BV, (f = n.a, dc(fg(sg(OV(f))))))
                ]), r);
            case 4:
                var o;
                return A2(pc, T((o = n.a).$ ? [
                    A2(cp, PV, xV(o.a.nO))
                ] : [
                    A2(cp, PV, EV("Upload deleted"))
                ]), r);
            case 5:
                return A2(pc, T([
                    A2(Yi, $R, LV)
                ]), r);
            default:
                var c = A2(zV, n.a, r.iA), s = c.a;
                return A2(pc, T([
                    A2(cp, PV, c.b)
                ]), p(r, {
                    iA: s
                }));
        }
        var f;
    }), HV = dw(mN), WV = function(n) {
        return {
            $: 3,
            a: n
        };
    }, QV = function(n) {
        return It(fe(100 * n)) + "%";
    }, ZV = {
        $: 4
    }, KV = {
        $: 2
    }, YV = {
        $: 1
    }, XV = F2(function(n, r) {
        return i(n.df, Tt) ? r ? YV : function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            aV: n.aV
        }) : KV;
    }), JV = F3(function(n, r, t) {
        var e = Va(A2(Iu, function(r) {
            return i(r.z, n);
        }, t)), u = r.lm;
        if (u.$) {
            if (i(r.j0, Tt) && 1 !== r.pj) {
                if (e.$) return A2(XV, r, !1);
                var a = e.a;
                return i(a.j0, Tt) ? A2(XV, r, a.dg) : ZV;
            }
            return ZV;
        }
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }({
            lm: u.a
        });
    }), GV = F3(function(n, r, t) {
        return 1 > n ? "" : 1 === n ? $(r, $(It(n), t)) : r + (It(n) + (t + "s"));
    }), _V = function(n) {
        return 86400 > n ? 3600 > n ? 60 > n ? A3(GV, n, "", " seconde") : A3(GV, n / 60 | 0, "", " minute") : $(A3(GV, n / 3600 | 0, "", " heure"), A3(GV, A2(qa, 60, n), " et ", " minute")) : $(A3(GV, n / 86400 | 0, "", " jour"), A3(GV, A2(qa, 24, n), " et ", " heure"));
    }, nE = Oi({
        bN: "in error",
        bT: "en erreur"
    }), rE = Oi({
        bN: "Calcultating the remaining time...",
        bT: "Calcul du temps restant..."
    }), tE = Oi({
        bN: "paused",
        bT: "en pause"
    }), eE = Oi({
        bN: "pausing...",
        bT: "mis en pause..."
    }), uE = Oi({
        bN: "seems stopped since ",
        bT: "semble \xe0 l\u2019arr\xeat depuis "
    }), aE = function(n) {
        switch(n.$){
            case 0:
                var r = n.a.aV;
                return r.$ ? rE : _V(r.a);
            case 1:
                return eE;
            case 2:
                return tE;
            case 3:
                var t = _V(n.a.qg);
                return "" === t ? "" : $(uE, t);
            case 4:
                return "";
            default:
                return nE;
        }
    }, iE = function(n) {
        switch(n.$){
            case 5:
                return "En erreur : " + n.a.lm;
            case 4:
                return "Termin\xe9";
            default:
                return aE(n);
        }
    }, oE = F2(function(n, r) {
        return A2(Ge, function(n) {
            var t = m(n.lB.sg, n.sp);
            if (t.a.$ || t.b.$) return g;
            var e = t.a.a, u = t.b.a;
            return T([
                lR(n.lB.n5),
                ih(QV(e.pj)),
                A2(Le, g, T([
                    BN(e.gG),
                    ih(r - jN(e.gG) > 6e5 ? "\xa0 \xa0 ???" : "")
                ])),
                ih(Wq(qs(e.qZ)) + "/s"),
                ih(iE(A3(JV, n.lB.mm, e, g))),
                ih(u.n5),
                ih(It(Dt(n.oY))),
                A2(Og, Th, WV(n.lB.mm))
            ]);
        }, n);
    }), cE = T([
        ih("Fichier"),
        ih("Progression"),
        ih("Last Updated"),
        ih("Last Speed Recorded"),
        ih("Statut"),
        ih("User"),
        ih("S3 parts"),
        ih("Supprimer")
    ]), sE = Se("ul"), fE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lE = Se("li"), mE = function(n) {
        return A2(lE, T([
            wh(fE(n))
        ]), T([
            ih(n.nO)
        ]));
    }, dE = function(n) {
        var r;
        return A2(Le, g, T([
            (r = n.iA, A2(sE, g, A2(Ge, mE, r)))
        ]));
    }, bE = function(n) {
        return A2(lE, T([
            A2(ph, "list-style", "disc"),
            A2(ph, "margin-top", "5px")
        ]), T([
            ih(n.m2)
        ]));
    }, pE = F2(function(n, r) {
        return A3(hw, "Uploads", Tt, A2(Le, g, T([
            A2(dk, PV, dE(r.iA)),
            A2(Gw, cE, A2(oE, r.dJ, r.oo)),
            HV("Unlinked S3 parts"),
            A2(sE, T([
                A2(ph, "padding-left", "1.5em")
            ]), A2(Ge, bE, r.sc))
        ])));
    }), vE = {
        l: function(n) {
            return n.dJ;
        },
        m: jV,
        o: F2(function(n, r) {
            return p(n, {
                dJ: r
            });
        }),
        p: vR,
        q: UV,
        r: pE
    }, $E = {
        kN: Tt,
        lm: Tt,
        oP: Au,
        pw: Ri(function(n) {
            return p(n, {
                gt: "Search User or Email or Organization",
                ss: ""
            });
        }),
        rv: Tt,
        rJ: a$("Full name"),
        dK: g
    }, gE = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hE = A2(Gb, Jo, A2(Gb, Ge(function(n) {
        return m(n.mm, n);
    }), A2(Gb, zi(function(n) {
        return n.n5;
    }), dc(A2(Ho, I$, So(M$)))))), kE = A2(Gb, zi(function(n) {
        return n.n5;
    }), dc(A2(Ho, FC, So(PC)))), TE = A2(Yi, gE, _b(m(kE, hE))), wE = A2(pc, T([
        TE
    ]), $E), CE = function(n) {
        return {
            $: 17,
            a: n
        };
    }, NE = {
        $: 0
    }, AE = function(n) {
        return {
            $: 24,
            a: n
        };
    }, SE = function(n) {
        return {
            $: 15,
            a: n
        };
    }, LE = Lo(Fo({
        $: 3
    })), yE = Po(A4(rc, "email", function(n) {
        return n.k8;
    }, xi, Io(function(n) {
        return {
            k8: n
        };
    }))), FE = function(n) {
        return dc(fg(A3(ag, yE, n, rg(LE))));
    }, jE = F2(function(n, r) {
        return Wo($i(T([
            m("name", gi(n)),
            m("message", gi(r))
        ])));
    }), PE = function(n) {
        return _e(function(r) {
            var t = A2(di, n, r);
            return t.$ ? A2(jE, "JSON Decode Error", Xt(t.a)) : Ke(t.a);
        });
    }, IE = qn, BE = function(n) {
        var r;
        return A2(Ii, A2(jE, "FFI Error", ji), (r = A2(mu, "_elm_ffi_apply_", Mo(T([
            A2(ye, Ke, A2(mu, "OK", Pi)),
            A2(Ce, A2(bu, je, ME(n)), A2(mu, "AW", fS)),
            A2(ye, Wo, A2(mu, "ER", Pi))
        ]))), A2(di, r, n)));
    }, ME = function(n) {
        return A2(No, IE, _e(function() {
            return BE(n);
        }));
    }, OE = F2(function(n, r) {
        return BE($i(T([
            m("_elm_ffi_apply_", $i(T([
                m("holder", r),
                m("params", A2(ic, Ie, n))
            ])))
        ])));
    }), qE = F2(function(n, r) {
        return $i(T([
            m("_elm_ffi_create_", $i(T([
                m("args", A2(ic, gi, n)),
                m("code", gi(r))
            ])))
        ]));
    }), DE = F2(function(n, r) {
        var t = A2(qE, A2(Ge, $e, n), r);
        return function(r) {
            return A2(OE, A2(Ge, A2(No, Ko, ce(r)), n), t);
        };
    }), xE = (ss = A2(DE, T([
        m("message", gi)
    ]), "return confirm(message);"), function(n) {
        return A2(Zi, function() {
            return Ke(!1);
        }, A2(PE, Ne, ss(n)));
    }), RE = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), VE = _r("focus"), EE = Po(A4(rc, "user", function(n) {
        return n.sp;
    }, xi, Io(function(n) {
        return {
            sp: n
        };
    }))), zE = ml(jC({
        $: 1
    })), UE = function(n) {
        return dc(fg(A3(ag, EE, {
            sp: n.mm
        }, rg(zE))));
    }, HE = function(n) {
        return {
            $: 12,
            a: n
        };
    }, WE = F7(function(n, r, t, e, u, a, i) {
        return {
            iw: a,
            kP: i,
            k8: r,
            n5: n,
            oL: t,
            oP: u,
            oZ: e
        };
    }), QE = Po(A4(rc, "disableOrganizationEmails", function(n) {
        return n.kP;
    }, no, A4(rc, "admin", function(n) {
        return n.iw;
    }, no, A4(rc, "organizations", function(n) {
        return n.oP;
    }, oc(xi), A4(rc, "password", function(n) {
        return n.oZ;
    }, xi, A4(Do, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(WE))))))))), ZE = function(n) {
        return A2(Yi, HE, function(n) {
            var r = A2(Ge, function(n) {
                return n.b.ss;
            }, pt(n.oP)), t = Va(r);
            return dc(A2(ng, Wv, A3(ag, QE, {
                iw: n.iw.ss,
                kP: n.kP.ss,
                k8: n.k8.ss,
                n5: n.n5.ss,
                oL: t,
                oP: r,
                oZ: n.oZ.ss
            }, rg(PC))));
        }(n));
    }, KE = function(n) {
        return {
            $: 14,
            a: n
        };
    }, YE = function(n) {
        return {
            $: 3,
            a: n
        };
    }, XE = A2(bu, A2(bu, ml, jC), YE), JE = function(n) {
        return A2(Yi, KE, function(n) {
            return dc(fg(sg(XE(n.mm))));
        }(n));
    }, GE = function(n) {
        return {
            $: 13,
            a: n
        };
    }, _E = F6(function(n, r, t, e, u, a) {
        return {
            iw: u,
            kP: a,
            k8: r,
            n5: n,
            oL: t,
            oP: e
        };
    }), nz = Po(A4(rc, "disableOrganizationEmails", function(n) {
        return n.kP;
    }, no, A4(rc, "admin", function(n) {
        return n.iw;
    }, no, A4(rc, "organizations", function(n) {
        return n.oP;
    }, oc(xi), A4(Do, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(_E)))))))), rz = F2(function(n, r) {
        var t = A2(Ge, function(n) {
            return n.b.ss;
        }, pt(r.oP)), e = Va(t);
        return dc(A2(Ho, Wv, A3(ag, nz, {
            iw: r.iw.ss,
            kP: r.kP.ss,
            k8: r.k8.ss,
            n5: r.n5.ss,
            oL: e,
            oP: t
        }, mg(XE(n.mm)))));
    }), tz = F2(function(n, r) {
        return A2(Yi, GE, A2(rz, n, r));
    }), ez = Kn("redirectAndRefresh", gi), uz = Po(A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return {
            mm: n
        };
    }))), az = Lo(Fo({
        $: 5
    })), iz = gN(Sp), oz = function(n) {
        return Ri(function(r) {
            return p(r, {
                m6: "Organization",
                ss: n.oN
            });
        });
    }, cz = F2(function(n) {
        var r;
        return {
            iw: ro(function(r) {
                return p(r, {
                    m6: "Admin",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.iw;
                    }, n))
                });
            }),
            kP: ro(function(r) {
                return p(r, {
                    m6: "Disable Emails",
                    ss: A2(ju, !1, A2(Fu, function(n) {
                        return n.kP;
                    }, n))
                });
            }),
            k8: Ri(function(r) {
                return p(r, {
                    m6: "Email",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.k8;
                    }, n))
                });
            }),
            n5: Ri(function(r) {
                return p(r, {
                    m6: "Name",
                    ss: A2(ju, "", A2(Fu, function(n) {
                        return n.n5;
                    }, n))
                });
            }),
            oP: n.$ ? Au : (r = n.a.oP, A2(_o, F2(function(n, r) {
                return oz(r);
            }), Jo(A2(zt, x$, r)))),
            oR: n,
            oZ: Ri(function(n) {
                return p(n, {
                    m6: "Password"
                });
            })
        };
    }), sz = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, r);
            case 1:
                if ((s = n.a).$) return A2(pc, g, A2(RE, s.a, r));
                var t = s.a;
                return A2(pc, g, p(r, {
                    oP: t.b,
                    dK: t.a
                }));
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(A2(cz, Tt, r.oP))
                }));
            case 3:
                var e = n.a;
                return A2(pc, T([
                    A2(Yi, function() {
                        return NE;
                    }, VE("LayoutPageTop"))
                ]), p(r, {
                    kN: kt(A2(cz, kt(e), r.oP)),
                    lm: Tt,
                    rv: Tt
                }));
            case 6:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 7:
                var u = n.a, a = A2(Fu, function(n) {
                    return p(n, {
                        n5: A2(gg, u, n.n5)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: a
                }));
            case 8:
                return u = n.a, a = A2(Fu, function(n) {
                    return p(n, {
                        k8: A2(gg, u, n.k8)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 9:
                return u = n.a, a = A2(Fu, function(n) {
                    return p(n, {
                        oZ: A2(gg, u, n.oZ)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 10:
                return u = n.a, a = A2(Fu, function(n) {
                    return p(n, {
                        iw: A2(vg, u, n.iw)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 11:
                return u = n.a, a = A2(Fu, function(n) {
                    return p(n, {
                        kP: A2(vg, u, n.kP)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 4:
                var o = r.kN;
                if (1 === o.$) return A2(pc, g, r);
                var c = (a = o.a).oR;
                return A2(pc, T(1 === c.$ ? [
                    ZE(a)
                ] : [
                    A2(tz, b = c.a, a)
                ]), r);
            case 12:
                return (s = n.a).$ ? A2(pc, g, A2(RE, s.a, r)) : A2(pc, T([
                    TE
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("User created")
                }));
            case 13:
                return (s = n.a).$ ? A2(pc, g, A2(RE, s.a, r)) : A2(pc, T([
                    TE
                ]), p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: kt("User updated")
                }));
            case 5:
                return A2(pc, T([
                    JE(b = n.a)
                ]), r);
            case 14:
            case 15:
                return (s = n.a).$ ? A2(pc, g, A2(RE, s.a, r)) : A2(pc, T([
                    TE
                ]), r);
            case 16:
                return A2(pc, T([
                    A2(Yi, CE, UE(b = n.a))
                ]), r);
            case 17:
                var s;
                return A2(pc, 1 === (s = n.a).$ ? g : T([
                    ez(iz)
                ]), r);
            case 18:
                u = n.a;
                var f = n.b;
                return a = A2(Fu, function(n) {
                    return p(n, {
                        oP: A2(_o, F2(function(n, r) {
                            return i(n, f) ? A2(gg, u, r) : r;
                        }), n.oP)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 20:
                return f = n.a, a = A2(Fu, function(n) {
                    return p(n, {
                        oP: A2(U$, F2(function(n) {
                            return !i(n, f);
                        }), n.oP)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 19:
                var l = A2(ju, 0, A2(Fu, function(n) {
                    return A2(ju, 0, H$(vt(n.oP)));
                }, r.kN)), m = A2(ju, "", Va(A2(Ge, function(n) {
                    return n.mm;
                }, A2(Ge, Ko, pt(r.oP))))), d = oz(A3(Uv, m, "", Tt));
                return a = A2(Fu, function(n) {
                    return p(n, {
                        oP: A3(wu, l + 1, d, n.oP)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: a
                }));
            case 22:
                return A2(pc, g, p(r, {
                    pw: A2(gg, u = n.a, r.pw)
                }));
            case 21:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
            case 23:
                return A2(pc, T([
                    A2(Yi, AE, FE({
                        k8: n.a
                    }))
                ]), r);
            case 24:
                return A2(pc, g, p(r, n.a.$ ? {
                    lm: kt(n.a.a.nO)
                } : {
                    rv: kt("Sent email to reset password.")
                }));
            default:
                var b = n.a;
                return A2(pc, T([
                    A2(Yi, SE, A2(OC, function(n) {
                        return n ? dc(fg(A3(ag, uz, {
                            mm: b.mm
                        }, rg(az)))) : oN(0);
                    }, A2(Qo, function() {
                        return {
                            lA: Au,
                            nO: "",
                            P: 0
                        };
                    }, xE("Confirm this unreversible action"))))
                ]), r);
        }
    }), fz = {
        $: 2
    }, lz = function(n) {
        return {
            $: 22,
            a: n
        };
    }, mz = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dz = function(n) {
        return {
            $: 16,
            a: n
        };
    }, bz = function(n) {
        return {
            $: 25,
            a: n
        };
    }, pz = function(n) {
        return {
            $: 21,
            a: n
        };
    }, vz = function(n) {
        return {
            $: 5,
            a: n
        };
    }, $z = function(n) {
        return n ? "\u2714" : "\u2716";
    }, gz = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), hz = function(n) {
        return _g({
            n5: "",
            ds: rh,
            dM: gz(n)
        });
    }, kz = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), Tz = F2(function(n, r) {
        return A3(Ym, n, "0", It(r));
    }), wz = function(n) {
        switch(n){
            case 0:
                return "01";
            case 1:
                return "02";
            case 2:
                return "03";
            case 3:
                return "04";
            case 4:
                return "05";
            case 5:
                return "06";
            case 6:
                return "07";
            case 7:
                return "08";
            case 8:
                return "09";
            case 9:
                return "10";
            case 10:
                return "11";
            default:
                return "12";
        }
    }, Cz = F2(function(n, r) {
        return $(A2(Tz, 4, A2(Gm, nd, r)), $(n, $(wz(A2(Wm, nd, r)), $(n, A2(Tz, 2, A2(Em, nd, r))))));
    }), Nz = function(n) {
        return A2(Cz, "/", n);
    }, Az = T([
        Rg("Table")
    ]), Sz = function() {
        return T([
            Rg("TableTr")
        ]);
    }, Lz = F2(function(n, r) {
        return Co(A2(LD, ", ", A2(Ge, function(r) {
            return A2(ju, "", A2(Fu, function(n) {
                return n.n5;
            }, A2(lo, r.oN, n)));
        }, r.oP)));
    }), yz = {
        $: 6
    }, Fz = function(n) {
        return {
            $: 10,
            a: n
        };
    }, jz = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Pz = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Iz = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Bz = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Mz = {
        $: 19
    }, Oz = function(n) {
        return {
            $: 23,
            a: n
        };
    }, qz = {
        $: 4
    }, Dz = function(n) {
        return A2(ju, !1, A2(Fu, function() {
            return !0;
        }, n.oR));
    }, xz = function(n) {
        return A2(jT, n, function(n) {
            return A2(Rh, n, A2(Eh, T([
                Rg("InputPassword"),
                Xh(n.kV),
                Ch("password"),
                ek(Fh),
                _h(jh),
                nk(Ph),
                ak(n.ss),
                uk(n.gt),
                zh(Kh(n.m6)),
                Vh(n.kQ),
                A2(IB, "autocomplete", "current-password")
            ]), g));
        }(n));
    }, Rz = F2(function(n, r) {
        return {
            $: 18,
            a: n,
            b: r
        };
    }), Vz = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ez = F2(function(n, r) {
        var t = A2(Ge, function(n) {
            return m(n.a, n.b.n5);
        }, A2(zi, function(n) {
            return n.b.n5;
        }, pt(r)));
        return A2(Ge, Ko, pt(A2(_o, F2(function(n, r) {
            return A2(Le, T([
                A2(ph, "position", "relative"),
                A2(ph, "margin", "25px 0")
            ]), T([
                A2(dk, function(r) {
                    return A2(Rz, r, n);
                }, A2(VT, r, t)),
                A3(JT, "remove", T([
                    m("position", "absolute"),
                    m("right", "0")
                ]), Vz(n))
            ]));
        }), n.oP)));
    }), zz = function(n) {
        return A2(wT, function(r) {
            var t = Dz(r) ? m("Save", "Edit user") : m("Create", "New User");
            return A4(ZT, t.b, m(t.a, qz), m("Cancel", yz), $(T([
                A2(dk, Iz, IT(r.n5)),
                A2(dk, Pz, IT(r.k8)),
                Dz(r) ? ih("") : A2(dk, Bz, xz(r.oZ)),
                A2(dk, Fz, PT(r.iw)),
                A2(dk, jz, PT(r.kP))
            ]), $(A2(Ez, r, n.oP), T([
                A2(Nh, "Add New Organization", Mz),
                A2(Nh, "Reset password", Oz(r.k8.ss)),
                A2(wT, lT, n.rv),
                A2(wT, fT, n.lm)
            ]))));
        }, n.kN);
    }, Uz = F2(function(n, r) {
        var t, e = Hi(r.pw.ss), u = A2(Iu, function(n) {
            return A2(bu, A2(bu, Oe(e), Hi), function(n) {
                return n.n5;
            })(n) || A2(bu, A2(bu, Oe(e), Hi), function(n) {
                return n.k8;
            })(n) || A2(bu, A2(bu, Oe(e), Hi), Lz(r.oP))(n);
        }, r.dK);
        return A3(hw, "Users", kt(A2(Nh, "New\u2026", fz)), A2(Le, g, T([
            A2(dk, lz, ik(r.pw)),
            zz(r),
            A3(cT, (t = r.oP, uh({
                jY: T([
                    hz(A2(bu, Nh("edit"), mz)),
                    A2(kz, "Full name", function(n) {
                        return n.n5;
                    }),
                    A2(kz, "Email address", function(n) {
                        return n.k8;
                    }),
                    A2(kz, "Admin", A2(bu, $z, function(n) {
                        return n.iw;
                    })),
                    A2(kz, "Disable Organization Emails", A2(bu, $z, function(n) {
                        return n.kP;
                    })),
                    A2(kz, "Organizations", Lz(t)),
                    A2(kz, "Creation date", A2(bu, A2(bu, ju("Unknown"), Fu(Nz)), function(n) {
                        return n.kg;
                    })),
                    hz(A2(bu, Nh("Log as"), dz)),
                    hz(A2(bu, Nh("Delete"), vz)),
                    hz(A2(bu, Nh("Revoke"), bz))
                ]),
                kt: p(kh, {
                    pR: Sz,
                    rA: Az,
                    rM: T([
                        Rg("TableTd")
                    ])
                }),
                rV: function(n) {
                    return n.mm;
                },
                rW: pz
            })), r.rJ, u)
        ])));
    }), Hz = {
        l: function(n) {
            return n.dK;
        },
        m: wE,
        o: F2(function(n, r) {
            return p(n, {
                dK: r
            });
        }),
        p: function(n) {
            return {
                $: 4,
                a: n
            };
        },
        q: sz,
        r: Uz
    }, Wz = {
        kN: Tt,
        lm: Tt,
        oP: g,
        rv: Tt,
        rJ: a$("Organization"),
        dQ: g
    }, Qz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Zz = dc(A2(Ho, I$, So(M$))), Kz = F5(function(n, r, t, e, u) {
        return {
            im: e,
            lo: t,
            mm: n,
            oL: r,
            oW: u
        };
    }), Yz = function(n) {
        switch(n){
            case "ShowCreation":
                return St(0);
            case "ProxyReady":
                return St(1);
            case "FileQualified":
                return St(2);
            case "FileDownload":
                return St(3);
            case "VersionAccepted":
                return St(4);
            case "VersionRejected":
                return St(5);
            case "InvitationAdded":
                return St(6);
            case "InvitationUpdated":
                return St(7);
            case "InvitationRemoved":
                return St(8);
            case "UploaderAdded":
                return St(9);
            case "UploaderRemoved":
                return St(10);
            case "UploadFinished":
                return St(11);
            case "QCFinished":
                return St(12);
            default:
                return wt("Can't parse webhook event " + n);
        }
    }, Xz = function(n) {
        switch(n){
            case 0:
                return "ShowCreation";
            case 1:
                return "ProxyReady";
            case 2:
                return "FileQualified";
            case 3:
                return "FileDownload";
            case 4:
                return "VersionAccepted";
            case 5:
                return "VersionRejected";
            case 6:
                return "InvitationAdded";
            case 7:
                return "InvitationUpdated";
            case 8:
                return "InvitationRemoved";
            case 9:
                return "UploaderAdded";
            case 10:
                return "UploaderRemoved";
            case 11:
                return "UploadFinished";
            default:
                return "QCFinished";
        }
    }, Jz = A2(Il, Xz, Yz), Gz = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _z = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nU = function(n) {
        switch(n){
            case "Json":
                return St(0);
            case "SaltoMam":
                return St(1);
            case "SaltoContent":
                return St(2);
            case "ADN":
                return St(3);
            default:
                return wt("Can't parse api call format " + n);
        }
    }, rU = A2(Ce, function(n) {
        var r = nU(n);
        return r.$ ? Dc(r.a) : je(r.a);
    }, Bi), tU = function(n) {
        switch(n){
            case "Manager":
                return St(0);
            case "Uploader":
                return St(1);
            case "EventSpecified":
                return St(2);
            default:
                return wt("Can't parse email target " + n);
        }
    }, eU = A2(Ce, function(n) {
        var r = tU(n);
        return r.$ ? Dc(r.a) : je(r.a);
    }, Bi), uU = on, aU = A2(Ce, function(n) {
        var r = n.a, t = n.b, e = t.a, u = m(r, d(e, t.b, t.c));
        n: for(;;){
            if (u.b.a.$) {
                if ("Email" !== u.a || 1 !== u.b.b.$ || u.b.c.$) break n;
                return je(_z(u.b.c.a));
            }
            if ("ApiCall" !== u.a || u.b.b.$ || 1 !== u.b.c.$) break n;
            var a = u.b;
            return je(A2(Gz, a.a.a, a.b.a));
        }
        return Dc("Can't decode webhook params with kind " + r + " and url " + A2(ju, "", e));
    }, A5(uU, F4(function(n, r, t, e) {
        return m(n, d(r, t, e));
    }), A2(mu, "kind", Bi), Oo(A2(mu, "url", Bi)), Oo(A2(mu, "format", rU)), Oo(A2(mu, "target", eU)))), iU = function(n) {
        switch(n){
            case 0:
                return "Json";
            case 1:
                return "SaltoMam";
            case 2:
                return "SaltoContent";
            default:
                return "ADN";
        }
    }, oU = function(n) {
        return gi(iU(n));
    }, cU = function(n) {
        switch(n){
            case 0:
                return "Manager";
            case 1:
                return "Uploader";
            default:
                return "EventSpecified";
        }
    }, sU = function(n) {
        return gi(cU(n));
    }, fU = Po(A4(rc, "params", function(n) {
        return n.oW;
    }, A2(Di, function(n) {
        if (n.$) {
            var r = n.a;
            return $i(T([
                m("kind", gi("Email")),
                m("target", sU(r))
            ]));
        }
        var t = n.a, e = n.b;
        return $i(T([
            m("kind", gi("ApiCall")),
            m("url", gi(t)),
            m("format", oU(e))
        ]));
    }, aU), A4(rc, "activated", function(n) {
        return n.im;
    }, no, A4(rc, "event", function(n) {
        return n.lo;
    }, Jz, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(Kz))))))), lU = oc(fU), mU = function(n) {
        return {
            $: 8,
            a: n
        };
    }, dU = ml(mU({
        $: 0
    })), bU = dc(A2(Ho, lU, So(dU))), pU = A2(Yi, Qz, _b(m(bU, Zz))), vU = m(Wz, pU), $U = F2(function(n, r) {
        return p(r, {
            lm: kt(n.nO),
            rv: Tt
        });
    }), gU = function(n) {
        return {
            $: 12,
            a: n
        };
    }, hU = F2(function(n, r) {
        return r.$ ? wt(r.a) : n(r.a);
    }), kU = F5(function(n, r, t, e, u) {
        return {
            im: t,
            lo: r,
            lR: u,
            oL: n,
            sn: e
        };
    }), TU = Po(A4(rc, "format", function(n) {
        return n.lR;
    }, A2(Il, iU, nU), A4(rc, "url", function(n) {
        return n.sn;
    }, xi, A4(rc, "activated", function(n) {
        return n.im;
    }, no, A4(rc, "event", function(n) {
        return n.lo;
    }, Jz, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, Io(kU))))))), wU = F4(function(n, r, t, e) {
        return {
            im: t,
            lo: r,
            oL: n,
            rL: e
        };
    }), CU = Po(A4(rc, "target", function(n) {
        return n.rL;
    }, A2(Il, cU, tU), A4(rc, "activated", function(n) {
        return n.im;
    }, no, A4(rc, "event", function(n) {
        return n.lo;
    }, Jz, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, Io(wU)))))), NU = ml(mU({
        $: 1
    })), AU = ml(mU({
        $: 3
    })), SU = function(n) {
        var r, t;
        return A2(Yi, gU, (t = Yz((r = n).lo.ss), A2(OC, function(n) {
            return dc(A2(ng, fU, n));
        }, ML(A2(hi, function(n) {
            return IL(A2(ki, n, f$));
        }, A2(hU, function(n) {
            return function(n) {
                switch(r.c$.ss){
                    case "api":
                        return A2(X$, function(t) {
                            return A3(ag, TU, {
                                im: r.im.ss,
                                lo: n,
                                lR: t,
                                oL: r.oL.ss,
                                sn: r.sn.ss
                            }, rg(NU));
                        }, nU(r.lR.ss));
                    case "email":
                        return A2(X$, function(t) {
                            return A3(ag, CU, {
                                im: r.im.ss,
                                lo: n,
                                oL: r.oL.ss,
                                rL: t
                            }, rg(AU));
                        }, tU(r.rL.ss));
                    default:
                        return wt("Can't parse kind from form");
                }
            }(n);
        }, t))))));
    }, LU = function(n) {
        return {
            $: 15,
            a: n
        };
    }, yU = function(n) {
        return ml(mU(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n)));
    }, FU = function(n) {
        return ml(mU(function(n) {
            return {
                $: 4,
                a: n
            };
        }(n)));
    }, jU = function(n) {
        return {
            $: 13,
            a: n
        };
    }, PU = F2(function(n, r) {
        var t = Yz(r.lo.ss);
        return A2(OC, function(n) {
            return dc(A2(Ho, fU, n));
        }, ML(A2(hi, function(n) {
            return IL(A2(ki, n, f$));
        }, A2(hU, function(t) {
            return function(t) {
                return n.oW.$ ? A2(X$, function(e) {
                    return A3(ag, CU, {
                        im: r.im.ss,
                        lo: t,
                        oL: r.oL.ss,
                        rL: e
                    }, mg(FU(n.mm)));
                }, tU(r.rL.ss)) : A2(X$, function(e) {
                    return A3(ag, TU, {
                        im: r.im.ss,
                        lo: t,
                        lR: e,
                        oL: r.oL.ss,
                        sn: r.sn.ss
                    }, mg(yU(n.mm)));
                }, nU(r.lR.ss));
            }(t);
        }, t))));
    }), IU = F2(function(n, r) {
        return A2(Yi, jU, A2(PU, n, r));
    }), BU = function(n) {
        var r = function(n) {
            return A2(No, Fu(n), ju(""));
        };
        return {
            im: ro(function(r) {
                return p(r, {
                    m6: "Activ\xe9",
                    ss: A2(ju, !0, A2(Fu, function(n) {
                        return n.im;
                    }, n))
                });
            }),
            lo: Ri(function(t) {
                return p(t, {
                    m6: "\xc9v\xe9nement",
                    ss: A2(r, function(n) {
                        return Xz(n.lo);
                    }, n)
                });
            }),
            lR: Ri(function(t) {
                return p(t, {
                    m6: "Format",
                    ss: A2(r, function(n) {
                        var r = n.oW;
                        return r.$ ? "" : iU(r.b);
                    }, n)
                });
            }),
            c$: Ri(function(t) {
                return p(t, {
                    m6: "Type",
                    ss: A2(r, function(n) {
                        return n.oW.$ ? "email" : "api";
                    }, n)
                });
            }),
            oL: Ri(function(t) {
                return p(t, {
                    m6: "Organization",
                    ss: A2(r, function(n) {
                        return n.oL;
                    }, n)
                });
            }),
            oR: n,
            rL: Ri(function(t) {
                return p(t, {
                    m6: "Cible",
                    ss: A2(r, function(n) {
                        var r = n.oW;
                        return r.$ ? cU(r.a) : "";
                    }, n)
                });
            }),
            sn: Ri(function(t) {
                return p(t, {
                    m6: "Url",
                    ss: A2(r, function(n) {
                        var r = n.oW;
                        return r.$ ? "" : r.a;
                    }, n)
                });
            })
        };
    }, MU = F2(function(n, r) {
        switch(n.$){
            case 2:
                return A2(pc, g, p(r, {
                    kN: kt(BU(kt(n.a)))
                }));
            case 1:
                return A2(pc, g, p(r, {
                    kN: kt(BU(Tt))
                }));
            case 3:
                return A2(pc, g, p(r, {
                    kN: Tt,
                    lm: Tt,
                    rv: Tt
                }));
            case 4:
                var t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        oL: A2(gg, t, n.oL)
                    });
                }, r.kN);
                return A2(pc, g, p(r, {
                    kN: e
                }));
            case 5:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lo: A2(gg, t, n.lo)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 6:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        im: A2(vg, t, n.im)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 7:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        c$: A2(gg, t, n.c$)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 8:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        sn: A2(gg, t, n.sn)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 9:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        lR: A2(gg, t, n.lR)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 10:
                return t = n.a, e = A2(Fu, function(n) {
                    return p(n, {
                        rL: A2(gg, t, n.rL)
                    });
                }, r.kN), A2(pc, g, p(r, {
                    kN: e
                }));
            case 11:
                var u = r.kN;
                return A2(pc, T(1 === u.$ ? [
                    n$
                ] : 1 === (c = (e = u.a).oR).$ ? [
                    SU(e)
                ] : [
                    A2(IU, c.a, e)
                ]), r);
            case 14:
                return A2(pc, T([
                    (o = n.a, A2(Yi, LU, function(n) {
                        var r = n.oW.$ ? FU : yU;
                        return A2(Gb, Ml(n), dc(fg(sg(r(n.mm)))));
                    }(o)))
                ]), r);
            case 12:
                return (a = n.a).$ ? A2(pc, g, A2($U, a.a, r)) : A2(pc, T([
                    pU
                ]), p(r, {
                    lm: Tt,
                    rv: kt("webhook created")
                }));
            case 13:
                return (a = n.a).$ ? A2(pc, g, A2($U, a.a, r)) : A2(pc, T([
                    pU
                ]), p(r, {
                    lm: Tt,
                    rv: kt("webhook updated")
                }));
            case 15:
                return (a = n.a).$ ? A2(pc, g, A2($U, a.a, r)) : A2(pc, T([
                    pU
                ]), r);
            case 0:
                var a;
                if ((a = n.a).$) return A2(pc, g, A2($U, a.a, r));
                var i = a.a;
                return A2(pc, g, p(r, {
                    oP: i.b,
                    dQ: i.a
                }));
            default:
                return A2(pc, g, p(r, {
                    rJ: n.a
                }));
        }
        var o, c;
    }), OU = {
        $: 1
    }, qU = function(n) {
        return {
            $: 16,
            a: n
        };
    }, DU = F2(function(n, r) {
        return A2(Vg, g, T([
            n(r)
        ]));
    }), xU = F2(function(n, r) {
        return _g({
            n5: n,
            ds: rh,
            dM: DU(r)
        });
    }), RU = F2(function(n, r) {
        var t;
        return ch({
            n5: n,
            ds: Eg((t = r, A2(bu, Hi, t))),
            dM: r
        });
    }), VU = T([
        Rg("Table")
    ]), EU = function() {
        return T([
            Rg("TableTr")
        ]);
    }, zU = function(n) {
        var r = n.oW;
        return r.$ ? "" : iU(r.b);
    }, UU = F2(function(n, r) {
        return A2(ju, "", A2(Fu, function(n) {
            return n.n5;
        }, Va(A2(Iu, function(n) {
            return i(n.mm, r.oL);
        }, n))));
    }), HU = function(n) {
        var r = n.oW;
        return r.$ ? cU(r.a) : "";
    }, WU = function(n) {
        return n.oW.$ ? "Email" : "ApiCall";
    }, QU = function(n) {
        var r = n.oW;
        return r.$ ? "" : r.a;
    }, ZU = {
        $: 3
    }, KU = function(n) {
        return {
            $: 6,
            a: n
        };
    }, YU = function(n) {
        return {
            $: 5,
            a: n
        };
    }, XU = function(n) {
        return {
            $: 9,
            a: n
        };
    }, JU = function(n) {
        return {
            $: 7,
            a: n
        };
    }, GU = function(n) {
        return {
            $: 4,
            a: n
        };
    }, _U = function(n) {
        return {
            $: 10,
            a: n
        };
    }, nH = function(n) {
        return {
            $: 8,
            a: n
        };
    }, rH = {
        $: 11
    }, tH = function(n) {
        return 1 !== n.oR.$;
    }, eH = function(n) {
        return A2(wT, function(r) {
            var t = T([
                m("", ""),
                m(Xz(0), Xz(0)),
                m(Xz(1), Xz(1)),
                m(Xz(2), Xz(2)),
                m(Xz(3), Xz(3)),
                m(Xz(4), Xz(4)),
                m(Xz(5), Xz(5)),
                m(Xz(6), Xz(6)),
                m(Xz(7), Xz(7)),
                m(Xz(8), Xz(8)),
                m(Xz(9), Xz(9)),
                m(Xz(10), Xz(10)),
                m(Xz(11), Xz(11)),
                m(Xz(12), Xz(12))
            ]), e = A2(dt, m("", ""), A2(Ge, function(n) {
                return m(n.mm, n.n5);
            }, n.oP)), u = T([
                m("", ""),
                m("api", "Call Api"),
                m("email", "Email")
            ]), a = r.c$, i = T([
                m("", ""),
                m(cU(0), cU(0)),
                m(cU(1), cU(1)),
                m(cU(2), cU(2))
            ]), o = T([
                m("", ""),
                m(iU(0), iU(0)),
                m(iU(1), iU(1)),
                m(iU(2), iU(2)),
                m(iU(3), iU(3))
            ]), c = function() {
                switch(r.c$.ss){
                    case "api":
                        return T([
                            A2(dk, nH, IT(r.sn)),
                            A2(dk, XU, A2(ET, r.lR, o))
                        ]);
                    case "email":
                        return T([
                            A2(dk, _U, A2(ET, r.rL, i))
                        ]);
                    default:
                        return g;
                }
            }(), s = tH(r) ? m("Save", "Edit Webhook") : m("Create", "New Webhook");
            return A4(ZT, s.b, m(s.a, rH), m("Cancel", ZU), $(T([
                A2(dk, GU, A2(wC, e, ET(r.oL))),
                A2(dk, YU, A2(ET, r.lo, t)),
                A2(dk, KU, PT(r.im)),
                A2(dk, JU, A2(ET, p(a, {
                    kQ: tH(r)
                }), u))
            ]), c));
        }, n.kN);
    }, uH = F2(function(n, r) {
        var t;
        return A3(hw, "Organizations", kt(A2(Nh, "New\u2026", OU)), A2(Le, g, T([
            eH(r),
            A3(cT, (t = r.oP, uh({
                jY: T([
                    A2(xU, "Edit", function(n) {
                        return A2(Nh, "Edit", function(n) {
                            return {
                                $: 2,
                                a: n
                            };
                        }(n));
                    }),
                    A2(RU, "Organization", UU(t)),
                    A2(RU, "Event", A2(bu, Xz, function(n) {
                        return n.lo;
                    })),
                    A2(xU, "Icon", function(n) {
                        return n.im ? Gg : Jg;
                    }),
                    A2(RU, "Type", WU),
                    A2(RU, "Url", QU),
                    A2(RU, "Format", zU),
                    A2(RU, "Target", HU),
                    A2(xU, "Delete", function(n) {
                        return A2(Og, Th, function(n) {
                            return {
                                $: 14,
                                a: n
                            };
                        }(n));
                    })
                ]),
                kt: p(kh, {
                    pR: EU,
                    rA: VU,
                    rM: T([
                        Rg("TableTd")
                    ])
                }),
                rV: function(n) {
                    return n.mm;
                },
                rW: qU
            })), r.rJ, r.dQ)
        ])));
    }), aH = {
        l: function(n) {
            return n.dQ;
        },
        m: vU,
        o: F2(function(n, r) {
            return p(n, {
                dQ: r
            });
        }),
        p: function(n) {
            return {
                $: 10,
                a: n
            };
        },
        q: MU,
        r: uH
    }, iH = F3(function(n, r, t) {
        var e = A4(tD, kc, t.oV, n, r), u = A4(eD, kc, t.oV, n, r), a = function() {
            switch(r.$){
                case 0:
                    return u(Sj);
                case 1:
                    return u(HO);
                case 2:
                    return u(vB);
                case 3:
                    return u(Hz);
                case 4:
                    return u(vE);
                case 5:
                    return u(pR);
                case 6:
                    return u(Tw);
                case 7:
                    return u(AC);
                case 8:
                    return u(rD);
                case 9:
                    return u(aH);
                case 10:
                    return u(qB);
                case 11:
                    return u(fj);
                case 12:
                    return u(Xx);
                case 13:
                    return u(mx);
                case 14:
                    return A2(e, iP, (n = r.a, bc(T([
                        A2(ju, A2(Gv, Ml(oP), oN(0)), A2(Fu, function(n) {
                            return dP(n);
                        }, n.oL)),
                        bP(n)
                    ]))));
                case 15:
                    return u(TI);
                case 16:
                    return u(_A);
                case 17:
                    return u(Fq);
                default:
                    return A2(e, WN, sN(r.a));
            }
            var n;
        }(), i = a.a;
        return A2(pc, T([
            A2(cp, Ie, a.b)
        ]), p(t, {
            oV: i
        }));
    }), oH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cH = F2(function(n, r) {
        return {
            eh: r,
            rS: n
        };
    }), sH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mH = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dH = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bH = function(n) {
        return {
            $: 5,
            a: n
        };
    }, pH = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vH = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $H = function(n) {
        return {
            $: 8,
            a: n
        };
    }, gH = F3(function(n, r, t) {
        return {
            m6: t,
            hk: r,
            cj: n
        };
    }), hH = F3(function(n, r, t) {
        return {
            eZ: r,
            hj: t,
            hp: n
        };
    }), kH = Fe(ce), TH = {
        $: 0
    }, wH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, CH = {
        $: 1
    }, NH = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), AH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, SH = F5(function(n, r, t, e, u) {
        return {
            mm: n,
            fQ: u,
            ha: t,
            rK: e,
            h4: r
        };
    }), LH = function(n) {
        return {
            $: 5,
            c: n
        };
    }, yH = F3(function(n, r, t) {
        return A2(Ce, function(e) {
            var u = A2(di, n, e);
            if (u.$) return je(t);
            var a = u.a, i = A2(di, Mo(T([
                r,
                LH(t)
            ])), a);
            return i.$ ? Dc(Xt(i.a)) : je(i.a);
        }, Pi);
    }), FH = F4(function(n, r, t, e) {
        return A2(kH, A3(yH, A2(mu, n, Pi), r, t), e);
    }), jH = F3(function(n, r, t) {
        return A2(kH, A2(mu, n, r), t);
    }), PH = A3(jH, "type", Bi, A3(jH, "tags", ac(Bi), A3(jH, "slug", Bi, A4(FH, "uid", Oo(Bi), Tt, A3(jH, "id", Bi, je(SH)))))), IH = F3(function(n, r, t) {
        return A2(kH, A2(Jh, n, r), t);
    }), BH = A2(Ce, function(n) {
        switch(n){
            case "Document":
                return A3(IH, T([
                    "isBroken"
                ]), Ne, A3(IH, g, PH, je(NH)));
            case "Web":
                return A3(IH, T([
                    "url"
                ]), Bi, je(AH));
            default:
                return Dc("Unknown link type: " + n);
        }
    }, A2(mu, "link_type", Bi)), MH = A2(kH, A2(Ce, function(n) {
        switch(n){
            case "em":
                return je(TH);
            case "strong":
                return je(CH);
            case "hyperlink":
                return A2(ye, wH, A2(mu, "data", BH));
            default:
                return Dc("Unknown span type: " + n);
        }
    }, A2(mu, "type", Bi)), A3(jH, "end", tc, A3(jH, "start", tc, je(hH)))), OH = A4(FH, "label", Oo(Bi), Tt, A3(jH, "spans", ac(MH), A3(jH, "text", Bi, je(gH)))), qH = F4(function(n, r, t, e) {
        return {
            iH: n,
            kb: r,
            kO: e,
            sn: t
        };
    }), DH = function(n) {
        return Mo(T([
            LH(Tt),
            A2(ye, kt, n)
        ]));
    }, xH = A3(jH, "dimensions", A3(jH, "height", tc, A3(jH, "width", tc, je(F2(function(n, r) {
        return {
            fk: r,
            id: n
        };
    })))), A3(jH, "url", Bi, A3(jH, "copyright", DH(Bi), A3(jH, "alt", DH(Bi), je(qH))))), RH = A2(ye, Ie, ac(A2(Ce, function(n) {
        switch(n){
            case "heading1":
                return A2(ye, sH, OH);
            case "heading2":
                return A2(ye, fH, OH);
            case "heading3":
                return A2(ye, lH, OH);
            case "heading4":
                return A2(ye, mH, OH);
            case "heading5":
                return A2(ye, dH, OH);
            case "heading6":
                return A2(ye, bH, OH);
            case "paragraph":
                return A2(ye, vH, OH);
            case "list-item":
                return A2(ye, pH, OH);
            case "image":
                return A2(ye, $H, xH);
            default:
                return Dc("Unknown structured field type: " + n);
        }
    }, A2(mu, "type", Bi)))), VH = A2(mu, "results", A2(xc, 0, A2(mu, "data", A3(Fe, cH, A2(mu, "title", A2(xc, 0, A2(mu, "text", Bi))), A2(mu, "body", RH))))), EH = F5(function(n, r, t, e, u) {
        return "" === n ? n$ : ms({
            cN: A2(qc, u, e),
            sn: ds + "/documents/search?ref=" + n + "&q=%5B%5Bat%28my." + r + ".uid%2C%20%22" + t + "%22%29%5D%5D&lang=*"
        });
    }), zH = F5(function(n, r, t, e, u) {
        if ("" === n) return n$;
        var a = Oi({
            bN: "en-GB",
            bT: "fr-FR"
        });
        return ms({
            cN: A2(qc, u, e),
            sn: ds + "/documents/search?ref=" + n + "&q=%5B%5Bat%28my." + r + ".uid%2C%20%22" + t + "%22%29%5D%5D&lang=" + a
        });
    }), UH = F2(function(n, r) {
        return "table" === r ? A5(zH, n, "help", "table", VH, oH) : A5(EH, n, "help", r, VH, oH);
    }), HH = F2(function(n, r) {
        return A2(pc, T([
            A2(UH, r.fX, n)
        ]), p(r, {
            b7: kt(n)
        }));
    }), WH = F3(function(n, r, t) {
        switch(r.$){
            case 1:
                var e = r.b, u = r.c;
                if (i(kt(c = r.a), Nv(t)) && !n) {
                    var a = p(o = t.g6, {
                        iW: e,
                        oW: u
                    });
                    return Cv(A2(pc, g, p(t, {
                        el: A2(e$, c, t.el),
                        g6: a
                    })));
                }
                var o = fl(t.ak);
                return Cv(A2(pc, T([
                    A2(cp, hv(c), _v)
                ]), p(t, {
                    el: A2(e$, c, t.el),
                    g6: p(o, {
                        iW: e,
                        mm: c,
                        oW: u
                    })
                })));
            case 2:
                var c;
                if (e = r.b, i(kt(c = r.a), Nv(t)) && !n) {
                    var s = p(t.ok, {
                        iW: e
                    });
                    return A2(pc, g, p(t, {
                        el: A2(e$, c, t.el),
                        ok: s
                    }));
                }
                var f = Yv(c), l = js;
                return A2(pc, T([
                    A2(cp, gv, f)
                ]), p(t, {
                    el: A2(e$, c, t.el),
                    ok: p(l, {
                        iW: e,
                        mm: c
                    })
                }));
            case 4:
                var d = t.ak, b = A3(iH, t.ak, r.a, t.iw), v = b.a;
                return A2(pc, T([
                    A2(cp, Ci, b.b)
                ]), p(t, {
                    iw: v,
                    ak: p(d, {
                        d1: !1
                    })
                }));
            case 5:
                var $ = A2(HH, r.a, t.l5);
                return v = $.a, A2(pc, T([
                    A2(cp, Ai, $.b)
                ]), p(t, {
                    l5: v
                }));
            case 6:
                return m(v = p(t, {
                    ak: p(d = t.ak, {
                        d1: !0
                    })
                }), n$);
            case 0:
                return m(v = p(t, {
                    ak: p(d = t.ak, {
                        d1: !1
                    })
                }), n$);
            default:
                return A2(pc, g, t);
        }
    }), QH = F2(function(n, r) {
        var t = $v(n.sn), e = A3(wc, n, r, t), u = Sb.a, a = Sb.b, i = A2(hc, r, n.sv), o = i.a, c = i.b, s = bs.a, f = bs.b, l = Tc.b, m = {
            iw: Tc.a,
            el: Sc(e),
            ak: e,
            k_: Ps,
            lm: Tt,
            l5: s,
            mU: !0,
            ok: js,
            b9: Wi(e.sp),
            qa: Lc,
            dp: o,
            g6: fl(e),
            rR: u,
            sg: jc(e.sp)
        }, d = A3(WH, !0, t, m), b = d.a;
        return A2(pc, T([
            A2(cp, Li, d.b),
            A2(cp, A2(bu, Li, yi), c),
            A2(cp, A2(bu, Li, Fi), a),
            A2(cp, A2(bu, Li, Ci), l),
            A2(cp, A2(bu, Li, Ai), f),
            A2(cp, A2(bu, Li, Ni), op)
        ]), Si(b));
    }), ZH = function(n) {
        return {
            $: 1,
            a: n
        };
    }, KH = function(n) {
        return {
            $: 3,
            a: n
        };
    }, YH = function(n) {
        return {
            $: 0,
            a: n
        };
    }, XH = function(n) {
        return {
            $: 2,
            a: n
        };
    }, JH = {
        $: 0
    }, GH = {
        k8: Ri(function(n) {
            return p(n, {
                m6: "Email"
            });
        }),
        nO: JH
    }, _H = Oi({
        bN: "Confirm your password",
        bT: "Confirmez votre mot de passe"
    }), nW = Oi({
        bN: "Last & First Name",
        bT: "Nom & Pr\xe9nom"
    }), rW = Oi({
        bN: "Create your password",
        bT: "Cr\xe9ez votre mot de passe"
    }), tW = {
        $: 0
    }, eW = Oi({
        bN: "Email",
        bT: "Email"
    }), uW = Oi({
        bN: "Password",
        bT: "Mot de passe"
    }), aW = function(n) {
        var r = n.lX;
        return {
            k8: Ri(function(n) {
                return p(n, {
                    m6: eW
                });
            }),
            lX: r,
            nO: tW,
            oZ: Ri(function(n) {
                return p(n, {
                    kV: "inputLoginPassword",
                    m6: uW
                });
            }),
            q$: 0,
            q0: Tt
        };
    }, iW = {
        $: 0
    }, oW = Oi({
        bN: "Password confirmation",
        bT: "Confirmation du mot de passe"
    }), cW = Oi({
        bN: "Password",
        bT: "Mot de passe"
    }), sW = function(n) {
        var r = $v(n), t = function() {
            if (3 !== r.$) return YH(aW({
                lX: Tt
            }));
            switch(r.a.$){
                case 1:
                    return ZH(GH);
                case 2:
                    return XH((e = (t = r.a.a).k8, u = t.rY, {
                        j3: Ri(function(n) {
                            return p(n, {
                                m6: oW
                            });
                        }),
                        k8: e,
                        nO: iW,
                        oZ: Ri(function(n) {
                            return p(n, {
                                m6: cW
                            });
                        }),
                        o_: Tt,
                        rY: u
                    }));
                case 3:
                    return KH((n = r.a.a, {
                        j3: Ri(function(n) {
                            return p(n, {
                                m6: _H
                            });
                        }),
                        k8: n.k8,
                        lm: Tt,
                        n5: Ri(function(n) {
                            return p(n, {
                                m6: nW
                            });
                        }),
                        oZ: Ri(function(n) {
                            return p(n, {
                                m6: rW
                            });
                        }),
                        o_: Tt,
                        pA: n.pA,
                        rY: n.rY
                    }));
                default:
                    return YH(aW(r.a.a));
            }
            var n, t, e, u;
        }();
        return m(r, t);
    }, fW = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mW = Hn, dW = Jn("newurl", Bi), bW = function(n) {
        return {
            $: 15,
            a: n
        };
    }, pW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vW = function(n) {
        return {
            $: 13,
            a: n
        };
    }, $W = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gW = function(n) {
        return {
            $: 9,
            a: n
        };
    }, hW = Un, kW = hW(g), TW = Jn("onKeypressNoInput", tc), wW = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), CW = F2(function(n, r) {
        return {
            gs: r,
            hz: n
        };
    }), NW = Ke(A2(CW, g, Au)), AW = function(n) {
        return m($(n.a ? "w_" : "d_", n.b), n);
    }, SW = F6(function(n, r, t, e, u, a) {
        var i = A3(z$, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, o = a.b;
                if (i.b) {
                    var c = i.a, s = c.a, l = c.b, d = i.b;
                    if (0 > f(s, e)) {
                        a = m(d, A3(n, s, l, o));
                        continue n;
                    }
                    return f(s, e) > 0 ? m(i, A3(t, e, u, o)) : m(d, A4(r, s, l, u, o));
                }
                return m(i, A3(t, e, u, o));
            }
        }), m(pt(e), a), u), o = i.a, c = i.b;
        return A3(qt, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), c, o);
    }), LW = F2(function(n, r) {
        return {
            lo: r,
            m2: n
        };
    }), yW = F3(function(n, r, t) {
        return A2(nu, function(n) {
            return m(r, n);
        }, A3(Jr, t.a ? Xr : Yr, t.b, function(t) {
            return A2(fo, n, A2(LW, r, t));
        }));
    }), FW = F2(function(n, r) {
        return A3(z$, wu, r, n);
    }), jW = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return d(e.a, e.b, A2(dt, A3(yW, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return d(A2(dt, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return d(e.a, A3(wu, n, r, e.b), u);
        }), i = A2(Ge, AW, r), o = A6(SW, u, a, e, t.gs, Jo(i), d(g, Au, g)), c = o.b, s = o.c;
        return A2(_e, function(n) {
            return Ke(A2(CW, i, A2(FW, c, Jo(n))));
        }, A2(_e, function() {
            return tu(s);
        }, tu(A2(Ge, Hc, o.a))));
    }), PW = F3(function(n, r, t) {
        var e = r.m2, u = r.lo, a = A2(Yc, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(Gr, r, u) : Tt;
        }, t.hz);
        return A2(_e, function() {
            return Ke(t);
        }, tu(A2(Ge, eu(n), a)));
    }), IW = F2(function(n, r) {
        return A3(wW, r.a, r.b, A2(ye, n, r.c));
    });
    Dn["Browser.Events"] = xn(NW, jW, PW, 0, IW);
    var BW = zn("Browser.Events"), MW = F3(function(n, r, t) {
        return BW(A3(wW, n, r, t));
    }), OW = F2(function(n, r) {
        return n(r ? 1 : 0);
    }), qW = {
        $: 5
    }, DW = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xW = F2(function(n, r) {
        return {
            gz: r,
            hK: n
        };
    }), RW = Ke(A2(xW, Au, Au)), VW = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(lo, t, r);
        return A3(wu, t, 1 === u.$ ? T([
            e
        ]) : A2(dt, e, u.a), r);
    }), EW = ot, zW = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = Wc(A2(EW, e, A2(fo, n, e)));
            return A2(_e, function(r) {
                return A3(zW, n, u, A3(wu, e, r, t));
            }, a);
        }
        return Ke(t);
    }), UW = F3(function(n, r, t) {
        var e = t.gz, u = F3(function(n, r, t) {
            var e = t.c;
            return d(t.a, t.b, A2(_e, function() {
                return e;
            }, Hc(r)));
        }), a = A3(qt, VW, Au, r), i = A6(SW, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return d(A2(dt, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return d(e.a, A3(wu, n, t, e.b), u);
        }), u, a, e, d(g, Au, Ke(0))), o = i.a, c = i.b;
        return A2(_e, function(n) {
            return Ke(A2(xW, a, n));
        }, A2(_e, function() {
            return A3(zW, n, o, c);
        }, i.c));
    }), HW = F3(function(n, r, t) {
        var e = A2(lo, r, t.hK);
        if (1 === e.$) return Ke(t);
        var u = e.a, a = function(r) {
            return tu(A2(Ge, function(t) {
                return A2(eu, n, t(r));
            }, u));
        };
        return A2(_e, function() {
            return Ke(t);
        }, A2(_e, a, Jv));
    }), WW = F2(function(n, r) {
        return A2(DW, r.a, A2(bu, n, r.b));
    });
    Dn.Time = xn(RW, UW, HW, 0, WW);
    var QW, ZW, KW, YW, XW, JW, GW, _W, nQ, rQ, tQ = zn("Time"), eQ = F2(function(n, r) {
        return tQ(A2(DW, n, r));
    }), uQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, aQ = function(n) {
        return 1 === n.dE.$ ? kW : A2(eQ, 1e3, uQ);
    }, iQ = function(n) {
        return hW(T([
            A2(eQ, 5e3, Ml(qW)),
            A2(mW, PV, aQ(n.iA))
        ]));
    }, oQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, sQ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, fQ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mQ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, dQ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, bQ = {
        $: 11
    }, pQ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, vQ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $Q = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gQ = function(n) {
        return {
            $: 9,
            a: n
        };
    }, hQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, TQ = A2(jH, "fileId", Bi), wQ = TQ(je(function(n) {
        return {
            z: n
        };
    })), CQ = F4(function(n, r, t, e) {
        return {
            j0: e,
            z: n,
            gV: t,
            hu: r
        };
    }), NQ = F7(function(n, r, t, e, u, a, i) {
        return {
            lE: i,
            nk: t,
            py: r,
            pB: u,
            aV: a,
            qZ: n,
            r_: e
        };
    }), AQ = A3(jH, "fileSize", tc, A3(jH, "secondsLeft", DH(tc), A3(jH, "remainingSize", tc, A3(jH, "totalUploaded", tc, A3(jH, "loaded", tc, A3(jH, "readableSpeed", Bi, A3(jH, "speed", fS, je(NQ)))))))), SQ = A3(jH, "completedAt", qm, A3(jH, "s3Key", Bi, A3(jH, "stats", AQ, TQ(je(CQ))))), LQ = F2(function(n, r) {
        return {
            lm: r,
            z: n
        };
    }), yQ = A3(jH, "error", Bi, TQ(je(LQ))), FQ = F2(function(n, r) {
        return {
            z: n,
            gV: r
        };
    }), jQ = A3(jH, "s3Key", Bi, TQ(je(FQ))), PQ = F2(function(n, r) {
        return {
            d4: r,
            z: n
        };
    }), IQ = A3(jH, "at", qm, TQ(je(PQ))), BQ = TQ(je(function(n) {
        return {
            z: n
        };
    })), MQ = F4(function(n, r, t, e) {
        return {
            d4: e,
            z: n,
            pj: t,
            hu: r
        };
    }), OQ = A3(jH, "at", qm, A3(jH, "progress", fS, A3(jH, "stats", AQ, TQ(je(MQ))))), qQ = TQ(je(function(n) {
        return {
            z: n
        };
    })), DQ = TQ(je(function(n) {
        return {
            z: n
        };
    })), xQ = A3(jH, "error", DH(Bi), A3(jH, "completedAt", DH(qm), A3(jH, "secondsLeft", DH(tc), A3(jH, "blob", Pi, A3(jH, "mimeType", DH(Bi), A3(jH, "size", tc, A3(jH, "pausedAt", DH(qm), A3(jH, "pausing", Ne, A3(jH, "progressedAt", qm, A3(jH, "progress", fS, A3(jH, "name", Bi, A3(jH, "s3Id", DH(Bi), A3(jH, "fileId", Bi, A3(jH, "id", Bi, je(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return {
                                                                jf: f,
                                                                j0: m,
                                                                lm: d,
                                                                z: r,
                                                                mm: n,
                                                                nS: s,
                                                                n5: e,
                                                                df: o,
                                                                dg: i,
                                                                pj: u,
                                                                gG: a,
                                                                pY: t,
                                                                aV: l,
                                                                qO: c
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), RQ = F2(function(n, r) {
        return {
            z: n,
            pZ: r
        };
    }), VQ = A3(jH, "s3UploadId", Bi, TQ(je(RQ))), EQ = Jn("uploadToElm", A2(Ce, function(n) {
        return A2(Ce, function(r) {
            return je({
                lo: r,
                n5: n
            });
        }, A2(mu, "event", Pi));
    }, A2(mu, "name", Bi))), zQ = A2(mW, function(n) {
        var r = n.n5, t = n.lo, e = function() {
            switch(r){
                case "Created":
                    return A2(ye, lQ, xQ);
                case "Started":
                    return A2(ye, hQ, DQ);
                case "Progress":
                    return A2(ye, $Q, OQ);
                case "UploadInitiated":
                    return A2(ye, kQ, VQ);
                case "Completed":
                    return A2(ye, fQ, SQ);
                case "Error":
                    return A2(ye, mQ, yQ);
                case "Cancelled":
                    return A2(ye, sQ, wQ);
                case "Pausing":
                    return A2(ye, vQ, BQ);
                case "Paused":
                    return A2(ye, pQ, IQ);
                case "Resumed":
                    return A2(ye, gQ, qQ);
                case "NameChanged":
                    return A2(ye, dQ, jQ);
                default:
                    return Dc("not an Event");
            }
        }(), u = A2(di, e, t);
        return u.$ ? bQ : u.a;
    }, EQ(Ie)), UQ = {
        $: 6
    }, HQ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, WQ = A2(MW, 0, "mousemove"), QQ = A2(MW, 0, "mouseup"), ZQ = F2(function(n, r) {
        return {
            sK: n,
            sP: r
        };
    }), KQ = A3(Fe, ZQ, A2(mu, "pageX", tc), A2(mu, "pageY", tc)), YQ = function(n) {
        return 1 === n.kY.$ ? kW : hW(T([
            WQ(A2(ye, HQ, KQ)),
            QQ(je(UQ))
        ]));
    }, XQ = function() {
        return kW;
    }, JQ = function(n) {
        return {
            $: 27,
            a: n
        };
    }, GQ = function(n) {
        return {
            $: 38,
            a: n
        };
    }, _Q = function(n) {
        return {
            $: 11,
            a: n
        };
    }, nZ = function(n) {
        return {
            $: 39,
            a: n
        };
    }, rZ = function(n) {
        return {
            $: 11,
            a: n
        };
    }, tZ = Jn("jsToElm", Pi), eZ = function(n) {
        return {
            $: 12,
            a: n
        };
    }, uZ = function(n) {
        return {
            $: 13,
            a: n
        };
    }, aZ = Jn("content", ac(A2(Ce, function(n) {
        return A2(Ce, function(r) {
            return A2(Ce, function(t) {
                return A2(Ce, function(e) {
                    return je({
                        ft: e,
                        nc: t,
                        r5: r,
                        sv: n
                    });
                }, A2(mu, "index", tc));
            }, A2(mu, "layout", Bi));
        }, A2(mu, "typeVersion", Bi));
    }, A2(mu, "version", Mo(T([
        LH(Tt),
        A2(ye, kt, Bi)
    ])))))), iZ = Jn("lastAudioQualification", A2(Ce, function(n) {
        return A2(Ce, function(r) {
            return A2(Ce, function(t) {
                return je({
                    cz: t,
                    z: r,
                    bl: n
                });
            }, A2(mu, "channels", ac(tc)));
        }, A2(mu, "fileId", Bi));
    }, A2(mu, "result", ac(A2(Ce, function(n) {
        return A2(Ce, function(r) {
            return A2(Ce, function(t) {
                return A2(Ce, function(e) {
                    return je({
                        ft: e,
                        nc: t,
                        r5: r,
                        sv: n
                    });
                }, A2(mu, "index", tc));
            }, A2(mu, "layout", Bi));
        }, A2(mu, "typeVersion", Bi));
    }, A2(mu, "version", Mo(T([
        LH(Tt),
        A2(ye, kt, Bi)
    ])))))))), oZ = function(n) {
        return {
            $: 28,
            a: n
        };
    }, cZ = Jn("sendPlayerName", Bi), sZ = Jn("updateAudioStreams", ac(A2(Ce, function(n) {
        return A2(Ce, function(r) {
            return je(m(n, r));
        }, A2(xc, 1, Mo(T([
            LH(Tt),
            A2(ye, kt, Bi)
        ]))));
    }, A2(xc, 0, tc)))), fZ = F2(function(n, r) {
        return hW(T([
            A2(mW, JQ, hW(T([
                iZ(eZ),
                aZ(uZ)
            ]))),
            A2(mW, _Q, hW(T([
                cZ(oZ)
            ]))),
            sZ(GQ),
            A2(du, function(n) {
                return i(n.j0, Tt);
            }, r._) || n.nj ? A2(eQ, 5e3, Ml(Xv)) : kW,
            A2(mW, nZ, tZ(rZ))
        ]));
    }), lZ = Jn("viewport", A2(Ce, function(n) {
        return A2(Ce, function(r) {
            return A2(Ce, function(t) {
                return je({
                    fk: t,
                    mP: r,
                    id: n
                });
            }, A2(mu, "height", tc));
        }, A2(mu, "isFullscreen", Ne));
    }, A2(mu, "width", tc))), mZ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vZ = {
        $: 1
    }, $Z = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gZ = function(n) {
        return p(n, {
            ln: g
        });
    }, hZ = F3(function(n, r, t) {
        return n(t) ? kt(r) : Tt;
    }), kZ = st, TZ = (QW = A2(ju, Qh, Wh("^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$")), kZ(QW)), wZ = A2(hZ, A2(bu, pu, TZ), "Cet email n'est pas valide"), CZ = F3(function(n, r, t) {
        return p(t, {
            lA: A3(ko, n, function(n) {
                return kt(1 === n.$ ? r : A2(Lu, n.a, r));
            }, t.lA)
        });
    }), NZ = {
        lA: Au,
        Y: Tt
    }, AZ = A2(hZ, function(n) {
        return "" === n;
    }, "Ce champ est obligatoire"), SZ = F3(function(n, r, t) {
        return n(t) ? r(t) : Tt;
    }), LZ = A3(CZ, "email", T([
        A2(No, function(n) {
            return n.k8;
        }, AZ),
        A2(No, function(n) {
            return n.k8;
        }, A2(SZ, function(n) {
            return "" !== n;
        }, wZ))
    ]), NZ), yZ = F2(function(n, r) {
        return kt(1 === r.$ ? T([
            n
        ]) : A2(dt, n, r.a));
    }), FZ = F3(function(n, r, t) {
        return p(t, {
            lA: A3(ko, n, yZ(r), t.lA)
        });
    }), jZ = F2(function(n, r) {
        var t = vi;
        return A3(z$, F3(function(n, e, u) {
            return A3(qt, F2(function(e, u) {
                var a = e(r);
                return 1 === a.$ ? u : wt(A3(FZ, n, a.a, u.$ ? u.a : t));
            }), u, e);
        }), function() {
            var e = n.Y;
            if (1 === e.$) return St(r);
            var u = (0, e.a)(r);
            return 1 === u.$ ? St(r) : wt(A2(ki, u.a, t));
        }(), n.lA);
    }), PZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, IZ = F3(function(n, r, t) {
        return p(n, {
            ln: A2(ju, g, A2(lo, r, t.lA))
        });
    }), BZ = F2(function(n, r) {
        return p(n, {
            k8: A3(IZ, n.k8, "email", r),
            nO: "" === r.nO ? JH : PZ(r.nO)
        });
    }), MZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, p(r, {
                    k8: A2(gg, n.a, r.k8)
                }));
            case 1:
                var t = {
                    k8: r.k8.ss
                }, e = A2(jZ, LZ, t);
                return 1 === e.$ ? A2(pc, g, A2(BZ, r, IL(e.a))) : A2(pc, T([
                    A2(Yi, $Z, FE(t))
                ]), p(r, {
                    nO: JH
                }));
            default:
                var u = n.a;
                if (u.$) return A2(pc, g, A2(BZ, r, u.a));
                var a = function(n) {
                    return p(n, {
                        k8: gZ(n.k8),
                        nO: JH
                    });
                }(r);
                return A2(pc, g, p(a, {
                    nO: vZ
                }));
        }
    }), OZ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, qZ = ml(jC({
        $: 6
    })), DZ = F5(function(n, r, t, e, u) {
        return {
            j4: u,
            k8: n,
            n5: t,
            oZ: e,
            rY: r
        };
    }), xZ = Po(A4(rc, "confirmation", function(n) {
        return n.j4;
    }, xi, A4(rc, "password", function(n) {
        return n.oZ;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "token", function(n) {
        return n.rY;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, Io(DZ))))))), RZ = Uo(Ml(St(0))), VZ = F2(function(n, r) {
        return p(n, {
            j3: A3(IZ, n.j3, "confirm", r),
            lm: kt(r.nO),
            n5: A3(IZ, n.n5, "name", r),
            oZ: A3(IZ, n.oZ, "password", r)
        });
    }), EZ = F2(function(n, r) {
        var t = r.a, e = qe(t) > 0 || qe(n.ss) > 0 ? i(t, n.ss) ? " : OK" : " : KO" : "";
        return p(n, {
            m6: $(_H, e)
        });
    }), zZ = function(n) {
        return A2(No, kZ(A2(ju, Qh, Wh(n))), pu);
    }, UZ = F2(function(n, r) {
        return 9 > qe(n) ? kt(1) : A2(zZ, "[a-z]", n) ? kt(2) : A2(zZ, "[A-Z]", n) ? kt(3) : A2(zZ, "[0-9]", n) ? kt(4) : A2(zZ, "[^A-Za-z0-9]", n) ? kt(5) : i(n, r) || "" === r ? Tt : kt(0);
    }), HZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, r);
            case 1:
                return A2(pc, g, p(r, {
                    n5: A2(gg, e = n.a, r.n5)
                }));
            case 2:
                var t = p(r, {
                    j3: A2(EZ, r.j3, e = n.a),
                    oZ: A2(gg, e, r.oZ)
                });
                return A2(pc, g, p(t, {
                    o_: A2(UZ, t.oZ.ss, t.j3.ss)
                }));
            case 3:
                var e;
                return A2(pc, g, p(r, {
                    j3: A2(gg, e = n.a, A2(EZ, r.oZ, e))
                }));
            case 4:
                var u = {
                    j4: r.j3.ss,
                    k8: r.k8,
                    n5: r.n5.ss,
                    oZ: r.oZ.ss,
                    rY: r.rY
                };
                return i(r.o_, Tt) ? A2(pc, T([
                    A2(Yi, OZ, (o = u, dc(RZ(A3(ag, xZ, o, rg(qZ))))))
                ]), r) : A2(pc, g, r);
            default:
                var a = n.a;
                return a.$ ? A2(pc, g, A2(VZ, r, a.a)) : A2(pc, T([
                    ez(r.pA)
                ]), r);
        }
        var o;
    }), WZ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, QZ = {
        $: 3
    }, ZZ = {
        $: 0
    }, KZ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, YZ = Kn("gotoSSO", gi), XZ = function(n) {
        return dc(A2(Ho, xo, So(A2(jo, n.k8.ss, n.lX))));
    }, JZ = F2(function(n, r) {
        return {
            k8: n,
            oZ: r
        };
    }), GZ = Po(A4(rc, "password", function(n) {
        return n.oZ;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, Io(JZ)))), _Z = Lo(Fo({
        $: 0
    })), nK = function(n) {
        return dc(RZ(A3(ag, GZ, n, rg(_Z))));
    }, rK = A3(CZ, "password", T([
        A2(No, function(n) {
            return n.oZ;
        }, AZ)
    ]), A3(CZ, "email", T([
        A2(No, function(n) {
            return n.k8;
        }, AZ),
        A2(No, function(n) {
            return n.k8;
        }, A2(SZ, function(n) {
            return "" !== n;
        }, wZ))
    ]), NZ)), tK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eK = F2(function(n, r) {
        return p(n, {
            k8: A3(IZ, n.k8, "email", r),
            nO: "" === r.nO ? tW : tK(r.nO),
            oZ: A3(IZ, n.oZ, "password", r)
        });
    }), uK = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return A2(pc, g, r);
            case 1:
                return A2(pc, g, p(r, {
                    k8: A2(gg, n.a, r.k8)
                }));
            case 2:
                var t = p(r, {
                    oZ: A2(gg, n.a, r.oZ)
                });
                if (r.q$) return A2(pc, g, t);
                n = QZ, r = t;
                continue n;
            case 3:
                if ("" === r.k8.ss) return A2(pc, g, r);
                if (i(r.q0, kt(r.k8.ss)) && 1 !== r.q$) {
                    var e = {
                        k8: r.k8.ss,
                        oZ: r.oZ.ss
                    }, u = A2(jZ, rK, e);
                    return 1 === u.$ ? A2(pc, g, A2(eK, r, IL(u.a))) : A2(pc, T([
                        A2(Yi, WZ, nK(e))
                    ]), r);
                }
                return A2(pc, T([
                    A2(Yi, KZ, XZ(r))
                ]), p(r, {
                    q$: 1,
                    q0: kt(r.k8.ss)
                }));
            case 5:
                return A2(pc, T([
                    YZ(n.a)
                ]), r);
            case 4:
                var a = r.oZ;
                return A2(pc, g, p(r, {
                    k8: p(r.k8, {
                        ss: ""
                    }),
                    nO: tW,
                    oZ: p(a, {
                        ss: ""
                    }),
                    q$: 0
                }));
            case 6:
                return (o = n.a).$ ? A2(pc, g, A2(eK, r, c = o.a)) : A2(pc, T([
                    function() {
                        var n = r.lX;
                        return ez(1 === n.$ ? "/" : n.a);
                    }()
                ]), p(r, {
                    nO: tW
                }));
            default:
                var o;
                if ((o = n.a).$) {
                    var c = o.a;
                    return A2(pc, g, A2(eK, p(r, {
                        q$: 0
                    }), c));
                }
                var s = o.a.q$;
                return s.$ ? A2(pc, T([
                    A2(Yi, Ml(ZZ), VE("inputLoginPassword"))
                ]), p(r, {
                    nO: tW,
                    q$: 2
                })) : A2(pc, T([
                    YZ(s.a)
                ]), r);
        }
    }), aK = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iK = Lo(Fo({
        $: 4
    })), oK = F4(function(n, r, t, e) {
        return {
            j4: t,
            k8: n,
            oZ: r,
            rY: e
        };
    }), cK = Po(A4(rc, "token", function(n) {
        return n.rY;
    }, xi, A4(rc, "confirmation", function(n) {
        return n.j4;
    }, xi, A4(rc, "password", function(n) {
        return n.oZ;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, Io(oK)))))), sK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, fK = F2(function(n, r) {
        return p(n, {
            j3: A3(IZ, n.j3, "confirm", r),
            nO: "" === r.nO ? iW : sK(r.nO),
            oZ: A3(IZ, n.oZ, "password", r)
        });
    }), lK = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, r);
            case 1:
                var t = p(r, {
                    oZ: A2(gg, n.a, r.oZ)
                });
                return A2(pc, g, p(t, {
                    o_: A2(UZ, t.oZ.ss, t.j3.ss)
                }));
            case 2:
                return t = p(r, {
                    j3: A2(gg, n.a, r.j3)
                }), A2(pc, g, p(t, {
                    o_: A2(UZ, t.oZ.ss, t.j3.ss)
                }));
            case 3:
                var e = {
                    j4: r.j3.ss,
                    k8: r.k8,
                    oZ: r.oZ.ss,
                    rY: r.rY
                };
                return i(r.o_, Tt) ? A2(pc, T([
                    A2(Yi, aK, (u = e, dc(fg(A3(ag, cK, u, rg(iK))))))
                ]), r) : A2(pc, g, r);
            default:
                return n.a.$ ? A2(pc, g, A2(fK, r, n.a.a)) : A2(pc, T([
                    ez("/")
                ]), r);
        }
        var u;
    }), mK = F2(function(n, r) {
        var t = m(r.oU, n);
        n: for(;;)switch(t.b.$){
            case 0:
                if (t.a.$) break n;
                var e = A2(uK, t.b.a, t.a.a), u = e.b;
                return m(p(r, {
                    oU: YH(e.a)
                }), A2(cp, bZ, u));
            case 1:
                if (1 === t.a.$) {
                    var a = A2(MZ, t.b.a, t.a.a);
                    return u = a.b, m(p(r, {
                        oU: ZH(a.a)
                    }), A2(cp, mZ, u));
                }
                break n;
            case 2:
                if (2 === t.a.$) {
                    var i = A2(lK, t.b.a, t.a.a);
                    return u = i.b, m(p(r, {
                        oU: XH(i.a)
                    }), A2(cp, pZ, u));
                }
                break n;
            case 3:
                if (3 === t.a.$) {
                    var o = A2(HZ, t.b.a, t.a.a);
                    return u = o.b, m(p(r, {
                        oU: KH(o.a)
                    }), A2(cp, dZ, u));
                }
                break n;
            default:
                var c = sW(t.b.a);
                return m(p(r, {
                    oU: c.b,
                    sn: c.a
                }), n$);
        }
        return m(r, n$);
    }), dK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bK = function(n) {
        return {
            $: 7,
            a: n
        };
    }, pK = function(n) {
        return {
            $: 10,
            a: n
        };
    }, vK = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $K = F2(function(n, r) {
        return A2(G$, n, _I(r));
    }), gK = F4(function(n, r, t, e) {
        return A2($K, r, e) ? wt(A3(wu, n, t, e)) : St(A3(wu, n, r, e));
    }), hK = function(n) {
        return A2(ju, !1, A2(Fu, function(n) {
            return !n.$;
        }, A2(Fu, function(n) {
            return n.j0;
        }, n.sg)));
    }, kK = function(n) {
        return !i(A2(Fu, function(n) {
            return n.o1;
        }, n.r2), kt(5));
    }, TK = F2(function(n, r) {
        return i(n.di, Tt) ? 1 === r.$ ? 0 : function(n) {
            var r = n.lB, t = n.pl, e = n.kG;
            if (i(r.sg, Tt)) {
                var u = r.su;
                if (1 === u.$) return 1;
                var a = u.a.bl;
                return 1 === a.$ ? 1 : a.a.n7 > 0 ? 2 : i(A2(Fu, kK, t.nv), kt(!0)) || A2(du, function(n) {
                    return 5 !== n.r2.o1;
                }, e) ? 1 : 3;
            }
            return 1;
        }(r.a) : 4;
    }), wK = T([
        ".aac",
        ".ac3",
        ".aif",
        ".aiff",
        ".alac",
        ".amb",
        ".amr",
        ".ape",
        ".aob",
        ".au",
        ".caf",
        ".dts",
        ".flac",
        ".m4a",
        ".mka",
        ".mov",
        ".mp2",
        ".mp3",
        ".mpc",
        ".oga",
        ".ogg",
        ".opus",
        ".ra",
        ".sln",
        ".spx",
        ".tta",
        ".voc",
        ".wav",
        ".wave",
        ".wavpack",
        ".wma",
        ".wv"
    ]), CK = H, NK = F2(function(n, r) {
        return A2(du, function(r) {
            return A2(CK, r, n);
        }, r);
    }), AK = T([
        ".srt",
        ".stl",
        ".sub",
        ".ssa",
        ".ass",
        ".vtt",
        ".scc",
        ".cap",
        ".ttml"
    ]), SK = T([
        ".mxf",
        ".mov",
        ".mpg",
        ".mpeg",
        ".mp4",
        ".mp2",
        ".ts",
        ".m2ts",
        ".gxf",
        ".m2t",
        ".mkv"
    ]), LK = function(n) {
        var r = n.nS;
        n: for(; !r.$;)switch(r.a){
            case "application/mxf":
            case "video/quicktime":
            case "video/mpeg":
            case "video/mp4":
                return 0;
            case "audio/mp3":
            case "audio/wav":
                return 1;
            default:
                break n;
        }
        var t = Hi(n.n5);
        return A2(NK, t, SK) ? 0 : A2(NK, t, AK) ? 2 : A2(NK, t, wK) ? 1 : 3;
    }, yK = F3(function(n, r, t) {
        return A3(qt, F2(function(r, t) {
            switch(LK(r)){
                case 0:
                    var e = A4(gK, r.n5, 0, 3, t);
                    if (e.$) return e.a;
                    var u = e.a;
                    return A2(TK, n.R.bD, n.R.bQ.fY) && A2(ju, !1, A2(Fu, hK, A2(Fu, function(n) {
                        return n.lB;
                    }, n.R.bQ.fY))) ? A3(ko, r.n5, function() {
                        return kt(3);
                    }, u) : u;
                case 1:
                    return A3(wu, r.n5, 1, t);
                case 2:
                    return A3(wu, r.n5, 2, t);
                default:
                    return t;
            }
        }), t, r);
    }), FK = F5(function(n, r, t) {
        if (r.$) return Fc;
        var e = r.a;
        return vK(t.$ || t.a.$ ? e : A3(yK, t.a.a, n, e));
    }), jK = F2(function(n, r) {
        return n.iw || A2(du, function(n) {
            return i(n.oN, r);
        }, n.oP);
    }), PK = F2(function(n, r) {
        return A2(du, function(r) {
            return i(n.mm, r.sp) && r.sg;
        }, r);
    }), IK = F3(function(n, r, t) {
        return A2(jK, n, r) || A2(PK, n, t);
    }), BK = F2(function(n, r) {
        return !(r.sp.iw || 1 === n.g6.c$);
    }), MK = {
        C: g,
        lo: g,
        aa: Tt
    }, OK = F2(function(n, r) {
        return {
            C: r.C,
            lo: r.lo,
            aa: n
        };
    }), qK = function(n) {
        return A2(OK, kt(n), MK);
    }, DK = F3(function(n, r, t) {
        if (n.$ || n.a.$) return qK(t);
        var e, u = n.a.a, a = A2(BK, u, t) ? A2(Iu, function(n) {
            return 2 === LK(n);
        }, r) : r, i = (e = m(n, t.oX)).a.$ ? 1 === e.b.$ ? m($(a, t.bQ), t.oX) : m(a, Fc) : e.b.$ ? m(a, vK(Au)) : m($(a, t.bQ), t.oX), o = i.a, c = A5(FK, a, i.b, n, t.pt, t.so);
        return qK(A3(IK, t.sp, u.oL.mm, A2(Ge, function(n) {
            return n.fz;
        }, u.fB)) ? p(t, {
            bQ: o,
            oX: c
        }) : t);
    }), xK = {
        $: 33
    }, RK = bc(T([
        A2(Gv, Ml(xK), Jv),
        A2(Gv, Ml(Xv), Jv)
    ])), VK = F4(function(n, r, t, e) {
        var u = n(A2(ju, t, e.aa)), a = A2(du, se(2), e.lo) ? p(u, {
            g6: p(u.g6, {
                o4: !0
            })
        }) : u, i = A2(Ge, function(n) {
            switch(n){
                case 0:
                    return A2(cp, Ni, op);
                case 1:
                case 3:
                    return A2(cp, hv(u.g6.mm), _v);
                case 2:
                    return A2(cp, hv(u.g6.mm), RK);
                default:
                    return A2(cp, gv, Yv(u.ok.mm));
            }
        }, e.lo), o = A2(cp, r, bc(e.C));
        return A2(pc, A2(dt, o, i), a);
    }), EK = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(pc, g, p(r, {
                    lm: Tt
                }));
            case 1:
                return A2(pc, g, p(r, {
                    q1: A2(gg, n.a, r.q1)
                }));
            case 2:
                return A2(pc, g, p(r, {
                    lh: A2(gg, n.a, r.lh)
                }));
            default:
                return A2(pc, g, p(r, {
                    oP: A2(yM, n.a, r.oP)
                }));
        }
    }), zK = function(n) {
        return {
            $: 8,
            a: n
        };
    }, UK = function(n) {
        return {
            $: 10,
            a: n
        };
    }, HK = F3(function(n, r, t) {
        return {
            kP: t,
            k8: r,
            n5: n
        };
    }), WK = Po(A4(rc, "disableOrganizationEmails", function(n) {
        return n.kP;
    }, no, A4(Do, "email", function(n) {
        return n.k8;
    }, xi, A4(Do, "name", function(n) {
        return n.n5;
    }, xi, Io(HK))))), QK = function(n) {
        return A2(wo, "PATCH", Ao(n));
    }, ZK = Kn("refresh", function() {
        return pi;
    }), KK = Oi({
        bN: "New name saved",
        bT: "Nouveau nom enregistr\xe9"
    }), YK = Oi({
        bN: "New password saved",
        bT: "Nouveau mot de passe enregistr\xe9"
    }), XK = F3(function(n, r, t) {
        return {
            j4: t,
            oc: r,
            oZ: n
        };
    }), JK = Po(A4(rc, "confirmation", function(n) {
        return n.j4;
    }, xi, A4(rc, "newPassword", function(n) {
        return n.oc;
    }, xi, A4(rc, "password", function(n) {
        return n.oZ;
    }, xi, Io(XK))))), GK = ml(jC({
        $: 4
    })), _K = F2(function(n, r) {
        var t = r.a, e = qe(t) > 0 || qe(n.ss) > 0 ? i(t, n.ss) ? " : OK" : " : KO" : "";
        return p(n, {
            m6: $(Xi, e)
        });
    }), nY = F2(function(n, r) {
        switch(n.$){
            case 7:
                return A2(pc, g, p(r, {
                    lm: Tt,
                    rv: Tt
                }));
            case 0:
                return A2(pc, g, p(r, {
                    n5: A2(gg, e = n.a, r.n5)
                }));
            case 1:
                return A2(pc, g, p(r, {
                    k8: A2(gg, e = n.a, r.k8)
                }));
            case 5:
                return A2(pc, g, p(r, {
                    kP: A2(vg, e = n.a, r.kP)
                }));
            case 2:
                return A2(pc, g, p(r, {
                    oZ: A2(gg, e = n.a, r.oZ)
                }));
            case 3:
                var t = p(r, {
                    od: A2(gg, e = n.a, r.od),
                    oe: A2(_K, r.oe, e)
                });
                return A2(pc, g, p(t, {
                    o_: A2(UZ, t.od.ss, t.oe.ss)
                }));
            case 4:
                var e;
                return t = p(r, {
                    oe: A2(gg, e = n.a, A2(_K, r.od, e))
                }), A2(pc, g, p(t, {
                    o_: A2(UZ, t.od.ss, t.oe.ss)
                }));
            case 6:
                return A2(pc, T([
                    A2(Yi, zK, (o = {
                        kP: r.kP.ss,
                        k8: kt(r.k8.ss),
                        n5: kt(r.n5.ss)
                    }, dc(fg(A3(ag, WK, o, QK(PC))))))
                ]), p(r, {
                    lm: Tt
                }));
            case 8:
                return (a = n.a).$ ? A2(pc, g, p(r, {
                    lm: kt(a.a),
                    rv: Tt
                })) : A2(pc, T([
                    ZK(0)
                ]), p(r, {
                    lm: Tt,
                    rv: kt(KK)
                }));
            case 9:
                var u = i(r.o_, Tt) ? A2(Yi, UK, function(n) {
                    return dc(fg(A3(ag, JK, n, rg(GK))));
                }({
                    j4: r.oe.ss,
                    oc: r.od.ss,
                    oZ: r.oZ.ss
                })) : n$;
                return A2(pc, T([
                    u
                ]), p(r, {
                    lm: Tt
                }));
            case 10:
                var a;
                return A2(pc, g, p(r, (a = n.a).$ ? {
                    lm: kt(a.a),
                    rv: Tt
                } : {
                    lm: Tt,
                    od: Ri(function(n) {
                        return p(n, {
                            m6: $c
                        });
                    }),
                    oe: Ri(function(n) {
                        return p(n, {
                            m6: Xi
                        });
                    }),
                    oZ: Ri(function(n) {
                        return p(n, {
                            m6: gc
                        });
                    }),
                    rv: kt(YK)
                }));
            default:
                return A2(pc, g, p(r, n.a.$ ? {
                    lm: kt(n.a.a)
                } : {
                    mS: kt(!i(n.a.a.q$, Tt))
                }));
        }
        var o;
    }), rY = F3(function(n, r, t) {
        var e, u = function(n) {
            return {
                l: n.l,
                m: n.m,
                o: n.o,
                p: n.p,
                q: n.q
            };
        }(t), a = (e = u.l(n)).$ ? m(Tt, n$) : A2(EL, kt, A2(u.q, r, e.a)), i = a.b;
        return m(A2(u.o, n, a.a), A2(cp, u.p, i));
    }), tY = F2(function(n, r) {
        var t = n, e = rY(r.oV), u = function() {
            switch(t.$){
                case 1:
                    return A2(e, t.a, Sj);
                case 2:
                    return A2(e, t.a, HO);
                case 3:
                    return A2(e, t.a, vB);
                case 4:
                    return A2(e, t.a, Hz);
                case 5:
                    return A2(e, t.a, vE);
                case 6:
                    return A2(e, t.a, pR);
                case 7:
                    return A2(e, t.a, Tw);
                case 8:
                    return A2(e, t.a, AC);
                case 9:
                    return A2(e, t.a, rD);
                case 10:
                    return A2(e, t.a, aH);
                case 11:
                    return A2(e, t.a, qB);
                case 12:
                    return A2(e, t.a, fj);
                case 13:
                    return A2(e, t.a, Xx);
                case 14:
                    return A2(e, t.a, mx);
                case 15:
                    return A2(e, t.a, iP);
                case 16:
                    return A2(e, t.a, TI);
                case 17:
                    return A2(e, t.a, _A);
                case 18:
                    return A2(e, t.a, Fq);
                default:
                    return A2(e, t.a, WN);
            }
        }(), a = u.a;
        return A2(pc, T([
            A2(cp, Ie, u.b)
        ]), p(r, {
            oV: a
        }));
    }), eY = function(n) {
        return {
            $: 4,
            a: n
        };
    }, uY = {
        $: 0
    }, aY = function(n) {
        return {
            $: 7,
            a: n
        };
    }, iY = function(n) {
        return dc(fg(sg(OV(n))));
    }, oY = Po(A4(rc, "error", function(n) {
        return n.lm;
    }, xi, Io(function(n) {
        return {
            lm: n
        };
    }))), cY = F2(function(n, r) {
        return dc(fg(A3(ag, oY, r, QK(ml(Rq(A2(MV, n, 11)))))));
    }), sY = Lo(Fo({
        $: 1
    })), fY = dc(fg(rg(sY))), lY = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), mY = F2(function(n, r) {
        return dc(fg(A3(ag, lY, r, QK(ml(Rq(A2(MV, n, 8)))))));
    }), dY = function(n) {
        return dc(fg(mg(ml(Rq(A2(MV, n, 12))))));
    }, bY = F4(function(n, r, t, e) {
        return {
            ew: r,
            pj: n,
            aV: e,
            qZ: t
        };
    }), pY = Po(A4(Do, "secondsLeft", function(n) {
        return n.aV;
    }, uc, A4(rc, "speed", function(n) {
        return n.qZ;
    }, mS, A4(rc, "completed", function(n) {
        return n.ew;
    }, no, A4(rc, "progress", function(n) {
        return n.pj;
    }, mS, Io(bY)))))), vY = F2(function(n, r) {
        return dc(fg(A3(ag, pY, r, QK(ml(Rq(A2(MV, n, 9)))))));
    }), $Y = Kn("resetPreference", function() {
        return pi;
    }), gY = Po(A4(rc, "s3Id", function(n) {
        return n.pY;
    }, xi, Io(function(n) {
        return {
            pY: n
        };
    }))), hY = F2(function(n, r) {
        return dc(fg(A3(ag, gY, r, QK(ml(Rq(A2(MV, n, 10)))))));
    }), kY = ml(jC({
        $: 5
    })), TY = Po(A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, Io(function(n) {
        return {
            oL: n
        };
    }))), wY = function(n) {
        return dc(fg(A3(ag, TY, {
            oL: n
        }, rg(kY))));
    }, CY = F3(function(n, r, t) {
        return p(t, {
            _: A2(Ge, function(t) {
                return i(t.z, n) ? r(t) : t;
            }, t._)
        });
    }), NY = F2(function(n, r) {
        return p(r, {
            _: A2(Iu, function(r) {
                return !i(r.z, n);
            }, r._)
        });
    }), AY = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, n$);
            case 1:
                return m(p(r, {
                    dN: n.a
                }), n$);
            case 3:
                return m(r, bc(T([
                    A2(Yi, eY, fY),
                    $Y(0)
                ])));
            case 4:
                return m(r, 1 === n.a.$ ? n$ : ez("/"));
            case 2:
                var t = n.a;
                switch(t.$){
                    case 0:
                        return m(p(r, {
                            _: A2(dt, t.a, r._)
                        }), n$);
                    case 1:
                        return m(A3(CY, l = t.a.z, function(n) {
                            return p(n, {
                                df: Tt
                            });
                        }, r), n$);
                    case 2:
                        var e = t.a.pj, u = t.a.d4, a = A2(vY, l = t.a.z, {
                            ew: !1,
                            pj: e,
                            aV: (o = t.a.hu).aV,
                            qZ: o.qZ
                        });
                        return m(A3(CY, l, function(n) {
                            return p(n, {
                                pj: e,
                                gG: u,
                                aV: o.aV
                            });
                        }, r), A2(Yi, Ml(uY), a));
                    case 3:
                        var i = t.a.pZ;
                        return a = A2(hY, l = t.a.z, {
                            pY: i
                        }), m(A3(CY, l, function(n) {
                            return p(n, {
                                pY: kt(i)
                            });
                        }, r), A2(Yi, function() {
                            return uY;
                        }, a));
                    case 7:
                        return m(A3(CY, l = t.a.z, function(n) {
                            return p(n, {
                                dg: !0
                            });
                        }, r), n$);
                    case 8:
                        return u = t.a.d4, a = dY(l = t.a.z), m(A3(CY, l, function(n) {
                            return p(n, {
                                df: kt(u),
                                dg: !1
                            });
                        }, r), A2(Yi, function() {
                            return uY;
                        }, a));
                    case 9:
                        return m(A3(CY, l = t.a.z, function(n) {
                            return p(n, {
                                df: Tt,
                                dg: !1
                            });
                        }, r), n$);
                    case 10:
                        return a = A2(mY, l = t.a.z, {
                            n5: c = t.a.gV
                        }), m(A3(CY, l, function(n) {
                            return p(n, {
                                n5: c
                            });
                        }, r), A2(Yi, function() {
                            return uY;
                        }, a));
                    case 4:
                        var o = t.a.hu, c = t.a.gV, s = t.a.j0;
                        return a = A2(vY, l = t.a.z, {
                            ew: !0,
                            pj: 1,
                            aV: kt(0),
                            qZ: o.qZ
                        }), m(A3(CY, l, function(n) {
                            return p(n, {
                                j0: kt(s),
                                pj: 1,
                                aV: Tt
                            });
                        }, r), A2(Yi, Ml(uY), a));
                    case 5:
                        var f = t.a.lm;
                        return a = A2(cY, l = t.a.z, {
                            lm: f
                        }), m(A3(CY, l, function(n) {
                            return p(n, {
                                lm: kt(f)
                            });
                        }, r), A2(Yi, function() {
                            return uY;
                        }, a));
                    case 6:
                        var l;
                        return a = iY(l = t.a.z), m(A2(NY, l, r), A2(Yi, function() {
                            return uY;
                        }, a));
                    default:
                        return m(r, n$);
                }
            case 5:
                return m(p(r, {
                    b$: !r.b$
                }), n$);
            case 6:
                return m(r, A2(Yi, aY, wY(n.a)));
            default:
                return m(r, 1 === n.a.$ ? n$ : ez(iz));
        }
    }), SY = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), LY = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), yY = function(n) {
        return {
            $: 6,
            a: n
        };
    }, FY = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), jY = F2(function(n, r) {
        return {
            n5: r,
            bm: n
        };
    }), PY = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "seasonId", function(n) {
        return n.bm;
    }, xi, Io(jY)))), IY = function(n) {
        return {
            $: 3,
            a: n
        };
    }, BY = ml(IY({
        $: 0
    })), MY = function(n) {
        return ml(Lv(A2(yv, n, 6)));
    }, OY = F2(function(n, r) {
        return {
            c$: r,
            n5: n
        };
    }), qY = Po(A4(rc, "kind", function(n) {
        return n.c$;
    }, Fd, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(OY)))), DY = Oi({
        bN: "Can\u2019t add.",
        bT: "Impossible d\u2019effectuer l\u2019ajout."
    }), xY = F2(function(n, r) {
        return {
            a5: n,
            n5: r
        };
    }), RY = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "collectionId", function(n) {
        return n.a5;
    }, xi, Io(xY)))), VY = function(n) {
        return {
            $: 2,
            a: n
        };
    }, EY = ml(VY({
        $: 0
    })), zY = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), UY = F3(function(n, r, t) {
        var e = F4(function(n, r, t, e) {
            return A2(Gb, function(n) {
                return n.mm;
            }, dc(A3(ag, t, e, A2(ng, r, rg(n)))));
        });
        if (r.$) return BL({
            lA: Au,
            nO: DY,
            P: 400
        });
        if (r.a.$) return A4(e, MY(n), Wb, qY, 1 === r.a.a ? {
            c$: 1,
            n5: t
        } : {
            c$: 0,
            n5: t
        });
        switch(r.a.a){
            case 3:
                return A4(e, rp, up, zY, {
                    n5: t
                });
            case 2:
                return A4(e, BY, zb, PY, {
                    n5: t,
                    bm: n
                });
            case 0:
                return A4(e, Fb, Ob, FY, {
                    n5: t
                });
            default:
                return A4(e, EY, Kb, RY, {
                    a5: n,
                    n5: t
                });
        }
    }), HY = F2(function(n, r) {
        return {
            kv: r,
            lm: kt(n),
            nl: !1
        };
    }), WY = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), QY = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ZY = {
        dT: 3,
        ih: !1,
        eA: QY(0),
        mm: "",
        fC: !0,
        m6: "",
        gf: 2,
        oL: "",
        gj: "",
        gn: "",
        gT: 1,
        hs: 0,
        h2: !1
    }, KY = function(n) {
        return !!n.hs;
    }, YY = "seeAccepted", XY = "seeActives", JY = "seeAll", GY = "seeArchives", _Y = "seeNonAccepted", nX = "seeTrashed", rX = F5(function(n, r, t, e, u) {
        var a = KY(u), o = !u.h2 && i(n.iR.ss, JY) || u.h2 && i(n.iR.ss, nX) || !u.h2 && a && i(n.iR.ss, GY) || !u.h2 && !a && i(n.iR.ss, XY), c = i(n.ii.ss, JY) || u.ih && i(n.ii.ss, YY) || !u.ih && i(n.ii.ss, _Y), s = o && c ? 0 : 1;
        return p(ZY, {
            dT: u.ih ? 1 : 2,
            ih: u.ih,
            eA: QY(1 === u.c$ ? 1 : 0),
            mm: u.mm,
            m6: u.rT,
            gf: s,
            oL: r,
            gn: t,
            gT: e,
            hs: u.hs,
            h2: u.h2
        });
    }), tX = A2(qt, F2(function(n, r) {
        var t = m(r, n.dT);
        n: for(;;)switch(t.a){
            case 1:
                if (1 === t.b) return 1;
                break n;
            case 2:
                if (2 === t.b) return 2;
                break n;
            case 3:
                return t.b;
            default:
                break n;
        }
        return 0;
    }), 3), eX = A2(qt, F2(function(n, r) {
        var t = m(r, n.gf);
        n: for(;;){
            r: for(;;)switch(t.a){
                case 0:
                    return 0;
                case 2:
                    switch(t.b){
                        case 0:
                            break n;
                        case 2:
                            return 2;
                        default:
                            break r;
                    }
                default:
                    if (t.b) break r;
                    break n;
            }
            return 1;
        }
        return 0;
    }), 2), uX = kC(hC(function(n) {
        return n.m6;
    })), aX = F2(function(n, r) {
        var t = r.gj, e = r.bH.oN, u = function(u) {
            var a = uX(A2(Ge, A4(rX, n, e, u.cL.mm, r.gT), u.dr));
            return p(ZY, {
                dT: tX(a),
                eA: A2(WY, 2, a),
                mm: u.cL.mm,
                fC: Cu(a),
                m6: u.cL.n5,
                gf: eX(a),
                oL: e,
                gj: t,
                gT: r.gT,
                hs: u.cL.hs
            });
        }, a = function(n) {
            var a = uX(A2(Ge, u, n.cM));
            return p(ZY, {
                dT: tX(a),
                eA: A2(WY, 1, a),
                mm: n.dn.mm,
                fC: Cu(a),
                m6: n.dn.n5,
                gf: eX(a),
                oL: e,
                gj: t,
                gT: r.gT,
                hs: n.dn.hs
            });
        }, i = uX(A2(Ge, a, r.g$));
        return p(ZY, {
            dT: tX(i),
            eA: A2(WY, 0, i),
            mm: r.bH.mm,
            fC: Cu(i),
            m6: r.bH.n5,
            gf: eX(i),
            oL: e,
            gj: t,
            gT: r.gT,
            hs: r.bH.hs
        });
    }), iX = function(n) {
        return Ge(function(r) {
            if (r.$) {
                var t = r.a, e = t.sb.oN, u = uX(A2(Ge, A4(rX, n, e, t.sb.mm, t.gT), t.dr));
                return p(ZY, {
                    dT: tX(u),
                    eA: A2(WY, 3, u),
                    mm: t.sb.mm,
                    fC: Cu(u),
                    m6: t.sb.n5,
                    gf: eX(u),
                    oL: e,
                    gj: t.gj,
                    gT: t.gT,
                    hs: t.sb.hs
                });
            }
            return A2(aX, n, r.a);
        });
    }, oX = function(n) {
        var r = uX(A2(iX, n, n.mH));
        return p(n, {
            jJ: uX(A2(iX, n, n.jK)),
            fB: r
        });
    }, cX = F2(function(n, r) {
        return A2(fu, r, A2(Zi, Ml(Ke(0)), A2(_e, Ml(VE(n)), IE(150))));
    }), sX = F2(function(n, r) {
        return A2(ju, !1, A2(Fu, se(n), r));
    }), fX = F2(function(n, r) {
        return A2(LM, n, r);
    }), lX = Kn("redirect", gi), mX = {
        bD: Tt,
        cf: kt(!0)
    }, dX = function(n) {
        return gN(A3(Ap, n, 0, mX));
    }, bX = F2(function(n, r) {
        return n.$ ? n$ : n.a.$ ? lX(dX(r)) : n$;
    }), pX = F2(function(n, r) {
        return A2(ho, n, r);
    }), vX = F2(function(n, r) {
        return {
            C: n,
            lo: r.lo,
            aa: r.aa
        };
    }), $X = F2(function(n, r) {
        return A2(vX, A2(dt, n, r.C), r);
    }), gX = F3(function(n, r, t) {
        return A2($X, wv(m(n, r)), qK(t));
    }), hX = function(n) {
        return {
            kv: kt(n),
            lm: Tt,
            nl: !1
        };
    }, kX = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), TX = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), wX = Oi({
        bN: "Can\u2019t edit.",
        bT: "Impossible d\u2019effectuer l\u2019\xe9dition."
    }), CX = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), NX = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), AX = function(n) {
        return {
            $: 5,
            a: n
        };
    }, SX = function(n) {
        return ml(AX(A2(NX, n, 0)));
    }, LX = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), yX = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(function(n) {
        return {
            n5: n
        };
    }))), FX = F3(function(n, r, t) {
        var e = F3(function(n, r, t) {
            return dc(A3(ag, r, t, RZ(mg(n))));
        });
        if (r.$) return BL({
            lA: Au,
            nO: wX,
            P: 400
        });
        if (r.a.$) return A3(e, SX(n), yX, {
            n5: t
        });
        switch(r.a.a){
            case 3:
                return A3(e, function(n) {
                    return ml(np(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), LX, {
                    n5: t
                });
            case 2:
                return A3(e, function(n) {
                    return ml(IY(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), TX, {
                    n5: t
                });
            case 0:
                return A3(e, function(n) {
                    return ml(yb(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), kX, {
                    n5: t
                });
            default:
                return A3(e, function(n) {
                    return ml(VY(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }(n), CX, {
                    n5: t
                });
        }
    }), jX = F2(function(n, r) {
        return A2(vX, $(n, r.C), r);
    }), PX = F2(function(n, r) {
        return {
            C: r.C,
            lo: n,
            aa: r.aa
        };
    }), IX = F2(function(n, r) {
        return A2(PX, A2(dt, n, r.lo), r);
    }), BX = F2(function(n, r) {
        switch(n.$){
            case 0:
                if (n.a.$) return qK(p(r, {
                    P: A2(HY, n.a.a, r.P.kv)
                }));
                var t = n.a.a, e = A3(Je, F2(function(n, r) {
                    var t = r.a, e = r.b;
                    return n.a.gT ? m(t, A2(dt, n, e)) : m(A2(dt, n, t), e);
                }), m(g, g), t), u = e.a, a = e.b;
                return A2(jX, T([
                    A2(ju, n$, A2(Fu, function(n) {
                        return r.pM ? A2(cX, n, yY) : n$;
                    }, r.qr))
                ]), qK(t$(oX(p(r, {
                    jK: u,
                    mH: a,
                    pM: !1,
                    P: hX(0)
                })))));
            case 2:
                var o = A2(fX, k = n.a, r.oB), c = A2(o ? pX : Is, k, r.oB), s = o && i(r.is, kt(k)) ? Tt : r.is;
                return qK(p(r, {
                    is: s,
                    oB: c
                }));
            case 1:
                return qK(p(r, {
                    oJ: A2(sX, k = n.a, r.oJ) ? Tt : kt(k)
                }));
            case 3:
                var f = n.a, l = n.b;
                return A2(jX, T([
                    A2(cX, "new-add-form", yY)
                ]), qK(p(r, {
                    is: kt(l),
                    it: p(Nc, {
                        kV: "addInBrowserInput"
                    }),
                    of: f,
                    oB: A2(Is, l, r.oB)
                })));
            case 4:
                var d = n.a, b = n.b, v = r.k3;
                return A2(jX, T([
                    A2(cX, v.kV, yY)
                ]), qK(p(r, {
                    k1: A2(sX, b.mm, r.k1) ? Tt : kt(b.mm),
                    k3: p(v, {
                        ss: b.m6
                    }),
                    of: d
                })));
            case 5:
                return qK(p(r, {
                    is: Tt,
                    k1: Tt,
                    oJ: Tt
                }));
            case 6:
                return MK;
            case 7:
                var $ = r.it.ss;
                return A2(jX, T([
                    A2(Yi, SY(h = n.a), A3(UY, h, r.of, $))
                ]), qK(p(r, {
                    rk: A2(Is, h, r.rk)
                })));
            case 8:
                return $ = r.k3.ss, A2(jX, T([
                    A2(Yi, LY(k = n.a), A3(FX, k, r.of, $))
                ]), qK(p(r, {
                    rk: A2(Is, k, r.rk)
                })));
            case 9:
                if (n.b.$) return k = n.a, qK(p(r, {
                    lm: kt(n.b.a),
                    rk: A2(pX, k, r.rk)
                }));
                var h = n.a;
                return A2(jX, T([
                    A2(bX, r.of, k = n.b.a)
                ]), A2(IX, 0, qK(p(r, {
                    is: Tt,
                    it: Nc,
                    lm: Tt,
                    of: Tt,
                    pM: !0,
                    qr: kt(k),
                    rk: A2(pX, h, r.rk)
                }))));
            case 10:
                var k;
                return n.b.$ ? (k = n.a, qK(p(r, {
                    lm: kt(n.b.a),
                    rk: A2(pX, k, r.rk)
                }))) : A2(IX, 0, qK(p(r, {
                    k1: Tt,
                    k3: Nc,
                    lm: Tt,
                    of: Tt,
                    rk: A2(pX, k = n.a, r.rk)
                })));
            case 11:
                return qK(p(r, {
                    it: A2(gg, n.a, r.it)
                }));
            case 12:
                return qK(p(r, {
                    k3: A2(gg, n.a, r.k3)
                }));
            case 16:
                return qK(p(r, {
                    lm: Tt
                }));
            case 13:
                var w = p(r, {
                    iR: A2(gg, n.a, r.iR),
                    oB: Cc
                });
                return A3(gX, "browserArchive", w.iR.ss, A3(ce, A2(Fu, e$, r.qr), ju(Ie), oX(w)));
            case 14:
                return w = p(r, {
                    ii: A2(gg, n.a, r.ii),
                    oB: Cc
                }), A3(gX, "browserAccept", w.ii.ss, A3(ce, A2(Fu, e$, r.qr), ju(Ie), oX(w)));
            default:
                return qK(p(r, {
                    oK: A2(gg, n.a, r.k3)
                }));
        }
    }), MX = {
        $: 2
    }, OX = {
        $: 3
    }, qX = F3(function(n, r, t) {
        return A3(qt, F2(function(n, e) {
            return A3(qt, F2(function(r, t) {
                return !!t || A2(kZ, A2(ju, Qh, Wh("(\\b" + n + ")")), r);
            }), !1, A2(Ge, A2(No, Hi, sC), A2(dt, t.m6, r))) && e;
        }), !0, n);
    }), DX = F5(function(n, r, t, e, u) {
        return A3(qX, n, r, e) ? A2(dt, d(r, t, e), u) : u;
    }), xX = F2(function(n, r) {
        return A2(Je, F2(function(t, e) {
            var u = t.eA;
            if (u.$) return A5(DX, r, n, u.a, t, e);
            var a = u.b;
            return $(A3(xX, $(n, T([
                t.m6
            ])), r, a), e);
        }), g);
    }), RX = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                if (2 === n.a.$) return A2(pc, T([
                    A2(fu, Ml(MX), IE(200))
                ]), r);
                var e = A2(gg, n.a, r.qb), u = T(sC(Hi(e.ss)).trim().split(/\s+/g)), a = $(A3(xX, g, u, t.jJ), A3(xX, g, u, t.fB));
                return A2(pc, g, {
                    qb: e,
                    qc: a,
                    qd: !0
                });
            case 1:
                return A2(pc, r.qd ? g : T([
                    A2(cX, r.qb.kV, Ml(OX))
                ]), {
                    qb: A2(gg, Fh(""), r.qb),
                    qc: A3(xX, g, g, t.jJ),
                    qd: !r.qd
                });
            case 2:
                return A2(pc, g, p(r, {
                    qd: !1
                }));
            default:
                return A2(pc, g, r);
        }
    }), VX = Oi({
        bN: "A video is already there.",
        bT: "Il y a d\xe9j\xe0 une vid\xe9o."
    }), EX = Oi({
        bN: "MXF video file needed",
        bT: "Vous devez d\xe9poser un fichier vid\xe9o MXF"
    }), zX = F4(function(n, r, t, e) {
        return A3(wu, n, r, A2(_o, F2(function(n, e) {
            return i(e, r) ? t : e;
        }), e));
    }), UX = F3(function(n, r, t) {
        var e = function(n) {
            return m(n, Tt);
        }, u = function(n) {
            return m(t, kt(n));
        }, a = m(t, r);
        if (a.a.$) return e(t);
        var i = a.a.a, o = a.b, c = m(o, LK(n));
        n: for(;;)switch(c.a){
            case 0:
                if (c.b) break n;
                return A3(bu, e, vK, A4(zX, n.n5, 0, 3, i));
            case 1:
                switch(c.b){
                    case 1:
                        return e(vK(A3(wu, n.n5, o, i)));
                    case 0:
                        return A2(NK, Hi(n.n5), wK) ? e(vK(A3(wu, n.n5, o, i))) : u(EX);
                    default:
                        break n;
                }
            case 2:
                if (2 === c.b) return e(vK(A3(wu, n.n5, o, i)));
                break n;
            default:
                return e(vK(A3(wu, n.n5, o, i)));
        }
        return u(EX);
    }), HX = function(n) {
        return A2(vX, T([
            n
        ]), MK);
    }, WX = F3(function(n, r, t) {
        return A2(ju, n, A2(lo, t.n5, r));
    }), QX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZX = Oi({
        bN: "No more parts to send but job is not complete",
        bT: "No more parts to send but job is not complete"
    }), KX = F3(function(n, r, t) {
        if (t.$) return qK(p(n, {
            iL: QX(t.a)
        }));
        var e = t.a;
        return 1 === e.$ ? $(r, A2(Iu, function(n) {
            return !A2(G$, n, r);
        }, e.b)).b ? MK : qK(p(n, {
            iL: QX(IL(A2(ki, ZX, f$)))
        })) : qK(p(n, {
            iL: e
        }));
    }), YX = F2(function(n, r) {
        return A3(qt, F2(function(n, r) {
            return A2(ho, n.n5, r);
        }), r, n);
    }), XX = F2(function(n, r) {
        var t, e = (t = r.oX).$ ? Fc : vK(A2(YX, n, t.a));
        return qK(p(r, {
            bQ: A2(Iu, function(r) {
                return !A2(G$, r, n);
            }, r.bQ),
            oX: e
        }));
    }), JX = F3(function(n, r, t) {
        return {
            $: 12,
            a: n,
            b: r,
            c: t
        };
    }), GX = F5(function(n, r, t, e, u) {
        return {
            c$: u,
            nS: t,
            n5: n,
            qO: r,
            dt: e
        };
    }), _X = function(n) {
        switch(n){
            case 0:
                return "Material";
            case 1:
                return "Audio";
            case 2:
                return "Subtitle";
            default:
                return "Extra";
        }
    }, nJ = function(n) {
        switch(n){
            case "Material":
                return St(0);
            case "Audio":
                return St(1);
            case "Subtitle":
                return St(2);
            default:
                return St(3);
        }
    }, rJ = A2(Il, _X, nJ), tJ = Po(A4(rc, "kind", function(n) {
        return n.c$;
    }, rJ, A4(Do, "source", function(n) {
        return n.dt;
    }, xi, A4(Do, "mimeType", function(n) {
        return n.nS;
    }, xi, A4(rc, "size", function(n) {
        return n.qO;
    }, uc, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(GX))))))), eJ = Zi, uJ = F2(function(n, r) {
        return {
            c$: r,
            n5: n
        };
    }), aJ = Po(A4(rc, "kind", function(n) {
        return n.c$;
    }, rJ, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(uJ)))), iJ = function(n) {
        return ml(AX(A2(NX, n, 3)));
    }, oJ = F3(function(n, r, t) {
        return dc(A2(Ho, kV, A3(ag, aJ, {
            c$: r,
            n5: t
        }, mg(iJ(n)))));
    }), cJ = F4(function(n, r, t, e) {
        return A2(eJ, function(n) {
            return 409 === n.P ? A3(oJ, r, t, e.n5) : BL(n);
        }, dc(A2(ng, kV, A3(ag, tJ, {
            c$: t,
            nS: e.nS,
            n5: e.n5,
            qO: e.qO,
            dt: kt(n.dt)
        }, rg(iJ(r))))));
    }), sJ = F4(function(n, r, t, e) {
        return A2(IX, 1, A2(jX, A2(Ge, function(e) {
            return A2(Yi, A2(JX, n, e), A4(cJ, n, r, t(e), e));
        }, e.bQ), qK(jc(e.sp))));
    }), fJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lJ = function(n) {
        switch(n.$){
            case 0:
                return {
                    lo: (r = n.a, $i(T([
                        m("source", gi(r.dt)),
                        m("userId", gi(r.h7)),
                        m("fileId", gi(r.z)),
                        m("key", gi(r.m2)),
                        m("file", (t = r.lB, $i(T([
                            m("name", gi(t.n5)),
                            m("size", ec(t.qO)),
                            m("mimeType", A2(ju, pi, A2(Fu, gi, t.nS))),
                            m("blob", t.jf)
                        ]))))
                    ]))),
                    n5: "Upload"
                };
            case 1:
                return {
                    lo: gi(n.a),
                    n5: "Pause"
                };
            case 2:
                return {
                    lo: gi(n.a),
                    n5: "Resume"
                };
            default:
                return {
                    lo: gi(n.a),
                    n5: "Cancel"
                };
        }
        var r, t;
    }, mJ = Kn("uploadToJs", function(n) {
        return $i(T([
            m("event", n.lo),
            m("name", gi(n.n5))
        ]));
    }), dJ = A2(bu, mJ, lJ), bJ = A2(bu, dJ, fJ), pJ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A4(sJ, n.a, n.b.mm, A2(WX, 3, n.c), r);
            case 1:
                return qK(jc(r.sp));
            case 2:
                return A2(XX, T([
                    t = n.a
                ]), r);
            case 4:
                var t = n.a, e = n.b;
                return 1 === e.jv ? qK(p(r, {
                    kY: kt(d(t, {
                        sK: e.b2.sK,
                        sP: e.b2.sP
                    }, {
                        sK: e.oU.sK,
                        sP: e.oU.sP
                    }))
                })) : MK;
            case 5:
                var u = r.kY;
                if (1 === u.$) return MK;
                var a = u.a;
                return qK(p(r, {
                    kY: kt(d(t = a.a, a.b, n.a))
                }));
            case 6:
                var i = (f = m(r.kY, r.kZ)).a.$ || f.b.$ ? m(r.oX, Tt) : A3(UX, f.a.a.a, f.b.a, r.oX);
                return qK(p(r, {
                    kY: Tt,
                    lm: i.b,
                    oX: i.a
                }));
            case 7:
                return qK(p(r, {
                    kZ: kt(n.a)
                }));
            case 8:
                return qK(p(r, {
                    kZ: Tt
                }));
            case 3:
                return MK;
            case 9:
                return qK(p(r, {
                    lm: Tt
                }));
            case 10:
                return A3(DK, n.a, n.b, r);
            case 11:
                var o = n.a, c = r.iL;
                switch(c.$){
                    case 1:
                        return A3(KX, r, c.b, o);
                    case 0:
                        return A3(KX, r, g, o);
                    default:
                        return MK;
                }
            default:
                if (n.c.$) return qK(p(r, {
                    lm: kt(VX)
                }));
                var s = n.c.a;
                return HX(bJ({
                    lB: t = n.b,
                    z: s.mm,
                    m2: s.m2,
                    dt: n.a.dt,
                    h7: "TODODODODO"
                }));
        }
        var f;
    }), vJ = F2(function(n, r) {
        if (n.$) return A2(pc, g, p(r, {
            oU: kt(n.a)
        }));
        if (n.a.$) return A2(pc, g, r);
        var t = n.a.a;
        return A2(pc, T([
            A2(ju, n$, A2(Fu, UH(t), r.b7))
        ]), p(r, {
            fX: t
        }));
    }), $J = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gJ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, hJ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kJ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, TJ = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), wJ = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), CJ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), NJ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), AJ = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), SJ = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), LJ = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), yJ = F2(function(n, r) {
        return {
            $: 13,
            a: n,
            b: r
        };
    }), FJ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), jJ = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), PJ = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), IJ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), BJ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), MJ = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), OJ = function(n) {
        if (1 === n.$) return 0;
        switch(n.a.$){
            case 13:
                return 1;
            case 0:
                return 2;
            case 12:
                return 3;
            case 1:
                return 4;
            case 5:
                return 5;
            case 6:
                return 6;
            case 9:
                return 7;
            case 8:
                return 8;
            case 7:
                return 9;
            case 2:
                return 11;
            case 4:
                return 12;
            case 3:
                return 13;
            case 10:
                return 14;
            default:
                return 15;
        }
    }, qJ = F2(function(n, r) {
        return f(OJ(kt(n)), OJ(r)) > 0 ? kt(n) : r;
    }), DJ = Oi({
        bN: " done",
        bT: " est termin\xe9e"
    }), xJ = Oi({
        bN: " failed",
        bT: " a \xe9chou\xe9"
    }), RJ = Oi({
        bN: " done generating ",
        bT: " est termin\xe9e g\xe9n\xe9rant "
    }), VJ = Oi({
        bN: "Segmentation of file ",
        bT: "La segmentation du fichier "
    }), EJ = Oi({
        bN: " started",
        bT: " a d\xe9marr\xe9"
    }), zJ = Oi({
        bN: " with rule ",
        bT: " avec la r\xe8gle "
    }), UJ = Oi({
        bN: "File ",
        bT: "Le fichier "
    }), HJ = Oi({
        bN: " has been uploaded",
        bT: " a \xe9t\xe9 upload\xe9"
    }), WJ = Oi({
        bN: " creeated invitation ",
        bT: " s\u2019est cr\xe9\xe9 une invitation "
    }), QJ = Oi({
        bN: " deleted invitation",
        bT: " a supprim\xe9 son invitation"
    }), ZJ = Oi({
        bN: " deleted invitation for ",
        bT: " a supprim\xe9 l\u2019invitation de "
    }), KJ = Oi({
        bN: " edit invitation ",
        bT: " a \xe9dit\xe9 son invitation "
    }), YJ = Oi({
        bN: " invited ",
        bT: " a invit\xe9 "
    }), XJ = Oi({
        bN: " expire at ",
        bT: " expirant le "
    }), JJ = function(n) {
        var r = A2(Tz, 4, A2(Gm, nd, n)), t = wz(A2(Wm, nd, n));
        return A2(Tz, 2, A2(Em, nd, n)) + "/" + t + "/" + r;
    }, GJ = function(n) {
        return A2(ju, "", A2(Fu, function(n) {
            return $(XJ, n);
        }, A2(Fu, JJ, n)));
    }, _J = Oi({
        bN: " to download and upload",
        bT: " autorisant le t\xe9l\xe9chargement et l\u2019upload"
    }), nG = Oi({
        bN: " to download",
        bT: " autorisant le t\xe9l\xe9chargement"
    }), rG = Oi({
        bN: " authorize download and unauthorize upload",
        bT: " autorisant le t\xe9l\xe9chargement et supprimant l\u2019upload"
    }), tG = Oi({
        bN: " authorizing download and delivery",
        bT: " autorisant le t\xe9l\xe9chargement et la livraison"
    }), eG = Oi({
        bN: " authorize download and unauthorize delivery",
        bT: " autorisant le t\xe9l\xe9chargement et supprimant la livraison"
    }), uG = Oi({
        bN: " to delivery",
        bT: " autorisant la livraison"
    }), aG = Oi({
        bN: " unauthorizing delivery",
        bT: " supprimant la livraison"
    }), iG = Oi({
        bN: " authorizing delivery and unauthorizing download",
        bT: " autorisant la livraison et supprimant le t\xe9l\xe9chargement"
    }), oG = Oi({
        bN: " unauthorizing delivery and download",
        bT: " supprimant la livraison et le t\xe9l\xe9chargement"
    }), cG = Oi({
        bN: " to upload",
        bT: " autorisant l\u2019upload"
    }), sG = Oi({
        bN: " to watch only",
        bT: " autorisant le visionnage seulement"
    }), fG = Oi({
        bN: " unauthorizing upload",
        bT: " supprimant l\u2019upload"
    }), lG = Oi({
        bN: " authorizing upload and unauthorizing download",
        bT: " autorisant l\u2019upload et supprimant le t\xe9l\xe9chargement"
    }), mG = Oi({
        bN: " unauthorizing download",
        bT: " supprimant le t\xe9l\xe9chargement"
    }), dG = Oi({
        bN: " unauthorizing upload and download",
        bT: " supprimant l\u2019upload et le t\xe9l\xe9chargement"
    }), bG = F3(function(n, r, t) {
        var e = m(n, r);
        switch(e.a){
            case 0:
                switch(e.b){
                    case 0:
                        return t ? tG : _J;
                    case 1:
                        return t ? eG : rG;
                    default:
                        return nG;
                }
            case 1:
                switch(e.b){
                    case 0:
                        return t ? iG : lG;
                    case 1:
                        return t ? oG : dG;
                    default:
                        return mG;
                }
            default:
                switch(e.b){
                    case 0:
                        return t ? uG : cG;
                    case 1:
                        return t ? aG : fG;
                    default:
                        return sG;
                }
        }
    }), pG = Oi({
        bN: "unknown user",
        bT: "utilisateur inconnu"
    }), vG = Oi({
        bN: "Video was watched by a guest : ",
        bT: "La vid\xe9o \xe0 \xe9t\xe9 visionn\xe9e par un invit\xe9 : "
    }), $G = Oi({
        bN: " ended with ",
        bT: " s\u2019est termin\xe9e avec "
    }), gG = F4(function(n, r, t, e) {
        return 1 === r.$ || 1 === t.$ || 1 === e.$ ? Tt : kt(A3(n, r.a, t.a, e.a));
    }), hG = Oi({
        bN: "Copy of file ",
        bT: "La copie du fichier "
    }), kG = Oi({
        bN: " for file ",
        bT: " pour le fichier "
    }), TG = Oi({
        bN: "Creation of ",
        bT: "La g\xe9n\xe9ration du "
    }), wG = Oi({
        bN: "deliverable with parameters ",
        bT: "livrable avec pour param\xe8tres "
    }), CG = Oi({
        bN: " High Res ",
        bT: " Haute Def "
    }), NG = Oi({
        bN: " and subtitles ",
        bT: " et sous-titres "
    }), AG = F2(function(n, r) {
        var t = n.aX;
        return "TC IN = " + n.dy + ", TC OUT = " + n.dz + ", version " + ib(n.sv) + ", format = " + (r + (t.$ ? "" : $(NG, t.a)));
    }), SG = F3(function(n, r, t) {
        switch(n){
            case 0:
                return "proxy";
            case 1:
                return "proxy" + CG;
            case 3:
            default:
                return "";
            case 2:
                return 1 === t.$ ? wG + "format = " + r : $(wG, A2(AG, t.a, r));
        }
    }), LG = Oi({
        bN: "organization ",
        bT: "vers l\u2019organisation "
    }), yG = F6(function(n, r, t, e, u, a) {
        var i = A2(ju, "", A2(Fu, function(n) {
            return $(LG, n);
        }, u));
        return 3 === a ? hG + (n + " ") + (i + e) : TG + (A3(SG, a, t, r) + (kG + (n + " "))) + (i + e);
    }), FG = Oi({
        bN: " warning",
        bT: " warning"
    }), jG = Oi({
        bN: " warnings",
        bT: " warnings"
    }), PG = Oi({
        bN: "files uploaded",
        bT: "fichiers upload\xe9s"
    }), IG = Oi({
        bN: " sent with success",
        bT: " a \xe9t\xe9 envoy\xe9 avec succ\xe8s"
    }), BG = Oi({
        bN: "Uploading of ",
        bT: "L'upload de "
    }), MG = Oi({
        bN: " uploading",
        bT: " est en cours d\u2019upload"
    }), OG = Oi({
        bN: " and ",
        bT: " et "
    }), qG = Oi({
        bN: " error ",
        bT: " erreur "
    }), DG = Oi({
        bN: " errors ",
        bT: " erreurs "
    }), xG = Oi({
        bN: " failed. Report generation impossible",
        bT: " a \xe9chou\xe9e. Impossible de g\xe9n\xe9rer le rapport"
    }), RG = Oi({
        bN: "Automated analysis ",
        bT: "L'analyse automatique du fichier "
    }), VG = Oi({
        bN: " archived program",
        bT: " a archiv\xe9 le programme"
    }), EG = Oi({
        bN: " commented program",
        bT: " a comment\xe9 le programme"
    }), zG = Oi({
        bN: " deleted ",
        bT: " a supprim\xe9 "
    }), UG = Oi({
        bN: " downloaded program",
        bT: " a t\xe9l\xe9charg\xe9 le programme"
    }), HG = Oi({
        bN: "program accepted by ",
        bT: "le programme a \xe9t\xe9 accept\xe9 par "
    }), WG = Oi({
        bN: " required a new version",
        bT: " a demand\xe9 une nouvelle version du programme"
    }), QG = Oi({
        bN: " created program",
        bT: " a cr\xe9\xe9 le programme"
    }), ZG = Oi({
        bN: " from organization ",
        bT: " de l\u2019organisation "
    }), KG = Oi({
        bN: " created SFTP access.",
        bT: " a cr\xe9\xe9 un acc\xe9s SFTP."
    }), YG = Oi({
        bN: " deleted program",
        bT: " a supprim\xe9 le programme"
    }), XG = Oi({
        bN: " unarchived program",
        bT: " a d\xe9sarchiv\xe9 le programme"
    }), JG = Oi({
        bN: " undeleted program",
        bT: " a restaur\xe9 le programme"
    }), GG = function(n) {
        switch(n.$){
            case 4:
                return function(n) {
                    switch(n.c$){
                        case 0:
                            return $(n.dt.n5, QG);
                        case 1:
                            return $(HG, $(n.dt.n5, A2(ju, " ", A2(Fu, function(n) {
                                return $(ZG, n);
                            }, n.dt.gj))));
                        default:
                            return $(n.dt.n5, WG);
                    }
                }(n.a);
            case 3:
                return $(n.a.dt.n5, EG);
            case 1:
                return $(UJ, $(n.a.cS, HJ));
            case 0:
                return function(n) {
                    var r = n.cS, t = n.bl;
                    if (1 === n.lm.$) {
                        if (1 === t.$) return $(RG, $(r, EJ));
                        var e = t.a;
                        return $(RG, $(r, $($G, $(It(e.n7), $(e.n7 > 1 ? DG : qG, $(OG, $(It(e.aq), e.aq > 1 ? jG : FG)))))));
                    }
                    return $(RG, $(r, xG));
                }(n.a);
            case 2:
                return e = (t = n.a).cW, u = t.c7, a = t.lm, o = t.c3, c = t.c4, s = t.c5, f = t.aX, l = t.dx, d = t.dI, A6(yG, t.cS, A4(gG, F3(function(n, r, t) {
                    return {
                        aX: f,
                        dy: n,
                        dz: r,
                        sv: t
                    };
                }), o, c, s), e, t.c$ ? 1 === a.$ ? u ? $($G, $(It(u), 1 === u ? FG : jG)) : DJ : xJ : EJ, l, d);
            case 5:
                return function(n) {
                    var r, t = (r = n.c6).$ ? "" : "(" + It(r.a) + " " + PG + ")", e = m(n.c$, n.lm);
                    return e.a ? 1 === e.b.$ ? $(n.rS, $(IG, t)) : $(BG, $(n.rS, xJ)) : $(n.rS, MG);
                }(n.a);
            case 6:
                return function(n) {
                    return $(n.dt.n5, $(A2(ju, "", A2(Fu, function(n) {
                        return " (" + n + ") ";
                    }, n.dt.gj)), KG));
                }(n.a);
            case 7:
                return (r = n.a).dt.n5 + (A2(ju, "", A2(Fu, function(n) {
                    return " (" + n + ") ";
                }, r.dt.gj)) + (UG + " ")) + r.cS;
            case 8:
                return $(n.a.dt.n5, VG);
            case 11:
                return $(n.a.dt.n5, XG);
            case 9:
                return $(n.a.dt.n5, YG);
            case 10:
                return $(n.a.dt.n5, JG);
            case 12:
                return function(n) {
                    return $(n.dt.n5, $(zG, n.cT));
                }(n.a);
            case 13:
                return function(n) {
                    var r = n.dt, t = n.rL, e = n.cJ, u = n.sg, a = n.cO, o = !n.qJ;
                    switch(n.c$){
                        case 0:
                            return i(r.mm, t.mm) ? $(r.n5, $(WJ, $(A3(bG, e, u, o), GJ(a)))) : $(r.n5, $(YJ, $(t.n5, $(A3(bG, e, u, o), GJ(a)))));
                        case 1:
                            return i(r.mm, t.mm) ? $(r.n5, $(KJ, $(A3(bG, e, u, o), GJ(a)))) : $(r.n5, $(KJ, $(t.n5, $(A3(bG, e, u, o), GJ(a)))));
                        default:
                            return i(r.mm, t.mm) ? $(r.n5, QJ) : $(r.n5, $(ZJ, $(t.n5, A3(bG, e, u, o))));
                    }
                }(n.a);
            case 14:
                return function(n) {
                    var r = n.du, t = n.cS, e = n.dm;
                    if (n.cp) return "";
                    if (n.c$) {
                        if (1 === n.lm.$) {
                            if (1 === t.$) return $(VJ, $(r, 1 === e.$ ? DJ : $(zJ, $(e.a, DJ))));
                            var u = t.a;
                            return $(VJ, $(r, 1 === e.$ ? $(RJ, u) : $(zJ, $(e.a, $(RJ, u)))));
                        }
                        return $(VJ, $(r, 1 === e.$ ? xJ : $(zJ, $(e.a, xJ))));
                    }
                    return $(VJ, $(r, 1 === e.$ ? EJ : $(zJ, $(e.a, EJ))));
                }(n.a);
            default:
                return function(n) {
                    return $(vG, A2(ju, pG, A2(Fu, function(n) {
                        return n.k8;
                    }, n.dt)));
                }(n.a);
        }
        var r, t, e, u, a, o, c, s, f, l, d;
    }, _G = function(n) {
        switch(n.$){
            case 4:
            case 3:
            case 6:
            case 7:
            case 8:
            case 11:
            case 9:
            case 10:
            case 12:
            case 13:
                return {
                    mm: (r = n.a).mm,
                    g6: r.g6,
                    dt: kt(r.dt),
                    hA: r.hA,
                    hX: r.hX,
                    rS: r.rS
                };
            default:
                var r;
                return {
                    mm: (r = n.a).mm,
                    g6: r.g6,
                    dt: Tt,
                    hA: r.hA,
                    hX: r.hX,
                    rS: r.rS
                };
        }
    }, n_ = A2(No, _G, function(n) {
        return n.hX;
    }), r_ = A2(qt, F2(function(n, r) {
        var t = GG(n), e = m(n, r);
        switch(e.a.$){
            case 4:
                var u = e.b;
                return A2(qJ, A2((o = e.a.a).c$ ? yJ : CJ, t, o.hX), u);
            case 3:
                return u = e.b, A2(qJ, A2(wJ, t, (o = e.a.a).hX), u);
            case 1:
                return u = e.b, A2(qJ, A2(NJ, t, (o = e.a.a).hX), u);
            case 0:
                u = e.b;
                var a = (o = e.a.a).bl;
                return A2(qJ, A2(a.$ ? IJ : a.a.n7 > 0 ? BJ : MJ, t, o.hX), u);
            case 2:
                return u = e.b, A2(qJ, A2((o = e.a.a).c$ ? SJ : AJ, t, o.hX), u);
            case 5:
                return u = e.b, (o = e.a.a).c$ ? i(o.lm, Tt) ? A2(qJ, A2(PJ, t, o.hX), u) : A2(qJ, A2(FJ, t, o.hX), u) : A2(qJ, A2(jJ, t, o.hX), u);
            case 8:
                return u = e.b, A2(qJ, A2(TJ, t, (o = e.a.a).hX), u);
            case 11:
                var o;
                return u = e.b, A2(qJ, A2(LJ, t, (o = e.a.a).hX), u);
            default:
                return u = e.b, A2(qJ, A2(yJ, t, n_(e.a)), u);
        }
    }), Tt), t_ = A2(No, _G, function(n) {
        return n.g6;
    }), e_ = A2(No, _G, function(n) {
        return n.rS;
    }), u_ = F3(function(n, r, t) {
        return A2(ko, n, function(n) {
            return kt(1 === n.$ ? A2(xk, r, T([
                t
            ])) : A3(ko, r, function(n) {
                return kt(1 === n.$ ? T([
                    t
                ]) : A2(dt, t, n.a));
            }, n.a));
        });
    }), a_ = (ZW = F2(function(n, r) {
        return {
            e0: A2(zi, A2(bu, A2(bu, de(-1), jN), n_), r),
            aI: !0,
            qI: A2(ju, "", A2(Fu, t_, Va(r))),
            P: r_(r),
            hW: n,
            rS: A2(ju, "", A2(Fu, e_, Va(r)))
        };
    }), A2(No, A2(Je, F2(function(n, r) {
        return A4(u_, Nz(n_(n)), t_(n), n, r);
    }), Au), _o(F2(function(n, r) {
        return A2(_o, ZW, r);
    })))), i_ = F2(function(n, r) {
        return A2(Fu, function(n) {
            return n.mm;
        }, Va(A2(Yc, function(r) {
            var t = r.fz;
            return i(r.sp.mm, n.sp.mm) ? kt(t) : Tt;
        }, r.fB)));
    }), o_ = F2(function(n, r) {
        return A2(vX, A2(Ge, cp(n), r.C), r);
    }), c_ = F2(function(n, r) {
        return A2(OK, A2(Fu, n, r.aa), r);
    }), s_ = F2(function(n, r) {
        return A2(bu, c_(n), o_(r));
    }), f_ = F2(function(n, r) {
        return A2(ko, n, function(n) {
            return n.$ ? Tt : kt(A3(ko, r, function(n) {
                if (n.$) return Tt;
                var r = n.a;
                return kt(p(r, {
                    aI: !r.aI
                }));
            }, n.a));
        });
    }), l_ = function(n) {
        return {
            $: 10,
            a: n
        };
    }, m_ = function(n) {
        return {
            $: 8,
            a: n
        };
    }, d_ = function(n) {
        return {
            $: 12,
            a: n
        };
    }, b_ = function(n) {
        return {
            $: 14,
            a: n
        };
    }, p_ = F5(function(n, r, t, e, u) {
        return {
            cJ: e,
            k8: n,
            cO: u,
            nO: r,
            sg: t
        };
    }), v_ = Po(A4(Do, "expireAt", function(n) {
        return n.cO;
    }, td, A4(rc, "download", function(n) {
        return n.cJ;
    }, no, A4(rc, "upload", function(n) {
        return n.sg;
    }, no, A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(rc, "email", function(n) {
        return n.k8;
    }, xi, Io(p_))))))), $_ = F2(function(n, r) {
        return dc(A2(ng, Ev, A3(ag, v_, r, rg(ml(Lv(A2(yv, n.mm, 5)))))));
    }), g_ = function(n) {
        return p(n, {
            lm: Tt
        });
    }, h_ = function(n) {
        return {
            $: 14,
            a: n
        };
    }, k_ = function(n) {
        return ml(h_(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n)));
    }, T_ = function(n) {
        return fp(function(r) {
            return Va(A2(Yc, function(r) {
                var t = r.fz;
                return i(r.sp.mm, n.sp.mm) ? kt(t.mm) : Tt;
            }, r.fB));
        });
    }, w_ = function(n) {
        return A2($m, "", function(r) {
            if (i(qe(r), n)) {
                var t = ze(r);
                return t.$ ? Kl('Invalid integer: "' + r + '"') : A2(pm, om, Yl(t.a));
            }
            return A2(pm, function(n) {
                return cm(A2(zu, r, n));
            }, Zl(lm(Qt)));
        });
    }, C_ = function(n) {
        var r = n.b, t = n.c;
        return Om(A2(Tz, 4, n.a) + "-" + A2(Tz, 2, r) + "-" + A2(Tz, 2, t) + "T00:00:00.000Z");
    }, N_ = function(n) {
        var r = A2(em, A2(em, A2(em, Yl(F3(function(n, r, t) {
            return d(n, r, t);
        })), A2(rm, w_(4), Tm("-"))), A2(rm, w_(2), Tm("-"))), w_(2));
        return A2(hU, C_, A2(hi, Ml("Can't parse date"), A2(Bm, r, n)));
    }, A_ = F5(function(n, r, t, e, u) {
        return {
            kg: u,
            fq: n,
            fT: t,
            oZ: e,
            gv: r
        };
    }), S_ = F4(function(n, r, t, e) {
        var u = e;
        return {
            e: Mo(T([
                A3(Fe, F2(function(n, r) {
                    return n(r);
                }), u.e, Oo(A2(mu, n, bi(t))))
            ])),
            g: function(e) {
                return A2(dt, m(n, A2(Bo, qo(t), r(e))), u.g(e));
            }
        };
    }), L_ = Po(A4(S_, "createdAt", function(n) {
        return n.kg;
    }, td, A4(S_, "password", function(n) {
        return n.oZ;
    }, xi, A4(rc, "login", function(n) {
        return n.fT;
    }, xi, A4(rc, "port", function(n) {
        return n.gv;
    }, uc, A4(rc, "hostname", function(n) {
        return n.fq;
    }, xi, Io(A_))))))), y_ = function(n) {
        return ml(h_(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n)));
    }, F_ = function(n) {
        return dc(A2(Ho, L_, rg(y_(n))));
    }, j_ = function(n) {
        return dc(fg(sg(y_(n))));
    }, P_ = F2(function(n, r) {
        return A2(PX, $(n, r.lo), r);
    }), I_ = F4(function(n, r, t, e) {
        switch(n.$){
            case 0:
                return qK(p(r, {
                    k8: A2(gg, n.a, r.k8)
                }));
            case 1:
                return qK(p(r, {
                    nO: A2(gg, n.a, r.nO)
                }));
            case 2:
                return qK(p(r, {
                    lr: A2(gg, n.a, r.lr)
                }));
            case 4:
                return qK(p(r, {
                    jx: A2(vg, n.a, r.jx)
                }));
            case 3:
                return qK(p(r, {
                    jy: A2(vg, n.a, r.jy)
                }));
            case 5:
                return qK(r);
            case 6:
                return qK(p(r, {
                    kS: !r.kS
                }));
            case 7:
                return A2(jX, T([
                    A2(Yi, m_, (d = n.a, dc(fg(sg(k_(d.mm))))))
                ]), qK(g_(r)));
            case 8:
                return (u = n.a).$ ? qK(p(r, {
                    lm: kt(u.a)
                })) : (m = T([
                    4
                ]), A2(PX, m, MK));
            case 10:
                var u;
                return (u = n.a).$ ? qK(p(r, {
                    lm: kt(u.a)
                })) : A2(P_, T([
                    4
                ]), qK(p(r, {
                    jx: vs,
                    jy: gs,
                    kS: !1,
                    k8: Ts,
                    lr: Cs,
                    nO: As
                })));
            case 9:
                var a = n.a, o = A2(hi, function() {
                    return Tt;
                }, A2(X$, Ie, N_(r.lr.ss))), c = {
                    cJ: r.jx.ss,
                    k8: r.k8.ss,
                    cO: o.$ ? Tt : kt(o.a),
                    nO: r.nO.ss,
                    sg: r.jy.ss
                };
                return A2(jX, T([
                    A2(Yi, l_, A2($_, a, c))
                ]), qK(g_(r)));
            case 11:
                var s = A2(T_, t, e);
                if (s.$) return MK;
                var f = s.a;
                return i(r.lY, Tt) ? HX(A2(Yi, d_, function(n) {
                    return A2(OC, function() {
                        return F_(n);
                    }, j_(n));
                }(f))) : HX(A2(Yi, d_, F_(f)));
            case 12:
                return qK(p(r, {
                    lY: kt(n.a)
                }));
            case 13:
                var l = A2(T_, t, e);
                return l.$ ? MK : HX(A2(Yi, b_, j_(f = l.a)));
            default:
                return qK(p(r, 1 === n.a.$ ? {
                    lY: kt(wt(n.a.a))
                } : {
                    lY: Tt
                }));
        }
        var m, d;
    }), B_ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, M_ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, O_ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, q_ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, D_ = {
        $: 1
    }, x_ = {
        $: 2
    }, R_ = function(n) {
        return ml(AX(A2(NX, n, 7)));
    }, V_ = function(n) {
        return dc(fg(rg(R_(n))));
    }, E_ = function(n) {
        return dc(RZ(rg(function(n) {
            return ml(Lv(A2(yv, n, 1)));
        }(n))));
    }, z_ = function(n) {
        return dc(fg(rg(function(n) {
            return ml(AX(A2(NX, n, 9)));
        }(n))));
    }, U_ = function(n) {
        return dc(RZ(rg(function(n) {
            return ml(Lv(A2(yv, n, 3)));
        }(n))));
    }, H_ = function(n) {
        return ml(AX(A2(NX, n, 8)));
    }, W_ = function(n) {
        return dc(fg(rg(H_(n))));
    }, Q_ = function(n) {
        return dc(RZ(rg(function(n) {
            return ml(Lv(A2(yv, n, 2)));
        }(n))));
    }, Z_ = function(n) {
        return dc(fg(rg(function(n) {
            return ml(AX(A2(NX, n, 10)));
        }(n))));
    }, K_ = function(n) {
        return dc(RZ(rg(function(n) {
            return ml(Lv(A2(yv, n, 4)));
        }(n))));
    }, Y_ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return qK(p(r, {
                    P: Ls
                }));
            case 1:
                return qK(p(r, {
                    oC: !r.oC
                }));
            case 2:
                return qK(p(r, {
                    oE: !r.oE
                }));
            case 3:
                return (t = n.a).$ ? qK(p(r, {
                    P: q_(t.a)
                })) : A2(P_, T([
                    4,
                    0,
                    1
                ]), qK(p(r, {
                    P: x_
                })));
            case 4:
                return (t = n.a).$ ? qK(p(r, {
                    r3: q_(t.a)
                })) : A2(P_, T([
                    4,
                    0,
                    1
                ]), qK(p(r, {
                    r3: x_
                })));
            case 5:
                var t;
                return (t = n.a).$ ? qK(p(r, {
                    sd: q_(t.a)
                })) : A2(P_, T([
                    4,
                    0,
                    1
                ]), qK(p(r, {
                    sd: x_
                })));
            case 6:
                return A2(jX, T([
                    A2(Yi, B_, ((e = n.a).mT ? V_ : E_)(e.mm))
                ]), qK(p(r, {
                    P: D_
                })));
            case 7:
                return A2(jX, T([
                    A2(Yi, B_, ((e = n.a).mT ? W_ : Q_)(e.mm))
                ]), qK(p(r, {
                    P: D_
                })));
            case 8:
                return A2(jX, T([
                    A2(Yi, M_, ((e = n.a).mT ? z_ : U_)(e.mm))
                ]), qK(p(r, {
                    P: D_
                })));
            default:
                var e;
                return A2(jX, T([
                    A2(Yi, O_, ((e = n.a).mT ? Z_ : K_)(e.mm))
                ]), qK(p(r, {
                    P: D_
                })));
        }
    }), X_ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, J_ = {
        $: 1
    }, G_ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, __ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, n1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, r1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, t1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, e1 = function(n) {
        return dc(A2(Ho, L_, rg(y_(n))));
    }, u1 = function(n) {
        return dc(fg(sg(y_(n))));
    }, a1 = F2(function(n, r) {
        switch(n.$){
            case 1:
                return qK(p(r, {
                    gh: !r.gh
                }));
            case 0:
                var t = n.a;
                return A2($X, A2(Yi, X_, dc(A2(Ho, L_, So(y_(t))))), qK(p(r, {
                    fz: t,
                    gh: !0
                })));
            case 3:
                switch(r.lY.$){
                    case 3:
                    case 2:
                        return HX(A2(Yi, r1, A2(OC, function() {
                            return e1(e);
                        }, u1(e = r.fz))));
                    default:
                        return HX(A2(Yi, r1, e1(r.fz)));
                }
            case 2:
                return qK(p(r, n.a.$ ? {
                    lY: J_
                } : {
                    lY: n1(n.a.a)
                }));
            case 4:
                return qK(p(r, n.a.$ ? {
                    lY: __(n.a.a)
                } : {
                    lY: G_(n.a.a)
                }));
            case 5:
                return HX(A2(Yi, t1, u1(r.fz)));
            default:
                return qK(p(r, 1 === n.a.$ ? {
                    lY: __(n.a.a)
                } : {
                    lY: J_,
                    gh: !1
                }));
        }
        var e;
    }), i1 = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return HX(Yv(r.mm));
            case 2:
                if ((u = n.a).$) return qK(p(r, {
                    e0: A2(HY, u.a, r.e0.kv)
                }));
                var e = u.a;
                return qK(p(r, {
                    e0: hX(e),
                    rR: a_(e)
                }));
            case 1:
                var u;
                if ((u = n.a).$) return qK(p(r, {
                    P: A2(HY, u.a, r.P.kv)
                }));
                var a = u.a;
                return A2($X, function() {
                    var n = A2(i_, t, a);
                    if (n.$) return n$;
                    var r = n.a;
                    return A2(Gv, A2(bu, hJ, $J), oN(r));
                }(), qK(p(r, {
                    nn: !1,
                    P: hX(a)
                })));
            case 4:
                return A3(s_, function(n) {
                    return p(r, {
                        cJ: n
                    });
                }, hJ, A2(a1, n.a, r.cJ));
            case 5:
                return A3(s_, function(n) {
                    return p(r, {
                        d1: n
                    });
                }, gJ, A2(Y_, n.a, r.d1));
            case 6:
                return A3(s_, function(n) {
                    return p(r, {
                        fB: n
                    });
                }, kJ, A4(I_, n.a, r.fB, t, r.P.kv));
            default:
                var i = n.a;
                return qK(p(r, {
                    rR: A3(f_, i.a, i.b, r.rR)
                }));
        }
    }), o1 = F2(function(n, r) {
        return p(r, 0 === n.$ ? {
            aL: 1
        } : {
            aL: 0
        });
    }), c1 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, s1 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, f1 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, l1 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, m1 = function(n) {
        return {
            $: 26,
            a: n
        };
    }, d1 = function(n) {
        return {
            $: 30,
            a: n
        };
    }, b1 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, p1 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, v1 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, $1 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, g1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, h1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, k1 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, T1 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, w1 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, C1 = function(n) {
        return {
            $: 22,
            a: n
        };
    }, N1 = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), A1 = function(n) {
        return {
            $: 24,
            a: n
        };
    }, S1 = function(n) {
        return {
            $: 28,
            a: n
        };
    }, L1 = F3(function(n, r, t) {
        return A2(Xs, r, A8(Os, n, Ds(n), t, 0, 0, 0, 0, 0));
    }), y1 = F3(function(n, r, t) {
        return A3(qt, F2(function(r, t) {
            return Ws(p(t, {
                lT: A2(n, t.lT, r.lT)
            }));
        }), r, A2(Ge, function(n) {
            return A3(L1, r.fe, n, r.eR);
        }, t));
    }), F1 = F2(function(n, r) {
        return A3(y1, yt, n, r);
    }), j1 = F2(function(n, r) {
        return A2(F1, r, T([
            n
        ]));
    }), P1 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, I1 = A2(bu, dJ, P1), B1 = function(n) {
        return ml(Rq(A2(MV, n, 0)));
    }, M1 = function(n) {
        return dc(fg(sg(B1(n))));
    }, O1 = Kn("downloadAll", gi), q1 = function(n) {
        return A2(vX, n, MK);
    }, D1 = function(n) {
        return A2(PX, T([
            n
        ]), MK);
    }, x1 = F6(function(n, r, t, e, u, a) {
        return (function(n) {
            return function(r) {
                return function(t) {
                    return function(e) {
                        return function(u) {
                            return function(a) {
                                return function(i) {
                                    return function(o) {
                                        return function(c) {
                                            return function(s) {
                                                return {
                                                    i0: o,
                                                    jt: c,
                                                    eS: t,
                                                    lU: i,
                                                    m2: s,
                                                    n2: r,
                                                    qp: u,
                                                    qq: a,
                                                    q4: n,
                                                    ro: e
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        })(n)(r)(t)(Tt)(e)(g)(u)(a)(Tt)(Tt);
    }), R1 = F2(function(n, r) {
        if (1 === r.$) return n.R;
        var t = r.a;
        return A2(ju, n.R, Va(A2(Iu, function(n) {
            return i(n.bD.mm, t);
        }, n.bj)));
    }), V1 = F2(function(n, r) {
        return A2(R1, r, n.oW.bD);
    }), E1 = F3(function(n, r, t) {
        return Va(A2(Iu, function(n) {
            return i(n.lB.mm, t);
        }, A2(V1, n, r).bQ.d6));
    }), z1 = F3(function(n, r, t) {
        return A2(fp, A2(No, function(n) {
            return n.pl;
        }, function(n) {
            return n.nv;
        }), A3(E1, n, r, t));
    }), U1 = function(n) {
        return 1 === n.$ ? kt(n.a) : Tt;
    }, H1 = function(n) {
        switch(n){
            case 0:
                return "mono";
            case 1:
                return "dual mono";
            case 2:
                return "stereo";
            case 3:
                return "stereo L";
            case 4:
                return "stereo R";
            case 5:
                return "5.1";
            case 6:
                return "5.1 L";
            case 7:
                return "5.1 R";
            case 8:
                return "5.1 C";
            case 9:
                return "5.1 SL";
            case 10:
                return "5.1 SR";
            case 11:
                return "5.1 LFE";
            case 12:
                return "7.1";
            default:
                return "multiple audio on 1 track";
        }
    }, W1 = function(n) {
        return A2(Ge, function(n) {
            return A2(x$, n.ft, A2(Fu, H1, n.aC));
        }, A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, U1, n.av)));
    }, Q1 = function(n) {
        return A2(Ge, function(n) {
            return A2(x$, n.ft, A2(Fu, H1, n.aC));
        }, A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, U1, n.av)));
    }, Z1 = function(n) {
        return n.$ ? Tt : kt(n.a);
    }, K1 = function(n) {
        return A2(ju, function(n) {
            return A2(ju, Tt, A2(Fu, function(n) {
                return n.eS;
            }, function(n) {
                return Va(A2(zi, function(n) {
                    return n.ft;
                }, A2(Yc, U1, n.av)));
            }(n)));
        }(n), A2(Fu, function(n) {
            return n.eS;
        }, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av)))));
    }, Y1 = function(n) {
        return A2(ju, Tt, A2(Fu, function(n) {
            return n.eS;
        }, function(n) {
            return Va(A2(zi, function(n) {
                return n.ft;
            }, A2(Yc, U1, n.av)));
        }(n)));
    }, X1 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), J1 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, G1 = function(n) {
        return dc(A2(Ho, Nb, So(function(n) {
            return Lo(J1(A2(X1, n, 1)));
        }(n))));
    }, _1 = function(n) {
        return qs(1e3 * n.at / n.as) / 1e3;
    }, n0 = function(n) {
        return A2(Fu, _1, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av))));
    }, r0 = F6(function(n, r, t, e, u, a) {
        return {
            iG: e,
            kg: t,
            mm: n,
            nq: u,
            n5: r,
            n9: a
        };
    }), t0 = Po(A4(rc, "needAccept", function(n) {
        return n.n9;
    }, no, A4(Do, "logo", function(n) {
        return n.nq;
    }, xi, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iG;
    }, no, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(r0)))))))), e0 = function(n) {
        return dc(A2(Ho, t0, So(function(n) {
            return Lo(B$(A2(wM, n, 6)));
        }(n))));
    }, u0 = function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return {
                                                R: i,
                                                cz: c,
                                                bK: r,
                                                bP: a,
                                                fB: s,
                                                cZ: u,
                                                c2: e,
                                                oL: t,
                                                bj: o,
                                                g6: n
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }, a0 = F3(function(n, r, t) {
        return {
            bD: n,
            bJ: t,
            bQ: r
        };
    }), i0 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            kg: t,
            eM: e,
            eS: u,
            fe: a,
            fg: c,
            mm: n,
            di: i,
            g6: r,
            h5: o
        };
    }), o0 = Po(A4(Do, "generatedWithMapping", function(n) {
        return n.fg;
    }, ob, A4(Do, "uploadLog", function(n) {
        return n.h5;
    }, xi, A4(Do, "rejection", function(n) {
        return n.di;
    }, xi, A4(Do, "framerate", function(n) {
        return n.fe;
    }, mS, A4(Do, "duration", function(n) {
        return n.eS;
    }, mS, A4(Do, "deliveryProgress", function(n) {
        return n.eM;
    }, uc, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(i0))))))))))), c0 = F3(function(n, r, t) {
        return {
            d6: r,
            fY: n,
            ad: t
        };
    }), s0 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            a6: r,
            kG: i,
            lB: n,
            pl: e,
            gM: a,
            gN: u,
            g0: o,
            av: t,
            hE: c
        };
    }), f0 = F4(function(n, r, t, e) {
        return {
            mm: n,
            gj: t,
            rS: r,
            r2: e
        };
    }), l0 = Po(A4(rc, "transcoding", function(n) {
        return n.r2;
    }, AR, A4(rc, "organizationName", function(n) {
        return n.gj;
    }, xi, A4(rc, "title", function(n) {
        return n.rS;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(f0)))))), m0 = F6(function(n, r, t, e, u, a) {
        return {
            ah: u,
            eS: e,
            z: n,
            e9: t,
            cW: r,
            hV: a
        };
    }), d0 = Po(A4(Do, "timecode", function(n) {
        return n.hV;
    }, xi, A4(Do, "bitRate", function(n) {
        return n.ah;
    }, uc, A4(Do, "duration", function(n) {
        return n.eS;
    }, mS, A4(rc, "formatLongName", function(n) {
        return n.e9;
    }, xi, A4(rc, "formatName", function(n) {
        return n.cW;
    }, xi, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, Io(m0)))))))), b0 = F7(function(n, r, t, e, u, a, i) {
        return {
            kg: e,
            bK: t,
            lB: u,
            bb: a,
            bc: i,
            mm: n,
            m6: r
        };
    }), p0 = function(n) {
        switch(n){
            case 0:
                return "openingCredits";
            case 1:
                return "endingCredits";
            case 2:
                return "introduction";
            case 3:
                return "program";
            case 4:
                return "trailer";
            case 5:
                return "advertising";
            case 6:
                return "testPattern";
            case 7:
                return "black";
            case 8:
                return "slate";
            case 9:
                return "neutralBases";
            default:
                return "customDelivery";
        }
    }, v0 = function(n) {
        switch(n){
            case "openingCredits":
                return St(0);
            case "endingCredits":
                return St(1);
            case "introduction":
                return St(2);
            case "program":
                return St(3);
            case "trailer":
                return St(4);
            case "advertising":
                return St(5);
            case "testPattern":
                return St(6);
            case "black":
                return St(7);
            case "slate":
                return St(8);
            case "neutralBases":
                return St(9);
            case "customDelivery":
                return St(10);
            default:
                return wt("Can't parse segment from string: " + n);
        }
    }, $0 = A2(Il, p0, v0), g0 = Po(A4(rc, "frameOut", function(n) {
        return n.bc;
    }, uc, A4(rc, "frameIn", function(n) {
        return n.bb;
    }, uc, A4(rc, "file", function(n) {
        return n.lB;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, Wv, A4(rc, "label", function(n) {
        return n.m6;
    }, $0, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(b0))))))))), h0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, k0 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, T0 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, w0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, C0 = function(n) {
        switch(n){
            case "Mono":
                return St(0);
            case "DualMono":
                return St(1);
            case "Stereo":
                return St(2);
            case "StereoL":
                return St(3);
            case "StereoR":
                return St(4);
            case "FiveDotOne":
                return St(5);
            case "FiveDotOneL":
                return St(6);
            case "FiveDotOneR":
                return St(7);
            case "FiveDotOneC":
                return St(8);
            case "FiveDotOneSL":
                return St(9);
            case "FiveDotOneSR":
                return St(10);
            case "FiveDotOneLFE":
                return St(11);
            case "SevenDotOne":
                return St(12);
            case "OneTrack":
                return St(13);
            default:
                return wt("Unknown Layout");
        }
    }, N0 = function(n) {
        switch(n){
            case 0:
                return "Mono";
            case 1:
                return "DualMono";
            case 2:
                return "Stereo";
            case 3:
                return "StereoL";
            case 4:
                return "StereoR";
            case 5:
                return "FiveDotOne";
            case 6:
                return "FiveDotOneL";
            case 7:
                return "FiveDotOneR";
            case 8:
                return "FiveDotOneC";
            case 9:
                return "FiveDotOneSL";
            case 10:
                return "FiveDotOneSR";
            case 11:
                return "FiveDotOneLFE";
            case 12:
                return "SevenDotOne";
            default:
                return "OneTrack";
        }
    }, A0 = A2(Il, N0, C0), S0 = function(n) {
        switch(n){
            case "ORIGINAL":
                return St(0);
            case "DUBBED":
                return St(1);
            case "AD":
                return St(2);
            case "MUTE":
                return St(3);
            case "INT":
                return St(4);
            case "ME":
                return St(5);
            case "VONLY":
                return St(6);
            case "C1":
                return St(7);
            case "C2":
                return St(8);
            case "C3":
                return St(9);
            case "C4":
                return St(10);
            case "C5":
                return St(11);
            case "C6":
                return St(12);
            case "C7":
                return St(13);
            case "C8":
                return St(14);
            case "C9":
                return St(15);
            case "C10":
                return St(16);
            default:
                return wt("Not an audio type version");
        }
    }, L0 = function(n) {
        switch(n){
            case 0:
                return "ORIGINAL";
            case 1:
                return "DUBBED";
            case 2:
                return "AD";
            case 3:
                return "MUTE";
            case 4:
                return "INT";
            case 5:
                return "ME";
            case 6:
                return "VONLY";
            case 7:
                return "C1";
            case 8:
                return "C2";
            case 9:
                return "C3";
            case 10:
                return "C4";
            case 11:
                return "C5";
            case 12:
                return "C6";
            case 13:
                return "C7";
            case 14:
                return "C8";
            case 15:
                return "C9";
            default:
                return "C10";
        }
    }, y0 = A2(Il, L0, S0), F0 = Po(A4(Do, "typeVersion", function(n) {
        return n.r5;
    }, y0, A4(Do, "version", function(n) {
        return n.sv;
    }, h$, A4(Do, "channelLayout", function(n) {
        return n.aC;
    }, A0, A4(Do, "bitRate", function(n) {
        return n.ah;
    }, uc, A4(rc, "bitsPerSample", function(n) {
        return n.ef;
    }, uc, A4(rc, "channels", function(n) {
        return n.cz;
    }, uc, A4(rc, "sampleFormat", function(n) {
        return n.gW;
    }, xi, A4(rc, "sampleRate", function(n) {
        return n.gX;
    }, uc, A4(Do, "duration", function(n) {
        return n.eS;
    }, mS, A4(rc, "codecLongName", function(n) {
        return n.aE;
    }, xi, A4(rc, "codecName", function(n) {
        return n.ai;
    }, xi, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return {
                                                            ah: s,
                                                            ef: c,
                                                            aC: f,
                                                            cz: o,
                                                            aE: e,
                                                            ai: t,
                                                            eS: u,
                                                            z: n,
                                                            ft: r,
                                                            gW: i,
                                                            gX: a,
                                                            r5: m,
                                                            sv: l
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), j0 = F3(function(n, r, t) {
        return {
            z: n,
            ft: r,
            hV: t
        };
    }), P0 = Po(A4(Do, "timecode", function(n) {
        return n.hV;
    }, xi, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, Io(j0))))), I0 = Po(A4(Do, "typeVersion", function(n) {
        return n.r5;
    }, SS, A4(Do, "subtitleType", function(n) {
        return n.hB;
    }, xi, A4(Do, "lastCueTimecode", function(n) {
        return n.fK;
    }, xi, A4(Do, "firstCueTimecode", function(n) {
        return n.e6;
    }, xi, A4(Do, "startTimecode", function(n) {
        return n.q4;
    }, xi, A4(Do, "frameRateDenominator", function(n) {
        return n.fc;
    }, uc, A4(Do, "frameRateNumerator", function(n) {
        return n.fd;
    }, uc, A4(Do, "version", function(n) {
        return n.sv;
    }, h$, A4(Do, "codecLongName", function(n) {
        return n.aE;
    }, xi, A4(Do, "codecName", function(n) {
        return n.ai;
    }, xi, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return {
                                                        aE: e,
                                                        ai: t,
                                                        z: n,
                                                        e6: c,
                                                        fc: i,
                                                        fd: a,
                                                        ft: r,
                                                        fK: s,
                                                        q4: o,
                                                        hB: f,
                                                        r5: l,
                                                        sv: u
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), B0 = Po(A4(Do, "nbFrames", function(n) {
        return n.gc;
    }, uc, A4(Do, "timecode", function(n) {
        return n.hV;
    }, xi, A4(Do, "scanningType", function(n) {
        return n.gY;
    }, xi, A4(Do, "chromaSubsampling", function(n) {
        return n.cA;
    }, xi, A4(Do, "profile", function(n) {
        return n.gD;
    }, xi, A4(Do, "level", function(n) {
        return n.ne;
    }, uc, A4(rc, "rFrameRateDenominator", function(n) {
        return n.as;
    }, uc, A4(rc, "rFrameRateNumerator", function(n) {
        return n.at;
    }, uc, A4(Do, "bitRate", function(n) {
        return n.ah;
    }, uc, A4(rc, "displayAspectRatioDenominator", function(n) {
        return n.cH;
    }, uc, A4(rc, "displayAspectRatioNumerator", function(n) {
        return n.cI;
    }, uc, A4(rc, "height", function(n) {
        return n.fk;
    }, uc, A4(rc, "width", function(n) {
        return n.id;
    }, uc, A4(Do, "duration", function(n) {
        return n.eS;
    }, mS, A4(rc, "codecLongName", function(n) {
        return n.aE;
    }, xi, A4(rc, "codecName", function(n) {
        return n.ai;
    }, xi, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, A4(rc, "fileId", function(n) {
        return n.z;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return function($) {
                                                                            return {
                                                                                ah: s,
                                                                                cA: b,
                                                                                aE: e,
                                                                                ai: t,
                                                                                cH: c,
                                                                                cI: o,
                                                                                eS: u,
                                                                                z: n,
                                                                                fk: i,
                                                                                ft: r,
                                                                                ne: m,
                                                                                gc: $,
                                                                                gD: d,
                                                                                as: l,
                                                                                at: f,
                                                                                gY: p,
                                                                                hV: v,
                                                                                id: a
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))), M0 = ld(A4(gb, "DataStream", k0, P0, A4(gb, "SubtitleStream", T0, I0, A4(gb, "AudioStream", h0, F0, A4(gb, "VideoStream", w0, B0, bd(F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return n(u.a);
            case 1:
                return r(u.a);
            case 2:
                return t(u.a);
            default:
                return e(u.a);
        }
    }))))))), O0 = F2(function(n, r) {
        return {
            fm: r,
            nv: n
        };
    }), q0 = Po(A4(Do, "hiRes", function(n) {
        return n.fm;
    }, kV, A4(Do, "lowRes", function(n) {
        return n.nv;
    }, kV, Io(O0)))), D0 = F2(function(n, r) {
        return {
            n5: n,
            hV: r
        };
    }), x0 = Po(A4(rc, "timecode", function(n) {
        return n.hV;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(D0)))), R0 = Po(A4(rc, "subtitleWarnings", function(n) {
        return n.hE;
    }, oc(x0), A4(rc, "segments", function(n) {
        return n.g0;
    }, oc(g0), A4(rc, "deliveries", function(n) {
        return n.kG;
    }, oc(l0), A4(Do, "reportPdf", function(n) {
        return n.gM;
    }, kV, A4(Do, "reportXml", function(n) {
        return n.gN;
    }, kV, A4(rc, "proxies", function(n) {
        return n.pl;
    }, q0, A4(rc, "streams", function(n) {
        return n.av;
    }, oc(M0), A4(Do, "container", function(n) {
        return n.a6;
    }, d0, A4(rc, "file", function(n) {
        return n.lB;
    }, kV, Io(s0))))))))))), V0 = Po(A4(rc, "subtitles", function(n) {
        return n.ad;
    }, oc(R0), A4(rc, "audios", function(n) {
        return n.d6;
    }, oc(R0), A4(Do, "material", function(n) {
        return n.fY;
    }, R0, Io(c0))))), E0 = F2(function(n, r) {
        return {
            cU: n,
            su: r
        };
    }), z0 = function(n) {
        switch(n){
            case "RedFlag":
                return St(0);
            case "OrangeFlag":
                return St(1);
            case "GreenFlag":
                return St(2);
            default:
                return St(3);
        }
    }, U0 = function(n) {
        switch(n){
            case 0:
                return "RedFlag";
            case 1:
                return "OrangeFlag";
            case 2:
                return "GreenFlag";
            default:
                return "BlueFlag";
        }
    }, H0 = A2(Il, U0, z0), W0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Q0 = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Z0 = F3(function(n, r, t) {
        return {
            eR: t,
            lU: r,
            ss: n
        };
    }), K0 = Po(A4(rc, "dropFrame", function(n) {
        return n.eR;
    }, no, A4(rc, "frameRate", function(n) {
        return n.lU;
    }, mS, A4(rc, "value", function(n) {
        return n.ss;
    }, uc, Io(Z0))))), Y0 = F4(function(n, r, t, e) {
        return A3($b, n, F3(function(n, r, u) {
            return n(T([
                A2(Bo, t, r),
                A2(Bo, e, u)
            ]));
        }), A3(Fe, r, A2(xc, 1, bi(t)), A2(xc, 2, bi(e))));
    }), X0 = ld(A5(Y0, "VerificationRange", Q0, K0, K0, A4(gb, "VerificationFrame", W0, K0, A3(lV, "Verification", af, bd(F4(function(n, r, t, e) {
        switch(e.$){
            case 0:
                return n;
            case 1:
                return r(e.a);
            default:
                return A2(t, e.a, e.b);
        }
    })))))), J0 = Po(A4(rc, "verification", function(n) {
        return n.su;
    }, X0, A4(rc, "flag", function(n) {
        return n.cU;
    }, H0, Io(E0)))), G0 = F7(function(n, r, t, e, u, a, i) {
        return {
            bI: a,
            kg: t,
            bK: r,
            mm: n,
            nO: i,
            cl: u,
            cm: e
        };
    }), _0 = Po(A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(rc, "comment", function(n) {
        return n.bI;
    }, xi, A4(rc, "updatedAt", function(n) {
        return n.cl;
    }, td, A4(rc, "updater", function(n) {
        return n.cm;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, Wv, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(G0))))))))), n2 = oc(_0), r2 = F3(function(n, r, t) {
        return {
            e: A2(ye, n, bi(t)),
            g: function(n) {
                return A2(Bo, t, r(n));
            }
        };
    }), t2 = A3(r2, function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, function(n) {
        return n.a;
    }, xi), e2 = Po(A4(rc, "answers", function(n) {
        return n.d0;
    }, n2, A4(rc, "annotations", function(n) {
        return n.S;
    }, oc(J0), A4(Do, "frame", function(n) {
        return n.bU;
    }, K0, A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(rc, "broadcastable", function(n) {
        return n.bD;
    }, xi, A4(rc, "updatedAt", function(n) {
        return n.cl;
    }, td, A4(rc, "updater", function(n) {
        return n.cm;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, Wv, A4(rc, "id", function(n) {
        return n.mm;
    }, t2, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return {
                                                S: c,
                                                d0: s,
                                                bD: a,
                                                kg: t,
                                                bK: r,
                                                bU: o,
                                                mm: n,
                                                nO: i,
                                                cl: u,
                                                cm: e
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), u2 = oc(e2), a2 = Po(A4(rc, "comments", function(n) {
        return n.bJ;
    }, u2, A4(rc, "files", function(n) {
        return n.bQ;
    }, V0, A4(rc, "broadcastable", function(n) {
        return n.bD;
    }, o0, Io(a0))))), i2 = oc(a2), o2 = F5(function(n, r, t, e, u) {
        return {
            a6: e,
            lB: n,
            gI: r,
            g0: t,
            av: u
        };
    }), c2 = Po(A4(rc, "streams", function(n) {
        return n.av;
    }, oc(M0), A4(Do, "container", function(n) {
        return n.a6;
    }, d0, A4(rc, "segments", function(n) {
        return n.g0;
    }, oc(g0), A4(Do, "proxy", function(n) {
        return n.gI;
    }, kV, A4(rc, "file", function(n) {
        return n.lB;
    }, kV, Io(o2))))))), s2 = oc(c2), f2 = F2(function(n, r) {
        return {
            fz: n,
            sp: r
        };
    }), l2 = Po(A4(rc, "user", function(n) {
        return n.sp;
    }, Wv, A4(rc, "invitation", function(n) {
        return n.fz;
    }, Ev, Io(f2)))), m2 = function(n) {
        switch(n){
            case "QC":
                return St(1);
            case "Spotcheck":
                return St(0);
            case "DownloadAsIs":
                return St(2);
            case "SimpleTranscode":
                return St(3);
            case "PADTranscode":
                return St(4);
            default:
                return wt("Can't parse jobtype " + n);
        }
    }, d2 = A2(Il, kf, m2), b2 = Po(A4(Do, "format", function(n) {
        return n.lR;
    }, xi, A4(Do, "externalJobId", function(n) {
        return n.lu;
    }, xi, A4(rc, "jobType", function(n) {
        return n.fG;
    }, d2, A4(rc, "requester", function(n) {
        return n.pG;
    }, xi, A4(rc, "organization", function(n) {
        return n.oL;
    }, xi, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, A4(Do, "completedAt", function(n) {
        return n.j0;
    }, td, A4(Do, "startedAt", function(n) {
        return n.q5;
    }, td, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return {
                                                j0: e,
                                                kg: r,
                                                lu: c,
                                                lR: s,
                                                mm: n,
                                                fG: o,
                                                oL: a,
                                                pG: i,
                                                g6: u,
                                                q5: t
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), p2 = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), v2 = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(p2)))), $2 = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), g2 = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io($2)))), h2 = Po(A5(gP, "additionalVideoFormats", function(n) {
        return n.iv;
    }, oc(xi), g, A4(rc, "subtitleFormats", function(n) {
        return n.dw;
    }, oc(g2), A4(rc, "formats", function(n) {
        return n.cX;
    }, oc(v2), A4(Do, "logo", function(n) {
        return n.nq;
    }, xi, A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iG;
    }, no, A4(rc, "manualDelivery", function(n) {
        return n.nJ;
    }, no, A4(Do, "broadcaster", function(n) {
        return n.jp;
    }, y$, A4(rc, "enableAutoReject", function(n) {
        return n.lb;
    }, no, A4(rc, "enableAutoAccept", function(n) {
        return n.la;
    }, no, A4(rc, "enableUploadSuccessEmail", function(n) {
        return n.le;
    }, no, A4(rc, "enableVideoReadyEmail", function(n) {
        return n.lf;
    }, no, A4(rc, "enableCreationEmail", function(n) {
        return n.lc;
    }, no, A4(rc, "qcMasterReportTemplate", function(n) {
        return n.pp;
    }, xi, A4(rc, "qcMasterTestPlan", function(n) {
        return n.pq;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return function(c) {
                                        return function(s) {
                                            return function(f) {
                                                return function(l) {
                                                    return function(m) {
                                                        return function(d) {
                                                            return function(b) {
                                                                return function(p) {
                                                                    return function(v) {
                                                                        return {
                                                                            iv: v,
                                                                            iG: m,
                                                                            jp: f,
                                                                            kg: r,
                                                                            la: c,
                                                                            lb: s,
                                                                            lc: a,
                                                                            le: o,
                                                                            lf: i,
                                                                            cX: b,
                                                                            mm: n,
                                                                            nq: d,
                                                                            nJ: l,
                                                                            n5: t,
                                                                            pp: u,
                                                                            pq: e,
                                                                            dw: p
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), k2 = Po(A4(rc, "invitations", function(n) {
        return n.fB;
    }, oc(l2), A4(rc, "channels", function(n) {
        return n.cz;
    }, oc(Aw), A4(rc, "previousBroadcastables", function(n) {
        return n.bj;
    }, i2, A4(rc, "activeBroadcastable", function(n) {
        return n.R;
    }, a2, A4(rc, "extras", function(n) {
        return n.bP;
    }, s2, A4(rc, "jobs", function(n) {
        return n.cZ;
    }, oc(b2), A4(rc, "metadata", function(n) {
        return n.c2;
    }, nc(Hb), A4(rc, "organization", function(n) {
        return n.oL;
    }, h2, A4(rc, "creator", function(n) {
        return n.bK;
    }, Wv, A4(rc, "show", function(n) {
        return n.g6;
    }, Wb, Io(u0)))))))))))), T2 = function(n) {
        return dc(A2(Ho, k2, So(SX(n))));
    }, w2 = function(n) {
        return 3 === n.$ ? kt(n.a) : Tt;
    }, C2 = function(n) {
        return Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av)));
    }, N2 = F2(function(n, r) {
        return r.$ ? n : kt(r.a);
    }), S2 = function(n) {
        var r = A2(fp, function(n) {
            return n.hV;
        }, C2(n)), t = A2(fp, function(n) {
            return n.hV;
        }, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, w2, n.av))));
        return A2(N2, r, A2(N2, t, A2(fp, function(n) {
            return n.hV;
        }, n.a6)));
    }, L2 = function(n) {
        var r = A2(fp, function(n) {
            return n.hV;
        }, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av)))), t = A2(fp, function(n) {
            return n.hV;
        }, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, w2, n.av))));
        return A2(N2, r, A2(N2, t, A2(fp, function(n) {
            return n.hV;
        }, n.a6)));
    }, y2 = function(n) {
        return n.P.nl || n.e0.nl;
    }, j2 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, P2 = F3(function(n, r, t) {
        return {
            n5: n,
            r6: r,
            ss: t
        };
    }), I2 = Po(A4(rc, "value", function(n) {
        return n.ss;
    }, Hb, A4(rc, "type", function(n) {
        return n.r6;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(P2))))), B2 = oc(I2), M2 = function(n) {
        return Lo(J1(A2(X1, n, 0)));
    }, O2 = function(n) {
        return dc(A2(Ho, B2, So(M2(n))));
    }, q2 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, D2 = function(n) {
        return A2(Yi, q2, dc(A2(Ho, TP, So(Lo(B$(A2(wM, n, 5)))))));
    }, x2 = F2(function(n, r) {
        return bc(T([
            A2(Yi, j2, O2(r)),
            D2(n)
        ]));
    }), R2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, V2 = A2(bu, dJ, R2), E2 = F2(function(n, r) {
        return A2(Fu, A2(bu, function(n) {
            return n.jt;
        }, function(n) {
            return n.lB;
        }), A2(V1, n, r).bQ.fY);
    }), z2 = F2(function(n, r) {
        return A2(Fu, A2(bu, function(n) {
            return n.m2;
        }, function(n) {
            return n.lB;
        }), A2(V1, n, r).bQ.fY);
    }), U2 = F2(function(n, r) {
        return A2(fp, function(n) {
            var r = n.r2;
            return r.$ ? Tt : 5 === r.a.o1 ? kt(n) : Tt;
        }, A2(fp, A2(No, function(n) {
            return n.pl;
        }, n.$9.l1 ? function(n) {
            return n.fm;
        } : function(n) {
            return n.nv;
        }), A2(V1, n, r).bQ.fY));
    }), H2 = function(n) {
        var r = n.P.kv;
        if (1 === r.$) return Tt;
        var t, e = r.a, u = (t = A2(Fu, function(n) {
            return n.ro;
        }, n.o2)).$ || t.a.$ ? Tt : kt(t.a.a), a = A2(V1, n, e).bQ.fY, i = A2(ju, "00:00:00:00", A2(fp, S2, a)), o = A2(fp, function(n) {
            return kt((n.at / n.as * 1e3 | 0) / 1e3);
        }, A2(fp, C2, a)), c = A2(fp, function(n) {
            return n.eS;
        }, A2(fp, C2, a));
        return A2(Fu, function(r) {
            return {
                i0: A2(ju, g, A2(Fu, W1, a)),
                jt: A2(E2, n, e),
                eS: c,
                lU: o,
                m2: A2(z2, n, e),
                n2: A2(ju, r.mm, A2(Fu, function(n) {
                    return n.n2;
                }, n.o2)),
                qp: A2(fp, function(n) {
                    return n.qp;
                }, n.o2),
                qq: A2(ju, g, A2(Fu, function(n) {
                    return n.qq;
                }, n.o2)),
                q4: i,
                ro: u
            };
        }, A2(U2, n, e));
    }, W2 = function(n) {
        return p(n.i4, {
            qo: Tt
        });
    }, Q2 = F2(function(n, r) {
        var t;
        return p(n.o5, {
            lU: 1 === (t = r.lU).$ ? 0 : t.a,
            q4: r.q4,
            ro: r.ro
        });
    }), Z2 = F2(function(n, r) {
        var t = H2(n);
        return qK(p(n, {
            i4: r ? W2(n) : n.i4,
            o2: t,
            o5: 1 === t.$ ? n.o5 : A2(Q2, n, t.a)
        }));
    }), K2 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Y2 = A2(bu, dJ, K2), X2 = function(n) {
        var r = n.P;
        return p(n, {
            e0: p(n.e0, {
                nl: !0
            }),
            P: p(r, {
                nl: !0
            })
        });
    }, J2 = Kn("info", function() {
        return pi;
    }), G2 = J2(0), _2 = Kn("getPlayerName", function() {
        return pi;
    }), n3 = _2(0), r3 = function(n) {
        return A2(Gv, Ie, oN(function(n) {
            return {
                $: 37,
                a: n
            };
        }(n)));
    }, t3 = function(n) {
        return A2(Gv, Ie, oN(function(n) {
            return {
                $: 36,
                a: n
            };
        }(n)));
    }, e3 = function(n) {
        switch(n){
            case 0:
            case 4:
            case 5:
            default:
                return 3;
            case 1:
            case 6:
                return 0;
            case 2:
            case 7:
                return 1;
            case 3:
            case 8:
                return 2;
        }
    }, u3 = F3(function(n, r, t) {
        return {
            il: n,
            em: r,
            bU: t
        };
    }), a3 = F2(function(n, r) {
        return {
            eZ: r,
            hp: n
        };
    }), i3 = A3(Fe, a3, A2(mu, "start", fS), A2(mu, "end", fS)), o3 = an, c3 = A4(o3, u3, A2(mu, "action", Bi), A2(mu, "buffer", ac(i3)), A2(mu, "frame", tc)), s3 = F4(function(n, r, t, e) {
        return A2(Xs, t, A8(Os, n, Ds(n), e, 0, 0, 0, r, 0));
    }), f3 = Kn("elmToJs", Ie), l3 = (KW = $i(T([
        m("action", gi("Fullscreen"))
    ])), f3(KW)), m3 = F3(function(n, r, t) {
        var e = $i(T([
            m("action", gi("GetPicture")),
            m("rawFrame", $i(T([
                m("frameRate", lS(t.lU)),
                m("bucket", gi(n)),
                m("key", gi(r))
            ])))
        ]));
        return f3(e);
    }), d3 = function() {
        var n = $i(T([
            m("action", gi("GoToEnd"))
        ]));
        return f3(n);
    }(), b3 = function() {
        var n = $i(T([
            m("action", gi("GoToStart"))
        ]));
        return f3(n);
    }(), p3 = function() {
        var n = $i(T([
            m("action", gi("NextFrame"))
        ]));
        return f3(n);
    }(), v3 = function() {
        var n = $i(T([
            m("action", gi("Pause"))
        ]));
        return f3(n);
    }(), $3 = function() {
        var n = $i(T([
            m("action", gi("Play"))
        ]));
        return f3(n);
    }(), g3 = function() {
        var n = $i(T([
            m("action", gi("PrevFrame"))
        ]));
        return f3(n);
    }(), h3 = F2(function(n, r) {
        var t = $i(T([
            m("action", gi(n + "Time")),
            m("seconds", lS(r))
        ]));
        return f3(t);
    }), k3 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(p(r, {
                    mN: !1,
                    mR: !0
                }), $3);
            case 1:
                return m(p(r, {
                    mR: !1
                }), v3);
            case 6:
                return m(r, A2(h3, n.a, n.b));
            case 2:
                return m(p(r, {
                    kn: 0,
                    kp: A4(s3, r.lU, 0, "00:00:00:00", !1)
                }), b3);
            case 3:
                return m(r, d3);
            case 4:
                return function(n) {
                    return m(n, n.mR ? n$ : p3);
                }(r);
            case 5:
                return function(n) {
                    return m(n, n.mR ? n$ : g3);
                }(r);
            case 7:
                return m(r, l3);
            case 8:
                return m(p(r, {
                    iY: !r.iY
                }), n$);
            case 9:
                var t = n.a, e = n.b;
                return m(r, A3(m3, t.$ ? "" : t.a, e.$ ? "" : e.a, r));
            case 10:
                return m(p(r, {
                    gu: n.a
                }), n$);
            default:
                var u = (a = A2(di, c3, n.a)).$ ? {
                    il: "",
                    em: g,
                    bU: 0
                } : a.a;
                return m("Added" === u.il ? p(r, {
                    iu: !0
                }) : "Buffering" === u.il ? p(r, {
                    mL: !0
                }) : "StopBuffering" === u.il ? p(r, {
                    mL: !1
                }) : "Finished" === u.il ? p(r, {
                    mN: !0,
                    mR: !1
                }) : "Loaded" === u.il ? p(r, {
                    em: u.em
                }) : "Playing" === u.il ? p(r, {
                    kn: u.bU,
                    kp: A4(s3, r.lU, u.bU, "00:00:00:00", !1),
                    mN: !1,
                    mR: !0
                }) : "isPaused" === u.il ? p(r, {
                    kn: u.bU,
                    kp: A4(s3, r.lU, u.bU, "00:00:00:00", !1),
                    mR: !1
                }) : r, n$);
        }
        var a;
    }), T3 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, w3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, C3 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, N3 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, S3 = {
        $: 3
    }, L3 = {
        $: 1
    }, y3 = Oi({
        bN: "The selected channel doesn\u2019t exist",
        bT: "La chaine s\xe9lectionn\xe9e n\u2019existe pas."
    }), j3 = Oi({
        bN: "You need to choose another channel",
        bT: "Vous devez choisir une chaine."
    }), P3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), I3 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, B3 = function(n) {
        return Lo(I3(A2(P3, n, 1)));
    }, M3 = Po(A4(Do, "channel", function(n) {
        return n.bE;
    }, xi, Io(function(n) {
        return {
            bE: n
        };
    }))), O3 = F2(function(n, r) {
        var t = "" === r ? Tt : kt(r);
        return dc(fg(A3(ag, M3, {
            bE: t
        }, rg(B3(n.mm)))));
    }), q3 = F4(function(n, r, t, e) {
        var u = Cu(t) ? oN(0) : "" === e ? BL(IL(A2(ki, j3, vi))) : A2(du, function(n) {
            return i(n.ss, e);
        }, t) ? oN(0) : BL(IL(A2(ki, y3, vi)));
        return A2(OC, function() {
            return function(n) {
                return dc(fg(rg(ml(AX(A2(NX, n.mm, 6))))));
            }(n);
        }, A2(OC, function() {
            return n.c$ ? oN(0) : A2(O3, r, e);
        }, u));
    }), D3 = Po(A4(rc, "rejection", function(n) {
        return n.di;
    }, xi, Io(function(n) {
        return {
            di: n
        };
    }))), x3 = F2(function(n, r) {
        return A2(Gb, function() {
            return 0;
        }, dc(A2(Ho, o0, A3(ag, D3, {
            di: r
        }, rg(ml(AX(A2(NX, n.mm, 4))))))));
    }), R3 = function(n) {
        return 1 === n.$;
    }, V3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), E3 = function(n) {
        return {
            $: 18,
            a: n
        };
    }, z3 = F2(function(n, r) {
        return dc(fg(mg(ml(E3(A2(V3, r.mm, 2))))));
    }), U3 = A2(No, Iq, gZ), H3 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return qK(p(r, {
                    gh: !r.gh
                }));
            case 1:
                return qK(p(r, {
                    nG: A2(gg, n.a, r.nG)
                }));
            case 2:
                return qK(p(r, {
                    nF: A2(gg, n.a, r.nF)
                }));
            case 3:
                var t = n.a, e = n.b, u = R3(r.nH) ? r : p(r, {
                    nH: L3
                });
                return A2(jX, T([
                    A2(Yi, N3, A2(z3, t, e))
                ]), qK(u));
            case 4:
            case 6:
                return (o = n.a).$ ? qK(p(r, {
                    nH: w3(o.a)
                })) : A2(IX, 1, qK(p(r, {
                    nF: U3(r.nF),
                    nG: U3(r.nG),
                    nH: nf
                })));
            case 5:
                t = n.a;
                var a = n.b, i = n.c;
                return R3(r.nH) ? MK : A2(jX, T([
                    A2(Yi, T3, A4(q3, t, a, i, r.nF.ss))
                ]), qK(p(r, {
                    nH: L3
                })));
            case 7:
                return t = n.a, R3(r.nH) ? MK : "" === r.nG.ss ? qK(p(r, {
                    nH: S3
                })) : A2(jX, T([
                    A2(Yi, C3, A2(x3, t, r.nG.ss))
                ]), qK(p(r, {
                    nH: L3
                })));
            case 8:
                var o;
                return (o = n.a).$ ? qK(p(r, {
                    nH: w3(o.a)
                })) : A2(IX, 2, qK(p(r, {
                    nF: U3(r.nF),
                    nG: U3(r.nG),
                    nH: nf,
                    gh: !1
                })));
            default:
                return qK(p(r, {
                    nH: nf
                }));
        }
    }), W3 = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), Q3 = F2(function(n, r) {
        return {
            $: 26,
            a: n,
            b: r
        };
    }), Z3 = F2(function(n, r) {
        return {
            $: 24,
            a: n,
            b: r
        };
    }), K3 = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), Y3 = F2(function(n, r) {
        return {
            $: 19,
            a: n,
            b: r
        };
    }), X3 = function(n) {
        return {
            $: 14,
            a: n
        };
    }, J3 = function(n) {
        return {
            $: 42,
            a: n
        };
    }, G3 = function(n) {
        return {
            $: 38,
            a: n
        };
    }, _3 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, n6 = {
        $: 1
    }, r6 = F2(function(n, r) {
        return {
            $: 20,
            a: n,
            b: r
        };
    }), t6 = function(n) {
        return {
            $: 15,
            a: n
        };
    }, e6 = function(n) {
        return {
            $: 40,
            a: n
        };
    }, u6 = function(n) {
        return {
            $: 45,
            a: n
        };
    }, a6 = {
        $: 2
    }, i6 = F7(function(n, r, t, e, u, a, i) {
        return {
            bI: a,
            kg: t,
            bK: r,
            mm: n,
            nO: i,
            cl: u,
            cm: e
        };
    }), o6 = Po(A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(rc, "comment", function(n) {
        return n.bI;
    }, xi, A4(rc, "updatedAt", function(n) {
        return n.cl;
    }, td, A4(rc, "updater", function(n) {
        return n.cm;
    }, xi, A4(rc, "createdAt", function(n) {
        return n.kg;
    }, td, A4(rc, "creator", function(n) {
        return n.bK;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(i6))))))))), c6 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), s6 = function(n) {
        return {
            $: 16,
            a: n
        };
    }, f6 = function(n) {
        return n.a;
    }, l6 = Po(A4(rc, "message", function(n) {
        return n.nO;
    }, xi, Io(function(n) {
        return {
            nO: n
        };
    }))), m6 = F2(function(n, r) {
        var t;
        return dc(A2(ng, o6, A3(ag, l6, {
            nO: r
        }, rg((t = f6(n.mm), ml(s6(A2(c6, t, 1))))))));
    }), d6 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            S: c,
            ek: a,
            kg: t,
            bK: r,
            ff: o,
            mm: n,
            nO: i,
            cl: u,
            cm: e
        };
    }), b6 = Po(A4(rc, "annotations", function(n) {
        return n.S;
    }, oc(J0), A4(Do, "frame", function(n) {
        return n.ff;
    }, K0, A4(rc, "message", function(n) {
        return n.nO;
    }, xi, A4(Do, "broadcastableId", function(n) {
        return n.ek;
    }, xi, Ub(d6)))))), p6 = function(n) {
        return ml(E3(A2(V3, n, 3)));
    }, v6 = F3(function(n, r, t) {
        return {
            S: t,
            bU: r,
            nO: n
        };
    }), $6 = Po(A4(rc, "annotations", function(n) {
        return n.S;
    }, oc(J0), A4(Do, "frame", function(n) {
        return n.bU;
    }, K0, A4(rc, "message", function(n) {
        return n.nO;
    }, xi, Io(v6))))), g6 = function(n) {
        return {
            eR: n.eR,
            lU: n.fe,
            ss: n.lT
        };
    }, h6 = function(n) {
        var r = n.bB, t = n.nO;
        return dc(A2(ng, b6, A3(ag, $6, {
            S: g,
            bU: A2(Fu, g6, n.kr),
            nO: t
        }, rg(p6(r)))));
    }, k6 = function(n) {
        return dc(fg(mg(ml(zC(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n))))));
    }, T6 = F4(function(n, r, t, e) {
        return {
            lu: t,
            lR: e,
            fG: r,
            g6: n
        };
    }), w6 = Po(A4(Do, "format", function(n) {
        return n.lR;
    }, xi, A4(Do, "externalJobId", function(n) {
        return n.lu;
    }, xi, A4(rc, "jobType", function(n) {
        return n.fG;
    }, RC, A4(rc, "show", function(n) {
        return n.g6;
    }, xi, Io(T6)))))), C6 = F2(function(n, r) {
        var t = r.sp.oL;
        if (t.$) return BL(A3(Yo, 1, "Organization not available", Au));
        var e = t.a, u = n.mX.ss;
        if (u.$) return BL(A3(Yo, 1, "JobType not selected", Au));
        var a = DC(u.a);
        return a.$ ? BL(A3(Yo, 1, "JobType not found", Au)) : dc(fg(A3(ag, w6, A4(T6, r.g6.mm, a.a, Tt, Tt), rg(function(n) {
            return ml(zC(function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(n)));
        }(e)))));
    }), N6 = F3(function(n, r, t) {
        return {
            bb: r,
            bc: t,
            m6: n
        };
    }), S6 = Po(A4(rc, "frameOut", function(n) {
        return n.bc;
    }, uc, A4(rc, "frameIn", function(n) {
        return n.bb;
    }, uc, A4(rc, "label", function(n) {
        return n.m6;
    }, $0, Io(N6))))), L6 = function(n) {
        return ml(Rq(A2(MV, n, 13)));
    }, y6 = function(n) {
        return dc(RZ(A3(ag, S6, {
            bb: n.bb,
            bc: n.bc,
            m6: n.m6
        }, rg(L6(n.z)))));
    }, j6 = function(n) {
        return ml(function(n) {
            return {
                $: 17,
                a: n
            };
        }(n));
    }, P6 = function(n) {
        return dc(fg(sg(j6(n.mm))));
    }, I6 = function(n) {
        return ml(s6(A2(c6, n, 0)));
    }, B6 = function(n) {
        return dc(fg(sg(I6(n))));
    }, M6 = Oi({
        bN: "Error while trying to delete comment",
        bT: "Echec de la suppression du commentaire."
    }), O6 = function(n) {
        return ml(function(n) {
            return {
                $: 27,
                a: n
            };
        }(n));
    }, q6 = function(n) {
        return dc(fg(sg(O6(n))));
    }, D6 = l6, x6 = F2(function(n, r) {
        return dc(A2(Ho, o6, A3(ag, D6, {
            nO: r
        }, mg(j6(n.mm)))));
    }), R6 = F2(function(n, r) {
        return {
            S: r,
            nO: n
        };
    }), V6 = Po(A4(rc, "annotations", function(n) {
        return n.S;
    }, oc(J0), A4(rc, "message", function(n) {
        return n.nO;
    }, xi, Io(R6)))), E6 = F3(function(n, r, t) {
        var e, u = (e = A2(lo, f6(r.mm), n.k2)).$ ? r.S : T([
            e.a
        ]);
        return dc(A2(Ho, b6, A3(ag, V6, {
            S: u,
            nO: t
        }, mg(I6(f6(r.mm))))));
    }), z6 = function(n) {
        return Ri(function(r) {
            return p(r, {
                ss: n
            });
        });
    }, U6 = F2(function(n, r) {
        return A2(_e, function(r) {
            return A2(nu, function(n) {
                return m(r, n);
            }, n(r));
        }, r);
    }), H6 = F3(function(n, r, t) {
        var e, u = v0(t), a = (e = A2(lo, f6(r.mm), n.k2)).$ ? A2(lD, "No annotations", Va(r.S)) : St(e.a), i = A2(hU, function(n) {
            var t = n.su;
            return 2 === t.$ ? St(m(t.a.ss, t.b.ss)) : wt("Can't get frame info from annotations for segment " + f6(r.mm));
        }, a);
        return A2(OC, function(n) {
            var t = n.b;
            return dc(RZ(A3(ag, S6, {
                bb: t.a,
                bc: t.b,
                m6: n.a
            }, mg(O6(f6(r.mm))))));
        }, A2(Qo, function(n) {
            return IL(A2(ki, n, f$));
        }, A2(U6, function() {
            return ML(i);
        }, ML(u))));
    }), W6 = function(n) {
        var r = $i(T([
            m("action", gi("GoTo")),
            m("frame", ec(n))
        ]));
        return f3(r);
    }, Q6 = function(n) {
        return Va(Kt(A2(zi, A2(bu, jN, function(n) {
            return n.kg;
        }), A2(Iu, function(n) {
            return i(n.j0, Tt) && i(n.q5, Tt);
        }, A2(Iu, function(n) {
            return 1 === n.fG || !n.fG;
        }, n)))));
    }, Z6 = function(n) {
        return Va(Kt(A2(zi, A2(bu, jN, function(n) {
            return n.kg;
        }), A2(Iu, function(n) {
            return i(n.j0, Tt) && !i(n.q5, Tt);
        }, A2(Iu, function(n) {
            return 1 === n.fG || !n.fG;
        }, n)))));
    }, K6 = A3(CZ, "message", T([
        A2(No, function(n) {
            return n.nO;
        }, AZ)
    ]), NZ), Y6 = A3(CZ, "message", T([
        A2(No, function(n) {
            return n.nO;
        }, AZ)
    ]), NZ), X6 = function(n) {
        switch(n){
            case "G\xe9n\xe9rique":
            case "Programme":
            case "Trailer":
            case "Mire":
            case "Noir":
            case "Panneau":
            case "Fonds neutres":
                return kt(3);
            default:
                return Tt;
        }
    }, J6 = function(n) {
        return dc(fg(mg(ml(zC(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n))))));
    }, G6 = function(n) {
        return dc(fg(rg(ml(Rq(A2(MV, n, 6))))));
    }, _6 = function(n) {
        return p(n, {
            gh: !n.gh
        });
    }, n5 = F2(function(n, r) {
        return p(r, {
            cU: n
        });
    }), r5 = F3(function(n, r, t) {
        var e = function() {
            var e = m(n, t.su);
            if (e.a) switch(e.b.$){
                case 1:
                case 2:
                    return A2(Q0, e.b.a, r);
                default:
                    return t.su;
            }
            else switch(e.b.$){
                case 0:
                case 1:
                    return W0(r);
                default:
                    return A2(Q0, r, e.b.b);
            }
        }();
        return p(t, {
            su: e
        });
    }), t5 = Oi({
        bN: "Answer",
        bT: "R\xe9pondre"
    }), e5 = Ri(function(n) {
        return p(n, {
            gt: t5
        });
    }), u5 = F3(function(n, r, t) {
        return A3(ko, n, function(n) {
            return kt(A2(gg, r, 1 === n.$ ? e5 : n.a));
        }, t);
    }), a5 = F3(function(n, r, t) {
        return A3(ko, n, function(n) {
            return 1 === n.$ ? Tt : kt(A3(IZ, gZ(n.a), "message", r));
        }, t);
    }), i5 = F2(function(n, r) {
        return p(n, {
            ss: kt(r)
        });
    }), o5 = function(n) {
        var r = n.bB, t = n.nO;
        return dc(A2(ng, b6, A3(ag, $6, {
            S: T([
                n.iN
            ]),
            bU: Tt,
            nO: t
        }, rg(p6(r)))));
    }, c5 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 35:
                return qK(n.a.$ ? p(r, {
                    qh: Tx(v0(O = n.a.a)),
                    qi: A2(i5, r.qi, O)
                }) : p(r, {
                    qi: _6(r.qi)
                }));
            case 36:
                return qK(n.a.$ ? p(r, {
                    mX: A2(i5, r.mX, O = n.a.a)
                }) : p(r, {
                    mX: _6(r.mX)
                }));
            case 0:
                var e = n.a, u = r.iN, a = function() {
                    var n = X6(r.nO.ss);
                    return 1 === n.$ ? r : p(r, {
                        iN: p(u, {
                            cU: n.a
                        })
                    });
                }();
                return qK(p(a, {
                    nO: A2(gg, e, r.nO)
                }));
            case 1:
                return qK(p(r, {
                    iN: A3(r5, n.a, g6(t.kp), r.iN)
                }));
            case 2:
                return qK(p(r, {
                    iN: A2(n5, n.a, r.iN),
                    qh: Tt
                }));
            case 37:
                return A2(jX, T([
                    A2(Yi, G3, A2(C6, r, n.a))
                ]), qK(p(r, {
                    j$: uf,
                    kd: n6,
                    q2: uf
                })));
            case 38:
                return (M = n.a).$ ? qK(p(r, {
                    kd: _3(M.a)
                })) : A2(IX, 1, qK(p(r, {
                    j$: uf,
                    kd: a6,
                    q2: uf
                })));
            case 39:
                var i = Q6(n.a);
                return i.$ ? qK(r) : A2(jX, T([
                    A2(Yi, e6, J6(i.a.mm))
                ]), qK(p(r, {
                    j$: uf,
                    kd: uf,
                    q2: n6
                })));
            case 40:
                return (M = n.a).$ ? qK(p(r, {
                    q2: _3(M.a)
                })) : A2(IX, 1, qK(p(r, {
                    j$: uf,
                    kd: uf,
                    q2: a6
                })));
            case 41:
                var o = Z6(n.a);
                return o.$ ? qK(r) : A2(jX, T([
                    A2(Yi, J3, k6(o.a.mm))
                ]), qK(p(r, {
                    j$: n6,
                    kd: uf,
                    q2: uf
                })));
            case 42:
                return (M = n.a).$ ? qK(p(r, {
                    j$: _3(M.a)
                })) : A2(IX, 1, qK(p(r, {
                    j$: a6,
                    kd: uf,
                    q2: uf
                })));
            case 43:
                return qK(r);
            case 3:
                return qK(p(r, {
                    iN: p(u = r.iN, {
                        su: af
                    })
                }));
            case 4:
                var c = A2(vg, e = n.a, r.hV), s = c.ss ? kt(t.kp) : Tt;
                return qK(p(r, {
                    kr: s,
                    hV: c
                }));
            case 34:
                var f = n.a;
                return qK(p(r, {
                    kr: kt(A2(j1, f.q4, A3(Js, mL(f.lU), f.ff, !1)))
                }));
            case 5:
                return qK(p(r, {
                    d0: A3(u5, n.a, e = n.b, r.d0)
                }));
            case 6:
                var l = n.b;
                return qK(p(r, {
                    k5: A3(ko, O = n.a, function(n) {
                        return 1 === n.$ ? Tt : kt(A2(gg, l, n.a));
                    }, r.k5)
                }));
            case 7:
                var m = n.a, b = A2(jZ, Y6, {
                    nO: r.nO.ss
                });
                if (b.$) {
                    n = X3(wt(IL(k = b.a)));
                    continue n;
                }
                return q1(T([
                    A2(Yi, X3, h6({
                        bB: m.mm,
                        kr: r.kr,
                        nO: r.nO.ss
                    }))
                ]));
            case 8:
                m = n.a;
                var v = n.b, $ = d(r.iN.cU, r.iN.su, r.qh);
                if (3 !== $.a || 2 !== $.b.$ || $.c.$) return q1(T([
                    A2(Yi, X3, o5({
                        iN: r.iN,
                        bB: m.mm,
                        kr: r.kr,
                        nO: A2(ju, r.nO.ss, A2(Fu, p0, r.qh))
                    }))
                ]));
                var h = $.b;
                return q1(T([
                    A2(Yi, t6, y6({
                        z: v.mm,
                        bb: h.a.ss,
                        bc: h.b.ss,
                        m6: $.c.a
                    }))
                ]));
            case 14:
                if ((M = n.a).$) {
                    var k = M.a;
                    return qK(p(r, {
                        nO: A3(IZ, gZ(r.nO), "message", k)
                    }));
                }
                return A2(IX, 1, qK(p(r, {
                    kr: Tt,
                    nO: gZ(Iq(r.nO)),
                    hV: A2(pg, r.hV, !1)
                })));
            case 15:
                return (M = n.a).$ ? (k = M.a, qK(p(r, {
                    nO: A3(IZ, gZ(r.nO), "message", k)
                }))) : A2(IX, 1, qK(p(r, {
                    kr: Tt,
                    nO: gZ(Iq(r.nO)),
                    hV: A2(pg, r.hV, !1)
                })));
            case 44:
                return A2(jX, T([
                    A2(Yi, u6, G6(n.a))
                ]), qK(p(r, {
                    q3: n6
                })));
            case 45:
                return (M = n.a).$ ? qK(p(r, {
                    q3: _3(M.a)
                })) : A2(IX, 1, qK(p(r, {
                    q3: a6
                })));
            case 16:
                return qK(p(r, {
                    k5: A3(wu, O = n.a.mm, z6(l = n.a.nO), r.k5)
                }));
            case 17:
                return qK(p(r, {
                    k5: A2(ho, O = n.a, r.k5)
                }));
            case 18:
                var w = A2(lo, f6((y = n.a).mm), r.k5);
                if (1 === w.$) return MK;
                var C = A2(jZ, Y6, {
                    nO: (P = w.a).ss
                });
                if (C.$) {
                    n = A2(Y3, y, wt(IL(k = C.a)));
                    continue n;
                }
                return q1(T([
                    A2(Yi, Y3(y), A3(E6, r, y, P.ss))
                ]));
            case 19:
                var N = n.a;
                return (M = n.b).$ ? (k = M.a, qK(p(r, {
                    k5: A3(a5, f6(N.mm), k, r.k5)
                }))) : A2(IX, 1, qK(p(r, {
                    k5: A2(ho, M.a.mm, r.k5)
                })));
            case 20:
                return N = n.a, (M = n.b).$ ? (k = M.a, qK(p(r, {
                    k5: A3(a5, f6(N.mm), k, r.k5)
                }))) : A2(IX, 1, qK(p(r, {
                    k5: A2(ho, f6(N.mm), r.k5)
                })));
            case 9:
                var A = A2(lo, f6((y = n.a).mm), r.k5);
                if (1 === A.$) return MK;
                var S = A2(jZ, Y6, {
                    nO: (P = A.a).ss
                });
                if (S.$) {
                    n = A2(Y3, y, wt(IL(k = S.a)));
                    continue n;
                }
                return q1(T(y.mm.$ ? [
                    A2(Yi, r6(y), A3(H6, r, y, P.ss))
                ] : [
                    A2(Yi, Y3(y), A3(E6, r, y, P.ss))
                ]));
            case 13:
                return N = n.a, (M = n.b).$ ? (k = M.a, qK(p(r, {
                    k5: A3(a5, f6(N.mm), k, r.k5)
                }))) : A2(IX, 1, qK(p(r, {
                    k5: A2(ho, M.a.mm, r.k5)
                })));
            case 10:
                return u = n.a, qK(p(r, {
                    k2: A3(wu, O = n.b, A3(r5, n.c, g6(t.kp), u), r.k2)
                }));
            case 12:
                return qK(p(r, {
                    k2: A3(wu, O = n.b, p(u = n.a, {
                        su: af
                    }), r.k2)
                }));
            case 11:
                return qK(p(r, {
                    k2: A3(wu, O = n.b, A2(n5, n.c, u = n.a), r.k2)
                }));
            case 21:
                var L = (y = n.a).mm;
                return A2(jX, T(L.$ ? [
                    A2(Yi, K3(O = L.a), q6(O))
                ] : [
                    A2(Yi, K3(O = L.a), B6(O))
                ]), qK(p(r, {
                    lm: Tt
                })));
            case 22:
                return (M = n.b).$ ? qK(p(r, {
                    lm: kt(M6)
                })) : D1(1);
            case 23:
                l = A2(ju, "", A2(Fu, function(n) {
                    return n.ss;
                }, A2(lo, f6((y = n.a).mm), r.d0)));
                var y, F = A2(jZ, K6, {
                    nO: l
                });
                if (F.$) {
                    n = A2(Z3, y, wt(IL(k = F.a)));
                    continue n;
                }
                return q1(T([
                    A2(Yi, Z3(y), A2(m6, y, l))
                ]));
            case 24:
                return N = n.a, (M = n.b).$ ? (k = M.a, qK(p(r, {
                    d0: A3(a5, f6(N.mm), k, r.d0)
                }))) : A2(IX, 1, qK(p(r, {
                    d0: A2(ho, f6(N.mm), r.d0)
                })));
            case 25:
                var j = A2(lo, (B = n.a).mm, r.k5);
                if (1 === j.$) return MK;
                var P, I = A2(jZ, K6, {
                    iN: g,
                    nO: (P = j.a).ss
                });
                if (I.$) {
                    n = A2(Q3, B, wt(IL(k = I.a)));
                    continue n;
                }
                return q1(T([
                    A2(Yi, Q3(B), A2(x6, B, P.ss))
                ]));
            case 26:
                var B = n.a;
                return (M = n.b).$ ? qK(p(r, {
                    k5: A3(a5, B.mm, k = M.a, r.k5)
                })) : A2(IX, 1, qK(p(r, {
                    k5: A2(ho, M.a.mm, r.k5)
                })));
            case 27:
                return q1(T([
                    A2(Yi, W3((B = n.a).mm), P6(B))
                ]));
            case 28:
                var M, O = n.a;
                return (M = n.b).$ ? qK(p(r, {
                    d0: A3(a5, O, k = M.a, r.d0)
                })) : D1(1);
            case 29:
                return qK(p(r, {
                    io: !r.io
                }));
            case 30:
                return qK(p(r, {
                    ip: !r.ip
                }));
            case 33:
                return MK;
            case 31:
                return qK(p(r, {
                    j_: !r.j_
                }));
            default:
                return q1(T([
                    W6(n.a)
                ]));
        }
    }), s5 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, f5 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, l5 = {
        $: 6
    }, m5 = function(n) {
        return {
            $: 10,
            a: n
        };
    }, d5 = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), b5 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, p5 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), v5 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $5 = Oi({
        bN: "Wrong layout and/or version",
        bT: "Erreur sur une version et/ou un agencement"
    }), g5 = F4(function(n, r, t, e) {
        return {
            aC: t,
            ft: n,
            r5: e,
            sv: r
        };
    }), h5 = Po(A4(rc, "typeVersion", function(n) {
        return n.r5;
    }, y0, A4(rc, "channelLayout", function(n) {
        return n.aC;
    }, A0, A4(Do, "version", function(n) {
        return n.sv;
    }, h$, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, Io(g5)))))), k5 = F5(function(n, r, t, e, u) {
        var a = d(r, t, e);
        return a.b.$ || a.c.$ ? BL({
            lA: Au,
            nO: $5,
            P: 400
        }) : dc(fg(A3(ag, h5, {
            aC: a.b.a,
            ft: u,
            r5: a.c.a,
            sv: r
        }, rg(Lo(v5(A2(p5, n, 0)))))));
    }), T5 = Kn("clean", function() {
        return pi;
    }), w5 = Kn("get", function(n) {
        return $i(T([
            m("channels", ic(ec)(n.cz)),
            m("fileId", gi(n.z))
        ]));
    }), C5 = function(n) {
        return i(n, L0(2)) || i(n, L0(1)) || i(n, L0(0));
    }, N5 = F2(function(n, r) {
        return m(r.a, n(r.b));
    }), S5 = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), L5 = Kn("save", ic(function(n) {
        return $i(T([
            m("index", ec(n.ft)),
            m("layout", function(n) {
                return A3(S5, pi, gi, n);
            }(n.nc)),
            m("typeVersion", function(n) {
                return A3(S5, pi, gi, n);
            }(n.r5)),
            m("version", function(n) {
                return A3(S5, pi, gi, n);
            }(n.sv))
        ]));
    })), y5 = F2(function(n, r) {
        switch(n.$){
            case 8:
                var t = n.a, e = n.b;
                return e.$ ? qK(p(r, {
                    lm: kt(e.a)
                })) : A2(IX, 1, qK(p(r, {
                    lm: Tt,
                    pv: g,
                    sx: A2(ho, t, r.sx)
                })));
            case 10:
                return MK;
            case 3:
                var u = n.a, a = n.b, o = n.c, c = n.d, s = {
                    nc: Ri(function(n) {
                        return p(n, {
                            m6: "Disposition",
                            ss: A2(ju, "", c)
                        });
                    }),
                    r5: Ri(function(n) {
                        return p(n, {
                            m6: "TypeVersion",
                            ss: A2(ju, "", a)
                        });
                    }),
                    sv: Ri(function(n) {
                        return p(n, {
                            m6: "Version",
                            ss: A2(ju, "", o)
                        });
                    })
                };
                return qK(p(r, {
                    pv: T([
                        u
                    ]),
                    sx: A3(wu, u, s, r.sx)
                }));
            case 0:
                var f = n.b;
                return qK(p(r, {
                    sx: A3(ko, t = n.a, Fu(function(n) {
                        return p(n, {
                            sv: A2(gg, f, n.sv)
                        });
                    }), r.sx)
                }));
            case 2:
                return f = n.b, qK(p(r, {
                    sx: A3(ko, t = n.a, Fu(function(n) {
                        return p(n, {
                            r5: A2(gg, f, n.r5)
                        });
                    }), r.sx)
                }));
            case 6:
                return A2(IX, 1, qK(r));
            case 5:
                return A2(jX, T([
                    A2(Gv, Ml(l5), IE(200))
                ]), qK(r));
            case 7:
                return qK(p(r, {
                    pv: g,
                    sx: A2(ho, u = n.a, r.sx)
                }));
            case 1:
                return f = n.b, qK(p(r, {
                    sx: A3(ko, t = n.a, Fu(function(n) {
                        return p(n, {
                            nc: A2(gg, f, n.nc)
                        });
                    }), r.sx)
                }));
            case 9:
                var l = (M = m(n.a, r.qo)).a.$ ? Tt : 1 === M.a.a.$ ? 1 === M.b.$ ? kt(b5(I = M.a.a.a)) : 1 === M.b.a.$ ? i(I = M.a.a.a, M.b.a.a) ? Tt : kt(b5(I)) : kt(b5(I = M.a.a.a)) : 1 === M.b.$ || M.b.a.$ ? kt(s5(B = M.a.a.a)) : i(B = M.a.a.a, M.b.a.a) ? Tt : kt(s5(B));
                return A2(jX, T([
                    A2(Gv, m5, oN(l))
                ]), qK(p(r, {
                    qo: l
                })));
            case 4:
                t = n.a;
                var b = function(n) {
                    var r = ze(n);
                    return r.$ ? -1 : r.a;
                }, v = function() {
                    var n = A2(lo, t, r.sx);
                    if (1 === n.$) return d(Tt, Tt, Tt);
                    var e = n.a.sv, u = n.a.nc, a = n.a.r5, i = C5(a.ss) ? e.ss : "NOTHING";
                    return d(Tx($$(i)), Tx(C0(u.ss)), Tx(S0(a.ss)));
                }(), $ = v.a, h = v.b, k = v.c, w = A2(N5, b, (O = A2(Mt, "/", t)).b && O.b.b ? m(O.a, O.b.a) : m("", "")), C = w.a, N = w.b;
                return A2(jX, T([
                    A2(Yi, d5(t), A5(k5, C, $, h, k, N))
                ]), qK(r));
            case 11:
                var A = n.a, S = A2(Fu, function(n) {
                    return n.m2;
                }, Va(A)), L = function() {
                    if (S.$) return n$;
                    var n = Va(A2(Mt, "/", S.a));
                    if (n.$) return n$;
                    var r = n.a;
                    return w5({
                        cz: A2(Ge, function(n) {
                            return n.ft;
                        }, A),
                        z: r
                    });
                }();
                return HX(L);
            case 12:
                return q1(T([
                    A2(Yi, f5, (P = n.a, A3(qt, F2(function(n, r) {
                        var t = n.a, e = n.b;
                        return A2(OC, function() {
                            var n = Va(A2(Iu, function(n) {
                                return i(n.ft, t + 1);
                            }, P.bl));
                            if (n.$) return oN(0);
                            var r = n.a;
                            return A5(k5, P.z, Tx($$(A2(ju, "NOTHING", r.sv))), Tx(C0(r.nc)), Tx(S0(r.r5)), e);
                        }, r);
                    }), oN(0), A2(zt, x$, P.cz))))
                ]));
            case 14:
                return q1(T([
                    T5(0),
                    J2(0)
                ]));
            case 15:
                var y = n.a;
                return q1(T([
                    L5(A2(zt, F2(function(n, r) {
                        return {
                            ft: n + 1,
                            nc: A2(Fu, N0, r.nc),
                            r5: A2(Fu, L0, r.r5),
                            sv: A2(Fu, g$, r.sv)
                        };
                    }), y)),
                    J2(0)
                ]));
            default:
                var F = n.a, j = Dt(F) ? A3(qt, F2(function(n, r) {
                    return r + "stream " + It(n.ft) + " " + A2(ju, "", n.sv) + " " + A2(Ii, " ", A2(X$, H1, C0(n.nc))) + " " + n.r5;
                }), "", F) : "";
                return qK(p(r, {
                    p$: kt(j)
                }));
        }
        var P, I, B, M, O;
    }), j5 = F2(function() {
        return MK;
    }), P5 = F4(function(n, r, t, e) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), I5 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, B5 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, M5 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, O5 = {
        $: 1
    }, q5 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, D5 = {
        $: 1
    }, x5 = {
        $: 0
    }, R5 = {
        $: 0
    }, V5 = F2(function(n, r) {
        return A2(_e, function(r) {
            var t = r.a, e = r.b;
            return A2(nu, function(n) {
                return d(t, e, n);
            }, n(m(t, e)));
        }, r);
    }), E5 = Oi({
        bN: "Please qualify audio before deliver.",
        bT: "Veuillez qualifier les pistes audios avant de livrer."
    }), z5 = Oi({
        bN: "Choose one or more segments to include",
        bT: "Choisissez un ou plusieurs segments \xe0 inclure"
    }), U5 = F2(function(n, r) {
        return {
            ad: r,
            ci: n
        };
    }), H5 = F3(function(n, r, t) {
        return {
            lR: t,
            mm: n,
            n5: r
        };
    }), W5 = Po(A4(Do, "format", function(n) {
        return n.lR;
    }, xi, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(H5))))), Q5 = Po(A4(Do, "subtitles", function(n) {
        return n.ad;
    }, W5, A4(rc, "targetOrg", function(n) {
        return n.ci;
    }, xi, Io(U5)))), Z5 = F2(function(n, r) {
        return A2(Gb, function(n) {
            return n.mm;
        }, dc(A2(Ho, Wb, A3(ag, Q5, {
            ad: r.ad,
            ci: r.rL
        }, rg(ml(E3(A2(V3, n, 1))))))));
    }), K5 = F2(function(n, r) {
        return {
            ad: r,
            ch: n
        };
    }), Y5 = Po(A4(Do, "subtitles", function(n) {
        return n.ad;
    }, W5, A4(rc, "targetId", function(n) {
        return n.ch;
    }, xi, Io(K5)))), X5 = F2(function(n, r) {
        return A2(Gb, function(n) {
            return n.mm;
        }, dc(A2(Ho, Wb, A3(ag, Y5, {
            ad: r.ad,
            ch: r.rL
        }, rg(ml(E3(A2(V3, n, 0))))))));
    }), J5 = function(n) {
        return A2(Fu, _1, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av))));
    }, G5 = function(n) {
        return Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av)));
    }, _5 = F2(function(n, r) {
        return r.$ ? n : kt(r.a);
    }), n4 = function(n) {
        var r = A2(fp, function(n) {
            return n.hV;
        }, G5(n)), t = A2(fp, function(n) {
            return n.hV;
        }, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, w2, n.av))));
        return A2(_5, r, A2(_5, t, A2(fp, function(n) {
            return n.hV;
        }, n.a6)));
    }, r4 = F3(function(n, r, t) {
        return A2(Bt, r, A2(Mt, n, t));
    }), t4 = F2(function(n, r) {
        return A3(y1, Rt, n, r);
    }), e4 = F2(function(n, r) {
        return A2(t4, r, T([
            n
        ]));
    }), u4 = F3(function(n, r, t) {
        var e = A2(ju, "00:00:00:00", A2(Fu, function(n) {
            return A3(r4, ";", ":", n);
        }, n4(n))), u = F2(function(n, r) {
            return A2(e4, e, A3(L1, r, n, !1)).lT;
        }), a = J5(n), i = A2(ju, 0, A2(Fu, u(t), a)), o = A2(ju, 0, A2(Fu, u(r), a));
        return dc(A2(ng, xi, A3(ag, S6, {
            bb: o,
            bc: i,
            m6: 10
        }, rg(L6(n.lB.mm)))));
    }), a4 = Oi({
        bN: "Video duration differs from at least one of standalone audio files duration. The deliverable duration may be incorrect.",
        bT: "La dur\xe9e de la vid\xe9o est diff\xe9rente de la dur\xe9e d'au moins un des audios seuls. La dur\xe9e du livrable pourrait \xeatre incorrecte."
    }), i4 = Oi({
        bN: "Container duration is not available.",
        bT: "Dur\xe9e du conteneur non disponible."
    }), o4 = Oi({
        bN: "Video is not loaded. Container and video stream durations are not available.",
        bT: "La vid\xe9o n'est pas charg\xe9e. Dur\xe9es du conteneur et du flux video indisponible."
    }), c4 = F2(function(n, r) {
        return Oi({
            bN: "Container duration (" + mL(n) + " s) and video stream duration (" + mL(r) + " s) are not equals. TC out is calculated with container duration.",
            bT: "La dur\xe9e du conteneur (" + mL(n) + " s) et la dur\xe9e du flux video (" + mL(r) + " s) sont in\xe9gales. Le TC out est calcul\xe9 avec la dur\xe9e du conteneur."
        });
    }), s4 = Oi({
        bN: "Video stream duration is not available.",
        bT: "Dur\xe9e du flux video non disponible."
    }), f4 = F4(function(n, r, t, e) {
        return A4(s3, r, qs(t * r - 1), n, e);
    }), l4 = function(n) {
        return A2(Yc, U1, n.av);
    }, m4 = function(n) {
        return A2(R1, n, Tt);
    }, d4 = function(n) {
        var r = function(n) {
            return A3(Ym, 2, "0", mL(n));
        }, t = n.eR ? ";" : ":";
        return r(n.mi) + ":" + r(n.n_) + ":" + (r(n.qf) + (t + A3(Ym, 2, "0", It(n.ff))));
    }, b4 = function(n) {
        var r, t = A2(fp, function(n) {
            return n.bQ.fY;
        }, A2(Fu, m4, n)), e = A2(ju, "00:00:00:00", A2(Fu, function(n) {
            return A3(r4, ";", ":", n);
        }, A2(fp, n4, t))), u = A2(fp, function(n) {
            return n.eS;
        }, A2(fp, G5, t)), a = A2(fp, J5, t), i = A2(fp, function(n) {
            return n.eS;
        }, A2(fp, function(n) {
            return n.a6;
        }, t)), o = A3(NL, F2(function(n, r) {
            return d4(A4(f4, e, r, n, !1));
        }), i, a), c = A2(ju, !1, A3(NL, se, i, u)), s = (r = m(i, u)).a.$ ? kt(r.b.$ ? o4 : i4) : r.b.$ ? kt(s4) : c ? Tt : kt(A2(c4, r.a.a, r.b.a)), f = F2(function(n, r) {
            var t;
            return (0 > (t = n - r) ? -t : t) > 1;
        }), l = A2(du, function(n) {
            return A2(ju, !1, A3(NL, f, n, u));
        }, A2(Ge, function(n) {
            return n.eS;
        }, A2(Gu, l4, A2(ju, g, A2(Fu, function(n) {
            return n.bQ.d6;
        }, A2(Fu, m4, n)))))) ? kt(a4) : Tt, b = m(a, o);
        return b.a.$ || b.b.$ ? d("--:--:--:--", "--:--:--:--", m(s, l)) : d(e, b.b.a, m(s, l));
    }, p4 = F9(function(n, r, t, e, u, a, i, o, c) {
        return {
            e2: i,
            e4: o,
            lR: a,
            fR: c,
            g0: t,
            ad: u,
            ch: n,
            ci: r,
            h9: e
        };
    }), v4 = Po(A4(Do, "lockedUntil", function(n) {
        return n.fR;
    }, xi, A4(Do, "extraVersionMapping", function(n) {
        return n.e4;
    }, ob, A4(Do, "extraFormat", function(n) {
        return n.e2;
    }, xi, A4(rc, "format", function(n) {
        return n.lR;
    }, xi, A4(Do, "subtitles", function(n) {
        return n.ad;
    }, W5, A4(rc, "versionMapping", function(n) {
        return n.h9;
    }, ob, A4(rc, "segments", function(n) {
        return n.g0;
    }, oc(xi), A4(rc, "targetOrg", function(n) {
        return n.ci;
    }, xi, A4(Do, "targetId", function(n) {
        return n.ch;
    }, xi, Io(p4))))))))))), $4 = Po(A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(function(n) {
        return {
            mm: n
        };
    }))), g4 = Oi({
        bN: "Program delivery for",
        bT: "Programmer la livraison pour"
    }), h4 = Oi({
        bN: "Choose subtitles (optional)",
        bT: "Choisir des sous-titres (optionnel)"
    }), k4 = Oi({
        bN: "Can not deliver without format",
        bT: "On ne peut pas livrer sans format"
    }), T4 = Oi({
        bN: "Extra format (optional)",
        bT: "Format compl\xe9mentaire (optionnel)"
    }), w4 = F2(function(n, r) {
        var t = Va(A2(Iu, function(n) {
            return i(n.mm, r);
        }, n));
        return !t.$ && !t.a.rr.$;
    }), C4 = Oi({
        bN: "Black",
        bT: "Noir"
    }), N4 = Oi({
        bN: "Custom delivery",
        bT: "Livraison custom"
    }), S4 = Oi({
        bN: "Slate",
        bT: "Panneau"
    }), L4 = Oi({
        bN: "Bar and tone",
        bT: "Mire"
    }), y4 = function(n) {
        switch(n.m6){
            case 0:
                return pf;
            case 1:
                return mf;
            case 2:
                return df;
            case 3:
                return vf;
            case 4:
                return $f;
            case 5:
                return lf;
            case 6:
                return L4;
            case 7:
                return C4;
            case 8:
                return S4;
            case 9:
                return bf;
            default:
                return N4;
        }
    }, j4 = function(n) {
        var r = function(n) {
            if (1 === n.$) {
                var r = n.a;
                return !i(r.r5, Tt) && !i(r.aC, Tt);
            }
            return !1;
        };
        return A2(ju, !1, A2(Fu, function(n) {
            return 0 >= Dt(n) || Dt(A2(Iu, r, n)) > 0;
        }, A2(Fu, A2(bu, Iu(function(n) {
            return 1 === n.$;
        }), function(n) {
            return n.av;
        }), A2(fp, A2(No, function(n) {
            return n.bQ;
        }, function(n) {
            return n.fY;
        }), n))));
    }, P4 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, I4 = F2(function(n, r) {
        return {
            c8: n,
            dr: r
        };
    }), B4 = F4(function(n, r, t, e) {
        return {
            mm: r,
            n5: t,
            gn: e,
            qI: n
        };
    }), M4 = Po(A4(rc, "parent", function(n) {
        return n.gn;
    }, qo(xi), A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, A4(rc, "showId", function(n) {
        return n.qI;
    }, xi, Io(B4)))))), O4 = Po(A4(rc, "shows", function(n) {
        return n.dr;
    }, oc(Wb), A4(rc, "nodes", function(n) {
        return n.c8;
    }, oc(M4), Io(I4)))), q4 = F4(function(n, r, t, e) {
        return {
            mm: n,
            mM: e,
            n5: r,
            rr: t
        };
    }), D4 = Po(A4(rc, "isDefault", function(n) {
        return n.mM;
    }, no, A4(Do, "subtitleTypeVersion", function(n) {
        return n.rr;
    }, SS, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(q4)))))), x4 = oc(D4), R4 = F4(function(n, r, t, e) {
        return {
            mM: t,
            mO: e,
            n5: n,
            r0: r
        };
    }), V4 = Po(A4(rc, "isExtraDefault", function(n) {
        return n.mO;
    }, no, A4(rc, "isDefault", function(n) {
        return n.mM;
    }, no, A4(rc, "tracks", function(n) {
        return n.r0;
    }, oc(k$), A4(rc, "name", function(n) {
        return n.n5;
    }, xi, Io(R4)))))), E4 = oc(V4), z4 = function(n) {
        return A2(Yi, P4, A6(iM, F5(function(n, r, t, e, u) {
            return {
                e3: u,
                cX: n,
                c8: t.c8,
                dr: t.dr,
                dw: r,
                h9: e
            };
        }), function(n) {
            return dc(A2(Ho, x4, So(Lo(B$(A2(wM, n, 3))))));
        }(n), function(n) {
            return dc(A2(Ho, XS, So(ml(fP(A2(sP, n, 3))))));
        }(n), function(n) {
            return dc(A2(Ho, O4, So(ml(fP(A2(sP, n, 4))))));
        }(n), function(n) {
            return dc(A2(Ho, E4, So(Lo(B$(A2(wM, n, 0))))));
        }(n), function(n) {
            return dc(A2(Ho, x4, So(Lo(B$(A2(wM, n, 4))))));
        }(n)));
    }, U4 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, H4 = F3(function(n, r, t) {
        return {
            iG: t,
            mm: n,
            n5: r
        };
    }), W4 = Po(A4(rc, "allowDeliveryWithoutTranscoding", function(n) {
        return n.iG;
    }, no, A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(H4))))), Q4 = oc(W4), Z4 = ml(fP({
        $: 1
    })), K4 = dc(A2(Ho, Q4, So(Z4))), Y4 = oc(g0), X4 = ru, J4 = function(n) {
        return A2(Yi, U4, A3(X4, F2(function(n, r) {
            return m(n, r);
        }), K4, function(n) {
            return dc(A2(Ho, Y4, So(L6(n))));
        }(n)));
    }, G4 = Oi({
        bN: "Organization",
        bT: "Organisation"
    }), _4 = Oi({
        bN: "Program",
        bT: "Programme"
    }), n8 = function(n) {
        return p(n, {
            st: Au
        });
    }, r8 = tu, t8 = Oi({
        bN: "Can not deliver the original organization",
        bT: "On ne peut pas livrer l\u2019organisation d\u2019origine"
    }), e8 = Oi({
        bN: "Please choose an option for subtitles",
        bT: "Veuillez choisir une option pour les sous-titres"
    }), u8 = Oi({
        bN: "Subtitling method",
        bT: "Mode de sous-titrage"
    }), a8 = Oi({
        bN: "Version mapping",
        bT: "Version mapping"
    }), i8 = Oi({
        bN: "Extra version mapping",
        bT: "Version mapping compl\xe9mentaire"
    }), o8 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 0:
                var e = m(t, A2(fp, function(n) {
                    var r = n.bQ.fY;
                    return r.$ ? Va(n.bQ.d6) : kt(r.a);
                }, A2(Fu, m4, t)));
                return e.a.$ || e.b.$ ? MK : A2(jX, T([
                    J4((J = e.b.a).lB.mm)
                ]), A2(IX, 0, qK(D5)));
            case 1:
                switch(r.$){
                    case 0:
                        n = R5;
                        continue n;
                    case 1:
                        return MK;
                    default:
                        return qK(Af);
                }
            case 2:
                if ((k = n.a).$) return qK(Af);
                var u = k.a, a = u.a, o = A2(zi, function(n) {
                    return n.bb;
                }, u.b), c = A2(Ge, function(n) {
                    return m(n.mm, y4(n));
                }, o), s = b4(t), f = s.a, l = s.b, b = s.c, v = b.a, $ = b.b, h = {
                    lD: o,
                    oP: a,
                    qs: Tt,
                    qt: {
                        kI: Ri(function(n) {
                            return p(n, {
                                mQ: !0,
                                m6: g4
                            });
                        }),
                        e2: Ri(function(n) {
                            return p(n, {
                                gt: T4
                            });
                        }),
                        e4: Ri(function(n) {
                            return p(n, {
                                gt: i8
                            });
                        }),
                        lR: Ri(function(n) {
                            return p(n, {
                                gt: "Format"
                            });
                        }),
                        nO: v,
                        n$: $,
                        oL: Ri(function(n) {
                            return p(n, {
                                gt: G4
                            });
                        }),
                        g0: A2(Vi, z5, c),
                        g6: Ri(function(n) {
                            return p(n, {
                                gt: _4
                            });
                        }),
                        rm: Ri(function(n) {
                            return p(n, {
                                gt: u8
                            });
                        }),
                        ru: Ri(function(n) {
                            return p(n, {
                                gt: h4
                            });
                        }),
                        dy: Ri(function(n) {
                            return p(n, {
                                gt: "Timecode in",
                                ss: f
                            });
                        }),
                        dz: Ri(function(n) {
                            return p(n, {
                                gt: "Timecode out",
                                ss: l
                            });
                        }),
                        rX: !i(c, g),
                        h9: Ri(function(n) {
                            return p(n, {
                                gt: a8
                            });
                        })
                    },
                    P: x5
                };
                return qK(q5(h));
            case 3:
                var k = n.a;
                if (2 === r.$) {
                    var w = r.a;
                    if (k.$) return qK(Af);
                    var C = k.a.c8, N = k.a.dr, A = k.a.cX, S = k.a.dw, L = k.a.h9, y = k.a.e3, F = (bn = w.qt).e2, j = bn.e4, P = bn.lR, I = bn.h9, B = A2(ju, "", A2(Fu, function(n) {
                        return n.n5;
                    }, Va(A2(Iu, function(n) {
                        return n.mM;
                    }, L)))), M = A2(ju, "", A2(Fu, function(n) {
                        return n.n5;
                    }, Va(A2(Iu, function(n) {
                        return n.mO;
                    }, L)))), O = A2(ju, "", 1 === Dt(A) ? A2(Fu, function(n) {
                        return n.mm;
                    }, Va(A)) : A2(Fu, function(n) {
                        return n.mm;
                    }, Va(A2(Iu, function(n) {
                        return n.mM;
                    }, A)))), q = p(bn, {
                        e2: p(F, {
                            ss: A2(ju, "", 1 === Dt(y) ? A2(Fu, function(n) {
                                return n.mm;
                            }, Va(y)) : A2(Fu, function(n) {
                                return n.mm;
                            }, Va(A2(Iu, function(n) {
                                return n.mM;
                            }, y))))
                        }),
                        e4: p(j, {
                            ss: M
                        }),
                        lR: p(P, {
                            ss: O
                        }),
                        h9: p(I, {
                            ss: B
                        })
                    });
                    return h = p(w, {
                        qs: kt({
                            e3: y,
                            cX: A,
                            c8: C,
                            dr: N,
                            dw: S,
                            h9: L
                        }),
                        qt: q
                    }), qK(q5(h));
                }
                return MK;
            case 4:
                var D = n.a, x = n.b, R = n.c, V = n.d, E = function() {
                    return 1 === R.$ ? A2(Z5, D, {
                        ad: V,
                        rL: x
                    }) : A2(X5, D, {
                        ad: V,
                        rL: R.a
                    });
                }();
                return HX(A2(Yi, I5, E));
            case 5:
                var z = n.a, U = (D = n.b, n.c), H = (R = n.d, m(U, r));
                if (H.a.$ || 2 !== H.b.$) return MK;
                x = H.a.a, S = A2(ju, g, A2(Fu, function(n) {
                    return n.dw;
                }, (h = H.b.a).qs));
                var W = Ve(h.qt.ru.ss) || Cu(S) || !Ve(h.qt.rm.ss) ? "Burning" === h.qt.rm.ss || Ve(h.qt.rm.ss) ? St(Tt) : St(kt(h.qt.rm.ss)) : wt(A2(ki, e8, f$)), Q = A2(Fu, m4, t), Z = "" === h.qt.kI.ss ? Tt : kt(h.qt.kI.ss);
                if ("AsSource" === h.qt.lR.ss) {
                    V = function() {
                        if (Q.$) return Tt;
                        var n = Q.a;
                        return kt({
                            lR: A2(Ii, Tt, W),
                            mm: h.qt.ru.ss,
                            n5: A2(ju, "", A2(Fu, A2(No, function(n) {
                                return n.lB;
                            }, function(n) {
                                return n.n5;
                            }), Va(A2(Iu, function(n) {
                                return i(n.lB.mm, h.qt.ru.ss);
                            }, n.bQ.ad))))
                        });
                    }(), n = A4(P5, D, x, R, V);
                    continue n;
                }
                var K = function(n) {
                    return ML(ab(n));
                }, Y = ML(W), X = vt(h.qt.g0.st), J = A2(fp, function(n) {
                    return n.bQ.fY;
                }, Q), G = ML(1 === Dt(A = A2(ju, g, A2(Fu, function(n) {
                    return n.cX;
                }, h.qs))) ? St(A2(ju, "", Va(A2(Ge, function(n) {
                    return n.mm;
                }, A)))) : Ve(h.qt.lR.ss) ? wt(A2(ki, k4, f$)) : St(h.qt.lR.ss)), _ = Ve(h.qt.e2.ss) || "NoExtra" === h.qt.e2.ss ? ML(St(Tt)) : A2(Gb, kt, K(h.qt.e4.ss)), nn = ML(Ve(h.qt.e2.ss) || "NoExtra" === h.qt.e2.ss ? St(Tt) : St(kt(h.qt.e2.ss))), rn = m(h.qt.dy.ss, h.qt.dz.ss), tn = (f = rn.a, l = rn.b, function() {
                    var n = m(X, J);
                    return n.a.b || n.b.$ ? oN(n.a) : h.qt.dy.fh || h.qt.dz.fh ? A2(Gb, Ua, A3(u4, n.b.a, f, l)) : r8(g);
                }()), en = A2(OC, function(n) {
                    var r, t = n.a, e = t.a, u = e.a, a = e.b, o = e.c, c = t.b, s = n.b, f = n.c;
                    return i(R, Tt) && i(U, kt(z.oL)) ? BL(IL(A2(ki, t8, f$))) : j4(Q) ? (r = "" === h.qt.ru.ss ? {
                        bB: D,
                        e2: s,
                        e4: f,
                        lR: a,
                        fR: Z,
                        g0: c,
                        ad: Tt,
                        rL: R,
                        ci: x,
                        h9: u
                    } : {
                        bB: D,
                        e2: s,
                        e4: f,
                        lR: a,
                        fR: Z,
                        g0: c,
                        ad: function() {
                            if (Q.$) return Tt;
                            var n = Q.a;
                            return kt({
                                lR: o,
                                mm: h.qt.ru.ss,
                                n5: A2(ju, "", A2(Fu, A2(No, function(n) {
                                    return n.lB;
                                }, function(n) {
                                    return n.n5;
                                }), Va(A2(Iu, function(n) {
                                    return i(n.lB.mm, h.qt.ru.ss);
                                }, n.bQ.ad))))
                            });
                        }(),
                        rL: R,
                        ci: x,
                        h9: u
                    }, A2(Gb, function(n) {
                        return n.mm;
                    }, dc(A2(Ho, $4, A3(ag, v4, {
                        e2: r.e2,
                        e4: r.e4,
                        lR: r.lR,
                        fR: r.fR,
                        g0: r.g0,
                        ad: r.ad,
                        ch: r.rL,
                        ci: r.ci,
                        h9: r.h9
                    }, rg(Lo(I3(A2(P3, r.bB, 2))))))))) : BL(IL(A2(ki, E5, f$)));
                }, A2(V5, function() {
                    return _;
                }, A2(U6, function() {
                    return nn;
                }, A2(OC, function(n) {
                    return A2(Gb, function(r) {
                        return m(n, r);
                    }, tn);
                }, A2(Qo, IL, A2(V5, function() {
                    return Y;
                }, A2(U6, function() {
                    return G;
                }, K(h.qt.h9.ss))))))));
                return A2($X, A2(Yi, I5, en), qK(q5(p(h, {
                    P: O5
                }))));
            case 6:
                var un = n.a;
                if (2 === r.$) {
                    if (h = r.a, 1 === un.$) return qK(q5(p(h, {
                        P: B5(un.a.nO)
                    })));
                    var an = un.a, on = (N = A2(ju, g, A2(Fu, function(n) {
                        return n.dr;
                    }, h.qs)), A2(Iu, A2(No, function(n) {
                        return n.mm;
                    }, Fa(an)), N)), cn = (bn = h.qt).g6, sn = bn.oL, fn = A2(Fu, function(n) {
                        return p(n, {
                            dr: on
                        });
                    }, h.qs), ln = q5(p(h, {
                        qs: fn,
                        qt: p(bn, {
                            oL: p(sn, {
                                ss: ""
                            }),
                            g6: p(cn, {
                                ss: ""
                            })
                        }),
                        P: M5(an)
                    }));
                    return A2(IX, 1, qK(ln));
                }
                return MK;
            case 17:
                var mn = n.a;
                return 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    kI: A2(gg, mn, bn.kI)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 9:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    h9: A2(gg, mn, bn.h9)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 10:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    e4: A2(gg, mn, bn.e4)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 11:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    ru: A2(gg, mn, bn.ru)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 12:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    rm: A2(gg, mn, bn.rm)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 13:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    e2: A2(gg, mn, bn.e2)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 16:
                return A = n.a, mn = n.b, 2 === r.$ ? (q = p(bn = (h = r.a).qt, A2(w4, A, bn.rm.ss) ? {
                    lR: A2(gg, mn, bn.lR),
                    rm: A2($g, bn.rm, ""),
                    ru: A2($g, bn.ru, "")
                } : {
                    lR: A2(gg, mn, bn.lR)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 14:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    oL: A2(gg, mn, bn.oL)
                }), A2(jX, T([
                    z4(q.oL.ss)
                ]), qK(q5(p(h, {
                    qt: q
                }))))) : MK;
            case 15:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    g6: A2(gg, mn, bn.g6)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 7:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    dy: A2(gg, mn, bn.dy)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 8:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    dz: A2(gg, mn, bn.dz)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 18:
                return mn = n.a, 2 === r.$ ? (q = p(bn = (h = r.a).qt, {
                    g0: A2(yM, mn, bn.g0)
                }), qK(q5(p(h, {
                    qt: q
                })))) : MK;
            case 19:
                var dn = n.a;
                if (2 === r.$) {
                    var bn = (h = r.a).qt, pn = b4(t), vn = (f = pn.a, l = pn.b, pn.c);
                    return q = p(bn, {
                        nO: v = vn.a,
                        n$: $ = vn.b,
                        g0: n8(bn.g0),
                        dy: A2($g, bn.dy, f),
                        dz: A2($g, bn.dz, l),
                        rX: dn
                    }), qK(q5(p(h, {
                        qt: q
                    })));
                }
                return MK;
            default:
                var $n = d(r, n.a, n.b);
                r: for(;;){
                    if (2 === $n.a.$) {
                        if ($n.b) {
                            if ($n.c.$) break r;
                            return q = p(bn = (h = $n.a.a).qt, {
                                dz: p(l = bn.dz, {
                                    fh: !0,
                                    ss: d4($n.c.a)
                                })
                            }), qK(q5(p(h, {
                                qt: q
                            })));
                        }
                        if ($n.c.$) break r;
                        q = p(bn = (h = $n.a.a).qt, {
                            dy: p(f = bn.dy, {
                                fh: !0,
                                ss: d4($n.c.a)
                            })
                        });
                        return qK(q5(p(h, {
                            qt: q
                        })));
                    }
                    break r;
                }
                return MK;
        }
    }), c8 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, s8 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, f8 = {
        $: 1
    }, l8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, m8 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, d8 = {
        $: 2
    }, b8 = {
        $: 1
    }, p8 = F4(function(n, r, t, e) {
        return A2(ju, e, A2(fp, Tx, A2(Fu, di(t), Va(A2(Ge, function(n) {
            return n.ss;
        }, A2(Iu, function(r) {
            return i(r.n5, n);
        }, r))))));
    }), v8 = function(n) {
        var r = m(n.rb, n.rc);
        if (1 === r.a.$ && 1 === r.b.$) {
            var t = A2(_o, F2(function(r, t) {
                return p(t, {
                    ss: A4(p8, r, n.c2, Bi, "")
                });
            }), n.mB), e = A2(_o, F2(function(r, t) {
                return p(t, {
                    ss: A4(p8, r, n.c2, Ne, !1)
                });
            }), n.jH);
            return p(n, {
                jH: e,
                mB: t
            });
        }
        return n;
    }, $8 = function(n) {
        return ug(eg(n));
    }, g8 = F2(function(n, r) {
        var t = $(A2(Yc, function(n) {
            var r = n.b;
            return "" === r.ss ? Tt : kt(m(n.a, gi(r.ss)));
        }, pt(r.mB)), A2(Yc, function(n) {
            var r = n.b;
            return r.ss ? kt(m(n.a, _i(r.ss))) : Tt;
        }, pt(r.jH)));
        return A2(OC, function() {
            return dc(A2(Ho, B2, So(M2(n))));
        }, dc(A2($8, $i(t), rg(M2(n)))));
    }), h8 = F2(function(n, r) {
        return dc(A2(Ho, Wb, A3(ag, yX, {
            n5: r.rT.ss
        }, mg(SX(n)))));
    }), k8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A3(ko, n.a, Fu(gg(n.b)), r.mB);
                return qK(p(r, {
                    mB: t
                }));
            case 2:
                return qK(p(r, {
                    rT: A2(gg, n.a, r.rT)
                }));
            case 1:
                var e = A3(ko, n.a, Fu(vg(n.b)), r.jH);
                return qK(p(r, {
                    jH: e
                }));
            case 3:
                return A2(jX, T([
                    A2(Yi, s8, A2(h8, (u = n.a).mm, r)),
                    A2(Yi, c8, A2(g8, u.mm, r))
                ]), qK(p(r, {
                    P: d8
                })));
            case 4:
                if ((a = n.a).$) return qK(p(r, {
                    P: m8(a.a)
                }));
                var u = a.a;
                return A2(P_, T([
                    1,
                    0
                ]), qK(p(r, {
                    P: yf,
                    rT: A2($g, r.rT, u.rT)
                })));
            case 6:
                return A2(IX, 1, A2(c_, function(n) {
                    return p(n, {
                        P: yf
                    });
                }, A2(k8, j2(a = n.a), r)));
            case 5:
                return qK((a = n.a).$ ? p(r, {
                    rb: l8(a.a)
                }) : v8(p(r, {
                    c2: a.a,
                    rb: b8
                })));
            case 7:
                var a;
                if ((a = n.a).$) return qK(p(r, {
                    rc: l8(a.a)
                }));
                var i = a.a, o = A3(qt, F2(function(n, r) {
                    return "boolean" === n.r6 ? A2(N5, A2(wu, n.n5, ro(function(r) {
                        return p(r, {
                            m6: n.n5
                        });
                    })), r) : A2(EL, A2(wu, n.n5, Ri(function(r) {
                        return p(r, {
                            m6: n.n5
                        });
                    })), r);
                }), m(Au, Au), i.lA);
                return qK(v8(p(r, {
                    jH: e = o.b,
                    mB: t = o.a,
                    p4: kt(i),
                    rc: b8
                })));
            case 8:
                return qK(p(r, {
                    P: f8,
                    rT: A2($g, r.rT, (u = n.a).rT)
                }));
            default:
                return qK(p(r, {
                    P: yf
                }));
        }
    }), T8 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, w8 = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), C8 = function(n) {
        return {
            $: 9,
            a: n
        };
    }, N8 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, S8 = function(n) {
        return dc(fg(sg(B1(n))));
    }, L8 = F2(function(n, r) {
        switch(n.$){
            case 3:
                return qK(p(r, {
                    pF: A3(ko, (u = n.a).mm, function(n) {
                        return kt(A2(ju, !0, A2(Fu, pu, n)));
                    }, r.pF)
                }));
            case 5:
                return qK(p(r, {
                    pm: A3(ko, (a = n.a) + "-" + n.b, function(n) {
                        return kt(A2(ju, !0, A2(Fu, pu, n)));
                    }, r.pm)
                }));
            case 6:
                return qK(p(r, {
                    hE: A3(ko, (u = n.a).mm, function(n) {
                        return kt(A2(ju, !0, A2(Fu, pu, n)));
                    }, r.hE)
                }));
            case 0:
                return q1(T([
                    V2((u = n.b).m2),
                    A2(Ki, C8, dY(u.mm))
                ]));
            case 1:
                var t = n.b, e = e3((u = n.c).c$);
                return q1(T([
                    Y2(u.m2),
                    A2(Ki, N8, A3(oJ, t, e, u.n5))
                ]));
            case 2:
                var u;
                return q1(T([
                    I1((u = n.b).m2),
                    A2(Ki, T8, iY(u.mm))
                ]));
            case 9:
            case 8:
            case 7:
                return D1(1);
            case 4:
                return qK(p(r, {
                    oD: A2(A2(fX, a = n.a, r.oD) ? pX : Is, a, r.oD)
                }));
            case 10:
                return q1(T([
                    A2(Ki, w8(a = n.a), S8(a))
                ]));
            case 11:
                var a = n.a, i = n.b;
                if (i.$) {
                    var o = i.a;
                    return qK(p(r, {
                        ln: A3(ko, a, function() {
                            return kt(o.nO);
                        }, r.ln)
                    }));
                }
                return D1(1);
            default:
                return MK;
        }
    }), y8 = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), j8 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, P8 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, I8 = F2(function(n, r) {
        return dc(A2(ng, Ev, A3(ag, v_, r, rg(ml(AX(A2(NX, n.mm, 1)))))));
    }), B8 = function(n) {
        return p(n, {
            lm: Tt
        });
    }, M8 = F2(function(n, r) {
        return f(n, r) > 0;
    }), O8 = Jv, q8 = Oi({
        bN: "Wrong expiration date: must be greater than today.",
        bT: "Date d\u2019expiration erron\xe9e : doit \xeatre sup\xe9rieur \xe0 aujourd'hui."
    }), D8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return qK(p(r, {
                    k8: A2(gg, n.a, r.k8),
                    lm: Tt
                }));
            case 1:
                return qK(p(r, {
                    lm: Tt,
                    nO: A2(gg, n.a, r.nO)
                }));
            case 2:
                return qK(p(r, {
                    lm: Tt,
                    lr: A2(gg, n.a, r.lr)
                }));
            case 4:
                return qK(p(r, {
                    jx: A2(vg, n.a, r.jx),
                    lm: Tt
                }));
            case 3:
                return qK(p(r, {
                    jy: A2(vg, n.a, r.jy),
                    lm: Tt
                }));
            case 5:
                return qK(r);
            case 6:
                return qK(p(r, {
                    kS: !r.kS,
                    lm: Tt
                }));
            case 7:
                return A2(jX, T([
                    A2(Yi, P8, (o = n.a, dc(fg(sg(k_(o.mm))))))
                ]), qK(B8(r)));
            case 8:
                return (t = n.a).$ ? qK(p(r, {
                    lm: kt(t.a)
                })) : D1(1);
            case 11:
                var t;
                return (t = n.a).$ ? qK(p(r, {
                    lm: kt(t.a)
                })) : A2(P_, T([
                    1
                ]), qK(p(r, {
                    jx: If,
                    jy: Mf,
                    kS: !1,
                    k8: Df,
                    lm: Tt,
                    lr: Rf,
                    nO: Ef
                })));
            case 9:
                var e = n.a, u = n.b, a = A2(hi, function() {
                    return Tt;
                }, A2(X$, Ie, N_(r.lr.ss))), i = {
                    cJ: r.jx.ss,
                    k8: r.k8.ss,
                    cO: a.$ ? Tt : kt(a.a),
                    nO: r.nO.ss,
                    sg: r.jy.ss
                };
                return a.$ || A2(M8, a.a, u) ? A2(jX, T([
                    A2(Yi, j8, A2(I8, e, i))
                ]), qK(B8(r))) : qK(p(r, {
                    lm: kt(A3(Yo, 1, q8, Au))
                }));
            default:
                return A2(jX, T([
                    A2(Gv, y8(e = n.a), O8)
                ]), qK(r));
        }
        var o;
    }), x8 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, R8 = function(n) {
        return {
            $: 39,
            a: n
        };
    }, V8 = function(n) {
        return {
            $: 22,
            a: n
        };
    }, E8 = function(n) {
        return {
            $: 10,
            a: n
        };
    }, z8 = function(n) {
        return {
            $: 32,
            a: n
        };
    }, U8 = function(n) {
        return {
            $: 34,
            a: n
        };
    }, H8 = function(n) {
        return {
            $: 33,
            a: n
        };
    }, W8 = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Q8 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Z8 = function(n) {
        return {
            $: 12,
            a: n
        };
    }, K8 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Y8 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, X8 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, J8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, G8 = {
        $: 1
    }, _8 = function(n) {
        return {
            $: 11,
            a: n
        };
    }, n9 = function(n) {
        return {
            $: 41,
            a: n
        };
    }, r9 = {
        $: 2
    }, t9 = function(n) {
        return {
            $: 24,
            a: n
        };
    }, e9 = function(n) {
        return {
            $: 17,
            a: n
        };
    }, u9 = F2(function(n, r) {
        return A2(Gb, function() {
            return 0;
        }, dc(A2(Ho, o0, A3(ag, D3, {
            di: r
        }, rg(ml(AX(A2(NX, n.mm, 5))))))));
    }), a9 = function(n) {
        return dc(fg(rg(ml(Rq(A2(MV, n.mm, 3))))));
    }, i9 = ml(KN({
        $: 2
    })), o9 = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), c9 = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(o9)))), s9 = oc(c9), f9 = dc(A2(Ho, s9, So(i9))), l9 = F2(function(n, r) {
        return {
            mm: n,
            n5: r
        };
    }), m9 = Po(A4(rc, "name", function(n) {
        return n.n5;
    }, xi, A4(rc, "id", function(n) {
        return n.mm;
    }, xi, Io(l9)))), d9 = oc(m9), b9 = F2(function(n, r) {
        return {
            gU: r,
            hL: n
        };
    }), p9 = Po(A4(rc, "rulesId", function(n) {
        return n.gU;
    }, xi, A4(rc, "task", function(n) {
        return n.hL;
    }, xi, Io(b9)))), v9 = F3(function(n, r, t) {
        return dc(fg(A3(ag, p9, {
            gU: t,
            hL: r
        }, rg(Lo(I3(A2(P3, n, 0)))))));
    }), $9 = Po(A4(rc, "configuration", function(n) {
        return n.aj;
    }, xi, Io(function(n) {
        return {
            aj: n
        };
    }))), g9 = F2(function(n, r) {
        return dc(fg(A3(ag, $9, {
            aj: r
        }, rg(function(n) {
            return ml(KN(function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(n)));
        }(n)))));
    }), h9 = function(n) {
        return dc(fg(rg(ml(Rq(A2(MV, n.mm, 5))))));
    }, k9 = F2(function(n, r) {
        var t = "" === r ? Tt : kt(r);
        return dc(fg(A3(ag, M3, {
            bE: t
        }, rg(B3(n.mm)))));
    }), T9 = Kn("switchPlayer", function() {
        return pi;
    }), w9 = F8(function(n, r, t, e, u, a, i, o) {
        return {
            j0: o,
            eA: u,
            kw: r,
            lB: e,
            mm: n,
            fS: i,
            bl: a,
            rN: t
        };
    }), C9 = F2(function(n, r) {
        return {
            m2: n,
            ss: r
        };
    }), N9 = function(n) {
        return A8(w9, n.bl.mm, n.bl.kg, n.bl.rO, n.lB.n5, A2(zt, F2(function(n, r) {
            var t;
            return A2(C9, It(n), (t = Cq(r)).n5 ? "blackframe \u2208 [" + It(t.nT) + " ms, " + It(t.nK) + " ms]" : "silence \u2208 [" + It(t.nT) + " ms, " + It(t.nK) + " ms]");
        }), n.bl.jI), n.gR, n.bl.fS, n.bl.j0);
    }, S9 = function(n) {
        return dc(fg(rg(H_(n.mm))));
    }, L9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, y9 = F3(function(n, r, t) {
        return {
            c$: t,
            sn: n,
            h8: r
        };
    }), j9 = Po(A4(rc, "destFileKind", function(n) {
        return n.c$;
    }, rJ, A4(rc, "destVersionId", function(n) {
        return n.h8;
    }, xi, A4(rc, "srcUrl", function(n) {
        return n.sn;
    }, xi, Io(y9))))), P9 = Lo(wP({
        $: 4
    })), I9 = function(n) {
        switch(n){
            case "Material":
                return 0;
            case "Audio":
                return 1;
            case "Subtitle":
                return 2;
            default:
                return 3;
        }
    }, B9 = F2(function(n, r) {
        return dc(fg(A3(ag, j9, {
            c$: I9(r.qn.ss),
            sn: r.mz.ss,
            h8: n.mm
        }, rg(P9))));
    }), M9 = F8(function(n, r, t, e, u, a, i, o) {
        return {
            l2: o,
            fq: e,
            oZ: t,
            o$: a,
            gw: u,
            pk: n,
            qa: i,
            sr: r
        };
    }), O9 = A3(jH, "hash", Bi, A3(jH, "search", Bi, A3(jH, "pathname", Bi, A3(jH, "port", Bi, A3(jH, "hostname", Bi, A3(jH, "password", Bi, A3(jH, "username", Bi, A3(jH, "protocol", Bi, je(M9))))))))), q9 = A2(No, A2(DE, T([
        m("url", gi)
    ]), " return new URL(url); "), PE(O9)), D9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(B9, n.a, r);
                return q1(T([
                    A2(Yi, L9, A2(OC, function() {
                        return t;
                    }, A2(Qo, function() {
                        return {
                            lA: Au,
                            nO: "URL incorrect",
                            P: 500
                        };
                    }, q9(r.mz.ss))))
                ]));
            case 1:
                var e = n.a;
                return qK(p(r, e.$ ? {
                    lm: kt(e.a)
                } : {
                    lm: Tt,
                    mz: Iq(r.mz),
                    qn: Iq(r.qn)
                }));
            case 2:
                var u = p(r, {
                    mz: A2(gg, n.a, r.mz)
                });
                return qK(u);
            default:
                return qK(p(r, {
                    qn: A2(gg, n.a, r.qn)
                }));
        }
    }), x9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, R9 = F7(function(n, r, t, e, u, a, i) {
        return {
            bD: a,
            fp: t,
            c$: i,
            oZ: r,
            gp: u,
            gw: e,
            sp: n
        };
    }), V9 = Po(A4(rc, "kind", function(n) {
        return n.c$;
    }, rJ, A4(rc, "versionId", function(n) {
        return n.bD;
    }, xi, A4(rc, "path", function(n) {
        return n.gp;
    }, xi, A4(rc, "port", function(n) {
        return n.gw;
    }, xi, A4(rc, "host", function(n) {
        return n.fp;
    }, xi, A4(rc, "password", function(n) {
        return n.oZ;
    }, xi, A4(rc, "user", function(n) {
        return n.sp;
    }, xi, Io(R9))))))))), E9 = ml({
        $: 22
    }), z9 = F7(function(n, r, t, e, u, a, i) {
        var o = A7(R9, r, t, e, u, a, n.mm, I9(i));
        return dc(fg(A3(ag, V9, o, rg(E9))));
    }), U9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return q1(T([
                    A2(Yi, x9, A7(z9, n.a, r.mA.ss, r.mu.ss, r.mt.ss, r.mw.ss, r.mv.ss, r.qn.ss))
                ]));
            case 1:
                var t = n.a;
                return qK(p(r, t.$ ? {
                    lm: kt(t.a)
                } : {
                    lm: Tt,
                    mt: Iq(r.mt),
                    mu: Iq(r.mu),
                    mv: Iq(r.mv),
                    mw: Iq(r.mw),
                    mA: Iq(r.mA),
                    qn: Iq(r.qn)
                }));
            case 2:
                return qK(p(r, {
                    mA: A2(gg, n.a, r.mA)
                }));
            case 3:
                return qK(p(r, {
                    mu: A2(gg, n.a, r.mu)
                }));
            case 4:
                return qK(p(r, {
                    mt: A2(gg, n.a, r.mt)
                }));
            case 5:
                return qK(p(r, {
                    mw: A2(gg, n.a, r.mw)
                }));
            case 6:
                return qK(p(r, {
                    mv: A2(gg, n.a, r.mv)
                }));
            default:
                return qK(p(r, {
                    qn: A2(gg, n.a, r.qn)
                }));
        }
    }), H9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, W9 = ml({
        $: 21,
        a: 0
    }), Q9 = F4(function(n, r, t, e) {
        return {
            bD: t,
            jt: n,
            m2: r,
            c$: e
        };
    }), Z9 = Po(A4(rc, "kind", function(n) {
        return n.c$;
    }, rJ, A4(rc, "broadcastable", function(n) {
        return n.bD;
    }, xi, A4(rc, "key", function(n) {
        return n.m2;
    }, xi, A4(rc, "bucket", function(n) {
        return n.jt;
    }, xi, Io(Q9)))))), K9 = F4(function(n, r, t, e) {
        return dc(fg(A3(ag, Z9, {
            bD: n.mm,
            jt: r,
            m2: t,
            c$: I9(e)
        }, rg(W9))));
    }), Y9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(jX, T([
                    A2(Yi, H9, A4(K9, n.a, r.mx.ss, r.my.ss, r.qn.ss))
                ]), qK(r));
            case 1:
                return qK(n.a.$ ? r : p(r, {
                    mx: Iq(r.mx),
                    my: Iq(r.my),
                    qn: Iq(r.qn)
                }));
            case 2:
                return qK(p(r, {
                    mx: A2(gg, n.a, r.mx)
                }));
            case 3:
                return qK(p(r, {
                    my: A2(gg, n.a, r.my)
                }));
            default:
                return qK(p(r, {
                    qn: A2(gg, n.a, r.qn)
                }));
        }
    }), X9 = Po(A4(rc, "versionMapping", function(n) {
        return n.h9;
    }, ob, Io(function(n) {
        return {
            h9: n
        };
    }))), J9 = F2(function(n, r) {
        return dc(fg(A3(ag, X9, {
            h9: r
        }, rg(ml(E3(A2(V3, n.mm, 4)))))));
    }), G9 = F2(function(n, r) {
        switch(n.$){
            case 11:
                return A3(s_, function(n) {
                    return p(r, {
                        pX: n
                    });
                }, _8, A2(Y9, n.a, r.pX));
            case 12:
                return A3(s_, function(n) {
                    return p(r, {
                        lZ: n
                    });
                }, Z8, A2(U9, n.a, r.lZ));
            case 13:
                return A3(s_, function(n) {
                    return p(r, {
                        ix: n
                    });
                }, x8, A2(D9, n.a, r.ix));
            case 30:
                return qK(p(r, {
                    kB: A2(gg, n.a, r.kB)
                }));
            case 31:
                return qK(p(r, {
                    qF: A2(gg, n.a, r.qF)
                }));
            case 6:
                return A2(jX, T([
                    A2(Yi, Q8, (d = n.a, dc(fg(rg(Lo(I3(A2(P3, d.mm, 3))))))))
                ]), qK(p(r, {
                    kF: G8
                })));
            case 7:
                return (s = n.a).$ ? qK(p(r, {
                    kF: K8(s.a)
                })) : A2(IX, 1, qK(p(r, {
                    kF: r9
                })));
            case 0:
                return A2(jX, T([
                    A2(Yi, J8, (l = n.a, dc(fg(rg(ml(Rq(A2(MV, l.mm, 4))))))))
                ]), qK(p(r, {
                    pK: G8
                })));
            case 1:
                return (s = n.a).$ ? qK(p(r, {
                    pK: K8(s.a)
                })) : A2(IX, 1, qK(p(r, {
                    pK: r9
                })));
            case 2:
                return A2(jX, T([
                    A2(Yi, Y8, h9(n.a))
                ]), qK(p(r, {
                    pI: G8
                })));
            case 3:
                return (s = n.a).$ ? qK(p(r, {
                    pI: K8(s.a)
                })) : A2(IX, 1, qK(p(r, {
                    pI: r9
                })));
            case 4:
                return A2(jX, T([
                    A2(Yi, X8, A2(k9, n.a, r.bE.ss))
                ]), qK(p(r, {
                    pJ: G8
                })));
            case 5:
                return (s = n.a).$ ? qK(p(r, {
                    pJ: K8(s.a)
                })) : A2(IX, 1, qK(p(r, {
                    pJ: r9
                })));
            case 8:
                return qK(p(r, {
                    bE: A2(gg, n.a, r.bE)
                }));
            case 14:
                return qK(p(r, {
                    kf: A2(gg, n.a, r.kf)
                }));
            case 9:
                return A2(jX, T([
                    A2(Yi, E8, A2(u9, n.a, r.kf.ss))
                ]), qK(p(r, {
                    ke: G8
                })));
            case 10:
                return (s = n.a).$ ? qK(p(r, {
                    ke: K8(s.a)
                })) : A2(IX, 1, qK(p(r, {
                    ke: r9,
                    kf: U3(r.kf)
                })));
            case 15:
                switch(n.a){
                    case 9:
                        return qK(p(r, {
                            kF: Uf
                        }));
                    case 0:
                        return qK(p(r, {
                            pK: Uf
                        }));
                    case 1:
                        return qK(p(r, {
                            pI: Uf
                        }));
                    case 2:
                        return qK(p(r, {
                            pJ: Uf
                        }));
                    case 3:
                        return qK(p(r, {
                            ke: Uf
                        }));
                    case 4:
                        return qK(p(r, {
                            se: Uf
                        }));
                    case 6:
                        return qK(p(r, {
                            kE: Uf
                        }));
                    case 7:
                        return qK(p(r, {
                            d1: Uf
                        }));
                    case 8:
                        return qK(p(r, {
                            iK: Uf
                        }));
                    default:
                        return MK;
                }
            case 16:
                var t = n.a, e = ab(n.b.ss);
                return e.$ ? MK : A2(IX, 1, A2(jX, T([
                    A2(Yi, e9, A2(J9, t, e.a))
                ]), qK(p(r, {
                    se: G8
                }))));
            case 17:
                var u = n.a;
                return u.$ ? qK(p(r, {
                    se: K8(u.a)
                })) : A2(IX, 1, qK(p(r, {
                    se: r9
                })));
            case 18:
                return qK(p(r, {
                    i2: A2(gg, n.a, r.i2),
                    se: Uf
                }));
            case 19:
                return A2(jX, T([
                    A2(Yi, W8, a9(n.a))
                ]), qK(p(r, {
                    kE: G8
                })));
            case 20:
                return (s = n.a).$ ? qK(p(r, {
                    kE: K8(s.a)
                })) : A2(IX, 1, qK(p(r, {
                    kE: r9
                })));
            case 21:
                return A2(jX, T([
                    A2(Yi, V8, (f = n.a, dc(fg(rg(R_(f.mm))))))
                ]), qK(p(r, {
                    d1: G8
                })));
            case 22:
                return (s = n.a).$ ? qK(p(r, {
                    d1: K8(s.a)
                })) : A2(IX, 1, A2(IX, 0, qK(p(r, {
                    d1: r9
                }))));
            case 23:
                return A2(jX, T([
                    A2(Yi, t9, S9(n.a))
                ]), qK(p(r, {
                    d1: G8
                })));
            case 24:
                return (s = n.a).$ ? qK(p(r, {
                    d1: K8(s.a)
                })) : A2(IX, 1, A2(IX, 0, qK(p(r, {
                    d1: r9
                }))));
            case 25:
                return A2(jX, T([
                    T9(0)
                ]), qK(r));
            case 28:
                return qK(p(r, {
                    ko: kt(n.a)
                }));
            case 29:
                return A2($X, A2(Yi, z8, A2(g9, n.a, n.b)), qK(p(r, {
                    pf: G8
                })));
            case 32:
                return qK(p(r, (s = n.a).$ ? {
                    pf: K8(s.a)
                } : {
                    pf: r9
                }));
            case 26:
                var a = (b = m(r.l8, r.g6)).a && !b.b.$ ? A2(Yi, H8, dc(A2(Ho, lq, So(ml(KN(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(b.b.a.g6.mm))))))) : n$;
                return A2($X, a, qK(p(r, {
                    l8: !r.l8
                })));
            case 33:
                if ((s = n.a).$) return qK(p(r, {
                    pf: K8(s.a)
                }));
                var o = s.a;
                return qK(p(r, {
                    pf: r9,
                    dh: A2(Ge, A2(bu, x$(!1), N9), o)
                }));
            case 27:
                var c = n.a;
                return qK(p(r, {
                    dh: A2(Ge, function(n) {
                        return i(A2(No, Ko, function(n) {
                            return n.mm;
                        })(n), c) ? m(!n.a, n.b) : n;
                    }, r.dh)
                }));
            case 35:
                return A2($X, A2(Yi, U8, f9), qK(p(r, {
                    l7: !1
                })));
            case 34:
                return qK(p(r, (s = n.a).$ ? {
                    pf: K8(s.a)
                } : {
                    pg: s.a
                }));
            case 36:
                return qK(p(r, {
                    g6: kt(n.a)
                }));
            case 37:
                return qK(p(r, {
                    po: kt(n.a)
                }));
            case 38:
                return A2(jX, T([
                    A2(Yi, R8, A3(v9, n.a, "Media2Cloud", n.b))
                ]), qK(p(r, {
                    iK: G8
                })));
            case 39:
                return qK(p(r, (s = n.a).$ ? {
                    iK: K8(s.a)
                } : {
                    iK: r9
                }));
            case 42:
                return A2($X, A2(Yi, n9, dc(A2(Ho, d9, So(Lo(B$(A2(wM, n.a, 2))))))), qK(p(r, {
                    l9: !1
                })));
            case 40:
                return qK(p(r, {
                    qj: A2(gg, n.a, r.qj)
                }));
            default:
                var s;
                return qK(p(r, (s = n.a).$ ? {
                    iK: K8(s.a)
                } : {
                    $7: s.a
                }));
        }
        var f, l, d, b;
    }), _9 = {
        $: 5
    }, n7 = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), r7 = Oi({
        bN: "Wrong layout and/or version",
        bT: "Erreur sur une version et/ou un agencement"
    }), t7 = F3(function(n, r, t) {
        return {
            ft: n,
            r5: t,
            sv: r
        };
    }), e7 = Po(A4(rc, "typeVersion", function(n) {
        return n.r5;
    }, SS, A4(rc, "version", function(n) {
        return n.sv;
    }, h$, A4(rc, "index", function(n) {
        return n.ft;
    }, uc, Io(t7))))), u7 = F4(function(n, r, t, e) {
        var u = m(r, t);
        return u.a.$ || u.b.$ ? BL({
            lA: Au,
            nO: r7,
            P: 400
        }) : dc(fg(A3(ag, e7, {
            ft: e,
            r5: u.b.a,
            sv: u.a.a
        }, rg(Lo(v5(A2(p5, n, 1)))))));
    }), a7 = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 2:
                var t = n.a, e = n.b, u = n.c, a = {
                    r5: Ri(function(n) {
                        return p(n, {
                            m6: "TypeVersion",
                            ss: A2(ju, "", u)
                        });
                    }),
                    sv: Ri(function(n) {
                        return p(n, {
                            m6: "Version",
                            ss: A2(ju, "", e)
                        });
                    })
                };
                return qK(p(r, {
                    pv: kt(t),
                    sx: A3(wu, t, a, r.sx)
                }));
            case 0:
                var i = n.b;
                return qK(p(r, {
                    sx: A3(ko, o = n.a, Fu(function(n) {
                        return p(n, {
                            sv: A2(gg, i, n.sv)
                        });
                    }), r.sx)
                }));
            case 1:
                return i = n.b, qK(p(r, {
                    sx: A3(ko, o = n.a, Fu(function(n) {
                        return p(n, {
                            r5: A2(gg, i, n.r5)
                        });
                    }), r.sx)
                }));
            case 5:
                return MK;
            case 7:
                n = _9;
                continue n;
            case 4:
                return A2(jX, T([
                    A2(Gv, Ml(_9), IE(200))
                ]), qK(r));
            case 6:
                return qK(p(r, {
                    pv: Tt,
                    sx: A2(ho, t = n.a, r.sx)
                }));
            default:
                var o = n.a, c = function(n) {
                    var r = ze(n);
                    return r.$ ? -1 : r.a;
                }, s = function(n) {
                    var r = A2(Mt, "/", n);
                    return r.b && r.b.b ? m(r.a, r.b.a) : m("", "");
                }, f = function() {
                    var n = A2(lo, o, r.sx);
                    if (1 === n.$) return m(Tt, Tt);
                    var t = n.a.r5;
                    return m(Tx($$(n.a.sv.ss)), Tx(NS(t.ss)));
                }(), l = f.a, d = f.b, b = A2(N5, c, s(o)).a;
                return A2(jX, T([
                    A2(Yi, n7(o), A4(u7, b, l, d, 0))
                ]), qK(p(r, {
                    pv: Tt
                })));
        }
    }), i7 = F3(function(n, r, t) {
        n: for(;;)switch(n.$){
            case 0:
                return qK(r);
            case 18:
                return qK(p(r, {
                    qC: !r.qC
                }));
            case 17:
                var e = r.j8;
                return qK(p(r, {
                    j8: p(e, {
                        oD: A2(A2(fX, R = n.a, e.oD) ? pX : Is, R, e.oD)
                    })
                }));
            case 19:
                return qK(p(r, {
                    qD: !r.qD
                }));
            case 20:
                return qK(p(r, {
                    qE: !r.qE
                }));
            case 1:
                return y2(r) && !i(r.P.kv, Tt) ? qK(p(r, {
                    nj: !0
                })) : A2(jX, T([
                    A2(Yi, h1, T2(r.mm)),
                    A2(Yi, g1, e0(A2(ju, "", r.oL))),
                    A2(Yi, $1, G1(r.mm)),
                    G2,
                    n3
                ]), qK(X2(p(r, {
                    nj: !1
                }))));
            case 4:
                return qK(p(r, (V = n.a).$ ? {
                    e0: A2(HY, V.a, r.e0.kv)
                } : {
                    e0: hX(V.a)
                }));
            case 40:
                return n.a.$ ? MK : HX(ZK(0));
            case 2:
                if ((V = n.a).$) return qK(p(r, {
                    P: A2(HY, V.a, r.P.kv)
                }));
                var u = r.o5, a = r.$9, o = i(t.sp.oL, kt((N = V.a).oL.mm)) ? Ie : $X(A2(Yi, T1, wY(N.oL.mm))), c = function(n) {
                    return n.bQ.fY;
                }(A2(V1, r, N)), s = A2(ju, "00:00:00:00", A2(fp, S2, c)), f = !i(A2(Fu, A2(No, function(n) {
                    return n.g6;
                }, function(n) {
                    return n.mm;
                }), r.P.kv), kt(N.g6.mm)), l = function() {
                    var n = r.o2;
                    if (n.$) return H2(r);
                    var t = n.a;
                    return f ? H2(r) : kt(t);
                }();
                return o(A2(jX, T([
                    A2(cp, _Q, t3(N)),
                    A2(cp, JQ, G2),
                    A2(cp, v1, A2(x2, N.oL.mm, r.mm))
                ]), qK(p(r, {
                    $9: p(a, {
                        q4: s
                    }),
                    o2: l,
                    o5: function() {
                        return l.$ ? u : A2(Q2, r, l.a);
                    }(),
                    P: hX(N)
                }))));
            case 3:
                if ((V = n.a).$) return qK(p(r, {
                    P: A2(HY, V.a, r.P.kv)
                }));
                var b = V.a;
                return A2(jX, T([
                    A2(cp, _Q, r3(b))
                ]), qK(p(r, {
                    pn: kt(b)
                })));
            case 31:
                var v = n.a, $ = H2(r), h = function() {
                    return $.$ ? r.o5 : A2(Q2, r, $.a);
                }();
                return qK(p(r, {
                    o2: A2(Fu, function(n) {
                        return p(n, {
                            ro: v
                        });
                    }, $),
                    o4: !1,
                    o5: p(h, {
                        ro: v
                    })
                }));
            case 27:
                if (10 === n.a.$) {
                    var k = n.a.a;
                    if (k.$) return A2(Z2, p(r, {
                        o2: Tt
                    }), !0);
                    var w = k.a, C = r.P.kv;
                    if (C.$) return qK(r);
                    var N = C.a, A = function() {
                        if (w.$) {
                            var n = w.a, t = A2(Mt, "/", n);
                            if (t.b && t.b.b) {
                                var e = t.a, u = t.b.a;
                                return d(A3(E1, r, N, e), A3(z1, r, N, e), ze(u));
                            }
                            return d(A3(E1, r, N, n), A3(z1, r, N, n), Tt);
                        }
                        return d(Tt, A2(fp, A2(No, function(n) {
                            return n.pl;
                        }, function(n) {
                            return n.nv;
                        }), A2(V1, r, N).bQ.fY), Tt);
                    }(), S = A.a, L = A.b, y = A.c, F = A2(ju, Tt, A2(Fu, Y1, S)), j = A2(ju, g, A2(Fu, W1, S));
                    return s = A2(ju, "00:00:00:00", A2(fp, S2, S)), qK(L.$ ? r : p(r, {
                        o2: kt(A6(x1, s, L.a.mm, F, y, kt(25), j)),
                        o4: !1
                    }));
                }
                return A3(s_, function(n) {
                    var t, e = 1 === (t = n.qo).$ ? r.i4.qo : kt(t.a);
                    return p(r, {
                        i4: p(n, {
                            qo: e
                        })
                    });
                }, JQ, A2(y5, Q = n.a, r.i4));
            case 28:
                if (7 === (Q = n.a).$) {
                    if ((V = Q.b).$) return MK;
                    var P = p(r.i4, {
                        sx: A2(ho, Q.a, r.i4.sx)
                    }), I = p(r, {
                        i4: P
                    });
                    return A2(IX, 1, qK(I));
                }
                return A3(s_, function(n) {
                    return p(r, {
                        rp: n
                    });
                }, S1, A2(a7, Q, r.rp));
            case 5:
                switch(n.a.$){
                    case 12:
                        if (n.a.a.$) return A2(Z2, p(r, {
                            o2: Tt
                        }), !1);
                        if (i(kt(R = n.a.a.a), A2(Fu, function(n) {
                            return n.n2;
                        }, r.o2))) return A2(Z2, r, !0);
                        var B = function() {
                            var n = r.P.kv;
                            return n.$ ? Tt : Va(A2(Yc, Ie, A2(Yc, function(n) {
                                return A2(Fu, function(r) {
                                    return i(r.mm, R) ? kt(n) : Tt;
                                }, n.gI);
                            }, n.a.bP)));
                        }(), M = A2(ju, Tt, A2(Fu, n0, B));
                        return s = A2(ju, "00:00:00:00", A2(fp, L2, B)), F = A2(ju, Tt, A2(Fu, K1, B)), qK(p(r, {
                            i4: W2(r),
                            o2: A2(Fu, A2(bu, A5(x1, s, R, F, Tt, M), Q1), B),
                            o4: !1
                        }));
                    case 13:
                        var O = i(kt(kt(R = n.a.a)), A2(Fu, function(n) {
                            return n.ro;
                        }, r.o2)) ? Tt : kt(R), q = (h = r.o5, A2(Fu, function(n) {
                            return p(n, {
                                ro: O
                            });
                        }, r.o2));
                        return qK(p(r, {
                            o2: q,
                            o5: p(h, {
                                ro: O
                            })
                        }));
                    default:
                        return A3(s_, function(n) {
                            return p(r, {
                                bQ: n
                            });
                        }, k1, A2(L8, Q = n.a, r.bQ));
                }
            case 6:
                if (33 === n.a.$) {
                    var D = r.$9;
                    return A2(Z2, p(r, {
                        $9: p(D, {
                            l1: !D.l1
                        }),
                        o2: Tt,
                        o5: _s
                    }), !0);
                }
                return A3(s_, function(n) {
                    return p(r, {
                        $9: n
                    });
                }, s1, A3(c5, Q = n.a, r.$9, r.o5));
            case 7:
                return A3(s_, function(n) {
                    return p(r, {
                        ig: n
                    });
                }, c1, A2(H3, Q = n.a, r.ig));
            case 8:
                return A3(s_, function(n) {
                    return p(r, {
                        d1: n
                    });
                }, f1, A2(Y_, Q = n.a, r.d1));
            case 9:
                return A3(s_, function(n) {
                    return p(r, {
                        k1: n
                    });
                }, v1, A2(k8, Q = n.a, r.k1));
            case 10:
                return qK(r);
            case 11:
                return A3(s_, function(n) {
                    return p(r, {
                        oI: n
                    });
                }, _Q, A2(G9, Q = n.a, r.oI));
            case 12:
                return A3(s_, function(n) {
                    return p(r, {
                        i7: n
                    });
                }, l1, A2(j5, Q = n.a, r.i7));
            case 13:
                return A3(s_, function(n) {
                    return p(r, {
                        fB: n
                    });
                }, w1, A2(D8, Q = n.a, r.fB));
            case 14:
                return A3(s_, function(n) {
                    return p(r, {
                        cJ: n
                    });
                }, p1, A2(a1, Q = n.a, r.cJ));
            case 15:
                if (20 === n.a.$ && 1 === n.a.b.$) {
                    n = b1(A2(N1, n.a.a, kt(A2(j1, r.o5.q4, r.o5.kp))));
                    continue n;
                }
                return A3(s_, function(n) {
                    return p(r, {
                        kH: n
                    });
                }, b1, A3(o8, Q = n.a, r.kH, r.P.kv));
            case 16:
                return q = r.o2, qK(p(r, {
                    jo: !r.jo,
                    o2: r.jo ? Tt : q,
                    o4: !!r.jo || r.o4,
                    o5: r.jo ? _s : r.o5
                }));
            case 21:
                return q1(T([
                    V2((B = n.b).m2),
                    A2(Yi, C1, dY(B.mm))
                ]));
            case 25:
                return q1(T([
                    I1((B = n.b).m2),
                    A2(Yi, m1, iY(B.mm))
                ]));
            case 23:
                N = n.b;
                var x = e3((B = n.c).c$);
                return q1(T([
                    Y2(B.m2),
                    A2(Yi, A1, A3(oJ, N, x, B.n5))
                ]));
            case 22:
            case 24:
            case 26:
                return D1(1);
            case 29:
                var R;
                return A2(jX, T([
                    A2(Yi, d1, M1(R = n.a))
                ]), qK(r));
            case 30:
                var V;
                return (V = n.a).$ ? MK : A2(IX, 1, qK(r));
            case 32:
                return A2(Z2, p(r, {
                    o4: !1
                }), !1);
            case 34:
                return qK(p(r, {
                    r1: !1
                }));
            case 35:
                return qK(p(r, {
                    r1: !0
                }));
            case 33:
                return qK(p(r, {
                    o4: !0,
                    o5: _s
                }));
            case 37:
                var E = n.a, z = E.a, U = E.b, H = A2(Fu, function(n) {
                    return p(n, {
                        qp: kt(z),
                        qq: A2(G$, z, A2(Ge, $e, n.qq)) ? A2(Iu, function(n) {
                            return !i(n.a, z);
                        }, n.qq) : A2(dt, m(z, U), n.qq)
                    });
                }, r.o2);
                return A2(Z2, p(r, {
                    o2: H,
                    o4: !1
                }), !1);
            case 36:
                return qK(p(r, {
                    iX: !r.iX
                }));
            case 38:
                var W = n.a;
                return H = A2(Fu, function(n) {
                    return p(n, {
                        qq: W
                    });
                }, r.o2), qK(p(r, {
                    o2: H
                }));
            case 39:
                var Q, Z = A2(k3, Q = n.a, r.o5);
                return P = Z.a, A2($X, A2(cp, nZ, Z.b), qK(p(r, {
                    o5: P
                })));
            default:
                return HX(O1(n.a));
        }
    }), o7 = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return A2(pc, g, p(r, {
                rR: A3(f_, t.a, t.b, r.rR)
            }));
        }
        var e = n.a;
        return A2(pc, g, p(r, e.$ ? {
            lm: kt(e.a.nO)
        } : {
            lm: Tt,
            rR: a_(e.a)
        }));
    }), c7 = {
        $: 1
    }, s7 = function(n) {
        return 1 === n.ak.sn.$ ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.g6.P.kv) : c7;
    }, f7 = F2(function(n, r) {
        switch(n.$){
            case 14:
                return A2(pc, g, r);
            case 3:
                var t = $v(n.a), e = A3(WH, !1, t, r), u = (s = e.a).ak;
                return A2(pc, T([
                    e.b
                ]), p(s, {
                    ak: p(u, {
                        sn: t
                    })
                }));
            case 13:
                return A2(pc, g, 27 === n.a ? p(r, {
                    sg: jc(r.ak.sp)
                }) : r);
            case 1:
                var a = n.a, o = n.b;
                return i(a, r.g6.mm) ? A4(VK, function(n) {
                    return p(r, {
                        g6: n
                    });
                }, hv(a), r.g6, A3(i7, o, r.g6, r.ak)) : A2(pc, g, r);
            case 2:
                return A4(VK, function(n) {
                    return p(r, {
                        ok: n
                    });
                }, gv, r.ok, A3(i1, o = n.a, r.ok, r.ak));
            case 5:
                var c = A2(o7, o = n.a, r.rR), s = c.a;
                return A2(pc, T([
                    A2(cp, Fi, c.b)
                ]), p(r, {
                    rR: s
                }));
            case 8:
                var f = A2(tY, o = n.a, r.iw);
                return s = f.a, A2(pc, T([
                    A2(cp, Ci, f.b)
                ]), p(r, {
                    iw: s
                }));
            case 7:
                var l = A2(EK, o = n.a, r.b9);
                return s = l.a, A2(pc, T([
                    A2(cp, bK, l.b)
                ]), p(r, {
                    b9: s
                }));
            case 6:
                var m = A2(nY, o = n.a, r.dp);
                return s = m.a, A2(pc, T([
                    A2(cp, yi, m.b)
                ]), p(r, {
                    dp: s
                }));
            case 0:
                var d = A2(AY, o = n.a, r.ak);
                return s = d.a, A2(pc, T([
                    A2(cp, pW, d.b)
                ]), p(r, {
                    ak: s
                }));
            case 9:
                return A4(VK, function(n) {
                    return p(r, {
                        sg: n
                    });
                }, gW, r.sg, A2(pJ, o = n.a, r.sg));
            case 10:
                var b = A3(RX, o = n.a, r.qa, r.el);
                return s = b.a, A2(pc, T([
                    A2(cp, pK, b.b)
                ]), p(r, {
                    qa: s
                }));
            case 11:
                var v = A2(vJ, o = n.a, r.l5);
                return s = v.a, A2(pc, T([
                    A2(cp, Ai, v.b)
                ]), p(r, {
                    l5: s
                }));
            case 12:
                if (2 === n.a.$) {
                    var $ = n.a.a, h = A4(VK, function(n) {
                        return p(r, {
                            sg: n
                        });
                    }, gW, r.sg, A3(DK, s7(r), $, r.sg));
                    return s = h.a, A2(pc, T([
                        h.b
                    ]), p(s, {
                        k_: A2(o1, dK($), r.k_)
                    }));
                }
                return A2(pc, g, p(r, {
                    k_: A2(o1, o = n.a, r.k_)
                }));
            case 4:
                return A4(VK, function(n) {
                    return p(r, {
                        el: n
                    });
                }, Ni, r.el, A2(BX, o = n.a, r.el));
            default:
                return A2(pc, g, p(r, {
                    mU: !n.a
                }));
        }
    }), l7 = F2(function(n, r) {
        var t = m(r, n);
        n: for(;;){
            if (t.a.$) {
                if (t.b.$) break n;
                var e = A2(f7, t.b.a, t.a.a);
                return a = e.b, m(Si(e.a), A2(cp, Li, a));
            }
            if (1 === t.b.$) {
                var u = A2(mK, t.b.a, t.a.a), a = u.b;
                return m(mi(u.a), A2(cp, lW, a));
            }
            break n;
        }
        return m(r, n$);
    }), m7 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, d7 = {
        $: 1
    }, b7 = Oi({
        bN: "Back to login",
        bT: "Retour au login"
    }), p7 = F2(function(n, r) {
        return A2(zT, T([
            WT(n),
            Rg("AccountForm")
        ]), r);
    }), v7 = F2(function(n, r) {
        return A2(aw, T([
            sw(n)
        ]), T([
            A2(Zj, g, T([
                ih(r)
            ]))
        ]));
    }), $7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, g7 = function(n) {
        switch(n.$){
            case 0:
                return "/";
            case 1:
                switch(n.a.$){
                    case 1:
                        return "/account/forgotPassword";
                    case 0:
                        var r = n.a.a.lX;
                        if (1 === r.$) return "/account/login";
                        switch(r.a){
                            case "/":
                            case "/logout":
                                return "/account/login";
                            default:
                                return "/account/login?from=" + r.a;
                        }
                    case 2:
                        return "/account/resetPassword?email=" + n.a.a.k8 + "&token=" + n.a.a.rY;
                    default:
                        return "/account/invitation?redirect=" + n.a.a.pA + "&email=" + n.a.a.k8 + "&token=" + n.a.a.rY;
                }
            case 2:
                switch(n.a){
                    case 0:
                        return "/services/forProd";
                    case 1:
                        return "/services/forTv";
                    case 2:
                        return "/services";
                    default:
                        return "/services/references";
                }
            case 3:
                return "/legal";
            default:
                return "/404";
        }
    }, h7 = g7($7(function(n) {
        return {
            $: 0,
            a: n
        };
    }({
        lX: Tt
    }))), k7 = Oi({
        bN: "Password forgotten",
        bT: "Mot de passe oubli\xe9"
    }), T7 = Oi({
        bN: "Recover",
        bT: "R\xe9cup\xe8rer"
    }), w7 = Oi({
        bN: "Email sent",
        bT: "Email envoy\xe9"
    }), C7 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, N7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, S7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, L7 = {
        $: 4
    }, y7 = Oi({
        bN: "Answer invitation",
        bT: "R\xe9pondre \xe0 l\u2019invitation"
    }), j7 = function(n) {
        return A2(Le, T([
            Rg("BannerEmptyness")
        ]), T([
            jB,
            A2(Dh, T([
                Rg("BannerContent")
            ]), n)
        ]));
    }, P7 = function(n) {
        switch(n){
            case 0:
                return Oi({
                    bN: "Confirmation doesn't match password",
                    bT: "La confirmation est differente du mot de passe"
                });
            case 1:
                return Oi({
                    bN: "Password is too short (min. 9)",
                    bT: "Mot de passe trop court (min. 9)"
                });
            case 2:
                return Oi({
                    bN: "Password must contain at least a lowercase char.",
                    bT: "Le mot de passe doit contenir au moins un caract\xe8re minuscule."
                });
            case 3:
                return Oi({
                    bN: "Password must contain at least an uppercase char.",
                    bT: "Le mot de passe doit contenir au moins caract\xe8re majuscule."
                });
            case 4:
                return Oi({
                    bN: "Password must contain at least a number.",
                    bT: "Le mot de passe doit contenir au moins un chiffre."
                });
            default:
                return Oi({
                    bN: "Password must contain at least a special char.",
                    bT: "Le mot de passe doit contenir au moins un caract\xe8re sp\xe9cial."
                });
        }
    }, I7 = Oi({
        bN: "Send",
        bT: "Envoyer"
    }), B7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, M7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, O7 = Oi({
        bN: "Access Nomalab",
        bT: "Acc\xe9der \xe0 Nomalab"
    }), q7 = Oi({
        bN: "Connection",
        bT: "Connexion"
    }), D7 = g7($7({
        $: 1
    })), x7 = Oi({
        bN: "Forgot password?",
        bT: "Mot de passe oubli\xe9"
    }), R7 = Oi({
        bN: "Submit Email",
        bT: "Valider Email"
    }), V7 = Oi({
        bN: "Email sent. You have 48h to validate.",
        bT: "Un email vient de vous \xeatre envoy\xe9. Vous disposez de 48h pour le valider."
    }), E7 = function(n) {
        return A2(Le, T([
            Rg("AccountMessage")
        ]), T([
            function() {
                switch(n.$){
                    case 0:
                        return ih("");
                    case 1:
                        return A2(Dh, T([
                            Rg("AccountSuccess")
                        ]), V7);
                    default:
                        var r = n.a;
                        return A2(Dh, T([
                            Rg("AccountFail")
                        ]), r);
                }
            }()
        ]));
    }, z7 = Fg("fill"), U7 = Fg("stroke"), H7 = Fg("stroke-linejoin"), W7 = Fg("stroke-width"), Q7 = A2(Kg, T([
        Yg("0 0 524 134"),
        Xg("524px")
    ]), T([
        A2(BT, g, T([
            A2(ow, T([
                iw("M419.771468,31.2572374 L419.771468,96.3052532 L429.351007,98.6620653 L429.351007,103.847052 L401.85773,103.847052 L401.85773,98.6620653 L410.000338,96.3052532 L410.000338,38.7990363 L401.85773,36.9135866 L401.85773,31.7285998 L419.771468,31.2572374 Z M433.014638,56.7108088 C439.91194,54.1968632 446.234372,52.9399093 451.982124,52.9399093 C457.602149,52.9399093 461.912898,54.0554559 464.914502,56.2865826 C467.916106,58.5177093 469.416885,62.2728591 469.416885,67.5521447 L469.416885,96.3052532 L477.080516,98.1907029 L477.080516,103.37569 L462.232231,103.847052 L460.220528,97.247978 C455.111415,102.275869 450.066242,104.789777 445.084857,104.789777 C440.103471,104.789777 436.367489,103.564247 433.876796,101.11315 C431.386104,98.6620531 430.140776,95.1740059 430.140776,90.648904 C430.140776,80.907365 437.485016,76.0366685 452.173715,76.0366685 L459.837346,76.0366685 L459.837346,68.4948696 C459.837346,62.8384921 456.803856,60.0103458 450.736784,60.0103458 C447.288133,60.0103458 444.446232,60.3560081 442.210995,61.0473432 L441.06145,61.4244331 L439.720315,68.4948696 L433.493615,68.4948696 L433.014638,56.7108088 Z M459.837346,82.1643802 L453.131669,82.1643802 C448.341876,82.1643802 444.941174,82.7771452 442.92946,84.0026937 C440.917747,85.2282421 439.911906,87.1293849 439.911906,89.7061791 C439.911906,92.157276 440.502638,94.026995 441.68412,95.315392 C442.865603,96.6037891 444.573937,97.247978 446.809174,97.247978 C447.89486,97.247978 448.996496,97.0594349 450.114114,96.6823431 C451.231733,96.3052513 452.317403,95.8338936 453.371158,95.2682558 C454.424912,94.7026181 455.366891,94.089853 456.197122,93.4299423 C457.027352,92.7700316 457.697913,92.1572666 458.208825,91.5916288 L459.837346,89.7061791 L459.837346,82.1643802 Z M489.197547,31.2572374 L489.197547,58.4077135 C493.859613,54.7624925 498.649334,52.9399093 503.566856,52.9399093 C510.33643,52.9399093 515.381603,55.1081548 518.702527,59.4447109 C522.02345,63.781267 523.683887,69.9403412 523.683887,77.9221183 C523.683887,81.8187339 523.10912,85.4167645 521.95957,88.716318 C520.81002,92.0158715 519.117651,94.8597298 516.882414,97.247978 C514.647178,99.6362263 511.901071,101.490233 508.644011,102.810055 C505.386952,104.129876 501.619037,104.789777 497.340155,104.789777 C494.083096,104.726928 491.161366,104.585521 488.574877,104.365551 C485.988389,104.145581 483.705288,103.721359 481.725507,103.092872 L479.618009,102.432965 L479.618009,38.7990363 L471.954378,36.9135866 L471.954378,31.7285998 L489.197547,31.2572374 Z M489.197547,96.3052532 C490.730281,96.9337395 494.051155,97.247978 499.160268,97.247978 C501.714824,97.247978 503.90213,96.7766203 505.722252,95.8338907 C507.542373,94.8911611 509.043153,93.5870715 510.224635,91.9215825 C511.406117,90.2560936 512.268267,88.2763912 512.81111,85.9824159 C513.353954,83.6884406 513.625371,81.1902446 513.625371,78.4877532 C513.625371,72.8313757 512.651461,68.4163251 510.703612,65.2424688 C508.755763,62.0686126 505.738238,60.4817082 501.650948,60.4817082 C498.457752,60.4817082 495.887268,61.0944733 493.939419,62.3200217 C491.99157,63.5455702 490.410962,64.9753553 489.197547,66.6094199 L489.197547,96.3052532 Z"),
                z7("#3BAAFF")
            ]), g),
            A2(ow, T([
                iw("M172.806239,53.8826342 L173.668397,60.5759807 C174.307037,60.0731916 175.201118,59.381867 176.350668,58.501986 C177.500219,57.6221051 178.857306,56.7736612 180.421972,55.9566289 C181.986638,55.1395966 183.710938,54.43256 185.594923,53.8354979 C187.478909,53.2384359 189.442694,52.9399093 191.48634,52.9399093 C196.659316,52.9399093 200.507059,54.4325421 203.029684,57.4178524 C205.552308,60.4031628 206.813602,64.5668226 206.813602,69.9089569 L206.813602,96.3052532 L213.998256,98.6620653 L213.998256,103.847052 L191.007363,103.847052 L191.007363,98.6620653 L197.234063,96.3052532 L197.234063,70.8516818 C197.234063,67.4578553 196.563502,64.9596594 195.22236,63.3570191 C193.881218,61.7543788 191.837603,60.9530707 189.091455,60.9530707 C187.750313,60.9530707 186.425156,61.1259018 185.115946,61.4715693 C183.806736,61.8172369 182.59334,62.2728827 181.475722,62.8385204 C180.358103,63.4041582 179.368227,64.0169232 178.506065,64.6768339 C177.643902,65.3367446 176.925444,65.9809335 176.350668,66.6094199 L174.722147,68.4948696 L174.722147,96.3052532 L180.948847,98.6620653 L180.948847,103.847052 L157,103.847052 L157,98.6620653 L165.142608,96.3052532 L165.142608,61.4244331 L157,59.5389834 L157,54.3539966 L172.806239,53.8826342 Z M213.703933,79.619023 C213.703933,75.5967102 214.294665,71.9358319 215.476147,68.6362783 C216.65763,65.3367248 218.334032,62.5242904 220.505405,60.1988908 C222.676778,57.8734911 225.247262,56.0823318 228.216934,54.825359 C231.186606,53.5683863 234.459582,52.9399093 238.035961,52.9399093 C245.188719,52.9399093 250.744796,55.1710025 254.704359,59.6332559 C258.663921,64.0955092 260.643673,70.2860073 260.643673,78.2049357 C260.643673,82.1015513 260.068906,85.6681581 258.919356,88.904863 C257.769805,92.1415678 256.157266,94.9382903 254.081689,97.2951143 C252.006112,99.6519382 249.483525,101.490233 246.513853,102.810055 C243.544181,104.129876 240.239273,104.789777 236.59903,104.789777 C229.318545,104.789777 223.682639,102.652955 219.691145,98.3792479 C215.69965,94.1055404 213.703933,87.8521947 213.703933,79.619023 L213.703933,79.619023 Z M237.65278,60.4817082 C228.392513,60.4817082 223.762448,66.6093586 223.762448,78.8648431 C223.762448,91.1203277 228.232855,97.247978 237.173803,97.247978 C241.835868,97.247978 245.236571,95.6767856 247.376012,92.5343537 C249.515453,89.3919218 250.585157,84.6783446 250.585157,78.3934807 C250.585157,66.4522394 246.274408,60.4817082 237.65278,60.4817082 L237.65278,60.4817082 Z M276.113543,53.8826342 L276.975701,60.5759807 C277.869796,59.7589484 278.955466,58.8947926 280.232744,57.9834873 C281.510023,57.0721821 282.915008,56.2394501 284.447741,55.4852664 C285.980475,54.7310828 287.593015,54.1183177 289.285409,53.646953 C290.977802,53.1755882 292.654205,52.9399093 294.314666,52.9399093 C300.764921,52.9399093 305.203397,55.6423602 307.630225,61.0473432 C308.779776,59.9160677 310.120898,58.8633688 311.653632,57.8892149 C313.186365,56.915061 314.766973,56.0509051 316.395503,55.2967215 C318.024033,54.5425378 319.620607,53.9611966 321.185273,53.5526805 C322.749938,53.1441643 324.170889,52.9399093 325.448167,52.9399093 C335.347074,52.9399093 340.296452,58.5962019 340.296452,69.9089569 L340.296452,96.3052532 L347.481107,98.6620653 L347.481107,103.847052 L324.490213,103.847052 L324.490213,98.6620653 L330.716914,96.3052532 L330.716914,70.8516818 C330.716914,67.3950066 330.110216,64.8810988 328.896801,63.3098828 C327.683387,61.7386669 325.703635,60.9530707 322.957487,60.9530707 C321.616345,60.9530707 320.32312,61.1259018 319.077774,61.4715693 C317.832428,61.8172369 316.666929,62.2728827 315.581242,62.8385204 C314.495556,63.4041582 313.537612,64.0169232 312.707381,64.6768339 C311.87715,65.3367446 311.206589,65.9809335 310.695678,66.6094199 L309.162951,68.4948696 L309.162951,96.3052532 L315.389652,98.6620653 L315.389652,103.847052 L293.356713,103.847052 L293.356713,98.6620653 L299.583413,96.3052532 L299.583413,70.8516818 C299.583413,67.3950066 298.976715,64.8810988 297.7633,63.3098828 C296.549886,61.7386669 294.570134,60.9530707 291.823986,60.9530707 C290.482844,60.9530707 289.189619,61.1259018 287.944273,61.4715693 C286.698927,61.8172369 285.533428,62.2728827 284.447741,62.8385204 C283.362055,63.4041582 282.404111,64.0169232 281.57388,64.6768339 C280.743649,65.3367446 280.073088,65.9809335 279.562177,66.6094199 L278.02945,68.4948696 L278.02945,96.3052532 L284.256151,98.6620653 L284.256151,103.847052 L260.307304,103.847052 L260.307304,98.6620653 L268.449912,96.3052532 L268.449912,61.4244331 L260.307304,59.5389834 L260.307304,54.3539966 L276.113543,53.8826342 Z M353.539622,56.7108088 C360.436925,54.1968632 366.759357,52.9399093 372.507109,52.9399093 C378.127133,52.9399093 382.437883,54.0554559 385.439486,56.2865826 C388.44109,58.5177093 389.94187,62.2728591 389.94187,67.5521447 L389.94187,96.3052532 L397.605501,98.1907029 L397.605501,103.37569 L382.757215,103.847052 L380.745512,97.247978 C375.636399,102.275869 370.591226,104.789777 365.609841,104.789777 C360.628456,104.789777 356.892473,103.564247 354.401781,101.11315 C351.911088,98.6620531 350.665761,95.1740059 350.665761,90.648904 C350.665761,80.907365 358.01,76.0366685 372.6987,76.0366685 L380.362331,76.0366685 L380.362331,68.4948696 C380.362331,62.8384921 377.328841,60.0103458 371.261769,60.0103458 C367.813118,60.0103458 364.971216,60.3560081 362.735979,61.0473432 L361.586435,61.4244331 L360.245299,68.4948696 L354.018599,68.4948696 L353.539622,56.7108088 Z M380.362331,82.1643802 L373.656654,82.1643802 C368.86686,82.1643802 365.466158,82.7771452 363.454445,84.0026937 C361.442732,85.2282421 360.43689,87.1293849 360.43689,89.7061791 C360.43689,92.157276 361.027622,94.026995 362.209105,95.315392 C363.390587,96.6037891 365.098921,97.247978 367.334158,97.247978 C368.419845,97.247978 369.52148,97.0594349 370.639099,96.6823431 C371.756717,96.3052513 372.842388,95.8338936 373.896142,95.2682558 C374.949897,94.7026181 375.891875,94.089853 376.722106,93.4299423 C377.552337,92.7700316 378.222898,92.1572666 378.733809,91.5916288 L380.362331,89.7061791 L380.362331,82.1643802 Z"),
                z7("#FFFFFF"),
                jg("HomeLogoNomalab")
            ]), g),
            A2(BT, T([
                U7("#252F3A"),
                H7("round"),
                W7("4"),
                Cj("translate(2.000000, 2.000000)")
            ]), T([
                A2(Zg, T([
                    z7("#FFFFFF"),
                    Ug("40 10 60 0 120 30 120 50 100 60 140 80 140 100 80 130 60 120 60 100 20 120 0 110 0 50 20 40 40 50")
                ]), g),
                A2(Zg, T([
                    z7("#3BAAFF"),
                    Ug("80 10 60 20 60 40 40 50 60 60 80 50 100 60 100 40 80 30")
                ]), g),
                A2(Zg, T([
                    z7("#3BAAFF"),
                    Ug("40 50 20 60 20 80 0 90 20 100 40 90 60 100 60 80 40 70")
                ]), g),
                A2(Zg, T([
                    z7("#3BAAFF"),
                    Ug("100 60 80 70 80 90 60 100 80 110 100 100 120 110 120 90 100 80")
                ]), g)
            ]))
        ]))
    ])), Z7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, K7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Y7 = {
        $: 3
    }, X7 = Oi({
        bN: "Back to login",
        bT: "Retour au login"
    }), J7 = Oi({
        bN: "Change",
        bT: "Changer"
    }), G7 = function(n) {
        return A2(jT, n, function(n) {
            return A2(Rh, n, A2(Eh, T([
                Rg("InputPassword"),
                Xh(n.kV),
                Ch("password"),
                ek(Fh),
                _h(jh),
                nk(Ph),
                ak(n.ss),
                uk(n.gt),
                zh(Kh(n.m6)),
                Vh(n.kQ),
                A2(IB, "autocomplete", "new-password")
            ]), g));
        }(n));
    }, _7 = Oi({
        bN: "Lost password",
        bT: "Mot de passe oubli\xe9"
    }), nnn = Oi({
        bN: "Your password has been changed",
        bT: "Votre mot de passe a \xe9t\xe9 chang\xe9"
    }), rnn = function(n) {
        switch(n.$){
            case 0:
                return ih("");
            case 1:
                return ih(nnn);
            default:
                return ih(n.a);
        }
    }, tnn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, enn = {
        $: 0
    }, unn = {
        $: 1
    }, ann = F2(function(n, r) {
        return A2(Bg, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), inn = F2(function(n, r) {
        return A2(ann, n, je({
            nO: r,
            pe: !0,
            rf: !1
        }));
    }), onn = inn("dragenter"), cnn = inn("dragleave"), snn = inn("dragover"), fnn = F3(function(n, r, t) {
        return A2(ann, n, A2(ye, function(n) {
            return {
                nO: t(n),
                pe: !0,
                rf: !0
            };
        }, r));
    }), lnn = F2(function(n, r) {
        return A3(fnn, "drop", r, function(r) {
            return n(dK(r));
        });
    }), mnn = F2(function(n, r) {
        return T([
            onn(n(enn)),
            cnn(n(unn)),
            snn(n(enn)),
            A2(lnn, n, r)
        ]);
    }), dnn = F4(function(n, r, t, e) {
        return {
            jf: e,
            nS: t,
            n5: n,
            qO: r
        };
    }), bnn = A5(uU, dnn, A2(mu, "name", Bi), A2(mu, "size", tc), A2(mu, "type", A2(ye, function(n) {
        return qe(n) > 0 ? kt(n) : Tt;
    }, Bi)), Pi), pnn = A2(Jh, T([
        "dataTransfer",
        "files"
    ]), ac(bnn)), vnn = function(n) {
        return 1 === n.aL;
    }, $nn = F2(function(n, r) {
        return iC(A2(bu, dk(n), r));
    }), gnn = fr, hnn = F3(function(n, r, t) {
        return nT(A2(n, r, t));
    }), knn = F3(function(n, r, t) {
        return fi(A4(gnn, hnn, n, r, t));
    }), Tnn = knn, wnn = F2(function(n, r) {
        return Tnn(F2(function(t, e) {
            return A2(dk, n, A2(r, t, e));
        }));
    }), Cnn = F2(function(n, r) {
        return eT(F3(function(t, e, u) {
            return A2(dk, n, A3(r, t, e, u));
        }));
    }), Nnn = {
        $: 0
    }, Ann = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Snn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Lnn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ynn = Oi({
        bN: "Please contact our customer service via email or chat ",
        bT: "Merci de contacter notre service op\xe9rations via le chat ou par mail "
    }), Fnn = T([
        ih(ynn),
        A2(aw, T([
            sw("mailto:ops@nomalab.com")
        ]), T([
            ih("ops@nomalab.com")
        ])),
        ih(".")
    ]), jnn = F2(function(n, r) {
        return A2(Uq, n, A2(Le, g, T([
            "" === r.nO && ux(r.lA) ? A2(Zj, g, Fnn) : ih(""),
            "" === r.nO ? ih("") : A2(Zj, g, T([
                ih(r.nO)
            ])),
            ux(r.lA) ? ih("") : A2(sE, g, A2(Ge, function(n) {
                return A2(lE, g, T([
                    ih(n)
                ]));
            }, Ju(_I(r.lA))))
        ])));
    }), Pnn = Oi({
        bN: "Generate",
        bT: "G\xe9n\xe9rer"
    }), Inn = Oi({
        bN: "error occurred",
        bT: "Une erreur est survenue"
    }), Bnn = Inn, Mnn = function(n) {
        return A2(Rh, n, A2(Eh, T([
            Rg("InputText"),
            Ch("date"),
            ek(Fh),
            ak(n.ss),
            uk(n.gt),
            zh(Kh(n.m6)),
            Vh(n.kQ)
        ]), g));
    }, Onn = function(n) {
        return A2(jT, n, Mnn(n));
    }, qnn = Oi({
        bN: "Report",
        bT: "Rapport"
    }), Dnn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), xnn = F3(function(n, r, t) {
        return ml(function(n) {
            return {
                $: 15,
                a: n
            };
        }(A3(Dnn, n, r, t)));
    }), Rnn = F2(function(n, r) {
        var t, e = "rapport_" + r.q1.ss + "_" + r.lh.ss + ".csv";
        return A2(Le, T([
            Rg("AccountReportWrapper")
        ]), T([
            $w(p(gw, {
                rS: qnn
            })),
            A2(Le, T([
                Rg("AccountReportContainer")
            ]), T([
                A2(Le, T([
                    wh(Nnn)
                ]), T([
                    (t = r.lm, t.$ ? ih("") : A2(jnn, Bnn, t.a))
                ])),
                A2(dk, Lnn, Onn(r.q1)),
                A2(dk, Ann, Onn(r.lh)),
                A2(dk, Snn, jO(r.oP)),
                lB(p(oB, {
                    jO: kt("AccountReportSubmit"),
                    lv: T([
                        A2(IB, "target", "_blank"),
                        A2(IB, "data-prevent-history", "true"),
                        A2(IB, "download", e)
                    ]),
                    m6: Pnn,
                    sn: kt(Ao(A3(xnn, r.q1.ss, r.lh.ss, vt(r.oP.st))))
                }))
            ]))
        ]));
    }), Vnn = {
        $: 7
    }, Enn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, znn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Unn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hnn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Wnn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qnn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Znn = {
        $: 6
    }, Knn = {
        $: 9
    }, Ynn = Oi({
        bN: "Change password",
        bT: "Changer de mot de passe"
    }), Xnn = Oi({
        bN: "General Informations",
        bT: "Informations g\xe9n\xe9rales"
    }), Jnn = Oi({
        bN: "Save",
        bT: "Enregistrer"
    }), Gnn = Oi({
        bN: "Settings",
        bT: "Param\xe8tres"
    }), _nn = F2(function(n, r) {
        return A2(Sg, T([
            wh(r),
            Ch("button"),
            Rg("Button")
        ]), T([
            ih(n)
        ]));
    }), nrn = F3(function(n, r, t) {
        var e = r.a, u = r.b;
        return A2(Le, T([
            A2(ph, "max-width", "500px"),
            A2(ph, "margin", "10px")
        ]), T([
            A2(mN, g, T([
                ih(n)
            ])),
            A2(Le, g, t),
            A2(Le, T([
                A2(ph, "display", "flex"),
                A2(ph, "justify-content", "flex-end")
            ]), T([
                A2(_nn, e, u)
            ]))
        ]));
    }), rrn = Oi({
        bN: "Success",
        bT: "Succ\xe8s"
    }), trn = F2(function(n, r) {
        return A2(Le, T([
            Rg("BannerSuccess")
        ]), T([
            A2(Le, T([
                Rg("BannerHeader")
            ]), T([
                Th,
                zq(n)
            ])),
            A2(Le, T([
                Rg("BannerContent")
            ]), T([
                r
            ]))
        ]));
    }), ern = F2(function(n, r) {
        var t, e, u;
        return A2(Le, T([
            Rg("SettingsContainer")
        ]), T([
            $w(p(gw, {
                rS: Gnn
            })),
            A2(Le, T([
                wh(Vnn)
            ]), T([
                (u = r.lm, u.$ ? ih("") : A2(jnn, Bnn, u.a)),
                (e = r.rv, e.$ ? ih("") : A2(trn, rrn, ih(e.a)))
            ])),
            A3(nrn, Xnn, m(Jnn, Znn), T([
                A2(dk, Unn, IT(r.n5)),
                A2(dk, znn, IT(r.k8)),
                A2(dk, Enn, PT(r.kP))
            ])),
            A2(FF, i(r.mS, kt(!1)), A3(nrn, Ynn, m(Jnn, Knn), T([
                A2(dk, Qnn, xz(r.oZ)),
                A2(dk, Hnn, G7(r.od)),
                A2(dk, Wnn, G7(r.oe)),
                (t = r.o_, t.$ ? ih("") : j7(P7(t.a)))
            ]))),
            A2(Le, T([
                Rg("Version")
            ]), T([
                ih("version " + r.sv)
            ]))
        ]));
    }), urn = F4(function(n, r, t, e) {
        var u = e, a = u.l(n);
        return a.$ ? A2(Le, g, g) : A2(dk, u.p, A2(u.r, r, a.a));
    }), arn = F3(function(n, r, t) {
        var e = A3(urn, t.oV, n, r);
        return A3(kk, "div", T([
            Rg("AdminWrapper"),
            Rg("DarkZone")
        ]), T([
            function() {
                switch(r.$){
                    case 0:
                        return m("AdminHome", A2(dk, Ie, e(Sj)));
                    case 1:
                        return m("AdminOrganizations", A2(dk, Ie, e(HO)));
                    case 2:
                        return m("AdminOnboarding", A2(dk, Ie, e(vB)));
                    case 3:
                        return m("AdminUsers", A2(dk, Ie, e(Hz)));
                    case 4:
                        return m("AdminUploads", A2(dk, Ie, e(vE)));
                    case 5:
                        return m("AdminTestPlans", A2(dk, Ie, e(pR)));
                    case 6:
                        return m("AdminAudioMappings", A2(dk, Ie, e(Tw)));
                    case 7:
                        return m("AdminChannels", A2(dk, Ie, e(AC)));
                    case 8:
                        return m("AdminResearchs", A2(dk, Ie, e(rD)));
                    case 9:
                        return m("AdminWebhooks", A2(dk, Ie, e(aH)));
                    case 10:
                        return m("AdminOrganizationListings", A2(dk, Ie, e(qB)));
                    case 11:
                        return m("AdminFormats", A2(dk, Ie, e(fj)));
                    case 12:
                        return m("AdminSubtitleFormats", A2(dk, Ie, e(Xx)));
                    case 13:
                        return m("AdminSegmentationRules", A2(dk, Ie, e(mx)));
                    case 14:
                        return m("AdminJobs", A2(dk, Ie, e(iP)));
                    case 15:
                        return m("AdminMetadata", A2(dk, Ie, e(TI)));
                    case 16:
                        return m("AdminDeepProbe", A2(dk, Ie, e(_A)));
                    case 17:
                        return m("AdminProbe", A2(dk, Ie, e(Fq)));
                    default:
                        return m("AdminDashboard", A2(dk, Ie, e(WN)));
                }
            }()
        ]));
    }), irn = {
        $: 5
    }, orn = gN(hp(Wp)), crn = gN(kp), srn = A2(Kg, T([
        zg("42px"),
        Xg("25px"),
        Pg("IconBreadcrumb")
    ]), T([
        A2(ow, T([
            iw("M 4 0L 0 0L 21 21.5L 0 42L 4 42L 25 21.5L 4 0Z")
        ]), g)
    ])), frn = Kg(T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18")
    ])), lrn = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M5,7 L5,3 L14.001899,3 L15,2 L18,2 L18,15 L6,15 L0,7 L5,7 Z M7,5 L7,7 L11,7 L16,13 L16,5 L7,5 Z"),
            Cj("translate(9.000000, 8.500000) scale(-1, 1) translate(-9.000000, -8.500000) ")
        ]), g)
    ])), mrn = function(n) {
        var r = n.a, t = n.b;
        return A2(aw, T([
            Rg("HeaderBreadcrumbItem"),
            sw(r)
        ]), T([
            lrn,
            A2(Dh, T([
                Rg("HeaderBreadcrumbLabel")
            ]), t),
            srn
        ]));
    }, drn = function(n) {
        return gN(A2(wp, n, 0));
    }, brn = F2(function(n, r) {
        var t = F3(function(n, r, e) {
            for(;;){
                if (!e.b) return g;
                var u = e.a, a = e.b, o = u.eA;
                if (o.$) {
                    if (i(u.mm, n)) return A2(dt, m(dX(u.mm), u.m6), r);
                    e = a;
                } else {
                    var c = o.b, s = drn(u.mm);
                    if (i(u.mm, n)) return A2(dt, m(s, u.m6), r);
                    var f = A3(t, n, A2(dt, m(s, u.m6), r), c);
                    if (f.b) return f;
                    e = a;
                }
            }
        });
        return Kt(A3(t, n, g, $(r.jJ, r.fB)));
    }), prn = F2(function(n, r) {
        return r.$ ? A2(fp, function(r) {
            return Va(A2(Iu, function(n) {
                return i(n.oN, r);
            }, n.oP));
        }, n.oL) : kt(r.a);
    }), vrn = Fg("fill-rule"), $rn = A2(Kg, T([
        Xg("64"),
        zg("62")
    ]), T([
        A2(BT, T([
            Cj("translate(0 .528)"),
            z7("#181F29")
        ]), T([
            A2(ow, T([
                iw("M52.944 28.472L56 26.944V14L28 0 16 6v12l-4-2-12 6v28.944l12 6 12-6v4l12 6 28-14V34l-11.056-5.528z")
            ]), g)
        ])),
        A2(BT, T([
            Cj("translate(4 5)"),
            z7("#FFF")
        ]), T([
            A2(ow, T([
                iw("M24 40l8-4v-8l8-4-8-4-8 4-8-4v8l8 4v8z")
            ]), g),
            A2(ow, T([
                iw("M40 24l8-4v-8L32 4v8l8 4v8z")
            ]), g),
            A2(ow, T([
                iw("M16 20l8-4V8l8-4-8-4-8 4v16z")
            ]), g),
            A2(ow, T([
                iw("M48 44l8-4v-8l-16-8v8l8 4v8z")
            ]), g),
            A2(ow, T([
                iw("M24 40l-8-4-8 4-8-4v8l8 4 16-8z")
            ]), g),
            A2(ow, T([
                iw("M48 44l-8-4-8 4-8-4v8l8 4 16-8z")
            ]), g),
            A2(ow, T([
                iw("M0 36l8-4v-8l8-4-8-4-8 4v16z")
            ]), g)
        ])),
        A2(BT, T([
            Cj("translate(4 9)"),
            z7("#3BAAFF")
        ]), T([
            A2(ow, T([
                iw("M16 16l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4v-8z")
            ]), g),
            A2(ow, T([
                iw("M32 0l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4V0z")
            ]), g),
            A2(ow, T([
                iw("M40 20l-8 4v8l-8 4 8 4 8-4 8 4v-8l-8-4v-8z")
            ]), g)
        ])),
        A2(BT, T([
            Cj("translate(1.764 7.382)"),
            z7("#181F29")
        ]), T([
            A2(ow, T([
                vrn("evenodd"),
                iw("M35.236 0v9l8 4v16l8 4v10.236l-9-4.5-8 4-16-8-8 4L0 33.618 9.236 29v-8l16-8V5l10-5zm-8 6.236v8l-6.764 3.382 5.764 2.882 8-4 7 3.5v-5.764l-8-4v-7l-6 3zM40 21.618l-5.764-2.882-8 4-7-3.5V25l8 4v7l6-3v-8L40 21.618zM25.236 36v-5.764l-8-4v-7l-6 3v8l-6.764 3.382 5.764 2.882 8-4 7 3.5zm3.236 1.618l6.764-3.382v-8l6-3v7l8 4V40l-7-3.5-8 4-5.764-2.882z")
            ]), g)
        ]))
    ])), grn = Se("img"), hrn = function(n) {
        return A2(xg, "src", n);
    }, krn = function(n) {
        return A2(aw, T([
            Rg("HeaderBreadcrumbItem"),
            sw(iz)
        ]), T([
            function() {
                if (n.$) return A2(Dh, T([
                    Rg("HeaderBreadcrumbLabel")
                ]), "Stock");
                var r = n.a, t = r.nq;
                if (t.$) return A2(Dh, T([
                    Rg("HeaderBreadcrumbLabel")
                ]), r.gj);
                var e = t.a;
                return A2(grn, T([
                    Rg("HeaderBreadcrumbItemLogo"),
                    hrn(e)
                ]), g);
            }(),
            srn
        ]));
    }, Trn = gN(Np), wrn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Crn = {
        $: 1
    }, Nrn = A2(Kg, T([
        zg("32px"),
        Xg("32px"),
        Yg("0 0 32 32"),
        Pg("IconSearch")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(Zg, T([
                Ug("22.7071068 19.2928932 22 18.5857864 20.5857864 20 21.2928932 20.7071068 23.2928932 22.7071068 24 23.4142136 25.4142136 22 24.7071068 21.2928932")
            ]), g),
            A2(ow, T([
                iw("M20,15 C20,12.790861 18.209139,11 16,11 C13.790861,11 12,12.790861 12,15 C12,17.209139 13.790861,19 16,19 C18.209139,19 20,17.209139 20,15 Z M10,15 C10,11.6862915 12.6862915,9 16,9 C19.3137085,9 22,11.6862915 22,15 C22,18.3137085 19.3137085,21 16,21 C12.6862915,21 10,18.3137085 10,15 Z")
            ]), g)
        ]))
    ])), Arn = A2(Kg, T([
        zg("27px"),
        Xg("27px"),
        Yg("0 0 27 27"),
        Pg("IconLaab")
    ]), T([
        A2(BT, T([
            Pg("Stroked"),
            W7("2")
        ]), T([
            A2(ow, T([
                iw("M13.5,18 C15.9852814,18 18,15.9852814 18,13.5 M13.5,9 C11.0147186,9 9,11.0147186 9,13.5"),
                Cj("translate(13.500000, 13.500000) scale(-1, 1) translate(-13.500000, -13.500000) ")
            ]), g),
            A2(ow, T([
                iw("M15.5,15.5 L18.5,18.5")
            ]), g),
            A2(ow, T([
                iw("M8.5,8.5 L11.5,11.5")
            ]), g)
        ]))
    ])), Srn = A2(Kg, T([
        zg("27px"),
        Xg("27px"),
        Yg("0 0 27 27"),
        Pg("IconPadok")
    ]), T([
        A2(BT, T([
            Pg("IconPadok"),
            z7("none"),
            W7("2")
        ]), T([
            A2(ow, T([
                iw("M13.5,18 C15.9852814,18 18,15.9852814 18,13.5 C18,11.0147186 15.9852814,9 13.5,9 C11.0147186,9 9,11.0147186 9,13.5"),
                Cj("translate(13.500000, 13.500000) scale(-1, 1) translate(-13.500000, -13.500000) ")
            ]), g),
            A2(ow, T([
                iw("M13.5,13.5 L17.5,17.5")
            ]), g)
        ]))
    ])), Lrn = function(n) {
        var r = n.a, t = n.c, e = 1 === n.b ? d("SearchResultsMaster", Arn, dX(t.mm)) : d("SearchResultsShow", Srn, dX(t.mm)), u = e.a, a = e.b;
        return A2(aw, T([
            sw(e.c),
            Rg("SearchResultsItem"),
            Rg(u)
        ]), T([
            A2(Le, T([
                Rg("SearchResultsPath")
            ]), A2(LD, ih(" / "), A2(Ge, ih, r))),
            A2(Le, T([
                Rg("SearchResultsTitle")
            ]), T([
                a,
                ih(t.m6)
            ]))
        ]));
    }, yrn = function(n) {
        return A2(Le, T([
            Oh(T([
                m("Search", !0),
                m("SearchClosed", !n.qd)
            ]))
        ]), T([
            A2(Le, T([
                Rg("SearchIcon"),
                wh(Crn)
            ]), T([
                n.qd ? JF : Nrn
            ])),
            A2(Le, T([
                Rg("SearchInput"),
                Oh(T([
                    m("Searching", n.qd)
                ]))
            ]), T([
                A2(dk, wrn, ik(n.qb))
            ])),
            A2(Le, T([
                Rg("SearchResults")
            ]), A2(Ge, Lrn, n.qc))
        ]));
    }, Frn = function(n) {
        var r = function() {
            var r = n.ak.sn;
            switch(r.$){
                case 0:
                    return T([
                        krn(A2(prn, n.ak.sp, Tt))
                    ]);
                case 1:
                    var t = r.a;
                    return A2(dt, krn(A2(prn, n.ak.sp, function(n) {
                        return A2(Fu, function(n) {
                            return {
                                nq: n.oL.nq,
                                oN: n.oL.mm,
                                gj: n.oL.n5
                            };
                        }, n.g6.P.kv);
                    }(n))), A2(Ge, mrn, A2(brn, t, n.el)));
                case 2:
                    return t = r.a, A2(dt, krn(A2(prn, n.ak.sp, function(n) {
                        return A2(fp, function(r) {
                            return Va(A2(Iu, function(n) {
                                return i(n.oN, r.be.oL);
                            }, n.ak.sp.oP));
                        }, n.ok.P.kv);
                    }(n))), A2(Ge, mrn, A2(brn, t, n.el)));
                case 6:
                    return T([
                        mrn(m(crn, "Archive"))
                    ]);
                case 8:
                    return T([
                        mrn(m(Trn, "Settings"))
                    ]);
                case 4:
                    return T([
                        mrn(m(orn, "Admin"))
                    ]);
                default:
                    return g;
            }
        }();
        return A2(Le, T([
            Rg("HeaderWrapper")
        ]), T([
            A2(aw, T([
                !n.ak.b$ && i(n.ak.sn, Sp) ? wh(pW(irn)) : sw(iz),
                Rg("HeaderLogo")
            ]), T([
                $rn
            ])),
            A2(dk, pK, A2(iC, yrn, n.qa)),
            A2(Le, T([
                Rg("HeaderBreadcrumb")
            ]), A2(dt, srn, r))
        ]));
    }, jrn = A2(Kg, T([
        zg("24px"),
        Xg("24px"),
        Yg("0 0 24 24"),
        Pg("IconSettings")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M4.5.257l3.771 3.771c.409 1.889-2.33 4.66-4.242 4.242l-3.771-3.77c-.172.584-.258 1.188-.258 1.792 0 1.602.607 3.202 1.83 4.426 1.351 1.351 3.164 1.958 4.931 1.821.933-.072 1.852.269 2.514.931l9.662 9.662c.578.578 1.337.868 2.097.868 1.661 0 3.001-1.364 2.966-3.03-.016-.737-.306-1.47-.868-2.033l-9.662-9.663c-.662-.661-1.002-1.581-.931-2.514.137-1.767-.471-3.58-1.82-4.93-1.225-1.224-2.825-1.83-4.428-1.83-.603 0-1.207.086-1.791.257zm17.5 20.743c0 .553-.447 1-1 1-.553 0-1-.448-1-1s.447-1 1-1 1 .447 1 1z")
            ]), g)
        ]))
    ])), Prn = A2(Kg, T([
        zg("30px"),
        Xg("20px"),
        Yg("0 0 26 36"),
        Pg("IconBigFile")
    ]), T([
        A2(ow, T([
            iw("M10,0 L26,0 L26,36 L0,36 L0,10 L10,0 Z M2,11 L2,34 L24,34 L24,2 L11,2 L2,11 Z"),
            Pg("Fg")
        ]), g),
        A2(Zg, T([
            Pg("Fg"),
            Ug("12 12 12 0 10 0 10 10 0 10 0 12")
        ]), g)
    ])), Irn = Fg("clip-rule"), Brn = A2(Kg, T([
        zg("26px"),
        Xg("26px"),
        Yg("0 0 26 26"),
        Pg("IconBigFile")
    ]), T([
        A2(ow, T([
            iw("M12.0498 15.0713C12.0498 14.251 12.1494 13.5977 12.3486 13.1113C12.5479 12.625 12.9111 12.1475 13.4385 11.6787C13.9717 11.2041 14.3262 10.8203 14.502 10.5273C14.6777 10.2285 14.7656 9.91504 14.7656 9.58691C14.7656 8.59668 14.3086 8.10156 13.3945 8.10156C12.9609 8.10156 12.6123 8.23633 12.3486 8.50586C12.0908 8.76953 11.9561 9.13574 11.9443 9.60449H9.39551C9.40723 8.48535 9.76758 7.60938 10.4766 6.97656C11.1914 6.34375 12.1641 6.02734 13.3945 6.02734C14.6367 6.02734 15.6006 6.3291 16.2861 6.93262C16.9717 7.53027 17.3145 8.37695 17.3145 9.47266C17.3145 9.9707 17.2031 10.4424 16.9805 10.8877C16.7578 11.3271 16.3682 11.8164 15.8115 12.3555L15.0996 13.0322C14.6543 13.46 14.3994 13.9609 14.335 14.5352L14.2998 15.0713H12.0498ZM11.7949 17.7695C11.7949 17.377 11.9268 17.0547 12.1904 16.8027C12.46 16.5449 12.8027 16.416 13.2188 16.416C13.6348 16.416 13.9746 16.5449 14.2383 16.8027C14.5078 17.0547 14.6426 17.377 14.6426 17.7695C14.6426 18.1562 14.5107 18.4756 14.2471 18.7275C13.9893 18.9795 13.6465 19.1055 13.2188 19.1055C12.791 19.1055 12.4453 18.9795 12.1816 18.7275C11.9238 18.4756 11.7949 18.1562 11.7949 17.7695Z"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M13 24C19.0751 24 24 19.0751 24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"),
            Pg("Fg")
        ]), g)
    ])), Mrn = Oi({
        bN: "Help",
        bT: "Aide"
    }), Orn = function(n) {
        return gN(Tp(n));
    }, qrn = Oi({
        bN: "Settings",
        bT: "Param\xe8tres"
    }), Drn = Oi({
        bN: "Stock",
        bT: "Stock"
    }), xrn = function(n) {
        return n.eY ? A2(aw, T([
            sw(n.sn),
            Rg("MenuItem"),
            Oh(T([
                m("Active", n.Q)
            ]))
        ]), T([
            A2(Le, T([
                Rg("MenuItemIcon")
            ]), T([
                n.ml
            ])),
            A2(Le, T([
                Rg("MenuItemTitle")
            ]), T([
                ih(n.rS)
            ]))
        ])) : ih("");
    }, Rrn = Qg("rect"), Vrn = Fg("x"), Ern = Fg("y"), zrn = A2(Kg, T([
        zg("30px"),
        Xg("20px"),
        Yg("0 0 26 36"),
        Pg("IconBigFile")
    ]), T([
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M19 4H12V28H19V4ZM10 2V30H21V2H10Z"),
            Pg("Fg")
        ]), g),
        A2(Rrn, T([
            Vrn("14"),
            Ern("6"),
            Xg("3"),
            zg("22"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M26 14H21V28H26V14ZM19 12V30H28V12H19Z"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M10 10H4V28H10V10ZM2 8V30H11V8H2Z"),
            Pg("Fg")
        ]), g),
        A2(Rrn, T([
            Vrn("4"),
            Ern("12"),
            Xg("6"),
            zg("2"),
            Pg("Fg")
        ]), g),
        A2(Rrn, T([
            Vrn("4"),
            Ern("16"),
            Xg("6"),
            zg("2"),
            Pg("Fg")
        ]), g),
        A2(Rrn, T([
            Vrn("4"),
            Ern("20"),
            Xg("6"),
            zg("2"),
            Pg("Fg")
        ]), g),
        A2(Rrn, T([
            Vrn("4"),
            Ern("24"),
            Xg("6"),
            zg("2"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M21 17L26 12.015L26 14L21 19L21 17Z"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M21 21L26 16.015L26 18L21 23L21 21Z"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M21 25L26 20.015L26 22L21 27L21 25Z"),
            Pg("Fg")
        ]), g),
        A2(ow, T([
            vrn("evenodd"),
            Irn("evenodd"),
            iw("M22 28L26 24.0149L26 26L24 28L22 28Z"),
            Pg("Fg")
        ]), g)
    ])), Urn = Oi({
        bN: "Organizations",
        bT: "Organizations"
    }), Hrn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Wrn = function(n) {
        var r = A2(ju, "", n.sp.oL);
        return A2(Ge, function(t) {
            return function(n) {
                return A2(aw, T([
                    n.cC ? sw(iz) : wh(Hrn(n.mm)),
                    Rg("MenuItem"),
                    Oh(T([
                        m("Active", n.Q)
                    ]))
                ]), T([
                    A2(Le, T([
                        Rg("MenuItemIcon")
                    ]), T([
                        function() {
                            var r = n.nq;
                            if (r.$) return ih("");
                            var t = r.a;
                            return A2(Le, T([
                                Rg("MenuAvatar")
                            ]), T([
                                A2(grn, T([
                                    hrn(t)
                                ]), g)
                            ]));
                        }()
                    ])),
                    A2(Le, T([
                        Rg("MenuItemTitle")
                    ]), T([
                        ih(n.n5)
                    ]))
                ]));
            }({
                Q: i(t.oN, r) && function() {
                    switch(n.sn.$){
                        case 0:
                        case 1:
                        case 2:
                            return !0;
                        default:
                            return !1;
                    }
                }(),
                cC: i(t.oN, r),
                mm: t.oN,
                nq: t.nq,
                n5: t.gj
            });
        }, A2(kC, hC(function(n) {
            return n.gj;
        }), n.sp.oP));
    }, Qrn = function(n) {
        return 1 > Dt(n.sp.oP) ? ih("") : A2(Le, T([
            Rg("MenuGroup"),
            wh(irn)
        ]), T([
            A2(Le, T([
                Rg("MenuItem")
            ]), T([
                A2(Le, T([
                    Rg("MenuItemIcon")
                ]), T([
                    zrn
                ])),
                A2(Le, T([
                    Rg("MenuItemTitle")
                ]), T([
                    ih(Urn)
                ]))
            ])),
            A2(Le, T([
                Rg("MenuList")
            ]), Wrn(n))
        ]));
    }, Zrn = function(n) {
        return Le(T(n.b$ ? [
            Rg("MenuWrapper"),
            Rg("MenuOpened"),
            wh(irn),
            TN(n.b$)
        ] : [
            Rg("MenuWrapper"),
            Rg("MenuClosed")
        ]));
    }, Krn = function(n) {
        var r = function(n) {
            return {
                l5: {
                    Q: 5 === n.sn.$,
                    eY: !0,
                    ml: Brn,
                    rS: Mrn,
                    sn: Orn("table")
                },
                dp: {
                    Q: 8 === n.sn.$,
                    eY: !0,
                    ml: jrn,
                    rS: qrn,
                    sn: Trn
                },
                dr: {
                    Q: !n.d1,
                    eY: !0,
                    ml: Prn,
                    rS: Drn,
                    sn: iz
                }
            };
        }(n);
        return A2(Zrn, n, T([
            A2(Le, T([
                Rg("MenuMain")
            ]), T([
                xrn(r.dr),
                Qrn(n),
                A2(Le, T([
                    Rg("MenuSpacer")
                ]), g),
                xrn(r.l5),
                xrn(r.dp),
                A2(Le, T([
                    Rg("MenuIntercom")
                ]), g)
            ]))
        ]));
    }, Yrn = {
        $: 1
    }, Xrn = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), Jrn = Bh("multiple"), Grn = A2(Jh, T([
        "target",
        "files"
    ]), ac(bnn)), _rn = F2(function(n) {
        var r;
        return r = T([
            Yh("nativeInputFile"),
            Rg("UploadInput"),
            A2(Mg, "change", A2(ye, function(r) {
                return A2(Xrn, n.oU, r);
            }, Grn))
        ]), A2(Eh, A2(dt, Ch("file"), A2(dt, Jrn(!0), r)), g);
    }), ntn = F2(function(n, r) {
        return n.mk || !i(r.bQ, g) || !i(r.lm, Tt);
    }), rtn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ttn = Oi({
        bN: ". Please choose a destination:",
        bT: ". Veuillez choisir une destination :"
    }), etn = Oi({
        bN: "Choose destination",
        bT: "Choisir une destination"
    }), utn = Oi({
        bN: " file",
        bT: " fichier"
    }), atn = Oi({
        bN: "Create new delivery",
        bT: "Cr\xe9er une nouvelle livraison"
    }), itn = Oi({
        bN: "Create new master",
        bT: "Cr\xe9er un nouveau master"
    }), otn = Oi({
        bN: "You are about to upload ",
        bT: "Vous \xeates sur le point d\u2019uploader "
    }), ctn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), stn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ftn = F8(function(n, r, t, e, u, a, i, o) {
        return {
            jv: a,
            jP: t,
            kq: o,
            m4: n,
            b2: e,
            oU: r,
            p6: u,
            rL: i
        };
    }), ltn = A2(Ce, function(n) {
        n: for(; !n.$;)switch(n.a){
            case 0:
                return je(0);
            case 1:
                return je(1);
            case 2:
                return je(2);
            case 3:
                return je(3);
            default:
                break n;
        }
        return A2(Ce, function(n) {
            n: for(; !n.$;)switch(n.a){
                case 0:
                    return je(1);
                case 1:
                    return je(2);
                case 2:
                    return je(3);
                case 4:
                    return je(4);
                case 5:
                    return je(5);
                default:
                    break n;
            }
            return je(0);
        }, Oo(A2(mu, "button", tc)));
    }, Oo(A2(mu, "which", tc))), mtn = function(n) {
        return {
            ow: n
        };
    }, dtn = A2(ye, mtn, A2(mu, "offsetWidth", fS)), btn = A2(mu, "currentTarget", dtn), ptn = F4(function(n, r, t, e) {
        return {
            iH: n,
            km: r,
            nQ: t,
            qy: e
        };
    }), vtn = A5(uU, ptn, A2(mu, "altKey", Ne), A2(mu, "ctrlKey", Ne), A2(mu, "metaKey", Ne), A2(mu, "shiftKey", Ne)), $tn = cn, gtn = function(n) {
        return A3(Fe, ZQ, A2(mu, n + "X", tc), A2(mu, n + "Y", tc));
    }, htn = A2(Ce, function() {
        var n = St(0);
        return 1 === n.$ ? Dc(n.a) : je(n.a);
    }, A2(mu, "target", Pi)), ktn = A9($tn, ftn, vtn, gtn("page"), gtn("client"), gtn("offset"), gtn("screen"), ltn, htn, btn), Ttn = F2(function(n, r) {
        var t = A2(ann, "mousedown", je({
            nO: stn(r),
            pe: !1,
            rf: !1
        })), e = n ? T([
            A2(Mg, "mousedown", A2(ye, ctn(r), ktn))
        ]) : g;
        return A2(Le, T([
            Rg("UploadFile")
        ]), T([
            A2(Le, A2(dt, Rg("UploadFileTitle"), e), T([
                Prn,
                A2(Le, T([
                    Rg("UploadFileSummary")
                ]), T([
                    A2(mh, T([
                        Rg("UploadFileName"),
                        yB(r.n5)
                    ]), T([
                        ih(r.n5)
                    ])),
                    A2(Dh, T([
                        Rg("UploadFileSize")
                    ]), Wq(r.qO))
                ]))
            ])),
            A2(Le, T([
                Rg("UploadRemove"),
                t
            ]), T([
                Th
            ]))
        ]));
    }), wtn = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("UploadDrag"),
            A2(ph, "left", It(t.sK - r.sK) + "px"),
            A2(ph, "top", It(t.sP - r.sP) + "px")
        ]), T([
            A2(Ttn, !1, n)
        ]));
    }), Ctn = {
        $: 9
    }, Ntn = Oi({
        bN: "An error occurred.",
        bT: "Une erreur est survenue."
    }), Atn = function(n) {
        return 1 === n.lm.$ ? ih("") : A2(Le, T([
            Rg("UploadError")
        ]), T([
            A2(Le, g, T([
                ih(Ntn)
            ])),
            A2(Le, T([
                Rg("UploadErrorClose"),
                wh(Ctn)
            ]), T([
                Th
            ]))
        ]));
    }, Stn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ltn = {
        $: 8
    }, ytn = Oi({
        bN: "No file",
        bT: "Aucun fichier"
    }), Ftn = function(n) {
        return A2(Mg, "mouseenter", je(n));
    }, jtn = function(n) {
        return A2(Mg, "mouseleave", je(n));
    }, Ptn = kk("ul"), Itn = F3(function(n, r, t) {
        var e = function() {
            if (1 === r.$) return g;
            var n = r.a;
            return T([
                A2(ph, "user-select", "none"),
                Ftn(Stn(n)),
                jtn(Ltn)
            ]);
        }();
        return A2(Le, e, T([
            A2(mN, T([
                Rg("UploadSubtitle")
            ]), T([
                ih(n)
            ])),
            A2(Ptn, T([
                Rg("UploadSection")
            ]), Cu(t) ? T([
                m("empty", A2(lE, T([
                    Rg("UploadItem")
                ]), T([
                    ih(ytn)
                ])))
            ]) : A2(Ge, function(n) {
                return m(n.n5, A2(lE, T([
                    Rg("UploadItem")
                ]), T([
                    A2(Ttn, !i(r, Tt), n)
                ])));
            }, t))
        ]));
    }), Btn = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Mtn = Oi({
        bN: "Add",
        bT: "Ajouter"
    }), Otn = Oi({
        bN: "Extra",
        bT: "Compl\xe9mentaire"
    }), qtn = Oi({
        bN: "Master being loaded...",
        bT: "Master en cours de chargement..."
    }), Dtn = Oi({
        bN: " into master ",
        bT: " au master "
    }), xtn = Oi({
        bN: "Subtitles",
        bT: "Sous titres"
    }), Rtn = F4(function(n, r, t, e) {
        var u = function(r) {
            return 1 === n.$ || A2(BK, n.a, e) ? ih("") : r;
        }, a = A3(qt, F2(function(n, t) {
            var e = A2(lo, n.n5, r);
            if (e.$) return p(t, {
                bP: A2(dt, n, t.bP)
            });
            switch(e.a){
                case 0:
                    return p(t, {
                        cn: A2(dt, n, t.cn)
                    });
                case 1:
                    return p(t, {
                        d6: A2(dt, n, t.d6)
                    });
                case 2:
                    return p(t, {
                        ad: A2(dt, n, t.ad)
                    });
                default:
                    return p(t, {
                        bP: A2(dt, n, t.bP)
                    });
            }
        }), {
            d6: g,
            bP: g,
            ad: g,
            cn: g
        }, e.bQ), i = a.cn, o = a.d6, c = a.ad, s = a.bP;
        return T([
            u(A3(Itn, "Video", kt(0), i)),
            u(A3(Itn, "Audios", kt(1), o)),
            A3(Itn, xtn, kt(2), c),
            A3(Itn, Otn, kt(3), s),
            A2(wF, g, g),
            function() {
                if (1 === n.$) return A2(Sg, T([
                    Vh(!0)
                ]), T([
                    ih(qtn)
                ]));
                var u = n.a;
                return A2(Le, g, T([
                    A2(Dh, T([
                        Rg("UploadDesc")
                    ]), $(otn, $(It(Dt(e.bQ)), $(utn, $(Dt(e.bQ) > 1 ? "s" : "", Dtn))))),
                    A2(_nn, Mtn, A3(Btn, t.e$, u.g6, r))
                ]));
            }()
        ]);
    }), Vtn = Oi({
        bN: "Your files",
        bT: "Vos fichiers"
    }), Etn = F2(function(n, r) {
        return A2(Le, T([
            Rg("UploadContainer")
        ]), T([
            A2(Le, T([
                Rg("UploadTitle")
            ]), T([
                ih("Upload")
            ])),
            A2(Le, T([
                Rg("UploadClose"),
                wh(Yrn)
            ]), T([
                Th
            ])),
            Atn(r),
            A2(Le, T([
                Rg("UploadContent")
            ]), function() {
                var t = m(n.oU, r.oX);
                n: for(;;){
                    if (t.a.$) {
                        if (1 === t.b.$) return T([
                            A2(Dh, T([
                                Rg("UploadDesc")
                            ]), $(otn, $(It(Dt(r.bQ)), $(utn, $(Dt(r.bQ) > 1 ? "s" : "", ttn))))),
                            A3(Itn, Vtn, Tt, r.bQ),
                            A2(dk, rtn, A2(VT, Ri(function(n) {
                                return p(n, {
                                    gt: etn
                                });
                            }), T([
                                m("liv", atn),
                                m("mas", itn)
                            ])))
                        ]);
                        break n;
                    }
                    if (t.b.$) break n;
                    var e = t.a.a, u = t.b.a;
                    return e.$ ? T([
                        ih("")
                    ]) : A4(Rtn, e, u, n, r);
                }
                return T([
                    ih(A2(ju, "", r.lm))
                ]);
            }()),
            function() {
                var n = r.kY;
                if (1 === n.$) return ih("");
                var t = n.a;
                return A3(wtn, t.a, t.b, t.c);
            }()
        ]));
    }), ztn = Oi({
        bN: "Please drop your file(s) to upload to Nomalab",
        bT: "D\xe9posez le(s) fichier(s) pour lancer un upload sur Nomalab"
    }), Utn = A2(Le, T([
        Rg("UploadDropping")
    ]), T([
        ih(ztn)
    ])), Htn = F2(function(n, r) {
        if (A2(ntn, n, r)) {
            var t = n.oU;
            if (t.$ || t.a.$) return ih("");
            var e = t.a.a;
            return A3(IK, n.sp, e.oL.mm, A2(Ge, function(n) {
                return n.fz;
            }, e.fB)) ? A2(Le, T([
                Rg("UploadWrapper")
            ]), T([
                A2(Le, T([
                    Rg("UploadMask"),
                    wh(Yrn)
                ]), g),
                i(r.bQ, g) && i(r.lm, Tt) ? Utn : A2(Etn, n, r),
                A2(_rn, n, r)
            ])) : ih("");
        }
        return A2(_rn, n, r);
    }), Wtn = Se("em"), Qtn = Se("strong"), Ztn = F2(function(n, r) {
        var t, e = function(n) {
            var r = n.hj;
            switch(r.$){
                case 0:
                    return Wtn(g);
                case 1:
                    return Qtn(g);
                default:
                    return aw(function(n) {
                        for(;;){
                            if (n.$) return T([
                                sw(n.a)
                            ]);
                            var r = n.a;
                            if ("help" === r.fQ) return T([
                                sw("/help/" + A2(ju, "table", r.h4))
                            ]);
                        }
                    }(r.a));
            }
        }, u = F2(function(n, t) {
            var u = t.a, a = t.b, i = A3(De, n.hp, n.eZ, r.cj);
            return m($(u, T([
                ih(A3(De, a, n.hp, r.cj)),
                A2(e, n, T([
                    ih(i)
                ]))
            ])), n.eZ);
        });
        return A2(n, A2(ju, g, A2(Fu, function(n) {
            return T([
                Rg(n)
            ]);
        }, r.m6)), $((t = A3(qt, u, m(g, 0), A2(zi, function(n) {
            return n.hp;
        }, r.hk))).a, T([
            ih(A2(xe, t.b, r.cj))
        ])));
    }), Ktn = Se("h5"), Ytn = Se("h6"), Xtn = function(n) {
        switch(n.$){
            case 8:
                return A2(grn, T([
                    hrn(n.a.sn)
                ]), g);
            case 0:
                return A2(Ztn, pw, r = n.a);
            case 1:
                return A2(Ztn, mN, r = n.a);
            case 2:
                return A2(Ztn, mw, r = n.a);
            case 3:
                return A2(Ztn, SF, r = n.a);
            case 4:
                return A2(Ztn, Ktn, r = n.a);
            case 5:
                return A2(Ztn, Ytn, r = n.a);
            case 6:
                return A2(Ztn, Zj, r = n.a);
            default:
                var r = n.a;
                return A2(Ztn, F2(function(n, r) {
                    return A2(sE, g, T([
                        A2(lE, n, r)
                    ]));
                }), r);
        }
    }, Jtn = function(n) {
        var r = n;
        return A2(Le, T([
            Rg("structuredText")
        ]), A2(Ge, Xtn, r));
    }, Gtn = function(n) {
        switch(n.P){
            case 0:
                return Oi({
                    bN: "Connection lost.",
                    bT: "Perte de connection avec le serveur, v\xe9rifiez votre connection internet"
                });
            case 401:
            case 403:
                return Oi({
                    bN: "You might not be authorized to acces this ressource.",
                    bT: "Vous ne semblez pas - ou plus - autoris\xe9 \xe0 consulter cette ressource"
                });
            case 404:
                return Oi({
                    bN: "This ressource doesn't seem to exist.",
                    bT: "Cette ressource n'existe pas ou a \xe9t\xe9 supprim\xe9e"
                });
            default:
                return "" === n.nO ? Eo : n.nO;
        }
    }, _tn = function(n) {
        var r = n.P.lm;
        return r.$ ? ih("") : fT(Gtn(r.a));
    }, nen = A2(Le, T([
        Rg("LoadingWrapper")
    ]), T([
        A2(Le, T([
            Rg("LoadingSpinner")
        ]), T([
            Nj
        ]))
    ])), ren = F2(function(n, r) {
        return A2(Le, T([
            Rg("ShowWrapper")
        ]), T([
            A2(Le, T([
                Rg("ShowMain")
            ]), T([
                $w(p(gw, {
                    d8: kt(iz)
                })),
                nen,
                _tn(r)
            ])),
            A2(Le, T([
                Rg("ShowAside")
            ]), g)
        ]));
    }), ten = function(n) {
        return n.iw;
    }, een = F2(function(n, r) {
        return ten(n) || i(n.oL, kt(r.oL));
    }), uen = function(n) {
        return drn(n.mm);
    }, aen = function(n) {
        return !n.hs;
    }, ien = function(n) {
        return "" !== n.cJ.fz;
    }, oen = {
        $: 6
    }, cen = function(n) {
        return A2(Le, T([
            Rg("BannerAdvice")
        ]), T([
            jB,
            A2(Dh, T([
                Rg("BannerContent")
            ]), n)
        ]));
    }, sen = F2(function(n, r) {
        return ten(n) || i(n.oL, kt(r.oL));
    }), fen = Oi({
        bN: "Invitations",
        bT: "Invitations"
    }), len = Oi({
        bN: "Invite",
        bT: "Inviter"
    }), men = Oi({
        bN: "No invitations.",
        bT: "Aucune invitation."
    }), den = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18"),
        Pg("IconPlus")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M10,8 L10,3 L8,3 L8,8 L3,8 L3,10 L8,10 L8,15 L10,15 L10,10 L15,10 L15,8 L10,8 Z")
            ]), g)
        ]))
    ])), ben = function(n) {
        return {
            $: 9,
            a: n
        };
    }, pen = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ven = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $en = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gen = function(n) {
        return {
            $: 4,
            a: n
        };
    }, hen = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ken = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Ten = Oi({
        bN: "Allow download (extra costs applies)",
        bT: "Autoriser le t\xe9l\xe9chargement (soumis \xe0 facturation)"
    }), wen = Oi({
        bN: "Allow upload ",
        bT: "Autoriser l'upload"
    }), Cen = Oi({
        bN: "Allow view",
        bT: "Autoriser \xe0 visionner"
    }), Nen = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16")
    ]), T([
        A2(ow, T([
            Pg("Fg"),
            iw("M8 10H3V6H8V3L13 8L8 13V10Z")
        ]), g)
    ])), Aen = Le(T([
        Rg("ButtonSubmitWrapper")
    ])), Sen = function(n) {
        return Aen(T([
            FB(p(oB, {
                ml: kt(Nen),
                bf: !0,
                bg: !0,
                m6: n
            }))
        ]));
    }, Len = xg("htmlFor"), yen = F2(function(n, r) {
        return A2(yT, T([
            Len(r.mm),
            Rg("InputCheckboxLine")
        ]), T([
            LT(r),
            ih(n)
        ]));
    }), Fen = F3(function(n, r) {
        return A2(zT, T([
            WT(ben(n.be)),
            Rg("InvitationsForm"),
            Rg("DarkZone")
        ]), T([
            A2(dk, pen, ik(r.k8)),
            A2(dk, ven, Onn(r.lr)),
            A2(dk, $en, vI(r.nO)),
            A2(dk, ken, A2(yen, Cen, ro(function(n) {
                return p(n, {
                    kQ: !0,
                    mm: "checkbox-canView",
                    m6: Cen,
                    ss: !0
                });
            }))),
            A2(dk, hen, A2(yen, wen, r.jy)),
            A2(dk, gen, A2(yen, Ten, r.jx)),
            Sen(len)
        ]));
    }), jen = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Pen = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M3,6 L3,3 L12.001899,3 L13,2 L16,2 L16,15 L4,15 L2,6 L3,6 Z M5,5 L5,6 L13,6 L14,13 L14,5 L5,5 Z"),
            Cj("translate(9.000000, 8.500000) scale(-1, 1) translate(-9.000000, -8.500000) ")
        ]), g)
    ])), Ien = frn(T([
        A2(BT, T([
            Pg("Fg"),
            Cj("translate(2.000000, 1.000000)")
        ]), T([
            A2(ow, T([
                iw("M4,0 L10,0 L14,4 L14,13 L4,13 L4,0 Z M6,2 L6,11 L12,11 L12,5 L9,5 L9,2 L6,2 Z")
            ]), g),
            A3(Qg, "polygon", T([
                Ug("0 3 3 3 3 5 2 5 2 14 10 14 10 16 0 16")
            ]), g)
        ]))
    ])), Ben = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M5,3 L5,15 L13,15 L13,6 L9,6 L9,3 L5,3 Z")
        ]), g)
    ])), Men = function(n) {
        return A2(Le, T([
            Rg(n ? "FullCube" : "EmptyCube")
        ]), g);
    }, Oen = function(n) {
        return A3(Se, "format-date", T([
            IN(rd(n))
        ]), T([
            ih(rd(n))
        ]));
    }, qen = F4(function(n, r, t, e) {
        return i(r.fz.hf, kt(t.be.mm)) ? A2(sen, n.sp, t.be) ? A2(uT, g, T([
            A2(Le, T([
                Rg("InvitationDelete"),
                wh(jen(r.fz))
            ]), T([
                Th
            ]))
        ])) : ih("") : A2(uT, g, T([
            A2(Le, T([
                Rg("InvitationSourceKind")
            ]), T([
                A2(wT, function(n) {
                    var r;
                    return A2(aw, T([
                        sw((r = n, drn(r)))
                    ]), T([
                        e
                    ]));
                }, r.fz.hf)
            ]))
        ]));
    }), Den = F3(function(n, r, t) {
        var e;
        return A2(Fk, g, T([
            A2(uT, g, T([
                Men(!0)
            ])),
            A2(uT, g, T([
                Men(t.fz.sg)
            ])),
            A2(uT, g, T([
                Men(t.fz.cJ)
            ])),
            A2(uT, T([
                Rg("InvitationEmail"),
                yB(t.sp.k8)
            ]), T([
                (e = t.fz.cO, e.$ ? ih("") : Oen(e.a)),
                ih("   "),
                ih(t.sp.k8)
            ])),
            function() {
                var e = t.fz.c$;
                n: for(; !e.$;)switch(e.a){
                    case 0:
                        return A4(qen, n, t, r, Pen);
                    case 2:
                        return A4(qen, n, t, r, Ien);
                    default:
                        break n;
                }
                return i(t.fz.qI, Tt) ? A2(sen, n.sp, r.be) ? A2(uT, g, T([
                    A2(Le, T([
                        Rg("InvitationDelete"),
                        wh(jen(t.fz))
                    ]), T([
                        Th
                    ]))
                ])) : ih("") : A2(uT, g, T([
                    A2(Le, T([
                        Rg("InvitationSourceKind")
                    ]), T([
                        A2(wT, function(n) {
                            var r;
                            return A2(aw, T([
                                sw((r = n, dX(r)))
                            ]), T([
                                Ben
                            ]));
                        }, t.fz.qI)
                    ]))
                ]));
            }()
        ]));
    }), xen = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("InvitationsWrapper")
        ]), T([
            Qq(T([
                Yq(fen),
                A2(sen, n.sp, t.be) ? FB(p(oB, {
                    jO: Tt,
                    ml: kt(den),
                    mI: !1,
                    m6: len,
                    ox: kt(oen)
                })) : ih("")
            ])),
            r.kS ? A3(Fen, t, r, n.sp) : ih(""),
            Cu(t.fB) ? cen(men) : A2(Tk, T([
                Rg("InvitationsTable")
            ]), A2(Ge, A2(Den, n, t), A2(zi, A2(No, function(n) {
                return n.sp;
            }, function(n) {
                return n.k8;
            }), t.fB)))
        ]));
    }), Ren = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ven = {
        $: 0
    }, Een = {
        $: 1
    }, zen = {
        $: 2
    }, Uen = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Hen = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Wen = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Qen = Le(T([
        Rg("LayoutHeaderActions")
    ])), Zen = Oi({
        bN: "Archive",
        bT: "Archiver"
    }), Ken = Oi({
        bN: "All files will be put into long lasting storage, retrieving them can take up to 12h. (extra costs applies for unarchiving)",
        bT: "Tous les fichiers iront en stockage longue dur\xe9e, les r\xe9cup\xe9rer prend jusqu'\xe0 12h et ils seront remis \xe0 disposition pour une dur\xe9e de 7 jours. (le d\xe9sarchivage est soumis \xe0 facturation)"
    }), Yen = Oi({
        bN: "Archiving...",
        bT: "Archivage..."
    }), Xen = Oi({
        bN: "Cancel",
        bT: "Annuler"
    }), Jen = Oi({
        bN: "Operation failed",
        bT: "L'op\xe9ration a \xe9chou\xe9"
    }), Gen = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M5 8H13V14H5V8Z")
        ]), g),
        A2(ow, T([
            Pg("Fg"),
            iw("M7.99957 7.68778C7.99978 7.78914 8 7.89313 8 8H6C6 7.90491 5.99978 7.80885 5.99956 7.71229C5.99854 7.26829 5.9975 6.81375 6.01771 6.39485C6.04227 5.88549 6.10037 5.34942 6.2604 4.8605C6.42521 4.35697 6.71365 3.85763 7.22215 3.49794C7.72555 3.14186 8.33543 3 9 3C9.66457 3 10.2745 3.14186 10.7779 3.49794C11.2864 3.85763 11.5748 4.35697 11.7396 4.8605C11.8996 5.34942 11.9577 5.88549 11.9823 6.39485C12.0025 6.81376 12.0015 7.26829 12.0004 7.71229C12.0002 7.80885 12 7.90491 12 8H10C10 7.89313 10.0002 7.78914 10.0004 7.68778C10.0013 7.24641 10.0022 6.85479 9.98462 6.49119C9.94969 5.76704 9.89141 5 9 5C8.10859 5 8.05031 5.76704 8.01538 6.49119C7.99785 6.85479 7.99866 7.24641 7.99957 7.68778Z")
        ]), g)
    ])), _en = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M12.5 15H5.5C4.948 15 4.5 14.552 4.5 14V6H13.5V14C13.5 14.552 13.052 15 12.5 15ZM8 8C8 7.724 7.776 7.5 7.5 7.5C7.224 7.5 7 7.724 7 8V12.5C7 12.776 7.224 13 7.5 13C7.776 13 8 12.776 8 12.5V8ZM11 8C11 7.724 10.776 7.5 10.5 7.5C10.224 7.5 10 7.724 10 8V12.5C10 12.776 10.224 13 10.5 13C10.776 13 11 12.776 11 12.5V8ZM14 5.5H4V4.5H7V3.75C7 3.3365 7.3365 3 7.75 3H10.25C10.6625 3 11 3.3355 11 3.75V4.5H14V5.5ZM8 4.5H10V4H8V4.5Z")
        ]), g)
    ])), nun = Oi({
        bN: "Delete",
        bT: "Supprimer"
    }), run = Oi({
        bN: "Ressource deleted",
        bT: "Ressource supprim\xe9e"
    }), tun = Oi({
        bN: "Delete...",
        bT: "Suppression..."
    }), eun = Oi({
        bN: "Delete",
        bT: "Supprimer"
    }), uun = Oi({
        bN: "Unarchive",
        bT: "D\xe9sarchiver"
    }), aun = Oi({
        bN: "Your files are now into long lasting storage. Retrieving them can take up to 12h and for a 7 days period. (extra costs applies for unarchiving)",
        bT: "Vos fichiers sont maintenant en stockage longue dur\xe9e, les r\xe9cup\xe9rer prend jusqu'\xe0 12h et ils seront remis \xe0 disposition pour une dur\xe9e de 7 jours. (le d\xe9sarchivage est soumis \xe0 facturation)"
    }), iun = Oi({
        bN: "Your files will be available within 12h and for a 7 days period only.",
        bT: "Vos fichiers seront disponibles dans les 12h et pour une dur\xe9e de 7 jours."
    }), oun = Oi({
        bN: "Undelete",
        bT: "Restaurer"
    }), cun = Oi({
        bN: "These files are deleted",
        bT: "Ces fichiers sont supprim\xe9s"
    }), sun = Oi({
        bN: "Ressource restored",
        bT: "Ressource restaur\xe9e"
    }), fun = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("ShowArchiveActions"),
            Rg("ShowArchiveStatusNone")
        ]), T([
            FB(p(oB, {
                kQ: n,
                ml: kt(Gen),
                m6: r,
                ox: kt(t)
            }))
        ]));
    }), lun = F2(function(n, r) {
        var t, e = 2 === r.hs;
        return A2(Le, T([
            Rg("ShowArchives")
        ]), T([
            Qq(T([
                A2(FF, 1 === r.hs, A2(mh, T([
                    Rg("ShowArchivesLock")
                ]), T([
                    Gen
                ]))),
                Yq(0 === r.hs ? Zen : uun),
                Qen(T([
                    FB(p(oB, {
                        kQ: e,
                        ml: kt(n.oC ? JF : den),
                        mI: n.oC,
                        m6: n.oC ? Xen : Yen,
                        ox: kt(Een)
                    }))
                ]))
            ])),
            A2(FF, n.oC || e, A2(Le, T([
                Rg("InvitationsForm")
            ]), T([
                3 === n.P.$ ? A2(Le, T([
                    Rg("ShowArchiveActions"),
                    wh(Ven)
                ]), T([
                    fT(Jen)
                ])) : ih(""),
                A2(Le, g, function() {
                    switch(r.hs){
                        case 0:
                            return T([
                                j7(Ken),
                                A3(fun, i(n.P, D_), Zen, Ren(r))
                            ]);
                        case 1:
                            return T([
                                fT(aun),
                                A3(fun, i(n.P, D_), uun, Hen(r))
                            ]);
                        default:
                            return T([
                                j7(iun)
                            ]);
                    }
                }())
            ]))),
            Qq(T([
                A2(FF, r.h2, A2(mh, T([
                    Rg("ShowArchivesLock")
                ]), T([
                    _en
                ]))),
                Yq(r.h2 ? oun : eun),
                Qen(T([
                    FB(p(oB, {
                        ml: kt(n.oE ? JF : den),
                        mI: n.oE,
                        m6: n.oE ? Xen : tun,
                        ox: kt(zen)
                    }))
                ]))
            ])),
            A2(FF, n.oE, A2(Le, T([
                Rg("InvitationsForm")
            ]), T([
                A2(Le, g, T(r.h2 ? [
                    fT(cun),
                    A2(FF, r.mJ, A3(fun, i(n.r3, D_), oun, Wen(r)))
                ] : [
                    i(n.sd, x_) ? fT(sun) : i(n.r3, x_) ? fT(run) : fT((t = r.mT, Oi({
                        bN: "Warning, this action will delete permanently every files in this " + (t ? "Show" : "folder"),
                        bT: "Attention, cette action entrainera la suppression d\xe9finitive de tous les fichiers pr\xe9sents dans ce " + (t ? "Show" : "dossier")
                    }))),
                    A3(fun, i(n.r3, D_), nun, Uen(r))
                ]))
            ])))
        ]));
    }), mun = Oi({
        bN: "Downloads",
        bT: "T\xe9l\xe9chargements"
    }), dun = {
        $: 3
    }, bun = {
        $: 5
    }, pun = Oi({
        bN: "Create a SFTP server access, accessible from any FTP client software.",
        bT: "Cr\xe9er un acc\xe8s serveur SFTP, accessible avec n'importe quel client FTP (logiciel)."
    }), vun = Oi({
        bN: "Create SFTP access",
        bT: "Cr\xe9er acc\xe8s SFTP"
    }), $un = function(n) {
        return A2(wj, n.a, n.b);
    }, gun = function(n) {
        return A2(Tk, T([
            Rg("KeyValueWrapper")
        ]), A2(Ge, $un, n));
    }, hun = Bh("readOnly"), kun = Oi({
        bN: "Revoke SFTP access",
        bT: "R\xe9voquer acc\xe8s SFTP"
    }), Tun = Oi({
        bN: "Renew SFTP access",
        bT: "Renouveler acc\xe8s SFTP"
    }), wun = Oi({
        bN: "Here are the credentials for your SFTP server. Keep them safe as their are being given only once.",
        bT: "Voici les identifiants de votre serveur SFTP, gardez-les pr\xe9cieusement car il ne vous seront donn\xe9s qu'une fois."
    }), Cun = Oi({
        bN: "A SFTP server access already exists, click on 'renew' if you can't retrieve the credentials.",
        bT: "Un acc\xe8s serveur SFTP existe, si vous n'avez plus les identifiants cliquez sur le bouton 'renouveler' pour en obtenir de nouveaux. Les anciens acc\xe8s seront supprim\xe9s."
    }), Nun = A2(Kg, T([
        zg("7px"),
        Xg("7px"),
        Yg("401 651 7 7"),
        Pg("IconSmallDownload")
    ]), T([
        A2(Zg, T([
            Pg("Fg"),
            vrn("evenodd"),
            Ug("403 651 406 651 406 654 408 654 404.678829 658 401 654 403 654")
        ]), g)
    ])), Aun = function(n) {
        var r, t = n.lY;
        switch(t.$){
            case 0:
                return g;
            case 1:
                return T([
                    cen(pun),
                    A2(Le, T([
                        Rg("DownloadOptionsButtons")
                    ]), T([
                        FB(p(oB, {
                            ml: kt(Nun),
                            m6: vun,
                            ox: kt(dun)
                        }))
                    ]))
                ]);
            case 3:
                var e = t.a;
                return T([
                    lT(wun),
                    A2(Le, T([
                        Rg("DownloadOptionsCredentials")
                    ]), T([
                        (r = "sftp://" + e.fT + ":" + A2(ju, "", e.oZ) + "@" + e.fq, A2(Le, T([
                            Rg("DownloadSftpLink")
                        ]), T([
                            ih("url: "),
                            A2(Eh, T([
                                ak(r),
                                hun(!0),
                                Rg("DownloadSftpUrl")
                            ]), g)
                        ]))),
                        gun(T([
                            m("hostname", e.fq),
                            m("port", It(e.gv)),
                            m("login", e.fT),
                            m("password", A2(ju, "*****", e.oZ))
                        ]))
                    ])),
                    A2(Le, T([
                        Rg("DownloadOptionsButtons")
                    ]), T([
                        FB(p(oB, {
                            ml: kt(JF),
                            m6: kun,
                            ox: kt(bun)
                        })),
                        FB(p(oB, {
                            ml: kt(Nun),
                            m6: Tun,
                            ox: kt(dun)
                        }))
                    ]))
                ]);
            case 2:
                return e = t.a, T([
                    cen(Cun),
                    A2(Le, T([
                        Rg("DownloadOptionsCredentials")
                    ]), T([
                        gun(T([
                            m("hostname", e.fq),
                            m("port", It(e.gv)),
                            m("login", e.fT)
                        ]))
                    ])),
                    A2(Le, T([
                        Rg("DownloadOptionsButtons")
                    ]), T([
                        FB(p(oB, {
                            ml: kt(JF),
                            m6: kun,
                            ox: kt(bun)
                        })),
                        FB(p(oB, {
                            ml: kt(Nun),
                            m6: Tun,
                            ox: kt(dun)
                        }))
                    ]))
                ]);
            default:
                return T([
                    fT(Gtn(t.a)),
                    A2(Le, T([
                        Rg("DownloadOptionsButtons")
                    ]), T([
                        FB(p(oB, {
                            ml: kt(Nun),
                            m6: vun,
                            ox: kt(dun)
                        }))
                    ]))
                ]);
        }
    }, Sun = function(n) {
        return A2(Le, g, T([
            Qq(T([
                Yq(mun)
            ])),
            A2(Le, T([
                Rg("InvitationsForm")
            ]), Aun(n))
        ]));
    }, Lun = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M9,13.1999999 L7.14589803,14.7063391 L6.53130198,12.3978713 L4.14589803,12.5267115 L5.0055627,10.2978714 L3,9 L5.0055627,7.70212865 L4.14589803,5.47328849 L6.53130198,5.60212868 L7.14589803,3.2936609 L9,4.80000007 L10.854102,3.2936609 L11.468698,5.60212868 L13.854102,5.47328849 L12.9944373,7.70212865 L15,9 L12.9944373,10.2978714 L13.854102,12.5267115 L11.468698,12.3978713 L10.854102,14.7063391 L9,13.1999999 Z M9,11 C10.1045695,11 11,10.1045695 11,9 C11,7.8954305 10.1045695,7 9,7 C7.8954305,7 7,7.8954305 7,9 C7,10.1045695 7.8954305,11 9,11 Z")
        ]), g)
    ])), yun = F3(function(n, r, t) {
        return T([
            A2(Le, T([
                Rg("AsideHeader")
            ]), T([
                A2(Le, T([
                    Rg("AsideTabs")
                ]), T([
                    A2(aw, T([
                        Oh(T([
                            m("AsideTab", !0),
                            m("AsideTabActive", !0)
                        ]))
                    ]), T([
                        A2(Le, T([
                            Rg("AsideTabsIcon")
                        ]), T([
                            Lun
                        ])),
                        ih("Actions")
                    ]))
                ])),
                A2(aw, T([
                    Rg("LayoutFwdButton"),
                    sw(uen(r))
                ]), T([
                    JF
                ]))
            ])),
            A2(Le, T([
                Rg("AsideBody")
            ]), T([
                A2(dk, kJ, A3(xen, n, r.fB, t)),
                A2(FF, ien(r) && aen(t.be), A2(dk, hJ, Sun(r.cJ))),
                A2(FF, A2(een, n.sp, t.be), A2(dk, gJ, A2(lun, r.d1, {
                    mm: t.be.mm,
                    mJ: n.sp.iw,
                    mT: !1,
                    hs: t.be.hs,
                    h2: t.be.h2
                })))
            ]))
        ]);
    }), Fun = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jun = F4(function(n, r, t, e) {
        var u;
        return $w(p(gw, {
            d8: kt(drn(t.mm)),
            fa: r ? kt((u = t.mm, gN(A2(wp, u, 1)))) : Tt,
            fo: kt(iz),
            rS: e.n5
        }));
    }), Pun = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Iun = F2(function(n, r) {
        return A2(Le, T([
            Rg("Avatar"),
            Rg("AvatarLetter"),
            Rg(n)
        ]), T([
            ih(A3(De, 0, 1, r))
        ]));
    }), Bun = F2(function(n, r) {
        var t = i(n.k8, r.k8) ? "AvatarMe" : i(n.oL, r.oL) ? "AvatarCowork" : "AvatarAlien";
        return A2(Iun, t, r.k8);
    }), Mun = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconBullet")
    ]), T([
        A2(BT, T([
            Pg("Bg")
        ]), T([
            A2(Rrn, T([
                zg("8"),
                Xg("8"),
                Vrn("4"),
                Ern("4")
            ]), g)
        ]))
    ])), Oun = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18"),
        Pg("IconPlus")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M3.58334909,5.81668873 C3.26117429,5.365644 3.4556644,5 3.99539757,5 L12.0046024,5 C12.5543453,5 12.7451752,5.35675466 12.4166509,5.81668873 L8.58334909,11.1833113 C8.26117429,11.634356 7.74517524,11.6432453 7.41665091,11.1833113 L3.58334909,5.81668873 Z")
            ]), g)
        ]))
    ])), qun = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18"),
        Pg("IconPlus")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M5,3.99539757 C5,3.44565467 5.35675466,3.25482476 5.81668873,3.58334909 L11.1833113,7.41665091 C11.634356,7.73882571 11.6432453,8.25482476 11.1833113,8.58334909 L5.81668873,12.4166509 C5.365644,12.7388257 5,12.5443356 5,12.0046024 L5,3.99539757 Z")
            ]), g)
        ]))
    ])), Dun = A2(No, _G, function(n) {
        return n.dt;
    }), xun = Oi({
        bN: "Archived",
        bT: "Archiv\xe9"
    }), Run = {
        jT: "#3BAAFF",
        eE: "#1D507B",
        eF: "#13334F",
        ku: "#0E2339",
        mb: "#62BBFF",
        md: "#89CCFF",
        nf: "#B0DDFF",
        ng: "#D7EEFF",
        nh: "#EBF6FF",
        nu: "#318CD3",
        nw: "#276EA7"
    }, Vun = Oi({
        bN: "Comment",
        bT: "Commentaire"
    }), Eun = Oi({
        bN: "Deliver started",
        bT: "Envoi d\xe9marr\xe9"
    }), zun = Oi({
        bN: "Delivered",
        bT: "Livr\xe9"
    }), Uun = Oi({
        bN: "Delivery",
        bT: "Livraison"
    }), Hun = {
        jT: "#1FB86A",
        eE: "#12553F",
        eF: "#0E3531",
        ku: "#0C252A",
        mb: "#4BC687",
        md: "#78D4A5",
        nf: "#A5E2C3",
        ng: "#D2F0E1",
        nh: "#E9F8F0",
        nu: "#1A975B",
        nw: "#16764D"
    }, Wun = "#878E96", Qun = "#3C4451", Zun = "#232D3A", Kun = "#181f29", Yun = "#9FA4AB", Xun = "#B7BBC0", Jun = "#CFD1D5", Gun = "#E7E8EA", _un = "#6E757F", nan = "#555D68", ran = Oi({
        bN: "New",
        bT: "Nouveau"
    }), tan = {
        jT: "#FF5A5A",
        eE: "#6C3039",
        eF: "#3B232E",
        ku: "#221B28",
        mb: "#FF7B7B",
        md: "#FF9C9C",
        nf: "#FFBDBD",
        ng: "#FFDEDE",
        nh: "#FFEEEE",
        nu: "#CE4C4F",
        nw: "#9a2b32"
    }, ean = F2(function(n, r) {
        return A2(mh, T([
            A2(ph, "color", n),
            Rg("TimelineEventLabel")
        ]), T([
            ih(r),
            A2(mh, T([
                Rg("TimelineEventLabelPin"),
                A2(ph, "background-color", n)
            ]), T([
                ih(" ")
            ]))
        ]));
    }), uan = Oi({
        bN: "Transcode",
        bT: "Transcode"
    }), aan = Oi({
        bN: "Unarchived",
        bT: "D\xe9sarchiv\xe9"
    }), ian = Oi({
        bN: "Upload",
        bT: "Upload"
    }), oan = Oi({
        bN: "Verification",
        bT: "Verification"
    }), can = function(n) {
        if (1 === n.$) return ih("");
        switch(n.a.$){
            case 13:
                return ih("");
            case 0:
                return A2(ean, Run.jT, ran);
            case 1:
                return A2(ean, Run.jT, ian);
            case 5:
                return A2(ean, Wun, uan);
            case 6:
                return A2(ean, Hun.jT, uan);
            case 9:
                return A2(ean, Run.jT, oan);
            case 7:
                return A2(ean, Hun.jT, oan);
            case 8:
                return A2(ean, tan.jT, oan);
            case 2:
                return A2(ean, Hun.jT, Eun);
            case 3:
                return A2(ean, Hun.jT, zun);
            case 4:
                return A2(ean, tan.jT, Uun);
            case 10:
                return A2(ean, Wun, xun);
            case 11:
                return A2(ean, Wun, aan);
            default:
                return A2(ean, Wun, Vun);
        }
    }, san = F4(function(n, r, t, e) {
        var u, a = Dt(e.e0) > 1;
        return A2(Le, T([
            Rg("TimelineEvent")
        ]), T([
            A2(Le, T([
                Rg("TimelineEventTitle")
            ]), T([
                can(e.P),
                a ? A2(Le, T([
                    wh(A2(Pun, r, t))
                ]), T([
                    e.aI ? qun : Oun
                ])) : A2(Le, g, T([
                    Mun
                ])),
                A2(v7, dX(e.qI), e.rS)
            ])),
            e.aI ? (u = e.P, A2(Le, T([
                Rg("TimelineEventTitleMessage")
            ]), function() {
                if (1 === u.$) return g;
                switch(u.a.$){
                    case 13:
                        var n = u.a, r = n.b;
                        return T([
                            ih(n.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 0:
                        var t = u.a;
                        return r = t.b, T([
                            ih(t.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 1:
                        var e = u.a;
                        return r = e.b, T([
                            ih(e.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 5:
                        var a = u.a;
                        return r = a.b, T([
                            ih(a.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 6:
                        var i = u.a;
                        return r = i.b, T([
                            ih(i.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 9:
                        var o = u.a;
                        return r = o.b, T([
                            ih(o.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 7:
                        var c = u.a;
                        return r = c.b, T([
                            ih(c.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 8:
                        var s = u.a;
                        return r = s.b, T([
                            ih(s.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 2:
                        var f = u.a;
                        return r = f.b, T([
                            ih(f.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 3:
                        var l = u.a;
                        return r = l.b, T([
                            ih(l.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 4:
                        var m = u.a;
                        return r = m.b, T([
                            ih(m.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 10:
                        var d = u.a;
                        return r = d.b, T([
                            ih(d.a),
                            ih(" "),
                            BN(r)
                        ]);
                    case 11:
                        var b = u.a;
                        return r = b.b, T([
                            ih(b.a),
                            ih(" "),
                            BN(r)
                        ]);
                    default:
                        var p = u.a;
                        return r = p.b, T([
                            ih(p.a),
                            ih(" "),
                            BN(r)
                        ]);
                }
            }())) : A2(Le, T([
                Rg("TimelineGroup")
            ]), A2(Ge, function(r) {
                var t;
                return A2(Le, T([
                    Rg("TimelineGroupEvent")
                ]), T([
                    (t = Dun(r), t.$ ? Mun : A2(Bun, n, t.a)),
                    A2(Le, T([
                        Rg("TimelineEventMessage")
                    ]), T([
                        ih(GG(r)),
                        BN(n_(r))
                    ]))
                ]));
            }, e.e0))
        ]));
    }), fan = F3(function(n, r, t) {
        return _I(A2(_o, F2(function(t, e) {
            return A4(san, n, r, t, e);
        }), t));
    }), lan = F2(function(n, r) {
        return Kt(_I(A2(_o, F2(function(r, t) {
            var e, u, a;
            return A2(Le, g, A2(dt, A2(Dh, T([
                Rg("TimelineDate")
            ]), (u = A3(De, 0, 4, e = r), a = A3(De, 5, 7, e), A3(De, 8, 10, e) + "/" + a + "/" + u)), A3(fan, n, r, t)));
        }), r)));
    }), man = F4(function(n, r, t) {
        return T([
            A4(jun, n, !0, r, t.be),
            _tn(r),
            A2(dk, Fun, A2(Le, T([
                Rg("ShowHomeWrapper")
            ]), A2(lan, n.sp, r.rR)))
        ]);
    }), dan = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("ShowWrapper")
        ]), T([
            A2(Le, T([
                Rg("ShowMain")
            ]), A4(man, n, r, t, e)),
            A2(Le, T([
                Rg("ShowAside")
            ]), A3(yun, n, r, t))
        ]));
    }), ban = F3(function(n, r, t) {
        var e = r.P.kv;
        return e.$ ? A2(ren, n, r) : A4(dan, n, r, e.a, t);
    }), pan = function(n) {
        var r = n.P.lm;
        return r.$ ? ih("") : fT(Gtn(r.a));
    }, van = F2(function(n, r) {
        return A2(du, function(r) {
            return i(n.mm, r.sp) && r.cJ;
        }, r);
    }), $an = F3(function(n, r, t) {
        return !A2(jK, n, r) && A2(van, n, t) && A2(PK, n, t);
    }), gan = function(n) {
        return A3($an, n.sp, n.oL.mm, A2(Ge, function(n) {
            return n.fz;
        }, n.fB));
    }, han = F2(function(n, r) {
        return Dt(A2(Iu, function(n) {
            return i(n.oN, r);
        }, n.oP)) > 0;
    }), kan = {
        $: 0
    }, Tan = F3(function(n, r, t) {
        return n.ih ? kan : function(n) {
            return {
                $: 1,
                a: n
            };
        }(A2(TK, r, t));
    }), wan = F3(function(n, r, t) {
        return {
            R: t.R,
            iW: r.iW,
            cz: t.cz,
            bK: t.bK,
            e$: n.e$,
            bP: t.bP,
            fB: t.fB,
            mK: n.mK,
            cZ: t.cZ,
            _: n._,
            c2: t.c2,
            oL: t.oL,
            oW: r.oW,
            o3: r.o2,
            bj: t.bj,
            g6: t.g6,
            P: A3(Tan, t.g6, t.R.bD, t.R.bQ.fY),
            sp: n.sp
        };
    }), Can = function(n) {
        return dX(n.mm);
    }, Nan = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Aan = F2(function(n, r) {
        return A2(R1, n, r.oW.bD);
    }), San = function(n) {
        return i(A2(Fu, function(n) {
            return KY(n.lB);
        }, n.R.bQ.fY), kt(!0));
    }, Lan = function(n) {
        return u0(n.g6)(n.bK)(n.oL)(n.c2)(n.cZ)(n.bP)(n.R)(n.bj)(n.cz)(n.fB);
    }, yan = {
        $: 0
    }, Fan = {
        $: 1
    }, jan = {
        $: 2
    }, Pan = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ian = {
        $: 0
    }, Ban = Oi({
        bN: "Acceptation",
        bT: "Acceptation"
    }), Man = Oi({
        bN: "Capsule accepted",
        bT: "Capsule accept\xe9e"
    }), Oan = Oi({
        bN: "Master accepted",
        bT: "Master accept\xe9"
    }), qan = function(n) {
        return A2(Le, T([
            Rg("AcceptationBorderWrapper")
        ]), T([
            n
        ]));
    }, Dan = Oi({
        bN: "Capsule rejected",
        bT: "Capsule rejet\xe9e"
    }), xan = Oi({
        bN: "Master rejected",
        bT: "Master rejet\xe9"
    }), Ran = Oi({
        bN: "Please fill in the motivation for rejection",
        bT: "Veuillez donner un motif de refus"
    }), Van = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ean = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zan = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), Uan = {
        $: 0
    }, Han = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Wan = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qan = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Zan = {
        $: 1
    }, Kan = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Yan = function(n) {
        return Kan(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, Xan = Uan, Jan = Kan({
        $: 1
    }), Gan = F2(function(n, r) {
        var t = r.lX, e = r.fY;
        return A2(jK, n, r.g6.oL) ? i(t.di, Tt) ? 1 === e.$ ? Yan("Vous devez uploader un fichier vid\xe9o et attendre la fin de son analyse automatique.") : 1 === A2(fp, function(n) {
            return n.bl;
        }, e.a.su).$ ? Yan("La validation n'est accessible qu'une fois l'analyse automatique termin\xe9e.") : Xan : Yan("Cette capsule a d\xe9j\xe0 \xe9t\xe9 rejet\xe9e.") : Jan;
    }), _an = F2(function(n, r) {
        return ten(n) ? Uan : r;
    }), nin = Kan({
        $: 0
    }), rin = F4(function(n, r, t, e) {
        return A2(_an, n, A2(jK, n, t.oL) ? t.ih ? Jan : e : nin);
    }), tin = F2(function(n, r) {
        return A4(rin, n, r.ak, r.g6, A2(Gan, n, r));
    }), ein = function(n) {
        return A2(Sg, T([
            Rg("ButtonDisabled"),
            Vh(!0)
        ]), T([
            ih(n)
        ]));
    }, uin = Fg("id"), ain = frn(T([
        A2(ow, T([
            iw("M6.75,10.4726562 L6.83203125,10.0351562 C6.90039097,9.67057109 6.99609313,9.35612111 7.11914062,9.09179688 C7.24218812,8.82747264 7.40397035,8.59049584 7.60449219,8.38085938 C7.80501402,8.17122291 8.12629987,7.92057438 8.56835938,7.62890625 C8.97396036,7.36458201 9.25992755,7.14811282 9.42626953,6.97949219 C9.59261151,6.81087155 9.67578125,6.63541758 9.67578125,6.453125 C9.67578125,6.13411299 9.47070518,5.97460938 9.06054688,5.97460938 C8.48632525,5.97460938 7.77311624,6.22297929 6.92089844,6.71972656 L6.10742188,4.78515625 C7.16016151,4.1699188 8.21060674,3.86230469 9.25878906,3.86230469 C10.1748093,3.86230469 10.9028293,4.06738076 11.4428711,4.47753906 C11.9829129,4.88769736 12.2529297,5.45279588 12.2529297,6.17285156 C12.2529297,6.57845255 12.1902676,6.93391774 12.0649414,7.23925781 C11.9396153,7.54459788 11.759604,7.81917196 11.5249023,8.06298828 C11.2902006,8.3068046 10.9016954,8.5927718 10.359375,8.92089844 C9.90364355,9.1943373 9.57893977,9.42219961 9.38525391,9.60449219 C9.19156804,9.78678477 9.06510446,9.9781891 9.00585938,10.1787109 L8.90332031,10.4726562 L6.75,10.4726562 Z M6.203125,13.1318359 C6.203125,12.6442033 6.3512355,12.2568374 6.64746094,11.9697266 C6.94368638,11.6826158 7.3515599,11.5390625 7.87109375,11.5390625 C8.26758011,11.5390625 8.57177628,11.6313467 8.78369141,11.815918 C8.99560653,12.0004892 9.1015625,12.2613915 9.1015625,12.5986328 C9.1015625,13.0999374 8.95686994,13.4873033 8.66748047,13.7607422 C8.378091,14.0341811 7.98047128,14.1708984 7.47460938,14.1708984 C7.07812302,14.1708984 6.76709097,14.0820321 6.54150391,13.9042969 C6.31591684,13.7265616 6.203125,13.4690772 6.203125,13.1318359 Z"),
            uin("?")
        ]), g)
    ])), iin = F3(function(n, r, t) {
        if (t.$) return T(r.$ ? [
            QT(n)
        ] : [
            A2(_nn, n, r.a)
        ]);
        var e = t.a;
        return T([
            A2(Le, T([
                yB(e)
            ]), T([
                ein(n)
            ])),
            A2(Le, T([
                yB(e),
                Rg("AcceptationWarning")
            ]), T([
                ain
            ]))
        ]);
    }), oin = F4(function(n, r, t, e) {
        return A2(_an, n, A2(jK, n, t.oL) ? t.ih ? Jan : e : nin);
    }), cin = F2(function(n, r) {
        return A4(oin, n, r.ak, r.g6, A2(Gan, n, r));
    }), sin = Oi({
        bN: "End file\u2019s qualification",
        bT: "Finir la qualification du fichier"
    }), fin = Oi({
        bN: "You do not have the right to perform this action",
        bT: "Vous n\u2019avez pas le droit d\u2019effectuer cette action"
    }), lin = Oi({
        bN: "Ongoing processing",
        bT: "Traitement en cours"
    }), min = F2(function(n, r) {
        if (1 === n.$) return kt(lin);
        if (!r.$) return Tt;
        var t = r.a;
        switch(t.$){
            case 0:
                return kt("");
            case 1:
                return kt(fin);
            default:
                return kt(t.a);
        }
    }), din = F3(function(n, r, t) {
        if (1 === t.$) return A2(min, n.nH, r);
        var e = t.a.su;
        return 1 === e.$ || 1 === e.a.bl.$ ? kt(lin) : A2(min, n.nH, r);
    }), bin = Oi({
        bN: "Accept",
        bT: "Accepter"
    }), pin = Oi({
        bN: "Accept master",
        bT: "Accepter le master"
    }), vin = Oi({
        bN: "Ask for new upload",
        bT: "Demander un nouvel upload"
    }), $in = Oi({
        bN: "Qualify",
        bT: "Qualifier"
    }), gin = Oi({
        bN: "Accept and deliver",
        bT: "Accepter et livrer"
    }), hin = Oi({
        bN: "Accept the capsule and deliver it to broadcaster",
        bT: "Accepter la capsule et la livrer au diffuseur"
    }), kin = Oi({
        bN: "Reject file and ask for a re-upload.",
        bT: "Rejeter les fichiers et demander un nouvel upload."
    }), Tin = Le(T([
        Rg("ButtonToolbar")
    ])), win = F3(function(n, r, t) {
        var e = A3(din, t, A2(cin, n.sp, {
            ak: n,
            lX: r.bD,
            fY: A2(Fu, function(n) {
                return n.lB;
            }, r.bQ.fY),
            g6: n.g6
        }), A2(Fu, function(n) {
            return n.lB;
        }, r.bQ.fY)), u = A3(din, t, Uan, A2(Fu, function(n) {
            return n.lB;
        }, r.bQ.fY)), a = A3(din, t, A2(tin, n.sp, {
            ak: n,
            lX: r.bD,
            fY: A2(Fu, function(n) {
                return n.lB;
            }, r.bQ.fY),
            g6: n.g6
        }), A2(Fu, function(n) {
            return n.lB;
        }, r.bQ.fY)), i = n.g6.c$ ? m(bin, pin) : m(gin, hin), o = i.a, c = i.b;
        return T([
            ten(n.sp) ? A2(Le, T([
                Rg("AcceptationLeft"),
                Rg("AcceptationNormal")
            ]), T([
                A2(Dh, T([
                    Rg("AcceptationText")
                ]), sin),
                Tin(A3(iin, $in, Ean(A2(Qan, n.g6, r.bD)), u))
            ])) : ih(""),
            A2(Le, T([
                Rg("AcceptationMiddle"),
                Rg("AcceptationOk")
            ]), T([
                A2(Dh, T([
                    Rg("AcceptationTextOk")
                ]), c),
                Cu(n.cz) ? ih("") : A2(dk, Han, A2(ET, t.nF, A2(Ge, function(n) {
                    return m(n.ss, n.ss);
                }, n.cz))),
                Tin(A3(iin, o, Ean(A3(zan, n.g6, r.bD, n.cz)), a))
            ])),
            A2(Le, T([
                Rg("AcceptationRight")
            ]), T([
                A2(zT, T([
                    WT(Van(n.g6)),
                    Rg("AcceptationKo")
                ]), T([
                    A2(Dh, T([
                        Rg("AcceptationRejectionText")
                    ]), kin),
                    A2(dk, Wan, vI(t.nG)),
                    Tin(A3(iin, vin, Zan, e))
                ]))
            ]))
        ]);
    }), Cin = F3(function(n, r, t) {
        return A2(FF, ten(n.sp) || !0, function() {
            var e, u = (e = r.bD.di).$ ? n.g6.ih ? yan : San(n) ? jan : Fan : function(n) {
                return {
                    $: 3,
                    a: n
                };
            }(e.a);
            switch(u.$){
                case 1:
                    return A2(Le, T([
                        Rg("Acceptation"),
                        Yh("accept"),
                        Oh(T([
                            m("AcceptationAccepted", n.g6.ih),
                            m("AcceptationRefused", !i(r.bD.di, Tt))
                        ]))
                    ]), T([
                        Qq(T([
                            Yq(Ban),
                            Qen(T([
                                FB(p(oB, {
                                    ml: kt(t.gh ? JF : Gg),
                                    mI: t.gh,
                                    m6: Ban,
                                    ox: kt(Ian)
                                }))
                            ]))
                        ])),
                        A2(FF, t.gh, A2(Le, T([
                            Rg("InvitationsForm")
                        ]), T([
                            function() {
                                var n = t.nH;
                                switch(n.$){
                                    case 2:
                                        var r = n.a;
                                        return A2(Le, T([
                                            wh(Pan(0))
                                        ]), T([
                                            A2(jnn, Bnn, r)
                                        ]));
                                    case 3:
                                        return A2(Le, T([
                                            wh(Pan(0))
                                        ]), T([
                                            fT(Ran)
                                        ]));
                                    default:
                                        return ih("");
                                }
                            }(),
                            A2(jK, n.sp, n.g6.oL) ? A2(Le, T([
                                Rg("AcceptationChoices")
                            ]), A3(win, n, r, t)) : ih("")
                        ])))
                    ]));
                case 2:
                    return ih("");
                case 0:
                    return qan(lT(n.g6.c$ ? Oan : Man));
                default:
                    return qan(A2(Uq, n.g6.c$ ? xan : Dan, ih(u.a)));
            }
        }());
    }), Nin = Oi({
        bN: "Segmentation IA",
        bT: "Segmentation IA"
    }), Ain = {
        $: 0
    }, Sin = Oi({
        bN: "Video archived",
        bT: "Fichier vid\xe9o archiv\xe9"
    }), Lin = Oi({
        bN: "Proxy required",
        bT: "Proxy requis"
    }), yin = Oi({
        bN: "Video file required",
        bT: "Fichier vid\xe9o requis"
    }), Fin = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(Le, T([
                wh(r)
            ]), T([
                A2(jnn, Bnn, t)
            ]));
        }
        return ih("");
    }), jin = function(n) {
        switch(n.$){
            case 0:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusNone")
                ]), g);
            case 1:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusRunning")
                ]), g);
            case 2:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusSuccess")
                ]), g);
            default:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusFailure")
                ]), g);
        }
    }, Pin = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            jin(n),
            A2(Le, T([
                Rg("OperationContent")
            ]), A2(dt, A2(Fin, n, r), t))
        ]));
    }), Iin = F2(function(n, r) {
        var t = m(n.bQ.fY, A2(fp, A2(No, function(n) {
            return n.pl;
        }, function(n) {
            return n.nv;
        }), n.bQ.fY));
        if (1 === t.a.$) return A3(Pin, Ain, 0, T([
            ih(yin)
        ]));
        if (1 === t.b.$) return A3(Pin, Ain, 0, T([
            ih(Lin)
        ]));
        var e = t.b.a;
        return KY(t.a.a.lB) ? A3(Pin, Ain, 0, T([
            ih(Sin)
        ])) : r(e);
    }), Bin = F2(function(n, r) {
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            jin(Ain),
            A2(Le, T([
                Rg("OperationContent"),
                Rg("PlayerSettings")
            ]), T([
                A2(Le, g, T([
                    ih(A2(ju, "", n.ko))
                ])),
                A2(aw, T([
                    sw("/neoplayer/" + r),
                    Rg("Button"),
                    RF("_blank"),
                    A2(IB, "data-prevent-history", "true")
                ]), T([
                    ih("Neo Player")
                ]))
            ]))
        ]));
    }), Min = F3(function(n, r, t) {
        var e;
        return "df35fcfb-a68e-42f4-8d9f-74d3df15125c" === (e = n.sp).mm || "f4f90af8-0702-49ff-89c0-aafecd8afec9" === e.mm || "f086968b-9a32-449b-bd87-5419c15973ec" === e.mm || "7c9b1827-1d6c-4fa0-8864-598812d5efd5" === e.mm || "5de3e02c-06aa-496f-a4f6-f5aac29114ee" === e.mm || "d00b873f-d6aa-4c16-8342-3e4e08a6d658" === e.mm || "354b2862-a0b9-4292-93a2-437d51a2df47" === e.mm ? A2(Le, T([
            Rg("Segmentation")
        ]), T([
            A2(Le, T([
                Rg("LayoutHeader"),
                A2(ph, "margin-bottom", "0px")
            ]), T([
                A2(Dh, T([
                    Rg("LayoutHeaderTitle")
                ]), Nin)
            ])),
            A2(Iin, r, function() {
                return A2(Bin, t, n.g6.mm);
            })
        ])) : ih("");
    }), Oin = {
        $: 1
    }, qin = function(n) {
        return Dt(n.oP) > 0;
    }, Din = Oi({
        bN: "Cancel",
        bT: "Annuler"
    }), xin = Oi({
        bN: "Deliveries",
        bT: "Livraisons"
    }), Rin = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18"),
        Pg("IconSpinner")
    ]), T([
        A2(ow, T([
            Pg("Fg"),
            iw("M4.94601622,4.57669369 C3.74989521,5.67353545 3,7.24919402 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,6.64729493 13.6458726,4.61086325 11.6744855,3.62757252 L11.2601446,5.69927685 C12.3108237,6.42010318 13,7.62956872 13,9 C13,11.209139 11.209139,13 9,13 C6.790861,13 5,11.209139 5,9 C5,7.98151039 5.38065278,7.051927 6.00745306,6.34575509 L7,8 L9,4 L4,3 L4.94601622,4.57669369 Z")
        ]), g)
    ])), Vin = Oi({
        bN: "Downloading before delivery",
        bT: "T\xe9l\xe9chargement avant livraison"
    }), Ein = Oi({
        bN: "Encoding in progress before delivery",
        bT: "Encodage en cours avant livraison"
    }), zin = Oi({
        bN: "Delivered",
        bT: "Livr\xe9"
    }), Uin = Oi({
        bN: "Packaging in progress before delivery",
        bT: "Enpaquetage en cours avant livraison"
    }), Hin = Oi({
        bN: "Uploading in progress before delivery",
        bT: "Transfert en cours"
    }), Win = Oi({
        bN: "Waiting for delivery",
        bT: "Livraison en attente"
    }), Qin = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M6,11 L9,14 L13,9 L12,7 L9,11 L7,9 L6,11 Z")
        ]), g)
    ])), Zin = function(n) {
        return A2(aw, T([
            sw(dX(n.mm)),
            Rg("DownloadsLinksItem"),
            5 === n.r2.o1 ? Rg("ShowDeliveriesSuccess") : Oh(g)
        ]), T([
            A2(mh, T([
                Rg("DownloadsLinksItemIcon")
            ]), T([
                5 === n.r2.o1 ? Qin : Rin
            ])),
            A2(mh, T([
                Rg("DownloadsLinksItemWrapper")
            ]), T([
                A2(mh, T([
                    Rg("DownloadsLinksItemName")
                ]), T([
                    ih(n.gj),
                    ih(" / "),
                    ih(n.rS)
                ])),
                A2(mh, T([
                    Rg("DownloadsLinksItemDetails")
                ]), T([
                    function() {
                        switch(n.r2.o1){
                            case 0:
                                return ih(Win);
                            case 1:
                                return ih(Vin);
                            case 2:
                                return ih(Ein);
                            case 3:
                                return ih(Uin);
                            case 4:
                                return ih(Hin);
                            default:
                                return ih(zin);
                        }
                    }(),
                    ih(" - "),
                    BN(n.r2.q5)
                ]))
            ]))
        ]));
    }, Kin = function(n) {
        return A2(Ge, Zin, A2(kC, hC(function(n) {
            return n.rS;
        }), n));
    }, Yin = Oi({
        bN: "New delivery",
        bT: "Nouvelle livraison"
    }), Xin = Oi({
        bN: "No delivery yet.",
        bT: "Aucune livraison."
    }), Jin = Oi({
        bN: "No material available.",
        bT: "Pas de mat\xe9riel disponible."
    }), Gin = F4(function(n, r, t, e) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), _in = function(n) {
        return {
            $: 14,
            a: n
        };
    }, non = Oi({
        bN: "This action will not re-encode, but copy source files to destination.",
        bT: "Cette action ne va pas r\xe9-encoder, mais seulement copier les sources \xe0 destination."
    }), ron = Oi({
        bN: "Error occurred during delivery",
        bT: "Une erreur est survenue pendant la livraison"
    }), ton = Oi({
        bN: "Delivery has started...",
        bT: "La livraison a commenc\xe9..."
    }), eon = Oi({
        bN: "Loading...",
        bT: "Chargement..."
    }), uon = Oi({
        bN: "You can not deliver this master on any program.",
        bT: "Vous ne pouvez livrer ce master sur aucun programme."
    }), aon = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M12.5918 14.7207L12.377 15.5996C11.7324 15.8535 11.2181 16.0456 10.834 16.1758C10.4499 16.3125 10.0039 16.3809 9.49609 16.3809C8.71484 16.3809 8.10612 16.1921 7.66992 15.8145C7.24023 15.4303 7.02539 14.9453 7.02539 14.3594C7.02539 14.1315 7.04167 13.9004 7.07422 13.666C7.10677 13.4251 7.15885 13.1549 7.23047 12.8555L8.03125 10.0039C8.10286 9.73047 8.16146 9.47331 8.20703 9.23242C8.25911 8.98503 8.28516 8.76042 8.28516 8.55859C8.28516 8.19401 8.21029 7.9401 8.06055 7.79688C7.91081 7.65365 7.62435 7.58203 7.20117 7.58203C6.99284 7.58203 6.77799 7.61458 6.55664 7.67969C6.3418 7.74479 6.15625 7.80664 6 7.86523L6.21484 6.98633C6.74219 6.77148 7.24674 6.58919 7.72852 6.43945C8.21029 6.2832 8.66602 6.20508 9.0957 6.20508C9.87044 6.20508 10.4661 6.39388 10.8828 6.77148C11.306 7.14258 11.5176 7.6276 11.5176 8.22656C11.5176 8.35026 11.5013 8.56836 11.4688 8.88086C11.4427 9.19336 11.3906 9.47982 11.3125 9.74023L10.5117 12.582C10.4466 12.8099 10.388 13.0703 10.3359 13.3633C10.2839 13.6562 10.2578 13.8776 10.2578 14.0273C10.2578 14.4049 10.3424 14.6621 10.5117 14.7988C10.681 14.9355 10.974 15.0039 11.3906 15.0039C11.5859 15.0039 11.8073 14.9714 12.0547 14.9062C12.3021 14.8346 12.4811 14.7728 12.5918 14.7207ZM11.7969 3.79688C11.7969 4.29167 11.6081 4.71484 11.2305 5.06641C10.8594 5.41146 10.4102 5.58398 9.88281 5.58398C9.35547 5.58398 8.90299 5.41146 8.52539 5.06641C8.14779 4.71484 7.95898 4.29167 7.95898 3.79688C7.95898 3.30208 8.14779 2.87891 8.52539 2.52734C8.90299 2.17578 9.35547 2 9.88281 2C10.4102 2 10.8594 2.17578 11.2305 2.52734C11.6081 2.87891 11.7969 3.30208 11.7969 3.79688Z")
        ]), g)
    ])), ion = function(n) {
        return A2(Le, T([
            Rg("BannerTodo")
        ]), T([
            A2(Le, T([
                Rg("BannerTodoIcon")
            ]), T([
                aon
            ])),
            A2(Le, T([
                Rg("BannerTodoBody")
            ]), T([
                A2(Dh, T([
                    Rg("BannerTodoTitle")
                ]), n)
            ]))
        ]));
    }, oon = Oi({
        bN: "An error occurred while searching for delivery capsules in the organization ",
        bT: "Une erreur est survenue pendant la recherche des capsules de livraison dans l\u2019organisation "
    }), con = Oi({
        bN: "Start delivery",
        bT: "D\xe9marrer la livraison"
    }), son = Oi({
        bN: "No version mapping are associated to this organization. Contact ops@nomalab.com",
        bT: "Aucune version mapping n'est associ\xe9e \xe0 cette organisation. Veuillez contacter ops@nomalab.com."
    }), fon = function(n) {
        return {
            $: 17,
            a: n
        };
    }, lon = function(n) {
        return {
            $: 13,
            a: n
        };
    }, mon = function(n) {
        return {
            $: 10,
            a: n
        };
    }, don = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), bon = function(n) {
        return {
            $: 15,
            a: n
        };
    }, pon = function(n) {
        return {
            $: 12,
            a: n
        };
    }, von = function(n) {
        return {
            $: 11,
            a: n
        };
    }, $on = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gon = function(n) {
        return {
            $: 8,
            a: n
        };
    }, hon = function(n) {
        return {
            $: 9,
            a: n
        };
    }, kon = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Ton = function(n) {
        return {
            $: 19,
            a: n
        };
    }, won = Oi({
        bN: "No transcoding delivery",
        bT: "Livraison source sans encodage"
    }), Con = Oi({
        bN: "Automatic creation",
        bT: "Cr\xe9ation automatique"
    }), Non = Oi({
        bN: "Burn subtitles",
        bT: "Sous-titres incrust\xe9s"
    }), Aon = Oi({
        bN: "Extra",
        bT: "Compl\xe9mentaire"
    }), Son = F2(function(n, r) {
        return A2(F2(function(n, t) {
            for(;;){
                var e = A2(lo, n, r);
                if (1 === e.$) return t;
                var u = e.a, a = u.gn;
                if (1 === a.$) return A2(dt, u.n5, t);
                n = a.a, t = A2(dt, u.n5, t);
            }
        }), n, g);
    }), Lon = Le(T([
        A2(ph, "display", "contents")
    ])), yon = function(n) {
        return A2(Rh, n, A2(Eh, T([
            Rg("InputText"),
            Xh(n.kV),
            Ch("text"),
            ek(Fh),
            _h(jh),
            nk(Ph),
            ak(n.ss),
            uk(n.gt),
            zh(Kh(n.m6)),
            Vh(n.kQ),
            hun(!0)
        ]), g));
    }, Fon = Oi({
        bN: "You can not deliver any of this organization\u2019s programs.",
        bT: "Vous ne pouvez livrer aucun des programmes de cette organisation."
    }), jon = F2(function(n, r) {
        return 1 > n ? r : A3(De, 0, -n, r);
    }), Pon = Oi({
        bN: "Mark in/out",
        bT: "Mark in/out"
    }), Ion = Oi({
        bN: "No subtitles",
        bT: "Sans sous-titres"
    }), Bon = Oi({
        bN: "No extra",
        bT: "Sans compl\xe9mentaire"
    }), Mon = Oi({
        bN: "No segment on this master",
        bT: "Il n'y a pas de segment pour ce master"
    }), Oon = Oi({
        bN: "Segment(s)",
        bT: "Segment(s)"
    }), qon = Oi({
        bN: "Sidecar format : ",
        bT: "Format \xe0 part : "
    }), Don = Oi({
        bN: "Warning, some subtitles have been detected with wrong position, they will be automatically readjusted when you will play and burn them.",
        bT: "Attention, certaines lignes de sous-titres sont d\xe9tect\xe9es avec des placements m\xe9dian, ils seront automatiquement repositionn\xe9s lors de la visualisation et l'incrustation."
    }), xon = Oi({
        bN: "The timezone used is",
        bT: "La timezone utilis\xe9e est"
    }), Ron = F4(function(n, r, t, e) {
        var u, a, o, c, s = A2(dt, m("", Ion), A2(Yc, function(n) {
            var r;
            return (r = n.lB.sg).$ || !i(r.a.j0, Tt) ? kt(m(n.lB.mm, n.lB.n5)) : Tt;
        }, n.bQ.ad)), f = A2(ju, !1, A2(Fu, A2(No, function(n) {
            return n.hE;
        }, A2(No, Cu, pu)), Va(A2(Iu, function(n) {
            return i(n.lB.mm, t.ru.ss);
        }, n.bQ.ad)))), l = "AsSource" !== t.lR.ss, b = F2(function(n, r) {
            return n ? r : ih("");
        }), p = "" !== t.ru.ss, v = "" !== t.e2.ss && "NoExtra" !== t.e2.ss, h = Dt(n.bQ.ad) > 0, k = d(e.c8, e.dr, e.h9), w = k.b, C = k.c, N = Jo(A2(Ge, function(n) {
            return m(n.mm, n);
        }, k.a)), A = $(A2(kC, hC(Ko), A2(Ge, N5(Bt(" > ")), A2(Ge, function(n) {
            return m(n.mm, $(A2(Son, n.gn, N), T([
                n.rT
            ])));
        }, A2(Iu, aen, w)))), T([
            m("Aucun", Con)
        ])), S = A2(Ge, function(n) {
            return m(n.n5, n.n5);
        }, C), L = d(e.cX, e.dw, e.e3), y = L.a, F = L.b, j = L.c, P = A2(dt, m("NoExtra", Bon), A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, j)), I = Dt(P) > 1, B = (u = A2(kC, hC(Ko), A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, y)), r.iG ? $(u, T([
            m("AsSource", won)
        ])) : u), M = A2(w4, y, t.lR.ss);
        return m(A, T([
            A2(Le, g, Cu(A) ? T("" === t.oL.ss ? [
                ih("")
            ] : [
                fT(Fon)
            ]) : T([
                A2(dk, bon, A2(VT, t.g6, A)),
                A2(b, l, A2(dk, hon, A2(VT, t.h9, S))),
                A2(dk, don(y), A2(VT, t.lR, B)),
                A2(b, h && !M, A2(dk, von, A2(VT, t.ru, s))),
                A2(b, h && !M && p, A2(dk, pon, A2(VT, t.rm, (a = t.ru.ss, o = A2(ju, "", Va(A2(Ge, function(n) {
                    return n.lB.n5;
                }, A2(Iu, function(n) {
                    return i(n.lB.mm, a);
                }, n.bQ.ad)))), A2(du, function(n) {
                    return A2(CK, n, Hi(o));
                }, T([
                    ".stl",
                    ".vtt",
                    ".srt",
                    ".ass"
                ])) ? A2(dt, l ? m("Burning", Non) : m("", ""), A2(kC, hC(Ko), A2(Ge, function(n) {
                    return m(n.mm, $(qon, n.n5));
                }, F))) : g)))),
                A2(b, f, j7(Don)),
                A2(b, I, Lon(T([
                    A2(Le, T([
                        Rg("ShowDeliveriesItemTitle")
                    ]), T([
                        ih(Aon)
                    ])),
                    A2(dk, lon, A2(VT, t.e2, P)),
                    A2(b, v, A2(dk, mon, A2(VT, t.e4, S)))
                ]))),
                A2(Le, g, T([
                    A2(dk, fon, (c = t.kI, A2(jT, c, function(n) {
                        var r;
                        return A2(Rh, n, A2(Eh, T([
                            Rg("InputText"),
                            Ch("datetime-local"),
                            A2(Mg, "input", A2(ye, function(n) {
                                return Fh(n);
                            }, A2(mu, "timezone", Bi))),
                            ak((r = n.ss, A2(jon, 6, r))),
                            uk(n.gt),
                            zh(Kh(n.m6)),
                            Vh(n.kQ)
                        ]), g));
                    }(c))))
                ])),
                A2(mh, g, T([
                    ih(xon + " "),
                    A3(Se, "time-zone", g, g)
                ])),
                A2(Le, T([
                    Rg("ShowDeliverySegmentsTabs")
                ]), T([
                    A2(Le, T([
                        wh(Ton(!0)),
                        Rg("ShowDeliverySegmentsTab"),
                        Oh(T([
                            m("ShowDeliverySegmentsTabActive", t.rX)
                        ]))
                    ]), T([
                        ih(Oon)
                    ])),
                    A2(Le, T([
                        wh(Ton(!1)),
                        Rg("ShowDeliverySegmentsTab"),
                        Oh(T([
                            m("ShowDeliverySegmentsTabActive", !t.rX)
                        ]))
                    ]), T([
                        ih(Pon)
                    ]))
                ])),
                A2(b, l, A2(Le, T([
                    Rg("ShowDeliverySegmentsContent")
                ]), T(t.rX ? [
                    i(t.g0.jL, g) ? ih(Mon) : A2(dk, kon, jO(t.g0))
                ] : [
                    A2(mh, T([
                        Rg("MasterTimecodeInputCls")
                    ]), T([
                        A2(dk, $on, yon(t.dy)),
                        A2(_nn, "Mark in", A2(N1, 0, Tt))
                    ])),
                    A2(mh, T([
                        Rg("MasterTimecodeInputCls")
                    ]), T([
                        A2(dk, gon, yon(t.dz)),
                        A2(_nn, "Mark out", A2(N1, 1, Tt))
                    ]))
                ])))
            ]))
        ]));
    }), Von = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return ih("");
            case 1:
                return A2(Le, T([
                    Rg("InvitationsForm")
                ]), T([
                    cen(eon)
                ]));
            default:
                var e = n.a.oP, u = n.a.qs, a = n.a.qt, o = n.a.P, c = !i(A2(Fu, function(n) {
                    return n.h9;
                }, u), Tt), s = A2(ju, g, A2(Fu, function(n) {
                    return n.h9;
                }, u)), f = A2(ju, g, A2(Fu, function(n) {
                    return n.dr;
                }, u)), l = A2(kC, hC(Ko), A2(Ge, function(n) {
                    return m(n.mm, n.n5);
                }, e)), d = A2(Fu, function(n) {
                    return n.mm;
                }, Va(A2(Iu, function(n) {
                    return i(n.oL, a.oL.ss) && i(n.mm, a.g6.ss);
                }, f))), b = Va(A2(Iu, function(n) {
                    return i(n.mm, a.oL.ss);
                }, e)), p = A2(Fu, function(n) {
                    return n.mm;
                }, b), v = i(o, O5), h = (C = m(b, u)).a.$ || C.b.$ ? m(g, g) : A4(Ron, r, C.a.a, a, C.b.a), k = h.a, w = h.b;
                return Cu(l) ? A2(Le, T([
                    Rg("InvitationsForm")
                ]), T([
                    j7(uon)
                ])) : Dt(A2(Iu, function(n) {
                    return !qe(n.a);
                }, k)) > 0 ? A2(Le, T([
                    Rg("InvitationsForm")
                ]), T([
                    j7($(oon, A2(ju, a.oL.ss, Va(A2(Ge, function(n) {
                        return n.n5;
                    }, A2(Iu, function(n) {
                        return i(n.mm, a.oL.ss);
                    }, e))))))
                ])) : A2(zT, T([
                    WT(A4(Gin, t.g6, t.R.bD.mm, p, d))
                ]), $(T([
                    A2(ju, ih(""), A2(Fu, ion, a.nO)),
                    A2(ju, ih(""), A2(Fu, j7, a.n$)),
                    A2(dk, _in, A2(VT, a.oL, l))
                ]), $(w, T([
                    A2(Le, T([
                        Rg("DeliveryFormBanners")
                    ]), T([
                        function() {
                            switch(o.$){
                                case 2:
                                    return A2(Uq, ron, ih(o.a));
                                case 3:
                                    return lT(ton);
                                default:
                                    return "AsSource" === a.lR.ss ? cen(non) : "" !== a.oL.ss && c && !Dt(s) ? j7(son) : ih("");
                            }
                        }(),
                        v || "" === a.g6.ss ? ein(con) : QT(con)
                    ]))
                ]))));
        }
        var C;
    }), Eon = F3(function(n, r, t) {
        var e, u, a, o = (e = r.bQ.fY).$ ? Va(r.bQ.d6) : kt(e.a);
        if (A2(jK, (u = t).sp, u.g6.oL) || A3($an, (a = u).sp, a.oL.mm, A2(Ge, function(n) {
            return n.fz;
        }, a.fB)) && qin(u.sp)) {
            if (o.$) return j7(Jin);
            var c = o.a;
            return A2(Le, T([
                Yh("delivery")
            ]), T([
                Qq(T([
                    Yq(xin),
                    A2(FF, !San(t), Qen(T([
                        FB(p(oB, {
                            kQ: i(n, D5),
                            ml: i(n, Af) ? kt(den) : kt(JF),
                            mI: !i(n, Af),
                            m6: i(n, Af) ? Yin : Din,
                            ox: kt(Oin)
                        }))
                    ])))
                ])),
                A3(Von, n, r, t),
                i(c.kG, g) ? cen(Xin) : A2(Le, T([
                    Rg("DownloadsLinks")
                ]), Kin(c.kG))
            ]));
        }
        return ih("");
    }), zon = {
        $: 6
    }, Uon = Oi({
        bN: "Cancel",
        bT: "Annuler"
    }), Hon = Oi({
        bN: "Invitations",
        bT: "Invitations"
    }), Won = Oi({
        bN: "Invite",
        bT: "Inviter"
    }), Qon = Oi({
        bN: "No invitations.",
        bT: "Aucune invitation."
    }), Zon = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kon = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Yon = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Xon = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Jon = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Gon = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _on = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ncn = Oi({
        bN: "Allow view",
        bT: "Autoriser \xe0 visionner"
    }), rcn = Oi({
        bN: "The files are archived at this time. Please unarchive before download or upload.",
        bT: "Les fichiers sont actuellement archiv\xe9s. Veuillez d\xe9sarchiver avant t\xe9l\xe9chargement ou upload."
    }), tcn = F2(function(n, r) {
        return A2(zT, T([
            WT(_on(n.g6)),
            Rg("InvitationsForm"),
            Rg("DarkZone")
        ]), T([
            A2(dk, Zon, ik(r.k8)),
            A2(dk, Kon, Onn(r.lr)),
            A2(dk, Yon, vI(r.nO)),
            A2(dk, Gon, A2(yen, ncn, ro(function(n) {
                return p(n, {
                    kQ: !0,
                    mm: "checkbox-canView",
                    m6: ncn,
                    ss: !0
                });
            }))),
            A2(dk, Jon, A2(yen, Bf, r.jy)),
            A2(dk, Xon, A2(yen, Pf, r.jx)),
            A2(FF, KY(n.g6) && (r.jx.ss || r.jy.ss), j7(rcn)),
            Sen(Won),
            A2(ju, ih(""), A2(Fu, A2(No, function(n) {
                return n.nO;
            }, fT), r.lm))
        ]));
    }), ecn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ucn = F2(function(n, r) {
        return gN(A2(wp, n, r));
    }), acn = function(n) {
        return A2(ucn, n, 1);
    }, icn = function(n) {
        return A2(Le, T([
            Rg(n ? "FullCube" : "EmptyCube")
        ]), g);
    }, ocn = F2(function(n, r) {
        var t;
        return A2(Fk, g, T([
            A2(uT, g, T([
                icn(!0)
            ])),
            A2(uT, g, T([
                icn(r.fz.sg)
            ])),
            A2(uT, g, T([
                icn(r.fz.cJ)
            ])),
            A2(uT, T([
                Rg("InvitationEmail"),
                yB(r.sp.k8)
            ]), T([
                ih(r.sp.k8),
                ih("   "),
                (t = r.fz.cO, t.$ ? ih("") : Oen(t.a))
            ])),
            function() {
                if (i(n.sp.oL, Tt)) return ih("");
                var t = r.fz.c$;
                n: for(; !t.$;)switch(t.a){
                    case 0:
                        return A2(uT, g, T([
                            A2(Le, T([
                                Rg("InvitationSourceKind")
                            ]), T([
                                A2(wT, function(n) {
                                    return A2(aw, T([
                                        sw(acn(n))
                                    ]), T([
                                        Pen
                                    ]));
                                }, r.fz.hf)
                            ]))
                        ]));
                    case 2:
                        return A2(uT, g, T([
                            A2(Le, T([
                                Rg("InvitationSourceKind")
                            ]), T([
                                A2(wT, function(n) {
                                    return A2(aw, T([
                                        sw(acn(n))
                                    ]), T([
                                        Ien
                                    ]));
                                }, r.fz.hf)
                            ]))
                        ]));
                    default:
                        break n;
                }
                return i(r.fz.qI, Tt) ? A2(uT, g, T([
                    A2(Le, T([
                        Rg("InvitationSourceKind")
                    ]), T([
                        A2(wT, function(n) {
                            return A2(aw, T([
                                sw(acn(n))
                            ]), T([
                                Ben
                            ]));
                        }, r.fz.hf)
                    ]))
                ])) : A2(jK, n.sp, n.g6.oL) ? A2(uT, g, T([
                    A2(Le, T([
                        Rg("InvitationDelete"),
                        wh(ecn(r.fz))
                    ]), T([
                        Th
                    ]))
                ])) : ih("");
            }()
        ]));
    }), ccn = F2(function(n, r) {
        return A2(Le, T([
            Rg("InvitationsWrapper")
        ]), T([
            Qq(T([
                Yq(Hon),
                A2(jK, n.sp, n.g6.oL) ? FB(p(oB, {
                    jO: Tt,
                    ml: kt(r.kS ? JF : den),
                    mI: r.kS,
                    m6: r.kS ? Uon : Won,
                    ox: kt(zon)
                })) : ih("")
            ])),
            r.kS ? A2(tcn, n, r) : ih(""),
            Cu(n.fB) ? cen(Qon) : A2(Tk, T([
                Rg("InvitationsTable")
            ]), A2(Ge, ocn(n), A2(zi, A2(No, function(n) {
                return n.sp;
            }, function(n) {
                return n.k8;
            }), n.fB)))
        ]));
    }), scn = Oi({
        bN: "Client ID",
        bT: "Identifiant client"
    }), fcn = kf, lcn = F2(function(n, r) {
        return A2(Le, T([
            Rg("JobsRow")
        ]), T([
            A2(mh, T([
                Rg("JobsRowLabel")
            ]), T([
                ih(n)
            ])),
            A2(Le, T([
                Rg("JobsRowContent")
            ]), T([
                ih(r)
            ]))
        ]));
    }), mcn = function(n) {
        return A2(Le, T([
            Rg("JobsContent")
        ]), T([
            A2(lcn, "Type", fcn(n.fG)),
            A2(lcn, scn, A2(ju, "", n.lu))
        ]));
    }, dcn = Oi({
        bN: "Job in progress",
        bT: "Travaux en cours"
    }), bcn = Qq(T([
        Yq(dcn)
    ])), pcn = function(n) {
        return {
            $: 21,
            a: n
        };
    }, vcn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $cn = {
        $: 35
    }, gcn = function(n) {
        return {
            $: 42,
            a: n
        };
    }, hcn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, kcn = function(n) {
        return {
            $: 40,
            a: n
        };
    }, Tcn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, wcn = F2(function(n, r) {
        return {
            $: 38,
            a: n,
            b: r
        };
    }), Ccn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ncn = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Acn = F2(function(n, r) {
        return {
            $: 16,
            a: n,
            b: r
        };
    }), Scn = Oi({
        bN: "Download (S3/SFTP)",
        bT: "Download (S3/SFTP)"
    }), Lcn = Oi({
        bN: "Archive show",
        bT: "Archiver le show"
    }), ycn = Oi({
        bN: "Same as source",
        bT: "Comme la source"
    }), Fcn = Oi({
        bN: "Deliver all ad destinations",
        bT: "Livrer vers toutes les destinations ad"
    }), jcn = Oi({
        bN: "Mark as delivered",
        bT: "Marquer comme livr\xe9"
    }), Pcn = F2(function(n, r) {
        return A2(SO, T([
            Rg("LayoutDetails")
        ]), T([
            A2(yO, T([
                Rg("LayoutDetailsHeader")
            ]), T([
                n
            ])),
            A2(Le, T([
                Rg("LayoutDetailsContent")
            ]), r)
        ]));
    }), Icn = Oi({
        bN: "FTP Upload",
        bT: "Upload FTP"
    }), Bcn = function(n) {
        return 2 === n.hs;
    }, Mcn = Oi({
        bN: "Generate Segmentation",
        bT: "G\xe9n\xe9rer Segmentation"
    }), Ocn = Oi({
        bN: "Silent",
        bT: "Silencieux"
    }), qcn = Oi({
        bN: "Dubbed version only",
        bT: "Version doubl\xe9e seulement"
    }), Dcn = Oi({
        bN: "Dubbed version + audiodescription",
        bT: "Version doubl\xe9e + audiodescription"
    }), xcn = Oi({
        bN: "Dubbed version + Music & effect + international version + Voice Only",
        bT: "Version doubl\xe9e + Music & effect + version internationale + Voice Only"
    }), Rcn = Oi({
        bN: "Dubbed + International version + Voice Only",
        bT: "Version doubl\xe9e + internationale + Voice Only"
    }), Vcn = Oi({
        bN: "Original version + dubbed version",
        bT: "Version originale + doubl\xe9e"
    }), Ecn = Oi({
        bN: "Dubbed + original + audiodescription version",
        bT: "Version doubl\xe9e + originale + audiodescription"
    }), zcn = Oi({
        bN: "International version only",
        bT: "Version internationale seulement"
    }), Ucn = Oi({
        bN: "International + Dubbed version",
        bT: "Version internationale + doubl\xe9e"
    }), Hcn = Oi({
        bN: "International + original version",
        bT: "Version internationale originale"
    }), Wcn = Oi({
        bN: "Original version only",
        bT: "Version originale seulement"
    }), Qcn = Oi({
        bN: "Original version + audiodescription",
        bT: "Version originale + audiodescription"
    }), Zcn = Oi({
        bN: "none",
        bT: "aucun"
    }), Kcn = Oi({
        bN: "Reupload file",
        bT: "Reuploader le fichier"
    }), Ycn = Oi({
        bN: "Retranscode proxy",
        bT: "Retranscoder le proxy"
    }), Xcn = Oi({
        bN: "Restart verification",
        bT: "Relancer la v\xe9rification"
    }), Jcn = Oi({
        bN: "Restoring the show, this can take up to 12h.",
        bT: "Restoration du show, cela peut prendre jusque 12h."
    }), Gcn = Oi({
        bN: "S3 Upload",
        bT: "Upload S3"
    }), _cn = Oi({
        bN: "Saved audio mapping: ",
        bT: "Mapping Audio enregistr\xe9 : "
    }), nsn = Oi({
        bN: "Select a rule",
        bT: "S\xe9lectionner une r\xe8gle"
    }), rsn = Oi({
        bN: "Admin Operations",
        bT: "Op\xe9rations Admin"
    }), tsn = Oi({
        bN: "Unarchive show",
        bT: "D\xe9sarchiver le show"
    }), esn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, usn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, asn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, isn = T([
        m("Material", "Material"),
        m("Audio", "Audio"),
        m("Subtitle", "Subtitle"),
        m("Extra", "Extra")
    ]), osn = Oi({
        bN: "Source (url)",
        bT: "Source (url)"
    }), csn = function(n) {
        return A2(du, function(n) {
            return "" === n.trim();
        }, T([
            n.mz.ss,
            n.qn.ss
        ]));
    }, ssn = Oi({
        bN: "Start Download",
        bT: "Start Download"
    }), fsn = F2(function(n, r) {
        var t;
        return A2(zT, T([
            WT(esn(n))
        ]), T([
            (t = r.lm, t.$ ? ih("") : A2(jnn, Bnn, t.a)),
            bw(Zf),
            A2(dk, asn, A2(ET, r.qn, isn)),
            bw(osn),
            A2(dk, usn, ik(r.mz)),
            FB(p(oB, {
                kQ: csn(r),
                bg: !0,
                m6: ssn
            }))
        ]));
    }), lsn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, msn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, dsn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bsn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, psn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vsn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $sn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gsn = Oi({
        bN: "Start FTP Upload",
        bT: "Start FTP Upload"
    }), hsn = F2(function(n, r) {
        var t;
        return A2(zT, T([
            WT(lsn(n))
        ]), T([
            (t = r.lm, t.$ ? ih("") : A2(jnn, Bnn, t.a)),
            A2(Le, T([
                Rg("FTPCopyWrapper")
            ]), T([
                A2(dk, vsn, ik(r.mA)),
                A2(dk, dsn, ik(r.mu)),
                A2(dk, msn, ik(r.mt)),
                A2(dk, psn, ik(r.mw)),
                A2(dk, bsn, ik(r.mv)),
                A2(dk, $sn, A2(ET, r.qn, isn))
            ])),
            QT(gsn)
        ]));
    }), ksn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tsn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, wsn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Csn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Nsn = Oi({
        bN: "Send",
        bT: "Envoyer"
    }), Asn = F2(function(n, r) {
        return A2(zT, T([
            WT(ksn(n))
        ]), T([
            A2(Le, T([
                Rg("S3CopyWrapper")
            ]), T([
                A2(dk, Tsn, ik(r.mx)),
                A2(dk, wsn, ik(r.my)),
                A2(dk, Csn, A2(ET, r.qn, isn))
            ])),
            QT(Nsn)
        ]));
    }), Ssn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Lsn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, ysn = Oi({
        bN: "Ask new upload",
        bT: "Demander un nouvel upload"
    }), Fsn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, jsn = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(Le, T([
                wh(Fsn(r))
            ]), T([
                A2(jnn, Bnn, t)
            ]));
        }
        return ih("");
    }), Psn = function(n) {
        switch(n.$){
            case 0:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusNone")
                ]), g);
            case 1:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusRunning")
                ]), g);
            case 2:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusSuccess")
                ]), g);
            default:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusFailure")
                ]), g);
        }
    }, Isn = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            Psn(n),
            A2(Le, T([
                Rg("OperationContent")
            ]), A2(dt, A2(jsn, n, r), t))
        ]));
    }), Bsn = F2(function(n, r) {
        return A3(Isn, r.ke, 3, T([
            A2(dk, Lsn, vI(r.kf)),
            A2(_nn, ysn, Ssn(n.g6))
        ]));
    }), Msn = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Osn = F2(function(n, r) {
        return {
            $: 29,
            a: n,
            b: r
        };
    }), qsn = function(n) {
        return {
            $: 31,
            a: n
        };
    }, Dsn = {
        $: 26
    }, xsn = F2(function(n, r) {
        return n.$ ? r : A2(dt, n.a, r);
    }), Rsn = A2(Je, xsn, g), Vsn = function(n) {
        var r = F2(function(n, r) {
            return m(r.mm, n + " " + r.n5);
        }), t = Rsn(A2(Ge, A2(No, function(n) {
            return n.bQ;
        }, A2(No, function(n) {
            return n.fY;
        }, Fu(A2(No, function(n) {
            return n.lB;
        }, r("(active)"))))), A2(ju, g, A2(Fu, function(n) {
            return n.bj;
        }, n.g6)))), e = A2(ju, Tt, A2(Fu, A2(No, function(n) {
            return n.R;
        }, A2(No, function(n) {
            return n.bQ;
        }, A2(No, function(n) {
            return n.fY;
        }, Fu(A2(No, function(n) {
            return n.lB;
        }, r("(active)")))))), n.g6));
        return $(g, A2(xsn, e, t));
    }, Esn = F2(function(n, r) {
        var t = n.b;
        if (t.$) return $(r, T([
            n.a
        ]));
        var e = t.a;
        return $(r, $(T([
            n.a
        ]), e));
    }), zsn = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Usn = function(n) {
        return A2(Fg, "colspan", It(n));
    }, Hsn = F2(function(n, r) {
        return A2(aw, T([
            sw(n),
            Rg("Button")
        ]), T([
            ih(r)
        ]));
    }), Wsn = function(n) {
        var r = "stream " + It(n.ft) + ": " + n.n5 + " -> [" + It(n.hp) + "ms, " + It(n.eZ) + "ms]";
        return A2(Fk, g, T([
            A2(uT, g, T([
                ih(r)
            ]))
        ]));
    }, Qsn = function(n) {
        return A2(Fk, g, T([
            A2(uT, g, T([
                ih(n.m2 + ": " + n.ss)
            ]))
        ]));
    }, Zsn = F2(function(n, r) {
        if (n) {
            var t = A2(Ge, Wsn, r.bl);
            return kt(T([
                A2(Fk, g, T([
                    A2(uT, T([
                        Usn(4)
                    ]), T([
                        ih("Configurations")
                    ]))
                ])),
                A2(Fk, g, T([
                    A2(uT, T([
                        Usn(4)
                    ]), T([
                        A2(Tk, g, A2(Ge, Qsn, r.eA))
                    ]))
                ])),
                A2(Fk, g, T([
                    A2(uT, T([
                        Usn(4)
                    ]), T([
                        ih("Results")
                    ]))
                ])),
                A2(Fk, g, T([
                    A2(uT, T([
                        Usn(4)
                    ]), T([
                        Cu(t) ? i(r.j0, Tt) ? ih("") : ih("nothing reported") : A2(Tk, g, t)
                    ]))
                ])),
                A2(Fk, g, T([
                    A2(uT, T([
                        Usn(4),
                        Rg("ProbeLog")
                    ]), T([
                        A2(Hsn, r.fS, "LOGS"),
                        A2(ju, ih("Currently running"), A2(Fu, function() {
                            return ih("Completed ");
                        }, r.j0)),
                        A2(ju, ih(""), A2(Fu, BN, r.j0))
                    ]))
                ]))
            ]));
        }
        return Tt;
    }), Ksn = function(n) {
        var r = n.a, t = n.b;
        return m(A2(Fk, g, T([
            A2(uT, T([
                wh(zsn(t.mm)),
                Rg("ProbeItem")
            ]), T([
                ih(r ? "\u25BC" : "\u25B6")
            ])),
            A2(uT, g, T([
                BN(t.kw)
            ])),
            A2(uT, g, T([
                ih(t.rN)
            ])),
            A2(uT, g, T([
                ih(t.lB)
            ]))
        ])), A2(Zsn, r, t));
    }, Ysn = function(n) {
        return Cu(n.dh) ? ih("No probes on show...") : A2(Tk, T([
            Rg("DeepProbeTable")
        ]), A2(dt, A2(Fk, g, T([
            A2(uT, g, T([
                ih("")
            ])),
            A2(uT, g, T([
                ih("Date")
            ])),
            A2(uT, g, T([
                ih("Template")
            ])),
            A2(uT, g, T([
                ih("File")
            ]))
        ])), A3(qt, Esn, g, A2(Ge, Ksn, n.dh))));
    }, Xsn = function(n) {
        var r = A2(Ge, function(n) {
            return m(n.mm, n.n5);
        }, n.pg);
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            Psn(n.pf),
            A2(Le, T([
                Rg("OperationContent")
            ]), T([
                A2(dk, Msn, A2(VT, n.kB, r)),
                A2(dk, qsn, A2(VT, n.qF, Vsn(n))),
                qe(n.qF.ss) > 0 && qe(n.kB.ss) > 0 ? A2(_nn, "Launch Deep Probe", A2(Osn, n.qF.ss, n.kB.ss)) : ih(""),
                A3(JT, n.l8 ? "Show Probes" : "Hide Probes", T([
                    m("align-self", "flex-end"),
                    m("position", "relative"),
                    m("top", "10px"),
                    m("margin", "0 0 10px 0")
                ]), Dsn),
                n.l8 ? ih("") : Ysn(n)
            ]))
        ]));
    }, Jsn = Oi({
        bN: "Show acceptation required",
        bT: "L'acceptation du show est n\xe9cessaire"
    }), Gsn = Oi({
        bN: "Public organization required",
        bT: "L'organization public est n\xe9cessaire"
    }), _sn = F3(function(n, r, t) {
        var e = n.po;
        return 1 === e.$ ? A3(Isn, Uf, 5, T([
            ih(Gsn)
        ])) : e.a.n9 ? r.g6.ih ? t : A3(Isn, Uf, 5, T([
            ih(Jsn)
        ])) : t;
    }), nfn = Oi({
        bN: "Video archived",
        bT: "Fichier vid\xe9o archiv\xe9"
    }), rfn = Oi({
        bN: "Vid\xe9o file required",
        bT: "Fichier vid\xe9o requis"
    }), tfn = F2(function(n, r) {
        var t = n.bQ.fY;
        if (1 === t.$) return A3(Isn, Uf, 5, T([
            ih(rfn)
        ]));
        var e = t.a;
        return KY(e.lB) ? A3(Isn, Uf, 5, T([
            ih(nfn)
        ])) : r(e.lB);
    }), efn = Oi({
        bN: "Proxy required",
        bT: "Proxy requis"
    }), ufn = F2(function(n, r) {
        var t = m(n.bQ.fY, A2(fp, A2(No, function(n) {
            return n.pl;
        }, function(n) {
            return n.nv;
        }), n.bQ.fY));
        if (1 === t.a.$) return A3(Isn, Uf, 5, T([
            ih(rfn)
        ]));
        if (1 === t.b.$) return A3(Isn, Uf, 5, T([
            ih(efn)
        ]));
        var e = t.b.a;
        return KY(t.a.a.lB) ? A3(Isn, Uf, 5, T([
            ih(nfn)
        ])) : r(e);
    }), afn = F2(function(n, r) {
        if (1 === r.$) return ih("");
        var t = r.a;
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            Psn(Uf),
            A2(Le, T([
                Rg("OperationContent")
            ]), T([
                A2(Hsn, t, n)
            ]))
        ]));
    }), ifn = F4(function(n, r, t, e) {
        return A3(Isn, r, t, T([
            A2(_nn, n, e)
        ]));
    }), ofn = F2(function(n, r) {
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            Psn(Uf),
            A2(Le, T([
                Rg("OperationContent"),
                Rg("PlayerSettings")
            ]), T([
                A2(Le, g, T([
                    ih(A2(ju, "", n.ko))
                ])),
                A2(aw, T([
                    sw("/neoplayer/" + r),
                    Rg("Button"),
                    RF("_blank"),
                    A2(IB, "data-prevent-history", "true")
                ]), T([
                    ih("Neo Player")
                ]))
            ]))
        ]));
    }), cfn = F3(function(n, r, t) {
        var e;
        return ten(n.sp) ? A2(Le, T([
            Rg("Operations")
        ]), T([
            A2(Dh, T([
                Rg("OperationsHeader")
            ]), rsn),
            A2(Pcn, Yq(Gcn), T([
                A2(dk, _8, A2(Asn, r.bD, t.pX))
            ])),
            A2(Pcn, Yq(Icn), T([
                A2(dk, Z8, A2(hsn, r.bD, t.lZ))
            ])),
            A2(Pcn, Yq(Scn), T([
                A2(dk, x8, A2(fsn, r.bD, t.ix))
            ])),
            A3(_sn, t, n, A4(ifn, Fcn, t.kF, 9, vcn(r.bD))),
            A2(tfn, r, function(n) {
                return A4(ifn, Xcn, t.pK, 0, function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(n));
            }),
            A2(tfn, r, function(n) {
                return A4(ifn, Ycn, t.pI, 1, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(n));
            }),
            (e = Cu(n.cz) ? ih("") : A2(dk, hcn, A2(ET, t.bE, A2(Ge, function(n) {
                return m(n.ss, n.ss);
            }, n.cz))), A3(Isn, t.pJ, 2, T([
                e,
                A2(_nn, Kcn, Ccn(r.bD))
            ]))),
            A2(Bsn, n, t),
            A2(ufn, r, function(n) {
                return A2(afn, "proxy log", A2(fp, function(n) {
                    return n.fS;
                }, n.r2));
            }),
            A2(tfn, r, function(n) {
                return A2(afn, "transcode log", A2(fp, function(n) {
                    return n.fS;
                }, n.r2));
            }),
            A2(afn, "upload log", r.bD.h5),
            A2(tfn, r, function() {
                var n, e = T([
                    m(ib(Kd), qcn),
                    m(ib(eb), Wcn),
                    m(ib(nb), zcn),
                    m(ib(Gd), Vcn),
                    m(ib(ub), Qcn),
                    m(ib(Yd), Dcn),
                    m(ib(rb), Ucn),
                    m(ib(tb), Hcn),
                    m(ib(_d), Ecn),
                    m(ib(Jd), Rcn),
                    m(ib(Xd), xcn),
                    m(ib(Zd), Ocn),
                    m(ib(Qd), ycn)
                ]), u = (n = r.bD.fg).$ ? Zcn : ib(n.a);
                return A3(Isn, t.se, 4, T([
                    A2(dk, Tcn, A2(VT, t.i2, e)),
                    A2(_nn, "update audio mapping", A2(Acn, r.bD, t.i2)),
                    A2(Le, g, T([
                        ih($(_cn, u))
                    ]))
                ]));
            }),
            A2(tfn, r, function(n) {
                return A4(ifn, jcn, t.kE, 6, function(n) {
                    return {
                        $: 19,
                        a: n
                    };
                }(n));
            }),
            Bcn(n.g6) ? A3(Isn, Uf, 5, T([
                ih(Jcn)
            ])) : KY(n.g6) ? A4(ifn, tsn, t.d1, 7, Ncn(n.g6)) : A4(ifn, Lcn, t.d1, 7, pcn(n.g6)),
            A2(ufn, r, function() {
                return A2(ofn, t, n.g6.mm);
            }),
            A2(tfn, r, function() {
                return t.l9 ? A2(Le, T([
                    Rg("Operation")
                ]), T([
                    Psn(Uf),
                    A2(Le, T([
                        Rg("OperationContent"),
                        Rg("PlayerSettings")
                    ]), T([
                        A2(Le, g, T([
                            ih("Segmentation")
                        ])),
                        A2(_nn, nsn, gcn(n.oL.mm))
                    ]))
                ])) : A3(Isn, t.iK, 8, T([
                    A2(dk, kcn, A2(VT, t.qj, A2(Ge, function(n) {
                        return m(n.mm, n.n5);
                    }, t.$7))),
                    A2(_nn, Mcn, A2(wcn, r.bD.mm, t.qj.ss))
                ]));
            }),
            t.l7 ? A2(Le, T([
                Rg("Operation")
            ]), T([
                Psn(Uf),
                A2(Le, T([
                    Rg("OperationContent"),
                    Rg("PlayerSettings")
                ]), T([
                    A2(Le, g, T([
                        ih("Deep Probe")
                    ])),
                    A2(_nn, "Show", $cn)
                ]))
            ])) : Xsn(t)
        ])) : ih("");
    }), sfn = {
        $: 1
    }, ffn = function(n) {
        return ml(Rq(A2(MV, n, 1)));
    }, lfn = function(n) {
        return f(n, 1073741824) > -1 ? It(re(n / 1073741824)) + " GB" : f(n, 1048576) > -1 ? It(re(n / 1048576)) + " MB" : 1024 > n ? n > 1 ? It(n) + " bytes" : 1 === n ? It(n) + " byte" : "0 bytes" : It(re(n / 1024)) + " KB";
    }, mfn = Oi({
        bN: "SFTP access",
        bT: "Acc\xe8s SFTP"
    }), dfn = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 0:
                        return "MXF (Material eXchange Format)";
                    case 1:
                        return "QuickTime File Format";
                    default:
                        return "Fichier vid\xe9o MP4";
                }
            case 1:
                return "Fichier de sous-titres";
            default:
                return "Fichier audio MP3";
        }
    }, bfn = {
        $: 1
    }, pfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vfn = T([
        {
            D: ".mxf",
            E: pfn(0),
            nS: "application/mxf"
        },
        {
            D: ".mov",
            E: pfn(1),
            nS: "video/quicktime"
        },
        {
            D: ".mp4",
            E: pfn(2),
            nS: "video/mp4"
        },
        {
            D: ".mp3",
            E: {
                $: 2,
                a: 0
            },
            nS: "audio/mp3"
        },
        {
            D: ".srt",
            E: bfn,
            nS: "application/x-subrip"
        },
        {
            D: ".ass",
            E: bfn,
            nS: "application/x-ass"
        },
        {
            D: ".stl",
            E: bfn,
            nS: "text/subtitle"
        },
        {
            D: ".vtt",
            E: bfn,
            nS: "text/vtt"
        },
        {
            D: ".scc",
            E: bfn,
            nS: "text/scc"
        }
    ]), $fn = F2(function(n, r) {
        return A2(CK, n, Hi(r.n5));
    }), gfn = F2(function(n, r) {
        return A2(ju, !1, A2(Fu, function(r) {
            return i(r, n);
        }, r.nS));
    }), hfn = function(n) {
        return A2(Fu, function(n) {
            return n.E;
        }, Va(A2(Iu, function(r) {
            return A2(gfn, r.nS, n) || A2($fn, r.D, n);
        }, vfn)));
    }, kfn = F2(function(n, r) {
        if (function(n) {
            return A2(du, function(r) {
                var t = r.fz;
                return i(r.sp.mm, n.sp.mm) && t.cJ;
            }, n.fB);
        }(n) && !i(n.R.bQ.fY, Tt)) {
            var t = function(n) {
                var r = n.fY;
                return 1 === r.$ ? g : $(T([
                    r.a
                ]), $(n.d6, n.ad));
            }(n.R.bQ), e = "" === r.fz ? A2(ju, sfn, A2(Fu, function(n) {
                return $J(n);
            }, function(n) {
                return A2(Fu, function(n) {
                    return n.mm;
                }, function(n) {
                    return Va(A2(Yc, function(r) {
                        var t = r.fz;
                        return i(r.sp.mm, n.sp.mm) ? kt(t) : Tt;
                    }, n.fB));
                }(n));
            }(n))) : sfn;
            return A2(Le, g, T([
                Qq(T([
                    Yq(mun),
                    Qen(T([
                        FB(p(oB, {
                            ml: kt(r.gh ? JF : den),
                            mI: r.gh,
                            m6: mfn,
                            ox: kt(e)
                        }))
                    ]))
                ])),
                A2(FF, r.gh, A2(Le, T([
                    Rg("InvitationsForm")
                ]), Aun(r))),
                (u = A2(Ge, function(n) {
                    var r;
                    return {
                        eP: A2(Bt, " - ", T([
                            (r = hfn(n.lB), 1 === r.$ ? "" : dfn(r.a) + " - "),
                            lfn(n.lB.qO)
                        ])),
                        ml: Ben,
                        rS: n.lB.n5,
                        sn: Ao(ffn(n.lB.mm))
                    };
                }, t), A2(Le, T([
                    Rg("DownloadsLinks")
                ]), A2(Ge, function(n) {
                    var r;
                    return A2(aw, T([
                        sw(n.sn),
                        Rg("DownloadsLinksItem"),
                        (r = n.rS, A2(xg, "download", r)),
                        A2(IB, "data-prevent-history", "true"),
                        yB(n.rS)
                    ]), T([
                        A2(mh, T([
                            Rg("DownloadsLinksItemIcon")
                        ]), T([
                            n.ml
                        ])),
                        A2(mh, T([
                            Rg("DownloadsLinksItemWrapper")
                        ]), T([
                            A2(mh, T([
                                Rg("DownloadsLinksItemName")
                            ]), T([
                                ih(n.rS)
                            ])),
                            A2(mh, T([
                                Rg("DownloadsLinksItemDetails")
                            ]), T([
                                ih(n.eP)
                            ]))
                        ]))
                    ]));
                }, u)))
            ]));
        }
        var u;
        return ih("");
    }), Tfn = F2(function(n, r) {
        var t, e, u = !San(n), a = A2(Aan, Lan(n), r);
        return T([
            A2(dk, b1, A3(Eon, r.kH, a, n)),
            A2(dk, c1, A3(Cin, n, a, r.ig)),
            A2(FF, u, A2(dk, p1, A2(kfn, n, r.cJ))),
            A2(dk, w1, A2(ccn, n, r.fB)),
            A2(dk, Nan, (t = n, e = A2(Iu, function(n) {
                return 1 === n.j0.$;
            }, t.cZ), Cu(e) ? ih("") : A2(Le, T([
                Rg("JobsWrapper")
            ]), A2(dt, bcn, A2(Ge, mcn, e))))),
            A2(dk, f1, A2(lun, r.d1, {
                mm: n.g6.mm,
                mJ: n.sp.iw,
                mT: !0,
                hs: n.g6.hs,
                h2: n.g6.h2
            })),
            A2(dk, l1, A3(Min, n, a, r.i7)),
            A2(dk, _Q, A3(cfn, n, a, r.oI))
        ]);
    }), wfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cfn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nfn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Afn = F4(function(n, r, t, e) {
        return {
            S: T([
                {
                    cU: 3,
                    su: A2(Q0, {
                        eR: e,
                        lU: t,
                        ss: n.bb
                    }, {
                        eR: e,
                        lU: t,
                        ss: n.bc
                    })
                }
            ]),
            d0: g,
            bD: r,
            kg: n.kg,
            bK: n.bK,
            bU: Tt,
            mm: Nfn(n.mm),
            nO: p0(n.m6),
            cl: n.kg,
            cm: n.bK.mm
        };
    }), Sfn = function(n) {
        return A2(Fu, _1, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, Z1, n.av))));
    }, Lfn = F3(function(n, r, t) {
        var e = A2(fp, Sfn, r.bQ.fY), u = A2(Gu, function(n) {
            return 1 === e.$ ? g : T([
                A4(Afn, n, r.bD.mm, e.a, !1)
            ]);
        }, A2(ju, g, A2(Fu, function(n) {
            return n.g0;
        }, r.bQ.fY))), a = A2(Ge, function(n) {
            return {
                d4: n_(n),
                mW: Cfn(n)
            };
        }, t), i = A2(Ge, function(n) {
            return {
                d4: n.kg,
                mW: wfn(n)
            };
        }, $(r.bJ, u));
        return A2(kC, F2(function(n, r) {
            return A2(M8, n.d4, r.d4) ? 0 : 2;
        }), A2(Lu, i, a));
    }), yfn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ffn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pfn = Oi({
        bN: "Add timecode",
        bT: "Ajouter un timecode"
    }), Ifn = A2(mh, T([
        Rg("TimecodeSep")
    ]), T([
        ih(":")
    ])), Bfn = A2(No, It, A2(Ym, 2, "0")), Mfn = function(n) {
        switch(n){
            case 0:
                return "TimecodeHH";
            case 1:
                return "TimecodeMM";
            case 2:
                return "TimecodeSS";
            default:
                return "TimecodeFF";
        }
    }, Ofn = F2(function(n, r) {
        var t = function() {
            switch(n){
                case 0:
                    return A2(No, qs, Bfn)(r.mi);
                case 1:
                    return A2(No, qs, Bfn)(r.n_);
                case 2:
                    return A2(No, qs, Bfn)(r.qf);
                default:
                    return Bfn(r.ff);
            }
        }();
        return A2(Le, T([
            Rg("TimecodeUnit"),
            Rg(Mfn(n))
        ]), T([
            ih(t)
        ]));
    }), qfn = function(n) {
        return A2(Le, T([
            Rg("TimecodeWrapper")
        ]), T([
            A2(Ofn, 0, n),
            Ifn,
            A2(Ofn, 1, n),
            Ifn,
            A2(Ofn, 2, n),
            Ifn,
            A2(Ofn, 3, n)
        ]));
    }, Dfn = F2(function(n, r) {
        var t;
        return A2(zT, T([
            WT(Ffn(n.bD)),
            Rg("ActivityCommentForm"),
            Rg("DarkZone")
        ]), T([
            A2(Le, T([
                Rg("ActivityCommentFormMessage")
            ]), T([
                A2(dk, jfn, vI(r.nO))
            ])),
            A2(Le, T([
                Rg("ActivityCommentFormSubmit")
            ]), T([
                A2(Le, T([
                    Rg("ActivityCommentTimecode")
                ]), T([
                    A2(dk, yfn, LT(r.hV)),
                    (t = r.kr, t.$ ? A2(Dh, T([
                        Rg("ActivityCommentTimecodeLabel")
                    ]), Pfn) : qfn(A2(j1, r.q4, t.a)))
                ])),
                QT(cf)
            ]))
        ]));
    }), xfn = function(n) {
        return {
            $: 35,
            a: n
        };
    }, Rfn = {
        $: 3
    }, Vfn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Efn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zfn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), Ufn = Fg("list"), Hfn = function(n) {
        return A2(Rh, n, A2(Eh, T([
            Rg("InputTextarea"),
            Xh(n.kV),
            ek(Fh),
            _h(jh),
            nk(Ph),
            ak(n.ss),
            uk(n.gt),
            Ufn(A2(ju, "", n.ja)),
            Ih(!1),
            Ch("search"),
            zh(Kh(n.m6)),
            Vh(n.kQ),
            n.d7 ? Mh(!0) : Oh(g)
        ]), g));
    }, Wfn = Oi({
        bN: "...End timecode",
        bT: "...Timecode de fin"
    }), Qfn = Oi({
        bN: "Examples...",
        bT: "Examples..."
    }), Zfn = function(n) {
        switch(n){
            case 1:
                return "OrangeFlag";
            case 0:
                return "RedFlag";
            default:
                return "BlueFlag";
        }
    }, Kfn = F2(function(n, r) {
        return A4(s3, n.lU, n.ss, r.q4, n.eR);
    }), Yfn = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconDelete")
    ]), T([
        A2(ow, T([
            Pg("Fg"),
            iw("M12 3H4V13H12V11H8V5H12V3Z")
        ]), g)
    ])), Xfn = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconDelete")
    ]), T([
        A2(ow, T([
            Pg("Fg"),
            iw("M4 3H12V13H4V11H8V5H4V3Z")
        ]), g)
    ])), Jfn = Se("optgroup"), Gfn = Oi({
        bN: "Publish",
        bT: "Publier"
    }), _fn = Oi({
        bN: "Verification Report",
        bT: "Rapport de v\xe9rification"
    }), nln = Oi({
        bN: "Verification: reason",
        bT: "V\xe9rification: motif"
    }), rln = A2(Kg, T([
        zg("16px"),
        Xg("16px"),
        Yg("0 0 16 16"),
        Pg("IconDelete")
    ]), T([
        A2(ow, T([
            Pg("Fg"),
            iw("M11.3982 3.21591L13.6357 3.8496L10.4672 15.037L8.22975 14.4033L11.3982 3.21591Z")
        ]), g),
        A2(ow, T([
            Pg("Fg"),
            iw("M8.37838 9.61152L10.2794 2.89907L2.61646 4.35424L8.37838 9.61152Z")
        ]), g)
    ])), tln = F2(function(n, r) {
        var t = function(t) {
            return A2(Le, T([
                Rg(Zfn(t)),
                Rg("ActivityVerificationFlag"),
                Oh(T([
                    m("ActivityVerificationFlagSelected", i(t, r))
                ])),
                wh(n(t))
            ]), T([
                rln
            ]));
        };
        return A2(Le, T([
            Rg("ActivityVerificationFlagSelect")
        ]), T([
            t(3),
            t(1),
            t(0)
        ]));
    }), eln = F2(function(n, r) {
        var t = n.bQ.fY;
        return 1 === t.$ ? ih("") : A2(zT, T([
            WT(A2(zfn, n.bD, t.a.lB)),
            Rg("ActivityCommentForm"),
            Rg("DarkZone"),
            Rg(Zfn(r.iN.cU))
        ]), T([
            A2(mh, T([
                Rg("ActivityTitle")
            ]), T([
                ih(_fn)
            ])),
            A2(Le, T([
                Rg("ActivityCommentVerifHeader")
            ]), T([
                3 === r.iN.cU ? A2(dk, xfn, UF(r.qi)) : A2(dk, jfn, Hfn(p(r.nO, {
                    ja: kt("VerificationMotifs"),
                    gt: nln
                }))),
                A2(tln, Vfn, r.iN.cU)
            ])),
            A3(Se, "datalist", T([
                Yh("VerificationMotifs")
            ]), T([
                A2(Jfn, T([
                    A2(IB, "label", Qfn)
                ]), A2(Ge, function(n) {
                    return A2(qT, g, T([
                        ih(n)
                    ]));
                }, A2(Ge, Ko, gf)))
            ])),
            A2(Le, T([
                Rg("ActivityCommentVerif")
            ]), T([
                function() {
                    var n = r.iN.su;
                    switch(n.$){
                        case 0:
                            return A2(Le, T([
                                Rg("ActivityCommentVerifTc")
                            ]), T([
                                A2(bI, Yfn, Efn(0)),
                                A2(Dh, T([
                                    Rg("ActivityCommentVerifLabel")
                                ]), Pfn)
                            ]));
                        case 1:
                            var t = n.a;
                            return A2(Le, T([
                                Rg("ActivityCommentVerifTc")
                            ]), T([
                                A2(bI, Yfn, Efn(0)),
                                qfn(A2(Kfn, t, r)),
                                A2(bI, Xfn, Efn(1)),
                                A2(Dh, T([
                                    Rg("ActivityCommentVerifLabel")
                                ]), Wfn),
                                A2(bI, Th, Rfn)
                            ]));
                        default:
                            t = n.a;
                            var e = n.b;
                            return A2(Le, T([
                                Rg("ActivityCommentVerifTc")
                            ]), T([
                                A2(bI, Yfn, Efn(0)),
                                qfn(A2(Kfn, t, r)),
                                A2(bI, Xfn, Efn(1)),
                                qfn(A2(Kfn, e, r)),
                                A2(bI, Th, Rfn)
                            ]));
                    }
                }()
            ])),
            A2(Le, T([
                Rg("ActivityCommentFormSubmit")
            ]), T([
                QT(Gfn)
            ]))
        ]));
    }), uln = function(n) {
        return !i(n.S, g);
    }, aln = function(n) {
        var r = n.mW;
        if (r.$) return 0;
        var t = r.a;
        return uln(t) ? A2(ju, 0, A2(Fu, function(n) {
            var r = n.su;
            switch(r.$){
                case 1:
                case 2:
                    return r.a.ss;
                default:
                    return 0;
            }
        }, Va(t.S))) : 0;
    }, iln = F2(function(n, r) {
        return 4 === n.iW ? A2(zi, aln, A2(Iu, function(n) {
            var r = n.mW;
            return !r.$ && uln(r.a);
        }, r)) : r;
    }), oln = function(n) {
        switch(n){
            case 0:
                return "Neutral";
            case 1:
                return "Good";
            case 2:
                return "Bad";
            default:
                return "Warn";
        }
    }, cln = F3(function(n, r, t) {
        var e = function() {
            switch(t.$){
                case 2:
                    return A2(G$, t.a.dI, T([
                        4,
                        5,
                        6
                    ]));
                case 14:
                    return A2(G$, t.a.cp, T([
                        1
                    ]));
                default:
                    return !1;
            }
        }(), u = n_(t), a = A2(M8, r, u), i = function() {
            switch(t.$){
                case 4:
                    switch((r = t.a).c$){
                        case 0:
                            return m(0, A2(Bun, n, r.dt));
                        case 1:
                            return m(1, A2(Bun, n, r.dt));
                        default:
                            return m(2, A2(Bun, n, r.dt));
                    }
                case 3:
                    return m(0, A2(Bun, n, (r = t.a).dt));
                case 0:
                    var r = t.a;
                    return m(function() {
                        if (1 === r.lm.$) {
                            var n = r.bl;
                            if (n.$) return 0;
                            var t = n.a;
                            return t.n7 > 0 ? 2 : t.aq > 0 ? 3 : 1;
                        }
                        return 2;
                    }(), Mun);
                case 2:
                    return m(1 === (r = t.a).c$ ? 1 === r.lm.$ ? r.c7 ? 3 : 1 : 2 : 0, Mun);
                case 5:
                    return m((r = t.a).c$ ? 1 === r.lm.$ ? 1 : 2 : 0, Mun);
                case 14:
                    return m(1 === (r = t.a).c$ ? 1 === r.lm.$ ? 1 : 2 : 0, Mun);
                default:
                    return m(0, Mun);
            }
        }(), o = i.a, c = i.b;
        return e ? ih("") : A2(Le, T([
            Rg("EventsItem"),
            Rg(oln(o)),
            Oh(T([
                m("EventsItemArchived", a)
            ]))
        ]), T([
            A2(Le, T([
                Rg("EventsItemIcon")
            ]), T([
                c
            ])),
            A2(Le, T([
                Rg("EventsItemBody")
            ]), T([
                A2(Dh, T([
                    Rg("EventsItemLabel")
                ]), GG(t)),
                ih(Qm(fh(160))),
                A2(mh, T([
                    Rg("EventsItemDate")
                ]), T([
                    BN(u)
                ]))
            ]))
        ]));
    }), sln = function(n) {
        return {
            $: 17,
            a: n
        };
    }, fln = function(n) {
        return {
            $: 21,
            a: n
        };
    }, lln = function(n) {
        return {
            $: 32,
            a: n
        };
    }, mln = function(n) {
        return {
            $: 16,
            a: n
        };
    }, dln = function(n) {
        return A2(Le, T([
            Rg("TimecodeDarker")
        ]), T([
            qfn(n)
        ]));
    }, bln = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M5,11 L7,13 L6,14 L4,14 L4,12 L5,11 Z M12,4 L14,6 L8,12 L6,10 L12,4 Z")
        ]), g)
    ])), pln = F2(function(n, r) {
        return A2(Le, T([
            Rg("ButtonMiniIcon"),
            wh(r)
        ]), T([
            n
        ]));
    }), vln = Oi({
        bN: ", modified",
        bT: ", modifi\xe9"
    }), $ln = ih(Qm(fh(160))), gln = F2(function(n, r) {
        return A2(mh, T([
            Rg(n)
        ]), T([
            BN(r)
        ]));
    }), hln = function(n) {
        return A2(kC, F2(function(n, r) {
            return A2(M8, n.kg, r.kg) ? 2 : 0;
        }), n);
    }, kln = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Tln = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), wln = Oi({
        bN: "Save",
        bT: "Sauvegarder"
    }), Cln = F3(function(n, r, t) {
        return A2(zT, T([
            WT(n),
            Rg("ActivityCommentEditForm")
        ]), T([
            A2(dk, Tln(r), ik(t)),
            A2(Le, T([
                Rg("ActivityCommentHideSubmit")
            ]), T([
                QT(wln)
            ]))
        ]));
    }), Nln = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("ActivityAnswer")
        ]), T([
            A2(Bun, n.sp, t.bK),
            A2(Le, T([
                Rg("ActivityCommentContent")
            ]), T([
                A2(Le, T([
                    Rg("ActivityCommentHeader")
                ]), T([
                    A2(Dh, T([
                        Rg("ActivityCommentAuthor")
                    ]), "" === t.bK.n5 ? t.bK.k8 : t.bK.n5),
                    $ln,
                    A2(gln, "ActivityCommentDate", t.kg),
                    $ln,
                    i(t.kg, t.cl) ? ih("") : ih(vln),
                    A2(Le, T([
                        Rg("ActivityCommentActions")
                    ]), T([
                        i(t.bK.mm, n.sp.mm) ? A2(LM, t.mm, r.k5) ? A2(pln, JF, sln(t.mm)) : A2(pln, bln, mln({
                            mm: t.mm,
                            nO: t.nO
                        })) : ih("")
                    ])),
                    A2(Le, T([
                        Rg("ActivityCommentDelete")
                    ]), T([
                        i(t.bK.mm, n.sp.mm) ? A2(pln, JF, kln(t)) : ih("")
                    ]))
                ])),
                function() {
                    var n = A2(lo, t.mm, r.k5);
                    if (1 === n.$) return A2(Dh, T([
                        Rg("ActivityAnswerMessage")
                    ]), t.nO);
                    var e = n.a;
                    return A3(Cln, function(n) {
                        return {
                            $: 25,
                            a: n
                        };
                    }(t), t.mm, e);
                }()
            ]))
        ]));
    }), Aln = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Sln = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Lln = F4(function(n, r, t, e) {
        return A2(zT, T([
            WT(Aln(e)),
            Rg("ActivityAnswerForm")
        ]), T([
            A2(Bun, n.sp, n.sp),
            A2(dk, Sln(f6(e.mm)), ik(A2(ju, e5, A2(lo, f6(e.mm), t.d0)))),
            A2(Le, T([
                Rg("ActivityCommentHideSubmit")
            ]), T([
                QT(t5)
            ]))
        ]));
    }), yln = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("ActivityItem"),
            Rg("ActivityComment")
        ]), T([
            A2(Bun, n.sp, e.bK),
            A2(Le, T([
                Rg("ActivityCommentContent")
            ]), T([
                A2(Le, T([
                    Rg("ActivityCommentHeader")
                ]), T([
                    A2(Dh, T([
                        Rg("ActivityCommentAuthor")
                    ]), "" === e.bK.n5 ? e.bK.k8 : e.bK.n5),
                    $ln,
                    A2(gln, "ActivityCommentDate", e.kg),
                    $ln,
                    i(e.kg, e.cl) ? ih("") : ih(vln),
                    A2(Dh, T([
                        Rg("ActivityCommentSpacer")
                    ]), ""),
                    A2(Le, T([
                        Rg("ActivityCommentActions")
                    ]), T([
                        i(e.bK.mm, n.sp.mm) ? A2(LM, f6(e.mm), t.k5) ? A2(pln, JF, sln(f6(e.mm))) : A2(pln, bln, mln({
                            mm: f6(e.mm),
                            nO: e.nO
                        })) : ih("")
                    ])),
                    A2(Le, T([
                        Rg("ActivityCommentDelete")
                    ]), T([
                        i(e.bK.mm, n.sp.mm) ? A2(pln, JF, fln(e)) : ih("")
                    ]))
                ])),
                function() {
                    var n = A2(lo, f6(e.mm), t.k5);
                    if (1 === n.$) return A2(Le, T([
                        Rg("ActivityCommentWrap")
                    ]), T([
                        A2(Dh, T([
                            Rg("ActivityCommentMessage")
                        ]), e.nO),
                        A2(wT, function(n) {
                            var r = n.ss, e = n.lU, u = n.eR;
                            return A2(Le, T([
                                Rg("ActivityCommentTimecode")
                            ]), T([
                                A2(bI, qun, lln(r)),
                                dln(A4(s3, e, r, t.q4, u))
                            ]));
                        }, e.bU)
                    ]));
                    var r = n.a;
                    return A3(Cln, function(n) {
                        return {
                            $: 18,
                            a: n
                        };
                    }(e), f6(e.mm), r);
                }(),
                A2(Le, T([
                    Rg("ActivityAnswers")
                ]), A2(Ge, A2(Nln, n, t), hln(e.d0))),
                A4(Lln, n, r, t, e)
            ]))
        ]));
    }), Fln = function(n) {
        switch(n){
            case "openingCredits":
                return pf;
            case "endingCredits":
                return mf;
            case "introduction":
                return df;
            case "program":
                return vf;
            case "trailer":
                return $f;
            case "advertising":
                return lf;
            case "testPattern":
                return L4;
            case "black":
                return C4;
            case "slate":
                return S4;
            case "neutralBases":
                return bf;
            default:
                return n;
        }
    }, jln = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Pln = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Iln = F3(function(n, r, t) {
        return {
            $: 11,
            a: n,
            b: r,
            c: t
        };
    }), Bln = F3(function(n, r, t) {
        return {
            $: 10,
            a: n,
            b: r,
            c: t
        };
    }), Mln = Oi({
        bN: "Edit",
        bT: "Editer"
    }), Oln = F2(function(n, r) {
        var t = m(A2(lo, f6(r.mm), n.k2), Va(r.S));
        return t.a.$ ? t.b.$ ? {
            cU: 3,
            su: af
        } : t.b.a : t.a.a;
    }), qln = F2(function(n, r) {
        var t = m(n, r);
        return t.a.$ ? t.b.$ ? af : t.b.a.su : t.a.a.su;
    }), Dln = F2(function(n, r) {
        var t = function(t) {
            return A2(Le, T([
                Rg(Zfn(t)),
                Rg("ActivityVerificationFlag"),
                Oh(T([
                    m("ActivityVerificationFlagSelected", i(t, r))
                ])),
                wh(n(t))
            ]), T([
                rln
            ]));
        };
        return A2(Le, T([
            Rg("ActivityVerificationFlagSelect")
        ]), T([
            t(1),
            t(0)
        ]));
    }), xln = F4(function(n, r, t, e) {
        var u = A2(Oln, n, t);
        return A2(zT, T([
            WT(jln(t)),
            Rg(Zfn(u.cU))
        ]), T([
            3 === u.cU ? A2(Le, T([
                Rg("ActivityVerificationMessage"),
                Rg(Zfn(u.cU))
            ]), T([
                ih(Fln(t.nO))
            ])) : A2(Le, T([
                Rg("ActivityCommentVerifHeader")
            ]), T([
                A2(dk, Tln(f6(t.mm)), Hfn(p(e, {
                    ja: kt("VerificationMotifs"),
                    kV: "editverif" + f6(t.mm),
                    gt: nln
                }))),
                A2(Dln, A2(Iln, u, f6(t.mm)), u.cU)
            ])),
            A2(Le, T([
                Rg("ActivityCommentVerif")
            ]), T([
                function() {
                    var r = A2(qln, A2(lo, f6(t.mm), n.k2), Va(t.S));
                    switch(r.$){
                        case 0:
                            return A2(Le, T([
                                Rg("ActivityCommentVerifTc")
                            ]), T([
                                A2(bI, Yfn, A3(Bln, u, f6(t.mm), 0)),
                                A2(Dh, T([
                                    Rg("ActivityCommentVerifLabel")
                                ]), Pfn)
                            ]));
                        case 1:
                            var e = r.a;
                            return A2(Le, T([
                                Rg("ActivityCommentVerifTc")
                            ]), T([
                                A2(bI, Yfn, A3(Bln, u, f6(t.mm), 0)),
                                qfn(A2(Kfn, e, n)),
                                A2(bI, Xfn, A3(Bln, u, f6(t.mm), 1)),
                                A2(Dh, T([
                                    Rg("ActivityCommentVerifLabel")
                                ]), Wfn),
                                A2(bI, Th, A2(Pln, u, f6(t.mm)))
                            ]));
                        default:
                            e = r.a;
                            var a = r.b;
                            return A2(Le, T([
                                Rg("ActivityCommentVerifTc")
                            ]), T([
                                A2(bI, Yfn, A3(Bln, u, f6(t.mm), 0)),
                                qfn(A2(Kfn, e, n)),
                                A2(bI, Xfn, A3(Bln, u, f6(t.mm), 1)),
                                qfn(A2(Kfn, a, n)),
                                A2(bI, Th, A2(Pln, u, f6(t.mm)))
                            ]));
                    }
                }()
            ])),
            A2(Le, T([
                Rg("ActivityCommentFormSubmit")
            ]), T([
                QT(Mln)
            ]))
        ]));
    }), Rln = F4(function(n, r, t, e) {
        return A2(wT, function(u) {
            return A2(Le, T([
                Rg("ActivityItem"),
                Rg("ActivityComment"),
                Rg(Zfn(u.cU))
            ]), T([
                A2(Bun, n.sp, e.bK),
                A2(Le, T([
                    Rg("ActivityCommentContent")
                ]), $(T([
                    A2(Le, T([
                        Rg("ActivityCommentHeader")
                    ]), T([
                        A2(Dh, T([
                            Rg("ActivityCommentAuthor")
                        ]), "" === e.bK.n5 ? e.bK.k8 : e.bK.n5),
                        $ln,
                        A2(gln, "ActivityCommentDate", e.kg),
                        i(e.kg, e.cl) ? ih("") : ih(vln),
                        A2(Dh, T([
                            Rg("ActivityCommentSpacer")
                        ]), ""),
                        A2(Le, T([
                            Rg("ActivityCommentActions")
                        ]), T([
                            !i(e.bK.mm, n.sp.mm) && n.sp.iw ? ih("") : A2(LM, f6(e.mm), t.k5) ? A2(pln, JF, sln(f6(e.mm))) : A2(pln, bln, mln({
                                mm: f6(e.mm),
                                nO: e.nO
                            })),
                            A2(Le, T([
                                Rg("ActivityCommentDelete")
                            ]), T([
                                i(e.bK.mm, n.sp.mm) ? A2(pln, JF, fln(e)) : ih("")
                            ]))
                        ]))
                    ])),
                    function() {
                        var n = A2(lo, f6(e.mm), t.k5);
                        if (1 === n.$) return A2(Le, T([
                            Rg("ActivityVerificationBloc")
                        ]), T([
                            function() {
                                var n = u.su;
                                switch(n.$){
                                    case 0:
                                        return ih("");
                                    case 1:
                                        var r = n.a;
                                        return A2(Le, T([
                                            Rg("ActivityCommentVerifTc")
                                        ]), T([
                                            A2(bI, qun, lln(r.ss)),
                                            dln(A2(Kfn, r, t))
                                        ]));
                                    default:
                                        r = n.a;
                                        var e = n.b;
                                        return A2(Le, T([
                                            Rg("ActivityCommentVerifTc")
                                        ]), T([
                                            A2(bI, qun, lln(r.ss)),
                                            dln(A2(Kfn, r, t)),
                                            A2(bI, qun, lln(e.ss)),
                                            dln(A2(Kfn, e, t))
                                        ]));
                                }
                            }(),
                            A2(Le, T([
                                Rg("ActivityVerificationMessage"),
                                Rg(Zfn(u.cU))
                            ]), T([
                                ih(Fln(e.nO))
                            ]))
                        ]));
                        var a = n.a;
                        return A2(Le, T([
                            Rg("ActivityVerificationBloc")
                        ]), T([
                            A4(xln, t, r, e, a)
                        ]));
                    }()
                ]), 1 === e.mm.$ ? g : T([
                    A2(Le, T([
                        Rg("ActivityAnswers")
                    ]), A2(Ge, A2(Nln, n, t), hln(e.d0))),
                    A4(Lln, n, r, t, e)
                ])))
            ]));
        }, Va(e.S));
    }), Vln = F4(function(n, r, t, e) {
        return uln(e) ? A4(Rln, n, r, t, e) : A4(yln, n, r, t, e);
    }), Eln = F4(function(n, r, t, e) {
        var u = m(e.mW, n.iW);
        n: for(;;)if (1 === u.a.$) switch(u.b){
            case 0:
                return 3 === u.a.a.$ ? Tt : kt(A3(cln, n.sp, r.bD.kg, u.a.a));
            case 3:
                return kt(A3(cln, n.sp, r.bD.kg, u.a.a));
            default:
                break n;
        }
        else switch(u.b){
            case 0:
                return kt(A4(Vln, n, r, t, a = u.a.a));
            case 4:
                return uln(a = u.a.a) ? kt(A4(Rln, n, r, t, a)) : Tt;
            case 5:
                var a;
                return uln(a = u.a.a) ? Tt : kt(A4(yln, n, r, t, a));
            default:
                break n;
        }
        return Tt;
    }), zln = F4(function(n, r, t, e) {
        var u = i(n.oW.cf, kt(!1)) ? Ie : iln(n);
        return A2(Le, T([
            Rg("ActivityContent"),
            Rg("DarkZone")
        ]), A2(Yc, A3(Eln, n, r, t), u(e)));
    }), Uln = function(n) {
        return {
            $: 36,
            a: n
        };
    }, Hln = Oi({
        bN: "Complete Last started Job",
        bT: "Finir dernier Job d\xe9marr\xe9"
    }), Wln = Oi({
        bN: "Create New Job",
        bT: "Nouveau Job"
    }), Qln = Oi({
        bN: "Start Last created Job",
        bT: "D\xe9marrer dernier Job cr\xe9\xe9"
    }), Zln = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Kln = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return A2(Le, T([
                wh(Zln(r))
            ]), T([
                A2(jnn, Bnn, t)
            ]));
        }
        return ih("");
    }), Yln = function(n) {
        switch(n.$){
            case 0:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusNone")
                ]), g);
            case 1:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusRunning")
                ]), g);
            case 2:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusSuccess")
                ]), g);
            default:
                return A2(Le, T([
                    Rg("OperationStatus"),
                    Rg("OperationStatusFailure")
                ]), g);
        }
    }, Xln = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            Yln(n),
            A2(Le, T([
                Rg("OperationContent"),
                Rg("VerifOperationContent")
            ]), A2(dt, A2(Kln, n, r), t))
        ]));
    }), Jln = function(n) {
        return Va(Kt(A2(zi, A2(bu, jN, function(n) {
            return n.kg;
        }), A2(Iu, function(n) {
            return !i(n.j0, Tt);
        }, A2(Iu, function(n) {
            return 1 === n.fG;
        }, n.cZ)))));
    }, Gln = function(n) {
        return Va(Kt(A2(zi, A2(bu, jN, function(n) {
            return n.kg;
        }), A2(Iu, function(n) {
            return i(n.j0, Tt);
        }, A2(Iu, function(n) {
            return 1 === n.fG;
        }, n.cZ)))));
    }, _ln = F2(function(n, r) {
        if (r.$) return ih("");
        var t = r.a;
        return A2(Le, g, T([
            ih(n),
            ih(" "),
            BN(t.kg)
        ]));
    }), nmn = F2(function(n, r) {
        var t = A2(Iu, function(r) {
            return i(r.fG, n);
        }, r.cZ), e = A2(Yc, function(n) {
            return n.q5;
        }, A2(Iu, function(n) {
            return i(n.j0, Tt);
        }, t)), u = function(n) {
            return It(Dt(n));
        }, a = F4(function(r, t, e, a) {
            return u(r) + " " + kf(n) + " jobs ( " + u(t) + " created, " + u(e) + " started, " + u(a) + " completed )";
        }), o = A2(Iu, function(n) {
            return i(n.j0, Tt) && i(n.q5, Tt);
        }, t), c = A2(Yc, function(n) {
            return n.j0;
        }, t);
        return Cu(t) ? ih("") : A2(Le, T([
            Rg("VerifContent")
        ]), T([
            ih(A4(a, t, o, e, c)),
            A2(_ln, "Last completed " + kf(n) + " Job", Jln(r)),
            A2(_ln, "Last uncompleted " + kf(n) + " Job", Gln(r))
        ]));
    }), rmn = F3(function(n, r) {
        var t = A2(Iu, function(n) {
            return 1 === n.fG || !n.fG;
        }, r.cZ), e = A2(Iu, function(n) {
            return i(n.j0, Tt) && !i(n.q5, Tt);
        }, t), u = A2(Iu, function(n) {
            return i(n.j0, Tt) && i(n.q5, Tt);
        }, t), a = Cu(u) ? ein(Qln) : A2(_nn, Qln, function(n) {
            return {
                $: 39,
                a: n
            };
        }(r.cZ)), o = Cu(e) ? ein(Hln) : A2(_nn, Hln, function(n) {
            return {
                $: 41,
                a: n
            };
        }(r.cZ)), c = Cu(u) && Cu(e) ? A2(_nn, Wln, function(n) {
            return {
                $: 37,
                a: n
            };
        }(r)) : ein(Wln);
        return ten(r.sp) ? A2(Le, T([
            Rg("Operations")
        ]), T([
            A2(Dh, T([
                Rg("OperationsHeader")
            ]), "Operation Admin"),
            A2(nmn, 1, r),
            A2(nmn, 0, r),
            A3(Xln, n.kd, 0, T([
                A2(dk, Uln, UF(n.mX)),
                c
            ])),
            A3(Xln, n.q2, 0, T([
                a
            ])),
            A3(Xln, n.j$, 0, T([
                o
            ]))
        ])) : ih("");
    }), tmn = {
        $: 30
    }, emn = Oi({
        bN: "Order by date",
        bT: "Trier par date"
    }), umn = Oi({
        bN: "Order by timecode",
        bT: "Trier par timecode"
    }), amn = F3(function(n, r, t) {
        return gN(A3(Ap, n, r, t));
    }), imn = F3(function(n, r, t) {
        var e = A2(ju, "", Va(A2(Yc, function(n) {
            return n.a ? kt(n.c) : Tt;
        }, t)));
        return A2(Le, T([
            Rg("Select"),
            Oh(T([
                m("SelectOpened", n)
            ])),
            wh(r),
            TN(n)
        ]), T([
            A2(Le, T([
                Rg("SelectButton")
            ]), T([
                A2(Le, T([
                    Rg("SelectButtonIcon")
                ]), T([
                    MT
                ])),
                A2(Dh, T([
                    Rg("SelectButtonTitle")
                ]), e)
            ])),
            A2(Le, T([
                Rg("SelectList")
            ]), A2(Ge, wN, t))
        ]));
    }), omn = F3(function(n, r, t) {
        var e = n.oW;
        return 4 === n.iW ? A2(Le, T([
            Rg("ActivityHeader")
        ]), T([
            A3(imn, t.ip, tmn, T([
                d(i(e.cf, Tt), A3(amn, n.g6.mm, n.iW, p(e, {
                    cf: Tt
                })), umn),
                d(i(e.cf, kt(!1)), A3(amn, n.g6.mm, n.iW, p(e, {
                    cf: kt(!1)
                })), emn)
            ]))
        ])) : ih("");
    }), cmn = {
        $: 33
    }, smn = function(n) {
        return 5 === n.o1;
    }, fmn = function(n) {
        return A2(ju, !1, A2(Fu, function(n) {
            return function(n) {
                return A2(ju, !1, A2(Fu, smn, n.r2));
            }(n) || !i(n.h6, Tt);
        }, A2(Fu, function(n) {
            return n.lB;
        }, n.R.bQ.fY)));
    }, lmn = Oi({
        bN: "Switch Proxy",
        bT: "Changer de proxy"
    }), mmn = Oi({
        bN: "For a more thourough verification, you can switch to a high-qualitity proxy.",
        bT: "Pour une v\xe9rification plus pouss\xe9e, vous pouvez choisir un proxy mp4 de meilleure qualit\xe9."
    }), dmn = Oi({
        bN: "Switch to hi-res proxy",
        bT: "Afficher le 'proxy hi-res'"
    }), bmn = Oi({
        bN: "Switch back to low-res proxy",
        bT: "Retour au 'proxy low-res'"
    }), pmn = Oi({
        bN: "Generate new proxy verif",
        bT: "G\xe9n\xe9ration du proxy de v\xe9rification"
    }), vmn = F2(function(n, r) {
        return A2(Le, T([
            Rg("Operation")
        ]), T([
            Yln(uf),
            A2(Le, T([
                Rg("OperationContent")
            ]), T([
                ih(n),
                r
            ]))
        ]));
    }), $mn = Oi({
        bN: "Currently watching hi-res proxy",
        bT: "Vous \xeates sur le 'proxy hi-res'"
    }), gmn = Oi({
        bN: "Currently watching low-res proxy",
        bT: "Vous \xeates sur le 'proxy low-res'"
    }), hmn = F3(function(n, r, t) {
        var e, u = ten(r.sp), a = fmn(r), i = function(n) {
            return A2(ju, !1, A2(Fu, function(n) {
                var r = n.r2;
                return !r.$ && 5 === r.a.o1;
            }, A2(fp, A2(No, function(n) {
                return n.pl;
            }, function(n) {
                return n.fm;
            }), n.bQ.fY)));
        }(t);
        return A2(FF, a && u || i, A2(Le, T([
            Rg("RegularOperations")
        ]), T([
            A2(Dh, T([
                Rg("RegularOperationsHeader")
            ]), lmn),
            u ? A3(Xln, n.q3, 0, T([
                (e = t.bQ.fY, 1 === e.$ ? ih("") : A2(_nn, pmn, function(n) {
                    return {
                        $: 44,
                        a: n
                    };
                }(e.a.lB.mm)))
            ])) : cen(mmn),
            A2(FF, i, n.l1 ? A2(vmn, $mn, A2(_nn, bmn, cmn)) : A2(vmn, gmn, A2(_nn, dmn, cmn)))
        ])));
    }), kmn = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("Activity")
        ]), T([
            A3(omn, n, r, t),
            A2(ju, ih(""), A2(Fu, fT, t.lm)),
            A2(Le, T([
                Rg("ActivityContent"),
                Rg("DarkZone")
            ]), function() {
                switch(n.iW){
                    case 4:
                        return T([
                            A3(rmn, t, n, r),
                            A3(hmn, t, n, r),
                            A2(eln, r, t),
                            A4(zln, n, r, t, A3(Lfn, n, r, e))
                        ]);
                    case 5:
                        return T([
                            A2(Dfn, r, t),
                            A4(zln, n, r, t, A3(Lfn, n, r, e))
                        ]);
                    default:
                        return T([
                            A4(zln, n, r, t, A3(Lfn, n, r, e))
                        ]);
                }
            }())
        ]));
    }), Tmn = F2(function(n, r) {
        var t, e, u = A2(Aan, Lan(n), r);
        return T([
            (e = r.P.lm, 1 === e.$ ? ih("") : fT(Gtn(e.a))),
            (t = r.e0.kv, t.$ ? ih("") : A2(dk, s1, A4(kmn, n, u, r.$9, t.a)))
        ]);
    }), wmn = {
        $: 36
    }, Cmn = Oi({
        bN: "Actions",
        bT: "Actions"
    }), Nmn = Oi({
        bN: "Activity",
        bT: "Activit\xe9"
    }), Amn = Oi({
        bN: "Comments",
        bT: "Commentaires"
    }), Smn = Oi({
        bN: "Settings",
        bT: "Param\xe8tres"
    }), Lmn = Oi({
        bN: "Verification report",
        bT: "Rapport de v\xe9rification"
    }), ymn = function(n) {
        switch(n){
            case 0:
            case 1:
                return Cmn;
            case 2:
                return Smn;
            case 3:
                return Nmn;
            case 4:
                return Lmn;
            default:
                return Amn;
        }
    }, Fmn = F2(function(n, r) {
        return gN(A3(Ap, n, r, mX));
    }), jmn = F2(function(n, r) {
        return A2(aw, T([
            Rg("AsideMenuItem"),
            sw(A2(Fmn, n.g6.mm, r)),
            Oh(T([
                m("Active", i(r, n.iW))
            ]))
        ]), T([
            ih(ymn(r))
        ]));
    }), Pmn = F2(function(n, r) {
        return A2(Le, T([
            Rg("AsideTabs"),
            wh(wmn),
            TN(r.iX),
            Oh(T([
                m("AsideMenuOpened", r.iX)
            ]))
        ]), T([
            A2(Le, T([
                Rg("AsideTab")
            ]), T([
                A2(Le, T([
                    Rg("AsideTabInner")
                ]), T([
                    A2(Le, T([
                        Rg("AsideTabsIcon")
                    ]), T([
                        Lun
                    ])),
                    A2(Dh, T([
                        Rg("AsideTabLabel")
                    ]), ymn(n.iW)),
                    MT
                ]))
            ])),
            A2(Le, T([
                Rg("AsideMenu")
            ]), T([
                A2(jmn, n, 1),
                A2(jmn, n, 2),
                A2(jmn, n, 3),
                A2(jmn, n, 4),
                A2(jmn, n, 5)
            ]))
        ]));
    }), Imn = function(n) {
        return 2 === n.$ ? kt(n.a) : Tt;
    }, Bmn = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M8,12 L8,10 L6,10 L6,12 L8,12 Z M12,14 L12,8 L9,10 L9,12 L12,14 Z")
        ]), g)
    ])), Mmn = Oi({
        bN: "audio stream ",
        bT: "stream audio "
    }), Omn = Oi({
        bN: "Channels",
        bT: "Canaux"
    }), qmn = Oi({
        bN: "File duration",
        bT: "Dur\xe9e totale"
    }), Dmn = function(n) {
        return A3(Ym, 2, "0", It(n));
    }, xmn = function(n) {
        var r = fe(1e3 * n), t = r % 1e3, e = r / 1e3 | 0, u = e % 60;
        return Dmn(e / 60 | 0) + " min " + Dmn(u) + " sec " + Dmn(t) + " ms";
    }, Rmn = function(n) {
        var r = A2(fp, function(n) {
            return n.eS;
        }, n);
        return 1 === r.$ ? "?" : xmn(r.a);
    }, Vmn = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M5,9 L5,11 L13,11 L13,9 L5,9 Z M5,13 L5,15 L10,15 L10,13 L5,13 Z")
        ]), g)
    ])), Emn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zmn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Umn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Hmn = F4(function(n, r, t, e) {
        return n.eW || n.hy || "" !== t ? A2(Le, T([
            Rg("EditRow")
        ]), T([
            A2(Dh, T([
                Rg("EditRowLabel")
            ]), r),
            A2(Le, T([
                Rg("EditRowContent")
            ]), T([
                n.eW ? e : ih(t)
            ]))
        ])) : ih("");
    }), Wmn = F4(function(n, r, t, e) {
        return A4(Hmn, n, r, e.ss ? "\u2714" : "", A2(dk, Umn(t), LT(e)));
    }), Qmn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Zmn = F4(function(n, r, t, e) {
        return A4(Hmn, n, r, e.ss, A2(dk, Qmn(t), Mnn(e)));
    }), Kmn = F4(function(n, r, t, e) {
        return A4(Hmn, n, r, e.ss, A2(dk, Qmn(t), ik(e)));
    }), Ymn = F5(function(n, r, t, e, u) {
        return A4(Hmn, n, r, e.ss, A2(dk, Qmn(t), A2(VT, e, u)));
    }), Xmn = function(n) {
        return Oi({
            bN: n.m7,
            bT: n.m8
        });
    }, Jmn = F3(function(n, r, t) {
        var e = A2(lo, t.n5, r.mB);
        if (e.$) {
            var u = A2(lo, t.n5, r.jH);
            if (u.$) return ih("");
            var a = u.a;
            return A4(Wmn, n, Xmn(t), t.n5, a);
        }
        var o = e.a;
        return "date" === t.r6 ? A4(Zmn, n, Xmn(t), t.n5, o) : i(t.st, g) ? A4(Kmn, n, Xmn(t), t.n5, o) : A5(Ymn, n, Xmn(t), t.n5, o, A2(Ge, function(n) {
            return m(n, n);
        }, t.st));
    }), Gmn = Oi({
        bN: "Save",
        bT: "Sauvegarder"
    }), _mn = F2(function(n, r) {
        return n.eW || n.hy || !i(r.ss, Tt) && !i(r.ss, kt(""));
    }), ndn = F2(function(n, r) {
        var t = r.ms;
        return A2(_mn, n, r) ? A2(Le, T([
            Rg("EditRow")
        ]), T([
            A2(Dh, T([
                Rg("EditRowLabel")
            ]), r.ms.m6),
            A2(Le, T([
                Rg("EditRowContent")
            ]), T([
                n.eW ? A2(dk, r.p, r.dk(p(t, {
                    kQ: n.hy
                }))) : ih(A2(ju, "", r.ss))
            ]))
        ])) : ih("");
    }), rdn = F3(function(n, r, t) {
        var e, u = r.g6, a = ndn(n);
        return A2(Le, T([
            Rg("EditContent")
        ]), T([
            (e = t.P, 3 === e.$ ? A2(jnn, Bnn, e.a) : ih("")),
            a({
                ms: t.rT,
                dk: ik,
                p: zmn,
                ss: kt(u.rT)
            }),
            A2(wT, function(r) {
                return Lon(A2(Ge, A2(Jmn, n, t), r.lA));
            }, t.p4),
            A2(FF, n.eW, A2(Le, T([
                Rg("EditFooter")
            ]), T([
                (n.hy ? ein : QT)(Gmn)
            ])))
        ]));
    }), tdn = Oi({
        bN: "Informations",
        bT: "Informations"
    }), edn = {
        $: 9
    }, udn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), adn = Oi({
        bN: "Cancel",
        bT: "Annuler"
    }), idn = Oi({
        bN: "Edit",
        bT: "Editer"
    }), odn = F4(function(n, r, t) {
        return A2(Le, T([
            Rg("EditHeaderActions")
        ]), T(n.eW ? [
            FB(p(oB, {
                kQ: n.hy,
                ml: kt(JF),
                mI: !0,
                m6: adn,
                ox: kt(edn)
            }))
        ] : [
            FB(p(oB, {
                ml: kt(bln),
                mI: !1,
                m6: idn,
                ox: kt(A2(udn, r, t))
            }))
        ]));
    }), cdn = F5(function(n, r, t, e, u) {
        return Qq(T([
            Yq(tdn),
            A2(jK, n.sp, n.g6.oL) ? A4(odn, r, t, e, u) : ih("")
        ]));
    }), sdn = F2(function(n, r) {
        var t = function(n) {
            return {
                eW: 0 !== n.P.$,
                hy: i(n.P, d8)
            };
        }(r);
        return A2(zT, T([
            Rg("EditWrapper"),
            WT(Emn(n.g6)),
            Oh(T([
                m("EditEditing", t.eW)
            ]))
        ]), T([
            A5(cdn, n, t, n.g6, r.c2, r),
            A3(rdn, t, n, r)
        ]));
    }), fdn = Oi({
        bN: "Audio Qualification",
        bT: "Qualification Audio"
    }), ldn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, mdn = {
        $: 14
    }, ddn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, bdn = Oi({
        bN: "Apply",
        bT: "Appliquer"
    }), pdn = Oi({
        bN: "Audio Layout",
        bT: "Agencement Audio"
    }), vdn = Oi({
        bN: "Copy",
        bT: "Copier"
    }), $dn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, gdn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), hdn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), kdn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Tdn = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), wdn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Cdn = F2(function(n, r) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n + ":" + r);
    }), Ndn = F2(function(n, r) {
        return n + "(" + A2(Bt, ", ", r) + ")";
    }), Adn = F3(function(n, r, t) {
        return {
            a2: 1,
            a4: t,
            jT: 0,
            bd: r,
            bk: n,
            ss: A2(Ndn, "rgb", A2(Ge, It, T([
                n,
                r,
                t
            ])))
        };
    }), Sdn = Dh(T([
        (_W = T([
            (XW = A3(Adn, 59, 170, 255), A2(Cdn, "color", XW.ss)),
            (YW = {
                X: 0,
                ss: "bold"
            }, A2(Cdn, "font-weight", YW.ss))
        ]), nQ = function(n) {
            return Cu(n) ? "unstyled" : A2(Na, "_", Ra(A2(Ma, 15739, ii(Ua(ci(Ua(A2(Hk, n, va(g)))))))));
        }(_W), rQ = A2(qg, "className", gi(nQ)), A3(Lg, rQ, _W, nQ))
    ])), Ldn = function(n) {
        switch(n){
            case 0:
                return Oi({
                    bN: "Original version",
                    bT: "Version originale"
                });
            case 1:
                return Oi({
                    bN: "Dubbed version",
                    bT: "Version doubl\xe9e"
                });
            case 2:
                return Oi({
                    bN: "Audio Description",
                    bT: "Audiodescription"
                });
            case 3:
                return Oi({
                    bN: "Silence",
                    bT: "Silence"
                });
            case 4:
                return Oi({
                    bN: "International",
                    bT: "International"
                });
            case 5:
                return Oi({
                    bN: "Music and effects",
                    bT: "Musique et effets"
                });
            case 6:
                return Oi({
                    bN: "Voice only",
                    bT: "Voix seule"
                });
            case 7:
                return Oi({
                    bN: "Custom 1",
                    bT: "Custom 1"
                });
            case 8:
                return Oi({
                    bN: "Custom 2",
                    bT: "Custom 2"
                });
            case 9:
                return Oi({
                    bN: "Custom 3",
                    bT: "Custom 3"
                });
            case 10:
                return Oi({
                    bN: "Custom 4",
                    bT: "Custom 4"
                });
            case 11:
                return Oi({
                    bN: "Custom 5",
                    bT: "Custom 5"
                });
            case 12:
                return Oi({
                    bN: "Custom 6",
                    bT: "Custom 6"
                });
            case 13:
                return Oi({
                    bN: "Custom 7",
                    bT: "Custom 7"
                });
            case 14:
                return Oi({
                    bN: "Custom 8",
                    bT: "Custom 8"
                });
            case 15:
                return Oi({
                    bN: "Custom 9",
                    bT: "Custom 9"
                });
            default:
                return Oi({
                    bN: "Custom 10",
                    bT: "Custom 10"
                });
        }
    }, ydn = T([
        m(L0(0), Ldn(0)),
        m(L0(1), Ldn(1)),
        m(L0(4), Ldn(4)),
        m(L0(2), Ldn(2)),
        m(L0(3), Ldn(3)),
        m(L0(5), Ldn(5)),
        m(L0(6), Ldn(6)),
        m(L0(7), Ldn(7)),
        m(L0(8), Ldn(8)),
        m(L0(9), Ldn(9)),
        m(L0(10), Ldn(10)),
        m(L0(11), Ldn(11)),
        m(L0(12), Ldn(12)),
        m(L0(13), Ldn(13)),
        m(L0(14), Ldn(14)),
        m(L0(15), Ldn(15)),
        m(L0(16), Ldn(16))
    ]), Fdn = Oi({
        bN: "Cancel",
        bT: "Annuler"
    }), jdn = Fk(T([
        Rg("TableTrHead")
    ])), Pdn = Se("i"), Idn = dw(Pdn), Bdn = function(n) {
        return kt(function(n) {
            return {
                $: 9,
                a: n
            };
        }(n));
    }, Mdn = Oi({
        bN: "Back to video",
        bT: "Retour au media principal"
    }), Odn = Oi({
        bN: "Play",
        bT: "Lecture"
    }), qdn = F2(function(n, r) {
        var t = n.qo;
        if (t.$) return Odn;
        var e = m(t.a, r);
        n: for(;;){
            if (e.a.$) {
                if (e.b.$ || 1 !== e.b.a.$) break n;
                return i(e.a.a, e.b.a.a) ? Mdn : Odn;
            }
            if (e.b.$ || e.b.a.$) break n;
            return i(e.a.a, e.b.a.a) ? Mdn : Odn;
        }
        return Odn;
    }), Ddn = Oi({
        bN: "Qualify",
        bT: "Qualifier"
    }), xdn = Oi({
        bN: "Save",
        bT: "Enregistrer"
    }), Rdn = F2(function(n, r) {
        return "" === n.ss && i(n.ln, g) ? A2(Le, T([
            Rg("InputWrapper"),
            Rg("InputWrapperPrechoice"),
            Oh(T([
                m("InputWrapperDisabled", n.kQ)
            ]))
        ]), A2(dt, A2(Le, T([
            Rg("InputSelectAllChoice")
        ]), T([
            MT,
            A2(RT, n, r)
        ])), A2(Ge, function(n) {
            var r = n.a, t = n.b;
            return A2(Dh, T([
                Rg("InputSelectPrechoice"),
                wh(Fh(r))
            ]), t);
        }, r))) : A2(VT, n, r);
    }), Vdn = Tk(T([
        Rg("Table")
    ])), Edn = function(n) {
        return A2(uT, T([
            Rg("TableTd")
        ]), T([
            n
        ]));
    }, zdn = function(n) {
        return A2(uT, T([
            Rg("TableTh")
        ]), T([
            n
        ]));
    }, Udn = Fk(T([
        Rg("TableTr")
    ])), Hdn = function(n) {
        var r = F2(function(n, r) {
            var t = n.b, e = r.b;
            return m(A2(dt, n.a, r.a), A2(dt, t, e));
        });
        return A3(Je, r, m(g, g), n);
    }, Wdn = F6(function(n, r, t, e, u, a) {
        var o, c, s, f, l = A2(Fu, YT, e.sv), b = A2(Fu, g$, e.sv), v = A2(Fu, Ldn, e.r5), $ = A2(Fu, L0, e.r5), g = i(t.pv, T([
            e.m2
        ])), h = T([
            m(N0(1), H1(1)),
            m(N0(2), H1(2))
        ]), k = T([
            m(N0(5), H1(5)),
            m(N0(13), H1(13))
        ]), w = T([
            m(N0(0), H1(0)),
            m(N0(3), H1(3)),
            m(N0(4), H1(4)),
            m(N0(6), H1(6)),
            m(N0(7), H1(7)),
            m(N0(8), H1(8)),
            m(N0(11), H1(11)),
            m(N0(9), H1(9)),
            m(N0(10), H1(10))
        ]), C = T([
            m(N0(12), H1(12)),
            m(N0(13), H1(13))
        ]), N = function() {
            switch(e.cz){
                case "1":
                    return w;
                case "2":
                    return h;
                case "6":
                    return k;
                case "8":
                    return C;
                default:
                    return T([
                        m(N0(0), H1(0)),
                        m(N0(2), H1(2)),
                        m(N0(3), H1(3)),
                        m(N0(4), H1(4)),
                        m(N0(1), H1(1)),
                        m(N0(6), H1(6)),
                        m(N0(7), H1(7)),
                        m(N0(8), H1(8)),
                        m(N0(11), H1(11)),
                        m(N0(9), H1(9)),
                        m(N0(10), H1(10)),
                        m(N0(12), H1(12)),
                        m(N0(13), H1(13))
                    ]);
            }
        }(), A = A2(Fu, H1, e.nc), S = A2(Fu, N0, e.nc), L = !i(A, Tt) && !i(v, Tt), y = !(o = A2(lo, e.m2, t.sx)).$ && C5(o.a.r5.ss), F = t.eY && A3(IK, r.sp, r.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, r.fB)), j = T(L ? [
            A2(wT, Sdn, A),
            A2(wT, lR, v),
            A2(wT, Idn, l)
        ] : [
            lR(e.rS)
        ]), P = A2(ju, d(ih(""), ih(""), ih("")), A2(Fu, function(n) {
            var r;
            return d(A2(dk, hdn(e.m2), A2(Rdn, n.r5, ydn)), (r = n.sv, A2(dk, kdn(e.m2), A2(Rdn, p(r, {
                kQ: !y
            }), XT))), A2(dk, gdn(e.m2), A2(Rdn, n.nc, N)));
        }, A2(fp, function() {
            return A2(lo, e.m2, t.sx);
        }, Va(t.pv)))), I = P.a, B = P.b, M = P.c;
        return A2(Le, T([
            Rg("AudioQualifyFilesAudioStream")
        ]), T([
            A2(Le, T([
                Rg("AudioQualifyFilesHeader")
            ]), T([
                Bmn,
                A2(Le, T([
                    Rg("AudioQualifyFilesTitle")
                ]), j),
                u ? A2(Le, T([
                    Rg("PlayAudio")
                ]), T([
                    lB(p(oB, {
                        ml: kt(Nen),
                        m6: A2(qdn, t, a),
                        ox: Bdn(a)
                    }))
                ])) : ih(""),
                F ? A2(Le, T([
                    Rg("AudioQualifyQualifyEdit")
                ]), T([
                    lB(p(oB, {
                        ml: kt(g ? JF : bln),
                        bf: g,
                        m6: g ? Fdn : Ddn,
                        ox: kt(g ? $dn(e.m2) : A4(Tdn, e.m2, $, b, S))
                    }))
                ])) : ih("")
            ])),
            i(t.pv, T([
                e.m2
            ])) ? A2(zT, T([
                WT(wdn(e.m2)),
                Rg("AudioQualifyQualifyForm")
            ]), T([
                M,
                I,
                B,
                Sen(xdn)
            ])) : ih(""),
            A2(Le, T([
                Rg("AudioQualifyFilesDesc")
            ]), (c = Hdn(e.kK), s = c.a, f = c.b, T([
                Vdn(T([
                    jdn(A2(Ge, A2(bu, zdn, ih), s)),
                    Udn(A2(Ge, A2(bu, Edn, ih), f))
                ]))
            ])))
        ]));
    }), Qdn = F5(function(n, r, t, e, u) {
        if (Cu(t)) return ih("");
        var a, i = A2(zi, function(n) {
            return n.ft;
        }, t), o = F2(function(n, r) {
            return A2(Fu, function(n) {
                return n.$ ? b5(n.a + "/" + It(r)) : s5(r + 1);
            }, n);
        });
        return A2(Le, T([
            Rg("AudioQualifyWrapper")
        ]), T([
            A2(Le, g, A2(zt, F2(function(t, a) {
                return A6(Wdn, t, n, r, a, e, A2(o, u, t));
            }), i)),
            r.eY && A3(IK, n.sp, n.g6.oL, A2(Ge, function(n) {
                return n.fz;
            }, n.fB)) && (u.$ || 1 !== u.a.$) ? A2(Le, T([
                Rg("AudioQualifyMemo")
            ]), T([
                A2(mh, T([
                    Rg("AudioQualifyMemoLabel")
                ]), T([
                    ih(pdn)
                ])),
                lB(p(oB, {
                    ml: Tt,
                    m6: vdn,
                    ox: kt(ddn(t))
                })),
                (a = r.p$, 1 === a.$ || "" === a.a ? ih("") : lB(p(oB, {
                    ml: Tt,
                    m6: bdn,
                    ox: kt(ldn(t))
                })))
            ])) : ih(""),
            function() {
                if (r.eY) {
                    if (u.$ || 1 !== u.a.$) {
                        var n = r.p$;
                        if (1 === n.$) return ih("");
                        if ("" === n.a) return ih("");
                        var t = n.a;
                        return A2(mh, T([
                            Rg("AudioQualifyMemoRecap")
                        ]), T([
                            ih(bdn + " '" + t + "' ?"),
                            A2(pln, Th, mdn)
                        ]));
                    }
                    return ih("");
                }
                return ih("");
            }()
        ]));
    }), Zdn = F5(function(n, r, t, e, u) {
        return A2(Le, T([
            Rg("AudioQualify")
        ]), T([
            Qq(T([
                Yq(fdn)
            ])),
            A5(Qdn, n, r, t, e, u)
        ]));
    }), Kdn = Oi({
        bN: "Subtitle Qualification",
        bT: "Qualification des sous-titres"
    }), Ydn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Xdn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Jdn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Gdn = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), _dn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, nbn = Oi({
        bN: "Qualify",
        bT: "Qualifier"
    }), rbn = Oi({
        bN: "Save",
        bT: "Enregistrer"
    }), tbn = F5(function(n, r, t, e) {
        var u = A2(Fu, YT, e.sv), a = A2(Fu, g$, e.sv), o = A2(Fu, qF, e.r5), c = A2(Fu, AS, e.r5), s = t.eY && A3(IK, r.sp, r.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, r.fB)), f = A2(ju, m(ih(""), ih("")), A2(Fu, function(n) {
            return m(A2(dk, Jdn(e.m2), A2(VT, n.sv, xF)), A2(dk, Xdn(e.m2), A2(VT, n.r5, DF)));
        }, A2(fp, function() {
            return A2(lo, e.m2, t.sx);
        }, t.pv))), l = f.a, d = f.b;
        return A2(Le, T([
            Rg("SubtitleQualifyFilesSubtitleStream")
        ]), T([
            A2(Le, T([
                Rg("SubtitleQualifyFilesHeader")
            ]), T([
                Bmn,
                A2(Dh, T([
                    Rg("SubtitleQualifyFilesTitle")
                ]), e.rS),
                s ? A2(Le, T([
                    Rg("SubtitleQualifyQualifyEdit")
                ]), T([
                    lB(p(oB, {
                        ml: kt(Nen),
                        mI: i(t.pv, kt(e.m2)),
                        m6: nbn,
                        ox: i(t.pv, kt(e.m2)) ? kt(Ydn(e.m2)) : kt(A3(Gdn, e.m2, a, c))
                    }))
                ])) : ih("")
            ])),
            i(t.pv, kt(e.m2)) ? A2(zT, T([
                WT(_dn(e.m2)),
                Rg("SubtitleQualifyQualifyForm")
            ]), T([
                l,
                d,
                QT(rbn)
            ])) : A2(Le, T([
                Rg("SubtitleQualifyQualify")
            ]), T([
                A2(wT, Dh(T([
                    Rg("SubtitleQualifyQualifyItem")
                ])), u),
                A2(wT, Dh(T([
                    Rg("SubtitleQualifyQualifyItem")
                ])), o)
            ]))
        ]));
    }), ebn = F4(function(n, r, t, e) {
        return Cu(t) ? ih("") : A2(Le, T([
            Rg("SubtitleQualifyWrapper")
        ]), T([
            A2(Le, g, A2(zt, F2(function(t, u) {
                return A5(tbn, t, n, r, u, e);
            }), t))
        ]));
    }), ubn = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("SubtitleQualify")
        ]), T([
            Qq(T([
                Yq(Kdn)
            ])),
            A4(ebn, n, r, t, e)
        ]));
    }), abn = F2(function(n, r) {
        var t = !1, e = A2(Aan, Lan(n), r), u = A3(Je, jt, g, A2(Ge, function(n) {
            return A2(Ge, function(r) {
                return {
                    z: r.z,
                    ft: r.ft,
                    n5: n.lB.n5,
                    r5: r.r5,
                    sv: r.sv
                };
            }, A2(Yc, Imn, n.av));
        }, e.bQ.ad)), a = A2(kC, hC(function(n) {
            return n.rS;
        }), A2(Ge, function(n) {
            return {
                ml: Vmn,
                ft: n.ft,
                m2: n.z + "/" + It(n.ft),
                rS: n.n5,
                r5: n.r5,
                sv: n.sv
            };
        }, u)), i = function() {
            var n = e.bQ.fY;
            return n.$ ? g : n.a.av;
        }(), o = A2(Yc, U1, i), c = A2(kC, hC(function(n) {
            return n.rS;
        }), A2(Ge, function(n) {
            return {
                cz: It(n.cz),
                kK: T([
                    m("Codec", n.aE),
                    m(qmn, Rmn(kt(n))),
                    m(Omn, It(n.cz))
                ]),
                ml: Bmn,
                ft: n.ft,
                m2: n.z + "/" + It(n.ft),
                nc: n.aC,
                rS: $(Mmn, A3(Ym, 2, "0", It(n.ft))),
                r5: n.r5,
                sv: n.sv
            };
        }, o));
        return T([
            A2(dk, v1, A2(sdn, n, r.k1)),
            A2(dk, JQ, A5(Zdn, n, r.i4, c, t, kt(s5(-1)))),
            A2(dk, S1, A4(ubn, n, r.rp, a, t))
        ]);
    }), ibn = F2(function(n, r) {
        return T([
            A2(Le, T([
                Rg("AsideHeader")
            ]), T([
                A2(Pmn, n, r),
                A2(aw, T([
                    Rg("LayoutFwdButton"),
                    sw(Can(r))
                ]), T([
                    JF
                ]))
            ])),
            A2(Le, T([
                Rg("AsideBody")
            ]), function() {
                switch(n.iW){
                    case 1:
                    case 0:
                        return A2(Tfn, n, r);
                    case 2:
                        return A2(abn, n, r);
                    default:
                        return A2(Tmn, n, r);
                }
            }())
        ]);
    }), obn = F2(function(n, r) {
        return n ? r : ih("");
    }), cbn = function(n) {
        return {
            $: 41,
            a: n
        };
    }, sbn = {
        $: 18
    }, fbn = {
        $: 19
    }, lbn = {
        $: 20
    }, mbn = F3(function(n, r, t) {
        return A2(jK, n, r) || A2(van, n, t);
    }), dbn = function(n) {
        return {
            $: 29,
            a: n
        };
    }, bbn = Oi({
        bN: "Delete",
        bT: "Supprimer"
    }), pbn = Oi({
        bN: "Download",
        bT: "T\xe9l\xe9charger"
    }), vbn = F3(function(n, r, t) {
        var e = n.P.kv;
        return !(e.$ || !t.iw && 9 !== r.c$ && (e.a.g6.c$ || 8 !== r.c$ && 7 !== r.c$));
    }), $bn = Oi({
        bN: "In progress...",
        bT: "En cours..."
    }), gbn = function(n) {
        switch(n){
            case 0:
                return "ProgressIdle";
            case 1:
                return "ProgressActive";
            case 2:
                return "ProgressError";
            case 3:
                return "ProgressWarning";
            case 4:
                return "ProgressPaused";
            default:
                return "ProgressCompleted";
        }
    }, hbn = function(n) {
        var r = function() {
            var r = n.pj;
            if (1 === r.$) return m(m($bn, 100), m(!1, !0));
            var t = r.a;
            return m(m(QV(t), 100 * t), m(1 > t, !1));
        }(), t = r.a, e = t.a, u = t.b, a = r.b, i = a.a, o = a.b;
        return A2(Le, T([
            Rg("ProgressBarOuter"),
            yB(e)
        ]), T([
            A2(Le, T([
                Rg("ProgressBarInner"),
                Rg(gbn(n.P)),
                Oh(T([
                    m("ProgressBarProgressing", i),
                    m("ProgressBarAnimated", o)
                ])),
                A2(ph, "width", mL(u) + "%")
            ]), g)
        ]));
    }, kbn = F7(function(n, r, t, e, u, a, o) {
        var c, s, f, l = function() {
            var n = u.sg;
            if (1 === n.$) return ih("");
            var r = n.a;
            return i(r.j0, Tt) ? i(r.lm, Tt) ? i(r.df, Tt) ? hbn({
                pj: kt(r.pj),
                P: 1
            }) : hbn({
                pj: kt(r.pj),
                P: 4
            }) : hbn({
                pj: kt(r.pj),
                P: 2
            }) : ih("");
        }(), d = A2(ju, !0, A2(Fu, function(n) {
            return !i(n.j0, Tt);
        }, u.sg)) ? A2(Le, T([
            Rg("MasterFilesDownload")
        ]), T([
            lB(!KY(u) && r || ten(e) ? p(oB, {
                lv: T([
                    A2(IB, "target", "_blank"),
                    A2(IB, "data-prevent-history", "true"),
                    Rg(a)
                ]),
                ml: kt(Nun),
                bf: !0,
                m6: pbn + " (" + Wq(u.qO) + ")",
                sn: kt(u.sn)
            }) : p(oB, {
                m6: Wq(u.qO)
            })),
            A3(vbn, t, u, e) ? lB(p(oB, {
                ml: kt(Th),
                m6: bbn,
                ox: kt(dbn(u.mm))
            })) : ih("")
        ])) : ih("");
        return A2(Le, T([
            Rg("MasterFilesAsset"),
            Oh(T([
                m("MasterFilesShowDesc", n)
            ]))
        ]), T([
            A2(Le, T([
                Rg("MasterFilesHeader")
            ]), T([
                A2(Le, T([
                    Rg("MasterFilesIcon")
                ]), T([
                    u.ml
                ])),
                A2(Dh, T([
                    Rg("MasterFilesTitle")
                ]), u.rS),
                l,
                d
            ])),
            u.kK.b ? A2(Le, T([
                Rg("MasterFilesDesc")
            ]), (c = Hdn(u.kK), s = c.a, f = c.b, T([
                Vdn(T([
                    jdn(A2(Ge, A2(bu, zdn, ih), s)),
                    Udn(A2(Ge, A2(bu, Edn, ih), f))
                ]))
            ]))) : ih(""),
            A2(Le, T([
                Rg("MasterFilesChildren")
            ]), u.jJ),
            o
        ]));
    }), Tbn = F2(function(n, r) {
        return r.$ ? n : kt(r.a);
    }), wbn = function(n) {
        var r = A2(fp, function(n) {
            return n.hV;
        }, Va(A2(Yc, Z1, n.av))), t = A2(fp, function(n) {
            return n.hV;
        }, Va(A2(zi, function(n) {
            return n.ft;
        }, A2(Yc, w2, n.av))));
        return A2(Tbn, r, A2(Tbn, t, A2(fp, function(n) {
            return n.hV;
        }, n.a6)));
    }, Cbn = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("MasterChild"),
            Rg(n)
        ]), T([
            A2(Le, T([
                Rg("MasterChildLabel")
            ]), r),
            A2(Le, T([
                Rg("MasterChildProgress")
            ]), t)
        ]));
    }), Nbn = F2(function(n, r) {
        return {
            $: 25,
            a: n,
            b: r
        };
    }), Abn = F2(function(n, r) {
        return A2(Nh, Din, A2(Nbn, n, r));
    }), Sbn = F2(function(n, r) {
        return {
            $: 21,
            a: n,
            b: r
        };
    }), Lbn = Oi({
        bN: "Pause",
        bT: "Pause"
    }), ybn = F2(function(n, r) {
        return A2(Nh, Lbn, A2(Sbn, n, r));
    }), Fbn = F3(function(n, r, t) {
        return {
            $: 23,
            a: n,
            b: r,
            c: t
        };
    }), jbn = Oi({
        bN: "Resume",
        bT: "Reprendre"
    }), Pbn = F3(function(n, r, t) {
        return A2(Nh, jbn, A3(Fbn, n, r, t));
    }), Ibn = F5(function(n, r, t, e, u) {
        if (!i(kt(n.dt), e.dt) && !i(u, ZV)) return T([
            A2(Abn, n, t)
        ]);
        switch(u.$){
            case 0:
                return T([
                    A2(ybn, n, t),
                    A2(Abn, n, t)
                ]);
            case 1:
            case 4:
            default:
                return g;
            case 2:
                return T([
                    A3(Pbn, n, r, t),
                    A2(Abn, n, t)
                ]);
            case 3:
                return T([
                    A2(Abn, n, t)
                ]);
        }
    }), Bbn = F3(function(n, r, t) {
        var e = t.sg;
        if (1 === e.$) return ih("");
        var u = e.a;
        return u.j0.$ ? A3(Cbn, "UploadChild", A5(Ibn, n.e$, r.g6.mm, t, u, A3(JV, t.mm, u, n._)), g) : ih("");
    }), Mbn = F4(function(n, r, t, e) {
        var u = e.lB, a = e.av, i = e.pl, o = function() {
            var n = i.nv;
            if (n.$) return !1;
            var r = A2(Fu, function(n) {
                return n.o1;
            }, n.a.r2);
            return !r.$ && 5 === r.a;
        }(), c = A5(Qdn, r, t.i4, A2(Yc, function(n) {
            if (1 === n.$) {
                var r = n.a;
                return kt({
                    cz: It(r.cz),
                    kK: T([
                        m("Codec", r.aE),
                        m(qmn, A2(ju, "?", A2(Fu, xmn, r.eS))),
                        m(Omn, It(r.cz)),
                        m("Start Timecode", A2(ju, "N/A", wbn(e)))
                    ]),
                    ml: Bmn,
                    ft: r.ft,
                    m2: u.mm + "/" + It(r.ft),
                    nc: r.aC,
                    rS: $(Mmn, A3(Ym, 2, "0", It(r.ft))),
                    r5: r.r5,
                    sv: r.sv
                });
            }
            return Tt;
        }, a), o, kt(b5(u.mm)));
        return A7(kbn, t.qD, A3(mbn, r.sp, r.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, r.fB)), t, r.sp, {
            jJ: T([
                A2(dk, JQ, c)
            ]),
            kK: g,
            ly: Tt,
            ml: Bmn,
            mm: u.mm,
            c$: u.c$,
            qO: u.qO,
            hs: u.hs,
            rS: u.n5,
            sg: u.sg,
            sn: Ao(ffn(u.mm))
        }, "audioFile", A3(Bbn, n, r, u));
    }), Obn = Oi({
        bN: "Audios alone",
        bT: "Audios seuls"
    }), qbn = function(n) {
        return qs(n.cI / n.cH * 100) / 100;
    }, Dbn = F2(function(n, r) {
        var t = r * n.at / n.as, e = fe(r), u = e * n.at / n.as, a = e % 60;
        return Dmn(e / 60 | 0) + " min " + Dmn(a) + " sec " + A3(Ym, 2, "0", It(qs(t - u))) + " frame(s)";
    }), xbn = function(n) {
        var r = n.eS;
        return r.$ ? "N/A" : A2(Dbn, n, r.a);
    }, Rbn = F3(function(n, r, t) {
        var e, u, a;
        return A2(Le, T([
            Rg("MasterFilesAsset"),
            Oh(T([
                m("MasterFilesShowDesc", n.qC)
            ]))
        ]), T([
            t,
            r.kK.b ? A2(Le, T([
                Rg("MasterFilesDesc")
            ]), (e = Hdn(r.kK), u = e.a, a = e.b, T([
                Vdn(T([
                    jdn(A2(Ge, A2(bu, zdn, ih), u)),
                    Udn(A2(Ge, A2(bu, Edn, ih), a))
                ]))
            ]))) : ih(""),
            n.qC ? A2(Le, T([
                Rg("MasterFilesChildren")
            ]), r.jJ) : ih("")
        ]));
    }), Vbn = function(n) {
        return f(n, 1e9) > -1 ? It(n / 1e9 | 0) + " Gbps" : f(n, 1e6) > -1 ? It(n / 1e6 | 0) + " Mbps" : 1e3 > n ? It(n) + " bps" : It(n / 1e3 | 0) + " kbps";
    }, Ebn = Oi({
        bN: "Level",
        bT: "Niveau"
    }), zbn = Oi({
        bN: "Quality",
        bT: "Qualit\xe9"
    }), Ubn = function(n) {
        var r = m(m(ten(n.sp), A2(jK, n.sp, n.g6.oL)), n.g6.c$);
        return !!r.a.a || !!r.a.b && 1 === r.b;
    }, Hbn = function(n) {
        return A3(mbn, n.sp, n.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, n.fB));
    }, Wbn = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M3,1 L11,1 L15,5 L15,17 L3,17 L3,1 Z M6,7 L6,13 L12,10 L6,7 Z")
        ]), g)
    ])), Qbn = F2(function(n, r) {
        return n.qC ? A2(Le, T([
            Rg("MasterFilesVideoStream")
        ]), T([
            A2(Le, T([
                Rg("MasterFilesHeader")
            ]), T([
                Wbn,
                A2(Dh, T([
                    Rg("MasterFilesTitle")
                ]), r.rS)
            ])),
            A2(Le, T([
                Rg("MasterFilesDesc")
            ]), function() {
                var n = Hdn(r.kK), t = n.a, e = n.b;
                return T([
                    Vdn(T([
                        jdn(A2(Ge, A2(bu, zdn, ih), t)),
                        Udn(A2(Ge, A2(bu, Edn, ih), e))
                    ]))
                ]);
            }())
        ])) : A2(Le, g, g);
    }), Zbn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Kbn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ybn = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Xbn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Jbn = function(n) {
        return A3(IK, n.sp, n.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, n.fB));
    }, Gbn = Oi({
        bN: "Upload was interrupted, re-upload exactly the same file to resume where it was.",
        bT: "L\u2019upload a \xe9t\xe9 interrompu, r\xe9-uploadez exactement le m\xeame fichier pour reprendre o\xf9 il en \xe9tait."
    }), _bn = Oi({
        bN: "Delete",
        bT: "Supprimer"
    }), npn = Oi({
        bN: "Download",
        bT: "T\xe9l\xe9charger"
    }), rpn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, tpn = Oi({
        bN: "Hide",
        bT: "Masquer"
    }), epn = Oi({
        bN: "Show",
        bT: "Montrer"
    }), upn = F3(function(n, r, t) {
        if (n.$) return " ";
        var e = n.a;
        return i(kt(e), t) || i(kt(e), r) ? tpn : epn;
    }), apn = F2(function(n, r) {
        return A2(fp, function(n) {
            var t = A2(fp, A2(bu, Fu(function(n) {
                return n.o1;
            }), function(n) {
                return n.r2;
            }), r);
            if (t.$ || 5 !== t.a) return Tt;
            switch(n.c$){
                case 0:
                    return kt(function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n.mm));
                case 3:
                    return kt(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n.mm));
                default:
                    return Tt;
            }
        }, r);
    }), ipn = function(n) {
        return A2(Kg, T([
            zg("18px"),
            Xg("18px"),
            Yg("0 0 18 18"),
            Pg("IconIcon18")
        ]), A2(dt, A2(Rrn, T([
            Pg("Bg"),
            zg("18"),
            Xg("18"),
            Vrn("0"),
            Ern("0")
        ]), g), n));
    }, opn = ipn(T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("6 5 12 9 6 13")
        ]), g)
    ])), cpn = F4(function(n, r, t, e) {
        var u, a = A2(apn, n, r), o = a.$ ? m(Tt, Tt) : 1 === a.a.$ ? i(kt(u = a.a.a), t) ? m(kt(rpn(Tt)), kt(u)) : m(kt(rpn(kt(u))), kt(u)) : m(kt(function(n) {
            return {
                $: 13,
                a: n
            };
        }(u = a.a.a)), kt(u)), c = o.a, s = o.b, f = lB(p(oB, {
            ml: kt(opn),
            m6: A3(upn, s, t, e),
            ox: c
        }));
        return 9 !== n.c$ || i(a, Tt) ? ih("") : f;
    }), spn = Oi({
        bN: "Error occurred while deleting file.",
        bT: "Une erreur est survenue lors de la suppression du fichier."
    }), fpn = Oi({
        bN: "Are you uploading from another tab or window? If not, you can re-upload exactly the same file to resume where it was.",
        bT: "Uploadez-vous depuis un autre onglet ou fen\xeatre? Si non, vous pouvez r\xe9-uploadez exactement le m\xeame fichier pour reprendre o\xf9 il en \xe9tait."
    }), lpn = function(n) {
        switch(n){
            case 3:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, mpn = A2(qt, F2(function(n, r) {
        if (1 === n.$) return r;
        var t = n.a;
        return 0 > f(lpn(t), lpn(r)) ? t : r;
    }), 0), dpn = function(n) {
        return A2(Le, T([
            Rg("LayoutSmallHeader")
        ]), T([
            bw(n)
        ]));
    }, bpn = F2(function(n, r) {
        var t = 1 === n.$ ? "FrameRate not defined. Unable to compute timecode for frame" + It(r.e7) : d4(A3(Js, mL(n.a), r.e7, !1));
        return A2(Fk, T([
            Rg("TranscodeWarning")
        ]), T([
            A2(uT, T([
                Rg("TranscodeWarningField")
            ]), T([
                ih(r.n5)
            ])),
            A2(uT, T([
                Rg("TranscodeWarningField")
            ]), T([
                ih(It(r.eB))
            ])),
            A2(uT, T([
                Rg("TranscodeWarningField")
            ]), T([
                ih(t)
            ]))
        ]));
    }), ppn = Oi({
        bN: "Count",
        bT: "Nombre total"
    }), vpn = Oi({
        bN: "First error at",
        bT: "Premiere erreur \xe0"
    }), $pn = Oi({
        bN: "Message",
        bT: "Message"
    }), gpn = F2(function(n, r) {
        var t = n.r2;
        if (1 === t.$) return ih("");
        var e = t.a.dO;
        return Cu(e) ? ih("") : A2(Le, T([
            Rg("FileOperationWarning")
        ]), T([
            dpn("Warnings"),
            Vdn($(T([
                jdn(T([
                    zdn(ih($pn)),
                    zdn(ih(ppn)),
                    zdn(ih(vpn))
                ]))
            ]), A2(Ge, bpn(r), e)))
        ]));
    }), hpn = Oi({
        bN: "Download ",
        bT: "T\xe9l\xe9charger "
    }), kpn = function(n) {
        var r = n.m6;
        return A2(aw, T([
            sw(n.sn),
            A2(IB, "target", "_blank"),
            A2(IB, "download", ""),
            A2(IB, "data-prevent-history", "true"),
            Rg("ReportLinksButton")
        ]), T([
            A2(Le, T([
                Rg("ReportLinksIcon")
            ]), T([
                Nun
            ])),
            A2(Dh, T([
                Rg("ReportLinksLabel")
            ]), r)
        ]));
    }, Tpn = function(n) {
        var r = d(ten(n.sp), A2(jK, n.sp, n.g6.oL) || A3(mbn, n.sp, n.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, n.fB)), n.g6.c$);
        return !!r.a || !(!r.b || 1 !== r.c);
    }, wpn = function(n) {
        return A2(Le, T([
            Rg("LayoutSubHeader")
        ]), T([
            HV(n)
        ]));
    }, Cpn = Oi({
        bN: "Summary automated analysis",
        bT: "R\xe9sum\xe9 analyse automatique"
    }), Npn = function(n) {
        return n ? "\u2714" : "\u2716";
    }, Apn = ju("unknown"), Spn = F3(function(n, r, t) {
        return A2(n, t, r);
    }), Lpn = kj, ypn = F2(function(n, r) {
        return A2(Lpn, ih(n), ih(r));
    }), Fpn = kj, jpn = F2(function(n, r) {
        return A2(Fpn, ih(n), ih(r));
    }), Ppn = F2(function(n, r) {
        return A2(Kq, ih(n), ih(r));
    }), Ipn = Oi({
        bN: "Unavailable information",
        bT: "Informations indisponibles"
    }), Bpn = Idn(Ipn), Mpn = function(n) {
        var r, t = (r = n.b0).$ ? Tt : kt(r.a), e = Apn(A2(Fu, A2(Spn, jt, " LUFS"), A2(fp, function(n) {
            return n.gE;
        }, t))), u = A2(ju, ih("unknown"), A2(Fu, function(n) {
            return A2(Le, g, A2(dt, A2(jpn, "channel", "value"), A2(Ge, function(n) {
                return A2(ypn, n.m6, n.h3 + " DbTP");
            }, n)));
        }, A2(Fu, function(n) {
            return n.cz;
        }, t))), a = Apn(A2(Fu, A2(Spn, jt, " LU"), A2(fp, function(n) {
            return n.ns;
        }, t))), i = Apn(A2(Fu, Npn, A2(Fu, function(n) {
            return n.fD;
        }, t)));
        return A2(dt, A2(Ppn, "Type (ID-Parent)", n.n5 + " (" + n.mm + "-" + n.gn + ")"), T(t.$ ? [
            Bpn
        ] : [
            A2(wj, "Mute track ?", i),
            A2(wj, "Program Loudness EBU", e),
            A2(wj, "Loudness Range EBU", a),
            A2(Tj, ih("True Peak EBU"), u)
        ]));
    }, Opn = function(n) {
        var r, t = (r = n, _I(A2(U$, F2(function(n, r) {
            return !r.b0.$;
        }), r.av)));
        return A2(Le, g, A2(dt, dpn("Audio Streams"), A3(Je, jt, g, A2(Ge, Mpn, A2(zi, function(n) {
            return A2(ju, 0, ze(n.mm));
        }, t)))));
    }, qpn = function(n) {
        var r = A2(ju, tV, A2(fp, function(n) {
            var r = n.b0;
            return 2 === r.$ ? kt(r.a) : Tt;
        }, A2(lo, "0", n.av)));
        return A2(Le, g, A2(dt, dpn("Container"), function() {
            switch(r.$){
                case 1:
                    return function(n) {
                        return T([
                            A2(wj, "Format", "MOV"),
                            A2(wj, "Duration SMPTE", Apn(n.eS)),
                            A2(wj, "Start timecode", Apn(n.q4))
                        ]);
                    }(r.a);
                case 0:
                    return function(n) {
                        return T([
                            A2(wj, "Duration SMPTE (source package TC)", Apn(n.hU.eS)),
                            A2(wj, "Format & Pattern", "MXF " + A2(ju, "(unknown pattern)", n.gi)),
                            A2(wj, "Product Name & Version", A2(ju, "(unknown product)", n.gA.n5) + " " + A2(ju, "(unknown version)", n.gA.sv)),
                            A2(wj, "Company Name", Apn(n.gA.fF)),
                            A2(Ppn, "Item", "Start timecode"),
                            A2(wj, "Source package", Apn(n.hU.hg)),
                            A2(wj, "Material package", Apn(n.hU.fZ)),
                            A2(wj, "System item", Apn(n.hU.hJ)),
                            A2(wj, "VITC presence", Apn(n.hU.fj))
                        ]);
                    }(r.a);
                default:
                    return T([
                        Bpn
                    ]);
            }
        }()));
    }, Dpn = function(n) {
        return A2(Le, g, T([
            dpn("Content summary"),
            Vdn($(T([
                jdn(T([
                    zdn(ih("Name")),
                    Edn(ih("ID")),
                    Edn(ih("Parent"))
                ]))
            ]), A2(Ge, function(n) {
                return Udn(T([
                    zdn(ih(n.n5)),
                    Edn(ih(n.mm)),
                    Edn(ih(n.gn))
                ]));
            }, A2(zi, function(n) {
                return A2(ju, 0, ze(n.mm));
            }, A2(Iu, function(n) {
                return 2 !== n.b0.$;
            }, _I(n.av))))))
        ]));
    }, xpn = function(n) {
        var r, t = Va((r = n, _I(A2(U$, F2(function(n, r) {
            return 1 === r.b0.$;
        }), r.av)))), e = A2(fp, function(n) {
            var r = n.b0;
            return 1 === r.$ ? kt(r.a) : Tt;
        }, t), u = m(t, e);
        if (u.a.$ || u.b.$) return A2(Le, g, T([
            Bpn
        ]));
        var a = u.a.a, i = u.b.a;
        return A2(Le, g, T([
            dpn("Video Stream"),
            A2(Ppn, "Type (ID-Parent)", a.n5 + " (" + a.mm + "-" + a.gn + ")"),
            A2(wj, "Chroma format", Apn(i.es)),
            A2(wj, "Frame rate", Apn(i.lU)),
            A2(wj, "Scanning type", Apn(i.gY)),
            A2(wj, "Cadence", Apn(i.en)),
            A2(wj, "Active pixels", Apn(i.dV)),
            A2(wj, "Display Aspect Ratio", Apn(i.eQ))
        ]));
    }, Rpn = function(n) {
        return A2(Le, g, T([
            wpn(Cpn),
            qpn(n),
            Dpn(n),
            xpn(n),
            Opn(n)
        ]));
    }, Vpn = Oi({
        bN: "Critical errors reported by automated analysis",
        bT: "Erreurs critiques relev\xe9es par l'analyse automatique"
    }), Epn = F2(function(n, r) {
        return n + " (" + r + ")";
    }), zpn = Oi({
        bN: "Crit\xe8re d\u2019analyse",
        bT: "Crit\xe8re d\u2019analyse"
    }), Upn = Oi({
        bN: " Specified criteria: ",
        bT: " Specified criteria: "
    }), Hpn = Se("tbody"), Wpn = Hpn(g), Qpn = Oi({
        bN: "Localization",
        bT: "Localisation"
    }), Zpn = Se("code"), Kpn = dw(Zpn), Ypn = F2(function(n, r) {
        var t, e, u = (e = m(r.u.hT, r.u.e_)).a.$ ? Tt : kt(1 === e.b.$ ? e.a.a : e.a.a + " - " + e.b.a), a = A2(ju, A2(ju, "", r.u.er), r.u.mm), i = (t = A2(Mt, Upn, r.u.kL)).b && t.b.b && !t.b.b.b ? m(t.a, kt(t.b.a)) : m(r.u.kL, Tt), o = i.a, c = i.b;
        return Wpn($(T([
            jdn(T([
                zdn(ih(a)),
                Edn(ih(o))
            ]))
        ]), $(function() {
            if (1 === u.$) return g;
            var n = u.a;
            return T([
                Udn(T([
                    zdn(ih(Qpn)),
                    Edn(Kpn(n))
                ]))
            ]);
        }(), function() {
            if (1 === c.$) return g;
            var n = c.a;
            return T([
                Udn(T([
                    zdn(ih(zpn)),
                    Edn(Kpn(n))
                ]))
            ]);
        }())));
    }), Xpn = F3(function(n, r, t) {
        var e = n(t);
        if (e.b) {
            var u = e;
            return kt(A2(lE, g, T([
                dpn(t.n5 + " (" + t.mm + "-" + t.gn + ")"),
                Vdn(A2(Ge, Ypn(r), u))
            ])));
        }
        return Tt;
    }), Jpn = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("ReportSection")
        ]), T([
            wpn(t),
            A2(sE, g, A2(Yc, Ie, A2(Ge, A2(Xpn, r, e), _I(n.av))))
        ]));
    }), Gpn = function(n) {
        var r = It(Dt(A2(Gu, function(n) {
            return n.bY.ln;
        }, _I(n.av))));
        return A4(Jpn, n, function(n) {
            return n.bY.ln;
        }, A2(Epn, Vpn, r), "red");
    }, _pn = Oi({
        bN: "File summary",
        bT: "R\xe9sum\xe9 fichier"
    }), nvn = A2(bu, St, rd), rvn = F2(function(n, r) {
        var t = Apn(A2(fp, A2(bu, Tx, nvn), n.lB.fL)), e = Apn(A2(Fu, Wq, n.lB.qO));
        return A2(Le, g, T([
            A2(wj, "File name", r.n5),
            A2(wj, "Modification date", t),
            A2(wj, "File size", e)
        ]));
    }), tvn = F2(function(n, r) {
        return A2(Le, T([
            Rg("ReportSection")
        ]), T([
            wpn(_pn),
            A2(rvn, n, r)
        ]));
    }), evn = Oi({
        bN: "Download the full report (",
        bT: "T\xe9l\xe9charger le rapport complet ("
    }), uvn = F3(function(n, r, t) {
        return 1 === t.$ ? ih("") : kpn({
            m6: evn + (r + ")"),
            sn: Ao(ffn(t.a.mm))
        });
    }), avn = Oi({
        bN: "Warnings reported by automated analysis",
        bT: "Signalements relev\xe9s par l'analyse automatique"
    }), ivn = function(n) {
        var r = It(Dt(A2(Gu, function(n) {
            return n.bY.dP;
        }, _I(n.av))));
        return A4(Jpn, n, function(n) {
            return n.bY.dP;
        }, A2(Epn, avn, r), "orange");
    }, ovn = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("ReportWrapper")
        ]), T([
            A2(Le, T([
                Rg("ReportLinks")
            ]), T([
                A3(uvn, r, "xml", e.gN),
                A3(uvn, r, "pdf", e.gM),
                Tpn(n) ? kpn({
                    m6: hpn + (e.lB.n5 + " (") + Wq(e.lB.qO) + ")",
                    sn: Ao(ffn(e.lB.mm))
                }) : ih("")
            ])),
            A2(tvn, t, e.lB),
            A2(yF, g, g),
            Rpn(t),
            A2(yF, g, g),
            Gpn(t),
            A2(yF, g, g),
            ivn(t)
        ]));
    }), cvn = F3(function(n, r) {
        var t = r.bQ.fY;
        if (1 === t.$) return ih("");
        var e = t.a, u = A2(fp, function(n) {
            return n.bl;
        }, e.lB.su);
        if (1 === u.$) return ih("");
        var a = u.a.b9;
        return 1 === a.$ ? ih("") : A4(ovn, n, r, a.a, e);
    }), svn = {
        $: 0
    }, fvn = Oi({
        bN: "Processing - downloading stage",
        bT: "En traitement - phase de t\xe9l\xe9chargement"
    }), lvn = Oi({
        bN: "Processing - encoding stage",
        bT: "En traitement - phase d'encodage"
    }), mvn = Oi({
        bN: "Finished",
        bT: "Termin\xe9"
    }), dvn = Oi({
        bN: "Processing - packaging stage",
        bT: "En traitement - phase de packaging"
    }), bvn = Oi({
        bN: "Processing - uploading stage",
        bT: "En traitement - phase d'upload"
    }), pvn = Oi({
        bN: "Processing - waiting stage",
        bT: "En traitement - phase d'attente"
    }), vvn = function(n) {
        switch(n){
            case 0:
                return pvn;
            case 1:
                return fvn;
            case 2:
                return lvn;
            case 3:
                return dvn;
            case 4:
                return bvn;
            default:
                return mvn;
        }
    }, $vn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), gvn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hvn = F2(function(n, r) {
        return A2(ju, gvn(n), A2(Fu, function(r) {
            return A2($vn, n, r);
        }, r));
    }), kvn = Oi({
        bN: "Done",
        bT: "Termin\xe9"
    }), Tvn = function(n) {
        var r = n.dO, t = !!n.pj.$, e = function() {
            var r = n.pj;
            switch(r.$){
                case 0:
                    return kvn;
                case 1:
                    return (t = r.a) + "...";
                default:
                    var t, e = r.b;
                    return "" === (t = r.a) ? QV(e) : t + " : " + QV(e);
            }
        }(), u = !i(n.lm, Tt), a = A2(ju, u ? 2 : t ? 1 : r ? 3 : 5, n.I);
        return m(kt(t ? 3 : u ? 1 : r ? 2 : 0), A2(Le, T([
            Rg("FileOperation")
        ]), T([
            A2(Le, T([
                Rg("FileOperationSummary")
            ]), T([
                A2(Le, T([
                    Rg("FileOperationIcon")
                ]), T([
                    i(n.eP, Tt) ? Oun : qun
                ])),
                A2(Le, T([
                    Rg("FileOperationIcon")
                ]), T([
                    n.ml
                ])),
                A2(Le, T([
                    Rg("FileOperationLabel")
                ]), T([
                    A2(Dh, T([
                        Rg("FileOperationLabelTitle")
                    ]), n.m6),
                    A2(Dh, T([
                        Rg("FileOperationLabelProgress")
                    ]), " (" + e + ")")
                ])),
                A2(Le, T([
                    Rg("FileOperationProgress")
                ]), T([
                    hbn({
                        pj: function() {
                            var r = n.pj;
                            switch(r.$){
                                case 0:
                                    return kt(1);
                                case 2:
                                    return kt(r.b);
                                default:
                                    return Tt;
                            }
                        }(),
                        P: a
                    })
                ]))
            ])),
            function() {
                var r = n.lm;
                if (r.$) {
                    var t = n.eP;
                    if (1 === t.$) return ih("");
                    var e = t.a;
                    return A2(Le, T([
                        Rg("FileOperationDetails")
                    ]), T([
                        A2(mh, T([
                            Rg("FileOperationDetailsLabel")
                        ]), T([
                            e.m6
                        ])),
                        Cu(e.dU) ? ih("") : A2(Le, T([
                            Rg("FileOperationDetailsActions")
                        ]), e.dU)
                    ]));
                }
                var u = r.a;
                return A2(Le, T([
                    Rg("FileOperationDetails")
                ]), T([
                    A2(Dh, T([
                        Rg("FileOperationDetailsLabel")
                    ]), u)
                ]));
            }()
        ])));
    }, wvn = F2(function(n, r) {
        if (1 === r.$) return m(Tt, ih(""));
        var t = r.a.r2;
        if (1 === t.$) return m(Tt, ih(""));
        var e = t.a.o1, u = t.a.pj, a = t.a.dO;
        return Tvn(5 === e ? {
            eP: Tt,
            lm: Tt,
            ml: ih(""),
            m6: n,
            pj: svn,
            I: Tt,
            dO: !Cu(a)
        } : {
            eP: Tt,
            lm: Tt,
            ml: ih(""),
            m6: n,
            pj: A2(hvn, vvn(e), u),
            I: Tt,
            dO: !1
        });
    }), Cvn = Oi({
        bN: "Processing",
        bT: "G\xe9n\xe9ration"
    }), Nvn = F2(function(n, r) {
        return A3(Se, "format-distance", T([
            A2(IB, "startdate", rd(n)),
            A2(IB, "enddate", rd(r))
        ]), T([
            ih("...")
        ]));
    }), Avn = Oi({
        bN: "Duration: ",
        bT: "Dur\xe9e : "
    }), Svn = F2(function(n, r) {
        return A2(ju, gvn(n), A2(Fu, function(r) {
            return 1 > r ? A2($vn, n, r) : svn;
        }, r));
    }), Lvn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), yvn = Oi({
        bN: "Cancel",
        bT: "Annuler"
    }), Fvn = F2(function(n, r) {
        return A2(Nh, yvn, A2(Lvn, n, r));
    }), jvn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Pvn = Oi({
        bN: "Pause",
        bT: "Pause"
    }), Ivn = F2(function(n, r) {
        return A2(Nh, Pvn, A2(jvn, n, r));
    }), Bvn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), Mvn = Oi({
        bN: "Resume",
        bT: "Reprendre"
    }), Ovn = F3(function(n, r, t) {
        return A2(Nh, Mvn, A3(Bvn, n, r, t));
    }), qvn = F5(function(n, r, t, e, u) {
        if (!i(kt(n.dt), e.dt)) return T([
            A2(Fvn, n, t)
        ]);
        switch(u.$){
            case 0:
                return T([
                    A2(Ivn, n, t),
                    A2(Fvn, n, t)
                ]);
            case 1:
            case 4:
            default:
                return g;
            case 2:
                return T([
                    A3(Ovn, n, r, t),
                    A2(Fvn, n, t)
                ]);
            case 3:
                return T([
                    A2(Fvn, n, t)
                ]);
        }
    }), Dvn = F2(function(n, r) {
        var t = r.h6;
        if (t.$) {
            var e = r.sg;
            if (1 === e.$) return m(Tt, ih(""));
            var u = e.a, a = A3(JV, r.mm, u, n._), o = kt(A2(ju, u.pj, Va(A2(Yc, function(n) {
                return i(r.mm, n.z) ? kt(n.pj) : Tt;
            }, n._)))), c = function() {
                switch(a.$){
                    case 0:
                    case 4:
                        return m(Tt, kt(aE(a)));
                    case 1:
                    case 2:
                        return m(kt(4), kt(aE(a)));
                    case 3:
                        return m(kt(0), kt(aE(a)));
                    default:
                        return m(Tt, Tt);
                }
            }(), s = c.a, f = c.b;
            return Tvn({
                eP: function() {
                    if (1 === f.$) return Tt;
                    var t = f.a;
                    return kt({
                        dU: A5(qvn, n.e$, n.g6.mm, r, u, a),
                        m6: ih(t)
                    });
                }(),
                lm: u.lm,
                ml: ih(""),
                m6: "Upload",
                pj: A2(Svn, "", o),
                I: s,
                dO: !1
            });
        }
        var l = t.a;
        return Tvn({
            eP: kt({
                dU: g,
                m6: A2(mh, g, T([
                    ih(Avn),
                    A2(Nvn, r.kg, l)
                ]))
            }),
            lm: Tt,
            ml: ih(""),
            m6: "Upload",
            pj: svn,
            I: Tt,
            dO: !1
        });
    }), xvn = Oi({
        bN: " errors and ",
        bT: " erreurs et "
    }), Rvn = Oi({
        bN: "Nothing to report",
        bT: "Rien \xe0 signaler"
    }), Vvn = Oi({
        bN: "Automated analysis",
        bT: "Analyse automatique"
    }), Evn = Oi({
        bN: "Unable to generate the verification report: ",
        bT: "Impossible de g\xe9n\xe9rer le rapport de v\xe9rification : "
    }), zvn = Oi({
        bN: " warnings.",
        bT: " avertissements."
    }), Uvn = F7(function(n, r, t, e, u, a, o) {
        var c, s, f, l = function() {
            var r = o.lB.sg;
            if (1 === r.$) return !1;
            var t = r.a;
            return i(kt(n.sp.mm), o.lB.si) && A2(vu, function(n) {
                return !i(n.z, o.lB.mm);
            }, n._) && function() {
                switch(A3(JV, o.lB.mm, t, n._).$){
                    case 2:
                    case 3:
                    case 0:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }();
        }(), b = function() {
            var r = o.lB.sg;
            if (1 === r.$) return !1;
            var t = r.a;
            return i(kt(n.sp.mm), o.lB.si) && function() {
                switch(A3(JV, o.lB.mm, t, n._).$){
                    case 2:
                    case 3:
                        return i(n._, g);
                    default:
                        return !1;
                }
            }();
        }(), v = function(n) {
            var r = n.su;
            if (1 === r.$) return m(Tt, ih(""));
            var t = r.a, e = function() {
                var n = t.bl;
                if (1 === n.$) {
                    var r = t.lm;
                    return 1 === r.$ ? d(A2($vn, "", t.pj), Tt, Tt) : d(svn, kt($(Evn, r.a)), kt({
                        dU: g,
                        m6: ih(Rvn)
                    }));
                }
                var e, u = n.a;
                return d(svn, u.n7 > 0 ? kt($(It(u.n7), $(xvn, $(It(u.aq), zvn)))) : Tt, (e = u.aq > 0 ? $(It(u.aq), zvn) : Rvn, kt({
                    dU: g,
                    m6: ih(e)
                })));
            }(), u = e.a;
            return Tvn({
                eP: e.c,
                lm: e.b,
                ml: ih(""),
                m6: Vvn,
                pj: u,
                I: Tt,
                dO: !1
            });
        }(o.lB), h = v.a, k = v.b, w = A2(Dvn, n, o.lB), C = w.a, N = w.b, A = A2(wvn, "Proxy", o.pl.nv), S = A.a, L = A.b, y = A2(wvn, "Proxy (hi-res)", o.pl.fm), F = y.a, j = y.b, P = function(n) {
            var r = n.r2;
            if (1 === r.$) return m(Tt, ih(""));
            var t = r.a.pj, e = r.a.o1;
            return Tvn(5 === e ? {
                eP: Tt,
                lm: Tt,
                ml: ih(""),
                m6: Cvn,
                pj: svn,
                I: Tt,
                dO: !1
            } : {
                eP: Tt,
                lm: Tt,
                ml: ih(""),
                m6: Cvn,
                pj: A2(hvn, vvn(e), t),
                I: Tt,
                dO: !1
            });
        }(o.lB), I = P.b, B = mpn(T([
            P.a,
            h,
            S,
            F,
            C
        ])), M = 3 !== B && A2(ju, i(o.lB.si, Tt), A2(Fu, function(n) {
            return !i(n.j0, Tt);
        }, o.lB.sg)), O = !!B || A2(fX, o.lB.mm, t.oD), q = function() {
            switch(B){
                case 3:
                    return "FileStatusOperation";
                case 1:
                    return "FileStatusFailure";
                case 2:
                    return "FileStatusWarning";
                default:
                    return "FileStatusSuccess";
            }
        }();
        return A2(Le, T([
            Rg("FileItem")
        ]), T([
            A2(Le, T([
                Rg("FileStatus"),
                Rg(q)
            ]), g),
            A2(Le, T([
                Rg("FileContent")
            ]), A2(dt, A2(Le, T([
                Rg("FileDescription")
            ]), T([
                A2(Le, T([
                    Rg("FileDescriptionTitle")
                ]), T([
                    A2(Le, T([
                        wh(Kbn(o.lB.mm)),
                        Rg("FileTitle")
                    ]), T([
                        O ? Oun : qun,
                        A2(Dh, T([
                            Rg("FileDescriptionTitleName")
                        ]), o.lB.n5)
                    ])),
                    A4(cpn, o.lB, o.pl.nv, u, a),
                    e && 9 === o.lB.c$ ? lB(p(oB, {
                        ml: kt(Th),
                        m6: _bn,
                        ox: kt(Zbn(o.lB.mm))
                    })) : ih(""),
                    M && (e && aen(o.lB) || ten(n.sp) && 9 === o.lB.c$) ? lB(p(oB, {
                        lv: T([
                            A2(IB, "target", "_blank"),
                            A2(IB, "data-prevent-history", "true"),
                            Rg("masterFile")
                        ]),
                        ml: kt(Nun),
                        bf: !0,
                        m6: npn + " (" + Wq(o.lB.qO) + ")",
                        sn: kt(Ao(ffn(o.lB.mm)))
                    })) : ih("")
                ])),
                A2(Le, T([
                    Rg("FileDescriptionDetails")
                ]), T([
                    (f = hfn(o.lB), ih(1 === f.$ ? "" : dfn(f.a) + " - ")),
                    ih(lfn(o.lB.qO)),
                    ih(" "),
                    BN(o.lB.kg)
                ]))
            ])), O ? T([
                I,
                Jbn(n) ? A2(Le, T([
                    wh(Xbn(o.lB))
                ]), T([
                    k
                ])) : ih(""),
                (s = A2(lo, o.lB.mm, t.pF), s.$ ? ih("") : s.a && i(kt(o.lB.mm), A2(Fu, function(n) {
                    return n.lB.mm;
                }, r.bQ.fY)) ? A3(cvn, n, r, {}) : ih("")),
                (c = o.pl.nv, 1 === c.$ ? ih("") : A2(Le, T([
                    wh(A2(Ybn, c.a.mm, "lowRes"))
                ]), T([
                    L
                ]))),
                function() {
                    var n = o.pl.nv;
                    if (1 === n.$) return ih("");
                    var r = n.a, e = A2(lo, r.mm + "-lowRes", t.pm);
                    return e.$ ? ih("") : e.a ? A2(gpn, r, Sfn(o)) : ih("");
                }(),
                function() {
                    if (n.sp.iw) {
                        var r = o.pl.fm;
                        return 1 === r.$ ? ih("") : A2(Le, T([
                            wh(A2(Ybn, r.a.mm, "hiRes"))
                        ]), T([
                            j
                        ]));
                    }
                    return ih("");
                }(),
                function() {
                    var n = o.pl.fm;
                    if (1 === n.$) return ih("");
                    var r = n.a, e = A2(lo, r.mm + "-hiRes", t.pm);
                    return e.$ ? ih("") : e.a ? A2(gpn, r, Sfn(o)) : ih("");
                }(),
                N,
                function() {
                    if (b) return j7(Gbn);
                    if (l) return j7(fpn);
                    if (A2(LM, o.lB.mm, t.ln)) {
                        var n = A2(lo, o.lB.mm, t.ln);
                        return fT(1 === n.$ ? spn : n.a);
                    }
                    return ih("");
                }()
            ]) : g))
        ]));
    }), Hvn = F5(function(n, r, t, e, u) {
        var a, i = t.lB, o = t.av, c = 1 === (a = A2(Fu, function(n) {
            return n.e9;
        }, t.a6)).$ ? "?" : a.a, s = p(r.i4, {
            eY: !1
        }), f = A3(qt, F2(function(n, r) {
            var t = r.a, e = r.b, u = r.c;
            switch(n.$){
                case 0:
                    return d(A2(dt, n.a, t), e, u);
                case 1:
                    return d(t, A2(dt, n.a, e), u);
                default:
                    return d(t, e, u);
            }
        }), d(g, g, g), o), l = f.a, b = A2(Ge, function(n) {
            var r, t, e, u = 1 === (r = n.gY).$ ? "" : A2(Ee, 1, r.a), a = 1 === (t = n.ne).$ ? "N/A" : It(t.a), i = 1 === (e = n.cA).$ ? "" : " (" + e.a + ")", o = "@" + A2(ju, "N/A", A2(Fu, Vbn, n.ah));
            return {
                kK: T([
                    m("Codec", n.aE),
                    m(qmn, xbn(n)),
                    m(zbn, It(n.id) + "x" + (It(n.fk) + (o + i))),
                    m("Framerate", $(mL(_1(n)), u)),
                    m(Ebn, a),
                    m("Profil", A2(ju, "N/A", n.gD)),
                    m("Aspect Ratio", mL(qbn(n)) + ":1")
                ]),
                ml: Wbn,
                rS: "video stream " + A3(Ym, 2, "0", It(n.ft))
            };
        }, l);
        return A3(Rbn, r, {
            jJ: $(A2(Ge, Qbn(r), b), T([
                A2(dk, JQ, A5(Qdn, n, s, e, !1, kt(s5(-1))))
            ])),
            kK: T([
                m("Type", c),
                m(qmn, A2(ju, "N/A", A2(Fu, xbn, Va(l)))),
                m("Start Timecode", A2(ju, "N/A", wbn(t)))
            ]),
            ly: Tt,
            ml: Wbn,
            mm: i.mm,
            c$: i.c$,
            qO: i.qO,
            hs: i.hs,
            rS: i.n5,
            sg: i.sg,
            sn: Ao(ffn(i.mm))
        }, function() {
            var t = u.bQ.fY;
            if (t.$) return ih("");
            var e = t.a;
            return A2(dk, k1, A7(Uvn, n, u, r.bQ, Ubn(n) || Hbn(n), Tt, Tt, e));
        }());
    }), Wvn = Oi({
        bN: "Main file",
        bT: "Fichier principal"
    }), Qvn = Oi({
        bN: "Download all",
        bT: "Tout t\xe9l\xe9charger"
    }), Zvn = Oi({
        bN: "Hide details",
        bT: "Masquer les d\xe9tails"
    }), Kvn = Oi({
        bN: "Show details",
        bT: "Afficher les d\xe9tails"
    }), Yvn = function(n) {
        return kC(hC(n));
    }, Xvn = Oi({
        bN: "subtitles",
        bT: "Sous-titres"
    }), Jvn = function(n) {
        return {
            $: 31,
            a: n
        };
    }, Gvn = Oi({
        bN: "Hide",
        bT: "Masquer"
    }), _vn = Oi({
        bN: "Show",
        bT: "Afficher"
    }), n$n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, r$n = Oi({
        bN: "Subtitle analysis",
        bT: "Analyse des sous-titres"
    }), t$n = F2(function(n, r) {
        var t, e, u = Tvn({
            eP: Tt,
            lm: Tt,
            ml: ih(""),
            m6: r$n,
            pj: svn,
            I: Tt,
            dO: !Cu(r.hE)
        }), a = u.b, i = mpn(T([
            u.a
        ])), o = function() {
            switch(i){
                case 3:
                    return "FileStatusOperation";
                case 1:
                    return "FileStatusFailure";
                case 2:
                    return "FileStatusWarning";
                default:
                    return "FileStatusSuccess";
            }
        }();
        return A2(Le, T([
            Rg("FileItem")
        ]), T([
            A2(Le, T([
                Rg("FileStatus"),
                Rg(o)
            ]), g),
            A2(Le, T([
                Rg("FileContent")
            ]), T([
                A2(Le, T([
                    wh(n$n(r.lB))
                ]), T([
                    a
                ])),
                (e = A2(lo, r.lB.mm, n.hE), e.$ ? ih("") : e.a ? Cu((t = r).hE) ? ih("") : A2(Le, T([
                    Rg("FileOperationWarning")
                ]), T([
                    dpn("Warnings"),
                    Vdn($(T([
                        jdn(T([
                            zdn(ih("Warning")),
                            zdn(ih("Timecode"))
                        ]))
                    ]), A2(Ge, function(n) {
                        return A2(Fk, T([
                            Rg("TranscodeWarning")
                        ]), T([
                            A2(uT, T([
                                Rg("TranscodeWarningField")
                            ]), T([
                                ih(n.n5)
                            ])),
                            A2(uT, T([
                                Rg("TranscodeWarningField")
                            ]), T([
                                ih(n.hV)
                            ]))
                        ]));
                    }, t.hE)))
                ])) : ih(""))
            ]))
        ]));
    }), e$n = F4(function(n, r, t, e) {
        var u, a, o, c, s = A2(Fu, YT, e.sv), f = A2(Fu, qF, e.r5);
        return A2(Le, T([
            Rg("MasterFilesAudioStream")
        ]), T([
            A2(Le, T([
                Rg("MasterFilesHeader")
            ]), T([
                Vmn,
                A2(Dh, T([
                    Rg("MasterFilesTitle")
                ]), e.rS),
                A2(Le, T([
                    Rg("MasterQualify")
                ]), T([
                    A2(wT, Dh(T([
                        Rg("MasterQualifyItem")
                    ])), s),
                    A2(wT, Dh(T([
                        Rg("MasterQualifyItem")
                    ])), f),
                    A2(Le, T([
                        Rg("PlayAudio")
                    ]), T([
                        5 === e.o1 ? lB(p(oB, {
                            ml: kt(opn),
                            m6: function() {
                                var n = r.o2;
                                return n.$ ? _vn : i(n.a.ro, e.gI) ? Gvn : _vn;
                            }(),
                            ox: kt(Jvn((c = r.o2, c.$ ? e.gI : i(c.a.ro, e.gI) ? Tt : e.gI)))
                        })) : ih("")
                    ]))
                ]))
            ])),
            A2(FF, !Cu(t.hE), A2(Le, T([
                Rg("MasterFilesAsset")
            ]), T([
                A2(dk, k1, A2(t$n, r.bQ, t))
            ]))),
            A2(Le, T([
                Rg("MasterFilesDesc")
            ]), (u = Hdn(e.kK), a = u.a, o = u.b, T([
                Vdn(T([
                    jdn(A2(Ge, A2(bu, zdn, ih), a)),
                    Udn(A2(Ge, A2(bu, Edn, ih), o))
                ]))
            ])))
        ]));
    }), u$n = F3(function(n, r, t) {
        var e, u, a = t.lB, i = t.av, o = t.pl, c = A2(fp, function(n) {
            return 2 === n.$ ? n.a.sv : Tt;
        }, Va(i)), s = A2(fp, function(n) {
            return 2 === n.$ ? n.a.r5 : Tt;
        }, Va(i)), f = A2(ju, {
            e6: Tt,
            lU: Tt,
            fK: Tt,
            q4: Tt,
            hB: Tt
        }, A2(Fu, function(n) {
            if (2 === n.$) {
                var r = n.a;
                return {
                    e6: r.e6,
                    lU: A3(NL, F2(function(n, r) {
                        return qs(1e3 * n / r) / 1e3;
                    }), r.fd, r.fc),
                    fK: r.fK,
                    q4: r.q4,
                    hB: r.hB
                };
            }
            return {
                e6: Tt,
                lU: Tt,
                fK: Tt,
                q4: Tt,
                hB: Tt
            };
        }, Va(i))), l = f.lU, d = f.q4, b = f.e6, p = f.fK, v = f.hB, $ = 1 === (e = A2(Fu, function(n) {
            return n.e9;
        }, t.a6)).$ ? A2(ju, "?", v) : e.a, h = (u = A2(Fu, function(e) {
            var u;
            return A4(e$n, n, r, t, {
                kK: T([
                    m("Type", $),
                    m("Framerate", A2(ju, "N/A", A2(Fu, mL, l))),
                    m("Start Timecode", A2(ju, "N/A", d)),
                    m("First Subtitle Timecode", A2(ju, "N/A", b)),
                    m("Last Subtitle Timecode", A2(ju, "N/A", p))
                ]),
                ml: Vmn,
                m2: a.mm,
                o1: (u = e.r2, u.$ ? 0 : u.a.o1),
                gI: A2(Fu, function(n) {
                    return n.mm;
                }, o.nv),
                rS: Xvn,
                r5: s,
                sv: c
            });
        }, o.nv)).$ ? g : Ua(u.a);
        return A7(kbn, r.qE, A3(mbn, n.sp, n.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, n.fB)), r, n.sp, {
            jJ: h,
            kK: g,
            ly: Tt,
            ml: Bmn,
            mm: a.mm,
            c$: a.c$,
            qO: a.qO,
            hs: a.hs,
            rS: a.n5,
            sg: a.sg,
            sn: Ao(ffn(a.mm))
        }, "subtitleFile", ih(""));
    }), a$n = F5(function(n, r, t, e, u) {
        var a = A2(Yvn, A2(No, function(n) {
            return n.lB;
        }, function(n) {
            return n.n5;
        }), u.bQ.ad), o = A2(Yvn, A2(No, function(n) {
            return n.lB;
        }, function(n) {
            return n.n5;
        }), u.bQ.d6), c = Ubn(t) || Hbn(t);
        return A2(Le, T([
            Rg("MasterFilesWrapper")
        ]), T([
            A2(obn, !i(u.bQ.fY, Tt), A2(Le, T([
                Rg("ReversedLayout")
            ]), T([
                Yq(Wvn),
                lB(p(oB, {
                    ml: kt(jB),
                    mI: r.qC,
                    m6: r.qC ? Zvn : Kvn,
                    ox: kt(sbn)
                }))
            ]))),
            function() {
                var n = u.bQ.fY;
                return n.$ ? ih("") : A2(Le, g, T([
                    A5(Hvn, t, r, n.a, e, u)
                ]));
            }(),
            A2(obn, !i(u.bQ.d6, g), Qq(T([
                Yq(Obn),
                A2(FF, c, lB(p(oB, {
                    ml: kt(Nun),
                    m6: Qvn,
                    ox: kt(cbn("audioFile"))
                }))),
                $ln,
                lB(p(oB, {
                    ml: kt(jB),
                    mI: r.qD,
                    m6: r.qD ? Zvn : Kvn,
                    ox: kt(fbn)
                }))
            ]))),
            A2(obn, !i(u.bQ.d6, g), A2(Le, g, A2(Ge, A3(Mbn, n, t, r), o))),
            A2(obn, !i(u.bQ.ad, g), Qq(T([
                Yq(Xvn),
                A2(FF, c, lB(p(oB, {
                    ml: kt(Nun),
                    m6: Qvn,
                    ox: kt(cbn("subtitleFile"))
                }))),
                $ln,
                lB(p(oB, {
                    ml: kt(jB),
                    mI: r.qE,
                    m6: r.qE ? Zvn : Kvn,
                    ox: kt(lbn)
                }))
            ]))),
            A2(obn, !i(u.bQ.ad, g), A2(Le, g, A2(Ge, A2(u$n, t, r), a)))
        ]));
    }), i$n = function(n) {
        var r = n.pl.nv;
        if (r.$) return !1;
        var t = r.a.r2;
        return !t.$ && 5 === t.a.o1;
    }, o$n = F2(function(n, r) {
        return A2(ju, g, Va(A2(Ge, function(n) {
            return n.av;
        }, A2(Iu, A2(No, function(n) {
            return n.pl;
        }, A2(No, function(n) {
            return n.nv;
        }, F2(function(n, r) {
            return A2(ju, !1, A2(Fu, function(r) {
                return i(n, kt(r.mm));
            }, r));
        })(n))), A2(Iu, i$n, r)))));
    }), c$n = function(n) {
        return A2(Ge, function(n) {
            return {
                a6: Tt,
                kG: g,
                lB: n.lB,
                pl: {
                    fm: Tt,
                    nv: n.gI
                },
                gM: Tt,
                gN: Tt,
                g0: n.g0,
                av: g,
                hE: g
            };
        }, A2(kC, hC(A2(No, function(n) {
            return n.lB;
        }, function(n) {
            return n.n5;
        })), n.bP));
    }, s$n = function(n) {
        return A2(fp, A2(No, function(n) {
            return n.pl;
        }, function(n) {
            return n.nv;
        }), n.bQ.fY);
    }, f$n = function(n) {
        if (n.$) return !1;
        var r = n.a.r2;
        return !r.$ && 5 === r.a.o1;
    }, l$n = {
        $: 0
    }, m$n = {
        $: 32
    }, d$n = frn(T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("6 5 12 9 6 13")
        ]), g)
    ])), b$n = Oi({
        bN: "Play",
        bT: "Play"
    }), p$n = Oi({
        bN: "Audios(s)",
        bT: "Audio(s)"
    }), v$n = Oi({
        bN: "Video format",
        bT: "Format Video"
    }), $$n = Oi({
        bN: "Main file specifications",
        bT: "Description technique du fichier principal"
    }), g$n = Oi({
        bN: " audio stream(s)",
        bT: " stream(s) audio(s)"
    }), h$n = T([
        m(2997, 100),
        m(3e4, 1001),
        m(5994, 100),
        m(6e4, 1001)
    ]), k$n = F2(function(n, r) {
        var t, e = A2(G$, m(n.at, n.as), h$n) ? A2(Oe, ";", r) ? "DF" : "NDF" : "", u = function() {
            var r = n.cA;
            return 1 === r.$ ? "" : " (" + r.a + ")";
        }(), a = "@" + A2(ju, "N/A", A2(Fu, Vbn, n.ah));
        return A2(Bt, " \u2022 ", T([
            (t = n.ai, t.toUpperCase()),
            It(n.id) + "x" + (It(n.fk) + (a + u)),
            mL(_1(n)) + " fps " + e,
            mL(qbn(n)) + ":1"
        ]));
    }), T$n = F4(function(n, r, t, e) {
        var u = A2(zi, function(n) {
            return n.bb;
        }, t), a = n.at / n.as, i = function(r) {
            return y4(r) + " (" + A2(Dbn, n, (1 + r.bc - r.bb) / a) + ")";
        };
        return A2(Le, T([
            Rg("PlayerFoldInfos")
        ]), T([
            A2(Le, T([
                Rg("PlayerFoldInfosTitle")
            ]), T([
                ih($$n)
            ])),
            A2(Le, T([
                Rg("PlayerFoldInfo")
            ]), T([
                A2(Dh, T([
                    Rg("PlayerFoldInfoLabel")
                ]), v$n),
                A2(Dh, T([
                    Rg("PlayerFoldInfoValue")
                ]), A2(k$n, n, e))
            ])),
            A2(Le, T([
                Rg("PlayerFoldInfo")
            ]), T([
                A2(Dh, T([
                    Rg("PlayerFoldInfoLabel")
                ]), qmn),
                A2(Dh, T([
                    Rg("PlayerFoldInfoValue")
                ]), xbn(n))
            ])),
            A2(Le, T([
                Rg("PlayerFoldInfo")
            ]), T([
                A2(Dh, T([
                    Rg("PlayerFoldInfoLabel")
                ]), p$n),
                A2(Le, T([
                    Rg("PlayerFoldInfoValues")
                ]), T([
                    A2(Dh, T([
                        Rg("PlayerFoldInfoValue")
                    ]), $(It(Dt(r)), g$n))
                ]))
            ])),
            Cu(t) ? ih("") : A2(Le, T([
                Rg("PlayerFoldInfo")
            ]), T([
                A2(Dh, T([
                    Rg("PlayerFoldInfoLabel")
                ]), Oon),
                A2(Le, T([
                    Rg("PlayerFoldInfoValues")
                ]), A2(Ge, A2(bu, Dh(T([
                    Rg("PlayerFoldInfoValue")
                ])), i), u))
            ]))
        ]));
    }), w$n = {
        $: 8
    }, C$n = {
        $: 7
    }, N$n = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), A$n = {
        $: 3
    }, S$n = {
        $: 2
    }, L$n = {
        $: 4
    }, y$n = {
        $: 5
    }, F$n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, j$n = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), P$n = A2(Kg, T([
        zg("1080"),
        Xg("1920"),
        Yg("0 0 1920 1080")
    ]), T([
        A2(Rrn, T([
            z7("#74F7FF"),
            zg("3"),
            Xg("1920"),
            Ern("22")
        ]), g),
        A2(Rrn, T([
            z7("#70FF00"),
            zg("3"),
            Xg("1920"),
            Ern("133")
        ]), g),
        A2(Rrn, T([
            z7("#FF4BF8"),
            zg("3"),
            Xg("1920"),
            Ern("140")
        ]), g),
        A2(Rrn, T([
            z7("#FF4BF8"),
            zg("3"),
            Xg("1920"),
            Ern("940")
        ]), g),
        A2(Rrn, T([
            z7("#70FF00"),
            zg("3"),
            Xg("1920"),
            Ern("947")
        ]), g),
        A2(Rrn, T([
            z7("#74F7FF"),
            zg("3"),
            Xg("1920"),
            Ern("1058")
        ]), g),
        A2(Rrn, T([
            z7("#74F7FF"),
            zg("31"),
            Xg("58"),
            Ern("22")
        ]), g),
        A2(Rrn, T([
            z7("#70FF00"),
            zg("31"),
            Xg("58"),
            Ern("105")
        ]), g),
        A2(Rrn, T([
            z7("#FF4BF8"),
            zg("31"),
            Xg("58"),
            Ern("140")
        ]), g),
        A2(ow, T([
            iw("M13.6935 43H10.783V31.0332L7.30859 32.1826V29.6582L13.3813 27.3379H13.6935V43ZM18.7389 41.4746C18.7389 40.9805 18.8933 40.5794 19.2022 40.2715C19.5178 39.9635 19.9105 39.8096 20.3805 39.8096C20.8572 39.8096 21.2499 39.9635 21.5587 40.2715C21.8743 40.5794 22.0321 40.9805 22.0321 41.4746C22.0321 41.9616 21.8777 42.359 21.5689 42.667C21.26 42.9678 20.8639 43.1182 20.3805 43.1182C19.9038 43.1182 19.511 42.9678 19.2022 42.667C18.8933 42.359 18.7389 41.9616 18.7389 41.4746ZM34.0265 31.5166C34.0265 32.2757 33.8485 32.9489 33.4926 33.5361C33.1369 34.1234 32.6467 34.5924 32.0224 34.9434C32.734 35.3086 33.298 35.8135 33.7143 36.458C34.1305 37.0954 34.3386 37.8473 34.3386 38.7139C34.3386 40.1032 33.8955 41.2025 33.0093 42.0117C32.123 42.8138 30.9179 43.2148 29.3939 43.2148C27.8698 43.2148 26.6613 42.8102 25.7684 42.001C24.8754 41.1917 24.429 40.096 24.429 38.7139C24.429 37.8473 24.6371 37.0918 25.0534 36.4473C25.4696 35.8027 26.0302 35.3014 26.7351 34.9434C26.1108 34.5924 25.6206 34.1234 25.2649 33.5361C24.9157 32.9489 24.7412 32.2757 24.7412 31.5166C24.7412 30.1846 25.1574 29.1247 25.9899 28.3369C26.8224 27.542 27.9537 27.1445 29.3838 27.1445C30.8071 27.1445 31.9351 27.5384 32.7676 28.3262C33.6068 29.1068 34.0265 30.1702 34.0265 31.5166ZM31.418 38.4883C31.418 37.8079 31.2335 37.2637 30.8642 36.8555C30.4949 36.4473 29.9981 36.2432 29.3737 36.2432C28.756 36.2432 28.2626 36.4473 27.8933 36.8555C27.524 37.2565 27.3395 37.8008 27.3395 38.4883C27.3395 39.1543 27.5207 39.6914 27.8832 40.0996C28.2458 40.5078 28.7494 40.7119 29.3939 40.7119C30.0249 40.7119 30.5184 40.515 30.8743 40.1211C31.2368 39.7272 31.418 39.1829 31.418 38.4883ZM31.116 31.667C31.116 31.0583 30.9649 30.5713 30.6628 30.2061C30.3606 29.8337 29.9344 29.6475 29.3838 29.6475C28.8399 29.6475 28.417 29.8265 28.1149 30.1846C27.8127 30.5426 27.6617 31.0368 27.6617 31.667C27.6617 32.29 27.8127 32.7913 28.1149 33.1709C28.417 33.5505 28.8433 33.7402 29.3939 33.7402C29.9444 33.7402 30.3674 33.5505 30.6628 33.1709C30.9649 32.7913 31.116 32.29 31.116 31.667ZM36.7456 35.3086L37.5915 27.3594H45.8092V29.9482H39.9783L39.6157 33.3105C40.3072 32.9167 41.0424 32.7197 41.8212 32.7197C43.2177 32.7197 44.312 33.1816 45.1043 34.1055C45.8965 35.0293 46.2927 36.3219 46.2927 37.9834C46.2927 38.9932 46.0912 39.8991 45.6884 40.7012C45.2923 41.4961 44.7216 42.1156 43.9763 42.5596C43.2311 42.9964 42.3516 43.2148 41.3378 43.2148C40.4516 43.2148 39.6291 43.0251 38.8705 42.6455C38.1118 42.2588 37.511 41.7181 37.0678 41.0234C36.6314 40.3288 36.3997 39.5374 36.3729 38.6494H39.2532C39.3136 39.3011 39.5251 39.8096 39.8876 40.1748C40.2569 40.5329 40.7369 40.7119 41.3278 40.7119C41.9857 40.7119 42.4926 40.4613 42.8484 39.96C43.2043 39.4515 43.3822 38.7354 43.3822 37.8115C43.3822 36.9235 43.1774 36.2432 42.7679 35.7705C42.3583 35.2979 41.7776 35.0615 41.0256 35.0615C40.3341 35.0615 39.7735 35.2549 39.3438 35.6416L39.0619 35.9209L36.7456 35.3086Z"),
            z7("black")
        ]), g),
        A2(ow, T([
            iw("M16.6709 125H6.62018V122.873L11.3635 117.48C12.0148 116.721 12.4949 116.059 12.8037 115.493C13.1192 114.927 13.277 114.39 13.277 113.882C13.277 113.187 13.1125 112.643 12.7835 112.249C12.4545 111.848 11.9846 111.648 11.3736 111.648C10.7157 111.648 10.1954 111.891 9.81267 112.378C9.43664 112.858 9.24866 113.492 9.24866 114.279H6.32812C6.32812 113.327 6.53962 112.457 6.96259 111.669C7.39227 110.881 7.99653 110.265 8.77533 109.821C9.55411 109.37 10.437 109.145 11.424 109.145C12.9345 109.145 14.1061 109.531 14.9386 110.305C15.7779 111.078 16.1975 112.17 16.1975 113.581C16.1975 114.354 16.0095 115.142 15.6335 115.944C15.2576 116.746 14.613 117.681 13.6999 118.748L10.3665 122.497H16.6709V125ZM18.7353 123.475C18.7353 122.98 18.8897 122.579 19.1986 122.271C19.5142 121.964 19.9069 121.81 20.3769 121.81C20.8536 121.81 21.2463 121.964 21.5551 122.271C21.8707 122.579 22.0285 122.98 22.0285 123.475C22.0285 123.962 21.8741 124.359 21.5653 124.667C21.2565 124.968 20.8603 125.118 20.3769 125.118C19.9002 125.118 19.5075 124.968 19.1986 124.667C18.8897 124.359 18.7353 123.962 18.7353 123.475ZM27.4264 115.805H28.9773C29.7159 115.805 30.2631 115.608 30.6189 115.214C30.9748 114.82 31.1526 114.297 31.1526 113.646C31.1526 113.015 30.9748 112.525 30.6189 112.174C30.2698 111.823 29.7864 111.648 29.1687 111.648C28.6114 111.648 28.1448 111.812 27.7689 112.142C27.3929 112.464 27.2049 112.886 27.2049 113.409H24.2944C24.2944 112.593 24.4992 111.862 24.9088 111.218C25.325 110.566 25.9024 110.058 26.6409 109.692C27.3862 109.327 28.2053 109.145 29.0982 109.145C30.6491 109.145 31.8644 109.542 32.7438 110.337C33.6234 111.125 34.0631 112.213 34.0631 113.603C34.0631 114.319 33.8583 114.978 33.4488 115.579C33.0392 116.181 32.5021 116.643 31.8375 116.965C32.6633 117.28 33.2775 117.753 33.6804 118.383C34.09 119.013 34.2947 119.758 34.2947 120.617C34.2947 122.007 33.818 123.12 32.8647 123.958C31.9181 124.796 30.6626 125.215 29.0982 125.215C27.6345 125.215 26.4361 124.803 25.503 123.979C24.5764 123.156 24.1132 122.067 24.1132 120.714H27.0236C27.0236 121.301 27.2284 121.781 27.6379 122.153C28.0542 122.526 28.5645 122.712 29.1687 122.712C29.8603 122.712 30.4007 122.519 30.7901 122.132C31.1863 121.738 31.3843 121.219 31.3843 120.574C31.3843 119.013 30.5786 118.232 28.9673 118.232H27.4264V115.805ZM36.742 117.309L37.5879 109.359H45.8056V111.948H39.9747L39.6121 115.311C40.3036 114.917 41.0388 114.72 41.8176 114.72C43.2141 114.72 44.3085 115.182 45.1007 116.105C45.8929 117.029 46.2891 118.322 46.2891 119.983C46.2891 120.993 46.0876 121.899 45.6848 122.701C45.2887 123.496 44.718 124.116 43.9727 124.56C43.2275 124.996 42.348 125.215 41.3342 125.215C40.448 125.215 39.6255 125.025 38.8669 124.646C38.1082 124.259 37.5074 123.718 37.0642 123.023C36.6278 122.329 36.3961 121.537 36.3693 120.649H39.2496C39.31 121.301 39.5215 121.81 39.884 122.175C40.2533 122.533 40.7333 122.712 41.3242 122.712C41.9821 122.712 42.489 122.461 42.8448 121.96C43.2007 121.451 43.3786 120.735 43.3786 119.812C43.3786 118.924 43.1738 118.243 42.7643 117.771C42.3547 117.298 41.774 117.062 41.022 117.062C40.3305 117.062 39.7699 117.255 39.3402 117.642L39.0583 117.921L36.742 117.309Z"),
            z7("black")
        ]), g),
        A2(ow, T([
            iw("M16.6709 163H6.62018V160.873L11.3635 155.48C12.0148 154.721 12.4949 154.059 12.8037 153.493C13.1192 152.927 13.277 152.39 13.277 151.882C13.277 151.187 13.1125 150.643 12.7835 150.249C12.4545 149.848 11.9846 149.647 11.3736 149.647C10.7157 149.647 10.1954 149.891 9.81267 150.378C9.43664 150.858 9.24866 151.492 9.24866 152.279H6.32812C6.32812 151.327 6.53962 150.457 6.96259 149.669C7.39227 148.881 7.99653 148.265 8.77533 147.821C9.55411 147.37 10.437 147.145 11.424 147.145C12.9345 147.145 14.1061 147.531 14.9386 148.305C15.7779 149.078 16.1975 150.17 16.1975 151.581C16.1975 152.354 16.0095 153.142 15.6335 153.944C15.2576 154.746 14.613 155.681 13.6999 156.748L10.3665 160.497H16.6709V163ZM18.7353 161.475C18.7353 160.98 18.8897 160.579 19.1986 160.271C19.5142 159.964 19.9069 159.81 20.3769 159.81C20.8536 159.81 21.2463 159.964 21.5551 160.271C21.8707 160.579 22.0285 160.98 22.0285 161.475C22.0285 161.962 21.8741 162.359 21.5653 162.667C21.2565 162.968 20.8603 163.118 20.3769 163.118C19.9002 163.118 19.5075 162.968 19.1986 162.667C18.8897 162.359 18.7353 161.962 18.7353 161.475ZM27.4264 153.805H28.9773C29.7159 153.805 30.2631 153.608 30.6189 153.214C30.9748 152.82 31.1526 152.297 31.1526 151.646C31.1526 151.015 30.9748 150.525 30.6189 150.174C30.2698 149.823 29.7864 149.647 29.1687 149.647C28.6114 149.647 28.1448 149.812 27.7689 150.142C27.3929 150.464 27.2049 150.886 27.2049 151.409H24.2944C24.2944 150.593 24.4992 149.862 24.9088 149.218C25.325 148.566 25.9024 148.058 26.6409 147.692C27.3862 147.327 28.2053 147.145 29.0982 147.145C30.6491 147.145 31.8644 147.542 32.7438 148.337C33.6234 149.125 34.0631 150.213 34.0631 151.603C34.0631 152.319 33.8583 152.978 33.4488 153.579C33.0392 154.181 32.5021 154.643 31.8375 154.965C32.6633 155.28 33.2775 155.753 33.6804 156.383C34.09 157.013 34.2947 157.758 34.2947 158.617C34.2947 160.007 33.818 161.12 32.8647 161.958C31.9181 162.796 30.6626 163.215 29.0982 163.215C27.6345 163.215 26.4361 162.803 25.503 161.979C24.5764 161.156 24.1132 160.067 24.1132 158.714H27.0236C27.0236 159.301 27.2284 159.781 27.6379 160.153C28.0542 160.526 28.5645 160.712 29.1687 160.712C29.8603 160.712 30.4007 160.519 30.7901 160.132C31.1863 159.738 31.3843 159.219 31.3843 158.574C31.3843 157.013 30.5786 156.232 28.9673 156.232H27.4264V153.805ZM43.1168 156.748C42.3581 157.543 41.4719 157.94 40.458 157.94C39.1623 157.94 38.125 157.468 37.3462 156.522C36.5674 155.57 36.178 154.288 36.178 152.677C36.178 151.653 36.3861 150.715 36.8024 149.862C37.2254 149.003 37.8128 148.337 38.5648 147.864C39.3167 147.384 40.1626 147.145 41.1026 147.145C42.0694 147.145 42.9287 147.402 43.6807 147.918C44.4327 148.434 45.0168 149.175 45.4331 150.142C45.8493 151.108 46.0608 152.215 46.0675 153.461V154.61C46.0675 157.217 45.4599 159.265 44.2447 160.755C43.0295 162.244 41.3074 163.039 39.0783 163.14L38.3634 163.15V160.562L39.0079 160.551C41.539 160.429 42.9087 159.161 43.1168 156.748ZM41.1731 155.566C41.643 155.566 42.0459 155.438 42.3816 155.18C42.724 154.922 42.9825 154.61 43.157 154.245V152.967C43.157 151.914 42.969 151.098 42.5931 150.518C42.2171 149.938 41.7135 149.647 41.0824 149.647C40.4984 149.647 40.0184 149.934 39.6423 150.507C39.2664 151.073 39.0783 151.785 39.0783 152.645C39.0783 153.497 39.2596 154.199 39.6222 154.75C39.9915 155.294 40.5084 155.566 41.1731 155.566Z"),
            z7("black")
        ]), g)
    ])), I$n = ipn(T([
        A2(Rrn, T([
            Pg("Fg"),
            zg("1"),
            Xg("18"),
            Vrn("0"),
            Ern("2")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("1"),
            Xg("18"),
            Vrn("0"),
            Ern("4")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("1"),
            Xg("18"),
            Vrn("0"),
            Ern("12")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("1"),
            Xg("18"),
            Vrn("0"),
            Ern("14")
        ]), g)
    ])), B$n = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M5.04443 10.3306H1.81641V8.92871H5.04443V10.3306ZM9.34238 13H7.52695V7.2207L5.74375 7.7417V6.3667L9.17588 5.17969H9.34238V13ZM13.6726 11.3672C13.6726 11.2132 13.592 11.0897 13.4309 10.9966C13.2697 10.9035 12.9636 10.8068 12.5124 10.7065C12.0612 10.6063 11.6888 10.4756 11.3952 10.3145C11.1016 10.1497 10.8778 9.95101 10.7238 9.71826C10.5699 9.48551 10.4929 9.21875 10.4929 8.91797C10.4929 8.38444 10.7131 7.9458 11.1535 7.60205C11.5939 7.25472 12.1704 7.08105 12.883 7.08105C13.6493 7.08105 14.2652 7.25472 14.7307 7.60205C15.1962 7.94938 15.4289 8.40592 15.4289 8.97168H13.6135C13.6135 8.50618 13.3682 8.27344 12.8776 8.27344C12.6879 8.27344 12.5285 8.32715 12.3996 8.43457C12.2707 8.53841 12.2063 8.66911 12.2063 8.82666C12.2063 8.98779 12.285 9.11849 12.4426 9.21875C12.6001 9.31901 12.8508 9.40137 13.1945 9.46582C13.5419 9.53027 13.8462 9.60726 14.1076 9.69678C14.9813 9.99756 15.4182 10.5365 15.4182 11.3135C15.4182 11.8434 15.1818 12.2749 14.7092 12.6079C14.2401 12.9409 13.6314 13.1074 12.883 13.1074C12.3853 13.1074 11.9413 13.0179 11.551 12.8389C11.1607 12.6598 10.8563 12.4163 10.6379 12.1084C10.4195 11.8005 10.3103 11.4764 10.3103 11.1362H12.0021C12.0093 11.4048 12.0988 11.6017 12.2707 11.7271C12.4426 11.8488 12.6628 11.9097 12.9313 11.9097C13.1784 11.9097 13.3628 11.8595 13.4846 11.7593C13.6099 11.659 13.6726 11.5283 13.6726 11.3672Z")
        ]), g)
    ])), M$n = Oi({
        bN: "Back 1s",
        bT: "Retour 1s en arri\xe8re"
    }), O$n = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M4.04443 10.3306H0.816406V8.92871H4.04443V10.3306ZM5.5376 9.17578L6.01562 5.17969H10.5864V6.58691H7.4873L7.31006 8.13916C7.43896 8.06396 7.60726 7.99772 7.81494 7.94043C8.0262 7.88314 8.2321 7.85449 8.43262 7.85449C9.20964 7.85449 9.80583 8.08545 10.2212 8.54736C10.6401 9.0057 10.8496 9.65023 10.8496 10.481C10.8496 10.9823 10.7368 11.437 10.5112 11.8452C10.2892 12.2498 9.97591 12.5614 9.57129 12.7798C9.16667 12.9982 8.68864 13.1074 8.13721 13.1074C7.64665 13.1074 7.18652 13.0072 6.75684 12.8066C6.32715 12.6025 5.99056 12.325 5.74707 11.9741C5.50358 11.6196 5.38363 11.2204 5.38721 10.7764H7.20264C7.22054 11.0628 7.31185 11.2902 7.47656 11.4585C7.64128 11.6268 7.85791 11.7109 8.12646 11.7109C8.73519 11.7109 9.03955 11.2598 9.03955 10.3574C9.03955 9.52311 8.66715 9.10596 7.92236 9.10596C7.49984 9.10596 7.18473 9.24202 6.97705 9.51416L5.5376 9.17578ZM14.8726 11.3672C14.8726 11.2132 14.792 11.0897 14.6309 10.9966C14.4697 10.9035 14.1636 10.8068 13.7124 10.7065C13.2612 10.6063 12.8888 10.4756 12.5952 10.3145C12.3016 10.1497 12.0778 9.95101 11.9238 9.71826C11.7699 9.48551 11.6929 9.21875 11.6929 8.91797C11.6929 8.38444 11.9131 7.9458 12.3535 7.60205C12.7939 7.25472 13.3704 7.08105 14.083 7.08105C14.8493 7.08105 15.4652 7.25472 15.9307 7.60205C16.3962 7.94938 16.6289 8.40592 16.6289 8.97168H14.8135C14.8135 8.50618 14.5682 8.27344 14.0776 8.27344C13.8879 8.27344 13.7285 8.32715 13.5996 8.43457C13.4707 8.53841 13.4062 8.66911 13.4062 8.82666C13.4062 8.98779 13.485 9.11849 13.6426 9.21875C13.8001 9.31901 14.0508 9.40137 14.3945 9.46582C14.7419 9.53027 15.0462 9.60726 15.3076 9.69678C16.1813 9.99756 16.6182 10.5365 16.6182 11.3135C16.6182 11.8434 16.3818 12.2749 15.9092 12.6079C15.4401 12.9409 14.8314 13.1074 14.083 13.1074C13.5853 13.1074 13.1413 13.0179 12.751 12.8389C12.3607 12.6598 12.0563 12.4163 11.8379 12.1084C11.6195 11.8005 11.5103 11.4764 11.5103 11.1362H13.2021C13.2093 11.4048 13.2988 11.6017 13.4707 11.7271C13.6426 11.8488 13.8628 11.9097 14.1313 11.9097C14.3784 11.9097 14.5628 11.8595 14.6846 11.7593C14.8099 11.659 14.8726 11.5283 14.8726 11.3672Z")
        ]), g)
    ])), q$n = Oi({
        bN: "Back 5s",
        bT: "Retour 5s en arri\xe8re"
    }), D$n = ipn(T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("11 5 11 13 6 9")
        ]), g)
    ])), x$n = Oi({
        bN: "Error",
        bT: "Erreur"
    }), R$n = function(n) {
        return A2(Fg, "tabIndex", It(n));
    }, V$n = A2(Eh, T([
        Rg("TimecodeInput"),
        Rg("TimecodeEditable"),
        R$n(0),
        Ch("text")
    ]), g), E$n = Oi({
        bN: "End",
        bT: "Fin"
    }), z$n = ipn(T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("7 5 7 13 12 9")
        ]), g),
        A2(Zg, T([
            Pg("Fg"),
            Ug("3 5 3 13 8 9")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("8"),
            Xg("1.5"),
            Vrn("11.75"),
            Ern("5")
        ]), g)
    ])), U$n = ipn(T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("7 5 7 13 12 9")
        ]), g)
    ])), H$n = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M9.1347656 5.1386719 L5.7011719 6.3242188 L5.7011719 7.6992188 L7.4863281 7.1796875 L7.4863281 12.958984 L9.3007812 12.958984 L9.3007812 12.957031 L9.3007812 5.1386719 L9.1347656 5.1386719z M12.841797 7.0390625 C12.128797 7.0390625 11.551328 7.2125469 11.111328 7.5605469 C10.671328 7.9035469 10.451172 8.3429531 10.451172 8.8769531 C10.451172 9.1769531 10.528641 9.4447344 10.681641 9.6777344 A1.895 1.895 0 0 0 11.353516 10.273438 C11.646516 10.434438 12.019703 10.565016 12.470703 10.666016 C12.921703 10.766016 13.228625 10.861078 13.390625 10.955078 C13.551625 11.047078 13.630859 11.172172 13.630859 11.326172 A0.479 0.479 0 0 1 13.443359 11.71875 C13.321359 11.81875 13.136672 11.867188 12.888672 11.867188 C12.620672 11.867187 12.400516 11.807547 12.228516 11.685547 C12.056516 11.560547 11.967937 11.363703 11.960938 11.095703 L10.269531 11.095703 A1.654 1.654 0 0 0 10.597656 12.066406 A2.228 2.228 0 0 0 11.509766 12.798828 C11.899766 12.976828 12.343797 13.066406 12.841797 13.066406 C13.589797 13.066406 14.197969 12.899406 14.667969 12.566406 C15.139969 12.233406 15.376953 11.801484 15.376953 11.271484 C15.376953 10.494484 14.940406 9.9552969 14.066406 9.6542969 C13.805406 9.5652969 13.500344 9.4888281 13.152344 9.4238281 C12.808344 9.3598281 12.558391 9.2777344 12.400391 9.1777344 C12.243391 9.0777344 12.164062 8.9461562 12.164062 8.7851562 A0.483 0.483 0 0 1 12.357422 8.3925781 C12.486422 8.2855781 12.645938 8.2324219 12.835938 8.2324219 C13.326938 8.2324219 13.572266 8.4646875 13.572266 8.9296875 L15.388672 8.9296875 C15.388672 8.3646875 15.155453 7.9085469 14.689453 7.5605469 C14.224453 7.2135469 13.607797 7.0390625 12.841797 7.0390625z M2.7246094 7.7363281 L2.7246094 8.8867188 L1.7753906 8.8867188 L1.7753906 10.289062 L2.7246094 10.289062 L2.7246094 11.394531 L4.0683594 11.394531 L4.0683594 10.289062 L5.0039062 10.289062 L5.0039062 10.287109 L5.0039062 8.8867188 L4.0683594 8.8867188 L4.0683594 7.7363281 L2.7246094 7.7363281z")
        ]), g)
    ])), W$n = Oi({
        bN: "Forward 1s",
        bT: "Avance 1s en avant"
    }), Q$n = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M6.015625 5.1796875 L5.5371094 9.1757812 L6.9765625 9.5136719 C7.1845625 9.2416719 7.499875 9.1054688 7.921875 9.1054688 C8.666875 9.1054688 9.0390625 9.4554219 9.0390625 10.357422 C9.0390625 11.260422 8.7349531 11.710938 8.1269531 11.710938 C7.8569531 11.710938 7.6405625 11.626031 7.4765625 11.457031 C7.3115625 11.289031 7.221125 11.062391 7.203125 10.775391 L5.3867188 10.775391 A2.036 2.036 0 0 0 5.7460938 11.974609 A2.505 2.505 0 0 0 6.7578125 12.806641 C7.1878125 13.006641 7.6467187 13.107422 8.1367188 13.107422 C8.6887188 13.107422 9.1663125 12.997297 9.5703125 12.779297 A2.294 2.294 0 0 0 10.511719 11.845703 C10.737719 11.437703 10.849609 10.981469 10.849609 10.480469 C10.849609 9.6494688 10.640703 9.005875 10.220703 8.546875 C9.8057031 8.084875 9.2105937 7.8535156 8.4335938 7.8535156 C8.2325938 7.8535156 8.0254531 7.8824531 7.8144531 7.9394531 C7.6064531 7.9974531 7.4395469 8.0636719 7.3105469 8.1386719 L7.4863281 6.5878906 L10.585938 6.5878906 L10.585938 5.1796875 L6.015625 5.1796875z M14.082031 7.0800781 C13.369031 7.0800781 12.793516 7.2545625 12.353516 7.6015625 C11.913516 7.9455625 11.693359 8.3839687 11.693359 8.9179688 A1.416 1.416 0 0 0 11.923828 9.71875 A1.895 1.895 0 0 0 12.595703 10.314453 C12.889703 10.476453 13.262891 10.607031 13.712891 10.707031 C14.164891 10.807031 14.469859 10.903094 14.630859 10.996094 C14.791859 11.089094 14.873047 11.213188 14.873047 11.367188 A0.479 0.479 0 0 1 14.685547 11.759766 C14.563547 11.859766 14.377859 11.910156 14.130859 11.910156 C13.862859 11.910156 13.642703 11.848562 13.470703 11.726562 C13.298703 11.601562 13.208172 11.405719 13.201172 11.136719 L11.509766 11.136719 A1.654 1.654 0 0 0 11.837891 12.107422 A2.228 2.228 0 0 0 12.751953 12.837891 C13.141953 13.017891 13.584031 13.107422 14.082031 13.107422 C14.830031 13.107422 15.439203 12.940422 15.908203 12.607422 C16.381203 12.274422 16.617188 11.8425 16.617188 11.3125 C16.617187 10.5355 16.181594 9.9973125 15.308594 9.6953125 C15.046594 9.6063125 14.742531 9.5307969 14.394531 9.4667969 C14.051531 9.4017969 13.799578 9.31875 13.642578 9.21875 C13.484578 9.11775 13.40625 8.9861719 13.40625 8.8261719 A0.483 0.483 0 0 1 13.599609 8.4355469 C13.727609 8.3275469 13.888125 8.2734375 14.078125 8.2734375 C14.568125 8.2734375 14.814453 8.5066563 14.814453 8.9726562 L16.628906 8.9726562 C16.628906 8.4066562 16.396641 7.9485625 15.931641 7.6015625 C15.465641 7.2545625 14.848031 7.0800781 14.082031 7.0800781z M1.7949219 7.7265625 L1.7949219 8.9296875 L0.81640625 8.9296875 L0.81640625 10.330078 L1.7949219 10.330078 L1.7949219 11.384766 L3.1386719 11.384766 L3.1386719 10.330078 L4.0449219 10.330078 L4.0449219 8.9296875 L3.1386719 8.9296875 L3.1386719 7.7265625 L1.7949219 7.7265625z")
        ]), g)
    ])), Z$n = Oi({
        bN: "Forward 5s",
        bT: "Avance 5s en avant"
    }), K$n = Oi({
        bN: "Full Screen",
        bT: "Plein \xe9cran"
    }), Y$n = ipn(T([
        A2(Rrn, T([
            Pg("Fg"),
            zg("4"),
            Xg("2"),
            Vrn("3"),
            Ern("3")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("4"),
            Xg("2"),
            Vrn("13"),
            Ern("3")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("4"),
            Xg("2"),
            Vrn("3"),
            Ern("12")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("4"),
            Xg("2"),
            Vrn("13"),
            Ern("12")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("2"),
            Xg("2"),
            Vrn("5"),
            Ern("3")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("2"),
            Xg("2"),
            Vrn("11"),
            Ern("3")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("2"),
            Xg("2"),
            Vrn("5"),
            Ern("14")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("2"),
            Xg("3"),
            Vrn("11"),
            Ern("14")
        ]), g)
    ])), X$n = Oi({
        bN: "Initialization",
        bT: "Initialisation"
    }), J$n = Oi({
        bN: "Next Frame",
        bT: "Frame suivante"
    }), G$n = Oi({
        bN: "normal speed",
        bT: "Vitesses normale"
    }), _$n = Oi({
        bN: "Previous Frame",
        bT: "Frame pr\xe9c\xe9dente"
    }), ngn = Oi({
        bN: "Show raw frame",
        bT: "Afficher image originale"
    }), rgn = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 20 20"),
        Pg("IconRawImage")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("m17.31864,1.25l-14.67396,0c-1.18282,0 -2.14468,0.96154 -2.14468,2.14576l0,13.48626c0,1.18282 0.96186,2.14334 2.14468,2.14334l14.6739,0c1.18282,0 2.14366,-0.96052 2.14366,-2.14334l0,-13.48626c0.00006,-1.18422 -0.96078,-2.14576 -2.1436,-2.14576zm-4.55665,3.19115c1.14384,0 2.07149,0.92771 2.07149,2.07149s-0.92771,2.07149 -2.07149,2.07149c-1.14416,0 -2.07149,-0.92771 -2.07149,-2.07149s0.92733,-2.07149 2.07149,-2.07149zm3.88406,12.60171l-6.66508,0l-6.36814,0c-0.57211,0 -0.82691,-0.41393 -0.569,-0.9246l3.55506,-7.04144c0.25759,-0.5106 0.74851,-0.55618 1.09617,-0.10188l3.57474,4.67161c0.34766,0.45436 0.95532,0.49302 1.35751,0.08595l0.87451,-0.88556c0.40187,-0.40707 0.99398,-0.35667 1.32196,0.11185l2.26452,3.23469c0.32735,0.46922 0.12987,0.84938 -0.44224,0.84938z")
            ]), g)
        ]))
    ])), tgn = A2(Kg, T([
        zg("1080"),
        Xg("1920"),
        Yg("0 0 1920 1080")
    ]), T([
        A2(Rrn, T([
            z7("#FFD600"),
            zg("31"),
            Xg("130"),
            Ern("54"),
            Vrn("97")
        ]), g),
        A2(Rrn, T([
            U7("#FFD600"),
            z7("none"),
            zg("972"),
            Xg("1728"),
            Ern("54"),
            Vrn("96")
        ]), g),
        A2(ow, T([
            iw("M113.5 66.4531C113.433 65.8329 113.154 65.3499 112.662 65.0043C112.174 64.6586 111.539 64.4858 110.758 64.4858C110.209 64.4858 109.738 64.5687 109.345 64.7344C108.952 64.9001 108.651 65.125 108.443 65.4091C108.234 65.6932 108.128 66.0175 108.123 66.3821C108.123 66.6851 108.192 66.9479 108.329 67.1705C108.471 67.393 108.663 67.5824 108.904 67.7386C109.146 67.8902 109.413 68.018 109.707 68.1222C110.001 68.2263 110.297 68.3139 110.595 68.3849L111.958 68.7259C112.508 68.8537 113.036 69.0265 113.542 69.2443C114.054 69.4621 114.511 69.7367 114.913 70.0682C115.32 70.3996 115.642 70.7997 115.879 71.2685C116.116 71.7372 116.234 72.2865 116.234 72.9162C116.234 73.7685 116.016 74.5189 115.581 75.1676C115.145 75.8116 114.515 76.3158 113.691 76.6804C112.872 77.0402 111.88 77.2202 110.716 77.2202C109.584 77.2202 108.601 77.045 107.768 76.6946C106.94 76.3442 106.291 75.8329 105.822 75.1605C105.358 74.4882 105.107 73.669 105.069 72.7031H107.662C107.699 73.2098 107.856 73.6312 108.13 73.9673C108.405 74.3035 108.762 74.5545 109.203 74.7202C109.648 74.8859 110.145 74.9688 110.694 74.9688C111.267 74.9688 111.769 74.8835 112.2 74.7131C112.636 74.5379 112.976 74.2964 113.223 73.9886C113.469 73.6761 113.594 73.3116 113.599 72.8949C113.594 72.5161 113.483 72.2036 113.265 71.9574C113.047 71.7064 112.742 71.4981 112.349 71.3324C111.961 71.1619 111.506 71.0104 110.985 70.8778L109.331 70.4517C108.133 70.1439 107.186 69.6776 106.49 69.0526C105.798 68.4228 105.453 67.5871 105.453 66.5455C105.453 65.6884 105.685 64.938 106.149 64.294C106.618 63.6501 107.254 63.1506 108.059 62.7955C108.864 62.4356 109.776 62.2557 110.794 62.2557C111.826 62.2557 112.73 62.4356 113.507 62.7955C114.288 63.1506 114.901 63.6454 115.346 64.2798C115.791 64.9096 116.021 65.634 116.035 66.4531H113.5ZM118.583 77V62.4545H128.043V64.6634H121.218V68.6122H127.553V70.821H121.218V74.7912H128.1V77H118.583ZM143.182 67.3622H140.526C140.45 66.9266 140.31 66.5407 140.107 66.2045C139.903 65.8636 139.65 65.5748 139.347 65.3381C139.044 65.1013 138.698 64.9238 138.31 64.8054C137.926 64.6823 137.512 64.6207 137.067 64.6207C136.276 64.6207 135.575 64.8196 134.964 65.2173C134.354 65.6103 133.875 66.188 133.53 66.9503C133.184 67.7079 133.011 68.6335 133.011 69.7273C133.011 70.84 133.184 71.7775 133.53 72.5398C133.88 73.2973 134.358 73.8703 134.964 74.2585C135.575 74.642 136.274 74.8338 137.06 74.8338C137.495 74.8338 137.902 74.777 138.281 74.6634C138.665 74.545 139.008 74.3722 139.311 74.1449C139.619 73.9176 139.877 73.6383 140.085 73.3068C140.298 72.9754 140.445 72.5966 140.526 72.1705L143.182 72.1847C143.082 72.8759 142.867 73.5246 142.536 74.1307C142.209 74.7367 141.78 75.2718 141.25 75.7358C140.72 76.1951 140.099 76.5549 139.389 76.8153C138.679 77.071 137.891 77.1989 137.024 77.1989C135.746 77.1989 134.605 76.9029 133.601 76.3111C132.597 75.7192 131.806 74.8646 131.229 73.7472C130.651 72.6297 130.362 71.2898 130.362 69.7273C130.362 68.16 130.653 66.8201 131.236 65.7074C131.818 64.59 132.611 63.7353 133.615 63.1435C134.619 62.5516 135.755 62.2557 137.024 62.2557C137.834 62.2557 138.587 62.3693 139.283 62.5966C139.979 62.8239 140.599 63.1577 141.143 63.598C141.688 64.0336 142.135 64.5687 142.486 65.2031C142.841 65.8329 143.073 66.5526 143.182 67.3622ZM154.764 62.4545H157.399V71.9574C157.399 72.9991 157.153 73.9152 156.66 74.706C156.172 75.4967 155.486 76.1146 154.6 76.5597C153.715 77 152.681 77.2202 151.497 77.2202C150.308 77.2202 149.271 77 148.386 76.5597C147.501 76.1146 146.814 75.4967 146.326 74.706C145.839 73.9152 145.595 72.9991 145.595 71.9574V62.4545H148.23V71.7372C148.23 72.3433 148.362 72.883 148.627 73.3565C148.897 73.83 149.276 74.2017 149.764 74.4716C150.252 74.7367 150.829 74.8693 151.497 74.8693C152.164 74.8693 152.742 74.7367 153.23 74.4716C153.722 74.2017 154.101 73.83 154.366 73.3565C154.631 72.883 154.764 72.3433 154.764 71.7372V62.4545ZM164.585 64.6634V62.4545H176.19V64.6634H171.694V77H169.08V64.6634H164.585ZM181.062 62.4545V77H178.427V62.4545H181.062ZM183.276 64.6634V62.4545H194.881V64.6634H190.385V77H187.772V64.6634H183.276ZM197.118 77V62.4545H202.573C203.69 62.4545 204.628 62.6487 205.385 63.0369C206.148 63.4252 206.723 63.9697 207.111 64.6705C207.504 65.3665 207.701 66.1785 207.701 67.1065C207.701 68.0393 207.502 68.849 207.104 69.5355C206.711 70.2173 206.131 70.7453 205.364 71.1193C204.597 71.4886 203.655 71.6733 202.537 71.6733H198.652V69.4858H202.182C202.836 69.4858 203.371 69.3958 203.787 69.2159C204.204 69.0312 204.512 68.7637 204.711 68.4134C204.914 68.0582 205.016 67.6226 205.016 67.1065C205.016 66.5904 204.914 66.1501 204.711 65.7855C204.507 65.4162 204.197 65.1368 203.78 64.9474C203.364 64.7533 202.826 64.6562 202.168 64.6562H199.753V77H197.118ZM204.632 70.4091L208.233 77H205.293L201.756 70.4091H204.632ZM210.126 77V62.4545H219.586V64.6634H212.761V68.6122H219.096V70.821H212.761V74.7912H219.643V77H210.126Z"),
            z7("black")
        ]), g)
    ])), egn = Oi({
        bN: "Speed X 2",
        bT: "Vitesse X 2"
    }), ugn = Oi({
        bN: "Speed X 4",
        bT: "Vitesse X 4"
    }), agn = Oi({
        bN: "Start",
        bT: "D\xe9but"
    }), ign = ipn(T([
        A2(Zg, T([
            Pg("Fg"),
            Ug("11 5 11 13 6 9")
        ]), g),
        A2(Zg, T([
            Pg("Fg"),
            Ug("15 5 15 13 10 9")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("8"),
            Xg("1.5"),
            Vrn("4.75"),
            Ern("5")
        ]), g)
    ])), ogn = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M5.3833 8.02344L6.37988 6.13184H8.60156L6.79248 9.47705L8.69043 13H6.45605L5.37695 10.9688L4.31689 13H2.06982L3.97412 9.47705L2.17139 6.13184H4.41846L5.3833 8.02344ZM14.1271 13H11.9816V6.16992L9.87414 6.78564V5.16064L13.9303 3.75781H14.1271V13Z")
        ]), g)
    ])), cgn = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M12.433594 3.234375 C11.644303 3.234375 11.024458 3.3490632 10.576172 3.5761719 C10.131717 3.7989131 9.7881853 4.1212769 9.5429688 4.5449219 C9.2977522 4.9641994 9.1290656 5.5495757 9.0371094 6.3007812 L11.380859 6.5175781 C11.445995 5.9760113 11.573975 5.5987719 11.761719 5.3847656 C11.953294 5.1707594 12.197236 5.0625 12.496094 5.0625 C12.783457 5.0625 13.02124 5.1673144 13.208984 5.3769531 C13.40056 5.5822244 13.496094 5.8323792 13.496094 6.125 C13.496094 6.3957834 13.40056 6.6810661 13.208984 6.9824219 C13.017409 7.2837776 12.578418 7.7257665 11.892578 8.3066406 C10.769946 9.2543825 10.003721 10.076595 9.59375 10.775391 C9.1876102 11.469819 8.9437429 12.213393 8.8632812 13.003906 L15.886719 13.003906 L15.886719 10.828125 L12.232422 10.828125 C12.446986 10.587914 12.631971 10.394588 12.789062 10.246094 C12.949986 10.0976 13.267006 9.8360791 13.738281 9.4648438 C14.531403 8.8271925 15.076142 8.2418162 15.375 7.7089844 C15.677689 7.1761525 15.830078 6.6184447 15.830078 6.0332031 C15.830078 5.4829014 15.697968 4.9860368 15.433594 4.5449219 C15.173051 4.0994395 14.813297 3.7706469 14.353516 3.5566406 C13.897566 3.3426344 13.257368 3.234375 12.433594 3.234375z M2.0703125 6.1328125 L3.9746094 9.6542969 L2.171875 13 L4.4179688 13 L5.3828125 11.109375 L6.3789062 13 L8.6015625 13 L6.7929688 9.6542969 L8.6914062 6.1328125 L6.4550781 6.1328125 L5.3769531 8.1621094 L4.3164062 6.1328125 L2.0703125 6.1328125z")
        ]), g)
    ])), sgn = ipn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M5.3833 8.02344L6.37988 6.13184H8.60156L6.79248 9.47705L8.69043 13H6.45605L5.37695 10.9688L4.31689 13H2.06982L3.97412 9.47705L2.17139 6.13184H4.41846L5.3833 8.02344ZM15.0348 9.38818H15.9742V11.0386H15.0348V13H12.8956V11.0386H9.32189L9.19494 9.73096L12.8956 3.77686V3.75781H15.0348V9.38818ZM11.2325 9.38818H12.8956V6.54443L12.7623 6.76025L11.2325 9.38818Z")
        ]), g)
    ])), fgn = {
        $: 1
    }, lgn = {
        $: 0
    }, mgn = ipn(T([
        A2(Rrn, T([
            Pg("Fg"),
            zg("8"),
            Xg("3"),
            Vrn("5"),
            Ern("5")
        ]), g),
        A2(Rrn, T([
            Pg("Fg"),
            zg("8"),
            Xg("3"),
            Vrn("10"),
            Ern("5")
        ]), g)
    ])), dgn = function(n) {
        return n.mR ? A2(Le, T([
            Rg("PlayerControlsPlayPause"),
            yB("Lire / Mettre en pause"),
            wh(fgn)
        ]), T([
            mgn
        ])) : A2(Le, T([
            Rg("PlayerControlsPlayPause"),
            yB("Lire / Mettre en pause"),
            wh(lgn)
        ]), T([
            opn
        ]));
    }, bgn = F2(function(n, r) {
        var t, e = (t = 100 * (r.eZ - r.hp) / n) > 100 ? "100" : mL(t);
        return A2(Le, T([
            Rg("PlayerControlsTimeBuffered"),
            A2(ph, "left", "0%"),
            A2(ph, "width", e + "%")
        ]), g);
    }), pgn = F3(function(n, r, t) {
        var e, u, a = (e = fe(r * t) - 1, (u = 100 * n.kn / e) > 100 ? "100" : mL(u));
        return A2(Le, T([
            Rg("PlayerControlsTimeProgress"),
            A2(ph, "left", "0%"),
            A2(ph, "width", a + "%")
        ]), g);
    }), vgn = F3(function(n, r, t) {
        var e = 1 === r.$ ? 0 : r.a, u = T(1 === t.$ ? [
            A2(Le, T([
                Rg("PlayerControlsTimeProgress"),
                A2(ph, "width", "0%")
            ]), g)
        ] : [
            A3(pgn, n, t.a, e)
        ]), a = 1 > Dt(n.em) ? T([
            A2(Le, T([
                Rg("PlayerControlsTimeBuffered"),
                A2(ph, "left", "0%"),
                A2(ph, "width", "0%")
            ]), g)
        ]) : A2(Ge, bgn(e), n.em);
        return A2(Le, T([
            Rg("PlayerControlsTime")
        ]), A2(dt, A2(Le, T([
            Rg("PlayerControlsTimeMask")
        ]), g), A2(dt, ih(""), A2(dt, A2(Le, T([
            Rg("PlayerControlsBufferProgress")
        ]), a), u))));
    }), $gn = F3(function(n, r, t) {
        var e, u = {
            i5: function() {
                var n = t.qp;
                return 1 === n.$ ? g : T([
                    It(n.a)
                ]);
            }(),
            nI: t.n2,
            gu: Tt,
            ad: r.ro
        }, a = r.mL || !r.iu ? "block" : "none", o = r.iY && !n || !r.iY && n ? "block" : "none";
        return A2(Le, T([
            Rg("PlayerVideoWrapper"),
            Yh("player-wrapper"),
            R$n(1)
        ]), T([
            A2(Le, T([
                Rg("PlayerBox")
            ]), T([
                A2(Le, T([
                    Rg("BannerEmptyness"),
                    Rg("PlayerBanner"),
                    A2(ph, "display", "none")
                ]), T([
                    jB,
                    A2(mh, T([
                        Rg("BannerContent")
                    ]), T([
                        ih(x$n)
                    ]))
                ])),
                A2(Le, T([
                    Rg("PlayerVideo"),
                    Oh(T([
                        m("PlayerDeployed", r.iu),
                        m("PlayerCollapsed", !r.iu)
                    ]))
                ]), T([
                    A2(Le, T([
                        Rg("PlayerVideoBuffering"),
                        A2(ph, "display", a)
                    ]), T([
                        (e = X$n, A2(Le, T([
                            Rg("LoadingWrapper")
                        ]), T([
                            A2(Le, T([
                                Rg("LoadingSpinner")
                            ]), T([
                                Nj,
                                A2(Le, T([
                                    Rg("LoadingSpinnerText")
                                ]), T([
                                    ih(e)
                                ]))
                            ]))
                        ])))
                    ])),
                    A3(Se, "noma-player", T([
                        A2(IB, "data-manifest", u.nI),
                        A2(IB, "data-audiostracks", "[" + A2(Bt, ",", u.i5) + "]"),
                        A2(IB, "data-playbackspeed", mL(r.gu)),
                        A2(IB, "data-subtitles", A2(ju, "", u.ad)),
                        A2(IB, "data-framerate", mL(r.lU)),
                        A2(IB, "data-starttimecode", t.q4)
                    ]), g),
                    A2(Le, T([
                        Rg("PlayerAspectRatio"),
                        A2(ph, "display", o),
                        A2(ph, "z-index", "3")
                    ]), T([
                        n ? tgn : P$n
                    ]))
                ]))
            ])),
            A2(Le, T([
                Rg("PlayerControlsBox")
            ]), T([
                A2(Le, T([
                    Rg("PlayerControls")
                ]), T([
                    dgn(r),
                    A3(vgn, r, t.eS, t.lU)
                ])),
                A2(Le, T([
                    Rg("PlayerControls")
                ]), T([
                    V$n,
                    A2(Le, T([
                        Rg("PlayerControlsStart"),
                        yB(agn),
                        wh(S$n)
                    ]), T([
                        ign
                    ])),
                    A2(Le, T([
                        Rg("PlayerControlsBackward"),
                        yB(_$n),
                        wh(y$n)
                    ]), T([
                        D$n
                    ])),
                    A2(Le, T([
                        Rg("PlayerControlsForward"),
                        yB(J$n),
                        wh(L$n)
                    ]), T([
                        U$n
                    ])),
                    A2(Le, T([
                        Rg("PlayerControlsEnd"),
                        yB(E$n),
                        wh(A$n)
                    ]), T([
                        z$n
                    ])),
                    A2(Dh, T([
                        Rg("PlayerOperationsSeparator")
                    ]), ""),
                    A2(Le, T([
                        Rg("PlayerGoBack1s"),
                        yB(M$n),
                        wh(A2(j$n, "Substract", 1))
                    ]), T([
                        B$n
                    ])),
                    A2(Le, T([
                        Rg("PlayerGoBack5s"),
                        yB(q$n),
                        wh(A2(j$n, "Substract", 5))
                    ]), T([
                        O$n
                    ])),
                    A2(Le, T([
                        Rg("PlayerGoForward1s"),
                        yB(W$n),
                        wh(A2(j$n, "Add", 1))
                    ]), T([
                        H$n
                    ])),
                    A2(Le, T([
                        Rg("PlayerGoForward5s"),
                        yB(Z$n),
                        wh(A2(j$n, "Add", 5))
                    ]), T([
                        Q$n
                    ])),
                    A2(Dh, T([
                        Rg("PlayerOperationsSeparator")
                    ]), ""),
                    A2(Le, T([
                        Rg("PlayerPlaybackSpeed1"),
                        Oh(T([
                            m("PlayerSelectedSpeed", i(r.gu, 1))
                        ])),
                        yB(G$n),
                        wh(F$n(1))
                    ]), T([
                        ogn
                    ])),
                    A2(Le, T([
                        Rg("PlayerPlaybackSpeed2"),
                        Oh(T([
                            m("PlayerSelectedSpeed", i(r.gu, 2))
                        ])),
                        yB(egn),
                        wh(F$n(2))
                    ]), T([
                        cgn
                    ])),
                    A2(Le, T([
                        Rg("PlayerPlaybackSpeed4"),
                        Oh(T([
                            m("PlayerSelectedSpeed", i(r.gu, 4))
                        ])),
                        yB(ugn),
                        wh(F$n(4))
                    ]), T([
                        sgn
                    ])),
                    A2(Dh, T([
                        Rg("PlayerOperationsSpacer")
                    ]), ""),
                    A2(Le, T([
                        Rg("PlayerControlsRatio"),
                        yB("aspect ratio"),
                        wh(w$n)
                    ]), T([
                        I$n
                    ])),
                    A2(Le, T([
                        Rg("ButtonDisplayRawImage"),
                        yB(ngn),
                        wh(A2(N$n, t.jt, t.m2))
                    ]), T([
                        rgn
                    ])),
                    A2(Le, T([
                        Rg("PlayerControlsFullScreen"),
                        yB(K$n),
                        wh(C$n)
                    ]), T([
                        Y$n
                    ]))
                ]))
            ]))
        ]));
    }), ggn = F5(function(n, r, t, e, u) {
        var a = A2(ju, "", A2(fp, wbn, A2(Aan, Lan(r), u).bQ.fY)), i = A2(ju, g, A2(Fu, function(n) {
            return n.g0;
        }, A2(Aan, Lan(r), u).bQ.fY)), o = s$n(A2(Aan, Lan(r), u)), c = f$n(o) ? m$n : l$n;
        if (t.$) return u.o4 ? ih("") : A2(Le, T([
            Yh("player"),
            Rg("PlayerUnfold")
        ]), T([
            (s = u.o2, 1 === s.$ ? ih("") : A2(dk, nZ, A3($gn, n, u.o5, s.a)))
        ]));
        var s, f, l = t.a;
        return u.o4 ? A2(Le, T([
            Rg("PlayerFold"),
            Oh(T([
                m("PlayerFolded", u.o4)
            ]))
        ]), T([
            f$n(o) ? A2(Le, T([
                Rg("PlayerFoldPreview"),
                wh(c)
            ]), T([
                A2(Le, T([
                    Rg("PlayerFoldPlay")
                ]), T([
                    d$n
                ])),
                A2(Le, T([
                    Rg("PlayerFoldProxy")
                ]), T([
                    ih(b$n)
                ]))
            ])) : A2(Le, T([
                Rg("PlayerFoldPreview")
            ]), T([
                A2(Le, T([
                    Rg("PlayerFoldSpinner")
                ]), T([
                    Nj
                ]))
            ])),
            A4(T$n, l, e, i, a)
        ])) : A2(Le, T([
            Yh("player"),
            Rg("PlayerUnfold")
        ]), T([
            (f = u.o2, 1 === f.$ ? ih("") : A2(dk, nZ, A3($gn, n, u.o5, f.a)))
        ]));
    }), hgn = Oi({
        bN: "No audio stream present for this video.",
        bT: "Aucun stream audio pr\xe9sente pour cette vid\xe9o"
    }), kgn = function(n) {
        return {
            $: 37,
            a: n
        };
    }, Tgn = F2(function(n, r) {
        var t = A2(ju, "", A2(Fu, YT, r.sv)), e = A2(ju, "", A2(Fu, Ldn, r.r5)), u = A2(Fu, H1, r.aC);
        return A2(yT, T([
            Rg("TracksTrackSelectLabel")
        ]), T([
            A2(Eh, T([
                Ch("radio"),
                ak(It(r.ft)),
                zh("selected-audio-track" + A3(Ym, 2, "0", It(r.ft))),
                wh(kgn(m(r.ft, u))),
                NT(A2(G$, r.ft, A2(ju, g, A2(Fu, A2(bu, Ge($e), function(n) {
                    return n.qq;
                }), n.o2))))
            ]), g),
            A2(mh, T([
                Rg("TracksTrackSelectItem")
            ]), T([
                A2(Dh, T([
                    Rg("TracksTrackSelectItemIndex")
                ]), A3(Ym, 2, "0", It(r.ft))),
                A2(Dh, T([
                    Rg("TracksTrackSelectItemTitle")
                ]), t + " " + e),
                A2(Dh, T([
                    Rg("TracksTrackSelectItemProp")
                ]), It(r.cz) + " channel(s)"),
                A2(Dh, T([
                    Rg("TracksTrackSelectItemProp")
                ]), A2(ju, "", u))
            ]))
        ]));
    }), wgn = function(n) {
        return A2(yT, T([
            Rg("TracksTrackSelectLabel")
        ]), T([
            A2(Eh, T([
                Ch("radio"),
                ak(It(n.ft)),
                zh("selected-subtitle-track")
            ]), g),
            A2(mh, T([
                Rg("TracksTrackSelectItem")
            ]), T([
                A2(Dh, T([
                    Rg("TracksTrackSelectItemTitle")
                ]), "subtitle stream " + A3(Ym, 2, "0", It(n.ft))),
                A2(Dh, T([
                    Rg("TracksTrackSelectItemProp")
                ]), A2(ju, "", A2(Fu, YT, n.sv)))
            ]))
        ]));
    }, Cgn = F2(function(n, r) {
        return A2(Le, T([
            Rg("TracksTrack")
        ]), T([
            A2(Le, T([
                Rg("TracksTrackIcon")
            ]), T([
                n
            ])),
            A2(Le, T([
                Rg("TracksTrackSelect")
            ]), r)
        ]));
    }), Ngn = A2(yT, T([
        Rg("TracksTrackSelectLabel")
    ]), T([
        A2(Eh, T([
            Ch("checkbox"),
            zh("selected-video-track")
        ]), g),
        A2(mh, T([
            Rg("TracksTrackSelectItem")
        ]), T([
            A2(Dh, T([
                Rg("TracksTrackSelectItemTitle")
            ]), "Video"),
            A2(Dh, T([
                Rg("TracksTrackSelectItemProp")
            ]), "")
        ]))
    ])), Agn = F3(function(n, r, t) {
        return A2(Le, T([
            Rg("Tracks")
        ]), T([
            A2(Cgn, Wbn, T([
                Ngn
            ])),
            A2(Cgn, Bmn, i(r, g) ? T([
                j7(hgn)
            ]) : A2(Ge, Tgn(n), A2(zi, function(n) {
                return n.ft;
            }, r))),
            i(t, g) ? ih("") : A2(Cgn, Vmn, A2(Ge, wgn, t))
        ]));
    }), Sgn = Oi({
        bN: "Additional material",
        bT: "Mat\xe9riel compl\xe9mentaire"
    }), Lgn = F5(function(n, r, t, e, u) {
        var a = c$n(n), i = A3(mbn, n.sp, n.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, n.fB));
        return A2(Le, T([
            Rg("FilesWrapper")
        ]), T([
            Cu(a) ? ih("") : A2(Le, g, A2(Ge, A6(Uvn, n, r, u, i, t, e), a))
        ]));
    }), ygn = Oi({
        bN: "File upload",
        bT: "Upload de fichier"
    }), Fgn = Oi({
        bN: "Looking for upload?",
        bT: "Vous voulez uploader des fichiers ?"
    }), jgn = Oi({
        bN: A2(Le, g, T([
            A2(Zj, g, T([
                ih("You can only upload subtitles.")
            ])),
            A2(Zj, g, T([
                ih("You are not allowed to deliver directly into the destination placeholder. First, you have to upload your master file into your own stock in Nomalab, then you will be able to start the delivery in Nomalab."),
                ih("For the records, you can follow the 3 steps tutorial available on this link: "),
                A2(aw, T([
                    sw(Orn("table"))
                ]), T([
                    ih("Read help")
                ])),
                ih(". If you need any assistance, you can also contact us via the Chat on the bottom left of this page.")
            ]))
        ])),
        bT: A2(Le, g, T([
            A2(Zj, g, T([
                ih("Vous ne pouver uploader que des sous-titres.")
            ])),
            A2(Zj, g, T([
                ih("Vous ne pouvez pas uploader directement dans la capsule de r\xe9ception de votre destinataire. "),
                ih("Vous devez dans un premier temps uploader votre master dans le stock de votre organisation. "),
                ih("Pour rappel, un tutoriel avec les 3 etapes \xe0 suivre pour livrer un programme avec Nomalab est disponible sur le lien suivant : "),
                A2(aw, T([
                    sw(Orn("table"))
                ]), T([
                    ih("Consulter l'aide")
                ])),
                ih(". En cas de besoin, vous pouvez contacter notre \xe9quipe op\xe9rationnelle via le bouton de messagerie instantan\xe9e disponible en bas \xe0 gauche de l'interface")
            ]))
        ]))
    }), Pgn = A2(Le, T([
        Rg("PadokUpload"),
        Rg("PadokUploadKo")
    ]), T([
        A2(Dh, T([
            Rg("PadokUploadTitle"),
            Rg("PadokUploadTitleKo")
        ]), Fgn),
        A2(Le, T([
            Rg("PadokUploadInfo")
        ]), T([
            jgn
        ]))
    ])), Ign = Oi({
        bN: "You can upload files",
        bT: "Vous pouvez uploader des fichiers"
    }), Bgn = Oi({
        bN: "Drop files here or ",
        bT: "Glisser-d\xe9poser les fichiers dans la fen\xeatre, ou "
    }), Mgn = F2(function(n, r) {
        return A2(yT, T([
            Len(n),
            Rg("InputFileLabel")
        ]), T([
            ih(r)
        ]));
    }), Ogn = Oi({
        bN: "select manually",
        bT: "s\xe9lectionner manuellement"
    }), qgn = A2(Le, T([
        Rg("PadokUpload")
    ]), T([
        A2(Dh, T([
            Rg("PadokUploadTitle")
        ]), Ign),
        A2(Le, T([
            Rg("PadokUploadInfo")
        ]), T([
            ih(Bgn),
            A2(Mgn, "nativeInputFile", Ogn)
        ]))
    ])), Dgn = Oi({
        bN: " and ",
        bT: " et "
    }), xgn = Oi({
        bN: ' Go to the "Settings" tab, Invitations area, to invite your contacts via their email adresses to upload files.',
        bT: ' Allez dans l\'onglet "Param\xe8tres" \xe0 gauche de l\'\xe9cran, zone "invitations", puis invitez vos contacts avec leurs adresses mail en upload.'
    }), Rgn = Oi({
        bN: " has been invited to upload files.",
        bT: " a \xe9t\xe9 invit\xe9(e) \xe0 uploader les fichiers."
    }), Vgn = Oi({
        bN: "Nobody is assigned for upload.",
        bT: "Si une autre personne doit uploader le fichier pour vous, "
    }), Egn = Oi({
        bN: " others were invited to upload files.",
        bT: " autres ont \xe9t\xe9 invit\xe9(e)s \xe0 uploader les fichiers."
    }), zgn = function(n) {
        return i(n.n5, n.k8) ? n.n5 : n.n5 + " (" + n.k8 + ")";
    }, Ugn = Oi({
        bN: " were invited to upload files.",
        bT: " ont \xe9t\xe9 invit\xe9(e)s \xe0 uploader les fichiers."
    }), Hgn = function(n) {
        var r = A2(Iu, A2(No, function(n) {
            return n.fz;
        }, function(n) {
            return n.sg;
        }), n.fB);
        return A2(Le, T([
            Rg("PadokUploadInvitation")
        ]), T([
            ih(function() {
                if (r.b) {
                    if (r.b.b) {
                        if (r.b.b.b) {
                            var n = r.b;
                            return A2(Bt, " ", T([
                                zgn(r.a.sp),
                                Dgn,
                                It(Dt(n)),
                                Egn
                            ]));
                        }
                        var t = r.b.a;
                        return A2(Bt, " ", T([
                            zgn(r.a.sp),
                            Dgn,
                            zgn(t.sp),
                            Ugn
                        ]));
                    }
                    return A2(Bt, " ", T([
                        zgn(r.a.sp),
                        Rgn
                    ]));
                }
                return Vgn;
            }()),
            ih(A2(jK, n.sp, n.g6.oL) ? xgn : "")
        ]));
    }, Wgn = function(n) {
        var r = !n.g6.c$ && !n.sp.iw, t = A3(IK, n.sp, n.g6.oL, A2(Ge, function(n) {
            return n.fz;
        }, n.fB));
        return A2(Le, T([
            Rg("PadokUploadWrapper")
        ]), T([
            r ? Pgn : t ? qgn : A2(Dh, T([
                Rg("PadokUploadTitle")
            ]), ygn),
            Hgn(n)
        ]));
    }, Qgn = {
        $: 16
    }, Zgn = Oi({
        bN: "Current capsule",
        bT: "Capsule courante"
    }), Kgn = Oi({
        bN: "Current master",
        bT: "Master courant"
    }), Ygn = Oi({
        bN: "No video file",
        bT: "Pas de fichier vid\xe9o"
    }), Xgn = Oi({
        bN: " (Rejected)",
        bT: " (Rejet\xe9)"
    }), Jgn = F2(function(n, r) {
        var t = n.oW;
        return !Dt(n.bj) || gan(n) && !qin(n.sp) ? ih("") : A2(Le, T([
            Rg("ShowSelectBroadcastable")
        ]), T([
            A3(imn, r.jo, Qgn, A2(dt, d(i(t.bD, Tt), A3(amn, n.g6.mm, n.iW, p(t, {
                bD: Tt
            })), function() {
                var r = m(n.R.bQ.fY, n.g6.c$);
                return 1 === r.a.$ ? r.b ? Kgn : Zgn : r.b ? r.a.a.lB.n5 + " (" + Kgn + ")" : r.a.a.lB.n5 + " (" + Zgn + ")";
            }()), A2(Ge, function(r) {
                var e;
                return d(i(t.bD, kt(r.bD.mm)), A3(amn, n.g6.mm, n.iW, p(t, {
                    bD: kt(r.bD.mm)
                })), 1 === (e = r.bQ.fY).$ ? Ygn : $(e.a.lB.n5, Xgn));
            }, n.bj)))
        ]));
    }), Ggn = Oi({
        bN: "Hide player",
        bT: "Masquer la video"
    }), _gn = frn(T([
        A2(ow, T([
            Pg("Fg"),
            iw("M4.94601622,4.57669369 C3.74989521,5.67353545 3,7.24919402 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,6.64729493 13.6458726,4.61086325 11.6744855,3.62757252 L11.2601446,5.69927685 C12.3108237,6.42010318 13,7.62956872 13,9 C13,11.209139 11.209139,13 9,13 C6.790861,13 5,11.209139 5,9 C5,7.98151039 5.38065278,7.051927 6.00745306,6.34575509 L7,8 L9,4 L4,3 L4.94601622,4.57669369 Z")
        ]), g)
    ])), nhn = Oi({
        bN: "Refresh",
        bT: "Rafra\xeechir"
    }), rhn = F4(function(n, r, t, e) {
        var u = A2(Fu, zu("#"), t.jq), a = kt(r.d1 ? crn : iz), i = gan(n) ? Tt : t.co ? kt(A2(Fmn, e.mm, Tv(r.bL.qz))) : Tt, o = kt(dX(e.mm)), c = A2(fw, g, T([
            FB(p(oB, {
                ml: kt(e.P.nl ? Rin : _gn),
                m6: nhn,
                ox: kt(Xv)
            })),
            e.o4 ? ih("") : FB(p(oB, {
                ml: kt(JF),
                m6: Ggn,
                ox: kt(xK)
            }))
        ]));
        return $w(p(gw, {
            dU: kt(c),
            d8: o,
            fa: i,
            fo: a,
            mm: u,
            rS: t.rS
        }));
    }), thn = F2(function(n, r) {
        return A2(Le, T([
            Rg("BannerCTA")
        ]), T([
            A2(Le, T([
                Rg("BannerCTAIcon")
            ]), T([
                aon
            ])),
            A2(Dh, T([
                Rg("BannerCTALabel")
            ]), n),
            FB(r)
        ]));
    }), ehn = Oi({
        bN: "Deliver",
        bT: "Livrer"
    }), uhn = Oi({
        bN: "Proceed to delivery",
        bT: "Proc\xe9der \xe0 la livraison"
    }), ahn = Oi({
        bN: "Qualify",
        bT: "Qualifier"
    }), ihn = Oi({
        bN: "All audios are not qualified",
        bT: "Toutes les pistes audios ne sont pas qualifi\xe9es"
    }), ohn = F3(function(n, r, t) {
        var e = !San(n);
        return fmn(n) && function(n) {
            return A3(IK, n.sp, n.oL.mm, A2(Ge, function(n) {
                return n.fz;
            }, n.fB));
        }(n) ? A2(Le, T([
            Rg("ShowTodos")
        ]), T([
            A2(obn, t, A2(thn, ihn, p(oB, {
                ml: kt(Nen),
                m6: ahn,
                sn: kt(A2(Fmn, r.mm, 2))
            }))),
            A2(obn, e, A2(thn, uhn, p(oB, {
                ml: kt(Nen),
                m6: ehn,
                ox: kt(b1(Oin)),
                sn: kt(A2(Fmn, r.mm, 1))
            })))
        ])) : ih("");
    }), chn = F3(function(n, r, t) {
        var e, u, a, o = c$n(r), c = A2(fp, Tx, A2(Fu, di(Bi), Va(A2(Ge, function(n) {
            return n.ss;
        }, A2(Iu, function(n) {
            return "broadcasterShowId" === n.n5;
        }, t.k1.c2))))), s = A2(Aan, Lan(r), t), f = s$n(s), l = (e = s.bQ.fY).$ ? g : e.a.av, d = (u = s.bQ.fY).$ ? g : A2(Yc, Imn, u.a.av), b = (a = s.bQ.fY).$ ? Tt : Va(A2(Yc, Z1, a.a.av)), p = A2(Yc, U1, l), v = A2(kC, hC(function(n) {
            return n.rS;
        }), A2(Ge, function(n) {
            return {
                cz: It(n.cz),
                kK: T([
                    m("Codec", n.aE),
                    m(qmn, Rmn(kt(n))),
                    m(Omn, It(n.cz))
                ]),
                ml: Bmn,
                ft: n.ft,
                m2: n.z + "/" + It(n.ft),
                nc: n.aC,
                rS: $(Mmn, A3(Ym, 2, "0", It(n.ft))),
                r5: n.r5,
                sv: n.sv
            };
        }, p)), h = A2(du, function(n) {
            return i(n.r5, Tt);
        }, p), k = $(function() {
            var n = s.bQ.fY;
            return n.$ ? g : T([
                n.a
            ]);
        }(), A2(Lu, o, s.bQ.d6));
        return T([
            A4(rhn, r, n, {
                co: !0,
                jq: c,
                rS: r.g6.rT
            }, t),
            pan(t),
            A2(Le, T([
                Rg("ShowHomeWrapper")
            ]), T([
                A3(ohn, r, t, h),
                A2(Jgn, r, t),
                A5(ggn, n.mK, r, b, p, t),
                A2(obn, f$n(f), A3(Agn, t, A2(Yc, U1, A2(o$n, A2(Fu, function(n) {
                    return n.mm;
                }, f), k)), d)),
                A5(a$n, n, t, r, v, s),
                A2(obn, !i(r.bP, g), Qq(T([
                    Yq(Sgn)
                ]))),
                A2(dk, k1, A5(Lgn, r, s, A2(Fu, function(n) {
                    return n.n2;
                }, t.o2), A2(fp, function(n) {
                    return n.ro;
                }, t.o2), t.bQ)),
                A3(IK, n.sp, r.g6.oL, A2(Ge, function(n) {
                    return n.fz;
                }, r.fB)) ? Wgn(r) : ih("")
            ]))
        ]);
    }), shn = F3(function(n, r, t) {
        var e = A3(wan, n, r, t), u = A2(han, e.sp, e.g6.oL);
        return gan(e), A2(Le, T([
            Rg("ShowWrapper"),
            Rg(e.g6.ih && u ? "ShowAccepted" : "ShowNoop")
        ]), T([
            A2(Le, T([
                Rg("ShowMain")
            ]), A3(chn, n, e, r)),
            A2(Le, T([
                Rg("ShowAside")
            ]), A2(ibn, e, r))
        ]));
    }), fhn = F2(function(n, r) {
        var t = r.P.kv;
        return 1 === t.$ ? function(n) {
            return A2(Le, T([
                Rg("ShowWrapper")
            ]), T([
                A2(Le, T([
                    Rg("ShowMain")
                ]), T([
                    $w(p(gw, {
                        fo: kt(iz)
                    })),
                    pan(n)
                ])),
                A2(Le, T([
                    Rg("ShowAside")
                ]), g)
            ]));
        }(r) : A3(shn, n, r, t.a);
    }), lhn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mhn = F2(function(n, r) {
        return A2(Le, T([
            Rg("TimelineWrapper")
        ]), T([
            function() {
                var n = r.lm;
                return 1 === n.$ ? ih("") : A2(Uq, Bnn, ih(n.a));
            }(),
            A2(dk, lhn, A2(Le, T([
                Rg("TimelineList")
            ]), A2(lan, n.sp, r.rR)))
        ]));
    }), dhn = A2(Le, T([
        Rg("BrowserWrapper")
    ]), T([
        nen
    ])), bhn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, phn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, vhn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $hn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, ghn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, hhn = Oi({
        bN: "Accepted only",
        bT: "Accept\xe9s seulement"
    }), khn = Oi({
        bN: "Display all",
        bT: "Tout afficher"
    }), Thn = Oi({
        bN: "Non-accepted only",
        bT: "Non-accept\xe9s seulement"
    }), whn = T([
        m(JY, khn),
        m(YY, hhn),
        m(_Y, Thn)
    ]), Chn = Oi({
        bN: "Actives only",
        bT: "Actifs seulement"
    }), Nhn = Oi({
        bN: "Archives only",
        bT: "Archives seulement"
    }), Ahn = Oi({
        bN: "Trash",
        bT: "Corbeille"
    }), Shn = T([
        d(!1, JY, khn),
        d(!1, XY, Chn),
        d(!1, GY, Nhn),
        d(!0, nX, Ahn)
    ]), Lhn = Oi({
        bN: "New",
        bT: "Nouveau"
    }), yhn = Oi({
        bN: "Add Advertiser",
        bT: "Ajouter un Annonceur"
    }), Fhn = Oi({
        bN: "Add Collection",
        bT: "Ajouter une Collection"
    }), jhn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Phn = {
        $: 5
    }, Ihn = A2(Le, T([
        Rg("LoadingMiniSpinner")
    ]), T([
        _gn
    ])), Bhn = Oi({
        bN: "New Ad",
        bT: "Nouveau Spot"
    }), Mhn = Oi({
        bN: "New Advertiser",
        bT: "Nouvel Annonceur"
    }), Ohn = Oi({
        bN: "New Capsule",
        bT: "Nouvelle Capsule"
    }), qhn = Oi({
        bN: "New Collection",
        bT: "Nouvelle Collection"
    }), Dhn = Oi({
        bN: "New Episode",
        bT: "Nouvel Episode"
    }), xhn = Oi({
        bN: "New Master",
        bT: "Nouveau Master"
    }), Rhn = Oi({
        bN: "New Product",
        bT: "Nouveau Produit"
    }), Vhn = Oi({
        bN: "New Season",
        bT: "Nouvelle Saison"
    }), Ehn = Oi({
        bN: "New Title",
        bT: "Nouveau Titre"
    }), zhn = Oi({
        bN: "New Unitary",
        bT: "Nouvel Unitaire"
    }), Uhn = A2(Kg, T([
        zg("18px"),
        Xg("18px"),
        Yg("0 0 18 18"),
        Pg("IconPlus")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 L10,14 L10,10 L14,10 L14,8 L10,8 Z")
            ]), g)
        ]))
    ])), Hhn = F2(function(n, r) {
        var t = function(n) {
            return {
                $: 7,
                a: n
            };
        }(r), e = function() {
            var r = n.of;
            if (r.$) return "";
            if (r.a.$) return 1 === r.a.a ? n.mK ? Bhn : xhn : Ohn;
            switch(r.a.a){
                case 0:
                    return n.mK ? Mhn : qhn;
                case 1:
                    return n.mK ? Rhn : Vhn;
                case 2:
                    return n.mK ? Ehn : Dhn;
                default:
                    return zhn;
            }
        }(), u = n.it;
        return A2(zT, T([
            WT(t),
            Rg("BrowserNewForm")
        ]), T([
            A2(Le, T([
                Rg("BrowserNewFormIcon")
            ]), T([
                function() {
                    var r = n.of;
                    n: for(; !r.$;){
                        if (r.a.$) return 1 === r.a.a ? Arn : Srn;
                        switch(r.a.a){
                            case 0:
                                return Pen;
                            case 1:
                                return Ien;
                            default:
                                break n;
                        }
                    }
                    return Ben;
                }()
            ])),
            A2(dk, jhn, ik(p(u, {
                kV: "new-add-form",
                gt: e
            }))),
            A2(Sg, T([
                Ch("submit"),
                Rg("BrowserNewFormIcon")
            ]), T([
                A2(fX, r, n.rk) ? Ihn : Uhn
            ])),
            A2(Le, T([
                Rg("BrowserNewFormIcon"),
                wh(Phn)
            ]), T([
                JF
            ]))
        ]));
    }), Whn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Qhn = function(n) {
        return wh(n);
    }, Zhn = function(n) {
        var r = n.a, t = n.b, e = n.c;
        return A2(Le, T([
            Rg("BrowserOptionsItem"),
            Qhn(A2(Whn, kt(r), t))
        ]), T([
            ih(e)
        ]));
    }, Khn = Oi({
        bN: "Add Unitary",
        bT: "Ajouter un Unitaire"
    }), Yhn = "alphabeticalInversed", Xhn = Oi({
        bN: "Reverse alphabetical",
        bT: "Alphab\xe9tique invers\xe9"
    }), Jhn = Oi({
        bN: "Alphabetical",
        bT: "Alphab\xe9tique"
    }), Ghn = T([
        m("alphabetical", Jhn),
        m(Yhn, Xhn)
    ]), _hn = {
        $: 16
    }, nkn = Oi({
        bN: "Vous n\u2019avez aucune enveloppe.",
        bT: "Vous n\u2019avez aucune enveloppe."
    }), rkn = function(n) {
        return A2(Le, T([
            Rg("BrowserErrors"),
            wh(_hn)
        ]), T([
            Cu(n.jJ) && Cu(n.fB) ? j7(nkn) : ih(""),
            function() {
                var r = n.lm;
                return r.$ ? ih("") : A2(jnn, Bnn, r.a);
            }()
        ]));
    }, tkn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), ekn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ukn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, akn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ikn = function(n) {
        switch(n){
            case 0:
                return "MixedAccepted";
            case 1:
                return "AcceptedContent";
            case 2:
                return "NonAcceptedContent";
            default:
                return "EmptyAccepted";
        }
    }, okn = F4(function(n, r, t, e) {
        return A2(Le, T([
            Rg("BrowserIcon")
        ]), T([
            A2(fX, r.mm, n) ? t : e
        ]));
    }), ckn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), skn = F3(function(n, r, t) {
        var e = A2(sX, t.mm, n.k1);
        return A2(Le, T([
            Rg("BrowserEdit"),
            Qhn(A2(ckn, r, t))
        ]), T([
            e ? JF : bln
        ]));
    }), fkn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, lkn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, mkn = F2(function(n, r) {
        var t = n.k3;
        return A2(zT, T([
            WT(lkn(r.mm))
        ]), T([
            A2(dk, fkn, ik(t))
        ]));
    }), dkn = Oi({
        bN: "Add Ad",
        bT: "Ajouter un Spot"
    }), bkn = Oi({
        bN: "Add Capsule",
        bT: "Ajouter une Capsule"
    }), pkn = Oi({
        bN: "Add Episode",
        bT: "Ajouter un \xc9pisode"
    }), vkn = Oi({
        bN: "Add Master",
        bT: "Ajouter un Master"
    }), $kn = Oi({
        bN: "Add Product",
        bT: "Ajouter un Produit"
    }), gkn = Oi({
        bN: "Add Season",
        bT: "Ajouter une Saison"
    }), hkn = Oi({
        bN: "Add Title",
        bT: "Ajouter un Titre"
    }), kkn = frn(T([
        A2(BT, T([
            Pg("Fg"),
            Cj("translate(1.000000, 0.000000)")
        ]), T([
            A2(ow, T([
                iw("M6,0 L12,0 L16,4 L16,13 L6,13 L6,0 Z M8,2 L8,11 L14,11 L14,5 L11,5 L11,2 L8,2 Z")
            ]), g),
            A3(Qg, "polygon", T([
                Ug("0 5 5 5 5 7 2 7 2 16 8 16 8 14 10 14 10 18 0 18")
            ]), g)
        ]))
    ])), Tkn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = t.c, i = A2(sX, r.mm, n.is);
            return A2(Le, T([
                Rg("BrowserOptions"),
                wh(i ? Phn : A2(Whn, kt(e), u)),
                Oh(T([
                    m("BrowserOptionsOpened", i)
                ])),
                yB(a)
            ]), T([
                A2(Le, T([
                    Rg("BrowserOptionsTitle")
                ]), T([
                    i ? JF : den
                ]))
            ]));
        }
        var o = t.a;
        return i = A2(sX, r.mm, n.oJ), A2(Le, T([
            Rg("BrowserOptions"),
            wh(ghn(r.mm)),
            TN(i),
            Oh(T([
                m("BrowserOptionsOpened", i)
            ]))
        ]), T([
            A2(Le, T([
                Rg("BrowserOptionsTitle")
            ]), T([
                i ? JF : den
            ])),
            i ? A2(Le, T([
                Rg("BrowserOptionsMenu")
            ]), A2(Ge, Zhn, o)) : ih("")
        ]));
    }), wkn = F4(function(n, r, t, e) {
        var u = t.mK ? $kn : gkn, a = t.mK ? dkn : vkn, o = t.mK ? hkn : pkn, c = i(t.qr, kt(e.mm)), s = A2(fX, e.mm, t.oB), f = A2(sX, e.mm, t.is), l = 2 === e.gf && KY(e), b = 1 !== e.gf && !l;
        if (f || b) {
            var p = e.eA;
            if (p.$) return v = p.a, m(e.mm, A2(Le, T([
                Rg("BrowserTitle"),
                Oh(T([
                    m("BrowserTitleOpened", A2(sX, e.mm, r)),
                    m("BrowserTitleHidden", c && !b)
                ])),
                Rg("BrowserItemWrapper")
            ]), T([
                A2(aw, T([
                    Yh(e.mm),
                    Rg("BrowserItem"),
                    sw(dX(e.mm))
                ]), T([
                    A2(Le, T([
                        Rg("BrowserIcon")
                    ]), T([
                        1 === v ? Arn : Srn
                    ])),
                    A2(mh, T([
                        Rg(1 === v ? "BrowserLabelMaster" : "BrowserLabelShow")
                    ]), T([
                        A2(sX, e.mm, t.k1) ? A2(mkn, t, e) : ih(e.m6)
                    ])),
                    e.ih ? A2(Le, T([
                        Rg("BrowserIcon")
                    ]), T([
                        A2(mh, T([
                            Rg("BrowserShowAccepted")
                        ]), g)
                    ])) : ih(""),
                    e.h2 ? A2(Le, T([
                        Rg("BrowserIcon")
                    ]), T([
                        _en
                    ])) : KY(e) ? A2(Le, T([
                        Rg("BrowserIcon")
                    ]), T([
                        Gen
                    ])) : ih("")
                ])),
                A2(sX, e.oL, n.sp.oL) ? A3(skn, t, kt(akn(v)), e) : ih(""),
                A2(fX, e.mm, t.oB) ? A2(Le, T([
                    Rg("BrowserList")
                ]), T([
                    A2(sX, e.mm, t.is) ? A2(Hhn, t, e.mm) : ih("")
                ])) : ih("")
            ])));
            var v = p.a, h = p.b, k = function() {
                switch(v){
                    case 0:
                        return d(m("BrowserCollection", 0), m(lrn, Pen), m(A3(tkn, vhn(1), e.mm, u), kt(drn(e.mm))));
                    case 1:
                        return d(m("BrowserSeason", 1), m(kkn, Ien), m(A3(tkn, vhn(2), e.mm, o), kt(drn(e.mm))));
                    case 2:
                        return d(m("BrowserEpisode", 2), m(Ben, Ben), m(ekn(T([
                            d(akn(1), e.mm, a),
                            d(akn(0), e.mm, bkn)
                        ])), kt(drn(e.mm))));
                    default:
                        return d(m("BrowserCollection", 3), m(Ben, Ben), m(ekn(T([
                            d(akn(1), e.mm, vkn),
                            d(akn(0), e.mm, bkn)
                        ])), kt(drn(e.mm))));
                }
            }(), w = k.b, C = w.a, N = w.b, A = k.c, S = A.a, L = A.b;
            return m(e.mm, A2(Le, T([
                Rg(k.a.a),
                Rg(ikn(e.dT))
            ]), T([
                A2(Le, T([
                    Rg("BrowserItemWrapper"),
                    Oh(T([
                        m("BrowserOpened", s),
                        m("BrowserAdding", f),
                        m("BrowserEmpty", 2 === e.gf),
                        m("BrowserShowAccepted", 1 === e.dT),
                        m("BrowserTitleOpened", A2(sX, e.mm, r)),
                        m("BrowserHasMenuOpened", A2(sX, e.mm, t.oJ))
                    ]))
                ]), $(T([
                    A2(Le, T([
                        Rg("BrowserItem"),
                        wh(ukn(e.mm))
                    ]), T([
                        A4(okn, t.oB, e, C, N),
                        A2(mh, T([
                            Rg("BrowserLabelMaster")
                        ]), T([
                            A2(sX, e.mm, t.k1) ? A2(mkn, t, e) : ih(e.m6)
                        ])),
                        e.h2 ? A2(Le, T([
                            Rg("BrowserIcon")
                        ]), T([
                            _en
                        ])) : 1 === e.hs ? A2(Le, T([
                            Rg("BrowserIcon")
                        ]), T([
                            Gen
                        ])) : ih("")
                    ])),
                    function() {
                        var r = m(L, A2(sX, e.oL, n.sp.oL));
                        if (!r.a.$ && r.b) {
                            var t = r.a.a;
                            return A2(aw, T([
                                Rg("BrowserAttachment"),
                                sw(t),
                                Yh(e.mm)
                            ]), T([
                                Lun
                            ]));
                        }
                        return ih("");
                    }()
                ]), A2(sX, e.oL, n.sp.oL) ? T([
                    A3(skn, t, kt(vhn(v)), e),
                    A3(Tkn, t, e, S)
                ]) : g)),
                s ? A3(kk, "div", T([
                    Rg("BrowserList"),
                    Oh(T([
                        m("BrowserListOpened", s),
                        m("BrowserAdding", f)
                    ]))
                ]), (i(t.oK.ss, Yhn) ? Kt : Ie)(A2(Ge, A3(wkn, n, r, t), h))) : ih(""),
                f ? A2(Le, g, T([
                    A2(Hhn, t, e.mm)
                ])) : ih("")
            ])));
        }
        return m(e.mm, ih(""));
    }), Ckn = F3(function(n, r, t) {
        return A2(dt, m("head", function() {
            var n = Va(t.jJ);
            if (n.$) return ih("");
            var r, e = n.a;
            return A2(Dh, T([
                Rg("BrowserSection")
            ]), Oi({
                bN: (r = e.gj) + "\u2019s Stock",
                bT: "Stock de " + r
            }));
        }()), (i(t.oK.ss, Yhn) ? Kt : Ie)(A2(Ge, A3(wkn, n, r, t), t.jJ)));
    }), Nkn = F3(function(n, r, t) {
        var e = function(n) {
            return vt(n);
        }(Bs(A2(Ge, function(n) {
            return n.gj;
        }, A2(Iu, function(r) {
            return i(KY(r), n.d1);
        }, t.fB))));
        return A2(dt, m("Invitations", A2(Dh, T([
            Rg("BrowserSection")
        ]), "Invitations")), A2(Ge, function(e) {
            return m(e, A3(kk, "div", g, A2(dt, m("org", A2(Dh, T([
                Rg("BrowserSubSection")
            ]), e)), A2(Ge, A3(wkn, n, r, t), A2(Iu, function(n) {
                return i(n.gj, e);
            }, t.fB)))));
        }, e));
    }), Akn = F3(function(n, r, t) {
        var e = t.mK ? yhn : Fhn, u = T(t.mK ? [
            d(vhn(0), "", e)
        ] : [
            d(vhn(0), "", e),
            d(vhn(3), "", Khn)
        ]), a = A2(sX, "", t.oJ), o = !i(n.sp.oL, Tt), c = A2(Yc, function(r) {
            return r.a && !n.sp.iw ? Tt : kt(m(r.b, r.c));
        }, Shn);
        return A2(Le, T([
            Rg("BrowserWrapper")
        ]), T([
            A2(Le, T([
                Rg("BrowserHeader")
            ]), T([
                A2(Le, T([
                    Rg("BrowserOrder")
                ]), T([
                    A2(dk, phn, A2(VT, t.iR, c)),
                    A2(dk, bhn, A2(VT, t.ii, whn)),
                    A2(dk, $hn, A2(VT, t.oK, Ghn))
                ])),
                A2(Le, T([
                    Rg("BrowserNewButton")
                ]), T([
                    o ? FB(p(oB, {
                        lv: T([
                            TN(a)
                        ]),
                        ml: kt(den),
                        mI: a,
                        m6: Lhn,
                        ox: kt(ghn(""))
                    })) : ih(""),
                    A2(sX, "", t.oJ) ? A2(Le, T([
                        Rg("BrowserOptionsMenu")
                    ]), A2(Ge, Zhn, u)) : ih("")
                ]))
            ])),
            A2(Le, T([
                Rg("BrowserNew")
            ]), T([
                A2(sX, "", t.is) ? A2(Hhn, t, "") : ih("")
            ])),
            rkn(t),
            A2(Le, T([
                Rg("Browser")
            ]), T([
                A3(kk, "div", g, A3(Ckn, n, r, t)),
                A3(kk, "div", g, A3(Nkn, n, r, t))
            ]))
        ]));
    }), Skn = F3(function(n, r, t) {
        return 1 === t.P.kv.$ ? dhn : A3(Akn, n, r, t);
    }), Lkn = F5(function(n, r, t, e, u) {
        return A3(kk, "div", T([
            Rg("ShowsWrapper"),
            Rg(r.sn.$ ? "ActiveShow" : "ActiveShows")
        ]), T([
            m("Browser", A2(dk, Ni, A3(Skn, r, t, e))),
            m(n, u)
        ]));
    }), ykn = {
        $: 3
    }, Fkn = gN(hp(Vp)), jkn = gN(hp(rv)), Pkn = gN(hp(tv)), Ikn = gN(hp(Ep)), Bkn = gN(hp(Up)), Mkn = gN(hp(Hp)), Okn = function(n) {
        return 4 === n.$ && 18 === n.a.$;
    }, qkn = function(n) {
        return 4 === n.$ && 14 === n.a.$;
    }, Dkn = gN(hp(Zp)), xkn = gN(hp(Kp)), Rkn = gN(hp(Yp)), Vkn = gN(hp(Xp)), Ekn = gN(hp(Jp)), zkn = Oi({
        bN: "Report",
        bT: "Rapport"
    }), Ukn = gN(Cp), Hkn = gN(hp(Gp)), Wkn = gN(hp(_p)), Qkn = gN(hp(nv)), Zkn = F3(function(n, r, t) {
        return A2(aw, T([
            Oh(T([
                m("MenuSettingsActive", n)
            ])),
            Rg("MenuSettingsItem"),
            sw(r)
        ]), T([
            t
        ]));
    }), Kkn = gN(hp(ev)), Ykn = gN(hp(uv)), Xkn = function(n) {
        var r;
        return A2(Le, T([
            Rg("MenuSettingsSub")
        ]), T([
            A3(Zkn, Okn(n.sn), hN({
                c$: Tt
            }), ih("Dashboard")),
            A3(Zkn, i(n.sn, Cp), Ukn, ih(zkn)),
            A3(Zkn, i(n.sn, hp(Xp)), Vkn, ih("Organizations")),
            A3(Zkn, i(n.sn, hp(Kp)), xkn, ih("Onboarding")),
            A3(Zkn, i(n.sn, hp(ev)), Kkn, ih("Users")),
            A3(Zkn, i(n.sn, hp(tv)), Pkn, ih("Uploads")),
            A3(Zkn, i(n.sn, hp(rv)), jkn, ih("Test Plans")),
            A3(Zkn, i(n.sn, hp(Vp)), Fkn, ih("Audio Mappings")),
            A3(Zkn, i(n.sn, hp(Ep)), Ikn, ih("Channels")),
            A3(Zkn, i(n.sn, hp(Gp)), Hkn, ih("Researchs")),
            A3(Zkn, i(n.sn, hp(uv)), Ykn, ih("Webhooks")),
            A3(Zkn, i(n.sn, hp(Yp)), Rkn, ih("Organization file listing")),
            A3(Zkn, i(n.sn, hp(Hp)), Mkn, ih("Formats")),
            A3(Zkn, i(n.sn, hp(nv)), Qkn, ih("Subtitle Formats")),
            A3(Zkn, i(n.sn, hp(_p)), Wkn, ih("Segmentation rules")),
            A3(Zkn, qkn(n.sn), (r = A4(ov, Tt, Tt, Tt, Tt), gN(hp(Qp(r)))), ih("Jobs")),
            A3(Zkn, i(n.sn, hp(Zp)), Dkn, ih("Metadata")),
            A3(Zkn, i(n.sn, hp(Up)), Bkn, ih("Deep Probe Templates")),
            A3(Zkn, i(n.sn, hp(Jp)), Ekn, ih("Deep Probes")),
            A3(Zkn, i(n.sn, hp(Wp)), orn, ih("Flubber"))
        ]));
    }, Jkn = A2(Kg, T([
        zg("40px"),
        Xg("40px"),
        Yg("0 0 27 27"),
        Pg("IconSettings")
    ]), T([
        A2(BT, T([
            Pg("Fg")
        ]), T([
            A2(ow, T([
                iw("M11.3255145,8.62757252 L11.7398554,10.6992769 C10.6891763,11.4201032 10,12.6295687 10,14 C10,16.209139 11.790861,18 14,18 C16.209139,18 18,16.209139 18,14 C18,12.6295687 17.3108237,11.4201032 16.2601446,10.6992769 L16.6744855,8.62757252 C18.6458726,9.61086325 20,11.6472949 20,14 C20,17.3137085 17.3137085,20 14,20 C10.6862915,20 8,17.3137085 8,14 C8,11.6472949 9.35412735,9.61086325 11.3255145,8.62757252 Z M13,7 L15,7 L15,15 L13,15 L13,7 Z")
            ]), g)
        ]))
    ])), Gkn = Oi({
        bN: "Logout",
        bT: "D\xe9connexion"
    }), _kn = function(n) {
        return A2(Le, T([
            Rg("MenuSettingsSub")
        ]), T([
            A3(Zkn, i(n.sn, Cp), Ukn, ih(zkn))
        ]));
    }, nTn = F3(function(n, r, t) {
        var e, u;
        return A3(kk, "div", T([
            Rg("SettingsWrapper")
        ]), T([
            m("SettingsMenu", A2(dk, pW, (e = r, u = 8 === e.sn.$, A2(Le, T([
                Rg("MenuSettings")
            ]), T([
                e.sp.iw ? Xkn(e) : _kn(e),
                A2(aw, T([
                    Rg("MenuSettingsItem"),
                    Rg("MenuSettingsProfile"),
                    sw(Trn),
                    Oh(T([
                        m("MenuSettingsActive", u)
                    ]))
                ]), T([
                    A2(Le, T([
                        Rg("MenuSettingsIcon")
                    ]), T([
                        jrn
                    ])),
                    A2(Le, T([
                        Rg("MenuSettingsTitle")
                    ]), T([
                        A2(Le, T([
                            Rg("UserCardName")
                        ]), T([
                            ih(e.sp.n5)
                        ]))
                    ]))
                ])),
                A2(Le, T([
                    Rg("MenuSettingsItem"),
                    Rg("MenuSettingsLogout"),
                    wh(ykn)
                ]), T([
                    A2(Le, T([
                        Rg("MenuSettingsIcon")
                    ]), T([
                        Jkn
                    ])),
                    A2(Le, T([
                        Rg("MenuSettingsTitle")
                    ]), T([
                        ih(Gkn)
                    ]))
                ]))
            ]))))),
            m(n, t)
        ]));
    }), rTn = function(n) {
        if (1 === n.$) return A2(dk, Li, function(n) {
            var r = 1 === n.ak.sn.$ ? A2(mnn, tnn, pnn) : g;
            return A2(Le, A2(dt, Oh(T([
                m("IsFullscreen", n.ak.dN.mP),
                m("AsideOpened", function() {
                    var r = n.ak.sn;
                    switch(r.$){
                        case 1:
                        case 2:
                            return !!r.b;
                        default:
                            return !1;
                    }
                }())
            ])), r), T([
                A2(Le, T([
                    Rg("AppWrapper")
                ]), T([
                    Frn(n),
                    A3(kk, "div", T([
                        Rg("Wrapper")
                    ]), T([
                        m("Menu", A3($nn, pW, Krn, n.ak)),
                        function() {
                            var r = n.ak.sn;
                            switch(r.$){
                                case 8:
                                    return m("Settings", A3(nTn, "", n.ak, A4(wnn, yi, ern, n.ak, n.dp)));
                                case 9:
                                    return m("Report", A3(nTn, "", n.ak, A4(wnn, bK, Rnn, n.ak, n.b9)));
                                case 0:
                                    return m("APP", A5(Lkn, "Shows", n.ak, Tt, n.el, A4(wnn, Fi, mhn, n.ak, n.rR)));
                                case 2:
                                    return m("APP", A5(Lkn, "Hierarchy", n.ak, kt(r.a), n.el, A5(Cnn, gv, ban, n.ak, n.ok, n.el)));
                                case 1:
                                    return m("APP", A5(Lkn, "Show", n.ak, kt(r.a), n.el, A4(wnn, hv(n.g6.mm), fhn, n.ak, n.g6)));
                                case 6:
                                    return m("APP", A5(Lkn, "Archive", n.ak, Tt, n.el, A4(wnn, Fi, mhn, n.ak, n.rR)));
                                case 4:
                                    return m("Admin", A3(nTn, "", n.ak, A5(Cnn, Ci, arn, n.ak, r.a, n.iw)));
                                case 5:
                                    return m("Help", function(n) {
                                        var r = n.oU;
                                        if (r.$) return A2(Le, T([
                                            Rg("SettingsWrapper")
                                        ]), T([
                                            Nj
                                        ]));
                                        if (r.a.$) return ih("Erreur 404");
                                        var t = r.a.a;
                                        return A2(Le, T([
                                            Rg("SettingsWrapper")
                                        ]), T([
                                            A3(hw, t.rS, Tt, A2(Le, T([
                                                Rg("Help")
                                            ]), T([
                                                Jtn(t.eh)
                                            ])))
                                        ]));
                                    }(n.l5));
                                case 7:
                                    return m("Upload", A4(wnn, gW, Htn, {
                                        e$: n.ak.e$,
                                        mk: vnn(n.k_),
                                        oU: s7(n),
                                        sp: n.ak.sp
                                    }, n.sg));
                                default:
                                    return m("notfound", A2(Le, T([
                                        Rg("SettingsWrapper")
                                    ]), T([
                                        ih("NOT FOUND")
                                    ])));
                            }
                        }()
                    ])),
                    A4(wnn, gW, Htn, {
                        e$: n.ak.e$,
                        mk: vnn(n.k_),
                        oU: s7(n),
                        sp: n.ak.sp
                    }, n.sg)
                ]))
            ]));
        }(n.a));
        var r = n.a;
        return function(n) {
            return A2(Le, T([
                Rg("AccountPageWrapper")
            ]), T([
                A2(Le, g, T([
                    A2(aw, T([
                        Rg("AccountPageLogo"),
                        sw("/")
                    ]), T([
                        Q7
                    ]))
                ])),
                A2(Le, T([
                    Rg("AccountPageContent")
                ]), n)
            ]));
        }(T([
            function() {
                var n = r.oU;
                switch(n.$){
                    case 0:
                        var t = n.a;
                        return A2(dk, A2(bu, lW, bZ), function(n) {
                            var r = 2 !== n.q$;
                            return A2(p7, QZ, T([
                                A2(Le, T([
                                    Rg("AccountHeader")
                                ]), T([
                                    A2(Dh, T([
                                        Rg("AccountTitle")
                                    ]), O7)
                                ])),
                                A2(Le, T([
                                    Rg("AccountFormFields")
                                ]), T([
                                    A2(dk, B7, IT(n.k8)),
                                    A2(Le, T([
                                        Oh(T([
                                            m("AccountFormPassword", !0),
                                            m("AccountFormPasswordHide", r)
                                        ]))
                                    ]), T([
                                        A2(dk, M7, xz(n.oZ))
                                    ]))
                                ])),
                                A2(Le, T([
                                    Rg("AccountMessage")
                                ]), T([
                                    E7(n.nO)
                                ])),
                                A2(Le, T([
                                    Rg("AccountFooter")
                                ]), T([
                                    A2(Le, T([
                                        Rg("AccountFooterLinks")
                                    ]), T([
                                        A2(FF, !r, A2(v7, D7, x7))
                                    ])),
                                    QT(r ? R7 : q7)
                                ]))
                            ]));
                        }(t));
                    case 1:
                        return t = n.a, A2(dk, A2(bu, lW, mZ), function(n) {
                            return A2(p7, d7, T([
                                A2(Le, T([
                                    Rg("AccountHeader")
                                ]), T([
                                    A2(Dh, T([
                                        Rg("AccountTitle")
                                    ]), k7)
                                ])),
                                A2(Le, T([
                                    Rg("AccountFormFields")
                                ]), T([
                                    A2(dk, m7, IT(n.k8))
                                ])),
                                A2(Le, T([
                                    Rg("AccountMessage")
                                ]), T([
                                    function() {
                                        var r = n.nO;
                                        switch(r.$){
                                            case 0:
                                                return ih("");
                                            case 1:
                                                return A2(Dh, T([
                                                    Rg("succeed")
                                                ]), w7);
                                            default:
                                                var t = r.a;
                                                return A2(Dh, T([
                                                    Rg("failed")
                                                ]), t);
                                        }
                                    }()
                                ])),
                                A2(Le, T([
                                    Rg("AccountFooter")
                                ]), T([
                                    A2(Le, T([
                                        Rg("AccountFooterLinks")
                                    ]), T([
                                        A2(v7, h7, b7)
                                    ])),
                                    QT(T7)
                                ]))
                            ]));
                        }(t));
                    case 2:
                        return t = n.a, A2(dk, A2(bu, lW, pZ), function(n) {
                            var r;
                            return A2(p7, Y7, T([
                                A2(Le, T([
                                    Rg("AccountHeader")
                                ]), T([
                                    A2(Dh, T([
                                        Rg("AccountTitle")
                                    ]), _7)
                                ])),
                                A2(Le, T([
                                    Rg("AccountFormFields")
                                ]), T([
                                    A2(dk, K7, G7(n.oZ)),
                                    A2(dk, Z7, G7(n.j3)),
                                    rnn(n.nO),
                                    (r = n.o_, r.$ ? ih("") : j7(P7(r.a)))
                                ])),
                                A2(Le, T([
                                    Rg("AccountFooter")
                                ]), T([
                                    A2(Le, T([
                                        Rg("AccountFooterLinks")
                                    ]), T([
                                        A2(v7, h7, X7)
                                    ])),
                                    QT(J7)
                                ]))
                            ]));
                        }(t));
                    default:
                        return t = n.a, A2(dk, A2(bu, lW, dZ), function(n) {
                            var r;
                            return A2(p7, L7, T([
                                A2(Le, T([
                                    Rg("AccountHeader")
                                ]), T([
                                    A2(Dh, T([
                                        Rg("AccountTitle")
                                    ]), y7)
                                ])),
                                A2(Le, T([
                                    Rg("AccountFormFields")
                                ]), T([
                                    A2(dk, N7, IT(n.n5)),
                                    A2(dk, S7, xz(n.oZ)),
                                    A2(dk, C7, xz(n.j3)),
                                    (r = n.o_, r.$ ? ih("") : j7(P7(r.a)))
                                ])),
                                A2(Le, T([
                                    Rg("AccountMessage")
                                ]), T([
                                    A2(wT, Dh(T([
                                        Rg("failed")
                                    ])), n.lm)
                                ])),
                                A2(Le, T([
                                    Rg("AccountFooter")
                                ]), T([
                                    A2(Le, T([
                                        Rg("AccountFooterLinks")
                                    ]), g),
                                    QT(I7)
                                ]))
                            ]));
                        }(t));
                }
            }()
        ]));
    }, tTn = function(n) {
        switch(n.$){
            case 0:
                return It(n.a) + "px";
            case 1:
                return mL(n.a) + "%";
            case 2:
                return mL(n.a) + "em";
            default:
                return "auto";
        }
    }, eTn = Cdn, uTn = function(n) {
        return A2(eTn, "bottom", tTn(n));
    }, aTn = function(n) {
        return A2(eTn, "left", tTn(n));
    }, iTn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, oTn = iTn, cTn = {
        $8: A2(eTn, "position", "absolute"),
        lI: A2(eTn, "position", "fixed"),
        dj: A2(eTn, "position", "relative"),
        q8: A2(eTn, "position", "static"),
        hv: A2(eTn, "position", "sticky")
    }, sTn = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, fTn = function(n) {
        return A2(eTn, "top", tTn(n));
    }, lTn = F3(function(n, r, t) {
        return oTn(T([
            cTn.$8,
            fTn(sTn(n)),
            uTn(sTn(r)),
            aTn(sTn(t))
        ]));
    }), mTn = function(n) {
        return A2(eTn, "right", tTn(n));
    }, dTn = F4(function(n, r, t, e) {
        return oTn(T([
            cTn.$8,
            fTn(sTn(n)),
            mTn(sTn(r)),
            uTn(sTn(t)),
            aTn(sTn(e))
        ]));
    }), bTn = F2(function(n, r) {
        return A2(Hk, r, va(T([
            Ek(n)
        ])));
    }), pTn = bTn, vTn = {
        jg: A2(eTn, "display", "block"),
        lL: A2(eTn, "display", "flex"),
        mo: A2(eTn, "display", "inline"),
        mp: A2(eTn, "display", "inline-block"),
        mq: A2(eTn, "display", "inline-flex"),
        mr: A2(eTn, "display", "inline-table"),
        ni: A2(eTn, "display", "list-item"),
        ol: A2(eTn, "display", "none"),
        pV: A2(eTn, "display", "run-in"),
        rz: A2(eTn, "display", "table"),
        rB: A2(eTn, "display", "table-caption"),
        rC: A2(eTn, "display", "table-cell"),
        rD: A2(eTn, "display", "table-column"),
        rE: A2(eTn, "display", "table-column-group"),
        rF: A2(eTn, "display", "table-footer-group"),
        rG: A2(eTn, "display", "table-header-group"),
        rH: A2(eTn, "display", "table-row"),
        rI: A2(eTn, "display", "table-row-group")
    }, $Tn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), gTn = $Tn(3), hTn = gTn, kTn = F2(function(n, r) {
        return A2(Hk, r, A2(ba, n, g));
    }), TTn = kTn, wTn = F2(function(n, r) {
        return A2(TTn, "", T([
            hTn(A2(Ge, ce(r), n))
        ]));
    }), CTn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, NTn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ATn = F2(function(n, r) {
        var t = A2(Gu, Ja, r), e = function(r) {
            n: for(;;){
                if (!r.b) return g;
                switch(r.a.$){
                    case 0:
                        r = a = r.b;
                        continue n;
                    case 1:
                        var t = r.a, u = t.b, a = r.b;
                        return A2(dt, A2(NTn, A2(Lu, n, t.a), u), e(a));
                    default:
                        return A2(dt, r.a, e(a = r.b));
                }
            }
        }, u = function(n) {
            n: for(;;){
                if (n.b) {
                    if (n.a.$) {
                        n = n.b;
                        continue n;
                    }
                    return A2(dt, n.a.a, u(n.b));
                }
                return g;
            }
        }, a = A2(NTn, n, u(t));
        return A2(dt, a, e(t));
    }), STn = F2(function(n, r) {
        return A2(ATn, A2(Ge, CTn, n), r);
    }), LTn = STn, yTn = function(n) {
        return {
            i8: A2(eTn, n, "auto"),
            l6: A2(eTn, n, "hidden"),
            p8: A2(eTn, n, "scroll"),
            sD: A2(eTn, n, "visible")
        };
    }, FTn = yTn("overflow"), jTn = T([
        A2(LTn, T([
            "(min-width: 1400px)"
        ]), T([
            A2(wTn, T([
                pTn("LayoutBackButton"),
                pTn("LayoutHomeButton"),
                pTn("LayoutFwdButton")
            ]), T([
                vTn.ol
            ])),
            A2(wTn, T([
                pTn("SettingsWrapper"),
                pTn("ShowsWrapper")
            ]), T([
                A4(dTn, 0, 0, 0, 94),
                FTn.l6
            ])),
            A2(pTn, "BrowserWrapper", T([
                A3(lTn, 0, 0, 0)
            ])),
            A2(wTn, T([
                pTn("TimelineWrapper"),
                pTn("ShowWrapper"),
                pTn("MasterWrapper")
            ]), T([
                A4(dTn, 0, 0, 0, 404)
            ]))
        ]))
    ]), PTn = eTn("animation"), ITn = T([
        A2(pTn, "IsFullscreen", T([
            hTn(T([
                A2(pTn, "ShowPlayer", T([
                    PTn("none")
                ]))
            ]))
        ]))
    ]), BTn = function(n) {
        return A2(eTn, "flex-basis", tTn(n));
    }, MTn = {
        jW: A2(eTn, "flex-direction", "column"),
        jX: A2(eTn, "flex-direction", "column-reverse"),
        pQ: A2(eTn, "flex-direction", "row"),
        pT: A2(eTn, "flex-direction", "row-reverse")
    }, OTn = oTn(T([
        vTn.lL,
        MTn.jW
    ])), qTn = A2(bu, eTn("flex-shrink"), It), DTn = function(n) {
        return A2(eTn, "height", tTn(n));
    }, xTn = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, RTn = F3(function(n, r, t) {
        return A2(pTn, n, T([
            hTn(T([
                A2(pTn, r, t)
            ]))
        ]));
    }), VTn = eTn("transition"), ETn = oTn(T([
        VTn("all cubic-bezier(0.8, 0, 0.1, 1) 80ms")
    ])), zTn = eTn("transform"), UTn = F3(function(n, r, t) {
        return zTn("translate3d(" + It(n) + "px," + It(r) + "px," + It(t) + "px)");
    }), HTn = Cdn, WTn = T([
        A2(LTn, T([
            "(min-width: 1000px) and (max-width: 1400px)"
        ]), T([
            A2(pTn, "ShowWrapper", T([
                qTn(0),
                BTn(xTn(100)),
                ETn
            ])),
            A2(wTn, T([
                pTn("ShowWrapper")
            ]), T([
                A3(UTn, 404, 0, 0),
                A4(dTn, 0, 0, 0, 0)
            ])),
            A2(pTn, "TimelineWrapper", T([
                A4(dTn, 0, 0, 0, 404)
            ])),
            A2(pTn, "MasterWrapper", T([
                A4(dTn, 0, 0, 0, 404)
            ])),
            A2(pTn, "ShowsWrapper", T([
                OTn,
                A4(dTn, 0, 0, 0, 94),
                FTn.l6
            ])),
            A2(pTn, "SettingsWrapper", T([
                A4(dTn, 0, 0, 0, 94),
                FTn.l6
            ])),
            A2(pTn, "BrowserWrapper", T([
                ETn,
                A3(lTn, 0, 0, 0)
            ])),
            A2(pTn, "ShowMain", T([
                A2(HTn, "width", "calc(100% - 404px)"),
                qTn(0)
            ])),
            A2(TTn, ".ShowMain:only-child", T([
                cTn.$8,
                DTn(xTn(100))
            ])),
            A2(pTn, "LayoutBackButton", T([
                vTn.ol
            ])),
            A2(pTn, "LayoutHomeButton", T([
                vTn.ol
            ])),
            A2(pTn, "AsideOpened", T([
                hTn(T([
                    A2(pTn, "ShowWrapper", T([
                        A3(UTn, 0, 0, 0)
                    ])),
                    A2(pTn, "BrowserWrapper", T([
                        A3(UTn, -404, 0, 0)
                    ])),
                    A2(pTn, "LayoutBackButton", T([
                        vTn.lL
                    ])),
                    A3(RTn, "ShowMain", "LayoutFwdButton", T([
                        vTn.ol
                    ]))
                ]))
            ]))
        ]))
    ]), QTn = oTn(T([
        vTn.lL,
        MTn.pQ
    ])), ZTn = T([
        A2(pTn, "AppWrapper", T([
            QTn,
            A4(dTn, 4, 4, 4, 4),
            A3(UTn, 0, 0, 0),
            FTn.l6
        ])),
        A2(pTn, "Wrapper", T([
            QTn,
            A4(dTn, 44, 0, 0, 0),
            A3(UTn, 0, 0, 0),
            FTn.l6
        ]))
    ]), KTn = F2(function(n, r) {
        return wTn(A2(Ge, n, r));
    }), YTn = {
        $: 3
    }, XTn = F2(function(n, r) {
        return A2(eTn, "border", It(n) + "px solid " + r);
    }), JTn = {
        jk: A2(eTn, "clear", "both"),
        c0: A2(eTn, "clear", "left"),
        ol: A2(eTn, "clear", "none"),
        pO: A2(eTn, "clear", "right")
    }, GTn = eTn("color"), _Tn = HTn("fill"), nwn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), rwn = function(n) {
        return nwn(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, twn = rwn("first-child"), ewn = twn, uwn = {
        c0: A2(eTn, "float", "left"),
        ol: A2(eTn, "float", "none"),
        pO: A2(eTn, "float", "right")
    }, awn = {
        ji: A2(eTn, "font-weight", "600"),
        jj: A2(eTn, "font-weight", "700"),
        ng: A2(eTn, "font-weight", "400"),
        om: A2(eTn, "font-weight", "500")
    }, iwn = function(n) {
        return gTn(T([
            A2(bTn, "Fg", T([
                A2(HTn, "fill", n)
            ]))
        ]));
    }, own = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cwn = F2(function(n, r) {
        return A2(Hk, r, va(T([
            own(n)
        ])));
    }), swn = cwn, fwn = function(n) {
        return A2(eTn, "margin", tTn(n));
    }, lwn = function(n) {
        return A2(eTn, "margin-top", tTn(n));
    }, mwn = function(n) {
        return A2(eTn, "opacity", mL(n / 100));
    }, dwn = function(n) {
        return A2(eTn, "padding", tTn(n));
    }, bwn = function(n) {
        return A2(eTn, "width", tTn(n));
    }, pwn = function(n) {
        return nwn(Ek(n));
    }, vwn = sTn(0), $wn = T([
        A2(LTn, T([
            "print"
        ]), T([
            A2(TTn, ".Button", T([
                A2(HTn, "display", "none !important")
            ])),
            A2(pTn, "IconBreadcrumb", T([
                _Tn(Jun)
            ])),
            A2(pTn, "Private", T([
                FTn.p8
            ])),
            A2(pTn, "HeaderLogo", T([
                fTn(YTn),
                aTn(YTn)
            ])),
            A3(KTn, TTn, T([
                "button",
                "form"
            ]), T([
                A2(HTn, "display", "none !important")
            ])),
            A2(swn, "player", T([
                A2(HTn, "display", "none !important")
            ])),
            A3(KTn, pTn, T([
                "MasterFilesDesc"
            ]), T([
                A2(HTn, "display", "flex !important")
            ])),
            A3(KTn, TTn, T([
                ".ActivityItem",
                "tr"
            ]), T([
                A2(HTn, "page-break-inside", "avoid")
            ])),
            A3(KTn, pTn, T([
                "Search",
                "MenuWrapper",
                "BrowserWrapper",
                "PlayerVideoWrapper",
                "LayoutFwdButton",
                "LayoutHomeButton",
                "LayoutAppBarActions",
                "LayoutBackButton",
                "CustomButton",
                "PadokUploadWrapper",
                "ProgressBarOuter",
                "ActivityHeader",
                "ButtonMiniIcon",
                "ActivityAnswerForm",
                "FileOperationLabelProgress",
                "FileOperationProgress",
                "FileOperationIcon",
                "PadokUploadWrapper",
                "DeliveryChild",
                "UploadChild",
                "PlayerFoldPreview",
                "AcceptationHeaderActions",
                "Button",
                "ReportLinksButton",
                "HeaderLogo",
                "Acceptation",
                "LayoutAppBarWrapper",
                "FileOperation",
                "ActivityHeader",
                "ActivityCommentForm",
                "Operations"
            ]), T([
                A2(HTn, "display", "none !important")
            ])),
            A2(pTn, "HeaderBreadcrumbLabel", T([
                GTn(Kun),
                awn.ji
            ])),
            A2(pTn, "HeaderBreadcrumb", T([
                iwn(Kun + "!important"),
                A2(XTn, 3, Kun),
                lwn(sTn(8))
            ])),
            A2(pTn, "IconBreadcrumb", T([
                ewn(T([
                    vTn.ol
                ]))
            ])),
            A2(pTn, "ActivityItem", T([
                A2(HTn, "order", "10"),
                A2(pwn, "RedFlag", T([
                    A2(HTn, "order", "1")
                ]))
            ])),
            A2(pTn, "ActivityContent", T([
                A2(XTn, 0, "!important")
            ])),
            A2(pTn, "ActivityItem", T([
                A2(XTn, 2, Kun)
            ])),
            A2(TTn, ".ActivityVerificationMessage:after", T([
                A2(HTn, "content", '" "'),
                JTn.jk,
                vTn.jg,
                DTn(sTn(1))
            ])),
            A2(pTn, "ActivityCommentVerifTc", T([
                uwn.c0,
                fwn(sTn(5)),
                hTn(T([
                    A2(pTn, "ButtonIcon", T([
                        mwn(0)
                    ])),
                    A2(pTn, "TimecodeWrapper", T([
                        A2(XTn, 2, Qun)
                    ])),
                    A2(pTn, "TimecodeUnit", T([
                        GTn(Qun)
                    ]))
                ]))
            ])),
            A3(KTn, pTn, T([
                "AppWrapper",
                "Wrapper",
                "ShowsWrapper",
                "ShowWrapper",
                "ShowMain",
                "ShowAside",
                "ShowHomeWrapper",
                "MasterFilesWrapper"
            ]), T([
                zTn("translate(0,0)"),
                bwn(YTn),
                DTn(YTn),
                fTn(vwn),
                mTn(vwn),
                uTn(vwn),
                aTn(vwn),
                A2(HTn, "overflow", "unset !important"),
                A2(HTn, "display", "unset !important"),
                A2(HTn, "position", "unset !important")
            ])),
            A3(KTn, pTn, T([
                "MasterFilesWrapper",
                "ShowAside"
            ]), T([
                A2(XTn, 3, Kun),
                lwn(sTn(4)),
                A2(HTn, "display", "block !important")
            ])),
            A2(pTn, "FileStatus", T([
                A2(XTn, 0, "black")
            ])),
            A2(pTn, "AsideTab", T([
                A2(XTn, 0, "black"),
                dwn(vwn),
                vTn.jg,
                bwn(vwn)
            ])),
            A3(KTn, pTn, T([
                "AsideTabsIcon",
                "IconChoice"
            ]), T([
                vTn.ol
            ])),
            A3(KTn, pTn, T([
                "AsideHeader",
                "AsideTabsLabel",
                "AsideTabInner",
                "AsideTabs",
                "AsideTab"
            ]), T([
                vTn.jg,
                bwn(YTn),
                DTn(YTn),
                dwn(vwn),
                A2(XTn, 0, "black !important")
            ])),
            A2(pTn, "AsideHeader", T([
                fwn(sTn(10))
            ])),
            A2(pTn, "Activity", T([
                fwn(sTn(3))
            ])),
            A2(pTn, "HeaderBreadcrumbItemLogo", T([
                A2(XTn, 0, "black")
            ])),
            A3(KTn, pTn, T([
                "ShowHomeWrapper",
                "ShowWrapper"
            ]), T([
                OTn
            ])),
            A3(KTn, pTn, T([
                "ActivityVerificationMessage",
                "ShowWrapper"
            ]), T([
                GTn(Kun)
            ]))
        ]))
    ]), gwn = T([
        A2(LTn, T([
            "(max-width: 650px)"
        ]), T([
            A2(wTn, T([
                pTn("SettingsWrapper"),
                pTn("ShowsWrapper")
            ]), T([
                A4(dTn, 0, 0, 0, 0)
            ])),
            A2(pTn, "MenuWrapper", T([
                vTn.ol,
                A2(pwn, "MenuOpened", T([
                    vTn.lL
                ]))
            ])),
            A2(pTn, "OptionalMenuItem", T([
                A2(HTn, "display", "none !important")
            ]))
        ]))
    ]), hwn = {
        cs: A2(eTn, "align-items", "baseline"),
        jF: A2(eTn, "align-items", "center"),
        bR: A2(eTn, "align-items", "flex-end"),
        lP: A2(eTn, "align-items", "flex-start"),
        rg: A2(eTn, "align-items", "stretch")
    }, kwn = eTn("background"), Twn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), wwn = function(n) {
        return Twn(n);
    }, Cwn = wwn("before"), Nwn = F2(function(n, r) {
        return A2(eTn, "border-bottom", It(n) + "px solid " + r);
    }), Awn = F2(function(n, r) {
        return A2(eTn, "border-top", It(n) + "px solid " + r);
    }), Swn = function(n) {
        return A2(eTn, "font-size", tTn(n));
    }, Lwn = oTn(T([
        Swn(sTn(20)),
        awn.ji
    ])), ywn = {
        jF: A2(eTn, "justify-content", "center"),
        bR: A2(eTn, "justify-content", "flex-end"),
        lP: A2(eTn, "justify-content", "flex-start"),
        hh: A2(eTn, "justify-content", "space-around"),
        qX: A2(eTn, "justify-content", "space-between")
    }, Fwn = F2(function(n, r) {
        return A2(eTn, "margin", A2(Bt, " ", A2(Ge, tTn, T([
            n,
            r
        ]))));
    }), jwn = F3(function(n, r, t) {
        return A2(eTn, "margin", A2(Bt, " ", A2(Ge, tTn, T([
            n,
            r,
            t
        ]))));
    }), Pwn = function(n) {
        return A2(eTn, "max-width", tTn(n));
    }, Iwn = F2(function(n, r) {
        return A2(eTn, "padding", A2(Bt, " ", A2(Ge, tTn, T([
            n,
            r
        ]))));
    }), Bwn = function(n) {
        return A2(eTn, "padding-left", tTn(n));
    }, Mwn = function(n) {
        return A2(eTn, "padding-right", tTn(n));
    }, Own = {
        jF: A2(eTn, "text-align", "center"),
        fH: A2(eTn, "text-align", "justify"),
        c0: A2(eTn, "text-align", "left"),
        pO: A2(eTn, "text-align", "right")
    }, qwn = "#fff", Dwn = A2(bu, eTn("z-index"), It), xwn = T([
        A2(pTn, "AccountPageWrapper", T([
            Pwn(sTn(580)),
            A3(jwn, sTn(50), YTn, sTn(0)),
            A2(Iwn, sTn(0), sTn(10))
        ])),
        A2(pTn, "AccountPageLogo", T([
            vTn.jg,
            zTn("scale(0.7)")
        ])),
        A2(LTn, T([
            "(max-width: 650px)"
        ]), T([
            A2(pTn, "AccountPageLogo", T([
                hTn(T([
                    A2(TTn, "svg", T([
                        bwn(xTn(100))
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AccountPageContent", T([
            A2(XTn, 4, Run.ku),
            A2(Fwn, sTn(40), sTn(0))
        ])),
        A2(pTn, "AccountWrapper", g),
        A2(pTn, "AccountForm", T([
            kwn(qwn),
            dwn(sTn(10))
        ])),
        A2(pTn, "AccountFormFields", T([
            dwn(sTn(10))
        ])),
        A2(pTn, "AccountTitle", T([
            Lwn
        ])),
        A2(pTn, "AccountSubmit", g),
        A2(pTn, "AccountLink", T([
            OTn,
            bwn(sTn(200)),
            A2(Iwn, sTn(5), sTn(0))
        ])),
        A2(pTn, "AccountMessage", g),
        A2(pTn, "AccountSuccess", T([
            GTn(Hun.jT),
            A2(Iwn, sTn(5), sTn(0))
        ])),
        A2(pTn, "AccountFail", T([
            GTn(tan.jT),
            A2(Iwn, sTn(5), sTn(0))
        ])),
        A2(pTn, "AccountHeader", T([
            dwn(sTn(10)),
            A2(Nwn, 2, Zun),
            Own.jF,
            fwn(sTn(4)),
            GTn(Zun)
        ])),
        A2(pTn, "AccountFooter", T([
            QTn,
            dwn(sTn(10)),
            A2(Awn, 2, Zun),
            fwn(sTn(4))
        ])),
        A2(pTn, "AccountFooterLinks", T([
            OTn,
            bwn(sTn(220)),
            Mwn(sTn(20)),
            Own.pO
        ])),
        A2(LTn, T([
            "(device-aspect-ratio: 40/71)"
        ]), T([
            A2(pTn, "AccountFooterLinks", T([
                OTn,
                bwn(sTn(175))
            ]))
        ])),
        A2(pTn, "BetaLoginFooter", T([
            QTn,
            ywn.qX,
            hwn.jF
        ])),
        A2(pTn, "AccountSSO", T([
            cTn.dj
        ])),
        A2(LTn, T([
            "(min-width: 650px)"
        ]), T([
            A2(pTn, "AccountSSO", T([
                Bwn(sTn(235))
            ]))
        ])),
        A2(pTn, "AccountFormPassword", T([
            cTn.dj,
            FTn.l6
        ])),
        A2(pTn, "AccountFormPasswordHide", T([
            cTn.dj,
            Cwn(T([
                A2(HTn, "content", '" "'),
                cTn.$8,
                A2(HTn, "inset", "0"),
                Dwn(90),
                kwn("white")
            ]))
        ]))
    ]), Rwn = eTn("background-color"), Vwn = F2(function(n, r) {
        return A2(eTn, "flex", It(n) + " " + It(r));
    }), Ewn = function(n) {
        return A2(eTn, "min-width", tTn(n));
    }, zwn = oTn(T([
        A2(Vwn, 1, 1),
        Ewn(vwn)
    ])), Uwn = oTn(T([
        vTn.lL,
        MTn.pT
    ])), Hwn = rwn("hover"), Wwn = yTn("overflow-x"), Qwn = yTn("overflow-y"), Zwn = {
        jz: A2(eTn, "text-transform", "capitalize"),
        nB: A2(eTn, "text-transform", "lowercase"),
        ol: A2(eTn, "text-transform", "none"),
        sm: A2(eTn, "text-transform", "uppercase")
    }, Kwn = T([
        A2(pTn, "AccountReportWrapper", T([
            OTn,
            zwn,
            Rwn(Zun)
        ])),
        A2(pTn, "AccountReportContainer", T([
            Wwn.l6,
            Qwn.i8,
            OTn,
            zwn,
            dwn(sTn(20)),
            Pwn(sTn(800)),
            bwn(xTn(100))
        ])),
        A2(pTn, "AccountReportSubmit", T([
            Rwn(Zun),
            Uwn,
            hTn(T([
                A2(pTn, "CustomButtonLabel", T([
                    GTn(qwn),
                    Rwn(Run.nu),
                    Zwn.sm,
                    awn.jj,
                    Swn(sTn(10)),
                    Hwn(T([
                        Rwn(Run.jT)
                    ]))
                ]))
            ]))
        ]))
    ]), Ywn = function(n) {
        return A2(eTn, "margin-bottom", tTn(n));
    }, Xwn = T([
        A2(pTn, "SettingsWrapper", T([
            QTn,
            zwn,
            A4(dTn, 0, 0, 0, 94)
        ])),
        A2(pTn, "SettingsTitle", T([
            Swn(sTn(18)),
            GTn(qwn)
        ])),
        A2(pTn, "SettingsForm", T([
            dwn(sTn(10)),
            Pwn(sTn(500)),
            Rwn(Zun)
        ])),
        A2(pTn, "SettingsContainer", T([
            Rwn(Zun),
            Wwn.l6,
            Qwn.i8,
            OTn,
            zwn
        ])),
        A2(pTn, "Version", T([
            Own.jF,
            Ywn(sTn(5)),
            cTn.$8,
            mTn(sTn(15)),
            lwn(sTn(10))
        ]))
    ]), Jwn = Ju(T([
        xwn,
        Xwn,
        Kwn
    ])), Gwn = $Tn(2), _wn = {
        iB: A2(eTn, "cursor", "alias"),
        iD: A2(eTn, "cursor", "all-scroll"),
        i8: A2(eTn, "cursor", "auto"),
        jE: A2(eTn, "cursor", "cell"),
        jS: A2(eTn, "cursor", "col-resize"),
        j5: A2(eTn, "cursor", "context-menu"),
        j9: A2(eTn, "cursor", "copy"),
        kl: A2(eTn, "cursor", "crosshair"),
        kC: A2(eTn, "cursor", "default"),
        k$: A2(eTn, "cursor", "e-resize"),
        lp: A2(eTn, "cursor", "ew-resize"),
        l$: A2(eTn, "cursor", "grab"),
        l0: A2(eTn, "cursor", "grabbing"),
        l5: A2(eTn, "cursor", "help"),
        n1: A2(eTn, "cursor", "move"),
        n4: A2(eTn, "cursor", "n-resize"),
        n8: A2(eTn, "cursor", "ne-resize"),
        oa: A2(eTn, "cursor", "nesw-resize"),
        og: A2(eTn, "cursor", "no-drop"),
        ol: A2(eTn, "cursor", "none"),
        on: A2(eTn, "cursor", "not-allowed"),
        oq: A2(eTn, "cursor", "ns-resize"),
        ot: A2(eTn, "cursor", "nw-resize"),
        ou: A2(eTn, "cursor", "nwse-resize"),
        o6: A2(eTn, "cursor", "pointer"),
        pj: A2(eTn, "cursor", "progress"),
        pS: A2(eTn, "cursor", "row-resize"),
        p_: A2(eTn, "cursor", "s-resize"),
        p9: A2(eTn, "cursor", "se-resize"),
        rx: A2(eTn, "cursor", "sw-resize"),
        cj: A2(eTn, "cursor", "text"),
        sz: A2(eTn, "cursor", "vertical-text"),
        sE: A2(eTn, "cursor", "w-resize"),
        sF: A2(eTn, "cursor", "wait"),
        sR: A2(eTn, "cursor", "zoom-in"),
        sS: A2(eTn, "cursor", "zoom-out")
    }, nCn = function(n) {
        return oTn(T([
            A2(HTn, "gap", It(n) + "px")
        ]));
    }, rCn = A2(bu, eTn("flex-grow"), It), tCn = function(n) {
        return A2(eTn, "line-height", tTn(n));
    }, eCn = F4(function(n, r, t, e) {
        return A2(eTn, "margin", A2(Bt, " ", A2(Ge, tTn, T([
            n,
            r,
            t,
            e
        ]))));
    }), uCn = function(n) {
        return A2(eTn, "margin-left", tTn(n));
    }, aCn = function(n) {
        return A2(eTn, "margin-right", tTn(n));
    }, iCn = function(n) {
        return A2(eTn, "min-height", tTn(n));
    }, oCn = T([
        A2(pTn, "AdminWrapper", T([
            QTn,
            zwn
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), g),
        A2(pTn, "AdminTabsWrapper", T([
            QTn,
            zwn,
            iCn(sTn(0))
        ])),
        A2(pTn, "AdminHeader", T([
            DTn(sTn(80)),
            dwn(sTn(10)),
            Rwn(Wun),
            Ywn(sTn(4)),
            QTn
        ])),
        A2(pTn, "AdminPadding", T([
            Pwn(sTn(800)),
            A2(Fwn, sTn(15), YTn),
            A2(XTn, 3, Kun)
        ])),
        A2(pTn, "AdminTitle", T([
            zwn,
            GTn(Kun),
            dwn(sTn(15)),
            tCn(sTn(30))
        ])),
        A2(pTn, "AdminTabs", T([
            OTn,
            bwn(sTn(200)),
            aCn(sTn(4)),
            FTn.i8
        ])),
        A2(pTn, "AdminTab", T([
            DTn(sTn(48)),
            A2(Iwn, sTn(15), sTn(25)),
            Swn(sTn(14)),
            Ywn(sTn(4)),
            _wn.o6,
            GTn(_un),
            Rwn(Zun),
            QTn,
            Hwn(T([
                GTn(qwn),
                Rwn(Run.jT)
            ])),
            A2(pwn, "AdminTabActive", T([
                GTn(Run.nf),
                Rwn(Run.nw)
            ])),
            hTn(T([
                A2(TTn, "a", T([
                    GTn("inherit")
                ]))
            ]))
        ])),
        A2(pTn, "AdminContent", T([
            GTn(Xun),
            zwn,
            FTn.i8
        ])),
        A2(pTn, "EditContainer", T([
            uCn(sTn(220))
        ])),
        A2(pTn, "EditSection", T([
            lwn(sTn(20))
        ])),
        A2(pTn, "EmptySection", T([
            vTn.lL,
            hwn.jF,
            ywn.jF,
            iCn(sTn(300))
        ])),
        A2(pTn, "Summary", T([
            dwn(sTn(10)),
            hTn(T([
                A2(TTn, "h2", T([
                    A2(Iwn, sTn(10), sTn(0))
                ])),
                A2(TTn, "p", T([
                    A2(Fwn, sTn(10), sTn(0))
                ]))
            ]))
        ])),
        A2(pTn, "Filter", T([
            Gwn(T([
                A2(TTn, ":first-child", T([
                    vTn.lL,
                    fwn(sTn(0)),
                    A2(Iwn, sTn(0), sTn(10)),
                    Rwn(Kun)
                ]))
            ]))
        ])),
        A2(pTn, "FilterSelect", T([
            bwn(sTn(225)),
            A4(eCn, sTn(6), sTn(0), sTn(10), sTn(10)),
            vTn.lL,
            Gwn(T([
                A2(TTn, ":first-child", T([
                    vTn.lL,
                    BTn(xTn(40)),
                    hwn.jF
                ]))
            ]))
        ])),
        A2(pTn, "JobsFilters", T([
            hwn.jF,
            Gwn(T([
                A2(TTn, ".Select", T([
                    DTn(sTn(32)),
                    Ywn(sTn(4))
                ]))
            ]))
        ])),
        A2(pTn, "LayoutAppBarActions", T([
            Ewn(sTn(100))
        ])),
        A2(pTn, "AdminForumSubsection", T([
            uCn(sTn(100))
        ])),
        A2(pTn, "FieldTitle", T([
            QTn,
            nCn(6)
        ])),
        A2(pTn, "FieldBloc", T([
            OTn,
            rCn(1)
        ])),
        A2(pTn, "FieldLine", T([
            QTn,
            hwn.jF,
            rCn(1)
        ])),
        A2(TTn, ".FieldLine .InputLabel", T([
            QTn,
            hwn.jF,
            rCn(1)
        ])),
        A2(pTn, "OrganizationOnboarding", T([
            QTn,
            hwn.jF,
            A2(Iwn, vwn, sTn(6)),
            A2(HTn, "gap", "3px")
        ])),
        A2(pTn, "OrganizationEditApp", T([
            QTn,
            hwn.jF,
            dwn(sTn(6)),
            A2(HTn, "gap", "6px")
        ]))
    ]), cCn = function(n) {
        return A2(eTn, "border-radius", tTn(n));
    }, sCn = {
        m9: A2(eTn, "font-size", "large"),
        na: A2(eTn, "font-size", "larger"),
        nM: A2(eTn, "font-size", "medium"),
        qT: A2(eTn, "font-size", "small"),
        qW: A2(eTn, "font-size", "smaller"),
        sL: A2(eTn, "font-size", "x-large"),
        sM: A2(eTn, "font-size", "x-small"),
        sN: A2(eTn, "font-size", "xx-large"),
        sO: A2(eTn, "font-size", "xx-small")
    }, fCn = T([
        A2(pTn, "EditContainer", T([
            uCn(sTn(220))
        ])),
        A2(pTn, "EditSection", T([
            lwn(sTn(20))
        ])),
        A2(pTn, "AdminDetailsSummary", T([
            lwn(sTn(10)),
            GTn("white"),
            awn.ji,
            sCn.nM
        ])),
        A2(pTn, "AdminDetailsSelection", T([
            vTn.lL,
            nCn(4)
        ])),
        A2(TTn, ".AdminDetailsSelection span", T([
            A2(Iwn, sTn(2), sTn(4)),
            kwn(Run.nu),
            cCn(sTn(3)),
            GTn("white")
        ]))
    ]), lCn = {
        op: A2(eTn, "flex-wrap", "nowrap"),
        sH: A2(eTn, "flex-wrap", "wrap"),
        sI: A2(eTn, "flex-wrap", "wrap-reverse")
    }, mCn = {
        mV: A2(eTn, "font-style", "italic"),
        om: A2(eTn, "font-style", "normal"),
        ov: A2(eTn, "font-style", "oblique")
    }, dCn = F4(function(n, r, t, e) {
        return A2(eTn, "padding", A2(Bt, " ", A2(Ge, tTn, T([
            n,
            r,
            t,
            e
        ]))));
    }), bCn = T([
        A2(pTn, "StitchWrapper", T([
            OTn,
            Ywn(sTn(4))
        ])),
        A2(pTn, "StitchHeader", T([
            QTn,
            dwn(sTn(10)),
            Rwn(nan),
            GTn(Kun),
            Ywn(sTn(4))
        ])),
        A2(pTn, "StitchTitle", T([
            Swn(sTn(16)),
            tCn(sTn(28)),
            awn.ji,
            zwn
        ])),
        A2(pTn, "StitchAdd", T([
            A2(XTn, 2, Qun),
            lwn(sTn(3)),
            GTn(qwn),
            QTn,
            lCn.sH,
            ywn.lP,
            A4(dCn, sTn(0), sTn(0), sTn(3), sTn(3)),
            A4(eCn, sTn(0), sTn(0), sTn(10), sTn(0)),
            hTn(T([
                A2(pTn, "Select", T([
                    BTn(xTn(30)),
                    A2(XTn, 0, Kun),
                    A4(eCn, sTn(3), sTn(3), sTn(0), sTn(0))
                ])),
                A2(pTn, "SelectButtonIcon", T([
                    DTn(sTn(30))
                ]))
            ]))
        ])),
        A2(pTn, "StichSegment", T([
            QTn,
            rCn(1),
            BTn(xTn(100)),
            dwn(sTn(3)),
            A4(eCn, sTn(3), sTn(3), sTn(0), sTn(0)),
            Rwn(Kun),
            Rwn(Qun),
            hwn.jF
        ])),
        A2(pTn, "StichSegmentTitle", T([
            zwn,
            A2(Iwn, vwn, sTn(6))
        ])),
        A2(pTn, "StichSegmentUnit", T([
            GTn(Wun),
            mCn.mV,
            Mwn(sTn(3))
        ])),
        A2(pTn, "StichSegmentDuration", T([
            bwn(sTn(60)),
            GTn(Run.jT),
            awn.jj,
            Own.pO,
            Rwn(Kun)
        ])),
        A2(pTn, "StichSegmentDelete", T([
            DTn(sTn(18)),
            uCn(sTn(3))
        ])),
        A2(pTn, "StichSegmentUrl", T([
            rCn(1),
            GTn(Run.jT),
            awn.jj,
            Own.pO,
            Rwn(Kun),
            Ewn(sTn(315))
        ])),
        A2(pTn, "StichVideoSegment", T([
            OTn,
            uCn(sTn(10))
        ])),
        A2(pTn, "StichSegmentSubtract", T([
            QTn,
            zwn,
            aCn(sTn(10))
        ]))
    ]), pCn = Ju(T([
        bCn,
        fCn
    ])), vCn = Ju(T([
        pCn,
        oCn
    ])), $Cn = F2(function(n, r) {
        return oTn(T([
            cTn.$8,
            fTn(sTn(n)),
            mTn(sTn(r))
        ]));
    }), gCn = "#000", hCn = F2(function(n, r) {
        return A2(eTn, "border-left", It(n) + "px solid " + r);
    }), kCn = F2(function(n, r) {
        return A2(eTn, "border-right", It(n) + "px solid " + r);
    }), TCn = function(n) {
        return A2(Hk, n, va(g));
    }, wCn = eTn("font-family"), CCn = function(n) {
        return A2(eTn, "max-height", tTn(n));
    }, NCn = F3(function(n, r, t) {
        return A2(eTn, "padding", A2(Bt, " ", A2(Ge, tTn, T([
            n,
            r,
            t
        ]))));
    }), ACn = function(n) {
        return A2(eTn, "padding-bottom", tTn(n));
    }, SCn = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAA4CAYAAAAl63xKAAAAAXNSR0IArs4c6QAABZJJREFUeAHtXMly1DAQVRIDYQmBIlxYTsCFUMWV4v8LyImiCk7AieVCKJYAEwIkzFN4To+mtXgjM5nWRba1up+6n6SWvXTr/sMDNw6rq6vu+o2bbuPKhltaWsKjqXBwcOC2P267d2/fuN3d3Yl0rfyTJ498nkvrl+u8e7/2xmVHbn9/3z9bW7voNjfv1eklF+zH61cvfXZZvyz/+csnf/vgwUP5uL5+8eK529n56u+Xl5fHMjjrTp86XafnLlj/rdt3VLlp75+rM5ceyq9CAXQegEAgACcEkgKTwPGFUR6AaOWRxhA2LAFnntIYA+zqxlXf39IyWr67dzcnBuSPH9/d7vKoMZDoy9BBkx9k7gG8uLbumCEEAh3TgJMjFddaeb7U150vtcZJ4GKaznJDxxwIsDrSsrQFcoj+Uq60WFJ+W1uPDwFEwwBBA4KdosZJ4JgWK890NC4bzgFHjX//7q2v4tr1G6qJYv1ajBcvDSkg91Z+ugsX1kqrUvOhLzG5qQX+Pfz2bcf9/vPb38Xk5zVQViKB/Dk2jQhnGnKDrK/JNYGTGo/yMdOu1R2OWHBsaQiBRLsUYGkdMh/aBse21Wi2HeNYtDUFIDtAIHmfi0PBYcTAHCMYxx5O+toCmeLYKIA5wJiuAcdJEGw0gnHscBzrARzSRhNoajQB52SJ6caxlESz2APYVrVLbHTYHQmkcWx3jq1AkJw0tAUyZaNDAHlPIHmfi6m5cjptHLvpKgh/ntdBAH6ROdab0HD6LDVy1tdB1FxqNDV1UTh2YhYaAjkP6yACyFgCuQgcOwEghUAgAWCXcJx7jQSytP/U3HnjWBXA0pfO5eNAMI4dbq+4evbsqbO9xrw7jRpNTZ0Vjq1Go5HtNUb8eZqFkUDOAsdW586dN39eC38egdRA1p5Rc/vm2IodYQM0DVhKMJg/j5JoHlOuErg+94rrSYwGJLuLxmP+KOaRMd1C5s/L+/MoN03+chUQ2yuuAWRFXWICx40A1oWO4BlHHmansRCO2JPuzwvlIIEs4dgawFBw5s9zbh7WsZUGHDXF/HmHh6dmeR1bwQOBkOM4qdryFBpNQMxGM10rzzTj2PZnZrwJTZ25oJAZSyBKbDTL9REbx05KEf5YD6D58yYFk7vjFqGcJebKaOl9cGw9idEa6OOZcWxcihwIXTi2CECAANPZNJSca2Sd0jQbxx6dYsv5Y5MA/o9zjQSQsQTSODZ/ZiYJYB82GsAYx3J4lsU0rSUcmwSQFXWx0WVdbp9r0Tk2CSDFmgIyZ6NZRyo2jm3/7Udle43z/e1HBZ5rGqiRJTY6Vbdx7FkvHjnrlpv+UnYxqqgAxnEFDgTj2PZnZlQO5JaV+fOG9+dReeTyiRrJtNRe8QSABM78eYeim4dvPzyAGnD0LuBVOCJCxyxHCOKYjYZ5bBpoWo1j899XVh+2P9Qft0DQBE5uneGaANmZmabDMZ2fcm17ZqbiKNeAk023tdGyDl5T441ju3NstTL+xYh9A8+h1Syehb3i8UJ+vajXmqrDnCJAe6Vp5ZEMLlGocXJyRI1HeePY5v+ZoUWcmIVCmGHQgCNAdmbm+M/MJAE0f144nPV7zpq1DYmh94qTAM7DOkiKVDPVSA+XPzTtsiyvQ4sz63vFSQD5UubPoyTKYmokZ/hlpaZzlewVFwE4XXV/T8IRL483GsfmObYXAAGCXPiXwmscWyYparTGsZ0AnIV1EESwyOvYTgCW2OiSMWYcWyKlozzUSHBsJwBZkababX6cetTF/q5OOsdGAcSLl4YUkEOvg1J9XASOnQIwHLGzvg5KAbgI69gawBA4OZ1PCUlLo0b+j3WQ1n747CRzbPL7QABxnIEDwTg27o8t/j5QAsktK/PndffnUa70zsTW0/Q+0FLSE/QXU2aja+FG/18AAAAASUVORK5CYII=) repeat", LCn = F4(function(n, r, t, e) {
        return A2(eTn, "text-shadow", tTn(n) + " " + tTn(r) + " " + tTn(t) + " " + e);
    }), yCn = DTn(sTn(24)), FCn = {
        d_: A2(eTn, "user-select", "all"),
        i8: A2(eTn, "user-select", "auto"),
        ez: A2(eTn, "user-select", "contain"),
        ol: A2(eTn, "user-select", "none"),
        cj: A2(eTn, "user-select", "text")
    }, jCn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), PCn = function(n) {
        return jCn(A2(Ge, CTn, n));
    }, ICn = T([
        A2(swn, "player-template", T([
            vTn.ol
        ])),
        A2(pTn, "PlayerVideoWrapper", T([
            OTn
        ])),
        A2(pTn, "PlayerBox", T([
            OTn,
            hwn.jF,
            ywn.jF,
            kwn(Qun),
            A2(XTn, 6, Qun)
        ])),
        A2(pTn, "PlayerVideoBuffering", T([
            cTn.$8,
            fTn(sTn(0)),
            uTn(sTn(0)),
            aTn(sTn(0)),
            mTn(sTn(0)),
            OTn,
            hwn.jF,
            ywn.jF
        ])),
        A2(pTn, "PlayerVideo", T([
            cTn.dj
        ])),
        A2(pTn, "PlayerDeployed", T([
            zwn,
            FTn.l6,
            A2(HTn, "aspect-ratio", "16 / 9"),
            A2(HTn, "max-height", "calc(100vh - 215px)"),
            Gwn(T([
                A2(TTn, "video", T([
                    lwn(xTn(-3.78))
                ]))
            ]))
        ])),
        A2(TTn, "noma-player", T([
            A2(HTn, "aspect-ratio", "16 / 9")
        ])),
        A2(pTn, "PlayerFullScreen", T([
            hTn(T([
                A2(pTn, "PlayerBox", T([
                    zwn,
                    dwn(vwn),
                    A2(XTn, 0, Qun),
                    QTn,
                    ywn.jF,
                    A2(PCn, T([
                        "(min-aspect-ratio: 16/9)"
                    ]), T([
                        OTn
                    ]))
                ])),
                A2(pTn, "PlayerDeployed", T([
                    A2(HTn, "max-height", "100%"),
                    A2(HTn, "max-width", "100%")
                ])),
                A2(pTn, "PlayerControlsBox", T([
                    A2(HTn, "outline", "3px solid black"),
                    A2(Awn, 3, Qun)
                ]))
            ]))
        ])),
        A2(pTn, "PlayerCollapsed", T([
            DTn(sTn(124)),
            kwn("radial-gradient(ellipse at center, rgba(24,31,41,0) 0%,rgba(24,31,41,.9) 100%), " + SCn),
            FTn.l6
        ])),
        A2(pTn, "PlayerVideoBuffering", T([
            cTn.$8,
            fTn(sTn(0)),
            uTn(sTn(0)),
            aTn(sTn(0)),
            mTn(sTn(0)),
            vTn.lL,
            hwn.jF,
            ywn.jF
        ])),
        A2(pTn, "PlayerControls", T([
            QTn,
            dwn(sTn(3)),
            Bwn(sTn(0)),
            A2(XTn, 3, Qun),
            A2(Awn, 0, Qun),
            Rwn(Kun),
            lCn.sH,
            Gwn(T([
                TCn(T([
                    uCn(sTn(3)),
                    yCn,
                    FCn.ol,
                    qTn(1)
                ]))
            ])),
            hTn(T([
                A2(TTn, ".InputSelect", T([
                    fwn(vwn)
                ]))
            ]))
        ])),
        A2(pTn, "PlayerControlsHidden", T([
            A2(pwn, "PlayerFullScreen", T([
                hTn(T([
                    A2(pTn, "PlayerControlsBox", T([
                        ETn,
                        mwn(0)
                    ]))
                ])),
                _wn.ol
            ]))
        ])),
        A2(wTn, T([
            pTn("PlayerControlsPlayPause"),
            pTn("PlayerControlsForward"),
            pTn("PlayerControlsBackward"),
            pTn("PlayerControlsSound"),
            pTn("PlayerControlsOptions"),
            pTn("PlayerControlsFullScreen"),
            pTn("PlayerControlsStart"),
            pTn("PlayerControlsEnd"),
            pTn("PlayerPlaybackSpeed1"),
            pTn("PlayerPlaybackSpeed2"),
            pTn("PlayerPlaybackSpeed4"),
            pTn("PlayerGoBack1s"),
            pTn("PlayerControlsRatio"),
            pTn("PlayerGoBack5s"),
            pTn("PlayerGoForward1s"),
            pTn("PlayerGoForward5s"),
            pTn("ButtonDisplayRawImage")
        ]), T([
            yCn,
            _wn.o6,
            dwn(sTn(3)),
            Rwn(Zun),
            Hwn(T([
                Rwn(Run.jT),
                hTn(T([
                    A2(pTn, "Fg", T([
                        _Tn(qwn)
                    ]))
                ]))
            ])),
            hTn(T([
                A2(pTn, "Bg", T([
                    _Tn("none")
                ]))
            ]))
        ])),
        A2(pTn, "PlayerBanner", T([
            bwn(xTn(100))
        ])),
        A2(pTn, "PlayerControlsTime", T([
            cTn.dj,
            zwn,
            Rwn(Zun)
        ])),
        A2(pTn, "PlayerControlsTimeMask", T([
            cTn.$8,
            fTn(sTn(0)),
            uTn(sTn(0)),
            aTn(sTn(0)),
            mTn(sTn(0)),
            mwn(0),
            Dwn(100)
        ])),
        A2(pTn, "PlayerControlsTimeProgress", T([
            cTn.$8,
            fTn(sTn(0)),
            uTn(sTn(0)),
            aTn(sTn(0)),
            yCn,
            Rwn(Run.jT),
            Dwn(10)
        ])),
        A2(pTn, "PlayerControlsTimeBuffered", T([
            cTn.$8,
            fTn(sTn(0)),
            uTn(sTn(0)),
            yCn,
            Rwn(Run.eE),
            Dwn(5)
        ])),
        A2(pTn, "PlayerControlsTimeCursor", T([
            cTn.$8,
            uTn(sTn(0)),
            A2(kCn, 2, Run.jT),
            DTn(sTn(60)),
            ACn(sTn(40)),
            Dwn(15)
        ])),
        A2(pTn, "PlayerControlsTimeTimecode", T([
            Rwn(Run.jT),
            GTn(qwn),
            cTn.$8,
            mTn(sTn(0)),
            vTn.jg,
            wCn("monospace"),
            awn.ji,
            A4(LCn, sTn(1), sTn(1), sTn(0), "rgba(0,0,0,.3)"),
            A2(Iwn, sTn(6), sTn(10))
        ])),
        A2(pTn, "PlayerControlsTimeGhost", T([
            cTn.$8,
            fTn(sTn(-6)),
            DTn(sTn(40)),
            mwn(0),
            bwn(xTn(100))
        ])),
        A2(pTn, "PlayerControlsDuration", T([
            wCn("monospace"),
            GTn(Jun),
            Rwn(nan),
            A4(LCn, sTn(1), sTn(1), sTn(0), "rgba(0,0,0,.3)"),
            A2(Iwn, vwn, sTn(6))
        ])),
        A2(pTn, "PlayerControlsBox", T([
            OTn,
            Dwn(4)
        ])),
        A2(pTn, "PlayerControlsBoxLeft", T([
            OTn,
            zwn
        ])),
        A2(pTn, "PlayerControlsBoxRight", T([
            OTn
        ])),
        A2(TTn, ".PlayerControlsBoxRight .PlayerControls", T([
            A2(hCn, 0, Qun)
        ])),
        A2(pTn, "PlayerSelection", T([
            A3(NCn, sTn(0), sTn(3), sTn(3)),
            Rwn(Qun)
        ])),
        A2(TTn, ".PlayerSelection .Select:nth-child(1)", T([
            A2(Awn, 3, Kun)
        ])),
        A2(pTn, "PlayerOperations", T([
            dwn(sTn(3)),
            A2(kCn, 3, Qun),
            A2(Nwn, 3, Qun),
            kwn(Kun),
            OTn,
            zwn
        ])),
        A2(pTn, "PlayerOperationsSeparator", T([
            Rwn(Zun),
            mwn(30),
            bwn(sTn(10))
        ])),
        A2(pTn, "PlayerOperationsSpacer", T([
            Rwn(Zun),
            mwn(30),
            rCn(1)
        ])),
        A2(pTn, "PlayerOperationsMarkinout", T([
            hTn(T([
                A2(pTn, "CustomButton", T([
                    A3(NCn, sTn(3), vwn, vwn)
                ]))
            ]))
        ])),
        A2(pTn, "PlayerControlsOptions", T([
            cTn.dj
        ])),
        A2(pTn, "PlayerControlsOptionsMenu", T([
            vTn.ol,
            A2($Cn, 33, 0),
            kwn(Run.jT),
            GTn(qwn)
        ])),
        A2(pTn, "PlayerControlsOptionsMenuOpened", T([
            Rwn(Run.jT),
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(qwn)
                ]))
            ]))
        ])),
        A3(RTn, "PlayerControlsOptionsMenuOpened", "PlayerControlsOptionsMenu", T([
            OTn,
            bwn(sTn(150))
        ])),
        A2(pTn, "PlayerOperationsMarkin", g),
        A2(pTn, "PlayerOperationsMarkout", g),
        A2(pTn, "PlayerOperationsSonagram", g),
        A2(pTn, "PlayerSonagram", T([
            lwn(sTn(4))
        ])),
        A2(pTn, "PlayerMarkinout", T([
            lwn(sTn(4)),
            Rwn(nan)
        ])),
        A2(pTn, "PlayerSelectedSpeed", T([
            kwn(Qun)
        ])),
        A2(pTn, "PlayerAspectRatio", T([
            A4(dTn, 0, 0, 0, 0),
            hTn(T([
                A2(TTn, "svg", T([
                    cTn.$8,
                    fTn(xTn(50)),
                    aTn(sTn(0)),
                    zTn("translateY(calc(-50% - 2px))"),
                    bwn(xTn(100)),
                    DTn(YTn)
                ]))
            ]))
        ])),
        A2(wTn, T([
            TTn(".PlayerVideoWrapper:fullscreen"),
            TTn(".PlayerVideoWrapper:-webkit-full-screen"),
            TTn(".PlayerVideoWrapper:-moz-full-screen"),
            TTn(".PlayerVideoWrapper:-ms-fullscreen")
        ]), T([
            cTn.lI,
            fTn(sTn(0)),
            uTn(sTn(0)),
            aTn(sTn(0)),
            mTn(sTn(0)),
            Pwn(xTn(100)),
            CCn(xTn(100)),
            kwn(Kun),
            FTn.l6,
            Dwn(3)
        ])),
        A2(wTn, T([
            TTn(".PlayerVideoWrapper:fullscreen .PlayerDeployed"),
            TTn(".PlayerVideoWrapper:-webkit-full-screen .PlayerDeployed"),
            TTn(".PlayerVideoWrapper:-moz-full-screen .PlayerDeployed"),
            TTn(".PlayerVideoWrapper:-ms-fullscreen .PlayerDeployed")
        ]), T([
            A2(XTn, 0, gCn)
        ])),
        A2(wTn, T([
            TTn(".PlayerVideoWrapper:fullscreen .PlayerControlsBox"),
            TTn(".PlayerVideoWrapper:-webkit-full-screen .PlayerControlsBox"),
            TTn(".PlayerVideoWrapper:-moz-full-screen .PlayerControlsBox"),
            TTn(".PlayerVideoWrapper:-ms-fullscreen .PlayerControlsBox")
        ]), T([
            cTn.lI,
            uTn(sTn(20)),
            aTn(xTn(50)),
            zTn("translateX(-50%)"),
            bwn(xTn(100)),
            Pwn(sTn(1e3)),
            kwn("transparent"),
            Gwn(T([
                A2(wTn, T([
                    pTn("PlayerControlsBoxLeft"),
                    pTn("PlayerControlsBoxRight")
                ]), T([
                    MTn.jX,
                    A2(Awn, 3, Qun)
                ]))
            ]))
        ])),
        A2(wTn, T([
            TTn(".PlayerVideoWrapper:-moz-full-screen .PlayerControlsBox")
        ]), T([
            cTn.$8
        ])),
        A2(wTn, T([
            TTn(".IPhone")
        ]), T([
            hTn(T([
                A2(wTn, T([
                    TTn(".PlayerVideoWrapper")
                ]), T([
                    bwn(xTn(50)),
                    fTn(sTn(0))
                ]))
            ]))
        ])),
        A2(wTn, T([
            TTn(".IPad")
        ]), T([
            hTn(T([
                A2(wTn, T([
                    TTn(".PlayerVideoWrapper")
                ]), T([
                    bwn(xTn(100)),
                    fTn(sTn(20))
                ]))
            ]))
        ])),
        A2(wTn, T([
            TTn(".IOSTheater")
        ]), T([
            hTn(T([
                A2(wTn, T([
                    TTn(".ShowSelectBroadcastable")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".ShowAside")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".Acceptation")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".MasterFilesWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".DownloadWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".FilesWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".LayoutAppBarWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".BrowserWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".MenuWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".HeaderWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".ShowsWrapper.ActiveShow")
                ]), T([
                    aTn(sTn(0))
                ])),
                A2(wTn, T([
                    TTn(".ShowWrapper.ShowNoop")
                ]), T([
                    zTn("translate3d(0px,0px,0px)")
                ])),
                A2(wTn, T([
                    TTn(".Wrapper")
                ]), T([
                    fTn(sTn(0))
                ])),
                A2(wTn, T([
                    TTn(".ShowMain")
                ]), T([
                    bwn(xTn(100))
                ])),
                A2(wTn, T([
                    TTn(".ShowHomeWrapper")
                ]), T([
                    hwn.jF,
                    ywn.jF
                ])),
                A2(wTn, T([
                    TTn(".PadokUploadWrapper")
                ]), T([
                    vTn.ol
                ])),
                A2(wTn, T([
                    TTn(".PlayerVideoWrapper")
                ]), T([
                    cTn.lI,
                    aTn(xTn(50)),
                    zTn("translateX(-50%)"),
                    Pwn(sTn(1070)),
                    kwn("transparent")
                ])),
                A2(wTn, T([
                    TTn("video")
                ]), T([
                    bwn(xTn(100))
                ]))
            ]))
        ]))
    ]), BCn = eTn("border-color"), MCn = "#EC79ED", OCn = "#8C96F7", qCn = "#57E5D0", DCn = T([
        A2(pTn, "Avatar", T([
            bwn(sTn(24)),
            DTn(sTn(24)),
            Rwn(Zun)
        ])),
        A2(pTn, "AvatarLetter", T([
            tCn(sTn(20)),
            Own.jF,
            Zwn.sm,
            awn.jj,
            A2(XTn, 2, Wun),
            GTn(Wun)
        ])),
        A2(pTn, "AvatarMe", T([
            GTn(qCn),
            BCn(qCn)
        ])),
        A2(pTn, "AvatarCowork", T([
            GTn(OCn),
            BCn(OCn)
        ])),
        A2(pTn, "AvatarAlien", T([
            GTn(MCn),
            BCn(MCn)
        ]))
    ]), xCn = F2(function(n, r) {
        return A2(pTn, n, T([
            GTn(r.nf),
            hTn(T([
                A2(TTn, "svg", T([
                    kwn(r.nw),
                    fwn(sTn(2)),
                    hTn(T([
                        A2(pTn, "Fg", T([
                            _Tn(r.jT)
                        ]))
                    ]))
                ])),
                A2(pTn, "BannerHeader", T([
                    kwn(r.jT),
                    GTn(qwn),
                    zwn,
                    QTn
                ])),
                A2(TTn, "h4", T([
                    Swn(sTn(12)),
                    GTn(qwn),
                    Zwn.sm,
                    dwn(sTn(2)),
                    A4(LCn, sTn(1), sTn(1), sTn(2), "rgba(0,0,0,0.4)")
                ])),
                A2(pTn, "BannerContent", T([
                    kwn(r.nu),
                    A2(Iwn, sTn(5), sTn(10))
                ]))
            ]))
        ]));
    }), RCn = {
        jT: "#FCB63B",
        eE: "#6A542C",
        eF: "#3A3527",
        ku: "#212425",
        mb: "#FCC462",
        md: "#FDD389",
        nf: "#FDE1B0",
        ng: "#FEF0D7",
        nh: "#FEF7EB",
        nu: "#CB9536",
        nw: "#9B7531"
    }, VCn = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, ECn = F2(function(n, r) {
        return A2(pTn, n, T([
            kwn(r.eF),
            GTn(r.jT),
            awn.ji,
            QTn,
            hwn.jF,
            dwn(sTn(6)),
            tCn(VCn(1.5)),
            Gwn(T([
                A2(TTn, "svg", T([
                    kwn(r.nw),
                    fwn(sTn(2)),
                    hTn(T([
                        A2(pTn, "Fg", T([
                            _Tn(r.ku)
                        ]))
                    ]))
                ])),
                A2(pTn, "BannerContent", T([
                    A2(Iwn, vwn, sTn(4)),
                    zwn
                ]))
            ]))
        ]));
    }), zCn = {
        fO: A2(eTn, "text-decoration", "line-through"),
        ol: A2(eTn, "text-decoration", "none"),
        gl: A2(eTn, "text-decoration", "overline"),
        sa: A2(eTn, "text-decoration", "underline")
    }, UCn = T([
        A2(xCn, "BannerError", tan),
        A2(xCn, "BannerWarning", RCn),
        A2(xCn, "BannerSuccess", Hun),
        A2(xCn, "BannerAction", Run),
        A2(ECn, "BannerInvalid", tan),
        A2(ECn, "BannerEmptyness", RCn),
        A2(ECn, "BannerValid", Hun),
        A2(ECn, "BannerAdvice", Run),
        A2(pTn, "BannerTodo", T([
            QTn,
            Rwn("#5E2F83"),
            GTn("#E6B0FF")
        ])),
        A2(pTn, "BannerTodoIcon", T([
            fwn(sTn(6)),
            iwn(Kun),
            Gwn(T([
                TCn(T([
                    A2(XTn, 2, Kun)
                ]))
            ]))
        ])),
        A2(pTn, "BannerTodoBody", T([
            OTn,
            fwn(sTn(6)),
            GTn("#E6B0FF"),
            zwn,
            hTn(T([
                A2(TTn, "a", T([
                    zCn.sa,
                    GTn("inherit"),
                    Hwn(T([
                        GTn(qwn)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "BannerTodoTitle", T([
            GTn(qwn)
        ])),
        A2(pTn, "BannerCTA", T([
            QTn,
            hwn.jF,
            Rwn(Zun),
            hTn(T([
                A2(pTn, "CustomButton", T([
                    A4(dCn, vwn, vwn, vwn, sTn(3))
                ])),
                A2(pTn, "CustomButtonLabel", T([
                    Rwn("#5E2F83"),
                    GTn(qwn)
                ])),
                A2(pTn, "CustomButtonIcon", T([
                    iwn("#AB47BC")
                ]))
            ]))
        ])),
        A2(pTn, "BannerCTAIcon", T([
            iwn("#AB47BC"),
            bwn(sTn(30)),
            Own.jF
        ])),
        A2(pTn, "BannerCTALabel", T([
            zwn,
            GTn(Yun)
        ]))
    ]), HCn = F2(function(n, r) {
        return iTn(T([
            A2(Awn, n, r),
            A2(hCn, n, r)
        ]));
    }), WCn = oTn(T([
        ywn.jF,
        hwn.jF,
        vTn.lL
    ])), QCn = T([
        OTn,
        Rwn(Zun),
        _wn.o6,
        Gwn(T([
            A2(wTn, T([
                pTn("BrowserOpened"),
                pTn("BrowserListOpened")
            ]), T([
                Rwn(Qun),
                Gwn(T([
                    A2(pTn, "BrowserItem", T([
                        Rwn(Zun),
                        GTn(Xun),
                        iwn(Run.jT)
                    ]))
                ]))
            ])),
            A2(pTn, "BrowserAdding", T([
                Rwn(Run.nw)
            ]))
        ]))
    ]), ZCn = T([
        A2(pTn, "BrowserWrapper", T([
            OTn,
            bwn(sTn(400)),
            hTn(T([
                A2(pTn, "LayoutAppBarWrapper", T([
                    uCn(sTn(82))
                ]))
            ]))
        ])),
        A2(pTn, "Browser", T([
            OTn,
            FTn.i8,
            GTn(Wun),
            zwn
        ])),
        A2(pTn, "BrowserHeader", T([
            Rwn(Run.nw),
            dwn(sTn(6)),
            QTn
        ])),
        A2(pTn, "BrowserSection", T([
            kwn(Wun),
            GTn(Kun),
            awn.jj,
            A2(Iwn, sTn(5), sTn(10)),
            QTn,
            A3(jwn, sTn(4), sTn(0), sTn(0))
        ])),
        A2(pTn, "BrowserSubSection", T([
            kwn(nan),
            GTn(Gun),
            awn.jj,
            A2(Iwn, sTn(5), sTn(10)),
            QTn,
            A3(jwn, sTn(4), sTn(0), sTn(0))
        ])),
        A2(pTn, "BrowserOrder", T([
            dwn(sTn(1)),
            Mwn(vwn),
            zwn,
            kwn(Kun),
            QTn
        ])),
        A2(pTn, "BrowserNewButton", T([
            cTn.dj
        ])),
        A2(pTn, "BrowserSection", T([
            A2(HTn, "position", "sticky"),
            fTn(sTn(4)),
            Dwn(4),
            A2(HTn, "outline", "4px solid " + Kun)
        ])),
        A2(pTn, "BrowserSubSection", T([
            A2(HTn, "position", "sticky"),
            fTn(sTn(4)),
            Dwn(4),
            A2(HTn, "outline", "4px solid " + Kun)
        ])),
        A2(TTn, ".BrowserCollection > .BrowserItemWrapper.BrowserOpened", T([
            A2(HTn, "position", "sticky"),
            fTn(sTn(33)),
            Dwn(3),
            A2(HTn, "outline", "2px solid " + Kun)
        ])),
        A2(TTn, ".BrowserSeason > .BrowserItemWrapper.BrowserOpened", T([
            A2(HTn, "position", "sticky"),
            fTn(sTn(63)),
            Dwn(2),
            A2(HTn, "outline", "2px solid " + Kun)
        ])),
        A2(wTn, T([
            pTn("BrowserCollection"),
            pTn("BrowserSeason"),
            pTn("BrowserEpisode")
        ]), T([
            hTn(T([
                A2(wTn, T([
                    pTn("BrowserSeason"),
                    pTn("BrowserEpisode"),
                    pTn("BrowserTitle")
                ]), T([
                    uCn(sTn(13)),
                    A2(HCn, 2, Kun)
                ]))
            ]))
        ])),
        A2(pTn, "BrowserCollection", $(T([
            lwn(sTn(4)),
            Rwn(Zun)
        ]), QCn)),
        A2(pTn, "BrowserSeason", $(T([
            A2(Awn, 2, Kun),
            Rwn(Zun)
        ]), QCn)),
        A2(pTn, "BrowserEpisode", $(T([
            A2(Awn, 2, Kun),
            Rwn(Zun)
        ]), QCn)),
        A2(pTn, "BrowserTitle", A2(dt, A2(HCn, 2, Kun), QCn)),
        A2(pTn, "BrowserItem", T([
            tCn(sTn(24)),
            fwn(sTn(2)),
            QTn,
            zwn,
            GTn(Wun)
        ])),
        A2(pTn, "BrowserItemWrapper", T([
            QTn
        ])),
        A2(TTn, ".BrowserHasMenuOpened", T([
            A2(HTn, "z-index", "8 !important")
        ])),
        A2(pTn, "BrowserLabelMaster", T([
            zwn,
            A2(HTn, "overflow-wrap", "break-word"),
            A2(HTn, "word-wrap", "break-word"),
            A2(HTn, "hyphens", "auto"),
            Swn(sTn(14)),
            awn.ji,
            hTn(T([
                A2(pTn, "InputText", T([
                    dwn(vwn),
                    fwn(vwn),
                    A2(XTn, 0, Zun),
                    GTn(Run.jT),
                    DTn(YTn)
                ]))
            ]))
        ])),
        A2(pTn, "BrowserLabelShow", T([
            zwn,
            A2(HTn, "overflow-wrap", "break-word"),
            A2(HTn, "word-wrap", "break-word"),
            A2(HTn, "hyphens", "auto"),
            Swn(sTn(14)),
            awn.ji,
            hTn(T([
                A2(pTn, "InputText", T([
                    dwn(vwn),
                    fwn(vwn),
                    A2(XTn, 0, Zun),
                    GTn(Run.jT),
                    DTn(YTn)
                ]))
            ]))
        ])),
        A2(pTn, "BrowserIcon", T([
            bwn(sTn(24)),
            DTn(sTn(24)),
            WCn,
            iwn(nan)
        ])),
        A2(pTn, "BrowserOptions", T([
            cTn.dj,
            A2(pwn, "BrowserOptionsOpened", T([
                hTn(T([
                    A2(wTn, T([
                        pTn("BrowserOptionsTitle")
                    ]), T([
                        Rwn(Run.jT),
                        iwn(qwn)
                    ])),
                    A2(pTn, "BrowserOptionsMenu", T([
                        A2($Cn, 25, 3),
                        A2(XTn, 1, Kun)
                    ]))
                ]))
            ]))
        ])),
        A2(wTn, T([
            pTn("BrowserOptionsTitle"),
            pTn("BrowserAttachment"),
            pTn("BrowserEdit")
        ]), T([
            bwn(sTn(24)),
            DTn(sTn(24)),
            WCn,
            ETn,
            _wn.o6,
            Rwn(Zun),
            A2(XTn, 2, Zun),
            A4(eCn, sTn(2), sTn(2), sTn(2), sTn(0)),
            iwn(nan),
            Hwn(T([
                Rwn(Run.jT),
                iwn(qwn)
            ]))
        ])),
        A2(pTn, "BrowserOptionsMenu", T([
            A2($Cn, 29, 0),
            Rwn(Run.jT),
            A2(XTn, 3, Kun),
            GTn(qwn),
            Dwn(99),
            bwn(sTn(200)),
            dwn(sTn(3))
        ])),
        A2(pTn, "BrowserOptionsItem", T([
            dwn(sTn(5)),
            _wn.o6,
            Hwn(T([
                Rwn(Run.nu)
            ]))
        ])),
        A2(pTn, "BrowserOptionsLink", T([
            dwn(sTn(5)),
            _wn.o6,
            GTn(Run.nf),
            vTn.jg,
            Hwn(T([
                Rwn(Run.nw),
                GTn(qwn)
            ]))
        ])),
        A2(pTn, "BrowserNewForm", T([
            QTn,
            dwn(sTn(1)),
            Rwn(Kun),
            hTn(T([
                A2(pTn, "InputText", T([
                    A2(Iwn, sTn(0), sTn(4)),
                    Rwn(Run.jT),
                    GTn(qwn)
                ]))
            ]))
        ])),
        A3(RTn, "BrowserNew", "BrowserNewForm", T([
            A2(XTn, 8, Run.nw),
            A2(Awn, 0, ""),
            hTn(T([
                A2(pTn, "InputText", T([
                    fwn(sTn(2)),
                    A2(XTn, 0, ""),
                    DTn(sTn(26))
                ]))
            ]))
        ])),
        A2(pTn, "BrowserNewFormIcon", T([
            bwn(sTn(30)),
            DTn(sTn(30)),
            WCn,
            A2(XTn, 2, Kun),
            Rwn(Run.jT),
            iwn(qwn)
        ])),
        A3(RTn, "Browser", "BrowserNewForm", T([
            A2(XTn, 0, ""),
            A2(Nwn, 3, Run.nw),
            A2(hCn, 13, Run.nw),
            Mwn(sTn(0)),
            hTn(T([
                A2(pTn, "InputText", T([
                    fwn(sTn(1)),
                    A2(XTn, 0, ""),
                    DTn(sTn(28))
                ])),
                A2(pTn, "BrowserNewFormIcon", T([
                    A2(XTn, 1, Kun)
                ]))
            ]))
        ])),
        A2(pTn, "BrowserSubmitting", T([
            Rwn(Run.jT)
        ])),
        A2(pTn, "BrowserErrors", T([
            Gwn(T([
                TCn(T([
                    lwn(sTn(4))
                ]))
            ]))
        ])),
        A2(pTn, "BrowserList", T([
            OTn
        ])),
        A2(pTn, "BrowserListOpened", T([
            vTn.lL
        ])),
        A2(pTn, "BrowserItem", T([
            Rwn(Zun)
        ])),
        A2(pTn, "BrowserOpened", T([
            Gwn(T([
                A2(pTn, "BrowserItemWrapper", T([
                    Gwn(T([
                        A2(pTn, "BrowserIcon", T([
                            iwn(Run.jT)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "BrowserTitleOpened", T([
            Rwn(Run.jT),
            A2(pwn, "BrowserEmpty", T([
                Rwn(RCn.eE),
                Gwn(T([
                    A2(pTn, "BrowserItem", T([
                        GTn(RCn.jT)
                    ]))
                ]))
            ])),
            Gwn(T([
                A2(pTn, "BrowserItem", T([
                    GTn(Run.jT)
                ]))
            ]))
        ])),
        A2(pTn, "BrowserTitleHidden", T([
            mwn(50)
        ])),
        A2(pTn, "BrowserLink", T([
            tCn(sTn(24)),
            QTn,
            zwn,
            GTn(Wun)
        ])),
        A2(pTn, "BrowserEmpty", T([
            hTn(T([
                A2(pTn, "BrowserLabelMaster", T([
                    mwn(50)
                ]))
            ]))
        ])),
        A2(pTn, "BrowserShowAccepted", T([
            Gwn(T([
                A2(pTn, "BrowserItem", T([
                    Gwn(T([
                        A2(pTn, "BrowserIcon", T([
                            iwn(Hun.nw)
                        ]))
                    ]))
                ]))
            ])),
            A2(pwn, "BrowserOpened", T([
                Gwn(T([
                    A2(pTn, "BrowserItem", T([
                        Gwn(T([
                            A2(pTn, "BrowserIcon", T([
                                iwn(Hun.jT)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), KCn = {
        i8: A2(eTn, "align-self", "auto"),
        cs: A2(eTn, "align-self", "baseline"),
        jF: A2(eTn, "align-self", "center"),
        bR: A2(eTn, "align-self", "flex-end"),
        lP: A2(eTn, "align-self", "flex-start"),
        rg: A2(eTn, "align-self", "stretch")
    }, YCn = rwn("active"), XCn = F2(function(n, r) {
        return iTn(A2(Ge, ce(r), n));
    })(T([
        Hwn,
        pwn("Active"),
        YCn
    ])), JCn = bwn(sTn(28)), GCn = rwn("visited"), _Cn = T([
        A2(pTn, "ButtonToolbar", T([
            QTn,
            Rwn(Kun),
            dwn(sTn(3)),
            ywn.bR,
            DTn(sTn(28)),
            hTn(T([
                TCn(T([
                    uCn(sTn(3)),
                    ewn(T([
                        uCn(sTn(0))
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "ButtonCounter", g),
        A2(pTn, "ButtonLabel", g),
        A2(pTn, "Button", T([
            Swn(sTn(12)),
            Rwn(Run.nu),
            GTn(Run.ng),
            A2(Iwn, sTn(4), sTn(8)),
            _wn.o6,
            vTn.jg,
            Zwn.sm,
            awn.jj,
            KCn.bR,
            Hwn(T([
                GTn(qwn),
                Rwn(Run.jT)
            ]))
        ])),
        A2(pTn, "ButtonIcon", T([
            WCn,
            JCn,
            yCn,
            _wn.o6,
            iwn(Run.ng),
            Rwn(Run.nu),
            Hwn(T([
                iwn(qwn),
                Rwn(Run.jT)
            ]))
        ])),
        A2(pTn, "ButtonMini", T([
            Swn(sTn(10)),
            awn.ji,
            A2(Iwn, sTn(2), sTn(5)),
            Rwn(Run.nu),
            GTn(Run.ng),
            Zwn.sm,
            awn.jj,
            A2(Fwn, sTn(0), sTn(2)),
            Hwn(T([
                GTn(qwn),
                Rwn(Run.jT)
            ]))
        ])),
        A2(pTn, "ButtonMiniIcon", T([
            bwn(sTn(18)),
            DTn(sTn(18)),
            dwn(sTn(0)),
            iwn(Qun),
            _wn.o6,
            Hwn(T([
                Rwn(Run.jT),
                iwn(Zun)
            ]))
        ])),
        A2(pTn, "ButtonBlock", T([
            Own.jF,
            Rwn(Qun),
            dwn(sTn(5)),
            Ywn(sTn(4)),
            Hwn(T([
                Rwn(nan),
                GTn(Jun)
            ]))
        ])),
        A2(pTn, "ButtonDisabled", T([
            Swn(sTn(12)),
            Rwn(_un),
            GTn(Gun),
            A2(Iwn, sTn(4), sTn(8)),
            _wn.o6,
            vTn.jg,
            Zwn.sm,
            awn.jj,
            KCn.bR
        ])),
        A2(pTn, "CustomButton", T([
            DTn(sTn(32)),
            Swn(sTn(13)),
            awn.ji,
            Rwn(Kun),
            dwn(sTn(3)),
            _wn.o6,
            QTn,
            XCn(T([
                hTn(T([
                    A2(pTn, "CustomButtonLabel", T([
                        Rwn(Run.jT),
                        GTn(qwn)
                    ]))
                ]))
            ])),
            A2(pwn, "CustomButtonActive", T([
                hTn(T([
                    A2(pTn, "CustomButtonIcon", T([
                        Rwn(Run.jT)
                    ])),
                    A2(pTn, "CustomButtonLabel", T([
                        Rwn(Run.jT),
                        GTn(qwn)
                    ])),
                    A2(pTn, "Fg", T([
                        _Tn(qwn)
                    ]))
                ]))
            ])),
            A2(pwn, "CustomButtonDisabled", T([
                mwn(30),
                _wn.kC
            ])),
            A2(pwn, "CustomButtonMini", T([
                DTn(sTn(26)),
                Swn(sTn(12)),
                dwn(sTn(3)),
                tCn(sTn(18)),
                hTn(T([
                    A2(pTn, "CustomButtonIcon", T([
                        bwn(sTn(18))
                    ])),
                    A2(pTn, "CustomButtonLabel", T([
                        A2(Iwn, sTn(1), sTn(3))
                    ]))
                ]))
            ])),
            A2(pwn, "CustomButtonPrimary", T([
                hTn(T([
                    A2(pTn, "CustomButtonIcon", T([
                        iwn(Run.jT)
                    ])),
                    A2(pTn, "CustomButtonLabel", T([
                        kwn(Run.nu),
                        GTn(Run.ng)
                    ]))
                ])),
                Hwn(T([
                    hTn(T([
                        A2(pTn, "CustomButtonLabel", T([
                            GTn(qwn),
                            Rwn(Run.jT)
                        ]))
                    ]))
                ])),
                GCn(T([
                    hTn(T([
                        A2(pTn, "CustomButtonLabel", T([
                            GTn(Kun),
                            Rwn(Wun)
                        ]))
                    ]))
                ]))
            ])),
            A2(pwn, "CustomButtonDisabled", T([
                hTn(T([
                    A2(pTn, "CustomButtonIcon", T([
                        kwn(nan + " !important")
                    ])),
                    A2(pTn, "CustomButtonLabel", T([
                        kwn(nan + " !important"),
                        GTn(Wun + " !important")
                    ])),
                    A2(pTn, "Fg", T([
                        _Tn(Wun + " !important")
                    ]))
                ]))
            ]))
        ])),
        A2(TTn, "button", T([
            cCn(sTn(0))
        ])),
        A2(pTn, "CustomButtonIcon", T([
            Rwn(Zun),
            GTn(Yun),
            QTn,
            WCn,
            bwn(sTn(28)),
            aCn(sTn(2)),
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(Run.jT)
                ]))
            ]))
        ])),
        A2(pTn, "CustomButtonLabel", T([
            Rwn(Wun),
            GTn(Kun),
            A2(Iwn, sTn(0), sTn(8)),
            awn.ji,
            QTn,
            hwn.jF
        ])),
        A2(pTn, "ButtonSubmitWrapper", T([
            QTn,
            ywn.bR
        ]))
    ]), nNn = T([
        A2(pTn, "DropDown", T([
            cTn.dj
        ])),
        A2(pTn, "DropDownMenu", T([
            A2($Cn, 20, 0),
            OTn,
            dwn(sTn(2)),
            vTn.ol
        ])),
        A2(pTn, "DropDownItem", T([
            QTn,
            dwn(sTn(4))
        ]))
    ]), rNn = T([
        A2(pTn, "EventsItem", T([
            QTn,
            Ywn(sTn(2)),
            Rwn(Zun),
            GTn(Yun),
            dwn(sTn(4))
        ])),
        A2(pTn, "EventsItemIcon", T([
            bwn(sTn(24)),
            DTn(sTn(24)),
            WCn
        ])),
        A2(pTn, "EventsItemBody", T([
            zwn,
            A2(Iwn, sTn(2), sTn(6))
        ])),
        A2(pTn, "EventsItemLabel", g),
        A2(pTn, "EventsItemDate", T([
            mwn(70)
        ])),
        A2(pTn, "Neutral", g),
        A2(pTn, "Good", T([
            Rwn(Hun.nu),
            GTn(qwn)
        ])),
        A2(pTn, "Bad", T([
            Rwn(tan.nu),
            GTn(qwn)
        ])),
        A2(pTn, "Warn", T([
            Rwn(RCn.nu),
            GTn(qwn)
        ])),
        A2(pTn, "Live", T([
            Rwn(Run.nu),
            GTn(qwn)
        ])),
        A2(pTn, "EventsItemArchived", T([
            mwn(70)
        ]))
    ]), tNn = T([
        A2(pTn, "InputCheckbox", T([
            A2(Iwn, sTn(4), sTn(8)),
            lwn(sTn(10))
        ])),
        A2(pTn, "InputCheckboxLine", T([
            QTn,
            lwn(sTn(3)),
            dwn(sTn(6)),
            kwn(Zun),
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    Pwn(sTn(20))
                ])),
                A2(pTn, "InputCheckbox", T([
                    lwn(sTn(2))
                ]))
            ]))
        ]))
    ]), eNn = F4(function(n, r, t, e) {
        return A2(eTn, "box-shadow", function(n) {
            var r = n.a, t = r.b, e = n.b, u = e.a, a = e.b, i = n.c;
            return tTn(r.a) + " " + tTn(t) + " " + tTn(u) + " " + a + (i ? " inset" : "");
        }(d(m(n, r), m(t, e), !1)));
    }), uNn = rwn("focus"), aNn = oTn(T([
        zwn,
        GTn(Jun),
        A2(Iwn, sTn(1), sTn(4)),
        fwn(sTn(2)),
        A2(XTn, 2, nan),
        Rwn(Zun),
        A2(pwn, "InputSelectEmpty", T([
            BCn(Qun),
            GTn(Wun),
            Rwn(Kun)
        ])),
        uNn(T([
            BCn(Run.jT)
        ]))
    ])), iNn = eTn("outline"), oNn = function(n) {
        return A2(eTn, "padding-top", tTn(n));
    }, cNn = {
        i8: A2(eTn, "pointer-events", "auto"),
        ol: A2(eTn, "pointer-events", "none")
    }, sNn = {
        bG: A2(eTn, "text-overflow", "clip"),
        k7: A2(eTn, "text-overflow", "ellipsis"),
        rh: A2(eTn, "text-overflow", "string")
    }, fNn = {
        om: A2(eTn, "white-space", "normal"),
        op: A2(eTn, "white-space", "nowrap"),
        o9: A2(eTn, "white-space", "pre"),
        pa: A2(eTn, "white-space", "pre-line"),
        pb: A2(eTn, "white-space", "pre-wrap")
    }, lNn = oTn(T([
        sNn.k7,
        FTn.l6,
        fNn.op
    ])), mNn = T([
        A2(pTn, "DarkZone", g),
        A2(pTn, "InputWrapper", T([
            zwn,
            OTn
        ])),
        A2(pTn, "InputWrapperDark", T([
            zwn,
            OTn,
            Rwn(Zun)
        ])),
        A2(pTn, "InputLabel", T([
            QTn,
            A2(Fwn, sTn(10), sTn(0))
        ])),
        A2(LTn, T([
            "(max-width: 650px)"
        ]), T([
            A2(pTn, "InputLabel", T([
                OTn
            ]))
        ])),
        A2(pTn, "InputLabelText", T([
            bwn(sTn(220)),
            oNn(sTn(10))
        ])),
        A2(pTn, "InputText", T([
            aNn
        ])),
        A2(pTn, "InputSearch", g),
        A2(pTn, "InputPassword", T([
            aNn
        ])),
        A2(pTn, "InputTextarea", T([
            aNn
        ])),
        A2(pTn, "InputSelect", T([
            aNn,
            QTn,
            cTn.dj,
            hwn.jF
        ])),
        A2(pTn, "InputSelectMini", T([
            Pwn(sTn(100)),
            fwn(vwn),
            dwn(vwn)
        ])),
        A2(pTn, "InputSelectValue", T([
            awn.ji,
            zwn,
            lNn
        ])),
        A2(pTn, "InputSelectChoice", T([
            bwn(sTn(20)),
            DTn(sTn(20))
        ])),
        A2(pTn, "InputSelectSelect", T([
            mwn(0),
            A4(dTn, 0, 0, 0, 0),
            bwn(xTn(100))
        ])),
        A2(pTn, "InputWrapperPrechoice", T([
            aNn,
            QTn,
            FTn.l6,
            nCn(2),
            dwn(sTn(2)),
            cTn.dj,
            Mwn(sTn(50))
        ])),
        A2(pTn, "InputSelectAllChoice", T([
            A2($Cn, 0, 0),
            uTn(vwn),
            bwn(sTn(30)),
            Rwn(Wun),
            A2(XTn, 3, nan),
            A4(eNn, sTn(-5), sTn(0), sTn(5), Zun),
            iwn(Kun),
            WCn,
            Hwn(T([
                Rwn(Run.jT),
                iwn(qwn)
            ]))
        ])),
        A2(pTn, "InputSelectPrechoice", T([
            GTn(Xun),
            A3(NCn, sTn(0), sTn(3), sTn(1)),
            _wn.o6,
            A2(XTn, 1, Qun),
            Hwn(T([
                Rwn(Run.jT),
                GTn(qwn)
            ]))
        ])),
        A2(pTn, "InputSelectEmpty", T([
            Gwn(T([
                A2(pTn, "InputSelectValue", T([
                    mwn(60),
                    awn.om
                ]))
            ]))
        ])),
        A2(pTn, "InputErrors", g),
        A2(pTn, "InputError", T([
            GTn(tan.jT)
        ])),
        A2(pTn, "InputMandatory", T([
            GTn(Run.jT)
        ])),
        A2(pTn, "InputWrapperDisabled", T([
            mwn(50),
            cNn.ol
        ])),
        A2(pTn, "InputFileLabel", T([
            zCn.sa,
            _wn.o6
        ])),
        A2(pTn, "InputLabelDanger", T([
            Rwn(tan.eE),
            iNn("2px solid red")
        ])),
        A2(pTn, "InputLabelWrapper", T([
            OTn,
            A2(Iwn, sTn(0), sTn(6))
        ]))
    ]), dNn = F3(function(n, r, t) {
        return oTn(T([
            cTn.$8,
            fTn(sTn(n)),
            mTn(sTn(r)),
            aTn(sTn(t))
        ]));
    }), bNn = $Tn(0), pNn = rwn("checked"), vNn = oTn(T([
        sNn.k7,
        fNn.op,
        FTn.l6
    ])), $Nn = T([
        A2(pTn, "Select", T([
            QTn,
            zwn,
            cTn.dj,
            Rwn(Wun),
            A2(XTn, 3, Kun),
            Hwn(T([
                hTn(T([
                    A2(pTn, "SelectButtonTitle", T([
                        GTn(qwn),
                        Rwn(Run.jT),
                        vNn
                    ]))
                ]))
            ])),
            A2(pwn, "SelectOpened", T([
                Rwn(Run.jT),
                hTn(T([
                    A2(pTn, "SelectList", T([
                        OTn
                    ])),
                    A2(pTn, "SelectButtonTitle", T([
                        GTn(qwn)
                    ])),
                    A2(pTn, "SelectButtonIcon", T([
                        Rwn(Run.jT),
                        iwn(qwn)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "SelectNative", T([
            Pwn(sTn(50))
        ])),
        A2(pTn, "SelectDisabled", g),
        A2(pTn, "SelectButton", T([
            QTn,
            zwn
        ])),
        A2(pTn, "SelectButtonIcon", T([
            dwn(sTn(3)),
            Rwn(Zun),
            A2(kCn, 2, Kun),
            bwn(sTn(28)),
            DTn(sTn(26)),
            iwn(Run.jT)
        ])),
        A2(pTn, "SelectButtonTitle", T([
            zwn,
            QTn,
            A2(Iwn, sTn(0), sTn(8)),
            GTn(Kun),
            awn.ji,
            hwn.jF,
            sNn.k7,
            fNn.op,
            FTn.l6
        ])),
        A2(pTn, "SelectList", T([
            vTn.ol,
            A3(dNn, 26, -3, -3),
            Dwn(99),
            Rwn(Run.jT),
            GTn(qwn),
            A2(XTn, 3, Kun),
            dwn(sTn(3))
        ])),
        A2(pTn, "SelectItem", T([
            dwn(sTn(6)),
            GTn(qwn),
            Hwn(T([
                Rwn(Run.nu)
            ]))
        ])),
        A2(pTn, "SelectItemSelected", T([
            Rwn(Run.nw)
        ])),
        A2(pTn, "SelectEmpty", g),
        A2(pTn, "SelectRadios", T([
            OTn,
            Rwn(Kun),
            A3(NCn, sTn(0), sTn(3), sTn(3))
        ])),
        A2(pTn, "SelectRadio", T([
            QTn
        ])),
        A2(pTn, "SelectRadiosItem", T([
            QTn,
            Rwn(Zun),
            A2(XTn, 3, Qun),
            lwn(sTn(3)),
            zwn,
            hwn.jF,
            Hwn(T([
                GTn(qwn)
            ]))
        ])),
        A2(pTn, "SelectRadiosLabel", T([
            A2(Iwn, sTn(6), sTn(4))
        ])),
        A2(pTn, "SelectRadiosType", T([
            A2(Fwn, sTn(0), sTn(6)),
            bwn(sTn(18)),
            DTn(sTn(18)),
            A2(XTn, 2, Wun),
            A2(HTn, "box-shadow", "inset 0 0 0 2px " + Zun),
            cCn(sTn(10))
        ])),
        A2(pTn, "SelectRadiosInput", T([
            cTn.$8,
            fTn(sTn(-9999)),
            aTn(sTn(-9999)),
            pNn(T([
                bNn(T([
                    A2(pTn, "SelectRadiosItem", T([
                        BCn(Run.jT),
                        GTn(qwn),
                        hTn(T([
                            A2(pTn, "SelectRadiosType", T([
                                BCn(Run.jT),
                                Rwn(Run.jT)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), gNn = T([
        A2(pTn, "SelectMultiple", T([
            QTn,
            zwn,
            cTn.dj,
            Rwn(Wun),
            A2(XTn, 3, Kun)
        ])),
        A2(pTn, "SelectMultipleDisabled", g),
        A2(pTn, "SelectMultipleLabel", T([
            OTn,
            A2(Fwn, sTn(10), sTn(0))
        ])),
        A2(pTn, "SelectMultipleLabelText", T([
            ACn(sTn(10))
        ])),
        A2(pTn, "SelectMultipleList", T([
            OTn,
            zwn,
            Rwn(Wun),
            GTn(qwn),
            dwn(sTn(3))
        ])),
        A2(pTn, "SelectMultipleItem", T([
            dwn(sTn(6)),
            GTn(qwn),
            Hwn(T([
                Rwn(Run.nu)
            ]))
        ])),
        A2(pTn, "SelectMultipleItemSelected", T([
            Rwn(Run.nw)
        ]))
    ]), hNn = oTn(T([
        lwn(sTn(3)),
        ewn(T([
            lwn(sTn(0))
        ]))
    ])), kNn = T([
        A2(pTn, "HeaderWrapper", T([
            QTn,
            zwn,
            hNn,
            hwn.jF,
            DTn(sTn(40)),
            Rwn(Qun)
        ])),
        A2(pTn, "HeaderLogo", T([
            cTn.dj,
            fTn(sTn(-5)),
            aTn(sTn(-4)),
            KCn.lP,
            Dwn(99)
        ])),
        A2(pTn, "HeaderBreadcrumb", T([
            QTn,
            zwn
        ])),
        A2(pTn, "HeaderBreadcrumbItem", T([
            QTn,
            hwn.jF,
            GTn(Jun),
            Bwn(sTn(10)),
            Hwn(T([
                GTn(qwn)
            ]))
        ])),
        A2(pTn, "HeaderBreadcrumbItemLogo", T([
            A2(XTn, 3, Kun),
            vTn.jg,
            CCn(sTn(32)),
            Pwn(sTn(50)),
            bwn(YTn),
            DTn(YTn),
            A2(HTn, "object-fit", "cover")
        ])),
        A2(pTn, "HeaderBreadcrumbItemDisabled", T([
            QTn,
            hwn.jF,
            GTn(Yun),
            Bwn(sTn(10)),
            iwn(Wun)
        ])),
        A2(pTn, "HeaderBreadcrumbLabel", T([
            Mwn(sTn(10)),
            Bwn(sTn(6)),
            QTn,
            hwn.jF
        ]))
    ]), TNn = "#AB47BC", wNn = HTn("stroke"), CNn = T([
        A2(pTn, "Bg", T([
            _Tn(Qun)
        ])),
        A2(pTn, "Fg", T([
            _Tn(Run.jT)
        ])),
        A2(pTn, "IconButton", g),
        A2(pTn, "Stroked", T([
            wNn(Run.jT)
        ])),
        A2(pTn, "IconChoice", g),
        A2(pTn, "IconSort", g),
        A2(pTn, "IconSearch", g),
        A2(pTn, "IconSmallDownload", g),
        A2(pTn, "IconDelete", g),
        A2(pTn, "IconKo", g),
        A2(pTn, "IconOk", g),
        A2(pTn, "IconBigFile", g),
        A2(pTn, "IconFileWithLabel", g),
        A2(pTn, "IconBullet", g),
        A2(pTn, "IconAvatar", g),
        A2(pTn, "IconSpinner", g),
        A2(pTn, "IconIcon18", g),
        A2(pTn, "IconIcon24", g),
        A2(pTn, "IconLogo", g),
        A2(pTn, "IconLaab", g),
        A2(pTn, "IconPadok", T([
            wNn(TNn)
        ])),
        A2(pTn, "IconSettings", g),
        A2(pTn, "IconPlus", g),
        A2(pTn, "IconBack", g),
        A2(pTn, "IconBreadcrumb", T([
            _Tn(Kun)
        ]))
    ]), NNn = function(n) {
        return rwn("nth-child(" + n + ")");
    }, ANn = T([
        A2(pTn, "KeyValueWrapper", T([
            OTn,
            Rwn(Zun),
            Ywn(sTn(4))
        ])),
        A2(pTn, "KeyValueRow", T([
            QTn,
            A2(NNn, "odd", T([
                kwn("rgba(255,255,255,0.05)")
            ]))
        ])),
        A2(pTn, "KeyValueKey", T([
            awn.ji,
            bwn(xTn(38)),
            GTn(Yun),
            A2(Iwn, sTn(4), sTn(10))
        ])),
        A2(pTn, "KeyValueValue", T([
            zwn,
            GTn(Jun),
            A2(Iwn, sTn(4), sTn(10))
        ])),
        A2(pTn, "KeyValueHeader", T([
            awn.ji,
            Swn(sTn(15)),
            GTn(Yun),
            A2(Iwn, sTn(6), sTn(20))
        ])),
        A2(pTn, "KeyValueWrapperHeader", T([
            QTn,
            kwn(Zun)
        ]))
    ]), SNn = T([
        A2(pTn, "LayoutPageWrapper", T([
            bwn(xTn(100)),
            OTn,
            zwn,
            FTn.i8
        ])),
        A2(pTn, "LayoutPageHeader", T([
            dwn(sTn(10))
        ])),
        A2(pTn, "LayoutPageTitle", T([
            vTn.mo,
            Bwn(sTn(10))
        ])),
        A2(pTn, "LayoutPageContent", T([
            Rwn(Qun),
            OTn,
            zwn,
            FTn.i8
        ])),
        A2(pTn, "LayoutPageActions", T([
            uwn.pO
        ])),
        A2(pTn, "LayoutAppBarWrapper", T([
            DTn(sTn(80)),
            QTn,
            Ywn(sTn(4))
        ])),
        A2(pTn, "LayoutAppBar", T([
            A2(Iwn, sTn(8), sTn(15)),
            Rwn(Wun),
            QTn,
            zwn,
            hTn(T([
                A2(TTn, "h1", T([
                    GTn(Kun),
                    FTn.l6,
                    DTn(sTn(25))
                ])),
                A2(TTn, "h2", T([
                    GTn("rgba(255,255,255,.8)")
                ])),
                A2(TTn, "h3", T([
                    GTn("rgba(0,0,0,.6)"),
                    Swn(sTn(13)),
                    lwn(sTn(2)),
                    Zwn.sm,
                    awn.ji
                ]))
            ]))
        ])),
        A2(pTn, "LayoutAppBarTitle", T([
            OTn,
            ywn.jF,
            zwn
        ])),
        A2(pTn, "LayoutAppBarActions", T([
            KCn.jF,
            QTn,
            DTn(sTn(32))
        ])),
        A2(pTn, "LayoutHeader", T([
            QTn,
            hwn.jF,
            A2(Iwn, vwn, sTn(8)),
            DTn(sTn(48)),
            Rwn(Run.nw),
            GTn(Kun),
            Ywn(sTn(4)),
            hTn(T([
                A2(pTn, "ButtonLabel", T([
                    Rwn(nan)
                ]))
            ]))
        ])),
        A2(pTn, "LayoutHeaderTitle", T([
            Swn(sTn(15)),
            Bwn(sTn(8)),
            awn.jj,
            zwn,
            GTn(qwn),
            A4(LCn, sTn(1), sTn(1), sTn(1), gCn)
        ])),
        A2(pTn, "LayoutSubHeader", T([
            QTn,
            A2(Iwn, sTn(5), sTn(10)),
            Rwn(Qun),
            GTn(Jun),
            Ywn(sTn(4))
        ])),
        A2(pTn, "LayoutSmallHeader", T([
            QTn,
            A2(Iwn, sTn(4), sTn(10)),
            Rwn(Qun),
            GTn(Wun),
            Ywn(sTn(4))
        ])),
        A2(pTn, "LayoutHeaderActions", g),
        A2(wTn, T([
            pTn("LayoutHomeButton"),
            pTn("LayoutBackButton")
        ]), T([
            QTn,
            WCn,
            bwn(sTn(80)),
            Rwn(Wun),
            aCn(sTn(2)),
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(nan)
                ]))
            ])),
            Hwn(T([
                Rwn(Jun)
            ]))
        ])),
        A2(pTn, "LayoutBloc", T([
            Rwn(Zun),
            dwn(sTn(3)),
            Ywn(sTn(3))
        ])),
        A2(pTn, "LayoutDetails", T([
            Rwn(Zun),
            dwn(sTn(3)),
            lwn(sTn(3))
        ])),
        A2(pTn, "LayoutDetailsHeader", T([
            dwn(sTn(3)),
            GTn(Jun)
        ])),
        A2(pTn, "LayoutDetailsContent", T([
            dwn(sTn(6)),
            Rwn(Kun)
        ])),
        A2(pTn, "LayoutFwdButton", T([
            QTn,
            WCn,
            bwn(sTn(80)),
            Rwn(Wun),
            A2(hCn, 2, Kun),
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(nan)
                ]))
            ])),
            Hwn(T([
                Rwn(Jun)
            ]))
        ]))
    ]), LNn = T([
        A2(pTn, "LoadingWrapper", T([
            DTn(xTn(100)),
            bwn(xTn(100)),
            hwn.jF,
            ywn.jF,
            vTn.lL,
            QTn,
            zwn
        ])),
        A2(pTn, "LoadingSpinner", T([
            bwn(sTn(100)),
            DTn(sTn(40)),
            Own.jF
        ])),
        A2(pTn, "LoadingMiniSpinner", T([
            bwn(sTn(18)),
            DTn(sTn(18))
        ])),
        A2(pTn, "IconSpinner", T([
            A2(HTn, "animation", "anim_spin 1s linear infinite")
        ]))
    ]), yNn = F2(function(n, r) {
        return oTn(T([
            cTn.$8,
            fTn(sTn(n)),
            aTn(sTn(r))
        ]));
    }), FNn = F2(function(n, r) {
        return A3(UTn, r, n, 0);
    }), jNn = T([
        A2(pTn, "MenuWrapper", T([
            A4(dTn, 0, 0, 0, 0),
            QTn,
            Rwn("rgba(24, 31, 41, .6)"),
            Dwn(9)
        ])),
        A2(pTn, "MenuMain", T([
            OTn,
            Rwn(Kun),
            A2(HTn, "outline", "4px solid " + Kun)
        ])),
        A2(pTn, "MenuHeader", T([
            DTn(sTn(80)),
            QTn
        ])),
        A2(pTn, "MenuHeaderTitle", T([
            QTn,
            zwn,
            dwn(sTn(15)),
            hwn.jF,
            Rwn(Wun),
            GTn(Kun)
        ])),
        A2(pTn, "MenuList", T([
            OTn,
            Rwn(Kun),
            A2(XTn, 10, Qun),
            hTn(T([
                A2(pTn, "MenuItem", T([
                    DTn(sTn(40))
                ])),
                A2(pTn, "MenuItemIcon", T([
                    bwn(sTn(50))
                ]))
            ]))
        ])),
        A2(LTn, T([
            "(max-width: 650px)"
        ]), T([
            A2(pTn, "MenuWrapper", T([
                FTn.i8
            ]))
        ])),
        A2(LTn, T([
            "(min-width: 650px)"
        ]), T([
            A2(pTn, "MenuList", T([
                zwn,
                vTn.ol,
                FTn.i8,
                A4(dTn, 0, 100, 0, 304),
                Pwn(sTn(400)),
                dwn(sTn(4)),
                A2(HTn, "outline", "4px solid " + Kun)
            ])),
            A2(TTn, ".MenuOpened .MenuGroup:hover .MenuList", T([
                vTn.lL
            ])),
            A2(TTn, ".MenuOpened .MenuMain", T([
                bwn(sTn(300))
            ])),
            A2(TTn, ".MenuOpened .MenuGroup:hover > .MenuItem", T([
                hTn(T([
                    A2(pTn, "MenuItemIcon", T([
                        Rwn(Run.nu),
                        iwn(qwn)
                    ])),
                    A2(pTn, "MenuItemTitle", T([
                        Rwn(Qun),
                        GTn(qwn)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "MenuItem", T([
            DTn(sTn(80)),
            A2(Nwn, 4, Kun),
            cTn.dj,
            Dwn(99),
            QTn,
            _wn.o6,
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(Run.nu),
                    ETn
                ])),
                A2(pTn, "Stroked", T([
                    wNn(Run.nu),
                    ETn
                ]))
            ])),
            XCn(T([
                hTn(T([
                    A2(pTn, "MenuItemIcon", T([
                        Rwn(Qun)
                    ])),
                    A2(pTn, "MenuItemTitle", T([
                        Rwn(Qun),
                        GTn(qwn)
                    ])),
                    A2(pTn, "Fg", T([
                        _Tn(Run.jT)
                    ])),
                    A2(pTn, "Stroked", T([
                        wNn(qwn)
                    ]))
                ]))
            ])),
            Hwn(T([
                hTn(T([
                    A2(pTn, "MenuItemIcon", T([
                        Rwn(Run.nu),
                        iwn(qwn)
                    ]))
                ]))
            ])),
            A2(pwn, "MenuLogout", T([
                hTn(T([
                    A2(pTn, "Fg", T([
                        _Tn(tan.nw)
                    ]))
                ])),
                Hwn(T([
                    Gwn(T([
                        TCn(T([
                            Rwn(tan.nu)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(TTn, ".MenuItemIcon:hover + .MenuItemTitle", T([
            vTn.lL
        ])),
        A2(pTn, "MenuItemTitle", T([
            DTn(xTn(100)),
            A2(yNn, 0, 94),
            A2(Iwn, vwn, sTn(25)),
            Rwn(Zun),
            Swn(sTn(16)),
            Swn(sTn(18)),
            awn.ji,
            GTn(Yun),
            OTn,
            ywn.jF,
            A2(HTn, "outline", "4px solid " + Kun)
        ])),
        A2(pTn, "MenuClosed", T([
            bwn(sTn(90)),
            hTn(T([
                A2(pTn, "MenuItemTitle", T([
                    vTn.ol
                ]))
            ]))
        ])),
        A2(pTn, "MenuOpened", T([
            A2(HTn, "outline", "4px solid " + Kun),
            hTn(T([
                A2(pTn, "MenuItem", T([
                    bwn(YTn),
                    vTn.lL
                ])),
                A2(pTn, "MenuItemTitle", T([
                    cTn.dj,
                    aTn(sTn(4)),
                    vTn.lL,
                    zwn,
                    Ewn(sTn(210)),
                    bwn(YTn)
                ]))
            ]))
        ])),
        A2(pTn, "MenuItemIcon", T([
            bwn(sTn(90)),
            DTn(xTn(100)),
            Rwn(Zun),
            ETn,
            WCn,
            iwn(Wun),
            qTn(0)
        ])),
        A2(pTn, "MenuUser", T([
            cTn.$8,
            uTn(sTn(0)),
            aTn(sTn(0)),
            bwn(sTn(80)),
            DTn(sTn(148)),
            A2(Awn, 2, Kun),
            A2(FNn, 0, 0),
            ETn
        ])),
        A2(pTn, "MenuAvatar", T([
            A2(XTn, 3, Zun),
            Rwn(Zun),
            hTn(T([
                A2(TTn, "img", T([
                    CCn(sTn(28)),
                    Pwn(sTn(50))
                ]))
            ]))
        ])),
        A2(pTn, "UserCard", T([
            Own.jF
        ])),
        A2(pTn, "UserCardStatus", g),
        A2(pTn, "MenuSpacer", T([
            zwn,
            Ywn(sTn(4)),
            Rwn(Zun)
        ])),
        A2(pTn, "MenuIntercom", T([
            DTn(sTn(90)),
            Rwn(Qun)
        ])),
        A2(pTn, "MenuSettings", T([
            OTn,
            A2(XTn, 10, Zun),
            dwn(sTn(4)),
            A2(PCn, T([
                "(min-width: 650px)"
            ]), T([
                bwn(sTn(280)),
                aCn(sTn(4))
            ]))
        ])),
        A2(pTn, "MenuSettingsExpand", T([
            zwn,
            Rwn(Zun),
            lwn(sTn(4))
        ])),
        A2(pTn, "MenuSettingsItems", T([
            OTn,
            zwn,
            dwn(sTn(4)),
            A2(XTn, 10, Qun),
            DTn(sTn(100)),
            Qwn.i8
        ])),
        A2(pTn, "MenuSettingsItem", T([
            QTn,
            dwn(sTn(16)),
            Rwn(Zun),
            lwn(sTn(4)),
            Hwn(T([
                Rwn(Qun)
            ])),
            ewn(T([
                lwn(vwn)
            ]))
        ])),
        A2(pTn, "MenuSettingsTitle", T([
            OTn,
            KCn.jF,
            zwn
        ])),
        A2(pTn, "MenuSettingsProfile", T([
            Swn(sTn(16)),
            iwn(Run.jT),
            Rwn(Qun),
            GTn("rgba(255,255,255,.5)"),
            Hwn(T([
                GTn(qwn),
                Rwn(Run.eE)
            ]))
        ])),
        A2(pTn, "MenuSettingsLogout", T([
            Swn(sTn(16)),
            iwn(tan.jT),
            _wn.o6,
            Rwn(tan.eF),
            GTn(tan.md),
            Hwn(T([
                GTn(qwn),
                Rwn(tan.eE)
            ]))
        ])),
        A2(pTn, "MenuSettingsSub", T([
            OTn,
            zwn,
            FTn.i8
        ])),
        A2(pTn, "SettingsTitle", T([
            Swn(sTn(18)),
            GTn(qwn)
        ])),
        A2(pTn, "SettingsForm", T([
            dwn(sTn(10)),
            Pwn(sTn(500)),
            Rwn(Zun)
        ])),
        A2(pTn, "MenuSettingsActive", T([
            Rwn(Run.nu),
            GTn(Run.nf),
            Hwn(T([
                Rwn(Run.jT)
            ]))
        ])),
        A2(pTn, "SettingsContainer", T([
            Rwn(Zun),
            Wwn.l6,
            Qwn.i8,
            OTn,
            zwn
        ])),
        A2(pTn, "MenuSettingsIcon", T([
            bwn(sTn(44)),
            DTn(sTn(44)),
            aCn(sTn(10)),
            QTn,
            hwn.jF,
            ywn.jF,
            Rwn(Kun)
        ]))
    ]), PNn = F4(function(n, r, t, e) {
        return "rgba(" + It(n) + "," + It(r) + "," + It(t) + "," + mL(e) + ")";
    }), INn = T([
        A2(pTn, "ModalWrapper", T([
            Rwn(Kun),
            Dwn(999),
            A4(eNn, sTn(-5), sTn(0), sTn(0), A4(PNn, 24, 31, 41, .3)),
            Ywn(sTn(0)),
            Bwn(sTn(3))
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), T([
            A2(pTn, "ModalWrapper", T([
                cTn.lI,
                fTn(sTn(0)),
                uTn(sTn(0)),
                mTn(sTn(0)),
                bwn(xTn(80)),
                Pwn(sTn(800)),
                fwn(sTn(0)),
                FTn.i8
            ]))
        ])),
        A2(pTn, "ModalTitle", T([
            Rwn(Qun),
            QTn,
            dwn(sTn(10)),
            Swn(sTn(20)),
            GTn(Yun),
            ywn.qX,
            cTn.hv,
            Dwn(99),
            fTn(sTn(0)),
            A2(Nwn, 3, Kun)
        ])),
        A2(pTn, "ModalContent", T([
            OTn,
            nCn(3),
            dwn(sTn(10)),
            ACn(sTn(20)),
            Rwn(Zun),
            GTn(Yun)
        ])),
        A2(pTn, "ModalSubmit", T([
            QTn,
            nCn(6),
            ywn.bR,
            dwn(sTn(10)),
            cTn.hv,
            Dwn(99),
            uTn(sTn(0)),
            Rwn(Qun),
            A2(Awn, 3, Kun)
        ]))
    ]), BNn = T([
        A2(pTn, "ProgressIdle", T([
            Rwn(Run.jT),
            mwn(50)
        ])),
        A2(pTn, "ProgressActive", T([
            Rwn(Run.jT)
        ])),
        A2(pTn, "ProgressPaused", T([
            Rwn(RCn.jT)
        ])),
        A2(pTn, "ProgressError", T([
            Rwn(tan.jT)
        ])),
        A2(pTn, "ProgressWarning", T([
            Rwn(RCn.jT)
        ])),
        A2(pTn, "ProgressCompleted", T([
            Rwn(Hun.jT)
        ])),
        A2(pTn, "ProgressBarProgressing", T([
            A2(kCn, 3, Qun)
        ])),
        A2(pTn, "ProgressBarOuter", T([
            A2(XTn, 3, Zun),
            Rwn(_un)
        ])),
        A2(pTn, "ProgressBarInner", T([
            vTn.jg,
            DTn(sTn(16))
        ])),
        A2(pTn, "ProgressBarAnimated", T([
            A2(HTn, "background-size", "1rem 1rem"),
            A2(HTn, "background-image", "linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)"),
            A2(HTn, "-webkit-animation", "progress-bar-animated 1s linear infinite"),
            A2(HTn, "animation", "progress-bar-animated 1s linear infinite")
        ]))
    ]), MNn = T([
        A2(pTn, "Search", T([
            QTn,
            Rwn(Kun),
            dwn(sTn(3)),
            DTn(sTn(32)),
            hTn(T([
                A2(TTn, "input", T([
                    A2(XTn, 0, ""),
                    zwn,
                    Rwn(Zun),
                    fwn(vwn)
                ]))
            ]))
        ])),
        A2(pTn, "SearchIcon", T([
            Rwn(Zun),
            WCn,
            bwn(sTn(28))
        ])),
        A2(pTn, "SearchInput", T([
            zwn,
            QTn,
            uCn(sTn(2)),
            vTn.ol,
            uNn(T([
                vTn.lL
            ])),
            A2(pwn, "Searching", T([
                vTn.lL
            ]))
        ])),
        A2(pTn, "SearchResults", T([
            OTn,
            FTn.i8,
            zwn,
            cTn.lI,
            fTn(sTn(36)),
            aTn(sTn(94)),
            bwn(sTn(330)),
            CCn(xTn(90)),
            A4(dCn, sTn(0), sTn(4), sTn(4), sTn(4)),
            Dwn(9),
            Rwn(Kun),
            ETn,
            A2(HTn, "outline", "3px solid " + Kun)
        ])),
        A2(pTn, "SearchClosed", T([
            hTn(T([
                A2(pTn, "SearchResults", T([
                    cNn.ol,
                    mwn(0)
                ]))
            ]))
        ])),
        A2(pTn, "SearchResultsItem", T([
            Rwn(Zun),
            A2(Iwn, sTn(4), sTn(8)),
            A2(XTn, 2, Zun),
            Ywn(sTn(2)),
            Hwn(T([
                A2(XTn, 2, Qun),
                Gwn(T([
                    A2(pTn, "SearchResultsTitle", T([
                        GTn(Jun)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "SearchResultsPath", T([
            GTn(Wun),
            vNn
        ])),
        A2(pTn, "SearchResultsMaster", T([
            iwn(Run.jT)
        ])),
        A2(pTn, "SearchResultsShow", T([
            iwn(TNn)
        ])),
        A2(pTn, "SearchResultsTitle", T([
            Swn(sTn(14)),
            awn.ji,
            GTn(Run.jT),
            QTn,
            hwn.jF
        ]))
    ]), ONn = T([
        A2(pTn, "Switch", T([
            _wn.o6,
            bwn(sTn(30)),
            DTn(sTn(15)),
            cCn(sTn(15)),
            kwn(Wun),
            vTn.jg,
            cTn.dj,
            KCn.jF
        ])),
        A2(pTn, "Switcher", T([
            cTn.$8,
            fTn(sTn(3)),
            aTn(sTn(3)),
            bwn(sTn(9)),
            DTn(sTn(9)),
            VTn("300ms"),
            kwn(qwn),
            cCn(xTn(50))
        ])),
        A2(pTn, "SwitchChecked", T([
            kwn(Run.jT),
            hTn(T([
                A2(pTn, "Switcher", T([
                    A2(HTn, "left", "calc(100% - " + It(3) + "px)"),
                    zTn("translateX(-100%)")
                ]))
            ]))
        ])),
        A2(pTn, "SwitchDisabled", T([
            _wn.kC,
            mwn(50)
        ]))
    ]), qNn = {
        cs: A2(eTn, "vertical-align", "baseline"),
        jl: A2(eTn, "vertical-align", "bottom"),
        nd: A2(eTn, "vertical-align", "length"),
        f1: A2(eTn, "vertical-align", "middle"),
        ri: A2(eTn, "vertical-align", "sub"),
        rw: A2(eTn, "vertical-align", "super"),
        rP: A2(eTn, "vertical-align", "text-bottom"),
        rQ: A2(eTn, "vertical-align", "text-top"),
        rZ: A2(eTn, "vertical-align", "top")
    }, DNn = T([
        A2(pTn, "Table", T([
            Ewn(xTn(100)),
            cTn.dj,
            bwn(xTn(100))
        ])),
        A2(pTn, "TableHeader", T([
            DTn(sTn(40)),
            qNn.f1,
            Own.c0,
            A2(Awn, 2, Zun),
            A2(Nwn, 2, Zun),
            dwn(sTn(10)),
            A2(pwn, "TableRight", T([
                Own.pO
            ]))
        ])),
        A2(TTn, "th", T([
            DTn(sTn(40)),
            qNn.f1,
            Own.c0,
            A2(Awn, 2, Zun),
            A2(Nwn, 2, Zun),
            dwn(sTn(10)),
            cTn.hv,
            fTn(sTn(0)),
            Dwn(1),
            Rwn(Zun),
            A2(pwn, "TableRight", T([
                Own.pO
            ]))
        ])),
        A2(pTn, "TableTr", T([
            kwn("rgba(0,0,0,0.0)"),
            GTn(Jun),
            A2(NNn, "odd", T([
                kwn("rgba(0,0,0,0.1)")
            ]))
        ])),
        A2(pTn, "TableTrHead", T([
            Rwn(Zun),
            GTn(Wun)
        ])),
        A2(TTn, "td", T([
            A2(Iwn, sTn(3), sTn(10))
        ])),
        A2(pTn, "TableTdBold", T([
            A2(Iwn, sTn(3), sTn(10)),
            awn.ji,
            GTn(Gun)
        ])),
        A2(pTn, "TableTh", T([
            A2(Iwn, sTn(3), sTn(10)),
            GTn(Wun),
            awn.ji,
            Own.c0
        ]))
    ]), xNn = function(n) {
        return A2(eTn, "letter-spacing", tTn(n));
    }, RNn = wwn("selection"), VNn = T([
        A2(pTn, "TimecodeWrapper", T([
            QTn,
            dwn(sTn(3)),
            Rwn(Kun),
            yCn,
            tCn(sTn(16))
        ])),
        A2(pTn, "TimecodeSep", T([
            A2(Iwn, sTn(0), sTn(2)),
            ywn.jF
        ])),
        A2(pTn, "TimecodeUnit", T([
            Rwn(Zun),
            GTn(Wun),
            A2(Iwn, sTn(0), sTn(3)),
            ywn.jF,
            awn.ji,
            xNn(sTn(2)),
            QTn,
            zwn
        ])),
        A2(pTn, "TimecodeHH", T([
            GTn(Jun)
        ])),
        A2(pTn, "TimecodeMM", T([
            GTn(Jun)
        ])),
        A2(pTn, "TimecodeSS", g),
        A2(pTn, "TimecodeFF", T([
            GTn(_un)
        ])),
        A2(TTn, "input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button", T([
            fwn(sTn(0)),
            A2(HTn, "-webkit-appearance", "none")
        ])),
        A2(pTn, "TimecodeEditable", T([
            A2(kCn, 2, Kun),
            Rwn(Zun),
            GTn(Wun),
            yCn,
            A2(Iwn, sTn(0), sTn(3)),
            tCn(sTn(24)),
            ywn.jF,
            awn.ji,
            xNn(sTn(2)),
            QTn,
            bwn(sTn(120)),
            Own.jF,
            RNn(T([
                GTn(qwn),
                Rwn(Run.jT)
            ]))
        ])),
        A2(pTn, "TimecodeDarker", T([
            hTn(T([
                A2(pTn, "TimecodeWrapper", T([
                    Rwn(Qun)
                ])),
                A2(pTn, "TimecodeUnit", T([
                    Rwn(Kun)
                ]))
            ]))
        ]))
    ]), ENn = T([
        A2(pTn, "UploadWrapper", T([
            cTn.lI,
            fTn(sTn(0)),
            uTn(sTn(0)),
            aTn(sTn(0)),
            mTn(sTn(0)),
            Dwn(999999)
        ])),
        A2(pTn, "UploadMask", T([
            A4(dTn, 0, 0, 0, 0),
            Rwn(Run.jT),
            mwn(75)
        ])),
        A2(pTn, "UploadClose", T([
            A2($Cn, 20, 20),
            Hwn(T([
                GTn(Run.jT)
            ]))
        ])),
        A2(pTn, "UploadDropping", T([
            A4(dTn, 40, 40, 40, 40),
            WCn,
            GTn(qwn),
            Swn(sTn(16))
        ])),
        A2(pTn, "UploadContainer", T([
            A4(dTn, 88, 88, 88, 88),
            Rwn(Kun),
            Wwn.l6,
            Qwn.i8
        ])),
        A2(pTn, "UploadContent", T([
            A2(Iwn, sTn(20), sTn(50)),
            Pwn(sTn(600)),
            A2(Fwn, sTn(0), YTn)
        ])),
        A2(pTn, "UploadTitle", T([
            Swn(sTn(20)),
            GTn(qwn),
            fwn(sTn(20)),
            awn.ji,
            Own.jF
        ])),
        A2(pTn, "UploadSubtitle", T([
            GTn("white"),
            oNn(sTn(20))
        ])),
        A2(pTn, "UploadInput", T([
            vTn.ol
        ])),
        A2(pTn, "UploadDesc", T([
            Swn(sTn(16)),
            GTn(Yun)
        ])),
        A2(pTn, "UploadError", T([
            GTn(tan.nf),
            Rwn(tan.nw),
            dwn(sTn(10)),
            QTn,
            hwn.jF,
            ywn.jF
        ])),
        A2(pTn, "UploadErrorClose", T([
            uCn(sTn(10)),
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(tan.nf),
                    _wn.o6
                ])),
                A2(pTn, "IconDelete", T([
                    vTn.jg
                ]))
            ]))
        ])),
        A2(pTn, "UploadDrag", T([
            cTn.lI,
            Rwn("rgba(22, 32, 46, 0.6)"),
            GTn("white"),
            FCn.ol,
            cNn.ol
        ])),
        A2(pTn, "UploadItem", T([
            lwn(sTn(15))
        ])),
        A2(pTn, "UploadFile", T([
            cTn.dj,
            QTn,
            hwn.jF
        ])),
        A2(pTn, "UploadFileTitle", T([
            QTn,
            zwn
        ])),
        A2(pTn, "UploadFileSummary", T([
            OTn,
            uCn(sTn(10)),
            qTn(1),
            Ewn(sTn(0))
        ])),
        A2(pTn, "UploadFileName", T([
            fNn.op,
            FTn.l6,
            sNn.k7
        ])),
        A2(pTn, "UploadFileSize", T([
            fNn.op
        ])),
        A2(pTn, "UploadRemove", T([
            uCn(sTn(10))
        ])),
        A2(pTn, "UploadFilesItemIconStamps", T([
            cTn.$8,
            OTn,
            fTn(sTn(43)),
            aTn(sTn(30)),
            zTn("translate(-50%,-50%)")
        ])),
        A2(pTn, "UploadFilesItemIconStamp", T([
            QTn,
            Ewn(sTn(20)),
            DTn(sTn(17)),
            tCn(sTn(17)),
            fwn(sTn(2)),
            A2(Iwn, sTn(0), sTn(5)),
            cCn(sTn(10)),
            oTn(T([
                Swn(sTn(12)),
                awn.ji
            ])),
            GTn(qwn),
            ywn.jF,
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(qwn)
                ]))
            ]))
        ])),
        A2(pTn, "UploadFilesItemNormal", T([
            hTn(T([
                A2(pTn, "UploadFilesItemIconStamp", T([
                    Rwn(Run.jT)
                ])),
                A2(pTn, "Bg", T([
                    _Tn(Run.jT)
                ]))
            ]))
        ])),
        A2(pTn, "UploadFilesItemWarning", T([
            hTn(T([
                A2(pTn, "UploadFilesItemIconStamp", T([
                    kwn(RCn.nu)
                ])),
                A2(pTn, "UploadFilesItemWarning", T([
                    kwn(RCn.nu)
                ])),
                A2(pTn, "Bg", T([
                    _Tn(RCn.nu)
                ]))
            ]))
        ])),
        A2(pTn, "UploadCardIdWarning", T([
            GTn(qwn),
            bwn(sTn(50)),
            ywn.jF,
            Rwn(RCn.nu),
            awn.ji,
            dwn(sTn(4)),
            fwn(sTn(4))
        ])),
        A2(pTn, "UploadCardName", T([
            zwn,
            ywn.jF,
            awn.jj,
            GTn(Jun),
            dwn(sTn(4)),
            fwn(sTn(4))
        ])),
        A2(pTn, "UploadCardWrapper", T([
            OTn
        ])),
        A2(pTn, "UploadCardRow", T([
            QTn,
            A2(NNn, "odd", T([
                kwn("rgba(255,255,255,0.05)")
            ]))
        ]))
    ]), zNn = T([
        A2(pTn, "AdminCopyWrapper", T([
            OTn,
            hTn(T([
                A2(TTn, ".InputWrapper:last-child", T([
                    DTn(sTn(30))
                ]))
            ]))
        ]))
    ]), UNn = T([
        A2(pTn, "FTPCopyWrapper", T([
            OTn,
            hTn(T([
                A2(TTn, ".InputWrapper:last-child", T([
                    DTn(sTn(30))
                ]))
            ]))
        ]))
    ]), HNn = T([
        A2(pTn, "S3CopyWrapper", T([
            hTn(T([
                A2(TTn, ".InputWrapper:last-child", T([
                    DTn(sTn(30))
                ]))
            ]))
        ]))
    ]), WNn = Ju(T([
        DCn,
        UCn,
        ZCn,
        MNn,
        _Cn,
        nNn,
        rNn,
        tNn,
        mNn,
        $Nn,
        gNn,
        CNn,
        ANn,
        SNn,
        LNn,
        kNn,
        jNn,
        INn,
        BNn,
        ONn,
        DNn,
        VNn,
        ENn,
        HNn,
        UNn,
        zNn
    ])), QNn = T([
        A2(pTn, "AsideTabs", T([
            QTn,
            zwn,
            Rwn(Wun),
            A3(NCn, sTn(10), sTn(20), sTn(0)),
            cTn.dj,
            iwn(Kun)
        ])),
        A2(pTn, "AsideTab", T([
            dwn(sTn(15)),
            awn.ji,
            A2(XTn, 4, Kun),
            A2(Nwn, 0, ""),
            uCn(sTn(-4)),
            Swn(sTn(16)),
            awn.jj,
            QTn,
            zwn,
            hwn.jF,
            GTn(Kun),
            Rwn(Run.nw),
            Ywn(sTn(-4)),
            ACn(sTn(19)),
            _wn.o6,
            Hwn(T([
                GTn(Kun),
                kwn(Run.nu),
                ACn(sTn(15)),
                A2(Nwn, 4, Run.nw),
                hTn(T([
                    A2(pTn, "AsideTabsIcon", T([
                        A2(XTn, 3, Kun),
                        iwn(Kun)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AsideTabInner", T([
            fwn(sTn(6)),
            dwn(sTn(6)),
            A2(XTn, 3, Kun),
            QTn,
            zwn,
            hwn.jF
        ])),
        A2(pTn, "AsideTabLabel", T([
            QTn,
            zwn
        ])),
        A2(pTn, "AsideTabsIcon", T([
            A2(XTn, 3, Kun),
            iwn(Kun),
            aCn(sTn(8)),
            bwn(sTn(30)),
            DTn(sTn(30)),
            WCn
        ])),
        A2(pTn, "AsideToggleButton", T([
            QTn,
            WCn,
            bwn(sTn(80)),
            Rwn(Wun),
            aCn(sTn(4)),
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(nan)
                ]))
            ])),
            Hwn(T([
                Rwn(Jun)
            ]))
        ])),
        A2(pTn, "AsideHeader", T([
            QTn,
            DTn(sTn(80))
        ])),
        A2(pTn, "AsideBody", T([
            OTn,
            zwn,
            lwn(sTn(4)),
            A2(HTn, "gap", "3px"),
            FTn.i8,
            A2(Awn, 6, Run.nw),
            ewn(g)
        ])),
        A2(LTn, T([
            "(min-width: 600px)"
        ]), T([
            A2(pTn, "AsideBody", T([
                uCn(sTn(4))
            ]))
        ])),
        A2(pTn, "MasterFilesShowDesc", T([
            hTn(T([
                A2(pTn, "MasterFilesDesc", T([
                    vTn.lL,
                    Rwn(Kun)
                ])),
                A2(TTn, ".TableTr", T([
                    GTn(Wun)
                ]))
            ]))
        ])),
        A2(pTn, "MasterFilesAsset", T([
            Rwn(nan),
            Ywn(sTn(4))
        ])),
        A2(pTn, "AsideMenu", T([
            A2(yNn, 80, 16),
            mTn(sTn(20)),
            Dwn(99),
            OTn,
            vTn.ol,
            A2(XTn, 2, Kun),
            kwn(Run.nu)
        ])),
        A2(pTn, "AsideMenuItem", T([
            QTn,
            dwn(sTn(16)),
            GTn(Kun),
            Swn(sTn(15)),
            awn.ji,
            A2(XTn, 2, Kun),
            XCn(T([
                kwn(Run.mb)
            ]))
        ])),
        A3(RTn, "AsideMenuOpened", "AsideMenu", T([
            vTn.lL
        ])),
        A3(RTn, "AsideMenuOpened", "AsideTab", T([
            kwn(Run.mb)
        ]))
    ]), ZNn = function(n) {
        return A2(rwn, "not(:first-child)", n);
    }, KNn = T([
        A2(pTn, "DownloadList", T([
            OTn,
            A2(XTn, 3, Qun),
            dwn(sTn(3))
        ])),
        A2(pTn, "DownloadListItemWrapper", T([
            QTn,
            ZNn(T([
                A2(Awn, 3, Qun)
            ]))
        ])),
        A2(pTn, "DownloadListIcon", T([
            kwn(Qun),
            iwn(qwn),
            hTn(T([
                A2(TTn, "svg", T([
                    bwn(sTn(18))
                ]))
            ]))
        ])),
        A2(pTn, "DownloadListItem", T([
            OTn,
            zwn
        ])),
        A2(pTn, "DownloadListItemTitle", T([
            QTn
        ])),
        A2(pTn, "DownloadListItemDesc", T([
            QTn,
            Rwn(Jun)
        ])),
        A2(pTn, "DownloadListItemBullet", g),
        A2(pTn, "DownloadListItemFilename", T([
            zwn
        ])),
        A2(pTn, "DownloadListItemDownload", T([
            QTn
        ])),
        A2(pTn, "DownloadListItemDownloadIcon", g),
        A2(pTn, "DownloadListItemDownloadLabel", g),
        A2(pTn, "DownloadListItemSpecs", g),
        A2(pTn, "DownloadListAlt", g)
    ]), YNn = oTn(T([
        hwn.jF,
        ywn.jF
    ])), XNn = T([
        A2(pTn, "AudioQualifyWrapper", T([
            OTn,
            lwn(sTn(4)),
            Ywn(sTn(2)),
            A2(Iwn, vwn, sTn(2)),
            kwn(nan)
        ])),
        A2(pTn, "AudioQualifyTitleHeader", T([
            QTn,
            kwn(nan),
            hwn.jF,
            GTn(Gun)
        ])),
        A2(pTn, "AudioQualifyTitle", T([
            awn.jj,
            A2(Iwn, sTn(5), sTn(10)),
            Ywn(sTn(4)),
            zwn
        ])),
        A2(pTn, "AudioQualifyMemo", T([
            QTn,
            dwn(sTn(4))
        ])),
        A2(pTn, "AudioQualifyMemoLabel", T([
            QTn,
            zwn,
            GTn(Jun),
            A2(Iwn, sTn(0), sTn(5))
        ])),
        A2(pTn, "AudioQualifyMemoRecap", T([
            A2(Iwn, sTn(3), sTn(5)),
            Own.pO,
            GTn(Jun),
            mCn.mV,
            hTn(T([
                A2(TTn, ".ButtonMiniIcon", T([
                    vTn.mp,
                    fwn(sTn(5)),
                    Hwn(T([
                        Rwn(tan.jT)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AudioQualifyFilesAudioStream", T([
            Rwn(Qun),
            Ywn(sTn(2)),
            A2(XTn, 2, Zun)
        ])),
        A2(pTn, "AudioQualifyQualify", T([
            QTn,
            ywn.bR,
            Bwn(sTn(26)),
            kwn(Zun)
        ])),
        A2(pTn, "AudioQualifyQualifyItem", T([
            A2(Iwn, sTn(3), sTn(5)),
            GTn(Jun),
            zwn
        ])),
        A2(pTn, "AudioQualifyQualifyEdit", g),
        A2(pTn, "AudioQualifyQualifyForm", T([
            Rwn(Zun),
            OTn,
            dwn(sTn(4)),
            hTn(T([
                A2(TTn, "label", T([
                    A2(Iwn, sTn(0), sTn(4)),
                    tCn(sTn(28)),
                    QTn
                ]))
            ]))
        ])),
        A2(pTn, "AudioQualifyFilesHeader", T([
            QTn,
            hwn.jF,
            iCn(sTn(32)),
            Bwn(sTn(6)),
            Mwn(sTn(3))
        ])),
        A2(pTn, "AudioQualifyFilesTitle", T([
            zwn,
            GTn(Gun),
            A2(Iwn, sTn(3), sTn(6)),
            awn.ji,
            QTn,
            nCn(6)
        ])),
        A2(pTn, "AudioQualifyFilesDesc", T([
            vTn.ol,
            Ywn(sTn(2))
        ])),
        A2(pTn, "MasterFilesShowDesc", T([
            hTn(T([
                A2(pTn, "AudioQualifyFilesDesc", T([
                    vTn.lL,
                    Rwn(Kun)
                ])),
                A2(TTn, ".TableTr", T([
                    GTn(Wun)
                ]))
            ]))
        ])),
        A2(pTn, "PlayAudio", T([
            A2(Fwn, sTn(0), sTn(5))
        ])),
        A2(pTn, "AudioQualifyCheckbox", T([
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    bwn(sTn(30)),
                    A2(HTn, "flex", "unset")
                ]))
            ]))
        ]))
    ]), JNn = {
        jm: A2(eTn, "word-break", "break-all"),
        m1: A2(eTn, "word-break", "keep-all"),
        om: A2(eTn, "word-break", "normal")
    }, GNn = T([
        A2(pTn, "SubtitleQualifyWrapper", T([
            OTn,
            lwn(sTn(4)),
            Ywn(sTn(2)),
            A2(Iwn, vwn, sTn(2)),
            kwn(nan)
        ])),
        A2(pTn, "SubtitleQualifyTitleHeader", T([
            QTn,
            kwn(nan),
            hwn.jF,
            GTn(Gun)
        ])),
        A2(pTn, "SubtitleQualifyTitle", T([
            awn.jj,
            A2(Iwn, sTn(5), sTn(10)),
            Ywn(sTn(4)),
            zwn
        ])),
        A2(pTn, "SubtitleQualifyMemo", T([
            QTn,
            dwn(sTn(4))
        ])),
        A2(pTn, "SubtitleQualifyMemoLabel", T([
            QTn,
            zwn,
            GTn(Jun),
            A2(Iwn, sTn(0), sTn(5))
        ])),
        A2(pTn, "SubtitleQualifyMemoRecap", T([
            A2(Iwn, sTn(3), sTn(5)),
            Own.pO,
            GTn(Jun),
            mCn.mV,
            hTn(T([
                A2(TTn, ".ButtonMiniIcon", T([
                    vTn.mp,
                    fwn(sTn(5)),
                    Hwn(T([
                        Rwn(tan.jT)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "SubtitleQualifyFilesSubtitleStream", T([
            Rwn(Qun),
            Ywn(sTn(2)),
            A2(XTn, 2, Zun)
        ])),
        A2(pTn, "SubtitleQualifyQualify", T([
            QTn,
            ywn.bR,
            Bwn(sTn(26)),
            kwn(Zun)
        ])),
        A2(pTn, "SubtitleQualifyQualifyItem", T([
            A2(Iwn, sTn(3), sTn(5)),
            GTn(Jun),
            zwn
        ])),
        A2(pTn, "SubtitleQualifyQualifyEdit", g),
        A2(pTn, "SubtitleQualifyQualifyForm", T([
            Rwn(Zun),
            OTn,
            dwn(sTn(4)),
            hTn(T([
                A2(TTn, "label", T([
                    A2(Iwn, sTn(0), sTn(4)),
                    tCn(sTn(28)),
                    QTn
                ]))
            ]))
        ])),
        A2(pTn, "SubtitleQualifyFilesHeader", T([
            QTn,
            hwn.jF,
            iCn(sTn(32)),
            Bwn(sTn(6)),
            Mwn(sTn(3))
        ])),
        A2(pTn, "SubtitleQualifyFilesTitle", T([
            zwn,
            GTn(Gun),
            A2(Iwn, sTn(3), sTn(6)),
            awn.ji,
            JNn.jm
        ])),
        A2(pTn, "SubtitleQualifyFilesDesc", T([
            vTn.ol,
            Ywn(sTn(2))
        ])),
        A2(pTn, "MasterFilesShowDesc", T([
            hTn(T([
                A2(pTn, "SubtitleQualifyFilesDesc", T([
                    vTn.lL,
                    Rwn(Kun)
                ])),
                A2(TTn, ".TableTr", T([
                    GTn(Wun)
                ]))
            ]))
        ])),
        A2(pTn, "PlaySubtitle", T([
            A2(Fwn, sTn(0), sTn(5))
        ])),
        A2(pTn, "SubtitleQualifyCheckbox", T([
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    bwn(sTn(30)),
                    A2(HTn, "flex", "unset")
                ]))
            ]))
        ]))
    ]), _Nn = Ju(T([
        XNn,
        GNn,
        T([
            A2(wTn, T([
                pTn("MasterWrapper"),
                pTn("MasterShadow")
            ]), T([
                ETn,
                OTn
            ])),
            A2(pTn, "MasterWrapper", T([
                mwn(100),
                A3(UTn, 0, 0, 0)
            ])),
            A2(pTn, "MasterShadow", T([
                mwn(0),
                A3(UTn, 100, 0, 0)
            ])),
            A2(pTn, "MasterHeader", T([
                DTn(sTn(80)),
                dwn(sTn(10)),
                Rwn(Run.jT),
                OTn
            ])),
            A2(pTn, "MasterHeaderId", T([
                GTn(Run.nw),
                DTn(sTn(14))
            ])),
            A2(pTn, "MasterHeaderTitle", T([
                GTn(Kun),
                Lwn,
                zwn
            ])),
            A2(pTn, "MasterHome", T([
                QTn,
                zwn,
                FTn.i8
            ])),
            A2(pTn, "MasterTitle", T([
                Rwn(nan),
                Zwn.sm,
                A2(Iwn, vwn, sTn(10)),
                tCn(sTn(36)),
                GTn(Jun),
                QTn
            ])),
            A2(pTn, "MasterFiles", T([
                OTn,
                zwn
            ])),
            A2(pTn, "MasterFilesTitleDesc", T([
                GTn(Yun),
                Swn(sTn(12))
            ])),
            A2(pTn, "MasterHeaderSubTitle", T([
                GTn(Yun),
                Swn(sTn(12))
            ])),
            A2(pTn, "MasterMaterialWrapper", T([
                OTn
            ])),
            A2(pTn, "MasterMaterialTitle", T([
                Rwn(Qun),
                Zwn.sm,
                Swn(sTn(12)),
                A2(Iwn, sTn(5), sTn(10))
            ])),
            A2(pTn, "MasterMaterialTitleType", T([
                GTn(Yun)
            ])),
            A2(pTn, "MasterMaterialTitleFormat", T([
                GTn(Run.jT)
            ])),
            A2(pTn, "MasterMaterialItem", T([
                Rwn(Zun),
                A2(Iwn, sTn(4), sTn(10)),
                QTn,
                Ywn(sTn(4))
            ])),
            A2(pTn, "MasterMaterialItemThumb", T([
                bwn(sTn(160)),
                DTn(sTn(90)),
                Rwn(Zun),
                vTn.lL,
                YNn
            ])),
            A2(pTn, "MasterMaterialItemDetails", T([
                GTn(Wun),
                A2(XTn, 3, "rgba(0,0,0,0.2)"),
                zwn,
                FTn.i8
            ])),
            A2(pTn, "MasterWarning", T([
                DTn(sTn(40)),
                dwn(sTn(10)),
                kwn(RCn.nu),
                GTn(qwn),
                awn.jj,
                Swn(sTn(14)),
                vTn.lL,
                A2(Nwn, 4, Kun)
            ])),
            A2(pTn, "MasterError", g),
            A2(pTn, "MasterFilesWrapper", T([
                OTn,
                GTn(Jun),
                Wwn.i8
            ])),
            A2(pTn, "MasterFilesAsset", T([
                A2(Iwn, sTn(3), sTn(0)),
                Rwn(nan),
                Ywn(sTn(4))
            ])),
            A2(pTn, "MasterFilesToggleDesc", g),
            A2(pTn, "MasterFilesChildren", T([
                fwn(sTn(3)),
                hTn(T([
                    A2(pTn, "Fg", T([
                        _Tn(Wun)
                    ]))
                ]))
            ])),
            A2(pTn, "MasterFilesHeader", T([
                QTn,
                hwn.jF,
                iCn(sTn(32)),
                Gwn(T([
                    A2(pTn, "ProgressBarOuter", T([
                        zwn,
                        Pwn(sTn(250))
                    ]))
                ]))
            ])),
            A2(pTn, "MasterFilesIcon", T([
                bwn(sTn(28)),
                DTn(sTn(28)),
                WCn
            ])),
            A2(pTn, "MasterStreamIcon", T([
                bwn(sTn(22)),
                DTn(sTn(22)),
                WCn
            ])),
            A2(pTn, "MasterFilesTitle", T([
                zwn,
                Swn(sTn(15)),
                A2(Iwn, sTn(3), sTn(6)),
                awn.ji,
                JNn.jm
            ])),
            A2(pTn, "MasterFilesDownload", T([
                vTn.lL,
                MTn.pQ,
                hTn(T([
                    A2(pTn, "CustomButton", T([
                        aCn(sTn(5))
                    ])),
                    A2(TTn, "CustomButton:last-child", T([
                        aCn(sTn(10))
                    ]))
                ]))
            ])),
            A2(pTn, "MasterFilesDesc", T([
                vTn.ol,
                Ywn(sTn(4)),
                cTn.dj
            ])),
            A2(pTn, "MasterFilesVideoStream", T([
                Rwn(Qun),
                Ywn(sTn(2)),
                A2(XTn, 2, Zun),
                Bwn(sTn(6)),
                Mwn(sTn(3))
            ])),
            A2(pTn, "MasterFilesShowDesc", T([
                hTn(T([
                    A2(pTn, "MasterFilesDesc", T([
                        vTn.lL,
                        Rwn(Kun)
                    ])),
                    A2(TTn, ".TableTr", T([
                        GTn(Wun)
                    ]))
                ]))
            ])),
            A2(pTn, "MasterTimecodeInputCls", T([
                QTn,
                zwn
            ])),
            A2(pTn, "MasterFilesAudioStream", T([
                Rwn(Qun),
                Ywn(sTn(2)),
                A2(XTn, 2, Zun)
            ])),
            A2(pTn, "MasterChild", T([
                QTn,
                dwn(sTn(5)),
                Rwn(nan),
                Ywn(sTn(4)),
                hwn.jF
            ])),
            A2(pTn, "MasterChildLabel", T([
                rCn(1),
                qTn(1),
                Ewn(sTn(250)),
                fNn.op,
                FTn.l6,
                sNn.k7,
                awn.ji,
                GTn(Gun),
                Gwn(T([
                    A2(TTn, "a", T([
                        GTn("#F3F3F4"),
                        zCn.sa
                    ]))
                ]))
            ])),
            A2(pTn, "MasterTimecodeInput", T([
                QTn,
                zwn
            ])),
            A2(pTn, "MasterChildProgress", T([
                bwn(xTn(50)),
                qTn(1),
                Pwn(sTn(250))
            ])),
            A2(pTn, "MasterQualify", T([
                QTn
            ])),
            A2(pTn, "MasterQualifyItem", T([
                A2(Iwn, sTn(3), sTn(5)),
                GTn(Jun)
            ])),
            A2(pTn, "MasterQualifyEdit", g),
            A2(pTn, "MasterQualifyForm", T([
                Rwn(Zun),
                QTn,
                dwn(sTn(4)),
                hTn(T([
                    A2(TTn, "label", T([
                        A2(Iwn, sTn(0), sTn(4)),
                        tCn(sTn(28)),
                        QTn
                    ]))
                ]))
            ])),
            A2(pTn, "ReversedLayout", T([
                QTn,
                hwn.jF,
                A2(Iwn, vwn, sTn(8)),
                DTn(sTn(48)),
                Rwn(Run.nw),
                GTn(Kun),
                Ywn(sTn(4)),
                hTn(T([
                    A2(TTn, ".ButtonLabel", T([
                        Rwn(nan)
                    ])),
                    A2(TTn, ".LayoutHeaderTitle", T([
                        zwn
                    ]))
                ]))
            ]))
        ])
    ])), nAn = T([
        A2(pTn, "PlayerFold", T([
            A2(XTn, 3, Qun),
            dwn(sTn(3)),
            OTn,
            iCn(sTn(190))
        ])),
        A2(pTn, "PlayerFoldInfos", T([
            OTn,
            zwn,
            dwn(sTn(6)),
            uCn(sTn(3)),
            Rwn(Zun)
        ])),
        A2(pTn, "PlayerFoldInfo", T([
            QTn,
            A2(Awn, 1, Kun)
        ])),
        A2(pTn, "PlayerFoldInfosTitle", T([
            GTn(Jun),
            Zwn.sm,
            awn.ji,
            dwn(sTn(6))
        ])),
        A2(pTn, "PlayerFoldInfoLabel", T([
            GTn(Wun),
            A2(Iwn, sTn(3), sTn(6)),
            bwn(sTn(100))
        ])),
        A2(pTn, "PlayerFoldInfoValues", T([
            OTn,
            zwn
        ])),
        A2(pTn, "PlayerFoldInfoValue", T([
            GTn(Jun),
            zwn,
            A2(Iwn, sTn(3), sTn(6))
        ])),
        A2(pTn, "PlayerFoldPreview", T([
            QTn,
            _wn.o6,
            hwn.jF,
            kwn("radial-gradient(ellipse at center, rgba(24,31,41,.6) 0%,rgba(24,31,41,1) 100%), " + SCn),
            BCn(Kun),
            ETn,
            DTn(sTn(90)),
            Hwn(T([
                kwn("radial-gradient(ellipse at center, rgba(24,31,41,0) 0%,rgba(24,31,41,1) 100%), " + SCn)
            ]))
        ])),
        A2(pTn, "PlayerFoldPlay", T([
            bwn(sTn(60)),
            DTn(sTn(60)),
            Rwn(Run.jT),
            A2(XTn, 3, Kun),
            iwn(qwn),
            hTn(T([
                A2(TTn, "svg", T([
                    bwn(sTn(60)),
                    DTn(sTn(60))
                ]))
            ]))
        ])),
        A2(pTn, "PlayerFoldProxy", T([
            DTn(sTn(60)),
            Rwn(Zun),
            dwn(sTn(20)),
            A2(XTn, 3, Kun),
            A2(hCn, 0, Kun),
            awn.ji,
            GTn(qwn)
        ])),
        A2(pTn, "PlayerFoldSpinner", T([
            Own.jF,
            zwn,
            iwn(nan)
        ])),
        A2(pTn, "PlayerUnfold", T([
            iCn(sTn(190))
        ]))
    ]), rAn = T([
        A2(pTn, "Settings", T([
            OTn,
            zwn
        ])),
        A2(pTn, "AdminOps", T([
            hTn(T([
                A2(pTn, "LayoutHeader", T([
                    Rwn(RCn.nw)
                ]))
            ]))
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), T([
            A2(pTn, "Settings", T([
                Wwn.l6,
                Qwn.i8
            ]))
        ]))
    ]), tAn = rwn("empty"), eAn = oTn(T([
        Swn(sTn(16)),
        awn.ji
    ])), uAn = function(n) {
        return nwn(function(n) {
            return {
                $: 3,
                a: n
            };
        }(n));
    }, aAn = T([
        A2(wTn, T([
            pTn("MasterWrapper"),
            pTn("MasterShadow")
        ]), T([
            ETn,
            OTn
        ])),
        A2(pTn, "MasterWrapper", T([
            mwn(100),
            A3(UTn, 0, 0, 0),
            hTn(T([
                A2(wTn, T([
                    pTn("ShowMain")
                ]), T([
                    bwn(xTn(100))
                ]))
            ]))
        ])),
        A2(pTn, "MasterShadow", T([
            mwn(0),
            A3(UTn, 100, 0, 0)
        ])),
        A2(pTn, "ShowWrapper", T([
            QTn,
            zwn
        ])),
        A2(pTn, "ShowMain", T([
            zwn,
            OTn,
            zTn("translate(0,0)")
        ])),
        A2(pTn, "ShowHomeWrapper", T([
            OTn,
            FTn.i8,
            zwn
        ])),
        A2(pTn, "ShowAside", T([
            bwn(sTn(404)),
            OTn
        ])),
        A2(pTn, "ShowDesc", T([
            Rwn(Kun),
            ETn,
            OTn,
            zwn
        ])),
        A2(pTn, "ShowSelectBroadcastable", T([
            Ywn(sTn(4)),
            dwn(sTn(1)),
            A2(XTn, 3, Qun)
        ])),
        A2(pTn, "ShowTodos", T([
            A2(XTn, 3, "#5E2F83"),
            OTn,
            dwn(sTn(3)),
            A2(HTn, "gap", "3px"),
            Ywn(sTn(4)),
            tAn(T([
                vTn.ol
            ]))
        ])),
        A2(pTn, "DeliveryForm", T([
            A2(XTn, 6, Qun),
            dwn(sTn(1))
        ])),
        A2(pTn, "DeliveryFormBanners", T([
            A2(XTn, 3, Kun),
            OTn,
            A2(HTn, "gap", "3px")
        ])),
        A2(pTn, "ShowDeliveries", T([
            lwn(sTn(4))
        ])),
        A2(pTn, "ShowDeliveriesTitle", T([
            Rwn(Run.eE),
            GTn(Run.nf),
            awn.ji,
            Swn(sTn(16)),
            dwn(sTn(6)),
            Ywn(sTn(3))
        ])),
        A2(pTn, "ShowDeliveryNew", T([
            Rwn(Run.eE),
            GTn(Jun),
            awn.ji,
            Swn(sTn(16)),
            dwn(sTn(6)),
            Ywn(sTn(3))
        ])),
        A2(pTn, "ShowDeliveriesItem", T([
            A2(XTn, 3, Run.nw),
            Ywn(sTn(3)),
            Rwn(Run.nw),
            GTn(Run.md),
            OTn,
            A2(uAn, "open", T([
                hTn(T([
                    A2(pTn, "IconFolded", T([
                        zTn("rotate(90deg)")
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "IconFolded", T([
            iwn(Run.eF)
        ])),
        A2(pTn, "ShowDeliveriesItemTitle", T([
            QTn,
            hwn.jF,
            GTn(qwn),
            dwn(sTn(6))
        ])),
        A2(pTn, "ShowDeliveriesItemTitleLink", T([
            GTn("inherit"),
            zwn,
            Hwn(T([
                zCn.sa
            ]))
        ])),
        A2(pTn, "ShowDeliveriesItemStatus", T([
            Rwn(qwn),
            A2(XTn, 3, Kun),
            GTn(Wun),
            dwn(sTn(6))
        ])),
        A2(pTn, "ShowDeliveriesSuccess", T([
            iwn(Hun.jT)
        ])),
        A2(pTn, "ShowDeliverySegmentsTabs", T([
            QTn,
            lwn(sTn(3))
        ])),
        A2(pTn, "ShowDeliverySegmentsContent", T([
            Rwn(Qun),
            dwn(sTn(4))
        ])),
        A2(TTn, ".ShowDeliverySegmentsContent .InputText", T([
            GTn(Jun)
        ])),
        A2(pTn, "ShowDeliverySegmentsTab", T([
            A2(Iwn, sTn(4), sTn(8)),
            GTn(Jun)
        ])),
        A2(pTn, "ShowDeliverySegmentsTabActive", T([
            Rwn(Qun),
            GTn(qwn)
        ])),
        A2(wTn, T([
            pTn("ShowMaterial"),
            pTn("ShowPlayer")
        ]), T([
            Rwn(Kun),
            Dwn(8888),
            OTn
        ])),
        A2(pTn, "ShowInfos", T([
            OTn
        ])),
        A2(pTn, "ShowComments", T([
            Rwn(Kun),
            ETn,
            OTn,
            Dwn(9999)
        ])),
        A2(pTn, "ShowHeader", T([
            DTn(sTn(80)),
            dwn(sTn(10)),
            Rwn(Wun),
            Ywn(sTn(4)),
            OTn
        ])),
        A2(pTn, "ShowActions", T([
            DTn(sTn(28)),
            QTn,
            KCn.jF
        ])),
        A2(pTn, "ShowHeaderTitle", T([
            Lwn,
            GTn(Kun)
        ])),
        A2(pTn, "ShowHeaderId", T([
            GTn(Zun),
            DTn(sTn(14))
        ])),
        A2(pTn, "ShowHeaderSubTitle", T([
            GTn(Zun),
            eAn
        ])),
        A2(pTn, "ShowActivity", g),
        A2(pTn, "ShowActivityList", g),
        A2(pTn, "ShowActivityItem", T([
            fwn(sTn(4)),
            GTn(Yun),
            Bwn(sTn(20)),
            cTn.dj,
            hTn(T([
                A2(TTn, "svg", T([
                    A2(yNn, 2, 2)
                ]))
            ]))
        ])),
        A2(pTn, "ShowActivityDate", T([
            uCn(sTn(10)),
            GTn(_un),
            fNn.op
        ])),
        A2(pTn, "ShowAccepted", T([
            hTn(T([
                A2(wTn, T([
                    pTn("LayoutAppBar"),
                    pTn("AsideTabs")
                ]), T([
                    Rwn(Hun.jT)
                ]))
            ]))
        ])),
        A2(pTn, "ShowError", T([
            OTn,
            zwn
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), g),
        A2(LTn, T([
            "(max-width: 650px)"
        ]), g),
        A2(TTn, "#player", T([
            hTn(T([
                A2(pTn, "LoadingSpinner", T([
                    fwn(YTn)
                ]))
            ]))
        ]))
    ]), iAn = function(n) {
        return oTn(T([
            hTn(T([
                A2(pTn, "Button", T([
                    kwn(n.nu),
                    GTn(n.ng),
                    Hwn(T([
                        kwn(n.jT),
                        GTn(qwn)
                    ]))
                ]))
            ]))
        ]));
    }, oAn = T([
        A2(pTn, "Acceptation", T([
            Rwn(Run.nw)
        ])),
        A2(pTn, "AcceptationAccepted", T([
            Rwn(Hun.nw),
            hTn(T([
                A2(pTn, "AcceptationContent", T([
                    BCn(Hun.nw)
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationRefused", T([
            Rwn(tan.nu),
            hTn(T([
                A2(pTn, "AcceptationContent", T([
                    BCn(tan.nu)
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationHeader", T([
            QTn,
            GTn(Kun),
            A2(Iwn, vwn, sTn(7)),
            DTn(sTn(48)),
            hwn.jF
        ])),
        A2(pTn, "AcceptationHeaderTitle", T([
            zwn,
            fNn.op,
            FTn.l6,
            sNn.k7,
            awn.ji,
            Swn(sTn(14)),
            Bwn(sTn(8))
        ])),
        A2(pTn, "AcceptationHeaderActions", T([
            Rwn(Kun),
            GTn(qwn),
            dwn(sTn(3)),
            QTn
        ])),
        A2(pTn, "AcceptationHeaderActionsWrapper", T([
            _wn.o6,
            Hwn(T([
                hTn(T([
                    A2(pTn, "AcceptationHeaderActionsAction", T([
                        Rwn(Run.jT),
                        iwn(Run.nf)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationHeaderActionsAction", T([
            Ewn(sTn(26)),
            DTn(sTn(26)),
            A2(Iwn, sTn(0), sTn(5)),
            Rwn(Zun),
            QTn,
            hwn.jF,
            A2(pwn, "AcceptationHeaderActionsOk", T([
                iwn(Hun.jT)
            ])),
            A2(pwn, "AcceptationHeaderActionsKo", T([
                iwn(tan.jT)
            ]))
        ])),
        A2(pTn, "AcceptationHeaderActionsIcon", T([
            lwn(sTn(4))
        ])),
        A2(pTn, "AcceptationHeaderActionsLabel", T([
            A2(Iwn, vwn, sTn(3))
        ])),
        A2(pTn, "AcceptationContent", T([
            OTn,
            Rwn(Kun),
            A2(XTn, 6, Run.nw),
            A2(Awn, 0, ""),
            dwn(sTn(3)),
            hTn(T([
                A2(pTn, "InputTextarea", T([
                    A2(XTn, 3, Kun),
                    A2(HTn, "width", "100% !important"),
                    fwn(vwn),
                    Rwn(Zun),
                    zwn
                ])),
                A2(pTn, "InputWrapper", T([
                    OTn,
                    zwn
                ])),
                A2(pTn, "AcceptationButton", T([
                    GTn(qwn),
                    lwn(sTn(3))
                ])),
                A2(pTn, "ButtonDisabled", T([
                    Rwn(Qun),
                    GTn(_un),
                    Hwn(T([
                        Rwn(Qun),
                        GTn(_un)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationChoices", T([
            OTn,
            Gwn(T([
                TCn(T([
                    Rwn(Zun),
                    OTn,
                    lwn(sTn(3)),
                    ewn(T([
                        lwn(sTn(0))
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationOk", T([
            Rwn(Hun.jT),
            dwn(sTn(3)),
            OTn,
            zwn,
            iAn(Hun)
        ])),
        A2(pTn, "AcceptationNormal", T([
            Rwn(Run.nu),
            dwn(sTn(3)),
            OTn,
            zwn
        ])),
        A2(pTn, "AcceptationKo", T([
            A2(XTn, 3, tan.jT),
            Rwn(Kun),
            dwn(sTn(3)),
            OTn,
            zwn,
            iAn(tan)
        ])),
        A2(pTn, "AcceptationText", T([
            A3(NCn, sTn(3), sTn(6), sTn(6)),
            Rwn(Run.eF),
            A2(XTn, 3, Kun),
            GTn(Run.mb),
            zwn,
            Own.jF
        ])),
        A2(pTn, "AcceptationTextOk", T([
            A3(NCn, sTn(3), sTn(6), sTn(6)),
            Rwn(Hun.eF),
            A2(XTn, 3, Kun),
            GTn(Hun.mb),
            zwn,
            Own.jF
        ])),
        A2(pTn, "AcceptationRejectionText", T([
            A3(NCn, sTn(3), sTn(6), sTn(6)),
            Rwn(tan.eF),
            GTn(tan.mb),
            zwn,
            Own.jF
        ])),
        A2(wTn, T([
            pTn("AcceptationVoteTitleAccepted"),
            pTn("AcceptationVoteTitleRejected")
        ]), T([
            Own.jF,
            dwn(sTn(6))
        ])),
        A2(pTn, "AcceptationVoteTitleRejected", T([
            GTn(tan.jT)
        ])),
        A2(pTn, "AcceptationVote", T([
            GTn(Jun),
            A2(Awn, 2, Kun)
        ])),
        A2(pTn, "AcceptationVoteUser", T([
            QTn,
            hwn.jF,
            dwn(sTn(3)),
            hTn(T([
                A2(pTn, "Avatar", T([
                    aCn(sTn(10))
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationVoteUserName", T([
            rCn(1),
            qTn(1),
            FTn.l6,
            sNn.k7,
            fNn.op
        ])),
        A2(pTn, "AcceptationVoteReason", T([
            A2(Iwn, sTn(5), sTn(10))
        ])),
        A2(pTn, "AcceptationVoteAccepted", T([
            QTn,
            Rwn(Hun.jT),
            GTn(qwn)
        ])),
        A2(pTn, "AcceptationVoteWaiting", T([
            QTn,
            Rwn(Zun)
        ])),
        A2(pTn, "AcceptationVoteRejected", T([
            OTn,
            Rwn(tan.jT),
            GTn(qwn)
        ])),
        A2(pTn, "AcceptationRejection", T([
            dwn(sTn(10)),
            Rwn(tan.nu),
            GTn(qwn)
        ])),
        A2(pTn, "AcceptationWarning", T([
            QTn,
            hwn.jF,
            Gwn(T([
                A2(TTn, "svg", T([
                    kwn(RCn.nw),
                    hTn(T([
                        A2(pTn, "Fg", T([
                            _Tn(RCn.ku)
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "AcceptationBorderWrapper", T([
            A2(XTn, 6, Run.nw),
            dwn(sTn(3))
        ]))
    ]), cAn = {
        i8: A2(eTn, "flex", "auto"),
        lM: function(n) {
            return A2(eTn, "flex", "flex-basis(" + It(n) + ")");
        },
        lN: function(n) {
            return A2(eTn, "flex", "flex-grow(" + It(n) + ")");
        },
        lO: function(n) {
            return A2(eTn, "flex", "flex-shrink(" + It(n) + ")");
        },
        ol: A2(eTn, "flex", "none")
    }, sAn = A2(bu, eTn("font-weight"), It), fAn = T([
        A2(pTn, "Activity", T([
            OTn,
            zwn
        ])),
        A2(pTn, "ActivityTitle", T([
            dwn(sTn(6)),
            Rwn(Run.eE),
            GTn(qwn),
            awn.ji,
            QTn,
            Ywn(sTn(2))
        ])),
        A2(pTn, "ActivityHeader", T([
            DTn(sTn(48)),
            Rwn(Run.nw),
            A2(Iwn, vwn, sTn(10)),
            QTn,
            Ywn(sTn(4)),
            hwn.jF,
            Gwn(T([
                A2(pTn, "Select", T([
                    A2(kCn, 0, ""),
                    Gwn(T([
                        A2(pTn, "SelectButton", T([
                            A2(kCn, 3, Kun)
                        ]))
                    ])),
                    A2(Fwn, sTn(0), sTn(5))
                ]))
            ]))
        ])),
        A2(pTn, "ActivityHeaderLink", T([
            GTn(qwn),
            A2(Iwn, vwn, sTn(10))
        ])),
        A2(pTn, "ActivityContent", T([
            OTn,
            zwn
        ])),
        A2(pTn, "ActivityItem", T([
            Rwn(Zun),
            dwn(sTn(3)),
            Ywn(sTn(2)),
            Gwn(T([
                A2(pTn, "IconBullet", T([
                    A2(FNn, 0, 4)
                ]))
            ]))
        ])),
        A2(pTn, "ActivityEvent", T([
            cTn.dj,
            Bwn(sTn(34)),
            Gwn(T([
                A2(pTn, "IconBullet", T([
                    A2(yNn, 1, 8)
                ]))
            ]))
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), T([
            A2(pTn, "Activity", T([
                OTn,
                zwn
            ])),
            A2(pTn, "ActivityContent", T([
                zwn,
                Ywn(sTn(2))
            ]))
        ])),
        A2(pTn, "ActivityOnlyEvents", T([
            hTn(T([
                A2(pTn, "ActivityComment", T([
                    vTn.ol
                ]))
            ]))
        ])),
        A2(pTn, "ActivityOnlyComments", T([
            hTn(T([
                A2(pTn, "ActivityEvent", T([
                    vTn.ol
                ]))
            ]))
        ])),
        A2(pTn, "CommentButton", T([
            aCn(sTn(4))
        ])),
        A2(pTn, "ActivityCommentForm", T([
            GTn(Xun),
            Rwn(Kun),
            dwn(sTn(3)),
            Ywn(sTn(4)),
            A2(XTn, 8, Run.nw)
        ])),
        A2(pTn, "ActivityAnswerForm", T([
            QTn,
            Rwn(Kun),
            GTn(Xun),
            Gwn(T([
                A2(pTn, "Avatar", T([
                    fwn(sTn(2))
                ]))
            ]))
        ])),
        A2(pTn, "ActivityCommentFormMessage", T([
            Rwn(Zun)
        ])),
        A2(pTn, "ActivityCommentFormSubmit", T([
            QTn,
            ywn.bR,
            lwn(sTn(2)),
            Rwn(Zun)
        ])),
        A2(pTn, "ActivityCommentHideSubmit", T([
            vTn.ol
        ])),
        A2(pTn, "ActivityComment", T([
            Rwn(Zun),
            dwn(sTn(4)),
            Ywn(sTn(2)),
            QTn
        ])),
        A2(pTn, "ActivityCommentHeader", T([
            QTn
        ])),
        A2(pTn, "ActivityCommentActions", T([
            QTn
        ])),
        A2(pTn, "ActivityCommentDelete", T([
            QTn,
            Hwn(T([
                iwn(qwn),
                hTn(T([
                    A2(pTn, "ButtonMiniIcon", T([
                        Rwn(tan.jT)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "ActivityCommentAuthor", T([
            GTn(Yun),
            sAn(500)
        ])),
        A2(pTn, "ActivityCommentContent", T([
            A2(Iwn, sTn(4), sTn(6)),
            zwn,
            OTn
        ])),
        A2(pTn, "ActivityCommentDate", g),
        A2(pTn, "ActivityCommentWrap", T([
            OTn,
            A2(Fwn, sTn(2), sTn(0))
        ])),
        A2(pTn, "ActivityCommentMessage", T([
            A2(Iwn, sTn(8), sTn(0)),
            GTn(Jun),
            fNn.pb
        ])),
        A2(pTn, "ActivityCommentTimecode", T([
            QTn,
            zwn,
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    cAn.ol,
                    bwn(sTn(30)),
                    WCn
                ])),
                A2(pTn, "InputCheckbox", T([
                    dwn(vwn),
                    fwn(vwn)
                ]))
            ]))
        ])),
        A3(RTn, "ActivityCommentContent", "ActivityCommentTimecode", T([
            A2(Fwn, sTn(8), sTn(0))
        ])),
        A2(pTn, "ActivityCommentTimecodeLabel", T([
            mCn.mV,
            GTn(Wun),
            dwn(sTn(2))
        ])),
        A2(pTn, "ActivityAnswerMessage", T([
            A2(Iwn, sTn(2), sTn(0)),
            GTn(Jun)
        ])),
        A2(pTn, "ActivityAnswers", g),
        A2(pTn, "ActivityAnswer", g),
        A2(pTn, "ActivityAnswerHeader", T([
            QTn
        ])),
        A2(pTn, "ActivityAnswer", T([
            dwn(sTn(4)),
            Rwn(Kun),
            QTn,
            Ywn(sTn(2))
        ])),
        A2(pTn, "ActivityCommentVerif", T([
            lwn(sTn(2))
        ])),
        A2(pTn, "ActivityCommentVerifTc", T([
            QTn,
            Ywn(sTn(2))
        ])),
        A2(pTn, "ActivityCommentVerifLabel", T([
            QTn,
            zwn,
            A2(Iwn, sTn(3), sTn(6)),
            Rwn(Zun)
        ])),
        A2(pTn, "ActivityCommentVerifHeader", T([
            QTn,
            hTn(T([
                A2(pTn, "InputTextarea", T([
                    Swn(sTn(16)),
                    A2(Iwn, sTn(3), sTn(6)),
                    A4(eCn, sTn(0), sTn(3), sTn(0), sTn(0))
                ]))
            ]))
        ])),
        A2(swn, "VerificationMotifInput", T([
            Swn(sTn(16)),
            A2(Iwn, sTn(3), sTn(6))
        ])),
        A2(pTn, "RedFlag", T([
            hTn(T([
                A2(pTn, "InputTextarea", T([
                    BCn(tan.jT)
                ]))
            ]))
        ])),
        A2(pTn, "OrangeFlag", T([
            hTn(T([
                A2(pTn, "InputTextarea", T([
                    BCn(RCn.jT)
                ]))
            ]))
        ])),
        A2(pTn, "GreenFlag", T([
            hTn(T([
                A2(pTn, "InputTextarea", T([
                    BCn(Hun.jT)
                ]))
            ]))
        ])),
        A2(pTn, "BlueFlag", T([
            hTn(T([
                A2(pTn, "InputTextarea", T([
                    BCn(Run.jT)
                ]))
            ]))
        ])),
        A2(pTn, "ActivityVerificationBloc", T([
            Rwn(Kun),
            dwn(sTn(2))
        ])),
        A2(pTn, "ActivityVerificationMessage", T([
            Swn(sTn(16)),
            A2(Iwn, sTn(3), sTn(6)),
            A2(XTn, 3, Run.jT),
            GTn(qwn),
            A2(pwn, "RedFlag", T([
                BCn(tan.jT)
            ])),
            A2(pwn, "OrangeFlag", T([
                BCn(RCn.jT)
            ])),
            A2(pwn, "GreenFlag", T([
                BCn(Hun.jT)
            ]))
        ])),
        A2(pTn, "ActivityVerificationFlag", T([
            dwn(sTn(5)),
            uCn(sTn(1)),
            Rwn(Zun)
        ])),
        A2(pTn, "RegularOperations", T([
            OTn,
            A2(XTn, 4, Run.jT),
            dwn(sTn(3)),
            lwn(sTn(3)),
            Ywn(sTn(3))
        ])),
        A2(pTn, "RegularOperationsHeader", T([
            dwn(sTn(10)),
            Rwn(Run.nw),
            GTn(Run.ku),
            awn.jj,
            Swn(sTn(15))
        ])),
        A2(pTn, "Operations", T([
            OTn,
            A2(XTn, 4, RCn.jT),
            dwn(sTn(3))
        ])),
        A2(pTn, "OperationsHeader", T([
            dwn(sTn(10)),
            Rwn(RCn.nw),
            GTn(RCn.ku),
            awn.jj,
            Swn(sTn(15))
        ])),
        A2(pTn, "OperationContent", T([
            OTn,
            rCn(1),
            qTn(1),
            dwn(sTn(10)),
            Rwn(Zun),
            GTn(qwn),
            A2(hCn, 3, Kun),
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    Ywn(sTn(5))
                ]))
            ]))
        ])),
        A2(pTn, "OperationStatusNone", T([
            Rwn(_un)
        ])),
        A2(pTn, "OperationStatusRunning", T([
            Rwn(Run.jT)
        ])),
        A2(pTn, "OperationStatusSuccess", T([
            Rwn(Hun.jT)
        ])),
        A2(pTn, "OperationStatusFailure", T([
            Rwn(tan.jT)
        ])),
        A2(pTn, "VerifContent", T([
            OTn,
            rCn(1),
            qTn(1),
            dwn(sTn(10)),
            Rwn(Zun),
            GTn(qwn),
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    Ywn(sTn(5))
                ]))
            ]))
        ])),
        A2(pTn, "ActivityVerificationFlagSelect", T([
            QTn,
            hTn(T([
                A2(pTn, "OrangeFlag", T([
                    iwn(RCn.jT),
                    A2(pwn, "ActivityVerificationFlagSelected", T([
                        Rwn(RCn.jT),
                        iwn(qwn)
                    ])),
                    Hwn(T([
                        Rwn(RCn.jT),
                        iwn(qwn)
                    ]))
                ])),
                A2(pTn, "RedFlag", T([
                    iwn(tan.jT),
                    A2(pwn, "ActivityVerificationFlagSelected", T([
                        Rwn(tan.jT),
                        iwn(qwn)
                    ])),
                    Hwn(T([
                        Rwn(tan.jT),
                        iwn(qwn)
                    ]))
                ])),
                A2(pTn, "BlueFlag", T([
                    iwn(Run.jT),
                    A2(pwn, "ActivityVerificationFlagSelected", T([
                        Rwn(Run.jT),
                        iwn(qwn)
                    ])),
                    Hwn(T([
                        Rwn(Run.jT),
                        iwn(qwn)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "ActivityCommentSpacer", T([
            zwn
        ])),
        A2(TTn, ".Activity > .ActivityContent", T([
            A2(Awn, 4, Run.nw)
        ])),
        A2(pTn, "VerifOperationContent", T([
            hwn.bR
        ])),
        A2(TTn, ".VerifOperationContent .Select", T([
            Ywn(sTn(10)),
            Ewn(sTn(135))
        ]))
    ]), lAn = T([
        A2(pTn, "ShowArchives", T([
            OTn
        ])),
        A2(pTn, "ShowArchivesHeader", T([
            dwn(sTn(10)),
            Rwn(nan),
            GTn(Kun),
            awn.jj,
            Swn(sTn(15))
        ])),
        A2(pTn, "ShowArchive", T([
            QTn,
            A2(Awn, 3, Kun)
        ])),
        A2(pTn, "ShowArchiveActions", T([
            dwn(sTn(6)),
            Rwn(Zun),
            ywn.bR,
            QTn
        ])),
        A2(pTn, "ShowArchivesLock", T([
            iwn(Run.ku),
            WCn,
            QTn
        ])),
        A2(pTn, "ShowArchiveStatus", T([
            bwn(sTn(10))
        ])),
        A2(pTn, "ShowArchiveContent", T([
            OTn,
            rCn(1),
            qTn(1),
            dwn(sTn(10)),
            Rwn(Zun),
            GTn(qwn),
            A2(hCn, 3, Kun),
            hTn(T([
                A2(pTn, "ShowInputWrapper", T([
                    Ywn(sTn(5))
                ]))
            ]))
        ]))
    ]), mAn = rwn("disabled"), dAn = T([
        A2(pTn, "DownloadWrapper", T([
            Rwn(Run.nw),
            lwn(sTn(4))
        ])),
        A2(pTn, "DownloadBloc", T([
            dwn(sTn(4)),
            kwn(Zun),
            lwn(sTn(3))
        ])),
        A2(pTn, "DownloadBlocTitle", T([
            GTn(Wun),
            awn.ji,
            Swn(sTn(15)),
            A3(NCn, sTn(4), sTn(6), sTn(4))
        ])),
        A2(pTn, "DownloadSection", g),
        A2(pTn, "DownloadSectionTitle", T([
            GTn(qwn),
            A3(NCn, sTn(8), sTn(6), sTn(4)),
            vTn.jg
        ])),
        A2(pTn, "DownloadSectionChoices", T([
            dwn(sTn(1)),
            kwn(Kun)
        ])),
        A2(pTn, "DownloadSectionChoice", T([
            QTn,
            fwn(sTn(2)),
            GTn(Kun),
            awn.ji,
            Hwn(T([
                hTn(T([
                    A2(pTn, "DownloadSectionLabel", T([
                        kwn(Run.jT),
                        GTn(qwn)
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "DownloadSectionInput", T([
            dwn(sTn(8)),
            vTn.lL,
            kwn(Zun)
        ])),
        A2(pTn, "DownloadSectionLabel", T([
            dwn(sTn(6)),
            kwn(Wun),
            zwn,
            uCn(sTn(2))
        ])),
        A2(pTn, "DownloadSubmit", T([
            QTn,
            lwn(sTn(4)),
            dwn(sTn(1)),
            kwn(Kun)
        ])),
        A2(pTn, "DownloadSubmitSpacer", T([
            zwn,
            fwn(sTn(2)),
            kwn(Zun)
        ])),
        A2(pTn, "DownloadSubmitButton", T([
            GTn(qwn),
            fwn(sTn(2)),
            A2(Iwn, sTn(4), sTn(6)),
            Swn(sTn(16)),
            kwn(Run.nu),
            Hwn(T([
                kwn(Run.jT)
            ])),
            mAn(T([
                kwn(_un),
                GTn(Kun)
            ]))
        ])),
        A2(pTn, "DownloadSimpleButton", T([
            GTn(Kun),
            fwn(sTn(2)),
            A2(Iwn, sTn(4), sTn(6)),
            kwn(_un),
            Hwn(T([
                kwn(Wun)
            ]))
        ])),
        A2(pTn, "DownloadFile", T([
            QTn,
            lwn(sTn(3)),
            kwn(Kun)
        ])),
        A2(pTn, "DownloadFileIcon", T([
            OTn,
            dwn(sTn(6)),
            kwn(Run.nw),
            iwn(qwn)
        ])),
        A2(pTn, "DownloadFileBody", T([
            QTn,
            zwn,
            uCn(sTn(2))
        ])),
        A2(pTn, "DownloadFileName", T([
            zwn,
            dwn(sTn(6)),
            kwn(Run.nw),
            GTn(qwn)
        ])),
        A2(pTn, "DownloadFileAction", T([
            dwn(sTn(6)),
            kwn(Run.nw),
            GTn(Run.nf),
            hTn(T([
                A2(TTn, "p", T([
                    fwn(sTn(0)),
                    oNn(sTn(4))
                ]))
            ]))
        ])),
        A2(pTn, "DownloadFileButton", T([
            dwn(sTn(6)),
            kwn(Run.nu),
            lwn(sTn(1)),
            A2(XTn, 3, Kun),
            iwn(qwn),
            GTn(Run.ng),
            QTn,
            zwn,
            hTn(T([
                A2(TTn, "svg", T([
                    fwn(sTn(2))
                ]))
            ])),
            Hwn(T([
                kwn(Run.jT),
                GTn(qwn)
            ]))
        ])),
        A2(pTn, "Downloaded", T([
            hTn(T([
                A2(pTn, "DownloadFileIcon", T([
                    kwn(Hun.nw)
                ])),
                A2(pTn, "DownloadFileName", T([
                    kwn(Hun.nw)
                ])),
                A2(pTn, "DownloadFileAction", T([
                    kwn(Hun.nw),
                    GTn(Hun.nf)
                ])),
                A2(pTn, "DownloadFileButton", T([
                    kwn(Hun.nu),
                    GTn(Hun.ng)
                ]))
            ]))
        ])),
        A2(pTn, "DownloadDisabled", T([
            hTn(T([
                A2(pTn, "DownloadFileIcon", T([
                    kwn(Zun),
                    iwn(nan)
                ])),
                A2(pTn, "DownloadFileName", T([
                    kwn(Qun),
                    GTn(Wun)
                ])),
                A2(pTn, "DownloadFileAction", T([
                    kwn(Qun),
                    GTn(Wun)
                ])),
                A2(pTn, "DownloadFileButton", T([
                    kwn(Zun),
                    GTn(Wun),
                    iwn(Wun)
                ]))
            ]))
        ])),
        A2(pTn, "HowToOpenIntercom", T([
            dwn(sTn(20)),
            Swn(sTn(14)),
            GTn(Gun),
            vTn.jg
        ])),
        A2(pTn, "DownloadOptionsWrapper", T([
            Rwn(Zun),
            dwn(sTn(3)),
            A2(XTn, 3, Kun),
            tAn(T([
                vTn.ol
            ]))
        ])),
        A2(pTn, "DownloadOptionsBloc", T([
            cTn.dj,
            kwn(Zun),
            Dwn(9),
            dwn(sTn(6)),
            OTn
        ])),
        A2(pTn, "DownloadOptionsBack", g),
        A2(pTn, "DownloadOptionsClose", T([
            A2($Cn, 12, 12)
        ])),
        A2(pTn, "DownloadRowBloc", T([
            QTn
        ])),
        A2(pTn, "DownloadOptionsCredentials", T([
            kwn(Zun),
            dwn(sTn(6))
        ])),
        A2(pTn, "DownloadOptionsText", T([
            zwn,
            lwn(sTn(3)),
            dwn(sTn(6))
        ])),
        A2(pTn, "DownloadOptionsButtons", T([
            kwn(Zun),
            QTn,
            dwn(sTn(6)),
            ywn.bR
        ])),
        A2(pTn, "DownloadRowButtons", T([
            Rwn("#5E2F83"),
            dwn(sTn(6))
        ])),
        A2(pTn, "DownloadSftpLink", T([
            dwn(sTn(6)),
            zwn,
            QTn,
            hwn.jF
        ])),
        A2(pTn, "DownloadSftpUrl", T([
            Rwn(nan),
            GTn(Run.jT),
            QTn,
            zwn,
            Swn(VCn(1.2)),
            uCn(sTn(10))
        ])),
        A2(pTn, "DownloadsLinks", T([
            OTn,
            A2(HTn, "gap", "3px")
        ])),
        A2(pTn, "DownloadsLinksItem", T([
            QTn,
            dwn(sTn(3)),
            Rwn(Qun),
            GTn(Xun),
            Hwn(T([
                Rwn(Run.nu),
                GTn(qwn)
            ]))
        ])),
        A2(pTn, "DownloadsLinksItemIcon", T([
            dwn(sTn(6)),
            Rwn(Kun),
            WCn,
            bwn(sTn(40))
        ])),
        A2(pTn, "DownloadsLinksItemWrapper", T([
            OTn,
            zwn,
            dwn(sTn(6))
        ])),
        A2(pTn, "DownloadsLinksItemName", T([
            awn.ji,
            Swn(VCn(1.1)),
            JNn.jm
        ])),
        A2(pTn, "DownloadsLinksItemDetails", T([
            Swn(VCn(.95)),
            mwn(70)
        ]))
    ]), bAn = T([
        A2(pTn, "EditWrapper", T([
            OTn,
            Ywn(sTn(4))
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), g),
        A2(pTn, "EditForm", T([
            OTn
        ])),
        A2(pTn, "EditHeaderIcon", T([
            bwn(sTn(50)),
            Rwn(Run.nw)
        ])),
        A2(pTn, "EditHeaderLabel", T([
            rCn(1),
            qTn(1),
            fNn.op,
            FTn.l6,
            sNn.k7,
            dwn(sTn(10)),
            GTn(Qun)
        ])),
        A2(pTn, "EditHeaderActions", T([
            QTn
        ])),
        A2(pTn, "EditFooter", T([
            QTn,
            Rwn(Kun),
            dwn(sTn(3)),
            ywn.bR
        ])),
        A2(pTn, "EditContent", T([
            OTn,
            Rwn(Zun),
            GTn(Xun),
            dwn(sTn(3))
        ])),
        A2(pTn, "EditEditing", T([
            hTn(T([
                A2(pTn, "EditContent", T([
                    Rwn(Zun)
                ])),
                A2(pTn, "EditRowContent", T([
                    Rwn(Kun),
                    FTn.sD
                ]))
            ]))
        ])),
        A2(pTn, "EditRow", T([
            QTn,
            Ywn(sTn(3)),
            lCn.sH
        ])),
        A2(pTn, "EditRowContent", T([
            rCn(1),
            qTn(1),
            fNn.op,
            FTn.l6,
            sNn.k7,
            GTn(qwn),
            Rwn(Zun),
            dwn(sTn(6)),
            hTn(T([
                A2(TTn, "input", T([
                    fwn(vwn),
                    dwn(vwn),
                    A2(XTn, 0, "")
                ]))
            ]))
        ])),
        A2(pTn, "EditRowLabel", T([
            GTn(Wun),
            dwn(sTn(6)),
            bwn(xTn(40)),
            mCn.mV
        ]))
    ]), pAn = function(n) {
        return oTn(T([
            Swn(sTn(n)),
            awn.ji
        ]));
    }, vAn = F2(function(n, r) {
        return T([
            Uk(A3(zk, A3(ta, A2(pa, n, g), g, Tt), g, r))
        ]);
    }), $An = vAn("svg"), gAn = T([
        A2(pTn, "FilesWrapper", T([
            OTn,
            GTn(Jun)
        ])),
        A2(pTn, "FilesHeader", T([
            QTn,
            Rwn(nan),
            A2(Iwn, sTn(0), sTn(10)),
            DTn(sTn(48)),
            hwn.jF
        ])),
        A2(pTn, "FilesTitle", T([
            pAn(16),
            GTn(Kun),
            tCn(sTn(28)),
            zwn
        ])),
        A2(pTn, "FilesItem", T([
            QTn
        ])),
        A2(pTn, "FilesItemIcon", T([
            cTn.dj,
            QTn
        ])),
        A2(pTn, "FilesItemIconStamps", T([
            cTn.$8,
            OTn,
            fTn(sTn(43)),
            aTn(sTn(30)),
            zTn("translate(-50%,-50%)")
        ])),
        A2(pTn, "FilesItemIconStamp", T([
            QTn,
            Ewn(sTn(20)),
            DTn(sTn(17)),
            tCn(sTn(17)),
            fwn(sTn(2)),
            A2(Iwn, sTn(0), sTn(5)),
            cCn(sTn(10)),
            pAn(12),
            GTn(qwn),
            ywn.jF,
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(qwn)
                ]))
            ]))
        ])),
        A2(pTn, "FilesItemSuccess", T([
            hTn(T([
                A2(pTn, "FilesItemIconStamp", T([
                    Rwn(Hun.jT)
                ])),
                A2(pTn, "Bg", T([
                    _Tn(Hun.jT)
                ]))
            ]))
        ])),
        A2(pTn, "FilesItemFailure", T([
            hTn(T([
                A2(pTn, "FilesItemIconStamp", T([
                    Rwn(tan.jT)
                ])),
                A2(pTn, "Bg", T([
                    _Tn(tan.jT)
                ]))
            ]))
        ])),
        A2(pTn, "FilesItemWarning", T([
            hTn(T([
                A2(pTn, "FilesItemIconStamp", T([
                    Rwn(Hun.jT)
                ])),
                A2(pTn, "FilesItemWarning", T([
                    kwn(RCn.jT)
                ])),
                A2(pTn, "Bg", T([
                    _Tn(Hun.jT)
                ]))
            ]))
        ])),
        A2(wTn, T([
            pTn("FilesItemAwait"),
            pTn("FilesMaterial")
        ]), T([
            hTn(T([
                A2(pTn, "Fg", T([
                    _Tn(Xun)
                ])),
                A2(pTn, "Bg", T([
                    _Tn(Xun)
                ]))
            ]))
        ])),
        A2(pTn, "FilesBroadcast", T([
            OTn,
            dwn(sTn(10)),
            Rwn(Gun),
            Ywn(sTn(4)),
            Hwn(T([
                kwn(qwn)
            ]))
        ])),
        A2(pTn, "FilesMaterial", T([
            OTn,
            dwn(sTn(10)),
            Rwn(Gun),
            Ywn(sTn(4)),
            Hwn(T([
                kwn(qwn)
            ]))
        ])),
        A2(pTn, "FilesGroupTitle", T([
            pAn(16),
            Rwn(Qun),
            GTn(Jun),
            A2(Iwn, sTn(10), sTn(10))
        ])),
        A2(pTn, "FilesItemContent", T([
            A2(Iwn, sTn(5), sTn(10))
        ])),
        A2(pTn, "FilesItemTitle", T([
            pAn(14),
            OTn,
            A2(Iwn, sTn(5), sTn(10))
        ])),
        A2(pTn, "FilesItemTitle2", T([
            Swn(sTn(12)),
            awn.jj,
            A2(Iwn, sTn(5), sTn(0)),
            Zwn.sm,
            GTn(_un)
        ])),
        A2(pTn, "FilesItemNextStep", T([
            A2(Iwn, sTn(5), sTn(10)),
            kwn("rgba(0,0,0,.1)"),
            GTn("rgba(255,255,255,.8)"),
            fwn(sTn(2)),
            QTn
        ])),
        A2(wTn, T([
            pTn("FilesAccepted"),
            pTn("FilesAwaitingUpload"),
            pTn("FilesUploading"),
            pTn("FilesRunningTasks")
        ]), T([
            Rwn(Run.jT),
            GTn(qwn),
            OTn
        ])),
        A2(pTn, "FilesAwaitingUpload", g),
        A2(pTn, "FilesUploading", g),
        A2(pTn, "FilesRunningTasks", T([
            dwn(sTn(2))
        ])),
        A2(pTn, "FilesFileOk", g),
        A2(pTn, "FilesFileKo", g),
        A2(pTn, "FilesAccepted", T([
            Rwn(Hun.jT)
        ])),
        A2(pTn, "ManagerActionsWrapper", T([
            Uwn,
            zwn,
            dwn(sTn(3))
        ])),
        A2(pTn, "FileItem", T([
            QTn,
            Ywn(sTn(4))
        ])),
        A2(pTn, "FileStatus", T([
            bwn(sTn(15)),
            A2(kCn, 2, Qun)
        ])),
        A2(pTn, "FileStatusOperation", T([
            Rwn(Run.jT)
        ])),
        A2(pTn, "FileStatusFailure", T([
            Rwn(tan.jT)
        ])),
        A2(pTn, "FileStatusWarning", T([
            Rwn(RCn.jT)
        ])),
        A2(pTn, "FileStatusSuccess", T([
            Rwn(Hun.jT)
        ])),
        A2(pTn, "FileContent", T([
            OTn,
            zwn,
            Rwn(Gun),
            GTn(Zun),
            dwn(sTn(2))
        ])),
        A2(pTn, "FileDescription", T([
            dwn(sTn(5))
        ])),
        A2(pTn, "FilesWrapperSectionTitle", T([
            kwn(nan),
            GTn(Gun),
            awn.jj,
            A2(Iwn, sTn(5), sTn(10)),
            QTn,
            Ywn(sTn(4))
        ])),
        A2(pTn, "FileDescriptionTitle", T([
            awn.jj,
            QTn,
            iwn(Wun)
        ])),
        A2(pTn, "FileDescriptionTitleName", T([
            zwn,
            Pwn(xTn(95)),
            JNn.jm
        ])),
        A2(pTn, "FileDescriptionDetails", T([
            GTn(_un)
        ])),
        A2(pTn, "FileOperation", T([
            lwn(sTn(2))
        ])),
        A2(pTn, "FileOperationSummary", T([
            QTn,
            dwn(sTn(3)),
            hwn.jF,
            Rwn(Jun)
        ])),
        A2(pTn, "FileOperationLabel", T([
            rCn(1),
            qTn(1),
            Ewn(sTn(250)),
            fNn.op,
            FTn.l6,
            sNn.k7,
            iwn(Wun),
            Gwn(T([
                $An(T([
                    A2(FNn, 0, 4)
                ]))
            ]))
        ])),
        A2(pTn, "FileOperationLabelTitle", T([
            awn.jj,
            GTn(Kun)
        ])),
        A2(pTn, "FileOperationLabelProgress", T([
            GTn(_un)
        ])),
        A2(pTn, "FileOperationProgress", T([
            bwn(xTn(50)),
            qTn(1),
            Pwn(sTn(250))
        ])),
        A2(pTn, "FileOperationDetails", T([
            QTn,
            Rwn(Yun),
            GTn(Zun),
            dwn(sTn(5))
        ])),
        A2(pTn, "FileOperationDetailsLabel", T([
            rCn(1),
            qTn(1),
            fNn.op,
            FTn.l6,
            sNn.k7
        ])),
        A2(pTn, "FileOperationDetailsActions", g),
        A2(pTn, "FileOperationWarning", T([
            OTn,
            vTn.jg,
            FTn.i8,
            Rwn(Zun),
            GTn(Yun),
            dwn(sTn(5)),
            hTn(T([
                A2(TTn, "tr:nth-child(odd)", T([
                    Rwn("#555d68")
                ])),
                A2(TTn, "th", T([
                    fNn.op
                ]))
            ]))
        ])),
        A2(pTn, "TranscodeWarning", T([
            rCn(1),
            fNn.op,
            FTn.l6,
            sNn.k7
        ])),
        A2(pTn, "TranscodeWarningField", T([
            zwn
        ])),
        A2(pTn, "FileOperationIcon", T([
            DTn(sTn(20)),
            bwn(sTn(20)),
            WCn,
            iwn(Wun)
        ])),
        A2(pTn, "FileTitle", T([
            rCn(1),
            qTn(1),
            QTn
        ]))
    ]), hAn = function(n) {
        return A2(eTn, "border-spacing", tTn(n));
    }, kAn = Oi({
        bN: "Download",
        bT: "Download"
    }), TAn = {
        i8: A2(eTn, "table-layout", "auto"),
        lI: A2(eTn, "table-layout", "fixed")
    }, wAn = {
        cu: A2(eTn, "transform-origin", "center bottom"),
        cv: A2(eTn, "transform-origin", "left bottom"),
        cw: A2(eTn, "transform-origin", "right bottom"),
        jF: A2(eTn, "transform-origin", "center"),
        cx: A2(eTn, "transform-origin", "left center"),
        cy: A2(eTn, "transform-origin", "right center"),
        cD: eTn("transform-origin"),
        dF: A2(eTn, "transform-origin", "center top"),
        bq: A2(eTn, "transform-origin", "left top"),
        dG: A2(eTn, "transform-origin", "right top")
    }, CAn = Oi({
        bN: "View",
        bT: "Visionnage"
    }), NAn = T([
        A2(pTn, "InvitationsWrapper", T([
            OTn,
            Rwn("#181e28"),
            hTn(T([
                A2(TTn, ".InvitationsForm .InputLabelText", T([
                    A2(HTn, "align-items", "center"),
                    kwn("#232d39"),
                    Bwn(sTn(8))
                ])),
                A2(TTn, ".InvitationsForm .InputLabel", T([
                    uCn(sTn(0)),
                    aCn(sTn(0)),
                    Ywn(sTn(0)),
                    lwn(sTn(3))
                ]))
            ]))
        ])),
        A2(pTn, "InvitationsTable", T([
            hTn(T([
                A2(TTn, "td:not(.InvitationEmail)", T([
                    dwn(sTn(3))
                ]))
            ]))
        ])),
        A2(pTn, "InvitationsHeader", T([
            QTn,
            dwn(sTn(10)),
            Rwn(nan),
            GTn(Kun),
            Ywn(sTn(4)),
            hTn(T([
                A2(pTn, "ButtonLabel", T([
                    Rwn(nan)
                ]))
            ]))
        ])),
        A2(pTn, "Header", T([
            hTn(T([
                A2(TTn, "td:not(:last-child)", T([
                    zTn("rotate(-45deg) translate(20px, -15px)"),
                    wAn.bq
                ]))
            ]))
        ])),
        A2(pTn, "InvitationsTable", T([
            oNn(sTn(70)),
            TAn.lI,
            bwn(xTn(100)),
            Rwn("#232D3A"),
            hAn(sTn(0)),
            Ywn(sTn(3)),
            hTn(T([
                A2(TTn, ".InputCheckboxLine .InputWrapper", T([
                    fwn(YTn)
                ])),
                A2(TTn, "tr", T([
                    Rwn("#555D68c2"),
                    DTn(sTn(30))
                ])),
                A2(TTn, "tr:nth-child(odd)", T([
                    Rwn("#555d68")
                ])),
                A2(TTn, "td", T([
                    cTn.dj,
                    bwn(sTn(30)),
                    A2(HTn, "border", "1px solid #181f29")
                ])),
                A2(TTn, "tr:first-child td:first-child:before", T([
                    A2(HTn, "content", "'" + CAn + "'"),
                    zTn("rotate(-45deg) translate(16px, -20px)"),
                    vTn.mp,
                    cTn.$8,
                    wAn.bq,
                    aTn(xTn(30))
                ])),
                A2(TTn, "tr:first-child td:nth-child(2):before", T([
                    A2(HTn, "content", "'Upload'"),
                    zTn("rotate(-45deg) translate(16px, -20px)"),
                    vTn.mp,
                    cTn.$8,
                    wAn.bq,
                    aTn(xTn(30))
                ])),
                A2(TTn, "tr:first-child td:nth-child(3):before", T([
                    A2(HTn, "content", "'" + kAn + "'"),
                    zTn("rotate(-45deg) translate(16px, -20px)"),
                    vTn.mp,
                    cTn.$8,
                    wAn.bq,
                    aTn(xTn(30))
                ])),
                A2(TTn, "tr:first-child td:nth-child(4):before", T([
                    A2(HTn, "content", "'Transcode'"),
                    zTn("rotate(-45deg) translate(16px, -20px)"),
                    vTn.mp,
                    cTn.$8,
                    wAn.bq,
                    aTn(xTn(30))
                ])),
                A2(pTn, "InvitationEmail", T([
                    bwn(xTn(60))
                ])),
                A2(pTn, "InvitationDelete", T([
                    Own.jF,
                    _wn.o6
                ])),
                A2(pTn, "InvitationSourceKind", T([
                    Own.jF
                ]))
            ]))
        ])),
        A2(pTn, "InvitationEmail", T([
            Pwn(sTn(100)),
            FTn.l6,
            sNn.k7,
            fNn.op,
            Bwn(sTn(5)),
            GTn("#ffffff")
        ])),
        A2(pTn, "InvitationEdit", T([
            hTn(T([
                A2(TTn, "svg", T([
                    zTn("scale(2)")
                ]))
            ]))
        ])),
        A2(pTn, "FullCube", T([
            bwn(sTn(17)),
            DTn(sTn(17)),
            Rwn("#3BAAFF"),
            A2(HTn, "margin", "auto"),
            A2(HTn, "border", "2px solid #181f29")
        ])),
        A2(pTn, "EmptyCube", T([
            bwn(sTn(17)),
            DTn(sTn(17)),
            Rwn(""),
            A2(HTn, "margin", "auto"),
            A2(HTn, "border", "2px solid #181f29")
        ])),
        A2(pTn, "InvitationsForm", T([
            OTn,
            dwn(sTn(4)),
            Ywn(sTn(4)),
            lwn(sTn(-4)),
            Rwn(Kun),
            A2(XTn, 8, Run.nw),
            A2(Awn, 0, Run.nw),
            hTn(T([
                A2(pTn, "InputLabel", T([
                    zwn,
                    fwn(sTn(6)),
                    dwn(vwn)
                ])),
                A2(pTn, "InputLabelText", T([
                    dwn(vwn),
                    zwn,
                    QTn
                ])),
                A2(pTn, "InputText", T([
                    A2(XTn, 0, Kun),
                    fwn(vwn),
                    GTn(Jun),
                    dwn(sTn(6)),
                    kwn(Zun)
                ]))
            ]))
        ])),
        A2(pTn, "ShowTranscode", T([
            vTn.rC
        ])),
        A2(pTn, "HideTranscode", T([
            vTn.ol
        ]))
    ]), AAn = T([
        A2(pTn, "JobsWrapper", T([
            OTn
        ])),
        A2(LTn, T([
            "(min-width: 1000px)"
        ]), g),
        A2(pTn, "JobsContent", T([
            OTn,
            Rwn(Zun),
            GTn(Xun),
            A2(Nwn, 3, Kun),
            dwn(sTn(3))
        ])),
        A2(pTn, "JobsRow", T([
            QTn,
            Ywn(sTn(3)),
            lCn.sH
        ])),
        A2(pTn, "JobsRowContent", T([
            rCn(1),
            qTn(1),
            fNn.op,
            FTn.l6,
            sNn.k7,
            GTn(qwn),
            Rwn(Zun),
            dwn(sTn(6)),
            hTn(T([
                A2(TTn, "input", T([
                    fwn(vwn),
                    dwn(vwn),
                    A2(XTn, 0, "")
                ]))
            ]))
        ])),
        A2(pTn, "JobsRowLabel", T([
            GTn(Wun),
            dwn(sTn(6)),
            bwn(xTn(40)),
            mCn.mV
        ]))
    ]), SAn = T([
        A2(pTn, "Operations", T([
            OTn,
            A2(XTn, 4, RCn.jT),
            dwn(sTn(3))
        ])),
        A2(pTn, "OperationsHeader", T([
            dwn(sTn(10)),
            Rwn(RCn.nw),
            GTn(RCn.ku),
            awn.jj,
            Swn(sTn(15))
        ])),
        A2(pTn, "Operation", T([
            QTn,
            A2(Awn, 3, Kun)
        ])),
        A2(pTn, "OperationStatus", T([
            bwn(sTn(10))
        ])),
        A2(pTn, "OperationStatusNone", T([
            Rwn(_un)
        ])),
        A2(pTn, "OperationStatusRunning", T([
            Rwn(Run.jT)
        ])),
        A2(pTn, "OperationStatusSuccess", T([
            Rwn(Hun.jT)
        ])),
        A2(pTn, "OperationStatusFailure", T([
            Rwn(tan.jT)
        ])),
        A2(pTn, "OperationContent", T([
            OTn,
            rCn(1),
            qTn(1),
            dwn(sTn(10)),
            Rwn(Zun),
            GTn(qwn),
            A2(hCn, 3, Kun),
            hTn(T([
                A2(pTn, "InputWrapper", T([
                    Ywn(sTn(5))
                ])),
                A2(pTn, "ShowHideTable", T([
                    KCn.lP,
                    cTn.dj,
                    fTn(sTn(-22))
                ]))
            ]))
        ])),
        A2(pTn, "PlayerSettings", T([
            QTn,
            hTn(T([
                A2(TTn, "div", T([
                    rCn(1)
                ]))
            ]))
        ])),
        A2(TTn, ".ButtonMini", T([
            _wn.o6
        ])),
        A2(pTn, "DeepProbeTable", T([
            oNn(sTn(10)),
            TAn.lI,
            bwn(xTn(100)),
            Rwn("#232D3A"),
            hAn(sTn(0)),
            vTn.jg,
            hTn(T([
                A2(TTn, ".InputCheckboxLine .InputWrapper", T([
                    fwn(YTn)
                ])),
                A2(TTn, "tr", T([
                    Rwn("#555D68c2"),
                    DTn(sTn(30))
                ])),
                A2(TTn, "tr:nth-child(odd)", T([
                    Rwn("#555d68")
                ])),
                A2(TTn, "td", T([
                    cTn.dj,
                    bwn(xTn(40)),
                    A2(HTn, "border", "1px solid #181f29"),
                    A2(Iwn, sTn(0), sTn(5))
                ])),
                A2(TTn, "td:first-child", T([
                    cTn.dj,
                    bwn(xTn(3)),
                    A2(HTn, "border", "none"),
                    Rwn("#232D3A")
                ])),
                A2(pTn, "ProbeItem", T([
                    _wn.o6
                ])),
                A2(TTn, "tr:first-child", T([
                    Rwn("#232D3A"),
                    hTn(T([
                        A2(TTn, "td", T([
                            cTn.dj,
                            bwn(xTn(3)),
                            A2(HTn, "border", "0px")
                        ]))
                    ]))
                ])),
                A2(TTn, "table", T([
                    bwn(xTn(95)),
                    A4(eCn, xTn(0), xTn(0), xTn(0), xTn(6)),
                    Rwn("#181f29"),
                    hTn(T([
                        A2(TTn, "tr", T([
                            Rwn("transparent")
                        ])),
                        A2(TTn, "tr:nth-child(odd)", T([
                            Rwn("transparent")
                        ])),
                        A2(TTn, "tr", T([
                            A2(HTn, "border", "none")
                        ])),
                        A2(TTn, "td:first-child", T([
                            Rwn("#181f29")
                        ]))
                    ]))
                ]))
            ]))
        ])),
        A2(pTn, "ProbeLog", T([
            hTn(T([
                A2(TTn, ".Button", T([
                    vTn.mo,
                    aCn(sTn(10))
                ]))
            ]))
        ]))
    ]), LAn = {
        jF: A2(eTn, "align-content", "center"),
        bR: A2(eTn, "align-content", "flex-end"),
        lP: A2(eTn, "align-content", "flex-start"),
        hh: A2(eTn, "align-content", "space-around"),
        qX: A2(eTn, "align-content", "space-between"),
        rg: A2(eTn, "align-content", "stretch")
    }, yAn = T([
        A2(pTn, "ReportWrapper", T([
            Rwn(Zun),
            dwn(sTn(10)),
            FTn.i8,
            QTn,
            vTn.jg
        ])),
        A2(pTn, "ReportSection", T([
            vTn.rz,
            JTn.jk,
            bwn(xTn(100))
        ])),
        A2(pTn, "ReportLinks", T([
            OTn,
            lCn.sH,
            LAn.rg
        ])),
        A2(pTn, "ReportLinksIcon", T([
            bwn(sTn(22)),
            DTn(sTn(22)),
            WCn,
            Rwn(Kun)
        ])),
        A2(pTn, "ReportLinksLabel", T([
            A2(Iwn, sTn(2), sTn(5)),
            zwn
        ])),
        A2(pTn, "ReportLinksButton", T([
            QTn,
            Ywn(sTn(3)),
            hwn.jF,
            Rwn(Run.eE),
            dwn(sTn(2)),
            Hwn(T([
                GTn(Run.ng),
                Rwn(Run.nu)
            ]))
        ]))
    ]), FAn = A2(bu, eTn("order"), It), jAn = T([
        A2(pTn, "Tracks", T([
            OTn,
            Ywn(sTn(4))
        ])),
        A2(pTn, "TracksTitle", T([
            Rwn(Qun),
            GTn(Yun),
            A2(Iwn, sTn(2), sTn(6)),
            lwn(sTn(3)),
            Zwn.sm,
            awn.ji
        ])),
        A2(pTn, "TracksTrack", T([
            QTn,
            A2(XTn, 3, Qun),
            dwn(sTn(3)),
            A2(Awn, 0, Qun)
        ])),
        A2(pTn, "TracksTrackIcon", T([
            Rwn(Qun),
            aCn(sTn(3)),
            iwn(Wun),
            dwn(sTn(6))
        ])),
        A2(pTn, "TracksTrackSelect", T([
            OTn,
            zwn,
            lwn(sTn(-3)),
            hTn(T([
                A2(pTn, "BannerEmptyness", T([
                    A3(jwn, sTn(3), sTn(0), sTn(0))
                ])),
                A2(pTn, "BannerTodo", T([
                    A3(jwn, sTn(3), sTn(0), sTn(0))
                ]))
            ]))
        ])),
        A2(pTn, "TracksTrackSelectItem", T([
            QTn,
            hwn.jF,
            _wn.o6,
            A2(XTn, 3, Qun),
            Rwn(Zun),
            dwn(sTn(3)),
            Hwn(T([
                GTn(qwn)
            ])),
            ZNn(T([
                lwn(sTn(3))
            ]))
        ])),
        A2(pTn, "TracksTrackSelectItemTitle", T([
            Swn(sTn(15)),
            dwn(sTn(3)),
            BTn(xTn(50))
        ])),
        A2(pTn, "TracksTrackSelectItemProp", T([
            dwn(sTn(3)),
            zwn,
            BTn(xTn(20))
        ])),
        A2(pTn, "TracksTrackSelectItemIndex", T([
            dwn(sTn(3)),
            BTn(sTn(40))
        ])),
        A2(TTn, ".TracksTrackSelectItemProp:last-child", T([
            Own.pO
        ])),
        A2(pTn, "TracksTrackToggleMore", T([
            vTn.ol
        ])),
        A2(TTn, ".TracksTrackSelectGroup.TracksTrackSelectFolded .TracksTrackSelectLabel:nth-child(n+5)", T([
            vTn.ol
        ])),
        A2(pTn, "TracksTrackSelectMore", T([
            Own.jF,
            Rwn(Zun),
            Swn(sTn(15)),
            A2(Iwn, sTn(4), sTn(6)),
            lwn(sTn(3)),
            FAn(99),
            GTn(qwn),
            Hwn(T([
                Rwn(Qun)
            ]))
        ])),
        A2(pTn, "TracksTrackSelectGroup", T([
            OTn
        ])),
        A2(pTn, "TracksTrackSelectLabel", T([
            hTn(T([
                A2(TTn, "input", T([
                    vTn.ol
                ])),
                A2(TTn, "input:checked", T([
                    bNn(T([
                        A2(pTn, "TracksTrackSelectItem", T([
                            BCn(Run.jT),
                            GTn(qwn)
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]), PAn = Ju(T([
        fAn,
        oAn,
        lAn,
        gAn,
        yAn,
        bAn,
        AAn,
        SAn,
        NAn,
        dAn,
        aAn,
        QNn,
        _Nn,
        nAn,
        jAn,
        KNn,
        rAn
    ])), IAn = T([
        A2(pTn, "TimelineWrapper", T([
            zwn,
            ETn,
            OTn,
            FTn.i8
        ])),
        A2(pTn, "TimelineList", T([
            OTn,
            hTn(T([
                A2(TTn, "a:hover", T([
                    zCn.sa
                ]))
            ]))
        ])),
        A2(pTn, "TimelineDate", T([
            A2(Iwn, sTn(4), sTn(10)),
            vTn.jg,
            Own.jF,
            Rwn(Qun),
            GTn(Yun),
            Ywn(sTn(4))
        ])),
        A2(pTn, "TimelineEvent", T([
            Rwn(Zun),
            GTn(Wun),
            tCn(sTn(25)),
            A2(Iwn, sTn(10), sTn(10)),
            Ywn(sTn(4)),
            OTn
        ])),
        A2(pTn, "TimelineGroup", T([
            A2(Iwn, sTn(4), sTn(6))
        ])),
        A2(pTn, "TimelineGroupEvent", T([
            QTn,
            hwn.jF,
            lwn(sTn(2))
        ])),
        A2(pTn, "TimelineSingleEvent", T([
            QTn,
            hwn.jF,
            lwn(sTn(2))
        ])),
        A2(pTn, "TimelineEventMessage", T([
            A2(Iwn, sTn(0), sTn(8)),
            zwn,
            hTn(T([
                A2(TTn, "span", T([
                    GTn(_un)
                ]))
            ]))
        ])),
        A2(pTn, "TimelineEventTitle", T([
            cTn.dj,
            hTn(T([
                A2(TTn, "a", T([
                    vTn.mo
                ])),
                A2(TTn, "p", T([
                    vTn.mo
                ])),
                A2(TTn, "svg", T([
                    uCn(sTn(5)),
                    aCn(sTn(5))
                ])),
                A2(TTn, "div", T([
                    cTn.dj,
                    fTn(sTn(5)),
                    vTn.mo,
                    _wn.o6,
                    fwn(sTn(0))
                ])),
                A2(pTn, "TimelineEventTitleMessage", T([
                    cTn.q8,
                    _wn.i8,
                    uCn(sTn(10))
                ])),
                A2(pTn, "TimelineEventResumeSingle", T([
                    _wn.i8
                ]))
            ]))
        ])),
        A2(pTn, "TimelineEventResume", T([
            vTn.mo,
            uCn(sTn(15)),
            cTn.dj,
            fTn(sTn(5)),
            _wn.o6
        ])),
        A2(pTn, "TimelineEventLabel", T([
            uwn.pO
        ])),
        A2(pTn, "TimelineEventLabelPin", T([
            bwn(sTn(10)),
            DTn(sTn(10)),
            cCn(sTn(10)),
            vTn.mp,
            uCn(sTn(6))
        ]))
    ]), BAn = T([
        A2(pTn, "PadokUploadWrapper", T([
            OTn
        ])),
        A2(pTn, "PadokUploadTitle", T([
            Rwn(Run.nw),
            dwn(sTn(10)),
            Swn(sTn(15)),
            awn.jj,
            GTn(qwn),
            Ywn(sTn(4))
        ])),
        A2(pTn, "PadokUpload", T([
            OTn,
            Rwn(Run.eE),
            Ywn(sTn(4)),
            GTn(Run.md)
        ])),
        A2(pTn, "PadokUploadInfo", T([
            dwn(sTn(10)),
            vTn.mo
        ])),
        A2(pTn, "PadokUploadKo", T([
            Rwn(RCn.eE),
            GTn(RCn.md)
        ])),
        A2(pTn, "PadokUploadTitleKo", T([
            Rwn(RCn.nw)
        ])),
        A2(pTn, "PadokUploadInvitation", T([
            Rwn(Qun),
            dwn(sTn(10)),
            sAn(600),
            Ywn(sTn(4))
        ]))
    ]), MAn = T([
        A2(LTn, T([
            "(max-width: 1000px)"
        ]), T([
            A2(pTn, "ShowsWrapper", T([
                A4(dTn, 0, 0, 0, 94),
                FTn.l6,
                OTn
            ])),
            A2(pTn, "SettingsWrapper", T([
                A4(dTn, 0, 0, 0, 94),
                FTn.i8,
                OTn
            ])),
            A2(pTn, "MenuSettings", T([
                bwn(YTn)
            ])),
            A2(pTn, "BrowserWrapper", T([
                bwn(YTn)
            ])),
            A2(wTn, T([
                pTn("BrowserWrapper"),
                pTn("TimelineWrapper"),
                pTn("ShowWrapper"),
                pTn("MasterWrapper")
            ]), T([
                qTn(0),
                zTn("translate3d(0,0,0)"),
                A2(hCn, 0, "transparent"),
                aCn(sTn(2)),
                Ywn(sTn(2)),
                A4(dTn, 0, 0, 0, 0),
                ETn
            ])),
            A2(wTn, T([
                pTn("ShowMain"),
                pTn("ShowAside")
            ]), T([
                A4(dTn, 0, 0, 0, 0),
                ETn
            ])),
            A2(pTn, "ShowAside", T([
                bwn(YTn)
            ])),
            A2(wTn, T([
                pTn("ShowWrapper"),
                pTn("ShowAside"),
                pTn("TimelineWrapper")
            ]), T([
                zTn("translate3d(101%,0,0)")
            ])),
            A3(RTn, "ActiveShow", "ShowWrapper", T([
                zTn("translate3d(0,0,0)")
            ])),
            A3(RTn, "ActiveShow", "BrowserWrapper", T([
                zTn("translate3d(-100%,0,0)")
            ])),
            A3(RTn, "AsideOpened", "ShowAside", T([
                zTn("translate3d(0,0,0)")
            ])),
            A3(RTn, "AsideOpened", "ShowMain", T([
                zTn("translate3d(-101%,0,0)")
            ])),
            A2(pTn, "LayoutFwdButton", T([
                bwn(sTn(80))
            ])),
            A2(pTn, "LayoutBackButton", T([
                vTn.ol
            ])),
            A2(pTn, "AsideOpened", T([
                hTn(T([
                    A2(pTn, "LayoutBackButton", T([
                        vTn.ol
                    ])),
                    A2(pTn, "LayoutHomeButton", T([
                        vTn.lL
                    ]))
                ]))
            ]))
        ]))
    ]), OAn = vAn("input"), qAn = mCn.mV, DAn = wwn("placeholder"), xAn = vAn("textarea"), RAn = (JW = T([
        DAn(T([
            mwn(80),
            GTn(Wun),
            qAn
        ]))
    ]), T([
        OAn(JW),
        xAn(JW)
    ])), VAn = Ju(T([
        ZTn,
        WNn,
        Jwn,
        vCn,
        PAn,
        BAn,
        IAn,
        jTn,
        WTn,
        MAn,
        gwn,
        ITn,
        RAn,
        ICn,
        $wn
    ])), EAn = nT, zAn = lu({
        m: function(n) {
            var r = sW(n.sn), t = m(mi({
                lJ: n,
                oU: r.b,
                sn: r.a
            }), n$), e = n.sp;
            if (e.$) return t;
            var u = A2(wi, Wv, e.a);
            return u.$ ? t : A2(QH, n, u.a);
        },
        rl: function(n) {
            return 1 === n.$ ? A2(mW, Li, function(n) {
                var r, t, e;
                return hW(T([
                    dW($W),
                    TW(vW),
                    (r = bW, t = void 0 !== nr.hidden ? {
                        l6: "hidden",
                        jG: "visibilitychange"
                    } : void 0 !== nr.mozHidden ? {
                        l6: "mozHidden",
                        jG: "mozvisibilitychange"
                    } : void 0 !== nr.msHidden ? {
                        l6: "msHidden",
                        jG: "msvisibilitychange"
                    } : void 0 !== nr.webkitHidden ? {
                        l6: "webkitHidden",
                        jG: "webkitvisibilitychange"
                    } : {
                        l6: "hidden",
                        jG: "visibilitychange"
                    }, A3(MW, 0, t.jG, A2(ye, OW(r), A2(mu, "target", A2(mu, t.l6, Ne))))),
                    A2(mW, pW, (e = lZ, hW(T([
                        A2(mW, oQ, zQ),
                        e(cQ)
                    ])))),
                    A2(mW, gW, YQ(n.sg)),
                    function() {
                        var r = n.ak.sn;
                        n: for(;;)switch(r.$){
                            case 1:
                                return A2(mW, hv(n.g6.mm), A2(fZ, n.g6, n.ak));
                            case 4:
                                if (4 === r.a.$) {
                                    var t = n.iw.oV.dJ;
                                    if (t.$) return kW;
                                    var e = t.a;
                                    return A2(mW, A2(bu, A2(bu, Ci, Ie), vR), iQ(e));
                                }
                                break n;
                            case 2:
                                return A2(mW, gv, XQ());
                            default:
                                break n;
                        }
                        return kW;
                    }()
                ]));
            }(n.a)) : A2(mW, lW, dW(fW));
        },
        q: l7,
        r: function(n) {
            var r;
            return EAn(A2(Le, g, T([
                rTn(n),
                (r = VAn, li(A3(oi, "style", g, Ua(si(ii(Ua(ci(r))))))))
            ])));
        }
    });
    GW = {
        Private: {
            init: zAn(A2(Ce, function(n) {
                return A2(Ce, function(r) {
                    return A2(Ce, function(t) {
                        return A2(Ce, function(e) {
                            return A2(Ce, function(u) {
                                return A2(Ce, function(a) {
                                    return A2(Ce, function(i) {
                                        return A2(Ce, function(o) {
                                            return je({
                                                bL: o,
                                                fk: i,
                                                mK: a,
                                                oo: u,
                                                sn: e,
                                                sp: t,
                                                sv: r,
                                                id: n
                                            });
                                        }, A2(mu, "defaults", A2(Ce, function(n) {
                                            return A2(Ce, function(r) {
                                                return A2(Ce, function(t) {
                                                    return je({
                                                        jr: t,
                                                        js: r,
                                                        qz: n
                                                    });
                                                }, A2(mu, "browserAccept", Bi));
                                            }, A2(mu, "browserArchive", Bi));
                                        }, A2(mu, "showAside", Bi))));
                                    }, A2(mu, "height", tc));
                                }, A2(mu, "isAdvertiser", Ne));
                            }, A2(mu, "now", tc));
                        }, A2(mu, "url", Bi));
                    }, A2(mu, "user", Mo(T([
                        LH(Tt),
                        A2(ye, kt, Pi)
                    ]))));
                }, A2(mu, "version", Bi));
            }, A2(mu, "width", tc)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, GW) : n.Elm = GW;
}($cc2b0350e0cbd02a$exports);


var $08e5db9bd951c9f9$require$Elm = $cc2b0350e0cbd02a$exports.Elm;
// Expose the config for everyboAdaY
window.nomalab = {
    user: null,
    isAdvertiser: false,
    aws: null,
    // nomalabEnv is exposed by config.js ()
    // See helpers/thirdParty
    sentry: null,
    intercom: null,
    raw_frame_url: null
};















window.addEventListener('load', async function() {
    const response = await fetch('/v4/config/front');
    if (response.ok) {
        const config = await response.json();
        window.nomalab.sentry = config.sentry;
        window.nomalab.intercom = config.intercom;
        window.nomalab.raw_frame_url = config.raw_frame?.url;
    }
    // Fetch user infos
    fetch('/v3/users/me').then(function(response) {
        if (response.status === 200) return response.json();
        else throw 'not logged';
    }).then(function(me) {
        // Setup the user
        window.nomalab.user = me;
        return Promise.all([
            // fetch isAdvertiser status
            me.organization ? fetch(`/v4/organizations/${me.organization}/isAdvertiser`).then(function(response) {
                return response.json();
            }).then(function(data) {
                window.nomalab.isAdvertiser = data.isAdvertiser;
            }) : Promise.resolve(null),
            // fetch aws config
            fetch('/v3/aws/config').then(function(response) {
                return response.json();
            }).then(function(awsConfig) {
                // See helpers/upload
                window.nomalab.aws = awsConfig;
            })
        ]);
    }).catch(function(err) {
        // Not logged
        if (location.pathname === "/account/settings" || !location.pathname.startsWith("/account")) {
            const from = "?from=" + location.pathname;
            window.history.replaceState(null, "", "/account/login" + from);
        }
    }).finally(function() {
        // RUN THE APP
        var app = $08e5db9bd951c9f9$require$Elm.Private.init({
            node: document.getElementById('page'),
            flags: {
                user: window.nomalab.user,
                url: window.location.pathname + window.location.search,
                lang: window.navigator.userLanguage || window.navigator.language,
                width: window.innerWidth,
                height: window.innerHeight,
                now: new Date().getTime(),
                defaults: $53dd92cf139b6a84$exports.defaults(),
                version: 'dev',
                isAdvertiser: window.nomalab.isAdvertiser ?? false
            }
        });
        (parcelRequire("8TgEi"))(app);
        (parcelRequire("bvPu1"))(app);
        (parcelRequire("hjsOJ"))(app);
        (parcelRequire("iHeIR"))(app, 'redirect');
        // do not bother to load when not logged
        if (window.nomalab.user) {
            (parcelRequire("8oUNT"));
            (parcelRequire("3mVol"));
            (parcelRequire("4ARPW"));
            (parcelRequire("5JGum"));
            (parcelRequire("3Ii3I"))(app);
            (parcelRequire("4lCIN"))(app);
            (parcelRequire("56a0I"))(app);
            (parcelRequire("j63Xd"));
            (parcelRequire("fFcjN")).default(app);
            (parcelRequire("5pxJW"))(app);
            (parcelRequire("kRPup"))(app);
            $53dd92cf139b6a84$exports.subscribe(app);
        }
    });
});


//# sourceMappingURL=apps.94f2e6f7.js.map
